import "./picture.svg.eb0b3f3e.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec59a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec59a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bQvnf", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagsService", () => $4a924395e8b6192b$export$2028ab7a0b8cbb43);

var $deWeK = parcelRequire("deWeK");

var $7X6iT = parcelRequire("7X6iT");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $5JMLH = parcelRequire("5JMLH");
var $g5fNy = parcelRequire("g5fNy");

var $j7eyO = parcelRequire("j7eyO");
var $gawXH = parcelRequire("gawXH");
class $4a924395e8b6192b$export$2028ab7a0b8cbb43 extends (0, $7X6iT.BaseGraphqlService) {
    #cachedFeatureFlags;
    updateFeatureFlag(id, payload) {
        delete payload.__typename;
        delete payload.settings.__typename;
        delete payload.id;
        return this.mutate({
            mutation: 'update-feature-flag.graphql',
            variables: {
                id: id,
                payload: payload
            }
        });
    }
    getFeatureFlag(id) {
        return this.query({
            query: 'get-feature-flag.graphql',
            variables: {
                id: id
            }
        }).pipe((0, $gawXH.map)(({ data: data })=>data.getFeatureFlag));
    }
    fetchFeatureFlags() {
        return (0, $5JMLH.from)(this.graphql.query({
            query: (0, $2O1GU.importQuery)('list-feature-flags.graphql'),
            errorPolicy: 'ignore'
        })).pipe((0, $gawXH.map)(({ data: data })=>data.getFeatureFlags), (0, $gawXH.map)((featureFlags)=>{
            if (featureFlags?.length) {
                window._excluded_components = featureFlags?.filter((v)=>!v.settings.enabled).map((v)=>v.name);
                this.#cachedFeatureFlags = featureFlags;
            } else /* Default to build ones */ // window._excluded_components = [];
            console.error('Unable to fetch feature flags defaulting to build in ones: ');
            return featureFlags;
        }), (0, $j7eyO.catchError)((e)=>{
            console.error('Unable to fetch feature flags defaulting to build in ones: ', e);
            return (0, $g5fNy.of)([]);
        }));
    }
    isOn(name) {
        return this.fetchFeatureFlags().pipe((0, $gawXH.map)((featureFlags)=>{
            const currentFlag = featureFlags.find((flag)=>flag.name === name);
            return !!currentFlag?.settings?.enabled;
        }));
    }
    isOnSync(name) {
        const currentFlag = this.#cachedFeatureFlags.find((userFlag)=>userFlag.name === name);
        return !!currentFlag?.settings?.enabled;
    }
    constructor(...args){
        super(...args), this.#cachedFeatureFlags = [];
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Injector)((0, $2O1GU.ApolloClient))
], $4a924395e8b6192b$export$2028ab7a0b8cbb43.prototype, "graphql", void 0);
$4a924395e8b6192b$export$2028ab7a0b8cbb43 = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Injectable)()
], $4a924395e8b6192b$export$2028ab7a0b8cbb43);

});
parcelRegister("deWeK", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $9a39c1cad6df5e5c$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $9a39c1cad6df5e5c$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $9a39c1cad6df5e5c$export$3c9a16f847548506);
$parcel$export(module.exports, "__decorate", () => $9a39c1cad6df5e5c$export$29e00dfd3077644b);
$parcel$export(module.exports, "__awaiter", () => $9a39c1cad6df5e5c$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $9a39c1cad6df5e5c$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $9a39c1cad6df5e5c$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $9a39c1cad6df5e5c$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $9a39c1cad6df5e5c$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $9a39c1cad6df5e5c$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $9a39c1cad6df5e5c$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $9a39c1cad6df5e5c$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $9a39c1cad6df5e5c$var$extendStatics = function(d, b) {
    $9a39c1cad6df5e5c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9a39c1cad6df5e5c$var$extendStatics(d, b);
};
function $9a39c1cad6df5e5c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9a39c1cad6df5e5c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9a39c1cad6df5e5c$export$18ce0697a983be9b = function() {
    $9a39c1cad6df5e5c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a39c1cad6df5e5c$export$18ce0697a983be9b.apply(this, arguments);
};
function $9a39c1cad6df5e5c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9a39c1cad6df5e5c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9a39c1cad6df5e5c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9a39c1cad6df5e5c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9a39c1cad6df5e5c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9a39c1cad6df5e5c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $9a39c1cad6df5e5c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9a39c1cad6df5e5c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9a39c1cad6df5e5c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9a39c1cad6df5e5c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9a39c1cad6df5e5c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9a39c1cad6df5e5c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9a39c1cad6df5e5c$export$45d3717a4c69092e(o, m, p);
}
function $9a39c1cad6df5e5c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9a39c1cad6df5e5c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9a39c1cad6df5e5c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9a39c1cad6df5e5c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9a39c1cad6df5e5c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9a39c1cad6df5e5c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9a39c1cad6df5e5c$export$10c90e4f7922046c(v) {
    return this instanceof $9a39c1cad6df5e5c$export$10c90e4f7922046c ? (this.v = v, this) : new $9a39c1cad6df5e5c$export$10c90e4f7922046c(v);
}
function $9a39c1cad6df5e5c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9a39c1cad6df5e5c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9a39c1cad6df5e5c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9a39c1cad6df5e5c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9a39c1cad6df5e5c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9a39c1cad6df5e5c$export$19a8beecd37a4c45 === "function" ? $9a39c1cad6df5e5c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9a39c1cad6df5e5c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9a39c1cad6df5e5c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $9a39c1cad6df5e5c$var$ownKeys = function(o) {
    $9a39c1cad6df5e5c$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $9a39c1cad6df5e5c$var$ownKeys(o);
};
function $9a39c1cad6df5e5c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $9a39c1cad6df5e5c$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9a39c1cad6df5e5c$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $9a39c1cad6df5e5c$var$__setModuleDefault(result, mod);
    return result;
}
function $9a39c1cad6df5e5c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9a39c1cad6df5e5c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9a39c1cad6df5e5c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9a39c1cad6df5e5c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9a39c1cad6df5e5c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9a39c1cad6df5e5c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9a39c1cad6df5e5c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9a39c1cad6df5e5c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $9a39c1cad6df5e5c$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $9a39c1cad6df5e5c$export$2e2bcd8739ae039 = {
    __extends: $9a39c1cad6df5e5c$export$a8ba968b8961cb8a,
    __assign: $9a39c1cad6df5e5c$export$18ce0697a983be9b,
    __rest: $9a39c1cad6df5e5c$export$3c9a16f847548506,
    __decorate: $9a39c1cad6df5e5c$export$29e00dfd3077644b,
    __param: $9a39c1cad6df5e5c$export$d5ad3fd78186038f,
    __esDecorate: $9a39c1cad6df5e5c$export$3a84e1ae4e97e9b0,
    __runInitializers: $9a39c1cad6df5e5c$export$d831c04e792af3d,
    __propKey: $9a39c1cad6df5e5c$export$6a2a36740a146cb8,
    __setFunctionName: $9a39c1cad6df5e5c$export$d1a06452d3489bc7,
    __metadata: $9a39c1cad6df5e5c$export$f1db080c865becb9,
    __awaiter: $9a39c1cad6df5e5c$export$1050f835b63b671e,
    __generator: $9a39c1cad6df5e5c$export$67ebef60e6f28a6,
    __createBinding: $9a39c1cad6df5e5c$export$45d3717a4c69092e,
    __exportStar: $9a39c1cad6df5e5c$export$f33643c0debef087,
    __values: $9a39c1cad6df5e5c$export$19a8beecd37a4c45,
    __read: $9a39c1cad6df5e5c$export$8d051b38c9118094,
    __spread: $9a39c1cad6df5e5c$export$afc72e2116322959,
    __spreadArrays: $9a39c1cad6df5e5c$export$6388937ca91ccae8,
    __spreadArray: $9a39c1cad6df5e5c$export$1216008129fb82ed,
    __await: $9a39c1cad6df5e5c$export$10c90e4f7922046c,
    __asyncGenerator: $9a39c1cad6df5e5c$export$e427f37a30a4de9b,
    __asyncDelegator: $9a39c1cad6df5e5c$export$bbd80228419bb833,
    __asyncValues: $9a39c1cad6df5e5c$export$e3b29a3d6162315f,
    __makeTemplateObject: $9a39c1cad6df5e5c$export$4fb47efe1390b86f,
    __importStar: $9a39c1cad6df5e5c$export$c21735bcef00d192,
    __importDefault: $9a39c1cad6df5e5c$export$da59b14a69baef04,
    __classPrivateFieldGet: $9a39c1cad6df5e5c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9a39c1cad6df5e5c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9a39c1cad6df5e5c$export$81fdc39f203e4e04,
    __addDisposableResource: $9a39c1cad6df5e5c$export$88ac25d8e944e405,
    __disposeResources: $9a39c1cad6df5e5c$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $9a39c1cad6df5e5c$export$889dfb5d17574b0b
};

});

parcelRegister("7X6iT", function(module, exports) {

$parcel$export(module.exports, "BaseGraphqlService", () => $60023d7c4fd22bc4$export$ad389ae17185862e);

var $deWeK = parcelRequire("deWeK");
parcelRequire("azXku");
var $YseI1 = parcelRequire("YseI1");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $g5fNy = parcelRequire("g5fNy");

var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");
var $3dOhR = parcelRequire("3dOhR");
/**
 * Will retry the request if fails 40 times with 5 seconds delay between the requests
 * That means 200 seconds or 3 minutes and 20 seconds
 */ const $60023d7c4fd22bc4$var$retryOnError = ()=>(0, $YseI1.retryWithDelay)(5, 40);
class $60023d7c4fd22bc4$export$ad389ae17185862e {
    query(options, raw) {
        return (0, $g5fNy.of)(options).pipe((0, $gawXH.map)((options)=>({
                ...options,
                query: !raw ? (0, $2O1GU.importQuery)(options.query) : options.query
            })), (0, $lNnaw.switchMap)((options)=>this.graphql.query(options)), $60023d7c4fd22bc4$var$retryOnError());
    }
    watchQuery(options, raw) {
        return (0, $g5fNy.of)(options).pipe((0, $gawXH.map)((options)=>({
                ...options,
                query: !raw ? (0, $2O1GU.importQuery)(options.query) : options.query
            })), (0, $lNnaw.switchMap)((options)=>this.graphql.watchQuery(options)), $60023d7c4fd22bc4$var$retryOnError(), (0, $3dOhR.tap)((e)=>{
            if (e.errors) console.error({
                path: e.errors[0]?.path?.join('.'),
                message: e.errors[0]?.message
            });
        }));
    }
    mutate(options, raw) {
        return (0, $g5fNy.of)(options).pipe((0, $gawXH.map)((options)=>({
                ...options,
                mutation: !raw ? (0, $2O1GU.importQuery)(options.mutation) : options.mutation
            })), (0, $lNnaw.switchMap)((options)=>this.graphql.mutate(options)), $60023d7c4fd22bc4$var$retryOnError());
    }
    subscribe(options, raw) {
        return (0, $g5fNy.of)(options).pipe((0, $gawXH.map)((options)=>({
                ...options,
                query: !raw ? (0, $2O1GU.importQuery)(options.query) : options.query
            })), (0, $lNnaw.switchMap)((options)=>this.graphql.subscribe(options)), $60023d7c4fd22bc4$var$retryOnError());
    }
}
(0, $deWeK.__decorate)([
    (0, $1t8Wn.Injector)((0, $2O1GU.ApolloClient))
], $60023d7c4fd22bc4$export$ad389ae17185862e.prototype, "graphql", void 0);

});
parcelRegister("azXku", function(module, exports) {
$parcel$export(module.exports, "retryWithDelay", () => (parcelRequire("YseI1")).retryWithDelay);
parcelRequire("YseI1");

});
parcelRegister("YseI1", function(module, exports) {

$parcel$export(module.exports, "retryWithDelay", () => $7fe5c279dc7dc3fb$export$1949aa7e4b5cd00f);

var $29pK2 = parcelRequire("29pK2");
var $4YpXN = parcelRequire("4YpXN");
var $lFNui = parcelRequire("lFNui");
var $3dOhR = parcelRequire("3dOhR");
function $7fe5c279dc7dc3fb$export$1949aa7e4b5cd00f(seconds, count = 1) {
    return (input)=>input.pipe((0, $4YpXN.retryWhen)((errors)=>errors.pipe((0, $lFNui.scan)((acc, error)=>({
                    count: acc.count + 1,
                    error: error
                }), {
                count: 0,
                error: null
            }), (0, $3dOhR.tap)((current)=>{
                if (current?.error?.graphQLErrors && current?.error?.message !== 'Failed to fetch') throw current.error;
                if (current?.count > count) throw current.error;
            }), (0, $29pK2.delay)(seconds * 1000))));
}

});
parcelRegister("29pK2", function(module, exports) {

$parcel$export(module.exports, "delay", () => $191063c9fa647040$export$1391212d75b2ee65);

var $8fD1K = parcelRequire("8fD1K");

var $auQGw = parcelRequire("auQGw");

var $gTQqg = parcelRequire("gTQqg");
function $191063c9fa647040$export$1391212d75b2ee65(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $8fD1K.asyncScheduler);
    var duration = (0, $gTQqg.timer)(due, scheduler);
    return (0, $auQGw.delayWhen)(function() {
        return duration;
    });
}

});
parcelRegister("8fD1K", function(module, exports) {

$parcel$export(module.exports, "asyncScheduler", () => $601dff70b921a8df$export$8d6b71a2b178fc32);
$parcel$export(module.exports, "async", () => $601dff70b921a8df$export$12af436354f1a4f7);

var $8Aw6k = parcelRequire("8Aw6k");

var $gNWWi = parcelRequire("gNWWi");
var $601dff70b921a8df$export$8d6b71a2b178fc32 = new (0, $gNWWi.AsyncScheduler)((0, $8Aw6k.AsyncAction));
var $601dff70b921a8df$export$12af436354f1a4f7 = $601dff70b921a8df$export$8d6b71a2b178fc32;

});
parcelRegister("8Aw6k", function(module, exports) {

$parcel$export(module.exports, "AsyncAction", () => $640a961b40de1a4a$export$b5369ffd7cb2211b);

var $deWeK = parcelRequire("deWeK");

var $7BnOa = parcelRequire("7BnOa");

var $5pzXw = parcelRequire("5pzXw");

var $8JVOt = parcelRequire("8JVOt");
var $640a961b40de1a4a$export$b5369ffd7cb2211b = function(_super) {
    (0, $deWeK.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $5pzXw.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $5pzXw.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $8JVOt.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $7BnOa.Action));

});
parcelRegister("7BnOa", function(module, exports) {

$parcel$export(module.exports, "Action", () => $588e74ed22256a04$export$e19cd5f9376f8cee);

var $deWeK = parcelRequire("deWeK");

var $iTzX8 = parcelRequire("iTzX8");
var $588e74ed22256a04$export$e19cd5f9376f8cee = function(_super) {
    (0, $deWeK.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $iTzX8.Subscription));

});
parcelRegister("iTzX8", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $dc1940861751d33b$export$f55210826850c514);
$parcel$export(module.exports, "EMPTY_SUBSCRIPTION", () => $dc1940861751d33b$export$610f9c3ca1a38dd8);
$parcel$export(module.exports, "isSubscription", () => $dc1940861751d33b$export$4f9221cbada3c4fc);

var $deWeK = parcelRequire("deWeK");

var $ePlbj = parcelRequire("ePlbj");

var $dqrXq = parcelRequire("dqrXq");

var $8JVOt = parcelRequire("8JVOt");
var $dc1940861751d33b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $deWeK.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $ePlbj.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $dqrXq.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $deWeK.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $dc1940861751d33b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $dqrXq.UnsubscriptionError)) errors = (0, $deWeK.__spreadArray)((0, $deWeK.__spreadArray)([], (0, $deWeK.__read)(errors)), (0, $deWeK.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $dqrXq.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $dc1940861751d33b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $8JVOt.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $8JVOt.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $dc1940861751d33b$export$610f9c3ca1a38dd8 = $dc1940861751d33b$export$f55210826850c514.EMPTY;
function $dc1940861751d33b$export$4f9221cbada3c4fc(value) {
    return value instanceof $dc1940861751d33b$export$f55210826850c514 || value && 'closed' in value && (0, $ePlbj.isFunction)(value.remove) && (0, $ePlbj.isFunction)(value.add) && (0, $ePlbj.isFunction)(value.unsubscribe);
}
function $dc1940861751d33b$var$execFinalizer(finalizer) {
    if ((0, $ePlbj.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("ePlbj", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $acb642523f580de8$export$f6e2535fb5126e54);
function $acb642523f580de8$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}

});

parcelRegister("dqrXq", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $9c6363dcad0b97a3$export$c9648b76fd580c34);

var $iNflj = parcelRequire("iNflj");
var $9c6363dcad0b97a3$export$c9648b76fd580c34 = (0, $iNflj.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

});
parcelRegister("iNflj", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $dae8b4529fa31e67$export$128a15b65d1b6041);
function $dae8b4529fa31e67$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("8JVOt", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $65cf5f2af6d45f77$export$dae3f38077fc36c0);
function $65cf5f2af6d45f77$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});



parcelRegister("5pzXw", function(module, exports) {

$parcel$export(module.exports, "intervalProvider", () => $3f0b2e40a789be6b$export$f0ca5e16f6f68711);

var $deWeK = parcelRequire("deWeK");
var $3f0b2e40a789be6b$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $3f0b2e40a789be6b$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $deWeK.__spreadArray)([
            handler,
            timeout
        ], (0, $deWeK.__read)(args)));
        return setInterval.apply(void 0, (0, $deWeK.__spreadArray)([
            handler,
            timeout
        ], (0, $deWeK.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $3f0b2e40a789be6b$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

});


parcelRegister("gNWWi", function(module, exports) {

$parcel$export(module.exports, "AsyncScheduler", () => $c3bef11006b42604$export$4114a3ec92faa3c6);

var $deWeK = parcelRequire("deWeK");

var $lSePN = parcelRequire("lSePN");
var $c3bef11006b42604$export$4114a3ec92faa3c6 = function(_super) {
    (0, $deWeK.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $lSePN.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $lSePN.Scheduler));

});
parcelRegister("lSePN", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $feca25e8ca7b998f$export$d3e54bb8584cda7c);

var $fd3nS = parcelRequire("fd3nS");
var $feca25e8ca7b998f$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $fd3nS.dateTimestampProvider).now;
    return Scheduler;
}();

});
parcelRegister("fd3nS", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", () => $b12ab1ed1c8f65ee$export$c1895ea2d519a677);
var $b12ab1ed1c8f65ee$export$c1895ea2d519a677 = {
    now: function() {
        return ($b12ab1ed1c8f65ee$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});




parcelRegister("auQGw", function(module, exports) {

$parcel$export(module.exports, "delayWhen", () => $7a4592d3580463f3$export$286ca829307725c9);

var $lDqfI = parcelRequire("lDqfI");

var $d5Aat = parcelRequire("d5Aat");

var $3M6kY = parcelRequire("3M6kY");

var $guYpB = parcelRequire("guYpB");

var $gD6ig = parcelRequire("gD6ig");

var $1wVYm = parcelRequire("1wVYm");
function $7a4592d3580463f3$export$286ca829307725c9(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, $lDqfI.concat)(subscriptionDelay.pipe((0, $d5Aat.take)(1), (0, $3M6kY.ignoreElements)()), source.pipe($7a4592d3580463f3$export$286ca829307725c9(delayDurationSelector)));
    };
    return (0, $gD6ig.mergeMap)(function(value, index) {
        return (0, $1wVYm.innerFrom)(delayDurationSelector(value, index)).pipe((0, $d5Aat.take)(1), (0, $guYpB.mapTo)(value));
    });
}

});
parcelRegister("lDqfI", function(module, exports) {

$parcel$export(module.exports, "concat", () => $fc019aaa3268b9f8$export$ee1b3e54f0441b22);

var $nDbKn = parcelRequire("nDbKn");

var $9Rm6G = parcelRequire("9Rm6G");

var $5JMLH = parcelRequire("5JMLH");
function $fc019aaa3268b9f8$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $nDbKn.concatAll)()((0, $5JMLH.from)(args, (0, $9Rm6G.popScheduler)(args)));
}

});
parcelRegister("nDbKn", function(module, exports) {

$parcel$export(module.exports, "concatAll", () => $04708c1c68f08b65$export$b314777ae20abca9);

var $S8ZgO = parcelRequire("S8ZgO");
function $04708c1c68f08b65$export$b314777ae20abca9() {
    return (0, $S8ZgO.mergeAll)(1);
}

});
parcelRegister("S8ZgO", function(module, exports) {

$parcel$export(module.exports, "mergeAll", () => $0a2c03efd795fcb0$export$18aef43295bbe906);

var $gD6ig = parcelRequire("gD6ig");

var $6BqGr = parcelRequire("6BqGr");
function $0a2c03efd795fcb0$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $gD6ig.mergeMap)((0, $6BqGr.identity), concurrent);
}

});
parcelRegister("gD6ig", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $c1b52ba29b11bbb9$export$6b9f6c0d32c093f9);

var $gawXH = parcelRequire("gawXH");

var $1wVYm = parcelRequire("1wVYm");

var $5CoSH = parcelRequire("5CoSH");

var $3Vbvi = parcelRequire("3Vbvi");

var $ePlbj = parcelRequire("ePlbj");
function $c1b52ba29b11bbb9$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $ePlbj.isFunction)(resultSelector)) return $c1b52ba29b11bbb9$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $gawXH.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1wVYm.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $5CoSH.operate)(function(source, subscriber) {
        return (0, $3Vbvi.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("gawXH", function(module, exports) {

$parcel$export(module.exports, "map", () => $0309a9e77fb5a785$export$871de8747c9eaa88);

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $0309a9e77fb5a785$export$871de8747c9eaa88(project, thisArg) {
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});
parcelRegister("5CoSH", function(module, exports) {

$parcel$export(module.exports, "operate", () => $4173cd3c90e86d78$export$871731df685d7753);

var $ePlbj = parcelRequire("ePlbj");
function $4173cd3c90e86d78$export$ebec8610810318c5(source) {
    return (0, $ePlbj.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $4173cd3c90e86d78$export$871731df685d7753(init) {
    return function(source) {
        if ($4173cd3c90e86d78$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

});

parcelRegister("iIZUt", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $da1c5c0c9d71adb4$export$b9e075132cc6937f);

var $deWeK = parcelRequire("deWeK");

var $1uzAx = parcelRequire("1uzAx");
function $da1c5c0c9d71adb4$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $da1c5c0c9d71adb4$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $da1c5c0c9d71adb4$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $deWeK.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $1uzAx.Subscriber));

});
parcelRegister("1uzAx", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $116432e7317ad3f7$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $116432e7317ad3f7$export$94eeb6a328cab6c7);

var $deWeK = parcelRequire("deWeK");

var $ePlbj = parcelRequire("ePlbj");

var $iTzX8 = parcelRequire("iTzX8");

var $jyRby = parcelRequire("jyRby");

var $3jHXf = parcelRequire("3jHXf");

var $a5qXo = parcelRequire("a5qXo");

var $lSCWa = parcelRequire("lSCWa");

var $7y8Vd = parcelRequire("7y8Vd");

var $liMhZ = parcelRequire("liMhZ");
var $116432e7317ad3f7$export$60959659b2c22881 = function(_super) {
    (0, $deWeK.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $iTzX8.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $116432e7317ad3f7$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $116432e7317ad3f7$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $116432e7317ad3f7$var$handleStoppedNotification((0, $lSCWa.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $116432e7317ad3f7$var$handleStoppedNotification((0, $lSCWa.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $116432e7317ad3f7$var$handleStoppedNotification((0, $lSCWa.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $iTzX8.Subscription));
var $116432e7317ad3f7$var$_bind = Function.prototype.bind;
function $116432e7317ad3f7$var$bind(fn, thisArg) {
    return $116432e7317ad3f7$var$_bind.call(fn, thisArg);
}
var $116432e7317ad3f7$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $116432e7317ad3f7$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $116432e7317ad3f7$var$handleUnhandledError(error);
        }
        else $116432e7317ad3f7$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $116432e7317ad3f7$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $116432e7317ad3f7$export$94eeb6a328cab6c7 = function(_super) {
    (0, $deWeK.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $ePlbj.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $jyRby.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $116432e7317ad3f7$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $116432e7317ad3f7$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $116432e7317ad3f7$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $116432e7317ad3f7$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($116432e7317ad3f7$export$60959659b2c22881);
function $116432e7317ad3f7$var$handleUnhandledError(error) {
    if ((0, $jyRby.config).useDeprecatedSynchronousErrorHandling) (0, $liMhZ.captureError)(error);
    else (0, $3jHXf.reportUnhandledError)(error);
}
function $116432e7317ad3f7$var$defaultErrorHandler(err) {
    throw err;
}
function $116432e7317ad3f7$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $jyRby.config).onStoppedNotification;
    onStoppedNotification && (0, $7y8Vd.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $116432e7317ad3f7$export$88d395d20619a0af = {
    closed: true,
    next: (0, $a5qXo.noop),
    error: $116432e7317ad3f7$var$defaultErrorHandler,
    complete: (0, $a5qXo.noop)
};

});
parcelRegister("jyRby", function(module, exports) {

$parcel$export(module.exports, "config", () => $e3da72d26d7c6ee9$export$e506a1d27d1eaa20);
var $e3da72d26d7c6ee9$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("3jHXf", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $26a53de6444970a7$export$ebf645db02d3e99f);

var $jyRby = parcelRequire("jyRby");

var $7y8Vd = parcelRequire("7y8Vd");
function $26a53de6444970a7$export$ebf645db02d3e99f(err) {
    (0, $7y8Vd.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $jyRby.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("7y8Vd", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $57f2a111a7fa6d40$export$365aa6bd3c788e3d);

var $deWeK = parcelRequire("deWeK");
var $57f2a111a7fa6d40$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $57f2a111a7fa6d40$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $deWeK.__spreadArray)([
            handler,
            timeout
        ], (0, $deWeK.__read)(args)));
        return setTimeout.apply(void 0, (0, $deWeK.__spreadArray)([
            handler,
            timeout
        ], (0, $deWeK.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $57f2a111a7fa6d40$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("a5qXo", function(module, exports) {

$parcel$export(module.exports, "noop", () => $757f481dc38b41b2$export$8793edee2d425525);
function $757f481dc38b41b2$export$8793edee2d425525() {}

});

parcelRegister("lSCWa", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $fedcd83e6d7ee480$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $fedcd83e6d7ee480$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $fedcd83e6d7ee480$export$ff9346b0d1d30313);
var $fedcd83e6d7ee480$export$b7f97edb34bc1f87 = function() {
    return $fedcd83e6d7ee480$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $fedcd83e6d7ee480$export$dd472c3d8fe5a85a(error) {
    return $fedcd83e6d7ee480$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $fedcd83e6d7ee480$export$ff9346b0d1d30313(value) {
    return $fedcd83e6d7ee480$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $fedcd83e6d7ee480$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("liMhZ", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $f820bca7508033db$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $f820bca7508033db$export$3e205fbb5df021e0);

var $jyRby = parcelRequire("jyRby");
var $f820bca7508033db$var$context = null;
function $f820bca7508033db$export$d974811edc77eafa(cb) {
    if ((0, $jyRby.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$f820bca7508033db$var$context;
        if (isRoot) $f820bca7508033db$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $f820bca7508033db$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $f820bca7508033db$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $f820bca7508033db$export$3e205fbb5df021e0(err) {
    if ((0, $jyRby.config).useDeprecatedSynchronousErrorHandling && $f820bca7508033db$var$context) {
        $f820bca7508033db$var$context.errorThrown = true;
        $f820bca7508033db$var$context.error = err;
    }
}

});




parcelRegister("1wVYm", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $11d5bfbd7ead00f1$export$6a9cfa3ebc765910);

var $deWeK = parcelRequire("deWeK");

var $g2lVS = parcelRequire("g2lVS");

var $gvuNH = parcelRequire("gvuNH");

var $8id0M = parcelRequire("8id0M");

var $93gW4 = parcelRequire("93gW4");

var $5mAwr = parcelRequire("5mAwr");

var $6LdrM = parcelRequire("6LdrM");

var $2QCg9 = parcelRequire("2QCg9");

var $aCJHO = parcelRequire("aCJHO");

var $ePlbj = parcelRequire("ePlbj");

var $3jHXf = parcelRequire("3jHXf");

var $jLNJa = parcelRequire("jLNJa");
function $11d5bfbd7ead00f1$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $8id0M.Observable)) return input;
    if (input != null) {
        if ((0, $93gW4.isInteropObservable)(input)) return $11d5bfbd7ead00f1$export$aa3d41784b3267fa(input);
        if ((0, $g2lVS.isArrayLike)(input)) return $11d5bfbd7ead00f1$export$4cb2acdbcda2c253(input);
        if ((0, $gvuNH.isPromise)(input)) return $11d5bfbd7ead00f1$export$60f45028237c39d1(input);
        if ((0, $5mAwr.isAsyncIterable)(input)) return $11d5bfbd7ead00f1$export$e073fccf36d78cc1(input);
        if ((0, $2QCg9.isIterable)(input)) return $11d5bfbd7ead00f1$export$dcccc29c315dd646(input);
        if ((0, $aCJHO.isReadableStreamLike)(input)) return $11d5bfbd7ead00f1$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $6LdrM.createInvalidObservableTypeError)(input);
}
function $11d5bfbd7ead00f1$export$aa3d41784b3267fa(obj) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        var obs = obj[0, $jLNJa.observable]();
        if ((0, $ePlbj.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $11d5bfbd7ead00f1$export$4cb2acdbcda2c253(array) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $11d5bfbd7ead00f1$export$60f45028237c39d1(promise) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $3jHXf.reportUnhandledError));
    });
}
function $11d5bfbd7ead00f1$export$dcccc29c315dd646(iterable) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $deWeK.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $11d5bfbd7ead00f1$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        $11d5bfbd7ead00f1$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $11d5bfbd7ead00f1$export$b2dcb11d46e7a4ad(readableStream) {
    return $11d5bfbd7ead00f1$export$e073fccf36d78cc1((0, $aCJHO.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $11d5bfbd7ead00f1$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $deWeK.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $deWeK.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("g2lVS", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $bacdd8936ba8f53d$export$1e2f57719e155213);
var $bacdd8936ba8f53d$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

});

parcelRegister("gvuNH", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $c0476eee0a6bedf9$export$4369c812aac99591);

var $ePlbj = parcelRequire("ePlbj");
function $c0476eee0a6bedf9$export$4369c812aac99591(value) {
    return (0, $ePlbj.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("8id0M", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $609a1902204d0f0e$export$77cea355fa80b5f4);

var $1uzAx = parcelRequire("1uzAx");

var $iTzX8 = parcelRequire("iTzX8");

var $jLNJa = parcelRequire("jLNJa");

var $hPrdq = parcelRequire("hPrdq");

var $jyRby = parcelRequire("jyRby");

var $ePlbj = parcelRequire("ePlbj");

var $liMhZ = parcelRequire("liMhZ");
var $609a1902204d0f0e$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $609a1902204d0f0e$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $1uzAx.SafeSubscriber)(observerOrNext, error, complete);
        (0, $liMhZ.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $609a1902204d0f0e$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $1uzAx.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $jLNJa.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $hPrdq.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $609a1902204d0f0e$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $609a1902204d0f0e$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $jyRby.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $609a1902204d0f0e$var$isObserver(value) {
    return value && (0, $ePlbj.isFunction)(value.next) && (0, $ePlbj.isFunction)(value.error) && (0, $ePlbj.isFunction)(value.complete);
}
function $609a1902204d0f0e$var$isSubscriber(value) {
    return value && value instanceof (0, $1uzAx.Subscriber) || $609a1902204d0f0e$var$isObserver(value) && (0, $iTzX8.isSubscription)(value);
}

});
parcelRegister("jLNJa", function(module, exports) {

$parcel$export(module.exports, "observable", () => $e648faf1d4119414$export$5ab46cbf6120b33a);
var $e648faf1d4119414$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

});

parcelRegister("hPrdq", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $cfac4f8608768e89$export$a4627e546088548d);
$parcel$export(module.exports, "pipeFromArray", () => $cfac4f8608768e89$export$71f88a61afaa14d7);

var $6BqGr = parcelRequire("6BqGr");
function $cfac4f8608768e89$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $cfac4f8608768e89$export$71f88a61afaa14d7(fns);
}
function $cfac4f8608768e89$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $6BqGr.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("6BqGr", function(module, exports) {

$parcel$export(module.exports, "identity", () => $4ceae5923c330ded$export$f0954fd7d5368655);
function $4ceae5923c330ded$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("93gW4", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $697187eaf1d5b694$export$48c0cddbc99c45c2);

var $jLNJa = parcelRequire("jLNJa");

var $ePlbj = parcelRequire("ePlbj");
function $697187eaf1d5b694$export$48c0cddbc99c45c2(input) {
    return (0, $ePlbj.isFunction)(input[0, $jLNJa.observable]);
}

});

parcelRegister("5mAwr", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $3e7b565b51d00997$export$edb10ab8dd75a915);

var $ePlbj = parcelRequire("ePlbj");
function $3e7b565b51d00997$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $ePlbj.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("6LdrM", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $4ec190321080ecdb$export$7cbe71b9fa263484);
function $4ec190321080ecdb$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("2QCg9", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $212e1da0a819db81$export$9652023d9040757);

var $34FBz = parcelRequire("34FBz");

var $ePlbj = parcelRequire("ePlbj");
function $212e1da0a819db81$export$9652023d9040757(input) {
    return (0, $ePlbj.isFunction)(input === null || input === void 0 ? void 0 : input[0, $34FBz.iterator]);
}

});
parcelRegister("34FBz", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $23d204b3ff192887$export$6f58e2338da23f4d);
function $23d204b3ff192887$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $23d204b3ff192887$export$6f58e2338da23f4d = $23d204b3ff192887$export$aa9956be4ae4fe8();

});


parcelRegister("aCJHO", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $7bc0e830c17b220c$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $7bc0e830c17b220c$export$c088ffafdba7405f);

var $deWeK = parcelRequire("deWeK");

var $ePlbj = parcelRequire("ePlbj");
function $7bc0e830c17b220c$export$cf4785e597badab3(readableStream) {
    return (0, $deWeK.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $deWeK.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $deWeK.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $deWeK.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $deWeK.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $7bc0e830c17b220c$export$c088ffafdba7405f(obj) {
    return (0, $ePlbj.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});


parcelRegister("3Vbvi", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", () => $2daf9e5b6afd5119$export$600918ebaa9e0a1b);

var $1wVYm = parcelRequire("1wVYm");

var $hrgoa = parcelRequire("hrgoa");

var $iIZUt = parcelRequire("iIZUt");
function $2daf9e5b6afd5119$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1wVYm.innerFrom)(project(value, index++)).subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $hrgoa.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});
parcelRegister("hrgoa", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $cb21abbf89389dab$export$a2b7447487315232);
function $cb21abbf89389dab$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});





parcelRegister("9Rm6G", function(module, exports) {

$parcel$export(module.exports, "popResultSelector", () => $72da363e9c84a262$export$9ae19b645239a61b);
$parcel$export(module.exports, "popScheduler", () => $72da363e9c84a262$export$29534b2f653ae592);
$parcel$export(module.exports, "popNumber", () => $72da363e9c84a262$export$3de14b735070dcd5);

var $ePlbj = parcelRequire("ePlbj");

var $b8G77 = parcelRequire("b8G77");
function $72da363e9c84a262$var$last(arr) {
    return arr[arr.length - 1];
}
function $72da363e9c84a262$export$9ae19b645239a61b(args) {
    return (0, $ePlbj.isFunction)($72da363e9c84a262$var$last(args)) ? args.pop() : undefined;
}
function $72da363e9c84a262$export$29534b2f653ae592(args) {
    return (0, $b8G77.isScheduler)($72da363e9c84a262$var$last(args)) ? args.pop() : undefined;
}
function $72da363e9c84a262$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $72da363e9c84a262$var$last(args) === 'number' ? args.pop() : defaultValue;
}

});
parcelRegister("b8G77", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $81c11bf84d3e8629$export$187e35932e88c15c);

var $ePlbj = parcelRequire("ePlbj");
function $81c11bf84d3e8629$export$187e35932e88c15c(value) {
    return value && (0, $ePlbj.isFunction)(value.schedule);
}

});


parcelRegister("5JMLH", function(module, exports) {

$parcel$export(module.exports, "from", () => $42d6fc1de06b3413$export$6788812c4e6611e6);

var $725xD = parcelRequire("725xD");

var $1wVYm = parcelRequire("1wVYm");
function $42d6fc1de06b3413$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $725xD.scheduled)(input, scheduler) : (0, $1wVYm.innerFrom)(input);
}

});
parcelRegister("725xD", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $51ed04bc93686a02$export$49c44dfc2bb21d70);

var $k3q1W = parcelRequire("k3q1W");

var $g4eGN = parcelRequire("g4eGN");

var $hzshe = parcelRequire("hzshe");

var $f1sdm = parcelRequire("f1sdm");

var $kkG4n = parcelRequire("kkG4n");

var $93gW4 = parcelRequire("93gW4");

var $gvuNH = parcelRequire("gvuNH");

var $g2lVS = parcelRequire("g2lVS");

var $2QCg9 = parcelRequire("2QCg9");

var $5mAwr = parcelRequire("5mAwr");

var $6LdrM = parcelRequire("6LdrM");

var $aCJHO = parcelRequire("aCJHO");

var $kFo4j = parcelRequire("kFo4j");
function $51ed04bc93686a02$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $93gW4.isInteropObservable)(input)) return (0, $k3q1W.scheduleObservable)(input, scheduler);
        if ((0, $g2lVS.isArrayLike)(input)) return (0, $hzshe.scheduleArray)(input, scheduler);
        if ((0, $gvuNH.isPromise)(input)) return (0, $g4eGN.schedulePromise)(input, scheduler);
        if ((0, $5mAwr.isAsyncIterable)(input)) return (0, $kkG4n.scheduleAsyncIterable)(input, scheduler);
        if ((0, $2QCg9.isIterable)(input)) return (0, $f1sdm.scheduleIterable)(input, scheduler);
        if ((0, $aCJHO.isReadableStreamLike)(input)) return (0, $kFo4j.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $6LdrM.createInvalidObservableTypeError)(input);
}

});
parcelRegister("k3q1W", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $e998478cc5e2d38a$export$ed8bd553a12b6a30);

var $1wVYm = parcelRequire("1wVYm");

var $44G0R = parcelRequire("44G0R");

var $f9mhr = parcelRequire("f9mhr");
function $e998478cc5e2d38a$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1wVYm.innerFrom)(input).pipe((0, $f9mhr.subscribeOn)(scheduler), (0, $44G0R.observeOn)(scheduler));
}

});
parcelRegister("44G0R", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $2f782008a7d972cf$export$9007f49c319d1ac7);

var $hrgoa = parcelRequire("hrgoa");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $2f782008a7d972cf$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $5CoSH.operate)(function(source, subscriber) {
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});

parcelRegister("f9mhr", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $b078fab1db80d269$export$1eb44d8f5f64733b);

var $5CoSH = parcelRequire("5CoSH");
function $b078fab1db80d269$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $5CoSH.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("g4eGN", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $bb286a069417e07d$export$fc9afd948577f0a8);

var $1wVYm = parcelRequire("1wVYm");

var $44G0R = parcelRequire("44G0R");

var $f9mhr = parcelRequire("f9mhr");
function $bb286a069417e07d$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1wVYm.innerFrom)(input).pipe((0, $f9mhr.subscribeOn)(scheduler), (0, $44G0R.observeOn)(scheduler));
}

});

parcelRegister("hzshe", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $ccaba3c25d32beb2$export$b34673931371729a);

var $8id0M = parcelRequire("8id0M");
function $ccaba3c25d32beb2$export$b34673931371729a(input, scheduler) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("f1sdm", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $aefcd5d2d08e97b0$export$2b75c58ab9b5b766);

var $8id0M = parcelRequire("8id0M");

var $34FBz = parcelRequire("34FBz");

var $ePlbj = parcelRequire("ePlbj");

var $hrgoa = parcelRequire("hrgoa");
function $aefcd5d2d08e97b0$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        var iterator;
        (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $34FBz.iterator]();
            (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $ePlbj.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("kkG4n", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $ecd64f12dd66c171$export$7c7f0979b56a32f3);

var $8id0M = parcelRequire("8id0M");

var $hrgoa = parcelRequire("hrgoa");
function $ecd64f12dd66c171$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $8id0M.Observable)(function(subscriber) {
        (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("kFo4j", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $f0ba4e814bef3910$export$3385251aeecad28a);

var $kkG4n = parcelRequire("kkG4n");

var $aCJHO = parcelRequire("aCJHO");
function $f0ba4e814bef3910$export$3385251aeecad28a(input, scheduler) {
    return (0, $kkG4n.scheduleAsyncIterable)((0, $aCJHO.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});




parcelRegister("d5Aat", function(module, exports) {

$parcel$export(module.exports, "take", () => $9877cc306203a0c2$export$b7df5d561049483a);

var $7xymH = parcelRequire("7xymH");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $9877cc306203a0c2$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $7xymH.EMPTY;
    } : (0, $5CoSH.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

});
parcelRegister("7xymH", function(module, exports) {

$parcel$export(module.exports, "EMPTY", () => $57d645acd5e69001$export$ccb33e29d92c9a58);

var $8id0M = parcelRequire("8id0M");
var $57d645acd5e69001$export$ccb33e29d92c9a58 = new (0, $8id0M.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $57d645acd5e69001$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $57d645acd5e69001$var$emptyScheduled(scheduler) : $57d645acd5e69001$export$ccb33e29d92c9a58;
}
function $57d645acd5e69001$var$emptyScheduled(scheduler) {
    return new (0, $8id0M.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});


parcelRegister("3M6kY", function(module, exports) {

$parcel$export(module.exports, "ignoreElements", () => $2bfac53d39d990bc$export$6953b97c7d866605);

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");

var $a5qXo = parcelRequire("a5qXo");
function $2bfac53d39d990bc$export$6953b97c7d866605() {
    return (0, $5CoSH.operate)(function(source, subscriber) {
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, (0, $a5qXo.noop)));
    });
}

});

parcelRegister("guYpB", function(module, exports) {

$parcel$export(module.exports, "mapTo", () => $c02e4f3c82cc4125$export$e0eaf3a86c03b2ad);

var $gawXH = parcelRequire("gawXH");
function $c02e4f3c82cc4125$export$e0eaf3a86c03b2ad(value) {
    return (0, $gawXH.map)(function() {
        return value;
    });
}

});


parcelRegister("gTQqg", function(module, exports) {

$parcel$export(module.exports, "timer", () => $c4da72696c69338e$export$9dc4ecf953986f04);

var $8id0M = parcelRequire("8id0M");

var $8fD1K = parcelRequire("8fD1K");

var $b8G77 = parcelRequire("b8G77");

var $8s4v1 = parcelRequire("8s4v1");
function $c4da72696c69338e$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $8fD1K.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $b8G77.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $8id0M.Observable)(function(subscriber) {
        var due = (0, $8s4v1.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}

});
parcelRegister("8s4v1", function(module, exports) {

$parcel$export(module.exports, "isValidDate", () => $62746db8d9cdcb5d$export$c03bb0116ee09d4b);
function $62746db8d9cdcb5d$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}

});



parcelRegister("4YpXN", function(module, exports) {

$parcel$export(module.exports, "retryWhen", () => $39f0e7d2d536140e$export$1281551253cfee02);

var $1wVYm = parcelRequire("1wVYm");

var $f16OP = parcelRequire("f16OP");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $39f0e7d2d536140e$export$1281551253cfee02(notifier) {
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function() {
            innerSub = source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
                if (!errors$) {
                    errors$ = new (0, $f16OP.Subject)();
                    (0, $1wVYm.innerFrom)(notifier(errors$)).subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function() {
                        return innerSub ? subscribeForRetryWhen() : syncResub = true;
                    }));
                }
                if (errors$) errors$.next(err);
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRetryWhen();
            }
        };
        subscribeForRetryWhen();
    });
}

});
parcelRegister("f16OP", function(module, exports) {

$parcel$export(module.exports, "Subject", () => $aeec3d1c015326a6$export$b6bbab5a9b109038);

var $deWeK = parcelRequire("deWeK");

var $8id0M = parcelRequire("8id0M");

var $iTzX8 = parcelRequire("iTzX8");

var $iMYrL = parcelRequire("iMYrL");

var $8JVOt = parcelRequire("8JVOt");

var $liMhZ = parcelRequire("liMhZ");
var $aeec3d1c015326a6$export$b6bbab5a9b109038 = function(_super) {
    (0, $deWeK.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $aeec3d1c015326a6$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $iMYrL.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $liMhZ.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $deWeK.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $liMhZ.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $liMhZ.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $iTzX8.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $iTzX8.Subscription)(function() {
            _this.currentObservers = null;
            (0, $8JVOt.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $8id0M.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $aeec3d1c015326a6$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $8id0M.Observable));
var $aeec3d1c015326a6$export$155189cde295587d = function(_super) {
    (0, $deWeK.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $iTzX8.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}($aeec3d1c015326a6$export$b6bbab5a9b109038);

});
parcelRegister("iMYrL", function(module, exports) {

$parcel$export(module.exports, "ObjectUnsubscribedError", () => $dadb993020e1a4b1$export$f708eee25634bc80);

var $iNflj = parcelRequire("iNflj");
var $dadb993020e1a4b1$export$f708eee25634bc80 = (0, $iNflj.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

});



parcelRegister("lFNui", function(module, exports) {

$parcel$export(module.exports, "scan", () => $fc73d083a7a31c63$export$c87d910e63d22ed6);

var $5CoSH = parcelRequire("5CoSH");

var $1WTxE = parcelRequire("1WTxE");
function $fc73d083a7a31c63$export$c87d910e63d22ed6(accumulator, seed) {
    return (0, $5CoSH.operate)((0, $1WTxE.scanInternals)(accumulator, seed, arguments.length >= 2, true));
}

});
parcelRegister("1WTxE", function(module, exports) {

$parcel$export(module.exports, "scanInternals", () => $16b64aab1e6cb153$export$30fc204bc7867c02);

var $iIZUt = parcelRequire("iIZUt");
function $16b64aab1e6cb153$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}

});


parcelRegister("3dOhR", function(module, exports) {

$parcel$export(module.exports, "tap", () => $258997fac081a649$export$3f23594af5f37336);

var $ePlbj = parcelRequire("ePlbj");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");

var $6BqGr = parcelRequire("6BqGr");
function $258997fac081a649$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $ePlbj.isFunction)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $5CoSH.operate)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $6BqGr.identity);
}

});



parcelRegister("1t8Wn", function(module, exports) {
"use strict";
var $111f6f47b30b032e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $111f6f47b30b032e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $111f6f47b30b032e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("eCW61");

$111f6f47b30b032e$var$__exportStar((parcelRequire("lbXPS")), module.exports);

$111f6f47b30b032e$var$__exportStar((parcelRequire("cWWbB")), module.exports);

$111f6f47b30b032e$var$__exportStar((parcelRequire("3y1aW")), module.exports);

$111f6f47b30b032e$var$__exportStar((parcelRequire("CEp6l")), module.exports);

});
parcelRegister("eCW61", function(module, exports) {
const $aa61adf6979a98f3$var$Metadata = new WeakMap();
function $aa61adf6979a98f3$var$decorateProperty(decorators, target, propertyKey, descriptor) {
    decorators.reverse().forEach((decorator)=>{
        descriptor = decorator(target, propertyKey, descriptor) || descriptor;
    });
    return descriptor;
}
function $aa61adf6979a98f3$var$decorateConstructor(decorators, target) {
    decorators.reverse().forEach((decorator)=>{
        const decorated = decorator(target);
        if (decorated) target = decorated;
    });
    return target;
}
function $aa61adf6979a98f3$export$c80826d3392ea781(decorators, target, propertyKey, attributes) {
    if (!Array.isArray(decorators) || decorators.length === 0) throw new TypeError();
    if (propertyKey !== undefined) return $aa61adf6979a98f3$var$decorateProperty(decorators, target, propertyKey, attributes);
    if (typeof target === 'function') return $aa61adf6979a98f3$var$decorateConstructor(decorators, target);
    return;
}
function $aa61adf6979a98f3$var$getMetadataMap(target, propertyKey) {
    return $aa61adf6979a98f3$var$Metadata.get(target) && $aa61adf6979a98f3$var$Metadata.get(target).get(propertyKey);
}
function $aa61adf6979a98f3$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey) {
    if (target === undefined) throw new TypeError();
    const metadataMap = $aa61adf6979a98f3$var$getMetadataMap(target, propertyKey);
    return metadataMap && metadataMap.get(metadataKey);
}
function $aa61adf6979a98f3$var$createMetadataMap(target, propertyKey) {
    const targetMetadata = $aa61adf6979a98f3$var$Metadata.get(target) || new Map();
    $aa61adf6979a98f3$var$Metadata.set(target, targetMetadata);
    const metadataMap = targetMetadata.get(propertyKey) || new Map();
    targetMetadata.set(propertyKey, metadataMap);
    return metadataMap;
}
function $aa61adf6979a98f3$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey) {
    if (propertyKey && ![
        'string',
        'symbol'
    ].includes(typeof propertyKey)) throw new TypeError();
    ($aa61adf6979a98f3$var$getMetadataMap(target, propertyKey) || $aa61adf6979a98f3$var$createMetadataMap(target, propertyKey)).set(metadataKey, metadataValue);
}
function $aa61adf6979a98f3$var$ordinaryGetMetadata(metadataKey, target, propertyKey) {
    return $aa61adf6979a98f3$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey) ? $aa61adf6979a98f3$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey) : Object.getPrototypeOf(target) ? $aa61adf6979a98f3$var$ordinaryGetMetadata(metadataKey, Object.getPrototypeOf(target), propertyKey) : undefined;
}
function $aa61adf6979a98f3$export$dbb5e893e736e4ee(metadataKey, metadataValue) {
    return function decorator(target, propertyKey) {
        $aa61adf6979a98f3$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
    };
}
function $aa61adf6979a98f3$export$8548546c0aa631e6(metadataKey, target, propertyKey) {
    return $aa61adf6979a98f3$var$ordinaryGetMetadata(metadataKey, target, propertyKey);
}
function $aa61adf6979a98f3$export$cc60eefbe5c9bad7(metadataKey, target, propertyKey) {
    return $aa61adf6979a98f3$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey);
}
function $aa61adf6979a98f3$export$38cb5e4e0f9aedfe(metadataKey, target, propertyKey) {
    return !!$aa61adf6979a98f3$var$ordinaryGetOwnMetadata(metadataKey, target, propertyKey);
}
function $aa61adf6979a98f3$export$fc04a41421709487(metadataKey, target, propertyKey) {
    return !!$aa61adf6979a98f3$var$ordinaryGetMetadata(metadataKey, target, propertyKey);
}
function $aa61adf6979a98f3$export$70bbf20791f57d90(metadataKey, metadataValue, target, propertyKey) {
    $aa61adf6979a98f3$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
}
const $aa61adf6979a98f3$export$7c4bec61e60f667b = {
    decorate: $aa61adf6979a98f3$export$c80826d3392ea781,
    defineMetadata: $aa61adf6979a98f3$export$70bbf20791f57d90,
    getMetadata: $aa61adf6979a98f3$export$8548546c0aa631e6,
    getOwnMetadata: $aa61adf6979a98f3$export$cc60eefbe5c9bad7,
    hasMetadata: $aa61adf6979a98f3$export$fc04a41421709487,
    hasOwnMetadata: $aa61adf6979a98f3$export$38cb5e4e0f9aedfe,
    metadata: $aa61adf6979a98f3$export$dbb5e893e736e4ee
};
Object.assign(Reflect, $aa61adf6979a98f3$export$7c4bec61e60f667b);

});

parcelRegister("lbXPS", function(module, exports) {
"use strict";
var $f6d90a32b1c10266$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f6d90a32b1c10266$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f6d90a32b1c10266$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectionToken = module.exports.ContainerInstance = module.exports.Container = module.exports.Injectable = void 0;

var $9dO3J = parcelRequire("9dO3J");
Object.defineProperty(module.exports, "Injectable", {
    enumerable: true,
    get: function() {
        return $9dO3J.Service;
    }
});

var $4VpzQ = parcelRequire("4VpzQ");
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function() {
        return $4VpzQ.Container;
    }
});

var $d9nCF = parcelRequire("d9nCF");
Object.defineProperty(module.exports, "ContainerInstance", {
    enumerable: true,
    get: function() {
        return $d9nCF.ContainerInstance;
    }
});

var $h7YuD = parcelRequire("h7YuD");
Object.defineProperty(module.exports, "InjectionToken", {
    enumerable: true,
    get: function() {
        return $h7YuD.Token;
    }
});

$f6d90a32b1c10266$var$__exportStar((parcelRequire("beEls")), module.exports);

});
parcelRegister("9dO3J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Service = $6b6c28ad99953f2d$var$Service;

var $4kW5x = parcelRequire("4kW5x");
/**
 * Marks class as a service that can be injected using container.
 */ function $6b6c28ad99953f2d$var$Service(options) {
    return (0, $4kW5x.ReflectDecorator)(options, {
        type: 'service'
    });
}

});
parcelRegister("4kW5x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReflectDecorator = $328616d22c0f636c$var$ReflectDecorator;

var $hCc9H = parcelRequire("hCc9H");

var $4VpzQ = parcelRequire("4VpzQ");

var $h7YuD = parcelRequire("h7YuD");
function $328616d22c0f636c$var$ReflectDecorator(options, metaOptions) {
    return (target)=>{
        const uniqueHashForClass = (0, $hCc9H.createUniqueHash)(`${target}${JSON.stringify(options, null, 4)}`);
        Object.defineProperty(target, 'originalName', {
            value: target.name || target.constructor.name,
            writable: false
        });
        Object.defineProperty(target, 'name', {
            value: uniqueHashForClass,
            writable: true
        });
        const nameCapitalized = (name)=>name.charAt(0).toUpperCase() + name.slice(1);
        target['metadata'] = {
            moduleName: target['originalName'],
            moduleHash: uniqueHashForClass,
            options: options || null,
            type: metaOptions.type,
            raw: `
        ---- @${nameCapitalized(metaOptions.type)} '${target.name}' metadata----
        @${nameCapitalized(metaOptions.type)}(${JSON.stringify(options, null, 4)})
        ${target['originalName']}
        `
        };
        const service = {
            type: target
        };
        if (typeof options === 'string' || options instanceof $h7YuD.Token) {
            service.id = options;
            service.multiple = options.multiple;
            service.global = options.global || false;
            service.transient = options.transient;
        } else if (options) {
            service.id = options.id;
            service.factory = options.factory;
            service.multiple = options.multiple;
            service.global = options.global || false;
            service.transient = options.transient;
        }
        $4VpzQ.Container.set(service);
    };
}

});
parcelRegister("hCc9H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUniqueHash = $cd2f6a1df0d76555$var$createUniqueHash;

var $1sM1c = parcelRequire("1sM1c");
function $cd2f6a1df0d76555$var$createUniqueHash(key) {
    return $1sM1c.sha256.hash(key);
}

});
parcelRegister("1sM1c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256 = module.exports.Sha256 = void 0;
class $110da769d2ef9c63$var$Sha256 {
    /**
     * Generates SHA-256 hash of string.
     *
     * @param   {string} msg - (Unicode) string to be hashed.
     * @param   {Object} [options]
     * @param   {string} [options.msgFormat=string] - Message format: 'string' for JavaScript string
     *   (gets converted to UTF-8 for hashing); 'hex-bytes' for string of hex bytes ('616263' ≡ 'abc') .
     * @param   {string} [options.outFormat=hex] - Output format: 'hex' for string of contiguous
     *   hex bytes; 'hex-w' for grouping hex bytes into groups of (4 byte / 8 character) words.
     * @returns {string} Hash of msg as hex character string.
     */ hash(msg, options) {
        const defaults = {
            msgFormat: 'string',
            outFormat: 'hex'
        };
        const opt = Object.assign(defaults, options);
        // note use throughout this routine of 'n >>> 0' to coerce Number 'n' to unsigned 32-bit integer
        msg = utf8Encode(msg);
        switch(opt.msgFormat){
            default:
            case 'string':
                msg = utf8Encode(msg);
                break;
            case 'hex-bytes':
                msg = hexBytesToString(msg);
                break; // mostly for running tests
        }
        // constants [§4.2.2]
        const K = [
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ];
        // initial hash value [§5.3.3]
        const H = [
            0x6a09e667,
            0xbb67ae85,
            0x3c6ef372,
            0xa54ff53a,
            0x510e527f,
            0x9b05688c,
            0x1f83d9ab,
            0x5be0cd19
        ];
        // PREPROCESSING [§6.2.1]
        msg += String.fromCharCode(0x80); // add trailing '1' bit (+ 0's padding) to string [§5.1.1]
        // convert string msg into 512-bit blocks (array of 16 32-bit integers) [§5.2.1]
        const l = msg.length / 4 + 2; // length (in 32-bit integers) of msg + ‘1’ + appended length
        const N = Math.ceil(l / 16); // number of 16-integer (512-bit) blocks required to hold 'l' ints
        const M = new Array(N); // message M is N×16 array of 32-bit integers
        for(let i = 0; i < N; i++){
            M[i] = new Array(16);
            for(let j = 0; j < 16; j++)M[i][j] = msg.charCodeAt(i * 64 + j * 4 + 0) << 24 | msg.charCodeAt(i * 64 + j * 4 + 1) << 16 | msg.charCodeAt(i * 64 + j * 4 + 2) << 8 | msg.charCodeAt(i * 64 + j * 4 + 3) << 0;
             // note running off the end of msg is ok 'cos bitwise ops on NaN return 0
        }
        // add length (in bits) into final pair of 32-bit integers (big-endian) [§5.1.1]
        // note: most significant word would be (len-1)*8 >>> 32, but since JS converts
        // bitwise-op args to 32 bits, we need to simulate this by arithmetic operators
        const lenHi = (msg.length - 1) * 8 / Math.pow(2, 32);
        const lenLo = (msg.length - 1) * 8 >>> 0;
        M[N - 1][14] = Math.floor(lenHi);
        M[N - 1][15] = lenLo;
        // HASH COMPUTATION [§6.2.2]
        for(let i = 0; i < N; i++){
            const W = new Array(64);
            // 1 - prepare message schedule 'W'
            for(let t = 0; t < 16; t++)W[t] = M[i][t];
            for(let t = 16; t < 64; t++)W[t] = this.\u03C31(W[t - 2]) + W[t - 7] + this.\u03C30(W[t - 15]) + W[t - 16] >>> 0;
            // 2 - initialise working variables a, b, c, d, e, f, g, h with previous hash value
            let a = H[0], b = H[1], c = H[2], d = H[3], e = H[4], f = H[5], g = H[6], h = H[7];
            // 3 - main loop (note '>>> 0' for 'addition modulo 2^32')
            for(let t = 0; t < 64; t++){
                const T1 = h + this.\u03A31(e) + this.Ch(e, f, g) + K[t] + W[t];
                const T2 = this.\u03A30(a) + this.Maj(a, b, c);
                h = g;
                g = f;
                f = e;
                e = d + T1 >>> 0;
                d = c;
                c = b;
                b = a;
                a = T1 + T2 >>> 0;
            }
            // 4 - compute the new intermediate hash value (note '>>> 0' for 'addition modulo 2^32')
            H[0] = H[0] + a >>> 0;
            H[1] = H[1] + b >>> 0;
            H[2] = H[2] + c >>> 0;
            H[3] = H[3] + d >>> 0;
            H[4] = H[4] + e >>> 0;
            H[5] = H[5] + f >>> 0;
            H[6] = H[6] + g >>> 0;
            H[7] = H[7] + h >>> 0;
        }
        // convert H0..H7 to hex strings (with leading zeros)
        for(let h = 0; h < H.length; h++)H[h] = ('00000000' + H[h].toString(16)).slice(-8);
        // concatenate H0..H7, with separator if required
        const separator = opt.outFormat == 'hex-w' ? ' ' : '';
        return H.join(separator);
        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */ function utf8Encode(str) {
            try {
                return new TextEncoder().encode(str).reduce((prev, curr)=>prev + String.fromCharCode(curr), '');
            } catch (e) {
                return unescape(encodeURIComponent(str)); // monsur.hossa.in/2012/07/20/utf-8-in-javascript.html
            }
        }
        function hexBytesToString(hexStr) {
            const str = hexStr.replace(' ', ''); // allow space-separated groups
            return str == '' ? '' : str.match(/.{2}/g).map((byte)=>String.fromCharCode(parseInt(byte, 16))).join('');
        }
    }
    /**
     * Rotates right (circular right shift) value x by n positions [§3.2.4].
     * @private
     */ ROTR(n, x) {
        return x >>> n | x << 32 - n;
    }
    /**
     * Logical functions [§4.1.2].
     * @private
     */ \u03A30(x) {
        return this.ROTR(2, x) ^ this.ROTR(13, x) ^ this.ROTR(22, x);
    }
    \u03A31(x) {
        return this.ROTR(6, x) ^ this.ROTR(11, x) ^ this.ROTR(25, x);
    }
    \u03C30(x) {
        return this.ROTR(7, x) ^ this.ROTR(18, x) ^ x >>> 3;
    }
    \u03C31(x) {
        return this.ROTR(17, x) ^ this.ROTR(19, x) ^ x >>> 10;
    }
    Ch(x, y, z) {
        return x & y ^ ~x & z;
    }
    Maj(x, y, z) {
        return x & y ^ x & z ^ y & z;
    }
}
module.exports.Sha256 = $110da769d2ef9c63$var$Sha256;
module.exports.sha256 = new $110da769d2ef9c63$var$Sha256();

});


parcelRegister("4VpzQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Container = void 0;

var $d9nCF = parcelRequire("d9nCF");
/**
 * Service container.
 */ class $3960535c05799be1$var$Container {
    // -------------------------------------------------------------------------
    // Public Static Methods
    // -------------------------------------------------------------------------
    /**
     * Gets a separate container instance for the given instance id.
     */ static of(instanceId) {
        if (instanceId === undefined) return this.globalInstance;
        let container = this.instances.get(instanceId);
        if (!container) {
            container = new $d9nCF.ContainerInstance(instanceId);
            this.instances.set(instanceId, container);
        }
        return container;
    }
    /**
     * Checks if the service with given name or type is registered service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ static has(identifier) {
        return this.globalInstance.has(identifier);
    }
    /**
     * Retrieves the service with given name or type from the service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ static get(identifier) {
        return this.globalInstance.get(identifier);
    }
    /**
     * Gets all instances registered in the container of the given service identifier.
     * Used when service defined with multiple: true flag.
     */ static getMany(id) {
        return this.globalInstance.getMany(id);
    }
    /**
     * Sets a value for the given type or service name in the container.
     */ static set(identifierOrServiceMetadata, value) {
        this.globalInstance.set(identifierOrServiceMetadata, value);
        return this;
    }
    /**
     * Removes services with a given service identifiers (tokens or types).
     */ static remove(...ids) {
        this.globalInstance.remove(...ids);
        return this;
    }
    /**
     * Completely resets the container by removing all previously registered services and handlers from it.
     */ static reset(containerId) {
        if (containerId) {
            const instance = this.instances.get(containerId);
            if (instance) {
                instance.reset();
                this.instances.delete(containerId);
            }
        } else {
            this.globalInstance.reset();
            Array.from(this.instances.values()).forEach((i)=>i.reset());
        }
        return this;
    }
    /**
     * Registers a new handler.
     */ static registerHandler(handler) {
        this.handlers.set(handler, handler);
        return this;
    }
    /**
     * Helper method that imports given services.
     */ static import(services) {
        return this;
    }
}
module.exports.Container = $3960535c05799be1$var$Container;
// -------------------------------------------------------------------------
// Private Static Properties
// -------------------------------------------------------------------------
/**
 * Global container instance.
 */ $3960535c05799be1$var$Container.globalInstance = new $d9nCF.ContainerInstance(undefined);
/**
 * Other containers created using Container.of method.
 */ $3960535c05799be1$var$Container.instances = new Map();
/**
 * All registered handlers.
 */ $3960535c05799be1$var$Container.handlers = new Map();

});
parcelRegister("d9nCF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerInstance = void 0;

var $4VpzQ = parcelRequire("4VpzQ");

var $dcXdC = parcelRequire("dcXdC");

var $d339E = parcelRequire("d339E");

var $h7YuD = parcelRequire("h7YuD");

var $c8A38 = parcelRequire("c8A38");
/**
 * TypeDI can have multiple containers.
 * One container is ContainerInstance.
 */ class $992e70936e125585$var$ContainerInstance {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    constructor(id){
        // -------------------------------------------------------------------------
        // Private Properties
        // -------------------------------------------------------------------------
        /**
         * All registered services.
         */ this.services = new Map();
        this.id = id;
    }
    /**
     * Checks if the service with given name or type is registered service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ has(identifier) {
        return !!this.findService(identifier);
    }
    /**
     * Retrieves the service with given name or type from the service container.
     * Optionally, parameters can be passed in case if instance is initialized in the container for the first time.
     */ get(identifier) {
        const globalContainer = $4VpzQ.Container.of(undefined);
        const service = globalContainer.findService(identifier);
        const scopedService = this.findService(identifier);
        if (service && service.global === true) return this.getServiceValue(identifier, service);
        if (scopedService) return this.getServiceValue(identifier, scopedService);
        if (service && this !== globalContainer) {
            const clonedService = Object.assign({}, service);
            clonedService.value = undefined;
            const value = this.getServiceValue(identifier, clonedService);
            this.set(identifier, value);
            return value;
        }
        return this.getServiceValue(identifier, service);
    }
    /**
     * Gets all instances registered in the container of the given service identifier.
     * Used when service defined with multiple: true flag.
     */ getMany(id) {
        return this.filterServices(id).map((service)=>this.getServiceValue(id, service));
    }
    /**
     * Sets a value for the given type or service name in the container.
     */ set(identifierOrServiceMetadata, value) {
        if (identifierOrServiceMetadata instanceof Array) {
            identifierOrServiceMetadata.forEach((v)=>this.set(v));
            return this;
        }
        if (typeof identifierOrServiceMetadata === 'string' || identifierOrServiceMetadata instanceof $h7YuD.Token) return this.set({
            id: identifierOrServiceMetadata,
            value: value
        });
        if (typeof identifierOrServiceMetadata === 'object' && identifierOrServiceMetadata.service) return this.set({
            id: identifierOrServiceMetadata.service,
            value: value
        });
        if (identifierOrServiceMetadata instanceof Function) return this.set({
            type: identifierOrServiceMetadata,
            id: identifierOrServiceMetadata,
            value: value
        });
        // const newService: ServiceMetadata<any, any> = arguments.length === 1 && typeof identifierOrServiceMetadata === 'object'  && !(identifierOrServiceMetadata instanceof Token) ? identifierOrServiceMetadata : undefined;
        const newService = identifierOrServiceMetadata;
        const service = this.services.get(newService);
        if (service && service.multiple !== true) Object.assign(service, newService);
        else this.services.set(newService, newService);
        return this;
    }
    /**
     * Removes services with a given service identifiers (tokens or types).
     */ remove(...ids) {
        ids.forEach((id)=>{
            this.filterServices(id).forEach((service)=>{
                this.services.delete(service);
            });
        });
        return this;
    }
    /**
     * Completely resets the container by removing all previously registered services from it.
     */ reset() {
        this.services.clear();
        return this;
    }
    // -------------------------------------------------------------------------
    // Private Methods
    // -------------------------------------------------------------------------
    /**
     * Filters registered service in the with a given service identifier.
     */ filterServices(identifier) {
        return Array.from(this.services.values()).filter((service)=>{
            if (service.id) return service.id === identifier;
            if (service.type && identifier instanceof Function) return service.type === identifier || identifier.prototype instanceof service.type;
            return false;
        });
    }
    /**
     * Finds registered service in the with a given service identifier.
     */ findService(identifier) {
        return Array.from(this.services.values()).find((service)=>{
            if (service.id) {
                if (identifier instanceof Object && service.id instanceof $h7YuD.Token && identifier.service instanceof $h7YuD.Token) return service.id === identifier.service;
                return service.id === identifier;
            }
            if (service.type && identifier instanceof Function) return service.type === identifier; // todo: not sure why it was here || identifier.prototype instanceof service.type;
            return false;
        });
    }
    /**
     * Gets service value.
     */ getServiceValue(identifier, service) {
        // find if instance of this object already initialized in the container and return it if it is
        if (service && service.value !== undefined) return service.value;
        // if named service was requested and its instance was not found plus there is not type to know what to initialize,
        // this means service was not pre-registered and we throw an exception
        if ((!service || !service.type) && (!service || !service.factory) && (typeof identifier === 'string' || identifier instanceof $h7YuD.Token)) throw new $d339E.ServiceNotFoundError(identifier);
        // at this point we either have type in service registered, either identifier is a target type
        let type = undefined;
        if (service && service.type) type = service.type;
        else if (service && service.id instanceof Function) type = service.id;
        else if (identifier instanceof Function) type = identifier;
        // if service was not found then create a new one and register it
        if (!service) {
            if (!type) throw new $dcXdC.MissingProvidedServiceTypeError(identifier);
            service = {
                type: type
            };
            this.services.set(service, service);
        }
        // setup constructor parameters for a newly initialized service
        const paramTypes = type && Reflect && Reflect.getMetadata ? Reflect.getMetadata('design:paramtypes', type) : undefined;
        let params = paramTypes ? this.initializeParams(type, paramTypes) : [];
        // if factory is set then use it to create service instance
        let value;
        if (service.factory) {
            // filter out non-service parameters from created service constructor
            // non-service parameters can be, lets say Car(name: string, isNew: boolean, engine: Engine)
            // where name and isNew are non-service parameters and engine is a service parameter
            params = params.filter((param)=>param !== undefined);
            if (service.factory instanceof Array) // use special [Type, 'create'] syntax to allow factory services
            // in this case Type instance will be obtained from Container and its method 'create' will be called
            value = this.get(service.factory[0])[service.factory[1]](...params);
            else // regular factory function
            value = service.factory(...params, this);
        } else {
            // otherwise simply create a new object instance
            if (!type) throw new $dcXdC.MissingProvidedServiceTypeError(identifier);
            params.unshift(null);
            // 'extra feature' - always pass container instance as the last argument to the service function
            // this allows us to support javascript where we don't have decorators and emitted metadata about dependencies
            // need to be injected, and user can use provided container to get instances he needs
            params.push(this);
            if (type.prototype.OnBefore) type.prototype.OnBefore.bind(type)();
            value = new (type.bind.apply(type, params))();
            $c8A38.constructorWatcherService.createConstructor(type['name'], {
                type: type,
                value: value
            });
            // if (value.render) {
            //     debugger
            // //    const test = new value['__proto__'].constructor()
            // Extend React class Correctly
            //    Object.assign(value['__proto__'].constructor.prototype, value);
            //    console.log(value['__proto__'].constructor.prototype);
            //     console.log(type['metadata']['moduleName'], value);
            //     console.log(value['__proto__'].constructor)
            // }
            if (value.OnInit) value.OnInit.bind(value)();
        }
        if (service && !service.transient && value) service.value = value;
        if (type) this.applyPropertyHandlers(type, value);
        return value;
    }
    /**
     * Initializes all parameter types for a given target service class.
     */ initializeParams(type, paramTypes) {
        return paramTypes.map((paramType, index)=>{
            const paramHandler = Array.from($4VpzQ.Container.handlers.values()).find((handler)=>handler.object === type && handler.index === index);
            if (paramHandler) return paramHandler.value(this);
            if (paramType && paramType.name && !this.isTypePrimitive(paramType.name)) return this.get(paramType);
            return undefined;
        });
    }
    /**
     * Checks if given type is primitive (e.g. string, boolean, number, object).
     */ isTypePrimitive(param) {
        return [
            'string',
            'boolean',
            'number',
            'object'
        ].indexOf(param.toLowerCase()) !== -1;
    }
    /**
     * Applies all registered handlers on a given target class.
     */ applyPropertyHandlers(target, instance) {
        $4VpzQ.Container.handlers.forEach((handler)=>{
            if (typeof handler.index === 'number') return;
            if (handler.object.constructor !== target && !(target.prototype instanceof handler.object.constructor)) return;
            instance[handler.propertyName] = handler.value(this);
        });
    }
}
module.exports.ContainerInstance = $992e70936e125585$var$ContainerInstance;

});
parcelRegister("dcXdC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingProvidedServiceTypeError = void 0;
/**
 * Thrown when service is registered without type.
 */ class $99da54ec29295fe8$var$MissingProvidedServiceTypeError extends Error {
    constructor(identifier){
        super(`Cannot determine a class of the requesting service '${JSON.stringify(identifier)}'`);
        this.name = 'ServiceNotFoundError';
        Object.setPrototypeOf(this, $99da54ec29295fe8$var$MissingProvidedServiceTypeError.prototype);
    }
}
module.exports.MissingProvidedServiceTypeError = $99da54ec29295fe8$var$MissingProvidedServiceTypeError;

});

parcelRegister("d339E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceNotFoundError = void 0;

var $h7YuD = parcelRequire("h7YuD");
/**
 * Thrown when requested service was not found.
 */ class $97fe009a4101635d$var$ServiceNotFoundError extends Error {
    constructor(identifier){
        super();
        this.name = 'ServiceNotFoundError';
        if (typeof identifier === 'string') this.message = `Service '${identifier}' was not found, looks like it was not registered in the container. ` + `Register it by calling Container.set('${JSON.stringify(identifier)}', ...) before using service.`;
        else if (identifier instanceof $h7YuD.Token && identifier.name) this.message = `Service '${identifier.name}' was not found, looks like it was not registered in the container. ` + `Register it by calling Container.set before using service.`;
        else if (identifier instanceof $h7YuD.Token) this.message = `Service with a given token was not found, looks like it was not registered in the container. ` + `Register it by calling Container.set before using service.`;
        Object.setPrototypeOf(this, $97fe009a4101635d$var$ServiceNotFoundError.prototype);
    }
}
module.exports.ServiceNotFoundError = $97fe009a4101635d$var$ServiceNotFoundError;

});
parcelRegister("h7YuD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectionToken = module.exports.Token = void 0;
/**
 * Used to create unique typed service identifier.
 * Useful when service has only interface, but don't have a class.
 */ class $c78203c7697948d4$var$Token {
    /**
     * @param name Token name, optional and only used for debugging purposes.
     */ constructor(name){
        this.name = name;
    }
}
module.exports.Token = $c78203c7697948d4$var$Token;
class $c78203c7697948d4$var$InjectionToken extends $c78203c7697948d4$var$Token {
}
module.exports.InjectionToken = $c78203c7697948d4$var$InjectionToken;

});


parcelRegister("c8A38", function(module, exports) {
"use strict";
var $8d623216e56cba03$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8d623216e56cba03$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8d623216e56cba03$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8d623216e56cba03$var$__exportStar((parcelRequire("lpxD0")), module.exports);

});
parcelRegister("lpxD0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.constructorWatcherService = module.exports.ConstructorWatcherService = void 0;
class $f966049b45e9784c$var$ConstructorWatcherService {
    constructor(){
        this._constructors = new Map();
    }
    getConstructor(name) {
        return this._constructors.get(name);
    }
    getByClass(currentClass) {
        return this._constructors.get(currentClass.name)['value'];
    }
    createConstructor(name, value) {
        if (this._constructors.has(name)) return this.getConstructor(name);
        this._constructors.set(name, value);
        return this.getConstructor(name);
    }
    triggerOnInit(currentClass) {
        const currentConstructor = this._constructors.get(currentClass.name);
        if (currentConstructor['value'] && currentConstructor['value'].OnInit) currentConstructor['value'].OnInit.bind(currentConstructor['value'])();
    }
}
module.exports.ConstructorWatcherService = $f966049b45e9784c$var$ConstructorWatcherService;
module.exports.constructorWatcherService = new $f966049b45e9784c$var$ConstructorWatcherService();

});






parcelRegister("beEls", function(module, exports) {
"use strict";
var $82e04c367e4a7fb8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $82e04c367e4a7fb8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $82e04c367e4a7fb8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$82e04c367e4a7fb8$var$__exportStar((parcelRequire("5PvON")), module.exports);

$82e04c367e4a7fb8$var$__exportStar((parcelRequire("8GIkM")), module.exports);

});
parcelRegister("5PvON", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8GIkM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("cWWbB", function(module, exports) {
"use strict";
var $96d809597389ae50$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $96d809597389ae50$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $96d809597389ae50$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Injectable = void 0;

$96d809597389ae50$var$__exportStar((parcelRequire("kSNma")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("akPSC")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("fK7Dt")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("dlGJ8")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("37VnB")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("kiP3r")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("gr7OL")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("9dO3J")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("hpmre")), module.exports);

$96d809597389ae50$var$__exportStar((parcelRequire("ggNw3")), module.exports);

Object.defineProperty(module.exports, "Injectable", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9dO3J")).Service;
    }
});

});
parcelRegister("kSNma", function(module, exports) {
"use strict";
var $f33f22fc68cce612$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f33f22fc68cce612$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f33f22fc68cce612$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f33f22fc68cce612$var$__exportStar((parcelRequire("dfqwu")), module.exports);

$f33f22fc68cce612$var$__exportStar((parcelRequire("eXK4b")), module.exports);

});
parcelRegister("dfqwu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NgModule = void 0;
module.exports.Module = $9a51400401c9f205$var$Module;

var $lbXPS = parcelRequire("lbXPS");

var $99xbn = parcelRequire("99xbn");

var $eNXZh = parcelRequire("eNXZh");

var $4wEKm = parcelRequire("4wEKm");

var $2bpRu = parcelRequire("2bpRu");

var $6rwNH = parcelRequire("6rwNH");

var $7xDCd = parcelRequire("7xDCd");
const $9a51400401c9f205$var$bootstrapLogger = $lbXPS.Container.get($4wEKm.BootstrapLogger);
const $9a51400401c9f205$var$resolverService = $lbXPS.Container.get($2bpRu.ResolverService);
const $9a51400401c9f205$var$cacheService = $lbXPS.Container.get($99xbn.CacheService);
const $9a51400401c9f205$var$metadataService = $lbXPS.Container.get($6rwNH.MetadataService);
const $9a51400401c9f205$var$moduleService = $lbXPS.Container.get($7xDCd.ModuleService);
function $9a51400401c9f205$var$Module(module) {
    return (target)=>{
        module = module || {};
        const original = Object.assign(target);
        const moduleName = target.name || target.constructor.name;
        const generatedHashData = $9a51400401c9f205$var$metadataService.generateHashData(module, original);
        const uniqueModuleTemplate = $9a51400401c9f205$var$metadataService.parseModuleTemplate(moduleName, generatedHashData, `${target}`);
        const uniqueHashForClass = $9a51400401c9f205$var$metadataService.createUniqueHash(uniqueModuleTemplate);
        // console.log(`--------- ${moduleName} --------- Hash: ${uniqueHashForClass}---------`);
        // console.log(uniqueModuleTemplate);
        Object.defineProperty(original, 'originalName', {
            value: original.name || original.constructor.name,
            writable: false
        });
        Object.defineProperty(original, 'name', {
            value: uniqueHashForClass,
            writable: true
        });
        const currentModuleLayer = $9a51400401c9f205$var$cacheService.createLayer({
            name: uniqueHashForClass
        });
        original.metadata = {
            moduleName: original.originalName,
            moduleHash: uniqueHashForClass,
            options: null,
            type: 'module',
            raw: uniqueModuleTemplate
        };
        const constructorFunction = function(...args) {
            $9a51400401c9f205$var$bootstrapLogger.log(`Bootstrap -> @Module('${original.originalName}')${$9a51400401c9f205$var$bootstrapLogger.logHashes(`(${original.name})`)}: loading...`);
            return (0, $eNXZh.GenericConstruct)(module, original, currentModuleLayer)(original, args);
        };
        Object.assign(constructorFunction, original);
        $9a51400401c9f205$var$resolverService.resolveDependencies(uniqueHashForClass, original, moduleName).subscribe(()=>$9a51400401c9f205$var$bootstrapLogger.log(`Start -> @Module('${original.originalName}')${$9a51400401c9f205$var$bootstrapLogger.logHashes(`(${original.name})`)}: loaded!`));
        Object.getOwnPropertyNames(original).filter((prop)=>typeof original[prop] === 'function').map((descriptor)=>Object.defineProperty(constructorFunction, descriptor, {
                configurable: true,
                writable: true,
                value: original[descriptor]
            }));
        if (original.forRoot) {
            const originalForRoot = constructorFunction.forRoot;
            constructorFunction.forRoot = function(...args) {
                const result = originalForRoot(...args);
                if (!result) throw new Error(`forRoot configuration inside ${constructorFunction.name} is returning undefined or null`);
                if (result.frameworkImports) $9a51400401c9f205$var$moduleService.setImports(result.frameworkImports, original);
                if (result.services) $9a51400401c9f205$var$moduleService.setServices(result.services, original, currentModuleLayer);
                if (result.providers) $9a51400401c9f205$var$moduleService.setServices(result.providers, original, currentModuleLayer);
                if (result.components) $9a51400401c9f205$var$moduleService.setComponents(result.components, original, currentModuleLayer);
                if (result.effects) $9a51400401c9f205$var$moduleService.setEffects(result.effects, original, currentModuleLayer);
                if (result.controllers) $9a51400401c9f205$var$moduleService.setControllers(result.controllers, original, currentModuleLayer);
                if (result.beforePlugins) $9a51400401c9f205$var$moduleService.setBeforePlugins(result.beforePlugins, original, currentModuleLayer);
                if (result.plugins) $9a51400401c9f205$var$moduleService.setPlugins(result.plugins, original, currentModuleLayer);
                if (result.afterPlugins) $9a51400401c9f205$var$moduleService.setAfterPlugins(result.afterPlugins, original, currentModuleLayer);
                /** @angular compatability */ if (result.ngModule) return result.ngModule;
                return result.module ? result.module : result;
            };
        }
        const service = {
            type: constructorFunction
        };
        $lbXPS.Container.set(service);
        return constructorFunction;
    };
}
/** @angular module compatability */ module.exports.NgModule = $9a51400401c9f205$var$Module;

});
parcelRegister("99xbn", function(module, exports) {
"use strict";
var $6a9eb1a90afa7c9e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a9eb1a90afa7c9e$var$CacheService_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CacheService = void 0;

var $bq6Hs = parcelRequire("bq6Hs");
var $8id0M = parcelRequire("8id0M");
var $g5fNy = parcelRequire("g5fNy");

var $gawXH = parcelRequire("gawXH");
var $5jZdk = parcelRequire("5jZdk");
var $d5Aat = parcelRequire("d5Aat");
var $29iGz = parcelRequire("29iGz");

var $93Tib = parcelRequire("93Tib");

var $6u0mD = parcelRequire("6u0mD");

var $9dO3J = parcelRequire("9dO3J");
let $6a9eb1a90afa7c9e$var$CacheService = $6a9eb1a90afa7c9e$var$CacheService_1 = class CacheService {
    constructor(){
        this._cachedLayers = new $bq6Hs.BehaviorSubject([]);
        this.map = new Map();
        this.config = {};
    }
    static createCacheInstance(cacheLayer) {
        return new $93Tib.CacheLayer(cacheLayer);
    }
    getLayer(name) {
        const exists = this.map.has(name);
        if (!exists) return this.createLayer({
            name: name
        });
        return this.map.get(name);
    }
    getLayersByName(name) {
        return Array.from(this.map.keys()).map((item)=>{
            if (item !== $6u0mD.InternalLayers.modules && item !== $6u0mD.InternalLayers.globalConfig) {
                const config = this.getLayer(item).getItem($6u0mD.InternalEvents.config);
                if (config && config.data && name === config.data.moduleName) return this.getLayer(config.data.moduleHash);
            }
        }).filter((i)=>!!i);
    }
    searchForDuplicateDependenciesInsideApp() {
        const uniq = [].concat.apply([], Array.from(this.map.keys()).map((key)=>Array.from(this.getLayer(key).map.keys()).map((key)=>!this.isExcludedEvent(key) ? key : null).filter((i)=>!!i))).map((name)=>Object.create({
                count: 1,
                name: name
            })).reduce((a, b)=>{
            a[b.name] = (a[b.name] || 0) + b.count;
            return a;
        }, {});
        const duplicates = Object.keys(uniq).filter((a)=>uniq[a] > 1);
        if (duplicates.length) {
            const dups = this.searchForDuplicatesByHash(duplicates[0]);
            const moduleType = dups[0].class['metadata']['type'].charAt(0).toUpperCase() + dups[0].class['metadata']['type'].slice(1);
            throw new Error(`
                ${dups[0].class['metadata'].raw}
                ${moduleType}: '${dups[0].originalName}' found multiple times!
                ${moduleType} hash: ${dups[0].moduleHash}
                Modules: [${dups[0].moduleName}, ${dups[1].moduleName}]

                Hint: '${dups[0].originalName}' class identity hash is identical in both
                imported files inside ${dups[0].moduleName} and ${dups[1].moduleName}
                consider removing one of the '${dups[0].originalName}'
            `);
        }
        return duplicates;
    }
    isExcludedEvent(i) {
        return i === $6u0mD.InternalEvents.config || i === $6u0mD.InternalEvents.load;
    }
    searchForItem(classItem) {
        return Array.from(this.map.keys()).map((module)=>{
            const currentModule = this.getLayer(module);
            const currentModuleDependencies = Array.from(currentModule.map.keys());
            const found = currentModuleDependencies.filter((i)=>{
                if (this.isExcludedEvent(i)) return;
                else return i === classItem.name;
            });
            if (found.length) return currentModule.getItem(found[0]).data;
        }).filter((i)=>!!i)[0];
    }
    searchForDuplicatesByHash(key) {
        return Array.from(this.map.keys()).map((module)=>{
            const currentModule = this.getLayer(module);
            const found = Array.from(currentModule.map.keys()).filter((i)=>{
                if (this.isExcludedEvent(i)) return;
                return i === key;
            });
            if (found.length) {
                const currentFoundItem = currentModule.getItem(found[0]);
                const currentModuleName = this.getLayer(module).getItem($6u0mD.InternalEvents.config);
                return {
                    moduleName: currentModuleName.data.moduleName,
                    moduleHash: currentModuleName.data.moduleHash,
                    originalName: currentFoundItem.data.originalName,
                    dupeName: currentFoundItem.key,
                    raw: currentModuleName.data.raw,
                    class: currentFoundItem.data
                };
            }
        }).filter((i)=>!!i);
    }
    createLayer(layer) {
        const exists = this.map.has(layer.name);
        if (exists) return this.map.get(layer.name);
        layer.items = layer.items || [];
        layer.config = layer.config || this.config;
        const cacheLayer = $6a9eb1a90afa7c9e$var$CacheService_1.createCacheInstance(layer);
        this.map.set(cacheLayer.name, cacheLayer);
        this._cachedLayers.next([
            ...this._cachedLayers.getValue(),
            cacheLayer
        ]);
        this.LayerHook(cacheLayer);
        return cacheLayer;
    }
    LayerHook(layerInstance) {
        this.protectLayerFromInvaders(layerInstance);
        if (layerInstance.config.cacheFlushInterval || this.config.cacheFlushInterval) this.OnExpire(layerInstance);
    }
    protectLayerFromInvaders(cacheLayer) {
        cacheLayer.items.constructor.prototype.unsubsribeFromLayer = cacheLayer.items.constructor.prototype.unsubscribe;
        cacheLayer.items.constructor.prototype.unsubscribe = ()=>{};
    }
    OnExpire(layerInstance) {
        return new $8id0M.Observable((observer)=>observer.next(true)).pipe((0, $29iGz.timeoutWith)(layerInstance.config.cacheFlushInterval || this.config.cacheFlushInterval, (0, $g5fNy.of)(1)), (0, $5jZdk.skip)(1), (0, $d5Aat.take)(1)).subscribe(()=>this.removeLayer(layerInstance));
    }
    removeLayer(layerInstance) {
        this.map.delete(layerInstance.name);
        this._cachedLayers.next([
            ...this._cachedLayers.getValue().filter((layer)=>layer.name !== layerInstance.name)
        ]);
    }
    transferItems(name, newCacheLayers) {
        const oldLayer = this.getLayer(name);
        const newLayers = [];
        newCacheLayers.forEach((layerName)=>{
            const newLayer = this.createLayer(layerName);
            oldLayer.items.getValue().forEach((item)=>newLayer.putItem(item));
            newLayers.push(newLayer);
        });
        return newLayers;
    }
    flushCache() {
        let oldLayersNames;
        return this._cachedLayers.pipe((0, $d5Aat.take)(1), (0, $gawXH.map)((layers)=>{
            oldLayersNames = layers.map((l)=>l.name);
            layers.forEach((layer)=>this.removeLayer(layer));
            oldLayersNames.forEach((l)=>this.createLayer({
                    name: l
                }));
            return true;
        }));
    }
};
module.exports.CacheService = $6a9eb1a90afa7c9e$var$CacheService;
module.exports.CacheService = $6a9eb1a90afa7c9e$var$CacheService = $6a9eb1a90afa7c9e$var$CacheService_1 = $6a9eb1a90afa7c9e$var$__decorate([
    (0, $9dO3J.Service)()
], $6a9eb1a90afa7c9e$var$CacheService);

});
parcelRegister("bq6Hs", function(module, exports) {

$parcel$export(module.exports, "BehaviorSubject", () => $850751dfef53b1f5$export$cc3d42e6b2b9cf8b);

var $deWeK = parcelRequire("deWeK");

var $f16OP = parcelRequire("f16OP");
var $850751dfef53b1f5$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $deWeK.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $f16OP.Subject));

});

parcelRegister("g5fNy", function(module, exports) {

$parcel$export(module.exports, "of", () => $bb595e2b9cc52a90$export$ba255e9e49e00608);

var $9Rm6G = parcelRequire("9Rm6G");

var $5JMLH = parcelRequire("5JMLH");
function $bb595e2b9cc52a90$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $9Rm6G.popScheduler)(args);
    return (0, $5JMLH.from)(args, scheduler);
}

});

parcelRegister("5jZdk", function(module, exports) {

$parcel$export(module.exports, "skip", () => $3dfe35ef70a6330a$export$955fc4a6c4be454d);

var $6Rz6W = parcelRequire("6Rz6W");
function $3dfe35ef70a6330a$export$955fc4a6c4be454d(count) {
    return (0, $6Rz6W.filter)(function(_, index) {
        return count <= index;
    });
}

});
parcelRegister("6Rz6W", function(module, exports) {

$parcel$export(module.exports, "filter", () => $4ff2eda0096dac58$export$3dea766d36a8935f);

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $4ff2eda0096dac58$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});


parcelRegister("29iGz", function(module, exports) {

$parcel$export(module.exports, "timeoutWith", () => $190aea99cbad72b5$export$86fe999fba7953f2);

var $8fD1K = parcelRequire("8fD1K");

var $8s4v1 = parcelRequire("8s4v1");

var $iDDcG = parcelRequire("iDDcG");
function $190aea99cbad72b5$export$86fe999fba7953f2(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : (0, $8fD1K.async);
    if ((0, $8s4v1.isValidDate)(due)) first = due;
    else if (typeof due === 'number') each = due;
    if (withObservable) _with = function() {
        return withObservable;
    };
    else throw new TypeError('No observable provided to switch to');
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, $iDDcG.timeout)({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with
    });
}

});
parcelRegister("iDDcG", function(module, exports) {

$parcel$export(module.exports, "timeout", () => $d91a478986e043c2$export$83e74882c5df8fe1);

var $8fD1K = parcelRequire("8fD1K");

var $8s4v1 = parcelRequire("8s4v1");

var $5CoSH = parcelRequire("5CoSH");

var $1wVYm = parcelRequire("1wVYm");

var $iNflj = parcelRequire("iNflj");

var $iIZUt = parcelRequire("iIZUt");

var $hrgoa = parcelRequire("hrgoa");
var $d91a478986e043c2$export$66d311bf29d5c89c = (0, $iNflj.createErrorClass)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function $d91a478986e043c2$export$83e74882c5df8fe1(config, schedulerArg) {
    var _a = (0, $8s4v1.isValidDate)(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? $d91a478986e043c2$var$timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, $8fD1K.asyncScheduler) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = (0, $hrgoa.executeSchedule)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, $1wVYm.innerFrom)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function $d91a478986e043c2$var$timeoutErrorFactory(info) {
    throw new $d91a478986e043c2$export$66d311bf29d5c89c(info);
}

});


parcelRegister("93Tib", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CacheLayer = void 0;

var $bq6Hs = parcelRequire("bq6Hs");
var $8id0M = parcelRequire("8id0M");
var $g5fNy = parcelRequire("g5fNy");

var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $5jZdk = parcelRequire("5jZdk");
var $d5Aat = parcelRequire("d5Aat");
var $29iGz = parcelRequire("29iGz");
class $698f48bfa6e9ba52$var$CacheLayer {
    get(name) {
        return this.map.get(name);
    }
    constructor(layer){
        this.items = new $bq6Hs.BehaviorSubject([]);
        this.map = new Map();
        this.name = layer.name;
        this.config = layer.config;
        this.initHook(layer);
    }
    initHook(layer) {
        if (this.config.maxAge) this.onExpireAll(layer);
    }
    onExpireAll(layer) {
        layer.items.forEach((item)=>this.onExpire(item['key']));
    }
    putItemHook(layerItem) {
        if (this.config.maxAge) this.onExpire(layerItem['key']);
    }
    getItem(key) {
        if (this.map.has(key)) return this.get(key);
        else return null;
    }
    putItem(layerItem) {
        this.map.set(layerItem['key'], layerItem);
        const item = this.get(layerItem['key']);
        const filteredItems = this.items.getValue().filter((item)=>item['key'] !== layerItem['key']);
        this.items.next([
            ...filteredItems,
            item
        ]);
        this.putItemHook(layerItem);
        return layerItem;
    }
    onExpire(key) {
        return new $8id0M.Observable((observer)=>observer.next(true)).pipe((0, $29iGz.timeoutWith)(this.config.maxAge, (0, $g5fNy.of)(1)), (0, $5jZdk.skip)(1), (0, $d5Aat.take)(1)).subscribe(()=>this.removeItem(key));
    }
    removeItem(key) {
        const newLayerItems = this.items.getValue().filter((item)=>item['key'] !== key);
        this.map.delete(key);
        this.items.next(newLayerItems);
    }
    getItemObservable(key) {
        return this.items.asObservable().pipe((0, $6Rz6W.filter)(()=>!!this.map.has(key)), (0, $gawXH.map)(()=>this.map.get(key)));
    }
    flushCache() {
        return this.items.asObservable().pipe((0, $gawXH.map)((items)=>{
            items.forEach((i)=>this.removeItem(i['key']));
            return true;
        }));
    }
}
module.exports.CacheLayer = $698f48bfa6e9ba52$var$CacheLayer;

});

parcelRegister("6u0mD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternalLayers = module.exports.InternalEvents = void 0;
function $4b85d3b1f7a31edf$var$strEnum(o) {
    return o.reduce((res, key)=>{
        res[key] = key;
        return res;
    }, Object.create(null));
}
module.exports.InternalEvents = $4b85d3b1f7a31edf$var$strEnum([
    'load',
    'config'
]);
module.exports.InternalLayers = $4b85d3b1f7a31edf$var$strEnum([
    'globalConfig',
    'modules'
]);

});


parcelRegister("eNXZh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GenericConstruct = $ac742c8fca273f69$var$GenericConstruct;

var $lbXPS = parcelRequire("lbXPS");

var $CEp6l = parcelRequire("CEp6l");
const $ac742c8fca273f69$var$moduleService = $lbXPS.Container.get($CEp6l.ModuleService);
const $ac742c8fca273f69$var$bootstrapLogger = $lbXPS.Container.get($CEp6l.BootstrapLogger);
function $ac742c8fca273f69$var$GenericConstruct(module, original, currentModule) {
    return function construct(constructor, args) {
        if (!module) return new constructor();
        if (module.imports) $ac742c8fca273f69$var$moduleService.setImports(module.imports, original);
        if (module.services) $ac742c8fca273f69$var$moduleService.setServices(module.services, original, currentModule);
        if (module.providers) $ac742c8fca273f69$var$moduleService.setServices(module.providers, original, currentModule);
        if (module.controllers) $ac742c8fca273f69$var$moduleService.setControllers(module.controllers, original, currentModule);
        if (module.effects) $ac742c8fca273f69$var$moduleService.setEffects(module.effects, original, currentModule);
        if (module.components) $ac742c8fca273f69$var$moduleService.setComponents(module.components, original, currentModule);
        if (module.beforePlugins) $ac742c8fca273f69$var$moduleService.setBeforePlugins(module.beforePlugins, original, currentModule);
        if (module.plugins) $ac742c8fca273f69$var$moduleService.setPlugins(module.plugins, original, currentModule);
        if (module.afterPlugins) $ac742c8fca273f69$var$moduleService.setAfterPlugins(module.afterPlugins, original, currentModule);
        if (module.bootstrap) $ac742c8fca273f69$var$moduleService.setBootstraps(module.bootstrap, original, currentModule);
        $ac742c8fca273f69$var$bootstrapLogger.log(`Bootstrap -> @Module('${constructor.originalName}')${$ac742c8fca273f69$var$bootstrapLogger.logHashes(`(${constructor.name})`)}: finished!`);
        return $lbXPS.Container.get(constructor);
    };
}

});
parcelRegister("CEp6l", function(module, exports) {
"use strict";
var $0742e416e85b85a3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0742e416e85b85a3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0742e416e85b85a3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0742e416e85b85a3$var$__exportStar((parcelRequire("1w8ds")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("9Ijpe")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("ku4It")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("38hsg")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("e8cPX")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("88uGA")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("818uG")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("8c7sa")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("iWKlu")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("c8A38")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("3Ouei")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("1clpo")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("Oj27e")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("iurA8")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("hjbHI")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("a8RBP")), module.exports);

$0742e416e85b85a3$var$__exportStar((parcelRequire("jubrU")), module.exports);

});
parcelRegister("1w8ds", function(module, exports) {
"use strict";
var $11af2721a74da375$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $11af2721a74da375$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $11af2721a74da375$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$11af2721a74da375$var$__exportStar((parcelRequire("99xbn")), module.exports);

$11af2721a74da375$var$__exportStar((parcelRequire("93Tib")), module.exports);

$11af2721a74da375$var$__exportStar((parcelRequire("gZmEB")), module.exports);

});
parcelRegister("gZmEB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CacheServiceConfigInterface = void 0;
class $c5e3ea73e1d5b99c$var$CacheServiceConfigInterface {
    constructor(){
        this.deleteOnExpire = 'aggressive';
        this.cacheFlushInterval = 3600000;
        this.maxAge = 900000;
        this.localStorage = false;
    }
}
module.exports.CacheServiceConfigInterface = $c5e3ea73e1d5b99c$var$CacheServiceConfigInterface;

});


parcelRegister("9Ijpe", function(module, exports) {
"use strict";
var $712746c1091eebef$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PluginService = void 0;

var $bq6Hs = parcelRequire("bq6Hs");

var $9dO3J = parcelRequire("9dO3J");
let $712746c1091eebef$var$PluginService = class PluginService {
    constructor(){
        this.plugins = new $bq6Hs.BehaviorSubject([]);
        this.beforePlugins = new $bq6Hs.BehaviorSubject([]);
        this.afterPlugins = new $bq6Hs.BehaviorSubject([]);
    }
    register(plugin) {
        this.plugins.next([
            ...this.plugins.getValue(),
            plugin
        ]);
    }
    registerBefore(plugin) {
        this.beforePlugins.next([
            ...this.plugins.getValue(),
            plugin
        ]);
    }
    registerAfter(plugin) {
        this.afterPlugins.next([
            ...this.plugins.getValue(),
            plugin
        ]);
    }
    getPlugins() {
        return this.plugins.getValue();
    }
    getAfterPlugins() {
        return this.afterPlugins.getValue();
    }
    getBeforePlugins() {
        return this.beforePlugins.getValue();
    }
};
module.exports.PluginService = $712746c1091eebef$var$PluginService;
module.exports.PluginService = $712746c1091eebef$var$PluginService = $712746c1091eebef$var$__decorate([
    (0, $9dO3J.Service)()
], $712746c1091eebef$var$PluginService);

});

parcelRegister("ku4It", function(module, exports) {
"use strict";
var $ee9a448e4bbae52c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee9a448e4bbae52c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee9a448e4bbae52c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ee9a448e4bbae52c$var$__exportStar((parcelRequire("4wEKm")), module.exports);

});
parcelRegister("4wEKm", function(module, exports) {
"use strict";
var $34b9c2048fea35e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $34b9c2048fea35e7$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BootstrapLogger = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $818uG = parcelRequire("818uG");

var $8YGle = parcelRequire("8YGle");
let $34b9c2048fea35e7$var$BootstrapLogger = class BootstrapLogger {
    log(message) {
        if (this.configService.config.logger.logging) {
            const m = [
                this.logDate(),
                message
            ];
            console.log(...m);
            return m;
        }
    }
    error(message) {
        console.error(message);
    }
    logImporter(message) {
        if (this.configService.config.logger.logging) return this.log(message);
    }
    logDate() {
        if (this.configService.config.logger.date) return `${Date.now().toPrecision()}`;
        else return '';
    }
    logHashes(message) {
        if (this.configService.config.logger.hashes) return message;
        else return '';
    }
    logExitHandler(message) {
        if (this.configService.config.logger.exitHandler) this.log(message);
        else return '';
    }
};
module.exports.BootstrapLogger = $34b9c2048fea35e7$var$BootstrapLogger;
$34b9c2048fea35e7$var$__decorate([
    (0, $8YGle.Injector)($818uG.ConfigService),
    $34b9c2048fea35e7$var$__metadata("design:type", $818uG.ConfigService)
], $34b9c2048fea35e7$var$BootstrapLogger.prototype, "configService", void 0);
module.exports.BootstrapLogger = $34b9c2048fea35e7$var$BootstrapLogger = $34b9c2048fea35e7$var$__decorate([
    (0, $9dO3J.Service)()
], $34b9c2048fea35e7$var$BootstrapLogger);

});
parcelRegister("818uG", function(module, exports) {
"use strict";
var $5d65017523626ad1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5d65017523626ad1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5d65017523626ad1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5d65017523626ad1$var$__exportStar((parcelRequire("hFOW0")), module.exports);

$5d65017523626ad1$var$__exportStar((parcelRequire("fdMQP")), module.exports);

});
parcelRegister("hFOW0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigModel = module.exports.InitOptionsConfig = module.exports.ExperimentalFeatures = module.exports.PrivateCryptoModel = module.exports.LoggerConfig = void 0;
class $cdddc692299fbd2c$var$LoggerConfig {
    constructor(){
        this.logging = false;
        this.hashes = true;
        this.date = true;
        this.exitHandler = true;
    }
}
module.exports.LoggerConfig = $cdddc692299fbd2c$var$LoggerConfig;
class $cdddc692299fbd2c$var$PrivateCryptoModel {
}
module.exports.PrivateCryptoModel = $cdddc692299fbd2c$var$PrivateCryptoModel;
class $cdddc692299fbd2c$var$ExperimentalFeatures {
}
module.exports.ExperimentalFeatures = $cdddc692299fbd2c$var$ExperimentalFeatures;
class $cdddc692299fbd2c$var$InitOptionsConfig {
}
module.exports.InitOptionsConfig = $cdddc692299fbd2c$var$InitOptionsConfig;
class $cdddc692299fbd2c$var$ConfigModel {
    constructor(){
        this.init = true;
        this.initOptions = new $cdddc692299fbd2c$var$InitOptionsConfig();
        this.experimental = new $cdddc692299fbd2c$var$ExperimentalFeatures();
        this.logger = new $cdddc692299fbd2c$var$LoggerConfig();
    }
}
module.exports.ConfigModel = $cdddc692299fbd2c$var$ConfigModel;

});

parcelRegister("fdMQP", function(module, exports) {
"use strict";
var $b14df6b47588bc63$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $hFOW0 = parcelRequire("hFOW0");
let $b14df6b47588bc63$var$ConfigService = class ConfigService {
    constructor(){
        this.config = new $hFOW0.ConfigModel();
    }
    setConfig(config) {
        Object.assign(this.config, config);
    }
};
module.exports.ConfigService = $b14df6b47588bc63$var$ConfigService;
module.exports.ConfigService = $b14df6b47588bc63$var$ConfigService = $b14df6b47588bc63$var$__decorate([
    (0, $9dO3J.Service)()
], $b14df6b47588bc63$var$ConfigService);

});


parcelRegister("8YGle", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Injector = $6894c57045253f45$var$Injector;

var $lbXPS = parcelRequire("lbXPS");
function $6894c57045253f45$var$Injector(Service) {
    return function(target, propertyName) {
        Object.defineProperty(target, propertyName, {
            get: ()=>$lbXPS.Container.get(Service)
        });
    };
}

});



parcelRegister("38hsg", function(module, exports) {
"use strict";
var $247fa89e226b0a83$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $247fa89e226b0a83$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $247fa89e226b0a83$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$247fa89e226b0a83$var$__exportStar((parcelRequire("k44E3")), module.exports);

});
parcelRegister("k44E3", function(module, exports) {

var $3rPrU = parcelRequire("3rPrU");
"use strict";
var $03c5075e0d046364$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $03c5075e0d046364$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExitHandlerService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $ku4It = parcelRequire("ku4It");

var $8YGle = parcelRequire("8YGle");

var $8id0M = parcelRequire("8id0M");
var $f16OP = parcelRequire("f16OP");
let $03c5075e0d046364$var$ExitHandlerService = class ExitHandlerService {
    constructor(){
        this.errorHandler = new $f16OP.Subject();
    }
    init() {}
    exitHandler(options, err) {
        this.errorHandler.next(err);
        if (options.cleanup) this.logger.logExitHandler('AppStopped');
        if (options.exit) this.logger.logExitHandler('Unhandled error rejection');
        if (err) {
            console.log(err);
            return $3rPrU.exit(1);
        }
        return $3rPrU.exit(0);
    }
    onExitApp(events) {
        return new $8id0M.Observable((o)=>events && events.length && events.forEach((event)=>$3rPrU.on(event, (e)=>o.next(e))));
    }
};
module.exports.ExitHandlerService = $03c5075e0d046364$var$ExitHandlerService;
$03c5075e0d046364$var$__decorate([
    (0, $8YGle.Injector)($ku4It.BootstrapLogger),
    $03c5075e0d046364$var$__metadata("design:type", $ku4It.BootstrapLogger)
], $03c5075e0d046364$var$ExitHandlerService.prototype, "logger", void 0);
module.exports.ExitHandlerService = $03c5075e0d046364$var$ExitHandlerService = $03c5075e0d046364$var$__decorate([
    (0, $9dO3J.Service)()
], $03c5075e0d046364$var$ExitHandlerService);

});
parcelRegister("3rPrU", function(module, exports) {
// shim for using process in browser
var $282bcd6c7ca8865b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $282bcd6c7ca8865b$var$cachedSetTimeout;
var $282bcd6c7ca8865b$var$cachedClearTimeout;
function $282bcd6c7ca8865b$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $282bcd6c7ca8865b$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $282bcd6c7ca8865b$var$cachedSetTimeout = setTimeout;
        else $282bcd6c7ca8865b$var$cachedSetTimeout = $282bcd6c7ca8865b$var$defaultSetTimout;
    } catch (e) {
        $282bcd6c7ca8865b$var$cachedSetTimeout = $282bcd6c7ca8865b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $282bcd6c7ca8865b$var$cachedClearTimeout = clearTimeout;
        else $282bcd6c7ca8865b$var$cachedClearTimeout = $282bcd6c7ca8865b$var$defaultClearTimeout;
    } catch (e) {
        $282bcd6c7ca8865b$var$cachedClearTimeout = $282bcd6c7ca8865b$var$defaultClearTimeout;
    }
})();
function $282bcd6c7ca8865b$var$runTimeout(fun) {
    if ($282bcd6c7ca8865b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($282bcd6c7ca8865b$var$cachedSetTimeout === $282bcd6c7ca8865b$var$defaultSetTimout || !$282bcd6c7ca8865b$var$cachedSetTimeout) && setTimeout) {
        $282bcd6c7ca8865b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $282bcd6c7ca8865b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $282bcd6c7ca8865b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $282bcd6c7ca8865b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $282bcd6c7ca8865b$var$runClearTimeout(marker) {
    if ($282bcd6c7ca8865b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($282bcd6c7ca8865b$var$cachedClearTimeout === $282bcd6c7ca8865b$var$defaultClearTimeout || !$282bcd6c7ca8865b$var$cachedClearTimeout) && clearTimeout) {
        $282bcd6c7ca8865b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $282bcd6c7ca8865b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $282bcd6c7ca8865b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $282bcd6c7ca8865b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $282bcd6c7ca8865b$var$queue = [];
var $282bcd6c7ca8865b$var$draining = false;
var $282bcd6c7ca8865b$var$currentQueue;
var $282bcd6c7ca8865b$var$queueIndex = -1;
function $282bcd6c7ca8865b$var$cleanUpNextTick() {
    if (!$282bcd6c7ca8865b$var$draining || !$282bcd6c7ca8865b$var$currentQueue) return;
    $282bcd6c7ca8865b$var$draining = false;
    if ($282bcd6c7ca8865b$var$currentQueue.length) $282bcd6c7ca8865b$var$queue = $282bcd6c7ca8865b$var$currentQueue.concat($282bcd6c7ca8865b$var$queue);
    else $282bcd6c7ca8865b$var$queueIndex = -1;
    if ($282bcd6c7ca8865b$var$queue.length) $282bcd6c7ca8865b$var$drainQueue();
}
function $282bcd6c7ca8865b$var$drainQueue() {
    if ($282bcd6c7ca8865b$var$draining) return;
    var timeout = $282bcd6c7ca8865b$var$runTimeout($282bcd6c7ca8865b$var$cleanUpNextTick);
    $282bcd6c7ca8865b$var$draining = true;
    var len = $282bcd6c7ca8865b$var$queue.length;
    while(len){
        $282bcd6c7ca8865b$var$currentQueue = $282bcd6c7ca8865b$var$queue;
        $282bcd6c7ca8865b$var$queue = [];
        while(++$282bcd6c7ca8865b$var$queueIndex < len)if ($282bcd6c7ca8865b$var$currentQueue) $282bcd6c7ca8865b$var$currentQueue[$282bcd6c7ca8865b$var$queueIndex].run();
        $282bcd6c7ca8865b$var$queueIndex = -1;
        len = $282bcd6c7ca8865b$var$queue.length;
    }
    $282bcd6c7ca8865b$var$currentQueue = null;
    $282bcd6c7ca8865b$var$draining = false;
    $282bcd6c7ca8865b$var$runClearTimeout(timeout);
}
$282bcd6c7ca8865b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $282bcd6c7ca8865b$var$queue.push(new $282bcd6c7ca8865b$var$Item(fun, args));
    if ($282bcd6c7ca8865b$var$queue.length === 1 && !$282bcd6c7ca8865b$var$draining) $282bcd6c7ca8865b$var$runTimeout($282bcd6c7ca8865b$var$drainQueue);
};
// v8 likes predictible objects
function $282bcd6c7ca8865b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$282bcd6c7ca8865b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$282bcd6c7ca8865b$var$process.title = 'browser';
$282bcd6c7ca8865b$var$process.browser = true;
$282bcd6c7ca8865b$var$process.env = {};
$282bcd6c7ca8865b$var$process.argv = [];
$282bcd6c7ca8865b$var$process.version = ''; // empty string to avoid regexp issues
$282bcd6c7ca8865b$var$process.versions = {};
function $282bcd6c7ca8865b$var$noop() {}
$282bcd6c7ca8865b$var$process.on = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.addListener = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.once = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.off = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.removeListener = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.removeAllListeners = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.emit = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.prependListener = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.prependOnceListener = $282bcd6c7ca8865b$var$noop;
$282bcd6c7ca8865b$var$process.listeners = function(name) {
    return [];
};
$282bcd6c7ca8865b$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$282bcd6c7ca8865b$var$process.cwd = function() {
    return '/';
};
$282bcd6c7ca8865b$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$282bcd6c7ca8865b$var$process.umask = function() {
    return 0;
};

});



parcelRegister("e8cPX", function(module, exports) {
"use strict";
var $a49bc538e3356628$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a49bc538e3356628$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a49bc538e3356628$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a49bc538e3356628$var$__exportStar((parcelRequire("7xDCd")), module.exports);

$a49bc538e3356628$var$__exportStar((parcelRequire("j0DzQ")), module.exports);

});
parcelRegister("7xDCd", function(module, exports) {
"use strict";
var $57da58435ba5bee6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $57da58435ba5bee6$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleService = void 0;

var $g5fNy = parcelRequire("g5fNy");

var $lbXPS = parcelRequire("lbXPS");

var $9dO3J = parcelRequire("9dO3J");

var $eLoXP = parcelRequire("eLoXP");

var $9Ijpe = parcelRequire("9Ijpe");

var $8YGle = parcelRequire("8YGle");

var $j0DzQ = parcelRequire("j0DzQ");

var $lpxD0 = parcelRequire("lpxD0");

var $cJVqd = parcelRequire("cJVqd");

var $5sFJS = parcelRequire("5sFJS");

var $3T1Zd = parcelRequire("3T1Zd");

var $5DN1P = parcelRequire("5DN1P");

var $gRuS1 = parcelRequire("gRuS1");

var $4kW5x = parcelRequire("4kW5x");
let $57da58435ba5bee6$var$ModuleService = class ModuleService {
    constructor(){
        this.watcherService = $lpxD0.constructorWatcherService;
    }
    setServices(services, original, currentModule) {
        services.forEach((service)=>{
            this.validators.validateServices(service, original);
            this.setInjectedDependencies(service);
            if (service.provide && service.provide.constructor === Function) service.provide = service.provide['name'];
            if (service.provide && service.useFactory) this.setUseFactory(service);
            else if (service.provide && service.useClass && service.useClass.constructor === Function) this.setUseClass(service);
            else if (service.provide && service.useValue) this.setUseValue(service);
            else {
                currentModule.putItem({
                    data: service,
                    key: service.name
                });
                this.servicesService.register(service);
            }
        });
    }
    setInjectedDependencies(service) {
        service.deps = service.deps || [];
        if (service.deps.length) service.deps = service.deps.map((dep)=>$lbXPS.Container.get(dep));
    }
    setUseValue(service) {
        $lbXPS.Container.set(service.provide, service.useValue);
        if (service.lazy) this.lazyFactoryService.setLazyFactory(service.provide, (0, $g5fNy.of)($lbXPS.Container.get(service.provide)));
    }
    setUseClass(service) {
        if (service.lazy) this.lazyFactoryService.setLazyFactory(service.provide, (0, $g5fNy.of)($lbXPS.Container.get(service.useClass)));
        else $lbXPS.Container.set(service.provide, $lbXPS.Container.get(service.useClass));
    }
    setUseFactory(service) {
        const factory = service.useFactory;
        service.useFactory = ()=>factory(...service.deps);
        if (service.lazy) this.lazyFactoryService.setLazyFactory(service.provide, service.useFactory());
        else $lbXPS.Container.set(service.provide, service.useFactory());
    }
    setControllers(controllers, original, currentModule) {
        controllers.forEach((controller)=>{
            this.validators.validateController(controller, original);
            currentModule.putItem({
                data: controller,
                key: controller.name
            });
            this.controllersService.register(controller);
        });
    }
    setEffects(effects, original, currentModule) {
        effects.forEach((effect)=>{
            this.validators.validateEffect(effect, original);
            currentModule.putItem({
                data: effect,
                key: effect.name
            });
            this.effectsService.register(effect);
        });
    }
    setComponents(components, original, currentModule) {
        components.forEach((component)=>{
            if (!component['metadata']) (0, $4kW5x.ReflectDecorator)({}, {
                type: 'component'
            })(component);
            this.validators.validateComponent(component, original);
            currentModule.putItem({
                data: component,
                key: component.name
            });
            this.componentsService.register(component);
        });
    }
    setPlugins(plugins, original, currentModule) {
        plugins.forEach((plugin)=>{
            this.validators.validatePlugin(plugin, original);
            currentModule.putItem({
                data: plugin,
                key: plugin.name
            });
            this.pluginService.register(plugin);
        });
    }
    setBootstraps(bootstraps, original, currentModule) {
        bootstraps.forEach((bootstrap)=>{
            if (!bootstrap['metadata']) (0, $4kW5x.ReflectDecorator)({}, {
                type: 'component'
            })(bootstrap);
            this.validators.validateEmpty(bootstrap, original, bootstrap['metadata']['type']);
            currentModule.putItem({
                data: bootstrap,
                key: bootstrap.name
            });
            this.bootstraps.register(bootstrap);
        });
    }
    setAfterPlugins(plugins, original, currentModule) {
        plugins.forEach((plugin)=>{
            this.validators.validatePlugin(plugin, original);
            currentModule.putItem({
                data: plugin,
                key: plugin.name
            });
            this.pluginService.registerAfter(plugin);
        });
    }
    setBeforePlugins(plugins, original, currentModule) {
        plugins.forEach((plugin)=>{
            this.validators.validatePlugin(plugin, original);
            currentModule.putItem({
                data: plugin,
                key: plugin.name
            });
            this.pluginService.registerBefore(plugin);
        });
    }
    setImports(imports, original) {
        imports.forEach((m)=>{
            this.validators.validateImports(m, original);
            if (!m) throw new Error('Missing import module');
            else $lbXPS.Container.get(m);
        });
    }
};
module.exports.ModuleService = $57da58435ba5bee6$var$ModuleService;
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($eLoXP.LazyFactory),
    $57da58435ba5bee6$var$__metadata("design:type", $eLoXP.LazyFactory)
], $57da58435ba5bee6$var$ModuleService.prototype, "lazyFactoryService", void 0);
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($9Ijpe.PluginService),
    $57da58435ba5bee6$var$__metadata("design:type", $9Ijpe.PluginService)
], $57da58435ba5bee6$var$ModuleService.prototype, "pluginService", void 0);
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($3T1Zd.ComponentsService),
    $57da58435ba5bee6$var$__metadata("design:type", $3T1Zd.ComponentsService)
], $57da58435ba5bee6$var$ModuleService.prototype, "componentsService", void 0);
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($cJVqd.ControllersService),
    $57da58435ba5bee6$var$__metadata("design:type", $cJVqd.ControllersService)
], $57da58435ba5bee6$var$ModuleService.prototype, "controllersService", void 0);
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($5sFJS.EffectsService),
    $57da58435ba5bee6$var$__metadata("design:type", $5sFJS.EffectsService)
], $57da58435ba5bee6$var$ModuleService.prototype, "effectsService", void 0);
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($5DN1P.BootstrapsServices),
    $57da58435ba5bee6$var$__metadata("design:type", $5DN1P.BootstrapsServices)
], $57da58435ba5bee6$var$ModuleService.prototype, "bootstraps", void 0);
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($j0DzQ.ModuleValidators),
    $57da58435ba5bee6$var$__metadata("design:type", $j0DzQ.ModuleValidators)
], $57da58435ba5bee6$var$ModuleService.prototype, "validators", void 0);
$57da58435ba5bee6$var$__decorate([
    (0, $8YGle.Injector)($gRuS1.ServicesService),
    $57da58435ba5bee6$var$__metadata("design:type", $gRuS1.ServicesService)
], $57da58435ba5bee6$var$ModuleService.prototype, "servicesService", void 0);
module.exports.ModuleService = $57da58435ba5bee6$var$ModuleService = $57da58435ba5bee6$var$__decorate([
    (0, $9dO3J.Service)()
], $57da58435ba5bee6$var$ModuleService);

});
parcelRegister("eLoXP", function(module, exports) {
"use strict";
var $abf8d1d0e085bb28$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LazyFactory = void 0;

var $9dO3J = parcelRequire("9dO3J");
let $abf8d1d0e085bb28$var$LazyFactory = class LazyFactory {
    constructor(){
        this.lazyFactories = new Map();
    }
    setLazyFactory(provide, factory) {
        this.lazyFactories.set(provide, factory);
        return this.getLazyFactory(provide);
    }
    getLazyFactory(provide) {
        return this.lazyFactories.get(provide);
    }
};
module.exports.LazyFactory = $abf8d1d0e085bb28$var$LazyFactory;
module.exports.LazyFactory = $abf8d1d0e085bb28$var$LazyFactory = $abf8d1d0e085bb28$var$__decorate([
    (0, $9dO3J.Service)()
], $abf8d1d0e085bb28$var$LazyFactory);

});

parcelRegister("j0DzQ", function(module, exports) {
"use strict";
var $dd6cb79731cc6145$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleValidators = void 0;

var $9dO3J = parcelRequire("9dO3J");
let $dd6cb79731cc6145$var$ModuleValidators = class ModuleValidators {
    validateEmpty(m, original, type) {
        if (!m) {
            const requiredType = type.charAt(0).toUpperCase() + type.slice(1);
            throw new Error(`
            ${original.metadata.raw}
            -> @Module: ${original.metadata.moduleName}
            -> @Module hash: ${original.metadata.moduleHash}
                --> Maybe you forgot to import some ${requiredType} inside ${original.metadata.moduleName} ?

                Hint: run ts-lint again, looks like imported ${requiredType} is undefined or null inside ${original.metadata.moduleName}
            `);
        }
    }
    genericWrongPluggableError(m, original, type) {
        if (m.metadata.type !== type) {
            const moduleType = m.metadata.type.charAt(0).toUpperCase() + m.metadata.type.slice(1);
            const requiredType = type.charAt(0).toUpperCase() + type.slice(1);
            throw new Error(`
            ${original.metadata.raw}
            -> @Module: '${original.metadata.moduleName}'
            -> @Module hash: '${original.metadata.moduleHash}'
                --> @${moduleType} '${m.metadata.moduleName}' provided, where expected class decorated with '@${requiredType}' instead,
            -> @Hint: please provide class with @Service decorator or remove ${m.metadata.moduleName} class
            `);
        }
    }
    validateImports(m, original) {
        if (m.metadata.type !== 'module') throw new Error(`
            ${original.metadata.raw}
            -> @Module: '${original.metadata.moduleName}'
            -> @Module hash: '${original.metadata.moduleHash}'
                --> @${m.metadata.type.charAt(0).toUpperCase() + m.metadata.type.slice(1)} '${m.originalName}' provided, where expected class decorated with '@Module' instead,
            -> @Hint: please provide class with @Module decorator or remove ${m.originalName} from imports
            `);
    }
    validateServices(m, original) {
        this.validateEmpty(m, original, 'service');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'service');
    }
    validatePlugin(m, original) {
        this.validateEmpty(m, original, 'plugin');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'plugin');
    }
    validateController(m, original) {
        this.validateEmpty(m, original, 'controller');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'controller');
    }
    validateEffect(m, original) {
        this.validateEmpty(m, original, 'effect');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'effect');
    }
    validateComponent(m, original) {
        this.validateEmpty(m, original, 'component');
        if (m.provide) return;
        this.genericWrongPluggableError(m, original, 'component');
    }
};
module.exports.ModuleValidators = $dd6cb79731cc6145$var$ModuleValidators;
module.exports.ModuleValidators = $dd6cb79731cc6145$var$ModuleValidators = $dd6cb79731cc6145$var$__decorate([
    (0, $9dO3J.Service)()
], $dd6cb79731cc6145$var$ModuleValidators);

});

parcelRegister("cJVqd", function(module, exports) {
"use strict";
var $94663aceb1ed888c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ControllersService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $bq6Hs = parcelRequire("bq6Hs");
let $94663aceb1ed888c$var$ControllersService = class ControllersService {
    constructor(){
        this.controllers = new $bq6Hs.BehaviorSubject([]);
    }
    register(plugin) {
        this.controllers.next([
            ...this.controllers.getValue(),
            plugin
        ]);
    }
    getControllers() {
        return this.controllers.getValue();
    }
};
module.exports.ControllersService = $94663aceb1ed888c$var$ControllersService;
module.exports.ControllersService = $94663aceb1ed888c$var$ControllersService = $94663aceb1ed888c$var$__decorate([
    (0, $9dO3J.Service)()
], $94663aceb1ed888c$var$ControllersService);

});

parcelRegister("5sFJS", function(module, exports) {
"use strict";
var $3f9ff1c3d1fe3f70$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EffectsService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $bq6Hs = parcelRequire("bq6Hs");
let $3f9ff1c3d1fe3f70$var$EffectsService = class EffectsService {
    constructor(){
        this.effects = new $bq6Hs.BehaviorSubject([]);
    }
    register(plugin) {
        this.effects.next([
            ...this.effects.getValue(),
            plugin
        ]);
    }
    getEffects() {
        return this.effects.getValue();
    }
};
module.exports.EffectsService = $3f9ff1c3d1fe3f70$var$EffectsService;
module.exports.EffectsService = $3f9ff1c3d1fe3f70$var$EffectsService = $3f9ff1c3d1fe3f70$var$__decorate([
    (0, $9dO3J.Service)()
], $3f9ff1c3d1fe3f70$var$EffectsService);

});

parcelRegister("3T1Zd", function(module, exports) {
"use strict";
var $2d480c9a5655b373$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComponentsService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $bq6Hs = parcelRequire("bq6Hs");
let $2d480c9a5655b373$var$ComponentsService = class ComponentsService {
    constructor(){
        this.components = new $bq6Hs.BehaviorSubject([]);
    }
    register(plugin) {
        this.components.next([
            ...this.components.getValue(),
            plugin
        ]);
    }
    getComponents() {
        return this.components.getValue();
    }
};
module.exports.ComponentsService = $2d480c9a5655b373$var$ComponentsService;
module.exports.ComponentsService = $2d480c9a5655b373$var$ComponentsService = $2d480c9a5655b373$var$__decorate([
    (0, $9dO3J.Service)()
], $2d480c9a5655b373$var$ComponentsService);

});

parcelRegister("5DN1P", function(module, exports) {
"use strict";
var $41b6a0541e33839a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BootstrapsServices = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $bq6Hs = parcelRequire("bq6Hs");
let $41b6a0541e33839a$var$BootstrapsServices = class BootstrapsServices {
    constructor(){
        this.bootstraps = new $bq6Hs.BehaviorSubject([]);
    }
    register(plugin) {
        this.bootstraps.next([
            ...this.bootstraps.getValue(),
            plugin
        ]);
    }
    getBootstraps() {
        return this.bootstraps.getValue();
    }
};
module.exports.BootstrapsServices = $41b6a0541e33839a$var$BootstrapsServices;
module.exports.BootstrapsServices = $41b6a0541e33839a$var$BootstrapsServices = $41b6a0541e33839a$var$__decorate([
    (0, $9dO3J.Service)()
], $41b6a0541e33839a$var$BootstrapsServices);

});

parcelRegister("gRuS1", function(module, exports) {
"use strict";
var $c4698ac1ae406e4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServicesService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $bq6Hs = parcelRequire("bq6Hs");
let $c4698ac1ae406e4f$var$ServicesService = class ServicesService {
    constructor(){
        this.services = new $bq6Hs.BehaviorSubject([]);
    }
    register(plugin) {
        this.services.next([
            ...this.services.getValue(),
            plugin
        ]);
    }
    getServices() {
        return this.services.getValue();
    }
};
module.exports.ServicesService = $c4698ac1ae406e4f$var$ServicesService;
module.exports.ServicesService = $c4698ac1ae406e4f$var$ServicesService = $c4698ac1ae406e4f$var$__decorate([
    (0, $9dO3J.Service)()
], $c4698ac1ae406e4f$var$ServicesService);

});



parcelRegister("88uGA", function(module, exports) {
"use strict";
var $5ec6dfa7b0692042$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5ec6dfa7b0692042$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5ec6dfa7b0692042$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5ec6dfa7b0692042$var$__exportStar((parcelRequire("2bpRu")), module.exports);

});
parcelRegister("2bpRu", function(module, exports) {
"use strict";
var $1970ab7acc2e0041$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1970ab7acc2e0041$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolverService = void 0;

var $lbXPS = parcelRequire("lbXPS");

var $99xbn = parcelRequire("99xbn");

var $6u0mD = parcelRequire("6u0mD");

var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");

var $g5fNy = parcelRequire("g5fNy");

var $4wEKm = parcelRequire("4wEKm");

var $8YGle = parcelRequire("8YGle");

var $9dO3J = parcelRequire("9dO3J");
let $1970ab7acc2e0041$var$ResolverService = class ResolverService {
    resolveDependencies(hash, target, moduleName) {
        this.cacheService.getLayer($6u0mD.InternalLayers.modules).putItem({
            key: hash,
            data: target
        });
        const currentModule = this.cacheService.getLayer(hash);
        currentModule.putItem({
            key: $6u0mD.InternalEvents.config,
            data: {
                moduleName: moduleName,
                moduleHash: hash
            }
        });
        return currentModule.getItemObservable($6u0mD.InternalEvents.load).pipe((0, $lNnaw.switchMap)((config)=>{
            if (!config.data) return (0, $g5fNy.of)(null);
            return currentModule.items.asObservable();
        }), (0, $6Rz6W.filter)((res)=>!!(res === null || res === void 0 ? void 0 : res.length)), (0, $gawXH.map)(this.resolveContainerDependencies(target, moduleName)));
    }
    resolveContainerDependencies(target, moduleName) {
        return (res)=>{
            res.forEach((i)=>{
                if (i.key === $6u0mD.InternalEvents.load || i.key === $6u0mD.InternalEvents.config) return;
                const found = this.cacheService.searchForItem(i.data);
                if (found) {
                    if (found.provide) return found;
                    const moduleType = found.metadata.type.charAt(0).toUpperCase() + found.metadata.type.slice(1);
                    this.bootstrapLogger.log(`Start -> @Module('${moduleName}')${this.bootstrapLogger.logHashes(`(${target.name})`)}: @${moduleType}('${found.originalName}')${this.bootstrapLogger.logHashes(`(${found.name})`)}` + ' initialized!');
                    return $lbXPS.Container.get(found);
                } else throw new Error('not found');
            });
            return res;
        };
    }
};
module.exports.ResolverService = $1970ab7acc2e0041$var$ResolverService;
$1970ab7acc2e0041$var$__decorate([
    (0, $8YGle.Injector)($4wEKm.BootstrapLogger),
    $1970ab7acc2e0041$var$__metadata("design:type", $4wEKm.BootstrapLogger)
], $1970ab7acc2e0041$var$ResolverService.prototype, "bootstrapLogger", void 0);
$1970ab7acc2e0041$var$__decorate([
    (0, $8YGle.Injector)($99xbn.CacheService),
    $1970ab7acc2e0041$var$__metadata("design:type", $99xbn.CacheService)
], $1970ab7acc2e0041$var$ResolverService.prototype, "cacheService", void 0);
module.exports.ResolverService = $1970ab7acc2e0041$var$ResolverService = $1970ab7acc2e0041$var$__decorate([
    (0, $9dO3J.Service)()
], $1970ab7acc2e0041$var$ResolverService);

});
parcelRegister("lNnaw", function(module, exports) {

$parcel$export(module.exports, "switchMap", () => $fde0256cf1891889$export$9f6ea8e48bc26eab);

var $1wVYm = parcelRequire("1wVYm");

var $5CoSH = parcelRequire("5CoSH");

var $iIZUt = parcelRequire("iIZUt");
function $fde0256cf1891889$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $1wVYm.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $iIZUt.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

});



parcelRegister("8c7sa", function(module, exports) {
"use strict";
var $5f7539d0c3e2dc0e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5f7539d0c3e2dc0e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5f7539d0c3e2dc0e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5f7539d0c3e2dc0e$var$__exportStar((parcelRequire("6rwNH")), module.exports);

});
parcelRegister("6rwNH", function(module, exports) {
"use strict";
var $4b0eb5330a55fc95$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MetadataService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $3y1aW = parcelRequire("3y1aW");
let $4b0eb5330a55fc95$var$MetadataService = class MetadataService {
    generateHashData(module, original) {
        const services = module.services || [];
        const imports = module.imports || [];
        const fillMetadata = (injectable)=>{
            if (injectable && injectable['provide']) return injectable['provide'];
            else if (injectable) {
                this.validateCustomInjectable(injectable, module, original);
                return {
                    moduleName: injectable['metadata']['moduleName'],
                    hash: injectable['metadata']['moduleHash']
                };
            }
        };
        return [
            [
                ...services.map((i)=>fillMetadata(i))
            ],
            [
                ...imports.map((i)=>fillMetadata(i))
            ]
        ];
    }
    validateCustomInjectableKeys(keys) {
    // keys.forEach(key => {
    //     console.log('TOVA NE E SHEGA', key);
    // });
    }
    validateCustomInjectable(injectable, module, original) {
        if (!injectable['metadata'] && !injectable['provide']) throw new Error(`
                ---- Wrong service ${JSON.stringify(injectable)} provided inside '${original.name}' ----
                @Module({
                    services: ${JSON.stringify([
            ...module.services.filter((i)=>!i['metadata']),
            ...module.services.filter((i)=>i && i['metadata'] && i['metadata']['moduleName']).map((i)=>i['metadata']['moduleName'])
        ])}
                })
                ${JSON.stringify(`${original}`, null, 2)}

                Hint: System recieved Object but it is not with appropriate format you must provide object with following parameters:

                YourObject: ${JSON.stringify(injectable)}

                Option 1. [YourClass]

                Option 2. [{provide: 'your-value', useClass: YourClass}]

                Option 3. [{provide: 'your-value', deps: [YourClass], useFactory: (test: YourClass) => {}}]

                Option 4. [{provide: 'your-value', useValue: 'your-value'}]
            `);
    }
    parseModuleTemplate(moduleName, generatedHashData, targetCurrentSymbol) {
        return `
            ---- @gapi module '${moduleName}' metadata----
            @Module({
                imports: ${JSON.stringify(generatedHashData[1], null, '\t')},
                services: ${JSON.stringify(generatedHashData[0], null, '\t')}
            })
            ${JSON.stringify(targetCurrentSymbol, null, 2)}
        `;
    }
    createUniqueHash(string) {
        return (0, $3y1aW.createUniqueHash)(string);
    }
};
module.exports.MetadataService = $4b0eb5330a55fc95$var$MetadataService;
module.exports.MetadataService = $4b0eb5330a55fc95$var$MetadataService = $4b0eb5330a55fc95$var$__decorate([
    (0, $9dO3J.Service)()
], $4b0eb5330a55fc95$var$MetadataService);

});
parcelRegister("3y1aW", function(module, exports) {
"use strict";
var $29557584a38af36e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29557584a38af36e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $29557584a38af36e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$29557584a38af36e$var$__exportStar((parcelRequire("hgS4T")), module.exports);

$29557584a38af36e$var$__exportStar((parcelRequire("hCc9H")), module.exports);

$29557584a38af36e$var$__exportStar((parcelRequire("eNXZh")), module.exports);

$29557584a38af36e$var$__exportStar((parcelRequire("1sM1c")), module.exports); // export * from './testing';

});
parcelRegister("hgS4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestBed = module.exports.setup = module.exports.BootstrapFramework = module.exports.BootstrapPromisify = module.exports.Bootstrap = void 0;
parcelRequire("eCW61");

var $lbXPS = parcelRequire("lbXPS");

var $9zF7T = parcelRequire("9zF7T");

var $gz85w = parcelRequire("gz85w");
(0, $gz85w.exitHandlerInit)();
const $c92de10e9ad3a040$var$bootstrapService = $lbXPS.Container.get($9zF7T.BootstrapService);
const $c92de10e9ad3a040$var$Bootstrap = (app, config)=>$c92de10e9ad3a040$var$bootstrapService.start(app, config);
module.exports.Bootstrap = $c92de10e9ad3a040$var$Bootstrap;
const $c92de10e9ad3a040$var$BootstrapPromisify = (app, config)=>$c92de10e9ad3a040$var$bootstrapService.start(app, config).toPromise();
module.exports.BootstrapPromisify = $c92de10e9ad3a040$var$BootstrapPromisify;
const $c92de10e9ad3a040$var$BootstrapFramework = (app, modules, config)=>{
    $c92de10e9ad3a040$var$bootstrapService.configService.setConfig(config);
    modules.map((m)=>$lbXPS.Container.get(m));
    return $c92de10e9ad3a040$var$bootstrapService.start(app, config);
};
module.exports.BootstrapFramework = $c92de10e9ad3a040$var$BootstrapFramework;

const $c92de10e9ad3a040$var$setup = (options, frameworks = [], bootstrapOptions)=>{
    const Module = (parcelRequire("dfqwu")).Module;
    return (0, module.exports.BootstrapFramework)(Module({
        imports: options.imports || [],
        providers: options.providers || [],
        services: options.services || [],
        bootstrap: options.bootstrap || [],
        components: options.components || [],
        controllers: options.controllers || [],
        effects: options.effects || [],
        plugins: options.plugins || [],
        afterPlugins: options.afterPlugins || [],
        beforePlugins: options.beforePlugins || []
    })(function() {}), frameworks, bootstrapOptions);
};
module.exports.setup = $c92de10e9ad3a040$var$setup;
module.exports.createTestBed = module.exports.setup;

});
parcelRegister("9zF7T", function(module, exports) {
"use strict";
var $6f8748ca66ba8ed3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6f8748ca66ba8ed3$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $6f8748ca66ba8ed3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BootstrapService = void 0;

var $cdTWx = parcelRequire("cdTWx");
var $5JMLH = parcelRequire("5JMLH");
var $g5fNy = parcelRequire("g5fNy");

var $lbXPS = parcelRequire("lbXPS");

var $4wEKm = parcelRequire("4wEKm");

var $99xbn = parcelRequire("99xbn");

var $6u0mD = parcelRequire("6u0mD");

var $eLoXP = parcelRequire("eLoXP");

var $fdMQP = parcelRequire("fdMQP");

var $9Ijpe = parcelRequire("9Ijpe");

var $gawXH = parcelRequire("gawXH");
var $bFKOt = parcelRequire("bFKOt");
var $lNnaw = parcelRequire("lNnaw");
var $d5Aat = parcelRequire("d5Aat");

var $5sFJS = parcelRequire("5sFJS");

var $cJVqd = parcelRequire("cJVqd");

var $3T1Zd = parcelRequire("3T1Zd");

var $5DN1P = parcelRequire("5DN1P");

var $gRuS1 = parcelRequire("gRuS1");

var $jubrU = parcelRequire("jubrU");

var $dSouY = parcelRequire("dSouY");

var $9dO3J = parcelRequire("9dO3J");
let $6f8748ca66ba8ed3$var$BootstrapService = class BootstrapService {
    constructor(logger, cacheService, lazyFactoriesService, configService, controllersService, effectsService, pluginService, componentsService, bootstrapsService, servicesService, afterStarterService){
        this.logger = logger;
        this.cacheService = cacheService;
        this.lazyFactoriesService = lazyFactoriesService;
        this.configService = configService;
        this.controllersService = controllersService;
        this.effectsService = effectsService;
        this.pluginService = pluginService;
        this.componentsService = componentsService;
        this.bootstrapsService = bootstrapsService;
        this.servicesService = servicesService;
        this.afterStarterService = afterStarterService;
        this.globalConfig = this.cacheService.createLayer({
            name: $6u0mD.InternalLayers.globalConfig
        });
    }
    start(app, config) {
        this.configService.setConfig(config);
        this.globalConfig.putItem({
            key: $6u0mD.InternalEvents.config,
            data: config
        });
        $lbXPS.Container.get(app);
        const lazyFactoryKeys = Array.from(this.lazyFactoriesService.lazyFactories.keys());
        return (0, $g5fNy.of)(lazyFactoryKeys).pipe((0, $gawXH.map)((factories)=>this.prepareAsyncChainables(factories)), (0, $lNnaw.switchMap)((res)=>(0, $cdTWx.combineLatest)(res).pipe((0, $d5Aat.take)(1), (0, $gawXH.map)((c)=>this.attachLazyLoadedChainables(lazyFactoryKeys, c)), (0, $gawXH.map)(()=>this.validateSystem()), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainableControllers())), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainablePluginsBeforeRegister())), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainablePluginsRegister())), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainablePluginsAfterRegister())), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainableServices())), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainableEffects())), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainableComponents())), (0, $gawXH.map)(()=>this.loadApplication()), (0, $lNnaw.switchMap)(()=>(0, $cdTWx.combineLatest)(this.asyncChainableBootstraps())), (0, $gawXH.map)(()=>this.final()))));
    }
    final() {
        this.afterStarterService.appStarted.next(true);
        if (!this.configService.config.init) this.logger.log('Bootstrap -> press start!');
        return $lbXPS.Container;
    }
    asyncChainableComponents() {
        return [
            (0, $g5fNy.of)(true),
            ...this.componentsService.getComponents().filter((c)=>this.genericFilter(c, 'components')).map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $lbXPS.Container.get(c);
                }))
        ];
    }
    asyncChainableBootstraps() {
        return [
            (0, $g5fNy.of)(true),
            ...this.bootstrapsService.getBootstraps().map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $lbXPS.Container.get(c);
                }))
        ];
    }
    asyncChainableEffects() {
        return [
            (0, $g5fNy.of)(true),
            ...this.effectsService.getEffects().filter((c)=>this.genericFilter(c, 'effects')).map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $lbXPS.Container.get(c);
                }))
        ];
    }
    asyncChainableServices() {
        return [
            (0, $g5fNy.of)(true),
            ...this.servicesService.getServices().filter((c)=>this.genericFilter(c, 'services')).map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $lbXPS.Container.get(c);
                }))
        ];
    }
    asyncChainableControllers() {
        return [
            (0, $g5fNy.of)(true),
            ...this.controllersService.getControllers().filter((c)=>this.genericFilter(c, 'controllers')).map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield $lbXPS.Container.get(c);
                }))
        ];
    }
    asyncChainablePluginsRegister() {
        return [
            (0, $g5fNy.of)(true),
            ...this.pluginService.getPlugins().filter((c)=>this.genericFilter(c, 'plugins')).map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield this.registerPlugin(c);
                }))
        ];
    }
    asyncChainablePluginsAfterRegister() {
        return [
            (0, $g5fNy.of)(true),
            ...this.pluginService.getAfterPlugins().filter((c)=>this.genericFilter(c, 'pluginsAfter')).map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield this.registerPlugin(c);
                }))
        ];
    }
    asyncChainablePluginsBeforeRegister() {
        return [
            (0, $g5fNy.of)(true),
            ...this.pluginService.getBeforePlugins().filter((c)=>this.genericFilter(c, 'pluginsBefore')).map((c)=>$6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
                    return yield this.registerPlugin(c);
                }))
        ];
    }
    genericFilter(c, name) {
        return this.configService.config.initOptions[name] || c.metadata.options && c.metadata.options['init'] || this.configService.config.init;
    }
    registerPlugin(pluggable) {
        return $6f8748ca66ba8ed3$var$__awaiter(this, void 0, void 0, function*() {
            const plugin = $lbXPS.Container.get(pluggable);
            if (typeof (plugin === null || plugin === void 0 ? void 0 : plugin.register) === 'function') yield plugin.register();
            return plugin;
        });
    }
    prepareAsyncChainables(injectables) {
        const asynChainables = [
            (0, $g5fNy.of)(true)
        ];
        const injectableLog = {};
        const getName = (n)=>n.name || n;
        injectables.map((i)=>{
            const date = Date.now();
            injectableLog[getName(i)] = {
                started: date,
                end: null
            };
            this.logger.log(`Bootstrap -> @Service('${getName(i)}'): loading...`);
            const somethingAsync = (0, $5JMLH.from)(this.lazyFactoriesService.getLazyFactory(i)).pipe((0, $bFKOt.shareReplay)(1));
            asynChainables.push(somethingAsync);
            somethingAsync.subscribe(()=>{
                this.logger.log(`Bootstrap -> @Service('${getName(i)}'): loading finished after ${Date.now() - injectableLog[getName(i)].started}ms !`);
                delete injectableLog[getName(i)];
            });
        });
        return asynChainables;
    }
    validateSystem() {
        if (this.configService.config.strict) this.cacheService.searchForDuplicateDependenciesInsideApp();
    }
    attachLazyLoadedChainables(res, chainables) {
        // Remove first chainable unused observable
        chainables.splice(0, 1);
        let count = 0;
        res.map((name)=>{
            (0, $dSouY.logExtendedInjectables)(name, this.configService.config.experimental.logExtendedInjectables);
            $lbXPS.Container.set(name, chainables[count++]);
        });
        return true;
    }
    loadApplication() {
        Array.from(this.cacheService.getLayer($6u0mD.InternalLayers.modules).map.keys()).forEach((m)=>this.cacheService.getLayer(m).putItem({
                key: $6u0mD.InternalEvents.load,
                data: this.configService.config.init
            }));
        return true;
    }
};
module.exports.BootstrapService = $6f8748ca66ba8ed3$var$BootstrapService;
module.exports.BootstrapService = $6f8748ca66ba8ed3$var$BootstrapService = $6f8748ca66ba8ed3$var$__decorate([
    (0, $9dO3J.Service)(),
    $6f8748ca66ba8ed3$var$__metadata("design:paramtypes", [
        $4wEKm.BootstrapLogger,
        $99xbn.CacheService,
        $eLoXP.LazyFactory,
        $fdMQP.ConfigService,
        $cJVqd.ControllersService,
        $5sFJS.EffectsService,
        $9Ijpe.PluginService,
        $3T1Zd.ComponentsService,
        $5DN1P.BootstrapsServices,
        $gRuS1.ServicesService,
        $jubrU.AfterStarterService
    ])
], $6f8748ca66ba8ed3$var$BootstrapService);

});
parcelRegister("cdTWx", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $8e62180f8f750821$export$77fa7d86f5204e8a);
$parcel$export(module.exports, "combineLatestInit", () => $8e62180f8f750821$export$f04dcfb475ed2128);

var $8id0M = parcelRequire("8id0M");

var $h76Jg = parcelRequire("h76Jg");

var $5JMLH = parcelRequire("5JMLH");

var $6BqGr = parcelRequire("6BqGr");

var $7hC7G = parcelRequire("7hC7G");

var $9Rm6G = parcelRequire("9Rm6G");

var $cNXK9 = parcelRequire("cNXK9");

var $iIZUt = parcelRequire("iIZUt");

var $hrgoa = parcelRequire("hrgoa");
function $8e62180f8f750821$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $9Rm6G.popScheduler)(args);
    var resultSelector = (0, $9Rm6G.popResultSelector)(args);
    var _a = (0, $h76Jg.argsArgArrayOrObject)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $5JMLH.from)([], scheduler);
    var result = new (0, $8id0M.Observable)($8e62180f8f750821$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $cNXK9.createObject)(keys, values);
    } : (0, $6BqGr.identity)));
    return resultSelector ? result.pipe((0, $7hC7G.mapOneOrManyArgs)(resultSelector)) : result;
}
function $8e62180f8f750821$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $6BqGr.identity);
    return function(subscriber) {
        $8e62180f8f750821$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $8e62180f8f750821$var$maybeSchedule(scheduler, function() {
                    var source = (0, $5JMLH.from)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $8e62180f8f750821$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $hrgoa.executeSchedule)(subscription, scheduler, execute);
    else execute();
}

});
parcelRegister("h76Jg", function(module, exports) {

$parcel$export(module.exports, "argsArgArrayOrObject", () => $c7584f62c19d23ff$export$8871b3799a14360f);
var $c7584f62c19d23ff$var$isArray = Array.isArray;
var $c7584f62c19d23ff$var$getPrototypeOf = Object.getPrototypeOf, $c7584f62c19d23ff$var$objectProto = Object.prototype, $c7584f62c19d23ff$var$getKeys = Object.keys;
function $c7584f62c19d23ff$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($c7584f62c19d23ff$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($c7584f62c19d23ff$var$isPOJO(first_1)) {
            var keys = $c7584f62c19d23ff$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $c7584f62c19d23ff$var$isPOJO(obj) {
    return obj && typeof obj === 'object' && $c7584f62c19d23ff$var$getPrototypeOf(obj) === $c7584f62c19d23ff$var$objectProto;
}

});

parcelRegister("7hC7G", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", () => $54d7b1596e6c5c3e$export$559affaa48f4288d);

var $deWeK = parcelRequire("deWeK");

var $gawXH = parcelRequire("gawXH");
var $54d7b1596e6c5c3e$var$isArray = Array.isArray;
function $54d7b1596e6c5c3e$var$callOrApply(fn, args) {
    return $54d7b1596e6c5c3e$var$isArray(args) ? fn.apply(void 0, (0, $deWeK.__spreadArray)([], (0, $deWeK.__read)(args))) : fn(args);
}
function $54d7b1596e6c5c3e$export$559affaa48f4288d(fn) {
    return (0, $gawXH.map)(function(args) {
        return $54d7b1596e6c5c3e$var$callOrApply(fn, args);
    });
}

});

parcelRegister("cNXK9", function(module, exports) {

$parcel$export(module.exports, "createObject", () => $95286771bde5c4c8$export$79c7e160a7743efd);
function $95286771bde5c4c8$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}

});


parcelRegister("bFKOt", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $87f7d6255ff84282$export$db61d692014e534e);

var $h7YIO = parcelRequire("h7YIO");

var $iUebj = parcelRequire("iUebj");
function $87f7d6255ff84282$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $iUebj.share)({
        connector: function() {
            return new (0, $h7YIO.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

});
parcelRegister("h7YIO", function(module, exports) {

$parcel$export(module.exports, "ReplaySubject", () => $c782313030840cef$export$915d2682b0aa0991);

var $deWeK = parcelRequire("deWeK");

var $f16OP = parcelRequire("f16OP");

var $fd3nS = parcelRequire("fd3nS");
var $c782313030840cef$export$915d2682b0aa0991 = function(_super) {
    (0, $deWeK.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $fd3nS.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $f16OP.Subject));

});

parcelRegister("iUebj", function(module, exports) {

$parcel$export(module.exports, "share", () => $dc38751cb8e67356$export$ed80d9de1d9df928);

var $deWeK = parcelRequire("deWeK");

var $1wVYm = parcelRequire("1wVYm");

var $f16OP = parcelRequire("f16OP");

var $1uzAx = parcelRequire("1uzAx");

var $5CoSH = parcelRequire("5CoSH");
function $dc38751cb8e67356$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $f16OP.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $5CoSH.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $dc38751cb8e67356$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $1uzAx.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $dc38751cb8e67356$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $dc38751cb8e67356$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1wVYm.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $dc38751cb8e67356$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $1uzAx.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $1wVYm.innerFrom)(on.apply(void 0, (0, $deWeK.__spreadArray)([], (0, $deWeK.__read)(args)))).subscribe(onSubscriber);
}

});


parcelRegister("jubrU", function(module, exports) {
"use strict";
var $e2f9b336ba180b70$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AfterStarterService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $f16OP = parcelRequire("f16OP");
let $e2f9b336ba180b70$var$AfterStarterService = class AfterStarterService {
    constructor(){
        this.appStarted = new $f16OP.Subject();
    }
};
module.exports.AfterStarterService = $e2f9b336ba180b70$var$AfterStarterService;
module.exports.AfterStarterService = $e2f9b336ba180b70$var$AfterStarterService = $e2f9b336ba180b70$var$__decorate([
    (0, $9dO3J.Service)()
], $e2f9b336ba180b70$var$AfterStarterService);

});

parcelRegister("dSouY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logExtendedInjectables = void 0;

var $4VpzQ = parcelRequire("4VpzQ");
const $a1a3526abf209648$var$logExtendedInjectables = (name, logExtendedInjectables)=>{
    if ($4VpzQ.Container.has(name) && logExtendedInjectables) console.log(`Warn: Injection Token '${name.name || name}' is extended after it has being declared! ${JSON.stringify($4VpzQ.Container.get(name))}`);
};
module.exports.logExtendedInjectables = $a1a3526abf209648$var$logExtendedInjectables;

});


parcelRegister("gz85w", function(module, exports) {

var $3rPrU = parcelRequire("3rPrU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exitHandlerInit = void 0;

var $k44E3 = parcelRequire("k44E3");

var $lbXPS = parcelRequire("lbXPS");
const $c0f63052e287dadf$var$exitHandlerInit = ()=>{
    const handler = $lbXPS.Container.get($k44E3.ExitHandlerService);
    handler.init();
    // do something when app is closing
    $3rPrU.on('exit', handler.exitHandler.bind(handler, {
        cleanup: true
    }));
    // catches ctrl+c event
    $3rPrU.on('SIGINT', handler.exitHandler.bind(handler, {
        exit: true
    }));
    // catches 'kill pid' (for example: nodemon restart)
    $3rPrU.on('SIGUSR1', handler.exitHandler.bind(handler, {
        exit: true
    }));
    $3rPrU.on('SIGUSR2', handler.exitHandler.bind(handler, {
        exit: true
    }));
    // catches uncaught exceptions
    $3rPrU.on('uncaughtException', handler.exitHandler.bind(handler, {
        exit: true
    }));
};
module.exports.exitHandlerInit = $c0f63052e287dadf$var$exitHandlerInit;

});





parcelRegister("iWKlu", function(module, exports) {
"use strict";
var $dcb1980ea5e11970$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dcb1980ea5e11970$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dcb1980ea5e11970$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dcb1980ea5e11970$var$__exportStar((parcelRequire("a13DM")), module.exports);

});
parcelRegister("a13DM", function(module, exports) {
"use strict";
var $74acd2540a3afbbe$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $74acd2540a3afbbe$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompressionService = void 0;

var $9dO3J = parcelRequire("9dO3J");

var $8YGle = parcelRequire("8YGle");

var $818uG = parcelRequire("818uG");
let $74acd2540a3afbbe$var$CompressionService = class CompressionService {
    // public gZipFile(input: string, output: string, options: PrivateCryptoModel = { cyperIv: '', algorithm: '', cyperKey: '' }) {
    //     const config = this.config.config.experimental.crypto || options;
    //     return Observable.create(observer => {
    //         createReadStream(input)
    //             .pipe(createGzip())
    //             // .pipe(createCipheriv(config.algorithm, config.cyperKey, config.cyperIv))
    //             .pipe(createWriteStream(output))
    //             .on('finish', () => observer.next(true))
    //             .on('error', (err) => observer.error(err));
    //     });
    // }
    // public readGzipFile(input: string, output: string, options: PrivateCryptoModel = { cyperIv: '', algorithm: '', cyperKey: '' }) {
    //     const config = this.config.config.experimental.crypto || options;
    //     return Observable.create(observer => {
    //         createReadStream(input)
    //             // .pipe(createDecipheriv(config.algorithm, config.cyperKey, config.cyperIv))
    //             .pipe(createGunzip())
    //             .pipe(createWriteStream(output))
    //             .on('finish', () => observer.next(true))
    //             .on('error', (err) => observer.error(err));
    //     });
    // }
    gZipAll() {
    // var archiver = require('archiver');
    // var output = createWriteStream('./example.tar.gz');
    // var archive = archiver('tar', {
    //     gzip: true,
    //     zlib: { level: 9 } // Sets the compression level.
    // });
    // archive.on('error', function (err) {
    //     throw err;
    // });
    // // pipe archive data to the output file
    // archive.pipe(output);
    // // append files
    // archive.file('/path/to/file0.txt', { name: 'file0-or-change-this-whatever.txt' });
    // archive.file('/path/to/README.md', { name: 'foobar.md' });
    // // Wait for streams to complete
    // archive.finalize();
    }
};
module.exports.CompressionService = $74acd2540a3afbbe$var$CompressionService;
$74acd2540a3afbbe$var$__decorate([
    (0, $8YGle.Injector)($818uG.ConfigService),
    $74acd2540a3afbbe$var$__metadata("design:type", $818uG.ConfigService)
], $74acd2540a3afbbe$var$CompressionService.prototype, "config", void 0);
module.exports.CompressionService = $74acd2540a3afbbe$var$CompressionService = $74acd2540a3afbbe$var$__decorate([
    (0, $9dO3J.Service)()
], $74acd2540a3afbbe$var$CompressionService);

});


parcelRegister("3Ouei", function(module, exports) {
"use strict";
var $2c6d7d8ebb2d0b1c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c6d7d8ebb2d0b1c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2c6d7d8ebb2d0b1c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2c6d7d8ebb2d0b1c$var$__exportStar((parcelRequire("5sFJS")), module.exports);

});

parcelRegister("1clpo", function(module, exports) {
"use strict";
var $0df784bf8636eaf7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0df784bf8636eaf7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0df784bf8636eaf7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0df784bf8636eaf7$var$__exportStar((parcelRequire("cJVqd")), module.exports);

});

parcelRegister("Oj27e", function(module, exports) {
"use strict";
var $09736f355a596bdc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $09736f355a596bdc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $09736f355a596bdc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$09736f355a596bdc$var$__exportStar((parcelRequire("3T1Zd")), module.exports);

});

parcelRegister("iurA8", function(module, exports) {
"use strict";
var $d7606c885be1e118$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d7606c885be1e118$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d7606c885be1e118$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d7606c885be1e118$var$__exportStar((parcelRequire("5DN1P")), module.exports);

});

parcelRegister("hjbHI", function(module, exports) {
"use strict";
var $c99d4a2e0cac309b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c99d4a2e0cac309b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c99d4a2e0cac309b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c99d4a2e0cac309b$var$__exportStar((parcelRequire("gRuS1")), module.exports);

});

parcelRegister("a8RBP", function(module, exports) {
"use strict";
var $76243c62ceeda843$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76243c62ceeda843$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PluginManager = void 0;

var $9Ijpe = parcelRequire("9Ijpe");

var $9dO3J = parcelRequire("9dO3J");
let $76243c62ceeda843$var$PluginManager = class PluginManager {
    constructor(pluginService){
        this.pluginService = pluginService;
    }
    listPlugins() {
        return this.pluginService.getPlugins();
    }
    getPlugin(pluginClass) {
        return this.pluginService.getPlugins().filter((p)=>p.name === pluginClass.name)[0];
    }
};
module.exports.PluginManager = $76243c62ceeda843$var$PluginManager;
module.exports.PluginManager = $76243c62ceeda843$var$PluginManager = $76243c62ceeda843$var$__decorate([
    (0, $9dO3J.Service)(),
    $76243c62ceeda843$var$__metadata("design:paramtypes", [
        $9Ijpe.PluginService
    ])
], $76243c62ceeda843$var$PluginManager);

});




parcelRegister("eXK4b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("akPSC", function(module, exports) {
"use strict";
var $786403e7afd696c7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $786403e7afd696c7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $786403e7afd696c7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$786403e7afd696c7$var$__exportStar((parcelRequire("8YGle")), module.exports);

});

parcelRegister("fK7Dt", function(module, exports) {
"use strict";
var $b7611333ea6aa15b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b7611333ea6aa15b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b7611333ea6aa15b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b7611333ea6aa15b$var$__exportStar((parcelRequire("cHucR")), module.exports);

});
parcelRegister("cHucR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectSoft = $93f0ee925c7b7857$var$InjectSoft;

var $lbXPS = parcelRequire("lbXPS");

var $7xDCd = parcelRequire("7xDCd");
function $93f0ee925c7b7857$var$InjectSoft(Service) {
    return $lbXPS.Container.get($7xDCd.ModuleService).watcherService.getByClass(Service);
}

});


parcelRegister("dlGJ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Inject = $9b7e613cb5bfc25a$var$Inject;

var $4VpzQ = parcelRequire("4VpzQ");

var $dZTS7 = parcelRequire("dZTS7");
/**
 * Injects a service into a class property or constructor parameter.
 */ function $9b7e613cb5bfc25a$var$Inject(typeOrName) {
    return function(target, propertyName, index) {
        if ((0, $dZTS7.isClient)() && typeOrName && typeof typeOrName === 'function') {
            Object.defineProperty(target, propertyName, {
                get: ()=>$4VpzQ.Container.get(typeOrName)
            });
            return;
        }
        if (!typeOrName) typeOrName = ()=>Reflect.getMetadata('design:type', target, propertyName);
        $4VpzQ.Container.registerHandler({
            object: target,
            propertyName: propertyName,
            index: index,
            value: (instance)=>instance.get((0, $dZTS7.getIdentifier)(typeOrName, target, propertyName))
        });
    };
}

});
parcelRegister("dZTS7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClient = module.exports.getIdentifier = void 0;

var $h7YuD = parcelRequire("h7YuD");

var $2KayX = parcelRequire("2KayX");
const $a30c4fdc227ec2be$var$getIdentifier = (typeOrName, target, propertyName)=>{
    let identifier;
    if (typeof typeOrName === 'string') identifier = typeOrName;
    else if (typeOrName instanceof $h7YuD.Token) identifier = typeOrName;
    else identifier = typeOrName();
    if (identifier === Object) throw new $2KayX.CannotInjectError(target, propertyName);
    return identifier;
};
module.exports.getIdentifier = $a30c4fdc227ec2be$var$getIdentifier;
const $a30c4fdc227ec2be$var$isClient = ()=>typeof window !== 'undefined' && typeof window.document !== 'undefined';
module.exports.isClient = $a30c4fdc227ec2be$var$isClient;

});
parcelRegister("2KayX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CannotInjectError = void 0;
/**
 * Thrown when DI cannot inject value into property decorated by @Inject decorator.
 */ class $1ff8123385b2fec2$var$CannotInjectError extends Error {
    constructor(target, propertyName){
        super(`Cannot inject value into '${target.constructor.name}.${propertyName}'. ` + `Please make sure you setup @abraham/reflection properly and you don't use interfaces without service tokens as injection value.`);
        this.name = 'ServiceNotFoundError';
        Object.setPrototypeOf(this, $1ff8123385b2fec2$var$CannotInjectError.prototype);
    }
}
module.exports.CannotInjectError = $1ff8123385b2fec2$var$CannotInjectError;

});



parcelRegister("37VnB", function(module, exports) {
"use strict";
var $246e88f6edbdc5fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $246e88f6edbdc5fc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $246e88f6edbdc5fc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$246e88f6edbdc5fc$var$__exportStar((parcelRequire("jhsOw")), module.exports);

});
parcelRegister("jhsOw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Controller = $039f5266032959cf$var$Controller;

var $4kW5x = parcelRequire("4kW5x");
function $039f5266032959cf$var$Controller(options) {
    return (0, $4kW5x.ReflectDecorator)(options, {
        type: 'controller'
    });
}

});


parcelRegister("kiP3r", function(module, exports) {
"use strict";
var $ec7d17786905722f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ec7d17786905722f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ec7d17786905722f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ec7d17786905722f$var$__exportStar((parcelRequire("2j14x")), module.exports);

});
parcelRegister("2j14x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Effect = $1ade300855a5ef47$var$Effect;

var $4kW5x = parcelRequire("4kW5x");
function $1ade300855a5ef47$var$Effect(options) {
    return (0, $4kW5x.ReflectDecorator)(options, {
        type: 'effect'
    });
}

});


parcelRegister("gr7OL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Plugin = $bf753b69c2c6ff8a$var$Plugin;

var $4kW5x = parcelRequire("4kW5x");
function $bf753b69c2c6ff8a$var$Plugin(options) {
    return (0, $4kW5x.ReflectDecorator)(options, {
        type: 'plugin'
    });
}

});

parcelRegister("hpmre", function(module, exports) {
"use strict";
var $cac62d3ae698d059$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cac62d3ae698d059$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cac62d3ae698d059$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cac62d3ae698d059$var$__exportStar((parcelRequire("1HbJt")), module.exports);

});
parcelRegister("1HbJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Component = $13c2e86aadb628cc$var$Component;

var $4kW5x = parcelRequire("4kW5x");
function $13c2e86aadb628cc$var$Component(options) {
    return (0, $4kW5x.ReflectDecorator)(options, {
        type: 'component'
    });
}

});


parcelRegister("ggNw3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectMany = $bd848cd0da19d55b$var$InjectMany;

var $4VpzQ = parcelRequire("4VpzQ");

var $h7YuD = parcelRequire("h7YuD");

var $dZTS7 = parcelRequire("dZTS7");
/**
 * Injects a service into a class property or constructor parameter.
 */ function $bd848cd0da19d55b$var$InjectMany(typeOrName) {
    return function(target, propertyName, index) {
        if ((0, $dZTS7.isClient)() && typeOrName instanceof $h7YuD.Token) {
            Object.defineProperty(target, propertyName, {
                get: ()=>$4VpzQ.Container.getMany((0, $dZTS7.getIdentifier)(typeOrName, target, propertyName))
            });
            return;
        }
        if (!typeOrName) typeOrName = ()=>Reflect.getMetadata('design:type', target, propertyName);
        $4VpzQ.Container.registerHandler({
            object: target,
            propertyName: propertyName,
            index: index,
            value: (instance)=>instance.getMany((0, $dZTS7.getIdentifier)(typeOrName, target, propertyName))
        });
    };
}

});



parcelRegister("2O1GU", function(module, exports) {
"use strict";
var $20b19014aa0b79b9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $20b19014aa0b79b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $20b19014aa0b79b9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $20b19014aa0b79b9$var$__createBinding(exports1, m, p);
};
var $20b19014aa0b79b9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $20b19014aa0b79b9$var$GraphqlModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemoryCache = module.exports.GraphqlModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $iAVuu = parcelRequire("iAVuu");


var $6GSyD = parcelRequire("6GSyD");
var $7xzZX = parcelRequire("7xzZX");
var $g72ol = parcelRequire("g72ol");
var $dH7IB = parcelRequire("dH7IB");
var $kWadF = parcelRequire("kWadF");parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");
var $eSYTM = parcelRequire("eSYTM");

var $i5NEx = parcelRequire("i5NEx");

var $hoK3o = parcelRequire("hoK3o");

var $8HL2O = parcelRequire("8HL2O");

var $gZgu2 = parcelRequire("gZgu2");
let $20b19014aa0b79b9$var$GraphqlModule = $20b19014aa0b79b9$var$GraphqlModule_1 = class GraphqlModule {
    static forRoot({ uri: uri, pubsub: pubsub, refreshOnUnauthenticated: refreshOnUnauthenticated, onRequest: onRequest, cache: cache, apolloRequestHandler: apolloRequestHandler, cancelPendingRequests: cancelPendingRequests, apolloClientOptions: apolloClientOptions } = {}, documents = {}) {
        const headers = {};
        const connections = {};
        return {
            module: $20b19014aa0b79b9$var$GraphqlModule_1,
            providers: [
                {
                    provide: (parcelRequire("e8RRb")).GraphqlDocuments,
                    useValue: Object.keys(documents).reduce((prev, doc)=>Object.assign(Object.assign({}, prev), {
                            [doc.split('/').pop()]: documents[doc]
                        }), {})
                },
                {
                    provide: (parcelRequire("e8RRb")).ApolloClient,
                    useFactory: ()=>new $6GSyD.ApolloClient(Object.assign({
                            link: (0, $g72ol.concat)((0, $kWadF.from)([
                                (0, $gZgu2.setContext)((operation)=>$20b19014aa0b79b9$var$__awaiter(this, void 0, void 0, function*() {
                                        const method = onRequest || (parcelRequire("e8RRb")).noopHeaders;
                                        let headersMap = (yield method.call(operation)) || {};
                                        headersMap.forEach((v, k)=>{
                                            headers[k] = v;
                                        });
                                        return {
                                            headers: headers
                                        };
                                    })),
                                new $7xzZX.ApolloLink(typeof apolloRequestHandler === 'function' ? apolloRequestHandler : (operation, forward)=>{
                                    /* Start cancel request */ if (cancelPendingRequests) return new $bYo4v.Observable((observer)=>{
                                        const context = operation.getContext();
                                        const connectionHandle = forward(operation).subscribe({
                                            next: (...arg)=>observer.next(...arg),
                                            error: (...arg)=>{
                                                cleanUp();
                                                observer.error(...arg);
                                            },
                                            complete: (...arg)=>{
                                                cleanUp();
                                                observer.complete(...arg);
                                            }
                                        });
                                        const cleanUp = ()=>{
                                            connectionHandle === null || connectionHandle === void 0 || connectionHandle.unsubscribe();
                                            delete connections[context.requestTrackerId];
                                        };
                                        if (context.requestTrackerId) {
                                            const controller = new AbortController();
                                            controller.signal.onabort = cleanUp;
                                            operation.setContext(Object.assign(Object.assign({}, context), {
                                                fetchOptions: Object.assign({
                                                    signal: controller.signal
                                                }, context === null || context === void 0 ? void 0 : context.fetchOptions)
                                            }));
                                            if (connections[context.requestTrackerId]) // If a controller exists, that means this operation should be aborted.
                                            connections[context.requestTrackerId].abort();
                                            connections[context.requestTrackerId] = controller;
                                        }
                                        return connectionHandle;
                                    });
                                    /* End cancel request */ return forward(operation);
                                })
                            ]), (0, $eSYTM.split)(({ query: query })=>{
                                const { kind: kind, operation: operation } = (0, $8HL2O.getMainDefinition)(query);
                                return kind === 'OperationDefinition' && operation === 'subscription';
                            }, (()=>{
                                const wsLink = new $i5NEx.WebSocketLink(new $hoK3o.SubscriptionClient(pubsub, {
                                    lazy: true,
                                    connectionParams: ()=>({
                                            get authorization () {
                                                return headers['authorization'];
                                            }
                                        }),
                                    connectionCallback: (error)=>{
                                        console.error('[Subscription]: ', error);
                                        if ((error === null || error === void 0 ? void 0 : error['message']) === 'Unauthorized') {
                                            if (refreshOnUnauthenticated) location.reload();
                                            wsLink['subscriptionClient'].close(false, false);
                                        }
                                    },
                                    reconnect: true
                                }));
                                return wsLink;
                            })(), (0, $dH7IB.createHttpLink)({
                                uri: uri
                            }))),
                            cache: cache || new $iAVuu.InMemoryCache()
                        }, apolloClientOptions))
                }
            ]
        };
    }
};
module.exports.GraphqlModule = $20b19014aa0b79b9$var$GraphqlModule;
module.exports.GraphqlModule = $20b19014aa0b79b9$var$GraphqlModule = $20b19014aa0b79b9$var$GraphqlModule_1 = $20b19014aa0b79b9$var$__decorate([
    (0, $1t8Wn.Module)({})
], $20b19014aa0b79b9$var$GraphqlModule);

$20b19014aa0b79b9$var$__exportStar((parcelRequire("e8RRb")), module.exports);

$20b19014aa0b79b9$var$__exportStar((parcelRequire("7kaBr")), module.exports);

var $iAVuu = parcelRequire("iAVuu");
Object.defineProperty(module.exports, "InMemoryCache", {
    enumerable: true,
    get: function() {
        return $iAVuu.InMemoryCache;
    }
});

});
parcelRegister("iAVuu", function(module, exports) {

$parcel$export(module.exports, "InMemoryCache", () => $d8982f45f98399d0$export$467265324939f47f);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");


var $35wna = parcelRequire("35wna");

var $6EJag = parcelRequire("6EJag");

var $8YAgr = parcelRequire("8YAgr");

var $dGJSl = parcelRequire("dGJSl");

var $ctUe3 = parcelRequire("ctUe3");
var $7QVo3 = parcelRequire("7QVo3");

var $5pFjR = parcelRequire("5pFjR");

var $3gI6V = parcelRequire("3gI6V");

var $6r8HE = parcelRequire("6r8HE");

var $aHxuU = parcelRequire("aHxuU");

var $gwujw = parcelRequire("gwujw");

var $fQFHs = parcelRequire("fQFHs");

var $4e05c = parcelRequire("4e05c");
var $d8982f45f98399d0$export$467265324939f47f = function(_super) {
    (0, $deWeK.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = (0, $aHxuU.makeVar);
        _this.txCount = 0;
        _this.config = (0, $fQFHs.normalizeConfig)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $gwujw.Policies)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        var rootStore = this.data = new (0, $6r8HE.EntityStore).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new (0, $3gI6V.StoreWriter)(this, this.storeReader = new (0, $5pFjR.StoreReader)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $fQFHs.shouldCanonizeResults)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $35wna.wrap)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $6r8HE.supportsResultCaching)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, (0, $4e05c.canonicalStringify)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $dGJSl.MissingFieldError)) return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $fQFHs.hasOwn).call(options, "id") && !options.id) return false;
        var store = options.optimistic ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) (0, $aHxuU.recallCache)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $aHxuU.forgetCache)(_this);
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        (0, $4e05c.canonicalStringify).reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $7QVo3.isReference)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            __DEV__ && (0, $64dys.invariant).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $fQFHs.hasOwn).call(options, "id")) return false;
            options = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $4e05c.canonicalStringify).reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $aHxuU.forgetCache)(this);
        } else this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) this.broadcastWatches((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === 'string') this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) perform(this.data);
        else perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) alreadyDirty.delete(watch);
                    return result;
                }
            }));
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $ctUe3.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) return;
        }
        if (!lastDiff || !(0, $6EJag.equal)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $8YAgr.ApolloCache));

});
parcelRegister("6TVLx", function(module, exports) {

$parcel$export(module.exports, "maybe", () => (parcelRequire("58Wpk")).maybe);
$parcel$export(module.exports, "invariant", () => (parcelRequire("64dys")).invariant);
$parcel$export(module.exports, "InvariantError", () => (parcelRequire("64dys")).InvariantError);

var $64dys = parcelRequire("64dys");

var $bnVgZ = parcelRequire("bnVgZ");

var $ftI1k = parcelRequire("ftI1k");

var $58Wpk = parcelRequire("58Wpk");

var $dnolI = parcelRequire("dnolI");
function $5064b0354697b2ab$export$94b45febe34b7938() {
    __DEV__ ? (0, $64dys.invariant)("boolean" === typeof (0, $bnVgZ.default), (0, $bnVgZ.default)) : (0, $64dys.invariant)("boolean" === typeof (0, $bnVgZ.default), 39);
}
(0, $ftI1k.removeTemporaryGlobals)();
$5064b0354697b2ab$export$94b45febe34b7938();

});
parcelRegister("64dys", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $46ada179230bfd53$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $46ada179230bfd53$export$f5708dca728d7177);

var $deWeK = parcelRequire("deWeK");
var $46ada179230bfd53$var$genericMessage = "Invariant Violation";
var $46ada179230bfd53$var$_a = Object.setPrototypeOf, $46ada179230bfd53$var$setPrototypeOf = $46ada179230bfd53$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $46ada179230bfd53$var$_a;
var $46ada179230bfd53$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $deWeK.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $46ada179230bfd53$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $46ada179230bfd53$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $46ada179230bfd53$var$genericMessage;
        $46ada179230bfd53$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $46ada179230bfd53$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $46ada179230bfd53$export$cea12affaee22fe8(message);
}
var $46ada179230bfd53$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $46ada179230bfd53$var$verbosityLevel = $46ada179230bfd53$var$verbosityLevels.indexOf("log");
function $46ada179230bfd53$var$wrapConsoleMethod(name) {
    return function() {
        if ($46ada179230bfd53$var$verbosityLevels.indexOf(name) >= $46ada179230bfd53$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $46ada179230bfd53$var$wrapConsoleMethod("debug");
    invariant.log = $46ada179230bfd53$var$wrapConsoleMethod("log");
    invariant.warn = $46ada179230bfd53$var$wrapConsoleMethod("warn");
    invariant.error = $46ada179230bfd53$var$wrapConsoleMethod("error");
})($46ada179230bfd53$export$f5708dca728d7177 || ($46ada179230bfd53$export$f5708dca728d7177 = {}));
function $46ada179230bfd53$export$a80e09f2cd325fb8(level) {
    var old = $46ada179230bfd53$var$verbosityLevels[$46ada179230bfd53$var$verbosityLevel];
    $46ada179230bfd53$var$verbosityLevel = Math.max(0, $46ada179230bfd53$var$verbosityLevels.indexOf(level));
    return old;
}
var $46ada179230bfd53$export$2e2bcd8739ae039 = $46ada179230bfd53$export$f5708dca728d7177;

});

parcelRegister("bnVgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $849e44ebb9650c1e$export$2e2bcd8739ae039);

var $dnolI = parcelRequire("dnolI");

var $58Wpk = parcelRequire("58Wpk");
var $849e44ebb9650c1e$var$__ = "__";
var $849e44ebb9650c1e$var$GLOBAL_KEY = [
    $849e44ebb9650c1e$var$__,
    $849e44ebb9650c1e$var$__
].join("DEV");
function $849e44ebb9650c1e$var$getDEV() {
    try {
        return Boolean(__DEV__);
    } catch (_a) {
        Object.defineProperty((0, $dnolI.default), $849e44ebb9650c1e$var$GLOBAL_KEY, {
            value: (0, $58Wpk.maybe)(function() {
                return "production";
            }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true
        });
        return (0, $dnolI.default)[$849e44ebb9650c1e$var$GLOBAL_KEY];
    }
}
var $849e44ebb9650c1e$export$2e2bcd8739ae039 = $849e44ebb9650c1e$var$getDEV();

});
parcelRegister("dnolI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd04f9e25be6887$export$2e2bcd8739ae039);

var $58Wpk = parcelRequire("58Wpk");
var $9bd04f9e25be6887$export$2e2bcd8739ae039 = (0, $58Wpk.maybe)(function() {
    return globalThis;
}) || (0, $58Wpk.maybe)(function() {
    return window;
}) || (0, $58Wpk.maybe)(function() {
    return self;
}) || (0, $58Wpk.maybe)(function() {
    return $parcel$global;
}) || (0, $58Wpk.maybe)(function() {
    return (0, $58Wpk.maybe).constructor("return this")();
});

});
parcelRegister("58Wpk", function(module, exports) {

$parcel$export(module.exports, "maybe", () => $3beb019b37864f14$export$f8b8b9ce72e9ccbf);
function $3beb019b37864f14$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

});



parcelRegister("ftI1k", function(module, exports) {

$parcel$export(module.exports, "removeTemporaryGlobals", () => $b44bb5fb3fe19b5d$export$645629cf60cf5775);

var $fQN2O = parcelRequire("fQN2O");

var $1KHiu = parcelRequire("1KHiu");
function $b44bb5fb3fe19b5d$export$645629cf60cf5775() {
    return typeof (0, $1KHiu.Source) === "function" ? (0, $fQN2O.remove)() : (0, $fQN2O.remove)();
}

});
parcelRegister("fQN2O", function(module, exports) {

$parcel$export(module.exports, "remove", () => $b8a1c185cbb62b28$export$cd7f480d6b8286c3);

var $3rPrU = parcelRequire("3rPrU");
function $b8a1c185cbb62b28$var$maybe(thunk) {
    try {
        return thunk();
    } catch (_) {}
}
var $b8a1c185cbb62b28$var$safeGlobal = $b8a1c185cbb62b28$var$maybe(function() {
    return globalThis;
}) || $b8a1c185cbb62b28$var$maybe(function() {
    return window;
}) || $b8a1c185cbb62b28$var$maybe(function() {
    return self;
}) || $b8a1c185cbb62b28$var$maybe(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
$b8a1c185cbb62b28$var$maybe(function() {
    return $b8a1c185cbb62b28$var$maybe.constructor("return this")();
});
var $b8a1c185cbb62b28$var$needToRemove = false;
function $b8a1c185cbb62b28$export$4b3e715f166fdd78() {
    if ($b8a1c185cbb62b28$var$safeGlobal && !$b8a1c185cbb62b28$var$maybe(function() {
        return "production";
    }) && !$b8a1c185cbb62b28$var$maybe(function() {
        return $3rPrU;
    })) {
        Object.defineProperty($b8a1c185cbb62b28$var$safeGlobal, "process", {
            value: {
                env: {
                    // This default needs to be "production" instead of "development", to
                    // avoid the problem https://github.com/graphql/graphql-js/pull/2894
                    // will eventually solve, once merged and released.
                    NODE_ENV: "production"
                }
            },
            // Let anyone else change global.process as they see fit, but hide it from
            // Object.keys(global) enumeration.
            configurable: true,
            enumerable: false,
            writable: true
        });
        $b8a1c185cbb62b28$var$needToRemove = true;
    }
}
// Call install() at least once, when this module is imported.
$b8a1c185cbb62b28$export$4b3e715f166fdd78();
function $b8a1c185cbb62b28$export$cd7f480d6b8286c3() {
    if ($b8a1c185cbb62b28$var$needToRemove) {
        delete $b8a1c185cbb62b28$var$safeGlobal.process;
        $b8a1c185cbb62b28$var$needToRemove = false;
    }
}

});

parcelRegister("1KHiu", function(module, exports) {

$parcel$export(module.exports, "Source", () => $d5841bff49909319$export$1d2df86270c81ecb);

var $28JEf = parcelRequire("28JEf");

var $6bUtK = parcelRequire("6bUtK");
var $d5841bff49909319$export$1d2df86270c81ecb = function Source(body, name, locationOffset) {
    this.body = body;
    this.name = name || 'GraphQL request';
    this.locationOffset = locationOffset || {
        line: 1,
        column: 1
    };
    this.locationOffset.line > 0 || (0, $28JEf.default)(0, 'line in locationOffset is 1-indexed and must be positive');
    this.locationOffset.column > 0 || (0, $28JEf.default)(0, 'column in locationOffset is 1-indexed and must be positive');
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
(0, $6bUtK.default)($d5841bff49909319$export$1d2df86270c81ecb);

});
parcelRegister("28JEf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d82644d3005919e$export$2e2bcd8739ae039);
function $1d82644d3005919e$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("6bUtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cbd144c98d7ede7$export$2e2bcd8739ae039);
/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */ function $8cbd144c98d7ede7$export$2e2bcd8739ae039(classObject) {
    if (typeof Symbol === 'function' && Symbol.toStringTag) Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
        get: function get() {
            return this.constructor.name;
        }
    });
}

});




parcelRegister("35wna", function(module, exports) {

$parcel$export(module.exports, "dep", () => $23faf33faff0276f$export$c723b7eff9d8f870);
$parcel$export(module.exports, "wrap", () => $23faf33faff0276f$export$4997ffc0176396a6);

var $gztQO = parcelRequire("gztQO");

var $35rPQ = parcelRequire("35rPQ");
function $23faf33faff0276f$var$defaultDispose() {}
var $23faf33faff0276f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $23faf33faff0276f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function(key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    };
    Cache.prototype.set = function(key, value) {
        var node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $23faf33faff0276f$var$parentEntrySlot = new (0, $35rPQ.Slot)();
var $23faf33faff0276f$var$_a;
var $23faf33faff0276f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var // This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
$23faf33faff0276f$var$toArray = ($23faf33faff0276f$var$_a = Array.from, $23faf33faff0276f$var$_a === void 0 ? function(collection) {
    var array = [];
    collection.forEach(function(item) {
        return array.push(item);
    });
    return array;
} : $23faf33faff0276f$var$_a);
function $23faf33faff0276f$var$maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
var $23faf33faff0276f$var$emptySetPool = [];
var $23faf33faff0276f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $23faf33faff0276f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $23faf33faff0276f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $23faf33faff0276f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $23faf33faff0276f$var$valueCopy(value) {
    return value.slice(0);
}
var $23faf33faff0276f$var$Entry = /** @class */ function() {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function() {
        if (this.value.length === 1 && !$23faf33faff0276f$var$mightBeDirty(this)) {
            $23faf33faff0276f$var$rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function(args) {
        $23faf33faff0276f$var$assert(!this.recomputing, "already recomputing");
        $23faf33faff0276f$var$rememberParent(this);
        return $23faf33faff0276f$var$mightBeDirty(this) ? $23faf33faff0276f$var$reallyRecompute(this, args) : $23faf33faff0276f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $23faf33faff0276f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $23faf33faff0276f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $23faf33faff0276f$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $23faf33faff0276f$var$eachParent(this, function(parent, child) {
            parent.setDirty();
            $23faf33faff0276f$var$forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $23faf33faff0276f$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function() {
        var _this = this;
        if (this.deps) {
            $23faf33faff0276f$var$toArray(this.deps).forEach(function(dep) {
                return dep.delete(_this);
            });
            this.deps.clear();
            $23faf33faff0276f$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}();
function $23faf33faff0276f$var$rememberParent(child) {
    var parent = $23faf33faff0276f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($23faf33faff0276f$var$mightBeDirty(child)) $23faf33faff0276f$var$reportDirtyChild(parent, child);
        else $23faf33faff0276f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $23faf33faff0276f$var$reallyRecompute(entry, args) {
    $23faf33faff0276f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $23faf33faff0276f$var$parentEntrySlot.withValue(entry, $23faf33faff0276f$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($23faf33faff0276f$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $23faf33faff0276f$var$setClean(entry);
    return $23faf33faff0276f$var$valueGet(entry.value);
}
function $23faf33faff0276f$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $23faf33faff0276f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $23faf33faff0276f$var$setClean(entry) {
    entry.dirty = false;
    if ($23faf33faff0276f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $23faf33faff0276f$var$reportClean(entry);
}
function $23faf33faff0276f$var$reportDirty(child) {
    $23faf33faff0276f$var$eachParent(child, $23faf33faff0276f$var$reportDirtyChild);
}
function $23faf33faff0276f$var$reportClean(child) {
    $23faf33faff0276f$var$eachParent(child, $23faf33faff0276f$var$reportCleanChild);
}
function $23faf33faff0276f$var$eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = $23faf33faff0276f$var$toArray(child.parents);
        for(var i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $23faf33faff0276f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $23faf33faff0276f$var$assert(parent.childValues.has(child));
    $23faf33faff0276f$var$assert($23faf33faff0276f$var$mightBeDirty(child));
    var parentWasClean = !$23faf33faff0276f$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $23faf33faff0276f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $23faf33faff0276f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $23faf33faff0276f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $23faf33faff0276f$var$assert(parent.childValues.has(child));
    $23faf33faff0276f$var$assert(!$23faf33faff0276f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $23faf33faff0276f$var$valueCopy(child.value));
    else if (!$23faf33faff0276f$var$valueIs(childValue, child.value)) parent.setDirty();
    $23faf33faff0276f$var$removeDirtyChild(parent, child);
    if ($23faf33faff0276f$var$mightBeDirty(parent)) return;
    $23faf33faff0276f$var$reportClean(parent);
}
function $23faf33faff0276f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($23faf33faff0276f$var$emptySetPool.length < $23faf33faff0276f$var$POOL_TARGET_SIZE) $23faf33faff0276f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $23faf33faff0276f$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach(function(_value, child) {
        $23faf33faff0276f$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $23faf33faff0276f$var$assert(parent.dirtyChildren === null);
}
function $23faf33faff0276f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $23faf33faff0276f$var$removeDirtyChild(parent, child);
}
function $23faf33faff0276f$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        $23faf33faff0276f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
var $23faf33faff0276f$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $23faf33faff0276f$export$c723b7eff9d8f870(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = $23faf33faff0276f$var$parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) depsByKey.set(key, dep_1 = new Set);
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                $23faf33faff0276f$var$maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = entryMethodName && $23faf33faff0276f$var$hasOwnProperty.call($23faf33faff0276f$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            $23faf33faff0276f$var$toArray(dep).forEach(function(entry) {
                return entry[m_1]();
            });
            depsByKey.delete(key);
            $23faf33faff0276f$var$maybeUnsubscribe(dep);
        }
    };
    return depend;
}
function $23faf33faff0276f$var$makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new (0, $gztQO.Trie)(typeof WeakMap === "function");
    return function() {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $23faf33faff0276f$export$cd3144f8dd136006 = $23faf33faff0276f$var$makeDefaultMakeCacheKeyFunction();
var $23faf33faff0276f$var$caches = new Set();
function $23faf33faff0276f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $23faf33faff0276f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey || $23faf33faff0276f$var$makeDefaultMakeCacheKeyFunction();
    var optimistic = function() {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new $23faf33faff0276f$var$Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $23faf33faff0276f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$23faf33faff0276f$var$parentEntrySlot.hasValue()) {
            $23faf33faff0276f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $23faf33faff0276f$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function() {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

});
parcelRegister("gztQO", function(module, exports) {

$parcel$export(module.exports, "Trie", () => $c10711f4d68c92c0$export$73571c50d0f2507e);
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var $c10711f4d68c92c0$var$defaultMakeData = function() {
    return Object.create(null);
};
// Useful for processing arguments objects as well as arrays.
var $c10711f4d68c92c0$var$_a = Array.prototype, $c10711f4d68c92c0$var$forEach = $c10711f4d68c92c0$var$_a.forEach, $c10711f4d68c92c0$var$slice = $c10711f4d68c92c0$var$_a.slice;
var $c10711f4d68c92c0$export$73571c50d0f2507e = /** @class */ function() {
    function Trie(weakness, makeData) {
        if (weakness === void 0) weakness = true;
        if (makeData === void 0) makeData = $c10711f4d68c92c0$var$defaultMakeData;
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function(array) {
        var node = this;
        $c10711f4d68c92c0$var$forEach.call(array, function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = this.makeData($c10711f4d68c92c0$var$slice.call(array)));
    };
    Trie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c10711f4d68c92c0$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}();
function $c10711f4d68c92c0$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

});

parcelRegister("35rPQ", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $23f76e397f7600d7$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $23f76e397f7600d7$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $23f76e397f7600d7$var$MISSING_VALUE = {};
var $23f76e397f7600d7$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $23f76e397f7600d7$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $23f76e397f7600d7$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $23f76e397f7600d7$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $23f76e397f7600d7$var$MISSING_VALUE) break;
                if (context_1 !== $23f76e397f7600d7$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $23f76e397f7600d7$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($23f76e397f7600d7$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $23f76e397f7600d7$var$currentContext.slots[this.id] = $23f76e397f7600d7$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $23f76e397f7600d7$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $23f76e397f7600d7$var$currentContext;
            $23f76e397f7600d7$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $23f76e397f7600d7$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $23f76e397f7600d7$var$currentContext;
            return function() {
                var saved = $23f76e397f7600d7$var$currentContext;
                try {
                    $23f76e397f7600d7$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $23f76e397f7600d7$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($23f76e397f7600d7$var$currentContext) {
                var saved = $23f76e397f7600d7$var$currentContext;
                try {
                    $23f76e397f7600d7$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $23f76e397f7600d7$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
function $23f76e397f7600d7$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
var $23f76e397f7600d7$var$globalKey = "@wry/context:Slot";
var $23f76e397f7600d7$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$23f76e397f7600d7$var$maybe(function() {
    return globalThis;
}) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$23f76e397f7600d7$var$maybe(function() {
    return $parcel$global;
}) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
var $23f76e397f7600d7$var$globalHost = $23f76e397f7600d7$var$host;
var $23f76e397f7600d7$export$8c6ed5c666ac1360 = $23f76e397f7600d7$var$globalHost[$23f76e397f7600d7$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$23f76e397f7600d7$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($23f76e397f7600d7$var$globalHost, $23f76e397f7600d7$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($23f76e397f7600d7$var$makeSlotClass());
var $23f76e397f7600d7$export$2385a24977818dd0 = $23f76e397f7600d7$export$8c6ed5c666ac1360.bind, $23f76e397f7600d7$export$9fa6f2e300a97f8 = $23f76e397f7600d7$export$8c6ed5c666ac1360.noContext;
function $23f76e397f7600d7$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($23f76e397f7600d7$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $23f76e397f7600d7$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $23f76e397f7600d7$export$2385a24977818dd0(gen.next);
        var boundThrow = $23f76e397f7600d7$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($23f76e397f7600d7$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $23f76e397f7600d7$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $23f76e397f7600d7$var$wrappedFibers = [];
function $23f76e397f7600d7$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($23f76e397f7600d7$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $23f76e397f7600d7$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $23f76e397f7600d7$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});


parcelRegister("6EJag", function(module, exports) {

$parcel$export(module.exports, "equal", () => $4d89833f17ff6636$export$2e2bcd8739ae039);
var $4d89833f17ff6636$var$_a = Object.prototype, $4d89833f17ff6636$var$toString = $4d89833f17ff6636$var$_a.toString, $4d89833f17ff6636$var$hasOwnProperty = $4d89833f17ff6636$var$_a.hasOwnProperty;
var $4d89833f17ff6636$var$fnToStr = Function.prototype.toString;
var $4d89833f17ff6636$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $4d89833f17ff6636$export$2e2bcd8739ae039(a, b) {
    try {
        return $4d89833f17ff6636$var$check(a, b);
    } finally{
        $4d89833f17ff6636$var$previousComparisons.clear();
    }
}
function $4d89833f17ff6636$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $4d89833f17ff6636$var$toString.call(a);
    var bTag = $4d89833f17ff6636$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($4d89833f17ff6636$var$previouslyCompared(a, b)) return true;
            var aKeys = $4d89833f17ff6636$var$definedKeys(a);
            var bKeys = $4d89833f17ff6636$var$definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$4d89833f17ff6636$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$4d89833f17ff6636$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "".concat(b);
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($4d89833f17ff6636$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$4d89833f17ff6636$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            var len = a.byteLength;
            if (len === b.byteLength) {
                while(len-- && a[len] === b[len]);
            }
            return len === -1;
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            var aCode = $4d89833f17ff6636$var$fnToStr.call(a);
            if (aCode !== $4d89833f17ff6636$var$fnToStr.call(b)) return false;
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !$4d89833f17ff6636$var$endsWith(aCode, $4d89833f17ff6636$var$nativeCodeSuffix);
    }
    // Otherwise the values are not equal.
    return false;
}
function $4d89833f17ff6636$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($4d89833f17ff6636$var$isDefinedKey, obj);
}
function $4d89833f17ff6636$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
var $4d89833f17ff6636$var$nativeCodeSuffix = "{ [native code] }";
function $4d89833f17ff6636$var$endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $4d89833f17ff6636$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $4d89833f17ff6636$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $4d89833f17ff6636$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}

});

parcelRegister("8YAgr", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $68900ea69e0ac51b$export$5fc74f25506aa9c);

var $deWeK = parcelRequire("deWeK");

var $35wna = parcelRequire("35wna");

var $chK20 = parcelRequire("chK20");
var $68900ea69e0ac51b$export$5fc74f25506aa9c = function() {
    function ApolloCache() {
        this.getFragmentDoc = (0, $35wna.wrap)((0, $chK20.getFragmentQueryDocument));
    }
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            rootId: options.id || 'ROOT_QUERY',
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $deWeK.__rest)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $deWeK.__rest)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();

});
parcelRegister("chK20", function(module, exports) {

$parcel$export(module.exports, "getFragmentQueryDocument", () => $8f1ac7730560f735$export$abbf37c7cf644e41);
$parcel$export(module.exports, "createFragmentMap", () => $8f1ac7730560f735$export$193789b4c8246dd4);
$parcel$export(module.exports, "getFragmentFromSelection", () => $8f1ac7730560f735$export$f80bdb85f299186);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");
function $8f1ac7730560f735$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw __DEV__ ? new (0, $64dys.InvariantError)("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") + 'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new (0, $64dys.InvariantError)(44);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0, $64dys.invariant)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0, $64dys.invariant)(fragments.length === 1, 45);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, document), {
        definitions: (0, $deWeK.__spreadArray)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $8f1ac7730560f735$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $8f1ac7730560f735$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread':
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0, $64dys.invariant)(fragment, "No fragment named ".concat(fragmentName)) : (0, $64dys.invariant)(fragment, 46);
            return fragment || null;
        default:
            return null;
    }
}

});


parcelRegister("dGJSl", function(module, exports) {

$parcel$export(module.exports, "MissingFieldError", () => $9f72c882b1eae338$export$257c68286583b0f9);

var $deWeK = parcelRequire("deWeK");
var $9f72c882b1eae338$export$257c68286583b0f9 = function(_super) {
    (0, $deWeK.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);

});

parcelRegister("ctUe3", function(module, exports) {

$parcel$export(module.exports, "addTypenameToDocument", () => $9163ceb180ad1a1e$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $9163ceb180ad1a1e$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $9163ceb180ad1a1e$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $9163ceb180ad1a1e$export$8eae69e876ee321e);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $9bJMq = parcelRequire("9bJMq");
var $4IPRa = parcelRequire("4IPRa");

var $8HL2O = parcelRequire("8HL2O");

var $7QVo3 = parcelRequire("7QVo3");

var $chK20 = parcelRequire("chK20");

var $8svBE = parcelRequire("8svBE");
var $9163ceb180ad1a1e$var$TYPENAME_FIELD = {
    kind: (0, $9bJMq.Kind).FIELD,
    name: {
        kind: (0, $9bJMq.Kind).NAME,
        value: '__typename'
    }
};
function $9163ceb180ad1a1e$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $9bJMq.Kind).FRAGMENT_SPREAD && $9163ceb180ad1a1e$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $9163ceb180ad1a1e$var$nullIfDocIsEmpty(doc) {
    return $9163ceb180ad1a1e$var$isEmpty((0, $8HL2O.getOperationDefinition)(doc) || (0, $8HL2O.getFragmentDefinition)(doc), (0, $chK20.createFragmentMap)((0, $8HL2O.getFragmentDefinitions)(doc))) ? null : doc;
}
function $9163ceb180ad1a1e$var$getDirectiveMatcher(directives) {
    var nameSet = new Set();
    var tests = [];
    directives.forEach(function(directive) {
        if (directive.name) nameSet.add(directive.name);
        else if (directive.test) tests.push(directive.test);
    });
    return function(directive) {
        return nameSet.has(directive.name.value) || tests.some(function(test) {
            return test(directive);
        });
    };
}
function $9163ceb180ad1a1e$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            variables: new Set,
            fragmentSpreads: new Set
        });
        return inUse;
    };
}
function $9163ceb180ad1a1e$export$e5ae0530da5fe96c(directives, doc) {
    var getInUseByOperationName = $9163ceb180ad1a1e$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $9163ceb180ad1a1e$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $8svBE.isArray)(ancestor)) continue;
            if (ancestor.kind === (0, $9bJMq.Kind).OPERATION_DEFINITION) return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $9bJMq.Kind).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        __DEV__ && (0, $64dys.invariant).error("Could not find operation or fragment");
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $9bJMq.Kind).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $9163ceb180ad1a1e$var$getDirectiveMatcher(directives);
    var hasRemoveDirective = directives.some(function(directive) {
        return directive.remove;
    });
    var shouldRemoveField = function(nodeDirectives) {
        return hasRemoveDirective && nodeDirectives && nodeDirectives.some(directiveMatcher);
    };
    var originalFragmentDefsByPath = new Map();
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $4IPRa.visit)(doc, {
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) return node;
                if (operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $9bJMq.Kind).FIELD && selection.name.value === '__typename';
                })) {
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) return doc;
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $9bJMq.Kind).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $9bJMq.Kind).FRAGMENT_DEFINITION && operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    allFragmentNamesUsed.forEach(function(fragmentName) {
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!(!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $9163ceb180ad1a1e$var$nullIfDocIsEmpty((0, $4IPRa.visit)(docWithoutDirectiveSubtrees, {
        FragmentSpread: enterVisitor,
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $9163ceb180ad1a1e$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $4IPRa.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === (0, $9bJMq.Kind).OPERATION_DEFINITION) return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return (0, $7QVo3.isField)(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ((0, $7QVo3.isField)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, node), {
                    selections: (0, $deWeK.__spreadArray)((0, $deWeK.__spreadArray)([], selections, true), [
                        $9163ceb180ad1a1e$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $9163ceb180ad1a1e$var$TYPENAME_FIELD;
    }
});
var $9163ceb180ad1a1e$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === 'key';
            })) __DEV__ && (0, $64dys.invariant).warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key.");
        }
        return willRemove;
    }
};
function $9163ceb180ad1a1e$export$74985f3324559867(doc) {
    return $9163ceb180ad1a1e$export$e5ae0530da5fe96c([
        $9163ceb180ad1a1e$var$connectionRemoveConfig
    ], (0, $8HL2O.checkDocument)(doc));
}
function $9163ceb180ad1a1e$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $9163ceb180ad1a1e$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $9163ceb180ad1a1e$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $7QVo3.isField)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($9163ceb180ad1a1e$var$getDirectiveMatcher(directives)) || nestedCheck && $9163ceb180ad1a1e$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $9163ceb180ad1a1e$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $9bJMq.Kind).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $9163ceb180ad1a1e$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $9163ceb180ad1a1e$var$getArgumentMatcher(config);
    return $9163ceb180ad1a1e$var$nullIfDocIsEmpty((0, $4IPRa.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $9163ceb180ad1a1e$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $9163ceb180ad1a1e$var$nullIfDocIsEmpty((0, $4IPRa.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $9163ceb180ad1a1e$export$57c368c23873f32b(document) {
    var definition = (0, $8HL2O.getMainDefinition)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $4IPRa.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $9163ceb180ad1a1e$export$8eae69e876ee321e(document) {
    (0, $8HL2O.checkDocument)(document);
    var modifiedDoc = $9163ceb180ad1a1e$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}

});
parcelRegister("9bJMq", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $38ade8a273bf3f12$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $38ade8a273bf3f12$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("4IPRa", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $5df02f8ea9cb2bf5$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $5df02f8ea9cb2bf5$export$bf638b60ea8b89b7);

var $eXwVb = parcelRequire("eXwVb");
var $5df02f8ea9cb2bf5$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $5df02f8ea9cb2bf5$export$a89c95c098ac2a58 = Object.freeze({});
function $5df02f8ea9cb2bf5$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $5df02f8ea9cb2bf5$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!$5df02f8ea9cb2bf5$var$isNode(node)) throw new Error('Invalid AST Node: ' + (0, $eXwVb.default)(node));
            var visitFn = $5df02f8ea9cb2bf5$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $5df02f8ea9cb2bf5$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ($5df02f8ea9cb2bf5$var$isNode(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $5df02f8ea9cb2bf5$var$isNode(maybeNode) {
    return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
function $5df02f8ea9cb2bf5$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (!skipping[i]) {
                var fn = $5df02f8ea9cb2bf5$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $5df02f8ea9cb2bf5$export$a89c95c098ac2a58) skipping[i] = $5df02f8ea9cb2bf5$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (!skipping[i]) {
                    var fn = $5df02f8ea9cb2bf5$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $5df02f8ea9cb2bf5$export$a89c95c098ac2a58) skipping[i] = $5df02f8ea9cb2bf5$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $5df02f8ea9cb2bf5$export$18ca434620348336(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = $5df02f8ea9cb2bf5$export$c9c25cca74db6e70(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ($5df02f8ea9cb2bf5$var$isNode(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = $5df02f8ea9cb2bf5$export$c9c25cca74db6e70(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}
function $5df02f8ea9cb2bf5$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("eXwVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0b32be3926390e$export$2e2bcd8739ae039);

var $hmmvT = parcelRequire("hmmvT");
function $ba0b32be3926390e$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ba0b32be3926390e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ba0b32be3926390e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ba0b32be3926390e$var$_typeof(obj);
}
var $ba0b32be3926390e$var$MAX_ARRAY_LENGTH = 10;
var $ba0b32be3926390e$var$MAX_RECURSIVE_DEPTH = 2;
function $ba0b32be3926390e$export$2e2bcd8739ae039(value) {
    return $ba0b32be3926390e$var$formatValue(value, []);
}
function $ba0b32be3926390e$var$formatValue(value, seenValues) {
    switch($ba0b32be3926390e$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $ba0b32be3926390e$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $ba0b32be3926390e$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $ba0b32be3926390e$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        // $FlowFixMe(>=0.90.0)
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $ba0b32be3926390e$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $ba0b32be3926390e$var$formatArray(value, seenValues);
    return $ba0b32be3926390e$var$formatObject(value, seenValues);
}
function $ba0b32be3926390e$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $ba0b32be3926390e$var$MAX_RECURSIVE_DEPTH) return '[' + $ba0b32be3926390e$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $ba0b32be3926390e$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $ba0b32be3926390e$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $ba0b32be3926390e$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($ba0b32be3926390e$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($ba0b32be3926390e$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $ba0b32be3926390e$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $hmmvT.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $ba0b32be3926390e$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("hmmvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dc77ea7e1abc355$export$2e2bcd8739ae039);
var $8dc77ea7e1abc355$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $8dc77ea7e1abc355$export$2e2bcd8739ae039 = $8dc77ea7e1abc355$var$nodejsCustomInspectSymbol;

});



parcelRegister("8HL2O", function(module, exports) {

$parcel$export(module.exports, "checkDocument", () => $6566d4e98b478add$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $6566d4e98b478add$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $6566d4e98b478add$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $6566d4e98b478add$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $6566d4e98b478add$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getFragmentDefinition", () => $6566d4e98b478add$export$772111caef41b3f5);
$parcel$export(module.exports, "getMainDefinition", () => $6566d4e98b478add$export$f431198736b7f96d);
$parcel$export(module.exports, "getDefaultValues", () => $6566d4e98b478add$export$84c19026e616569e);
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $7QVo3 = parcelRequire("7QVo3");
function $6566d4e98b478add$export$a7d0d8111d2386df(doc) {
    __DEV__ ? (0, $64dys.invariant)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0, $64dys.invariant)(doc && doc.kind === 'Document', 47);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw __DEV__ ? new (0, $64dys.InvariantError)("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new (0, $64dys.InvariantError)(48);
        return definition;
    });
    __DEV__ ? (0, $64dys.invariant)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0, $64dys.invariant)(operations.length <= 1, 49);
    return doc;
}
function $6566d4e98b478add$export$7a5b1fa979d2c158(doc) {
    $6566d4e98b478add$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $6566d4e98b478add$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $6566d4e98b478add$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $6566d4e98b478add$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $6566d4e98b478add$export$7a5b1fa979d2c158(doc);
    __DEV__ ? (0, $64dys.invariant)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0, $64dys.invariant)(queryDef && queryDef.operation === 'query', 50);
    return queryDef;
}
function $6566d4e98b478add$export$772111caef41b3f5(doc) {
    __DEV__ ? (0, $64dys.invariant)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0, $64dys.invariant)(doc.kind === 'Document', 51);
    __DEV__ ? (0, $64dys.invariant)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0, $64dys.invariant)(doc.definitions.length <= 1, 52);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0, $64dys.invariant)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0, $64dys.invariant)(fragmentDef.kind === 'FragmentDefinition', 53);
    return fragmentDef;
}
function $6566d4e98b478add$export$f431198736b7f96d(queryDoc) {
    $6566d4e98b478add$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw __DEV__ ? new (0, $64dys.InvariantError)('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new (0, $64dys.InvariantError)(54);
}
function $6566d4e98b478add$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $7QVo3.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

});
parcelRegister("7QVo3", function(module, exports) {

$parcel$export(module.exports, "makeReference", () => $5b79e797bd0d4923$export$634ae0e932e9be99);
$parcel$export(module.exports, "isReference", () => $5b79e797bd0d4923$export$fa99cac1c0883c47);
$parcel$export(module.exports, "isDocumentNode", () => $5b79e797bd0d4923$export$540432d49fcec6c9);
$parcel$export(module.exports, "valueToObjectRepresentation", () => $5b79e797bd0d4923$export$a1dab82d368d6525);
$parcel$export(module.exports, "storeKeyNameFromField", () => $5b79e797bd0d4923$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $5b79e797bd0d4923$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $5b79e797bd0d4923$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $5b79e797bd0d4923$export$7d1ad22471852218);
$parcel$export(module.exports, "getTypenameFromResult", () => $5b79e797bd0d4923$export$cf7bf7e4f289cc26);
$parcel$export(module.exports, "isField", () => $5b79e797bd0d4923$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $5b79e797bd0d4923$export$22a1cdafaf27bcff);
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $4iLy6 = parcelRequire("4iLy6");

var $chK20 = parcelRequire("chK20");
function $5b79e797bd0d4923$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $5b79e797bd0d4923$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function $5b79e797bd0d4923$export$540432d49fcec6c9(value) {
    return (0, $4iLy6.isNonNullObject)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $5b79e797bd0d4923$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $5b79e797bd0d4923$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $5b79e797bd0d4923$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $5b79e797bd0d4923$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $5b79e797bd0d4923$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $5b79e797bd0d4923$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $5b79e797bd0d4923$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $5b79e797bd0d4923$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $5b79e797bd0d4923$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $5b79e797bd0d4923$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($5b79e797bd0d4923$var$isIntValue(value) || $5b79e797bd0d4923$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($5b79e797bd0d4923$var$isBooleanValue(value) || $5b79e797bd0d4923$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($5b79e797bd0d4923$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $5b79e797bd0d4923$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($5b79e797bd0d4923$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($5b79e797bd0d4923$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $5b79e797bd0d4923$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($5b79e797bd0d4923$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($5b79e797bd0d4923$var$isNullValue(value)) argObj[name.value] = null;
    else throw __DEV__ ? new (0, $64dys.InvariantError)("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") + 'is not supported. Use variables instead of inline arguments to ' + 'overcome this limitation.') : new (0, $64dys.InvariantError)(55);
}
function $5b79e797bd0d4923$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $5b79e797bd0d4923$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $5b79e797bd0d4923$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $5b79e797bd0d4923$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $5b79e797bd0d4923$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
var $5b79e797bd0d4923$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat($5b79e797bd0d4923$var$stringify(filteredArgs_1), ")");
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = $5b79e797bd0d4923$var$stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($5b79e797bd0d4923$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($5b79e797bd0d4923$var$stringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $5b79e797bd0d4923$var$stringify;
        $5b79e797bd0d4923$var$stringify = s;
        return previous;
    }
});
var $5b79e797bd0d4923$var$stringify = function defaultStringify(value) {
    return JSON.stringify(value, $5b79e797bd0d4923$var$stringifyReplacer);
};
function $5b79e797bd0d4923$var$stringifyReplacer(_key, value) {
    if ((0, $4iLy6.isNonNullObject)(value) && !Array.isArray(value)) value = Object.keys(value).sort().reduce(function(copy, key) {
        copy[key] = value[key];
        return copy;
    }, {});
    return value;
}
function $5b79e797bd0d4923$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $5b79e797bd0d4923$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $5b79e797bd0d4923$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $5b79e797bd0d4923$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') return result.__typename;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($5b79e797bd0d4923$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === '__typename') return result[$5b79e797bd0d4923$export$7d1ad22471852218(selection)];
        } else {
            var typename = $5b79e797bd0d4923$export$cf7bf7e4f289cc26(result, (0, $chK20.getFragmentFromSelection)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') return typename;
        }
    }
}
function $5b79e797bd0d4923$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $5b79e797bd0d4923$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}

});
parcelRegister("4iLy6", function(module, exports) {

$parcel$export(module.exports, "isNonNullObject", () => $321dba1cb3bbe036$export$417207af72fad9c9);
function $321dba1cb3bbe036$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === 'object';
}

});



parcelRegister("8svBE", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $628974970d56ae72$export$43bee75e5e14138e);
$parcel$export(module.exports, "isNonEmptyArray", () => $628974970d56ae72$export$d307f5934e447d0e);
var $628974970d56ae72$export$43bee75e5e14138e = Array.isArray;
function $628974970d56ae72$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});


parcelRegister("5pFjR", function(module, exports) {

$parcel$export(module.exports, "StoreReader", () => $0104605db482d719$export$628ef07ba8965f12);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $9bJMq = parcelRequire("9bJMq");

var $35wna = parcelRequire("35wna");

var $ctUe3 = parcelRequire("ctUe3");
var $8uSJ8 = parcelRequire("8uSJ8");
var $dnkFk = parcelRequire("dnkFk");
var $lVr1f = parcelRequire("lVr1f");
var $8HL2O = parcelRequire("8HL2O");
var $chK20 = parcelRequire("chK20");
var $7QVo3 = parcelRequire("7QVo3");
var $4iLy6 = parcelRequire("4iLy6");
var $fZycb = parcelRequire("fZycb");
var $4f7Lj = parcelRequire("4f7Lj");

var $6r8HE = parcelRequire("6r8HE");

var $fQFHs = parcelRequire("fQFHs");
var $8svBE = parcelRequire("8svBE");

var $dGJSl = parcelRequire("dGJSl");

var $4e05c = parcelRequire("4e05c");
function $0104605db482d719$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults
    ];
}
var $0104605db482d719$export$628ef07ba8965f12 = function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $8uSJ8.canUseWeakMap) ? WeakMap : Map)();
        this.config = (0, $dnkFk.compact)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $fQFHs.shouldCanonizeResults)(config)
        });
        this.canon = config.canon || new (0, $4e05c.ObjectCanon);
        this.executeSelectionSet = (0, $35wna.wrap)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $0104605db482d719$var$execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, other), {
                    result: _this.canon.admit(other.result)
                });
                return other;
            }
            (0, $6r8HE.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: $0104605db482d719$var$execSelectionSetKeyArgs,
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $6r8HE.supportsResultCaching)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $7QVo3.isReference)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $35wna.wrap)(function(options) {
            (0, $6r8HE.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $6r8HE.supportsResultCaching)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $4e05c.ObjectCanon);
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, (0, $8HL2O.getDefaultValues)((0, $8HL2O.getQueryDefinition)(query))), variables);
        var rootRef = (0, $7QVo3.makeReference)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $8HL2O.getMainDefinition)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $deWeK.__assign)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $4e05c.canonicalStringify)(variables),
                canonizeResults: canonizeResults
            }, (0, $fQFHs.extractFragmentContext)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            missing = [
                new (0, $dGJSl.MissingFieldError)($0104605db482d719$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $6r8HE.supportsResultCaching)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $7QVo3.isReference)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $lVr1f.DeepMerger)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            if (!(0, $4f7Lj.shouldInclude)(selection, variables)) return;
            if ((0, $7QVo3.isField)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $7QVo3.resultKeyNameFromField)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $ctUe3.addTypenameToDocument).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $7QVo3.isReference)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $8svBE.isArray)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $7QVo3.isReference)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $chK20.getFragmentFromSelection)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $9bJMq.Kind).FRAGMENT_SPREAD) throw __DEV__ ? new (0, $64dys.InvariantError)("No fragment named ".concat(selection.name.value)) : new (0, $64dys.InvariantError)(5);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $lVr1f.mergeDeepArray)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $fZycb.maybeDeepFreeze)(finalResult);
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $lVr1f.DeepMerger)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            if (item === null) return null;
            if ((0, $8svBE.isArray)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $7QVo3.isReference)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (__DEV__) $0104605db482d719$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $0104605db482d719$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $0104605db482d719$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $4iLy6.isNonNullObject)(value)) {
                __DEV__ ? (0, $64dys.invariant)(!(0, $7QVo3.isReference)(value), "Missing selection set for object of type ".concat((0, $fQFHs.getTypenameFromStoreObject)(store, value), " returned for query field ").concat(field.name.value)) : (0, $64dys.invariant)(!(0, $7QVo3.isReference)(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

});
parcelRegister("8uSJ8", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", () => $62fb93aff1aed7bd$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "canUseWeakSet", () => $62fb93aff1aed7bd$export$7293b8a0b474028d);
$parcel$export(module.exports, "canUseSymbol", () => $62fb93aff1aed7bd$export$23ba675b4b838b92);
$parcel$export(module.exports, "canUseAsyncIteratorSymbol", () => $62fb93aff1aed7bd$export$c34f882e9f1c1637);
parcelRequire("6TVLx");
var $58Wpk = parcelRequire("58Wpk");
var $62fb93aff1aed7bd$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && (0, $58Wpk.maybe)(function() {
    return navigator.product;
}) !== 'ReactNative';
var $62fb93aff1aed7bd$export$7293b8a0b474028d = typeof WeakSet === 'function';
var $62fb93aff1aed7bd$export$23ba675b4b838b92 = typeof Symbol === 'function' && typeof Symbol.for === 'function';
var $62fb93aff1aed7bd$export$c34f882e9f1c1637 = $62fb93aff1aed7bd$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $62fb93aff1aed7bd$export$71594e8a50f746f4 = typeof (0, $58Wpk.maybe)(function() {
    return window.document.createElement;
}) === "function";
var $62fb93aff1aed7bd$var$usingJSDOM = (0, $58Wpk.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $62fb93aff1aed7bd$export$4001f6cd4a62405b = $62fb93aff1aed7bd$export$71594e8a50f746f4 && !$62fb93aff1aed7bd$var$usingJSDOM;

});

parcelRegister("dnkFk", function(module, exports) {

$parcel$export(module.exports, "compact", () => $9bcd7419467ba68a$export$8e16b83750b44988);
function $9bcd7419467ba68a$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});

parcelRegister("lVr1f", function(module, exports) {

$parcel$export(module.exports, "mergeDeep", () => $ff63e142da001871$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $ff63e142da001871$export$160070228be94b08);
$parcel$export(module.exports, "DeepMerger", () => $ff63e142da001871$export$509e11c221f576c0);

var $deWeK = parcelRequire("deWeK");

var $4iLy6 = parcelRequire("4iLy6");
var $ff63e142da001871$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ff63e142da001871$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $ff63e142da001871$export$160070228be94b08(sources);
}
function $ff63e142da001871$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $ff63e142da001871$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $ff63e142da001871$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $ff63e142da001871$export$509e11c221f576c0 = function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $ff63e142da001871$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $4iLy6.isNonNullObject);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $4iLy6.isNonNullObject)(source) && (0, $4iLy6.isNonNullObject)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($ff63e142da001871$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $deWeK.__spreadArray)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $4iLy6.isNonNullObject)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $deWeK.__assign)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();

});

parcelRegister("fZycb", function(module, exports) {

$parcel$export(module.exports, "maybeDeepFreeze", () => $ba4714066b87844d$export$7f9c177735b71f18);
parcelRequire("6TVLx");

var $4iLy6 = parcelRequire("4iLy6");
function $ba4714066b87844d$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $4iLy6.isNonNullObject)(obj) && $ba4714066b87844d$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $4iLy6.isNonNullObject)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $ba4714066b87844d$var$shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $ba4714066b87844d$export$7f9c177735b71f18(obj) {
    if (__DEV__) $ba4714066b87844d$var$deepFreeze(obj);
    return obj;
}

});

parcelRegister("4f7Lj", function(module, exports) {

$parcel$export(module.exports, "shouldInclude", () => $316e958ac60df147$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $316e958ac60df147$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $316e958ac60df147$export$8d1e9e5bbfa5d09a);
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $4IPRa = parcelRequire("4IPRa");
function $316e958ac60df147$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $316e958ac60df147$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0, $64dys.invariant)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0, $64dys.invariant)(evaledValue !== void 0, 40);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $316e958ac60df147$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $4IPRa.visit)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $316e958ac60df147$export$528b5e7d8ba07fbf = function(names, root) {
    return $316e958ac60df147$export$2dafb573e282fe8d(names, root, false);
};
var $316e958ac60df147$export$ad1b63b26c1a9b76 = function(names, root) {
    return $316e958ac60df147$export$2dafb573e282fe8d(names, root, true);
};
function $316e958ac60df147$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $4IPRa.visit)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $4IPRa.BREAK;
        }
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $316e958ac60df147$export$8d1e9e5bbfa5d09a(document) {
    return document && $316e958ac60df147$export$2dafb573e282fe8d([
        'client',
        'export'
    ], document, true);
}
function $316e958ac60df147$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $316e958ac60df147$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$316e958ac60df147$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        __DEV__ ? (0, $64dys.invariant)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0, $64dys.invariant)(directiveArguments && directiveArguments.length === 1, 41);
        var ifArgument = directiveArguments[0];
        __DEV__ ? (0, $64dys.invariant)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0, $64dys.invariant)(ifArgument.name && ifArgument.name.value === 'if', 42);
        var ifValue = ifArgument.value;
        __DEV__ ? (0, $64dys.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0, $64dys.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 43);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}

});

parcelRegister("6r8HE", function(module, exports) {

$parcel$export(module.exports, "EntityStore", () => $4afc03eaf4017690$export$cb507f57054c7321);
$parcel$export(module.exports, "maybeDependOnExistenceOfEntity", () => $4afc03eaf4017690$export$f8068a30967ddc18);
$parcel$export(module.exports, "supportsResultCaching", () => $4afc03eaf4017690$export$488c0743feab3d61);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $35wna = parcelRequire("35wna");

var $6EJag = parcelRequire("6EJag");

var $gztQO = parcelRequire("gztQO");

var $8uSJ8 = parcelRequire("8uSJ8");
var $lVr1f = parcelRequire("lVr1f");
var $4iLy6 = parcelRequire("4iLy6");
var $7QVo3 = parcelRequire("7QVo3");
var $fZycb = parcelRequire("fZycb");

var $fQFHs = parcelRequire("fQFHs");
var $4afc03eaf4017690$var$DELETE = Object.create(null);
var $4afc03eaf4017690$var$delModifier = function() {
    return $4afc03eaf4017690$var$DELETE;
};
var $4afc03eaf4017690$var$INVALIDATE = Object.create(null);
var $4afc03eaf4017690$export$cb507f57054c7321 = function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $fZycb.maybeDeepFreeze)((0, $7QVo3.isReference)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        this.canRead = function(objOrRef) {
            return (0, $7QVo3.isReference)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $7QVo3.makeReference)(objOrIdOrRef);
            if ((0, $7QVo3.isReference)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $7QVo3.makeReference)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function() {
        return (0, $deWeK.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $fQFHs.hasOwn).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $fQFHs.hasOwn).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $fQFHs.hasOwn).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $4afc03eaf4017690$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $fQFHs.hasOwn).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $4afc03eaf4017690$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        if ((0, $7QVo3.isReference)(older)) older = older.__ref;
        if ((0, $7QVo3.isReference)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        if (!incoming) return;
        __DEV__ ? (0, $64dys.invariant)(typeof dataId === "string", "store.merge expects a string ID") : (0, $64dys.invariant)(typeof dataId === "string", 1);
        var merged = new (0, $lVr1f.DeepMerger)($4afc03eaf4017690$var$storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing) fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0, $fQFHs.fieldNameFromStoreName)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $4afc03eaf4017690$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $4afc03eaf4017690$var$DELETE,
                INVALIDATE: $4afc03eaf4017690$var$INVALIDATE,
                isReference: (0, $7QVo3.isReference),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $7QVo3.makeReference)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $fQFHs.fieldNameFromStoreName)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $4afc03eaf4017690$var$delModifier ? $4afc03eaf4017690$var$DELETE : modify((0, $fZycb.maybeDeepFreeze)(fieldValue), (0, $deWeK.__assign)((0, $deWeK.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $4afc03eaf4017690$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $4afc03eaf4017690$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $4afc03eaf4017690$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $4afc03eaf4017690$var$delModifier, _a) : $4afc03eaf4017690$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $fQFHs.hasOwn).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $4afc03eaf4017690$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $fQFHs.hasOwn).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $fQFHs.hasOwn).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $deWeK.__rest)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $4afc03eaf4017690$var$Layer) this.parent.getRootIdSet(ids);
        else Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $fQFHs.hasOwn).call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $4afc03eaf4017690$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $fQFHs.hasOwn).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            workSet_1.forEach(function(obj) {
                if ((0, $7QVo3.isReference)(obj)) found_1[obj.__ref] = true;
                if ((0, $4iLy6.isNonNullObject)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    if ((0, $4iLy6.isNonNullObject)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
var $4afc03eaf4017690$var$CacheGroup = function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $35wna.dep)() : null;
        this.keyMaker = new (0, $gztQO.Trie)((0, $8uSJ8.canUseWeakMap));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($4afc03eaf4017690$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $fQFHs.fieldNameFromStoreName)(storeFieldName);
            if (fieldName !== storeFieldName) this.d($4afc03eaf4017690$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($4afc03eaf4017690$var$makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $4afc03eaf4017690$var$makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function $4afc03eaf4017690$export$f8068a30967ddc18(store, entityId) {
    if ($4afc03eaf4017690$export$488c0743feab3d61(store)) store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    var Root = function(_super) {
        (0, $deWeK.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $4afc03eaf4017690$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $4afc03eaf4017690$var$Stump(_this);
            _this.storageTrie = new (0, $gztQO.Trie)((0, $8uSJ8.canUseWeakMap));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($4afc03eaf4017690$export$cb507f57054c7321 || ($4afc03eaf4017690$export$cb507f57054c7321 = {}));
var $4afc03eaf4017690$var$Layer = function(_super) {
    (0, $deWeK.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) _this.delete(dataId);
                else if (!ownStoreObject) {
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $6EJag.equal)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        if (parent === this.parent) return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $fQFHs.hasOwn).call(this.data, dataId) ? (0, $deWeK.__assign)((0, $deWeK.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}($4afc03eaf4017690$export$cb507f57054c7321);
var $4afc03eaf4017690$var$Stump = function(_super) {
    (0, $deWeK.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $4afc03eaf4017690$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        return this;
    };
    Stump.prototype.merge = function() {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}($4afc03eaf4017690$var$Layer);
function $4afc03eaf4017690$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0, $6EJag.equal)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $4afc03eaf4017690$export$488c0743feab3d61(store) {
    return !!(store instanceof $4afc03eaf4017690$export$cb507f57054c7321 && store.group.caching);
}

});
parcelRegister("fQFHs", function(module, exports) {

$parcel$export(module.exports, "hasOwn", () => $b89c0f0e6c47de4b$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $b89c0f0e6c47de4b$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "normalizeConfig", () => $b89c0f0e6c47de4b$export$fa542f9ee3f7f4e2);
$parcel$export(module.exports, "shouldCanonizeResults", () => $b89c0f0e6c47de4b$export$3ac2a95fbd99c479);
$parcel$export(module.exports, "getTypenameFromStoreObject", () => $b89c0f0e6c47de4b$export$fdef206c83ff2c09);
$parcel$export(module.exports, "TypeOrFieldNameRegExp", () => $b89c0f0e6c47de4b$export$6ed54d4784f1ce28);
$parcel$export(module.exports, "fieldNameFromStoreName", () => $b89c0f0e6c47de4b$export$37874422037b6029);
$parcel$export(module.exports, "selectionSetMatchesResult", () => $b89c0f0e6c47de4b$export$60bd1cbb09c1a4a2);
$parcel$export(module.exports, "storeValueIsStoreObject", () => $b89c0f0e6c47de4b$export$4f39afca21bd938e);
$parcel$export(module.exports, "makeProcessedFieldsMerger", () => $b89c0f0e6c47de4b$export$b874a818f7a2fa6d);
$parcel$export(module.exports, "extractFragmentContext", () => $b89c0f0e6c47de4b$export$3a33c00f0ae4a480);
$parcel$export(module.exports, "isArray", () => (parcelRequire("8svBE")).isArray);

var $dnkFk = parcelRequire("dnkFk");
var $chK20 = parcelRequire("chK20");
var $lVr1f = parcelRequire("lVr1f");
var $8HL2O = parcelRequire("8HL2O");
var $8svBE = parcelRequire("8svBE");
var $7QVo3 = parcelRequire("7QVo3");
var $4iLy6 = parcelRequire("4iLy6");
var $4f7Lj = parcelRequire("4f7Lj");
var $b89c0f0e6c47de4b$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $b89c0f0e6c47de4b$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $b89c0f0e6c47de4b$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$b89c0f0e6c47de4b$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$b89c0f0e6c47de4b$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        if ($b89c0f0e6c47de4b$export$b931b78cbb3caf86(id) && !$b89c0f0e6c47de4b$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$b89c0f0e6c47de4b$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $b89c0f0e6c47de4b$var$defaultConfig = {
    dataIdFromObject: $b89c0f0e6c47de4b$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false
};
function $b89c0f0e6c47de4b$export$fa542f9ee3f7f4e2(config) {
    return (0, $dnkFk.compact)($b89c0f0e6c47de4b$var$defaultConfig, config);
}
function $b89c0f0e6c47de4b$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $b89c0f0e6c47de4b$var$defaultConfig.canonizeResults : value;
}
function $b89c0f0e6c47de4b$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $7QVo3.isReference)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $b89c0f0e6c47de4b$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $b89c0f0e6c47de4b$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($b89c0f0e6c47de4b$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $b89c0f0e6c47de4b$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $4iLy6.isNonNullObject)(result)) return (0, $8svBE.isArray)(result) ? result.every(function(item) {
        return $b89c0f0e6c47de4b$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $7QVo3.isField)(field) && (0, $4f7Lj.shouldInclude)(field, variables)) {
            var key = (0, $7QVo3.resultKeyNameFromField)(field);
            return $b89c0f0e6c47de4b$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $b89c0f0e6c47de4b$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        return true;
    });
    return false;
}
function $b89c0f0e6c47de4b$export$4f39afca21bd938e(value) {
    return (0, $4iLy6.isNonNullObject)(value) && !(0, $7QVo3.isReference)(value) && !(0, $8svBE.isArray)(value);
}
function $b89c0f0e6c47de4b$export$b874a818f7a2fa6d() {
    return new (0, $lVr1f.DeepMerger);
}
function $b89c0f0e6c47de4b$export$3a33c00f0ae4a480(document, fragments) {
    var fragmentMap = (0, $chK20.createFragmentMap)((0, $8HL2O.getFragmentDefinitions)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}

});


parcelRegister("4e05c", function(module, exports) {

$parcel$export(module.exports, "ObjectCanon", () => $313888b5948a7343$export$c2e7fdd82233f4a4);
$parcel$export(module.exports, "canonicalStringify", () => $313888b5948a7343$export$88a0ad9b6f961b51);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");

var $gztQO = parcelRequire("gztQO");

var $8uSJ8 = parcelRequire("8uSJ8");
var $4iLy6 = parcelRequire("4iLy6");
parcelRequire("fQFHs");
var $8svBE = parcelRequire("8svBE");
function $313888b5948a7343$var$shallowCopy(value) {
    if ((0, $4iLy6.isNonNullObject)(value)) return (0, $8svBE.isArray)(value) ? value.slice(0) : (0, $deWeK.__assign)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
var $313888b5948a7343$export$c2e7fdd82233f4a4 = function() {
    function ObjectCanon() {
        this.known = new ((0, $8uSJ8.canUseWeakSet) ? WeakSet : Set)();
        this.pool = new (0, $gztQO.Trie)((0, $8uSJ8.canUseWeakMap));
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $4iLy6.isNonNullObject)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $4iLy6.isNonNullObject)(value)) {
            var copy = $313888b5948a7343$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $4iLy6.isNonNullObject)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();
var $313888b5948a7343$export$88a0ad9b6f961b51 = Object.assign(function(value) {
    if ((0, $4iLy6.isNonNullObject)(value)) {
        if ($313888b5948a7343$var$stringifyCanon === void 0) $313888b5948a7343$var$resetCanonicalStringify();
        var canonical = $313888b5948a7343$var$stringifyCanon.admit(value);
        var json = $313888b5948a7343$var$stringifyCache.get(canonical);
        if (json === void 0) $313888b5948a7343$var$stringifyCache.set(canonical, json = JSON.stringify(canonical));
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: $313888b5948a7343$var$resetCanonicalStringify
});
var $313888b5948a7343$var$stringifyCanon;
var $313888b5948a7343$var$stringifyCache;
function $313888b5948a7343$var$resetCanonicalStringify() {
    $313888b5948a7343$var$stringifyCanon = new $313888b5948a7343$export$c2e7fdd82233f4a4;
    $313888b5948a7343$var$stringifyCache = new ((0, $8uSJ8.canUseWeakMap) ? WeakMap : Map)();
}

});


parcelRegister("3gI6V", function(module, exports) {

$parcel$export(module.exports, "StoreWriter", () => $26151533dce57839$export$eb8361c5d132fb8f);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $6EJag = parcelRequire("6EJag");

var $gztQO = parcelRequire("gztQO");

var $9bJMq = parcelRequire("9bJMq");

var $ctUe3 = parcelRequire("ctUe3");
var $7QVo3 = parcelRequire("7QVo3");
var $bR2gQ = parcelRequire("bR2gQ");
var $8HL2O = parcelRequire("8HL2O");
var $chK20 = parcelRequire("chK20");
var $8svBE = parcelRequire("8svBE");
var $4f7Lj = parcelRequire("4f7Lj");

var $fQFHs = parcelRequire("fQFHs");
var $8svBE = parcelRequire("8svBE");

var $4e05c = parcelRequire("4e05c");

var $gwujw = parcelRequire("gwujw");
function $26151533dce57839$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $deWeK.__assign)((0, $deWeK.__assign)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $26151533dce57839$export$eb8361c5d132fb8f = function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $8HL2O.getOperationDefinition)(query);
        var merger = (0, $fQFHs.makeProcessedFieldsMerger)();
        variables = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, (0, $8HL2O.getDefaultValues)(operationDefinition)), variables);
        var context = (0, $deWeK.__assign)((0, $deWeK.__assign)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $4e05c.canonicalStringify)(variables)
        }, (0, $fQFHs.extractFragmentContext)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map,
            clientOnly: false,
            deferred: false,
            flavors: new Map
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map
            },
            context: context
        });
        if (!(0, $7QVo3.isReference)(ref)) throw __DEV__ ? new (0, $64dys.InvariantError)("Could not identify object ".concat(JSON.stringify(result))) : new (0, $64dys.InvariantError)(7);
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $7QVo3.makeReference)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $7QVo3.isReference)(applied)) return;
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $fQFHs.fieldNameFromStoreName)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $26151533dce57839$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $7QVo3.getTypenameFromResult)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        var readField = function() {
            var options = (0, $gwujw.normalizeReadFieldOptions)(arguments, incoming, context.variables);
            if ((0, $7QVo3.isReference)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $7QVo3.resultKeyNameFromField)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $26151533dce57839$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet ? $26151533dce57839$var$getContextFlavor(context, false, false) : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet && ((0, $7QVo3.isReference)(incomingValue) || (0, $fQFHs.storeValueIsStoreObject)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $26151533dce57839$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (__DEV__ && !context.clientOnly && !context.deferred && !(0, $ctUe3.addTypenameToDocument).added(field) && !policies.getReadFunction(typename, field.name.value)) __DEV__ && (0, $64dys.invariant).error("Missing field '".concat((0, $7QVo3.resultKeyNameFromField)(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) incoming = context.merge(incoming, keyObject);
        } catch (e) {
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $7QVo3.makeReference)(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $26151533dce57839$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                mergeTree: $26151533dce57839$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) return __DEV__ ? (0, $bR2gQ.cloneDeep)(value) : value;
        if ((0, $8svBE.isArray)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $26151533dce57839$var$getChildMergeTree(mergeTree, i));
            $26151533dce57839$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $7QVo3.getTypenameFromResult)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $gztQO.Trie)(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $4f7Lj.shouldInclude)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) && (0, $8svBE.isNonEmptyArray)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $7QVo3.argumentsObjectFromField)(dir, context.variables);
                        if (!args || args.if !== false) deferred = true;
                    }
                });
                if ((0, $7QVo3.isField)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $26151533dce57839$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $chK20.getFragmentFromSelection)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $9bJMq.Kind).FRAGMENT_SPREAD) throw __DEV__ ? new (0, $64dys.InvariantError)("No fragment named ".concat(selection.name.value)) : new (0, $64dys.InvariantError)(8);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $26151533dce57839$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $7QVo3.isReference)(incoming)) {
            var e_1 = !(0, $8svBE.isArray)(incoming) && ((0, $7QVo3.isReference)(existing) || (0, $fQFHs.storeValueIsStoreObject)(existing)) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $7QVo3.isReference)(e_1) ? e_1.__ref : e_1
            ];
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $8svBE.isArray)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $64dys.invariant)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                incoming = (0, $8svBE.isArray)(i_1) ? i_1.slice(0) : (0, $deWeK.__assign)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $26151533dce57839$var$emptyMergeTreePool = [];
function $26151533dce57839$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $26151533dce57839$var$emptyMergeTreePool.pop() || {
        map: new Map
    });
    return map.get(name);
}
function $26151533dce57839$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $26151533dce57839$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $26151533dce57839$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $deWeK.__assign)((0, $deWeK.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $26151533dce57839$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $26151533dce57839$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $26151533dce57839$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $26151533dce57839$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $26151533dce57839$var$mergeTreeIsEmpty(childTree)) {
        $26151533dce57839$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $26151533dce57839$var$warnings = new Set();
function $26151533dce57839$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    if ((0, $7QVo3.isReference)(existing)) return;
    if ((0, $6EJag.equal)(existing, incoming)) return;
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $fQFHs.fieldNameFromStoreName)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if ($26151533dce57839$var$warnings.has(typeDotName)) return;
    $26151533dce57839$var$warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0, $8svBE.isArray)(existing) && !(0, $8svBE.isArray)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    __DEV__ && (0, $64dys.invariant).warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}

});
parcelRegister("bR2gQ", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", () => $8a1667e10af3fa59$export$629a2bd3f5a49ecc);
var $8a1667e10af3fa59$var$toString = Object.prototype.toString;
function $8a1667e10af3fa59$export$629a2bd3f5a49ecc(value) {
    return $8a1667e10af3fa59$var$cloneDeepHelper(value);
}
function $8a1667e10af3fa59$var$cloneDeepHelper(val, seen) {
    switch($8a1667e10af3fa59$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $8a1667e10af3fa59$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $8a1667e10af3fa59$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

});

parcelRegister("gwujw", function(module, exports) {

$parcel$export(module.exports, "Policies", () => $c0772634187d94f7$export$e9859ad90648930b);
$parcel$export(module.exports, "normalizeReadFieldOptions", () => $c0772634187d94f7$export$1ad7a877581bdf2e);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $7QVo3 = parcelRequire("7QVo3");
var $4iLy6 = parcelRequire("4iLy6");
var $k0Fdm = parcelRequire("k0Fdm");

var $fQFHs = parcelRequire("fQFHs");
var $8svBE = parcelRequire("8svBE");

var $aHxuU = parcelRequire("aHxuU");

var $4e05c = parcelRequire("4e05c");

var $781eB = parcelRequire("781eB");
(0, $7QVo3.getStoreKeyName).setStringify((0, $4e05c.canonicalStringify));
function $c0772634187d94f7$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $7QVo3.argumentsObjectFromField)(spec.field, spec.variables) : null;
}
var $c0772634187d94f7$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $c0772634187d94f7$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
var $c0772634187d94f7$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $c0772634187d94f7$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $c0772634187d94f7$export$e9859ad90648930b = function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $deWeK.__assign)({
            dataIdFromObject: (0, $fQFHs.defaultDataIdFromObject)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $c0772634187d94f7$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn(object, context);
            if ((0, $8svBE.isArray)(specifierOrId)) keyFn = (0, $781eB.keyFieldsFnFromSpecifier)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $deWeK.__rest)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $fQFHs.hasOwn).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $c0772634187d94f7$var$mergeTrueFn : merge === false ? $c0772634187d94f7$var$mergeFalseFn : existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn = keyFields === false ? $c0772634187d94f7$var$nullKeyFieldsFn : (0, $8svBE.isArray)(keyFields) ? (0, $781eB.keyFieldsFnFromSpecifier)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = keyArgs === false ? $c0772634187d94f7$var$simpleKeyArgsFn : (0, $8svBE.isArray)(keyArgs) ? (0, $781eB.keyArgsFnFromSpecifier)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) existing.keyFn = existing.keyFn || $c0772634187d94f7$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0, $64dys.invariant)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0, $64dys.invariant)(!old || old === which, 3);
            if (old) delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $fQFHs.TypeOrFieldNameRegExp));
                if (!match || match[0] !== subtype) _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $fQFHs.hasOwn).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) supertypes.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $deWeK.__rest)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) __DEV__ && (0, $64dys.invariant).warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && i === workQueue_1.length - 1 && (0, $fQFHs.selectionSetMatchesResult)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $c0772634187d94f7$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $8svBE.isArray)(specifierOrString)) keyFn = (0, $781eB.keyArgsFnFromSpecifier)(specifierOrString);
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $7QVo3.storeKeyNameFromField)(fieldSpec.field, fieldSpec.variables) : (0, $7QVo3.getStoreKeyName)(fieldName, $c0772634187d94f7$var$argsFromFieldSpecifier(fieldSpec));
        if (storeFieldName === false) return fieldName;
        return fieldName === (0, $fQFHs.fieldNameFromStoreName)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $fQFHs.fieldNameFromStoreName)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $c0772634187d94f7$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $7QVo3.isReference)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            return (0, $aHxuU.cacheSlot).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $c0772634187d94f7$var$mergeTrueFn) return $c0772634187d94f7$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $c0772634187d94f7$var$mergeFalseFn) return incoming;
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $c0772634187d94f7$var$makeFieldFunctionOptions(this, void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $c0772634187d94f7$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $fQFHs.fieldNameFromStoreName)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $c0772634187d94f7$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $7QVo3.isReference),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($c0772634187d94f7$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $c0772634187d94f7$var$makeMergeObjectsFunction(context.store)
    };
}
function $c0772634187d94f7$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $deWeK.__assign)({}, fieldNameOrOptions);
        if (!(0, $fQFHs.hasOwn).call(options, "from")) options.from = objectOrReference;
    }
    if (__DEV__ && options.from === void 0) __DEV__ && (0, $64dys.invariant).warn("Undefined 'from' passed to readField with arguments ".concat((0, $k0Fdm.stringifyForDisplay)(Array.from(readFieldArgs))));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $c0772634187d94f7$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $8svBE.isArray)(existing) || (0, $8svBE.isArray)(incoming)) throw __DEV__ ? new (0, $64dys.InvariantError)("Cannot automatically merge arrays") : new (0, $64dys.InvariantError)(4);
        if ((0, $4iLy6.isNonNullObject)(existing) && (0, $4iLy6.isNonNullObject)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $7QVo3.isReference)(existing) && (0, $fQFHs.storeValueIsStoreObject)(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $fQFHs.storeValueIsStoreObject)(existing) && (0, $7QVo3.isReference)(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $fQFHs.storeValueIsStoreObject)(existing) && (0, $fQFHs.storeValueIsStoreObject)(incoming)) return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, existing), incoming);
        }
        return incoming;
    };
}

});
parcelRegister("k0Fdm", function(module, exports) {

$parcel$export(module.exports, "stringifyForDisplay", () => $e913c7169c0992f5$export$f341b4883239463f);

var $coC0K = parcelRequire("coC0K");
function $e913c7169c0992f5$export$f341b4883239463f(value) {
    var undefId = (0, $coC0K.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}

});
parcelRegister("coC0K", function(module, exports) {

$parcel$export(module.exports, "makeUniqueId", () => $906536258faa07c4$export$d0c8ec0fe1b18b70);
var $906536258faa07c4$var$prefixCounts = new Map();
function $906536258faa07c4$export$d0c8ec0fe1b18b70(prefix) {
    var count = $906536258faa07c4$var$prefixCounts.get(prefix) || 1;
    $906536258faa07c4$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

});


parcelRegister("aHxuU", function(module, exports) {

$parcel$export(module.exports, "cacheSlot", () => $7ca7e76f41a2e236$export$ac9723609f5c76c2);
$parcel$export(module.exports, "forgetCache", () => $7ca7e76f41a2e236$export$cbe12faed7725318);
$parcel$export(module.exports, "recallCache", () => $7ca7e76f41a2e236$export$f342bdd61b3e9412);
$parcel$export(module.exports, "makeVar", () => $7ca7e76f41a2e236$export$5345c8ac69b4a9db);

var $35wna = parcelRequire("35wna");

var $35rPQ = parcelRequire("35rPQ");
var $7ca7e76f41a2e236$export$ac9723609f5c76c2 = new (0, $35rPQ.Slot)();
var $7ca7e76f41a2e236$var$cacheInfoMap = new WeakMap();
function $7ca7e76f41a2e236$var$getCacheInfo(cache) {
    var info = $7ca7e76f41a2e236$var$cacheInfoMap.get(cache);
    if (!info) $7ca7e76f41a2e236$var$cacheInfoMap.set(cache, info = {
        vars: new Set,
        dep: (0, $35wna.dep)()
    });
    return info;
}
function $7ca7e76f41a2e236$export$cbe12faed7725318(cache) {
    $7ca7e76f41a2e236$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $7ca7e76f41a2e236$export$f342bdd61b3e9412(cache) {
    $7ca7e76f41a2e236$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $7ca7e76f41a2e236$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    $7ca7e76f41a2e236$var$getCacheInfo(cache).dep.dirty(rv);
                    $7ca7e76f41a2e236$var$broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            var cache = $7ca7e76f41a2e236$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $7ca7e76f41a2e236$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $7ca7e76f41a2e236$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $7ca7e76f41a2e236$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}

});

parcelRegister("781eB", function(module, exports) {

$parcel$export(module.exports, "keyFieldsFnFromSpecifier", () => $530a3ce8d84c06b1$export$f1953a0407594d2c);
$parcel$export(module.exports, "keyArgsFnFromSpecifier", () => $530a3ce8d84c06b1$export$550737ee0cc371ac);
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $7QVo3 = parcelRequire("7QVo3");
var $lVr1f = parcelRequire("lVr1f");
var $8svBE = parcelRequire("8svBE");
var $4iLy6 = parcelRequire("4iLy6");

var $fQFHs = parcelRequire("fQFHs");
var $8svBE = parcelRequire("8svBE");
var $530a3ce8d84c06b1$var$specifierInfoCache = Object.create(null);
function $530a3ce8d84c06b1$var$lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return $530a3ce8d84c06b1$var$specifierInfoCache[cacheKey] || ($530a3ce8d84c06b1$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $530a3ce8d84c06b1$export$f1953a0407594d2c(specifier) {
    var info = $530a3ce8d84c06b1$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $530a3ce8d84c06b1$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $530a3ce8d84c06b1$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $fQFHs.hasOwn).call(object, schemaKeyPath[0])) extracted = $530a3ce8d84c06b1$export$e8f64f7a025887d3(object, schemaKeyPath, $530a3ce8d84c06b1$var$extractKey);
            __DEV__ ? (0, $64dys.invariant)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0, $64dys.invariant)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $530a3ce8d84c06b1$export$550737ee0cc371ac(specifier) {
    var info = $530a3ce8d84c06b1$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $530a3ce8d84c06b1$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $8svBE.isNonEmptyArray)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    var directiveArgs = d && (0, $7QVo3.argumentsObjectFromField)(d, variables);
                    return directiveArgs && $530a3ce8d84c06b1$export$e8f64f7a025887d3(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $fQFHs.hasOwn).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $530a3ce8d84c06b1$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                return;
            }
            if (args) return $530a3ce8d84c06b1$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $530a3ce8d84c06b1$export$2db31da99613c21f(specifier, extractor) {
    var merger = new (0, $lVr1f.DeepMerger);
    return $530a3ce8d84c06b1$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $530a3ce8d84c06b1$export$eca459f173e85801(spec) {
    var info = $530a3ce8d84c06b1$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $8svBE.isArray)(s)) {
                $530a3ce8d84c06b1$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $8svBE.isArray)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $530a3ce8d84c06b1$var$extractKey(object, key) {
    return object[key];
}
function $530a3ce8d84c06b1$export$e8f64f7a025887d3(object, path, extract) {
    extract = extract || $530a3ce8d84c06b1$var$extractKey;
    return $530a3ce8d84c06b1$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $8svBE.isArray)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $530a3ce8d84c06b1$var$normalize(value) {
    if ((0, $4iLy6.isNonNullObject)(value)) {
        if ((0, $8svBE.isArray)(value)) return value.map($530a3ce8d84c06b1$var$normalize);
        return $530a3ce8d84c06b1$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $530a3ce8d84c06b1$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}

});




parcelRegister("e8RRb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.noop = module.exports.noopHeaders = module.exports.GraphqlDocuments = module.exports.ApolloClient = void 0;

var $1t8Wn = parcelRequire("1t8Wn");
module.exports.ApolloClient = new $1t8Wn.InjectionToken('apollo-link');
module.exports.GraphqlDocuments = new $1t8Wn.InjectionToken('graphql-documents');
const $a4bb96e12dabd764$var$noopHeaders = ()=>new Headers();
module.exports.noopHeaders = $a4bb96e12dabd764$var$noopHeaders;
const $a4bb96e12dabd764$var$noop = ()=>null;
module.exports.noop = $a4bb96e12dabd764$var$noop;

});

parcelRegister("6GSyD", function(module, exports) {

$parcel$export(module.exports, "ApolloClient", () => $4df0fc50bb25866f$export$13f5a5f0f1dbab88);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $7xzZX = parcelRequire("7xzZX");
var $8lDD6 = parcelRequire("8lDD6");

var $bBNpA = parcelRequire("bBNpA");

var $jAlpy = parcelRequire("jAlpy");

var $6c3mS = parcelRequire("6c3mS");

var $7RuIi = parcelRequire("7RuIi");

var $ed371 = parcelRequire("ed371");
var $4df0fc50bb25866f$var$hasSuggestedDevtools = false;
var $4df0fc50bb25866f$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' && !window.__APOLLO_CLIENT__ && __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $jAlpy.HttpLink)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $7xzZX.ApolloLink).empty();
        if (!cache) throw __DEV__ ? new (0, $64dys.InvariantError)("To initialize Apollo Client, you must specify a 'cache' property in the options object. \nFor more information, please visit: https://go.apollo.dev/c/docs") : new (0, $64dys.InvariantError)(9);
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') window.__APOLLO_CLIENT__ = this;
        if (!$4df0fc50bb25866f$var$hasSuggestedDevtools && connectToDevTools && __DEV__) {
            $4df0fc50bb25866f$var$hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                }
                if (url) __DEV__ && (0, $64dys.invariant).log("Download the Apollo DevTools for a better development experience: " + url);
            }
        }
        this.version = (0, $bBNpA.version);
        this.localState = new (0, $7RuIi.LocalState)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $6c3mS.QueryManager)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $ed371.mergeOptions)(this.defaultOptions.watchQuery, options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $ed371.mergeOptions)(this.defaultOptions.query, options);
        __DEV__ ? (0, $64dys.invariant)(options.fetchPolicy !== 'cache-and-network', "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : (0, $64dys.invariant)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $ed371.mergeOptions)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $8lDD6.execute)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function(error) {
            __DEV__ && (0, $64dys.invariant).debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}();

});
parcelRegister("7xzZX", function(module, exports) {

$parcel$export(module.exports, "ApolloLink", () => $57d78a0016fa2e86$export$2fed3d61f740bc7f);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");
parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");

var $bQjIR = parcelRequire("bQjIR");
var $gLNbv = parcelRequire("gLNbv");
var $h4xrg = parcelRequire("h4xrg");
function $57d78a0016fa2e86$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $bYo4v.Observable).of();
}
function $57d78a0016fa2e86$var$toLink(handler) {
    return typeof handler === 'function' ? new $57d78a0016fa2e86$export$2fed3d61f740bc7f(handler) : handler;
}
function $57d78a0016fa2e86$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $57d78a0016fa2e86$var$LinkError = function(_super) {
    (0, $deWeK.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
var $57d78a0016fa2e86$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $bYo4v.Observable).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($57d78a0016fa2e86$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $57d78a0016fa2e86$var$toLink(left);
        var rightLink = $57d78a0016fa2e86$var$toLink(right || new ApolloLink($57d78a0016fa2e86$var$passthrough));
        if ($57d78a0016fa2e86$var$isTerminating(leftLink) && $57d78a0016fa2e86$var$isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $bYo4v.Observable).of() : rightLink.request(operation) || (0, $bYo4v.Observable).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $bYo4v.Observable).of() : rightLink.request(operation, forward) || (0, $bYo4v.Observable).of();
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $bQjIR.createOperation)(operation.context, (0, $gLNbv.transformOperation)((0, $h4xrg.validateOperation)(operation)))) || (0, $bYo4v.Observable).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $57d78a0016fa2e86$var$toLink(first);
        if ($57d78a0016fa2e86$var$isTerminating(firstLink)) {
            __DEV__ && (0, $64dys.invariant).warn(new $57d78a0016fa2e86$var$LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = $57d78a0016fa2e86$var$toLink(second);
        if ($57d78a0016fa2e86$var$isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $bYo4v.Observable).of();
            }) || (0, $bYo4v.Observable).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $bYo4v.Observable).of();
            }) || (0, $bYo4v.Observable).of();
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($57d78a0016fa2e86$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw __DEV__ ? new (0, $64dys.InvariantError)('request is not implemented') : new (0, $64dys.InvariantError)(22);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();

});
parcelRegister("ey0GP", function(module, exports) {

$parcel$export(module.exports, "Observable", () => (parcelRequire("bYo4v")).Observable);

var $bYo4v = parcelRequire("bYo4v");
parcelRequire("1t9ny");
var $a974c6a7c11d9d06$var$prototype = (0, $bYo4v.Observable).prototype;
var $a974c6a7c11d9d06$var$fakeObsSymbol = '@@observable';
if (!$a974c6a7c11d9d06$var$prototype[$a974c6a7c11d9d06$var$fakeObsSymbol]) $a974c6a7c11d9d06$var$prototype[$a974c6a7c11d9d06$var$fakeObsSymbol] = function() {
    return this;
};

});
parcelRegister("bYo4v", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $8b77f86e60c743b1$export$77cea355fa80b5f4);
function $8b77f86e60c743b1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $8b77f86e60c743b1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8b77f86e60c743b1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8b77f86e60c743b1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8b77f86e60c743b1$var$_arrayLikeToArray(o, minLen);
}
function $8b77f86e60c743b1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8b77f86e60c743b1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8b77f86e60c743b1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8b77f86e60c743b1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8b77f86e60c743b1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $8b77f86e60c743b1$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $8b77f86e60c743b1$var$hasSymbol = function(name) {
    return $8b77f86e60c743b1$var$hasSymbols() && Boolean(Symbol[name]);
};
var $8b77f86e60c743b1$var$getSymbol = function(name) {
    return $8b77f86e60c743b1$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($8b77f86e60c743b1$var$hasSymbols() && !$8b77f86e60c743b1$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $8b77f86e60c743b1$var$SymbolIterator = $8b77f86e60c743b1$var$getSymbol('iterator');
var $8b77f86e60c743b1$var$SymbolObservable = $8b77f86e60c743b1$var$getSymbol('observable');
var $8b77f86e60c743b1$var$SymbolSpecies = $8b77f86e60c743b1$var$getSymbol('species'); // === Abstract Operations ===
function $8b77f86e60c743b1$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $8b77f86e60c743b1$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$8b77f86e60c743b1$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $8b77f86e60c743b1$export$77cea355fa80b5f4;
}
function $8b77f86e60c743b1$var$isObservable(x) {
    return x instanceof $8b77f86e60c743b1$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $8b77f86e60c743b1$var$hostReportError(e) {
    if ($8b77f86e60c743b1$var$hostReportError.log) $8b77f86e60c743b1$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $8b77f86e60c743b1$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $8b77f86e60c743b1$var$hostReportError(e);
        }
    });
}
function $8b77f86e60c743b1$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $8b77f86e60c743b1$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $8b77f86e60c743b1$var$hostReportError(e);
    }
}
function $8b77f86e60c743b1$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $8b77f86e60c743b1$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $8b77f86e60c743b1$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $8b77f86e60c743b1$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $8b77f86e60c743b1$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $8b77f86e60c743b1$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $8b77f86e60c743b1$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $8b77f86e60c743b1$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $8b77f86e60c743b1$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $8b77f86e60c743b1$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $8b77f86e60c743b1$var$enqueue(function() {
            return $8b77f86e60c743b1$var$flushSubscription(subscription);
        });
        return;
    }
    $8b77f86e60c743b1$var$notifySubscription(subscription, type, value);
}
var $8b77f86e60c743b1$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $8b77f86e60c743b1$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $8b77f86e60c743b1$var$closeSubscription(this);
            $8b77f86e60c743b1$var$cleanupSubscription(this);
        }
    };
    $8b77f86e60c743b1$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $8b77f86e60c743b1$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $8b77f86e60c743b1$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $8b77f86e60c743b1$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $8b77f86e60c743b1$var$onNotify(this._subscription, 'complete');
    };
    $8b77f86e60c743b1$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $8b77f86e60c743b1$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $8b77f86e60c743b1$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $8b77f86e60c743b1$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $8b77f86e60c743b1$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $8b77f86e60c743b1$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $8b77f86e60c743b1$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $8b77f86e60c743b1$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$8b77f86e60c743b1$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $8b77f86e60c743b1$var$getMethod(x, $8b77f86e60c743b1$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($8b77f86e60c743b1$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($8b77f86e60c743b1$var$hasSymbol('iterator')) {
            method = $8b77f86e60c743b1$var$getMethod(x, $8b77f86e60c743b1$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $8b77f86e60c743b1$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $8b77f86e60c743b1$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $8b77f86e60c743b1$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $8b77f86e60c743b1$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $8b77f86e60c743b1$var$_createClass(Observable, null, [
        {
            key: $8b77f86e60c743b1$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($8b77f86e60c743b1$var$hasSymbols()) Object.defineProperty($8b77f86e60c743b1$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $8b77f86e60c743b1$var$SymbolObservable,
        hostReportError: $8b77f86e60c743b1$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("1t9ny", function(module, exports) {
/* global window */ 
var $hUfLG = parcelRequire("hUfLG");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $hUfLG.default)(root);
var $111fc6566438f7eb$export$2e2bcd8739ae039 = result;

});
parcelRegister("hUfLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d093e5d6f620e0fc$export$2e2bcd8739ae039);
function $d093e5d6f620e0fc$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("bQjIR", function(module, exports) {

$parcel$export(module.exports, "createOperation", () => $89f3d98cbe2a732b$export$f29bedd62f56fcb2);

var $deWeK = parcelRequire("deWeK");
function $89f3d98cbe2a732b$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $deWeK.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, context), next(context));
        else context = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, $deWeK.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    return operation;
}

});

parcelRegister("gLNbv", function(module, exports) {

$parcel$export(module.exports, "transformOperation", () => $c3573029d101d165$export$4f3f7df1b558c729);

var $8HL2O = parcelRequire("8HL2O");
function $c3573029d101d165$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $8HL2O.getOperationName)(transformedOperation.query) || undefined : '';
    return transformedOperation;
}

});

parcelRegister("h4xrg", function(module, exports) {

$parcel$export(module.exports, "validateOperation", () => $c6dcbf9dec196b94$export$a92a48117d546c9);
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");
function $c6dcbf9dec196b94$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw __DEV__ ? new (0, $64dys.InvariantError)("illegal argument: ".concat(key)) : new (0, $64dys.InvariantError)(27);
    }
    return operation;
}

});


parcelRegister("8lDD6", function(module, exports) {

$parcel$export(module.exports, "execute", () => $613f06836fea95e9$export$51396ec711da548b);

var $7xzZX = parcelRequire("7xzZX");
var $613f06836fea95e9$export$51396ec711da548b = (0, $7xzZX.ApolloLink).execute;

});

parcelRegister("bBNpA", function(module, exports) {

$parcel$export(module.exports, "version", () => $87397a8dde03fcc9$export$83d89fbfd8236492);
var $87397a8dde03fcc9$export$83d89fbfd8236492 = '3.7.10';

});

parcelRegister("jAlpy", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $e421fceb03dd8000$export$f4bbf1aec241cc1);

var $deWeK = parcelRequire("deWeK");

var $7xzZX = parcelRequire("7xzZX");

var $dH7IB = parcelRequire("dH7IB");
var $e421fceb03dd8000$export$f4bbf1aec241cc1 = function(_super) {
    (0, $deWeK.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $dH7IB.createHttpLink)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $7xzZX.ApolloLink));

});
parcelRegister("dH7IB", function(module, exports) {

$parcel$export(module.exports, "createHttpLink", () => $9f85473752f98ecb$export$95180a16573d6675);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");

var $4IPRa = parcelRequire("4IPRa");

var $7xzZX = parcelRequire("7xzZX");

var $4f7Lj = parcelRequire("4f7Lj");parcelRequire("6TVLx");
var $58Wpk = parcelRequire("58Wpk");parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");

var $b5f9c = parcelRequire("b5f9c");

var $le6eu = parcelRequire("le6eu");

var $jK6kg = parcelRequire("jK6kg");

var $4PXEQ = parcelRequire("4PXEQ");

var $5daXl = parcelRequire("5daXl");

var $aUtna = parcelRequire("aUtna");

var $8gLtU = parcelRequire("8gLtU");

var $zEj0y = parcelRequire("zEj0y");
var $9f85473752f98ecb$var$backupFetch = (0, $58Wpk.maybe)(function() {
    return fetch;
});
var $9f85473752f98ecb$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $5daXl.defaultPrinter) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $deWeK.__rest)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (__DEV__) (0, $4PXEQ.checkFetcher)(preferredFetch || $9f85473752f98ecb$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $7xzZX.ApolloLink)(function(operation) {
        var chosenURI = (0, $le6eu.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $5daXl.selectHttpOptionsAndBodyInternal)(operation, print, (0, $5daXl.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0, $4IPRa.visit)(operation.query, {
                Variable: function(node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') unusedNames_1.delete(node.name.value);
                }
            });
            if (unusedNames_1.size) {
                body.variables = (0, $deWeK.__assign)({}, body.variables);
                unusedNames_1.forEach(function(name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = (0, $aUtna.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if ((0, $4f7Lj.hasDirectives)([
            'defer'
        ], operation.query)) {
            options.headers = options.headers || {};
            options.headers.accept = "multipart/mixed; deferSpec=20220824, application/json";
        }
        if (options.method === 'GET') {
            var _d = (0, $8gLtU.rewriteURIForGET)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $zEj0y.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $b5f9c.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $zEj0y.fromError)(parseError);
        }
        return new (0, $bYo4v.Observable)(function(observer) {
            var currentFetch = preferredFetch || (0, $58Wpk.maybe)(function() {
                return fetch;
            }) || $9f85473752f98ecb$var$backupFetch;
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $jK6kg.readMultipartBody)(response, observer);
                else return (0, $jK6kg.readJsonBody)(response, operation, observer);
            }).catch(function(err) {
                return (0, $jK6kg.handleError)(err, observer);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};

});
parcelRegister("b5f9c", function(module, exports) {

$parcel$export(module.exports, "serializeFetchParameter", () => $811be94f8ca4a665$export$5f8e80ac52052e28);
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");
var $811be94f8ca4a665$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = __DEV__ ? new (0, $64dys.InvariantError)("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new (0, $64dys.InvariantError)(24);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

});

parcelRegister("le6eu", function(module, exports) {

$parcel$export(module.exports, "selectURI", () => $f73fbd74cf3b2ccf$export$63ccc2571850f81a);
var $f73fbd74cf3b2ccf$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});

parcelRegister("jK6kg", function(module, exports) {

$parcel$export(module.exports, "readMultipartBody", () => $e5f7385d608e13ff$export$ccb60864026baf09);
$parcel$export(module.exports, "handleError", () => $e5f7385d608e13ff$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "readJsonBody", () => $e5f7385d608e13ff$export$239a7c04069f210b);

var $deWeK = parcelRequire("deWeK");

var $eiKXJ = parcelRequire("eiKXJ");

var $fETYw = parcelRequire("fETYw");
var $e5f7385d608e13ff$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e5f7385d608e13ff$export$ccb60864026baf09(response, observer) {
    var _a, _b, _c;
    return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _d, value, done, chunk, bi, message, i, headers, contentType_1, body, result;
        var _e;
        return (0, $deWeK.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $eiKXJ.responseIterator)(response);
                    running = true;
                    _f.label = 1;
                case 1:
                    if (!running) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        iterator.next()
                    ];
                case 2:
                    _d = _f.sent(), value = _d.value, done = _d.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary);
                    while(bi > -1){
                        message = void 0;
                        _e = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _e[0], buffer = _e[1];
                        if (message.trim()) {
                            i = message.indexOf("\r\n\r\n");
                            headers = $e5f7385d608e13ff$export$eea2c1c5e1a37e50(message.slice(0, i));
                            contentType_1 = headers["content-type"];
                            if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                            body = message.slice(i);
                            try {
                                result = $e5f7385d608e13ff$export$759bcb35b0d1bf81(response, body.replace("\r\n", ""));
                                if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result) (_b = observer.next) === null || _b === void 0 || _b.call(observer, result);
                            } catch (err) {
                                $e5f7385d608e13ff$export$d3da1ecaf1206c58(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    (_c = observer.complete) === null || _c === void 0 || _c.call(observer);
                    return [
                        2
                    ];
            }
        });
    });
}
function $e5f7385d608e13ff$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $e5f7385d608e13ff$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $fETYw.throwServerError)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $e5f7385d608e13ff$export$d3da1ecaf1206c58(err, observer) {
    var _a, _b;
    if (err.name === "AbortError") return;
    if (err.result && err.result.errors && err.result.data) (_a = observer.next) === null || _a === void 0 || _a.call(observer, err.result);
    (_b = observer.error) === null || _b === void 0 || _b.call(observer, err);
}
function $e5f7385d608e13ff$export$239a7c04069f210b(response, operation, observer) {
    $e5f7385d608e13ff$export$d4051215bea0639f(operation)(response).then(function(result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 || _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 || _b.call(observer);
    }).catch(function(err) {
        return $e5f7385d608e13ff$export$d3da1ecaf1206c58(err, observer);
    });
}
function $e5f7385d608e13ff$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $e5f7385d608e13ff$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (response.status >= 300) (0, $fETYw.throwServerError)(response, result, "Response not successful: Received status code ".concat(response.status));
            if (!Array.isArray(result) && !$e5f7385d608e13ff$var$hasOwnProperty.call(result, "data") && !$e5f7385d608e13ff$var$hasOwnProperty.call(result, "errors")) (0, $fETYw.throwServerError)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}

});
parcelRegister("eiKXJ", function(module, exports) {

$parcel$export(module.exports, "responseIterator", () => $a6972ce872b71d7a$export$7e4ac9ed9577f145);

var $gucmz = parcelRequire("gucmz");

var $iG4xT = parcelRequire("iG4xT");

var $dAQyY = parcelRequire("dAQyY");

var $ln783 = parcelRequire("ln783");

var $d4ycw = parcelRequire("d4ycw");
function $a6972ce872b71d7a$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ((0, $gucmz.isNodeResponse)(response)) body = response.body;
    if ((0, $gucmz.isAsyncIterableIterator)(body)) return (0, $iG4xT.default)(body);
    if ((0, $gucmz.isReadableStream)(body)) return (0, $d4ycw.default)(body.getReader());
    if ((0, $gucmz.isStreamableBlob)(body)) return (0, $d4ycw.default)(body.stream().getReader());
    if ((0, $gucmz.isBlob)(body)) return (0, $ln783.default)(body.arrayBuffer());
    if ((0, $gucmz.isNodeReadableStream)(body)) return (0, $dAQyY.default)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

});
parcelRegister("gucmz", function(module, exports) {

$parcel$export(module.exports, "isNodeResponse", () => $c00909be24110938$export$18f63c735264ee11);
$parcel$export(module.exports, "isReadableStream", () => $c00909be24110938$export$ac613ff475b69d05);
$parcel$export(module.exports, "isAsyncIterableIterator", () => $c00909be24110938$export$fe1556bffc7e68ee);
$parcel$export(module.exports, "isStreamableBlob", () => $c00909be24110938$export$70be23b513fb72ac);
$parcel$export(module.exports, "isBlob", () => $c00909be24110938$export$5bcd6e94ed871c88);
$parcel$export(module.exports, "isNodeReadableStream", () => $c00909be24110938$export$530196473208426f);

var $8uSJ8 = parcelRequire("8uSJ8");
function $c00909be24110938$export$18f63c735264ee11(value) {
    return !!value.body;
}
function $c00909be24110938$export$ac613ff475b69d05(value) {
    return !!value.getReader;
}
function $c00909be24110938$export$fe1556bffc7e68ee(value) {
    return !!((0, $8uSJ8.canUseAsyncIteratorSymbol) && value[Symbol.asyncIterator]);
}
function $c00909be24110938$export$70be23b513fb72ac(value) {
    return !!value.stream;
}
function $c00909be24110938$export$5bcd6e94ed871c88(value) {
    return !!value.arrayBuffer;
}
function $c00909be24110938$export$530196473208426f(value) {
    return !!value.pipe;
}

});

parcelRegister("iG4xT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98facec321f0ddf$export$2e2bcd8739ae039);
function $d98facec321f0ddf$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}

});

parcelRegister("dAQyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e57691b51e7e842$export$2e2bcd8739ae039);

var $8uSJ8 = parcelRequire("8uSJ8");
function $9e57691b51e7e842$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $8uSJ8.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("ln783", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f1469995020a50$export$2e2bcd8739ae039);

var $8uSJ8 = parcelRequire("8uSJ8");
function $f8f1469995020a50$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $8uSJ8.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("d4ycw", function(module, exports) {

$parcel$export(module.exports, "default", () => $98462db3a9856a39$export$2e2bcd8739ae039);

var $8uSJ8 = parcelRequire("8uSJ8");
function $98462db3a9856a39$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $8uSJ8.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});


parcelRegister("fETYw", function(module, exports) {

$parcel$export(module.exports, "throwServerError", () => $02f12114673438d8$export$c33ef9219f27efd7);
var $02f12114673438d8$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

});


parcelRegister("4PXEQ", function(module, exports) {

$parcel$export(module.exports, "checkFetcher", () => $385a339e18c23358$export$8423f0cd3773115e);
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");
var $385a339e18c23358$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') throw __DEV__ ? new (0, $64dys.InvariantError)("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new (0, $64dys.InvariantError)(23);
};

});

parcelRegister("5daXl", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $3cb6aa4bc28dbe12$export$dd86f00dc866e75d);
$parcel$export(module.exports, "defaultPrinter", () => $3cb6aa4bc28dbe12$export$e88934976ca4fd65);
$parcel$export(module.exports, "selectHttpOptionsAndBodyInternal", () => $3cb6aa4bc28dbe12$export$12d90ccf75844275);

var $deWeK = parcelRequire("deWeK");

var $bPPwj = parcelRequire("bPPwj");
var $3cb6aa4bc28dbe12$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $3cb6aa4bc28dbe12$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $3cb6aa4bc28dbe12$var$defaultOptions = {
    method: 'POST'
};
var $3cb6aa4bc28dbe12$export$dd86f00dc866e75d = {
    http: $3cb6aa4bc28dbe12$var$defaultHttpOptions,
    headers: $3cb6aa4bc28dbe12$var$defaultHeaders,
    options: $3cb6aa4bc28dbe12$var$defaultOptions
};
var $3cb6aa4bc28dbe12$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $3cb6aa4bc28dbe12$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $3cb6aa4bc28dbe12$export$12d90ccf75844275.apply(void 0, (0, $deWeK.__spreadArray)([
        operation,
        $3cb6aa4bc28dbe12$export$e88934976ca4fd65
    ], configs, false));
}
function $3cb6aa4bc28dbe12$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $deWeK.__assign)((0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), config.options), {
            headers: (0, $deWeK.__assign)((0, $deWeK.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, http), config.http);
    });
    if (options.headers) options.headers = $3cb6aa4bc28dbe12$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = printer(query, (0, $bPPwj.print));
    return {
        options: options,
        body: body
    };
}
function $3cb6aa4bc28dbe12$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

});
parcelRegister("bPPwj", function(module, exports) {

$parcel$export(module.exports, "print", () => $a8478e4e6884860c$export$c2d084dc44961371);

var $4IPRa = parcelRequire("4IPRa");

var $fs9Mn = parcelRequire("fs9Mn");
function $a8478e4e6884860c$export$c2d084dc44961371(ast) {
    return (0, $4IPRa.visit)(ast, {
        leave: $a8478e4e6884860c$var$printDocASTReducer
    });
} // TODO: provide better type coverage in future
var $a8478e4e6884860c$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $a8478e4e6884860c$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $a8478e4e6884860c$var$wrap('(', $a8478e4e6884860c$var$join(node.variableDefinitions, ', '), ')');
        var directives = $a8478e4e6884860c$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $a8478e4e6884860c$var$join([
            op,
            $a8478e4e6884860c$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $a8478e4e6884860c$var$wrap(' = ', defaultValue) + $a8478e4e6884860c$var$wrap(' ', $a8478e4e6884860c$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $a8478e4e6884860c$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return $a8478e4e6884860c$var$join([
            $a8478e4e6884860c$var$wrap('', alias, ': ') + name + $a8478e4e6884860c$var$wrap('(', $a8478e4e6884860c$var$join(args, ', '), ')'),
            $a8478e4e6884860c$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $a8478e4e6884860c$var$wrap(' ', $a8478e4e6884860c$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $a8478e4e6884860c$var$join([
            '...',
            $a8478e4e6884860c$var$wrap('on ', typeCondition),
            $a8478e4e6884860c$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($a8478e4e6884860c$var$wrap('(', $a8478e4e6884860c$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($a8478e4e6884860c$var$wrap('', $a8478e4e6884860c$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $fs9Mn.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $a8478e4e6884860c$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $a8478e4e6884860c$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $a8478e4e6884860c$var$wrap('(', $a8478e4e6884860c$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $a8478e4e6884860c$var$join([
            'schema',
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(operationTypes)
        ], ' ');
    },
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $a8478e4e6884860c$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $a8478e4e6884860c$var$join([
            'scalar',
            name,
            $a8478e4e6884860c$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $a8478e4e6884860c$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $a8478e4e6884860c$var$join([
            'type',
            name,
            $a8478e4e6884860c$var$wrap('implements ', $a8478e4e6884860c$var$join(interfaces, ' & ')),
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $a8478e4e6884860c$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($a8478e4e6884860c$var$hasMultilineItems(args) ? $a8478e4e6884860c$var$wrap('(\n', $a8478e4e6884860c$var$indent($a8478e4e6884860c$var$join(args, '\n')), '\n)') : $a8478e4e6884860c$var$wrap('(', $a8478e4e6884860c$var$join(args, ', '), ')')) + ': ' + type + $a8478e4e6884860c$var$wrap(' ', $a8478e4e6884860c$var$join(directives, ' '));
    }),
    InputValueDefinition: $a8478e4e6884860c$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $a8478e4e6884860c$var$join([
            name + ': ' + type,
            $a8478e4e6884860c$var$wrap('= ', defaultValue),
            $a8478e4e6884860c$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $a8478e4e6884860c$var$addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return $a8478e4e6884860c$var$join([
            'interface',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $a8478e4e6884860c$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $a8478e4e6884860c$var$join([
            'union',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $a8478e4e6884860c$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $a8478e4e6884860c$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $a8478e4e6884860c$var$join([
            'enum',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $a8478e4e6884860c$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $a8478e4e6884860c$var$join([
            name,
            $a8478e4e6884860c$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $a8478e4e6884860c$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $a8478e4e6884860c$var$join([
            'input',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $a8478e4e6884860c$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($a8478e4e6884860c$var$hasMultilineItems(args) ? $a8478e4e6884860c$var$wrap('(\n', $a8478e4e6884860c$var$indent($a8478e4e6884860c$var$join(args, '\n')), '\n)') : $a8478e4e6884860c$var$wrap('(', $a8478e4e6884860c$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $a8478e4e6884860c$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $a8478e4e6884860c$var$join([
            'extend schema',
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $a8478e4e6884860c$var$join([
            'extend scalar',
            name,
            $a8478e4e6884860c$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $a8478e4e6884860c$var$join([
            'extend type',
            name,
            $a8478e4e6884860c$var$wrap('implements ', $a8478e4e6884860c$var$join(interfaces, ' & ')),
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return $a8478e4e6884860c$var$join([
            'extend interface',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $a8478e4e6884860c$var$join([
            'extend union',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $a8478e4e6884860c$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $a8478e4e6884860c$var$join([
            'extend enum',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $a8478e4e6884860c$var$join([
            'extend input',
            name,
            $a8478e4e6884860c$var$join(directives, ' '),
            $a8478e4e6884860c$var$block(fields)
        ], ' ');
    }
};
function $a8478e4e6884860c$var$addDescription(cb) {
    return function(node) {
        return $a8478e4e6884860c$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $a8478e4e6884860c$var$join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function(x) {
        return x;
    }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $a8478e4e6884860c$var$block(array) {
    return array && array.length !== 0 ? '{\n' + $a8478e4e6884860c$var$indent($a8478e4e6884860c$var$join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function $a8478e4e6884860c$var$wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || '') : '';
}
function $a8478e4e6884860c$var$indent(maybeString) {
    return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}
function $a8478e4e6884860c$var$isMultiline(string) {
    return string.indexOf('\n') !== -1;
}
function $a8478e4e6884860c$var$hasMultilineItems(maybeArray) {
    return maybeArray && maybeArray.some($a8478e4e6884860c$var$isMultiline);
}

});
parcelRegister("fs9Mn", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $6cd8189fb7f54352$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $6cd8189fb7f54352$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function $6cd8189fb7f54352$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $6cd8189fb7f54352$export$3c95bfdc680af0c(lines);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $6cd8189fb7f54352$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $6cd8189fb7f54352$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join('\n');
} // @internal
function $6cd8189fb7f54352$export$3c95bfdc680af0c(lines) {
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $6cd8189fb7f54352$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        if (commonIndent === null || indent < commonIndent) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    return commonIndent === null ? 0 : commonIndent;
}
function $6cd8189fb7f54352$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === ' ' || str[i] === '\t'))i++;
    return i;
}
function $6cd8189fb7f54352$var$isBlank(str) {
    return $6cd8189fb7f54352$var$leadingWhitespace(str) === str.length;
}
function $6cd8189fb7f54352$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});



parcelRegister("aUtna", function(module, exports) {

$parcel$export(module.exports, "createSignalIfSupported", () => $7f15eb247fc2cbab$export$f5853cd1fc39aea6);
var $7f15eb247fc2cbab$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};

});

parcelRegister("8gLtU", function(module, exports) {

$parcel$export(module.exports, "rewriteURIForGET", () => $6054a62a618c1ff7$export$fb82bb094b6f76b5);

var $b5f9c = parcelRequire("b5f9c");
function $6054a62a618c1ff7$export$fb82bb094b6f76b5(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $b5f9c.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $b5f9c.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}

});

parcelRegister("zEj0y", function(module, exports) {

$parcel$export(module.exports, "fromError", () => $06b288d8f503b9e1$export$4fd972edbe7450d3);
parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");
function $06b288d8f503b9e1$export$4fd972edbe7450d3(errorValue) {
    return new (0, $bYo4v.Observable)(function(observer) {
        observer.error(errorValue);
    });
}

});



parcelRegister("6c3mS", function(module, exports) {

$parcel$export(module.exports, "QueryManager", () => $482679de5eafd622$export$b986383a50b53ea4);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $6EJag = parcelRequire("6EJag");

var $8lDD6 = parcelRequire("8lDD6");

var $lmsxK = parcelRequire("lmsxK");

var $4e05c = parcelRequire("4e05c");

var $2MrBx = parcelRequire("2MrBx");
var $8uSJ8 = parcelRequire("8uSJ8");
var $2uZDP = parcelRequire("2uZDP");
var $8HL2O = parcelRequire("8HL2O");
var $j90bg = parcelRequire("j90bg");
var $4f7Lj = parcelRequire("4f7Lj");
var $7QVo3 = parcelRequire("7QVo3");
var $8svBE = parcelRequire("8svBE");
var $4iLy6 = parcelRequire("4iLy6");
var $coC0K = parcelRequire("coC0K");parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");
var $ctUe3 = parcelRequire("ctUe3");

var $dLZ47 = parcelRequire("dLZ47");

var $ji55q = parcelRequire("ji55q");

var $62xZn = parcelRequire("62xZn");

var $7RuIi = parcelRequire("7RuIi");

var $dstPT = parcelRequire("dstPT");
var $482679de5eafd622$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $482679de5eafd622$export$b986383a50b53ea4 = function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new ((0, $8uSJ8.canUseWeakMap) ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $7RuIi.LocalState)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new (0, $64dys.InvariantError)('QueryManager stopped while query was in flight') : new (0, $64dys.InvariantError)(14));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0, $deWeK.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        __DEV__ ? (0, $64dys.invariant)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0, $64dys.invariant)(mutation, 15);
                        __DEV__ ? (0, $64dys.invariant)(fetchPolicy === 'network-only' || fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0, $64dys.invariant)(fetchPolicy === 'network-only' || fetchPolicy === 'no-cache', 16);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        if (optimisticResponse) this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                return (0, $2MrBx.asyncMap)(self.getObservableFromLink(mutation, (0, $deWeK.__assign)((0, $deWeK.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false), function(result) {
                                    if ((0, $j90bg.graphQLResultHasError)(result) && errorPolicy === 'none') throw new (0, $dLZ47.ApolloError)({
                                        graphQLErrors: (0, $j90bg.getGraphQLErrorsFromResult)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $deWeK.__assign)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === 'ignore' && (0, $j90bg.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        if (!('hasNext' in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $dLZ47.ApolloError) ? err : new (0, $dLZ47.ApolloError)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $dstPT.shouldWriteResult)(result, mutation.errorPolicy)) {
            if (!(0, $lmsxK.isExecutionPatchIncrementalResult)(result)) cacheWrites.push({
                result: result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $lmsxK.isExecutionPatchIncrementalResult)(result) && (0, $8svBE.isNonEmptyArray)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    query: this.transform(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $lmsxK.mergeIncrementalData)(diff.result, result);
                if (typeof mergedData !== 'undefined') {
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$482679de5eafd622$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $8HL2O.getOperationName)(document) || void 0,
                        queryVariables: variables
                    });
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || mutation.refetchQueries || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    var update = mutation.update;
                    var isFinalResult = !(0, $lmsxK.isExecutionPatchResult)(result) || (0, $lmsxK.isExecutionPatchIncrementalResult)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, result), {
                                    data: diff.result
                                });
                                if ('incremental' in result) delete result.incremental;
                                if ('hasNext' in result) delete result.hasNext;
                            }
                        }
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: 'ROOT_MUTATION',
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables) : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $deWeK.__assign)((0, $deWeK.__assign)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                __DEV__ && (0, $64dys.invariant).error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = (0, $ctUe3.removeConnectionDirectiveFromDocument)(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $4f7Lj.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $8HL2O.getDefaultValues)((0, $8HL2O.getOperationDefinition)(transformed)),
                asQuery: (0, $deWeK.__assign)((0, $deWeK.__assign)({}, transformed), {
                    definitions: transformed.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        options = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            variables: this.getVariables(options.query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $dstPT.QueryInfo)(this);
        var observable = new (0, $ji55q.ObservableQuery)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        __DEV__ ? (0, $64dys.invariant)(options.query, "query option is required. You must specify your GraphQL document in the query option.") : (0, $64dys.invariant)(options.query, 17);
        __DEV__ ? (0, $64dys.invariant)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0, $64dys.invariant)(options.query.kind === 'Document', 18);
        __DEV__ ? (0, $64dys.invariant)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0, $64dys.invariant)(!options.returnPartialData, 19);
        __DEV__ ? (0, $64dys.invariant)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0, $64dys.invariant)(!options.pollInterval, 20);
        return this.fetchQuery(queryId, options).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        this.cancelPendingFetches(__DEV__ ? new (0, $64dys.InvariantError)('Store reset while query was in flight (not completed in link chain)') : new (0, $64dys.InvariantError)(21));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) queryInfo.networkStatus = (0, $62xZn.NetworkStatus).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $7QVo3.isDocumentNode)(desc)) queryNamesAndDocs.set(_this.transform(desc).document, false);
            else if ((0, $4iLy6.isNonNullObject)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            var queryId = (0, $coC0K.makeUniqueId)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $ji55q.ObservableQuery)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $64dys.invariant)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (__DEV__ && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) __DEV__ && (0, $64dys.invariant).warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== 'no-cache') {
                    if ((0, $dstPT.shouldWriteResult)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: 'ROOT_SUBSCRIPTION',
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                if ((0, $j90bg.graphQLResultHasError)(result)) throw new (0, $dLZ47.ApolloError)({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $bYo4v.Observable)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $8HL2O.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $deWeK.__assign)((0, $deWeK.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = (0, $4e05c.canonicalStringify)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new (0, $2uZDP.Concast)([
                        (0, $8lDD6.execute)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function() {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) inFlightLinkObservables_1.delete(serverQuery);
                    });
                }
            } else observable = new (0, $2uZDP.Concast)([
                (0, $8lDD6.execute)(link, operation)
            ]);
        } else {
            observable = new (0, $2uZDP.Concast)([
                (0, $bYo4v.Observable).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = (0, $2MrBx.asyncMap)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return (0, $2MrBx.asyncMap)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $j90bg.getGraphQLErrorsFromResult)(result);
            var hasErrors = graphQLErrors.length > 0;
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") throw queryInfo.markError(new (0, $dLZ47.ApolloError)({
                    graphQLErrors: graphQLErrors
                }));
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $62xZn.NetworkStatus).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $62xZn.NetworkStatus).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $dLZ47.isApolloError)(networkError) ? networkError : new (0, $dLZ47.ApolloError)({
                networkError: networkError
            });
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function(queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $62xZn.NetworkStatus).loading;
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            normalized.variables = variables;
            var concastSources = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" && concastSources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return concastSources;
        };
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast = new (0, $2uZDP.Concast)(this.transform(normalized.query).hasClientExports ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables) : fromVariables(normalized.variables));
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return concast;
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $coC0K.makeUniqueId)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map;
        if (updateCache) this.cache.batch({
            update: updateCache,
            optimistic: optimistic && removeOptimistic || false,
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $dstPT.QueryInfo) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) result = oq.refetch();
                        if (result !== false) results.set(oq, result);
                        return result;
                    }
                    if (onQueryUpdated !== null) includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset();
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff(variables);
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $62xZn.NetworkStatus).loading;
            var data = diff.result;
            if (__DEV__ && !returnPartialData && !(0, $6EJag.equal)(data, {})) (0, $ji55q.logMissingFieldErrors)(diff.missing);
            var fromData = function(data) {
                return (0, $bYo4v.Observable).of((0, $deWeK.__assign)({
                    data: data,
                    loading: (0, $62xZn.isNetworkRequestInFlight)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.transform(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            if (errorPolicy === 'none' && networkStatus === (0, $62xZn.NetworkStatus).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 : networkStatus === (0, $62xZn.NetworkStatus).refetch && refetchWritePolicy !== "merge" ? 1 : 2;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $62xZn.isNetworkRequestInFlight)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return [
                    resultsFromCache(diff, queryInfo.markReady())
                ];
                if (returnPartialData || shouldNotify) return [
                    resultsFromCache(diff),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return [
                    resultsFromCache(diff),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady())
                ];
            case "network-only":
                if (shouldNotify) return [
                    resultsFromCache(readCache()),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "no-cache":
                if (shouldNotify) return [
                    resultsFromCache(queryInfo.getDiff()),
                    resultsFromLink()
                ];
                return [
                    resultsFromLink()
                ];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $dstPT.QueryInfo)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();

});
parcelRegister("lmsxK", function(module, exports) {

$parcel$export(module.exports, "isExecutionPatchIncrementalResult", () => $f8d1cb2c186e17f7$export$879767c5cdf33cb3);
$parcel$export(module.exports, "isExecutionPatchResult", () => $f8d1cb2c186e17f7$export$f90dc0a3531b8b83);
$parcel$export(module.exports, "mergeIncrementalData", () => $f8d1cb2c186e17f7$export$9a905f57d6393874);

var $8svBE = parcelRequire("8svBE");

var $lVr1f = parcelRequire("lVr1f");
function $f8d1cb2c186e17f7$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $f8d1cb2c186e17f7$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $f8d1cb2c186e17f7$export$f90dc0a3531b8b83(value) {
    return $f8d1cb2c186e17f7$export$879767c5cdf33cb3(value) || $f8d1cb2c186e17f7$export$6c17a45d8c64ff02(value);
}
function $f8d1cb2c186e17f7$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $lVr1f.DeepMerger)();
    if ($f8d1cb2c186e17f7$export$879767c5cdf33cb3(result) && (0, $8svBE.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}

});

parcelRegister("2MrBx", function(module, exports) {

$parcel$export(module.exports, "asyncMap", () => $20657a27978f8aa0$export$707ee4c4c95d39e3);
parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");
function $20657a27978f8aa0$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $bYo4v.Observable)(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, delegate) {
            if (examiner) return function(arg) {
                ++activeCallbackCount;
                var both = function() {
                    return examiner(arg);
                };
                promiseQueue = promiseQueue.then(both, both).then(function(result) {
                    --activeCallbackCount;
                    next && next.call(observer, result);
                    if (completed) handler.complete();
                }, function(error) {
                    --activeCallbackCount;
                    throw error;
                }).catch(function(caught) {
                    error && error.call(observer, caught);
                });
            };
            else return function(arg) {
                return delegate && delegate.call(observer, arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function() {
                completed = true;
                if (!activeCallbackCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

});

parcelRegister("2uZDP", function(module, exports) {

$parcel$export(module.exports, "Concast", () => $1d1e32d558d62536$export$ae0cf2ec7a6fa78e);

var $deWeK = parcelRequire("deWeK");
parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");

var $49Jzz = parcelRequire("49Jzz");

var $ipvgg = parcelRequire("ipvgg");
function $1d1e32d558d62536$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var $1d1e32d558d62536$export$ae0cf2ec7a6fa78e = function(_super) {
    (0, $deWeK.__extends)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $49Jzz.iterateObserversSafely)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $49Jzz.iterateObserversSafely)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        (0, $49Jzz.iterateObserversSafely)(_this.observers, "complete");
                    } else if ($1d1e32d558d62536$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    });
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function(_) {});
        if (typeof sources === "function") sources = [
            new (0, $bYo4v.Observable)(sources)
        ];
        if ($1d1e32d558d62536$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $bYo4v.Observable));
(0, $ipvgg.fixObservableSubclass)($1d1e32d558d62536$export$ae0cf2ec7a6fa78e);

});
parcelRegister("49Jzz", function(module, exports) {

$parcel$export(module.exports, "iterateObserversSafely", () => $306b5a78f2502c56$export$9f6c99ae166dbeca);
function $306b5a78f2502c56$export$9f6c99ae166dbeca(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

});

parcelRegister("ipvgg", function(module, exports) {

$parcel$export(module.exports, "fixObservableSubclass", () => $d672cf9f032b71c9$export$33c8bd820eece9b2);
parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");

var $8uSJ8 = parcelRequire("8uSJ8");
function $d672cf9f032b71c9$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, {
            value: (0, $bYo4v.Observable)
        });
    }
    if ((0, $8uSJ8.canUseSymbol) && Symbol.species) set(Symbol.species);
    set("@@species");
    return subclass;
}

});


parcelRegister("j90bg", function(module, exports) {

$parcel$export(module.exports, "graphQLResultHasError", () => $defeff721b6bed67$export$b4df399e879e53ab);
$parcel$export(module.exports, "getGraphQLErrorsFromResult", () => $defeff721b6bed67$export$a163557155188b6e);

var $8svBE = parcelRequire("8svBE");

var $lmsxK = parcelRequire("lmsxK");
function $defeff721b6bed67$export$b4df399e879e53ab(result) {
    var errors = $defeff721b6bed67$export$a163557155188b6e(result);
    return (0, $8svBE.isNonEmptyArray)(errors);
}
function $defeff721b6bed67$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $8svBE.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $lmsxK.isExecutionPatchIncrementalResult)(result) && (0, $8svBE.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}

});

parcelRegister("dLZ47", function(module, exports) {

$parcel$export(module.exports, "isApolloError", () => $a06f087aac07d48b$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $a06f087aac07d48b$export$26a337512320b8c6);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");

var $8svBE = parcelRequire("8svBE");
function $a06f087aac07d48b$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $a06f087aac07d48b$var$generateErrorMessage = function(err) {
    var message = '';
    if ((0, $8svBE.isNonEmptyArray)(err.graphQLErrors) || (0, $8svBE.isNonEmptyArray)(err.clientErrors)) {
        var errors = (err.graphQLErrors || []).concat(err.clientErrors || []);
        errors.forEach(function(error) {
            var errorMessage = error ? error.message : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) message += "".concat(err.networkError.message, "\n");
    message = message.replace(/\n$/, '');
    return message;
};
var $a06f087aac07d48b$export$26a337512320b8c6 = function(_super) {
    (0, $deWeK.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = 'ApolloError';
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $a06f087aac07d48b$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("ji55q", function(module, exports) {

$parcel$export(module.exports, "ObservableQuery", () => $e0b3a4d1ab0de45a$export$6c1b56eac59c9584);
$parcel$export(module.exports, "logMissingFieldErrors", () => $e0b3a4d1ab0de45a$export$b7e1973aacac3ae7);
$parcel$export(module.exports, "reobserveCacheFirst", () => $e0b3a4d1ab0de45a$export$419171d60552792a);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $6EJag = parcelRequire("6EJag");

var $62xZn = parcelRequire("62xZn");

var $bR2gQ = parcelRequire("bR2gQ");
var $dnkFk = parcelRequire("dnkFk");
var $ipvgg = parcelRequire("ipvgg");
var $8HL2O = parcelRequire("8HL2O");
var $8svBE = parcelRequire("8svBE");
var $49Jzz = parcelRequire("49Jzz");parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");
var $e0b3a4d1ab0de45a$var$assign = Object.assign, $e0b3a4d1ab0de45a$var$hasOwnProperty = Object.hasOwnProperty;
var $e0b3a4d1ab0de45a$export$6c1b56eac59c9584 = function(_super) {
    (0, $deWeK.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $e0b3a4d1ab0de45a$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            if (first) _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, options), {
            initialFetchPolicy: initialFetchPolicy,
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $8HL2O.getOperationDefinition)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function() {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $62xZn.NetworkStatus).ready;
        var result = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, lastResult), {
            loading: (0, $62xZn.isNetworkRequestInFlight)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' || fetchPolicy === 'no-cache' || fetchPolicy === 'standby' || this.queryManager.transform(this.options.query).hasForcedResolvers) ;
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $6EJag.equal)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                delete result.partial;
                if (diff.complete && result.networkStatus === (0, $62xZn.NetworkStatus).loading && (fetchPolicy === 'cache-first' || fetchPolicy === 'cache-only')) {
                    result.networkStatus = (0, $62xZn.NetworkStatus).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (__DEV__ && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $e0b3a4d1ab0de45a$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        return !this.last || !(0, $6EJag.equal)(this.last.result, newResult) || variables && !(0, $6EJag.equal)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $6EJag.equal)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === 'no-cache') reobserveOptions.fetchPolicy = 'no-cache';
        else reobserveOptions.fetchPolicy = 'network-only';
        if (__DEV__ && variables && $e0b3a4d1ab0de45a$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $8HL2O.getQueryDefinition)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) __DEV__ && (0, $64dys.invariant).warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
        }
        if (variables && !(0, $6EJag.equal)(this.options.variables, variables)) reobserveOptions.variables = this.options.variables = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $62xZn.NetworkStatus).refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $deWeK.__assign)((0, $deWeK.__assign)((0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.options), {
            query: this.query
        }), fetchMoreOptions), {
            variables: (0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "no-cache"
        });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $62xZn.NetworkStatus).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $62xZn.NetworkStatus).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $62xZn.NetworkStatus).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            if (!updatedQuerySet.has(_this.query)) $e0b3a4d1ab0de45a$export$419171d60552792a(_this);
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && (0, $64dys.invariant).error('Unhandled GraphQL subscription error', err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $6EJag.equal)(this.variables, variables)) return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $62xZn.NetworkStatus).setVariables);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        __DEV__ ? (0, $64dys.invariant)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0, $64dys.invariant)(pollInterval, 13);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            if (_this.pollingInfo) {
                if (!(0, $62xZn.isNetworkRequestInFlight)(_this.queryInfo.networkStatus)) _this.reobserve({
                    fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only'
                }, (0, $62xZn.NetworkStatus).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        this.last = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.last), {
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $bR2gQ.cloneDeep)(newResult),
            variables: variables
        });
        if (!(0, $8svBE.isNonEmptyArray)(newResult.errors)) delete this.last.error;
        return this.last;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === (0, $62xZn.NetworkStatus).refetch || newNetworkStatus === (0, $62xZn.NetworkStatus).fetchMore || newNetworkStatus === (0, $62xZn.NetworkStatus).poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $dnkFk.compact)(this.options, newOptions || {});
        var options = useDisposableConcast ? mergedOptions : $e0b3a4d1ab0de45a$var$assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions && newOptions.variables && !(0, $6EJag.equal)(newOptions.variables, oldVariables) && options.fetchPolicy !== "standby" && options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $62xZn.NetworkStatus).setVariables;
            }
        }
        var variables = options.variables && (0, $deWeK.__assign)({}, options.variables);
        var concast = this.fetch(options, newNetworkStatus);
        var observer = {
            next: function(result) {
                _this.reportResult(result, variables);
            },
            error: function(error) {
                _this.reportError(error, variables);
            }
        };
        if (!useDisposableConcast) {
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast.promise;
    };
    ObservableQuery.prototype.observe = function() {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
            (0, $49Jzz.iterateObserversSafely)(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var errorResult = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $62xZn.NetworkStatus).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $49Jzz.iterateObserversSafely)(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}((0, $bYo4v.Observable));
(0, $ipvgg.fixObservableSubclass)($e0b3a4d1ab0de45a$export$6c1b56eac59c9584);
function $e0b3a4d1ab0de45a$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        nextFetchPolicy: function() {
            this.nextFetchPolicy = nextFetchPolicy;
            if (typeof nextFetchPolicy === "function") return nextFetchPolicy.apply(this, arguments);
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $e0b3a4d1ab0de45a$var$defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && (0, $64dys.invariant).error('Unhandled error', error.message, error.stack);
}
function $e0b3a4d1ab0de45a$export$b7e1973aacac3ae7(missing) {
    if (__DEV__ && missing) __DEV__ && (0, $64dys.invariant).debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
}

});
parcelRegister("62xZn", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $01228979d0236969$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isNetworkRequestInFlight", () => $01228979d0236969$export$37509604341a3464);
var $01228979d0236969$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($01228979d0236969$export$bd096ddbd246c79c || ($01228979d0236969$export$bd096ddbd246c79c = {}));
function $01228979d0236969$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}

});


parcelRegister("7RuIi", function(module, exports) {

$parcel$export(module.exports, "LocalState", () => $5b954eb7e65b474f$export$19901bcd339c3ded);

var $deWeK = parcelRequire("deWeK");
parcelRequire("6TVLx");
var $64dys = parcelRequire("64dys");

var $4IPRa = parcelRequire("4IPRa");
var $dzsIS = parcelRequire("dzsIS");

var $7QVo3 = parcelRequire("7QVo3");
var $ctUe3 = parcelRequire("ctUe3");
var $chK20 = parcelRequire("chK20");
var $8HL2O = parcelRequire("8HL2O");
var $4f7Lj = parcelRequire("4f7Lj");
var $lVr1f = parcelRequire("lVr1f");

var $aHxuU = parcelRequire("aHxuU");
var $5b954eb7e65b474f$export$19901bcd339c3ded = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $lVr1f.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $lVr1f.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
            return (0, $deWeK.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $4f7Lj.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return (0, $ctUe3.removeClientSetsFromDocument)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
            return (0, $deWeK.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $deWeK.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $4IPRa.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $4IPRa.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $ctUe3.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0, $deWeK.__generator)(this, function(_b) {
                mainDefinition = (0, $8HL2O.getMainDefinition)(document);
                fragments = (0, $8HL2O.getFragmentDefinitions)(document);
                fragmentMap = (0, $chK20.createFragmentMap)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $deWeK.__assign)((0, $deWeK.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $deWeK.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $deWeK.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $deWeK.__generator)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) return [
                                2
                            ];
                            if (!(0, $4f7Lj.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $7QVo3.isField)(selection)) return [
                                2,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $7QVo3.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $7QVo3.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                __DEV__ ? (0, $64dys.invariant)(fragment, "No fragment named ".concat(selection.name.value)) : (0, $64dys.invariant)(fragment, 11);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $lVr1f.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $deWeK.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $deWeK.__generator)(this, function(_a) {
                if (!rootValue) return [
                    2,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $7QVo3.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve((0, $aHxuU.cacheSlot).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $7QVo3.argumentsObjectFromField)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === 'client';
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $4IPRa.visit)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === 'client') ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $dzsIS.isSelectionNode)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        __DEV__ ? (0, $64dys.invariant)(fragment, "No fragment named ".concat(spread.name.value)) : (0, $64dys.invariant)(fragment, 12);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $dzsIS.isSelectionNode)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();

});
parcelRegister("dzsIS", function(module, exports) {

$parcel$export(module.exports, "isSelectionNode", () => $157eb40fe5ef2a97$export$65772b71e1d017ba);

var $9bJMq = parcelRequire("9bJMq");
function $157eb40fe5ef2a97$export$e7ecd7c16613ccfd(node) {
    return $157eb40fe5ef2a97$export$4cedd8740794bd78(node) || $157eb40fe5ef2a97$export$b05c7141ec7770ba(node) || $157eb40fe5ef2a97$export$fbc18e88163d676d(node);
}
function $157eb40fe5ef2a97$export$4cedd8740794bd78(node) {
    return node.kind === (0, $9bJMq.Kind).OPERATION_DEFINITION || node.kind === (0, $9bJMq.Kind).FRAGMENT_DEFINITION;
}
function $157eb40fe5ef2a97$export$65772b71e1d017ba(node) {
    return node.kind === (0, $9bJMq.Kind).FIELD || node.kind === (0, $9bJMq.Kind).FRAGMENT_SPREAD || node.kind === (0, $9bJMq.Kind).INLINE_FRAGMENT;
}
function $157eb40fe5ef2a97$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $9bJMq.Kind).VARIABLE || node.kind === (0, $9bJMq.Kind).INT || node.kind === (0, $9bJMq.Kind).FLOAT || node.kind === (0, $9bJMq.Kind).STRING || node.kind === (0, $9bJMq.Kind).BOOLEAN || node.kind === (0, $9bJMq.Kind).NULL || node.kind === (0, $9bJMq.Kind).ENUM || node.kind === (0, $9bJMq.Kind).LIST || node.kind === (0, $9bJMq.Kind).OBJECT;
}
function $157eb40fe5ef2a97$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $9bJMq.Kind).NAMED_TYPE || node.kind === (0, $9bJMq.Kind).LIST_TYPE || node.kind === (0, $9bJMq.Kind).NON_NULL_TYPE;
}
function $157eb40fe5ef2a97$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $9bJMq.Kind).SCHEMA_DEFINITION || $157eb40fe5ef2a97$export$a3584bba04f5bfe0(node) || node.kind === (0, $9bJMq.Kind).DIRECTIVE_DEFINITION;
}
function $157eb40fe5ef2a97$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $9bJMq.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $9bJMq.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $9bJMq.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $9bJMq.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $9bJMq.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $9bJMq.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $157eb40fe5ef2a97$export$fbc18e88163d676d(node) {
    return node.kind === (0, $9bJMq.Kind).SCHEMA_EXTENSION || $157eb40fe5ef2a97$export$d7907721b241e11f(node);
}
function $157eb40fe5ef2a97$export$d7907721b241e11f(node) {
    return node.kind === (0, $9bJMq.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $9bJMq.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $9bJMq.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $9bJMq.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $9bJMq.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $9bJMq.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("dstPT", function(module, exports) {

$parcel$export(module.exports, "QueryInfo", () => $9cc508b708560260$export$79a6120a39c90b6a);
$parcel$export(module.exports, "shouldWriteResult", () => $9cc508b708560260$export$5f47a9fb9a521654);

var $deWeK = parcelRequire("deWeK");

var $6EJag = parcelRequire("6EJag");

var $8uSJ8 = parcelRequire("8uSJ8");
var $lVr1f = parcelRequire("lVr1f");
var $j90bg = parcelRequire("j90bg");
var $8svBE = parcelRequire("8svBE");

var $lmsxK = parcelRequire("lmsxK");

var $ji55q = parcelRequire("ji55q");

var $62xZn = parcelRequire("62xZn");
var $9cc508b708560260$var$destructiveMethodCounts = new ((0, $8uSJ8.canUseWeakMap) ? WeakMap : Map)();
function $9cc508b708560260$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") cache[methodName] = function() {
        $9cc508b708560260$var$destructiveMethodCounts.set(cache, ($9cc508b708560260$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        return original.apply(this, arguments);
    };
}
function $9cc508b708560260$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var $9cc508b708560260$export$79a6120a39c90b6a = function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!$9cc508b708560260$var$destructiveMethodCounts.has(cache)) {
            $9cc508b708560260$var$destructiveMethodCounts.set(cache, 0);
            $9cc508b708560260$var$wrapDestructiveCacheMethod(cache, "evict");
            $9cc508b708560260$var$wrapDestructiveCacheMethod(cache, "modify");
            $9cc508b708560260$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $62xZn.NetworkStatus).loading;
        if (this.variables && this.networkStatus !== (0, $62xZn.NetworkStatus).loading && !(0, $6EJag.equal)(this.variables, query.variables)) networkStatus = (0, $62xZn.NetworkStatus).setVariables;
        if (!(0, $6EJag.equal)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $9cc508b708560260$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function(variables) {
        if (variables === void 0) variables = this.variables;
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0, $6EJag.equal)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $6EJag.equal)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) oq["observe"]();
                else (0, $ji55q.reobserveCacheFirst)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $9cc508b708560260$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $62xZn.isNetworkRequestInFlight)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $deWeK.__assign)((0, $deWeK.__assign)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $6EJag.equal)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && lastWrite.dmCount === $9cc508b708560260$var$destructiveMethodCounts.get(this.cache) && (0, $6EJag.equal)(variables, lastWrite.variables) && (0, $6EJag.equal)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $lVr1f.DeepMerger)();
        var graphQLErrors = (0, $8svBE.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
        this.reset();
        if ('incremental' in result && (0, $8svBE.isNonEmptyArray)(result.incremental)) {
            var mergedData = (0, $lmsxK.mergeIncrementalData)(this.getDiff().result, result);
            result.data = mergedData;
        } else if ('hasNext' in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0) {
            if ($9cc508b708560260$export$5f47a9fb9a521654(result, options.errorPolicy)) this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $9cc508b708560260$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                if (!_this.stopped) _this.updateWatch(options.variables);
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $62xZn.NetworkStatus).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $62xZn.NetworkStatus).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $9cc508b708560260$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $j90bg.graphQLResultHasError)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}

});


parcelRegister("ed371", function(module, exports) {

$parcel$export(module.exports, "mergeOptions", () => $a584b19ce39a66ec$export$235b7fc70b9fc359);

var $deWeK = parcelRequire("deWeK");

var $dnkFk = parcelRequire("dnkFk");
function $a584b19ce39a66ec$export$235b7fc70b9fc359(defaults, options) {
    return (0, $dnkFk.compact)(defaults, options, options.variables && {
        variables: (0, $deWeK.__assign)((0, $deWeK.__assign)({}, defaults && defaults.variables), options.variables)
    });
}

});


parcelRegister("g72ol", function(module, exports) {

$parcel$export(module.exports, "concat", () => $bbaf27bb7e088e64$export$ee1b3e54f0441b22);

var $7xzZX = parcelRequire("7xzZX");
var $bbaf27bb7e088e64$export$ee1b3e54f0441b22 = (0, $7xzZX.ApolloLink).concat;

});

parcelRegister("kWadF", function(module, exports) {

$parcel$export(module.exports, "from", () => $f3e126ca0ec80353$export$6788812c4e6611e6);

var $7xzZX = parcelRequire("7xzZX");
var $f3e126ca0ec80353$export$6788812c4e6611e6 = (0, $7xzZX.ApolloLink).from;

});

parcelRegister("eSYTM", function(module, exports) {

$parcel$export(module.exports, "split", () => $ad6559106e78d900$export$65980d18b75784e2);

var $7xzZX = parcelRequire("7xzZX");
var $ad6559106e78d900$export$65980d18b75784e2 = (0, $7xzZX.ApolloLink).split;

});

parcelRegister("i5NEx", function(module, exports) {

$parcel$export(module.exports, "WebSocketLink", () => $d2bf359f351f3611$export$c6ec1f112bd949a0);

var $deWeK = parcelRequire("deWeK");

var $hoK3o = parcelRequire("hoK3o");

var $7xzZX = parcelRequire("7xzZX");
var $d2bf359f351f3611$export$c6ec1f112bd949a0 = function(_super) {
    (0, $deWeK.__extends)(WebSocketLink, _super);
    function WebSocketLink(paramsOrClient) {
        var _this = _super.call(this) || this;
        if (paramsOrClient instanceof (0, $hoK3o.SubscriptionClient)) _this.subscriptionClient = paramsOrClient;
        else _this.subscriptionClient = new (0, $hoK3o.SubscriptionClient)(paramsOrClient.uri, paramsOrClient.options, paramsOrClient.webSocketImpl);
        return _this;
    }
    WebSocketLink.prototype.request = function(operation) {
        return this.subscriptionClient.request(operation);
    };
    return WebSocketLink;
}((0, $7xzZX.ApolloLink));

});
parcelRegister("hoK3o", function(module, exports) {
"use strict";
var $caa866e0a32e6a05$var$__assign = module.exports && module.exports.__assign || function() {
    $caa866e0a32e6a05$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $caa866e0a32e6a05$var$__assign.apply(this, arguments);
};
var $caa866e0a32e6a05$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $caa866e0a32e6a05$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $caa866e0a32e6a05$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubscriptionClient = void 0;
var $caa866e0a32e6a05$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : {};
var $caa866e0a32e6a05$var$NativeWebSocket = $caa866e0a32e6a05$var$_global.WebSocket || $caa866e0a32e6a05$var$_global.MozWebSocket;

var $crdxH = parcelRequire("crdxH");

var $1jxBN = parcelRequire("1jxBN");

var $epOT8 = parcelRequire("epOT8");

var $hcpsC = parcelRequire("hcpsC");

var $gvmuT = parcelRequire("gvmuT");

var $lxbR6 = parcelRequire("lxbR6");

var $jdb97 = parcelRequire("jdb97");

var $bXcdn = parcelRequire("bXcdn");

var $aDkaO = parcelRequire("aDkaO");

var $epd4r = parcelRequire("epd4r");
var $caa866e0a32e6a05$var$SubscriptionClient = function() {
    function SubscriptionClient(url, options, webSocketImpl, webSocketProtocols) {
        var _a = options || {}, _b = _a.connectionCallback, connectionCallback = _b === void 0 ? undefined : _b, _c = _a.connectionParams, connectionParams = _c === void 0 ? {} : _c, _d = _a.minTimeout, minTimeout = _d === void 0 ? $aDkaO.MIN_WS_TIMEOUT : _d, _e = _a.timeout, timeout = _e === void 0 ? $aDkaO.WS_TIMEOUT : _e, _f = _a.reconnect, reconnect = _f === void 0 ? false : _f, _g = _a.reconnectionAttempts, reconnectionAttempts = _g === void 0 ? Infinity : _g, _h = _a.lazy, lazy = _h === void 0 ? false : _h, _j = _a.inactivityTimeout, inactivityTimeout = _j === void 0 ? 0 : _j, _k = _a.wsOptionArguments, wsOptionArguments = _k === void 0 ? [] : _k;
        this.wsImpl = webSocketImpl || $caa866e0a32e6a05$var$NativeWebSocket;
        if (!this.wsImpl) throw new Error('Unable to find native implementation, or alternative implementation for WebSocket!');
        this.wsProtocols = webSocketProtocols || $bXcdn.GRAPHQL_WS;
        this.connectionCallback = connectionCallback;
        this.url = url;
        this.operations = {};
        this.nextOperationId = 0;
        this.minWsTimeout = minTimeout;
        this.wsTimeout = timeout;
        this.unsentMessagesQueue = [];
        this.reconnect = reconnect;
        this.reconnecting = false;
        this.reconnectionAttempts = reconnectionAttempts;
        this.lazy = !!lazy;
        this.inactivityTimeout = inactivityTimeout;
        this.closedByUser = false;
        this.backoff = new $crdxH({
            jitter: 0.5
        });
        this.eventEmitter = new $1jxBN.EventEmitter();
        this.middlewares = [];
        this.client = null;
        this.maxConnectTimeGenerator = this.createMaxConnectTimeGenerator();
        this.connectionParams = this.getConnectionParams(connectionParams);
        this.wsOptionArguments = wsOptionArguments;
        if (!this.lazy) this.connect();
    }
    Object.defineProperty(SubscriptionClient.prototype, "status", {
        get: function() {
            if (this.client === null) return this.wsImpl.CLOSED;
            return this.client.readyState;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionClient.prototype.close = function(isForced, closedByUser) {
        if (isForced === void 0) isForced = true;
        if (closedByUser === void 0) closedByUser = true;
        this.clearInactivityTimeout();
        if (this.client !== null) {
            this.closedByUser = closedByUser;
            if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, $epd4r.default.GQL_CONNECTION_TERMINATE, null);
            }
            this.client.close();
            this.client.onopen = null;
            this.client.onclose = null;
            this.client.onerror = null;
            this.client.onmessage = null;
            this.client = null;
            this.eventEmitter.emit('disconnected');
            if (!isForced) this.tryReconnect();
        }
    };
    SubscriptionClient.prototype.request = function(request) {
        var _a;
        var getObserver = this.getObserver.bind(this);
        var executeOperation = this.executeOperation.bind(this);
        var unsubscribe = this.unsubscribe.bind(this);
        var opId;
        this.clearInactivityTimeout();
        return _a = {}, _a[$jdb97.default] = function() {
            return this;
        }, _a.subscribe = function(observerOrNext, onError, onComplete) {
            var observer = getObserver(observerOrNext, onError, onComplete);
            opId = executeOperation(request, function(error, result) {
                if (error === null && result === null) {
                    if (observer.complete) observer.complete();
                } else if (error) {
                    if (observer.error) observer.error(error[0]);
                } else if (observer.next) observer.next(result);
            });
            return {
                unsubscribe: function() {
                    if (opId) {
                        unsubscribe(opId);
                        opId = null;
                    }
                }
            };
        }, _a;
    };
    SubscriptionClient.prototype.on = function(eventName, callback, context) {
        var handler = this.eventEmitter.on(eventName, callback, context);
        return function() {
            handler.off(eventName, callback, context);
        };
    };
    SubscriptionClient.prototype.onConnected = function(callback, context) {
        return this.on('connected', callback, context);
    };
    SubscriptionClient.prototype.onConnecting = function(callback, context) {
        return this.on('connecting', callback, context);
    };
    SubscriptionClient.prototype.onDisconnected = function(callback, context) {
        return this.on('disconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnected = function(callback, context) {
        return this.on('reconnected', callback, context);
    };
    SubscriptionClient.prototype.onReconnecting = function(callback, context) {
        return this.on('reconnecting', callback, context);
    };
    SubscriptionClient.prototype.onError = function(callback, context) {
        return this.on('error', callback, context);
    };
    SubscriptionClient.prototype.unsubscribeAll = function() {
        var _this = this;
        Object.keys(this.operations).forEach(function(subId) {
            _this.unsubscribe(subId);
        });
    };
    SubscriptionClient.prototype.applyMiddlewares = function(options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var queue = function(funcs, scope) {
                var next = function(error) {
                    if (error) reject(error);
                    else if (funcs.length > 0) {
                        var f = funcs.shift();
                        if (f) f.applyMiddleware.apply(scope, [
                            options,
                            next
                        ]);
                    } else resolve(options);
                };
                next();
            };
            queue($caa866e0a32e6a05$var$__spreadArrays(_this.middlewares), _this);
        });
    };
    SubscriptionClient.prototype.use = function(middlewares) {
        var _this = this;
        middlewares.map(function(middleware) {
            if (typeof middleware.applyMiddleware === 'function') _this.middlewares.push(middleware);
            else throw new Error('Middleware must implement the applyMiddleware function.');
        });
        return this;
    };
    SubscriptionClient.prototype.getConnectionParams = function(connectionParams) {
        return function() {
            return new Promise(function(resolve, reject) {
                if (typeof connectionParams === 'function') try {
                    return resolve(connectionParams.call(null));
                } catch (error) {
                    return reject(error);
                }
                resolve(connectionParams);
            });
        };
    };
    SubscriptionClient.prototype.executeOperation = function(options, handler) {
        var _this = this;
        if (this.client === null) this.connect();
        var opId = this.generateOperationId();
        this.operations[opId] = {
            options: options,
            handler: handler
        };
        this.applyMiddlewares(options).then(function(processedOptions) {
            _this.checkOperationOptions(processedOptions, handler);
            if (_this.operations[opId]) {
                _this.operations[opId] = {
                    options: processedOptions,
                    handler: handler
                };
                _this.sendMessage(opId, $epd4r.default.GQL_START, processedOptions);
            }
        }).catch(function(error) {
            _this.unsubscribe(opId);
            handler(_this.formatErrors(error));
        });
        return opId;
    };
    SubscriptionClient.prototype.getObserver = function(observerOrNext, error, complete) {
        if (typeof observerOrNext === 'function') return {
            next: function(v) {
                return observerOrNext(v);
            },
            error: function(e) {
                return error && error(e);
            },
            complete: function() {
                return complete && complete();
            }
        };
        return observerOrNext;
    };
    SubscriptionClient.prototype.createMaxConnectTimeGenerator = function() {
        var minValue = this.minWsTimeout;
        var maxValue = this.wsTimeout;
        return new $crdxH({
            min: minValue,
            max: maxValue,
            factor: 1.2
        });
    };
    SubscriptionClient.prototype.clearCheckConnectionInterval = function() {
        if (this.checkConnectionIntervalId) {
            clearInterval(this.checkConnectionIntervalId);
            this.checkConnectionIntervalId = null;
        }
    };
    SubscriptionClient.prototype.clearMaxConnectTimeout = function() {
        if (this.maxConnectTimeoutId) {
            clearTimeout(this.maxConnectTimeoutId);
            this.maxConnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearTryReconnectTimeout = function() {
        if (this.tryReconnectTimeoutId) {
            clearTimeout(this.tryReconnectTimeoutId);
            this.tryReconnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearInactivityTimeout = function() {
        if (this.inactivityTimeoutId) {
            clearTimeout(this.inactivityTimeoutId);
            this.inactivityTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.setInactivityTimeout = function() {
        var _this = this;
        if (this.inactivityTimeout > 0 && Object.keys(this.operations).length === 0) this.inactivityTimeoutId = setTimeout(function() {
            if (Object.keys(_this.operations).length === 0) _this.close();
        }, this.inactivityTimeout);
    };
    SubscriptionClient.prototype.checkOperationOptions = function(options, handler) {
        var query = options.query, variables = options.variables, operationName = options.operationName;
        if (!query) throw new Error('Must provide a query.');
        if (!handler) throw new Error('Must provide an handler.');
        if (!$epOT8.default(query) && !$lxbR6.getOperationAST(query, operationName) || operationName && !$epOT8.default(operationName) || variables && !$hcpsC.default(variables)) throw new Error("Incorrect option types. query must be a string or a document,`operationName` must be a string, and `variables` must be an object.");
    };
    SubscriptionClient.prototype.buildMessage = function(id, type, payload) {
        var payloadToReturn = payload && payload.query ? $caa866e0a32e6a05$var$__assign($caa866e0a32e6a05$var$__assign({}, payload), {
            query: typeof payload.query === 'string' ? payload.query : $gvmuT.print(payload.query)
        }) : payload;
        return {
            id: id,
            type: type,
            payload: payloadToReturn
        };
    };
    SubscriptionClient.prototype.formatErrors = function(errors) {
        if (Array.isArray(errors)) return errors;
        if (errors && errors.errors) return this.formatErrors(errors.errors);
        if (errors && errors.message) return [
            errors
        ];
        return [
            {
                name: 'FormatedError',
                message: 'Unknown error',
                originalError: errors
            }
        ];
    };
    SubscriptionClient.prototype.sendMessage = function(id, type, payload) {
        this.sendMessageRaw(this.buildMessage(id, type, payload));
    };
    SubscriptionClient.prototype.sendMessageRaw = function(message) {
        switch(this.status){
            case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                try {
                    JSON.parse(serializedMessage);
                } catch (e) {
                    this.eventEmitter.emit('error', new Error("Message must be JSON-serializable. Got: " + message));
                }
                this.client.send(serializedMessage);
                break;
            case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;
            default:
                if (!this.reconnecting) this.eventEmitter.emit('error', new Error("A message was not sent because socket is not connected, is closing or is already closed. Message was: " + JSON.stringify(message)));
        }
    };
    SubscriptionClient.prototype.generateOperationId = function() {
        return String(++this.nextOperationId);
    };
    SubscriptionClient.prototype.tryReconnect = function() {
        var _this = this;
        if (!this.reconnect || this.backoff.attempts >= this.reconnectionAttempts) return;
        if (!this.reconnecting) {
            Object.keys(this.operations).forEach(function(key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, $epd4r.default.GQL_START, _this.operations[key].options));
            });
            this.reconnecting = true;
        }
        this.clearTryReconnectTimeout();
        var delay = this.backoff.duration();
        this.tryReconnectTimeoutId = setTimeout(function() {
            _this.connect();
        }, delay);
    };
    SubscriptionClient.prototype.flushUnsentMessagesQueue = function() {
        var _this = this;
        this.unsentMessagesQueue.forEach(function(message) {
            _this.sendMessageRaw(message);
        });
        this.unsentMessagesQueue = [];
    };
    SubscriptionClient.prototype.checkConnection = function() {
        if (this.wasKeepAliveReceived) {
            this.wasKeepAliveReceived = false;
            return;
        }
        if (!this.reconnecting) this.close(false, true);
    };
    SubscriptionClient.prototype.checkMaxConnectTimeout = function() {
        var _this = this;
        this.clearMaxConnectTimeout();
        this.maxConnectTimeoutId = setTimeout(function() {
            if (_this.status !== _this.wsImpl.OPEN) {
                _this.reconnecting = true;
                _this.close(false, true);
            }
        }, this.maxConnectTimeGenerator.duration());
    };
    SubscriptionClient.prototype.connect = function() {
        var _a;
        var _this = this;
        this.client = new ((_a = this.wsImpl).bind.apply(_a, $caa866e0a32e6a05$var$__spreadArrays([
            void 0,
            this.url,
            this.wsProtocols
        ], this.wsOptionArguments)))();
        this.checkMaxConnectTimeout();
        this.client.onopen = function() {
            return $caa866e0a32e6a05$var$__awaiter(_this, void 0, void 0, function() {
                var connectionParams, error_1;
                return $caa866e0a32e6a05$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(this.status === this.wsImpl.OPEN)) return [
                                3,
                                4
                            ];
                            this.clearMaxConnectTimeout();
                            this.closedByUser = false;
                            this.eventEmitter.emit(this.reconnecting ? 'reconnecting' : 'connecting');
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                this.connectionParams()
                            ];
                        case 2:
                            connectionParams = _a.sent();
                            this.sendMessage(undefined, $epd4r.default.GQL_CONNECTION_INIT, connectionParams);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error_1 = _a.sent();
                            this.sendMessage(undefined, $epd4r.default.GQL_CONNECTION_ERROR, error_1);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        this.client.onclose = function() {
            if (!_this.closedByUser) _this.close(false, false);
        };
        this.client.onerror = function(err) {
            _this.eventEmitter.emit('error', err);
        };
        this.client.onmessage = function(_a) {
            var data = _a.data;
            _this.processReceivedData(data);
        };
    };
    SubscriptionClient.prototype.processReceivedData = function(receivedData) {
        var parsedMessage;
        var opId;
        try {
            parsedMessage = JSON.parse(receivedData);
            opId = parsedMessage.id;
        } catch (e) {
            throw new Error("Message must be JSON-parseable. Got: " + receivedData);
        }
        if ([
            $epd4r.default.GQL_DATA,
            $epd4r.default.GQL_COMPLETE,
            $epd4r.default.GQL_ERROR
        ].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
            this.unsubscribe(opId);
            return;
        }
        switch(parsedMessage.type){
            case $epd4r.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) this.connectionCallback(parsedMessage.payload);
                break;
            case $epd4r.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? 'reconnected' : 'connected', parsedMessage.payload);
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();
                if (this.connectionCallback) this.connectionCallback();
                break;
            case $epd4r.default.GQL_COMPLETE:
                var handler = this.operations[opId].handler;
                delete this.operations[opId];
                handler.call(this, null, null);
                break;
            case $epd4r.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;
            case $epd4r.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : $caa866e0a32e6a05$var$__assign($caa866e0a32e6a05$var$__assign({}, parsedMessage.payload), {
                    errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;
            case $epd4r.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === 'undefined';
                this.wasKeepAliveReceived = true;
                if (firstKA) this.checkConnection();
                if (this.checkConnectionIntervalId) {
                    clearInterval(this.checkConnectionIntervalId);
                    this.checkConnection();
                }
                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), this.wsTimeout);
                break;
            default:
                throw new Error('Invalid message type!');
        }
    };
    SubscriptionClient.prototype.unsubscribe = function(opId) {
        if (this.operations[opId]) {
            delete this.operations[opId];
            this.setInactivityTimeout();
            this.sendMessage(opId, $epd4r.default.GQL_STOP, undefined);
        }
    };
    return SubscriptionClient;
}();
module.exports.SubscriptionClient = $caa866e0a32e6a05$var$SubscriptionClient;

});
parcelRegister("crdxH", function(module, exports) {
/**
 * Expose `Backoff`.
 */ module.exports = $90e282f163731350$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $90e282f163731350$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $90e282f163731350$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $90e282f163731350$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $90e282f163731350$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $90e282f163731350$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $90e282f163731350$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});

parcelRegister("1jxBN", function(module, exports) {
'use strict';
var $0f51a2bf7171cec4$var$has = Object.prototype.hasOwnProperty, $0f51a2bf7171cec4$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $0f51a2bf7171cec4$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $0f51a2bf7171cec4$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $0f51a2bf7171cec4$var$Events().__proto__) $0f51a2bf7171cec4$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $0f51a2bf7171cec4$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $0f51a2bf7171cec4$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $0f51a2bf7171cec4$var$EE(fn, context || emitter, once), evt = $0f51a2bf7171cec4$var$prefix ? $0f51a2bf7171cec4$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $0f51a2bf7171cec4$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $0f51a2bf7171cec4$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $0f51a2bf7171cec4$var$EventEmitter() {
    this._events = new $0f51a2bf7171cec4$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($0f51a2bf7171cec4$var$has.call(events, name)) names.push($0f51a2bf7171cec4$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $0f51a2bf7171cec4$var$prefix ? $0f51a2bf7171cec4$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $0f51a2bf7171cec4$var$prefix ? $0f51a2bf7171cec4$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $0f51a2bf7171cec4$var$prefix ? $0f51a2bf7171cec4$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $0f51a2bf7171cec4$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $0f51a2bf7171cec4$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $0f51a2bf7171cec4$var$prefix ? $0f51a2bf7171cec4$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $0f51a2bf7171cec4$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $0f51a2bf7171cec4$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $0f51a2bf7171cec4$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $0f51a2bf7171cec4$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $0f51a2bf7171cec4$var$prefix ? $0f51a2bf7171cec4$var$prefix + event : event;
        if (this._events[evt]) $0f51a2bf7171cec4$var$clearEvent(this, evt);
    } else {
        this._events = new $0f51a2bf7171cec4$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$0f51a2bf7171cec4$var$EventEmitter.prototype.off = $0f51a2bf7171cec4$var$EventEmitter.prototype.removeListener;
$0f51a2bf7171cec4$var$EventEmitter.prototype.addListener = $0f51a2bf7171cec4$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$0f51a2bf7171cec4$var$EventEmitter.prefixed = $0f51a2bf7171cec4$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$0f51a2bf7171cec4$var$EventEmitter.EventEmitter = $0f51a2bf7171cec4$var$EventEmitter;
module.exports = $0f51a2bf7171cec4$var$EventEmitter;

});

parcelRegister("epOT8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a7eadfd7c1f481fe$var$isString(value) {
    return typeof value === 'string';
}
module.exports.default = $a7eadfd7c1f481fe$var$isString;

});

parcelRegister("hcpsC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $c8574e9719503eba$var$isObject(value) {
    return value !== null && typeof value === 'object';
}
module.exports.default = $c8574e9719503eba$var$isObject;

});

parcelRegister("gvmuT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $c040fe18d2dd7a05$var$print;

var $mLXtA = parcelRequire("mLXtA");

var $fQhTv = parcelRequire("fQhTv");
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $c040fe18d2dd7a05$var$print(ast) {
    return (0, $mLXtA.visit)(ast, {
        leave: $c040fe18d2dd7a05$var$printDocASTReducer
    });
} // TODO: provide better type coverage in future
var $c040fe18d2dd7a05$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $c040fe18d2dd7a05$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $c040fe18d2dd7a05$var$wrap('(', $c040fe18d2dd7a05$var$join(node.variableDefinitions, ', '), ')');
        var directives = $c040fe18d2dd7a05$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $c040fe18d2dd7a05$var$join([
            op,
            $c040fe18d2dd7a05$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $c040fe18d2dd7a05$var$wrap(' = ', defaultValue) + $c040fe18d2dd7a05$var$wrap(' ', $c040fe18d2dd7a05$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $c040fe18d2dd7a05$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return $c040fe18d2dd7a05$var$join([
            $c040fe18d2dd7a05$var$wrap('', alias, ': ') + name + $c040fe18d2dd7a05$var$wrap('(', $c040fe18d2dd7a05$var$join(args, ', '), ')'),
            $c040fe18d2dd7a05$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $c040fe18d2dd7a05$var$wrap(' ', $c040fe18d2dd7a05$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $c040fe18d2dd7a05$var$join([
            '...',
            $c040fe18d2dd7a05$var$wrap('on ', typeCondition),
            $c040fe18d2dd7a05$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($c040fe18d2dd7a05$var$wrap('(', $c040fe18d2dd7a05$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($c040fe18d2dd7a05$var$wrap('', $c040fe18d2dd7a05$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $fQhTv.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $c040fe18d2dd7a05$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $c040fe18d2dd7a05$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $c040fe18d2dd7a05$var$wrap('(', $c040fe18d2dd7a05$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $c040fe18d2dd7a05$var$join([
            'schema',
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(operationTypes)
        ], ' ');
    },
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $c040fe18d2dd7a05$var$join([
            'scalar',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $c040fe18d2dd7a05$var$join([
            'type',
            name,
            $c040fe18d2dd7a05$var$wrap('implements ', $c040fe18d2dd7a05$var$join(interfaces, ' & ')),
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($c040fe18d2dd7a05$var$hasMultilineItems(args) ? $c040fe18d2dd7a05$var$wrap('(\n', $c040fe18d2dd7a05$var$indent($c040fe18d2dd7a05$var$join(args, '\n')), '\n)') : $c040fe18d2dd7a05$var$wrap('(', $c040fe18d2dd7a05$var$join(args, ', '), ')')) + ': ' + type + $c040fe18d2dd7a05$var$wrap(' ', $c040fe18d2dd7a05$var$join(directives, ' '));
    }),
    InputValueDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $c040fe18d2dd7a05$var$join([
            name + ': ' + type,
            $c040fe18d2dd7a05$var$wrap('= ', defaultValue),
            $c040fe18d2dd7a05$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return $c040fe18d2dd7a05$var$join([
            'interface',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $c040fe18d2dd7a05$var$join([
            'union',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $c040fe18d2dd7a05$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $c040fe18d2dd7a05$var$join([
            'enum',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $c040fe18d2dd7a05$var$join([
            name,
            $c040fe18d2dd7a05$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $c040fe18d2dd7a05$var$join([
            'input',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $c040fe18d2dd7a05$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($c040fe18d2dd7a05$var$hasMultilineItems(args) ? $c040fe18d2dd7a05$var$wrap('(\n', $c040fe18d2dd7a05$var$indent($c040fe18d2dd7a05$var$join(args, '\n')), '\n)') : $c040fe18d2dd7a05$var$wrap('(', $c040fe18d2dd7a05$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $c040fe18d2dd7a05$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $c040fe18d2dd7a05$var$join([
            'extend schema',
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $c040fe18d2dd7a05$var$join([
            'extend scalar',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $c040fe18d2dd7a05$var$join([
            'extend type',
            name,
            $c040fe18d2dd7a05$var$wrap('implements ', $c040fe18d2dd7a05$var$join(interfaces, ' & ')),
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return $c040fe18d2dd7a05$var$join([
            'extend interface',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $c040fe18d2dd7a05$var$join([
            'extend union',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $c040fe18d2dd7a05$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $c040fe18d2dd7a05$var$join([
            'extend enum',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $c040fe18d2dd7a05$var$join([
            'extend input',
            name,
            $c040fe18d2dd7a05$var$join(directives, ' '),
            $c040fe18d2dd7a05$var$block(fields)
        ], ' ');
    }
};
function $c040fe18d2dd7a05$var$addDescription(cb) {
    return function(node) {
        return $c040fe18d2dd7a05$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $c040fe18d2dd7a05$var$join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function(x) {
        return x;
    }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $c040fe18d2dd7a05$var$block(array) {
    return array && array.length !== 0 ? '{\n' + $c040fe18d2dd7a05$var$indent($c040fe18d2dd7a05$var$join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function $c040fe18d2dd7a05$var$wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || '') : '';
}
function $c040fe18d2dd7a05$var$indent(maybeString) {
    return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}
function $c040fe18d2dd7a05$var$isMultiline(string) {
    return string.indexOf('\n') !== -1;
}
function $c040fe18d2dd7a05$var$hasMultilineItems(maybeArray) {
    return maybeArray && maybeArray.some($c040fe18d2dd7a05$var$isMultiline);
}

});
parcelRegister("mLXtA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $044741b4e52dd2df$var$visit;
module.exports.visitInParallel = $044741b4e52dd2df$var$visitInParallel;
module.exports.visitWithTypeInfo = $044741b4e52dd2df$var$visitWithTypeInfo;
module.exports.getVisitFn = $044741b4e52dd2df$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;

var $044741b4e52dd2df$var$_inspect = $044741b4e52dd2df$var$_interopRequireDefault((parcelRequire("lNMht")));
function $044741b4e52dd2df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $044741b4e52dd2df$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
module.exports.QueryDocumentKeys = $044741b4e52dd2df$var$QueryDocumentKeys;
var $044741b4e52dd2df$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $044741b4e52dd2df$var$BREAK;
function $044741b4e52dd2df$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $044741b4e52dd2df$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!$044741b4e52dd2df$var$isNode(node)) throw new Error('Invalid AST Node: ' + (0, $044741b4e52dd2df$var$_inspect.default)(node));
            var visitFn = $044741b4e52dd2df$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $044741b4e52dd2df$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ($044741b4e52dd2df$var$isNode(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $044741b4e52dd2df$var$isNode(maybeNode) {
    return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $044741b4e52dd2df$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (!skipping[i]) {
                var fn = $044741b4e52dd2df$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $044741b4e52dd2df$var$BREAK) skipping[i] = $044741b4e52dd2df$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (!skipping[i]) {
                    var fn = $044741b4e52dd2df$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $044741b4e52dd2df$var$BREAK) skipping[i] = $044741b4e52dd2df$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */ function $044741b4e52dd2df$var$visitWithTypeInfo(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = $044741b4e52dd2df$var$getVisitFn(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ($044741b4e52dd2df$var$isNode(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = $044741b4e52dd2df$var$getVisitFn(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $044741b4e52dd2df$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("lNMht", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fdf3a02a1a942685$var$inspect;

var $fdf3a02a1a942685$var$_nodejsCustomInspectSymbol = $fdf3a02a1a942685$var$_interopRequireDefault((parcelRequire("hiwce")));
function $fdf3a02a1a942685$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fdf3a02a1a942685$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fdf3a02a1a942685$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fdf3a02a1a942685$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fdf3a02a1a942685$var$_typeof(obj);
}
var $fdf3a02a1a942685$var$MAX_ARRAY_LENGTH = 10;
var $fdf3a02a1a942685$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $fdf3a02a1a942685$var$inspect(value) {
    return $fdf3a02a1a942685$var$formatValue(value, []);
}
function $fdf3a02a1a942685$var$formatValue(value, seenValues) {
    switch($fdf3a02a1a942685$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $fdf3a02a1a942685$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $fdf3a02a1a942685$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $fdf3a02a1a942685$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        // $FlowFixMe(>=0.90.0)
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $fdf3a02a1a942685$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $fdf3a02a1a942685$var$formatArray(value, seenValues);
    return $fdf3a02a1a942685$var$formatObject(value, seenValues);
}
function $fdf3a02a1a942685$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $fdf3a02a1a942685$var$MAX_RECURSIVE_DEPTH) return '[' + $fdf3a02a1a942685$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $fdf3a02a1a942685$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $fdf3a02a1a942685$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $fdf3a02a1a942685$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($fdf3a02a1a942685$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($fdf3a02a1a942685$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $fdf3a02a1a942685$var$getCustomFn(object) {
    var customInspectFn = object[String($fdf3a02a1a942685$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $fdf3a02a1a942685$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("hiwce", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $c97d17a44484acc9$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $c97d17a44484acc9$var$_default = $c97d17a44484acc9$var$nodejsCustomInspectSymbol;
module.exports.default = $c97d17a44484acc9$var$_default;

});



parcelRegister("fQhTv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dedentBlockStringValue = $b88997c11abebb9b$var$dedentBlockStringValue;
module.exports.getBlockStringIndentation = $b88997c11abebb9b$var$getBlockStringIndentation;
module.exports.printBlockString = $b88997c11abebb9b$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function $b88997c11abebb9b$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $b88997c11abebb9b$var$getBlockStringIndentation(lines);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $b88997c11abebb9b$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $b88997c11abebb9b$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join('\n');
} // @internal
function $b88997c11abebb9b$var$getBlockStringIndentation(lines) {
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $b88997c11abebb9b$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        if (commonIndent === null || indent < commonIndent) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    return commonIndent === null ? 0 : commonIndent;
}
function $b88997c11abebb9b$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === ' ' || str[i] === '\t'))i++;
    return i;
}
function $b88997c11abebb9b$var$isBlank(str) {
    return $b88997c11abebb9b$var$leadingWhitespace(str) === str.length;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */ function $b88997c11abebb9b$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("lxbR6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOperationAST = $fad5e04a0ec8ab5d$var$getOperationAST;

var $hdfWp = parcelRequire("hdfWp");
/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */ function $fad5e04a0ec8ab5d$var$getOperationAST(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === $hdfWp.Kind.OPERATION_DEFINITION) {
            if (!operationName) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (definition.name && definition.name.value === operationName) return definition;
        }
    }
    return operation;
}

});
parcelRegister("hdfWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $c880041de769bfc0$var$Kind = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ module.exports.Kind = $c880041de769bfc0$var$Kind;

});


parcelRegister("jdb97", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfc7e09e21b8dc56$export$2e2bcd8739ae039);
/* global window */ 
var $gGEjV = parcelRequire("gGEjV");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $gGEjV.default)(root);
var $dfc7e09e21b8dc56$export$2e2bcd8739ae039 = result;

});
parcelRegister("gGEjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c25fd85e7e649bc0$export$2e2bcd8739ae039);
function $c25fd85e7e649bc0$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("bXcdn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRAPHQL_SUBSCRIPTIONS = module.exports.GRAPHQL_WS = void 0;
var $8b3eadf86e285ba8$var$GRAPHQL_WS = 'graphql-ws';
module.exports.GRAPHQL_WS = $8b3eadf86e285ba8$var$GRAPHQL_WS;
var $8b3eadf86e285ba8$var$GRAPHQL_SUBSCRIPTIONS = 'graphql-subscriptions';
module.exports.GRAPHQL_SUBSCRIPTIONS = $8b3eadf86e285ba8$var$GRAPHQL_SUBSCRIPTIONS;

});

parcelRegister("aDkaO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WS_TIMEOUT = module.exports.MIN_WS_TIMEOUT = void 0;
var $7bdd31e70dc38789$var$MIN_WS_TIMEOUT = 1000;
module.exports.MIN_WS_TIMEOUT = $7bdd31e70dc38789$var$MIN_WS_TIMEOUT;
var $7bdd31e70dc38789$var$WS_TIMEOUT = 30000;
module.exports.WS_TIMEOUT = $7bdd31e70dc38789$var$WS_TIMEOUT;

});

parcelRegister("epd4r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a7cd8a063ab6f779$var$MessageTypes = function() {
    function MessageTypes() {
        throw new Error('Static Class');
    }
    MessageTypes.GQL_CONNECTION_INIT = 'connection_init';
    MessageTypes.GQL_CONNECTION_ACK = 'connection_ack';
    MessageTypes.GQL_CONNECTION_ERROR = 'connection_error';
    MessageTypes.GQL_CONNECTION_KEEP_ALIVE = 'ka';
    MessageTypes.GQL_CONNECTION_TERMINATE = 'connection_terminate';
    MessageTypes.GQL_START = 'start';
    MessageTypes.GQL_DATA = 'data';
    MessageTypes.GQL_ERROR = 'error';
    MessageTypes.GQL_COMPLETE = 'complete';
    MessageTypes.GQL_STOP = 'stop';
    MessageTypes.SUBSCRIPTION_START = 'subscription_start';
    MessageTypes.SUBSCRIPTION_DATA = 'subscription_data';
    MessageTypes.SUBSCRIPTION_SUCCESS = 'subscription_success';
    MessageTypes.SUBSCRIPTION_FAIL = 'subscription_fail';
    MessageTypes.SUBSCRIPTION_END = 'subscription_end';
    MessageTypes.INIT = 'init';
    MessageTypes.INIT_SUCCESS = 'init_success';
    MessageTypes.INIT_FAIL = 'init_fail';
    MessageTypes.KEEP_ALIVE = 'keepalive';
    return MessageTypes;
}();
module.exports.default = $a7cd8a063ab6f779$var$MessageTypes;

});



parcelRegister("gZgu2", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $c5df211eb27b1fc7$export$2f04de43fe27971a);

var $deWeK = parcelRequire("deWeK");

var $7xzZX = parcelRequire("7xzZX");
parcelRequire("ey0GP");
var $bYo4v = parcelRequire("bYo4v");
function $c5df211eb27b1fc7$export$2f04de43fe27971a(setter) {
    return new (0, $7xzZX.ApolloLink)(function(operation, forward) {
        var request = (0, $deWeK.__rest)(operation, []);
        return new (0, $bYo4v.Observable)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("7kaBr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deepCopy = module.exports.convertToPossibleTypes = void 0;
module.exports.importQuery = $5552a033252a3322$var$importQuery;

var $1t8Wn = parcelRequire("1t8Wn");

var $e8RRb = parcelRequire("e8RRb");
function $5552a033252a3322$var$importQuery(search) {
    const DOCUMENTS = $1t8Wn.Container.get($e8RRb.GraphqlDocuments);
    if (!DOCUMENTS[search]) throw new Error(`Missing query: ${search}`);
    return DOCUMENTS[search];
}
const $5552a033252a3322$var$convertToPossibleTypes = (introspectionQuery)=>introspectionQuery.__schema.types.reduce((acc, curr)=>Object.assign(Object.assign({}, acc), {
            [curr.name]: curr.possibleTypes.map((type)=>type.name)
        }), {});
module.exports.convertToPossibleTypes = $5552a033252a3322$var$convertToPossibleTypes;
/* Utility function helping us to get a new object using the apollo-store */ const $5552a033252a3322$var$deepCopy = (state)=>JSON.parse(JSON.stringify(state));
module.exports.deepCopy = $5552a033252a3322$var$deepCopy;

});



parcelRegister("j7eyO", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $dea9f732231bb7e8$export$3dede90624df3ba9);

var $1wVYm = parcelRequire("1wVYm");

var $iIZUt = parcelRequire("iIZUt");

var $5CoSH = parcelRequire("5CoSH");
function $dea9f732231bb7e8$export$3dede90624df3ba9(selector) {
    return (0, $5CoSH.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $iIZUt.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $1wVYm.innerFrom)(selector(err, $dea9f732231bb7e8$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

});


parcelRegister("7lFX5", function(module, exports) {

$parcel$export(module.exports, "isDevelopment", () => $6540850376291d7c$export$df77466336fe5355);
$parcel$export(module.exports, "ENVIRONMENT", () => $6540850376291d7c$export$be46596bc6608f3b);
const $6540850376291d7c$export$df77466336fe5355 = ()=>false;
const $6540850376291d7c$export$be46596bc6608f3b = {
    DOMAIN_NAME: 'graphql-server.com',
    GRAPH_URL: $6540850376291d7c$export$df77466336fe5355() ? 'http://localhost:9004/graphql' : 'https://pubsub.graphql-server.com/graphql',
    GRAPH_WS_URL: $6540850376291d7c$export$df77466336fe5355() ? 'ws://localhost:9000/subscriptions' : 'wss://pubsub.graphql-server.com/subscriptions',
    GOOGLE_API_KEY: "AIzaSyBIVE_Fj_cWeqM3_UcY0waucHfdj4ENf3U",
    GOOGLE_AUTH_DOMAIN: "graphql-server-9e3db.firebaseapp.com",
    GOOGLE_DATABASE_URL: "https://graphql-server-9e3db.firebaseio.com",
    GOOGLE_PROJECT_ID: "graphql-server-9e3db",
    GOOGLE_STORAGE_BUCKET: "graphql-server-9e3db.appspot.com",
    GOOGLE_MESSAGE_SENDER_ID: "962894804196",
    GOOGLE_APP_ID: "1:962894804196:web:ced2957e403596c1a728f1",
    GOOGLE_MEASURMENT_ID: undefined,
    SENTRY_DSN: undefined ?? 'https://2f2772c093124e3ea9ce2b1777c86e7f@sentry.io/1774993'
};

});

parcelRegister("crd5F", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds);

var $fWOqV = parcelRequire("fWOqV");

var $9fktW = parcelRequire("9fktW");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $9fktW.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $fWOqV.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $fWOqV.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();

});
parcelRegister("fWOqV", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);

var $kHHr4 = parcelRequire("kHHr4");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $kHHr4.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("kHHr4", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $f12984394f65798e$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $f12984394f65798e$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $f12984394f65798e$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $f12984394f65798e$export$8ad33f488b1ab046() {
    // @ts-ignore "npm" is injected by rollup during build process
    return "npm";
}

});


parcelRegister("9fktW", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $6bb5671339b34cad$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $6bb5671339b34cad$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $6bb5671339b34cad$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $6bb5671339b34cad$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $6bb5671339b34cad$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $6bb5671339b34cad$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $6bb5671339b34cad$var$isGlobalObj(window) || typeof self == 'object' && $6bb5671339b34cad$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $6bb5671339b34cad$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $6bb5671339b34cad$export$256479dc0cea61c4() {
    return $6bb5671339b34cad$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $6bb5671339b34cad$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $6bb5671339b34cad$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("cDzby", function(module, exports) {
$parcel$export(module.exports, "FirestoreDB", () => (parcelRequire("3gZZ5")).FirestoreDB);
$parcel$export(module.exports, "IotFlowsService", () => (parcelRequire("cNJGF")).IotFlowsService);
$parcel$export(module.exports, "IotService", () => (parcelRequire("2YViC")).IotService);
$parcel$export(module.exports, "LocalStorageService", () => (parcelRequire("2yHHh")).LocalStorageService);
$parcel$export(module.exports, "SocialModule", () => (parcelRequire("kWJha")).SocialModule);
$parcel$export(module.exports, "SocialService", () => (parcelRequire("97odG")).SocialService);
parcelRequire("e45ds");

});
parcelRegister("e45ds", function(module, exports) {
$parcel$export(module.exports, "FirestoreDB", () => (parcelRequire("3gZZ5")).FirestoreDB);
$parcel$export(module.exports, "SocialModule", () => (parcelRequire("kWJha")).SocialModule);
$parcel$export(module.exports, "SocialService", () => (parcelRequire("97odG")).SocialService);
$parcel$export(module.exports, "IotService", () => (parcelRequire("2YViC")).IotService);
$parcel$export(module.exports, "IotFlowsService", () => (parcelRequire("cNJGF")).IotFlowsService);
$parcel$export(module.exports, "LocalStorageService", () => (parcelRequire("2yHHh")).LocalStorageService);
parcelRequire("3auZ5");
parcelRequire("aNW6J");
parcelRequire("xtegK");
parcelRequire("dCd0u");
parcelRequire("5pp6R");
parcelRequire("gGEGx");

});
parcelRegister("3auZ5", function(module, exports) {
$parcel$export(module.exports, "FirestoreDB", () => (parcelRequire("3gZZ5")).FirestoreDB);
$parcel$export(module.exports, "SocialModule", () => (parcelRequire("kWJha")).SocialModule);
$parcel$export(module.exports, "SocialService", () => (parcelRequire("97odG")).SocialService);
parcelRequire("3gZZ5");
parcelRequire("kWJha");
parcelRequire("97odG");
parcelRequire("cQ02v");
parcelRequire("1JoXj");

});
parcelRegister("3gZZ5", function(module, exports) {

$parcel$export(module.exports, "FirestoreDB", () => $2622f27aca248cb6$export$810137c0d4bae87d);
$parcel$export(module.exports, "FirebaseDB", () => $2622f27aca248cb6$export$38c95526226ae95e);

var $1t8Wn = parcelRequire("1t8Wn");
const $2622f27aca248cb6$export$810137c0d4bae87d = new (0, $1t8Wn.InjectionToken)('firestore-database');
const $2622f27aca248cb6$export$38c95526226ae95e = new (0, $1t8Wn.InjectionToken)('firebase-database');

});

parcelRegister("kWJha", function(module, exports) {

$parcel$export(module.exports, "SocialModule", () => $f3fc584bd22cd571$export$a160666a9a51eeb5);
parcelRequire("bNhVg");
parcelRequire("aYeKz");
parcelRequire("hX7P2");

var $1t8Wn = parcelRequire("1t8Wn");

var $1MQ4j = parcelRequire("1MQ4j");

var $cQ02v = parcelRequire("cQ02v");

var $3gZZ5 = parcelRequire("3gZZ5");

var $97odG = parcelRequire("97odG");
var $f3fc584bd22cd571$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f3fc584bd22cd571$export$a160666a9a51eeb5 = /** @class */ (()=>{
    var SocialModule_1;
    let SocialModule = SocialModule_1 = class SocialModule {
        static forRoot(config) {
            try {
                $1MQ4j.initializeApp(config);
            } catch (e) {
                console.error(e);
            }
            return {
                module: SocialModule_1
            };
        }
    };
    SocialModule = SocialModule_1 = $f3fc584bd22cd571$var$__decorate([
        (0, $1t8Wn.Module)({
            components: [
                (0, $cQ02v.SocialLoginButtonComponent)
            ],
            providers: [
                (0, $97odG.SocialService),
                {
                    provide: (0, $3gZZ5.FirebaseDB),
                    useFactory: ()=>$1MQ4j.database()
                },
                {
                    provide: (0, $3gZZ5.FirestoreDB),
                    useFactory: ()=>$1MQ4j.firestore()
                }
            ]
        })
    ], SocialModule);
    return SocialModule;
})();

});
parcelRegister("bNhVg", function(module, exports) {
parcelRequire("ernjr");

});
parcelRegister("ernjr", function(module, exports) {

var $jJO2d = parcelRequire("jJO2d");
(function() {
    var k, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        a != Array.prototype && a != Object.prototype && (a[b] = c.value);
    };
    function ba(a) {
        a = [
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global,
            a
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        return globalThis;
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                e in c || (c[e] = {});
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a) {
        var b = 0;
        return function() {
            return b < a.length ? {
                done: !1,
                value: a[b++]
            } : {
                done: !0
            };
        };
    }
    function fa(a) {
        var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
        return b ? b.call(a) : {
            next: ea(a)
        };
    }
    da("Promise", function(a) {
        function b(g) {
            this.b = 0;
            this.c = void 0;
            this.a = [];
            var h = this.f();
            try {
                g(h.resolve, h.reject);
            } catch (m) {
                h.reject(m);
            }
        }
        function c() {
            this.a = null;
        }
        function d(g) {
            return g instanceof b ? g : new b(function(h) {
                h(g);
            });
        }
        if (a) return a;
        c.prototype.b = function(g) {
            if (null == this.a) {
                this.a = [];
                var h = this;
                this.c(function() {
                    h.g();
                });
            }
            this.a.push(g);
        };
        var e = ca.setTimeout;
        c.prototype.c = function(g) {
            e(g, 0);
        };
        c.prototype.g = function() {
            for(; this.a && this.a.length;){
                var g = this.a;
                this.a = [];
                for(var h = 0; h < g.length; ++h){
                    var m = g[h];
                    g[h] = null;
                    try {
                        m();
                    } catch (p) {
                        this.f(p);
                    }
                }
            }
            this.a = null;
        };
        c.prototype.f = function(g) {
            this.c(function() {
                throw g;
            });
        };
        b.prototype.f = function() {
            function g(p) {
                return function(v) {
                    m || (m = !0, p.call(h, v));
                };
            }
            var h = this, m = !1;
            return {
                resolve: g(this.m),
                reject: g(this.g)
            };
        };
        b.prototype.m = function(g) {
            if (g === this) this.g(new TypeError("A Promise cannot resolve to itself"));
            else if (g instanceof b) this.s(g);
            else {
                a: switch(typeof g){
                    case "object":
                        var h = null != g;
                        break a;
                    case "function":
                        h = !0;
                        break a;
                    default:
                        h = !1;
                }
                h ? this.u(g) : this.h(g);
            }
        };
        b.prototype.u = function(g) {
            var h = void 0;
            try {
                h = g.then;
            } catch (m) {
                this.g(m);
                return;
            }
            "function" == typeof h ? this.w(h, g) : this.h(g);
        };
        b.prototype.g = function(g) {
            this.i(2, g);
        };
        b.prototype.h = function(g) {
            this.i(1, g);
        };
        b.prototype.i = function(g, h) {
            if (0 != this.b) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.b);
            this.b = g;
            this.c = h;
            this.l();
        };
        b.prototype.l = function() {
            if (null != this.a) {
                for(var g = 0; g < this.a.length; ++g)f.b(this.a[g]);
                this.a = null;
            }
        };
        var f = new c;
        b.prototype.s = function(g) {
            var h = this.f();
            g.Oa(h.resolve, h.reject);
        };
        b.prototype.w = function(g, h) {
            var m = this.f();
            try {
                g.call(h, m.resolve, m.reject);
            } catch (p) {
                m.reject(p);
            }
        };
        b.prototype.then = function(g, h) {
            function m(A, Q) {
                return "function" == typeof A ? function(xa) {
                    try {
                        p(A(xa));
                    } catch (ud) {
                        v(ud);
                    }
                } : Q;
            }
            var p, v, C = new b(function(A, Q) {
                p = A;
                v = Q;
            });
            this.Oa(m(g, p), m(h, v));
            return C;
        };
        b.prototype.catch = function(g) {
            return this.then(void 0, g);
        };
        b.prototype.Oa = function(g, h) {
            function m() {
                switch(p.b){
                    case 1:
                        g(p.c);
                        break;
                    case 2:
                        h(p.c);
                        break;
                    default:
                        throw Error("Unexpected state: " + p.b);
                }
            }
            var p = this;
            null == this.a ? f.b(m) : this.a.push(m);
        };
        b.resolve = d;
        b.reject = function(g) {
            return new b(function(h, m) {
                m(g);
            });
        };
        b.race = function(g) {
            return new b(function(h, m) {
                for(var p = fa(g), v = p.next(); !v.done; v = p.next())d(v.value).Oa(h, m);
            });
        };
        b.all = function(g) {
            var h = fa(g), m = h.next();
            return m.done ? d([]) : new b(function(p, v) {
                function C(xa) {
                    return function(ud) {
                        A[xa] = ud;
                        Q--;
                        0 == Q && p(A);
                    };
                }
                var A = [], Q = 0;
                do A.push(void 0), Q++, d(m.value).Oa(C(A.length - 1), v), m = h.next();
                while (!m.done);
            });
        };
        return b;
    });
    var ha = ha || {}, l = this || self, ia = /^[\w+/_-]+[=]{0,2}$/, ja = null;
    function ka() {}
    function la(a) {
        var b = typeof a;
        if ("object" == b) {
            if (a) {
                if (a instanceof Array) return "array";
                if (a instanceof Object) return b;
                var c = Object.prototype.toString.call(a);
                if ("[object Window]" == c) return "object";
                if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
                if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
            } else return "null";
        } else if ("function" == b && "undefined" == typeof a.call) return "object";
        return b;
    }
    function ma(a) {
        var b = la(a);
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        return "function" == la(a);
    }
    function q(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function na(a) {
        return Object.prototype.hasOwnProperty.call(a, oa) && a[oa] || (a[oa] = ++pa);
    }
    var oa = "closure_uid_" + (1E9 * Math.random() >>> 0), pa = 0;
    function qa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ra(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function r(a, b, c) {
        Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? r = qa : r = ra;
        return r.apply(null, arguments);
    }
    function sa(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    var ta = Date.now || function() {
        return +new Date;
    };
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Za = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
    }
    function u(a, b, c) {
        this.code = ua + a;
        this.message = b || va[a] || "";
        this.a = c || null;
    }
    t(u, Error);
    u.prototype.v = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.a && (a.serverResponse = this.a);
        return a;
    };
    u.prototype.toJSON = function() {
        return this.v();
    };
    function wa(a) {
        var b = a && a.code;
        return b ? new u(b.substring(ua.length), a.message, a.serverResponse) : null;
    }
    var ua = "auth/", va = {
        "admin-restricted-operation": "This operation is restricted to administrators only.",
        "argument-error": "",
        "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        "code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
        "cordova-not-ready": "Cordova framework is not ready.",
        "cors-unsupported": "This browser is not supported.",
        "credential-already-in-use": "This credential is already associated with a different user account.",
        "custom-token-mismatch": "The custom token corresponds to a different audience.",
        "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        "email-change-needs-verification": "Multi-factor users must always have a verified email.",
        "email-already-in-use": "The email address is already in use by another account.",
        "expired-action-code": "The action code has expired. ",
        "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
        "internal-error": "An internal error has occurred.",
        "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        "invalid-app-id": "The mobile app identifier is not registed for the current project.",
        "invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        "invalid-auth-event": "An internal error has occurred.",
        "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
        "invalid-continue-uri": "The continue URL provided in the request is invalid.",
        "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
        "invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
        "invalid-email": "The email address is badly formatted.",
        "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
        "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
        "invalid-credential": "The supplied auth credential is malformed or has expired.",
        "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
        "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
        "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        "wrong-password": "The password is invalid or the user does not have a password.",
        "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
        "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        "invalid-provider-id": "The specified provider ID is invalid.",
        "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
        "invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
        "multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
        "multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
        "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
        "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
        "missing-continue-uri": "A continue URL must be provided in the request.",
        "missing-iframe-start": "An internal error has occurred.",
        "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
        "missing-multi-factor-info": "No second factor identifier is provided.",
        "missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
        "missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        "missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
        "missing-verification-id": "The phone auth credential was created with an empty verification ID.",
        "app-deleted": "This instance of FirebaseApp has been deleted.",
        "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
        "no-auth-event": "An internal error has occurred.",
        "no-such-provider": "User was not linked to an account with the given provider.",
        "null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
        "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
        "provider-already-linked": "User can only be linked to one identity for the given provider.",
        "quota-exceeded": "The project's quota for this operation has been exceeded.",
        "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
        "redirect-operation-pending": "A redirect sign-in operation is already pending.",
        "rejected-credential": "The request contains malformed or mismatching credentials.",
        "second-factor-already-in-use": "The second factor is already enrolled on this account.",
        "maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
        "tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
        timeout: "The operation has timed out.",
        "user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
        "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
        "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        "unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        "unsupported-persistence-type": "The current environment does not support the specified persistence type.",
        "unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
        "unverified-email": "The operation requires a verified email.",
        "user-cancelled": "The user did not grant your application the permissions it requested.",
        "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
        "user-disabled": "The user account has been disabled by an administrator.",
        "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
        "user-signed-out": "",
        "weak-password": "The password must be 6 characters long or more.",
        "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
    };
    var ya = {
        hd: {
            Ra: "https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "b"
        },
        pd: {
            Ra: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://securetoken.googleapis.com/v1/token",
            Ua: "https://identitytoolkit.googleapis.com/v2/",
            id: "p"
        },
        rd: {
            Ra: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "s"
        },
        sd: {
            Ra: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://test-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://test-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "t"
        }
    };
    function za(a) {
        for(var b in ya)if (ya[b].id === a) return a = ya[b], {
            firebaseEndpoint: a.Ra,
            secureTokenEndpoint: a.Xa,
            identityPlatformEndpoint: a.Ua
        };
        return null;
    }
    var Aa;
    Aa = za("__EID__") ? "__EID__" : void 0;
    function Ba(a) {
        if (!a) return !1;
        try {
            return !!a.$goog_Thenable;
        } catch (b) {
            return !1;
        }
    }
    function w(a) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, w);
        else {
            var b = Error().stack;
            b && (this.stack = b);
        }
        a && (this.message = String(a));
    }
    t(w, Error);
    w.prototype.name = "CustomError";
    function Ca(a, b) {
        a = a.split("%s");
        for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
        w.call(this, c + a[d]);
    }
    t(Ca, w);
    Ca.prototype.name = "AssertionError";
    function Da(a, b) {
        throw new Ca("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
    }
    function Ea(a, b) {
        this.c = a;
        this.f = b;
        this.b = 0;
        this.a = null;
    }
    Ea.prototype.get = function() {
        if (0 < this.b) {
            this.b--;
            var a = this.a;
            this.a = a.next;
            a.next = null;
        } else a = this.c();
        return a;
    };
    function Fa(a, b) {
        a.f(b);
        100 > a.b && (a.b++, b.next = a.a, a.a = b);
    }
    function Ga() {
        this.b = this.a = null;
    }
    var Ia = new Ea(function() {
        return new Ha;
    }, function(a) {
        a.reset();
    });
    Ga.prototype.add = function(a, b) {
        var c = Ia.get();
        c.set(a, b);
        this.b ? this.b.next = c : this.a = c;
        this.b = c;
    };
    function Ja() {
        var a = Ka, b = null;
        a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
        return b;
    }
    function Ha() {
        this.next = this.b = this.a = null;
    }
    Ha.prototype.set = function(a, b) {
        this.a = a;
        this.b = b;
        this.next = null;
    };
    Ha.prototype.reset = function() {
        this.next = this.b = this.a = null;
    };
    var La = Array.prototype.indexOf ? function(a, b) {
        return Array.prototype.indexOf.call(a, b, void 0);
    } : function(a, b) {
        if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
        for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
        return -1;
    }, x = Array.prototype.forEach ? function(a, b, c) {
        Array.prototype.forEach.call(a, b, c);
    } : function(a, b, c) {
        for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
    };
    function Ma(a, b) {
        for(var c = "string" === typeof a ? a.split("") : a, d = a.length - 1; 0 <= d; --d)d in c && b.call(void 0, c[d], d, a);
    }
    var Na = Array.prototype.filter ? function(a, b) {
        return Array.prototype.filter.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = [], e = 0, f = "string" === typeof a ? a.split("") : a, g = 0; g < c; g++)if (g in f) {
            var h = f[g];
            b.call(void 0, h, g, a) && (d[e++] = h);
        }
        return d;
    }, Oa = Array.prototype.map ? function(a, b) {
        return Array.prototype.map.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = Array(c), e = "string" === typeof a ? a.split("") : a, f = 0; f < c; f++)f in e && (d[f] = b.call(void 0, e[f], f, a));
        return d;
    }, Pa = Array.prototype.some ? function(a, b) {
        return Array.prototype.some.call(a, b, void 0);
    } : function(a, b) {
        for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) return !0;
        return !1;
    };
    function Qa(a) {
        a: {
            var b = Ra;
            for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
                b = e;
                break a;
            }
            b = -1;
        }
        return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
    }
    function Sa(a, b) {
        return 0 <= La(a, b);
    }
    function Ta(a, b) {
        b = La(a, b);
        var c;
        (c = 0 <= b) && Array.prototype.splice.call(a, b, 1);
        return c;
    }
    function Ua(a, b) {
        var c = 0;
        Ma(a, function(d, e) {
            b.call(void 0, d, e, a) && 1 == Array.prototype.splice.call(a, e, 1).length && c++;
        });
    }
    function Va(a) {
        return Array.prototype.concat.apply([], arguments);
    }
    function Wa(a) {
        var b = a.length;
        if (0 < b) {
            for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    var Xa = String.prototype.trim ? function(a) {
        return a.trim();
    } : function(a) {
        return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
    }, Ya = /&/g, Za = /</g, $a = />/g, ab = /"/g, bb = /'/g, cb = /\x00/g, db = /[\x00&<>"']/;
    function y(a, b) {
        return -1 != a.indexOf(b);
    }
    function eb(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    var fb;
    a: {
        var gb = l.navigator;
        if (gb) {
            var hb = gb.userAgent;
            if (hb) {
                fb = hb;
                break a;
            }
        }
        fb = "";
    }
    function z(a) {
        return y(fb, a);
    }
    function ib(a, b) {
        for(var c in a)b.call(void 0, a[c], c, a);
    }
    function jb(a) {
        for(var b in a)return !1;
        return !0;
    }
    function kb(a) {
        var b = {}, c;
        for(c in a)b[c] = a[c];
        return b;
    }
    var lb = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function B(a, b) {
        for(var c, d, e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(var f = 0; f < lb.length; f++)c = lb[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function mb(a, b) {
        a: {
            try {
                var c = a && a.ownerDocument, d = c && (c.defaultView || c.parentWindow);
                d = d || l;
                if (d.Element && d.Location) {
                    var e = d;
                    break a;
                }
            } catch (g) {}
            e = null;
        }
        if (e && "undefined" != typeof e[b] && (!a || !(a instanceof e[b]) && (a instanceof e.Location || a instanceof e.Element))) {
            if (q(a)) try {
                var f = a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
            } catch (g) {
                f = "<object could not be stringified>";
            }
            else f = void 0 === a ? "undefined" : null === a ? "null" : typeof a;
            Da("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, f);
        }
    }
    function nb(a, b) {
        this.a = a === ob && b || "";
        this.b = pb;
    }
    nb.prototype.ra = !0;
    nb.prototype.qa = function() {
        return this.a;
    };
    nb.prototype.toString = function() {
        return "Const{" + this.a + "}";
    };
    function qb(a) {
        if (a instanceof nb && a.constructor === nb && a.b === pb) return a.a;
        Da("expected object of type Const, got '" + a + "'");
        return "type_error:Const";
    }
    var pb = {}, ob = {}, rb = new nb(ob, "");
    function sb(a, b) {
        this.a = a === tb && b || "";
        this.b = ub;
    }
    sb.prototype.ra = !0;
    sb.prototype.qa = function() {
        return this.a.toString();
    };
    sb.prototype.toString = function() {
        return "TrustedResourceUrl{" + this.a + "}";
    };
    function vb(a) {
        if (a instanceof sb && a.constructor === sb && a.b === ub) return a.a;
        Da("expected object of type TrustedResourceUrl, got '" + a + "' of type " + la(a));
        return "type_error:TrustedResourceUrl";
    }
    function wb(a, b) {
        var c = qb(a);
        if (!xb.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
        a = c.replace(yb, function(d, e) {
            if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
            d = b[e];
            return d instanceof nb ? qb(d) : encodeURIComponent(String(d));
        });
        return new sb(tb, a);
    }
    var yb = /%{(\w+)}/g, xb = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, ub = {}, tb = {};
    function zb(a, b) {
        this.a = a === Ab && b || "";
        this.b = Bb;
    }
    zb.prototype.ra = !0;
    zb.prototype.qa = function() {
        return this.a.toString();
    };
    zb.prototype.toString = function() {
        return "SafeUrl{" + this.a + "}";
    };
    function Cb(a) {
        if (a instanceof zb && a.constructor === zb && a.b === Bb) return a.a;
        Da("expected object of type SafeUrl, got '" + a + "' of type " + la(a));
        return "type_error:SafeUrl";
    }
    var Db = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
    function Eb(a) {
        if (a instanceof zb) return a;
        a = "object" == typeof a && a.ra ? a.qa() : String(a);
        Db.test(a) || (a = "about:invalid#zClosurez");
        return new zb(Ab, a);
    }
    var Bb = {}, Ab = {};
    function Fb() {
        this.a = "";
        this.b = Gb;
    }
    Fb.prototype.ra = !0;
    Fb.prototype.qa = function() {
        return this.a.toString();
    };
    Fb.prototype.toString = function() {
        return "SafeHtml{" + this.a + "}";
    };
    function Hb(a) {
        if (a instanceof Fb && a.constructor === Fb && a.b === Gb) return a.a;
        Da("expected object of type SafeHtml, got '" + a + "' of type " + la(a));
        return "type_error:SafeHtml";
    }
    var Gb = {};
    function Ib(a) {
        var b = new Fb;
        b.a = a;
        return b;
    }
    Ib("<!DOCTYPE html>");
    var Jb = Ib("");
    Ib("<br>");
    function Kb(a) {
        var b = new sb(tb, qb(rb));
        mb(a, "HTMLIFrameElement");
        a.src = vb(b).toString();
    }
    function Lb(a, b) {
        mb(a, "HTMLScriptElement");
        a.src = vb(b);
        if (null === ja) b: {
            b = l.document;
            if ((b = b.querySelector && b.querySelector("script[nonce]")) && (b = b.nonce || b.getAttribute("nonce")) && ia.test(b)) {
                ja = b;
                break b;
            }
            ja = "";
        }
        b = ja;
        b && a.setAttribute("nonce", b);
    }
    function Mb(a, b) {
        for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
        return d + c.join("%s");
    }
    function Nb(a) {
        db.test(a) && (-1 != a.indexOf("&") && (a = a.replace(Ya, "&amp;")), -1 != a.indexOf("<") && (a = a.replace(Za, "&lt;")), -1 != a.indexOf(">") && (a = a.replace($a, "&gt;")), -1 != a.indexOf('"') && (a = a.replace(ab, "&quot;")), -1 != a.indexOf("'") && (a = a.replace(bb, "&#39;")), -1 != a.indexOf("\x00") && (a = a.replace(cb, "&#0;")));
        return a;
    }
    function Ob(a) {
        Ob[" "](a);
        return a;
    }
    Ob[" "] = ka;
    function Pb(a, b) {
        var c = Qb;
        return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
    }
    var Rb = z("Opera"), Sb = z("Trident") || z("MSIE"), Tb = z("Edge"), Ub = Tb || Sb, Vb = z("Gecko") && !(y(fb.toLowerCase(), "webkit") && !z("Edge")) && !(z("Trident") || z("MSIE")) && !z("Edge"), Wb = y(fb.toLowerCase(), "webkit") && !z("Edge");
    function Xb() {
        var a = l.document;
        return a ? a.documentMode : void 0;
    }
    var Yb;
    a: {
        var Zb = "", $b = function() {
            var a = fb;
            if (Vb) return /rv:([^\);]+)(\)|;)/.exec(a);
            if (Tb) return /Edge\/([\d\.]+)/.exec(a);
            if (Sb) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
            if (Wb) return /WebKit\/(\S+)/.exec(a);
            if (Rb) return /(?:Version)[ \/]?(\S+)/.exec(a);
        }();
        $b && (Zb = $b ? $b[1] : "");
        if (Sb) {
            var ac = Xb();
            if (null != ac && ac > parseFloat(Zb)) {
                Yb = String(ac);
                break a;
            }
        }
        Yb = Zb;
    }
    var Qb = {};
    function bc(a) {
        return Pb(a, function() {
            for(var b = 0, c = Xa(String(Yb)).split("."), d = Xa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++){
                var g = c[f] || "", h = d[f] || "";
                do {
                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    h = /(\d*)(\D*)(.*)/.exec(h) || [
                        "",
                        "",
                        "",
                        ""
                    ];
                    if (0 == g[0].length && 0 == h[0].length) break;
                    b = eb(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || eb(0 == g[2].length, 0 == h[2].length) || eb(g[2], h[2]);
                    g = g[3];
                    h = h[3];
                }while (0 == b);
            }
            return 0 <= b;
        });
    }
    var cc;
    cc = l.document && Sb ? Xb() : void 0;
    try {
        new self.OffscreenCanvas(0, 0).getContext("2d");
    } catch (a) {}
    var dc = !Sb || 9 <= Number(cc);
    function ec(a) {
        var b = document;
        return "string" === typeof a ? b.getElementById(a) : a;
    }
    function fc(a, b) {
        ib(b, function(c, d) {
            c && "object" == typeof c && c.ra && (c = c.qa());
            "style" == d ? a.style.cssText = c : "class" == d ? a.className = c : "for" == d ? a.htmlFor = c : gc.hasOwnProperty(d) ? a.setAttribute(gc[d], c) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, c) : a[d] = c;
        });
    }
    var gc = {
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        colspan: "colSpan",
        frameborder: "frameBorder",
        height: "height",
        maxlength: "maxLength",
        nonce: "nonce",
        role: "role",
        rowspan: "rowSpan",
        type: "type",
        usemap: "useMap",
        valign: "vAlign",
        width: "width"
    };
    function hc(a, b, c) {
        var d = arguments, e = document, f = String(d[0]), g = d[1];
        if (!dc && g && (g.name || g.type)) {
            f = [
                "<",
                f
            ];
            g.name && f.push(' name="', Nb(g.name), '"');
            if (g.type) {
                f.push(' type="', Nb(g.type), '"');
                var h = {};
                B(h, g);
                delete h.type;
                g = h;
            }
            f.push(">");
            f = f.join("");
        }
        f = ic(e, f);
        g && ("string" === typeof g ? f.className = g : Array.isArray(g) ? f.className = g.join(" ") : fc(f, g));
        2 < d.length && jc(e, f, d);
        return f;
    }
    function jc(a, b, c) {
        function d(g) {
            g && b.appendChild("string" === typeof g ? a.createTextNode(g) : g);
        }
        for(var e = 2; e < c.length; e++){
            var f = c[e];
            !ma(f) || q(f) && 0 < f.nodeType ? d(f) : x(kc(f) ? Wa(f) : f, d);
        }
    }
    function ic(a, b) {
        b = String(b);
        "application/xhtml+xml" === a.contentType && (b = b.toLowerCase());
        return a.createElement(b);
    }
    function kc(a) {
        if (a && "number" == typeof a.length) {
            if (q(a)) return "function" == typeof a.item || "string" == typeof a.item;
            if (n(a)) return "function" == typeof a.item;
        }
        return !1;
    }
    function lc(a) {
        l.setTimeout(function() {
            throw a;
        }, 0);
    }
    var mc;
    function nc() {
        var a = l.MessageChannel;
        "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !z("Presto") && (a = function() {
            var e = ic(document, "IFRAME");
            e.style.display = "none";
            Kb(e);
            document.documentElement.appendChild(e);
            var f = e.contentWindow;
            e = f.document;
            e.open();
            e.write(Hb(Jb));
            e.close();
            var g = "callImmediate" + Math.random(), h = "file:" == f.location.protocol ? "*" : f.location.protocol + "//" + f.location.host;
            e = r(function(m) {
                if (("*" == h || m.origin == h) && m.data == g) this.port1.onmessage();
            }, this);
            f.addEventListener("message", e, !1);
            this.port1 = {};
            this.port2 = {
                postMessage: function() {
                    f.postMessage(g, h);
                }
            };
        });
        if ("undefined" !== typeof a && !z("Trident") && !z("MSIE")) {
            var b = new a, c = {}, d = c;
            b.port1.onmessage = function() {
                if (void 0 !== c.next) {
                    c = c.next;
                    var e = c.Db;
                    c.Db = null;
                    e();
                }
            };
            return function(e) {
                d.next = {
                    Db: e
                };
                d = d.next;
                b.port2.postMessage(0);
            };
        }
        return function(e) {
            l.setTimeout(e, 0);
        };
    }
    function oc(a, b) {
        pc || qc();
        rc || (pc(), rc = !0);
        Ka.add(a, b);
    }
    var pc;
    function qc() {
        if (l.Promise && l.Promise.resolve) {
            var a = l.Promise.resolve(void 0);
            pc = function() {
                a.then(sc);
            };
        } else pc = function() {
            var b = sc;
            !n(l.setImmediate) || l.Window && l.Window.prototype && !z("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? (mc || (mc = nc()), mc(b)) : l.setImmediate(b);
        };
    }
    var rc = !1, Ka = new Ga;
    function sc() {
        for(var a; a = Ja();){
            try {
                a.a.call(a.b);
            } catch (b) {
                lc(b);
            }
            Fa(Ia, a);
        }
        rc = !1;
    }
    function D(a, b) {
        this.a = tc;
        this.i = void 0;
        this.f = this.b = this.c = null;
        this.g = this.h = !1;
        if (a != ka) try {
            var c = this;
            a.call(b, function(d) {
                uc(c, vc, d);
            }, function(d) {
                if (!(d instanceof wc)) try {
                    if (d instanceof Error) throw d;
                    throw Error("Promise rejected.");
                } catch (e) {}
                uc(c, xc, d);
            });
        } catch (d) {
            uc(this, xc, d);
        }
    }
    var tc = 0, vc = 2, xc = 3;
    function yc() {
        this.next = this.f = this.b = this.g = this.a = null;
        this.c = !1;
    }
    yc.prototype.reset = function() {
        this.f = this.b = this.g = this.a = null;
        this.c = !1;
    };
    var zc = new Ea(function() {
        return new yc;
    }, function(a) {
        a.reset();
    });
    function Ac(a, b, c) {
        var d = zc.get();
        d.g = a;
        d.b = b;
        d.f = c;
        return d;
    }
    function E(a) {
        if (a instanceof D) return a;
        var b = new D(ka);
        uc(b, vc, a);
        return b;
    }
    function F(a) {
        return new D(function(b, c) {
            c(a);
        });
    }
    function Bc(a, b, c) {
        Cc(a, b, c, null) || oc(sa(b, a));
    }
    function Dc(a) {
        return new D(function(b, c) {
            var d = a.length, e = [];
            if (d) for(var f = function(p, v) {
                d--;
                e[p] = v;
                0 == d && b(e);
            }, g = function(p) {
                c(p);
            }, h = 0, m; h < a.length; h++)m = a[h], Bc(m, sa(f, h), g);
            else b(e);
        });
    }
    function Ec(a) {
        return new D(function(b) {
            var c = a.length, d = [];
            if (c) for(var e = function(h, m, p) {
                c--;
                d[h] = m ? {
                    Mb: !0,
                    value: p
                } : {
                    Mb: !1,
                    reason: p
                };
                0 == c && b(d);
            }, f = 0, g; f < a.length; f++)g = a[f], Bc(g, sa(e, f, !0), sa(e, f, !1));
            else b(d);
        });
    }
    D.prototype.then = function(a, b, c) {
        return Fc(this, n(a) ? a : null, n(b) ? b : null, c);
    };
    D.prototype.$goog_Thenable = !0;
    k = D.prototype;
    k.ma = function(a, b) {
        a = Ac(a, a, b);
        a.c = !0;
        Gc(this, a);
        return this;
    };
    k.o = function(a, b) {
        return Fc(this, null, a, b);
    };
    k.cancel = function(a) {
        if (this.a == tc) {
            var b = new wc(a);
            oc(function() {
                Hc(this, b);
            }, this);
        }
    };
    function Hc(a, b) {
        if (a.a == tc) {
            if (a.c) {
                var c = a.c;
                if (c.b) {
                    for(var d = 0, e = null, f = null, g = c.b; g && (g.c || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next)e || (f = g);
                    e && (c.a == tc && 1 == d ? Hc(c, b) : (f ? (d = f, d.next == c.f && (c.f = d), d.next = d.next.next) : Ic(c), Jc(c, e, xc, b)));
                }
                a.c = null;
            } else uc(a, xc, b);
        }
    }
    function Gc(a, b) {
        a.b || a.a != vc && a.a != xc || Kc(a);
        a.f ? a.f.next = b : a.b = b;
        a.f = b;
    }
    function Fc(a, b, c, d) {
        var e = Ac(null, null, null);
        e.a = new D(function(f, g) {
            e.g = b ? function(h) {
                try {
                    var m = b.call(d, h);
                    f(m);
                } catch (p) {
                    g(p);
                }
            } : f;
            e.b = c ? function(h) {
                try {
                    var m = c.call(d, h);
                    void 0 === m && h instanceof wc ? g(h) : f(m);
                } catch (p) {
                    g(p);
                }
            } : g;
        });
        e.a.c = a;
        Gc(a, e);
        return e.a;
    }
    k.Yc = function(a) {
        this.a = tc;
        uc(this, vc, a);
    };
    k.Zc = function(a) {
        this.a = tc;
        uc(this, xc, a);
    };
    function uc(a, b, c) {
        a.a == tc && (a === c && (b = xc, c = new TypeError("Promise cannot resolve to itself")), a.a = 1, Cc(c, a.Yc, a.Zc, a) || (a.i = c, a.a = b, a.c = null, Kc(a), b != xc || c instanceof wc || Lc(a, c)));
    }
    function Cc(a, b, c, d) {
        if (a instanceof D) return Gc(a, Ac(b || ka, c || null, d)), !0;
        if (Ba(a)) return a.then(b, c, d), !0;
        if (q(a)) try {
            var e = a.then;
            if (n(e)) return Mc(a, e, b, c, d), !0;
        } catch (f) {
            return c.call(d, f), !0;
        }
        return !1;
    }
    function Mc(a, b, c, d, e) {
        function f(m) {
            h || (h = !0, d.call(e, m));
        }
        function g(m) {
            h || (h = !0, c.call(e, m));
        }
        var h = !1;
        try {
            b.call(a, g, f);
        } catch (m) {
            f(m);
        }
    }
    function Kc(a) {
        a.h || (a.h = !0, oc(a.ec, a));
    }
    function Ic(a) {
        var b = null;
        a.b && (b = a.b, a.b = b.next, b.next = null);
        a.b || (a.f = null);
        return b;
    }
    k.ec = function() {
        for(var a; a = Ic(this);)Jc(this, a, this.a, this.i);
        this.h = !1;
    };
    function Jc(a, b, c, d) {
        if (c == xc && b.b && !b.c) for(; a && a.g; a = a.c)a.g = !1;
        if (b.a) b.a.c = null, Nc(b, c, d);
        else try {
            b.c ? b.g.call(b.f) : Nc(b, c, d);
        } catch (e) {
            Oc.call(null, e);
        }
        Fa(zc, b);
    }
    function Nc(a, b, c) {
        b == vc ? a.g.call(a.f, c) : a.b && a.b.call(a.f, c);
    }
    function Lc(a, b) {
        a.g = !0;
        oc(function() {
            a.g && Oc.call(null, b);
        });
    }
    var Oc = lc;
    function wc(a) {
        w.call(this, a);
    }
    t(wc, w);
    wc.prototype.name = "cancel";
    function Pc() {
        0 != Qc && (Rc[na(this)] = this);
        this.wa = this.wa;
        this.na = this.na;
    }
    var Qc = 0, Rc = {};
    Pc.prototype.wa = !1;
    function Sc(a) {
        if (!a.wa && (a.wa = !0, a.Ba(), 0 != Qc)) {
            var b = na(a);
            if (0 != Qc && a.na && 0 < a.na.length) throw Error(a + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
            delete Rc[b];
        }
    }
    Pc.prototype.Ba = function() {
        if (this.na) for(; this.na.length;)this.na.shift()();
    };
    var Tc = Object.freeze || function(a) {
        return a;
    };
    var Uc = !Sb || 9 <= Number(cc), Vc = Sb && !bc("9"), Wc = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            l.addEventListener("test", ka, b), l.removeEventListener("test", ka, b);
        } catch (c) {}
        return a;
    }();
    function Xc(a, b) {
        this.type = a;
        this.b = this.target = b;
        this.defaultPrevented = !1;
    }
    Xc.prototype.preventDefault = function() {
        this.defaultPrevented = !0;
    };
    function Yc(a, b) {
        Xc.call(this, a ? a.type : "");
        this.relatedTarget = this.b = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.pointerId = 0;
        this.pointerType = "";
        this.a = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.b = b;
            if (b = a.relatedTarget) {
                if (Vb) {
                    a: {
                        try {
                            Ob(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Zc[a.pointerType] || "";
            this.a = a;
            a.defaultPrevented && this.preventDefault();
        }
    }
    t(Yc, Xc);
    var Zc = Tc({
        2: "touch",
        3: "pen",
        4: "mouse"
    });
    Yc.prototype.preventDefault = function() {
        Yc.Za.preventDefault.call(this);
        var a = this.a;
        if (a.preventDefault) a.preventDefault();
        else if (a.returnValue = !1, Vc) try {
            if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
        } catch (b) {}
    };
    Yc.prototype.f = function() {
        return this.a;
    };
    var $c = "closure_listenable_" + (1E6 * Math.random() | 0), ad = 0;
    function bd(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.Ta = e;
        this.key = ++ad;
        this.ua = this.Na = !1;
    }
    function cd(a) {
        a.ua = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.Ta = null;
    }
    function dd(a) {
        this.src = a;
        this.a = {};
        this.b = 0;
    }
    dd.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.a[f];
        a || (a = this.a[f] = [], this.b++);
        var g = ed(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.Na = !1)) : (b = new bd(b, this.src, f, !!d, e), b.Na = c, a.push(b));
        return b;
    };
    function fd(a, b) {
        var c = b.type;
        c in a.a && Ta(a.a[c], b) && (cd(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
    function ed(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.ua && f.listener == b && f.capture == !!c && f.Ta == d) return e;
        }
        return -1;
    }
    var gd = "closure_lm_" + (1E6 * Math.random() | 0), hd = {}, id = 0;
    function jd(a, b, c, d, e) {
        if (d && d.once) kd(a, b, c, d, e);
        else if (Array.isArray(b)) for(var f = 0; f < b.length; f++)jd(a, b[f], c, d, e);
        else c = ld(c), a && a[$c] ? md(a, b, c, q(d) ? !!d.capture : !!d, e) : nd(a, b, c, !1, d, e);
    }
    function nd(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = q(e) ? !!e.capture : !!e, h = od(a);
        h || (a[gd] = h = new dd(a));
        c = h.add(b, c, d, g, f);
        if (!c.proxy) {
            d = pd();
            c.proxy = d;
            d.src = a;
            d.listener = c;
            if (a.addEventListener) Wc || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
            else if (a.attachEvent) a.attachEvent(qd(b.toString()), d);
            else if (a.addListener && a.removeListener) a.addListener(d);
            else throw Error("addEventListener and attachEvent are unavailable.");
            id++;
        }
    }
    function pd() {
        var a = rd, b = Uc ? function(c) {
            return a.call(b.src, b.listener, c);
        } : function(c) {
            c = a.call(b.src, b.listener, c);
            if (!c) return c;
        };
        return b;
    }
    function kd(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)kd(a, b[f], c, d, e);
        else c = ld(c), a && a[$c] ? sd(a, b, c, q(d) ? !!d.capture : !!d, e) : nd(a, b, c, !0, d, e);
    }
    function td(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)td(a, b[f], c, d, e);
        else (d = q(d) ? !!d.capture : !!d, c = ld(c), a && a[$c]) ? (a = a.u, b = String(b).toString(), b in a.a && (f = a.a[b], c = ed(f, c, d, e), -1 < c && (cd(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = od(a)) && (b = a.a[b.toString()], a = -1, b && (a = ed(b, c, d, e)), (c = -1 < a ? b[a] : null) && vd(c));
    }
    function vd(a) {
        if ("number" !== typeof a && a && !a.ua) {
            var b = a.src;
            if (b && b[$c]) fd(b.u, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(qd(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                id--;
                (c = od(b)) ? (fd(c, a), 0 == c.b && (c.src = null, b[gd] = null)) : cd(a);
            }
        }
    }
    function qd(a) {
        return a in hd ? hd[a] : hd[a] = "on" + a;
    }
    function wd(a, b, c, d) {
        var e = !0;
        if (a = od(a)) {
            if (b = a.a[b.toString()]) for(b = b.concat(), a = 0; a < b.length; a++){
                var f = b[a];
                f && f.capture == c && !f.ua && (f = xd(f, d), e = e && !1 !== f);
            }
        }
        return e;
    }
    function xd(a, b) {
        var c = a.listener, d = a.Ta || a.src;
        a.Na && vd(a);
        return c.call(d, b);
    }
    function rd(a, b) {
        if (a.ua) return !0;
        if (!Uc) {
            if (!b) a: {
                b = [
                    "window",
                    "event"
                ];
                for(var c = l, d = 0; d < b.length; d++)if (c = c[b[d]], null == c) {
                    b = null;
                    break a;
                }
                b = c;
            }
            d = b;
            b = new Yc(d, this);
            c = !0;
            if (!(0 > d.keyCode || void 0 != d.returnValue)) {
                a: {
                    var e = !1;
                    if (0 == d.keyCode) try {
                        d.keyCode = -1;
                        break a;
                    } catch (g) {
                        e = !0;
                    }
                    if (e || void 0 == d.returnValue) d.returnValue = !0;
                }
                d = [];
                for(e = b.b; e; e = e.parentNode)d.push(e);
                a = a.type;
                for(e = d.length - 1; 0 <= e; e--){
                    b.b = d[e];
                    var f = wd(d[e], a, !0, b);
                    c = c && f;
                }
                for(e = 0; e < d.length; e++)b.b = d[e], f = wd(d[e], a, !1, b), c = c && f;
            }
            return c;
        }
        return xd(a, new Yc(b, this));
    }
    function od(a) {
        a = a[gd];
        return a instanceof dd ? a : null;
    }
    var yd = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function ld(a) {
        if (n(a)) return a;
        a[yd] || (a[yd] = function(b) {
            return a.handleEvent(b);
        });
        return a[yd];
    }
    function G() {
        Pc.call(this);
        this.u = new dd(this);
        this.Yb = this;
        this.eb = null;
    }
    t(G, Pc);
    G.prototype[$c] = !0;
    G.prototype.addEventListener = function(a, b, c, d) {
        jd(this, a, b, c, d);
    };
    G.prototype.removeEventListener = function(a, b, c, d) {
        td(this, a, b, c, d);
    };
    G.prototype.dispatchEvent = function(a) {
        var b, c = this.eb;
        if (c) for(b = []; c; c = c.eb)b.push(c);
        c = this.Yb;
        var d = a.type || a;
        if ("string" === typeof a) a = new Xc(a, c);
        else if (a instanceof Xc) a.target = a.target || c;
        else {
            var e = a;
            a = new Xc(d, c);
            B(a, e);
        }
        e = !0;
        if (b) for(var f = b.length - 1; 0 <= f; f--){
            var g = a.b = b[f];
            e = zd(g, d, !0, a) && e;
        }
        g = a.b = c;
        e = zd(g, d, !0, a) && e;
        e = zd(g, d, !1, a) && e;
        if (b) for(f = 0; f < b.length; f++)g = a.b = b[f], e = zd(g, d, !1, a) && e;
        return e;
    };
    G.prototype.Ba = function() {
        G.Za.Ba.call(this);
        if (this.u) {
            var a = this.u, b = 0, c;
            for(c in a.a){
                for(var d = a.a[c], e = 0; e < d.length; e++)++b, cd(d[e]);
                delete a.a[c];
                a.b--;
            }
        }
        this.eb = null;
    };
    function md(a, b, c, d, e) {
        a.u.add(String(b), c, !1, d, e);
    }
    function sd(a, b, c, d, e) {
        a.u.add(String(b), c, !0, d, e);
    }
    function zd(a, b, c, d) {
        b = a.u.a[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.ua && g.capture == c) {
                var h = g.listener, m = g.Ta || g.src;
                g.Na && fd(a.u, g);
                e = !1 !== h.call(m, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Ad(a, b, c) {
        if (n(a)) c && (a = r(a, c));
        else if (a && "function" == typeof a.handleEvent) a = r(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : l.setTimeout(a, b || 0);
    }
    function Bd(a) {
        var b = null;
        return new D(function(c, d) {
            b = Ad(function() {
                c(void 0);
            }, a);
            -1 == b && d(Error("Failed to schedule timer."));
        }).o(function(c) {
            l.clearTimeout(b);
            throw c;
        });
    }
    function Cd(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("string" === typeof a) return a.split("");
        if (ma(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function Dd(a) {
        if (a.X && "function" == typeof a.X) return a.X();
        if (!a.V || "function" != typeof a.V) {
            if (ma(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(var d in a)b[c++] = d;
            return b;
        }
    }
    function Ed(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ma(a) || "string" === typeof a) x(a, b, void 0);
        else for(var c = Dd(a), d = Cd(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    function Fd(a, b) {
        this.b = {};
        this.a = [];
        this.c = 0;
        var c = arguments.length;
        if (1 < c) {
            if (c % 2) throw Error("Uneven number of arguments");
            for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
        } else if (a) {
            if (a instanceof Fd) for(c = a.X(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
            else for(d in a)this.set(d, a[d]);
        }
    }
    k = Fd.prototype;
    k.V = function() {
        Gd(this);
        for(var a = [], b = 0; b < this.a.length; b++)a.push(this.b[this.a[b]]);
        return a;
    };
    k.X = function() {
        Gd(this);
        return this.a.concat();
    };
    k.clear = function() {
        this.b = {};
        this.c = this.a.length = 0;
    };
    function Gd(a) {
        if (a.c != a.a.length) {
            for(var b = 0, c = 0; b < a.a.length;){
                var d = a.a[b];
                Hd(a.b, d) && (a.a[c++] = d);
                b++;
            }
            a.a.length = c;
        }
        if (a.c != a.a.length) {
            var e = {};
            for(c = b = 0; b < a.a.length;)d = a.a[b], Hd(e, d) || (a.a[c++] = d, e[d] = 1), b++;
            a.a.length = c;
        }
    }
    k.get = function(a, b) {
        return Hd(this.b, a) ? this.b[a] : b;
    };
    k.set = function(a, b) {
        Hd(this.b, a) || (this.c++, this.a.push(a));
        this.b[a] = b;
    };
    k.forEach = function(a, b) {
        for(var c = this.X(), d = 0; d < c.length; d++){
            var e = c[d], f = this.get(e);
            a.call(b, f, e, this);
        }
    };
    function Hd(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    var Id = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/\\#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
    function Jd(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function Kd(a, b) {
        this.b = this.i = this.f = "";
        this.l = null;
        this.g = this.c = "";
        this.h = !1;
        var c;
        a instanceof Kd ? (this.h = void 0 !== b ? b : a.h, Ld(this, a.f), this.i = a.i, this.b = a.b, Md(this, a.l), this.c = a.c, Nd(this, Od(a.a)), this.g = a.g) : a && (c = String(a).match(Id)) ? (this.h = !!b, Ld(this, c[1] || "", !0), this.i = Pd(c[2] || ""), this.b = Pd(c[3] || "", !0), Md(this, c[4]), this.c = Pd(c[5] || "", !0), Nd(this, c[6] || "", !0), this.g = Pd(c[7] || "")) : (this.h = !!b, this.a = new Qd(null, this.h));
    }
    Kd.prototype.toString = function() {
        var a = [], b = this.f;
        b && a.push(Rd(b, Sd, !0), ":");
        var c = this.b;
        if (c || "file" == b) a.push("//"), (b = this.i) && a.push(Rd(b, Sd, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.l, null != c && a.push(":", String(c));
        if (c = this.c) this.b && "/" != c.charAt(0) && a.push("/"), a.push(Rd(c, "/" == c.charAt(0) ? Td : Ud, !0));
        (c = this.a.toString()) && a.push("?", c);
        (c = this.g) && a.push("#", Rd(c, Vd));
        return a.join("");
    };
    Kd.prototype.resolve = function(a) {
        var b = new Kd(this), c = !!a.f;
        c ? Ld(b, a.f) : c = !!a.i;
        c ? b.i = a.i : c = !!a.b;
        c ? b.b = a.b : c = null != a.l;
        var d = a.c;
        if (c) Md(b, a.l);
        else if (c = !!a.c) {
            if ("/" != d.charAt(0)) {
                if (this.b && !this.c) d = "/" + d;
                else {
                    var e = b.c.lastIndexOf("/");
                    -1 != e && (d = b.c.substr(0, e + 1) + d);
                }
            }
            e = d;
            if (".." == e || "." == e) d = "";
            else if (y(e, "./") || y(e, "/.")) {
                d = 0 == e.lastIndexOf("/", 0);
                e = e.split("/");
                for(var f = [], g = 0; g < e.length;){
                    var h = e[g++];
                    "." == h ? d && g == e.length && f.push("") : ".." == h ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(h), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.c = d : c = "" !== a.a.toString();
        c ? Nd(b, Od(a.a)) : c = !!a.g;
        c && (b.g = a.g);
        return b;
    };
    function Ld(a, b, c) {
        a.f = c ? Pd(b, !0) : b;
        a.f && (a.f = a.f.replace(/:$/, ""));
    }
    function Md(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.l = b;
        } else a.l = null;
    }
    function Nd(a, b, c) {
        b instanceof Qd ? (a.a = b, Wd(a.a, a.h)) : (c || (b = Rd(b, Xd)), a.a = new Qd(b, a.h));
    }
    function H(a, b, c) {
        a.a.set(b, c);
    }
    function Yd(a, b) {
        return a.a.get(b);
    }
    function Zd(a) {
        return a instanceof Kd ? new Kd(a) : new Kd(a, void 0);
    }
    function $d(a, b) {
        var c = new Kd(null, void 0);
        Ld(c, "https");
        a && (c.b = a);
        b && (c.c = b);
        return c;
    }
    function Pd(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function Rd(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, ae), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function ae(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var Sd = /[#\/\?@]/g, Ud = /[#\?:]/g, Td = /[#\?]/g, Xd = /[#\?@]/g, Vd = /#/g;
    function Qd(a, b) {
        this.b = this.a = null;
        this.c = a || null;
        this.f = !!b;
    }
    function be(a) {
        a.a || (a.a = new Fd, a.b = 0, a.c && Jd(a.c, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    function ce(a) {
        var b = Dd(a);
        if ("undefined" == typeof b) throw Error("Keys are undefined");
        var c = new Qd(null, void 0);
        a = Cd(a);
        for(var d = 0; d < b.length; d++){
            var e = b[d], f = a[d];
            Array.isArray(f) ? de(c, e, f) : c.add(e, f);
        }
        return c;
    }
    k = Qd.prototype;
    k.add = function(a, b) {
        be(this);
        this.c = null;
        a = ee(this, a);
        var c = this.a.get(a);
        c || this.a.set(a, c = []);
        c.push(b);
        this.b += 1;
        return this;
    };
    function fe(a, b) {
        be(a);
        b = ee(a, b);
        Hd(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, Hd(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && Gd(a)));
    }
    k.clear = function() {
        this.a = this.c = null;
        this.b = 0;
    };
    function ge(a, b) {
        be(a);
        b = ee(a, b);
        return Hd(a.a.b, b);
    }
    k.forEach = function(a, b) {
        be(this);
        this.a.forEach(function(c, d) {
            x(c, function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    k.X = function() {
        be(this);
        for(var a = this.a.V(), b = this.a.X(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
        return c;
    };
    k.V = function(a) {
        be(this);
        var b = [];
        if ("string" === typeof a) ge(this, a) && (b = Va(b, this.a.get(ee(this, a))));
        else {
            a = this.a.V();
            for(var c = 0; c < a.length; c++)b = Va(b, a[c]);
        }
        return b;
    };
    k.set = function(a, b) {
        be(this);
        this.c = null;
        a = ee(this, a);
        ge(this, a) && (this.b -= this.a.get(a).length);
        this.a.set(a, [
            b
        ]);
        this.b += 1;
        return this;
    };
    k.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function de(a, b, c) {
        fe(a, b);
        0 < c.length && (a.c = null, a.a.set(ee(a, b), Wa(c)), a.b += c.length);
    }
    k.toString = function() {
        if (this.c) return this.c;
        if (!this.a) return "";
        for(var a = [], b = this.a.X(), c = 0; c < b.length; c++){
            var d = b[c], e = encodeURIComponent(String(d));
            d = this.V(d);
            for(var f = 0; f < d.length; f++){
                var g = e;
                "" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));
                a.push(g);
            }
        }
        return this.c = a.join("&");
    };
    function Od(a) {
        var b = new Qd;
        b.c = a.c;
        a.a && (b.a = new Fd(a.a), b.b = a.b);
        return b;
    }
    function ee(a, b) {
        b = String(b);
        a.f && (b = b.toLowerCase());
        return b;
    }
    function Wd(a, b) {
        b && !a.f && (be(a), a.c = null, a.a.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (fe(this, d), de(this, e, c));
        }, a));
        a.f = b;
    }
    function he(a) {
        var b = [];
        ie(new je, a, b);
        return b.join("");
    }
    function je() {}
    function ie(a, b, c) {
        if (null == b) c.push("null");
        else {
            if ("object" == typeof b) {
                if (Array.isArray(b)) {
                    var d = b;
                    b = d.length;
                    c.push("[");
                    for(var e = "", f = 0; f < b; f++)c.push(e), ie(a, d[f], c), e = ",";
                    c.push("]");
                    return;
                }
                if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();
                else {
                    c.push("{");
                    e = "";
                    for(d in b)Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), ke(d, c), c.push(":"), ie(a, f, c), e = ","));
                    c.push("}");
                    return;
                }
            }
            switch(typeof b){
                case "string":
                    ke(b, c);
                    break;
                case "number":
                    c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");
                    break;
                case "boolean":
                    c.push(String(b));
                    break;
                case "function":
                    c.push("null");
                    break;
                default:
                    throw Error("Unknown type: " + typeof b);
            }
        }
    }
    var le = {
        '"': '\\"',
        "\\": "\\\\",
        "/": "\\/",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t",
        "\x0B": "\\u000b"
    }, me = /\uffff/.test("\uffff") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
    function ke(a, b) {
        b.push('"', a.replace(me, function(c) {
            var d = le[c];
            d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).substr(1), le[c] = d);
            return d;
        }), '"');
    }
    function ne() {
        var a = I();
        return Sb && !!cc && 11 == cc || /Edge\/\d+/.test(a);
    }
    function oe() {
        return l.window && l.window.location.href || self && self.location && self.location.href || "";
    }
    function pe(a, b) {
        b = b || l.window;
        var c = "about:blank";
        a && (c = Cb(Eb(a)));
        b.location.href = c;
    }
    function qe(a, b) {
        var c = [], d;
        for(d in a)d in b ? typeof a[d] != typeof b[d] ? c.push(d) : "object" == typeof a[d] && null != a[d] && null != b[d] ? 0 < qe(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
        for(d in b)d in a || c.push(d);
        return c;
    }
    function re() {
        var a = I();
        a = se(a) != te ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;
        return a && 30 > a ? !1 : !Sb || !cc || 9 < cc;
    }
    function ue(a) {
        a = (a || I()).toLowerCase();
        return a.match(/android/) || a.match(/webos/) || a.match(/iphone|ipad|ipod/) || a.match(/blackberry/) || a.match(/windows phone/) || a.match(/iemobile/) ? !0 : !1;
    }
    function ve(a) {
        a = a || l.window;
        try {
            a.close();
        } catch (b) {}
    }
    function we(a, b, c) {
        var d = Math.floor(1E9 * Math.random()).toString();
        b = b || 500;
        c = c || 600;
        var e = (window.screen.availHeight - c) / 2, f = (window.screen.availWidth - b) / 2;
        b = {
            width: b,
            height: c,
            top: 0 < e ? e : 0,
            left: 0 < f ? f : 0,
            location: !0,
            resizable: !0,
            statusbar: !0,
            toolbar: !1
        };
        c = I().toLowerCase();
        d && (b.target = d, y(c, "crios/") && (b.target = "_blank"));
        se(I()) == xe && (a = a || "http://localhost", b.scrollbars = !0);
        c = a || "";
        (a = b) || (a = {});
        d = window;
        b = c instanceof zb ? c : Eb("undefined" != typeof c.href ? c.href : String(c));
        c = a.target || c.target;
        e = [];
        for(g in a)switch(g){
            case "width":
            case "height":
            case "top":
            case "left":
                e.push(g + "=" + a[g]);
                break;
            case "target":
            case "noopener":
            case "noreferrer":
                break;
            default:
                e.push(g + "=" + (a[g] ? 1 : 0));
        }
        var g = e.join(",");
        if ((z("iPhone") && !z("iPod") && !z("iPad") || z("iPad") || z("iPod")) && d.navigator && d.navigator.standalone && c && "_self" != c) g = ic(document, "A"), mb(g, "HTMLAnchorElement"), b instanceof zb || b instanceof zb || (b = "object" == typeof b && b.ra ? b.qa() : String(b), Db.test(b) || (b = "about:invalid#zClosurez"), b = new zb(Ab, b)), g.href = Cb(b), g.setAttribute("target", c), a.noreferrer && g.setAttribute("rel", "noreferrer"), a = document.createEvent("MouseEvent"), a.initMouseEvent("click", !0, !0, d, 1), g.dispatchEvent(a), g = {};
        else if (a.noreferrer) {
            if (g = d.open("", c, g), a = Cb(b), g && (Ub && y(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'"), g.opener = null, a = Ib('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + Nb(a) + '">'), d = g.document)) d.write(Hb(a)), d.close();
        } else (g = d.open(Cb(b), c, g)) && a.noopener && (g.opener = null);
        if (g) try {
            g.focus();
        } catch (h) {}
        return g;
    }
    function ye(a) {
        return new D(function(b) {
            function c() {
                Bd(2E3).then(function() {
                    if (!a || a.closed) b();
                    else return c();
                });
            }
            return c();
        });
    }
    var ze = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, Ae = /^[^@]+@[^@]+$/;
    function Be() {
        var a = null;
        return new D(function(b) {
            "complete" == l.document.readyState ? b() : (a = function() {
                b();
            }, kd(window, "load", a));
        }).o(function(b) {
            td(window, "load", a);
            throw b;
        });
    }
    function Ce() {
        return De(void 0) ? Be().then(function() {
            return new D(function(a, b) {
                var c = l.document, d = setTimeout(function() {
                    b(Error("Cordova framework is not ready."));
                }, 1E3);
                c.addEventListener("deviceready", function() {
                    clearTimeout(d);
                    a();
                }, !1);
            });
        }) : F(Error("Cordova must run in an Android or iOS file scheme."));
    }
    function De(a) {
        a = a || I();
        return !("file:" !== Ee() && "ionic:" !== Ee() || !a.toLowerCase().match(/iphone|ipad|ipod|android/));
    }
    function Fe() {
        var a = l.window;
        try {
            return !(!a || a == a.top);
        } catch (b) {
            return !1;
        }
    }
    function Ge() {
        return "undefined" !== typeof l.WorkerGlobalScope && "function" === typeof l.importScripts;
    }
    function He() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.hasOwnProperty("node") ? "Node" : Ge() ? "Worker" : "Browser";
    }
    function Ie() {
        var a = He();
        return "ReactNative" === a || "Node" === a;
    }
    function Je() {
        for(var a = 50, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    var xe = "Firefox", te = "Chrome";
    function se(a) {
        var b = a.toLowerCase();
        if (y(b, "opera/") || y(b, "opr/") || y(b, "opios/")) return "Opera";
        if (y(b, "iemobile")) return "IEMobile";
        if (y(b, "msie") || y(b, "trident/")) return "IE";
        if (y(b, "edge/")) return "Edge";
        if (y(b, "firefox/")) return xe;
        if (y(b, "silk/")) return "Silk";
        if (y(b, "blackberry")) return "Blackberry";
        if (y(b, "webos")) return "Webos";
        if (!y(b, "safari/") || y(b, "chrome/") || y(b, "crios/") || y(b, "android")) {
            if (!y(b, "chrome/") && !y(b, "crios/") || y(b, "edge/")) {
                if (y(b, "android")) return "Android";
                if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
            } else return te;
        } else return "Safari";
        return "Other";
    }
    var Ke = {
        jd: "FirebaseCore-web",
        ld: "FirebaseUI-web"
    };
    function Le(a, b) {
        b = b || [];
        var c = [], d = {}, e;
        for(e in Ke)d[Ke[e]] = !0;
        for(e = 0; e < b.length; e++)"undefined" !== typeof d[b[e]] && (delete d[b[e]], c.push(b[e]));
        c.sort();
        b = c;
        b.length || (b = [
            "FirebaseCore-web"
        ]);
        c = He();
        "Browser" === c ? (d = I(), c = se(d)) : "Worker" === c && (d = I(), c = se(d) + "-" + c);
        return c + "/JsCore/" + a + "/" + b.join(",");
    }
    function I() {
        return l.navigator && l.navigator.userAgent || "";
    }
    function J(a, b) {
        a = a.split(".");
        b = b || l;
        for(var c = 0; c < a.length && "object" == typeof b && null != b; c++)b = b[a[c]];
        c != a.length && (b = void 0);
        return b;
    }
    function Me() {
        try {
            var a = l.localStorage, b = Ne();
            if (a) return a.setItem(b, "1"), a.removeItem(b), ne() ? !!l.indexedDB : !0;
        } catch (c) {
            return Ge() && !!l.indexedDB;
        }
        return !1;
    }
    function Oe() {
        return (Pe() || "chrome-extension:" === Ee() || De()) && !Ie() && Me() && !Ge();
    }
    function Pe() {
        return "http:" === Ee() || "https:" === Ee();
    }
    function Ee() {
        return l.location && l.location.protocol || null;
    }
    function Qe(a) {
        a = a || I();
        return ue(a) || se(a) == xe ? !1 : !0;
    }
    function Re(a) {
        return "undefined" === typeof a ? null : he(a);
    }
    function Se(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
        return b;
    }
    function Te(a) {
        if (null !== a) return JSON.parse(a);
    }
    function Ne(a) {
        return a ? a : Math.floor(1E9 * Math.random()).toString();
    }
    function Ue(a) {
        a = a || I();
        return "Safari" == se(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0;
    }
    function Ve() {
        var a = l.___jsl;
        if (a && a.H) {
            for(var b in a.H)if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for(var c = 0; c < a.CP.length; c++)a.CP[c] = null;
        }
    }
    function We(a, b) {
        if (a > b) throw Error("Short delay should be less than long delay!");
        this.a = a;
        this.c = b;
        a = I();
        b = He();
        this.b = ue(a) || "ReactNative" === b;
    }
    We.prototype.get = function() {
        var a = l.navigator;
        return (a && "boolean" === typeof a.onLine && (Pe() || "chrome-extension:" === Ee() || "undefined" !== typeof a.connection) ? a.onLine : 1) ? this.b ? this.c : this.a : Math.min(5E3, this.a);
    };
    function Xe() {
        var a = l.document;
        return a && "undefined" !== typeof a.visibilityState ? "visible" == a.visibilityState : !0;
    }
    function Ye() {
        var a = l.document, b = null;
        return Xe() || !a ? E() : new D(function(c) {
            b = function() {
                Xe() && (a.removeEventListener("visibilitychange", b, !1), c());
            };
            a.addEventListener("visibilitychange", b, !1);
        }).o(function(c) {
            a.removeEventListener("visibilitychange", b, !1);
            throw c;
        });
    }
    function Ze(a) {
        try {
            var b = new Date(parseInt(a, 10));
            if (!isNaN(b.getTime()) && !/[^0-9]/.test(a)) return b.toUTCString();
        } catch (c) {}
        return null;
    }
    function $e() {
        return !(!J("fireauth.oauthhelper", l) && !J("fireauth.iframe", l));
    }
    function af() {
        var a = l.navigator;
        return a && a.serviceWorker && a.serviceWorker.controller || null;
    }
    function bf() {
        var a = l.navigator;
        return a && a.serviceWorker ? E().then(function() {
            return a.serviceWorker.ready;
        }).then(function(b) {
            return b.active || null;
        }).o(function() {
            return null;
        }) : E(null);
    }
    var cf = {};
    function df(a) {
        cf[a] || (cf[a] = !0, "undefined" !== typeof console && "function" === typeof console.warn && console.warn(a));
    }
    var ef;
    try {
        var ff = {};
        Object.defineProperty(ff, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 1
        });
        Object.defineProperty(ff, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 2
        });
        ef = 2 == ff.abcd;
    } catch (a) {
        ef = !1;
    }
    function K(a, b, c) {
        ef ? Object.defineProperty(a, b, {
            configurable: !0,
            enumerable: !0,
            value: c
        }) : a[b] = c;
    }
    function L(a, b) {
        if (b) for(var c in b)b.hasOwnProperty(c) && K(a, c, b[c]);
    }
    function gf(a) {
        var b = {};
        L(b, a);
        return b;
    }
    function hf(a) {
        var b = {}, c;
        for(c in a)a.hasOwnProperty(c) && (b[c] = a[c]);
        return b;
    }
    function jf(a, b) {
        if (!b || !b.length) return !0;
        if (!a) return !1;
        for(var c = 0; c < b.length; c++){
            var d = a[b[c]];
            if (void 0 === d || null === d || "" === d) return !1;
        }
        return !0;
    }
    function kf(a) {
        var b = a;
        if ("object" == typeof a && null != a) {
            b = "length" in a ? [] : {};
            for(var c in a)K(b, c, kf(a[c]));
        }
        return b;
    }
    function lf(a) {
        var b = a && (a[mf] ? "phone" : null);
        if (b && a && a[nf]) {
            K(this, "uid", a[nf]);
            K(this, "displayName", a[of] || null);
            var c = null;
            a[pf] && (c = new Date(a[pf]).toUTCString());
            K(this, "enrollmentTime", c);
            K(this, "factorId", b);
        } else throw new u("internal-error", "Internal assert: invalid MultiFactorInfo object");
    }
    lf.prototype.v = function() {
        return {
            uid: this.uid,
            displayName: this.displayName,
            factorId: this.factorId,
            enrollmentTime: this.enrollmentTime
        };
    };
    function qf(a) {
        try {
            var b = new rf(a);
        } catch (c) {
            b = null;
        }
        return b;
    }
    var of = "displayName", pf = "enrolledAt", nf = "mfaEnrollmentId", mf = "phoneInfo";
    function rf(a) {
        lf.call(this, a);
        K(this, "phoneNumber", a[mf]);
    }
    t(rf, lf);
    rf.prototype.v = function() {
        var a = rf.Za.v.call(this);
        a.phoneNumber = this.phoneNumber;
        return a;
    };
    function sf(a) {
        var b = {}, c = a[tf], d = a[uf], e = a[vf];
        a = qf(a[wf]);
        if (!e || e != xf && e != yf && !c || e == yf && !d || e == zf && !a) throw Error("Invalid checkActionCode response!");
        e == yf ? (b[Af] = c || null, b[Bf] = c || null, b[Cf] = d) : (b[Af] = d || null, b[Bf] = d || null, b[Cf] = c || null);
        b[Df] = a || null;
        K(this, Ef, e);
        K(this, Ff, kf(b));
    }
    var zf = "REVERT_SECOND_FACTOR_ADDITION", xf = "EMAIL_SIGNIN", yf = "VERIFY_AND_CHANGE_EMAIL", tf = "email", wf = "mfaInfo", uf = "newEmail", vf = "requestType", Cf = "email", Af = "fromEmail", Df = "multiFactorInfo", Bf = "previousEmail", Ff = "data", Ef = "operation";
    function Gf(a) {
        a = Zd(a);
        var b = Yd(a, Hf) || null, c = Yd(a, If) || null, d = Yd(a, Jf) || null;
        d = d ? Kf[d] || null : null;
        if (!b || !c || !d) throw new u("argument-error", Hf + ", " + If + "and " + Jf + " are required in a valid action code URL.");
        L(this, {
            apiKey: b,
            operation: d,
            code: c,
            continueUrl: Yd(a, Lf) || null,
            languageCode: Yd(a, Mf) || null,
            tenantId: Yd(a, Nf) || null
        });
    }
    var Hf = "apiKey", If = "oobCode", Lf = "continueUrl", Mf = "languageCode", Jf = "mode", Nf = "tenantId", Kf = {
        recoverEmail: "RECOVER_EMAIL",
        resetPassword: "PASSWORD_RESET",
        revertSecondFactorAddition: zf,
        signIn: xf,
        verifyAndChangeEmail: yf,
        verifyEmail: "VERIFY_EMAIL"
    };
    function Of(a) {
        try {
            return new Gf(a);
        } catch (b) {
            return null;
        }
    }
    function Pf(a) {
        var b = a[Qf];
        if ("undefined" === typeof b) throw new u("missing-continue-uri");
        if ("string" !== typeof b || "string" === typeof b && !b.length) throw new u("invalid-continue-uri");
        this.h = b;
        this.b = this.a = null;
        this.g = !1;
        var c = a[Rf];
        if (c && "object" === typeof c) {
            b = c[Sf];
            var d = c[Tf];
            c = c[Uf];
            if ("string" === typeof b && b.length) {
                this.a = b;
                if ("undefined" !== typeof d && "boolean" !== typeof d) throw new u("argument-error", Tf + " property must be a boolean when specified.");
                this.g = !!d;
                if ("undefined" !== typeof c && ("string" !== typeof c || "string" === typeof c && !c.length)) throw new u("argument-error", Uf + " property must be a non empty string when specified.");
                this.b = c || null;
            } else {
                if ("undefined" !== typeof b) throw new u("argument-error", Sf + " property must be a non empty string when specified.");
                if ("undefined" !== typeof d || "undefined" !== typeof c) throw new u("missing-android-pkg-name");
            }
        } else if ("undefined" !== typeof c) throw new u("argument-error", Rf + " property must be a non null object when specified.");
        this.f = null;
        if ((b = a[Vf]) && "object" === typeof b) {
            if (b = b[Wf], "string" === typeof b && b.length) this.f = b;
            else {
                if ("undefined" !== typeof b) throw new u("argument-error", Wf + " property must be a non empty string when specified.");
            }
        } else if ("undefined" !== typeof b) throw new u("argument-error", Vf + " property must be a non null object when specified.");
        b = a[Xf];
        if ("undefined" !== typeof b && "boolean" !== typeof b) throw new u("argument-error", Xf + " property must be a boolean when specified.");
        this.c = !!b;
        a = a[Yf];
        if ("undefined" !== typeof a && ("string" !== typeof a || "string" === typeof a && !a.length)) throw new u("argument-error", Yf + " property must be a non empty string when specified.");
        this.i = a || null;
    }
    var Rf = "android", Yf = "dynamicLinkDomain", Xf = "handleCodeInApp", Vf = "iOS", Qf = "url", Tf = "installApp", Uf = "minimumVersion", Sf = "packageName", Wf = "bundleId";
    function Zf(a) {
        var b = {};
        b.continueUrl = a.h;
        b.canHandleCodeInApp = a.c;
        if (b.androidPackageName = a.a) b.androidMinimumVersion = a.b, b.androidInstallApp = a.g;
        b.iOSBundleId = a.f;
        b.dynamicLinkDomain = a.i;
        for(var c in b)null === b[c] && delete b[c];
        return b;
    }
    function $f(a) {
        return Oa(a, function(b) {
            b = b.toString(16);
            return 1 < b.length ? b : "0" + b;
        }).join("");
    }
    var ag = null;
    function bg(a) {
        var b = "";
        cg(a, function(c) {
            b += String.fromCharCode(c);
        });
        return b;
    }
    function cg(a, b) {
        function c(m) {
            for(; d < a.length;){
                var p = a.charAt(d++), v = ag[p];
                if (null != v) return v;
                if (!/^[\s\xa0]*$/.test(p)) throw Error("Unknown base64 encoding at char: " + p);
            }
            return m;
        }
        dg();
        for(var d = 0;;){
            var e = c(-1), f = c(0), g = c(64), h = c(64);
            if (64 === h && -1 === e) break;
            b(e << 2 | f >> 4);
            64 != g && (b(f << 4 & 240 | g >> 2), 64 != h && b(g << 6 & 192 | h));
        }
    }
    function dg() {
        if (!ag) {
            ag = {};
            for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], c = 0; 5 > c; c++)for(var d = a.concat(b[c].split("")), e = 0; e < d.length; e++){
                var f = d[e];
                void 0 === ag[f] && (ag[f] = e);
            }
        }
    }
    function eg(a) {
        var b = fg(a);
        if (!(b && b.sub && b.iss && b.aud && b.exp)) throw Error("Invalid JWT");
        this.g = a;
        this.c = b.exp;
        this.h = b.sub;
        ta();
        this.a = b.provider_id || b.firebase && b.firebase.sign_in_provider || null;
        this.f = b.firebase && b.firebase.tenant || null;
        this.b = !!b.is_anonymous || "anonymous" == this.a;
    }
    eg.prototype.S = function() {
        return this.f;
    };
    eg.prototype.i = function() {
        return this.b;
    };
    eg.prototype.toString = function() {
        return this.g;
    };
    function gg(a) {
        try {
            return new eg(a);
        } catch (b) {
            return null;
        }
    }
    function fg(a) {
        if (!a) return null;
        a = a.split(".");
        if (3 != a.length) return null;
        a = a[1];
        for(var b = (4 - a.length % 4) % 4, c = 0; c < b; c++)a += ".";
        try {
            return JSON.parse(bg(a));
        } catch (d) {}
        return null;
    }
    var hg = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "), ig = [
        "client_id",
        "response_type",
        "scope",
        "redirect_uri",
        "state"
    ], jg = {
        kd: {
            Ha: "locale",
            ta: 700,
            sa: 600,
            ea: "facebook.com",
            Va: ig
        },
        md: {
            Ha: null,
            ta: 500,
            sa: 750,
            ea: "github.com",
            Va: ig
        },
        nd: {
            Ha: "hl",
            ta: 515,
            sa: 680,
            ea: "google.com",
            Va: ig
        },
        td: {
            Ha: "lang",
            ta: 485,
            sa: 705,
            ea: "twitter.com",
            Va: hg
        },
        gd: {
            Ha: "locale",
            ta: 640,
            sa: 600,
            ea: "apple.com",
            Va: []
        }
    };
    function kg(a) {
        for(var b in jg)if (jg[b].ea == a) return jg[b];
        return null;
    }
    function lg(a) {
        var b = {};
        b["facebook.com"] = mg;
        b["google.com"] = ng;
        b["github.com"] = og;
        b["twitter.com"] = pg;
        var c = a && a[qg];
        try {
            if (c) return b[c] ? new b[c](a) : new rg(a);
            if ("undefined" !== typeof a[sg]) return new tg(a);
        } catch (d) {}
        return null;
    }
    var sg = "idToken", qg = "providerId";
    function tg(a) {
        var b = a[qg];
        if (!b && a[sg]) {
            var c = gg(a[sg]);
            c && c.a && (b = c.a);
        }
        if (!b) throw Error("Invalid additional user info!");
        if ("anonymous" == b || "custom" == b) b = null;
        c = !1;
        "undefined" !== typeof a.isNewUser ? c = !!a.isNewUser : "identitytoolkit#SignupNewUserResponse" === a.kind && (c = !0);
        K(this, "providerId", b);
        K(this, "isNewUser", c);
    }
    function rg(a) {
        tg.call(this, a);
        a = Te(a.rawUserInfo || "{}");
        K(this, "profile", kf(a || {}));
    }
    t(rg, tg);
    function mg(a) {
        rg.call(this, a);
        if ("facebook.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    t(mg, rg);
    function og(a) {
        rg.call(this, a);
        if ("github.com" != this.providerId) throw Error("Invalid provider ID!");
        K(this, "username", this.profile && this.profile.login || null);
    }
    t(og, rg);
    function ng(a) {
        rg.call(this, a);
        if ("google.com" != this.providerId) throw Error("Invalid provider ID!");
    }
    t(ng, rg);
    function pg(a) {
        rg.call(this, a);
        if ("twitter.com" != this.providerId) throw Error("Invalid provider ID!");
        K(this, "username", a.screenName || null);
    }
    t(pg, rg);
    function ug(a) {
        var b = Zd(a), c = Yd(b, "link"), d = Yd(Zd(c), "link");
        b = Yd(b, "deep_link_id");
        return Yd(Zd(b), "link") || b || d || c || a;
    }
    function vg(a, b) {
        if (!a && !b) throw new u("internal-error", "Internal assert: no raw session string available");
        if (a && b) throw new u("internal-error", "Internal assert: unable to determine the session type");
        this.a = a || null;
        this.b = b || null;
        this.type = this.a ? wg : xg;
    }
    var wg = "enroll", xg = "signin";
    vg.prototype.Fa = function() {
        return this.a ? E(this.a) : E(this.b);
    };
    vg.prototype.v = function() {
        return this.type == wg ? {
            multiFactorSession: {
                idToken: this.a
            }
        } : {
            multiFactorSession: {
                pendingCredential: this.b
            }
        };
    };
    function yg() {}
    yg.prototype.ia = function() {};
    yg.prototype.b = function() {};
    yg.prototype.c = function() {};
    yg.prototype.v = function() {};
    function zg(a, b) {
        return a.then(function(c) {
            if (c[Ag]) {
                var d = gg(c[Ag]);
                if (!d || b != d.h) throw new u("user-mismatch");
                return c;
            }
            throw new u("user-mismatch");
        }).o(function(c) {
            throw c && c.code && c.code == ua + "user-not-found" ? new u("user-mismatch") : c;
        });
    }
    function Bg(a, b) {
        if (b) this.a = b;
        else throw new u("internal-error", "failed to construct a credential");
        K(this, "providerId", a);
        K(this, "signInMethod", a);
    }
    Bg.prototype.ia = function(a) {
        return Cg(a, Dg(this));
    };
    Bg.prototype.b = function(a, b) {
        var c = Dg(this);
        c.idToken = b;
        return Eg(a, c);
    };
    Bg.prototype.c = function(a, b) {
        return zg(Fg(a, Dg(this)), b);
    };
    function Dg(a) {
        return {
            pendingToken: a.a,
            requestUri: "http://localhost"
        };
    }
    Bg.prototype.v = function() {
        return {
            providerId: this.providerId,
            signInMethod: this.signInMethod,
            pendingToken: this.a
        };
    };
    function Gg(a) {
        if (a && a.providerId && a.signInMethod && 0 == a.providerId.indexOf("saml.") && a.pendingToken) try {
            return new Bg(a.providerId, a.pendingToken);
        } catch (b) {}
        return null;
    }
    function Hg(a, b, c) {
        this.a = null;
        if (b.idToken || b.accessToken) b.idToken && K(this, "idToken", b.idToken), b.accessToken && K(this, "accessToken", b.accessToken), b.nonce && !b.pendingToken && K(this, "nonce", b.nonce), b.pendingToken && (this.a = b.pendingToken);
        else if (b.oauthToken && b.oauthTokenSecret) K(this, "accessToken", b.oauthToken), K(this, "secret", b.oauthTokenSecret);
        else throw new u("internal-error", "failed to construct a credential");
        K(this, "providerId", a);
        K(this, "signInMethod", c);
    }
    Hg.prototype.ia = function(a) {
        return Cg(a, Ig(this));
    };
    Hg.prototype.b = function(a, b) {
        var c = Ig(this);
        c.idToken = b;
        return Eg(a, c);
    };
    Hg.prototype.c = function(a, b) {
        var c = Ig(this);
        return zg(Fg(a, c), b);
    };
    function Ig(a) {
        var b = {};
        a.idToken && (b.id_token = a.idToken);
        a.accessToken && (b.access_token = a.accessToken);
        a.secret && (b.oauth_token_secret = a.secret);
        b.providerId = a.providerId;
        a.nonce && !a.a && (b.nonce = a.nonce);
        b = {
            postBody: ce(b).toString(),
            requestUri: "http://localhost"
        };
        a.a && (delete b.postBody, b.pendingToken = a.a);
        return b;
    }
    Hg.prototype.v = function() {
        var a = {
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
        this.idToken && (a.oauthIdToken = this.idToken);
        this.accessToken && (a.oauthAccessToken = this.accessToken);
        this.secret && (a.oauthTokenSecret = this.secret);
        this.nonce && (a.nonce = this.nonce);
        this.a && (a.pendingToken = this.a);
        return a;
    };
    function Jg(a) {
        if (a && a.providerId && a.signInMethod) {
            var b = {
                idToken: a.oauthIdToken,
                accessToken: a.oauthTokenSecret ? null : a.oauthAccessToken,
                oauthTokenSecret: a.oauthTokenSecret,
                oauthToken: a.oauthTokenSecret && a.oauthAccessToken,
                nonce: a.nonce,
                pendingToken: a.pendingToken
            };
            try {
                return new Hg(a.providerId, b, a.signInMethod);
            } catch (c) {}
        }
        return null;
    }
    function Kg(a, b) {
        this.Oc = b || [];
        L(this, {
            providerId: a,
            isOAuthProvider: !0
        });
        this.Fb = {};
        this.lb = (kg(a) || {}).Ha || null;
        this.kb = null;
    }
    Kg.prototype.Ia = function(a) {
        this.Fb = kb(a);
        return this;
    };
    function Lg(a) {
        if ("string" !== typeof a || 0 != a.indexOf("saml.")) throw new u("argument-error", 'SAML provider IDs must be prefixed with "saml."');
        Kg.call(this, a, []);
    }
    t(Lg, Kg);
    function M(a) {
        Kg.call(this, a, ig);
        this.a = [];
    }
    t(M, Kg);
    M.prototype.Aa = function(a) {
        Sa(this.a, a) || this.a.push(a);
        return this;
    };
    M.prototype.Nb = function() {
        return Wa(this.a);
    };
    M.prototype.credential = function(a, b) {
        var c;
        q(a) ? c = {
            idToken: a.idToken || null,
            accessToken: a.accessToken || null,
            nonce: a.rawNonce || null
        } : c = {
            idToken: a || null,
            accessToken: b || null
        };
        if (!c.idToken && !c.accessToken) throw new u("argument-error", "credential failed: must provide the ID token and/or the access token.");
        return new Hg(this.providerId, c, this.providerId);
    };
    function Mg() {
        M.call(this, "facebook.com");
    }
    t(Mg, M);
    K(Mg, "PROVIDER_ID", "facebook.com");
    K(Mg, "FACEBOOK_SIGN_IN_METHOD", "facebook.com");
    function Ng(a) {
        if (!a) throw new u("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        q(a) && (b = a.accessToken);
        return (new Mg).credential({
            accessToken: b
        });
    }
    function Og() {
        M.call(this, "github.com");
    }
    t(Og, M);
    K(Og, "PROVIDER_ID", "github.com");
    K(Og, "GITHUB_SIGN_IN_METHOD", "github.com");
    function Pg(a) {
        if (!a) throw new u("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
        var b = a;
        q(a) && (b = a.accessToken);
        return (new Og).credential({
            accessToken: b
        });
    }
    function Qg() {
        M.call(this, "google.com");
        this.Aa("profile");
    }
    t(Qg, M);
    K(Qg, "PROVIDER_ID", "google.com");
    K(Qg, "GOOGLE_SIGN_IN_METHOD", "google.com");
    function Rg(a, b) {
        var c = a;
        q(a) && (c = a.idToken, b = a.accessToken);
        return (new Qg).credential({
            idToken: c,
            accessToken: b
        });
    }
    function Sg() {
        Kg.call(this, "twitter.com", hg);
    }
    t(Sg, Kg);
    K(Sg, "PROVIDER_ID", "twitter.com");
    K(Sg, "TWITTER_SIGN_IN_METHOD", "twitter.com");
    function Tg(a, b) {
        var c = a;
        q(c) || (c = {
            oauthToken: a,
            oauthTokenSecret: b
        });
        if (!c.oauthToken || !c.oauthTokenSecret) throw new u("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");
        return new Hg("twitter.com", c, "twitter.com");
    }
    function Ug(a, b, c) {
        this.a = a;
        this.f = b;
        K(this, "providerId", "password");
        K(this, "signInMethod", c === Vg.EMAIL_LINK_SIGN_IN_METHOD ? Vg.EMAIL_LINK_SIGN_IN_METHOD : Vg.EMAIL_PASSWORD_SIGN_IN_METHOD);
    }
    Ug.prototype.ia = function(a) {
        return this.signInMethod == Vg.EMAIL_LINK_SIGN_IN_METHOD ? N(a, Wg, {
            email: this.a,
            oobCode: this.f
        }) : N(a, Xg, {
            email: this.a,
            password: this.f
        });
    };
    Ug.prototype.b = function(a, b) {
        return this.signInMethod == Vg.EMAIL_LINK_SIGN_IN_METHOD ? N(a, Yg, {
            idToken: b,
            email: this.a,
            oobCode: this.f
        }) : N(a, Zg, {
            idToken: b,
            email: this.a,
            password: this.f
        });
    };
    Ug.prototype.c = function(a, b) {
        return zg(this.ia(a), b);
    };
    Ug.prototype.v = function() {
        return {
            email: this.a,
            password: this.f,
            signInMethod: this.signInMethod
        };
    };
    function $g(a) {
        return a && a.email && a.password ? new Ug(a.email, a.password, a.signInMethod) : null;
    }
    function Vg() {
        L(this, {
            providerId: "password",
            isOAuthProvider: !1
        });
    }
    function ah(a, b) {
        b = bh(b);
        if (!b) throw new u("argument-error", "Invalid email link!");
        return new Ug(a, b.code, Vg.EMAIL_LINK_SIGN_IN_METHOD);
    }
    function bh(a) {
        a = ug(a);
        return (a = Of(a)) && a.operation === xf ? a : null;
    }
    L(Vg, {
        PROVIDER_ID: "password"
    });
    L(Vg, {
        EMAIL_LINK_SIGN_IN_METHOD: "emailLink"
    });
    L(Vg, {
        EMAIL_PASSWORD_SIGN_IN_METHOD: "password"
    });
    function ch(a) {
        if (!(a.bb && a.ab || a.Ja && a.da)) throw new u("internal-error");
        this.a = a;
        K(this, "providerId", "phone");
        this.ea = "phone";
        K(this, "signInMethod", "phone");
    }
    ch.prototype.ia = function(a) {
        return a.cb(dh(this));
    };
    ch.prototype.b = function(a, b) {
        var c = dh(this);
        c.idToken = b;
        return N(a, eh, c);
    };
    ch.prototype.c = function(a, b) {
        var c = dh(this);
        c.operation = "REAUTH";
        a = N(a, fh, c);
        return zg(a, b);
    };
    ch.prototype.v = function() {
        var a = {
            providerId: "phone"
        };
        this.a.bb && (a.verificationId = this.a.bb);
        this.a.ab && (a.verificationCode = this.a.ab);
        this.a.Ja && (a.temporaryProof = this.a.Ja);
        this.a.da && (a.phoneNumber = this.a.da);
        return a;
    };
    function gh(a) {
        if (a && "phone" === a.providerId && (a.verificationId && a.verificationCode || a.temporaryProof && a.phoneNumber)) {
            var b = {};
            x([
                "verificationId",
                "verificationCode",
                "temporaryProof",
                "phoneNumber"
            ], function(c) {
                a[c] && (b[c] = a[c]);
            });
            return new ch(b);
        }
        return null;
    }
    function dh(a) {
        return a.a.Ja && a.a.da ? {
            temporaryProof: a.a.Ja,
            phoneNumber: a.a.da
        } : {
            sessionInfo: a.a.bb,
            code: a.a.ab
        };
    }
    function hh(a) {
        try {
            this.a = a || (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).auth();
        } catch (b) {
            throw new u("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
        }
        L(this, {
            providerId: "phone",
            isOAuthProvider: !1
        });
    }
    hh.prototype.cb = function(a, b) {
        var c = this.a.b;
        return E(b.verify()).then(function(d) {
            if ("string" !== typeof d) throw new u("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");
            switch(b.type){
                case "recaptcha":
                    var e = q(a) ? a.session : null, f = q(a) ? a.phoneNumber : a, g;
                    e && e.type == wg ? g = e.Fa().then(function(h) {
                        return ih(c, {
                            idToken: h,
                            phoneEnrollmentInfo: {
                                phoneNumber: f,
                                recaptchaToken: d
                            }
                        });
                    }) : e && e.type == xg ? g = e.Fa().then(function(h) {
                        return jh(c, {
                            mfaPendingCredential: h,
                            mfaEnrollmentId: a.multiFactorHint && a.multiFactorHint.uid || a.multiFactorUid,
                            phoneSignInInfo: {
                                recaptchaToken: d
                            }
                        });
                    }) : g = kh(c, {
                        phoneNumber: f,
                        recaptchaToken: d
                    });
                    return g.then(function(h) {
                        "function" === typeof b.reset && b.reset();
                        return h;
                    }, function(h) {
                        "function" === typeof b.reset && b.reset();
                        throw h;
                    });
                default:
                    throw new u("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');
            }
        });
    };
    function lh(a, b) {
        if (!a) throw new u("missing-verification-id");
        if (!b) throw new u("missing-verification-code");
        return new ch({
            bb: a,
            ab: b
        });
    }
    L(hh, {
        PROVIDER_ID: "phone"
    });
    L(hh, {
        PHONE_SIGN_IN_METHOD: "phone"
    });
    function mh(a) {
        if (a.temporaryProof && a.phoneNumber) return new ch({
            Ja: a.temporaryProof,
            da: a.phoneNumber
        });
        var b = a && a.providerId;
        if (!b || "password" === b) return null;
        var c = a && a.oauthAccessToken, d = a && a.oauthTokenSecret, e = a && a.nonce, f = a && a.oauthIdToken, g = a && a.pendingToken;
        try {
            switch(b){
                case "google.com":
                    return Rg(f, c);
                case "facebook.com":
                    return Ng(c);
                case "github.com":
                    return Pg(c);
                case "twitter.com":
                    return Tg(c, d);
                default:
                    return c || d || f || g ? g ? 0 == b.indexOf("saml.") ? new Bg(b, g) : new Hg(b, {
                        pendingToken: g,
                        idToken: a.oauthIdToken,
                        accessToken: a.oauthAccessToken
                    }, b) : new M(b).credential({
                        idToken: f,
                        accessToken: c,
                        rawNonce: e
                    }) : null;
            }
        } catch (h) {
            return null;
        }
    }
    function nh(a) {
        if (!a.isOAuthProvider) throw new u("invalid-oauth-provider");
    }
    function oh(a, b, c, d, e, f, g) {
        this.c = a;
        this.b = b || null;
        this.g = c || null;
        this.f = d || null;
        this.i = f || null;
        this.h = g || null;
        this.a = e || null;
        if (this.g || this.a) {
            if (this.g && this.a) throw new u("invalid-auth-event");
            if (this.g && !this.f) throw new u("invalid-auth-event");
        } else throw new u("invalid-auth-event");
    }
    oh.prototype.getUid = function() {
        var a = [];
        a.push(this.c);
        this.b && a.push(this.b);
        this.f && a.push(this.f);
        this.h && a.push(this.h);
        return a.join("-");
    };
    oh.prototype.S = function() {
        return this.h;
    };
    oh.prototype.v = function() {
        return {
            type: this.c,
            eventId: this.b,
            urlResponse: this.g,
            sessionId: this.f,
            postBody: this.i,
            tenantId: this.h,
            error: this.a && this.a.v()
        };
    };
    function ph(a) {
        a = a || {};
        return a.type ? new oh(a.type, a.eventId, a.urlResponse, a.sessionId, a.error && wa(a.error), a.postBody, a.tenantId) : null;
    }
    function qh() {
        this.b = null;
        this.a = [];
    }
    var rh = null;
    function sh(a) {
        var b = rh;
        b.a.push(a);
        b.b || (b.b = function(c) {
            for(var d = 0; d < b.a.length; d++)b.a[d](c);
        }, a = J("universalLinks.subscribe", l), "function" === typeof a && a(null, b.b));
    }
    function th(a) {
        var b = "unauthorized-domain", c = void 0, d = Zd(a);
        a = d.b;
        d = d.f;
        "chrome-extension" == d ? c = Mb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : "http" == d || "https" == d ? c = Mb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : b = "operation-not-supported-in-this-environment";
        u.call(this, b, c);
    }
    t(th, u);
    function uh(a, b, c) {
        u.call(this, a, c);
        a = b || {};
        a.Gb && K(this, "email", a.Gb);
        a.da && K(this, "phoneNumber", a.da);
        a.credential && K(this, "credential", a.credential);
        a.Wb && K(this, "tenantId", a.Wb);
    }
    t(uh, u);
    uh.prototype.v = function() {
        var a = {
            code: this.code,
            message: this.message
        };
        this.email && (a.email = this.email);
        this.phoneNumber && (a.phoneNumber = this.phoneNumber);
        this.tenantId && (a.tenantId = this.tenantId);
        var b = this.credential && this.credential.v();
        b && B(a, b);
        return a;
    };
    uh.prototype.toJSON = function() {
        return this.v();
    };
    function vh(a) {
        if (a.code) {
            var b = a.code || "";
            0 == b.indexOf(ua) && (b = b.substring(ua.length));
            var c = {
                credential: mh(a),
                Wb: a.tenantId
            };
            if (a.email) c.Gb = a.email;
            else if (a.phoneNumber) c.da = a.phoneNumber;
            else if (!c.credential) return new u(b, a.message || void 0);
            return new uh(b, c, a.message);
        }
        return null;
    }
    function wh() {}
    wh.prototype.c = null;
    function xh(a) {
        return a.c || (a.c = a.b());
    }
    var yh;
    function zh() {}
    t(zh, wh);
    zh.prototype.a = function() {
        var a = Ah(this);
        return a ? new ActiveXObject(a) : new XMLHttpRequest;
    };
    zh.prototype.b = function() {
        var a = {};
        Ah(this) && (a[0] = !0, a[1] = !0);
        return a;
    };
    function Ah(a) {
        if (!a.f && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for(var b = [
                "MSXML2.XMLHTTP.6.0",
                "MSXML2.XMLHTTP.3.0",
                "MSXML2.XMLHTTP",
                "Microsoft.XMLHTTP"
            ], c = 0; c < b.length; c++){
                var d = b[c];
                try {
                    return new ActiveXObject(d), a.f = d;
                } catch (e) {}
            }
            throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
        }
        return a.f;
    }
    yh = new zh;
    function Bh() {}
    t(Bh, wh);
    Bh.prototype.a = function() {
        var a = new XMLHttpRequest;
        if ("withCredentials" in a) return a;
        if ("undefined" != typeof XDomainRequest) return new Ch;
        throw Error("Unsupported browser");
    };
    Bh.prototype.b = function() {
        return {};
    };
    function Ch() {
        this.a = new XDomainRequest;
        this.readyState = 0;
        this.onreadystatechange = null;
        this.responseType = this.responseText = this.response = "";
        this.status = -1;
        this.statusText = "";
        this.a.onload = r(this.oc, this);
        this.a.onerror = r(this.Pb, this);
        this.a.onprogress = r(this.pc, this);
        this.a.ontimeout = r(this.tc, this);
    }
    k = Ch.prototype;
    k.open = function(a, b, c) {
        if (null != c && !c) throw Error("Only async requests are supported.");
        this.a.open(a, b);
    };
    k.send = function(a) {
        if (a) {
            if ("string" == typeof a) this.a.send(a);
            else throw Error("Only string data is supported");
        } else this.a.send();
    };
    k.abort = function() {
        this.a.abort();
    };
    k.setRequestHeader = function() {};
    k.getResponseHeader = function(a) {
        return "content-type" == a.toLowerCase() ? this.a.contentType : "";
    };
    k.oc = function() {
        this.status = 200;
        this.response = this.responseText = this.a.responseText;
        Dh(this, 4);
    };
    k.Pb = function() {
        this.status = 500;
        this.response = this.responseText = "";
        Dh(this, 4);
    };
    k.tc = function() {
        this.Pb();
    };
    k.pc = function() {
        this.status = 200;
        Dh(this, 1);
    };
    function Dh(a, b) {
        a.readyState = b;
        if (a.onreadystatechange) a.onreadystatechange();
    }
    k.getAllResponseHeaders = function() {
        return "content-type: " + this.a.contentType;
    };
    function Eh(a, b, c) {
        this.reset(a, b, c, void 0, void 0);
    }
    Eh.prototype.a = null;
    var Fh = 0;
    Eh.prototype.reset = function(a, b, c, d, e) {
        "number" == typeof e || Fh++;
        d || ta();
        delete this.a;
    };
    function Gh(a) {
        this.f = a;
        this.b = this.c = this.a = null;
    }
    function Hh(a, b) {
        this.name = a;
        this.value = b;
    }
    Hh.prototype.toString = function() {
        return this.name;
    };
    var Ih = new Hh("SEVERE", 1E3), Jh = new Hh("WARNING", 900), Kh = new Hh("CONFIG", 700), Lh = new Hh("FINE", 500);
    function Mh(a) {
        if (a.c) return a.c;
        if (a.a) return Mh(a.a);
        Da("Root logger has no level set.");
        return null;
    }
    Gh.prototype.log = function(a, b, c) {
        if (a.value >= Mh(this).value) for(n(b) && (b = b()), a = new Eh(a, String(b), this.f), c && (a.a = c), c = this; c;)c = c.a;
    };
    var Nh = {}, Oh = null;
    function Ph(a) {
        Oh || (Oh = new Gh(""), Nh[""] = Oh, Oh.c = Kh);
        var b;
        if (!(b = Nh[a])) {
            b = new Gh(a);
            var c = a.lastIndexOf("."), d = a.substr(c + 1);
            c = Ph(a.substr(0, c));
            c.b || (c.b = {});
            c.b[d] = b;
            b.a = c;
            Nh[a] = b;
        }
        return b;
    }
    function Qh(a, b) {
        a && a.log(Lh, b, void 0);
    }
    function Rh(a) {
        this.f = a;
    }
    t(Rh, wh);
    Rh.prototype.a = function() {
        return new Sh(this.f);
    };
    Rh.prototype.b = function(a) {
        return function() {
            return a;
        };
    }({});
    function Sh(a) {
        G.call(this);
        this.s = a;
        this.readyState = Th;
        this.status = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.i = new Headers;
        this.b = null;
        this.m = "GET";
        this.g = "";
        this.a = !1;
        this.h = Ph("goog.net.FetchXmlHttp");
        this.l = this.c = this.f = null;
    }
    t(Sh, G);
    var Th = 0;
    k = Sh.prototype;
    k.open = function(a, b) {
        if (this.readyState != Th) throw this.abort(), Error("Error reopening a connection");
        this.m = a;
        this.g = b;
        this.readyState = 1;
        Uh(this);
    };
    k.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.a = !0;
        var b = {
            headers: this.i,
            method: this.m,
            credentials: void 0,
            cache: void 0
        };
        a && (b.body = a);
        this.s.fetch(new Request(this.g, b)).then(this.sc.bind(this), this.Sa.bind(this));
    };
    k.abort = function() {
        this.response = this.responseText = "";
        this.i = new Headers;
        this.status = 0;
        this.c && this.c.cancel("Request was aborted.");
        1 <= this.readyState && this.a && 4 != this.readyState && (this.a = !1, Vh(this, !1));
        this.readyState = Th;
    };
    k.sc = function(a) {
        this.a && (this.f = a, this.b || (this.b = a.headers, this.readyState = 2, Uh(this)), this.a && (this.readyState = 3, Uh(this), this.a && ("arraybuffer" === this.responseType ? a.arrayBuffer().then(this.qc.bind(this), this.Sa.bind(this)) : "undefined" !== typeof l.ReadableStream && "body" in a ? (this.response = this.responseText = "", this.c = a.body.getReader(), this.l = new TextDecoder, Wh(this)) : a.text().then(this.rc.bind(this), this.Sa.bind(this)))));
    };
    function Wh(a) {
        a.c.read().then(a.nc.bind(a)).catch(a.Sa.bind(a));
    }
    k.nc = function(a) {
        if (this.a) {
            var b = this.l.decode(a.value ? a.value : new Uint8Array(0), {
                stream: !a.done
            });
            b && (this.response = this.responseText += b);
            a.done ? Vh(this, !0) : Uh(this);
            3 == this.readyState && Wh(this);
        }
    };
    k.rc = function(a) {
        this.a && (this.response = this.responseText = a, Vh(this, !0));
    };
    k.qc = function(a) {
        this.a && (this.response = a, Vh(this, !0));
    };
    k.Sa = function(a) {
        var b = this.h;
        b && b.log(Jh, "Failed to fetch url " + this.g, a instanceof Error ? a : Error(a));
        this.a && Vh(this, !0);
    };
    function Vh(a, b) {
        b && a.f && (a.status = a.f.status, a.statusText = a.f.statusText);
        a.readyState = 4;
        a.f = null;
        a.c = null;
        a.l = null;
        Uh(a);
    }
    k.setRequestHeader = function(a, b) {
        this.i.append(a, b);
    };
    k.getResponseHeader = function(a) {
        return this.b ? this.b.get(a.toLowerCase()) || "" : ((a = this.h) && a.log(Jh, "Attempting to get response header but no headers have been received for url: " + this.g, void 0), "");
    };
    k.getAllResponseHeaders = function() {
        if (!this.b) {
            var a = this.h;
            a && a.log(Jh, "Attempting to get all response headers but no headers have been received for url: " + this.g, void 0);
            return "";
        }
        a = [];
        for(var b = this.b.entries(), c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Uh(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    function Xh(a) {
        G.call(this);
        this.headers = new Fd;
        this.D = a || null;
        this.c = !1;
        this.B = this.a = null;
        this.h = this.P = this.l = "";
        this.f = this.O = this.i = this.N = !1;
        this.g = 0;
        this.s = null;
        this.m = Yh;
        this.w = this.R = !1;
    }
    t(Xh, G);
    var Yh = "";
    Xh.prototype.b = Ph("goog.net.XhrIo");
    var Zh = /^https?$/i, $h = [
        "POST",
        "PUT"
    ];
    function ai(a, b, c, d, e) {
        if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.l + "; newUri=" + b);
        c = c ? c.toUpperCase() : "GET";
        a.l = b;
        a.h = "";
        a.P = c;
        a.N = !1;
        a.c = !0;
        a.a = a.D ? a.D.a() : yh.a();
        a.B = a.D ? xh(a.D) : xh(yh);
        a.a.onreadystatechange = r(a.Sb, a);
        try {
            Qh(a.b, bi(a, "Opening Xhr")), a.O = !0, a.a.open(c, String(b), !0), a.O = !1;
        } catch (g) {
            Qh(a.b, bi(a, "Error opening Xhr: " + g.message));
            ci(a, g);
            return;
        }
        b = d || "";
        var f = new Fd(a.headers);
        e && Ed(e, function(g, h) {
            f.set(h, g);
        });
        e = Qa(f.X());
        d = l.FormData && b instanceof l.FormData;
        !Sa($h, c) || e || d || f.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        f.forEach(function(g, h) {
            this.a.setRequestHeader(h, g);
        }, a);
        a.m && (a.a.responseType = a.m);
        "withCredentials" in a.a && a.a.withCredentials !== a.R && (a.a.withCredentials = a.R);
        try {
            di(a), 0 < a.g && (a.w = ei(a.a), Qh(a.b, bi(a, "Will abort after " + a.g + "ms if incomplete, xhr2 " + a.w)), a.w ? (a.a.timeout = a.g, a.a.ontimeout = r(a.Ka, a)) : a.s = Ad(a.Ka, a.g, a)), Qh(a.b, bi(a, "Sending request")), a.i = !0, a.a.send(b), a.i = !1;
        } catch (g) {
            Qh(a.b, bi(a, "Send error: " + g.message)), ci(a, g);
        }
    }
    function ei(a) {
        return Sb && bc(9) && "number" === typeof a.timeout && void 0 !== a.ontimeout;
    }
    function Ra(a) {
        return "content-type" == a.toLowerCase();
    }
    k = Xh.prototype;
    k.Ka = function() {
        "undefined" != typeof ha && this.a && (this.h = "Timed out after " + this.g + "ms, aborting", Qh(this.b, bi(this, this.h)), this.dispatchEvent("timeout"), this.abort(8));
    };
    function ci(a, b) {
        a.c = !1;
        a.a && (a.f = !0, a.a.abort(), a.f = !1);
        a.h = b;
        fi(a);
        gi(a);
    }
    function fi(a) {
        a.N || (a.N = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
    }
    k.abort = function() {
        this.a && this.c && (Qh(this.b, bi(this, "Aborting")), this.c = !1, this.f = !0, this.a.abort(), this.f = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), gi(this));
    };
    k.Ba = function() {
        this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), gi(this, !0));
        Xh.Za.Ba.call(this);
    };
    k.Sb = function() {
        this.wa || (this.O || this.i || this.f ? hi(this) : this.Hc());
    };
    k.Hc = function() {
        hi(this);
    };
    function hi(a) {
        if (a.c && "undefined" != typeof ha) {
            if (a.B[1] && 4 == ii(a) && 2 == ji(a)) Qh(a.b, bi(a, "Local request error detected and ignored"));
            else if (a.i && 4 == ii(a)) Ad(a.Sb, 0, a);
            else if (a.dispatchEvent("readystatechange"), 4 == ii(a)) {
                Qh(a.b, bi(a, "Request complete"));
                a.c = !1;
                try {
                    var b = ji(a);
                    a: switch(b){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var c = !0;
                            break a;
                        default:
                            c = !1;
                    }
                    var d;
                    if (!(d = c)) {
                        var e;
                        if (e = 0 === b) {
                            var f = String(a.l).match(Id)[1] || null;
                            if (!f && l.self && l.self.location) {
                                var g = l.self.location.protocol;
                                f = g.substr(0, g.length - 1);
                            }
                            e = !Zh.test(f ? f.toLowerCase() : "");
                        }
                        d = e;
                    }
                    if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");
                    else {
                        try {
                            var h = 2 < ii(a) ? a.a.statusText : "";
                        } catch (m) {
                            Qh(a.b, "Can not get status: " + m.message), h = "";
                        }
                        a.h = h + " [" + ji(a) + "]";
                        fi(a);
                    }
                } finally{
                    gi(a);
                }
            }
        }
    }
    function gi(a, b) {
        if (a.a) {
            di(a);
            var c = a.a, d = a.B[0] ? ka : null;
            a.a = null;
            a.B = null;
            b || a.dispatchEvent("ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {
                (a = a.b) && a.log(Ih, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
            }
        }
    }
    function di(a) {
        a.a && a.w && (a.a.ontimeout = null);
        a.s && (l.clearTimeout(a.s), a.s = null);
    }
    function ii(a) {
        return a.a ? a.a.readyState : 0;
    }
    function ji(a) {
        try {
            return 2 < ii(a) ? a.a.status : -1;
        } catch (b) {
            return -1;
        }
    }
    function ki(a) {
        try {
            return a.a ? a.a.responseText : "";
        } catch (b) {
            return Qh(a.b, "Can not get responseText: " + b.message), "";
        }
    }
    k.getResponse = function() {
        try {
            if (!this.a) return null;
            if ("response" in this.a) return this.a.response;
            switch(this.m){
                case Yh:
                case "text":
                    return this.a.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in this.a) return this.a.mozResponseArrayBuffer;
            }
            var a = this.b;
            a && a.log(Ih, "Response type " + this.m + " is not supported on this browser", void 0);
            return null;
        } catch (b) {
            return Qh(this.b, "Can not get response: " + b.message), null;
        }
    };
    function bi(a, b) {
        return b + " [" + a.P + " " + a.l + " " + ji(a) + "]";
    }
    function li(a) {
        var b = mi;
        this.g = [];
        this.w = b;
        this.s = a || null;
        this.f = this.a = !1;
        this.c = void 0;
        this.u = this.B = this.i = !1;
        this.h = 0;
        this.b = null;
        this.l = 0;
    }
    li.prototype.cancel = function(a) {
        if (this.a) this.c instanceof li && this.c.cancel();
        else {
            if (this.b) {
                var b = this.b;
                delete this.b;
                a ? b.cancel(a) : (b.l--, 0 >= b.l && b.cancel());
            }
            this.w ? this.w.call(this.s, this) : this.u = !0;
            this.a || (a = new ni(this), oi(this), pi(this, !1, a));
        }
    };
    li.prototype.m = function(a, b) {
        this.i = !1;
        pi(this, a, b);
    };
    function pi(a, b, c) {
        a.a = !0;
        a.c = c;
        a.f = !b;
        qi(a);
    }
    function oi(a) {
        if (a.a) {
            if (!a.u) throw new ri(a);
            a.u = !1;
        }
    }
    function si(a, b) {
        ti(a, null, b, void 0);
    }
    function ti(a, b, c, d) {
        a.g.push([
            b,
            c,
            d
        ]);
        a.a && qi(a);
    }
    li.prototype.then = function(a, b, c) {
        var d, e, f = new D(function(g, h) {
            d = g;
            e = h;
        });
        ti(this, d, function(g) {
            g instanceof ni ? f.cancel() : e(g);
        });
        return f.then(a, b, c);
    };
    li.prototype.$goog_Thenable = !0;
    function ui(a) {
        return Pa(a.g, function(b) {
            return n(b[1]);
        });
    }
    function qi(a) {
        if (a.h && a.a && ui(a)) {
            var b = a.h, c = vi[b];
            c && (l.clearTimeout(c.a), delete vi[b]);
            a.h = 0;
        }
        a.b && (a.b.l--, delete a.b);
        b = a.c;
        for(var d = c = !1; a.g.length && !a.i;){
            var e = a.g.shift(), f = e[0], g = e[1];
            e = e[2];
            if (f = a.f ? g : f) try {
                var h = f.call(e || a.s, b);
                void 0 !== h && (a.f = a.f && (h == b || h instanceof Error), a.c = b = h);
                if (Ba(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.i = !0;
            } catch (m) {
                b = m, a.f = !0, ui(a) || (c = !0);
            }
        }
        a.c = b;
        d && (h = r(a.m, a, !0), d = r(a.m, a, !1), b instanceof li ? (ti(b, h, d), b.B = !0) : b.then(h, d));
        c && (b = new wi(b), vi[b.a] = b, a.h = b.a);
    }
    function ri() {
        w.call(this);
    }
    t(ri, w);
    ri.prototype.message = "Deferred has already fired";
    ri.prototype.name = "AlreadyCalledError";
    function ni() {
        w.call(this);
    }
    t(ni, w);
    ni.prototype.message = "Deferred was canceled";
    ni.prototype.name = "CanceledError";
    function wi(a) {
        this.a = l.setTimeout(r(this.c, this), 0);
        this.b = a;
    }
    wi.prototype.c = function() {
        delete vi[this.a];
        throw this.b;
    };
    var vi = {};
    function xi(a) {
        var b = {}, c = b.document || document, d = vb(a).toString(), e = ic(document, "SCRIPT"), f = {
            Tb: e,
            Ka: void 0
        }, g = new li(f), h = null, m = null != b.timeout ? b.timeout : 5E3;
        0 < m && (h = window.setTimeout(function() {
            yi(e, !0);
            var p = new zi(Ai, "Timeout reached for loading script " + d);
            oi(g);
            pi(g, !1, p);
        }, m), f.Ka = h);
        e.onload = e.onreadystatechange = function() {
            e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (yi(e, b.ud || !1, h), oi(g), pi(g, !0, null));
        };
        e.onerror = function() {
            yi(e, !0, h);
            var p = new zi(Bi, "Error while loading script " + d);
            oi(g);
            pi(g, !1, p);
        };
        f = b.attributes || {};
        B(f, {
            type: "text/javascript",
            charset: "UTF-8"
        });
        fc(e, f);
        Lb(e, a);
        Ci(c).appendChild(e);
        return g;
    }
    function Ci(a) {
        var b;
        return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
    }
    function mi() {
        if (this && this.Tb) {
            var a = this.Tb;
            a && "SCRIPT" == a.tagName && yi(a, !0, this.Ka);
        }
    }
    function yi(a, b, c) {
        null != c && l.clearTimeout(c);
        a.onload = ka;
        a.onerror = ka;
        a.onreadystatechange = ka;
        b && window.setTimeout(function() {
            a && a.parentNode && a.parentNode.removeChild(a);
        }, 0);
    }
    var Bi = 0, Ai = 1;
    function zi(a, b) {
        var c = "Jsloader error (code #" + a + ")";
        b && (c += ": " + b);
        w.call(this, c);
        this.code = a;
    }
    t(zi, w);
    function Di(a) {
        this.f = a;
    }
    t(Di, wh);
    Di.prototype.a = function() {
        return new this.f;
    };
    Di.prototype.b = function() {
        return {};
    };
    function Ei(a, b, c) {
        this.c = a;
        a = b || {};
        this.u = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";
        this.m = a.secureTokenTimeout || Fi;
        this.g = kb(a.secureTokenHeaders || Gi);
        this.h = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";
        this.l = a.identityPlatformEndpoint || "https://identitytoolkit.googleapis.com/v2/";
        this.i = a.firebaseTimeout || Hi;
        this.a = kb(a.firebaseHeaders || Ii);
        c && (this.a["X-Client-Version"] = c, this.g["X-Client-Version"] = c);
        c = "Node" == He();
        c = l.XMLHttpRequest || c && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node.XMLHttpRequest;
        if (!c && !Ge()) throw new u("internal-error", "The XMLHttpRequest compatibility library was not found.");
        this.f = void 0;
        Ge() ? this.f = new Rh(self) : Ie() ? this.f = new Di(c) : this.f = new Bh;
        this.b = null;
    }
    var Ji, Ag = "idToken", Fi = new We(3E4, 6E4), Gi = {
        "Content-Type": "application/x-www-form-urlencoded"
    }, Hi = new We(3E4, 6E4), Ii = {
        "Content-Type": "application/json"
    };
    function Ki(a, b) {
        b ? a.a["X-Firebase-Locale"] = b : delete a.a["X-Firebase-Locale"];
    }
    function Li(a, b) {
        b ? (a.a["X-Client-Version"] = b, a.g["X-Client-Version"] = b) : (delete a.a["X-Client-Version"], delete a.g["X-Client-Version"]);
    }
    Ei.prototype.S = function() {
        return this.b;
    };
    function Mi(a, b, c, d, e, f, g) {
        re() || Ge() ? a = r(a.w, a) : (Ji || (Ji = new D(function(h, m) {
            Ni(h, m);
        })), a = r(a.s, a));
        a(b, c, d, e, f, g);
    }
    Ei.prototype.w = function(a, b, c, d, e, f) {
        if (Ge() && ("undefined" === typeof l.fetch || "undefined" === typeof l.Headers || "undefined" === typeof l.Request)) throw new u("operation-not-supported-in-this-environment", "fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");
        var g = new Xh(this.f);
        if (f) {
            g.g = Math.max(0, f);
            var h = setTimeout(function() {
                g.dispatchEvent("timeout");
            }, f);
        }
        md(g, "complete", function() {
            h && clearTimeout(h);
            var m = null;
            try {
                m = JSON.parse(ki(this)) || null;
            } catch (p) {
                m = null;
            }
            b && b(m);
        });
        sd(g, "ready", function() {
            h && clearTimeout(h);
            Sc(this);
        });
        sd(g, "timeout", function() {
            h && clearTimeout(h);
            Sc(this);
            b && b(null);
        });
        ai(g, a, c, d, e);
    };
    var Oi = new nb(ob, "https://apis.google.com/js/client.js?onload=%{onload}"), Pi = "__fcb" + Math.floor(1E6 * Math.random()).toString();
    function Ni(a, b) {
        if (((window.gapi || {}).client || {}).request) a();
        else {
            l[Pi] = function() {
                ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
            };
            var c = wb(Oi, {
                onload: Pi
            });
            si(xi(c), function() {
                b(Error("CORS_UNSUPPORTED"));
            });
        }
    }
    Ei.prototype.s = function(a, b, c, d, e) {
        var f = this;
        Ji.then(function() {
            window.gapi.client.setApiKey(f.c);
            var g = window.gapi.auth.getToken();
            window.gapi.auth.setToken(null);
            window.gapi.client.request({
                path: a,
                method: c,
                body: d,
                headers: e,
                authType: "none",
                callback: function(h) {
                    window.gapi.auth.setToken(g);
                    b && b(h);
                }
            });
        }).o(function(g) {
            b && b({
                error: {
                    message: g && g.message || "CORS_UNSUPPORTED"
                }
            });
        });
    };
    function Qi(a, b) {
        return new D(function(c, d) {
            "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? Mi(a, a.u + "?key=" + encodeURIComponent(a.c), function(e) {
                e ? e.error ? d(Ri(e)) : e.access_token && e.refresh_token ? c(e) : d(new u("internal-error")) : d(new u("network-request-failed"));
            }, "POST", ce(b).toString(), a.g, a.m.get()) : d(new u("internal-error"));
        });
    }
    function Si(a, b, c, d, e, f, g) {
        var h = Zd(b + c);
        H(h, "key", a.c);
        g && H(h, "cb", ta().toString());
        var m = "GET" == d;
        if (m) for(var p in e)e.hasOwnProperty(p) && H(h, p, e[p]);
        return new D(function(v, C) {
            Mi(a, h.toString(), function(A) {
                A ? A.error ? C(Ri(A, f || {})) : v(A) : C(new u("network-request-failed"));
            }, d, m ? void 0 : he(Se(e)), a.a, a.i.get());
        });
    }
    function Ti(a) {
        a = a.email;
        if ("string" !== typeof a || !Ae.test(a)) throw new u("invalid-email");
    }
    function Ui(a) {
        "email" in a && Ti(a);
    }
    function Vi(a, b) {
        return N(a, Wi, {
            identifier: b,
            continueUri: Pe() ? oe() : "http://localhost"
        }).then(function(c) {
            return c.signinMethods || [];
        });
    }
    function Xi(a) {
        return N(a, Yi, {}).then(function(b) {
            return b.authorizedDomains || [];
        });
    }
    function O(a) {
        if (!a[Ag]) {
            if (a.mfaPendingCredential) throw new u("multi-factor-auth-required", null, kb(a));
            throw new u("internal-error");
        }
    }
    function Zi(a) {
        if (a.phoneNumber || a.temporaryProof) {
            if (!a.phoneNumber || !a.temporaryProof) throw new u("internal-error");
        } else {
            if (!a.sessionInfo) throw new u("missing-verification-id");
            if (!a.code) throw new u("missing-verification-code");
        }
    }
    Ei.prototype.vb = function() {
        return N(this, $i, {});
    };
    Ei.prototype.xb = function(a, b) {
        return N(this, aj, {
            idToken: a,
            email: b
        });
    };
    Ei.prototype.yb = function(a, b) {
        return N(this, Zg, {
            idToken: a,
            password: b
        });
    };
    var bj = {
        displayName: "DISPLAY_NAME",
        photoUrl: "PHOTO_URL"
    };
    k = Ei.prototype;
    k.zb = function(a, b) {
        var c = {
            idToken: a
        }, d = [];
        ib(bj, function(e, f) {
            var g = b[f];
            null === g ? d.push(e) : f in b && (c[f] = g);
        });
        d.length && (c.deleteAttribute = d);
        return N(this, aj, c);
    };
    k.rb = function(a, b) {
        a = {
            requestType: "PASSWORD_RESET",
            email: a
        };
        B(a, b);
        return N(this, cj, a);
    };
    k.sb = function(a, b) {
        a = {
            requestType: "EMAIL_SIGNIN",
            email: a
        };
        B(a, b);
        return N(this, dj, a);
    };
    k.qb = function(a, b) {
        a = {
            requestType: "VERIFY_EMAIL",
            idToken: a
        };
        B(a, b);
        return N(this, ej, a);
    };
    k.Ab = function(a, b, c) {
        a = {
            requestType: "VERIFY_AND_CHANGE_EMAIL",
            idToken: a,
            newEmail: b
        };
        B(a, c);
        return N(this, fj, a);
    };
    function kh(a, b) {
        return N(a, gj, b);
    }
    k.cb = function(a) {
        return N(this, hj, a);
    };
    function ih(a, b) {
        return N(a, ij, b).then(function(c) {
            return c.phoneSessionInfo.sessionInfo;
        });
    }
    function jj(a) {
        if (!a.phoneVerificationInfo) throw new u("internal-error");
        if (!a.phoneVerificationInfo.sessionInfo) throw new u("missing-verification-id");
        if (!a.phoneVerificationInfo.code) throw new u("missing-verification-code");
    }
    function jh(a, b) {
        return N(a, kj, b).then(function(c) {
            return c.phoneResponseInfo.sessionInfo;
        });
    }
    function lj(a, b, c) {
        return N(a, mj, {
            idToken: b,
            deleteProvider: c
        });
    }
    function nj(a) {
        if (!a.requestUri || !a.sessionId && !a.postBody && !a.pendingToken) throw new u("internal-error");
    }
    function oj(a, b) {
        b.oauthIdToken && b.providerId && 0 == b.providerId.indexOf("oidc.") && !b.pendingToken && (a.sessionId ? b.nonce = a.sessionId : a.postBody && (a = new Qd(a.postBody), ge(a, "nonce") && (b.nonce = a.get("nonce"))));
        return b;
    }
    function pj(a) {
        var b = null;
        a.needConfirmation ? (a.code = "account-exists-with-different-credential", b = vh(a)) : "FEDERATED_USER_ID_ALREADY_LINKED" == a.errorMessage ? (a.code = "credential-already-in-use", b = vh(a)) : "EMAIL_EXISTS" == a.errorMessage ? (a.code = "email-already-in-use", b = vh(a)) : a.errorMessage && (b = qj(a.errorMessage));
        if (b) throw b;
        O(a);
    }
    function Cg(a, b) {
        b.returnIdpCredential = !0;
        return N(a, rj, b);
    }
    function Eg(a, b) {
        b.returnIdpCredential = !0;
        return N(a, sj, b);
    }
    function Fg(a, b) {
        b.returnIdpCredential = !0;
        b.autoCreate = !1;
        return N(a, tj, b);
    }
    function uj(a) {
        if (!a.oobCode) throw new u("invalid-action-code");
    }
    k.jb = function(a, b) {
        return N(this, vj, {
            oobCode: a,
            newPassword: b
        });
    };
    k.Pa = function(a) {
        return N(this, wj, {
            oobCode: a
        });
    };
    k.fb = function(a) {
        return N(this, xj, {
            oobCode: a
        });
    };
    var xj = {
        endpoint: "setAccountInfo",
        A: uj,
        Y: "email",
        C: !0
    }, wj = {
        endpoint: "resetPassword",
        A: uj,
        G: function(a) {
            var b = a.requestType;
            if (!b || !a.email && "EMAIL_SIGNIN" != b && "VERIFY_AND_CHANGE_EMAIL" != b) throw new u("internal-error");
        },
        C: !0
    }, yj = {
        endpoint: "signupNewUser",
        A: function(a) {
            Ti(a);
            if (!a.password) throw new u("weak-password");
        },
        G: O,
        U: !0,
        C: !0
    }, Wi = {
        endpoint: "createAuthUri",
        C: !0
    }, zj = {
        endpoint: "deleteAccount",
        M: [
            "idToken"
        ]
    }, mj = {
        endpoint: "setAccountInfo",
        M: [
            "idToken",
            "deleteProvider"
        ],
        A: function(a) {
            if ("array" != la(a.deleteProvider)) throw new u("internal-error");
        }
    }, Wg = {
        endpoint: "emailLinkSignin",
        M: [
            "email",
            "oobCode"
        ],
        A: Ti,
        G: O,
        U: !0,
        C: !0
    }, Yg = {
        endpoint: "emailLinkSignin",
        M: [
            "idToken",
            "email",
            "oobCode"
        ],
        A: Ti,
        G: O,
        U: !0
    }, Aj = {
        endpoint: "accounts/mfaEnrollment:finalize",
        M: [
            "idToken",
            "phoneVerificationInfo"
        ],
        A: jj,
        G: O,
        C: !0,
        La: !0
    }, Bj = {
        endpoint: "accounts/mfaSignIn:finalize",
        M: [
            "mfaPendingCredential",
            "phoneVerificationInfo"
        ],
        A: jj,
        G: O,
        C: !0,
        La: !0
    }, Cj = {
        endpoint: "getAccountInfo"
    }, dj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "requestType"
        ],
        A: function(a) {
            if ("EMAIL_SIGNIN" != a.requestType) throw new u("internal-error");
            Ti(a);
        },
        Y: "email",
        C: !0
    }, ej = {
        endpoint: "getOobConfirmationCode",
        M: [
            "idToken",
            "requestType"
        ],
        A: function(a) {
            if ("VERIFY_EMAIL" != a.requestType) throw new u("internal-error");
        },
        Y: "email",
        C: !0
    }, fj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "idToken",
            "newEmail",
            "requestType"
        ],
        A: function(a) {
            if ("VERIFY_AND_CHANGE_EMAIL" != a.requestType) throw new u("internal-error");
        },
        Y: "email",
        C: !0
    }, cj = {
        endpoint: "getOobConfirmationCode",
        M: [
            "requestType"
        ],
        A: function(a) {
            if ("PASSWORD_RESET" != a.requestType) throw new u("internal-error");
            Ti(a);
        },
        Y: "email",
        C: !0
    }, Yi = {
        hb: !0,
        endpoint: "getProjectConfig",
        Rb: "GET"
    }, Dj = {
        hb: !0,
        endpoint: "getRecaptchaParam",
        Rb: "GET",
        G: function(a) {
            if (!a.recaptchaSiteKey) throw new u("internal-error");
        }
    }, vj = {
        endpoint: "resetPassword",
        A: uj,
        Y: "email",
        C: !0
    }, gj = {
        endpoint: "sendVerificationCode",
        M: [
            "phoneNumber",
            "recaptchaToken"
        ],
        Y: "sessionInfo",
        C: !0
    }, aj = {
        endpoint: "setAccountInfo",
        M: [
            "idToken"
        ],
        A: Ui,
        U: !0
    }, Zg = {
        endpoint: "setAccountInfo",
        M: [
            "idToken"
        ],
        A: function(a) {
            Ui(a);
            if (!a.password) throw new u("weak-password");
        },
        G: O,
        U: !0
    }, $i = {
        endpoint: "signupNewUser",
        G: O,
        U: !0,
        C: !0
    }, ij = {
        endpoint: "accounts/mfaEnrollment:start",
        M: [
            "idToken",
            "phoneEnrollmentInfo"
        ],
        A: function(a) {
            if (!a.phoneEnrollmentInfo) throw new u("internal-error");
            if (!a.phoneEnrollmentInfo.phoneNumber) throw new u("missing-phone-number");
            if (!a.phoneEnrollmentInfo.recaptchaToken) throw new u("missing-app-credential");
        },
        G: function(a) {
            if (!a.phoneSessionInfo || !a.phoneSessionInfo.sessionInfo) throw new u("internal-error");
        },
        C: !0,
        La: !0
    }, kj = {
        endpoint: "accounts/mfaSignIn:start",
        M: [
            "mfaPendingCredential",
            "mfaEnrollmentId",
            "phoneSignInInfo"
        ],
        A: function(a) {
            if (!a.phoneSignInInfo || !a.phoneSignInInfo.recaptchaToken) throw new u("missing-app-credential");
        },
        G: function(a) {
            if (!a.phoneResponseInfo || !a.phoneResponseInfo.sessionInfo) throw new u("internal-error");
        },
        C: !0,
        La: !0
    }, rj = {
        endpoint: "verifyAssertion",
        A: nj,
        Wa: oj,
        G: pj,
        U: !0,
        C: !0
    }, tj = {
        endpoint: "verifyAssertion",
        A: nj,
        Wa: oj,
        G: function(a) {
            if (a.errorMessage && "USER_NOT_FOUND" == a.errorMessage) throw new u("user-not-found");
            if (a.errorMessage) throw qj(a.errorMessage);
            O(a);
        },
        U: !0,
        C: !0
    }, sj = {
        endpoint: "verifyAssertion",
        A: function(a) {
            nj(a);
            if (!a.idToken) throw new u("internal-error");
        },
        Wa: oj,
        G: pj,
        U: !0
    }, Ej = {
        endpoint: "verifyCustomToken",
        A: function(a) {
            if (!a.token) throw new u("invalid-custom-token");
        },
        G: O,
        U: !0,
        C: !0
    }, Xg = {
        endpoint: "verifyPassword",
        A: function(a) {
            Ti(a);
            if (!a.password) throw new u("wrong-password");
        },
        G: O,
        U: !0,
        C: !0
    }, hj = {
        endpoint: "verifyPhoneNumber",
        A: Zi,
        G: O,
        C: !0
    }, eh = {
        endpoint: "verifyPhoneNumber",
        A: function(a) {
            if (!a.idToken) throw new u("internal-error");
            Zi(a);
        },
        G: function(a) {
            if (a.temporaryProof) throw a.code = "credential-already-in-use", vh(a);
            O(a);
        }
    }, fh = {
        Eb: {
            USER_NOT_FOUND: "user-not-found"
        },
        endpoint: "verifyPhoneNumber",
        A: Zi,
        G: O,
        C: !0
    }, Fj = {
        endpoint: "accounts/mfaEnrollment:withdraw",
        M: [
            "idToken",
            "mfaEnrollmentId"
        ],
        G: function(a) {
            if (!!a[Ag] ^ !!a.refreshToken) throw new u("internal-error");
        },
        C: !0,
        La: !0
    };
    function N(a, b, c) {
        if (!jf(c, b.M)) return F(new u("internal-error"));
        var d = !!b.La, e = b.Rb || "POST", f;
        return E(c).then(b.A).then(function() {
            b.U && (c.returnSecureToken = !0);
            b.C && a.b && "undefined" === typeof c.tenantId && (c.tenantId = a.b);
            return d ? Si(a, a.l, b.endpoint, e, c, b.Eb, b.hb || !1) : Si(a, a.h, b.endpoint, e, c, b.Eb, b.hb || !1);
        }).then(function(g) {
            f = g;
            return b.Wa ? b.Wa(c, f) : f;
        }).then(b.G).then(function() {
            if (!b.Y) return f;
            if (!(b.Y in f)) throw new u("internal-error");
            return f[b.Y];
        });
    }
    function qj(a) {
        return Ri({
            error: {
                errors: [
                    {
                        message: a
                    }
                ],
                code: 400,
                message: a
            }
        });
    }
    function Ri(a, b) {
        var c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";
        var d = {
            keyInvalid: "invalid-api-key",
            ipRefererBlocked: "app-not-authorized"
        };
        if (c = d[c] ? new u(d[c]) : null) return c;
        c = a.error && a.error.message || "";
        d = {
            INVALID_CUSTOM_TOKEN: "invalid-custom-token",
            CREDENTIAL_MISMATCH: "custom-token-mismatch",
            MISSING_CUSTOM_TOKEN: "internal-error",
            INVALID_IDENTIFIER: "invalid-email",
            MISSING_CONTINUE_URI: "internal-error",
            INVALID_EMAIL: "invalid-email",
            INVALID_PASSWORD: "wrong-password",
            USER_DISABLED: "user-disabled",
            MISSING_PASSWORD: "internal-error",
            EMAIL_EXISTS: "email-already-in-use",
            PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
            INVALID_IDP_RESPONSE: "invalid-credential",
            INVALID_PENDING_TOKEN: "invalid-credential",
            FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
            MISSING_OR_INVALID_NONCE: "missing-or-invalid-nonce",
            INVALID_MESSAGE_PAYLOAD: "invalid-message-payload",
            INVALID_RECIPIENT_EMAIL: "invalid-recipient-email",
            INVALID_SENDER: "invalid-sender",
            EMAIL_NOT_FOUND: "user-not-found",
            RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
            EXPIRED_OOB_CODE: "expired-action-code",
            INVALID_OOB_CODE: "invalid-action-code",
            MISSING_OOB_CODE: "internal-error",
            INVALID_PROVIDER_ID: "invalid-provider-id",
            CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
            INVALID_ID_TOKEN: "invalid-user-token",
            TOKEN_EXPIRED: "user-token-expired",
            USER_NOT_FOUND: "user-token-expired",
            CORS_UNSUPPORTED: "cors-unsupported",
            DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated",
            INVALID_APP_ID: "invalid-app-id",
            TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
            WEAK_PASSWORD: "weak-password",
            OPERATION_NOT_ALLOWED: "operation-not-allowed",
            USER_CANCELLED: "user-cancelled",
            CAPTCHA_CHECK_FAILED: "captcha-check-failed",
            INVALID_APP_CREDENTIAL: "invalid-app-credential",
            INVALID_CODE: "invalid-verification-code",
            INVALID_PHONE_NUMBER: "invalid-phone-number",
            INVALID_SESSION_INFO: "invalid-verification-id",
            INVALID_TEMPORARY_PROOF: "invalid-credential",
            MISSING_APP_CREDENTIAL: "missing-app-credential",
            MISSING_CODE: "missing-verification-code",
            MISSING_PHONE_NUMBER: "missing-phone-number",
            MISSING_SESSION_INFO: "missing-verification-id",
            QUOTA_EXCEEDED: "quota-exceeded",
            SESSION_EXPIRED: "code-expired",
            REJECTED_CREDENTIAL: "rejected-credential",
            INVALID_CONTINUE_URI: "invalid-continue-uri",
            MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
            MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id",
            UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
            INVALID_DYNAMIC_LINK_DOMAIN: "invalid-dynamic-link-domain",
            INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
            INVALID_CERT_HASH: "invalid-cert-hash",
            UNSUPPORTED_TENANT_OPERATION: "unsupported-tenant-operation",
            INVALID_TENANT_ID: "invalid-tenant-id",
            TENANT_ID_MISMATCH: "tenant-id-mismatch",
            ADMIN_ONLY_OPERATION: "admin-restricted-operation",
            INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
            MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
            MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
            MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
            EMAIL_CHANGE_NEEDS_VERIFICATION: "email-change-needs-verification",
            SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
            SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
            UNSUPPORTED_FIRST_FACTOR: "unsupported-first-factor",
            UNVERIFIED_EMAIL: "unverified-email"
        };
        B(d, b || {});
        b = (b = c.match(/^[^\s]+\s*:\s*([\s\S]*)$/)) && 1 < b.length ? b[1] : void 0;
        for(var e in d)if (0 === c.indexOf(e)) return new u(d[e], b);
        !b && a && (b = Re(a));
        return new u("internal-error", b);
    }
    function Gj(a) {
        this.b = a;
        this.a = null;
        this.nb = Hj(this);
    }
    function Hj(a) {
        return Ij().then(function() {
            return new D(function(b, c) {
                J("gapi.iframes.getContext")().open({
                    where: document.body,
                    url: a.b,
                    messageHandlersFilter: J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),
                    attributes: {
                        style: {
                            position: "absolute",
                            top: "-100px",
                            width: "1px",
                            height: "1px"
                        }
                    },
                    dontclear: !0
                }, function(d) {
                    function e() {
                        clearTimeout(f);
                        b();
                    }
                    a.a = d;
                    a.a.restyle({
                        setHideOnLeave: !1
                    });
                    var f = setTimeout(function() {
                        c(Error("Network Error"));
                    }, Jj.get());
                    d.ping(e).then(e, function() {
                        c(Error("Network Error"));
                    });
                });
            });
        });
    }
    function Kj(a, b) {
        return a.nb.then(function() {
            return new D(function(c) {
                a.a.send(b.type, b, c, J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
            });
        });
    }
    function Lj(a, b) {
        a.nb.then(function() {
            a.a.register("authEvent", b, J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
        });
    }
    var Mj = new nb(ob, "https://apis.google.com/js/api.js?onload=%{onload}"), Nj = new We(3E4, 6E4), Jj = new We(5E3, 15E3), Oj = null;
    function Ij() {
        return Oj ? Oj : Oj = new D(function(a, b) {
            function c() {
                Ve();
                J("gapi.load")("gapi.iframes", {
                    callback: a,
                    ontimeout: function() {
                        Ve();
                        b(Error("Network Error"));
                    },
                    timeout: Nj.get()
                });
            }
            if (J("gapi.iframes.Iframe")) a();
            else if (J("gapi.load")) c();
            else {
                var d = "__iframefcb" + Math.floor(1E6 * Math.random()).toString();
                l[d] = function() {
                    J("gapi.load") ? c() : b(Error("Network Error"));
                };
                d = wb(Mj, {
                    onload: d
                });
                E(xi(d)).o(function() {
                    b(Error("Network Error"));
                });
            }
        }).o(function(a) {
            Oj = null;
            throw a;
        });
    }
    function Pj(a, b, c) {
        this.i = a;
        this.g = b;
        this.h = c;
        this.f = null;
        this.a = $d(this.i, "/__/auth/iframe");
        H(this.a, "apiKey", this.g);
        H(this.a, "appName", this.h);
        this.b = null;
        this.c = [];
    }
    Pj.prototype.toString = function() {
        this.f ? H(this.a, "v", this.f) : fe(this.a.a, "v");
        this.b ? H(this.a, "eid", this.b) : fe(this.a.a, "eid");
        this.c.length ? H(this.a, "fw", this.c.join(",")) : fe(this.a.a, "fw");
        return this.a.toString();
    };
    function Qj(a, b, c, d, e) {
        this.s = a;
        this.m = b;
        this.c = c;
        this.u = d;
        this.i = this.g = this.l = null;
        this.a = e;
        this.h = this.f = null;
    }
    Qj.prototype.ub = function(a) {
        this.h = a;
        return this;
    };
    Qj.prototype.toString = function() {
        var a = $d(this.s, "/__/auth/handler");
        H(a, "apiKey", this.m);
        H(a, "appName", this.c);
        H(a, "authType", this.u);
        if (this.a.isOAuthProvider) {
            var b = this.a;
            try {
                var c = (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).app(this.c).auth().ja();
            } catch (h) {
                c = null;
            }
            b.kb = c;
            H(a, "providerId", this.a.providerId);
            b = this.a;
            c = Se(b.Fb);
            for(var d in c)c[d] = c[d].toString();
            d = b.Oc;
            c = kb(c);
            for(var e = 0; e < d.length; e++){
                var f = d[e];
                f in c && delete c[f];
            }
            b.lb && b.kb && !c[b.lb] && (c[b.lb] = b.kb);
            jb(c) || H(a, "customParameters", Re(c));
        }
        "function" === typeof this.a.Nb && (b = this.a.Nb(), b.length && H(a, "scopes", b.join(",")));
        this.l ? H(a, "redirectUrl", this.l) : fe(a.a, "redirectUrl");
        this.g ? H(a, "eventId", this.g) : fe(a.a, "eventId");
        this.i ? H(a, "v", this.i) : fe(a.a, "v");
        if (this.b) for(var g in this.b)this.b.hasOwnProperty(g) && !Yd(a, g) && H(a, g, this.b[g]);
        this.h ? H(a, "tid", this.h) : fe(a.a, "tid");
        this.f ? H(a, "eid", this.f) : fe(a.a, "eid");
        g = Rj(this.c);
        g.length && H(a, "fw", g.join(","));
        return a.toString();
    };
    function Rj(a) {
        try {
            return (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).app(a).auth().Ea();
        } catch (b) {
            return [];
        }
    }
    function Sj(a, b, c, d, e) {
        this.u = a;
        this.f = b;
        this.b = c;
        this.c = d || null;
        this.h = e || null;
        this.m = this.s = this.w = null;
        this.g = [];
        this.l = this.a = null;
    }
    function Tj(a) {
        var b = oe();
        return Xi(a).then(function(c) {
            a: {
                var d = Zd(b), e = d.f;
                d = d.b;
                for(var f = 0; f < c.length; f++){
                    var g = c[f];
                    var h = d;
                    var m = e;
                    0 == g.indexOf("chrome-extension://") ? h = Zd(g).b == h && "chrome-extension" == m : "http" != m && "https" != m ? h = !1 : ze.test(g) ? h = h == g : (g = g.split(".").join("\\."), h = new RegExp("^(.+\\." + g + "|" + g + ")$", "i").test(h));
                    if (h) {
                        c = !0;
                        break a;
                    }
                }
                c = !1;
            }
            if (!c) throw new th(oe());
        });
    }
    function Uj(a) {
        if (a.l) return a.l;
        a.l = Be().then(function() {
            if (!a.s) {
                var b = a.c, c = a.h, d = Rj(a.b), e = new Pj(a.u, a.f, a.b);
                e.f = b;
                e.b = c;
                e.c = Wa(d || []);
                a.s = e.toString();
            }
            a.i = new Gj(a.s);
            Vj(a);
        });
        return a.l;
    }
    k = Sj.prototype;
    k.Lb = function(a, b, c) {
        var d = new u("popup-closed-by-user"), e = new u("web-storage-unsupported"), f = this, g = !1;
        return this.ka().then(function() {
            Wj(f).then(function(h) {
                h || (a && ve(a), b(e), g = !0);
            });
        }).o(function() {}).then(function() {
            if (!g) return ye(a);
        }).then(function() {
            if (!g) return Bd(c).then(function() {
                b(d);
            });
        });
    };
    k.Ub = function() {
        var a = I();
        return !Qe(a) && !Ue(a);
    };
    k.Qb = function() {
        return !1;
    };
    k.Jb = function(a, b, c, d, e, f, g, h) {
        if (!a) return F(new u("popup-blocked"));
        if (g && !Qe()) return this.ka().o(function(p) {
            ve(a);
            e(p);
        }), d(), E();
        this.a || (this.a = Tj(Xj(this)));
        var m = this;
        return this.a.then(function() {
            var p = m.ka().o(function(v) {
                ve(a);
                e(v);
                throw v;
            });
            d();
            return p;
        }).then(function() {
            nh(c);
            if (!g) {
                var p = Yj(m.u, m.f, m.b, b, c, null, f, m.c, void 0, m.h, h);
                pe(p, a);
            }
        }).o(function(p) {
            "auth/network-request-failed" == p.code && (m.a = null);
            throw p;
        });
    };
    function Xj(a) {
        a.m || (a.w = a.c ? Le(a.c, Rj(a.b)) : null, a.m = new Ei(a.f, za(a.h), a.w));
        return a.m;
    }
    k.Kb = function(a, b, c, d) {
        this.a || (this.a = Tj(Xj(this)));
        var e = this;
        return this.a.then(function() {
            nh(b);
            var f = Yj(e.u, e.f, e.b, a, b, oe(), c, e.c, void 0, e.h, d);
            pe(f);
        }).o(function(f) {
            "auth/network-request-failed" == f.code && (e.a = null);
            throw f;
        });
    };
    k.ka = function() {
        var a = this;
        return Uj(this).then(function() {
            return a.i.nb;
        }).o(function() {
            a.a = null;
            throw new u("network-request-failed");
        });
    };
    k.Xb = function() {
        return !0;
    };
    function Yj(a, b, c, d, e, f, g, h, m, p, v) {
        a = new Qj(a, b, c, d, e);
        a.l = f;
        a.g = g;
        a.i = h;
        a.b = kb(m || null);
        a.f = p;
        return a.ub(v).toString();
    }
    function Vj(a) {
        if (!a.i) throw Error("IfcHandler must be initialized!");
        Lj(a.i, function(b) {
            var c = {};
            if (b && b.authEvent) {
                var d = !1;
                b = ph(b.authEvent);
                for(c = 0; c < a.g.length; c++)d = a.g[c](b) || d;
                c = {};
                c.status = d ? "ACK" : "ERROR";
                return E(c);
            }
            c.status = "ERROR";
            return E(c);
        });
    }
    function Wj(a) {
        var b = {
            type: "webStorageSupport"
        };
        return Uj(a).then(function() {
            return Kj(a.i, b);
        }).then(function(c) {
            if (c && c.length && "undefined" !== typeof c[0].webStorageSupport) return c[0].webStorageSupport;
            throw Error();
        });
    }
    k.Ca = function(a) {
        this.g.push(a);
    };
    k.Qa = function(a) {
        Ua(this.g, function(b) {
            return b == a;
        });
    };
    function Zj(a) {
        this.a = a || (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.reactNative && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.reactNative.AsyncStorage;
        if (!this.a) throw new u("internal-error", "The React Native compatibility library was not found.");
        this.type = "asyncStorage";
    }
    k = Zj.prototype;
    k.get = function(a) {
        return E(this.a.getItem(a)).then(function(b) {
            return b && Te(b);
        });
    };
    k.set = function(a, b) {
        return E(this.a.setItem(a, Re(b)));
    };
    k.T = function(a) {
        return E(this.a.removeItem(a));
    };
    k.ba = function() {};
    k.ha = function() {};
    function ak(a) {
        this.b = a;
        this.a = {};
        this.f = r(this.c, this);
    }
    var bk = [];
    function ck() {
        var a = Ge() ? self : null;
        x(bk, function(c) {
            c.b == a && (b = c);
        });
        if (!b) {
            var b = new ak(a);
            bk.push(b);
        }
        return b;
    }
    ak.prototype.c = function(a) {
        var b = a.data.eventType, c = a.data.eventId, d = this.a[b];
        if (d && 0 < d.length) {
            a.ports[0].postMessage({
                status: "ack",
                eventId: c,
                eventType: b,
                response: null
            });
            var e = [];
            x(d, function(f) {
                e.push(E().then(function() {
                    return f(a.origin, a.data.data);
                }));
            });
            Ec(e).then(function(f) {
                var g = [];
                x(f, function(h) {
                    g.push({
                        fulfilled: h.Mb,
                        value: h.value,
                        reason: h.reason ? h.reason.message : void 0
                    });
                });
                x(g, function(h) {
                    for(var m in h)"undefined" === typeof h[m] && delete h[m];
                });
                a.ports[0].postMessage({
                    status: "done",
                    eventId: c,
                    eventType: b,
                    response: g
                });
            });
        }
    };
    function dk(a, b, c) {
        jb(a.a) && a.b.addEventListener("message", a.f);
        "undefined" === typeof a.a[b] && (a.a[b] = []);
        a.a[b].push(c);
    }
    function ek(a) {
        this.a = a;
    }
    ek.prototype.postMessage = function(a, b) {
        this.a.postMessage(a, b);
    };
    function fk(a) {
        this.c = a;
        this.b = !1;
        this.a = [];
    }
    function gk(a, b, c, d) {
        var e, f = c || {}, g, h, m, p = null;
        if (a.b) return F(Error("connection_unavailable"));
        var v = d ? 800 : 50, C = "undefined" !== typeof MessageChannel ? new MessageChannel : null;
        return new D(function(A, Q) {
            C ? (e = Math.floor(Math.random() * Math.pow(10, 20)).toString(), C.port1.start(), h = setTimeout(function() {
                Q(Error("unsupported_event"));
            }, v), g = function(xa) {
                xa.data.eventId === e && ("ack" === xa.data.status ? (clearTimeout(h), m = setTimeout(function() {
                    Q(Error("timeout"));
                }, 3E3)) : "done" === xa.data.status ? (clearTimeout(m), "undefined" !== typeof xa.data.response ? A(xa.data.response) : Q(Error("unknown_error"))) : (clearTimeout(h), clearTimeout(m), Q(Error("invalid_response"))));
            }, p = {
                messageChannel: C,
                onMessage: g
            }, a.a.push(p), C.port1.addEventListener("message", g), a.c.postMessage({
                eventType: b,
                eventId: e,
                data: f
            }, [
                C.port2
            ])) : Q(Error("connection_unavailable"));
        }).then(function(A) {
            hk(a, p);
            return A;
        }).o(function(A) {
            hk(a, p);
            throw A;
        });
    }
    function hk(a, b) {
        if (b) {
            var c = b.messageChannel, d = b.onMessage;
            c && (c.port1.removeEventListener("message", d), c.port1.close());
            Ua(a.a, function(e) {
                return e == b;
            });
        }
    }
    fk.prototype.close = function() {
        for(; 0 < this.a.length;)hk(this, this.a[0]);
        this.b = !0;
    };
    function ik() {
        if (!jk()) throw new u("web-storage-unsupported");
        this.c = {};
        this.a = [];
        this.b = 0;
        this.u = l.indexedDB;
        this.type = "indexedDB";
        this.g = this.l = this.f = this.i = null;
        this.s = !1;
        this.h = null;
        var a = this;
        Ge() && self ? (this.l = ck(), dk(this.l, "keyChanged", function(b, c) {
            return kk(a).then(function(d) {
                0 < d.length && x(a.a, function(e) {
                    e(d);
                });
                return {
                    keyProcessed: Sa(d, c.key)
                };
            });
        }), dk(this.l, "ping", function() {
            return E([
                "keyChanged"
            ]);
        })) : bf().then(function(b) {
            if (a.h = b) a.g = new fk(new ek(b)), gk(a.g, "ping", null, !0).then(function(c) {
                c[0].fulfilled && Sa(c[0].value, "keyChanged") && (a.s = !0);
            }).o(function() {});
        });
    }
    var lk;
    function mk(a) {
        return new D(function(b, c) {
            var d = a.u.deleteDatabase("firebaseLocalStorageDb");
            d.onsuccess = function() {
                b();
            };
            d.onerror = function(e) {
                c(Error(e.target.error));
            };
        });
    }
    function nk(a) {
        return new D(function(b, c) {
            var d = a.u.open("firebaseLocalStorageDb", 1);
            d.onerror = function(e) {
                try {
                    e.preventDefault();
                } catch (f) {}
                c(Error(e.target.error));
            };
            d.onupgradeneeded = function(e) {
                e = e.target.result;
                try {
                    e.createObjectStore("firebaseLocalStorage", {
                        keyPath: "fbase_key"
                    });
                } catch (f) {
                    c(f);
                }
            };
            d.onsuccess = function(e) {
                e = e.target.result;
                e.objectStoreNames.contains("firebaseLocalStorage") ? b(e) : mk(a).then(function() {
                    return nk(a);
                }).then(function(f) {
                    b(f);
                }).o(function(f) {
                    c(f);
                });
            };
        });
    }
    function ok(a) {
        a.m || (a.m = nk(a));
        return a.m;
    }
    function jk() {
        try {
            return !!l.indexedDB;
        } catch (a) {
            return !1;
        }
    }
    function pk(a) {
        return a.objectStore("firebaseLocalStorage");
    }
    function qk(a, b) {
        return a.transaction([
            "firebaseLocalStorage"
        ], b ? "readwrite" : "readonly");
    }
    function rk(a) {
        return new D(function(b, c) {
            a.onsuccess = function(d) {
                d && d.target ? b(d.target.result) : b();
            };
            a.onerror = function(d) {
                c(d.target.error);
            };
        });
    }
    k = ik.prototype;
    k.set = function(a, b) {
        var c = !1, d, e = this;
        return ok(this).then(function(f) {
            d = f;
            f = pk(qk(d, !0));
            return rk(f.get(a));
        }).then(function(f) {
            var g = pk(qk(d, !0));
            if (f) return f.value = b, rk(g.put(f));
            e.b++;
            c = !0;
            f = {};
            f.fbase_key = a;
            f.value = b;
            return rk(g.add(f));
        }).then(function() {
            e.c[a] = b;
            return sk(e, a);
        }).ma(function() {
            c && e.b--;
        });
    };
    function sk(a, b) {
        return a.g && a.h && af() === a.h ? gk(a.g, "keyChanged", {
            key: b
        }, a.s).then(function() {}).o(function() {}) : E();
    }
    k.get = function(a) {
        return ok(this).then(function(b) {
            return rk(pk(qk(b, !1)).get(a));
        }).then(function(b) {
            return b && b.value;
        });
    };
    k.T = function(a) {
        var b = !1, c = this;
        return ok(this).then(function(d) {
            b = !0;
            c.b++;
            return rk(pk(qk(d, !0))["delete"](a));
        }).then(function() {
            delete c.c[a];
            return sk(c, a);
        }).ma(function() {
            b && c.b--;
        });
    };
    function kk(a) {
        return ok(a).then(function(b) {
            var c = pk(qk(b, !1));
            return c.getAll ? rk(c.getAll()) : new D(function(d, e) {
                var f = [], g = c.openCursor();
                g.onsuccess = function(h) {
                    (h = h.target.result) ? (f.push(h.value), h["continue"]()) : d(f);
                };
                g.onerror = function(h) {
                    e(h.target.error);
                };
            });
        }).then(function(b) {
            var c = {}, d = [];
            if (0 == a.b) {
                for(d = 0; d < b.length; d++)c[b[d].fbase_key] = b[d].value;
                d = qe(a.c, c);
                a.c = c;
            }
            return d;
        });
    }
    k.ba = function(a) {
        0 == this.a.length && tk(this);
        this.a.push(a);
    };
    k.ha = function(a) {
        Ua(this.a, function(b) {
            return b == a;
        });
        0 == this.a.length && uk(this);
    };
    function tk(a) {
        function b() {
            a.f = setTimeout(function() {
                a.i = kk(a).then(function(c) {
                    0 < c.length && x(a.a, function(d) {
                        d(c);
                    });
                }).then(function() {
                    b();
                }).o(function(c) {
                    "STOP_EVENT" != c.message && b();
                });
            }, 800);
        }
        uk(a);
        b();
    }
    function uk(a) {
        a.i && a.i.cancel("STOP_EVENT");
        a.f && (clearTimeout(a.f), a.f = null);
    }
    function vk(a) {
        var b = this, c = null;
        this.a = [];
        this.type = "indexedDB";
        this.c = a;
        this.b = E().then(function() {
            if (jk()) {
                var d = Ne(), e = "__sak" + d;
                lk || (lk = new ik);
                c = lk;
                return c.set(e, d).then(function() {
                    return c.get(e);
                }).then(function(f) {
                    if (f !== d) throw Error("indexedDB not supported!");
                    return c.T(e);
                }).then(function() {
                    return c;
                }).o(function() {
                    return b.c;
                });
            }
            return b.c;
        }).then(function(d) {
            b.type = d.type;
            d.ba(function(e) {
                x(b.a, function(f) {
                    f(e);
                });
            });
            return d;
        });
    }
    k = vk.prototype;
    k.get = function(a) {
        return this.b.then(function(b) {
            return b.get(a);
        });
    };
    k.set = function(a, b) {
        return this.b.then(function(c) {
            return c.set(a, b);
        });
    };
    k.T = function(a) {
        return this.b.then(function(b) {
            return b.T(a);
        });
    };
    k.ba = function(a) {
        this.a.push(a);
    };
    k.ha = function(a) {
        Ua(this.a, function(b) {
            return b == a;
        });
    };
    function wk() {
        this.a = {};
        this.type = "inMemory";
    }
    k = wk.prototype;
    k.get = function(a) {
        return E(this.a[a]);
    };
    k.set = function(a, b) {
        this.a[a] = b;
        return E();
    };
    k.T = function(a) {
        delete this.a[a];
        return E();
    };
    k.ba = function() {};
    k.ha = function() {};
    function xk() {
        if (!yk()) {
            if ("Node" == He()) throw new u("internal-error", "The LocalStorage compatibility library was not found.");
            throw new u("web-storage-unsupported");
        }
        this.a = zk() || (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node.localStorage;
        this.type = "localStorage";
    }
    function zk() {
        try {
            var a = l.localStorage, b = Ne();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function yk() {
        var a = "Node" == He();
        a = zk() || a && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node.localStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = xk.prototype;
    k.get = function(a) {
        var b = this;
        return E().then(function() {
            var c = b.a.getItem(a);
            return Te(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return E().then(function() {
            var d = Re(b);
            null === d ? c.T(a) : c.a.setItem(a, d);
        });
    };
    k.T = function(a) {
        var b = this;
        return E().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ba = function(a) {
        l.window && jd(l.window, "storage", a);
    };
    k.ha = function(a) {
        l.window && td(l.window, "storage", a);
    };
    function Ak() {
        this.type = "nullStorage";
    }
    k = Ak.prototype;
    k.get = function() {
        return E(null);
    };
    k.set = function() {
        return E();
    };
    k.T = function() {
        return E();
    };
    k.ba = function() {};
    k.ha = function() {};
    function Bk() {
        if (!Ck()) {
            if ("Node" == He()) throw new u("internal-error", "The SessionStorage compatibility library was not found.");
            throw new u("web-storage-unsupported");
        }
        this.a = Dk() || (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node.sessionStorage;
        this.type = "sessionStorage";
    }
    function Dk() {
        try {
            var a = l.sessionStorage, b = Ne();
            a && (a.setItem(b, "1"), a.removeItem(b));
            return a;
        } catch (c) {
            return null;
        }
    }
    function Ck() {
        var a = "Node" == He();
        a = Dk() || a && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.node.sessionStorage;
        if (!a) return !1;
        try {
            return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
        } catch (b) {
            return !1;
        }
    }
    k = Bk.prototype;
    k.get = function(a) {
        var b = this;
        return E().then(function() {
            var c = b.a.getItem(a);
            return Te(c);
        });
    };
    k.set = function(a, b) {
        var c = this;
        return E().then(function() {
            var d = Re(b);
            null === d ? c.T(a) : c.a.setItem(a, d);
        });
    };
    k.T = function(a) {
        var b = this;
        return E().then(function() {
            b.a.removeItem(a);
        });
    };
    k.ba = function() {};
    k.ha = function() {};
    function Ek() {
        var a = {};
        a.Browser = Fk;
        a.Node = Gk;
        a.ReactNative = Hk;
        a.Worker = Ik;
        this.a = a[He()];
    }
    var Jk, Fk = {
        F: xk,
        $a: Bk
    }, Gk = {
        F: xk,
        $a: Bk
    }, Hk = {
        F: Zj,
        $a: Ak
    }, Ik = {
        F: xk,
        $a: Ak
    }; /*

 Copyright 2017 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
    var Kk = {
        od: "local",
        NONE: "none",
        qd: "session"
    };
    function Lk(a) {
        var b = new u("invalid-persistence-type"), c = new u("unsupported-persistence-type");
        a: {
            for(d in Kk)if (Kk[d] == a) {
                var d = !0;
                break a;
            }
            d = !1;
        }
        if (!d || "string" !== typeof a) throw b;
        switch(He()){
            case "ReactNative":
                if ("session" === a) throw c;
                break;
            case "Node":
                if ("none" !== a) throw c;
                break;
            case "Worker":
                if ("session" === a || !jk() && "none" !== a) throw c;
                break;
            default:
                if (!Me() && "none" !== a) throw c;
        }
    }
    function Mk() {
        var a = !Ue(I()) && Fe() ? !0 : !1, b = Qe(), c = Me();
        this.m = a;
        this.h = b;
        this.l = c;
        this.a = {};
        Jk || (Jk = new Ek);
        a = Jk;
        try {
            this.g = !ne() && $e() || !l.indexedDB ? new a.a.F : new vk(Ge() ? new wk : new a.a.F);
        } catch (d) {
            this.g = new wk, this.h = !0;
        }
        try {
            this.i = new a.a.$a;
        } catch (d) {
            this.i = new wk;
        }
        this.u = new wk;
        this.f = r(this.Vb, this);
        this.b = {};
    }
    var Nk;
    function Ok() {
        Nk || (Nk = new Mk);
        return Nk;
    }
    function Pk(a, b) {
        switch(b){
            case "session":
                return a.i;
            case "none":
                return a.u;
            default:
                return a.g;
        }
    }
    function Qk(a, b) {
        return "firebase:" + a.name + (b ? ":" + b : "");
    }
    function Rk(a, b, c) {
        var d = Qk(b, c), e = Pk(a, b.F);
        return a.get(b, c).then(function(f) {
            var g = null;
            try {
                g = Te(l.localStorage.getItem(d));
            } catch (h) {}
            if (g && !f) return l.localStorage.removeItem(d), a.set(b, g, c);
            g && f && "localStorage" != e.type && l.localStorage.removeItem(d);
        });
    }
    k = Mk.prototype;
    k.get = function(a, b) {
        return Pk(this, a.F).get(Qk(a, b));
    };
    function Sk(a, b, c) {
        c = Qk(b, c);
        "local" == b.F && (a.b[c] = null);
        return Pk(a, b.F).T(c);
    }
    k.set = function(a, b, c) {
        var d = Qk(a, c), e = this, f = Pk(this, a.F);
        return f.set(d, b).then(function() {
            return f.get(d);
        }).then(function(g) {
            "local" == a.F && (e.b[d] = g);
        });
    };
    k.addListener = function(a, b, c) {
        a = Qk(a, b);
        this.l && (this.b[a] = l.localStorage.getItem(a));
        jb(this.a) && (Pk(this, "local").ba(this.f), this.h || (ne() || !$e()) && l.indexedDB || !this.l || Tk(this));
        this.a[a] || (this.a[a] = []);
        this.a[a].push(c);
    };
    k.removeListener = function(a, b, c) {
        a = Qk(a, b);
        this.a[a] && (Ua(this.a[a], function(d) {
            return d == c;
        }), 0 == this.a[a].length && delete this.a[a]);
        jb(this.a) && (Pk(this, "local").ha(this.f), Uk(this));
    };
    function Tk(a) {
        Uk(a);
        a.c = setInterval(function() {
            for(var b in a.a){
                var c = l.localStorage.getItem(b), d = a.b[b];
                c != d && (a.b[b] = c, c = new Yc({
                    type: "storage",
                    key: b,
                    target: window,
                    oldValue: d,
                    newValue: c,
                    a: !0
                }), a.Vb(c));
            }
        }, 1E3);
    }
    function Uk(a) {
        a.c && (clearInterval(a.c), a.c = null);
    }
    k.Vb = function(a) {
        if (a && a.f) {
            var b = a.a.key;
            if (null == b) for(var c in this.a){
                var d = this.b[c];
                "undefined" === typeof d && (d = null);
                var e = l.localStorage.getItem(c);
                e !== d && (this.b[c] = e, this.ib(c));
            }
            else if (0 == b.indexOf("firebase:") && this.a[b]) {
                "undefined" !== typeof a.a.a ? Pk(this, "local").ha(this.f) : Uk(this);
                if (this.m) {
                    if (c = l.localStorage.getItem(b), d = a.a.newValue, d !== c) null !== d ? l.localStorage.setItem(b, d) : l.localStorage.removeItem(b);
                    else if (this.b[b] === d && "undefined" === typeof a.a.a) return;
                }
                var f = this;
                c = function() {
                    if ("undefined" !== typeof a.a.a || f.b[b] !== l.localStorage.getItem(b)) f.b[b] = l.localStorage.getItem(b), f.ib(b);
                };
                Sb && cc && 10 == cc && l.localStorage.getItem(b) !== a.a.newValue && a.a.newValue !== a.a.oldValue ? setTimeout(c, 10) : c();
            }
        } else x(a, r(this.ib, this));
    };
    k.ib = function(a) {
        this.a[a] && x(this.a[a], function(b) {
            b();
        });
    };
    function Vk(a) {
        this.a = a;
        this.b = Ok();
    }
    var Wk = {
        name: "authEvent",
        F: "local"
    };
    function Xk(a) {
        return a.b.get(Wk, a.a).then(function(b) {
            return ph(b);
        });
    }
    function Yk() {
        this.a = Ok();
    }
    function Zk() {
        this.b = -1;
    }
    function $k(a, b) {
        this.b = al;
        this.f = l.Uint8Array ? new Uint8Array(this.b) : Array(this.b);
        this.g = this.c = 0;
        this.a = [];
        this.i = a;
        this.h = b;
        this.l = l.Int32Array ? new Int32Array(64) : Array(64);
        void 0 === bl && (l.Int32Array ? bl = new Int32Array(cl) : bl = cl);
        this.reset();
    }
    var bl;
    t($k, Zk);
    for(var al = 64, dl = al - 1, el = [], fl = 0; fl < dl; fl++)el[fl] = 0;
    var gl = Va(128, el);
    $k.prototype.reset = function() {
        this.g = this.c = 0;
        this.a = l.Int32Array ? new Int32Array(this.h) : Wa(this.h);
    };
    function hl(a) {
        for(var b = a.f, c = a.l, d = 0, e = 0; e < b.length;)c[d++] = b[e] << 24 | b[e + 1] << 16 | b[e + 2] << 8 | b[e + 3], e = 4 * d;
        for(b = 16; 64 > b; b++){
            e = c[b - 15] | 0;
            d = c[b - 2] | 0;
            var f = (c[b - 16] | 0) + ((e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3) | 0, g = (c[b - 7] | 0) + ((d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10) | 0;
            c[b] = f + g | 0;
        }
        d = a.a[0] | 0;
        e = a.a[1] | 0;
        var h = a.a[2] | 0, m = a.a[3] | 0, p = a.a[4] | 0, v = a.a[5] | 0, C = a.a[6] | 0;
        f = a.a[7] | 0;
        for(b = 0; 64 > b; b++){
            var A = ((d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10)) + (d & e ^ d & h ^ e & h) | 0;
            g = p & v ^ ~p & C;
            f = f + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) | 0;
            g = g + (bl[b] | 0) | 0;
            g = f + (g + (c[b] | 0) | 0) | 0;
            f = C;
            C = v;
            v = p;
            p = m + g | 0;
            m = h;
            h = e;
            e = d;
            d = g + A | 0;
        }
        a.a[0] = a.a[0] + d | 0;
        a.a[1] = a.a[1] + e | 0;
        a.a[2] = a.a[2] + h | 0;
        a.a[3] = a.a[3] + m | 0;
        a.a[4] = a.a[4] + p | 0;
        a.a[5] = a.a[5] + v | 0;
        a.a[6] = a.a[6] + C | 0;
        a.a[7] = a.a[7] + f | 0;
    }
    function il(a, b, c) {
        void 0 === c && (c = b.length);
        var d = 0, e = a.c;
        if ("string" === typeof b) for(; d < c;)a.f[e++] = b.charCodeAt(d++), e == a.b && (hl(a), e = 0);
        else if (ma(b)) for(; d < c;){
            var f = b[d++];
            if (!("number" == typeof f && 0 <= f && 255 >= f && f == (f | 0))) throw Error("message must be a byte array");
            a.f[e++] = f;
            e == a.b && (hl(a), e = 0);
        }
        else throw Error("message must be string or array");
        a.c = e;
        a.g += c;
    }
    var cl = [
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
    ];
    function jl() {
        $k.call(this, 8, kl);
    }
    t(jl, $k);
    var kl = [
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
    ];
    function ll(a, b, c, d, e) {
        this.u = a;
        this.i = b;
        this.l = c;
        this.m = d || null;
        this.s = e || null;
        this.h = b + ":" + c;
        this.w = new Yk;
        this.g = new Vk(this.h);
        this.f = null;
        this.b = [];
        this.a = this.c = null;
    }
    function ml(a) {
        return new u("invalid-cordova-configuration", a);
    }
    k = ll.prototype;
    k.ka = function() {
        return this.Ga ? this.Ga : this.Ga = Ce().then(function() {
            if ("function" !== typeof J("universalLinks.subscribe", l)) throw ml("cordova-universal-links-plugin-fix is not installed");
            if ("undefined" === typeof J("BuildInfo.packageName", l)) throw ml("cordova-plugin-buildinfo is not installed");
            if ("function" !== typeof J("cordova.plugins.browsertab.openUrl", l)) throw ml("cordova-plugin-browsertab is not installed");
            if ("function" !== typeof J("cordova.InAppBrowser.open", l)) throw ml("cordova-plugin-inappbrowser is not installed");
        }, function() {
            throw new u("cordova-not-ready");
        });
    };
    function nl() {
        for(var a = 20, b = []; 0 < a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
        return b.join("");
    }
    function ol(a) {
        var b = new jl;
        il(b, a);
        a = [];
        var c = 8 * b.g;
        56 > b.c ? il(b, gl, 56 - b.c) : il(b, gl, b.b - (b.c - 56));
        for(var d = 63; 56 <= d; d--)b.f[d] = c & 255, c /= 256;
        hl(b);
        for(d = c = 0; d < b.i; d++)for(var e = 24; 0 <= e; e -= 8)a[c++] = b.a[d] >> e & 255;
        return $f(a);
    }
    k.Lb = function(a, b) {
        b(new u("operation-not-supported-in-this-environment"));
        return E();
    };
    k.Jb = function() {
        return F(new u("operation-not-supported-in-this-environment"));
    };
    k.Xb = function() {
        return !1;
    };
    k.Ub = function() {
        return !0;
    };
    k.Qb = function() {
        return !0;
    };
    k.Kb = function(a, b, c, d) {
        if (this.c) return F(new u("redirect-operation-pending"));
        var e = this, f = l.document, g = null, h = null, m = null, p = null;
        return this.c = E().then(function() {
            nh(b);
            return pl(e);
        }).then(function() {
            return ql(e, a, b, c, d);
        }).then(function() {
            return new D(function(v, C) {
                h = function() {
                    var A = J("cordova.plugins.browsertab.close", l);
                    v();
                    "function" === typeof A && A();
                    e.a && "function" === typeof e.a.close && (e.a.close(), e.a = null);
                    return !1;
                };
                e.Ca(h);
                m = function() {
                    g || (g = Bd(2E3).then(function() {
                        C(new u("redirect-cancelled-by-user"));
                    }));
                };
                p = function() {
                    Xe() && m();
                };
                f.addEventListener("resume", m, !1);
                I().toLowerCase().match(/android/) || f.addEventListener("visibilitychange", p, !1);
            }).o(function(v) {
                return rl(e).then(function() {
                    throw v;
                });
            });
        }).ma(function() {
            m && f.removeEventListener("resume", m, !1);
            p && f.removeEventListener("visibilitychange", p, !1);
            g && g.cancel();
            h && e.Qa(h);
            e.c = null;
        });
    };
    function ql(a, b, c, d, e) {
        var f = nl(), g = new oh(b, d, null, f, new u("no-auth-event"), null, e), h = J("BuildInfo.packageName", l);
        if ("string" !== typeof h) throw new u("invalid-cordova-configuration");
        var m = J("BuildInfo.displayName", l), p = {};
        if (I().toLowerCase().match(/iphone|ipad|ipod/)) p.ibi = h;
        else if (I().toLowerCase().match(/android/)) p.apn = h;
        else return F(new u("operation-not-supported-in-this-environment"));
        m && (p.appDisplayName = m);
        f = ol(f);
        p.sessionId = f;
        var v = Yj(a.u, a.i, a.l, b, c, null, d, a.m, p, a.s, e);
        return a.ka().then(function() {
            var C = a.h;
            return a.w.a.set(Wk, g.v(), C);
        }).then(function() {
            var C = J("cordova.plugins.browsertab.isAvailable", l);
            if ("function" !== typeof C) throw new u("invalid-cordova-configuration");
            var A = null;
            C(function(Q) {
                if (Q) {
                    A = J("cordova.plugins.browsertab.openUrl", l);
                    if ("function" !== typeof A) throw new u("invalid-cordova-configuration");
                    A(v);
                } else {
                    A = J("cordova.InAppBrowser.open", l);
                    if ("function" !== typeof A) throw new u("invalid-cordova-configuration");
                    Q = I();
                    a.a = A(v, Q.match(/(iPad|iPhone|iPod).*OS 7_\d/i) || Q.match(/(iPad|iPhone|iPod).*OS 8_\d/i) ? "_blank" : "_system", "location=yes");
                }
            });
        });
    }
    function sl(a, b) {
        for(var c = 0; c < a.b.length; c++)try {
            a.b[c](b);
        } catch (d) {}
    }
    function pl(a) {
        a.f || (a.f = a.ka().then(function() {
            return new D(function(b) {
                function c(d) {
                    b(d);
                    a.Qa(c);
                    return !1;
                }
                a.Ca(c);
                tl(a);
            });
        }));
        return a.f;
    }
    function rl(a) {
        var b = null;
        return Xk(a.g).then(function(c) {
            b = c;
            c = a.g;
            return Sk(c.b, Wk, c.a);
        }).then(function() {
            return b;
        });
    }
    function tl(a) {
        function b(g) {
            d = !0;
            e && e.cancel();
            rl(a).then(function(h) {
                var m = c;
                if (h && g && g.url) {
                    var p = null;
                    m = ug(g.url);
                    -1 != m.indexOf("/__/auth/callback") && (p = Zd(m), p = Te(Yd(p, "firebaseError") || null), p = (p = "object" === typeof p ? wa(p) : null) ? new oh(h.c, h.b, null, null, p, null, h.S()) : new oh(h.c, h.b, m, h.f, null, null, h.S()));
                    m = p || c;
                }
                sl(a, m);
            });
        }
        var c = new oh("unknown", null, null, null, new u("no-auth-event")), d = !1, e = Bd(500).then(function() {
            return rl(a).then(function() {
                d || sl(a, c);
            });
        }), f = l.handleOpenURL;
        l.handleOpenURL = function(g) {
            0 == g.toLowerCase().indexOf(J("BuildInfo.packageName", l).toLowerCase() + "://") && b({
                url: g
            });
            if ("function" === typeof f) try {
                f(g);
            } catch (h) {
                console.error(h);
            }
        };
        rh || (rh = new qh);
        sh(b);
    }
    k.Ca = function(a) {
        this.b.push(a);
        pl(this).o(function(b) {
            "auth/invalid-cordova-configuration" === b.code && (b = new oh("unknown", null, null, null, new u("no-auth-event")), a(b));
        });
    };
    k.Qa = function(a) {
        Ua(this.b, function(b) {
            return b == a;
        });
    };
    function ul(a) {
        this.a = a;
        this.b = Ok();
    }
    var vl = {
        name: "pendingRedirect",
        F: "session"
    };
    function wl(a) {
        return a.b.set(vl, "pending", a.a);
    }
    function xl(a) {
        return Sk(a.b, vl, a.a);
    }
    function yl(a) {
        return a.b.get(vl, a.a).then(function(b) {
            return "pending" == b;
        });
    }
    function zl(a, b, c) {
        this.i = {};
        this.w = 0;
        this.D = a;
        this.u = b;
        this.m = c;
        this.h = [];
        this.f = !1;
        this.l = r(this.s, this);
        this.b = new Al;
        this.B = new Bl;
        this.g = new ul(this.u + ":" + this.m);
        this.c = {};
        this.c.unknown = this.b;
        this.c.signInViaRedirect = this.b;
        this.c.linkViaRedirect = this.b;
        this.c.reauthViaRedirect = this.b;
        this.c.signInViaPopup = this.B;
        this.c.linkViaPopup = this.B;
        this.c.reauthViaPopup = this.B;
        this.a = Cl(this.D, this.u, this.m, Aa);
    }
    function Cl(a, b, c, d) {
        var e = (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION || null;
        return De() ? new ll(a, b, c, e, d) : new Sj(a, b, c, e, d);
    }
    zl.prototype.reset = function() {
        this.f = !1;
        this.a.Qa(this.l);
        this.a = Cl(this.D, this.u, this.m);
        this.i = {};
    };
    function Dl(a) {
        a.f || (a.f = !0, a.a.Ca(a.l));
        var b = a.a;
        return a.a.ka().o(function(c) {
            a.a == b && a.reset();
            throw c;
        });
    }
    function El(a) {
        a.a.Ub() && Dl(a).o(function(b) {
            var c = new oh("unknown", null, null, null, new u("operation-not-supported-in-this-environment"));
            Fl(b) && a.s(c);
        });
        a.a.Qb() || Gl(a.b);
    }
    function Hl(a, b) {
        Sa(a.h, b) || a.h.push(b);
        a.f || yl(a.g).then(function(c) {
            c ? xl(a.g).then(function() {
                Dl(a).o(function(d) {
                    var e = new oh("unknown", null, null, null, new u("operation-not-supported-in-this-environment"));
                    Fl(d) && a.s(e);
                });
            }) : El(a);
        }).o(function() {
            El(a);
        });
    }
    function Il(a, b) {
        Ua(a.h, function(c) {
            return c == b;
        });
    }
    zl.prototype.s = function(a) {
        if (!a) throw new u("invalid-auth-event");
        6E5 <= ta() - this.w && (this.i = {}, this.w = 0);
        if (a && a.getUid() && this.i.hasOwnProperty(a.getUid())) return !1;
        for(var b = !1, c = 0; c < this.h.length; c++){
            var d = this.h[c];
            if (d.Cb(a.c, a.b)) {
                if (b = this.c[a.c]) b.h(a, d), a && (a.f || a.b) && (this.i[a.getUid()] = !0, this.w = ta());
                b = !0;
                break;
            }
        }
        Gl(this.b);
        return b;
    };
    var Jl = new We(2E3, 1E4), Kl = new We(3E4, 6E4);
    zl.prototype.pa = function() {
        return this.b.pa();
    };
    function Ll(a, b, c, d, e, f, g) {
        return a.a.Jb(b, c, d, function() {
            a.f || (a.f = !0, a.a.Ca(a.l));
        }, function() {
            a.reset();
        }, e, f, g);
    }
    function Fl(a) {
        return a && "auth/cordova-not-ready" == a.code ? !0 : !1;
    }
    function Ml(a, b, c, d, e) {
        var f;
        return wl(a.g).then(function() {
            return a.a.Kb(b, c, d, e).o(function(g) {
                if (Fl(g)) throw new u("operation-not-supported-in-this-environment");
                f = g;
                return xl(a.g).then(function() {
                    throw f;
                });
            }).then(function() {
                return a.a.Xb() ? new D(function() {}) : xl(a.g).then(function() {
                    return a.pa();
                }).then(function() {}).o(function() {});
            });
        });
    }
    function Nl(a, b, c, d, e) {
        return a.a.Lb(d, function(f) {
            b.la(c, null, f, e);
        }, Jl.get());
    }
    var Ol = {};
    function Pl(a, b, c) {
        var d = b + ":" + c;
        Ol[d] || (Ol[d] = new zl(a, b, c));
        return Ol[d];
    }
    function Al() {
        this.b = null;
        this.f = [];
        this.c = [];
        this.a = null;
        this.i = this.g = !1;
    }
    Al.prototype.reset = function() {
        this.b = null;
        this.a && (this.a.cancel(), this.a = null);
    };
    Al.prototype.h = function(a, b) {
        if (a) {
            this.reset();
            this.g = !0;
            var c = a.c, d = a.b, e = a.a && "auth/web-storage-unsupported" == a.a.code, f = a.a && "auth/operation-not-supported-in-this-environment" == a.a.code;
            this.i = !(!e && !f);
            "unknown" != c || e || f ? a.a ? (Ql(this, !0, null, a.a), E()) : b.Da(c, d) ? Rl(this, a, b) : F(new u("invalid-auth-event")) : (Ql(this, !1, null, null), E());
        } else F(new u("invalid-auth-event"));
    };
    function Gl(a) {
        a.g || (a.g = !0, Ql(a, !1, null, null));
    }
    function Sl(a) {
        a.g && !a.i && Ql(a, !1, null, null);
    }
    function Rl(a, b, c) {
        c = c.Da(b.c, b.b);
        var d = b.g, e = b.f, f = b.i, g = b.S(), h = !!b.c.match(/Redirect$/);
        c(d, e, g, f).then(function(m) {
            Ql(a, h, m, null);
        }).o(function(m) {
            Ql(a, h, null, m);
        });
    }
    function Tl(a, b) {
        a.b = function() {
            return F(b);
        };
        if (a.c.length) for(var c = 0; c < a.c.length; c++)a.c[c](b);
    }
    function Ul(a, b) {
        a.b = function() {
            return E(b);
        };
        if (a.f.length) for(var c = 0; c < a.f.length; c++)a.f[c](b);
    }
    function Ql(a, b, c, d) {
        b ? d ? Tl(a, d) : Ul(a, c) : Ul(a, {
            user: null
        });
        a.f = [];
        a.c = [];
    }
    Al.prototype.pa = function() {
        var a = this;
        return new D(function(b, c) {
            a.b ? a.b().then(b, c) : (a.f.push(b), a.c.push(c), Vl(a));
        });
    };
    function Vl(a) {
        var b = new u("timeout");
        a.a && a.a.cancel();
        a.a = Bd(Kl.get()).then(function() {
            a.b || (a.g = !0, Ql(a, !0, null, b));
        });
    }
    function Bl() {}
    Bl.prototype.h = function(a, b) {
        if (a) {
            var c = a.c, d = a.b;
            a.a ? (b.la(a.c, null, a.a, a.b), E()) : b.Da(c, d) ? Wl(a, b) : F(new u("invalid-auth-event"));
        } else F(new u("invalid-auth-event"));
    };
    function Wl(a, b) {
        var c = a.b, d = a.c;
        b.Da(d, c)(a.g, a.f, a.S(), a.i).then(function(e) {
            b.la(d, e, null, c);
        }).o(function(e) {
            b.la(d, null, e, c);
        });
    }
    function Xl() {
        this.Bb = !1;
        Object.defineProperty(this, "appVerificationDisabled", {
            get: function() {
                return this.Bb;
            },
            set: function(a) {
                this.Bb = a;
            },
            enumerable: !1
        });
    }
    function Yl(a, b) {
        this.a = b;
        K(this, "verificationId", a);
    }
    Yl.prototype.confirm = function(a) {
        a = lh(this.verificationId, a);
        return this.a(a);
    };
    function Zl(a, b, c, d) {
        return new hh(a).cb(b, c).then(function(e) {
            return new Yl(e, d);
        });
    }
    function $l(a) {
        var b = fg(a);
        if (!(b && b.exp && b.auth_time && b.iat)) throw new u("internal-error", "An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");
        L(this, {
            token: a,
            expirationTime: Ze(1E3 * b.exp),
            authTime: Ze(1E3 * b.auth_time),
            issuedAtTime: Ze(1E3 * b.iat),
            signInProvider: b.firebase && b.firebase.sign_in_provider ? b.firebase.sign_in_provider : null,
            signInSecondFactor: b.firebase && b.firebase.sign_in_second_factor ? b.firebase.sign_in_second_factor : null,
            claims: b
        });
    }
    function am(a, b, c) {
        var d = b && b[bm];
        if (!d) throw new u("argument-error", "Internal assert: Invalid MultiFactorResolver");
        this.a = a;
        this.f = kb(b);
        this.g = c;
        this.c = new vg(null, d);
        this.b = [];
        var e = this;
        x(b[cm] || [], function(f) {
            (f = qf(f)) && e.b.push(f);
        });
        K(this, "auth", this.a);
        K(this, "session", this.c);
        K(this, "hints", this.b);
    }
    var cm = "mfaInfo", bm = "mfaPendingCredential";
    am.prototype.Pc = function(a) {
        var b = this;
        return a.ob(this.a.b, this.c).then(function(c) {
            var d = kb(b.f);
            delete d[cm];
            delete d[bm];
            B(d, c);
            return b.g(d);
        });
    };
    function dm(a, b, c, d) {
        u.call(this, "multi-factor-auth-required", d, b);
        this.b = new am(a, b, c);
        K(this, "resolver", this.b);
    }
    t(dm, u);
    function em(a, b, c) {
        if (a && q(a.serverResponse) && "auth/multi-factor-auth-required" === a.code) try {
            return new dm(b, a.serverResponse, c, a.message);
        } catch (d) {}
        return null;
    }
    function fm() {}
    fm.prototype.ob = function(a, b, c) {
        return b.type == wg ? gm(this, a, b, c) : hm(this, a, b);
    };
    function gm(a, b, c, d) {
        return c.Fa().then(function(e) {
            e = {
                idToken: e
            };
            "undefined" !== typeof d && (e.displayName = d);
            B(e, {
                phoneVerificationInfo: dh(a.a)
            });
            return N(b, Aj, e);
        });
    }
    function hm(a, b, c) {
        return c.Fa().then(function(d) {
            d = {
                mfaPendingCredential: d
            };
            B(d, {
                phoneVerificationInfo: dh(a.a)
            });
            return N(b, Bj, d);
        });
    }
    function im(a) {
        K(this, "factorId", a.ea);
        this.a = a;
    }
    t(im, fm);
    function jm(a) {
        im.call(this, a);
        if (this.a.ea != hh.PROVIDER_ID) throw new u("argument-error", "firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");
    }
    t(jm, im);
    function km(a, b) {
        Xc.call(this, a);
        for(var c in b)this[c] = b[c];
    }
    t(km, Xc);
    function lm(a, b) {
        this.a = a;
        this.b = [];
        this.c = r(this.wc, this);
        jd(this.a, "userReloaded", this.c);
        var c = [];
        b && b.multiFactor && b.multiFactor.enrolledFactors && x(b.multiFactor.enrolledFactors, function(d) {
            var e = null, f = {};
            if (d) {
                d.uid && (f[nf] = d.uid);
                d.displayName && (f[of] = d.displayName);
                d.enrollmentTime && (f[pf] = new Date(d.enrollmentTime).toISOString());
                d.phoneNumber && (f[mf] = d.phoneNumber);
                try {
                    e = new rf(f);
                } catch (g) {}
                d = e;
            } else d = null;
            d && c.push(d);
        });
        mm(this, c);
    }
    function nm(a) {
        var b = [];
        x(a.mfaInfo || [], function(c) {
            (c = qf(c)) && b.push(c);
        });
        return b;
    }
    k = lm.prototype;
    k.wc = function(a) {
        mm(this, nm(a.ed));
    };
    function mm(a, b) {
        a.b = b;
        K(a, "enrolledFactors", b);
    }
    k.Ob = function() {
        return this.a.I().then(function(a) {
            return new vg(a, null);
        });
    };
    k.dc = function(a, b) {
        var c = this, d = this.a.a;
        return this.Ob().then(function(e) {
            return a.ob(d, e, b);
        }).then(function(e) {
            om(c.a, e);
            return c.a.reload();
        });
    };
    k.$c = function(a) {
        var b = this, c = "string" === typeof a ? a : a.uid, d = this.a.a;
        return this.a.I().then(function(e) {
            return N(d, Fj, {
                idToken: e,
                mfaEnrollmentId: c
            });
        }).then(function(e) {
            var f = Na(b.b, function(g) {
                return g.uid != c;
            });
            mm(b, f);
            om(b.a, e);
            return b.a.reload().o(function(g) {
                if ("auth/user-token-expired" != g.code) throw g;
            });
        });
    };
    k.v = function() {
        return {
            multiFactor: {
                enrolledFactors: Oa(this.b, function(a) {
                    return a.v();
                })
            }
        };
    };
    function pm(a, b, c) {
        this.h = a;
        this.i = b;
        this.g = c;
        this.c = 3E4;
        this.f = 96E4;
        this.b = null;
        this.a = this.c;
        if (this.f < this.c) throw Error("Proactive refresh lower bound greater than upper bound!");
    }
    pm.prototype.start = function() {
        this.a = this.c;
        qm(this, !0);
    };
    function rm(a, b) {
        if (b) return a.a = a.c, a.g();
        b = a.a;
        a.a *= 2;
        a.a > a.f && (a.a = a.f);
        return b;
    }
    function qm(a, b) {
        a.stop();
        a.b = Bd(rm(a, b)).then(function() {
            return Ye();
        }).then(function() {
            return a.h();
        }).then(function() {
            qm(a, !0);
        }).o(function(c) {
            a.i(c) && qm(a, !1);
        });
    }
    pm.prototype.stop = function() {
        this.b && (this.b.cancel(), this.b = null);
    };
    function sm(a) {
        this.c = a;
        this.b = this.a = null;
    }
    sm.prototype.v = function() {
        return {
            apiKey: this.c.c,
            refreshToken: this.a,
            accessToken: this.b && this.b.toString(),
            expirationTime: tm(this)
        };
    };
    function tm(a) {
        return a.b && 1E3 * a.b.c || 0;
    }
    function um(a, b) {
        var c = b.refreshToken;
        a.b = gg(b[Ag] || "");
        a.a = c;
    }
    function vm(a, b) {
        a.b = b.b;
        a.a = b.a;
    }
    function wm(a, b) {
        return Qi(a.c, b).then(function(c) {
            a.b = gg(c.access_token);
            a.a = c.refresh_token;
            return {
                accessToken: a.b.toString(),
                refreshToken: a.a
            };
        }).o(function(c) {
            "auth/user-token-expired" == c.code && (a.a = null);
            throw c;
        });
    }
    sm.prototype.getToken = function(a) {
        a = !!a;
        return this.b && !this.a ? F(new u("user-token-expired")) : a || !this.b || ta() > tm(this) - 3E4 ? this.a ? wm(this, {
            grant_type: "refresh_token",
            refresh_token: this.a
        }) : E(null) : E({
            accessToken: this.b.toString(),
            refreshToken: this.a
        });
    };
    function xm(a, b) {
        this.a = a || null;
        this.b = b || null;
        L(this, {
            lastSignInTime: Ze(b || null),
            creationTime: Ze(a || null)
        });
    }
    function ym(a) {
        return new xm(a.a, a.b);
    }
    xm.prototype.v = function() {
        return {
            lastLoginAt: this.b,
            createdAt: this.a
        };
    };
    function zm(a, b, c, d, e, f) {
        L(this, {
            uid: a,
            displayName: d || null,
            photoURL: e || null,
            email: c || null,
            phoneNumber: f || null,
            providerId: b
        });
    }
    function P(a, b, c) {
        this.N = [];
        this.l = a.apiKey;
        this.m = a.appName;
        this.s = a.authDomain || null;
        a = (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION) : null;
        this.a = new Ei(this.l, za(Aa), a);
        this.b = new sm(this.a);
        Am(this, b[Ag]);
        um(this.b, b);
        K(this, "refreshToken", this.b.a);
        Bm(this, c || {});
        G.call(this);
        this.P = !1;
        this.s && Oe() && (this.i = Pl(this.s, this.l, this.m));
        this.R = [];
        this.h = null;
        this.B = Cm(this);
        this.Z = r(this.Ma, this);
        var d = this;
        this.oa = null;
        this.za = function(e) {
            d.va(e.g);
        };
        this.aa = null;
        this.W = [];
        this.ya = function(e) {
            Dm(d, e.c);
        };
        this.$ = null;
        this.O = new lm(this, c);
        K(this, "multiFactor", this.O);
    }
    t(P, G);
    P.prototype.va = function(a) {
        this.oa = a;
        Ki(this.a, a);
    };
    P.prototype.ja = function() {
        return this.oa;
    };
    function Em(a, b) {
        a.aa && td(a.aa, "languageCodeChanged", a.za);
        (a.aa = b) && jd(b, "languageCodeChanged", a.za);
    }
    function Dm(a, b) {
        a.W = b;
        Li(a.a, (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION, a.W) : null);
    }
    P.prototype.Ea = function() {
        return Wa(this.W);
    };
    function Fm(a, b) {
        a.$ && td(a.$, "frameworkChanged", a.ya);
        (a.$ = b) && jd(b, "frameworkChanged", a.ya);
    }
    P.prototype.Ma = function() {
        this.B.b && (this.B.stop(), this.B.start());
    };
    function Gm(a) {
        try {
            return (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).app(a.m).auth();
        } catch (b) {
            throw new u("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + a.m + "'!");
        }
    }
    function Cm(a) {
        return new pm(function() {
            return a.I(!0);
        }, function(b) {
            return b && "auth/network-request-failed" == b.code ? !0 : !1;
        }, function() {
            var b = tm(a.b) - ta() - 3E5;
            return 0 < b ? b : 0;
        });
    }
    function Hm(a) {
        a.D || a.B.b || (a.B.start(), td(a, "tokenChanged", a.Z), jd(a, "tokenChanged", a.Z));
    }
    function Im(a) {
        td(a, "tokenChanged", a.Z);
        a.B.stop();
    }
    function Am(a, b) {
        a.xa = b;
        K(a, "_lat", b);
    }
    function Jm(a, b) {
        Ua(a.R, function(c) {
            return c == b;
        });
    }
    function Km(a) {
        for(var b = [], c = 0; c < a.R.length; c++)b.push(a.R[c](a));
        return Ec(b).then(function() {
            return a;
        });
    }
    function Lm(a) {
        a.i && !a.P && (a.P = !0, Hl(a.i, a));
    }
    function Bm(a, b) {
        L(a, {
            uid: b.uid,
            displayName: b.displayName || null,
            photoURL: b.photoURL || null,
            email: b.email || null,
            emailVerified: b.emailVerified || !1,
            phoneNumber: b.phoneNumber || null,
            isAnonymous: b.isAnonymous || !1,
            tenantId: b.tenantId || null,
            metadata: new xm(b.createdAt, b.lastLoginAt),
            providerData: []
        });
        a.a.b = a.tenantId;
    }
    K(P.prototype, "providerId", "firebase");
    function Mm() {}
    function Nm(a) {
        return E().then(function() {
            if (a.D) throw new u("app-deleted");
        });
    }
    function Om(a) {
        return Oa(a.providerData, function(b) {
            return b.providerId;
        });
    }
    function Pm(a, b) {
        b && (Qm(a, b.providerId), a.providerData.push(b));
    }
    function Qm(a, b) {
        Ua(a.providerData, function(c) {
            return c.providerId == b;
        });
    }
    function Rm(a, b, c) {
        ("uid" != b || c) && a.hasOwnProperty(b) && K(a, b, c);
    }
    function Sm(a, b) {
        a != b && (L(a, {
            uid: b.uid,
            displayName: b.displayName,
            photoURL: b.photoURL,
            email: b.email,
            emailVerified: b.emailVerified,
            phoneNumber: b.phoneNumber,
            isAnonymous: b.isAnonymous,
            tenantId: b.tenantId,
            providerData: []
        }), b.metadata ? K(a, "metadata", ym(b.metadata)) : K(a, "metadata", new xm), x(b.providerData, function(c) {
            Pm(a, c);
        }), vm(a.b, b.b), K(a, "refreshToken", a.b.a), mm(a.O, b.O.b));
    }
    k = P.prototype;
    k.reload = function() {
        var a = this;
        return R(this, Nm(this).then(function() {
            return Tm(a).then(function() {
                return Km(a);
            }).then(Mm);
        }));
    };
    function Tm(a) {
        return a.I().then(function(b) {
            var c = a.isAnonymous;
            return Um(a, b).then(function() {
                c || Rm(a, "isAnonymous", !1);
                return b;
            });
        });
    }
    k.mc = function(a) {
        return this.I(a).then(function(b) {
            return new $l(b);
        });
    };
    k.I = function(a) {
        var b = this;
        return R(this, Nm(this).then(function() {
            return b.b.getToken(a);
        }).then(function(c) {
            if (!c) throw new u("internal-error");
            c.accessToken != b.xa && (Am(b, c.accessToken), b.dispatchEvent(new km("tokenChanged")));
            Rm(b, "refreshToken", c.refreshToken);
            return c.accessToken;
        }));
    };
    function om(a, b) {
        b[Ag] && a.xa != b[Ag] && (um(a.b, b), a.dispatchEvent(new km("tokenChanged")), Am(a, b[Ag]), Rm(a, "refreshToken", a.b.a));
    }
    function Um(a, b) {
        return N(a.a, Cj, {
            idToken: b
        }).then(r(a.Ic, a));
    }
    k.Ic = function(a) {
        a = a.users;
        if (!a || !a.length) throw new u("internal-error");
        a = a[0];
        Bm(this, {
            uid: a.localId,
            displayName: a.displayName,
            photoURL: a.photoUrl,
            email: a.email,
            emailVerified: !!a.emailVerified,
            phoneNumber: a.phoneNumber,
            lastLoginAt: a.lastLoginAt,
            createdAt: a.createdAt,
            tenantId: a.tenantId
        });
        for(var b = Vm(a), c = 0; c < b.length; c++)Pm(this, b[c]);
        Rm(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
        this.dispatchEvent(new km("userReloaded", {
            ed: a
        }));
    };
    function Vm(a) {
        return (a = a.providerUserInfo) && a.length ? Oa(a, function(b) {
            return new zm(b.rawId, b.providerId, b.email, b.displayName, b.photoUrl, b.phoneNumber);
        }) : [];
    }
    k.Jc = function(a) {
        df("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");
        return this.pb(a);
    };
    k.pb = function(a) {
        var b = this, c = null;
        return R(this, a.c(this.a, this.uid).then(function(d) {
            om(b, d);
            c = Wm(b, d, "reauthenticate");
            b.h = null;
            return b.reload();
        }).then(function() {
            return c;
        }), !0);
    };
    function Xm(a, b) {
        return Tm(a).then(function() {
            if (Sa(Om(a), b)) return Km(a).then(function() {
                throw new u("provider-already-linked");
            });
        });
    }
    k.Ac = function(a) {
        df("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");
        return this.mb(a);
    };
    k.mb = function(a) {
        var b = this, c = null;
        return R(this, Xm(this, a.providerId).then(function() {
            return b.I();
        }).then(function(d) {
            return a.b(b.a, d);
        }).then(function(d) {
            c = Wm(b, d, "link");
            return Ym(b, d);
        }).then(function() {
            return c;
        }));
    };
    k.Bc = function(a, b) {
        var c = this;
        return R(this, Xm(this, "phone").then(function() {
            return Zl(Gm(c), a, b, r(c.mb, c));
        }));
    };
    k.Kc = function(a, b) {
        var c = this;
        return R(this, E().then(function() {
            return Zl(Gm(c), a, b, r(c.pb, c));
        }), !0);
    };
    function Wm(a, b, c) {
        var d = mh(b);
        b = lg(b);
        return gf({
            user: a,
            credential: d,
            additionalUserInfo: b,
            operationType: c
        });
    }
    function Ym(a, b) {
        om(a, b);
        return a.reload().then(function() {
            return a;
        });
    }
    k.xb = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.xb(c, a);
        }).then(function(c) {
            om(b, c);
            return b.reload();
        }));
    };
    k.cd = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return a.b(b.a, c);
        }).then(function(c) {
            om(b, c);
            return b.reload();
        }));
    };
    k.yb = function(a) {
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.yb(c, a);
        }).then(function(c) {
            om(b, c);
            return b.reload();
        }));
    };
    k.zb = function(a) {
        if (void 0 === a.displayName && void 0 === a.photoURL) return Nm(this);
        var b = this;
        return R(this, this.I().then(function(c) {
            return b.a.zb(c, {
                displayName: a.displayName,
                photoUrl: a.photoURL
            });
        }).then(function(c) {
            om(b, c);
            Rm(b, "displayName", c.displayName || null);
            Rm(b, "photoURL", c.photoUrl || null);
            x(b.providerData, function(d) {
                "password" === d.providerId && (K(d, "displayName", b.displayName), K(d, "photoURL", b.photoURL));
            });
            return Km(b);
        }).then(Mm));
    };
    k.ad = function(a) {
        var b = this;
        return R(this, Tm(this).then(function(c) {
            return Sa(Om(b), a) ? lj(b.a, c, [
                a
            ]).then(function(d) {
                var e = {};
                x(d.providerUserInfo || [], function(f) {
                    e[f.providerId] = !0;
                });
                x(Om(b), function(f) {
                    e[f] || Qm(b, f);
                });
                e[hh.PROVIDER_ID] || K(b, "phoneNumber", null);
                return Km(b);
            }) : Km(b).then(function() {
                throw new u("no-such-provider");
            });
        }));
    };
    k.delete = function() {
        var a = this;
        return R(this, this.I().then(function(b) {
            return N(a.a, zj, {
                idToken: b
            });
        }).then(function() {
            a.dispatchEvent(new km("userDeleted"));
        })).then(function() {
            for(var b = 0; b < a.N.length; b++)a.N[b].cancel("app-deleted");
            Em(a, null);
            Fm(a, null);
            a.N = [];
            a.D = !0;
            Im(a);
            K(a, "refreshToken", null);
            a.i && Il(a.i, a);
        });
    };
    k.Cb = function(a, b) {
        return "linkViaPopup" == a && (this.g || null) == b && this.f || "reauthViaPopup" == a && (this.g || null) == b && this.f || "linkViaRedirect" == a && (this.fa || null) == b || "reauthViaRedirect" == a && (this.fa || null) == b ? !0 : !1;
    };
    k.la = function(a, b, c, d) {
        "linkViaPopup" != a && "reauthViaPopup" != a || d != (this.g || null) || (c && this.w ? this.w(c) : b && !c && this.f && this.f(b), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.w);
    };
    k.Da = function(a, b) {
        return "linkViaPopup" == a && b == (this.g || null) ? r(this.Hb, this) : "reauthViaPopup" == a && b == (this.g || null) ? r(this.Ib, this) : "linkViaRedirect" == a && (this.fa || null) == b ? r(this.Hb, this) : "reauthViaRedirect" == a && (this.fa || null) == b ? r(this.Ib, this) : null;
    };
    k.Cc = function(a) {
        var b = this;
        return Zm(this, "linkViaPopup", a, function() {
            return Xm(b, a.providerId).then(function() {
                return Km(b);
            });
        }, !1);
    };
    k.Lc = function(a) {
        return Zm(this, "reauthViaPopup", a, function() {
            return E();
        }, !0);
    };
    function Zm(a, b, c, d, e) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        if (a.h && !e) return F(a.h);
        var f = kg(c.providerId), g = Ne(a.uid + ":::"), h = null;
        (!Qe() || Fe()) && a.s && c.isOAuthProvider && (h = Yj(a.s, a.l, a.m, b, c, null, g, (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION || null, null, null, a.tenantId));
        var m = we(h, f && f.ta, f && f.sa);
        d = d().then(function() {
            $m(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            return Ll(a.i, m, b, c, g, !!h, a.tenantId);
        }).then(function() {
            return new D(function(p, v) {
                a.la(b, null, new u("cancelled-popup-request"), a.g || null);
                a.f = p;
                a.w = v;
                a.g = g;
                a.c = Nl(a.i, a, b, m, g);
            });
        }).then(function(p) {
            m && ve(m);
            return p ? gf(p) : null;
        }).o(function(p) {
            m && ve(m);
            throw p;
        });
        return R(a, d, e);
    }
    k.Dc = function(a) {
        var b = this;
        return an(this, "linkViaRedirect", a, function() {
            return Xm(b, a.providerId);
        }, !1);
    };
    k.Mc = function(a) {
        return an(this, "reauthViaRedirect", a, function() {
            return E();
        }, !0);
    };
    function an(a, b, c, d, e) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        if (a.h && !e) return F(a.h);
        var f = null, g = Ne(a.uid + ":::");
        d = d().then(function() {
            $m(a);
            if (!e) return a.I().then(function() {});
        }).then(function() {
            a.fa = g;
            return Km(a);
        }).then(function(h) {
            a.ga && (h = a.ga, h = h.b.set(bn, a.v(), h.a));
            return h;
        }).then(function() {
            return Ml(a.i, b, c, g, a.tenantId);
        }).o(function(h) {
            f = h;
            if (a.ga) return cn(a.ga);
            throw f;
        }).then(function() {
            if (f) throw f;
        });
        return R(a, d, e);
    }
    function $m(a) {
        if (!a.i || !a.P) {
            if (a.i && !a.P) throw new u("internal-error");
            throw new u("auth-domain-config-required");
        }
    }
    k.Hb = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null;
        c = this.I().then(function(g) {
            return Eg(e.a, {
                requestUri: a,
                postBody: d,
                sessionId: b,
                idToken: g
            });
        }).then(function(g) {
            f = Wm(e, g, "link");
            return Ym(e, g);
        }).then(function() {
            return f;
        });
        return R(this, c);
    };
    k.Ib = function(a, b, c, d) {
        var e = this;
        this.c && (this.c.cancel(), this.c = null);
        var f = null, g = E().then(function() {
            return zg(Fg(e.a, {
                requestUri: a,
                sessionId: b,
                postBody: d,
                tenantId: c
            }), e.uid);
        }).then(function(h) {
            f = Wm(e, h, "reauthenticate");
            om(e, h);
            e.h = null;
            return e.reload();
        }).then(function() {
            return f;
        });
        return R(this, g, !0);
    };
    k.qb = function(a) {
        var b = this, c = null;
        return R(this, this.I().then(function(d) {
            c = d;
            return "undefined" === typeof a || jb(a) ? {} : Zf(new Pf(a));
        }).then(function(d) {
            return b.a.qb(c, d);
        }).then(function(d) {
            if (b.email != d) return b.reload();
        }).then(function() {}));
    };
    k.Ab = function(a, b) {
        var c = this, d = null;
        return R(this, this.I().then(function(e) {
            d = e;
            return "undefined" === typeof b || jb(b) ? {} : Zf(new Pf(b));
        }).then(function(e) {
            return c.a.Ab(d, a, e);
        }).then(function(e) {
            if (c.email != e) return c.reload();
        }).then(function() {}));
    };
    function R(a, b, c) {
        var d = dn(a, b, c);
        a.N.push(d);
        d.ma(function() {
            Ta(a.N, d);
        });
        return d.o(function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = em(e.v(), Gm(a), r(a.hc, a)));
            throw f || e;
        });
    }
    k.hc = function(a) {
        var b = null, c = this;
        a = zg(E(a), c.uid).then(function(d) {
            b = Wm(c, d, "reauthenticate");
            om(c, d);
            c.h = null;
            return c.reload();
        }).then(function() {
            return b;
        });
        return R(this, a, !0);
    };
    function dn(a, b, c) {
        return a.h && !c ? (b.cancel(), F(a.h)) : b.o(function(d) {
            !d || "auth/user-disabled" != d.code && "auth/user-token-expired" != d.code || (a.h || a.dispatchEvent(new km("userInvalidated")), a.h = d);
            throw d;
        });
    }
    k.toJSON = function() {
        return this.v();
    };
    k.v = function() {
        var a = {
            uid: this.uid,
            displayName: this.displayName,
            photoURL: this.photoURL,
            email: this.email,
            emailVerified: this.emailVerified,
            phoneNumber: this.phoneNumber,
            isAnonymous: this.isAnonymous,
            tenantId: this.tenantId,
            providerData: [],
            apiKey: this.l,
            appName: this.m,
            authDomain: this.s,
            stsTokenManager: this.b.v(),
            redirectEventId: this.fa || null
        };
        this.metadata && B(a, this.metadata.v());
        x(this.providerData, function(b) {
            a.providerData.push(hf(b));
        });
        B(a, this.O.v());
        return a;
    };
    function en(a) {
        if (!a.apiKey) return null;
        var b = {
            apiKey: a.apiKey,
            authDomain: a.authDomain,
            appName: a.appName
        }, c = {};
        if (a.stsTokenManager && a.stsTokenManager.accessToken) c[Ag] = a.stsTokenManager.accessToken, c.refreshToken = a.stsTokenManager.refreshToken || null;
        else return null;
        var d = new P(b, c, a);
        a.providerData && x(a.providerData, function(e) {
            e && Pm(d, gf(e));
        });
        a.redirectEventId && (d.fa = a.redirectEventId);
        return d;
    }
    function fn(a, b, c, d) {
        var e = new P(a, b);
        c && (e.ga = c);
        d && Dm(e, d);
        return e.reload().then(function() {
            return e;
        });
    }
    function gn(a, b, c, d) {
        var e = a.b, f = {};
        f[Ag] = e.b && e.b.toString();
        f.refreshToken = e.a;
        b = new P(b || {
            apiKey: a.l,
            authDomain: a.s,
            appName: a.m
        }, f);
        c && (b.ga = c);
        d && Dm(b, d);
        Sm(b, a);
        return b;
    }
    function hn(a) {
        this.a = a;
        this.b = Ok();
    }
    var bn = {
        name: "redirectUser",
        F: "session"
    };
    function cn(a) {
        return Sk(a.b, bn, a.a);
    }
    function jn(a, b) {
        return a.b.get(bn, a.a).then(function(c) {
            c && b && (c.authDomain = b);
            return en(c || {});
        });
    }
    function kn(a) {
        this.a = a;
        this.b = Ok();
        this.c = null;
        this.f = ln(this);
        this.b.addListener(mn("local"), this.a, r(this.g, this));
    }
    kn.prototype.g = function() {
        var a = this, b = mn("local");
        nn(this, function() {
            return E().then(function() {
                return a.c && "local" != a.c.F ? a.b.get(b, a.a) : null;
            }).then(function(c) {
                if (c) return on(a, "local").then(function() {
                    a.c = b;
                });
            });
        });
    };
    function on(a, b) {
        var c = [], d;
        for(d in Kk)Kk[d] !== b && c.push(Sk(a.b, mn(Kk[d]), a.a));
        c.push(Sk(a.b, pn, a.a));
        return Dc(c);
    }
    function ln(a) {
        var b = mn("local"), c = mn("session"), d = mn("none");
        return Rk(a.b, b, a.a).then(function() {
            return a.b.get(c, a.a);
        }).then(function(e) {
            return e ? c : a.b.get(d, a.a).then(function(f) {
                return f ? d : a.b.get(b, a.a).then(function(g) {
                    return g ? b : a.b.get(pn, a.a).then(function(h) {
                        return h ? mn(h) : b;
                    });
                });
            });
        }).then(function(e) {
            a.c = e;
            return on(a, e.F);
        }).o(function() {
            a.c || (a.c = b);
        });
    }
    var pn = {
        name: "persistence",
        F: "session"
    };
    function mn(a) {
        return {
            name: "authUser",
            F: a
        };
    }
    kn.prototype.tb = function(a) {
        var b = null, c = this;
        Lk(a);
        return nn(this, function() {
            return a != c.c.F ? c.b.get(c.c, c.a).then(function(d) {
                b = d;
                return on(c, a);
            }).then(function() {
                c.c = mn(a);
                if (b) return c.b.set(c.c, b, c.a);
            }) : E();
        });
    };
    function qn(a) {
        return nn(a, function() {
            return a.b.set(pn, a.c.F, a.a);
        });
    }
    function rn(a, b) {
        return nn(a, function() {
            return a.b.set(a.c, b.v(), a.a);
        });
    }
    function sn(a) {
        return nn(a, function() {
            return Sk(a.b, a.c, a.a);
        });
    }
    function tn(a, b) {
        return nn(a, function() {
            return a.b.get(a.c, a.a).then(function(c) {
                c && b && (c.authDomain = b);
                return en(c || {});
            });
        });
    }
    function nn(a, b) {
        a.f = a.f.then(b, b);
        return a.f;
    }
    function un(a) {
        this.l = !1;
        K(this, "settings", new Xl);
        K(this, "app", a);
        if (S(this).options && S(this).options.apiKey) a = (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION) : null, this.b = new Ei(S(this).options && S(this).options.apiKey, za(Aa), a);
        else throw new u("invalid-api-key");
        this.P = [];
        this.m = [];
        this.O = [];
        this.$b = (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.createSubscribe(r(this.xc, this));
        this.W = void 0;
        this.ac = (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.createSubscribe(r(this.yc, this));
        vn(this, null);
        this.i = new kn(S(this).options.apiKey + ":" + S(this).name);
        this.B = new hn(S(this).options.apiKey + ":" + S(this).name);
        this.Z = T(this, wn(this));
        this.h = T(this, xn(this));
        this.aa = !1;
        this.oa = r(this.Xc, this);
        this.Ma = r(this.ca, this);
        this.xa = r(this.jc, this);
        this.ya = r(this.uc, this);
        this.za = r(this.vc, this);
        this.a = null;
        yn(this);
        this.INTERNAL = {};
        this.INTERNAL["delete"] = r(this.delete, this);
        this.INTERNAL.logFramework = r(this.Ec, this);
        this.s = 0;
        G.call(this);
        zn(this);
        this.N = [];
    }
    t(un, G);
    function An(a) {
        Xc.call(this, "languageCodeChanged");
        this.g = a;
    }
    t(An, Xc);
    function Bn(a) {
        Xc.call(this, "frameworkChanged");
        this.c = a;
    }
    t(Bn, Xc);
    k = un.prototype;
    k.tb = function(a) {
        a = this.i.tb(a);
        return T(this, a);
    };
    k.va = function(a) {
        this.$ === a || this.l || (this.$ = a, Ki(this.b, this.$), this.dispatchEvent(new An(this.ja())));
    };
    k.ja = function() {
        return this.$;
    };
    k.dd = function() {
        var a = l.navigator;
        this.va(a ? a.languages && a.languages[0] || a.language || a.userLanguage || null : null);
    };
    k.Ec = function(a) {
        this.N.push(a);
        Li(this.b, (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION, this.N) : null);
        this.dispatchEvent(new Bn(this.N));
    };
    k.Ea = function() {
        return Wa(this.N);
    };
    k.ub = function(a) {
        this.R === a || this.l || (this.R = a, this.b.b = this.R);
    };
    k.S = function() {
        return this.R;
    };
    function zn(a) {
        Object.defineProperty(a, "lc", {
            get: function() {
                return this.ja();
            },
            set: function(b) {
                this.va(b);
            },
            enumerable: !1
        });
        a.$ = null;
        Object.defineProperty(a, "ti", {
            get: function() {
                return this.S();
            },
            set: function(b) {
                this.ub(b);
            },
            enumerable: !1
        });
        a.R = null;
    }
    k.toJSON = function() {
        return {
            apiKey: S(this).options.apiKey,
            authDomain: S(this).options.authDomain,
            appName: S(this).name,
            currentUser: U(this) && U(this).v()
        };
    };
    function Cn(a) {
        return a.Zb || F(new u("auth-domain-config-required"));
    }
    function yn(a) {
        var b = S(a).options.authDomain, c = S(a).options.apiKey;
        b && Oe() && (a.Zb = a.Z.then(function() {
            if (!a.l) {
                a.a = Pl(b, c, S(a).name);
                Hl(a.a, a);
                U(a) && Lm(U(a));
                if (a.D) {
                    Lm(a.D);
                    var d = a.D;
                    d.va(a.ja());
                    Em(d, a);
                    d = a.D;
                    Dm(d, a.N);
                    Fm(d, a);
                    a.D = null;
                }
                return a.a;
            }
        }));
    }
    k.Cb = function(a, b) {
        switch(a){
            case "unknown":
            case "signInViaRedirect":
                return !0;
            case "signInViaPopup":
                return this.g == b && !!this.f;
            default:
                return !1;
        }
    };
    k.la = function(a, b, c, d) {
        "signInViaPopup" == a && this.g == d && (c && this.w ? this.w(c) : b && !c && this.f && this.f(b), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.w);
    };
    k.Da = function(a, b) {
        return "signInViaRedirect" == a || "signInViaPopup" == a && this.g == b && this.f ? r(this.gc, this) : null;
    };
    k.gc = function(a, b, c, d) {
        var e = this, f = {
            requestUri: a,
            postBody: d,
            sessionId: b,
            tenantId: c
        };
        this.c && (this.c.cancel(), this.c = null);
        return e.Z.then(function() {
            return Dn(e, Cg(e.b, f));
        });
    };
    k.Vc = function(a) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        var b = this, c = kg(a.providerId), d = Ne(), e = null;
        (!Qe() || Fe()) && S(this).options.authDomain && a.isOAuthProvider && (e = Yj(S(this).options.authDomain, S(this).options.apiKey, S(this).name, "signInViaPopup", a, null, d, (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION || null, null, null, this.S()));
        var f = we(e, c && c.ta, c && c.sa);
        c = Cn(this).then(function(g) {
            return Ll(g, f, "signInViaPopup", a, d, !!e, b.S());
        }).then(function() {
            return new D(function(g, h) {
                b.la("signInViaPopup", null, new u("cancelled-popup-request"), b.g);
                b.f = g;
                b.w = h;
                b.g = d;
                b.c = Nl(b.a, b, "signInViaPopup", f, d);
            });
        }).then(function(g) {
            f && ve(f);
            return g ? gf(g) : null;
        }).o(function(g) {
            f && ve(f);
            throw g;
        });
        return T(this, c);
    };
    k.Wc = function(a) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        var b = this, c = Cn(this).then(function() {
            return qn(b.i);
        }).then(function() {
            return Ml(b.a, "signInViaRedirect", a, void 0, b.S());
        });
        return T(this, c);
    };
    function En(a) {
        if (!Oe()) return F(new u("operation-not-supported-in-this-environment"));
        var b = Cn(a).then(function() {
            return a.a.pa();
        }).then(function(c) {
            return c ? gf(c) : null;
        });
        return T(a, b);
    }
    k.pa = function() {
        var a = this;
        return En(this).then(function(b) {
            a.a && Sl(a.a.b);
            return b;
        }).o(function(b) {
            a.a && Sl(a.a.b);
            throw b;
        });
    };
    k.bd = function(a) {
        if (!a) return F(new u("null-user"));
        if (this.R != a.tenantId) return F(new u("tenant-id-mismatch"));
        var b = this, c = {};
        c.apiKey = S(this).options.apiKey;
        c.authDomain = S(this).options.authDomain;
        c.appName = S(this).name;
        var d = gn(a, c, b.B, b.Ea());
        return T(this, this.h.then(function() {
            if (S(b).options.apiKey != a.l) return d.reload();
        }).then(function() {
            if (U(b) && a.uid == U(b).uid) return Sm(U(b), a), b.ca(a);
            vn(b, d);
            Lm(d);
            return b.ca(d);
        }).then(function() {
            Fn(b);
        }));
    };
    function Gn(a, b) {
        var c = {};
        c.apiKey = S(a).options.apiKey;
        c.authDomain = S(a).options.authDomain;
        c.appName = S(a).name;
        return a.Z.then(function() {
            return fn(c, b, a.B, a.Ea());
        }).then(function(d) {
            if (U(a) && d.uid == U(a).uid) return Sm(U(a), d), a.ca(d);
            vn(a, d);
            Lm(d);
            return a.ca(d);
        }).then(function() {
            Fn(a);
        });
    }
    function vn(a, b) {
        U(a) && (Jm(U(a), a.Ma), td(U(a), "tokenChanged", a.xa), td(U(a), "userDeleted", a.ya), td(U(a), "userInvalidated", a.za), Im(U(a)));
        b && (b.R.push(a.Ma), jd(b, "tokenChanged", a.xa), jd(b, "userDeleted", a.ya), jd(b, "userInvalidated", a.za), 0 < a.s && Hm(b));
        K(a, "currentUser", b);
        b && (b.va(a.ja()), Em(b, a), Dm(b, a.N), Fm(b, a));
    }
    k.wb = function() {
        var a = this, b = this.h.then(function() {
            a.a && Sl(a.a.b);
            if (!U(a)) return E();
            vn(a, null);
            return sn(a.i).then(function() {
                Fn(a);
            });
        });
        return T(this, b);
    };
    function Hn(a) {
        var b = jn(a.B, S(a).options.authDomain).then(function(c) {
            if (a.D = c) c.ga = a.B;
            return cn(a.B);
        });
        return T(a, b);
    }
    function wn(a) {
        var b = S(a).options.authDomain, c = Hn(a).then(function() {
            return tn(a.i, b);
        }).then(function(d) {
            return d ? (d.ga = a.B, a.D && (a.D.fa || null) == (d.fa || null) ? d : d.reload().then(function() {
                return rn(a.i, d).then(function() {
                    return d;
                });
            }).o(function(e) {
                return "auth/network-request-failed" == e.code ? d : sn(a.i);
            })) : null;
        }).then(function(d) {
            vn(a, d || null);
        });
        return T(a, c);
    }
    function xn(a) {
        return a.Z.then(function() {
            return En(a);
        }).o(function() {}).then(function() {
            if (!a.l) return a.oa();
        }).o(function() {}).then(function() {
            if (!a.l) {
                a.aa = !0;
                var b = a.i;
                b.b.addListener(mn("local"), b.a, a.oa);
            }
        });
    }
    k.Xc = function() {
        var a = this;
        return tn(this.i, S(this).options.authDomain).then(function(b) {
            if (!a.l) {
                var c;
                if (c = U(a) && b) {
                    c = U(a).uid;
                    var d = b.uid;
                    c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
                }
                if (c) return Sm(U(a), b), U(a).I();
                if (U(a) || b) vn(a, b), b && (Lm(b), b.ga = a.B), a.a && Hl(a.a, a), Fn(a);
            }
        });
    };
    k.ca = function(a) {
        return rn(this.i, a);
    };
    k.jc = function() {
        Fn(this);
        this.ca(U(this));
    };
    k.uc = function() {
        this.wb();
    };
    k.vc = function() {
        this.wb();
    };
    function Dn(a, b) {
        var c = null, d = null;
        return T(a, b.then(function(e) {
            c = mh(e);
            d = lg(e);
            return Gn(a, e);
        }, function(e) {
            var f = null;
            e && "auth/multi-factor-auth-required" === e.code && (f = em(e.v(), a, r(a.ic, a)));
            throw f || e;
        }).then(function() {
            return gf({
                user: U(a),
                credential: c,
                additionalUserInfo: d,
                operationType: "signIn"
            });
        }));
    }
    k.ic = function(a) {
        var b = this;
        return this.h.then(function() {
            return Dn(b, E(a));
        });
    };
    k.xc = function(a) {
        var b = this;
        this.addAuthTokenListener(function() {
            a.next(U(b));
        });
    };
    k.yc = function(a) {
        var b = this;
        In(this, function() {
            a.next(U(b));
        });
    };
    k.Gc = function(a, b, c) {
        var d = this;
        this.aa && Promise.resolve().then(function() {
            n(a) ? a(U(d)) : n(a.next) && a.next(U(d));
        });
        return this.$b(a, b, c);
    };
    k.Fc = function(a, b, c) {
        var d = this;
        this.aa && Promise.resolve().then(function() {
            d.W = d.getUid();
            n(a) ? a(U(d)) : n(a.next) && a.next(U(d));
        });
        return this.ac(a, b, c);
    };
    k.kc = function(a) {
        var b = this, c = this.h.then(function() {
            return U(b) ? U(b).I(a).then(function(d) {
                return {
                    accessToken: d
                };
            }) : null;
        });
        return T(this, c);
    };
    k.Rc = function(a) {
        var b = this;
        return this.h.then(function() {
            return Dn(b, N(b.b, Ej, {
                token: a
            }));
        }).then(function(c) {
            var d = c.user;
            Rm(d, "isAnonymous", !1);
            b.ca(d);
            return c;
        });
    };
    k.Sc = function(a, b) {
        var c = this;
        return this.h.then(function() {
            return Dn(c, N(c.b, Xg, {
                email: a,
                password: b
            }));
        });
    };
    k.cc = function(a, b) {
        var c = this;
        return this.h.then(function() {
            return Dn(c, N(c.b, yj, {
                email: a,
                password: b
            }));
        });
    };
    k.Ya = function(a) {
        var b = this;
        return this.h.then(function() {
            return Dn(b, a.ia(b.b));
        });
    };
    k.Qc = function(a) {
        df("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");
        return this.Ya(a);
    };
    k.vb = function() {
        var a = this;
        return this.h.then(function() {
            var b = U(a);
            if (b && b.isAnonymous) {
                var c = gf({
                    providerId: null,
                    isNewUser: !1
                });
                return gf({
                    user: b,
                    credential: null,
                    additionalUserInfo: c,
                    operationType: "signIn"
                });
            }
            return Dn(a, a.b.vb()).then(function(d) {
                var e = d.user;
                Rm(e, "isAnonymous", !0);
                a.ca(e);
                return d;
            });
        });
    };
    function S(a) {
        return a.app;
    }
    function U(a) {
        return a.currentUser;
    }
    k.getUid = function() {
        return U(this) && U(this).uid || null;
    };
    function Jn(a) {
        return U(a) && U(a)._lat || null;
    }
    function Fn(a) {
        if (a.aa) {
            for(var b = 0; b < a.m.length; b++)if (a.m[b]) a.m[b](Jn(a));
            if (a.W !== a.getUid() && a.O.length) {
                for(a.W = a.getUid(), b = 0; b < a.O.length; b++)if (a.O[b]) a.O[b](Jn(a));
            }
        }
    }
    k.bc = function(a) {
        this.addAuthTokenListener(a);
        this.s++;
        0 < this.s && U(this) && Hm(U(this));
    };
    k.Nc = function(a) {
        var b = this;
        x(this.m, function(c) {
            c == a && b.s--;
        });
        0 > this.s && (this.s = 0);
        0 == this.s && U(this) && Im(U(this));
        this.removeAuthTokenListener(a);
    };
    k.addAuthTokenListener = function(a) {
        var b = this;
        this.m.push(a);
        T(this, this.h.then(function() {
            b.l || Sa(b.m, a) && a(Jn(b));
        }));
    };
    k.removeAuthTokenListener = function(a) {
        Ua(this.m, function(b) {
            return b == a;
        });
    };
    function In(a, b) {
        a.O.push(b);
        T(a, a.h.then(function() {
            !a.l && Sa(a.O, b) && a.W !== a.getUid() && (a.W = a.getUid(), b(Jn(a)));
        }));
    }
    k.delete = function() {
        this.l = !0;
        for(var a = 0; a < this.P.length; a++)this.P[a].cancel("app-deleted");
        this.P = [];
        this.i && (a = this.i, a.b.removeListener(mn("local"), a.a, this.oa));
        this.a && (Il(this.a, this), Sl(this.a.b));
        return Promise.resolve();
    };
    function T(a, b) {
        a.P.push(b);
        b.ma(function() {
            Ta(a.P, b);
        });
        return b;
    }
    k.fc = function(a) {
        return T(this, Vi(this.b, a));
    };
    k.zc = function(a) {
        return !!bh(a);
    };
    k.sb = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            var d = new Pf(b);
            if (!d.c) throw new u("argument-error", Xf + " must be true when sending sign in link to email");
            return Zf(d);
        }).then(function(d) {
            return c.b.sb(a, d);
        }).then(function() {}));
    };
    k.fd = function(a) {
        return this.Pa(a).then(function(b) {
            return b.data.email;
        });
    };
    k.jb = function(a, b) {
        return T(this, this.b.jb(a, b).then(function() {}));
    };
    k.Pa = function(a) {
        return T(this, this.b.Pa(a).then(function(b) {
            return new sf(b);
        }));
    };
    k.fb = function(a) {
        return T(this, this.b.fb(a).then(function() {}));
    };
    k.rb = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            return "undefined" === typeof b || jb(b) ? {} : Zf(new Pf(b));
        }).then(function(d) {
            return c.b.rb(a, d);
        }).then(function() {}));
    };
    k.Uc = function(a, b) {
        return T(this, Zl(this, a, b, r(this.Ya, this)));
    };
    k.Tc = function(a, b) {
        var c = this;
        return T(this, E().then(function() {
            var d = b || oe(), e = ah(a, d);
            d = bh(d);
            if (!d) throw new u("argument-error", "Invalid email link!");
            if (d.tenantId !== c.S()) throw new u("tenant-id-mismatch");
            return c.Ya(e);
        }));
    };
    function Kn() {}
    Kn.prototype.render = function() {};
    Kn.prototype.reset = function() {};
    Kn.prototype.getResponse = function() {};
    Kn.prototype.execute = function() {};
    function Ln() {
        this.a = {};
        this.b = 1E12;
    }
    var Mn = null;
    Ln.prototype.render = function(a, b) {
        this.a[this.b.toString()] = new Nn(a, b);
        return this.b++;
    };
    Ln.prototype.reset = function(a) {
        var b = On(this, a);
        a = Pn(a);
        b && a && (b.delete(), delete this.a[a]);
    };
    Ln.prototype.getResponse = function(a) {
        return (a = On(this, a)) ? a.getResponse() : null;
    };
    Ln.prototype.execute = function(a) {
        (a = On(this, a)) && a.execute();
    };
    function On(a, b) {
        return (b = Pn(b)) ? a.a[b] || null : null;
    }
    function Pn(a) {
        return (a = "undefined" === typeof a ? 1E12 : a) ? a.toString() : null;
    }
    function Nn(a, b) {
        this.g = !1;
        this.c = b;
        this.a = this.b = null;
        this.h = "invisible" !== this.c.size;
        this.f = ec(a);
        var c = this;
        this.i = function() {
            c.execute();
        };
        this.h ? this.execute() : jd(this.f, "click", this.i);
    }
    Nn.prototype.getResponse = function() {
        Qn(this);
        return this.b;
    };
    Nn.prototype.execute = function() {
        Qn(this);
        var a = this;
        this.a || (this.a = setTimeout(function() {
            a.b = Je();
            var b = a.c.callback, c = a.c["expired-callback"];
            if (b) try {
                b(a.b);
            } catch (d) {}
            a.a = setTimeout(function() {
                a.a = null;
                a.b = null;
                if (c) try {
                    c();
                } catch (d) {}
                a.h && a.execute();
            }, 6E4);
        }, 500));
    };
    Nn.prototype.delete = function() {
        Qn(this);
        this.g = !0;
        clearTimeout(this.a);
        this.a = null;
        td(this.f, "click", this.i);
    };
    function Qn(a) {
        if (a.g) throw Error("reCAPTCHA mock was already deleted!");
    }
    function Rn() {}
    K(Rn, "FACTOR_ID", "phone");
    function Sn() {}
    Sn.prototype.g = function() {
        Mn || (Mn = new Ln);
        return E(Mn);
    };
    Sn.prototype.c = function() {};
    var Tn = null;
    function Un() {
        this.b = l.grecaptcha ? Infinity : 0;
        this.f = null;
        this.a = "__rcb" + Math.floor(1E6 * Math.random()).toString();
    }
    var Vn = new nb(ob, "https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"), Wn = new We(3E4, 6E4);
    Un.prototype.g = function(a) {
        var b = this;
        return new D(function(c, d) {
            var e = setTimeout(function() {
                d(new u("network-request-failed"));
            }, Wn.get());
            if (!l.grecaptcha || a !== b.f && !b.b) {
                l[b.a] = function() {
                    if (l.grecaptcha) {
                        b.f = a;
                        var g = l.grecaptcha.render;
                        l.grecaptcha.render = function(h, m) {
                            h = g(h, m);
                            b.b++;
                            return h;
                        };
                        clearTimeout(e);
                        c(l.grecaptcha);
                    } else clearTimeout(e), d(new u("internal-error"));
                    delete l[b.a];
                };
                var f = wb(Vn, {
                    onload: b.a,
                    hl: a || ""
                });
                E(xi(f)).o(function() {
                    clearTimeout(e);
                    d(new u("internal-error", "Unable to load external reCAPTCHA dependencies!"));
                });
            } else clearTimeout(e), c(l.grecaptcha);
        });
    };
    Un.prototype.c = function() {
        this.b--;
    };
    var Xn = null;
    function Yn(a, b, c, d, e, f, g) {
        K(this, "type", "recaptcha");
        this.c = this.f = null;
        this.D = !1;
        this.u = b;
        this.g = null;
        g ? (Tn || (Tn = new Sn), g = Tn) : (Xn || (Xn = new Un), g = Xn);
        this.m = g;
        this.a = c || {
            theme: "light",
            type: "image"
        };
        this.h = [];
        if (this.a[Zn]) throw new u("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");
        this.i = "invisible" === this.a[$n];
        if (!l.document) throw new u("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
        if (!ec(b) || !this.i && ec(b).hasChildNodes()) throw new u("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");
        this.s = new Ei(a, f || null, e || null);
        this.w = d || function() {
            return null;
        };
        var h = this;
        this.l = [];
        var m = this.a[ao];
        this.a[ao] = function(v) {
            bo(h, v);
            if ("function" === typeof m) m(v);
            else if ("string" === typeof m) {
                var C = J(m, l);
                "function" === typeof C && C(v);
            }
        };
        var p = this.a[co];
        this.a[co] = function() {
            bo(h, null);
            if ("function" === typeof p) p();
            else if ("string" === typeof p) {
                var v = J(p, l);
                "function" === typeof v && v();
            }
        };
    }
    var ao = "callback", co = "expired-callback", Zn = "sitekey", $n = "size";
    function bo(a, b) {
        for(var c = 0; c < a.l.length; c++)try {
            a.l[c](b);
        } catch (d) {}
    }
    function eo(a, b) {
        Ua(a.l, function(c) {
            return c == b;
        });
    }
    function fo(a, b) {
        a.h.push(b);
        b.ma(function() {
            Ta(a.h, b);
        });
        return b;
    }
    k = Yn.prototype;
    k.Ga = function() {
        var a = this;
        return this.f ? this.f : this.f = fo(this, E().then(function() {
            if (Pe() && !Ge()) return Be();
            throw new u("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
        }).then(function() {
            return a.m.g(a.w());
        }).then(function(b) {
            a.g = b;
            return N(a.s, Dj, {});
        }).then(function(b) {
            a.a[Zn] = b.recaptchaSiteKey;
        }).o(function(b) {
            a.f = null;
            throw b;
        }));
    };
    k.render = function() {
        go(this);
        var a = this;
        return fo(this, this.Ga().then(function() {
            if (null === a.c) {
                var b = a.u;
                if (!a.i) {
                    var c = ec(b);
                    b = hc("DIV");
                    c.appendChild(b);
                }
                a.c = a.g.render(b, a.a);
            }
            return a.c;
        }));
    };
    k.verify = function() {
        go(this);
        var a = this;
        return fo(this, this.render().then(function(b) {
            return new D(function(c) {
                var d = a.g.getResponse(b);
                if (d) c(d);
                else {
                    var e = function(f) {
                        f && (eo(a, e), c(f));
                    };
                    a.l.push(e);
                    a.i && a.g.execute(a.c);
                }
            });
        }));
    };
    k.reset = function() {
        go(this);
        null !== this.c && this.g.reset(this.c);
    };
    function go(a) {
        if (a.D) throw new u("internal-error", "RecaptchaVerifier instance has been destroyed.");
    }
    k.clear = function() {
        go(this);
        this.D = !0;
        this.m.c();
        for(var a = 0; a < this.h.length; a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");
        if (!this.i) {
            a = ec(this.u);
            for(var b; b = a.firstChild;)a.removeChild(b);
        }
    };
    function ho(a, b, c) {
        var d = !1;
        try {
            this.b = c || (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).app();
        } catch (g) {
            throw new u("argument-error", "No firebase.app.App instance is currently initialized.");
        }
        if (this.b.options && this.b.options.apiKey) c = this.b.options.apiKey;
        else throw new u("invalid-api-key");
        var e = this, f = null;
        try {
            f = this.b.auth().Ea();
        } catch (g) {}
        try {
            d = this.b.auth().settings.appVerificationDisabledForTesting;
        } catch (g) {}
        f = (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION ? Le((0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).SDK_VERSION, f) : null;
        Yn.call(this, c, a, b, function() {
            try {
                var g = e.b.auth().ja();
            } catch (h) {
                g = null;
            }
            return g;
        }, f, za(Aa), d);
    }
    t(ho, Yn);
    function io(a, b, c, d) {
        a: {
            c = Array.prototype.slice.call(c);
            var e = 0;
            for(var f = !1, g = 0; g < b.length; g++)if (b[g].optional) f = !0;
            else {
                if (f) throw new u("internal-error", "Argument validator encountered a required argument after an optional argument.");
                e++;
            }
            f = b.length;
            if (c.length < e || f < c.length) d = "Expected " + (e == f ? 1 == e ? "1 argument" : e + " arguments" : e + "-" + f + " arguments") + " but got " + c.length + ".";
            else {
                for(e = 0; e < c.length; e++)if (f = b[e].optional && void 0 === c[e], !b[e].K(c[e]) && !f) {
                    b = b[e];
                    if (0 > e || e >= jo.length) throw new u("internal-error", "Argument validator received an unsupported number of arguments.");
                    c = jo[e];
                    d = (d ? "" : c + " argument ") + (b.name ? '"' + b.name + '" ' : "") + "must be " + b.J + ".";
                    break a;
                }
                d = null;
            }
        }
        if (d) throw new u("argument-error", a + " failed: " + d);
    }
    var jo = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");
    function V(a, b) {
        return {
            name: a || "",
            J: "a valid string",
            optional: !!b,
            K: function(c) {
                return "string" === typeof c;
            }
        };
    }
    function ko(a, b) {
        return {
            name: a || "",
            J: "a boolean",
            optional: !!b,
            K: function(c) {
                return "boolean" === typeof c;
            }
        };
    }
    function W(a, b) {
        return {
            name: a || "",
            J: "a valid object",
            optional: !!b,
            K: q
        };
    }
    function lo(a, b) {
        return {
            name: a || "",
            J: "a function",
            optional: !!b,
            K: n
        };
    }
    function mo(a, b) {
        return {
            name: a || "",
            J: "null",
            optional: !!b,
            K: function(c) {
                return null === c;
            }
        };
    }
    function no() {
        return {
            name: "",
            J: "an HTML element",
            optional: !1,
            K: function(a) {
                return !!(a && a instanceof Element);
            }
        };
    }
    function oo() {
        return {
            name: "auth",
            J: "an instance of Firebase Auth",
            optional: !0,
            K: function(a) {
                return !!(a && a instanceof un);
            }
        };
    }
    function po() {
        return {
            name: "app",
            J: "an instance of Firebase App",
            optional: !0,
            K: function(a) {
                return !!(a && a instanceof (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).app.App);
            }
        };
    }
    function qo(a) {
        return {
            name: a ? a + "Credential" : "credential",
            J: a ? "a valid " + a + " credential" : "a valid credential",
            optional: !1,
            K: function(b) {
                if (!b) return !1;
                var c = !a || b.providerId === a;
                return !(!b.ia || !c);
            }
        };
    }
    function ro() {
        return {
            name: "multiFactorAssertion",
            J: "a valid multiFactorAssertion",
            optional: !1,
            K: function(a) {
                return a ? !!a.ob : !1;
            }
        };
    }
    function so() {
        return {
            name: "authProvider",
            J: "a valid Auth provider",
            optional: !1,
            K: function(a) {
                return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
            }
        };
    }
    function to(a, b) {
        return q(a) && "string" === typeof a.type && a.type === b && n(a.Fa);
    }
    function uo(a) {
        return q(a) && "string" === typeof a.uid;
    }
    function vo() {
        return {
            name: "applicationVerifier",
            J: "an implementation of firebase.auth.ApplicationVerifier",
            optional: !1,
            K: function(a) {
                return !(!a || "string" !== typeof a.type || !n(a.verify));
            }
        };
    }
    function X(a, b, c, d) {
        return {
            name: c || "",
            J: a.J + " or " + b.J,
            optional: !!d,
            K: function(e) {
                return a.K(e) || b.K(e);
            }
        };
    }
    function Y(a, b) {
        for(var c in b){
            var d = b[c].name;
            a[d] = wo(d, a[c], b[c].j);
        }
    }
    function xo(a, b) {
        for(var c in b){
            var d = b[c].name;
            d !== c && Object.defineProperty(a, d, {
                get: sa(function(e) {
                    return this[e];
                }, c),
                set: sa(function(e, f, g, h) {
                    io(e, [
                        g
                    ], [
                        h
                    ], !0);
                    this[f] = h;
                }, d, c, b[c].gb),
                enumerable: !0
            });
        }
    }
    function Z(a, b, c, d) {
        a[b] = wo(b, c, d);
    }
    function wo(a, b, c) {
        function d() {
            var g = Array.prototype.slice.call(arguments);
            io(e, c, g);
            return b.apply(this, g);
        }
        if (!c) return b;
        var e = yo(a), f;
        for(f in b)d[f] = b[f];
        for(f in b.prototype)d.prototype[f] = b.prototype[f];
        return d;
    }
    function yo(a) {
        a = a.split(".");
        return a[a.length - 1];
    }
    Y(un.prototype, {
        fb: {
            name: "applyActionCode",
            j: [
                V("code")
            ]
        },
        Pa: {
            name: "checkActionCode",
            j: [
                V("code")
            ]
        },
        jb: {
            name: "confirmPasswordReset",
            j: [
                V("code"),
                V("newPassword")
            ]
        },
        cc: {
            name: "createUserWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        fc: {
            name: "fetchSignInMethodsForEmail",
            j: [
                V("email")
            ]
        },
        pa: {
            name: "getRedirectResult",
            j: []
        },
        zc: {
            name: "isSignInWithEmailLink",
            j: [
                V("emailLink")
            ]
        },
        Fc: {
            name: "onAuthStateChanged",
            j: [
                X(W(), lo(), "nextOrObserver"),
                lo("opt_error", !0),
                lo("opt_completed", !0)
            ]
        },
        Gc: {
            name: "onIdTokenChanged",
            j: [
                X(W(), lo(), "nextOrObserver"),
                lo("opt_error", !0),
                lo("opt_completed", !0)
            ]
        },
        rb: {
            name: "sendPasswordResetEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), mo(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        sb: {
            name: "sendSignInLinkToEmail",
            j: [
                V("email"),
                W("actionCodeSettings")
            ]
        },
        tb: {
            name: "setPersistence",
            j: [
                V("persistence")
            ]
        },
        Qc: {
            name: "signInAndRetrieveDataWithCredential",
            j: [
                qo()
            ]
        },
        vb: {
            name: "signInAnonymously",
            j: []
        },
        Ya: {
            name: "signInWithCredential",
            j: [
                qo()
            ]
        },
        Rc: {
            name: "signInWithCustomToken",
            j: [
                V("token")
            ]
        },
        Sc: {
            name: "signInWithEmailAndPassword",
            j: [
                V("email"),
                V("password")
            ]
        },
        Tc: {
            name: "signInWithEmailLink",
            j: [
                V("email"),
                V("emailLink", !0)
            ]
        },
        Uc: {
            name: "signInWithPhoneNumber",
            j: [
                V("phoneNumber"),
                vo()
            ]
        },
        Vc: {
            name: "signInWithPopup",
            j: [
                so()
            ]
        },
        Wc: {
            name: "signInWithRedirect",
            j: [
                so()
            ]
        },
        bd: {
            name: "updateCurrentUser",
            j: [
                X(function(a) {
                    return {
                        name: "user",
                        J: "an instance of Firebase User",
                        optional: !!a,
                        K: function(b) {
                            return !!(b && b instanceof P);
                        }
                    };
                }(), mo(), "user")
            ]
        },
        wb: {
            name: "signOut",
            j: []
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        dd: {
            name: "useDeviceLanguage",
            j: []
        },
        fd: {
            name: "verifyPasswordResetCode",
            j: [
                V("code")
            ]
        }
    });
    xo(un.prototype, {
        lc: {
            name: "languageCode",
            gb: X(V(), mo(), "languageCode")
        },
        ti: {
            name: "tenantId",
            gb: X(V(), mo(), "tenantId")
        }
    });
    un.Persistence = Kk;
    un.Persistence.LOCAL = "local";
    un.Persistence.SESSION = "session";
    un.Persistence.NONE = "none";
    Y(P.prototype, {
        "delete": {
            name: "delete",
            j: []
        },
        mc: {
            name: "getIdTokenResult",
            j: [
                ko("opt_forceRefresh", !0)
            ]
        },
        I: {
            name: "getIdToken",
            j: [
                ko("opt_forceRefresh", !0)
            ]
        },
        Ac: {
            name: "linkAndRetrieveDataWithCredential",
            j: [
                qo()
            ]
        },
        mb: {
            name: "linkWithCredential",
            j: [
                qo()
            ]
        },
        Bc: {
            name: "linkWithPhoneNumber",
            j: [
                V("phoneNumber"),
                vo()
            ]
        },
        Cc: {
            name: "linkWithPopup",
            j: [
                so()
            ]
        },
        Dc: {
            name: "linkWithRedirect",
            j: [
                so()
            ]
        },
        Jc: {
            name: "reauthenticateAndRetrieveDataWithCredential",
            j: [
                qo()
            ]
        },
        pb: {
            name: "reauthenticateWithCredential",
            j: [
                qo()
            ]
        },
        Kc: {
            name: "reauthenticateWithPhoneNumber",
            j: [
                V("phoneNumber"),
                vo()
            ]
        },
        Lc: {
            name: "reauthenticateWithPopup",
            j: [
                so()
            ]
        },
        Mc: {
            name: "reauthenticateWithRedirect",
            j: [
                so()
            ]
        },
        reload: {
            name: "reload",
            j: []
        },
        qb: {
            name: "sendEmailVerification",
            j: [
                X(W("opt_actionCodeSettings", !0), mo(null, !0), "opt_actionCodeSettings", !0)
            ]
        },
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        },
        ad: {
            name: "unlink",
            j: [
                V("provider")
            ]
        },
        xb: {
            name: "updateEmail",
            j: [
                V("email")
            ]
        },
        yb: {
            name: "updatePassword",
            j: [
                V("password")
            ]
        },
        cd: {
            name: "updatePhoneNumber",
            j: [
                qo("phone")
            ]
        },
        zb: {
            name: "updateProfile",
            j: [
                W("profile")
            ]
        },
        Ab: {
            name: "verifyBeforeUpdateEmail",
            j: [
                V("email"),
                X(W("opt_actionCodeSettings", !0), mo(null, !0), "opt_actionCodeSettings", !0)
            ]
        }
    });
    Y(Ln.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(Kn.prototype, {
        execute: {
            name: "execute"
        },
        render: {
            name: "render"
        },
        reset: {
            name: "reset"
        },
        getResponse: {
            name: "getResponse"
        }
    });
    Y(D.prototype, {
        ma: {
            name: "finally"
        },
        o: {
            name: "catch"
        },
        then: {
            name: "then"
        }
    });
    xo(Xl.prototype, {
        appVerificationDisabled: {
            name: "appVerificationDisabledForTesting",
            gb: ko("appVerificationDisabledForTesting")
        }
    });
    Y(Yl.prototype, {
        confirm: {
            name: "confirm",
            j: [
                V("verificationCode")
            ]
        }
    });
    Z(yg, "fromJSON", function(a) {
        a = "string" === typeof a ? JSON.parse(a) : a;
        for(var b, c = [
            Jg,
            $g,
            gh,
            Gg
        ], d = 0; d < c.length; d++)if (b = c[d](a)) return b;
        return null;
    }, [
        X(V(), W(), "json")
    ]);
    Z(Vg, "credential", function(a, b) {
        return new Ug(a, b);
    }, [
        V("email"),
        V("password")
    ]);
    Y(Ug.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Mg.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Mg, "credential", Ng, [
        X(V(), W(), "token")
    ]);
    Z(Vg, "credentialWithLink", ah, [
        V("email"),
        V("emailLink")
    ]);
    Y(Og.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Og, "credential", Pg, [
        X(V(), W(), "token")
    ]);
    Y(Qg.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Qg, "credential", Rg, [
        X(V(), X(W(), mo()), "idToken"),
        X(V(), mo(), "accessToken", !0)
    ]);
    Y(Sg.prototype, {
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Z(Sg, "credential", Tg, [
        X(V(), W(), "token"),
        V("secret", !0)
    ]);
    Y(M.prototype, {
        Aa: {
            name: "addScope",
            j: [
                V("scope")
            ]
        },
        credential: {
            name: "credential",
            j: [
                X(V(), X(W(), mo()), "optionsOrIdToken"),
                X(V(), mo(), "accessToken", !0)
            ]
        },
        Ia: {
            name: "setCustomParameters",
            j: [
                W("customOAuthParameters")
            ]
        }
    });
    Y(Hg.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(Bg.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Z(hh, "credential", lh, [
        V("verificationId"),
        V("verificationCode")
    ]);
    Y(hh.prototype, {
        cb: {
            name: "verifyPhoneNumber",
            j: [
                X(V(), function(a, b) {
                    return {
                        name: a || "phoneInfoOptions",
                        J: "valid phone info options",
                        optional: !!b,
                        K: function(c) {
                            return c ? c.session && c.phoneNumber ? to(c.session, wg) && "string" === typeof c.phoneNumber : c.session && c.multiFactorHint ? to(c.session, xg) && uo(c.multiFactorHint) : c.session && c.multiFactorUid ? to(c.session, xg) && "string" === typeof c.multiFactorUid : c.phoneNumber ? "string" === typeof c.phoneNumber : !1 : !1;
                        }
                    };
                }(), "phoneInfoOptions"),
                vo()
            ]
        }
    });
    Y(ch.prototype, {
        v: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(u.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(uh.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(th.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(dm.prototype, {
        toJSON: {
            name: "toJSON",
            j: [
                V(null, !0)
            ]
        }
    });
    Y(am.prototype, {
        Pc: {
            name: "resolveSignIn",
            j: [
                ro()
            ]
        }
    });
    Y(lm.prototype, {
        Ob: {
            name: "getSession",
            j: []
        },
        dc: {
            name: "enroll",
            j: [
                ro(),
                V("displayName", !0)
            ]
        },
        $c: {
            name: "unenroll",
            j: [
                X({
                    name: "multiFactorInfo",
                    J: "a valid multiFactorInfo",
                    optional: !1,
                    K: uo
                }, V(), "multiFactorInfoIdentifier")
            ]
        }
    });
    Y(ho.prototype, {
        clear: {
            name: "clear",
            j: []
        },
        render: {
            name: "render",
            j: []
        },
        verify: {
            name: "verify",
            j: []
        }
    });
    Z(Gf, "parseLink", Of, [
        V("link")
    ]);
    Z(Rn, "assertion", function(a) {
        return new jm(a);
    }, [
        qo("phone")
    ]);
    (function() {
        if ("undefined" !== typeof (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))) && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL && (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.registerComponent) {
            var a = {
                ActionCodeInfo: {
                    Operation: {
                        EMAIL_SIGNIN: xf,
                        PASSWORD_RESET: "PASSWORD_RESET",
                        RECOVER_EMAIL: "RECOVER_EMAIL",
                        REVERT_SECOND_FACTOR_ADDITION: zf,
                        VERIFY_AND_CHANGE_EMAIL: yf,
                        VERIFY_EMAIL: "VERIFY_EMAIL"
                    }
                },
                Auth: un,
                AuthCredential: yg,
                Error: u
            };
            Z(a, "EmailAuthProvider", Vg, []);
            Z(a, "FacebookAuthProvider", Mg, []);
            Z(a, "GithubAuthProvider", Og, []);
            Z(a, "GoogleAuthProvider", Qg, []);
            Z(a, "TwitterAuthProvider", Sg, []);
            Z(a, "OAuthProvider", M, [
                V("providerId")
            ]);
            Z(a, "SAMLAuthProvider", Lg, [
                V("providerId")
            ]);
            Z(a, "PhoneAuthProvider", hh, [
                oo()
            ]);
            Z(a, "RecaptchaVerifier", ho, [
                X(V(), no(), "recaptchaContainer"),
                W("recaptchaParameters", !0),
                po()
            ]);
            Z(a, "ActionCodeURL", Gf, []);
            Z(a, "PhoneMultiFactorGenerator", Rn, []);
            (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.registerComponent({
                name: "auth",
                instanceFactory: function(b) {
                    b = b.getProvider("app").getImmediate();
                    return new un(b);
                },
                multipleInstances: !1,
                serviceProps: a,
                instantiationMode: "LAZY",
                type: "PUBLIC"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.registerComponent({
                name: "auth-internal",
                instanceFactory: function(b) {
                    b = b.getProvider("auth").getImmediate();
                    return {
                        getUid: r(b.getUid, b),
                        getToken: r(b.kc, b),
                        addAuthTokenListener: r(b.bc, b),
                        removeAuthTokenListener: r(b.Nc, b)
                    };
                },
                multipleInstances: !1,
                instantiationMode: "LAZY",
                type: "PRIVATE"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).registerVersion("@firebase/auth", "0.14.6");
            (0, (/*@__PURE__*/$parcel$interopDefault($jJO2d))).INTERNAL.extendNamespace({
                User: P
            });
        } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
    })();
}).apply(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});
parcelRegister("jJO2d", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $jAuJs = parcelRequire("jAuJs");

var $epfVL = parcelRequire("epfVL");

var $9Cwol = parcelRequire("9Cwol");

var $ctGiR = parcelRequire("ctGiR");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e5e908211ba4e8b1$var$_a;
var $e5e908211ba4e8b1$var$ERRORS = ($e5e908211ba4e8b1$var$_a = {}, $e5e908211ba4e8b1$var$_a["no-app" /* NO_APP */ ] = "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()", $e5e908211ba4e8b1$var$_a["bad-app-name" /* BAD_APP_NAME */ ] = "Illegal App name: '{$appName}", $e5e908211ba4e8b1$var$_a["duplicate-app" /* DUPLICATE_APP */ ] = "Firebase App named '{$appName}' already exists", $e5e908211ba4e8b1$var$_a["app-deleted" /* APP_DELETED */ ] = "Firebase App named '{$appName}' already deleted", $e5e908211ba4e8b1$var$_a["invalid-app-argument" /* INVALID_APP_ARGUMENT */ ] = "firebase.{$appName}() takes either no argument or a Firebase App instance.", $e5e908211ba4e8b1$var$_a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */ ] = 'First argument to `onLog` must be null or a function.', $e5e908211ba4e8b1$var$_a);
var $e5e908211ba4e8b1$var$ERROR_FACTORY = new $epfVL.ErrorFactory('app', 'Firebase', $e5e908211ba4e8b1$var$ERRORS);
var $e5e908211ba4e8b1$var$name$1 = "@firebase/app";
var $e5e908211ba4e8b1$var$version = "0.6.4";
var $e5e908211ba4e8b1$var$name$2 = "@firebase/analytics";
var $e5e908211ba4e8b1$var$name$3 = "@firebase/auth";
var $e5e908211ba4e8b1$var$name$4 = "@firebase/database";
var $e5e908211ba4e8b1$var$name$5 = "@firebase/functions";
var $e5e908211ba4e8b1$var$name$6 = "@firebase/installations";
var $e5e908211ba4e8b1$var$name$7 = "@firebase/messaging";
var $e5e908211ba4e8b1$var$name$8 = "@firebase/performance";
var $e5e908211ba4e8b1$var$name$9 = "@firebase/remote-config";
var $e5e908211ba4e8b1$var$name$a = "@firebase/storage";
var $e5e908211ba4e8b1$var$name$b = "@firebase/firestore";
var $e5e908211ba4e8b1$var$name$c = "firebase-wrapper";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e5e908211ba4e8b1$var$_a$1;
var $e5e908211ba4e8b1$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
var $e5e908211ba4e8b1$var$PLATFORM_LOG_STRING = ($e5e908211ba4e8b1$var$_a$1 = {}, $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$1] = 'fire-core', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$2] = 'fire-analytics', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$3] = 'fire-auth', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$4] = 'fire-rtdb', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$5] = 'fire-fn', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$6] = 'fire-iid', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$7] = 'fire-fcm', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$8] = 'fire-perf', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$9] = 'fire-rc', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$a] = 'fire-gcs', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$b] = 'fire-fst', $e5e908211ba4e8b1$var$_a$1['fire-js'] = 'fire-js', $e5e908211ba4e8b1$var$_a$1[$e5e908211ba4e8b1$var$name$c] = 'fire-js-all', $e5e908211ba4e8b1$var$_a$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e5e908211ba4e8b1$var$logger = new $ctGiR.Logger('@firebase/app');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Global context object for a collection of services using
 * a shared authentication state.
 */ var $e5e908211ba4e8b1$var$FirebaseAppImpl = /** @class */ function() {
    function FirebaseAppImpl(options, config, firebase_) {
        var e_1, _a;
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ = config.automaticDataCollectionEnabled || false;
        this.options_ = $epfVL.deepCopy(options);
        this.container = new $9Cwol.ComponentContainer(config.name);
        // add itself to container
        this._addComponent(new $9Cwol.Component('app', function() {
            return _this;
        }, "PUBLIC" /* PUBLIC */ ));
        try {
            // populate ComponentContainer with existing components
            for(var _b = $jAuJs.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var component$1 = _c.value;
                this._addComponent(component$1);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function() {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function(val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function() {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function() {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function() {
        var _this = this;
        return new Promise(function(resolve) {
            _this.checkDestroyed_();
            resolve();
        }).then(function() {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            return Promise.all(_this.container.getProviders().map(function(provider) {
                return provider.delete();
            }));
        }).then(function() {
            _this.isDeleted_ = true;
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */ FirebaseAppImpl.prototype._getService = function(name1, instanceIdentifier) {
        if (instanceIdentifier === void 0) instanceIdentifier = $e5e908211ba4e8b1$var$DEFAULT_ENTRY_NAME;
        this.checkDestroyed_();
        // getImmediate will always succeed because _getService is only called for registered components.
        return this.container.getProvider(name1).getImmediate({
            identifier: instanceIdentifier
        });
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */ FirebaseAppImpl.prototype._removeServiceInstance = function(name1, instanceIdentifier) {
        if (instanceIdentifier === void 0) instanceIdentifier = $e5e908211ba4e8b1$var$DEFAULT_ENTRY_NAME;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.container.getProvider(name1).clearInstance(instanceIdentifier);
    };
    /**
     * @param component the component being added to this app's container
     */ FirebaseAppImpl.prototype._addComponent = function(component) {
        try {
            this.container.addComponent(component);
        } catch (e) {
            $e5e908211ba4e8b1$var$logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
        }
    };
    FirebaseAppImpl.prototype._addOrOverwriteComponent = function(component) {
        this.container.addOrOverwriteComponent(component);
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ FirebaseAppImpl.prototype.checkDestroyed_ = function() {
        if (this.isDeleted_) throw $e5e908211ba4e8b1$var$ERROR_FACTORY.create("app-deleted" /* APP_DELETED */ , {
            appName: this.name_
        });
    };
    return FirebaseAppImpl;
}();
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
$e5e908211ba4e8b1$var$FirebaseAppImpl.prototype.name && $e5e908211ba4e8b1$var$FirebaseAppImpl.prototype.options || $e5e908211ba4e8b1$var$FirebaseAppImpl.prototype.delete || console.log('dc');
var $e5e908211ba4e8b1$var$version$1 = "7.14.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */ function $e5e908211ba4e8b1$var$createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var components = new Map();
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        registerVersion: registerVersion,
        setLogLevel: $ctGiR.setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: $e5e908211ba4e8b1$var$version$1,
        INTERNAL: {
            registerComponent: registerComponent,
            removeApp: removeApp,
            components: components,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */ function removeApp(name1) {
        delete apps[name1];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */ function app(name1) {
        name1 = name1 || $e5e908211ba4e8b1$var$DEFAULT_ENTRY_NAME;
        if (!$epfVL.contains(apps, name1)) throw $e5e908211ba4e8b1$var$ERROR_FACTORY.create("no-app" /* NO_APP */ , {
            appName: name1
        });
        return apps[name1];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) rawConfig = {};
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = {
                name: name_1
            };
        }
        var config = rawConfig;
        if (config.name === undefined) config.name = $e5e908211ba4e8b1$var$DEFAULT_ENTRY_NAME;
        var name1 = config.name;
        if (typeof name1 !== 'string' || !name1) throw $e5e908211ba4e8b1$var$ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */ , {
            appName: String(name1)
        });
        if ($epfVL.contains(apps, name1)) throw $e5e908211ba4e8b1$var$ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */ , {
            appName: name1
        });
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name1] = app;
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */ function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function(name1) {
            return apps[name1];
        });
    }
    function registerComponent(component) {
        var e_1, _a;
        var componentName = component.name;
        if (components.has(componentName)) {
            $e5e908211ba4e8b1$var$logger.debug("There were multiple attempts to register component " + componentName + ".");
            return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
        }
        components.set(componentName, component);
        // create service namespace for public components
        if (component.type === "PUBLIC" /* PUBLIC */ ) {
            // The Service namespace is an accessor function ...
            var serviceNamespace = function(appArg) {
                if (appArg === void 0) appArg = app();
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentName] !== 'function') // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw $e5e908211ba4e8b1$var$ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */ , {
                    appName: componentName
                });
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentName]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) $epfVL.deepExtend(serviceNamespace, component.serviceProps);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentName] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentName] = // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var serviceFxn = this._getService.bind(this, componentName);
                return serviceFxn.apply(this, component.multipleInstances ? args : []);
            };
        }
        try {
            // add the component to existing app instances
            for(var _b = $jAuJs.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()){
                var appName = _c.value;
                apps[appName]._addComponent(component);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return component.type === "PUBLIC" /* PUBLIC */  ? namespace[componentName] : null;
    }
    function registerVersion(libraryKeyOrName, version, variant) {
        var _a;
        // TODO: We can use this check to whitelist strings when/if we set up
        // a good whitelist system.
        var library = (_a = $e5e908211ba4e8b1$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
        if (variant) library += "-" + variant;
        var libraryMismatch = library.match(/\s|\//);
        var versionMismatch = version.match(/\s|\//);
        if (libraryMismatch || versionMismatch) {
            var warning = [
                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
            ];
            if (libraryMismatch) warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
            if (libraryMismatch && versionMismatch) warning.push('and');
            if (versionMismatch) warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
            $e5e908211ba4e8b1$var$logger.warn(warning.join(' '));
            return;
        }
        registerComponent(new $9Cwol.Component(library + "-version", function() {
            return {
                library: library,
                version: version
            };
        }, "VERSION" /* VERSION */ ));
    }
    function onLog(logCallback, options) {
        if (logCallback !== null && typeof logCallback !== 'function') throw $e5e908211ba4e8b1$var$ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */ , {
            appName: name
        });
        $ctGiR.setUserLogHandler(logCallback, options);
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name1) {
        if (name1 === 'serverAuth') return null;
        var useService = name1;
        return useService;
    }
    return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */ function $e5e908211ba4e8b1$var$createFirebaseNamespace() {
    var namespace = $e5e908211ba4e8b1$var$createFirebaseNamespaceCore($e5e908211ba4e8b1$var$FirebaseAppImpl);
    namespace.INTERNAL = $jAuJs.__assign($jAuJs.__assign({}, namespace.INTERNAL), {
        createFirebaseNamespace: $e5e908211ba4e8b1$var$createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: $epfVL.createSubscribe,
        ErrorFactory: $epfVL.ErrorFactory,
        deepExtend: $epfVL.deepExtend
    });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */ function extendNamespace(props) {
        $epfVL.deepExtend(namespace, props);
    }
    return namespace;
}
var $e5e908211ba4e8b1$var$firebase = $e5e908211ba4e8b1$var$createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e5e908211ba4e8b1$var$PlatformLoggerService = /** @class */ function() {
    function PlatformLoggerService(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    PlatformLoggerService.prototype.getPlatformInfoString = function() {
        var providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map(function(provider) {
            if ($e5e908211ba4e8b1$var$isVersionServiceProvider(provider)) {
                var service = provider.getImmediate();
                return service.library + "/" + service.version;
            } else return null;
        }).filter(function(logString) {
            return logString;
        }).join(' ');
    };
    return PlatformLoggerService;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $e5e908211ba4e8b1$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e5e908211ba4e8b1$var$registerCoreComponents(firebase, variant) {
    firebase.INTERNAL.registerComponent(new $9Cwol.Component('platform-logger', function(container) {
        return new $e5e908211ba4e8b1$var$PlatformLoggerService(container);
    }, "PRIVATE" /* PRIVATE */ ));
    // Register `app` package.
    firebase.registerVersion($e5e908211ba4e8b1$var$name$1, $e5e908211ba4e8b1$var$version, variant);
    // Register platform SDK identifier (no version).
    firebase.registerVersion('fire-js', '');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Firebase Lite detection test
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ($epfVL.isBrowser() && self.firebase !== undefined) {
    $e5e908211ba4e8b1$var$logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var $e5e908211ba4e8b1$var$sdkVersion = self.firebase.SDK_VERSION;
    if ($e5e908211ba4e8b1$var$sdkVersion && $e5e908211ba4e8b1$var$sdkVersion.indexOf('LITE') >= 0) $e5e908211ba4e8b1$var$logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
}
var $e5e908211ba4e8b1$var$initializeApp = $e5e908211ba4e8b1$var$firebase.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$e5e908211ba4e8b1$var$firebase.initializeApp = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if ($epfVL.isNode()) $e5e908211ba4e8b1$var$logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    return $e5e908211ba4e8b1$var$initializeApp.apply(undefined, args);
};
var $e5e908211ba4e8b1$var$firebase$1 = $e5e908211ba4e8b1$var$firebase;
$e5e908211ba4e8b1$var$registerCoreComponents($e5e908211ba4e8b1$var$firebase$1);
module.exports.default = $e5e908211ba4e8b1$var$firebase$1;
module.exports.firebase = $e5e908211ba4e8b1$var$firebase$1;

});
parcelRegister("jAuJs", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $e42937e381c76d21$export$18ce0697a983be9b);
$parcel$export(module.exports, "__values", () => $e42937e381c76d21$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $e42937e381c76d21$var$extendStatics = function(d, b) {
    $e42937e381c76d21$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e42937e381c76d21$var$extendStatics(d, b);
};
function $e42937e381c76d21$export$a8ba968b8961cb8a(d, b) {
    $e42937e381c76d21$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e42937e381c76d21$export$18ce0697a983be9b = function() {
    $e42937e381c76d21$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e42937e381c76d21$export$18ce0697a983be9b.apply(this, arguments);
};
function $e42937e381c76d21$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e42937e381c76d21$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e42937e381c76d21$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e42937e381c76d21$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e42937e381c76d21$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e42937e381c76d21$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e42937e381c76d21$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e42937e381c76d21$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e42937e381c76d21$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e42937e381c76d21$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e42937e381c76d21$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e42937e381c76d21$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e42937e381c76d21$export$10c90e4f7922046c(v) {
    return this instanceof $e42937e381c76d21$export$10c90e4f7922046c ? (this.v = v, this) : new $e42937e381c76d21$export$10c90e4f7922046c(v);
}
function $e42937e381c76d21$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e42937e381c76d21$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e42937e381c76d21$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e42937e381c76d21$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e42937e381c76d21$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e42937e381c76d21$export$19a8beecd37a4c45 === "function" ? $e42937e381c76d21$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e42937e381c76d21$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e42937e381c76d21$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e42937e381c76d21$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e42937e381c76d21$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e42937e381c76d21$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("epfVL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $hAQla = parcelRequire("hAQla");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $a7cfc1f6a4e1d3e3$var$CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $a7cfc1f6a4e1d3e3$var$assert = function(assertion, message) {
    if (!assertion) throw $a7cfc1f6a4e1d3e3$var$assertionError(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $a7cfc1f6a4e1d3e3$var$assertionError = function(message) {
    return new Error('Firebase Database (' + $a7cfc1f6a4e1d3e3$var$CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cfc1f6a4e1d3e3$var$stringToByteArray = function(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $a7cfc1f6a4e1d3e3$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $a7cfc1f6a4e1d3e3$var$base64 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($a7cfc1f6a4e1d3e3$var$stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $a7cfc1f6a4e1d3e3$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw Error();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */ var $a7cfc1f6a4e1d3e3$var$base64Encode = function(str) {
    var utf8Bytes = $a7cfc1f6a4e1d3e3$var$stringToByteArray(str);
    return $a7cfc1f6a4e1d3e3$var$base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $a7cfc1f6a4e1d3e3$var$base64Decode = function(str) {
    try {
        return $a7cfc1f6a4e1d3e3$var$base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $a7cfc1f6a4e1d3e3$var$deepCopy(value) {
    return $a7cfc1f6a4e1d3e3$var$deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */ function $a7cfc1f6a4e1d3e3$var$deepExtend(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        if (!source.hasOwnProperty(prop)) continue;
        target[prop] = $a7cfc1f6a4e1d3e3$var$deepExtend(target[prop], source[prop]);
    }
    return target;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cfc1f6a4e1d3e3$var$Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ Deferred.prototype.wrapCallback = function(callback) {
        var _this = this;
        return function(error, value) {
            if (error) _this.reject(error);
            else _this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function() {});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    };
    return Deferred;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $a7cfc1f6a4e1d3e3$var$getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $a7cfc1f6a4e1d3e3$var$isMobileCordova() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($a7cfc1f6a4e1d3e3$var$getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $a7cfc1f6a4e1d3e3$var$isNode() {
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $a7cfc1f6a4e1d3e3$var$isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function $a7cfc1f6a4e1d3e3$var$isBrowserExtension() {
    var runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $a7cfc1f6a4e1d3e3$var$isReactNative() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $a7cfc1f6a4e1d3e3$var$isElectron() {
    return $a7cfc1f6a4e1d3e3$var$getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $a7cfc1f6a4e1d3e3$var$isIE() {
    var ua = $a7cfc1f6a4e1d3e3$var$getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $a7cfc1f6a4e1d3e3$var$isUWP() {
    return $a7cfc1f6a4e1d3e3$var$getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $a7cfc1f6a4e1d3e3$var$isNodeSdk() {
    return $a7cfc1f6a4e1d3e3$var$CONSTANTS.NODE_CLIENT === true || $a7cfc1f6a4e1d3e3$var$CONSTANTS.NODE_ADMIN === true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7cfc1f6a4e1d3e3$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $a7cfc1f6a4e1d3e3$var$FirebaseError = /** @class */ function(_super) {
    $hAQla.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = $a7cfc1f6a4e1d3e3$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(_this, $a7cfc1f6a4e1d3e3$var$ErrorFactory.prototype.create);
        return _this;
    }
    return FirebaseError;
}(Error);
var $a7cfc1f6a4e1d3e3$var$ErrorFactory = /** @class */ function() {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function(code) {
        var data = [];
        for(var _i = 1; _i < arguments.length; _i++)data[_i - 1] = arguments[_i];
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? $a7cfc1f6a4e1d3e3$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new $a7cfc1f6a4e1d3e3$var$FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for(var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++){
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}();
function $a7cfc1f6a4e1d3e3$var$replaceTemplate(template, data) {
    return template.replace($a7cfc1f6a4e1d3e3$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? value.toString() : "<" + key + "?>";
    });
}
var $a7cfc1f6a4e1d3e3$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $a7cfc1f6a4e1d3e3$var$jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $a7cfc1f6a4e1d3e3$var$stringify(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $a7cfc1f6a4e1d3e3$var$decode = function(token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = $a7cfc1f6a4e1d3e3$var$jsonEval($a7cfc1f6a4e1d3e3$var$base64Decode(parts[0]) || '');
        claims = $a7cfc1f6a4e1d3e3$var$jsonEval($a7cfc1f6a4e1d3e3$var$base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $a7cfc1f6a4e1d3e3$var$isValidTimestamp = function(token) {
    var claims = $a7cfc1f6a4e1d3e3$var$decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $a7cfc1f6a4e1d3e3$var$issuedAtTime = function(token) {
    var claims = $a7cfc1f6a4e1d3e3$var$decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $a7cfc1f6a4e1d3e3$var$isValidFormat = function(token) {
    var decoded = $a7cfc1f6a4e1d3e3$var$decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $a7cfc1f6a4e1d3e3$var$isAdmin = function(token) {
    var claims = $a7cfc1f6a4e1d3e3$var$decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a7cfc1f6a4e1d3e3$var$contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $a7cfc1f6a4e1d3e3$var$safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $a7cfc1f6a4e1d3e3$var$isEmpty(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $a7cfc1f6a4e1d3e3$var$map(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $a7cfc1f6a4e1d3e3$var$querystring(querystringParams) {
    var params = [];
    var _loop_1 = function(key, value) {
        if (Array.isArray(value)) value.forEach(function(arrayVal) {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
        });
        else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    };
    for(var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $a7cfc1f6a4e1d3e3$var$querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function(token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $a7cfc1f6a4e1d3e3$var$Sha1 = /** @class */ function() {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    Sha1.prototype.reset = function() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ Sha1.prototype.compress_ = function(buf, offset) {
        if (!offset) offset = 0;
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(var i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(var i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(var i = 16; i < 80; i++){
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(var i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            var t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    };
    Sha1.prototype.update = function(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */ Sha1.prototype.digest = function() {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(var i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for(var i = 0; i < 5; i++)for(var j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    };
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $a7cfc1f6a4e1d3e3$var$createSubscribe(executor, onNoObservers) {
    var proxy = new $a7cfc1f6a4e1d3e3$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $a7cfc1f6a4e1d3e3$var$ObserverProxy = /** @class */ function() {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function(value) {
        this.forEachObserver(function(observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function(error) {
        this.forEachObserver(function(observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function() {
        this.forEachObserver(function(observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ ObserverProxy.prototype.subscribe = function(nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($a7cfc1f6a4e1d3e3$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $a7cfc1f6a4e1d3e3$var$noop;
        if (observer.error === undefined) observer.error = $a7cfc1f6a4e1d3e3$var$noop;
        if (observer.complete === undefined) observer.complete = $a7cfc1f6a4e1d3e3$var$noop;
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            try {
                if (_this.finalError) observer.error(_this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    };
    ObserverProxy.prototype.forEachObserver = function(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function(i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                fn(_this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    };
    ObserverProxy.prototype.close = function(err) {
        var _this = this;
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function() {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ function $a7cfc1f6a4e1d3e3$var$async(fn, onError) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        Promise.resolve(true).then(function() {
            fn.apply(void 0, args);
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $a7cfc1f6a4e1d3e3$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for(var _i = 0, methods_1 = methods; _i < methods_1.length; _i++){
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $a7cfc1f6a4e1d3e3$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $a7cfc1f6a4e1d3e3$var$validateArgCount = function(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        var error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */ function $a7cfc1f6a4e1d3e3$var$errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch(argumentNumber){
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $a7cfc1f6a4e1d3e3$var$validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($a7cfc1f6a4e1d3e3$var$errorPrefix(fnName, argumentNumber, optional) + 'must be a valid firebase namespace.');
}
function $a7cfc1f6a4e1d3e3$var$validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($a7cfc1f6a4e1d3e3$var$errorPrefix(fnName, argumentNumber, optional) + 'must be a valid function.');
}
function $a7cfc1f6a4e1d3e3$var$validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($a7cfc1f6a4e1d3e3$var$errorPrefix(fnName, argumentNumber, optional) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $a7cfc1f6a4e1d3e3$var$stringToByteArray$1 = function(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $a7cfc1f6a4e1d3e3$var$assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $a7cfc1f6a4e1d3e3$var$stringLength = function(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
module.exports.CONSTANTS = $a7cfc1f6a4e1d3e3$var$CONSTANTS;
module.exports.Deferred = $a7cfc1f6a4e1d3e3$var$Deferred;
module.exports.ErrorFactory = $a7cfc1f6a4e1d3e3$var$ErrorFactory;
module.exports.FirebaseError = $a7cfc1f6a4e1d3e3$var$FirebaseError;
module.exports.Sha1 = $a7cfc1f6a4e1d3e3$var$Sha1;
module.exports.assert = $a7cfc1f6a4e1d3e3$var$assert;
module.exports.assertionError = $a7cfc1f6a4e1d3e3$var$assertionError;
module.exports.async = $a7cfc1f6a4e1d3e3$var$async;
module.exports.base64 = $a7cfc1f6a4e1d3e3$var$base64;
module.exports.base64Decode = $a7cfc1f6a4e1d3e3$var$base64Decode;
module.exports.base64Encode = $a7cfc1f6a4e1d3e3$var$base64Encode;
module.exports.contains = $a7cfc1f6a4e1d3e3$var$contains;
module.exports.createSubscribe = $a7cfc1f6a4e1d3e3$var$createSubscribe;
module.exports.decode = $a7cfc1f6a4e1d3e3$var$decode;
module.exports.deepCopy = $a7cfc1f6a4e1d3e3$var$deepCopy;
module.exports.deepExtend = $a7cfc1f6a4e1d3e3$var$deepExtend;
module.exports.errorPrefix = $a7cfc1f6a4e1d3e3$var$errorPrefix;
module.exports.getUA = $a7cfc1f6a4e1d3e3$var$getUA;
module.exports.isAdmin = $a7cfc1f6a4e1d3e3$var$isAdmin;
module.exports.isBrowser = $a7cfc1f6a4e1d3e3$var$isBrowser;
module.exports.isBrowserExtension = $a7cfc1f6a4e1d3e3$var$isBrowserExtension;
module.exports.isElectron = $a7cfc1f6a4e1d3e3$var$isElectron;
module.exports.isEmpty = $a7cfc1f6a4e1d3e3$var$isEmpty;
module.exports.isIE = $a7cfc1f6a4e1d3e3$var$isIE;
module.exports.isMobileCordova = $a7cfc1f6a4e1d3e3$var$isMobileCordova;
module.exports.isNode = $a7cfc1f6a4e1d3e3$var$isNode;
module.exports.isNodeSdk = $a7cfc1f6a4e1d3e3$var$isNodeSdk;
module.exports.isReactNative = $a7cfc1f6a4e1d3e3$var$isReactNative;
module.exports.isUWP = $a7cfc1f6a4e1d3e3$var$isUWP;
module.exports.isValidFormat = $a7cfc1f6a4e1d3e3$var$isValidFormat;
module.exports.isValidTimestamp = $a7cfc1f6a4e1d3e3$var$isValidTimestamp;
module.exports.issuedAtTime = $a7cfc1f6a4e1d3e3$var$issuedAtTime;
module.exports.jsonEval = $a7cfc1f6a4e1d3e3$var$jsonEval;
module.exports.map = $a7cfc1f6a4e1d3e3$var$map;
module.exports.querystring = $a7cfc1f6a4e1d3e3$var$querystring;
module.exports.querystringDecode = $a7cfc1f6a4e1d3e3$var$querystringDecode;
module.exports.safeGet = $a7cfc1f6a4e1d3e3$var$safeGet;
module.exports.stringLength = $a7cfc1f6a4e1d3e3$var$stringLength;
module.exports.stringToByteArray = $a7cfc1f6a4e1d3e3$var$stringToByteArray$1;
module.exports.stringify = $a7cfc1f6a4e1d3e3$var$stringify;
module.exports.validateArgCount = $a7cfc1f6a4e1d3e3$var$validateArgCount;
module.exports.validateCallback = $a7cfc1f6a4e1d3e3$var$validateCallback;
module.exports.validateContextObject = $a7cfc1f6a4e1d3e3$var$validateContextObject;
module.exports.validateNamespace = $a7cfc1f6a4e1d3e3$var$validateNamespace;

});
parcelRegister("hAQla", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $ccee6630460fba6c$export$a8ba968b8961cb8a);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $ccee6630460fba6c$var$extendStatics = function(d, b) {
    $ccee6630460fba6c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ccee6630460fba6c$var$extendStatics(d, b);
};
function $ccee6630460fba6c$export$a8ba968b8961cb8a(d, b) {
    $ccee6630460fba6c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ccee6630460fba6c$export$18ce0697a983be9b = function() {
    $ccee6630460fba6c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ccee6630460fba6c$export$18ce0697a983be9b.apply(this, arguments);
};
function $ccee6630460fba6c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ccee6630460fba6c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ccee6630460fba6c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ccee6630460fba6c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ccee6630460fba6c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ccee6630460fba6c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ccee6630460fba6c$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ccee6630460fba6c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ccee6630460fba6c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ccee6630460fba6c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ccee6630460fba6c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ccee6630460fba6c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ccee6630460fba6c$export$10c90e4f7922046c(v) {
    return this instanceof $ccee6630460fba6c$export$10c90e4f7922046c ? (this.v = v, this) : new $ccee6630460fba6c$export$10c90e4f7922046c(v);
}
function $ccee6630460fba6c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ccee6630460fba6c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ccee6630460fba6c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ccee6630460fba6c$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ccee6630460fba6c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ccee6630460fba6c$export$19a8beecd37a4c45 === "function" ? $ccee6630460fba6c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ccee6630460fba6c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ccee6630460fba6c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ccee6630460fba6c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ccee6630460fba6c$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ccee6630460fba6c$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("9Cwol", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

var $eYzpl = parcelRequire("eYzpl");

var $epfVL = parcelRequire("epfVL");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $7010c9fc31fdc883$var$Component = /** @class */ function() {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ function Component(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */ ;
    }
    Component.prototype.setInstantiationMode = function(mode) {
        this.instantiationMode = mode;
        return this;
    };
    Component.prototype.setMultipleInstances = function(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    };
    Component.prototype.setServiceProps = function(props) {
        this.serviceProps = props;
        return this;
    };
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7010c9fc31fdc883$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $7010c9fc31fdc883$var$Provider = /** @class */ function() {
    function Provider(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ Provider.prototype.get = function(identifier) {
        if (identifier === void 0) identifier = $7010c9fc31fdc883$var$DEFAULT_ENTRY_NAME;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            var deferred = new $epfVL.Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            // If the service instance is available, resolve the promise with it immediately
            try {
                var instance = this.getOrInitializeService(normalizedIdentifier);
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    };
    Provider.prototype.getImmediate = function(options) {
        var _a = $eYzpl.__assign({
            identifier: $7010c9fc31fdc883$var$DEFAULT_ENTRY_NAME,
            optional: false
        }, options), identifier = _a.identifier, optional = _a.optional;
        // if multipleInstances is not supported, use the default name
        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        try {
            var instance = this.getOrInitializeService(normalizedIdentifier);
            if (!instance) {
                if (optional) return null;
                throw Error("Service " + this.name + " is not available");
            }
            return instance;
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
    };
    Provider.prototype.getComponent = function() {
        return this.component;
    };
    Provider.prototype.setComponent = function(component) {
        var e_1, _a;
        if (component.name !== this.name) throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
        if (this.component) throw Error("Component for " + this.name + " has already been provided");
        this.component = component;
        // if the service is eager, initialize the default instance
        if ($7010c9fc31fdc883$var$isComponentEager(component)) try {
            this.getOrInitializeService($7010c9fc31fdc883$var$DEFAULT_ENTRY_NAME);
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        try {
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            for(var _b = $eYzpl.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $eYzpl.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                try {
                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                    var instance = this.getOrInitializeService(normalizedIdentifier);
                    instanceDeferred.resolve(instance);
                } catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Provider.prototype.clearInstance = function(identifier) {
        if (identifier === void 0) identifier = $7010c9fc31fdc883$var$DEFAULT_ENTRY_NAME;
        this.instancesDeferred.delete(identifier);
        this.instances.delete(identifier);
    };
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    Provider.prototype.delete = function() {
        return $eYzpl.__awaiter(this, void 0, void 0, function() {
            var services;
            return $eYzpl.__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        services = Array.from(this.instances.values());
                        return [
                            4 /*yield*/ ,
                            Promise.all(services.filter(function(service) {
                                return 'INTERNAL' in service;
                            })// eslint-disable-next-line @typescript-eslint/no-explicit-any
                            .map(function(service) {
                                return service.INTERNAL.delete();
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Provider.prototype.isComponentSet = function() {
        return this.component != null;
    };
    Provider.prototype.getOrInitializeService = function(identifier) {
        var instance = this.instances.get(identifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, $7010c9fc31fdc883$var$normalizeIdentifierForFactory(identifier));
            this.instances.set(identifier, instance);
        }
        return instance || null;
    };
    Provider.prototype.normalizeInstanceIdentifier = function(identifier) {
        if (this.component) return this.component.multipleInstances ? identifier : $7010c9fc31fdc883$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    };
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $7010c9fc31fdc883$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $7010c9fc31fdc883$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $7010c9fc31fdc883$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $7010c9fc31fdc883$var$ComponentContainer = /** @class */ function() {
    function ComponentContainer(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ ComponentContainer.prototype.addComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error("Component " + component.name + " has already been registered with " + this.name);
        provider.setComponent(component);
    };
    ComponentContainer.prototype.addOrOverwriteComponent = function(component) {
        var provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    };
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ ComponentContainer.prototype.getProvider = function(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        var provider = new $7010c9fc31fdc883$var$Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    };
    ComponentContainer.prototype.getProviders = function() {
        return Array.from(this.providers.values());
    };
    return ComponentContainer;
}();
module.exports.Component = $7010c9fc31fdc883$var$Component;
module.exports.ComponentContainer = $7010c9fc31fdc883$var$ComponentContainer;
module.exports.Provider = $7010c9fc31fdc883$var$Provider;

});
parcelRegister("eYzpl", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $ae722285f2d1eeb7$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $ae722285f2d1eeb7$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $ae722285f2d1eeb7$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $ae722285f2d1eeb7$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $ae722285f2d1eeb7$export$8d051b38c9118094);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $ae722285f2d1eeb7$var$extendStatics = function(d, b) {
    $ae722285f2d1eeb7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ae722285f2d1eeb7$var$extendStatics(d, b);
};
function $ae722285f2d1eeb7$export$a8ba968b8961cb8a(d, b) {
    $ae722285f2d1eeb7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ae722285f2d1eeb7$export$18ce0697a983be9b = function() {
    $ae722285f2d1eeb7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ae722285f2d1eeb7$export$18ce0697a983be9b.apply(this, arguments);
};
function $ae722285f2d1eeb7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ae722285f2d1eeb7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ae722285f2d1eeb7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ae722285f2d1eeb7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ae722285f2d1eeb7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ae722285f2d1eeb7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ae722285f2d1eeb7$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ae722285f2d1eeb7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ae722285f2d1eeb7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ae722285f2d1eeb7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ae722285f2d1eeb7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ae722285f2d1eeb7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ae722285f2d1eeb7$export$10c90e4f7922046c(v) {
    return this instanceof $ae722285f2d1eeb7$export$10c90e4f7922046c ? (this.v = v, this) : new $ae722285f2d1eeb7$export$10c90e4f7922046c(v);
}
function $ae722285f2d1eeb7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ae722285f2d1eeb7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ae722285f2d1eeb7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ae722285f2d1eeb7$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ae722285f2d1eeb7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ae722285f2d1eeb7$export$19a8beecd37a4c45 === "function" ? $ae722285f2d1eeb7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ae722285f2d1eeb7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ae722285f2d1eeb7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ae722285f2d1eeb7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ae722285f2d1eeb7$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ae722285f2d1eeb7$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});


parcelRegister("ctGiR", function(module, exports) {

$parcel$export(module.exports, "LogLevel", () => $915901fbc44eef96$export$243e62d78d3b544d);
$parcel$export(module.exports, "Logger", () => $915901fbc44eef96$export$efa9a398d6368992);
$parcel$export(module.exports, "setLogLevel", () => $915901fbc44eef96$export$c622e99c0ce7b1c9);
$parcel$export(module.exports, "setUserLogHandler", () => $915901fbc44eef96$export$29577d29c84db5f6);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $915901fbc44eef96$var$__spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $915901fbc44eef96$var$_a;
/**
 * A container for all of the Logger instances
 */ var $915901fbc44eef96$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $915901fbc44eef96$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($915901fbc44eef96$export$243e62d78d3b544d || ($915901fbc44eef96$export$243e62d78d3b544d = {}));
var $915901fbc44eef96$var$levelStringToEnum = {
    'debug': $915901fbc44eef96$export$243e62d78d3b544d.DEBUG,
    'verbose': $915901fbc44eef96$export$243e62d78d3b544d.VERBOSE,
    'info': $915901fbc44eef96$export$243e62d78d3b544d.INFO,
    'warn': $915901fbc44eef96$export$243e62d78d3b544d.WARN,
    'error': $915901fbc44eef96$export$243e62d78d3b544d.ERROR,
    'silent': $915901fbc44eef96$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $915901fbc44eef96$var$defaultLogLevel = $915901fbc44eef96$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $915901fbc44eef96$var$ConsoleMethod = ($915901fbc44eef96$var$_a = {}, $915901fbc44eef96$var$_a[$915901fbc44eef96$export$243e62d78d3b544d.DEBUG] = 'log', $915901fbc44eef96$var$_a[$915901fbc44eef96$export$243e62d78d3b544d.VERBOSE] = 'log', $915901fbc44eef96$var$_a[$915901fbc44eef96$export$243e62d78d3b544d.INFO] = 'info', $915901fbc44eef96$var$_a[$915901fbc44eef96$export$243e62d78d3b544d.WARN] = 'warn', $915901fbc44eef96$var$_a[$915901fbc44eef96$export$243e62d78d3b544d.ERROR] = 'error', $915901fbc44eef96$var$_a);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $915901fbc44eef96$var$defaultLogHandler = function(instance, logType) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $915901fbc44eef96$var$ConsoleMethod[logType];
    if (method) console[method].apply(console, $915901fbc44eef96$var$__spreadArrays([
        "[" + now + "]  " + instance.name + ":"
    ], args));
    else throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
};
var $915901fbc44eef96$export$efa9a398d6368992 = /** @class */ function() {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $915901fbc44eef96$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $915901fbc44eef96$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $915901fbc44eef96$var$instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function() {
            return this._logLevel;
        },
        set: function(val) {
            if (!(val in $915901fbc44eef96$export$243e62d78d3b544d)) throw new TypeError('Invalid value assigned to `logLevel`');
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function() {
            return this._logHandler;
        },
        set: function(val) {
            if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "userLogHandler", {
        get: function() {
            return this._userLogHandler;
        },
        set: function(val) {
            this._userLogHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */ Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.DEBUG
        ], args));
        this._logHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.DEBUG
        ], args));
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.VERBOSE
        ], args));
        this._logHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.VERBOSE
        ], args));
    };
    Logger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.INFO
        ], args));
        this._logHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.INFO
        ], args));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.WARN
        ], args));
        this._logHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.WARN
        ], args));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this._userLogHandler && this._userLogHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.ERROR
        ], args));
        this._logHandler.apply(this, $915901fbc44eef96$var$__spreadArrays([
            this,
            $915901fbc44eef96$export$243e62d78d3b544d.ERROR
        ], args));
    };
    return Logger;
}();
function $915901fbc44eef96$export$c622e99c0ce7b1c9(level) {
    var newLevel = typeof level === 'string' ? $915901fbc44eef96$var$levelStringToEnum[level] : level;
    $915901fbc44eef96$var$instances.forEach(function(inst) {
        inst.logLevel = newLevel;
    });
}
function $915901fbc44eef96$export$29577d29c84db5f6(logCallback, options) {
    var _loop_1 = function(instance) {
        var customLogLevel = null;
        if (options && options.level) customLogLevel = $915901fbc44eef96$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = function(instance, level) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            var message = args.map(function(arg) {
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter(function(arg) {
                return arg;
            }).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $915901fbc44eef96$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    };
    for(var _i = 0, instances_1 = $915901fbc44eef96$var$instances; _i < instances_1.length; _i++){
        var instance = instances_1[_i];
        _loop_1(instance);
    }
}

});




parcelRegister("aYeKz", function(module, exports) {
parcelRequire("a4wqY");

});
parcelRegister("a4wqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $75536fd4bb2e2ab6$var$t;

var $8QG6t = parcelRequire("8QG6t");

var $75536fd4bb2e2ab6$var$n = ($75536fd4bb2e2ab6$var$t = (parcelRequire("jJO2d"))) && "object" == typeof $75536fd4bb2e2ab6$var$t && "default" in $75536fd4bb2e2ab6$var$t ? $75536fd4bb2e2ab6$var$t.default : $75536fd4bb2e2ab6$var$t;

var $ctGiR = parcelRequire("ctGiR");

var $epfVL = parcelRequire("epfVL");

var $9Cwol = parcelRequire("9Cwol");

var $gyel3 = parcelRequire("gyel3");
var $75536fd4bb2e2ab6$var$u = $75536fd4bb2e2ab6$var$n.SDK_VERSION, $75536fd4bb2e2ab6$var$a = /** @class */ function() {
    function t(t) {
        this.uid = t;
    }
    return t.prototype.t = function() {
        return null != this.uid;
    }, /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ t.prototype.s = function() {
        return this.t() ? "uid:" + this.uid : "anonymous-user";
    }, t.prototype.isEqual = function(t) {
        return t.uid === this.uid;
    }, t;
}();
/** A user with a null UID. */ $75536fd4bb2e2ab6$var$a.UNAUTHENTICATED = new $75536fd4bb2e2ab6$var$a(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$75536fd4bb2e2ab6$var$a.i = new $75536fd4bb2e2ab6$var$a("google-credentials-uid"), $75536fd4bb2e2ab6$var$a.h = new $75536fd4bb2e2ab6$var$a("first-party-uid");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$h = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
}, $75536fd4bb2e2ab6$var$c = /** @class */ function(t) {
    function n(e, n) {
        var r = this;
        return (r = t.call(this, n) || this).code = e, r.message = n, r.name = "FirebaseError", // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        r.toString = function() {
            return r.name + ": [code=" + r.code + "]: " + r.message;
        }, r;
    }
    return $8QG6t.__extends(n, t), n;
}(Error), $75536fd4bb2e2ab6$var$f = function(t, e) {
    this.user = e, this.type = "OAuth", this.o = {}, // Set the headers using Object Literal notation to avoid minification
    this.o.Authorization = "Bearer " + t;
}, $75536fd4bb2e2ab6$var$l = /** @class */ function() {
    function t() {
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.u = null;
    }
    return t.prototype.getToken = function() {
        return Promise.resolve(null);
    }, t.prototype._ = function() {}, t.prototype.l = function(t) {
        this.u = t, // Fire with initial user.
        t($75536fd4bb2e2ab6$var$a.UNAUTHENTICATED);
    }, t.prototype.T = function() {
        this.u = null;
    }, t;
}(), $75536fd4bb2e2ab6$var$p = /** @class */ function() {
    function t(t) {
        var e = this;
        /**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */ this.I = null, /** Tracks the current User. */ this.currentUser = $75536fd4bb2e2ab6$var$a.UNAUTHENTICATED, this.R = !1, /**
             * Counter used to detect if the token changed while a getToken request was
             * outstanding.
             */ this.A = 0, /** The listener registered with setChangeListener(). */ this.u = null, this.forceRefresh = !1, this.I = function() {
            e.A++, e.currentUser = e.m(), e.R = !0, e.u && e.u(e.currentUser);
        }, this.A = 0, this.auth = t.getImmediate({
            optional: !0
        }), this.auth ? this.auth.addAuthTokenListener(this.I) : // if auth is not available, invoke tokenListener once with null token
        (this.I(null), t.get().then(function(t) {
            e.auth = t, e.I && // tokenListener can be removed by removeChangeListener()
            e.auth.addAuthTokenListener(e.I);
        }, function() {}));
    }
    return t.prototype.getToken = function() {
        var t = this, e = this.A, n = this.forceRefresh;
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(n).then(function(n) {
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            if (t.A !== e) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.ABORTED, "getToken aborted due to token change.");
            return n ? ($75536fd4bb2e2ab6$var$me("string" == typeof n.accessToken), new $75536fd4bb2e2ab6$var$f(n.accessToken, t.currentUser)) : null;
        }) : Promise.resolve(null);
    }, t.prototype._ = function() {
        this.forceRefresh = !0;
    }, t.prototype.l = function(t) {
        this.u = t, // Fire the initial event
        this.R && t(this.currentUser);
    }, t.prototype.T = function() {
        this.auth && this.auth.removeAuthTokenListener(this.I), this.I = null, this.u = null;
    }, // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    t.prototype.m = function() {
        var t = this.auth && this.auth.getUid();
        return $75536fd4bb2e2ab6$var$me(null === t || "string" == typeof t), new $75536fd4bb2e2ab6$var$a(t);
    }, t;
}(), $75536fd4bb2e2ab6$var$d = /** @class */ function() {
    function t(t, e) {
        this.P = t, this.V = e, this.type = "FirstParty", this.user = $75536fd4bb2e2ab6$var$a.h;
    }
    return Object.defineProperty(t.prototype, "o", {
        get: function() {
            var t = {
                "X-Goog-AuthUser": this.V
            }, e = this.P.auth.g([]);
            return e && (t.Authorization = e), t;
        },
        enumerable: !0,
        configurable: !0
    }), t;
}(), $75536fd4bb2e2ab6$var$y = /** @class */ function() {
    function t(t, e) {
        this.P = t, this.V = e;
    }
    return t.prototype.getToken = function() {
        return Promise.resolve(new $75536fd4bb2e2ab6$var$d(this.P, this.V));
    }, t.prototype.l = function(t) {
        // Fire with initial uid.
        t($75536fd4bb2e2ab6$var$a.h);
    }, t.prototype.T = function() {}, t.prototype._ = function() {}, t;
}(), $75536fd4bb2e2ab6$var$v = /** @class */ function() {
    function t(t, e) {
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
    return t.now = function() {
        return t.fromMillis(Date.now());
    }, t.fromDate = function(e) {
        return t.fromMillis(e.getTime());
    }, t.fromMillis = function(e) {
        var n = Math.floor(e / 1e3);
        return new t(n, 1e6 * (e - 1e3 * n));
    }, t.prototype.toDate = function() {
        return new Date(this.toMillis());
    }, t.prototype.toMillis = function() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }, t.prototype.p = function(t) {
        return this.seconds === t.seconds ? $75536fd4bb2e2ab6$var$be(this.nanoseconds, t.nanoseconds) : $75536fd4bb2e2ab6$var$be(this.seconds, t.seconds);
    }, t.prototype.isEqual = function(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }, t.prototype.toString = function() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }, t.prototype.valueOf = function() {
        // This method returns a string of the form <seconds>.<nanoseconds> where <seconds> is
        // translated to have a non-negative value and both <seconds> and <nanoseconds> are left-padded
        // with zeroes to be a consistent length. Strings with this format then have a lexiographical
        // ordering that matches the expected ordering. The <seconds> translation is done to avoid
        // having a leading negative sign (i.e. a leading '-' character) in its string representation,
        // which would affect its lexiographical ordering.
        var t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }, t;
}(), $75536fd4bb2e2ab6$var$g = /** @class */ function() {
    function t(t) {
        this.timestamp = t;
    }
    return t.v = function(e) {
        return new t(e);
    }, t.min = function() {
        return new t(new $75536fd4bb2e2ab6$var$v(0, 0));
    }, t.prototype.S = function(t) {
        return this.timestamp.p(t.timestamp);
    }, t.prototype.isEqual = function(t) {
        return this.timestamp.isEqual(t.timestamp);
    }, /** Returns a number representation of the version for use in spec tests. */ t.prototype.D = function() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }, t.prototype.toString = function() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }, t.prototype.C = function() {
        return this.timestamp;
    }, t;
}(), $75536fd4bb2e2ab6$var$m = /** @class */ function() {
    function t(t, e, n) {
        void 0 === e ? e = 0 : e > t.length && $75536fd4bb2e2ab6$var$ge(), void 0 === n ? n = t.length - e : n > t.length - e && $75536fd4bb2e2ab6$var$ge(), this.segments = t, this.offset = e, this.F = n;
    }
    return Object.defineProperty(t.prototype, "length", {
        get: function() {
            return this.F;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        return 0 === t.N(this, e);
    }, t.prototype.child = function(e) {
        var n = this.segments.slice(this.offset, this.limit());
        return e instanceof t ? e.forEach(function(t) {
            n.push(t);
        }) : n.push(e), this.$(n);
    }, /** The index of one past the last segment of the path. */ t.prototype.limit = function() {
        return this.offset + this.length;
    }, t.prototype.k = function(t) {
        return t = void 0 === t ? 1 : t, this.$(this.segments, this.offset + t, this.length - t);
    }, t.prototype.L = function() {
        return this.$(this.segments, this.offset, this.length - 1);
    }, t.prototype.M = function() {
        return this.segments[this.offset];
    }, t.prototype.O = function() {
        return this.get(this.length - 1);
    }, t.prototype.get = function(t) {
        return this.segments[this.offset + t];
    }, t.prototype.B = function() {
        return 0 === this.length;
    }, t.prototype.q = function(t) {
        if (t.length < this.length) return !1;
        for(var e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }, t.prototype.U = function(t) {
        if (this.length + 1 !== t.length) return !1;
        for(var e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }, t.prototype.forEach = function(t) {
        for(var e = this.offset, n = this.limit(); e < n; e++)t(this.segments[e]);
    }, t.prototype.W = function() {
        return this.segments.slice(this.offset, this.limit());
    }, t.N = function(t, e) {
        for(var n = Math.min(t.length, e.length), r = 0; r < n; r++){
            var i = t.get(r), o = e.get(r);
            if (i < o) return -1;
            if (i > o) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }, t;
}(), $75536fd4bb2e2ab6$var$w = /** @class */ function(t) {
    function n() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.$ = function(t, e, r) {
        return new n(t, e, r);
    }, n.prototype.j = function() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.W().join("/");
    }, n.prototype.toString = function() {
        return this.j();
    }, /**
     * Creates a resource path from the given slash-delimited string.
     */ n.K = function(t) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        if (t.indexOf("//") >= 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid path (" + t + "). Paths must not contain // in them.");
        // We may still have an empty segment at the beginning or end if they had a
        // leading or trailing slash (which we allow).
        return new n(t.split("/").filter(function(t) {
            return t.length > 0;
        }));
    }, n;
}($75536fd4bb2e2ab6$var$m);
/**
 * An error class used for Firestore-generated errors. Ideally we should be
 * using FirebaseError, but integrating with it is overly arduous at the moment,
 * so we define our own compatible error class (with a `name` of 'FirebaseError'
 * and compatible `code` and `message` fields.)
 */ $75536fd4bb2e2ab6$var$w.G = new $75536fd4bb2e2ab6$var$w([]);
var $75536fd4bb2e2ab6$var$E = /^[_a-zA-Z][_a-zA-Z0-9]*$/, $75536fd4bb2e2ab6$var$b = /** @class */ function(t) {
    function n() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.$ = function(t, e, r) {
        return new n(t, e, r);
    }, /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ n.H = function(t) {
        return $75536fd4bb2e2ab6$var$E.test(t);
    }, n.prototype.j = function() {
        return this.W().map(function(t) {
            return t = t.replace("\\", "\\\\").replace("`", "\\`"), n.H(t) || (t = "`" + t + "`"), t;
        }).join(".");
    }, n.prototype.toString = function() {
        return this.j();
    }, /**
     * Returns true if this field references the key of a document.
     */ n.prototype.Y = function() {
        return 1 === this.length && "__name__" === this.get(0);
    }, /**
     * The field designating the key of a document.
     */ n.J = function() {
        return new n([
            "__name__"
        ]);
    }, /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ n.X = function(t) {
        for(var e = [], r = "", i = 0, o = function() {
            if (0 === r.length) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
            e.push(r), r = "";
        }, s = !1; i < t.length;){
            var u = t[i];
            if ("\\" === u) {
                if (i + 1 === t.length) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                var a = t[i + 1];
                if ("\\" !== a && "." !== a && "`" !== a) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                r += a, i += 2;
            } else "`" === u ? (s = !s, i++) : "." !== u || s ? (r += u, i++) : (o(), i++);
        }
        if (o(), s) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
        return new n(e);
    }, n;
}($75536fd4bb2e2ab6$var$m);
/** A dot-separated path for navigating sub-objects within a document. */ $75536fd4bb2e2ab6$var$b.G = new $75536fd4bb2e2ab6$var$b([]);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$_ = /** @class */ function() {
    function t(t) {
        this.path = t;
    }
    return t.Z = function(e) {
        return new t($75536fd4bb2e2ab6$var$w.K(e).k(5));
    }, /** Returns true if the document is in the specified collectionId. */ t.prototype.tt = function(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }, t.prototype.isEqual = function(t) {
        return null !== t && 0 === $75536fd4bb2e2ab6$var$w.N(this.path, t.path);
    }, t.prototype.toString = function() {
        return this.path.toString();
    }, t.N = function(t, e) {
        return $75536fd4bb2e2ab6$var$w.N(t.path, e.path);
    }, t.et = function(t) {
        return t.length % 2 == 0;
    }, /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments The segments of the path to the document
     * @return A new instance of DocumentKey
     */ t.st = function(e) {
        return new t(new $75536fd4bb2e2ab6$var$w(e.slice()));
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $75536fd4bb2e2ab6$var$T(t) {
    var e = 0;
    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e++;
    return e;
}
function $75536fd4bb2e2ab6$var$I(t, e) {
    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
}
function $75536fd4bb2e2ab6$var$N(t) {
    for(var e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 */ $75536fd4bb2e2ab6$var$_.EMPTY = new $75536fd4bb2e2ab6$var$_(new $75536fd4bb2e2ab6$var$w([]));
var $75536fd4bb2e2ab6$var$A = /** @class */ function() {
    function t(t) {
        this.it = t;
    }
    return t.fromBase64String = function(e) {
        return new t($75536fd4bb2e2ab6$var$ce.nt().atob(e));
    }, t.fromUint8Array = function(e) {
        return new t(/**
 * Helper function to convert an Uint8array to a binary string.
 */ function(t) {
            for(var e = "", n = 0; n < t.length; ++n)e += String.fromCharCode(t[n]);
            return e;
        }(e));
    }, t.prototype.toBase64 = function() {
        return $75536fd4bb2e2ab6$var$ce.nt().btoa(this.it);
    }, t.prototype.toUint8Array = function() {
        return function(t) {
            for(var e = new Uint8Array(t.length), n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
            return e;
        }(this.it);
    }, t.prototype.rt = function() {
        return 2 * this.it.length;
    }, t.prototype.S = function(t) {
        return $75536fd4bb2e2ab6$var$be(this.it, t.it);
    }, t.prototype.isEqual = function(t) {
        return this.it === t.it;
    }, t;
}();
function $75536fd4bb2e2ab6$var$k(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $75536fd4bb2e2ab6$var$D(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return -0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */ function $75536fd4bb2e2ab6$var$x(t) {
    return "number" == typeof t && Number.isInteger(t) && !$75536fd4bb2e2ab6$var$D(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $75536fd4bb2e2ab6$var$S(t) {
    var e, n;
    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the local time at which this timestamp was first set.
 */ function $75536fd4bb2e2ab6$var$R(t) {
    var e = $75536fd4bb2e2ab6$var$M(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $75536fd4bb2e2ab6$var$v(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A RegExp matching ISO 8601 UTC timestamps with optional fraction.
$75536fd4bb2e2ab6$var$A.ht = new $75536fd4bb2e2ab6$var$A("");
var $75536fd4bb2e2ab6$var$L = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/** Extracts the backend's type order for the provided value. */ function $75536fd4bb2e2ab6$var$O(t) {
    return "nullValue" in t ? 0 /* NullValue */  : "booleanValue" in t ? 1 /* BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* NumberValue */  : "timestampValue" in t ? 3 /* TimestampValue */  : "stringValue" in t ? 5 /* StringValue */  : "bytesValue" in t ? 6 /* BlobValue */  : "referenceValue" in t ? 7 /* RefValue */  : "geoPointValue" in t ? 8 /* GeoPointValue */  : "arrayValue" in t ? 9 /* ArrayValue */  : "mapValue" in t ? $75536fd4bb2e2ab6$var$S(t) ? 4 /* ServerTimestampValue */  : 10 /* ObjectValue */  : $75536fd4bb2e2ab6$var$ge();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $75536fd4bb2e2ab6$var$V(t, e) {
    var n = $75536fd4bb2e2ab6$var$O(t);
    if (n !== $75536fd4bb2e2ab6$var$O(e)) return !1;
    switch(n){
        case 0 /* NullValue */ :
            return !0;
        case 1 /* BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* ServerTimestampValue */ :
            return $75536fd4bb2e2ab6$var$R(t).isEqual($75536fd4bb2e2ab6$var$R(e));
        case 3 /* TimestampValue */ :
            return function(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                var n = $75536fd4bb2e2ab6$var$M(t.timestampValue), r = $75536fd4bb2e2ab6$var$M(e.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(t, e);
        case 5 /* StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* BlobValue */ :
            return function(t, e) {
                return $75536fd4bb2e2ab6$var$F(t.bytesValue).isEqual($75536fd4bb2e2ab6$var$F(e.bytesValue));
            }(t, e);
        case 7 /* RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                return $75536fd4bb2e2ab6$var$j(t.geoPointValue.latitude) === $75536fd4bb2e2ab6$var$j(e.geoPointValue.latitude) && $75536fd4bb2e2ab6$var$j(t.geoPointValue.longitude) === $75536fd4bb2e2ab6$var$j(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* NumberValue */ :
            return function(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $75536fd4bb2e2ab6$var$j(t.integerValue) === $75536fd4bb2e2ab6$var$j(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    var n = $75536fd4bb2e2ab6$var$j(t.doubleValue), r = $75536fd4bb2e2ab6$var$j(e.doubleValue);
                    return n === r ? $75536fd4bb2e2ab6$var$D(n) === $75536fd4bb2e2ab6$var$D(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(t, e);
        case 9 /* ArrayValue */ :
            return $75536fd4bb2e2ab6$var$_e(t.arrayValue.values || [], e.arrayValue.values || [], $75536fd4bb2e2ab6$var$V);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                var n = t.mapValue.fields || {}, r = e.mapValue.fields || {};
                if ($75536fd4bb2e2ab6$var$T(n) !== $75536fd4bb2e2ab6$var$T(r)) return !1;
                for(var i in n)if (n.hasOwnProperty(i) && (void 0 === r[i] || !$75536fd4bb2e2ab6$var$V(n[i], r[i]))) return !1;
                return !0;
            }(t, e);
        default:
            return $75536fd4bb2e2ab6$var$ge();
    }
}
function $75536fd4bb2e2ab6$var$P(t, e) {
    return void 0 !== (t.values || []).find(function(t) {
        return $75536fd4bb2e2ab6$var$V(t, e);
    });
}
function $75536fd4bb2e2ab6$var$U(t, e) {
    var n = $75536fd4bb2e2ab6$var$O(t), r = $75536fd4bb2e2ab6$var$O(e);
    if (n !== r) return $75536fd4bb2e2ab6$var$be(n, r);
    switch(n){
        case 0 /* NullValue */ :
            return 0;
        case 1 /* BooleanValue */ :
            return $75536fd4bb2e2ab6$var$be(t.booleanValue, e.booleanValue);
        case 2 /* NumberValue */ :
            return function(t, e) {
                var n = $75536fd4bb2e2ab6$var$j(t.integerValue || t.doubleValue), r = $75536fd4bb2e2ab6$var$j(e.integerValue || e.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TimestampValue */ :
            return $75536fd4bb2e2ab6$var$C(t.timestampValue, e.timestampValue);
        case 4 /* ServerTimestampValue */ :
            return $75536fd4bb2e2ab6$var$C($75536fd4bb2e2ab6$var$R(t), $75536fd4bb2e2ab6$var$R(e));
        case 5 /* StringValue */ :
            return $75536fd4bb2e2ab6$var$be(t.stringValue, e.stringValue);
        case 6 /* BlobValue */ :
            return function(t, e) {
                var n = $75536fd4bb2e2ab6$var$F(t), r = $75536fd4bb2e2ab6$var$F(e);
                return n.S(r);
            }(t.bytesValue, e.bytesValue);
        case 7 /* RefValue */ :
            return function(t, e) {
                for(var n = t.split("/"), r = e.split("/"), i = 0; i < n.length && i < r.length; i++){
                    var o = $75536fd4bb2e2ab6$var$be(n[i], r[i]);
                    if (0 !== o) return o;
                }
                return $75536fd4bb2e2ab6$var$be(n.length, r.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* GeoPointValue */ :
            return function(t, e) {
                var n = $75536fd4bb2e2ab6$var$be($75536fd4bb2e2ab6$var$j(t.latitude), $75536fd4bb2e2ab6$var$j(e.latitude));
                return 0 !== n ? n : $75536fd4bb2e2ab6$var$be($75536fd4bb2e2ab6$var$j(t.longitude), $75536fd4bb2e2ab6$var$j(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* ArrayValue */ :
            return function(t, e) {
                for(var n = t.values || [], r = e.values || [], i = 0; i < n.length && i < r.length; ++i){
                    var o = $75536fd4bb2e2ab6$var$U(n[i], r[i]);
                    if (o) return o;
                }
                return $75536fd4bb2e2ab6$var$be(n.length, r.length);
            }(t.arrayValue, e.arrayValue);
        case 10 /* ObjectValue */ :
            return function(t, e) {
                var n = t.fields || {}, r = Object.keys(n), i = e.fields || {}, o = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), o.sort();
                for(var s = 0; s < r.length && s < o.length; ++s){
                    var u = $75536fd4bb2e2ab6$var$be(r[s], o[s]);
                    if (0 !== u) return u;
                    var a = $75536fd4bb2e2ab6$var$U(n[r[s]], i[o[s]]);
                    if (0 !== a) return a;
                }
                return $75536fd4bb2e2ab6$var$be(r.length, o.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $75536fd4bb2e2ab6$var$ge();
    }
}
function $75536fd4bb2e2ab6$var$C(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $75536fd4bb2e2ab6$var$be(t, e);
    var n = $75536fd4bb2e2ab6$var$M(t), r = $75536fd4bb2e2ab6$var$M(e), i = $75536fd4bb2e2ab6$var$be(n.seconds, r.seconds);
    return 0 !== i ? i : $75536fd4bb2e2ab6$var$be(n.nanos, r.nanos);
}
function $75536fd4bb2e2ab6$var$q(t) {
    return function t(e) {
        var n, r;
        return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function(t) {
            var e = $75536fd4bb2e2ab6$var$M(t);
            return "time(" + e.seconds + "," + e.nanos + ")";
        }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? $75536fd4bb2e2ab6$var$F(e.bytesValue).toBase64() : "referenceValue" in e ? (r = e.referenceValue, $75536fd4bb2e2ab6$var$_.Z(r).toString()) : "geoPointValue" in e ? "geo(" + (n = e.geoPointValue).latitude + "," + n.longitude + ")" : "arrayValue" in e ? function(e) {
            for(var n = "[", r = !0, i = 0, o = e.values || []; i < o.length; i++){
                var s = o[i];
                r ? r = !1 : n += ",", n += t(s);
            }
            return n + "]";
        }(e.arrayValue) : "mapValue" in e ? function(e) {
            for(// Iteration order in JavaScript is not guaranteed. To ensure that we generate
            // matching canonical IDs for identical maps, we need to sort the keys.
            var n = "{", r = !0, i = 0, o = Object.keys(e.fields || {}).sort(); i < o.length; i++){
                var s = o[i];
                r ? r = !1 : n += ",", n += s + ":" + t(e.fields[s]);
            }
            return n + "}";
        }(e.mapValue) : $75536fd4bb2e2ab6$var$ge();
    }(t);
}
function $75536fd4bb2e2ab6$var$M(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($75536fd4bb2e2ab6$var$me(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var e = 0, n = $75536fd4bb2e2ab6$var$L.exec(t);
        if ($75536fd4bb2e2ab6$var$me(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var r = n[1];
            r = (r + "000000000").substr(0, 9), e = Number(r);
        }
        // Parse the date to get the seconds.
        var i = new Date(t);
        return {
            seconds: Math.floor(i.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $75536fd4bb2e2ab6$var$j(t.seconds),
        nanos: $75536fd4bb2e2ab6$var$j(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $75536fd4bb2e2ab6$var$j(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $75536fd4bb2e2ab6$var$F(t) {
    return "string" == typeof t ? $75536fd4bb2e2ab6$var$A.fromBase64String(t) : $75536fd4bb2e2ab6$var$A.fromUint8Array(t);
}
/** Returns a reference value for the provided database and key. */ function $75536fd4bb2e2ab6$var$B(t, e) {
    return {
        referenceValue: "projects/" + t.projectId + "/databases/" + t.database + "/documents/" + e.path.j()
    };
}
/** Returns true if `value` is an IntegerValue . */ function $75536fd4bb2e2ab6$var$z(t) {
    return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $75536fd4bb2e2ab6$var$G(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $75536fd4bb2e2ab6$var$W(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $75536fd4bb2e2ab6$var$Q(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $75536fd4bb2e2ab6$var$K(t) {
    return !!t && "mapValue" in t;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Transforms a value into a server-generated timestamp. */ var $75536fd4bb2e2ab6$var$Y = /** @class */ function() {
    function t() {}
    return t.prototype.ot = function(t, e) {
        return function(t, e) {
            var n = {
                fields: {
                    __type__: {
                        stringValue: "server_timestamp"
                    },
                    __local_write_time__: {
                        timestampValue: {
                            seconds: t.seconds,
                            nanos: t.nanoseconds
                        }
                    }
                }
            };
            return e && (n.fields.__previous_value__ = e), {
                mapValue: n
            };
        }(e, t);
    }, t.prototype.at = function(t, e) {
        return e;
    }, t.prototype.ut = function(t) {
        return null;
    // Server timestamps are idempotent and don't require a base value.
    }, t.prototype.isEqual = function(e) {
        return e instanceof t;
    }, t;
}();
$75536fd4bb2e2ab6$var$Y.instance = new $75536fd4bb2e2ab6$var$Y;
/** Transforms an array value via a union operation. */ var $75536fd4bb2e2ab6$var$$ = /** @class */ function() {
    function t(t) {
        this.elements = t;
    }
    return t.prototype.ot = function(t, e) {
        return this.apply(t);
    }, t.prototype.at = function(t, e) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(t);
    }, t.prototype.apply = function(t) {
        for(var e = $75536fd4bb2e2ab6$var$X(t), n = function(t) {
            e.some(function(e) {
                return $75536fd4bb2e2ab6$var$V(e, t);
            }) || e.push(t);
        }, r = 0, i = this.elements; r < i.length; r++)n(i[r]);
        return {
            arrayValue: {
                values: e
            }
        };
    }, t.prototype.ut = function(t) {
        return null;
    // Array transforms are idempotent and don't require a base value.
    }, t.prototype.isEqual = function(e) {
        return e instanceof t && $75536fd4bb2e2ab6$var$_e(this.elements, e.elements, $75536fd4bb2e2ab6$var$V);
    }, t;
}(), $75536fd4bb2e2ab6$var$J = /** @class */ function() {
    function t(t) {
        this.elements = t;
    }
    return t.prototype.ot = function(t, e) {
        return this.apply(t);
    }, t.prototype.at = function(t, e) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(t);
    }, t.prototype.apply = function(t) {
        for(var e = $75536fd4bb2e2ab6$var$X(t), n = function(t) {
            e = e.filter(function(e) {
                return !$75536fd4bb2e2ab6$var$V(e, t);
            });
        }, r = 0, i = this.elements; r < i.length; r++)n(i[r]);
        return {
            arrayValue: {
                values: e
            }
        };
    }, t.prototype.ut = function(t) {
        return null;
    // Array transforms are idempotent and don't require a base value.
    }, t.prototype.isEqual = function(e) {
        return e instanceof t && $75536fd4bb2e2ab6$var$_e(this.elements, e.elements, $75536fd4bb2e2ab6$var$V);
    }, t;
}(), $75536fd4bb2e2ab6$var$H = /** @class */ function() {
    function t(t, e) {
        this.serializer = t, this.ct = e;
    }
    return t.prototype.ot = function(t, e) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        var n = this.ut(t), r = this.asNumber(n) + this.asNumber(this.ct);
        return $75536fd4bb2e2ab6$var$z(n) && $75536fd4bb2e2ab6$var$z(this.ct) ? this.serializer._t(r) : this.serializer.lt(r);
    }, t.prototype.at = function(t, e) {
        return e;
    }, /**
     * Inspects the provided value, returning the provided value if it is already
     * a NumberValue, otherwise returning a coerced value of 0.
     */ t.prototype.ut = function(t) {
        var e;
        return $75536fd4bb2e2ab6$var$z(e = t) || function(t) {
            return !!t && "doubleValue" in t;
        }(e) ? t : {
            integerValue: 0
        };
    }, t.prototype.isEqual = function(e) {
        return e instanceof t && $75536fd4bb2e2ab6$var$V(this.ct, e.ct);
    }, t.prototype.asNumber = function(t) {
        return $75536fd4bb2e2ab6$var$j(t.integerValue || t.doubleValue);
    }, t;
}();
/** Transforms an array value via a remove operation. */ function $75536fd4bb2e2ab6$var$X(t) {
    return $75536fd4bb2e2ab6$var$G(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ var $75536fd4bb2e2ab6$var$Z = /** @class */ function() {
    function t(t) {
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($75536fd4bb2e2ab6$var$b.N);
    }
    return t.prototype.dt = function(t) {
        for(var e = 0, n = this.fields; e < n.length; e++){
            if (n[e].q(t)) return !0;
        }
        return !1;
    }, t.prototype.isEqual = function(t) {
        return $75536fd4bb2e2ab6$var$_e(this.fields, t.fields, function(t, e) {
            return t.isEqual(e);
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$tt = /** @class */ function() {
    function t(t, e) {
        this.field = t, this.transform = e;
    }
    return t.prototype.isEqual = function(t) {
        return this.field.isEqual(t.field) && this.transform.isEqual(t.transform);
    }, t;
}(), $75536fd4bb2e2ab6$var$et = function(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ t, /**
     * The resulting fields returned from the backend after a
     * TransformMutation has been committed. Contains one FieldValue for each
     * FieldTransform that was in the mutation.
     *
     * Will be null if the mutation was not a TransformMutation.
     */ e) {
    this.version = t, this.transformResults = e;
}, $75536fd4bb2e2ab6$var$nt = /** @class */ function() {
    function t(t, e) {
        this.updateTime = t, this.exists = e;
    }
    return t.ft = function() {
        return new t;
    }, /** Creates a new Precondition with an exists flag. */ t.exists = function(e) {
        return new t(void 0, e);
    }, /** Creates a new Precondition based on a version a document exists at. */ t.updateTime = function(e) {
        return new t(e);
    }, Object.defineProperty(t.prototype, "Tt", {
        /** Returns whether this Precondition is empty. */ get: function() {
            return void 0 === this.updateTime && void 0 === this.exists;
        },
        enumerable: !0,
        configurable: !0
    }), /**
     * Returns true if the preconditions is valid for the given document
     * (or null if no document is available).
     */ t.prototype.Et = function(t) {
        return void 0 !== this.updateTime ? t instanceof $75536fd4bb2e2ab6$var$yt && t.version.isEqual(this.updateTime) : void 0 === this.exists || this.exists === t instanceof $75536fd4bb2e2ab6$var$yt;
    }, t.prototype.isEqual = function(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }, t;
}(), $75536fd4bb2e2ab6$var$rt = /** @class */ function() {
    function t() {}
    return t.prototype.It = function(t) {}, /**
     * Returns the version from the given document for use as the result of a
     * mutation. Mutations are defined to return the version of the base document
     * only if it is an existing document. Deleted and unknown documents have a
     * post-mutation version of SnapshotVersion.min().
     */ t.wt = function(t) {
        return t instanceof $75536fd4bb2e2ab6$var$yt ? t.version : $75536fd4bb2e2ab6$var$g.min();
    }, t;
}(), $75536fd4bb2e2ab6$var$it = /** @class */ function(t) {
    function n(e, n, r) {
        var i = this;
        return (i = t.call(this) || this).key = e, i.value = n, i.Rt = r, i.type = 0 /* Set */ , i;
    }
    return $8QG6t.__extends(n, t), n.prototype.at = function(t, e) {
        this.It(t);
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        var n = e.version;
        return new $75536fd4bb2e2ab6$var$yt(this.key, n, this.value, {
            hasCommittedMutations: !0
        });
    }, n.prototype.ot = function(t, e, n) {
        if (this.It(t), !this.Rt.Et(t)) return t;
        var r = $75536fd4bb2e2ab6$var$rt.wt(t);
        return new $75536fd4bb2e2ab6$var$yt(this.key, r, this.value, {
            At: !0
        });
    }, n.prototype.Pt = function(t) {
        return null;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.key.isEqual(t.key) && this.value.isEqual(t.value) && this.Rt.isEqual(t.Rt);
    }, n;
}($75536fd4bb2e2ab6$var$rt), $75536fd4bb2e2ab6$var$ot = /** @class */ function(t) {
    function n(e, n, r, i) {
        var o = this;
        return (o = t.call(this) || this).key = e, o.data = n, o.Vt = r, o.Rt = i, o.type = 1 /* Patch */ , o;
    }
    return $8QG6t.__extends(n, t), n.prototype.at = function(t, e) {
        if (this.It(t), !this.Rt.Et(t)) // Since the mutation was not rejected, we know that the  precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and return an UnknownDocument with the
        // known updateTime.
        return new $75536fd4bb2e2ab6$var$gt(this.key, e.version);
        var n = this.gt(t);
        return new $75536fd4bb2e2ab6$var$yt(this.key, e.version, n, {
            hasCommittedMutations: !0
        });
    }, n.prototype.ot = function(t, e, n) {
        if (this.It(t), !this.Rt.Et(t)) return t;
        var r = $75536fd4bb2e2ab6$var$rt.wt(t), i = this.gt(t);
        return new $75536fd4bb2e2ab6$var$yt(this.key, r, i, {
            At: !0
        });
    }, n.prototype.Pt = function(t) {
        return null;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.key.isEqual(t.key) && this.Vt.isEqual(t.Vt) && this.Rt.isEqual(t.Rt);
    }, /**
     * Patches the data of document if available or creates a new document. Note
     * that this does not check whether or not the precondition of this patch
     * holds.
     */ n.prototype.gt = function(t) {
        var e;
        return e = t instanceof $75536fd4bb2e2ab6$var$yt ? t.data() : $75536fd4bb2e2ab6$var$ht.empty(), this.pt(e);
    }, n.prototype.pt = function(t) {
        var e = this, n = new $75536fd4bb2e2ab6$var$ct(t);
        return this.Vt.fields.forEach(function(t) {
            if (!t.B()) {
                var r = e.data.field(t);
                null !== r ? n.set(t, r) : n.delete(t);
            }
        }), n.yt();
    }, n;
}($75536fd4bb2e2ab6$var$rt), $75536fd4bb2e2ab6$var$st = /** @class */ function(t) {
    function n(e, n) {
        var r = this;
        return (r = t.call(this) || this).key = e, r.fieldTransforms = n, r.type = 2 /* Transform */ , // NOTE: We set a precondition of exists: true as a safety-check, since we
        // always combine TransformMutations with a SetMutation or PatchMutation which
        // (if successful) should end up with an existing document.
        r.Rt = $75536fd4bb2e2ab6$var$nt.exists(!0), r;
    }
    return $8QG6t.__extends(n, t), n.prototype.at = function(t, e) {
        if (this.It(t), $75536fd4bb2e2ab6$var$me(null != e.transformResults), !this.Rt.Et(t)) // Since the mutation was not rejected, we know that the  precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and return an UnknownDocument with the
        // known updateTime.
        return new $75536fd4bb2e2ab6$var$gt(this.key, e.version);
        var n = this.bt(t), r = this.vt(t, e.transformResults), i = e.version, o = this.St(n.data(), r);
        return new $75536fd4bb2e2ab6$var$yt(this.key, i, o, {
            hasCommittedMutations: !0
        });
    }, n.prototype.ot = function(t, e, n) {
        if (this.It(t), !this.Rt.Et(t)) return t;
        var r = this.bt(t), i = this.Dt(n, t, e), o = this.St(r.data(), i);
        return new $75536fd4bb2e2ab6$var$yt(this.key, r.version, o, {
            At: !0
        });
    }, n.prototype.Pt = function(t) {
        for(var e = null, n = 0, r = this.fieldTransforms; n < r.length; n++){
            var i = r[n], o = t instanceof $75536fd4bb2e2ab6$var$yt ? t.field(i.field) : void 0, s = i.transform.ut(o || null);
            null != s && (e = null == e ? (new $75536fd4bb2e2ab6$var$ct).set(i.field, s) : e.set(i.field, s));
        }
        return e ? e.yt() : null;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.key.isEqual(t.key) && $75536fd4bb2e2ab6$var$_e(this.fieldTransforms, t.fieldTransforms, function(t, e) {
            return t.isEqual(e);
        }) && this.Rt.isEqual(t.Rt);
    }, /**
     * Asserts that the given MaybeDocument is actually a Document and verifies
     * that it matches the key for this mutation. Since we only support
     * transformations with precondition exists this method is guaranteed to be
     * safe.
     */ n.prototype.bt = function(t) {
        return t;
    }, /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use after a
     * TransformMutation has been acknowledged by the server.
     *
     * @param baseDoc The document prior to applying this mutation batch.
     * @param serverTransformResults The transform results received by the server.
     * @return The transform results list.
     */ n.prototype.vt = function(t, e) {
        var n = [];
        $75536fd4bb2e2ab6$var$me(this.fieldTransforms.length === e.length);
        for(var r = 0; r < e.length; r++){
            var i = this.fieldTransforms[r], o = i.transform, s = null;
            t instanceof $75536fd4bb2e2ab6$var$yt && (s = t.field(i.field)), n.push(o.at(s, e[r]));
        }
        return n;
    }, /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use when applying a
     * TransformMutation locally.
     *
     * @param localWriteTime The local time of the transform mutation (used to
     *     generate ServerTimestampValues).
     * @param maybeDoc The current state of the document after applying all
     *     previous mutations.
     * @param baseDoc The document prior to applying this mutation batch.
     * @return The transform results list.
     */ n.prototype.Dt = function(t, e, n) {
        for(var r = [], i = 0, o = this.fieldTransforms; i < o.length; i++){
            var s = o[i], u = s.transform, a = null;
            e instanceof $75536fd4bb2e2ab6$var$yt && (a = e.field(s.field)), null === a && n instanceof $75536fd4bb2e2ab6$var$yt && // If the current document does not contain a value for the mutated
            // field, use the value that existed before applying this mutation
            // batch. This solves an edge case where a PatchMutation clears the
            // values in a nested map before the TransformMutation is applied.
            (a = n.field(s.field)), r.push(u.ot(a, t));
        }
        return r;
    }, n.prototype.St = function(t, e) {
        for(var n = new $75536fd4bb2e2ab6$var$ct(t), r = 0; r < this.fieldTransforms.length; r++){
            var i = this.fieldTransforms[r].field;
            n.set(i, e[r]);
        }
        return n.yt();
    }, n;
}($75536fd4bb2e2ab6$var$rt), $75536fd4bb2e2ab6$var$ut = /** @class */ function(t) {
    function n(e, n) {
        var r = this;
        return (r = t.call(this) || this).key = e, r.Rt = n, r.type = 3 /* Delete */ , r;
    }
    return $8QG6t.__extends(n, t), n.prototype.at = function(t, e) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        return this.It(t), new $75536fd4bb2e2ab6$var$vt(this.key, e.version, {
            hasCommittedMutations: !0
        });
    }, n.prototype.ot = function(t, e, n) {
        return this.It(t), this.Rt.Et(t) ? new $75536fd4bb2e2ab6$var$vt(this.key, $75536fd4bb2e2ab6$var$g.min()) : t;
    }, n.prototype.Pt = function(t) {
        return null;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.key.isEqual(t.key) && this.Rt.isEqual(t.Rt);
    }, n;
}($75536fd4bb2e2ab6$var$rt), $75536fd4bb2e2ab6$var$at = /** @class */ function(t) {
    function n(e, n) {
        var r = this;
        return (r = t.call(this) || this).key = e, r.Rt = n, r.type = 4 /* Verify */ , r;
    }
    return $8QG6t.__extends(n, t), n.prototype.at = function(t, e) {
        $75536fd4bb2e2ab6$var$ge();
    }, n.prototype.ot = function(t, e, n) {
        $75536fd4bb2e2ab6$var$ge();
    }, n.prototype.Pt = function(t) {
        $75536fd4bb2e2ab6$var$ge();
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.key.isEqual(t.key) && this.Rt.isEqual(t.Rt);
    }, n;
}($75536fd4bb2e2ab6$var$rt), $75536fd4bb2e2ab6$var$ht = /** @class */ function() {
    function t(t) {
        this.proto = t;
    }
    return t.empty = function() {
        return new t({
            mapValue: {}
        });
    }, /**
     * Returns the value at the given path or null.
     *
     * @param path the path to search
     * @return The value at the path or if there it doesn't exist.
     */ t.prototype.field = function(t) {
        if (t.B()) return this.proto;
        for(var e = this.proto, n = 0; n < t.length - 1; ++n){
            if (!e.mapValue.fields) return null;
            if (!$75536fd4bb2e2ab6$var$K(e = e.mapValue.fields[t.get(n)])) return null;
        }
        return (e = (e.mapValue.fields || {})[t.O()]) || null;
    }, t.prototype.isEqual = function(t) {
        return $75536fd4bb2e2ab6$var$V(this.proto, t.proto);
    }, t;
}(), $75536fd4bb2e2ab6$var$ct = /** @class */ function() {
    /**
     * @param baseObject The object to mutate.
     */ function t(t) {
        void 0 === t && (t = $75536fd4bb2e2ab6$var$ht.empty()), this.Ct = t, /** A map that contains the accumulated changes in this builder. */ this.Ft = new Map;
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path The field path to set.
     * @param value The value to set.
     * @return The current Builder instance.
     */ return t.prototype.set = function(t, e) {
        return this.Nt(t, e), this;
    }, /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path The field path to remove.
     * @return The current Builder instance.
     */ t.prototype.delete = function(t) {
        return this.Nt(t, null), this;
    }, /**
     * Adds `value` to the overlay map at `path`. Creates nested map entries if
     * needed.
     */ t.prototype.Nt = function(t, e) {
        for(var n = this.Ft, r = 0; r < t.length - 1; ++r){
            var i = t.get(r), o = n.get(i);
            o instanceof Map ? // Re-use a previously created map
            n = o : o && 10 /* ObjectValue */  === $75536fd4bb2e2ab6$var$O(o) ? // Convert the existing Protobuf MapValue into a map
            (o = new Map(Object.entries(o.mapValue.fields || {})), n.set(i, o), n = o) : // Create an empty map to represent the current nesting level
            (o = new Map, n.set(i, o), n = o);
        }
        n.set(t.O(), e);
    }, /** Returns an ObjectValue with all mutations applied. */ t.prototype.yt = function() {
        var t = this.$t($75536fd4bb2e2ab6$var$b.G, this.Ft);
        return null != t ? new $75536fd4bb2e2ab6$var$ht(t) : this.Ct;
    }, /**
     * Applies any overlays from `currentOverlays` that exist at `currentPath`
     * and returns the merged data at `currentPath` (or null if there were no
     * changes).
     *
     * @param currentPath The path at the current nesting level. Can be set to
     * FieldValue.EMPTY_PATH to represent the root.
     * @param currentOverlays The overlays at the current nesting level in the
     * same format as `overlayMap`.
     * @return The merged data at `currentPath` or null if no modifications
     * were applied.
     */ t.prototype.$t = function(t, e) {
        var n = this, r = !1, i = this.Ct.field(t), o = $75536fd4bb2e2ab6$var$K(i) ? Object.assign({}, i.mapValue.fields) : {};
        return e.forEach(function(e, i) {
            if (e instanceof Map) {
                var s = n.$t(t.child(i), e);
                null != s && (o[i] = s, r = !0);
            } else null !== e ? (o[i] = e, r = !0) : o.hasOwnProperty(i) && (delete o[i], r = !0);
        }), r ? {
            mapValue: {
                fields: o
            }
        } : null;
    }, t;
}();
/** A field path and the TransformOperation to perform upon it. */ /**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $75536fd4bb2e2ab6$var$ft(t) {
    var e = [];
    return $75536fd4bb2e2ab6$var$I(t.fields || {}, function(t, n) {
        var r = new $75536fd4bb2e2ab6$var$b([
            t
        ]);
        if ($75536fd4bb2e2ab6$var$K(n)) {
            var i = $75536fd4bb2e2ab6$var$ft(n.mapValue).fields;
            if (0 === i.length) // Preserve the empty map by adding it to the FieldMask.
            e.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for(var o = 0, s = i; o < s.length; o++){
                var u = s[o];
                e.push(r.child(u));
            }
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        e.push(r);
    }), new $75536fd4bb2e2ab6$var$Z(e);
}
var $75536fd4bb2e2ab6$var$lt, $75536fd4bb2e2ab6$var$pt, $75536fd4bb2e2ab6$var$dt = function(t, e) {
    this.key = t, this.version = e;
}, $75536fd4bb2e2ab6$var$yt = /** @class */ function(t) {
    function n(e, n, r, i) {
        var o = this;
        return (o = t.call(this, e, n) || this).kt = r, o.At = !!i.At, o.hasCommittedMutations = !!i.hasCommittedMutations, o;
    }
    return $8QG6t.__extends(n, t), n.prototype.field = function(t) {
        return this.kt.field(t);
    }, n.prototype.data = function() {
        return this.kt;
    }, n.prototype.Lt = function() {
        return this.kt.proto;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.At === t.At && this.hasCommittedMutations === t.hasCommittedMutations && this.kt.isEqual(t.kt);
    }, n.prototype.toString = function() {
        return "Document(" + this.key + ", " + this.version + ", " + this.kt.toString() + ", {hasLocalMutations: " + this.At + "}), {hasCommittedMutations: " + this.hasCommittedMutations + "})";
    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
        get: function() {
            return this.At || this.hasCommittedMutations;
        },
        enumerable: !0,
        configurable: !0
    }), n;
}($75536fd4bb2e2ab6$var$dt), $75536fd4bb2e2ab6$var$vt = /** @class */ function(t) {
    function n(e, n, r) {
        var i = this;
        return (i = t.call(this, e, n) || this).hasCommittedMutations = !(!r || !r.hasCommittedMutations), i;
    }
    return $8QG6t.__extends(n, t), n.prototype.toString = function() {
        return "NoDocument(" + this.key + ", " + this.version + ")";
    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
        get: function() {
            return this.hasCommittedMutations;
        },
        enumerable: !0,
        configurable: !0
    }), n.prototype.isEqual = function(t) {
        return t instanceof n && t.hasCommittedMutations === this.hasCommittedMutations && t.version.isEqual(this.version) && t.key.isEqual(this.key);
    }, n;
}($75536fd4bb2e2ab6$var$dt), $75536fd4bb2e2ab6$var$gt = /** @class */ function(t) {
    function n() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.toString = function() {
        return "UnknownDocument(" + this.key + ", " + this.version + ")";
    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
        get: function() {
            return !0;
        },
        enumerable: !0,
        configurable: !0
    }), n.prototype.isEqual = function(t) {
        return t instanceof n && t.version.isEqual(this.version) && t.key.isEqual(this.key);
    }, n;
}($75536fd4bb2e2ab6$var$dt), $75536fd4bb2e2ab6$var$mt = /** @class */ function() {
    /**
     * Initializes a Target with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     *
     * NOTE: you should always construct `Target` from `Query.toTarget` instead of
     * using this constructor, because `Query` provides an implicit `orderBy`
     * property.
     */ function t(t, e, n, r, i, o, s) {
        void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = null), void 0 === s && (s = null), this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = o, this.endAt = s, this.Mt = null;
    }
    return t.prototype.canonicalId = function() {
        if (null === this.Mt) {
            var t = this.path.j();
            null !== this.collectionGroup && (t += "|cg:" + this.collectionGroup), t += "|f:", t += this.filters.map(function(t) {
                return t.canonicalId();
            }).join(","), t += "|ob:", t += this.orderBy.map(function(t) {
                return t.canonicalId();
            }).join(","), $75536fd4bb2e2ab6$var$k(this.limit) || (t += "|l:", t += this.limit), this.startAt && (t += "|lb:", t += this.startAt.canonicalId()), this.endAt && (t += "|ub:", t += this.endAt.canonicalId()), this.Mt = t;
        }
        return this.Mt;
    }, t.prototype.toString = function() {
        var t = this.path.j();
        return null !== this.collectionGroup && (t += " collectionGroup=" + this.collectionGroup), this.filters.length > 0 && (t += ", filters: [" + this.filters.join(", ") + "]"), $75536fd4bb2e2ab6$var$k(this.limit) || (t += ", limit: " + this.limit), this.orderBy.length > 0 && (t += ", orderBy: [" + this.orderBy.join(", ") + "]"), this.startAt && (t += ", startAt: " + this.startAt.canonicalId()), this.endAt && (t += ", endAt: " + this.endAt.canonicalId()), "Target(" + t + ")";
    }, t.prototype.isEqual = function(t) {
        if (this.limit !== t.limit) return !1;
        if (this.orderBy.length !== t.orderBy.length) return !1;
        for(var e = 0; e < this.orderBy.length; e++)if (!this.orderBy[e].isEqual(t.orderBy[e])) return !1;
        if (this.filters.length !== t.filters.length) return !1;
        for(var n = 0; n < this.filters.length; n++)if (!this.filters[n].isEqual(t.filters[n])) return !1;
        return this.collectionGroup === t.collectionGroup && !!this.path.isEqual(t.path) && !!(null !== this.startAt ? this.startAt.isEqual(t.startAt) : null === t.startAt) && (null !== this.endAt ? this.endAt.isEqual(t.endAt) : null === t.endAt);
    }, t.prototype.Ot = function() {
        return $75536fd4bb2e2ab6$var$_.et(this.path) && null === this.collectionGroup && 0 === this.filters.length;
    }, t;
}(), $75536fd4bb2e2ab6$var$wt = /** @class */ function() {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ function t(t, e, n, r, i, o /* First */ , s, u) {
        void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = "F"), void 0 === s && (s = null), void 0 === u && (u = null), this.path = t, this.collectionGroup = e, this.xt = n, this.filters = r, this.limit = i, this.Bt = o, this.startAt = s, this.endAt = u, this.qt = null, // The corresponding `Target` of this `Query` instance.
        this.Ut = null, this.startAt && this.Qt(this.startAt), this.endAt && this.Qt(this.endAt);
    }
    return t.Wt = function(e) {
        return new t(e);
    }, Object.defineProperty(t.prototype, "orderBy", {
        get: function() {
            if (null === this.qt) {
                this.qt = [];
                var t = this.jt(), e = this.Kt();
                if (null !== t && null === e) // In order to implicitly add key ordering, we must also add the
                // inequality filter field for it to be a valid query.
                // Note that the default inequality field and key ordering is ascending.
                t.Y() || this.qt.push(new $75536fd4bb2e2ab6$var$kt(t)), this.qt.push(new $75536fd4bb2e2ab6$var$kt($75536fd4bb2e2ab6$var$b.J(), "asc" /* ASCENDING */ ));
                else {
                    for(var n = !1, r = 0, i = this.xt; r < i.length; r++){
                        var o = i[r];
                        this.qt.push(o), o.field.Y() && (n = !0);
                    }
                    if (!n) {
                        // The order of the implicit key ordering always matches the last
                        // explicit order by
                        var s = this.xt.length > 0 ? this.xt[this.xt.length - 1].dir : "asc" /* ASCENDING */ ;
                        this.qt.push(new $75536fd4bb2e2ab6$var$kt($75536fd4bb2e2ab6$var$b.J(), s));
                    }
                }
            }
            return this.qt;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.Gt = function(e) {
        var n = this.filters.concat([
            e
        ]);
        return new t(this.path, this.collectionGroup, this.xt.slice(), n, this.limit, this.Bt, this.startAt, this.endAt);
    }, t.prototype.zt = function(e) {
        // TODO(dimond): validate that orderBy does not list the same key twice.
        var n = this.xt.concat([
            e
        ]);
        return new t(this.path, this.collectionGroup, n, this.filters.slice(), this.limit, this.Bt, this.startAt, this.endAt);
    }, t.prototype.Ht = function(e) {
        return new t(this.path, this.collectionGroup, this.xt.slice(), this.filters.slice(), e, "F" /* First */ , this.startAt, this.endAt);
    }, t.prototype.Yt = function(e) {
        return new t(this.path, this.collectionGroup, this.xt.slice(), this.filters.slice(), e, "L" /* Last */ , this.startAt, this.endAt);
    }, t.prototype.Jt = function(e) {
        return new t(this.path, this.collectionGroup, this.xt.slice(), this.filters.slice(), this.limit, this.Bt, e, this.endAt);
    }, t.prototype.Xt = function(e) {
        return new t(this.path, this.collectionGroup, this.xt.slice(), this.filters.slice(), this.limit, this.Bt, this.startAt, e);
    }, /**
     * Helper to convert a collection group query into a collection query at a
     * specific path. This is used when executing collection group queries, since
     * we have to split the query into a set of collection queries at multiple
     * paths.
     */ t.prototype.Zt = function(e) {
        return new t(e, /*collectionGroup=*/ null, this.xt.slice(), this.filters.slice(), this.limit, this.Bt, this.startAt, this.endAt);
    }, /**
     * Returns true if this query does not specify any query constraints that
     * could remove results.
     */ t.prototype.te = function() {
        return 0 === this.filters.length && null === this.limit && null == this.startAt && null == this.endAt && (0 === this.xt.length || 1 === this.xt.length && this.xt[0].field.Y());
    }, // TODO(b/29183165): This is used to get a unique string from a query to, for
    // example, use as a dictionary key, but the implementation is subject to
    // collisions. Make it collision-free.
    t.prototype.canonicalId = function() {
        return this.ee().canonicalId() + "|lt:" + this.Bt;
    }, t.prototype.toString = function() {
        return "Query(target=" + this.ee().toString() + "; limitType=" + this.Bt + ")";
    }, t.prototype.isEqual = function(t) {
        return this.ee().isEqual(t.ee()) && this.Bt === t.Bt;
    }, t.prototype.se = function(t, e) {
        for(var n = !1, r = 0, i = this.orderBy; r < i.length; r++){
            var o = i[r], s = o.compare(t, e);
            if (0 !== s) return s;
            n = n || o.field.Y();
        }
        return 0;
    }, t.prototype.matches = function(t) {
        return this.ie(t) && this.ne(t) && this.re(t) && this.he(t);
    }, t.prototype.oe = function() {
        return !$75536fd4bb2e2ab6$var$k(this.limit) && "F" /* First */  === this.Bt;
    }, t.prototype.ae = function() {
        return !$75536fd4bb2e2ab6$var$k(this.limit) && "L" /* Last */  === this.Bt;
    }, t.prototype.Kt = function() {
        return this.xt.length > 0 ? this.xt[0].field : null;
    }, t.prototype.jt = function() {
        for(var t = 0, e = this.filters; t < e.length; t++){
            var n = e[t];
            if (n instanceof $75536fd4bb2e2ab6$var$Et && n.ue()) return n.field;
        }
        return null;
    }, // Checks if any of the provided Operators are included in the query and
    // returns the first one that is, or null if none are.
    t.prototype.ce = function(t) {
        for(var e = 0, n = this.filters; e < n.length; e++){
            var r = n[e];
            if (r instanceof $75536fd4bb2e2ab6$var$Et && t.indexOf(r.op) >= 0) return r.op;
        }
        return null;
    }, t.prototype.Ot = function() {
        return this.ee().Ot();
    }, t.prototype._e = function() {
        return null !== this.collectionGroup;
    }, /**
     * Converts this `Query` instance to it's corresponding `Target`
     * representation.
     */ t.prototype.ee = function() {
        if (!this.Ut) {
            if ("F" /* First */  === this.Bt) this.Ut = new $75536fd4bb2e2ab6$var$mt(this.path, this.collectionGroup, this.orderBy, this.filters, this.limit, this.startAt, this.endAt);
            else {
                for(// Flip the orderBy directions since we want the last results
                var t = [], e = 0, n = this.orderBy; e < n.length; e++){
                    var r = n[e], i = "desc" /* DESCENDING */  === r.dir ? "asc" /* ASCENDING */  : "desc" /* DESCENDING */ ;
                    t.push(new $75536fd4bb2e2ab6$var$kt(r.field, i));
                }
                // We need to swap the cursors to match the now-flipped query ordering.
                var o = this.endAt ? new $75536fd4bb2e2ab6$var$At(this.endAt.position, !this.endAt.before) : null, s = this.startAt ? new $75536fd4bb2e2ab6$var$At(this.startAt.position, !this.startAt.before) : null;
                // Now return as a LimitType.First query.
                this.Ut = new $75536fd4bb2e2ab6$var$mt(this.path, this.collectionGroup, t, this.filters, this.limit, o, s);
            }
        }
        return this.Ut;
    }, t.prototype.ie = function(t) {
        var e = t.key.path;
        return null !== this.collectionGroup ? t.key.tt(this.collectionGroup) && this.path.q(e) : $75536fd4bb2e2ab6$var$_.et(this.path) ? this.path.isEqual(e) : this.path.U(e);
    }, /**
     * A document must have a value for every ordering clause in order to show up
     * in the results.
     */ t.prototype.ne = function(t) {
        for(var e = 0, n = this.xt; e < n.length; e++){
            var r = n[e];
            // order by key always matches
            if (!r.field.Y() && null === t.field(r.field)) return !1;
        }
        return !0;
    }, t.prototype.re = function(t) {
        for(var e = 0, n = this.filters; e < n.length; e++){
            if (!n[e].matches(t)) return !1;
        }
        return !0;
    }, /**
     * Makes sure a document is within the bounds, if provided.
     */ t.prototype.he = function(t) {
        return !(this.startAt && !this.startAt.le(this.orderBy, t) || this.endAt && this.endAt.le(this.orderBy, t));
    }, t.prototype.Qt = function(t) {}, t;
}(), $75536fd4bb2e2ab6$var$Et = /** @class */ function(t) {
    function n(e, n, r) {
        var i = this;
        return (i = t.call(this) || this).field = e, i.op = n, i.value = r, i;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ return $8QG6t.__extends(n, t), n.create = function(t, e, r) {
        if (t.Y()) return "in" /* IN */  === e ? new $75536fd4bb2e2ab6$var$_t(t, r) : new $75536fd4bb2e2ab6$var$bt(t, e, r);
        if ($75536fd4bb2e2ab6$var$W(r)) {
            if ("==" /* EQUAL */  !== e) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. Null supports only equality comparisons.");
            return new n(t, e, r);
        }
        if ($75536fd4bb2e2ab6$var$Q(r)) {
            if ("==" /* EQUAL */  !== e) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. NaN supports only equality comparisons.");
            return new n(t, e, r);
        }
        return "array-contains" /* ARRAY_CONTAINS */  === e ? new $75536fd4bb2e2ab6$var$Tt(t, r) : "in" /* IN */  === e ? new $75536fd4bb2e2ab6$var$It(t, r) : "array-contains-any" /* ARRAY_CONTAINS_ANY */  === e ? new $75536fd4bb2e2ab6$var$Nt(t, r) : new n(t, e, r);
    }, n.prototype.matches = function(t) {
        var e = t.field(this.field);
        // Only compare types with matching backend order (such as double and int).
        return null !== e && $75536fd4bb2e2ab6$var$O(this.value) === $75536fd4bb2e2ab6$var$O(e) && this.de($75536fd4bb2e2ab6$var$U(e, this.value));
    }, n.prototype.de = function(t) {
        switch(this.op){
            case "<" /* LESS_THAN */ :
                return t < 0;
            case "<=" /* LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* EQUAL */ :
                return 0 === t;
            case ">" /* GREATER_THAN */ :
                return t > 0;
            case ">=" /* GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $75536fd4bb2e2ab6$var$ge();
        }
    }, n.prototype.ue = function() {
        return [
            "<" /* LESS_THAN */ ,
            "<=" /* LESS_THAN_OR_EQUAL */ ,
            ">" /* GREATER_THAN */ ,
            ">=" /* GREATER_THAN_OR_EQUAL */ 
        ].indexOf(this.op) >= 0;
    }, n.prototype.canonicalId = function() {
        // TODO(b/29183165): Technically, this won't be unique if two values have
        // the same description, such as the int 3 and the string "3". So we should
        // add the types in here somehow, too.
        return this.field.j() + this.op.toString() + $75536fd4bb2e2ab6$var$q(this.value);
    }, n.prototype.isEqual = function(t) {
        return t instanceof n && this.op === t.op && this.field.isEqual(t.field) && $75536fd4bb2e2ab6$var$V(this.value, t.value);
    }, n.prototype.toString = function() {
        return this.field.j() + " " + this.op + " " + $75536fd4bb2e2ab6$var$q(this.value);
    }, n;
}(function() {}), $75536fd4bb2e2ab6$var$bt = /** @class */ function(t) {
    function n(e, n, r) {
        var i = this;
        return (i = t.call(this, e, n, r) || this).key = $75536fd4bb2e2ab6$var$_.Z(r.referenceValue), i;
    }
    return $8QG6t.__extends(n, t), n.prototype.matches = function(t) {
        var e = $75536fd4bb2e2ab6$var$_.N(t.key, this.key);
        return this.de(e);
    }, n;
}($75536fd4bb2e2ab6$var$Et), $75536fd4bb2e2ab6$var$_t = /** @class */ function(t) {
    function n(e, n) {
        var r = this;
        return (r = t.call(this, e, "in" /* IN */ , n) || this).keys = (n.arrayValue.values || []).map(function(t) {
            return $75536fd4bb2e2ab6$var$_.Z(t.referenceValue);
        }), r;
    }
    return $8QG6t.__extends(n, t), n.prototype.matches = function(t) {
        return this.keys.some(function(e) {
            return e.isEqual(t.key);
        });
    }, n;
}($75536fd4bb2e2ab6$var$Et), $75536fd4bb2e2ab6$var$Tt = /** @class */ function(t) {
    function n(e, n) {
        return t.call(this, e, "array-contains" /* ARRAY_CONTAINS */ , n) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.matches = function(t) {
        var e = t.field(this.field);
        return $75536fd4bb2e2ab6$var$G(e) && $75536fd4bb2e2ab6$var$P(e.arrayValue, this.value);
    }, n;
}($75536fd4bb2e2ab6$var$Et), $75536fd4bb2e2ab6$var$It = /** @class */ function(t) {
    function n(e, n) {
        return t.call(this, e, "in" /* IN */ , n) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.matches = function(t) {
        var e = t.field(this.field);
        return null !== e && $75536fd4bb2e2ab6$var$P(this.value.arrayValue, e);
    }, n;
}($75536fd4bb2e2ab6$var$Et), $75536fd4bb2e2ab6$var$Nt = /** @class */ function(t) {
    function n(e, n) {
        return t.call(this, e, "array-contains-any" /* ARRAY_CONTAINS_ANY */ , n) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.matches = function(t) {
        var e = this, n = t.field(this.field);
        return !(!$75536fd4bb2e2ab6$var$G(n) || !n.arrayValue.values) && n.arrayValue.values.some(function(t) {
            return $75536fd4bb2e2ab6$var$P(e.value.arrayValue, t);
        });
    }, n;
}($75536fd4bb2e2ab6$var$Et), $75536fd4bb2e2ab6$var$At = /** @class */ function() {
    function t(t, e) {
        this.position = t, this.before = e;
    }
    return t.prototype.canonicalId = function() {
        // TODO(b/29183165): Make this collision robust.
        return (this.before ? "b" : "a") + ":" + this.position.map(function(t) {
            return $75536fd4bb2e2ab6$var$q(t);
        }).join(",");
    }, /**
     * Returns true if a document sorts before a bound using the provided sort
     * order.
     */ t.prototype.le = function(t, e) {
        for(var n = 0, r = 0; r < this.position.length; r++){
            var i = t[r], o = this.position[r];
            if (n = i.field.Y() ? $75536fd4bb2e2ab6$var$_.N($75536fd4bb2e2ab6$var$_.Z(o.referenceValue), e.key) : $75536fd4bb2e2ab6$var$U(o, e.field(i.field)), "desc" /* DESCENDING */  === i.dir && (n *= -1), 0 !== n) break;
        }
        return this.before ? n <= 0 : n < 0;
    }, t.prototype.isEqual = function(t) {
        if (null === t) return !1;
        if (this.before !== t.before || this.position.length !== t.position.length) return !1;
        for(var e = 0; e < this.position.length; e++)if (!$75536fd4bb2e2ab6$var$V(this.position[e], t.position[e])) return !1;
        return !0;
    }, t;
}(), $75536fd4bb2e2ab6$var$kt = /** @class */ function() {
    function t(t, e) {
        this.field = t, void 0 === e && (e = "asc" /* ASCENDING */ ), this.dir = e, this.fe = t.Y();
    }
    return t.prototype.compare = function(t, e) {
        var n = this.fe ? $75536fd4bb2e2ab6$var$_.N(t.key, e.key) : function(t, e, n) {
            var r = e.field(t), i = n.field(t);
            return null !== r && null !== i ? $75536fd4bb2e2ab6$var$U(r, i) : $75536fd4bb2e2ab6$var$ge();
        }(this.field, t, e);
        switch(this.dir){
            case "asc" /* ASCENDING */ :
                return n;
            case "desc" /* DESCENDING */ :
                return -1 * n;
            default:
                return $75536fd4bb2e2ab6$var$ge();
        }
    }, t.prototype.canonicalId = function() {
        // TODO(b/29183165): Make this collision robust.
        return this.field.j() + this.dir.toString();
    }, t.prototype.toString = function() {
        return this.field.j() + " (" + this.dir + ")";
    }, t.prototype.isEqual = function(t) {
        return this.dir === t.dir && this.field.isEqual(t.field);
    }, t;
}(), $75536fd4bb2e2ab6$var$Dt = /** @class */ function() {
    function t(/** The target being listened to. */ t, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ e, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i, o, s) {
        void 0 === i && (i = $75536fd4bb2e2ab6$var$g.min()), void 0 === o && (o = $75536fd4bb2e2ab6$var$g.min()), void 0 === s && (s = $75536fd4bb2e2ab6$var$A.ht), this.target = t, this.targetId = e, this.Te = n, this.sequenceNumber = r, this.Ee = i, this.lastLimboFreeSnapshotVersion = o, this.resumeToken = s;
    }
    /** Creates a new target data instance with an updated sequence number. */ return t.prototype.Ie = function(e) {
        return new t(this.target, this.targetId, this.Te, e, this.Ee, this.lastLimboFreeSnapshotVersion, this.resumeToken);
    }, /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ t.prototype.we = function(e, n) {
        return new t(this.target, this.targetId, this.Te, this.sequenceNumber, n, this.lastLimboFreeSnapshotVersion, e);
    }, /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ t.prototype.Re = function(e) {
        return new t(this.target, this.targetId, this.Te, this.sequenceNumber, this.Ee, e, this.resumeToken);
    }, t;
}(), $75536fd4bb2e2ab6$var$xt = // TODO(b/33078163): just use simplest form of existence filter for now
function(t) {
    this.count = t;
};
/**
 * Represents a document in Firestore with a key, version, data and whether the
 * data has local mutations applied to it.
 */ /**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $75536fd4bb2e2ab6$var$St(t) {
    switch(t){
        case $75536fd4bb2e2ab6$var$h.OK:
            return $75536fd4bb2e2ab6$var$ge();
        case $75536fd4bb2e2ab6$var$h.CANCELLED:
        case $75536fd4bb2e2ab6$var$h.UNKNOWN:
        case $75536fd4bb2e2ab6$var$h.DEADLINE_EXCEEDED:
        case $75536fd4bb2e2ab6$var$h.RESOURCE_EXHAUSTED:
        case $75536fd4bb2e2ab6$var$h.INTERNAL:
        case $75536fd4bb2e2ab6$var$h.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $75536fd4bb2e2ab6$var$h.UNAUTHENTICATED:
            return !1;
        case $75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT:
        case $75536fd4bb2e2ab6$var$h.NOT_FOUND:
        case $75536fd4bb2e2ab6$var$h.ALREADY_EXISTS:
        case $75536fd4bb2e2ab6$var$h.PERMISSION_DENIED:
        case $75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $75536fd4bb2e2ab6$var$h.ABORTED:
        case $75536fd4bb2e2ab6$var$h.OUT_OF_RANGE:
        case $75536fd4bb2e2ab6$var$h.UNIMPLEMENTED:
        case $75536fd4bb2e2ab6$var$h.DATA_LOSS:
            return !0;
        default:
            return $75536fd4bb2e2ab6$var$ge();
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $75536fd4bb2e2ab6$var$Rt(t) {
    if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $75536fd4bb2e2ab6$var$ye("GRPC error has no .code"), $75536fd4bb2e2ab6$var$h.UNKNOWN;
    switch(t){
        case $75536fd4bb2e2ab6$var$lt.OK:
            return $75536fd4bb2e2ab6$var$h.OK;
        case $75536fd4bb2e2ab6$var$lt.CANCELLED:
            return $75536fd4bb2e2ab6$var$h.CANCELLED;
        case $75536fd4bb2e2ab6$var$lt.UNKNOWN:
            return $75536fd4bb2e2ab6$var$h.UNKNOWN;
        case $75536fd4bb2e2ab6$var$lt.DEADLINE_EXCEEDED:
            return $75536fd4bb2e2ab6$var$h.DEADLINE_EXCEEDED;
        case $75536fd4bb2e2ab6$var$lt.RESOURCE_EXHAUSTED:
            return $75536fd4bb2e2ab6$var$h.RESOURCE_EXHAUSTED;
        case $75536fd4bb2e2ab6$var$lt.INTERNAL:
            return $75536fd4bb2e2ab6$var$h.INTERNAL;
        case $75536fd4bb2e2ab6$var$lt.UNAVAILABLE:
            return $75536fd4bb2e2ab6$var$h.UNAVAILABLE;
        case $75536fd4bb2e2ab6$var$lt.UNAUTHENTICATED:
            return $75536fd4bb2e2ab6$var$h.UNAUTHENTICATED;
        case $75536fd4bb2e2ab6$var$lt.INVALID_ARGUMENT:
            return $75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT;
        case $75536fd4bb2e2ab6$var$lt.NOT_FOUND:
            return $75536fd4bb2e2ab6$var$h.NOT_FOUND;
        case $75536fd4bb2e2ab6$var$lt.ALREADY_EXISTS:
            return $75536fd4bb2e2ab6$var$h.ALREADY_EXISTS;
        case $75536fd4bb2e2ab6$var$lt.PERMISSION_DENIED:
            return $75536fd4bb2e2ab6$var$h.PERMISSION_DENIED;
        case $75536fd4bb2e2ab6$var$lt.FAILED_PRECONDITION:
            return $75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION;
        case $75536fd4bb2e2ab6$var$lt.ABORTED:
            return $75536fd4bb2e2ab6$var$h.ABORTED;
        case $75536fd4bb2e2ab6$var$lt.OUT_OF_RANGE:
            return $75536fd4bb2e2ab6$var$h.OUT_OF_RANGE;
        case $75536fd4bb2e2ab6$var$lt.UNIMPLEMENTED:
            return $75536fd4bb2e2ab6$var$h.UNIMPLEMENTED;
        case $75536fd4bb2e2ab6$var$lt.DATA_LOSS:
            return $75536fd4bb2e2ab6$var$h.DATA_LOSS;
        default:
            return $75536fd4bb2e2ab6$var$ge();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($75536fd4bb2e2ab6$var$pt = $75536fd4bb2e2ab6$var$lt || ($75536fd4bb2e2ab6$var$lt = {}))[$75536fd4bb2e2ab6$var$pt.OK = 0] = "OK", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.CANCELLED = 1] = "CANCELLED", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.UNKNOWN = 2] = "UNKNOWN", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.NOT_FOUND = 5] = "NOT_FOUND", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.ABORTED = 10] = "ABORTED", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.INTERNAL = 13] = "INTERNAL", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.UNAVAILABLE = 14] = "UNAVAILABLE", $75536fd4bb2e2ab6$var$pt[$75536fd4bb2e2ab6$var$pt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var $75536fd4bb2e2ab6$var$Lt = /** @class */ function() {
    function t(t, e) {
        this.N = t, this.root = e || $75536fd4bb2e2ab6$var$Vt.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    return t.prototype.Ae = function(e, n) {
        return new t(this.N, this.root.Ae(e, n, this.N).me(null, null, $75536fd4bb2e2ab6$var$Vt.Pe, null, null));
    }, // Returns a copy of the map, with the specified key removed.
    t.prototype.remove = function(e) {
        return new t(this.N, this.root.remove(e, this.N).me(null, null, $75536fd4bb2e2ab6$var$Vt.Pe, null, null));
    }, // Returns the value of the node with the given key, or null.
    t.prototype.get = function(t) {
        for(var e = this.root; !e.B();){
            var n = this.N(t, e.key);
            if (0 === n) return e.value;
            n < 0 ? e = e.left : n > 0 && (e = e.right);
        }
        return null;
    }, // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    t.prototype.indexOf = function(t) {
        for(// Number of nodes that were pruned when descending right
        var e = 0, n = this.root; !n.B();){
            var r = this.N(t, n.key);
            if (0 === r) return e + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (e += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }, t.prototype.B = function() {
        return this.root.B();
    }, Object.defineProperty(t.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function() {
            return this.root.size;
        },
        enumerable: !0,
        configurable: !0
    }), // Returns the minimum key in the map.
    t.prototype.Ve = function() {
        return this.root.Ve();
    }, // Returns the maximum key in the map.
    t.prototype.ge = function() {
        return this.root.ge();
    }, // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.pe = function(t) {
        return this.root.pe(t);
    }, t.prototype.forEach = function(t) {
        this.pe(function(e, n) {
            return t(e, n), !1;
        });
    }, t.prototype.toString = function() {
        var t = [];
        return this.pe(function(e, n) {
            return t.push(e + ":" + n), !1;
        }), "{" + t.join(", ") + "}";
    }, // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.ye = function(t) {
        return this.root.ye(t);
    }, // Returns an iterator over the SortedMap.
    t.prototype.be = function() {
        return new $75536fd4bb2e2ab6$var$Ot(this.root, null, this.N, !1);
    }, t.prototype.ve = function(t) {
        return new $75536fd4bb2e2ab6$var$Ot(this.root, t, this.N, !1);
    }, t.prototype.Se = function() {
        return new $75536fd4bb2e2ab6$var$Ot(this.root, null, this.N, !0);
    }, t.prototype.De = function(t) {
        return new $75536fd4bb2e2ab6$var$Ot(this.root, t, this.N, !0);
    }, t;
}(), $75536fd4bb2e2ab6$var$Ot = /** @class */ function() {
    function t(t, e, n, r) {
        this.Ce = r, this.Fe = [];
        for(var i = 1; !t.B();)if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
        r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.Ce ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.Fe.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.Fe.push(t), t = this.Ce ? t.right : t.left;
        }
    }
    return t.prototype.Ne = function() {
        var t = this.Fe.pop(), e = {
            key: t.key,
            value: t.value
        };
        if (this.Ce) for(t = t.left; !t.B();)this.Fe.push(t), t = t.right;
        else for(t = t.right; !t.B();)this.Fe.push(t), t = t.left;
        return e;
    }, t.prototype.$e = function() {
        return this.Fe.length > 0;
    }, t.prototype.ke = function() {
        if (0 === this.Fe.length) return null;
        var t = this.Fe[this.Fe.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }, t;
}(), $75536fd4bb2e2ab6$var$Vt = /** @class */ function() {
    function t(e, n, r, i, o) {
        this.key = e, this.value = n, this.color = null != r ? r : t.RED, this.left = null != i ? i : t.EMPTY, this.right = null != o ? o : t.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    return t.prototype.me = function(e, n, r, i, o) {
        return new t(null != e ? e : this.key, null != n ? n : this.value, null != r ? r : this.color, null != i ? i : this.left, null != o ? o : this.right);
    }, t.prototype.B = function() {
        return !1;
    }, // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.pe = function(t) {
        return this.left.pe(t) || t(this.key, this.value) || this.right.pe(t);
    }, // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    t.prototype.ye = function(t) {
        return this.right.ye(t) || t(this.key, this.value) || this.left.ye(t);
    }, // Returns the minimum node in the tree.
    t.prototype.min = function() {
        return this.left.B() ? this : this.left.min();
    }, // Returns the maximum key in the tree.
    t.prototype.Ve = function() {
        return this.min().key;
    }, // Returns the maximum key in the tree.
    t.prototype.ge = function() {
        return this.right.B() ? this.key : this.right.ge();
    }, // Returns new tree, with the key/value added.
    t.prototype.Ae = function(t, e, n) {
        var r = this, i = n(t, r.key);
        return (r = i < 0 ? r.me(null, null, null, r.left.Ae(t, e, n), null) : 0 === i ? r.me(null, e, null, null, null) : r.me(null, null, null, null, r.right.Ae(t, e, n))).Le();
    }, t.prototype.Me = function() {
        if (this.left.B()) return t.EMPTY;
        var e = this;
        return e.left.Oe() || e.left.left.Oe() || (e = e.xe()), (e = e.me(null, null, null, e.left.Me(), null)).Le();
    }, // Returns new tree, with the specified item removed.
    t.prototype.remove = function(e, n) {
        var r, i = this;
        if (n(e, i.key) < 0) i.left.B() || i.left.Oe() || i.left.left.Oe() || (i = i.xe()), i = i.me(null, null, null, i.left.remove(e, n), null);
        else {
            if (i.left.Oe() && (i = i.Be()), i.right.B() || i.right.Oe() || i.right.left.Oe() || (i = i.qe()), 0 === n(e, i.key)) {
                if (i.right.B()) return t.EMPTY;
                r = i.right.min(), i = i.me(r.key, r.value, null, null, i.right.Me());
            }
            i = i.me(null, null, null, null, i.right.remove(e, n));
        }
        return i.Le();
    }, t.prototype.Oe = function() {
        return this.color;
    }, // Returns new tree after performing any needed rotations.
    t.prototype.Le = function() {
        var t = this;
        return t.right.Oe() && !t.left.Oe() && (t = t.Ue()), t.left.Oe() && t.left.left.Oe() && (t = t.Be()), t.left.Oe() && t.right.Oe() && (t = t.Qe()), t;
    }, t.prototype.xe = function() {
        var t = this.Qe();
        return t.right.left.Oe() && (t = (t = (t = t.me(null, null, null, null, t.right.Be())).Ue()).Qe()), t;
    }, t.prototype.qe = function() {
        var t = this.Qe();
        return t.left.left.Oe() && (t = (t = t.Be()).Qe()), t;
    }, t.prototype.Ue = function() {
        var e = this.me(null, null, t.RED, null, this.right.left);
        return this.right.me(null, null, this.color, e, null);
    }, t.prototype.Be = function() {
        var e = this.me(null, null, t.RED, this.left.right, null);
        return this.left.me(null, null, this.color, null, e);
    }, t.prototype.Qe = function() {
        var t = this.left.me(null, null, !this.left.color, null, null), e = this.right.me(null, null, !this.right.color, null, null);
        return this.me(null, null, !this.color, t, e);
    }, // For testing.
    t.prototype.We = function() {
        var t = this.je();
        return Math.pow(2, t) <= this.size + 1;
    }, // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    t.prototype.je = function() {
        if (this.Oe() && this.left.Oe()) throw $75536fd4bb2e2ab6$var$ge();
        if (this.right.Oe()) throw $75536fd4bb2e2ab6$var$ge();
        var t = this.left.je();
        if (t !== this.right.je()) throw $75536fd4bb2e2ab6$var$ge();
        return t + (this.Oe() ? 0 : 1);
    }, t;
}();
// end SortedMap
// An iterator over an LLRBNode.
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$75536fd4bb2e2ab6$var$Vt.EMPTY = null, $75536fd4bb2e2ab6$var$Vt.RED = !0, $75536fd4bb2e2ab6$var$Vt.Pe = !1, // end LLRBEmptyNode
$75536fd4bb2e2ab6$var$Vt.EMPTY = new /** @class */ (function() {
    function t() {
        this.size = 0;
    }
    return Object.defineProperty(t.prototype, "key", {
        get: function() {
            throw $75536fd4bb2e2ab6$var$ge();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "value", {
        get: function() {
            throw $75536fd4bb2e2ab6$var$ge();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "color", {
        get: function() {
            throw $75536fd4bb2e2ab6$var$ge();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "left", {
        get: function() {
            throw $75536fd4bb2e2ab6$var$ge();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "right", {
        get: function() {
            throw $75536fd4bb2e2ab6$var$ge();
        },
        enumerable: !0,
        configurable: !0
    }), // Returns a copy of the current node.
    t.prototype.me = function(t, e, n, r, i) {
        return this;
    }, // Returns a copy of the tree, with the specified key/value added.
    t.prototype.Ae = function(t, e, n) {
        return new $75536fd4bb2e2ab6$var$Vt(t, e);
    }, // Returns a copy of the tree, with the specified key removed.
    t.prototype.remove = function(t, e) {
        return this;
    }, t.prototype.B = function() {
        return !0;
    }, t.prototype.pe = function(t) {
        return !1;
    }, t.prototype.ye = function(t) {
        return !1;
    }, t.prototype.Ve = function() {
        return null;
    }, t.prototype.ge = function() {
        return null;
    }, t.prototype.Oe = function() {
        return !1;
    }, // For testing.
    t.prototype.We = function() {
        return !0;
    }, t.prototype.je = function() {
        return 0;
    }, t;
}());
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ var $75536fd4bb2e2ab6$var$Pt = /** @class */ function() {
    function t(t) {
        this.N = t, this.data = new $75536fd4bb2e2ab6$var$Lt(this.N);
    }
    return t.prototype.has = function(t) {
        return null !== this.data.get(t);
    }, t.prototype.first = function() {
        return this.data.Ve();
    }, t.prototype.last = function() {
        return this.data.ge();
    }, Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.data.size;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.indexOf = function(t) {
        return this.data.indexOf(t);
    }, /** Iterates elements in order defined by "comparator" */ t.prototype.forEach = function(t) {
        this.data.pe(function(e, n) {
            return t(e), !1;
        });
    }, /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */ t.prototype.Ke = function(t, e) {
        for(var n = this.data.ve(t[0]); n.$e();){
            var r = n.Ne();
            if (this.N(r.key, t[1]) >= 0) return;
            e(r.key);
        }
    }, /**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */ t.prototype.Ge = function(t, e) {
        var n;
        for(n = void 0 !== e ? this.data.ve(e) : this.data.be(); n.$e();)if (!t(n.Ne().key)) return;
    }, /** Finds the least element greater than or equal to `elem`. */ t.prototype.ze = function(t) {
        var e = this.data.ve(t);
        return e.$e() ? e.Ne().key : null;
    }, t.prototype.be = function() {
        return new $75536fd4bb2e2ab6$var$Ut(this.data.be());
    }, t.prototype.ve = function(t) {
        return new $75536fd4bb2e2ab6$var$Ut(this.data.ve(t));
    }, /** Inserts or updates an element */ t.prototype.add = function(t) {
        return this.me(this.data.remove(t).Ae(t, !0));
    }, /** Deletes an element */ t.prototype.delete = function(t) {
        return this.has(t) ? this.me(this.data.remove(t)) : this;
    }, t.prototype.B = function() {
        return this.data.B();
    }, t.prototype.He = function(t) {
        var e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach(function(t) {
            e = e.add(t);
        }), e;
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) return !1;
        if (this.size !== e.size) return !1;
        for(var n = this.data.be(), r = e.data.be(); n.$e();){
            var i = n.Ne().key, o = r.Ne().key;
            if (0 !== this.N(i, o)) return !1;
        }
        return !0;
    }, t.prototype.W = function() {
        var t = [];
        return this.forEach(function(e) {
            t.push(e);
        }), t;
    }, t.prototype.toString = function() {
        var t = [];
        return this.forEach(function(e) {
            return t.push(e);
        }), "SortedSet(" + t.toString() + ")";
    }, t.prototype.me = function(e) {
        var n = new t(this.N);
        return n.data = e, n;
    }, t;
}(), $75536fd4bb2e2ab6$var$Ut = /** @class */ function() {
    function t(t) {
        this.Ye = t;
    }
    return t.prototype.Ne = function() {
        return this.Ye.Ne().key;
    }, t.prototype.$e = function() {
        return this.Ye.$e();
    }, t;
}(), $75536fd4bb2e2ab6$var$Ct = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
function $75536fd4bb2e2ab6$var$qt() {
    return $75536fd4bb2e2ab6$var$Ct;
}
function $75536fd4bb2e2ab6$var$Mt() {
    return $75536fd4bb2e2ab6$var$qt();
}
var $75536fd4bb2e2ab6$var$jt = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
function $75536fd4bb2e2ab6$var$Ft() {
    return $75536fd4bb2e2ab6$var$jt;
}
var $75536fd4bb2e2ab6$var$Bt = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
function $75536fd4bb2e2ab6$var$zt() {
    return $75536fd4bb2e2ab6$var$Bt;
}
var $75536fd4bb2e2ab6$var$Gt = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$_.N);
function $75536fd4bb2e2ab6$var$Wt() {
    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
    for(var n = $75536fd4bb2e2ab6$var$Gt, r = 0, i = t; r < i.length; r++){
        var o = i[r];
        n = n.add(o);
    }
    return n;
}
var $75536fd4bb2e2ab6$var$Qt = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be);
function $75536fd4bb2e2ab6$var$Kt() {
    return $75536fd4bb2e2ab6$var$Qt;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ var $75536fd4bb2e2ab6$var$Yt = /** @class */ function() {
    /** The default ordering is by key if the comparator is omitted */ function t(t) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.N = t ? function(e, n) {
            return t(e, n) || $75536fd4bb2e2ab6$var$_.N(e.key, n.key);
        } : function(t, e) {
            return $75536fd4bb2e2ab6$var$_.N(t.key, e.key);
        }, this.Je = $75536fd4bb2e2ab6$var$Ft(), this.Xe = new $75536fd4bb2e2ab6$var$Lt(this.N);
    }
    return t.Ze = function(e) {
        return new t(e.N);
    }, t.prototype.has = function(t) {
        return null != this.Je.get(t);
    }, t.prototype.get = function(t) {
        return this.Je.get(t);
    }, t.prototype.first = function() {
        return this.Xe.Ve();
    }, t.prototype.last = function() {
        return this.Xe.ge();
    }, t.prototype.B = function() {
        return this.Xe.B();
    }, /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ t.prototype.indexOf = function(t) {
        var e = this.Je.get(t);
        return e ? this.Xe.indexOf(e) : -1;
    }, Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.Xe.size;
        },
        enumerable: !0,
        configurable: !0
    }), /** Iterates documents in order defined by "comparator" */ t.prototype.forEach = function(t) {
        this.Xe.pe(function(e, n) {
            return t(e), !1;
        });
    }, /** Inserts or updates a document with the same key */ t.prototype.add = function(t) {
        // First remove the element if we have it.
        var e = this.delete(t.key);
        return e.me(e.Je.Ae(t.key, t), e.Xe.Ae(t, null));
    }, /** Deletes a document with a given key */ t.prototype.delete = function(t) {
        var e = this.get(t);
        return e ? this.me(this.Je.remove(t), this.Xe.remove(e)) : this;
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) return !1;
        if (this.size !== e.size) return !1;
        for(var n = this.Xe.be(), r = e.Xe.be(); n.$e();){
            var i = n.Ne().key, o = r.Ne().key;
            if (!i.isEqual(o)) return !1;
        }
        return !0;
    }, t.prototype.toString = function() {
        var t = [];
        return this.forEach(function(e) {
            t.push(e.toString());
        }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }, t.prototype.me = function(e, n) {
        var r = new t;
        return r.N = this.N, r.Je = e, r.Xe = n, r;
    }, t;
}(), $75536fd4bb2e2ab6$var$$t = /** @class */ function() {
    function t() {
        this.ts = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
    }
    return t.prototype.track = function(t) {
        var e = t.doc.key, n = this.ts.get(e);
        n ? // Merge the new change with the existing change.
        0 /* Added */  !== t.type && 3 /* Metadata */  === n.type ? this.ts = this.ts.Ae(e, t) : 3 /* Metadata */  === t.type && 1 /* Removed */  !== n.type ? this.ts = this.ts.Ae(e, {
            type: n.type,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 2 /* Modified */  === n.type ? this.ts = this.ts.Ae(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : 2 /* Modified */  === t.type && 0 /* Added */  === n.type ? this.ts = this.ts.Ae(e, {
            type: 0 /* Added */ ,
            doc: t.doc
        }) : 1 /* Removed */  === t.type && 0 /* Added */  === n.type ? this.ts = this.ts.remove(e) : 1 /* Removed */  === t.type && 2 /* Modified */  === n.type ? this.ts = this.ts.Ae(e, {
            type: 1 /* Removed */ ,
            doc: n.doc
        }) : 0 /* Added */  === t.type && 1 /* Removed */  === n.type ? this.ts = this.ts.Ae(e, {
            type: 2 /* Modified */ ,
            doc: t.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $75536fd4bb2e2ab6$var$ge() : this.ts = this.ts.Ae(e, t);
    }, t.prototype.es = function() {
        var t = [];
        return this.ts.pe(function(e, n) {
            t.push(n);
        }), t;
    }, t;
}(), $75536fd4bb2e2ab6$var$Jt = /** @class */ function() {
    function t(t, e, n, r, i, o, s, u) {
        this.query = t, this.docs = e, this.ss = n, this.docChanges = r, this.ns = i, this.fromCache = o, this.rs = s, this.hs = u;
    }
    return t.os = function(e, n, r, i) {
        var o = [];
        return n.forEach(function(t) {
            o.push({
                type: 0 /* Added */ ,
                doc: t
            });
        }), new t(e, n, $75536fd4bb2e2ab6$var$Yt.Ze(n), o, r, i, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1);
    }, Object.defineProperty(t.prototype, "hasPendingWrites", {
        get: function() {
            return !this.ns.B();
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.isEqual = function(t) {
        if (!(this.fromCache === t.fromCache && this.rs === t.rs && this.ns.isEqual(t.ns) && this.query.isEqual(t.query) && this.docs.isEqual(t.docs) && this.ss.isEqual(t.ss))) return !1;
        var e = this.docChanges, n = t.docChanges;
        if (e.length !== n.length) return !1;
        for(var r = 0; r < e.length; r++)if (e[r].type !== n[r].type || !e[r].doc.isEqual(n[r].doc)) return !1;
        return !0;
    }, t;
}(), $75536fd4bb2e2ab6$var$Ht = /** @class */ function() {
    function t(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ t, /**
     * A map from target to changes to the target. See TargetChange.
     */ e, /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i) {
        this.Ee = t, this.as = e, this.us = n, this.cs = r, this._s = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    return t.ls = function(e, n) {
        var r = new Map;
        return r.set(e, $75536fd4bb2e2ab6$var$Xt.ds(e, n)), new t($75536fd4bb2e2ab6$var$g.min(), r, $75536fd4bb2e2ab6$var$Kt(), $75536fd4bb2e2ab6$var$qt(), $75536fd4bb2e2ab6$var$Wt());
    }, t;
}(), $75536fd4bb2e2ab6$var$Xt = /** @class */ function() {
    function t(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ t, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ e, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i) {
        this.resumeToken = t, this.fs = e, this.Ts = n, this.Es = r, this.Is = i;
    }
    return t.ds = function(e, n) {
        return new t($75536fd4bb2e2ab6$var$A.ht, n, $75536fd4bb2e2ab6$var$Wt(), $75536fd4bb2e2ab6$var$Wt(), $75536fd4bb2e2ab6$var$Wt());
    }, t;
}(), $75536fd4bb2e2ab6$var$Zt = function(/** The new document applies to all of these targets. */ t, /** The new document is removed from all of these targets. */ e, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r) {
    this.ws = t, this.removedTargetIds = e, this.key = n, this.Rs = r;
}, $75536fd4bb2e2ab6$var$te = function(t, e) {
    this.targetId = t, this.As = e;
}, $75536fd4bb2e2ab6$var$ee = function(/** What kind of change occurred to the watch target. */ t, /** The target IDs that were added/removed/set. */ e, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n, r) {
    void 0 === n && (n = $75536fd4bb2e2ab6$var$A.ht), void 0 === r && (r = null), this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = r;
}, $75536fd4bb2e2ab6$var$ne = /** @class */ function() {
    function t() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ms = 0, /**
             * Keeps track of the document changes since the last raised snapshot.
             *
             * These changes are continuously updated as we receive document updates and
             * always reflect the current set of changes against the last issued snapshot.
             */ this.Ps = $75536fd4bb2e2ab6$var$oe(), /** See public getters for explanations of these fields. */ this.Vs = $75536fd4bb2e2ab6$var$A.ht, this.gs = !1, /**
             * Whether this target state should be included in the next snapshot. We
             * initialize to true so that newly-added targets are included in the next
             * RemoteEvent.
             */ this.ps = !0;
    }
    return Object.defineProperty(t.prototype, "fs", {
        /**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */ get: function() {
            return this.gs;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "resumeToken", {
        /** The last resume token sent to us for this target. */ get: function() {
            return this.Vs;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ys", {
        /** Whether this target has pending target adds or target removes. */ get: function() {
            return 0 !== this.ms;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "bs", {
        /** Whether we have modified any state that should trigger a snapshot. */ get: function() {
            return this.ps;
        },
        enumerable: !0,
        configurable: !0
    }), /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ t.prototype.vs = function(t) {
        t.rt() > 0 && (this.ps = !0, this.Vs = t);
    }, /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ t.prototype.Ss = function() {
        var t = $75536fd4bb2e2ab6$var$Wt(), e = $75536fd4bb2e2ab6$var$Wt(), n = $75536fd4bb2e2ab6$var$Wt();
        return this.Ps.forEach(function(r, i) {
            switch(i){
                case 0 /* Added */ :
                    t = t.add(r);
                    break;
                case 2 /* Modified */ :
                    e = e.add(r);
                    break;
                case 1 /* Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $75536fd4bb2e2ab6$var$ge();
            }
        }), new $75536fd4bb2e2ab6$var$Xt(this.Vs, this.gs, t, e, n);
    }, /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ t.prototype.Ds = function() {
        this.ps = !1, this.Ps = $75536fd4bb2e2ab6$var$oe();
    }, t.prototype.Cs = function(t, e) {
        this.ps = !0, this.Ps = this.Ps.Ae(t, e);
    }, t.prototype.Fs = function(t) {
        this.ps = !0, this.Ps = this.Ps.remove(t);
    }, t.prototype.Ns = function() {
        this.ms += 1;
    }, t.prototype.$s = function() {
        this.ms -= 1;
    }, t.prototype.ks = function() {
        this.ps = !0, this.gs = !0;
    }, t;
}(), $75536fd4bb2e2ab6$var$re = /** @class */ function() {
    function t(t) {
        this.Ls = t, /** The internal state of all tracked targets. */ this.Ms = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.Os = $75536fd4bb2e2ab6$var$qt(), /** A mapping of document keys to their set of target IDs. */ this.xs = $75536fd4bb2e2ab6$var$ie(), /**
             * A list of targets with existence filter mismatches. These targets are
             * known to be inconsistent and their listens needs to be re-established by
             * RemoteStore.
             */ this.Bs = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be);
    }
    return t.prototype.qs = function(t) {
        for(var e = 0, n = t.ws; e < n.length; e++){
            var r = n[e];
            t.Rs instanceof $75536fd4bb2e2ab6$var$yt ? this.Us(r, t.Rs) : t.Rs instanceof $75536fd4bb2e2ab6$var$vt && this.Qs(r, t.key, t.Rs);
        }
        for(var i = 0, o = t.removedTargetIds; i < o.length; i++){
            var s = o[i];
            this.Qs(s, t.key, t.Rs);
        }
    }, /** Processes and adds the WatchTargetChange to the current set of changes. */ t.prototype.Ws = function(t) {
        var e = this;
        this.js(t, function(n) {
            var r = e.Ks(n);
            switch(t.state){
                case 0 /* NoChange */ :
                    e.Gs(n) && r.vs(t.resumeToken);
                    break;
                case 1 /* Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    r.$s(), r.ys || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    r.Ds(), r.vs(t.resumeToken);
                    break;
                case 2 /* Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    r.$s(), r.ys || e.removeTarget(n);
                    break;
                case 3 /* Current */ :
                    e.Gs(n) && (r.ks(), r.vs(t.resumeToken));
                    break;
                case 4 /* Reset */ :
                    e.Gs(n) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (e.zs(n), r.vs(t.resumeToken));
                    break;
                default:
                    $75536fd4bb2e2ab6$var$ge();
            }
        });
    }, /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ t.prototype.js = function(t, e) {
        var n = this;
        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Ms.forEach(function(t, r) {
            n.Gs(r) && e(r);
        });
    }, /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ t.prototype.Hs = function(t) {
        var e = t.targetId, n = t.As.count, r = this.Ys(e);
        if (r) {
            var i = r.target;
            if (i.Ot()) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    var o = new $75536fd4bb2e2ab6$var$_(i.path);
                    this.Qs(e, o, new $75536fd4bb2e2ab6$var$vt(o, $75536fd4bb2e2ab6$var$g.min()));
                } else $75536fd4bb2e2ab6$var$me(1 === n);
            } else this.Js(e) !== n && // Existence filter mismatch: We reset the mapping and raise a new
            // snapshot with `isFromCache:true`.
            (this.zs(e), this.Bs = this.Bs.add(e));
        }
    }, /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ t.prototype.Xs = function(t) {
        var e = this, n = new Map;
        this.Ms.forEach(function(r, i) {
            var o = e.Ys(i);
            if (o) {
                if (r.fs && o.target.Ot()) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    var s = new $75536fd4bb2e2ab6$var$_(o.target.path);
                    null !== e.Os.get(s) || e.Zs(i, s) || e.Qs(i, s, new $75536fd4bb2e2ab6$var$vt(s, t));
                }
                r.bs && (n.set(i, r.Ss()), r.Ds());
            }
        });
        var r = $75536fd4bb2e2ab6$var$Wt();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.xs.forEach(function(t, n) {
            var i = !0;
            n.Ge(function(t) {
                var n = e.Ys(t);
                return !n || 2 /* LimboResolution */  === n.Te || (i = !1, !1);
            }), i && (r = r.add(t));
        });
        var i = new $75536fd4bb2e2ab6$var$Ht(t, n, this.Bs, this.Os, r);
        return this.Os = $75536fd4bb2e2ab6$var$qt(), this.xs = $75536fd4bb2e2ab6$var$ie(), this.Bs = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be), i;
    }, /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    t.prototype.Us = function(t, e) {
        if (this.Gs(t)) {
            var n = this.Zs(t, e.key) ? 2 /* Modified */  : 0 /* Added */ ;
            this.Ks(t).Cs(e.key, n), this.Os = this.Os.Ae(e.key, e), this.xs = this.xs.Ae(e.key, this.ti(e.key).add(t));
        }
    }, /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    t.prototype.Qs = function(t, e, n) {
        if (this.Gs(t)) {
            var r = this.Ks(t);
            this.Zs(t, e) ? r.Cs(e, 1 /* Removed */ ) : // The document may have entered and left the target before we raised a
            // snapshot, so we can just ignore the change.
            r.Fs(e), this.xs = this.xs.Ae(e, this.ti(e).delete(t)), n && (this.Os = this.Os.Ae(e, n));
        }
    }, t.prototype.removeTarget = function(t) {
        this.Ms.delete(t);
    }, /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ t.prototype.Js = function(t) {
        var e = this.Ks(t).Ss();
        return this.Ls.ei(t).size + e.Ts.size - e.Is.size;
    }, /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ t.prototype.Ns = function(t) {
        this.Ks(t).Ns();
    }, t.prototype.Ks = function(t) {
        var e = this.Ms.get(t);
        return e || (e = new $75536fd4bb2e2ab6$var$ne, this.Ms.set(t, e)), e;
    }, t.prototype.ti = function(t) {
        var e = this.xs.get(t);
        return e || (e = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be), this.xs = this.xs.Ae(t, e)), e;
    }, /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ t.prototype.Gs = function(t) {
        var e = null !== this.Ys(t);
        return e || $75536fd4bb2e2ab6$var$de("WatchChangeAggregator", "Detected inactive target", t), e;
    }, /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ t.prototype.Ys = function(t) {
        var e = this.Ms.get(t);
        return e && e.ys ? null : this.Ls.si(t);
    }, /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ t.prototype.zs = function(t) {
        var e = this;
        this.Ms.set(t, new $75536fd4bb2e2ab6$var$ne), this.Ls.ei(t).forEach(function(n) {
            e.Qs(t, n, /*updatedDocument=*/ null);
        });
    }, /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ t.prototype.Zs = function(t, e) {
        return this.Ls.ei(t).has(e);
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ function $75536fd4bb2e2ab6$var$ie() {
    return new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
}
function $75536fd4bb2e2ab6$var$oe() {
    return new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$se = {
    asc: "ASCENDING",
    desc: "DESCENDING"
}, $75536fd4bb2e2ab6$var$ue = {
    "<": "LESS_THAN",
    "<=": "LESS_THAN_OR_EQUAL",
    ">": "GREATER_THAN",
    ">=": "GREATER_THAN_OR_EQUAL",
    "==": "EQUAL",
    "array-contains": "ARRAY_CONTAINS",
    in: "IN",
    "array-contains-any": "ARRAY_CONTAINS_ANY"
}, $75536fd4bb2e2ab6$var$ae = /** @class */ function() {
    function t(t, e) {
        this.ii = t, this.options = e;
    }
    return t.prototype.ni = function(t) {
        var e = void 0 === t.code ? $75536fd4bb2e2ab6$var$h.UNKNOWN : $75536fd4bb2e2ab6$var$Rt(t.code);
        return new $75536fd4bb2e2ab6$var$c(e, t.message || "");
    }, /**
     * Returns a value for a number (or null) that's appropriate to put into
     * a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "number" because that's what
     * our generated proto interfaces say Int32Value must be. But GRPC actually
     * expects a { value: <number> } struct.
     */ t.prototype.ri = function(t) {
        return this.options.hi || $75536fd4bb2e2ab6$var$k(t) ? t : {
            value: t
        };
    }, /**
     * Returns a number (or null) from a google.protobuf.Int32Value proto.
     */ t.prototype.oi = function(t) {
        var e;
        return $75536fd4bb2e2ab6$var$k(e = "object" == typeof t ? t.value : t) ? null : e;
    }, /**
     * Returns an IntegerValue for `value`.
     */ t.prototype._t = function(t) {
        return {
            integerValue: "" + t
        };
    }, /**
     * Returns an DoubleValue for `value` that is encoded based the serializer's
     * `useProto3Json` setting.
     */ t.prototype.lt = function(t) {
        if (this.options.hi) {
            if (isNaN(t)) return {
                doubleValue: "NaN"
            };
            if (t === 1 / 0) return {
                doubleValue: "Infinity"
            };
            if (t === -1 / 0) return {
                doubleValue: "-Infinity"
            };
        }
        return {
            doubleValue: $75536fd4bb2e2ab6$var$D(t) ? "-0" : t
        };
    }, /**
     * Returns a value for a number that's appropriate to put into a proto.
     * The return value is an IntegerValue if it can safely represent the value,
     * otherwise a DoubleValue is returned.
     */ t.prototype.ai = function(t) {
        return $75536fd4bb2e2ab6$var$x(t) ? this._t(t) : this.lt(t);
    }, /**
     * Returns a value for a Date that's appropriate to put into a proto.
     */ t.prototype.C = function(t) {
        return this.options.hi ? new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "") + "." + ("000000000" + t.nanoseconds).slice(-9) + "Z" : {
            seconds: "" + t.seconds,
            nanos: t.nanoseconds
        };
    }, t.prototype.v = function(t) {
        var e = $75536fd4bb2e2ab6$var$M(t);
        return new $75536fd4bb2e2ab6$var$v(e.seconds, e.nanos);
    }, /**
     * Returns a value for bytes that's appropriate to put in a proto.
     *
     * Visible for testing.
     */ t.prototype.ui = function(t) {
        return this.options.hi ? t.toBase64() : t.toUint8Array();
    }, /**
     * Returns a ByteString based on the proto string value.
     */ t.prototype.ci = function(t) {
        return this.options.hi ? ($75536fd4bb2e2ab6$var$me(void 0 === t || "string" == typeof t), $75536fd4bb2e2ab6$var$A.fromBase64String(t || "")) : ($75536fd4bb2e2ab6$var$me(void 0 === t || t instanceof Uint8Array), $75536fd4bb2e2ab6$var$A.fromUint8Array(t || new Uint8Array));
    }, t.prototype.toVersion = function(t) {
        return this.C(t.C());
    }, t.prototype.fromVersion = function(t) {
        return $75536fd4bb2e2ab6$var$me(!!t), $75536fd4bb2e2ab6$var$g.v(this.v(t));
    }, t.prototype._i = function(t, e) {
        return this.li(e || this.ii).child("documents").child(t).j();
    }, t.prototype.di = function(t) {
        var e = $75536fd4bb2e2ab6$var$w.K(t);
        return $75536fd4bb2e2ab6$var$me($75536fd4bb2e2ab6$var$he(e)), e;
    }, t.prototype.fi = function(t) {
        return this._i(t.path);
    }, t.prototype.Z = function(t) {
        var e = this.di(t);
        return $75536fd4bb2e2ab6$var$me(e.get(1) === this.ii.projectId), $75536fd4bb2e2ab6$var$me(!e.get(3) && !this.ii.database || e.get(3) === this.ii.database), new $75536fd4bb2e2ab6$var$_(this.Ti(e));
    }, t.prototype.Ei = function(t) {
        return this._i(t);
    }, t.prototype.Ii = function(t) {
        var e = this.di(t);
        // In v1beta1 queries for collections at the root did not have a trailing
        // "/documents". In v1 all resource paths contain "/documents". Preserve the
        // ability to read the v1beta1 form for compatibility with queries persisted
        // in the local target cache.
        return 4 === e.length ? $75536fd4bb2e2ab6$var$w.G : this.Ti(e);
    }, Object.defineProperty(t.prototype, "wi", {
        get: function() {
            return new $75536fd4bb2e2ab6$var$w([
                "projects",
                this.ii.projectId,
                "databases",
                this.ii.database
            ]).j();
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.li = function(t) {
        return new $75536fd4bb2e2ab6$var$w([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    }, t.prototype.Ti = function(t) {
        return $75536fd4bb2e2ab6$var$me(t.length > 4 && "documents" === t.get(4)), t.k(5);
    }, /** Creates an api.Document from key and fields (but no create/update time) */ t.prototype.Ri = function(t, e) {
        return {
            name: this.fi(t),
            fields: e.proto.mapValue.fields
        };
    }, t.prototype.Ai = function(t) {
        return {
            name: this.fi(t.key),
            fields: t.Lt().mapValue.fields,
            updateTime: this.C(t.version.C())
        };
    }, t.prototype.mi = function(t, e) {
        var n = this.Z(t.name), r = this.fromVersion(t.updateTime), i = new $75536fd4bb2e2ab6$var$ht({
            mapValue: {
                fields: t.fields
            }
        });
        return new $75536fd4bb2e2ab6$var$yt(n, r, i, {
            hasCommittedMutations: !!e
        });
    }, t.prototype.Pi = function(t) {
        $75536fd4bb2e2ab6$var$me(!!t.found), t.found.name, t.found.updateTime;
        var e = this.Z(t.found.name), n = this.fromVersion(t.found.updateTime), r = new $75536fd4bb2e2ab6$var$ht({
            mapValue: {
                fields: t.found.fields
            }
        });
        return new $75536fd4bb2e2ab6$var$yt(e, n, r, {});
    }, t.prototype.Vi = function(t) {
        $75536fd4bb2e2ab6$var$me(!!t.missing), $75536fd4bb2e2ab6$var$me(!!t.readTime);
        var e = this.Z(t.missing), n = this.fromVersion(t.readTime);
        return new $75536fd4bb2e2ab6$var$vt(e, n);
    }, t.prototype.gi = function(t) {
        return "found" in t ? this.Pi(t) : "missing" in t ? this.Vi(t) : $75536fd4bb2e2ab6$var$ge();
    }, t.prototype.pi = function(t) {
        var e;
        if ("targetChange" in t) {
            t.targetChange;
            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
            // if unset
            var n = this.yi(t.targetChange.targetChangeType || "NO_CHANGE"), r = t.targetChange.targetIds || [], i = this.ci(t.targetChange.resumeToken), o = t.targetChange.cause, s = o && this.ni(o);
            e = new $75536fd4bb2e2ab6$var$ee(n, r, i, s || null);
        } else if ("documentChange" in t) {
            t.documentChange;
            var u = t.documentChange;
            u.document, u.document.name, u.document.updateTime;
            var a = this.Z(u.document.name), h = this.fromVersion(u.document.updateTime), c = new $75536fd4bb2e2ab6$var$ht({
                mapValue: {
                    fields: u.document.fields
                }
            }), f = new $75536fd4bb2e2ab6$var$yt(a, h, c, {}), l = u.targetIds || [], p = u.removedTargetIds || [];
            e = new $75536fd4bb2e2ab6$var$Zt(l, p, f.key, f);
        } else if ("documentDelete" in t) {
            t.documentDelete;
            var d = t.documentDelete;
            d.document;
            var y = this.Z(d.document), v = d.readTime ? this.fromVersion(d.readTime) : $75536fd4bb2e2ab6$var$g.min(), m = new $75536fd4bb2e2ab6$var$vt(y, v), w = d.removedTargetIds || [];
            e = new $75536fd4bb2e2ab6$var$Zt([], w, m.key, m);
        } else if ("documentRemove" in t) {
            t.documentRemove;
            var E = t.documentRemove;
            E.document;
            var b = this.Z(E.document), _ = E.removedTargetIds || [];
            e = new $75536fd4bb2e2ab6$var$Zt([], _, b, null);
        } else {
            if (!("filter" in t)) return $75536fd4bb2e2ab6$var$ge();
            t.filter;
            var T = t.filter;
            T.targetId;
            var I = T.count || 0, N = new $75536fd4bb2e2ab6$var$xt(I), A = T.targetId;
            e = new $75536fd4bb2e2ab6$var$te(A, N);
        }
        return e;
    }, t.prototype.yi = function(t) {
        return "NO_CHANGE" === t ? 0 /* NoChange */  : "ADD" === t ? 1 /* Added */  : "REMOVE" === t ? 2 /* Removed */  : "CURRENT" === t ? 3 /* Current */  : "RESET" === t ? 4 /* Reset */  : $75536fd4bb2e2ab6$var$ge();
    }, t.prototype.bi = function(t) {
        // We have only reached a consistent snapshot for the entire stream if there
        // is a read_time set and it applies to all targets (i.e. the list of
        // targets is empty). The backend is guaranteed to send such responses.
        if (!("targetChange" in t)) return $75536fd4bb2e2ab6$var$g.min();
        var e = t.targetChange;
        return e.targetIds && e.targetIds.length ? $75536fd4bb2e2ab6$var$g.min() : e.readTime ? this.fromVersion(e.readTime) : $75536fd4bb2e2ab6$var$g.min();
    }, t.prototype.vi = function(t) {
        var e, n = this;
        if (t instanceof $75536fd4bb2e2ab6$var$it) e = {
            update: this.Ri(t.key, t.value)
        };
        else if (t instanceof $75536fd4bb2e2ab6$var$ut) e = {
            delete: this.fi(t.key)
        };
        else if (t instanceof $75536fd4bb2e2ab6$var$ot) e = {
            update: this.Ri(t.key, t.data),
            updateMask: this.Si(t.Vt)
        };
        else if (t instanceof $75536fd4bb2e2ab6$var$st) e = {
            transform: {
                document: this.fi(t.key),
                fieldTransforms: t.fieldTransforms.map(function(t) {
                    return n.Di(t);
                })
            }
        };
        else {
            if (!(t instanceof $75536fd4bb2e2ab6$var$at)) return $75536fd4bb2e2ab6$var$ge();
            e = {
                verify: this.fi(t.key)
            };
        }
        return t.Rt.Tt || (e.currentDocument = this.Ci(t.Rt)), e;
    }, t.prototype.Fi = function(t) {
        var e = this, n = t.currentDocument ? this.Ni(t.currentDocument) : $75536fd4bb2e2ab6$var$nt.ft();
        if (t.update) {
            t.update.name;
            var r = this.Z(t.update.name), i = new $75536fd4bb2e2ab6$var$ht({
                mapValue: {
                    fields: t.update.fields
                }
            });
            if (t.updateMask) {
                var o = this.$i(t.updateMask);
                return new $75536fd4bb2e2ab6$var$ot(r, i, o, n);
            }
            return new $75536fd4bb2e2ab6$var$it(r, i, n);
        }
        if (t.delete) {
            var s = this.Z(t.delete);
            return new $75536fd4bb2e2ab6$var$ut(s, n);
        }
        if (t.transform) {
            var u = this.Z(t.transform.document), a = t.transform.fieldTransforms.map(function(t) {
                return e.ki(t);
            });
            return $75536fd4bb2e2ab6$var$me(!0 === n.exists), new $75536fd4bb2e2ab6$var$st(u, a);
        }
        if (t.verify) {
            var h = this.Z(t.verify);
            return new $75536fd4bb2e2ab6$var$at(h, n);
        }
        return $75536fd4bb2e2ab6$var$ge();
    }, t.prototype.Ci = function(t) {
        return void 0 !== t.updateTime ? {
            updateTime: this.toVersion(t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $75536fd4bb2e2ab6$var$ge();
    }, t.prototype.Ni = function(t) {
        return void 0 !== t.updateTime ? $75536fd4bb2e2ab6$var$nt.updateTime(this.fromVersion(t.updateTime)) : void 0 !== t.exists ? $75536fd4bb2e2ab6$var$nt.exists(t.exists) : $75536fd4bb2e2ab6$var$nt.ft();
    }, t.prototype.Li = function(t, e) {
        // NOTE: Deletes don't have an updateTime.
        var n = t.updateTime ? this.fromVersion(t.updateTime) : this.fromVersion(e);
        n.isEqual($75536fd4bb2e2ab6$var$g.min()) && // The Firestore Emulator currently returns an update time of 0 for
        // deletes of non-existing documents (rather than null). This breaks the
        // test "get deleted doc while offline with source=cache" as NoDocuments
        // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
        // TODO(#2149): Remove this when Emulator is fixed
        (n = this.fromVersion(e));
        var r = null;
        return t.transformResults && t.transformResults.length > 0 && (r = t.transformResults), new $75536fd4bb2e2ab6$var$et(n, r);
    }, t.prototype.Mi = function(t, e) {
        var n = this;
        return t && t.length > 0 ? ($75536fd4bb2e2ab6$var$me(void 0 !== e), t.map(function(t) {
            return n.Li(t, e);
        })) : [];
    }, t.prototype.Di = function(t) {
        var e = t.transform;
        if (e instanceof $75536fd4bb2e2ab6$var$Y) return {
            fieldPath: t.field.j(),
            setToServerValue: "REQUEST_TIME"
        };
        if (e instanceof $75536fd4bb2e2ab6$var$$) return {
            fieldPath: t.field.j(),
            appendMissingElements: {
                values: e.elements
            }
        };
        if (e instanceof $75536fd4bb2e2ab6$var$J) return {
            fieldPath: t.field.j(),
            removeAllFromArray: {
                values: e.elements
            }
        };
        if (e instanceof $75536fd4bb2e2ab6$var$H) return {
            fieldPath: t.field.j(),
            increment: e.ct
        };
        throw $75536fd4bb2e2ab6$var$ge();
    }, t.prototype.ki = function(t) {
        var e = null;
        if ("setToServerValue" in t) $75536fd4bb2e2ab6$var$me("REQUEST_TIME" === t.setToServerValue), e = $75536fd4bb2e2ab6$var$Y.instance;
        else if ("appendMissingElements" in t) {
            var n = t.appendMissingElements.values || [];
            e = new $75536fd4bb2e2ab6$var$$(n);
        } else if ("removeAllFromArray" in t) {
            var r = t.removeAllFromArray.values || [];
            e = new $75536fd4bb2e2ab6$var$J(r);
        } else "increment" in t ? e = new $75536fd4bb2e2ab6$var$H(this, t.increment) : $75536fd4bb2e2ab6$var$ge();
        var i = $75536fd4bb2e2ab6$var$b.X(t.fieldPath);
        return new $75536fd4bb2e2ab6$var$tt(i, e);
    }, t.prototype.Oi = function(t) {
        return {
            documents: [
                this.Ei(t.path)
            ]
        };
    }, t.prototype.xi = function(t) {
        $75536fd4bb2e2ab6$var$me(1 === t.documents.length);
        var e = t.documents[0];
        return $75536fd4bb2e2ab6$var$wt.Wt(this.Ii(e)).ee();
    }, t.prototype.Bi = function(t) {
        // Dissect the path into parent, collectionId, and optional key filter.
        var e = {
            structuredQuery: {}
        }, n = t.path;
        null !== t.collectionGroup ? (e.parent = this.Ei(n), e.structuredQuery.from = [
            {
                collectionId: t.collectionGroup,
                allDescendants: !0
            }
        ]) : (e.parent = this.Ei(n.L()), e.structuredQuery.from = [
            {
                collectionId: n.O()
            }
        ]);
        var r = this.qi(t.filters);
        r && (e.structuredQuery.where = r);
        var i = this.Ui(t.orderBy);
        i && (e.structuredQuery.orderBy = i);
        var o = this.ri(t.limit);
        return null !== o && (e.structuredQuery.limit = o), t.startAt && (e.structuredQuery.startAt = this.Qi(t.startAt)), t.endAt && (e.structuredQuery.endAt = this.Qi(t.endAt)), e;
    }, t.prototype.Wi = function(t) {
        var e = this.Ii(t.parent), n = t.structuredQuery, r = n.from ? n.from.length : 0, i = null;
        if (r > 0) {
            $75536fd4bb2e2ab6$var$me(1 === r);
            var o = n.from[0];
            o.allDescendants ? i = o.collectionId : e = e.child(o.collectionId);
        }
        var s = [];
        n.where && (s = this.ji(n.where));
        var u = [];
        n.orderBy && (u = this.Ki(n.orderBy));
        var a = null;
        n.limit && (a = this.oi(n.limit));
        var h = null;
        n.startAt && (h = this.Gi(n.startAt));
        var c = null;
        return n.endAt && (c = this.Gi(n.endAt)), new $75536fd4bb2e2ab6$var$wt(e, i, u, s, a, "F" /* First */ , h, c).ee();
    }, t.prototype.zi = function(t) {
        var e = this.Hi(t.Te);
        return null == e ? null : {
            "goog-listen-tags": e
        };
    }, t.prototype.Hi = function(t) {
        switch(t){
            case 0 /* Listen */ :
                return null;
            case 1 /* ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case 2 /* LimboResolution */ :
                return "limbo-document";
            default:
                return $75536fd4bb2e2ab6$var$ge();
        }
    }, t.prototype.ee = function(t) {
        var e, n = t.target;
        return (e = n.Ot() ? {
            documents: this.Oi(n)
        } : {
            query: this.Bi(n)
        }).targetId = t.targetId, t.resumeToken.rt() > 0 && (e.resumeToken = this.ui(t.resumeToken)), e;
    }, t.prototype.qi = function(t) {
        var e = this;
        if (0 !== t.length) {
            var n = t.map(function(t) {
                return t instanceof $75536fd4bb2e2ab6$var$Et ? e.Yi(t) : $75536fd4bb2e2ab6$var$ge();
            });
            return 1 === n.length ? n[0] : {
                compositeFilter: {
                    op: "AND",
                    filters: n
                }
            };
        }
    }, t.prototype.ji = function(t) {
        var e = this;
        return t ? void 0 !== t.unaryFilter ? [
            this.Ji(t)
        ] : void 0 !== t.fieldFilter ? [
            this.Xi(t)
        ] : void 0 !== t.compositeFilter ? t.compositeFilter.filters.map(function(t) {
            return e.ji(t);
        }).reduce(function(t, e) {
            return t.concat(e);
        }) : $75536fd4bb2e2ab6$var$ge() : [];
    }, t.prototype.Ui = function(t) {
        var e = this;
        if (0 !== t.length) return t.map(function(t) {
            return e.Zi(t);
        });
    }, t.prototype.Ki = function(t) {
        var e = this;
        return t.map(function(t) {
            return e.tn(t);
        });
    }, t.prototype.Qi = function(t) {
        return {
            before: t.before,
            values: t.position
        };
    }, t.prototype.Gi = function(t) {
        var e = !!t.before, n = t.values || [];
        return new $75536fd4bb2e2ab6$var$At(n, e);
    }, // visible for testing
    t.prototype.en = function(t) {
        return $75536fd4bb2e2ab6$var$se[t];
    }, // visible for testing
    t.prototype.sn = function(t) {
        switch(t){
            case "ASCENDING":
                return "asc" /* ASCENDING */ ;
            case "DESCENDING":
                return "desc" /* DESCENDING */ ;
            default:
                return;
        }
    }, // visible for testing
    t.prototype.nn = function(t) {
        return $75536fd4bb2e2ab6$var$ue[t];
    }, t.prototype.rn = function(t) {
        switch(t){
            case "EQUAL":
                return "==" /* EQUAL */ ;
            case "GREATER_THAN":
                return ">" /* GREATER_THAN */ ;
            case "GREATER_THAN_OR_EQUAL":
                return ">=" /* GREATER_THAN_OR_EQUAL */ ;
            case "LESS_THAN":
                return "<" /* LESS_THAN */ ;
            case "LESS_THAN_OR_EQUAL":
                return "<=" /* LESS_THAN_OR_EQUAL */ ;
            case "ARRAY_CONTAINS":
                return "array-contains" /* ARRAY_CONTAINS */ ;
            case "IN":
                return "in" /* IN */ ;
            case "ARRAY_CONTAINS_ANY":
                return "array-contains-any" /* ARRAY_CONTAINS_ANY */ ;
            case "OPERATOR_UNSPECIFIED":
            default:
                return $75536fd4bb2e2ab6$var$ge();
        }
    }, t.prototype.hn = function(t) {
        return {
            fieldPath: t.j()
        };
    }, t.prototype.on = function(t) {
        return $75536fd4bb2e2ab6$var$b.X(t.fieldPath);
    }, // visible for testing
    t.prototype.Zi = function(t) {
        return {
            field: this.hn(t.field),
            direction: this.en(t.dir)
        };
    }, t.prototype.tn = function(t) {
        return new $75536fd4bb2e2ab6$var$kt(this.on(t.field), this.sn(t.direction));
    }, t.prototype.Xi = function(t) {
        return $75536fd4bb2e2ab6$var$Et.create(this.on(t.fieldFilter.field), this.rn(t.fieldFilter.op), t.fieldFilter.value);
    }, // visible for testing
    t.prototype.Yi = function(t) {
        if ("==" /* EQUAL */  === t.op) {
            if ($75536fd4bb2e2ab6$var$Q(t.value)) return {
                unaryFilter: {
                    field: this.hn(t.field),
                    op: "IS_NAN"
                }
            };
            if ($75536fd4bb2e2ab6$var$W(t.value)) return {
                unaryFilter: {
                    field: this.hn(t.field),
                    op: "IS_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: this.hn(t.field),
                op: this.nn(t.op),
                value: t.value
            }
        };
    }, t.prototype.Ji = function(t) {
        switch(t.unaryFilter.op){
            case "IS_NAN":
                var e = this.on(t.unaryFilter.field);
                return $75536fd4bb2e2ab6$var$Et.create(e, "==" /* EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                var n = this.on(t.unaryFilter.field);
                return $75536fd4bb2e2ab6$var$Et.create(n, "==" /* EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
            default:
                return $75536fd4bb2e2ab6$var$ge();
        }
    }, t.prototype.Si = function(t) {
        var e = [];
        return t.fields.forEach(function(t) {
            return e.push(t.j());
        }), {
            fieldPaths: e
        };
    }, t.prototype.$i = function(t) {
        var e = t.fieldPaths || [];
        return new $75536fd4bb2e2ab6$var$Z(e.map(function(t) {
            return $75536fd4bb2e2ab6$var$b.X(t);
        }));
    }, t;
}();
/**
 * Generates JsonObject values for the Datastore API suitable for sending to
 * either GRPC stub methods or via the JSON/HTTP REST API.
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ function $75536fd4bb2e2ab6$var$he(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides singleton helpers where setup code can inject a platform at runtime.
 * setPlatform needs to be set before Firestore is used and must be set exactly
 * once.
 */ var $75536fd4bb2e2ab6$var$ce = /** @class */ function() {
    function t() {}
    return t.an = function(e) {
        t.platform && $75536fd4bb2e2ab6$var$ge(), t.platform = e;
    }, t.nt = function() {
        return t.platform || $75536fd4bb2e2ab6$var$ge(), t.platform;
    }, t;
}(), $75536fd4bb2e2ab6$var$fe = new $ctGiR.Logger("@firebase/firestore");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Helper methods are needed because variables can't be exported as read/write
function $75536fd4bb2e2ab6$var$le() {
    return $75536fd4bb2e2ab6$var$fe.logLevel;
}
function $75536fd4bb2e2ab6$var$pe(t) {
    $75536fd4bb2e2ab6$var$fe.logLevel = t;
}
function $75536fd4bb2e2ab6$var$de(t) {
    for(var n = [], i = 1; i < arguments.length; i++)n[i - 1] = arguments[i];
    if ($75536fd4bb2e2ab6$var$fe.logLevel <= $ctGiR.LogLevel.DEBUG) {
        var o = n.map($75536fd4bb2e2ab6$var$ve);
        $75536fd4bb2e2ab6$var$fe.debug.apply($75536fd4bb2e2ab6$var$fe, $8QG6t.__spreadArrays([
            "Firestore (" + $75536fd4bb2e2ab6$var$u + "): " + t
        ], o));
    }
}
function $75536fd4bb2e2ab6$var$ye(t) {
    for(var n = [], i = 1; i < arguments.length; i++)n[i - 1] = arguments[i];
    if ($75536fd4bb2e2ab6$var$fe.logLevel <= $ctGiR.LogLevel.ERROR) {
        var o = n.map($75536fd4bb2e2ab6$var$ve);
        $75536fd4bb2e2ab6$var$fe.error.apply($75536fd4bb2e2ab6$var$fe, $8QG6t.__spreadArrays([
            "Firestore (" + $75536fd4bb2e2ab6$var$u + "): " + t
        ], o));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $75536fd4bb2e2ab6$var$ve(t) {
    if ("string" == typeof t) return t;
    var e = $75536fd4bb2e2ab6$var$ce.nt();
    try {
        return e.un(t);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $75536fd4bb2e2ab6$var$ge(t) {
    void 0 === t && (t = "Unexpected state");
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var e = "FIRESTORE (" + $75536fd4bb2e2ab6$var$u + ") INTERNAL ASSERTION FAILED: " + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $75536fd4bb2e2ab6$var$ye(e), new Error(e);
}
function $75536fd4bb2e2ab6$var$me(t, e) {
    t || $75536fd4bb2e2ab6$var$ge();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $75536fd4bb2e2ab6$var$we(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$Ee = /** @class */ function() {
    function t() {}
    return t.cn = function() {
        for(// Alphanumeric characters
        var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length, n = ""; n.length < 20;)for(var r = $75536fd4bb2e2ab6$var$ce.nt()._n(40), i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
        // be evenly mapped to indices of `chars` via a modulo operation.
        n.length < 20 && r[i] < e && (n += t.charAt(r[i] % t.length));
        return n;
    }, t;
}();
function $75536fd4bb2e2ab6$var$be(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $75536fd4bb2e2ab6$var$_e(t, e, n) {
    return t.length === e.length && t.every(function(t, r) {
        return n(t, e[r]);
    });
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $75536fd4bb2e2ab6$var$Te(t) {
    // Return the input string, with an additional NUL byte appended.
    return t + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$Ie = /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     * @param forceLongPolling Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     */ function(t, e, n, r, i) {
    this.ii = t, this.persistenceKey = e, this.host = n, this.ssl = r, this.forceLongPolling = i;
}, $75536fd4bb2e2ab6$var$Ne = /** @class */ function() {
    function t(t, e) {
        this.projectId = t, this.database = e || "(default)";
    }
    return Object.defineProperty(t.prototype, "ln", {
        get: function() {
            return "(default)" === this.database;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        return e instanceof t && e.projectId === this.projectId && e.database === this.database;
    }, t.prototype.S = function(t) {
        return $75536fd4bb2e2ab6$var$be(this.projectId, t.projectId) || $75536fd4bb2e2ab6$var$be(this.database, t.database);
    }, t;
}(), $75536fd4bb2e2ab6$var$Ae = /** @class */ function() {
    function t(t) {
        this.dn = t, /**
             * The inner map for a key -> value pair. Due to the possibility of
             * collisions we keep a list of entries that we do a linear search through
             * to find an actual match. Note that collisions should be rare, so we still
             * expect near constant time lookups in practice.
             */ this.fn = {};
    }
    return t.prototype.get = function(t) {
        var e = this.dn(t), n = this.fn[e];
        if (void 0 !== n) for(var r = 0, i = n; r < i.length; r++){
            var o = i[r], s = o[0], u = o[1];
            if (s.isEqual(t)) return u;
        }
    }, t.prototype.has = function(t) {
        return void 0 !== this.get(t);
    }, /** Put this key and value in the map. */ t.prototype.set = function(t, e) {
        var n = this.dn(t), r = this.fn[n];
        if (void 0 !== r) {
            for(var i = 0; i < r.length; i++)if (r[i][0].isEqual(t)) return void (r[i] = [
                t,
                e
            ]);
            r.push([
                t,
                e
            ]);
        } else this.fn[n] = [
            [
                t,
                e
            ]
        ];
    }, /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ t.prototype.delete = function(t) {
        var e = this.dn(t), n = this.fn[e];
        if (void 0 === n) return !1;
        for(var r = 0; r < n.length; r++)if (n[r][0].isEqual(t)) return 1 === n.length ? delete this.fn[e] : n.splice(r, 1), !0;
        return !1;
    }, t.prototype.forEach = function(t) {
        $75536fd4bb2e2ab6$var$I(this.fn, function(e, n) {
            for(var r = 0, i = n; r < i.length; r++){
                var o = i[r], s = o[0], u = o[1];
                t(s, u);
            }
        });
    }, t.prototype.B = function() {
        return $75536fd4bb2e2ab6$var$N(this.fn);
    }, t;
}(), $75536fd4bb2e2ab6$var$ke = /** @class */ function() {
    /**
     * @param batchId The unique ID of this mutation batch.
     * @param localWriteTime The original write time of this mutation.
     * @param baseMutations Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ function t(t, e, n, r) {
        this.batchId = t, this.Tn = e, this.baseMutations = n, this.mutations = r;
    }
    return t.prototype.at = function(t, e, n) {
        for(var r = n.En, i = 0; i < this.mutations.length; i++){
            var o = this.mutations[i];
            if (o.key.isEqual(t)) {
                var s = r[i];
                e = o.at(e, s);
            }
        }
        return e;
    }, /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */ t.prototype.ot = function(t, e) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for(var n = 0, r = this.baseMutations; n < r.length; n++){
            var i = r[n];
            i.key.isEqual(t) && (e = i.ot(e, e, this.Tn));
        }
        // Second, apply all user-provided mutations.
        for(var o = e, s = 0, u = this.mutations; s < u.length; s++){
            var a = u[s];
            a.key.isEqual(t) && (e = a.ot(e, o, this.Tn));
        }
        return e;
    }, /**
     * Computes the local view for all provided documents given the mutations in
     * this batch.
     */ t.prototype.In = function(t) {
        var e = this, n = t;
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        return this.mutations.forEach(function(r) {
            var i = e.ot(r.key, t.get(r.key));
            i && (n = n.Ae(r.key, i));
        }), n;
    }, t.prototype.keys = function() {
        return this.mutations.reduce(function(t, e) {
            return t.add(e.key);
        }, $75536fd4bb2e2ab6$var$Wt());
    }, t.prototype.isEqual = function(t) {
        return this.batchId === t.batchId && $75536fd4bb2e2ab6$var$_e(this.mutations, t.mutations, function(t, e) {
            return t.isEqual(e);
        }) && $75536fd4bb2e2ab6$var$_e(this.baseMutations, t.baseMutations, function(t, e) {
            return t.isEqual(e);
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$De = /** @class */ function() {
    function t(t, e, n, r, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ i) {
        this.batch = t, this.wn = e, this.En = n, this.streamToken = r, this.Rn = i;
    }
    return t.from = function(e, n, r, i) {
        $75536fd4bb2e2ab6$var$me(e.mutations.length === r.length);
        for(var o = $75536fd4bb2e2ab6$var$zt(), s = e.mutations, u = 0; u < s.length; u++)o = o.Ae(s[u].key, r[u].version);
        return new t(e, n, r, i, o);
    }, t;
}(), $75536fd4bb2e2ab6$var$xe = /** @class */ function() {
    function t(t) {
        var e = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.An = null, this.mn = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.Pn = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.Vn = !1, t(function(t) {
            e.Pn = !0, e.result = t, e.An && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            e.An(t);
        }, function(t) {
            e.Pn = !0, e.error = t, e.mn && e.mn(t);
        });
    }
    return t.prototype.catch = function(t) {
        return this.next(void 0, t);
    }, t.prototype.next = function(e, n) {
        var r = this;
        return this.Vn && $75536fd4bb2e2ab6$var$ge(), this.Vn = !0, this.Pn ? this.error ? this.gn(n, this.error) : this.pn(e, this.result) : new t(function(t, i) {
            r.An = function(n) {
                r.pn(e, n).next(t, i);
            }, r.mn = function(e) {
                r.gn(n, e).next(t, i);
            };
        });
    }, t.prototype.yn = function() {
        var t = this;
        return new Promise(function(e, n) {
            t.next(e, n);
        });
    }, t.prototype.bn = function(e) {
        try {
            var n = e();
            return n instanceof t ? n : t.resolve(n);
        } catch (e) {
            return t.reject(e);
        }
    }, t.prototype.pn = function(e, n) {
        return e ? this.bn(function() {
            return e(n);
        }) : t.resolve(n);
    }, t.prototype.gn = function(e, n) {
        return e ? this.bn(function() {
            return e(n);
        }) : t.reject(n);
    }, t.resolve = function(e) {
        return new t(function(t, n) {
            t(e);
        });
    }, t.reject = function(e) {
        return new t(function(t, n) {
            n(e);
        });
    }, t.vn = function(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new t(function(t, n) {
            var r = 0, i = 0, o = !1;
            e.forEach(function(e) {
                ++r, e.next(function() {
                    ++i, o && i === r && t();
                }, function(t) {
                    return n(t);
                });
            }), o = !0, i === r && t();
        });
    }, /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ t.Sn = function(e) {
        for(var n = t.resolve(!1), r = function(e) {
            n = n.next(function(n) {
                return n ? t.resolve(n) : e();
            });
        }, i = 0, o = e; i < o.length; i++)r(o[i]);
        return n;
    }, t.forEach = function(t, e) {
        var n = this, r = [];
        return t.forEach(function(t, i) {
            r.push(e.call(n, t, i));
        }), this.vn(r);
    }, t;
}(), $75536fd4bb2e2ab6$var$Se = /** @class */ function() {
    function t() {
        // A mapping of document key to the new cache entry that should be written (or null if any
        // existing cache entry should be removed).
        this.Dn = new $75536fd4bb2e2ab6$var$Ae(function(t) {
            return t.toString();
        }), this.Cn = !1;
    }
    return Object.defineProperty(t.prototype, "readTime", {
        get: function() {
            return this.Fn;
        },
        set: function(t) {
            this.Fn = t;
        },
        enumerable: !0,
        configurable: !0
    }), /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ t.prototype.Nn = function(t, e) {
        this.$n(), this.readTime = e, this.Dn.set(t.key, t);
    }, /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ t.prototype.kn = function(t, e) {
        this.$n(), e && (this.readTime = e), this.Dn.set(t, null);
    }, /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */ t.prototype.Ln = function(t, e) {
        this.$n();
        var n = this.Dn.get(e);
        return void 0 !== n ? $75536fd4bb2e2ab6$var$xe.resolve(n) : this.Mn(t, e);
    }, /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys The keys of the entries to look up.
     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
     *     entry cannot be found, the corresponding key will be mapped to a null
     *     value.
     */ t.prototype.getEntries = function(t, e) {
        return this.On(t, e);
    }, /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ t.prototype.apply = function(t) {
        return this.$n(), this.Cn = !0, this.xn(t);
    }, /** Helper to assert this.changes is not null  */ t.prototype.$n = function() {}, t;
}(), $75536fd4bb2e2ab6$var$Re = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", $75536fd4bb2e2ab6$var$Le = /** @class */ function() {
    function t() {
        this.Bn = [];
    }
    return t.prototype.qn = function(t) {
        this.Bn.push(t);
    }, t.prototype.Un = function() {
        this.Bn.forEach(function(t) {
            return t();
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$Oe = /** @class */ function() {
    function t(t, e, n) {
        this.Qn = t, this.Wn = e, this.jn = n;
    }
    return t.prototype.Kn = function(t, e) {
        var n = this;
        return this.Wn.Gn(t, e).next(function(r) {
            return n.zn(t, e, r);
        });
    }, /** Internal version of `getDocument` that allows reusing batches. */ t.prototype.zn = function(t, e, n) {
        return this.Qn.Ln(t, e).next(function(t) {
            for(var r = 0, i = n; r < i.length; r++)t = i[r].ot(e, t);
            return t;
        });
    }, // Returns the view of the given `docs` as they would appear after applying
    // all mutations in the given `batches`.
    t.prototype.Hn = function(t, e, n) {
        var r = $75536fd4bb2e2ab6$var$Mt();
        return e.forEach(function(t, e) {
            for(var i = 0, o = n; i < o.length; i++)e = o[i].ot(t, e);
            r = r.Ae(t, e);
        }), r;
    }, /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ t.prototype.Yn = function(t, e) {
        var n = this;
        return this.Qn.getEntries(t, e).next(function(e) {
            return n.Jn(t, e);
        });
    }, /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     */ t.prototype.Jn = function(t, e) {
        var n = this;
        return this.Wn.Xn(t, e).next(function(r) {
            var i = n.Hn(t, e, r), o = $75536fd4bb2e2ab6$var$qt();
            return i.forEach(function(t, e) {
                // TODO(http://b/32275378): Don't conflate missing / deleted.
                e || (e = new $75536fd4bb2e2ab6$var$vt(t, $75536fd4bb2e2ab6$var$g.min())), o = o.Ae(t, e);
            }), o;
        });
    }, /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction The persistence transaction.
     * @param query The query to match documents against.
     * @param sinceReadTime If not set to SnapshotVersion.min(), return only
     *     documents that have been read since this snapshot version (exclusive).
     */ t.prototype.Zn = function(t, e, n) {
        return e.Ot() ? this.tr(t, e.path) : e._e() ? this.er(t, e, n) : this.sr(t, e, n);
    }, t.prototype.tr = function(t, e) {
        // Just do a simple document lookup.
        return this.Kn(t, new $75536fd4bb2e2ab6$var$_(e)).next(function(t) {
            var e = $75536fd4bb2e2ab6$var$Ft();
            return t instanceof $75536fd4bb2e2ab6$var$yt && (e = e.Ae(t.key, t)), e;
        });
    }, t.prototype.er = function(t, e, n) {
        var r = this, i = e.collectionGroup, o = $75536fd4bb2e2ab6$var$Ft();
        return this.jn.ir(t, i).next(function(s) {
            return $75536fd4bb2e2ab6$var$xe.forEach(s, function(s) {
                var u = e.Zt(s.child(i));
                return r.sr(t, u, n).next(function(t) {
                    t.forEach(function(t, e) {
                        o = o.Ae(t, e);
                    });
                });
            }).next(function() {
                return o;
            });
        });
    }, t.prototype.sr = function(t, e, n) {
        var r, i, o = this;
        // Query the remote documents and overlay mutations.
        return this.Qn.Zn(t, e, n).next(function(n) {
            return r = n, o.Wn.nr(t, e);
        }).next(function(e) {
            return i = e, o.rr(t, i, r).next(function(t) {
                r = t;
                for(var e = 0, n = i; e < n.length; e++)for(var o = n[e], s = 0, u = o.mutations; s < u.length; s++){
                    var a = u[s], h = a.key, c = r.get(h), f = a.ot(c, c, o.Tn);
                    r = f instanceof $75536fd4bb2e2ab6$var$yt ? r.Ae(h, f) : r.remove(h);
                }
            });
        }).next(function() {
            // Finally, filter out any documents that don't actually match
            // the query.
            return r.forEach(function(t, n) {
                e.matches(n) || (r = r.remove(t));
            }), r;
        });
    }, t.prototype.rr = function(t, e, n) {
        for(var r = $75536fd4bb2e2ab6$var$Wt(), i = 0, o = e; i < o.length; i++)for(var s = 0, u = o[i].mutations; s < u.length; s++){
            var a = u[s];
            a instanceof $75536fd4bb2e2ab6$var$ot && null === n.get(a.key) && (r = r.add(a.key));
        }
        var h = n;
        return this.Qn.getEntries(t, r).next(function(t) {
            return t.forEach(function(t, e) {
                null !== e && e instanceof $75536fd4bb2e2ab6$var$yt && (h = h.Ae(t, e));
            }), h;
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$Ve = /** @class */ function() {
    function t(t, e, n, r) {
        this.targetId = t, this.fromCache = e, this.hr = n, this.or = r;
    }
    return t.ar = function(e, n) {
        for(var r = $75536fd4bb2e2ab6$var$Wt(), i = $75536fd4bb2e2ab6$var$Wt(), o = 0, s = n.docChanges; o < s.length; o++){
            var u = s[o];
            switch(u.type){
                case 0 /* Added */ :
                    r = r.add(u.doc.key);
                    break;
                case 1 /* Removed */ :
                    i = i.add(u.doc.key);
            }
        }
        return new t(e, n.fromCache, r, i);
    }, t;
}(), $75536fd4bb2e2ab6$var$Pe = /** @class */ function() {
    function t(t, e) {
        var n = this;
        this.previousValue = t, e && (e.ur = function(t) {
            return n.cr(t);
        }, this._r = function(t) {
            return e.lr(t);
        });
    }
    return t.prototype.cr = function(t) {
        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }, t.prototype.next = function() {
        var t = ++this.previousValue;
        return this._r && this._r(t), t;
    }, t;
}();
/** The default database name for a project. */ /** Represents the database ID a Firestore client is associated with. */ $75536fd4bb2e2ab6$var$Pe.dr = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$Ue = function() {
    var t = this;
    this.promise = new Promise(function(e, n) {
        t.resolve = e, t.reject = n;
    });
}, $75536fd4bb2e2ab6$var$Ce = /** @class */ function() {
    function t(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n, r, i) {
        void 0 === n && (n = 1e3), void 0 === r && (r = 1.5), void 0 === i && (i = 6e4), this.Tr = t, this.Er = e, this.Ir = n, this.wr = r, this.Rr = i, this.Ar = 0, this.mr = null, /** The last backoff attempt, as epoch milliseconds. */ this.Pr = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ return t.prototype.reset = function() {
        this.Ar = 0;
    }, /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ t.prototype.Vr = function() {
        this.Ar = this.Rr;
    }, /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ t.prototype.gr = function(t) {
        var e = this;
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var n = Math.floor(this.Ar + this.pr()), r = Math.max(0, Date.now() - this.Pr), i = Math.max(0, n - r);
        // Guard against lastAttemptTime being in the future due to a clock change.
        i > 0 && $75536fd4bb2e2ab6$var$de("ExponentialBackoff", "Backing off for " + i + " ms (base delay: " + this.Ar + " ms, delay with jitter: " + n + " ms, last attempt: " + r + " ms ago)"), this.mr = this.Tr.yr(this.Er, i, function() {
            return e.Pr = Date.now(), t();
        }), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.Ar *= this.wr, this.Ar < this.Ir && (this.Ar = this.Ir), this.Ar > this.Rr && (this.Ar = this.Rr);
    }, t.prototype.br = function() {
        null !== this.mr && (this.mr.vr(), this.mr = null);
    }, t.prototype.cancel = function() {
        null !== this.mr && (this.mr.cancel(), this.mr = null);
    }, /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ t.prototype.pr = function() {
        return (Math.random() - .5) * this.Ar;
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $75536fd4bb2e2ab6$var$qe(t) {
    for(var e = "", n = 0; n < t.length; n++)e.length > 0 && (e = $75536fd4bb2e2ab6$var$je(e)), e = $75536fd4bb2e2ab6$var$Me(t.get(n), e);
    return $75536fd4bb2e2ab6$var$je(e);
}
/** Encodes a single segment of a resource path into the given result */ function $75536fd4bb2e2ab6$var$Me(t, e) {
    for(var n = e, r = t.length, i = 0; i < r; i++){
        var o = t.charAt(i);
        switch(o){
            case "\0":
                n += "";
                break;
            case "":
                n += "";
                break;
            default:
                n += o;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $75536fd4bb2e2ab6$var$je(t) {
    return t + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $75536fd4bb2e2ab6$var$Fe(t) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var e = t.length;
    if ($75536fd4bb2e2ab6$var$me(e >= 2), 2 === e) return $75536fd4bb2e2ab6$var$me("" === t.charAt(0) && "" === t.charAt(1)), $75536fd4bb2e2ab6$var$w.G;
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    for(var n = e - 2, r = [], i = "", o = 0; o < e;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var s = t.indexOf("", o);
        switch((s < 0 || s > n) && $75536fd4bb2e2ab6$var$ge(), t.charAt(s + 1)){
            case "":
                var u = t.substring(o, s), a = void 0;
                0 === i.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                a = u : (a = i += u, i = ""), r.push(a);
                break;
            case "":
                i += t.substring(o, s), i += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                i += t.substring(o, s + 1);
                break;
            default:
                $75536fd4bb2e2ab6$var$ge();
        }
        o = s + 2;
    }
    return new $75536fd4bb2e2ab6$var$w(r);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ var $75536fd4bb2e2ab6$var$Be = /** @class */ function() {
    function t() {
        this.Sr = new $75536fd4bb2e2ab6$var$ze;
    }
    return t.prototype.Dr = function(t, e) {
        return this.Sr.add(e), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.ir = function(t, e) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.Sr.getEntries(e));
    }, t;
}(), $75536fd4bb2e2ab6$var$ze = /** @class */ function() {
    function t() {
        this.index = {};
    }
    // Returns false if the entry already existed.
    return t.prototype.add = function(t) {
        var e = t.O(), n = t.L(), r = this.index[e] || new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$w.N), i = !r.has(n);
        return this.index[e] = r.add(n), i;
    }, t.prototype.has = function(t) {
        var e = t.O(), n = t.L(), r = this.index[e];
        return r && r.has(n);
    }, t.prototype.getEntries = function(t) {
        return (this.index[t] || new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$w.N)).W();
    }, t;
}(), $75536fd4bb2e2ab6$var$Ge = /** @class */ function() {
    function t() {
        /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be used to
         * satisfy reads.
         */ this.Cr = new $75536fd4bb2e2ab6$var$ze;
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ return t.prototype.Dr = function(t, e) {
        var n = this;
        if (!this.Cr.has(e)) {
            var r = e.O(), i = e.L();
            t.qn(function() {
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                n.Cr.add(e);
            });
            var o = {
                collectionId: r,
                parent: $75536fd4bb2e2ab6$var$qe(i)
            };
            return $75536fd4bb2e2ab6$var$We(t).put(o);
        }
        return $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.ir = function(t, e) {
        var n = [], r = IDBKeyRange.bound([
            e,
            ""
        ], [
            $75536fd4bb2e2ab6$var$Te(e),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $75536fd4bb2e2ab6$var$We(t).Fr(r).next(function(t) {
            for(var r = 0, i = t; r < i.length; r++){
                var o = i[r];
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (o.collectionId !== e) break;
                n.push($75536fd4bb2e2ab6$var$Fe(o.parent));
            }
            return n;
        });
    }, t;
}();
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ /**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $75536fd4bb2e2ab6$var$We(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$Rn.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$Qe = /** @class */ function() {
    /**
     * @param {LocalSerializer} serializer The document serializer.
     * @param {IndexManager} indexManager The query indexes that need to be maintained.
     */ function t(t, e) {
        this.serializer = t, this.jn = e;
    }
    return t.prototype.Nn = function(t, e, n) {
        return $75536fd4bb2e2ab6$var$Ye(t).put($75536fd4bb2e2ab6$var$$e(e), n);
    }, /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ t.prototype.kn = function(t, e) {
        var n = $75536fd4bb2e2ab6$var$Ye(t), r = $75536fd4bb2e2ab6$var$$e(e);
        return n.delete(r);
    }, /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ t.prototype.updateMetadata = function(t, e) {
        var n = this;
        return this.getMetadata(t).next(function(r) {
            return r.byteSize += e, n.$r(t, r);
        });
    }, t.prototype.Ln = function(t, e) {
        var n = this;
        return $75536fd4bb2e2ab6$var$Ye(t).get($75536fd4bb2e2ab6$var$$e(e)).next(function(t) {
            return n.kr(t);
        });
    }, /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */ t.prototype.Lr = function(t, e) {
        var n = this;
        return $75536fd4bb2e2ab6$var$Ye(t).get($75536fd4bb2e2ab6$var$$e(e)).next(function(t) {
            var e = n.kr(t);
            return e ? {
                Mr: e,
                size: $75536fd4bb2e2ab6$var$Je(t)
            } : null;
        });
    }, t.prototype.getEntries = function(t, e) {
        var n = this, r = $75536fd4bb2e2ab6$var$Mt();
        return this.Or(t, e, function(t, e) {
            var i = n.kr(e);
            r = r.Ae(t, i);
        }).next(function() {
            return r;
        });
    }, /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */ t.prototype.xr = function(t, e) {
        var n = this, r = $75536fd4bb2e2ab6$var$Mt(), i = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
        return this.Or(t, e, function(t, e) {
            var o = n.kr(e);
            o ? (r = r.Ae(t, o), i = i.Ae(t, $75536fd4bb2e2ab6$var$Je(e))) : (r = r.Ae(t, null), i = i.Ae(t, 0));
        }).next(function() {
            return {
                Br: r,
                qr: i
            };
        });
    }, t.prototype.Or = function(t, e, n) {
        if (e.B()) return $75536fd4bb2e2ab6$var$xe.resolve();
        var r = IDBKeyRange.bound(e.first().path.W(), e.last().path.W()), i = e.be(), o = i.Ne();
        return $75536fd4bb2e2ab6$var$Ye(t).Ur({
            range: r
        }, function(t, e, r) {
            // Go through keys not found in cache.
            for(var s = $75536fd4bb2e2ab6$var$_.st(t); o && $75536fd4bb2e2ab6$var$_.N(o, s) < 0;)n(o, null), o = i.Ne();
            o && o.isEqual(s) && // Key found in cache.
            (n(o, e), o = i.$e() ? i.Ne() : null), // Skip to the next key (if there is one).
            o ? r.Qr(o.path.W()) : r.done();
        }).next(function() {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = i.$e() ? i.Ne() : null;
        });
    }, t.prototype.Zn = function(t, e, n) {
        var r = this, i = $75536fd4bb2e2ab6$var$Ft(), o = e.path.length + 1, s = {};
        if (n.isEqual($75536fd4bb2e2ab6$var$g.min())) {
            // Documents are ordered by key, so we can use a prefix scan to narrow
            // down the documents we need to match the query against.
            var u = e.path.W();
            s.range = IDBKeyRange.lowerBound(u);
        } else {
            // Execute an index-free query and filter by read time. This is safe
            // since all document changes to queries that have a
            // lastLimboFreeSnapshotVersion (`sinceReadTime`) have a read time set.
            var a = e.path.W(), h = this.serializer.Wr(n);
            s.range = IDBKeyRange.lowerBound([
                a,
                h
            ], /* open= */ !0), s.index = $75536fd4bb2e2ab6$var$An.collectionReadTimeIndex;
        }
        return $75536fd4bb2e2ab6$var$Ye(t).Ur(s, function(t, n, s) {
            // The query is actually returning any path that starts with the query
            // path prefix which may include documents in subcollections. For
            // example, a query on 'rooms' will return rooms/abc/messages/xyx but we
            // shouldn't match it. Fix this by discarding rows with document keys
            // more than one segment longer than the query path.
            if (t.length === o) {
                var u = r.serializer.jr(n);
                e.path.q(u.key.path) ? u instanceof $75536fd4bb2e2ab6$var$yt && e.matches(u) && (i = i.Ae(u.key, u)) : s.done();
            }
        }).next(function() {
            return i;
        });
    }, /**
     * Returns the set of documents that have changed since the specified read
     * time.
     */ // PORTING NOTE: This is only used for multi-tab synchronization.
    t.prototype.Kr = function(t, e) {
        var n = this, r = $75536fd4bb2e2ab6$var$qt(), i = this.serializer.Wr(e), o = $75536fd4bb2e2ab6$var$Ye(t), s = IDBKeyRange.lowerBound(i, !0);
        return o.Ur({
            index: $75536fd4bb2e2ab6$var$An.readTimeIndex,
            range: s
        }, function(t, e) {
            // Unlike `getEntry()` and others, `getNewDocumentChanges()` parses
            // the documents directly since we want to keep sentinel deletes.
            var o = n.serializer.jr(e);
            r = r.Ae(o.key, o), i = e.readTime;
        }).next(function() {
            return {
                Gr: r,
                readTime: n.serializer.zr(i)
            };
        });
    }, /**
     * Returns the read time of the most recently read document in the cache, or
     * SnapshotVersion.min() if not available.
     */ // PORTING NOTE: This is only used for multi-tab synchronization.
    t.prototype.Hr = function(t) {
        var e = this, n = $75536fd4bb2e2ab6$var$Ye(t), r = $75536fd4bb2e2ab6$var$g.min();
        return n.Ur({
            index: $75536fd4bb2e2ab6$var$An.readTimeIndex,
            reverse: !0
        }, function(t, n, i) {
            n.readTime && (r = e.serializer.zr(n.readTime)), i.done();
        }).next(function() {
            return r;
        });
    }, t.prototype.Yr = function(e) {
        return new t.Jr(this, !!e && e.Xr);
    }, t.prototype.Zr = function(t) {
        return this.getMetadata(t).next(function(t) {
            return t.byteSize;
        });
    }, t.prototype.getMetadata = function(t) {
        return $75536fd4bb2e2ab6$var$Ke(t).get($75536fd4bb2e2ab6$var$kn.key).next(function(t) {
            return $75536fd4bb2e2ab6$var$me(!!t), t;
        });
    }, t.prototype.$r = function(t, e) {
        return $75536fd4bb2e2ab6$var$Ke(t).put($75536fd4bb2e2ab6$var$kn.key, e);
    }, /**
     * Decodes `remoteDoc` and returns the document (or null, if the document
     * corresponds to the format used for sentinel deletes).
     */ t.prototype.kr = function(t) {
        if (t) {
            var e = this.serializer.jr(t);
            return e instanceof $75536fd4bb2e2ab6$var$vt && e.version.isEqual($75536fd4bb2e2ab6$var$g.min()) ? null : e;
        }
        return null;
    }, t;
}();
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ function $75536fd4bb2e2ab6$var$Ke(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$kn.store);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $75536fd4bb2e2ab6$var$Ye(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$An.store);
}
function $75536fd4bb2e2ab6$var$$e(t) {
    return t.path.W();
}
/**
 * Retrusn an approximate size for the given document.
 */ function $75536fd4bb2e2ab6$var$Je(t) {
    var e;
    if (t.document) e = t.document;
    else if (t.unknownDocument) e = t.unknownDocument;
    else {
        if (!t.noDocument) throw $75536fd4bb2e2ab6$var$ge();
        e = t.noDocument;
    }
    return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ $75536fd4bb2e2ab6$var$Qe.Jr = /** @class */ function(t) {
    /**
     * @param documentCache The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ function n(e, n) {
        var r = this;
        return (r = t.call(this) || this).th = e, r.Xr = n, // A map of document sizes prior to applying the changes in this buffer.
        r.eh = new $75536fd4bb2e2ab6$var$Ae(function(t) {
            return t.toString();
        }), r;
    }
    return $8QG6t.__extends(n, t), n.prototype.xn = function(t) {
        var e = this, n = [], r = 0, i = new $75536fd4bb2e2ab6$var$Pt(function(t, e) {
            return $75536fd4bb2e2ab6$var$be(t.j(), e.j());
        });
        return this.Dn.forEach(function(o, s) {
            var u = e.eh.get(o);
            if (s) {
                var a = e.th.serializer.sh(s, e.readTime);
                i = i.add(o.path.L());
                var h = $75536fd4bb2e2ab6$var$Je(a);
                r += h - u, n.push(e.th.Nn(t, o, a));
            } else if (r -= u, e.Xr) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                var c = e.th.serializer.sh(new $75536fd4bb2e2ab6$var$vt(o, $75536fd4bb2e2ab6$var$g.min()), e.readTime);
                n.push(e.th.Nn(t, o, c));
            } else n.push(e.th.kn(t, o));
        }), i.forEach(function(r) {
            n.push(e.th.jn.Dr(t, r));
        }), n.push(this.th.updateMetadata(t, r)), $75536fd4bb2e2ab6$var$xe.vn(n);
    }, n.prototype.Mn = function(t, e) {
        var n = this;
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.th.Lr(t, e).next(function(t) {
            return null === t ? (n.eh.set(e, 0), null) : (n.eh.set(e, t.size), t.Mr);
        });
    }, n.prototype.On = function(t, e) {
        var n = this;
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.th.xr(t, e).next(function(t) {
            var e = t.Br;
            // Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `NullableMaybeDocumentMap` directly, without a conversion.
            return t.qr.forEach(function(t, e) {
                n.eh.set(t, e);
            }), e;
        });
    }, n;
}($75536fd4bb2e2ab6$var$Se);
/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ var $75536fd4bb2e2ab6$var$He = /** @class */ function() {
    function t(t) {
        this.ih = t;
    }
    return t.prototype.next = function() {
        return this.ih += 2, this.ih;
    }, t.nh = function() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new t(0);
    }, t.rh = function() {
        // Sync engine assigns target IDs for limbo document detection.
        return new t(-1);
    }, t;
}(), $75536fd4bb2e2ab6$var$Xe = /** @class */ function() {
    function t(t, e) {
        this.hh = t, this.serializer = e;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    return t.prototype.oh = function(t) {
        var e = this;
        return this.ah(t).next(function(n) {
            var r = new $75536fd4bb2e2ab6$var$He(n.highestTargetId);
            return n.highestTargetId = r.next(), e.uh(t, n).next(function() {
                return n.highestTargetId;
            });
        });
    }, t.prototype._h = function(t) {
        return this.ah(t).next(function(t) {
            return $75536fd4bb2e2ab6$var$g.v(new $75536fd4bb2e2ab6$var$v(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds));
        });
    }, t.prototype.lh = function(t) {
        return this.ah(t).next(function(t) {
            return t.highestListenSequenceNumber;
        });
    }, t.prototype.dh = function(t, e, n) {
        var r = this;
        return this.ah(t).next(function(i) {
            return i.highestListenSequenceNumber = e, n && (i.lastRemoteSnapshotVersion = n.C()), e > i.highestListenSequenceNumber && (i.highestListenSequenceNumber = e), r.uh(t, i);
        });
    }, t.prototype.fh = function(t, e) {
        var n = this;
        return this.Th(t, e).next(function() {
            return n.ah(t).next(function(r) {
                return r.targetCount += 1, n.Eh(e, r), n.uh(t, r);
            });
        });
    }, t.prototype.Ih = function(t, e) {
        return this.Th(t, e);
    }, t.prototype.wh = function(t, e) {
        var n = this;
        return this.Rh(t, e.targetId).next(function() {
            return $75536fd4bb2e2ab6$var$Ze(t).delete(e.targetId);
        }).next(function() {
            return n.ah(t);
        }).next(function(e) {
            return $75536fd4bb2e2ab6$var$me(e.targetCount > 0), e.targetCount -= 1, n.uh(t, e);
        });
    }, /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ t.prototype.Ah = function(t, e, n) {
        var r = this, i = 0, o = [];
        return $75536fd4bb2e2ab6$var$Ze(t).Ur(function(s, u) {
            var a = r.serializer.mh(u);
            a.sequenceNumber <= e && null === n.get(a.targetId) && (i++, o.push(r.wh(t, a)));
        }).next(function() {
            return $75536fd4bb2e2ab6$var$xe.vn(o);
        }).next(function() {
            return i;
        });
    }, /**
     * Call provided function with each `TargetData` that we have cached.
     */ t.prototype.js = function(t, e) {
        var n = this;
        return $75536fd4bb2e2ab6$var$Ze(t).Ur(function(t, r) {
            var i = n.serializer.mh(r);
            e(i);
        });
    }, t.prototype.ah = function(t) {
        return $75536fd4bb2e2ab6$var$tn(t).get($75536fd4bb2e2ab6$var$Sn.key).next(function(t) {
            return $75536fd4bb2e2ab6$var$me(null !== t), t;
        });
    }, t.prototype.uh = function(t, e) {
        return $75536fd4bb2e2ab6$var$tn(t).put($75536fd4bb2e2ab6$var$Sn.key, e);
    }, t.prototype.Th = function(t, e) {
        return $75536fd4bb2e2ab6$var$Ze(t).put(this.serializer.Ph(e));
    }, /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ t.prototype.Eh = function(t, e) {
        var n = !1;
        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }, t.prototype.Vh = function(t) {
        return this.ah(t).next(function(t) {
            return t.targetCount;
        });
    }, t.prototype.gh = function(t, e) {
        var n = this, r = e.canonicalId(), i = IDBKeyRange.bound([
            r,
            Number.NEGATIVE_INFINITY
        ], [
            r,
            Number.POSITIVE_INFINITY
        ]), o = null;
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        return $75536fd4bb2e2ab6$var$Ze(t).Ur({
            range: i,
            index: $75536fd4bb2e2ab6$var$Dn.queryTargetsIndexName
        }, function(t, r, i) {
            var s = n.serializer.mh(r);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            e.isEqual(s.target) && (o = s, i.done());
        }).next(function() {
            return o;
        });
    }, t.prototype.ph = function(t, e, n) {
        var r = this, i = [], o = $75536fd4bb2e2ab6$var$en(t);
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        return e.forEach(function(e) {
            var s = $75536fd4bb2e2ab6$var$qe(e.path);
            i.push(o.put(new $75536fd4bb2e2ab6$var$xn(n, s))), i.push(r.hh.yh(t, n, e));
        }), $75536fd4bb2e2ab6$var$xe.vn(i);
    }, t.prototype.bh = function(t, e, n) {
        var r = this, i = $75536fd4bb2e2ab6$var$en(t);
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        return $75536fd4bb2e2ab6$var$xe.forEach(e, function(e) {
            var o = $75536fd4bb2e2ab6$var$qe(e.path);
            return $75536fd4bb2e2ab6$var$xe.vn([
                i.delete([
                    n,
                    o
                ]),
                r.hh.vh(t, n, e)
            ]);
        });
    }, t.prototype.Rh = function(t, e) {
        var n = $75536fd4bb2e2ab6$var$en(t), r = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }, t.prototype.Sh = function(t, e) {
        var n = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $75536fd4bb2e2ab6$var$en(t), i = $75536fd4bb2e2ab6$var$Wt();
        return r.Ur({
            range: n,
            Dh: !0
        }, function(t, e, n) {
            var r = $75536fd4bb2e2ab6$var$Fe(t[1]), o = new $75536fd4bb2e2ab6$var$_(r);
            i = i.add(o);
        }).next(function() {
            return i;
        });
    }, t.prototype.Ch = function(t, e) {
        var n = $75536fd4bb2e2ab6$var$qe(e.path), r = IDBKeyRange.bound([
            n
        ], [
            $75536fd4bb2e2ab6$var$Te(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), i = 0;
        return $75536fd4bb2e2ab6$var$en(t).Ur({
            index: $75536fd4bb2e2ab6$var$xn.documentTargetsIndex,
            Dh: !0,
            range: r
        }, function(t, e, n) {
            var r = t[0];
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            t[1];
            0 !== r && (i++, n.done());
        }).next(function() {
            return i > 0;
        });
    }, /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId The target ID of the TargetData entry to look up.
     * @return The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.si = function(t, e) {
        var n = this;
        return $75536fd4bb2e2ab6$var$Ze(t).get(e).next(function(t) {
            return t ? n.serializer.mh(t) : null;
        });
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $75536fd4bb2e2ab6$var$Ze(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$Dn.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $75536fd4bb2e2ab6$var$tn(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$Sn.store);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $75536fd4bb2e2ab6$var$en(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$xn.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ var $75536fd4bb2e2ab6$var$nn = /** @class */ function() {
    function t(t) {
        this.Fh = t;
    }
    /** Decodes a remote document from storage locally to a Document. */ return t.prototype.jr = function(t) {
        if (t.document) return this.Fh.mi(t.document, !!t.hasCommittedMutations);
        if (t.noDocument) {
            var e = $75536fd4bb2e2ab6$var$_.st(t.noDocument.path), n = this.Nh(t.noDocument.readTime);
            return new $75536fd4bb2e2ab6$var$vt(e, n, {
                hasCommittedMutations: !!t.hasCommittedMutations
            });
        }
        if (t.unknownDocument) {
            var r = $75536fd4bb2e2ab6$var$_.st(t.unknownDocument.path), i = this.Nh(t.unknownDocument.version);
            return new $75536fd4bb2e2ab6$var$gt(r, i);
        }
        return $75536fd4bb2e2ab6$var$ge();
    }, /** Encodes a document for storage locally. */ t.prototype.sh = function(t, e) {
        var n = this.Wr(e), r = t.key.path.L().W();
        if (t instanceof $75536fd4bb2e2ab6$var$yt) {
            var i = this.Fh.Ai(t), o = t.hasCommittedMutations;
            return new $75536fd4bb2e2ab6$var$An(/* unknownDocument= */ null, /* noDocument= */ null, i, o, n, r);
        }
        if (t instanceof $75536fd4bb2e2ab6$var$vt) {
            var s = t.key.path.W(), u = this.$h(t.version), a = t.hasCommittedMutations;
            return new $75536fd4bb2e2ab6$var$An(/* unknownDocument= */ null, new $75536fd4bb2e2ab6$var$In(s, u), /* document= */ null, a, n, r);
        }
        if (t instanceof $75536fd4bb2e2ab6$var$gt) {
            var h = t.key.path.W(), c = this.$h(t.version);
            return new $75536fd4bb2e2ab6$var$An(new $75536fd4bb2e2ab6$var$Nn(h, c), /* noDocument= */ null, /* document= */ null, /* hasCommittedMutations= */ !0, n, r);
        }
        return $75536fd4bb2e2ab6$var$ge();
    }, t.prototype.Wr = function(t) {
        var e = t.C();
        return [
            e.seconds,
            e.nanoseconds
        ];
    }, t.prototype.zr = function(t) {
        var e = new $75536fd4bb2e2ab6$var$v(t[0], t[1]);
        return $75536fd4bb2e2ab6$var$g.v(e);
    }, t.prototype.$h = function(t) {
        var e = t.C();
        return new $75536fd4bb2e2ab6$var$wn(e.seconds, e.nanoseconds);
    }, t.prototype.Nh = function(t) {
        var e = new $75536fd4bb2e2ab6$var$v(t.seconds, t.nanoseconds);
        return $75536fd4bb2e2ab6$var$g.v(e);
    }, /** Encodes a batch of mutations into a DbMutationBatch for local storage. */ t.prototype.kh = function(t, e) {
        var n = this, r = e.baseMutations.map(function(t) {
            return n.Fh.vi(t);
        }), i = e.mutations.map(function(t) {
            return n.Fh.vi(t);
        });
        return new $75536fd4bb2e2ab6$var$_n(t, e.batchId, e.Tn.toMillis(), r, i);
    }, /** Decodes a DbMutationBatch into a MutationBatch */ t.prototype.Lh = function(t) {
        var e = this, n = (t.baseMutations || []).map(function(t) {
            return e.Fh.Fi(t);
        }), r = t.mutations.map(function(t) {
            return e.Fh.Fi(t);
        }), i = $75536fd4bb2e2ab6$var$v.fromMillis(t.localWriteTimeMs);
        return new $75536fd4bb2e2ab6$var$ke(t.batchId, i, n, r);
    }, /** Decodes a DbTarget into TargetData */ t.prototype.mh = function(t) {
        var e, n = this.Nh(t.readTime), r = void 0 !== t.lastLimboFreeSnapshotVersion ? this.Nh(t.lastLimboFreeSnapshotVersion) : $75536fd4bb2e2ab6$var$g.min();
        return e = void 0 !== t.query.documents ? this.Fh.xi(t.query) : this.Fh.Wi(t.query), new $75536fd4bb2e2ab6$var$Dt(e, t.targetId, 0 /* Listen */ , t.lastListenSequenceNumber, n, r, $75536fd4bb2e2ab6$var$A.fromBase64String(t.resumeToken));
    }, /** Encodes TargetData into a DbTarget for storage locally. */ t.prototype.Ph = function(t) {
        var e, n = this.$h(t.Ee), r = this.$h(t.lastLimboFreeSnapshotVersion);
        e = t.target.Ot() ? this.Fh.Oi(t.target) : this.Fh.Bi(t.target);
        // We can't store the resumeToken as a ByteString in IndexedDb, so we
        // convert it to a base64 string for storage.
        var i = t.resumeToken.toBase64();
        // lastListenSequenceNumber is always 0 until we do real GC.
        return new $75536fd4bb2e2ab6$var$Dn(t.targetId, t.target.canonicalId(), n, i, t.sequenceNumber, r, e);
    }, t;
}(), $75536fd4bb2e2ab6$var$rn = "Failed to obtain exclusive access to the persistence layer. To allow shared access, make sure to invoke `enablePersistence()` with `synchronizeTabs:true` in all tabs.", $75536fd4bb2e2ab6$var$on = /** @class */ function(t) {
    function n(e, n) {
        var r = this;
        return (r = t.call(this) || this).Mh = e, r.Oh = n, r;
    }
    return $8QG6t.__extends(n, t), n;
}($75536fd4bb2e2ab6$var$Le), $75536fd4bb2e2ab6$var$sn = /** @class */ function() {
    function t(e, n, r, i, o, s, u, a) {
        if (this.allowTabSynchronization = e, this.persistenceKey = n, this.clientId = r, this.Tr = s, this.xh = a, this.Bh = null, this.qh = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Uh = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Qh = null, /** The client metadata refresh task. */ this.Wh = null, /** The last time we garbage collected the client metadata object store. */ this.jh = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Kh = function(t) {
            return Promise.resolve();
        }, !t.Gh()) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        if (this.hh = new $75536fd4bb2e2ab6$var$hn(this, o), this.zh = n + t.Hh, this.serializer = new $75536fd4bb2e2ab6$var$nn(u), this.document = i.document, this.Yh = new $75536fd4bb2e2ab6$var$Xe(this.hh, this.serializer), this.jn = new $75536fd4bb2e2ab6$var$Ge, this.Qn = new $75536fd4bb2e2ab6$var$Qe(this.serializer, this.jn), !i.window || !i.window.localStorage) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        this.window = i.window, this.Jh = this.window.localStorage;
    }
    return t.Nr = function(t, e) {
        if (t instanceof $75536fd4bb2e2ab6$var$on) return $75536fd4bb2e2ab6$var$Pn.Nr(t.Mh, e);
        throw $75536fd4bb2e2ab6$var$ge();
    }, /**
     * Attempt to start IndexedDb persistence.
     *
     * @return {Promise<void>} Whether persistence was enabled.
     */ t.prototype.start = function() {
        var t = this;
        return $75536fd4bb2e2ab6$var$Pn.Xh(this.zh, $75536fd4bb2e2ab6$var$gn, new $75536fd4bb2e2ab6$var$mn(this.serializer)).then(function(e) {
            return t.Zh = e, t.to();
        }).then(function() {
            if (!t.isPrimary && !t.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, $75536fd4bb2e2ab6$var$rn);
            return t.eo(), t.so(), t.io(), t.runTransaction("getHighestListenSequenceNumber", "readonly", function(e) {
                return t.Yh.lh(e);
            });
        }).then(function(e) {
            t.Bh = new $75536fd4bb2e2ab6$var$Pe(e, t.xh);
        }).then(function() {
            t.qh = !0;
        }).catch(function(e) {
            return t.Zh && t.Zh.close(), Promise.reject(e);
        });
    }, /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.no = function(t) {
        var n = this;
        return this.Kh = function(r) {
            return $8QG6t.__awaiter(n, void 0, void 0, function() {
                return $8QG6t.__generator(this, function(e) {
                    return this.ro ? [
                        2 /*return*/ ,
                        t(r)
                    ] : [
                        2 /*return*/ 
                    ];
                });
            });
        }, t(this.isPrimary);
    }, /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.ho = function(t) {
        var n = this;
        this.Zh.oo(function(r) {
            return $8QG6t.__awaiter(n, void 0, void 0, function() {
                return $8QG6t.__generator(this, function(e) {
                    switch(e.label){
                        case 0:
                            return null === r.newVersion ? [
                                4 /*yield*/ ,
                                t()
                            ] : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            e.sent(), e.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.ao = function(t) {
        var n = this;
        this.networkEnabled !== t && (this.networkEnabled = t, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Tr.uo(function() {
            return $8QG6t.__awaiter(n, void 0, void 0, function() {
                return $8QG6t.__generator(this, function(t) {
                    switch(t.label){
                        case 0:
                            return this.ro ? [
                                4 /*yield*/ ,
                                this.to()
                            ] : [
                                3 /*break*/ ,
                                2
                            ];
                        case 1:
                            t.sent(), t.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }));
    }, /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ t.prototype.to = function() {
        var t = this;
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function(e) {
            return $75536fd4bb2e2ab6$var$an(e).put(new $75536fd4bb2e2ab6$var$On(t.clientId, Date.now(), t.networkEnabled, t.inForeground)).next(function() {
                if (t.isPrimary) return t.co(e).next(function(e) {
                    e || (t.isPrimary = !1, t.Tr.uo(function() {
                        return t.Kh(!1);
                    }));
                });
            }).next(function() {
                return t._o(e);
            }).next(function(n) {
                return t.isPrimary && !n ? t.lo(e).next(function() {
                    return !1;
                }) : !!n && t.do(e).next(function() {
                    return !0;
                });
            });
        }).catch(function(e) {
            if (!t.allowTabSynchronization) {
                if ($75536fd4bb2e2ab6$var$qn(e)) // Proceed with the existing state. Any subsequent access to
                // IndexedDB will verify the lease.
                return $75536fd4bb2e2ab6$var$de("IndexedDbPersistence", "Failed to extend owner lease: ", e), t.isPrimary;
                throw e;
            }
            return $75536fd4bb2e2ab6$var$de("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then(function(e) {
            t.isPrimary !== e && t.Tr.uo(function() {
                return t.Kh(e);
            }), t.isPrimary = e;
        });
    }, t.prototype.co = function(t) {
        var e = this;
        return $75536fd4bb2e2ab6$var$un(t).get($75536fd4bb2e2ab6$var$En.key).next(function(t) {
            return $75536fd4bb2e2ab6$var$xe.resolve(e.fo(t));
        });
    }, t.prototype.To = function(t) {
        return $75536fd4bb2e2ab6$var$an(t).delete(this.clientId);
    }, /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ t.prototype.Eo = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return !this.isPrimary || this.Io(this.jh, 18e5) ? [
                            3 /*break*/ ,
                            2
                        ] : (this.jh = Date.now(), [
                            4 /*yield*/ ,
                            this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function(e) {
                                var r = t.Nr(e, $75536fd4bb2e2ab6$var$On.store);
                                return r.Fr().next(function(t) {
                                    var e = n.wo(t, 18e5), i = t.filter(function(t) {
                                        return -1 === e.indexOf(t);
                                    });
                                    // Delete metadata for clients that are no longer considered active.
                                    return $75536fd4bb2e2ab6$var$xe.forEach(i, function(t) {
                                        return r.delete(t.clientId);
                                    }).next(function() {
                                        return i;
                                    });
                                });
                            }).catch(function() {
                                return [];
                            })
                        ]);
                    case 1:
                        // Delete potential leftover entries that may continue to mark the
                        // inactive clients as zombied in LocalStorage.
                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                        // the client atomically, but we can't. So we opt to delete the IndexedDb
                        // entries first to avoid potentially reviving a zombied client.
                        e.sent().forEach(function(t) {
                            n.window.localStorage.removeItem(n.Ro(t.clientId));
                        }), e.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ t.prototype.io = function() {
        var t = this;
        this.Wh = this.Tr.yr("client_metadata_refresh" /* ClientMetadataRefresh */ , 4e3, function() {
            return t.to().then(function() {
                return t.Eo();
            }).then(function() {
                return t.io();
            });
        });
    }, /** Checks whether `client` is the local client. */ t.prototype.fo = function(t) {
        return !!t && t.ownerId === this.clientId;
    }, /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ t.prototype._o = function(t) {
        var e = this;
        return $75536fd4bb2e2ab6$var$un(t).get($75536fd4bb2e2ab6$var$En.key).next(function(n) {
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            if (null !== n && e.Io(n.leaseTimestampMs, 5e3) && !e.Ao(n.ownerId)) {
                if (e.fo(n) && e.networkEnabled) return !0;
                if (!e.fo(n)) {
                    if (!n.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, $75536fd4bb2e2ab6$var$rn);
                    return !1;
                }
            }
            return !(!e.networkEnabled || !e.inForeground) || $75536fd4bb2e2ab6$var$an(t).Fr().next(function(t) {
                return void 0 === e.wo(t, 5e3).find(function(t) {
                    if (e.clientId !== t.clientId) {
                        var n = !e.networkEnabled && t.networkEnabled, r = !e.inForeground && t.inForeground, i = e.networkEnabled === t.networkEnabled;
                        if (n || r && i) return !0;
                    }
                    return !1;
                });
            });
        }).next(function(t) {
            return e.isPrimary !== t && $75536fd4bb2e2ab6$var$de("IndexedDbPersistence", "Client " + (t ? "is" : "is not") + " eligible for a primary lease."), t;
        });
    }, t.prototype.mo = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        return this.qh = !1, this.Po(), this.Wh && (this.Wh.cancel(), this.Wh = null), this.Vo(), this.po(), [
                            4 /*yield*/ ,
                            this.runTransaction("shutdown", "readwrite", function(e) {
                                return t.lo(e).next(function() {
                                    return t.To(e);
                                });
                            }).catch(function(t) {
                                $75536fd4bb2e2ab6$var$de("IndexedDbPersistence", "Proceeding with shutdown despite failure: ", t);
                            })
                        ];
                    case 1:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        return e.sent(), this.Zh.close(), // Remove the entry marking the client as zombied from LocalStorage since
                        // we successfully deleted its metadata from IndexedDb.
                        this.yo(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ t.prototype.wo = function(t, e) {
        var n = this;
        return t.filter(function(t) {
            return n.Io(t.updateTimeMs, e) && !n.Ao(t.clientId);
        });
    }, /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ t.prototype.bo = function() {
        var t = this;
        return this.runTransaction("getActiveClients", "readonly", function(e) {
            return $75536fd4bb2e2ab6$var$an(e).Fr().next(function(e) {
                return t.wo(e, 18e5).map(function(t) {
                    return t.clientId;
                });
            });
        });
    }, t.clearPersistence = function(n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return t.Gh() ? (r = n + t.Hh, [
                            4 /*yield*/ ,
                            $75536fd4bb2e2ab6$var$Pn.delete(r)
                        ]) : [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                    case 1:
                        return e.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, Object.defineProperty(t.prototype, "ro", {
        get: function() {
            return this.qh;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.vo = function(t) {
        return $75536fd4bb2e2ab6$var$fn.So(t, this.serializer, this.jn, this.hh);
    }, t.prototype.Do = function() {
        return this.Yh;
    }, t.prototype.Co = function() {
        return this.Qn;
    }, t.prototype.Fo = function() {
        return this.jn;
    }, t.prototype.runTransaction = function(t, e, n) {
        var r = this;
        $75536fd4bb2e2ab6$var$de("IndexedDbPersistence", "Starting transaction:", t);
        var i, o = "readonly" === e ? "readonly" : "readwrite";
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.Zh.runTransaction(o, $75536fd4bb2e2ab6$var$Vn, function(o) {
            return i = new $75536fd4bb2e2ab6$var$on(o, r.Bh ? r.Bh.next() : $75536fd4bb2e2ab6$var$Pe.dr), "readwrite-primary" === e ? r.co(i).next(function(t) {
                return !!t || r._o(i);
            }).next(function(e) {
                if (!e) throw $75536fd4bb2e2ab6$var$ye("Failed to obtain primary lease for action '" + t + "'."), r.isPrimary = !1, r.Tr.uo(function() {
                    return r.Kh(!1);
                }), new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, $75536fd4bb2e2ab6$var$Re);
                return n(i);
            }).next(function(t) {
                return r.do(i).next(function() {
                    return t;
                });
            }) : r.No(i).next(function() {
                return n(i);
            });
        }).then(function(t) {
            return i.Un(), t;
        });
    }, /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    t.prototype.No = function(t) {
        var e = this;
        return $75536fd4bb2e2ab6$var$un(t).get($75536fd4bb2e2ab6$var$En.key).next(function(t) {
            if (null !== t && e.Io(t.leaseTimestampMs, 5e3) && !e.Ao(t.ownerId) && !e.fo(t) && (!e.allowTabSynchronization || !t.allowTabSynchronization)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, $75536fd4bb2e2ab6$var$rn);
        });
    }, /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ t.prototype.do = function(t) {
        var e = new $75536fd4bb2e2ab6$var$En(this.clientId, this.allowTabSynchronization, Date.now());
        return $75536fd4bb2e2ab6$var$un(t).put($75536fd4bb2e2ab6$var$En.key, e);
    }, t.Gh = function() {
        return $75536fd4bb2e2ab6$var$Pn.Gh();
    }, /**
     * Generates a string used as a prefix when storing data in IndexedDB and
     * LocalStorage.
     */ t.$o = function(t) {
        // Use two different prefix formats:
        //   * firestore / persistenceKey / projectID . databaseID / ...
        //   * firestore / persistenceKey / projectID / ...
        // projectIDs are DNS-compatible names and cannot contain dots
        // so there's no danger of collisions.
        var e = t.ii.projectId;
        return t.ii.ln || (e += "." + t.ii.database), "firestore/" + t.persistenceKey + "/" + e + "/";
    }, /** Checks the primary lease and removes it if we are the current primary. */ t.prototype.lo = function(t) {
        var e = this, n = $75536fd4bb2e2ab6$var$un(t);
        return n.get($75536fd4bb2e2ab6$var$En.key).next(function(t) {
            return e.fo(t) ? ($75536fd4bb2e2ab6$var$de("IndexedDbPersistence", "Releasing primary lease."), n.delete($75536fd4bb2e2ab6$var$En.key)) : $75536fd4bb2e2ab6$var$xe.resolve();
        });
    }, /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ t.prototype.Io = function(t, e) {
        var n = Date.now();
        return !(t < n - e || t > n && ($75536fd4bb2e2ab6$var$ye("Detected an update time that is in the future: " + t + " > " + n), 1));
    }, t.prototype.eo = function() {
        var t = this;
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Qh = function() {
            t.Tr.uo(function() {
                return t.inForeground = "visible" === t.document.visibilityState, t.to();
            });
        }, this.document.addEventListener("visibilitychange", this.Qh), this.inForeground = "visible" === this.document.visibilityState);
    }, t.prototype.Vo = function() {
        this.Qh && (this.document.removeEventListener("visibilitychange", this.Qh), this.Qh = null);
    }, /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ t.prototype.so = function() {
        var t = this;
        "function" == typeof this.window.addEventListener && (this.Uh = function() {
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            t.Po(), t.Tr.uo(function() {
                return t.mo();
            });
        }, this.window.addEventListener("unload", this.Uh));
    }, t.prototype.po = function() {
        this.Uh && (this.window.removeEventListener("unload", this.Uh), this.Uh = null);
    }, /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ t.prototype.Ao = function(t) {
        try {
            var e = null !== this.Jh.getItem(this.Ro(t));
            return $75536fd4bb2e2ab6$var$de("IndexedDbPersistence", "Client '" + t + "' " + (e ? "is" : "is not") + " zombied in LocalStorage"), e;
        } catch (t) {
            // Gracefully handle if LocalStorage isn't working.
            return $75536fd4bb2e2ab6$var$ye("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
        }
    }, /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ t.prototype.Po = function() {
        try {
            this.Jh.setItem(this.Ro(this.clientId), String(Date.now()));
        } catch (t) {
            // Gracefully handle if LocalStorage isn't available / working.
            $75536fd4bb2e2ab6$var$ye("Failed to set zombie client id.", t);
        }
    }, /** Removes the zombied client entry if it exists. */ t.prototype.yo = function() {
        try {
            this.Jh.removeItem(this.Ro(this.clientId));
        } catch (t) {
        // Ignore
        }
    }, t.prototype.Ro = function(t) {
        return "firestore_zombie_" + this.persistenceKey + "_" + t;
    }, t;
}();
/**
 * A helper function for figuring out what kind of query has been stored.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The name of the main (and currently only) IndexedDB database. this name is
 * appended to the prefix provided to the IndexedDbPersistence constructor.
 */ /**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $75536fd4bb2e2ab6$var$un(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$En.store);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $75536fd4bb2e2ab6$var$an(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$On.store);
}
/** Provides LRU functionality for IndexedDB persistence. */ $75536fd4bb2e2ab6$var$sn.Hh = "main";
var $75536fd4bb2e2ab6$var$hn = /** @class */ function() {
    function t(t, e) {
        this.db = t, this.ko = new $75536fd4bb2e2ab6$var$Xn(this, e);
    }
    return t.prototype.Lo = function(t) {
        var e = this.Mo(t);
        return this.db.Do().Vh(t).next(function(t) {
            return e.next(function(e) {
                return t + e;
            });
        });
    }, t.prototype.Mo = function(t) {
        var e = 0;
        return this.Oo(t, function(t) {
            e++;
        }).next(function() {
            return e;
        });
    }, t.prototype.js = function(t, e) {
        return this.db.Do().js(t, e);
    }, t.prototype.Oo = function(t, e) {
        return this.xo(t, function(t, n) {
            return e(n);
        });
    }, t.prototype.yh = function(t, e, n) {
        return $75536fd4bb2e2ab6$var$cn(t, n);
    }, t.prototype.vh = function(t, e, n) {
        return $75536fd4bb2e2ab6$var$cn(t, n);
    }, t.prototype.Ah = function(t, e, n) {
        return this.db.Do().Ah(t, e, n);
    }, t.prototype.Bo = function(t, e) {
        return $75536fd4bb2e2ab6$var$cn(t, e);
    }, /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ t.prototype.qo = function(t, e) {
        /** Returns true if any mutation queue contains the given document. */ return function(t, e) {
            var n = !1;
            return $75536fd4bb2e2ab6$var$vn(t).Uo(function(r) {
                return $75536fd4bb2e2ab6$var$ln(t, r, e).next(function(t) {
                    return t && (n = !0), $75536fd4bb2e2ab6$var$xe.resolve(!t);
                });
            }).next(function() {
                return n;
            });
        }(t, e);
    }, t.prototype.Qo = function(t, e) {
        var n = this, r = this.db.Co().Yr(), i = [], o = 0;
        return this.xo(t, function(s, u) {
            if (u <= e) {
                var a = n.qo(t, s).next(function(e) {
                    if (!e) // Our size accounting requires us to read all documents before
                    // removing them.
                    return o++, r.Ln(t, s).next(function() {
                        return r.kn(s), $75536fd4bb2e2ab6$var$en(t).delete([
                            0,
                            $75536fd4bb2e2ab6$var$qe(s.path)
                        ]);
                    });
                });
                i.push(a);
            }
        }).next(function() {
            return $75536fd4bb2e2ab6$var$xe.vn(i);
        }).next(function() {
            return r.apply(t);
        }).next(function() {
            return o;
        });
    }, t.prototype.removeTarget = function(t, e) {
        var n = e.Ie(t.Oh);
        return this.db.Do().Ih(t, n);
    }, t.prototype.Wo = function(t, e) {
        return $75536fd4bb2e2ab6$var$cn(t, e);
    }, /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ t.prototype.xo = function(t, e) {
        var n, r = $75536fd4bb2e2ab6$var$en(t), i = $75536fd4bb2e2ab6$var$Pe.dr;
        return r.Ur({
            index: $75536fd4bb2e2ab6$var$xn.documentTargetsIndex
        }, function(t, r) {
            var o = t[0], s = (t[1], r.path), u = r.sequenceNumber;
            0 === o ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $75536fd4bb2e2ab6$var$Pe.dr && e(new $75536fd4bb2e2ab6$var$_($75536fd4bb2e2ab6$var$Fe(n)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = u, n = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $75536fd4bb2e2ab6$var$Pe.dr;
        }).next(function() {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $75536fd4bb2e2ab6$var$Pe.dr && e(new $75536fd4bb2e2ab6$var$_($75536fd4bb2e2ab6$var$Fe(n)), i);
        });
    }, t.prototype.jo = function(t) {
        return this.db.Co().Zr(t);
    }, t;
}();
function $75536fd4bb2e2ab6$var$cn(t, e) {
    return $75536fd4bb2e2ab6$var$en(t).put(/**
 * @return A value suitable for writing a sentinel row in the target-document
 * store.
 */ function(t, e) {
        return new $75536fd4bb2e2ab6$var$xn(0, $75536fd4bb2e2ab6$var$qe(t.path), e);
    }(e, t.Oh));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ var $75536fd4bb2e2ab6$var$fn = /** @class */ function() {
    function t(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ t, e, n, r) {
        this.userId = t, this.serializer = e, this.jn = n, this.hh = r, /**
             * Caches the document keys for pending mutation batches. If the mutation
             * has been removed from IndexedDb, the cached value may continue to
             * be used to retrieve the batch's document keys. To remove a cached value
             * locally, `removeCachedMutationKeys()` should be invoked either directly
             * or through `removeMutationBatches()`.
             *
             * With multi-tab, when the primary client acknowledges or rejects a mutation,
             * this cache is used by secondary clients to invalidate the local
             * view of the documents that were previously affected by the mutation.
             */ // PORTING NOTE: Multi-tab only.
        this.Ko = {};
    }
    return t.So = function(e, n, r, i) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        return $75536fd4bb2e2ab6$var$me("" !== e.uid), new t(e.t() ? e.uid : "", n, r, i);
    }, t.prototype.Go = function(t) {
        var e = !0, n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $75536fd4bb2e2ab6$var$dn(t).Ur({
            index: $75536fd4bb2e2ab6$var$_n.userMutationsIndex,
            range: n
        }, function(t, n, r) {
            e = !1, r.done();
        }).next(function() {
            return e;
        });
    }, t.prototype.zo = function(t, e, n) {
        return this.Ho(t).next(function(e) {
            // We can't store the resumeToken as a ByteString in IndexedDB, so we
            // convert it to a Base64 string for storage.
            return e.lastStreamToken = n.toBase64(), $75536fd4bb2e2ab6$var$vn(t).put(e);
        });
    }, t.prototype.Yo = function(t) {
        return this.Ho(t).next(function(t) {
            return $75536fd4bb2e2ab6$var$A.fromBase64String(t.lastStreamToken);
        });
    }, t.prototype.Jo = function(t, e) {
        return this.Ho(t).next(function(n) {
            // We can't store the resumeToken as a ByteString in IndexedDB, so we
            // convert it to a Base64 string for storage.
            return n.lastStreamToken = e.toBase64(), $75536fd4bb2e2ab6$var$vn(t).put(n);
        });
    }, t.prototype.Xo = function(t, e, n, r) {
        var i = this, o = $75536fd4bb2e2ab6$var$yn(t), s = $75536fd4bb2e2ab6$var$dn(t);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next(function(u) {
            $75536fd4bb2e2ab6$var$me("number" == typeof u);
            for(var a = new $75536fd4bb2e2ab6$var$ke(u, e, n, r), h = i.serializer.kh(i.userId, a), c = [], f = new $75536fd4bb2e2ab6$var$Pt(function(t, e) {
                return $75536fd4bb2e2ab6$var$be(t.j(), e.j());
            }), l = 0, p = r; l < p.length; l++){
                var d = p[l], y = $75536fd4bb2e2ab6$var$Tn.key(i.userId, d.key.path, u);
                f = f.add(d.key.path.L()), c.push(s.put(h)), c.push(o.put(y, $75536fd4bb2e2ab6$var$Tn.PLACEHOLDER));
            }
            return f.forEach(function(e) {
                c.push(i.jn.Dr(t, e));
            }), t.qn(function() {
                i.Ko[u] = a.keys();
            }), $75536fd4bb2e2ab6$var$xe.vn(c).next(function() {
                return a;
            });
        });
    }, t.prototype.Zo = function(t, e) {
        var n = this;
        return $75536fd4bb2e2ab6$var$dn(t).get(e).next(function(t) {
            return t ? ($75536fd4bb2e2ab6$var$me(t.userId === n.userId), n.serializer.Lh(t)) : null;
        });
    }, /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.ta = function(t, e) {
        var n = this;
        return this.Ko[e] ? $75536fd4bb2e2ab6$var$xe.resolve(this.Ko[e]) : this.Zo(t, e).next(function(t) {
            if (t) {
                var r = t.keys();
                return n.Ko[e] = r, r;
            }
            return null;
        });
    }, t.prototype.ea = function(t, e) {
        var n = this, r = e + 1, i = IDBKeyRange.lowerBound([
            this.userId,
            r
        ]), o = null;
        return $75536fd4bb2e2ab6$var$dn(t).Ur({
            index: $75536fd4bb2e2ab6$var$_n.userMutationsIndex,
            range: i
        }, function(t, e, i) {
            e.userId === n.userId && ($75536fd4bb2e2ab6$var$me(e.batchId >= r), o = n.serializer.Lh(e)), i.done();
        }).next(function() {
            return o;
        });
    }, t.prototype.sa = function(t) {
        var e = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]), n = -1;
        return $75536fd4bb2e2ab6$var$dn(t).Ur({
            index: $75536fd4bb2e2ab6$var$_n.userMutationsIndex,
            range: e,
            reverse: !0
        }, function(t, e, r) {
            n = e.batchId, r.done();
        }).next(function() {
            return n;
        });
    }, t.prototype.ia = function(t) {
        var e = this, n = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $75536fd4bb2e2ab6$var$dn(t).Fr($75536fd4bb2e2ab6$var$_n.userMutationsIndex, n).next(function(t) {
            return t.map(function(t) {
                return e.serializer.Lh(t);
            });
        });
    }, t.prototype.Gn = function(t, e) {
        var n = this, r = $75536fd4bb2e2ab6$var$Tn.prefixForPath(this.userId, e.path), i = IDBKeyRange.lowerBound(r), o = [];
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        return $75536fd4bb2e2ab6$var$yn(t).Ur({
            range: i
        }, function(r, i, s) {
            var u = r[0], a = r[1], h = r[2], c = $75536fd4bb2e2ab6$var$Fe(a);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (u === n.userId && e.path.isEqual(c)) // Look up the mutation batch in the store.
            return $75536fd4bb2e2ab6$var$dn(t).get(h).next(function(t) {
                if (!t) throw $75536fd4bb2e2ab6$var$ge();
                $75536fd4bb2e2ab6$var$me(t.userId === n.userId), o.push(n.serializer.Lh(t));
            });
            s.done();
        }).next(function() {
            return o;
        });
    }, t.prototype.Xn = function(t, e) {
        var n = this, r = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be), i = [];
        return e.forEach(function(e) {
            var o = $75536fd4bb2e2ab6$var$Tn.prefixForPath(n.userId, e.path), s = IDBKeyRange.lowerBound(o), u = $75536fd4bb2e2ab6$var$yn(t).Ur({
                range: s
            }, function(t, i, o) {
                var s = t[0], u = t[1], a = t[2], h = $75536fd4bb2e2ab6$var$Fe(u);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === n.userId && e.path.isEqual(h) ? r = r.add(a) : o.done();
            });
            i.push(u);
        }), $75536fd4bb2e2ab6$var$xe.vn(i).next(function() {
            return n.na(t, r);
        });
    }, t.prototype.nr = function(t, e) {
        var n = this, r = e.path, i = r.length + 1, o = $75536fd4bb2e2ab6$var$Tn.prefixForPath(this.userId, r), s = IDBKeyRange.lowerBound(o), u = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be);
        return $75536fd4bb2e2ab6$var$yn(t).Ur({
            range: s
        }, function(t, e, o) {
            var s = t[0], a = t[1], h = t[2], c = $75536fd4bb2e2ab6$var$Fe(a);
            s === n.userId && r.q(c) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            c.length === i && (u = u.add(h)) : o.done();
        }).next(function() {
            return n.na(t, u);
        });
    }, t.prototype.na = function(t, e) {
        var n = this, r = [], i = [];
        // TODO(rockwood): Implement this using iterate.
        return e.forEach(function(e) {
            i.push($75536fd4bb2e2ab6$var$dn(t).get(e).next(function(t) {
                if (null === t) throw $75536fd4bb2e2ab6$var$ge();
                $75536fd4bb2e2ab6$var$me(t.userId === n.userId), r.push(n.serializer.Lh(t));
            }));
        }), $75536fd4bb2e2ab6$var$xe.vn(i).next(function() {
            return r;
        });
    }, t.prototype.ra = function(t, e) {
        var n = this;
        return $75536fd4bb2e2ab6$var$pn(t.Mh, this.userId, e).next(function(r) {
            return t.qn(function() {
                n.ha(e.batchId);
            }), $75536fd4bb2e2ab6$var$xe.forEach(r, function(e) {
                return n.hh.Bo(t, e);
            });
        });
    }, /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    t.prototype.ha = function(t) {
        delete this.Ko[t];
    }, t.prototype.oa = function(t) {
        var e = this;
        return this.Go(t).next(function(n) {
            if (!n) return $75536fd4bb2e2ab6$var$xe.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var r = IDBKeyRange.lowerBound($75536fd4bb2e2ab6$var$Tn.prefixForUser(e.userId)), i = [];
            return $75536fd4bb2e2ab6$var$yn(t).Ur({
                range: r
            }, function(t, n, r) {
                if (t[0] === e.userId) {
                    var o = $75536fd4bb2e2ab6$var$Fe(t[1]);
                    i.push(o);
                } else r.done();
            }).next(function() {
                $75536fd4bb2e2ab6$var$me(0 === i.length);
            });
        });
    }, t.prototype.Ch = function(t, e) {
        return $75536fd4bb2e2ab6$var$ln(t, this.userId, e);
    }, // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ t.prototype.Ho = function(t) {
        var e = this;
        return $75536fd4bb2e2ab6$var$vn(t).get(this.userId).next(function(t) {
            return t || new $75536fd4bb2e2ab6$var$bn(e.userId, -1, /*lastStreamToken=*/ "");
        });
    }, t;
}();
/**
 * @return true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $75536fd4bb2e2ab6$var$ln(t, e, n) {
    var r = $75536fd4bb2e2ab6$var$Tn.prefixForPath(e, n.path), i = r[1], o = IDBKeyRange.lowerBound(r), s = !1;
    return $75536fd4bb2e2ab6$var$yn(t).Ur({
        range: o,
        Dh: !0
    }, function(t, n, r) {
        var o = t[0], u = t[1];
        t[2];
        o === e && u === i && (s = !0), r.done();
    }).next(function() {
        return s;
    });
}
function $75536fd4bb2e2ab6$var$pn(t, e, n) {
    var r = t.store($75536fd4bb2e2ab6$var$_n.store), i = t.store($75536fd4bb2e2ab6$var$Tn.store), o = [], s = IDBKeyRange.only(n.batchId), u = 0, a = r.Ur({
        range: s
    }, function(t, e, n) {
        return u++, n.delete();
    });
    o.push(a.next(function() {
        $75536fd4bb2e2ab6$var$me(1 === u);
    }));
    for(var h = [], c = 0, f = n.mutations; c < f.length; c++){
        var l = f[c], p = $75536fd4bb2e2ab6$var$Tn.key(e, l.key.path, n.batchId);
        o.push(i.delete(p)), h.push(l.key);
    }
    return $75536fd4bb2e2ab6$var$xe.vn(o).next(function() {
        return h;
    });
}
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $75536fd4bb2e2ab6$var$dn(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$_n.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $75536fd4bb2e2ab6$var$yn(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$Tn.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $75536fd4bb2e2ab6$var$vn(t) {
    return $75536fd4bb2e2ab6$var$sn.Nr(t, $75536fd4bb2e2ab6$var$bn.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 */ var $75536fd4bb2e2ab6$var$gn = 10, $75536fd4bb2e2ab6$var$mn = /** @class */ function() {
    function t(t) {
        this.serializer = t;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ return t.prototype.createOrUpgrade = function(t, e, n, r) {
        var i = this;
        $75536fd4bb2e2ab6$var$me(n < r && n >= 0 && r <= $75536fd4bb2e2ab6$var$gn);
        var o = new $75536fd4bb2e2ab6$var$Mn(e);
        n < 1 && r >= 1 && (function(t) {
            t.createObjectStore($75536fd4bb2e2ab6$var$En.store);
        }(t), function(t) {
            t.createObjectStore($75536fd4bb2e2ab6$var$bn.store, {
                keyPath: $75536fd4bb2e2ab6$var$bn.keyPath
            }), t.createObjectStore($75536fd4bb2e2ab6$var$_n.store, {
                keyPath: $75536fd4bb2e2ab6$var$_n.keyPath,
                autoIncrement: !0
            }).createIndex($75536fd4bb2e2ab6$var$_n.userMutationsIndex, $75536fd4bb2e2ab6$var$_n.userMutationsKeyPath, {
                unique: !0
            }), t.createObjectStore($75536fd4bb2e2ab6$var$Tn.store);
        }(t), $75536fd4bb2e2ab6$var$Ln(t), function(t) {
            t.createObjectStore($75536fd4bb2e2ab6$var$An.store);
        }(t));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        var s = $75536fd4bb2e2ab6$var$xe.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (function(t) {
            t.deleteObjectStore($75536fd4bb2e2ab6$var$xn.store), t.deleteObjectStore($75536fd4bb2e2ab6$var$Dn.store), t.deleteObjectStore($75536fd4bb2e2ab6$var$Sn.store);
        }(t), $75536fd4bb2e2ab6$var$Ln(t)), s = s.next(function() {
            /**
     * Creates the target global singleton row.
     *
     * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
     */ return function(t) {
                var e = t.store($75536fd4bb2e2ab6$var$Sn.store), n = new $75536fd4bb2e2ab6$var$Sn(/*highestTargetId=*/ 0, /*lastListenSequenceNumber=*/ 0, $75536fd4bb2e2ab6$var$g.min().C(), /*targetCount=*/ 0);
                return e.put($75536fd4bb2e2ab6$var$Sn.key, n);
            }(o);
        })), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(function() {
            return function(t, e) {
                return e.store($75536fd4bb2e2ab6$var$_n.store).Fr().next(function(n) {
                    t.deleteObjectStore($75536fd4bb2e2ab6$var$_n.store), t.createObjectStore($75536fd4bb2e2ab6$var$_n.store, {
                        keyPath: $75536fd4bb2e2ab6$var$_n.keyPath,
                        autoIncrement: !0
                    }).createIndex($75536fd4bb2e2ab6$var$_n.userMutationsIndex, $75536fd4bb2e2ab6$var$_n.userMutationsKeyPath, {
                        unique: !0
                    });
                    var r = e.store($75536fd4bb2e2ab6$var$_n.store), i = n.map(function(t) {
                        return r.put(t);
                    });
                    return $75536fd4bb2e2ab6$var$xe.vn(i);
                });
            }(t, o);
        })), s = s.next(function() {
            !function(t) {
                t.createObjectStore($75536fd4bb2e2ab6$var$On.store, {
                    keyPath: $75536fd4bb2e2ab6$var$On.keyPath
                });
            }(t);
        })), n < 5 && r >= 5 && (s = s.next(function() {
            return i.removeAcknowledgedMutations(o);
        })), n < 6 && r >= 6 && (s = s.next(function() {
            return function(t) {
                t.createObjectStore($75536fd4bb2e2ab6$var$kn.store);
            }(t), i.addDocumentGlobal(o);
        })), n < 7 && r >= 7 && (s = s.next(function() {
            return i.ensureSequenceNumbers(o);
        })), n < 8 && r >= 8 && (s = s.next(function() {
            return i.createCollectionParentIndex(t, o);
        })), n < 9 && r >= 9 && (s = s.next(function() {
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function(t) {
                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
            }(t), function(t) {
                var e = t.objectStore($75536fd4bb2e2ab6$var$An.store);
                e.createIndex($75536fd4bb2e2ab6$var$An.readTimeIndex, $75536fd4bb2e2ab6$var$An.readTimeIndexPath, {
                    unique: !1
                }), e.createIndex($75536fd4bb2e2ab6$var$An.collectionReadTimeIndex, $75536fd4bb2e2ab6$var$An.collectionReadTimeIndexPath, {
                    unique: !1
                });
            }(e);
        })), n < 10 && r >= 10 && (s = s.next(function() {
            return i.rewriteCanonicalIds(o);
        })), s;
    }, t.prototype.addDocumentGlobal = function(t) {
        var e = 0;
        return t.store($75536fd4bb2e2ab6$var$An.store).Ur(function(t, n) {
            e += $75536fd4bb2e2ab6$var$Je(n);
        }).next(function() {
            var n = new $75536fd4bb2e2ab6$var$kn(e);
            return t.store($75536fd4bb2e2ab6$var$kn.store).put($75536fd4bb2e2ab6$var$kn.key, n);
        });
    }, t.prototype.removeAcknowledgedMutations = function(t) {
        var e = this, n = t.store($75536fd4bb2e2ab6$var$bn.store), r = t.store($75536fd4bb2e2ab6$var$_n.store);
        return n.Fr().next(function(n) {
            return $75536fd4bb2e2ab6$var$xe.forEach(n, function(n) {
                var i = IDBKeyRange.bound([
                    n.userId,
                    -1
                ], [
                    n.userId,
                    n.lastAcknowledgedBatchId
                ]);
                return r.Fr($75536fd4bb2e2ab6$var$_n.userMutationsIndex, i).next(function(r) {
                    return $75536fd4bb2e2ab6$var$xe.forEach(r, function(r) {
                        $75536fd4bb2e2ab6$var$me(r.userId === n.userId);
                        var i = e.serializer.Lh(r);
                        return $75536fd4bb2e2ab6$var$pn(t, n.userId, i).next(function() {});
                    });
                });
            });
        });
    }, /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ t.prototype.ensureSequenceNumbers = function(t) {
        var e = t.store($75536fd4bb2e2ab6$var$xn.store), n = t.store($75536fd4bb2e2ab6$var$An.store);
        return t.store($75536fd4bb2e2ab6$var$Sn.store).get($75536fd4bb2e2ab6$var$Sn.key).next(function(t) {
            var r = [];
            return n.Ur(function(n, i) {
                var o = new $75536fd4bb2e2ab6$var$w(n), s = function(t) {
                    return [
                        0,
                        $75536fd4bb2e2ab6$var$qe(t)
                    ];
                }(o);
                r.push(e.get(s).next(function(n) {
                    return n ? $75536fd4bb2e2ab6$var$xe.resolve() : function(n) {
                        return e.put(new $75536fd4bb2e2ab6$var$xn(0, $75536fd4bb2e2ab6$var$qe(n), t.highestListenSequenceNumber));
                    }(o);
                }));
            }).next(function() {
                return $75536fd4bb2e2ab6$var$xe.vn(r);
            });
        });
    }, t.prototype.createCollectionParentIndex = function(t, e) {
        // Create the index.
        t.createObjectStore($75536fd4bb2e2ab6$var$Rn.store, {
            keyPath: $75536fd4bb2e2ab6$var$Rn.keyPath
        });
        var n = e.store($75536fd4bb2e2ab6$var$Rn.store), r = new $75536fd4bb2e2ab6$var$ze, i = function(t) {
            if (r.add(t)) {
                var e = t.O(), i = t.L();
                return n.put({
                    collectionId: e,
                    parent: $75536fd4bb2e2ab6$var$qe(i)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return e.store($75536fd4bb2e2ab6$var$An.store).Ur({
            Dh: !0
        }, function(t, e) {
            var n = new $75536fd4bb2e2ab6$var$w(t);
            return i(n.L());
        }).next(function() {
            return e.store($75536fd4bb2e2ab6$var$Tn.store).Ur({
                Dh: !0
            }, function(t, e) {
                t[0];
                var n = t[1], r = (t[2], $75536fd4bb2e2ab6$var$Fe(n));
                return i(r.L());
            });
        });
    }, t.prototype.rewriteCanonicalIds = function(t) {
        var e = this, n = t.store($75536fd4bb2e2ab6$var$Dn.store);
        return n.Ur(function(t, r) {
            var i = e.serializer.mh(r), o = e.serializer.Ph(i);
            return n.put(o);
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$wn = function(t, e) {
    this.seconds = t, this.nanoseconds = e;
}, $75536fd4bb2e2ab6$var$En = function(t, /** Whether to allow shared access from multiple tabs. */ e, n) {
    this.ownerId = t, this.allowTabSynchronization = e, this.leaseTimestampMs = n;
};
/** Performs database creation and schema upgrades. */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ $75536fd4bb2e2ab6$var$En.store = "owner", /**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */ $75536fd4bb2e2ab6$var$En.key = "owner";
var $75536fd4bb2e2ab6$var$bn = function(/**
     * The normalized user ID to which this queue belongs.
     */ t, /**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */ e, /**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     */ n) {
    this.userId = t, this.lastAcknowledgedBatchId = e, this.lastStreamToken = n;
};
/** Name of the IndexedDb object store.  */ $75536fd4bb2e2ab6$var$bn.store = "mutationQueues", /** Keys are automatically assigned via the userId property. */ $75536fd4bb2e2ab6$var$bn.keyPath = "userId";
/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */ var $75536fd4bb2e2ab6$var$_n = function(/**
     * The normalized user ID to which this batch belongs.
     */ t, /**
     * An identifier for this batch, allocated using an auto-generated key.
     */ e, /**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */ n, /**
     * A list of "mutations" that represent a partial base state from when this
     * write batch was initially created. During local application of the write
     * batch, these baseMutations are applied prior to the real writes in order
     * to override certain document fields from the remote document cache. This
     * is necessary in the case of non-idempotent writes (e.g. `increment()`
     * transforms) to make sure that the local view of the modified documents
     * doesn't flicker if the remote document cache receives the result of the
     * non-idempotent write before the write is removed from the queue.
     *
     * These mutations are never sent to the backend.
     */ r, /**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via JsonProtoSerializer.toMutation().
     */ i) {
    this.userId = t, this.batchId = e, this.localWriteTimeMs = n, this.baseMutations = r, this.mutations = i;
};
/** Name of the IndexedDb object store.  */ $75536fd4bb2e2ab6$var$_n.store = "mutations", /** Keys are automatically assigned via the userId, batchId properties. */ $75536fd4bb2e2ab6$var$_n.keyPath = "batchId", /** The index name for lookup of mutations by user. */ $75536fd4bb2e2ab6$var$_n.userMutationsIndex = "userMutationsIndex", /** The user mutations index is keyed by [userId, batchId] pairs. */ $75536fd4bb2e2ab6$var$_n.userMutationsKeyPath = [
    "userId",
    "batchId"
];
var $75536fd4bb2e2ab6$var$Tn = /** @class */ function() {
    function t() {}
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */ return t.prefixForUser = function(t) {
        return [
            t
        ];
    }, /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */ t.prefixForPath = function(t, e) {
        return [
            t,
            $75536fd4bb2e2ab6$var$qe(e)
        ];
    }, /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */ t.key = function(t, e, n) {
        return [
            t,
            $75536fd4bb2e2ab6$var$qe(e),
            n
        ];
    }, t;
}();
$75536fd4bb2e2ab6$var$Tn.store = "documentMutations", /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */ $75536fd4bb2e2ab6$var$Tn.PLACEHOLDER = new $75536fd4bb2e2ab6$var$Tn;
var $75536fd4bb2e2ab6$var$In = function(t, e) {
    this.path = t, this.readTime = e;
}, $75536fd4bb2e2ab6$var$Nn = function(t, e) {
    this.path = t, this.version = e;
}, $75536fd4bb2e2ab6$var$An = // TODO: We are currently storing full document keys almost three times
// (once as part of the primary key, once - partly - as `parentPath` and once
// inside the encoded documents). During our next migration, we should
// rewrite the primary key as parentPath + document ID which would allow us
// to drop one value.
function(/**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */ t, /**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */ e, /**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */ n, /**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */ r, /**
     * When the document was read from the backend. Undefined for data written
     * prior to schema version 9.
     */ i, /**
     * The path of the collection this document is part of. Undefined for data
     * written prior to schema version 9.
     */ o) {
    this.unknownDocument = t, this.noDocument = e, this.document = n, this.hasCommittedMutations = r, this.readTime = i, this.parentPath = o;
};
/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */ $75536fd4bb2e2ab6$var$An.store = "remoteDocuments", /**
     * An index that provides access to all entries sorted by read time (which
     * corresponds to the last modification time of each row).
     *
     * This index is used to provide a changelog for Multi-Tab.
     */ $75536fd4bb2e2ab6$var$An.readTimeIndex = "readTimeIndex", $75536fd4bb2e2ab6$var$An.readTimeIndexPath = "readTime", /**
     * An index that provides access to documents in a collection sorted by read
     * time.
     *
     * This index is used to allow the RemoteDocumentCache to fetch newly changed
     * documents in a collection.
     */ $75536fd4bb2e2ab6$var$An.collectionReadTimeIndex = "collectionReadTimeIndex", $75536fd4bb2e2ab6$var$An.collectionReadTimeIndexPath = [
    "parentPath",
    "readTime"
];
/**
 * Contains a single entry that has metadata about the remote document cache.
 */ var $75536fd4bb2e2ab6$var$kn = /**
     * @param byteSize Approximately the total size in bytes of all the documents in the document
     * cache.
     */ function(t) {
    this.byteSize = t;
};
$75536fd4bb2e2ab6$var$kn.store = "remoteDocumentGlobal", $75536fd4bb2e2ab6$var$kn.key = "remoteDocumentGlobalKey";
var $75536fd4bb2e2ab6$var$Dn = function(/**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */ t, /**
     * The canonical string representing this query. This is not unique.
     */ e, /**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */ n, /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */ r, /**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */ i, /**
     * Denotes the maximum snapshot version at which the associated query view
     * contained no limbo documents.  Undefined for data written prior to
     * schema version 9.
     */ o, /**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */ s) {
    this.targetId = t, this.canonicalId = e, this.readTime = n, this.resumeToken = r, this.lastListenSequenceNumber = i, this.lastLimboFreeSnapshotVersion = o, this.query = s;
};
$75536fd4bb2e2ab6$var$Dn.store = "targets", /** Keys are automatically assigned via the targetId property. */ $75536fd4bb2e2ab6$var$Dn.keyPath = "targetId", /** The name of the queryTargets index. */ $75536fd4bb2e2ab6$var$Dn.queryTargetsIndexName = "queryTargetsIndex", /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */ $75536fd4bb2e2ab6$var$Dn.queryTargetsKeyPath = [
    "canonicalId",
    "targetId"
];
/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */ var $75536fd4bb2e2ab6$var$xn = function(/**
     * The targetId identifying a target or 0 for a sentinel row.
     */ t, /**
     * The path to the document, as encoded in the key.
     */ e, /**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */ n) {
    this.targetId = t, this.path = e, this.sequenceNumber = n;
};
/** Name of the IndexedDb object store.  */ $75536fd4bb2e2ab6$var$xn.store = "targetDocuments", /** Keys are automatically assigned via the targetId, path properties. */ $75536fd4bb2e2ab6$var$xn.keyPath = [
    "targetId",
    "path"
], /** The index name for the reverse index. */ $75536fd4bb2e2ab6$var$xn.documentTargetsIndex = "documentTargetsIndex", /** We also need to create the reverse index for these properties. */ $75536fd4bb2e2ab6$var$xn.documentTargetsKeyPath = [
    "path",
    "targetId"
];
/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */ var $75536fd4bb2e2ab6$var$Sn = function(/**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */ t, /**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */ e, /**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */ n, /**
     * The number of targets persisted.
     */ r) {
    this.highestTargetId = t, this.highestListenSequenceNumber = e, this.lastRemoteSnapshotVersion = n, this.targetCount = r;
};
/**
 * The key string used for the single object that exists in the
 * DbTargetGlobal store.
 */ $75536fd4bb2e2ab6$var$Sn.key = "targetGlobalKey", $75536fd4bb2e2ab6$var$Sn.store = "targetGlobal";
/**
 * An object representing an association between a Collection id (e.g. 'messages')
 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
 * This is used to efficiently find all collections to query when performing
 * a Collection Group query.
 */ var $75536fd4bb2e2ab6$var$Rn = function(/**
     * The collectionId (e.g. 'messages')
     */ t, /**
     * The path to the parent (either a document location or an empty path for
     * a root-level collection).
     */ e) {
    this.collectionId = t, this.parent = e;
};
/** Name of the IndexedDb object store. */ function $75536fd4bb2e2ab6$var$Ln(t) {
    t.createObjectStore($75536fd4bb2e2ab6$var$xn.store, {
        keyPath: $75536fd4bb2e2ab6$var$xn.keyPath
    }).createIndex($75536fd4bb2e2ab6$var$xn.documentTargetsIndex, $75536fd4bb2e2ab6$var$xn.documentTargetsKeyPath, {
        unique: !0
    }), // NOTE: This is unique only because the TargetId is the suffix.
    t.createObjectStore($75536fd4bb2e2ab6$var$Dn.store, {
        keyPath: $75536fd4bb2e2ab6$var$Dn.keyPath
    }).createIndex($75536fd4bb2e2ab6$var$Dn.queryTargetsIndexName, $75536fd4bb2e2ab6$var$Dn.queryTargetsKeyPath, {
        unique: !0
    }), t.createObjectStore($75536fd4bb2e2ab6$var$Sn.store);
}
$75536fd4bb2e2ab6$var$Rn.store = "collectionParents", /** Keys are automatically assigned via the collectionId, parent properties. */ $75536fd4bb2e2ab6$var$Rn.keyPath = [
    "collectionId",
    "parent"
];
var $75536fd4bb2e2ab6$var$On = function(// Note: Previous schema versions included a field
// "lastProcessedDocumentChangeId". Don't use anymore.
/** The auto-generated client id assigned at client startup. */ t, /** The last time this state was updated. */ e, /** Whether the client's network connection is enabled. */ n, /** Whether this client is running in a foreground tab. */ r) {
    this.clientId = t, this.updateTimeMs = e, this.networkEnabled = n, this.inForeground = r;
};
/** Name of the IndexedDb object store. */ $75536fd4bb2e2ab6$var$On.store = "clientMetadata", /** Keys are automatically assigned via the clientId properties. */ $75536fd4bb2e2ab6$var$On.keyPath = "clientId";
var $75536fd4bb2e2ab6$var$Vn = $8QG6t.__spreadArrays($8QG6t.__spreadArrays($8QG6t.__spreadArrays([
    $75536fd4bb2e2ab6$var$bn.store,
    $75536fd4bb2e2ab6$var$_n.store,
    $75536fd4bb2e2ab6$var$Tn.store,
    $75536fd4bb2e2ab6$var$An.store,
    $75536fd4bb2e2ab6$var$Dn.store,
    $75536fd4bb2e2ab6$var$En.store,
    $75536fd4bb2e2ab6$var$Sn.store,
    $75536fd4bb2e2ab6$var$xn.store
], [
    $75536fd4bb2e2ab6$var$On.store
]), [
    $75536fd4bb2e2ab6$var$kn.store
]), [
    $75536fd4bb2e2ab6$var$Rn.store
]), $75536fd4bb2e2ab6$var$Pn = /** @class */ function() {
    function t(e) {
        this.db = e, // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === t.aa($epfVL.getUA()) && $75536fd4bb2e2ab6$var$ye("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    return t.Xh = function(e, n, r) {
        return $75536fd4bb2e2ab6$var$de("SimpleDb", "Opening database:", e), new $75536fd4bb2e2ab6$var$xe(function(i, o) {
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            var s = window.indexedDB.open(e, n);
            s.onsuccess = function(e) {
                var n = e.target.result;
                i(new t(n));
            }, s.onblocked = function() {
                o(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, s.onerror = function(t) {
                var e = t.target.error;
                "VersionError" === e.name ? o(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : o(e);
            }, s.onupgradeneeded = function(t) {
                $75536fd4bb2e2ab6$var$de("SimpleDb", 'Database "' + e + '" requires upgrade from version:', t.oldVersion);
                var n = t.target.result;
                r.createOrUpgrade(n, s.transaction, t.oldVersion, $75536fd4bb2e2ab6$var$gn).next(function() {
                    $75536fd4bb2e2ab6$var$de("SimpleDb", "Database upgrade to version " + $75536fd4bb2e2ab6$var$gn + " complete");
                });
            };
        }).yn();
    }, /** Deletes the specified database. */ t.delete = function(t) {
        return $75536fd4bb2e2ab6$var$de("SimpleDb", "Removing database:", t), $75536fd4bb2e2ab6$var$Fn(window.indexedDB.deleteDatabase(t)).yn();
    }, /** Returns true if IndexedDB is available in the current environment. */ t.Gh = function() {
        if ("undefined" == typeof window || null == window.indexedDB) return !1;
        if (t.ua()) return !0;
        // In some Node environments, `window` is defined, but `window.navigator` is
        // not. We don't support IndexedDB persistence in Node if the
        // isMockPersistence() check above returns false.
        if (void 0 === window.navigator) return !1;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        var e = $epfVL.getUA(), n = t.aa(e), r = 0 < n && n < 10, o = t.ca(e), s = 0 < o && o < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || r || s);
    }, /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ t.ua = function() {
        var t;
        return "undefined" != typeof __PRIVATE_process && "YES" === (null === (t = __PRIVATE_process.__PRIVATE_env) || void 0 === t ? void 0 : t._a);
    }, /** Helper to get a typed SimpleDbStore from a transaction. */ t.Nr = function(t, e) {
        return t.store(e);
    }, // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ t.aa = function(t) {
        var e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }, // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ t.ca = function(t) {
        var e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }, t.prototype.oo = function(t) {
        this.db.onversionchange = function(e) {
            return t(e);
        };
    }, t.prototype.runTransaction = function(t, n, r) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var i, o, s, u, a;
            return $8QG6t.__generator(this, function(h) {
                switch(h.label){
                    case 0:
                        i = "readonly" === t, o = 0, s = function() {
                            var t, s, a, h, c;
                            return $8QG6t.__generator(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        ++o, t = $75536fd4bb2e2ab6$var$Mn.open(u.db, i ? "readonly" : "readwrite", n), e.label = 1;
                                    case 1:
                                        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                        // fire), but still return the original transactionFnResult back to the
                                        // caller.
                                        return e.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]), s = r(t).catch(function(e) {
                                            // Abort the transaction if there was an error.
                                            return t.abort(e), $75536fd4bb2e2ab6$var$xe.reject(e);
                                        }).yn(), a = {}, s.catch(function() {}), [
                                            4 /*yield*/ ,
                                            t.la
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            (a.value = // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                            // fire), but still return the original transactionFnResult back to the
                                            // caller.
                                            (e.sent(), s), a)
                                        ];
                                    case 3:
                                        return h = e.sent(), c = "FirebaseError" !== h.name && o < 3, $75536fd4bb2e2ab6$var$de("SimpleDb", "Transaction failed with error: %s. Retrying: %s.", h.message, c), c ? [
                                            3 /*break*/ ,
                                            4
                                        ] : [
                                            2 /*return*/ ,
                                            {
                                                value: Promise.reject(h)
                                            }
                                        ];
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        }, u = this, h.label = 1;
                    case 1:
                        return [
                            5 /*yield**/ ,
                            s()
                        ];
                    case 2:
                        if ("object" == typeof (a = h.sent())) return [
                            2 /*return*/ ,
                            a.value
                        ];
                        h.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.close = function() {
        this.db.close();
    }, t;
}(), $75536fd4bb2e2ab6$var$Un = /** @class */ function() {
    function t(t) {
        this.da = t, this.fa = !1, this.Ta = null;
    }
    return Object.defineProperty(t.prototype, "Pn", {
        get: function() {
            return this.fa;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "Ea", {
        get: function() {
            return this.Ta;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "cursor", {
        set: function(t) {
            this.da = t;
        },
        enumerable: !0,
        configurable: !0
    }), /**
     * This function can be called to stop iteration at any point.
     */ t.prototype.done = function() {
        this.fa = !0;
    }, /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ t.prototype.Qr = function(t) {
        this.Ta = t;
    }, /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ t.prototype.delete = function() {
        return $75536fd4bb2e2ab6$var$Fn(this.da.delete());
    }, t;
}(), $75536fd4bb2e2ab6$var$Cn = /** @class */ function(t) {
    function n(e) {
        var n = this;
        return (n = t.call(this, $75536fd4bb2e2ab6$var$h.UNAVAILABLE, "IndexedDB transaction failed: " + e) || this).name = "IndexedDbTransactionError", n;
    }
    return $8QG6t.__extends(n, t), n;
}($75536fd4bb2e2ab6$var$c);
// V2 is no longer usable (see comment at top of file)
// Visible for testing
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ /** Verifies whether `e` is an IndexedDbTransactionError. */ function $75536fd4bb2e2ab6$var$qn(t) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === t.name;
}
/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ var $75536fd4bb2e2ab6$var$Mn = /** @class */ function() {
    function t(t) {
        var e = this;
        this.transaction = t, this.aborted = !1, /**
             * A promise that resolves with the result of the IndexedDb transaction.
             */ this.Ia = new $75536fd4bb2e2ab6$var$Ue, this.transaction.oncomplete = function() {
            e.Ia.resolve();
        }, this.transaction.onabort = function() {
            t.error ? e.Ia.reject(new $75536fd4bb2e2ab6$var$Cn(t.error)) : e.Ia.resolve();
        }, this.transaction.onerror = function(t) {
            var n = $75536fd4bb2e2ab6$var$zn(t.target.error);
            e.Ia.reject(new $75536fd4bb2e2ab6$var$Cn(n));
        };
    }
    return t.open = function(e, n, r) {
        return new t(e.transaction(r, n));
    }, Object.defineProperty(t.prototype, "la", {
        get: function() {
            return this.Ia.promise;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.abort = function(t) {
        t && this.Ia.reject(t), this.aborted || ($75536fd4bb2e2ab6$var$de("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }, /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ t.prototype.store = function(t) {
        var e = this.transaction.objectStore(t);
        return new $75536fd4bb2e2ab6$var$jn(e);
    }, t;
}(), $75536fd4bb2e2ab6$var$jn = /** @class */ function() {
    function t(t) {
        this.store = t;
    }
    return t.prototype.put = function(t, e) {
        var n;
        return void 0 !== e ? ($75536fd4bb2e2ab6$var$de("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : ($75536fd4bb2e2ab6$var$de("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), $75536fd4bb2e2ab6$var$Fn(n);
    }, /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value The object to write.
     * @return The key of the value to add.
     */ t.prototype.add = function(t) {
        return $75536fd4bb2e2ab6$var$de("SimpleDb", "ADD", this.store.name, t, t), $75536fd4bb2e2ab6$var$Fn(this.store.add(t));
    }, /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */ t.prototype.get = function(t) {
        var e = this;
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $75536fd4bb2e2ab6$var$Fn(this.store.get(t)).next(function(n) {
            // Normalize nonexistence to null.
            return void 0 === n && (n = null), $75536fd4bb2e2ab6$var$de("SimpleDb", "GET", e.store.name, t, n), n;
        });
    }, t.prototype.delete = function(t) {
        return $75536fd4bb2e2ab6$var$de("SimpleDb", "DELETE", this.store.name, t), $75536fd4bb2e2ab6$var$Fn(this.store.delete(t));
    }, /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ t.prototype.count = function() {
        return $75536fd4bb2e2ab6$var$de("SimpleDb", "COUNT", this.store.name), $75536fd4bb2e2ab6$var$Fn(this.store.count());
    }, t.prototype.Fr = function(t, e) {
        var n = this.cursor(this.options(t, e)), r = [];
        return this.wa(n, function(t, e) {
            r.push(e);
        }).next(function() {
            return r;
        });
    }, t.prototype.Ra = function(t, e) {
        $75536fd4bb2e2ab6$var$de("SimpleDb", "DELETE ALL", this.store.name);
        var n = this.options(t, e);
        n.Dh = !1;
        var r = this.cursor(n);
        return this.wa(r, function(t, e, n) {
            return n.delete();
        });
    }, t.prototype.Ur = function(t, e) {
        var n;
        e ? n = t : (n = {}, e = t);
        var r = this.cursor(n);
        return this.wa(r, e);
    }, /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ t.prototype.Uo = function(t) {
        var e = this.cursor({});
        return new $75536fd4bb2e2ab6$var$xe(function(n, r) {
            e.onerror = function(t) {
                var e = $75536fd4bb2e2ab6$var$zn(t.target.error);
                r(e);
            }, e.onsuccess = function(e) {
                var r = e.target.result;
                r ? t(r.primaryKey, r.value).next(function(t) {
                    t ? r.continue() : n();
                }) : n();
            };
        });
    }, t.prototype.wa = function(t, e) {
        var n = [];
        return new $75536fd4bb2e2ab6$var$xe(function(r, i) {
            t.onerror = function(t) {
                i(t.target.error);
            }, t.onsuccess = function(t) {
                var i = t.target.result;
                if (i) {
                    var o = new $75536fd4bb2e2ab6$var$Un(i), s = e(i.primaryKey, i.value, o);
                    if (s instanceof $75536fd4bb2e2ab6$var$xe) {
                        var u = s.catch(function(t) {
                            return o.done(), $75536fd4bb2e2ab6$var$xe.reject(t);
                        });
                        n.push(u);
                    }
                    o.Pn ? r() : null === o.Ea ? i.continue() : i.continue(o.Ea);
                } else r();
            };
        }).next(function() {
            return $75536fd4bb2e2ab6$var$xe.vn(n);
        });
    }, t.prototype.options = function(t, e) {
        var n = void 0;
        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
            index: n,
            range: e
        };
    }, t.prototype.cursor = function(t) {
        var e = "next";
        if (t.reverse && (e = "prev"), t.index) {
            var n = this.store.index(t.index);
            return t.Dh ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
        }
        return this.store.openCursor(t.range, e);
    }, t;
}();
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ /**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $75536fd4bb2e2ab6$var$Fn(t) {
    return new $75536fd4bb2e2ab6$var$xe(function(e, n) {
        t.onsuccess = function(t) {
            var n = t.target.result;
            e(n);
        }, t.onerror = function(t) {
            var e = $75536fd4bb2e2ab6$var$zn(t.target.error);
            n(e);
        };
    });
}
// Guard so we only report the error once.
var $75536fd4bb2e2ab6$var$Bn = !1;
function $75536fd4bb2e2ab6$var$zn(t) {
    var e = $75536fd4bb2e2ab6$var$Pn.aa($epfVL.getUA());
    if (e >= 12.2 && e < 13) {
        var n = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(n) >= 0) {
            // Wrap error in a more descriptive one.
            var r = new $75536fd4bb2e2ab6$var$c("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + n + "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
            return $75536fd4bb2e2ab6$var$Bn || ($75536fd4bb2e2ab6$var$Bn = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(function() {
                throw r;
            }, 0)), r;
        }
    }
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ var $75536fd4bb2e2ab6$var$Gn = /** @class */ function() {
    function t(t, e, n, r, i) {
        this.Aa = t, this.Er = e, this.ma = n, this.op = r, this.Pa = i, this.Va = new $75536fd4bb2e2ab6$var$Ue, this.then = this.Va.promise.then.bind(this.Va.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.Va.promise.catch(function(t) {});
    }
    return t.ga = function(e, n, r, i, o) {
        var s = new t(e, n, Date.now() + r, i, o);
        return s.start(r), s;
    }, /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ t.prototype.start = function(t) {
        var e = this;
        this.pa = setTimeout(function() {
            return e.ya();
        }, t);
    }, /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ t.prototype.vr = function() {
        return this.ya();
    }, /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ t.prototype.cancel = function(t) {
        null !== this.pa && (this.clearTimeout(), this.Va.reject(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }, t.prototype.ya = function() {
        var t = this;
        this.Aa.uo(function() {
            return null !== t.pa ? (t.clearTimeout(), t.op().then(function(e) {
                return t.Va.resolve(e);
            })) : Promise.resolve();
        });
    }, t.prototype.clearTimeout = function() {
        null !== this.pa && (this.Pa(this), clearTimeout(this.pa), this.pa = null);
    }, t;
}(), $75536fd4bb2e2ab6$var$Wn = /** @class */ function() {
    function t() {
        var t = this;
        // The last promise in the queue.
        this.ba = Promise.resolve(), // The last retryable operation. Retryable operation are run in order and
        // retried with backoff.
        this.va = Promise.resolve(), // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Sa = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.Da = [], // visible for testing
        this.Ca = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Fa = !1, // List of TimerIds to fast-forward delays for.
        this.Na = [], // Backoff timer used to schedule retries for retryable operations
        this.$a = new $75536fd4bb2e2ab6$var$Ce(this, "async_queue_retry" /* AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.ka = function() {
            return t.$a.br();
        };
        var e = $75536fd4bb2e2ab6$var$ce.nt().window;
        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.ka);
    }
    return Object.defineProperty(t.prototype, "La", {
        // Is this AsyncQueue being shut down? If true, this instance will not enqueue
        // any new operations, Promises from enqueue requests will not resolve.
        get: function() {
            return this.Sa;
        },
        enumerable: !0,
        configurable: !0
    }), /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ t.prototype.uo = function(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }, /**
     * Regardless if the queue has initialized shutdown, adds a new operation to the
     * queue without waiting for it to complete (i.e. we ignore the Promise result).
     */ t.prototype.Ma = function(t) {
        this.Oa(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.xa(t);
    }, /**
     * Regardless if the queue has initialized shutdown, adds a new operation to the
     * queue.
     */ t.prototype.Ba = function(t) {
        return this.Oa(), this.xa(t);
    }, /**
     * Adds a new operation to the queue and initialize the shut down of this queue.
     * Returns a promise that will be resolved when the promise returned by the new
     * operation is (with its value).
     * Once this method is called, the only possible way to request running an operation
     * is through `enqueueAndForgetEvenAfterShutdown`.
     */ t.prototype.qa = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.Oa(), this.Sa ? [
                            3 /*break*/ ,
                            2
                        ] : (this.Sa = !0, (n = $75536fd4bb2e2ab6$var$ce.nt().window) && n.removeEventListener("visibilitychange", this.ka), [
                            4 /*yield*/ ,
                            this.Ba(t)
                        ]);
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     */ t.prototype.enqueue = function(t) {
        return this.Oa(), this.Sa ? new Promise(function(t) {}) : this.xa(t);
    }, /**
     * Enqueue a retryable operation.
     *
     * A retryable operation is rescheduled with backoff if it fails with a
     * IndexedDbTransactionError (the error type used by SimpleDb). All
     * retryable operations are executed in order and only run if all prior
     * operations were retried successfully.
     */ t.prototype.Ua = function(t) {
        var n = this;
        this.Oa(), this.Sa || (this.va = this.va.then(function() {
            var r = new $75536fd4bb2e2ab6$var$Ue, i = function() {
                return $8QG6t.__awaiter(n, void 0, void 0, function() {
                    var n;
                    return $8QG6t.__generator(this, function(e) {
                        switch(e.label){
                            case 0:
                                return e.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]), [
                                    4 /*yield*/ ,
                                    t()
                                ];
                            case 1:
                                return e.sent(), r.resolve(), this.$a.reset(), [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                if (!$75536fd4bb2e2ab6$var$qn(n = e.sent())) throw r.resolve(), n;
                                // Failure will be handled by AsyncQueue
                                return $75536fd4bb2e2ab6$var$de("AsyncQueue", "Operation failed with retryable error: " + n), this.$a.gr(i), [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            return n.uo(i), r.promise;
        }));
    }, t.prototype.xa = function(t) {
        var e = this, n = this.ba.then(function() {
            return e.Fa = !0, t().catch(function(t) {
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw e.Ca = t, e.Fa = !1, $75536fd4bb2e2ab6$var$ye("INTERNAL UNHANDLED ERROR: ", t.stack || t.message || ""), t;
            }).then(function(t) {
                return e.Fa = !1, t;
            });
        });
        return this.ba = n, n;
    }, /**
     * Schedules an operation to be queued on the AsyncQueue once the specified
     * `delayMs` has elapsed. The returned DelayedOperation can be used to cancel
     * or fast-forward the operation prior to its running.
     */ t.prototype.yr = function(t, e, n) {
        var r = this;
        this.Oa(), // Fast-forward delays for timerIds that have been overriden.
        this.Na.indexOf(t) > -1 && (e = 0);
        var i = $75536fd4bb2e2ab6$var$Gn.ga(this, t, e, n, function(t) {
            return r.Qa(t);
        });
        return this.Da.push(i), i;
    }, t.prototype.Oa = function() {
        this.Ca && $75536fd4bb2e2ab6$var$ge();
    }, /**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */ t.prototype.Wa = function() {}, /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ t.prototype.ja = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            t = this.ba
                        ];
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        if (t !== this.ba) return [
                            3 /*break*/ ,
                            0
                        ];
                        e.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ t.prototype.Ka = function(t) {
        for(var e = 0, n = this.Da; e < n.length; e++){
            if (n[e].Er === t) return !0;
        }
        return !1;
    }, /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId Delayed operations up to and including this TimerId will
     *  be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ t.prototype.Ga = function(t) {
        var e = this;
        // Note that draining may generate more delayed ops, so we do that first.
        return this.ja().then(function() {
            // Run ops in the same order they'd run if they ran naturally.
            e.Da.sort(function(t, e) {
                return t.ma - e.ma;
            });
            for(var n = 0, r = e.Da; n < r.length; n++){
                var i = r[n];
                if (i.vr(), "all" /* All */  !== t && i.Er === t) break;
            }
            return e.ja();
        });
    }, /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ t.prototype.za = function(t) {
        this.Na.push(t);
    }, /** Called once a DelayedOperation is run or canceled. */ t.prototype.Qa = function(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        var e = this.Da.indexOf(t);
        this.Da.splice(e, 1);
    }, t;
}();
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $75536fd4bb2e2ab6$var$Qn(t, e) {
    if ($75536fd4bb2e2ab6$var$ye("AsyncQueue", e + ": " + t), $75536fd4bb2e2ab6$var$qn(t)) return new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNAVAILABLE, e + ": " + t);
    throw t;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $75536fd4bb2e2ab6$var$Kn(t, e) {
    var n = t[0], r = t[1], i = e[0], o = e[1], s = $75536fd4bb2e2ab6$var$be(n, i);
    return 0 === s ? $75536fd4bb2e2ab6$var$be(r, o) : s;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ var $75536fd4bb2e2ab6$var$Yn = /** @class */ function() {
    function t(t) {
        this.Ha = t, this.buffer = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$Kn), this.Ya = 0;
    }
    return t.prototype.Ja = function() {
        return ++this.Ya;
    }, t.prototype.Xa = function(t) {
        var e = [
            t,
            this.Ja()
        ];
        if (this.buffer.size < this.Ha) this.buffer = this.buffer.add(e);
        else {
            var n = this.buffer.last();
            $75536fd4bb2e2ab6$var$Kn(e, n) < 0 && (this.buffer = this.buffer.delete(n).add(e));
        }
    }, Object.defineProperty(t.prototype, "maxValue", {
        get: function() {
            // Guaranteed to be non-empty. If we decide we are not collecting any
            // sequence numbers, nthSequenceNumber below short-circuits. If we have
            // decided that we are collecting n sequence numbers, it's because n is some
            // percentage of the existing sequence numbers. That means we should never
            // be in a situation where we are collecting sequence numbers but don't
            // actually have any.
            return this.buffer.last()[0];
        },
        enumerable: !0,
        configurable: !0
    }), t;
}(), $75536fd4bb2e2ab6$var$$n = {
    Za: !1,
    tu: 0,
    eu: 0,
    su: 0
}, $75536fd4bb2e2ab6$var$Jn = /** @class */ function() {
    function t(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    t, // The percentage of sequence numbers that we will attempt to collect
    e, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n) {
        this.iu = t, this.nu = e, this.ru = n;
    }
    return t.hu = function(e) {
        return new t(e, t.ou, t.au);
    }, t;
}();
$75536fd4bb2e2ab6$var$Jn.uu = -1, $75536fd4bb2e2ab6$var$Jn.cu = 1048576, $75536fd4bb2e2ab6$var$Jn._u = 41943040, $75536fd4bb2e2ab6$var$Jn.ou = 10, $75536fd4bb2e2ab6$var$Jn.au = 1e3, $75536fd4bb2e2ab6$var$Jn.lu = new $75536fd4bb2e2ab6$var$Jn($75536fd4bb2e2ab6$var$Jn._u, $75536fd4bb2e2ab6$var$Jn.ou, $75536fd4bb2e2ab6$var$Jn.au), $75536fd4bb2e2ab6$var$Jn.DISABLED = new $75536fd4bb2e2ab6$var$Jn($75536fd4bb2e2ab6$var$Jn.uu, 0, 0);
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ var $75536fd4bb2e2ab6$var$Hn = /** @class */ function() {
    function t(t, e) {
        this.ko = t, this.Aa = e, this.du = !1, this.fu = null;
    }
    return t.prototype.start = function(t) {
        this.ko.Tu.iu !== $75536fd4bb2e2ab6$var$Jn.uu && this.Eu(t);
    }, t.prototype.stop = function() {
        this.fu && (this.fu.cancel(), this.fu = null);
    }, Object.defineProperty(t.prototype, "ro", {
        get: function() {
            return null !== this.fu;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.Eu = function(t) {
        var n = this, r = this.du ? 3e5 : 6e4;
        $75536fd4bb2e2ab6$var$de("LruGarbageCollector", "Garbage collection scheduled in " + r + "ms"), this.fu = this.Aa.yr("lru_garbage_collection" /* LruGarbageCollection */ , r, function() {
            return $8QG6t.__awaiter(n, void 0, void 0, function() {
                var n;
                return $8QG6t.__generator(this, function(e) {
                    switch(e.label){
                        case 0:
                            this.fu = null, this.du = !0, e.label = 1;
                        case 1:
                            return e.trys.push([
                                1,
                                3,
                                ,
                                7
                            ]), [
                                4 /*yield*/ ,
                                t.Iu(this.ko)
                            ];
                        case 2:
                            return e.sent(), [
                                3 /*break*/ ,
                                7
                            ];
                        case 3:
                            return $75536fd4bb2e2ab6$var$qn(n = e.sent()) ? ($75536fd4bb2e2ab6$var$de("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", n), [
                                3 /*break*/ ,
                                6
                            ]) : [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                $75536fd4bb2e2ab6$var$er(n)
                            ];
                        case 5:
                            e.sent(), e.label = 6;
                        case 6:
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                4 /*yield*/ ,
                                this.Eu(t)
                            ];
                        case 8:
                            return e.sent(), [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$Xn = /** @class */ function() {
    function t(t, e) {
        this.wu = t, this.Tu = e;
    }
    return t.prototype.Ru = function(t, e) {
        return this.wu.Lo(t).next(function(t) {
            return Math.floor(e / 100 * t);
        });
    }, /** Returns the nth sequence number, counting in order from the smallest. */ t.prototype.Au = function(t, e) {
        var n = this;
        if (0 === e) return $75536fd4bb2e2ab6$var$xe.resolve($75536fd4bb2e2ab6$var$Pe.dr);
        var r = new $75536fd4bb2e2ab6$var$Yn(e);
        return this.wu.js(t, function(t) {
            return r.Xa(t.sequenceNumber);
        }).next(function() {
            return n.wu.Oo(t, function(t) {
                return r.Xa(t);
            });
        }).next(function() {
            return r.maxValue;
        });
    }, /**
     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
     * document associations with those targets.
     */ t.prototype.Ah = function(t, e, n) {
        return this.wu.Ah(t, e, n);
    }, /**
     * Removes documents that have a sequence number equal to or less than the upper bound and are not
     * otherwise pinned.
     */ t.prototype.Qo = function(t, e) {
        return this.wu.Qo(t, e);
    }, t.prototype.mu = function(t, e) {
        var n = this;
        return this.Tu.iu === $75536fd4bb2e2ab6$var$Jn.uu ? ($75536fd4bb2e2ab6$var$de("LruGarbageCollector", "Garbage collection skipped; disabled"), $75536fd4bb2e2ab6$var$xe.resolve($75536fd4bb2e2ab6$var$$n)) : this.jo(t).next(function(r) {
            return r < n.Tu.iu ? ($75536fd4bb2e2ab6$var$de("LruGarbageCollector", "Garbage collection skipped; Cache size " + r + " is lower than threshold " + n.Tu.iu), $75536fd4bb2e2ab6$var$$n) : n.Pu(t, e);
        });
    }, t.prototype.jo = function(t) {
        return this.wu.jo(t);
    }, t.prototype.Pu = function(t, e) {
        var n, i, o, s, u, a, h, c = this, f = Date.now();
        return this.Ru(t, this.Tu.nu).next(function(e) {
            // Cap at the configured max
            return e > c.Tu.ru ? ($75536fd4bb2e2ab6$var$de("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of " + c.Tu.ru + " from " + e), i = c.Tu.ru) : i = e, s = Date.now(), c.Au(t, i);
        }).next(function(r) {
            return n = r, u = Date.now(), c.Ah(t, n, e);
        }).next(function(e) {
            return o = e, a = Date.now(), c.Qo(t, n);
        }).next(function(t) {
            return h = Date.now(), $75536fd4bb2e2ab6$var$le() <= $ctGiR.LogLevel.DEBUG && $75536fd4bb2e2ab6$var$de("LruGarbageCollector", "LRU Garbage Collection\n\tCounted targets in " + (s - f) + "ms\n\tDetermined least recently used " + i + " in " + (u - s) + "ms\n\tRemoved " + o + " targets in " + (a - u) + "ms\n\tRemoved " + t + " documents in " + (h - a) + "ms\nTotal Duration: " + (h - f) + "ms"), $75536fd4bb2e2ab6$var$xe.resolve({
                Za: !0,
                tu: i,
                eu: o,
                su: t
            });
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$Zn = /** @class */ function() {
    function t(/** Manages our in-memory or durable persistence. */ t, e, n) {
        this.persistence = t, this.Vu = e, /**
             * Maps a targetID to data about its target.
             *
             * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
             * of `applyRemoteEvent()` idempotent.
             */ this.gu = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$be), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.pu = new $75536fd4bb2e2ab6$var$Ae(function(t) {
            return t.canonicalId();
        }), /**
             * The read time of the last entry processed by `getNewDocumentChanges()`.
             *
             * PORTING NOTE: This is only used for multi-tab synchronization.
             */ this.yu = $75536fd4bb2e2ab6$var$g.min(), this.Wn = t.vo(n), this.bu = t.Co(), this.Yh = t.Do(), this.vu = new $75536fd4bb2e2ab6$var$Oe(this.bu, this.Wn, this.persistence.Fo()), this.Vu.Su(this.vu);
    }
    return t.prototype.start = function() {
        return Promise.resolve();
    }, /**
     * Tells the LocalStore that the currently authenticated user has changed.
     *
     * In response the local store switches the mutation queue to the new user and
     * returns any resulting document changes.
     */ // PORTING NOTE: Android and iOS only return the documents affected by the
    // change.
    t.prototype.Du = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return n = this.Wn, r = this.vu, [
                            4 /*yield*/ ,
                            this.persistence.runTransaction("Handle user change", "readonly", function(e) {
                                // Swap out the mutation queue, grabbing the pending mutation batches
                                // before and after.
                                var i;
                                return o.Wn.ia(e).next(function(s) {
                                    return i = s, n = o.persistence.vo(t), // Recreate our LocalDocumentsView using the new
                                    // MutationQueue.
                                    r = new $75536fd4bb2e2ab6$var$Oe(o.bu, n, o.persistence.Fo()), n.ia(e);
                                }).next(function(t) {
                                    for(var n = [], o = [], s = $75536fd4bb2e2ab6$var$Wt(), u = 0, a = i; u < a.length; u++){
                                        var h = a[u];
                                        n.push(h.batchId);
                                        for(var c = 0, f = h.mutations; c < f.length; c++){
                                            var l = f[c];
                                            s = s.add(l.key);
                                        }
                                    }
                                    for(var p = 0, d = t; p < d.length; p++){
                                        var y = d[p];
                                        o.push(y.batchId);
                                        for(var v = 0, g = y.mutations; v < g.length; v++){
                                            var m = g[v];
                                            s = s.add(m.key);
                                        }
                                    }
                                    // Return the set of all (potentially) changed documents and the list
                                    // of mutation batch IDs that were affected by change.
                                    return r.Yn(e, s).next(function(t) {
                                        return {
                                            Cu: t,
                                            Fu: n,
                                            Nu: o
                                        };
                                    });
                                });
                            })
                        ];
                    case 1:
                        return i = e.sent(), [
                            2 /*return*/ ,
                            (this.Wn = n, this.vu = r, this.Vu.Su(this.vu), i)
                        ];
                }
            });
        });
    }, /* Accept locally generated Mutations and commit them to storage. */ t.prototype.$u = function(t) {
        var e, n = this, r = $75536fd4bb2e2ab6$var$v.now(), i = t.reduce(function(t, e) {
            return t.add(e.key);
        }, $75536fd4bb2e2ab6$var$Wt());
        return this.persistence.runTransaction("Locally write mutations", "readwrite", function(o) {
            return n.vu.Yn(o, i).next(function(i) {
                e = i;
                for(// For non-idempotent mutations (such as `FieldValue.increment()`),
                // we record the base state in a separate patch mutation. This is
                // later used to guarantee consistent values and prevents flicker
                // even if the backend sends us an update that already includes our
                // transform.
                var s = [], u = 0, a = t; u < a.length; u++){
                    var h = a[u], c = h.Pt(e.get(h.key));
                    null != c && // NOTE: The base state should only be applied if there's some
                    // existing document to override, so use a Precondition of
                    // exists=true
                    s.push(new $75536fd4bb2e2ab6$var$ot(h.key, c, $75536fd4bb2e2ab6$var$ft(c.proto.mapValue), $75536fd4bb2e2ab6$var$nt.exists(!0)));
                }
                return n.Wn.Xo(o, r, s, t);
            });
        }).then(function(t) {
            var n = t.In(e);
            return {
                batchId: t.batchId,
                Dn: n
            };
        });
    }, /**
     * Acknowledge the given batch.
     *
     * On the happy path when a batch is acknowledged, the local store will
     *
     *  + remove the batch from the mutation queue;
     *  + apply the changes to the remote document cache;
     *  + recalculate the latency compensated view implied by those changes (there
     *    may be mutations in the queue that affect the documents but haven't been
     *    acknowledged yet); and
     *  + give the changed documents back the sync engine
     *
     * @returns The resulting (modified) documents.
     */ t.prototype.zo = function(t) {
        var e = this;
        return this.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function(n) {
            var r = t.batch.keys(), i = e.bu.Yr({
                Xr: !0
            });
            return e.Wn.zo(n, t.batch, t.streamToken).next(function() {
                return e.ku(n, t, i);
            }).next(function() {
                return i.apply(n);
            }).next(function() {
                return e.Wn.oa(n);
            }).next(function() {
                return e.vu.Yn(n, r);
            });
        });
    }, /**
     * Remove mutations from the MutationQueue for the specified batch;
     * LocalDocuments will be recalculated.
     *
     * @returns The resulting modified documents.
     */ t.prototype.Lu = function(t) {
        var e = this;
        return this.persistence.runTransaction("Reject batch", "readwrite-primary", function(n) {
            var r;
            return e.Wn.Zo(n, t).next(function(t) {
                return $75536fd4bb2e2ab6$var$me(null !== t), r = t.keys(), e.Wn.ra(n, t);
            }).next(function() {
                return e.Wn.oa(n);
            }).next(function() {
                return e.vu.Yn(n, r);
            });
        });
    }, /**
     * Returns the largest (latest) batch id in mutation queue that is pending server response.
     * Returns `BATCHID_UNKNOWN` if the queue is empty.
     */ t.prototype.sa = function() {
        var t = this;
        return this.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function(e) {
            return t.Wn.sa(e);
        });
    }, /** Returns the last recorded stream token for the current user. */ t.prototype.Yo = function() {
        var t = this;
        return this.persistence.runTransaction("Get last stream token", "readonly", function(e) {
            return t.Wn.Yo(e);
        });
    }, /**
     * Sets the stream token for the current user without acknowledging any
     * mutation batch. This is usually only useful after a stream handshake or in
     * response to an error that requires clearing the stream token.
     */ t.prototype.Jo = function(t) {
        var e = this;
        return this.persistence.runTransaction("Set last stream token", "readwrite-primary", function(n) {
            return e.Wn.Jo(n, t);
        });
    }, /**
     * Returns the last consistent snapshot processed (used by the RemoteStore to
     * determine whether to buffer incoming snapshots from the backend).
     */ t.prototype._h = function() {
        var t = this;
        return this.persistence.runTransaction("Get last remote snapshot version", "readonly", function(e) {
            return t.Yh._h(e);
        });
    }, /**
     * Update the "ground-state" (remote) documents. We assume that the remote
     * event reflects any write batches that have been acknowledged or rejected
     * (i.e. we do not re-apply local mutations to updates from this event).
     *
     * LocalDocuments are re-calculated if there are remaining mutations in the
     * queue.
     */ t.prototype.Mu = function(e) {
        var n = this, r = e.Ee, i = this.gu;
        return this.persistence.runTransaction("Apply remote event", "readwrite-primary", function(o) {
            var s = n.bu.Yr({
                Xr: !0
            });
            // Reset newTargetDataByTargetMap in case this transaction gets re-run.
            i = n.gu;
            var u = [];
            e.as.forEach(function(e, s) {
                var a = i.get(s);
                if (a) {
                    // Only update the remote keys if the target is still active. This
                    // ensures that we can persist the updated target data along with
                    // the updated assignment.
                    u.push(n.Yh.bh(o, e.Is, s).next(function() {
                        return n.Yh.ph(o, e.Ts, s);
                    }));
                    var h = e.resumeToken;
                    // Update the resume token if the change includes one.
                    if (h.rt() > 0) {
                        var c = a.we(h, r).Ie(o.Oh);
                        i = i.Ae(s, c), // Update the target data if there are target changes (or if
                        // sufficient time has passed since the last update).
                        t.Ou(a, c, e) && u.push(n.Yh.Ih(o, c));
                    }
                }
            });
            var a = $75536fd4bb2e2ab6$var$qt(), h = $75536fd4bb2e2ab6$var$Wt();
            // HACK: The only reason we allow a null snapshot version is so that we
            // can synthesize remote events when we get permission denied errors while
            // trying to resolve the state of a locally cached document that is in
            // limbo.
            if (e.cs.forEach(function(t, e) {
                h = h.add(t);
            }), // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
            // documents in advance in a single call.
            u.push(s.getEntries(o, h).next(function(t) {
                e.cs.forEach(function(i, h) {
                    var c = t.get(i);
                    // Note: The order of the steps below is important, since we want
                    // to ensure that rejected limbo resolutions (which fabricate
                    // NoDocuments with SnapshotVersion.min()) never add documents to
                    // cache.
                    h instanceof $75536fd4bb2e2ab6$var$vt && h.version.isEqual($75536fd4bb2e2ab6$var$g.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
                    // events. We remove these documents from cache since we lost
                    // access.
                    (s.kn(i, r), a = a.Ae(i, h)) : null == c || h.version.S(c.version) > 0 || 0 === h.version.S(c.version) && c.hasPendingWrites ? (s.Nn(h, r), a = a.Ae(i, h)) : $75536fd4bb2e2ab6$var$de("LocalStore", "Ignoring outdated watch update for ", i, ". Current version:", c.version, " Watch version:", h.version), e._s.has(i) && u.push(n.persistence.hh.Wo(o, i));
                });
            })), !r.isEqual($75536fd4bb2e2ab6$var$g.min())) {
                var c = n.Yh._h(o).next(function(t) {
                    return n.Yh.dh(o, o.Oh, r);
                });
                u.push(c);
            }
            return $75536fd4bb2e2ab6$var$xe.vn(u).next(function() {
                return s.apply(o);
            }).next(function() {
                return n.vu.Jn(o, a);
            });
        }).then(function(t) {
            return n.gu = i, t;
        });
    }, /**
     * Returns true if the newTargetData should be persisted during an update of
     * an active target. TargetData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, TargetData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */ t.Ou = function(t, e, n) {
        // Always persist target data if we don't already have a resume token.
        return $75536fd4bb2e2ab6$var$me(e.resumeToken.rt() > 0), 0 === t.resumeToken.rt() || e.Ee.D() - t.Ee.D() >= this.xu || n.Ts.size + n.Es.size + n.Is.size > 0;
    // Don't allow resume token changes to be buffered indefinitely. This
    // allows us to be reasonably up-to-date after a crash and avoids needing
    // to loop over all active queries on shutdown. Especially in the browser
    // we may not get time to do anything interesting while the current tab is
    // closing.
    }, /**
     * Notify local store of the changed views to locally pin documents.
     */ t.prototype.Bu = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o, s, u, a, h, c = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return e.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]), [
                            4 /*yield*/ ,
                            this.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function(e) {
                                return $75536fd4bb2e2ab6$var$xe.forEach(t, function(t) {
                                    return $75536fd4bb2e2ab6$var$xe.forEach(t.hr, function(n) {
                                        return c.persistence.hh.yh(e, t.targetId, n);
                                    }).next(function() {
                                        return $75536fd4bb2e2ab6$var$xe.forEach(t.or, function(n) {
                                            return c.persistence.hh.vh(e, t.targetId, n);
                                        });
                                    });
                                });
                            })
                        ];
                    case 1:
                        return e.sent(), [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (!$75536fd4bb2e2ab6$var$qn(n = e.sent())) throw n;
                        // If `notifyLocalViewChanges` fails, we did not advance the sequence
                        // number for the documents that were included in this transaction.
                        // This might trigger them to be deleted earlier than they otherwise
                        // would have, but it should not invalidate the integrity of the data.
                        return $75536fd4bb2e2ab6$var$de("LocalStore", "Failed to update sequence numbers: " + n), [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        for(r = 0, i = t; r < i.length; r++)o = i[r], s = o.targetId, o.fromCache || (u = this.gu.get(s), a = u.Ee, h = u.Re(a), // Advance the last limbo free snapshot version
                        this.gu = this.gu.Ae(s, h));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Gets the mutation batch after the passed in batchId in the mutation queue
     * or null if empty.
     * @param afterBatchId If provided, the batch to search after.
     * @returns The next mutation or null if there wasn't one.
     */ t.prototype.qu = function(t) {
        var e = this;
        return this.persistence.runTransaction("Get next mutation batch", "readonly", function(n) {
            return void 0 === t && (t = -1), e.Wn.ea(n, t);
        });
    }, /**
     * Read the current value of a Document with a given key or null if not
     * found - used for testing.
     */ t.prototype.Uu = function(t) {
        var e = this;
        return this.persistence.runTransaction("read document", "readonly", function(n) {
            return e.vu.Kn(n, t);
        });
    }, /**
     * Assigns the given target an internal ID so that its results can be pinned so
     * they don't get GC'd. A target must be allocated in the local store before
     * the store can be used to manage its view.
     *
     * Allocating an already allocated `Target` will return the existing `TargetData`
     * for that `Target`.
     */ t.prototype.Qu = function(t) {
        var e = this;
        return this.persistence.runTransaction("Allocate target", "readwrite", function(n) {
            var r;
            return e.Yh.gh(n, t).next(function(i) {
                return i ? // This target has been listened to previously, so reuse the
                // previous targetID.
                // TODO(mcg): freshen last accessed date?
                (r = i, $75536fd4bb2e2ab6$var$xe.resolve(r)) : e.Yh.oh(n).next(function(i) {
                    return r = new $75536fd4bb2e2ab6$var$Dt(t, i, 0 /* Listen */ , n.Oh), e.Yh.fh(n, r).next(function() {
                        return r;
                    });
                });
            });
        }).then(function(n) {
            return null === e.gu.get(n.targetId) && (e.gu = e.gu.Ae(n.targetId, n), e.pu.set(t, n.targetId)), n;
        });
    }, /**
     * Returns the TargetData as seen by the LocalStore, including updates that may
     * have not yet been persisted to the TargetCache.
     */ // Visible for testing.
    t.prototype.gh = function(t, e) {
        var n = this.pu.get(e);
        return void 0 !== n ? $75536fd4bb2e2ab6$var$xe.resolve(this.gu.get(n)) : this.Yh.gh(t, e);
    }, /**
     * Unpin all the documents associated with the given target. If
     * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
     * directly removes the associated target data from the target cache.
     *
     * Releasing a non-existing `Target` is a no-op.
     */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
    t.prototype.Wu = function(t, e) {
        var n = this, r = this.gu.get(t), i = e ? "readwrite" : "readwrite-primary";
        return this.persistence.runTransaction("Release target", i, function(t) {
            return e ? $75536fd4bb2e2ab6$var$xe.resolve() : n.persistence.hh.removeTarget(t, r);
        }).then(function() {
            n.gu = n.gu.remove(t), n.pu.delete(r.target);
        });
    }, /**
     * Runs the specified query against the local store and returns the results,
     * potentially taking advantage of query data from previous executions (such
     * as the set of remote keys).
     *
     * @param usePreviousResults Whether results from previous executions can
     * be used to optimize this query execution.
     */ t.prototype.ju = function(t, e) {
        var n = this, r = $75536fd4bb2e2ab6$var$g.min(), i = $75536fd4bb2e2ab6$var$Wt();
        return this.persistence.runTransaction("Execute query", "readonly", function(o) {
            return n.gh(o, t.ee()).next(function(t) {
                if (t) return r = t.lastLimboFreeSnapshotVersion, n.Yh.Sh(o, t.targetId).next(function(t) {
                    i = t;
                });
            }).next(function() {
                return n.Vu.Zn(o, t, e ? r : $75536fd4bb2e2ab6$var$g.min(), e ? i : $75536fd4bb2e2ab6$var$Wt());
            }).next(function(t) {
                return {
                    documents: t,
                    Ku: i
                };
            });
        });
    }, t.prototype.ku = function(t, e, n) {
        var r = this, i = e.batch, o = i.keys(), s = $75536fd4bb2e2ab6$var$xe.resolve();
        return o.forEach(function(r) {
            s = s.next(function() {
                return n.Ln(t, r);
            }).next(function(t) {
                var o = t, s = e.Rn.get(r);
                $75536fd4bb2e2ab6$var$me(null !== s), (!o || o.version.S(s) < 0) && (o = i.at(r, o, e)) && // We use the commitVersion as the readTime rather than the
                // document's updateTime since the updateTime is not advanced
                // for updates that do not modify the underlying document.
                n.Nn(o, e.wn);
            });
        }), s.next(function() {
            return r.Wn.ra(t, i);
        });
    }, t.prototype.Iu = function(t) {
        var e = this;
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function(n) {
            return t.mu(n, e.gu);
        });
    }, t;
}();
/** Implements the steps for LRU garbage collection. */ /**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ $75536fd4bb2e2ab6$var$Zn.xu = 3e8;
/**
 * An implementation of LocalStore that provides additional functionality
 * for MultiTabSyncEngine.
 */ // PORTING NOTE: Web only.
var $75536fd4bb2e2ab6$var$tr = /** @class */ function(t) {
    function n(e, n, r) {
        var i = this;
        return (i = t.call(this, e, n, r) || this).persistence = e, i.Wn = e.vo(r), i.bu = e.Co(), i.Yh = e.Do(), i;
    }
    /** Starts the LocalStore. */ return $8QG6t.__extends(n, t), n.prototype.start = function() {
        return this.Gu();
    }, /** Returns the local view of the documents affected by a mutation batch. */ n.prototype.zu = function(t) {
        var e = this;
        return this.persistence.runTransaction("Lookup mutation documents", "readonly", function(n) {
            return e.Wn.ta(n, t).next(function(t) {
                return t ? e.vu.Yn(n, t) : $75536fd4bb2e2ab6$var$xe.resolve(null);
            });
        });
    }, n.prototype.Hu = function(t) {
        this.Wn.ha(t);
    }, n.prototype.ao = function(t) {
        this.persistence.ao(t);
    }, n.prototype.bo = function() {
        return this.persistence.bo();
    }, n.prototype.Yu = function(t) {
        var e = this, n = this.gu.get(t);
        return n ? Promise.resolve(n.target) : this.persistence.runTransaction("Get target data", "readonly", function(n) {
            return e.Yh.si(n, t).next(function(t) {
                return t ? t.target : null;
            });
        });
    }, /**
     * Returns the set of documents that have been updated since the last call.
     * If this is the first call, returns the set of changes since client
     * initialization. Further invocations will return document changes since
     * the point of rejection.
     */ n.prototype.Kr = function() {
        var t = this;
        return this.persistence.runTransaction("Get new document changes", "readonly", function(e) {
            return t.bu.Kr(e, t.yu);
        }).then(function(e) {
            var n = e.Gr, r = e.readTime;
            return t.yu = r, n;
        });
    }, /**
     * Reads the newest document change from persistence and forwards the internal
     * synchronization marker so that calls to `getNewDocumentChanges()`
     * only return changes that happened after client initialization.
     */ n.prototype.Gu = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t, n = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = this, [
                            4 /*yield*/ ,
                            this.persistence.runTransaction("Synchronize last document change read time", "readonly", function(t) {
                                return n.bu.Hr(t);
                            })
                        ];
                    case 1:
                        return t.yu = e.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n;
}($75536fd4bb2e2ab6$var$Zn);
/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err An error returned by a LocalStore operation.
 * @return A Promise that resolves after we recovered, or the original error.
 */ function $75536fd4bb2e2ab6$var$er(t) {
    return $8QG6t.__awaiter(this, void 0, void 0, function() {
        return $8QG6t.__generator(this, function(e) {
            if (t.code !== $75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION || t.message !== $75536fd4bb2e2ab6$var$Re) throw t;
            return $75536fd4bb2e2ab6$var$de("LocalStore", "Unexpectedly lost primary lease"), [
                2 /*return*/ 
            ];
        });
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ var $75536fd4bb2e2ab6$var$nr = /** @class */ function() {
    function t() {
        // A set of outstanding references to a document sorted by key.
        this.Ju = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$rr.Xu), // A set of outstanding references to a document sorted by target id.
        this.Zu = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$rr.tc);
    }
    return t.prototype.B = function() {
        return this.Ju.B();
    }, /** Adds a reference to the given document key for the given ID. */ t.prototype.yh = function(t, e) {
        var n = new $75536fd4bb2e2ab6$var$rr(t, e);
        this.Ju = this.Ju.add(n), this.Zu = this.Zu.add(n);
    }, /** Add references to the given document keys for the given ID. */ t.prototype.ec = function(t, e) {
        var n = this;
        t.forEach(function(t) {
            return n.yh(t, e);
        });
    }, /**
     * Removes a reference to the given document key for the given
     * ID.
     */ t.prototype.vh = function(t, e) {
        this.sc(new $75536fd4bb2e2ab6$var$rr(t, e));
    }, t.prototype.ic = function(t, e) {
        var n = this;
        t.forEach(function(t) {
            return n.vh(t, e);
        });
    }, /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ t.prototype.nc = function(t) {
        var e = this, n = $75536fd4bb2e2ab6$var$_.EMPTY, r = new $75536fd4bb2e2ab6$var$rr(n, t), i = new $75536fd4bb2e2ab6$var$rr(n, t + 1), o = [];
        return this.Zu.Ke([
            r,
            i
        ], function(t) {
            e.sc(t), o.push(t.key);
        }), o;
    }, t.prototype.rc = function() {
        var t = this;
        this.Ju.forEach(function(e) {
            return t.sc(e);
        });
    }, t.prototype.sc = function(t) {
        this.Ju = this.Ju.delete(t), this.Zu = this.Zu.delete(t);
    }, t.prototype.hc = function(t) {
        var e = $75536fd4bb2e2ab6$var$_.EMPTY, n = new $75536fd4bb2e2ab6$var$rr(e, t), r = new $75536fd4bb2e2ab6$var$rr(e, t + 1), i = $75536fd4bb2e2ab6$var$Wt();
        return this.Zu.Ke([
            n,
            r
        ], function(t) {
            i = i.add(t.key);
        }), i;
    }, t.prototype.Ch = function(t) {
        var e = new $75536fd4bb2e2ab6$var$rr(t, 0), n = this.Ju.ze(e);
        return null !== n && t.isEqual(n.key);
    }, t;
}(), $75536fd4bb2e2ab6$var$rr = /** @class */ function() {
    function t(t, e) {
        this.key = t, this.oc = e;
    }
    return t.Xu = function(t, e) {
        return $75536fd4bb2e2ab6$var$_.N(t.key, e.key) || $75536fd4bb2e2ab6$var$be(t.oc, e.oc);
    }, /** Compare by ID then by key */ t.tc = function(t, e) {
        return $75536fd4bb2e2ab6$var$be(t.oc, e.oc) || $75536fd4bb2e2ab6$var$_.N(t.key, e.key);
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Validates that no arguments were passed in the invocation of functionName.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateNoArgs('myFunction', arguments);
 */ function $75536fd4bb2e2ab6$var$ir(t, e) {
    if (0 !== e.length) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() does not support arguments, but was called with " + $75536fd4bb2e2ab6$var$br(e.length, "argument") + ".");
}
/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */ function $75536fd4bb2e2ab6$var$or(t, e, n) {
    if (e.length !== n) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires " + $75536fd4bb2e2ab6$var$br(n, "argument") + ", but was called with " + $75536fd4bb2e2ab6$var$br(e.length, "argument") + ".");
}
/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */ function $75536fd4bb2e2ab6$var$sr(t, e, n) {
    if (e.length < n) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires at least " + $75536fd4bb2e2ab6$var$br(n, "argument") + ", but was called with " + $75536fd4bb2e2ab6$var$br(e.length, "argument") + ".");
}
/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */ function $75536fd4bb2e2ab6$var$ur(t, e, n, r) {
    if (e.length < n || e.length > r) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires between " + n + " and " + r + " arguments, but was called with " + $75536fd4bb2e2ab6$var$br(e.length, "argument") + ".");
}
/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */ /**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */ function $75536fd4bb2e2ab6$var$ar(t, e, n, r) {
    $75536fd4bb2e2ab6$var$pr(t, e, $75536fd4bb2e2ab6$var$Er(n) + " argument", r);
}
/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */ function $75536fd4bb2e2ab6$var$hr(t, e, n, r) {
    void 0 !== r && $75536fd4bb2e2ab6$var$ar(t, e, n, r);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */ function $75536fd4bb2e2ab6$var$cr(t, e, n, r) {
    $75536fd4bb2e2ab6$var$pr(t, e, n + " option", r);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */ function $75536fd4bb2e2ab6$var$fr(t, e, n, r) {
    void 0 !== r && $75536fd4bb2e2ab6$var$cr(t, e, n, r);
}
/**
 * Validates that the provided named option equals one of the expected values.
 */ /**
 * Validates that the provided named option equals one of the expected values or
 * is undefined.
 */ function $75536fd4bb2e2ab6$var$lr(t, e, n, r, i) {
    void 0 !== r && function(t, e, n, r, i) {
        for(var o = [], s = 0, u = i; s < u.length; s++){
            var a = u[s];
            if (a === r) return;
            o.push($75536fd4bb2e2ab6$var$yr(a));
        }
        var f = $75536fd4bb2e2ab6$var$yr(r);
        throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid value " + f + " provided to function " + t + '() for option "' + n + '". Acceptable values: ' + o.join(", "));
    }(t, 0, n, r, i);
}
/**
 * Validates that the provided argument is a valid enum.
 *
 * @param functionName Function making the validation call.
 * @param enums Array containing all possible values for the enum.
 * @param position Position of the argument in `functionName`.
 * @param argument Argument to validate.
 * @return The value as T if the argument can be converted.
 */ /** Helper to validate the type of a provided input. */ function $75536fd4bb2e2ab6$var$pr(t, e, n, r) {
    if (!("object" === e ? $75536fd4bb2e2ab6$var$dr(r) : "non-empty string" === e ? "string" == typeof r && "" !== r : typeof r === e)) {
        var i = $75536fd4bb2e2ab6$var$yr(r);
        throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires its " + n + " to be of type " + e + ", but it was: " + i);
    }
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $75536fd4bb2e2ab6$var$dr(t) {
    return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
}
/** Returns a string describing the type / value of the provided input. */ function $75536fd4bb2e2ab6$var$yr(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = t.substring(0, 20) + "..."), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        var e = /** Hacky method to try to get the constructor name for an object. */ function(t) {
            if (t.constructor) {
                var e = /function\s+([^\s(]+)\s*\(/.exec(t.constructor.toString());
                if (e && e.length > 1) return e[1];
            }
            return null;
        }(t);
        return e ? "a custom " + e + " object" : "an object";
    }
    return "function" == typeof t ? "a function" : $75536fd4bb2e2ab6$var$ge();
}
function $75536fd4bb2e2ab6$var$vr(t, e, n) {
    if (void 0 === n) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires a valid " + $75536fd4bb2e2ab6$var$Er(e) + " argument, but it was undefined.");
}
/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */ function $75536fd4bb2e2ab6$var$gr(t, e, n) {
    $75536fd4bb2e2ab6$var$I(e, function(e, r) {
        if (n.indexOf(e) < 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Unknown option '" + e + "' passed to function " + t + "(). Available options: " + n.join(", "));
    });
}
/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */ function $75536fd4bb2e2ab6$var$mr(t, e, n, r) {
    var i = $75536fd4bb2e2ab6$var$yr(r);
    return new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires its " + $75536fd4bb2e2ab6$var$Er(n) + " argument to be a " + e + ", but it was: " + i);
}
function $75536fd4bb2e2ab6$var$wr(t, e, n) {
    if (n <= 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires its " + $75536fd4bb2e2ab6$var$Er(e) + " argument to be a positive number, but it was: " + n + ".");
}
/** Converts a number to its english word representation */ function $75536fd4bb2e2ab6$var$Er(t) {
    switch(t){
        case 1:
            return "first";
        case 2:
            return "second";
        case 3:
            return "third";
        default:
            return t + "th";
    }
}
/**
 * Formats the given word as plural conditionally given the preceding number.
 */ function $75536fd4bb2e2ab6$var$br(t, e) {
    return t + " " + e + (1 === t ? "" : "s");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Helper function to assert Uint8Array is available at runtime. */ function $75536fd4bb2e2ab6$var$_r() {
    if ("undefined" == typeof Uint8Array) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNIMPLEMENTED, "Uint8Arrays are not available in this environment.");
}
/** Helper function to assert Base64 functions are available at runtime. */ function $75536fd4bb2e2ab6$var$Tr() {
    if (!$75536fd4bb2e2ab6$var$ce.nt().ac) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNIMPLEMENTED, "Blobs are unavailable in Firestore in this environment.");
}
/**
 * Immutable class holding a blob (binary data).
 * This class is directly exposed in the public API.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */ var $75536fd4bb2e2ab6$var$Ir = /** @class */ function() {
    function t(t) {
        $75536fd4bb2e2ab6$var$Tr(), this.uc = t;
    }
    return t.fromBase64String = function(e) {
        $75536fd4bb2e2ab6$var$or("Blob.fromBase64String", arguments, 1), $75536fd4bb2e2ab6$var$ar("Blob.fromBase64String", "string", 1, e), $75536fd4bb2e2ab6$var$Tr();
        try {
            return new t($75536fd4bb2e2ab6$var$A.fromBase64String(e));
        } catch (e) {
            throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Failed to construct Blob from Base64 string: " + e);
        }
    }, t.fromUint8Array = function(e) {
        if ($75536fd4bb2e2ab6$var$or("Blob.fromUint8Array", arguments, 1), $75536fd4bb2e2ab6$var$_r(), !(e instanceof Uint8Array)) throw $75536fd4bb2e2ab6$var$mr("Blob.fromUint8Array", "Uint8Array", 1, e);
        return new t($75536fd4bb2e2ab6$var$A.fromUint8Array(e));
    }, t.prototype.toBase64 = function() {
        return $75536fd4bb2e2ab6$var$or("Blob.toBase64", arguments, 0), $75536fd4bb2e2ab6$var$Tr(), this.uc.toBase64();
    }, t.prototype.toUint8Array = function() {
        return $75536fd4bb2e2ab6$var$or("Blob.toUint8Array", arguments, 0), $75536fd4bb2e2ab6$var$_r(), this.uc.toUint8Array();
    }, t.prototype.toString = function() {
        return "Blob(base64: " + this.toBase64() + ")";
    }, t.prototype.isEqual = function(t) {
        return this.uc.isEqual(t.uc);
    }, t;
}(), $75536fd4bb2e2ab6$var$Nr = /** @class */ function() {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */ function t() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        !function(t, e, n, r) {
            if (!(e instanceof Array) || e.length < 1) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function FieldPath() requires its fieldNames argument to be an array with at least " + $75536fd4bb2e2ab6$var$br(1, "element") + ".");
        }(0, t);
        for(var n = 0; n < t.length; ++n)if ($75536fd4bb2e2ab6$var$ar("FieldPath", "string", n, t[n]), 0 === t[n].length) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this.cc = new $75536fd4bb2e2ab6$var$b(t);
    }
    return t.documentId = function() {
        return t._c;
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) throw $75536fd4bb2e2ab6$var$mr("isEqual", "FieldPath", 1, e);
        return this.cc.isEqual(e.cc);
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
/**
 * A FieldPath refers to a field in a document. The path may consist of a single
 * field name (referring to a top-level field in the document), or a list of
 * field names (referring to a nested field in the document).
 */ /**
 * Internal Note: The backend doesn't technically support querying by
 * document ID. Instead it queries by the entire document name (full path
 * included), but in the cases we currently support documentId(), the net
 * effect is the same.
 */ $75536fd4bb2e2ab6$var$Nr._c = new $75536fd4bb2e2ab6$var$Nr($75536fd4bb2e2ab6$var$b.J().j());
/**
 * Matches any characters in a field path string that are reserved.
 */ var $75536fd4bb2e2ab6$var$Ar = new RegExp("[~\\*/\\[\\]]"), $75536fd4bb2e2ab6$var$kr = function(t) {
    this.lc = t;
}, $75536fd4bb2e2ab6$var$Dr = /** @class */ function(t) {
    function n() {
        return t.call(this, "FieldValue.delete") || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.Di = function(t) {
        if (2 /* MergeSet */  !== t.dc) throw 1 /* Update */  === t.dc ? t.fc("FieldValue.delete() can only appear at the top level of your update data") : t.fc("FieldValue.delete() cannot be used with set() unless you pass {merge:true}");
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.Vt.push(t.path), null;
    }, n.prototype.isEqual = function(t) {
        return t instanceof n;
    }, n;
}($75536fd4bb2e2ab6$var$kr), $75536fd4bb2e2ab6$var$xr = /** @class */ function(t) {
    function n() {
        return t.call(this, "FieldValue.serverTimestamp") || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.Di = function(t) {
        return new $75536fd4bb2e2ab6$var$tt(t.path, $75536fd4bb2e2ab6$var$Y.instance);
    }, n.prototype.isEqual = function(t) {
        return t instanceof n;
    }, n;
}($75536fd4bb2e2ab6$var$kr), $75536fd4bb2e2ab6$var$Sr = /** @class */ function(t) {
    function n(e) {
        var n = this;
        return (n = t.call(this, "FieldValue.arrayUnion") || this).Tc = e, n;
    }
    return $8QG6t.__extends(n, t), n.prototype.Di = function(t) {
        // Although array transforms are used with writes, the actual elements
        // being uniomed or removed are not considered writes since they cannot
        // contain any FieldValue sentinels, etc.
        var e = new $75536fd4bb2e2ab6$var$qr({
            dc: 3 /* Argument */ ,
            methodName: this.lc,
            Ec: !0
        }, t.ii, t.serializer, t.ignoreUndefinedProperties), n = this.Tc.map(function(t) {
            return $75536fd4bb2e2ab6$var$jr(t, e);
        }), r = new $75536fd4bb2e2ab6$var$$(n);
        return new $75536fd4bb2e2ab6$var$tt(t.path, r);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($75536fd4bb2e2ab6$var$kr), $75536fd4bb2e2ab6$var$Rr = /** @class */ function(t) {
    function n(e) {
        var n = this;
        return (n = t.call(this, "FieldValue.arrayRemove") || this).Tc = e, n;
    }
    return $8QG6t.__extends(n, t), n.prototype.Di = function(t) {
        // Although array transforms are used with writes, the actual elements
        // being unioned or removed are not considered writes since they cannot
        // contain any FieldValue sentinels, etc.
        var e = new $75536fd4bb2e2ab6$var$qr({
            dc: 3 /* Argument */ ,
            methodName: this.lc,
            Ec: !0
        }, t.ii, t.serializer, t.ignoreUndefinedProperties), n = this.Tc.map(function(t) {
            return $75536fd4bb2e2ab6$var$jr(t, e);
        }), r = new $75536fd4bb2e2ab6$var$J(n);
        return new $75536fd4bb2e2ab6$var$tt(t.path, r);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($75536fd4bb2e2ab6$var$kr), $75536fd4bb2e2ab6$var$Lr = /** @class */ function(t) {
    function n(e) {
        var n = this;
        return (n = t.call(this, "FieldValue.increment") || this).Ic = e, n;
    }
    return $8QG6t.__extends(n, t), n.prototype.Di = function(t) {
        var e = new $75536fd4bb2e2ab6$var$qr({
            dc: 3 /* Argument */ ,
            methodName: this.lc
        }, t.ii, t.serializer, t.ignoreUndefinedProperties), n = $75536fd4bb2e2ab6$var$jr(this.Ic, e), r = new $75536fd4bb2e2ab6$var$H(t.serializer, n);
        return new $75536fd4bb2e2ab6$var$tt(t.path, r);
    }, n.prototype.isEqual = function(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }, n;
}($75536fd4bb2e2ab6$var$kr), $75536fd4bb2e2ab6$var$Or = /** @class */ function() {
    function t(t, e) {
        if ($75536fd4bb2e2ab6$var$or("GeoPoint", arguments, 2), $75536fd4bb2e2ab6$var$ar("GeoPoint", "number", 1, t), $75536fd4bb2e2ab6$var$ar("GeoPoint", "number", 2, e), !isFinite(t) || t < -90 || t > 90) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
        this.wc = t, this.Rc = e;
    }
    return Object.defineProperty(t.prototype, "latitude", {
        /**
         * Returns the latitude of this geo point, a number between -90 and 90.
         */ get: function() {
            return this.wc;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "longitude", {
        /**
         * Returns the longitude of this geo point, a number between -180 and 180.
         */ get: function() {
            return this.Rc;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.isEqual = function(t) {
        return this.wc === t.wc && this.Rc === t.Rc;
    }, /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ t.prototype.p = function(t) {
        return $75536fd4bb2e2ab6$var$be(this.wc, t.wc) || $75536fd4bb2e2ab6$var$be(this.Rc, t.Rc);
    }, t;
}(), $75536fd4bb2e2ab6$var$Vr = /^__.*__$/, $75536fd4bb2e2ab6$var$Pr = /** @class */ function() {
    function t(t, e, n) {
        this.data = t, this.Vt = e, this.fieldTransforms = n;
    }
    return t.prototype.Ac = function(t, e) {
        var n = [];
        return null !== this.Vt ? n.push(new $75536fd4bb2e2ab6$var$ot(t, this.data, this.Vt, e)) : n.push(new $75536fd4bb2e2ab6$var$it(t, this.data, e)), this.fieldTransforms.length > 0 && n.push(new $75536fd4bb2e2ab6$var$st(t, this.fieldTransforms)), n;
    }, t;
}(), $75536fd4bb2e2ab6$var$Ur = /** @class */ function() {
    function t(t, e, n) {
        this.data = t, this.Vt = e, this.fieldTransforms = n;
    }
    return t.prototype.Ac = function(t, e) {
        var n = [
            new $75536fd4bb2e2ab6$var$ot(t, this.data, this.Vt, e)
        ];
        return this.fieldTransforms.length > 0 && n.push(new $75536fd4bb2e2ab6$var$st(t, this.fieldTransforms)), n;
    }, t;
}();
/**
 * Parses a field path string into a FieldPath, treating dots as separators.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An opaque base class for FieldValue sentinel objects in our public API,
 * with public static methods for creating said sentinel objects.
 */ function $75536fd4bb2e2ab6$var$Cr(t) {
    switch(t){
        case 0 /* Set */ :
        // fall through
        case 2 /* MergeSet */ :
        // fall through
        case 1 /* Update */ :
            return !0;
        case 3 /* Argument */ :
        case 4 /* ArrayArgument */ :
            return !1;
        default:
            throw $75536fd4bb2e2ab6$var$ge();
    }
}
/** A "context" object passed around while parsing user data. */ var $75536fd4bb2e2ab6$var$qr = /** @class */ function() {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings The settings for the parser.
     * @param databaseId The database ID of the Firestore instance.
     * @param serializer The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ function t(t, e, n, r, i, o) {
        this.settings = t, this.ii = e, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.mc(), this.fieldTransforms = i || [], this.Vt = o || [];
    }
    return Object.defineProperty(t.prototype, "path", {
        get: function() {
            return this.settings.path;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "dc", {
        get: function() {
            return this.settings.dc;
        },
        enumerable: !0,
        configurable: !0
    }), /** Returns a new context with the specified settings overwritten. */ t.prototype.Pc = function(e) {
        return new t(Object.assign(Object.assign({}, this.settings), e), this.ii, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.Vt);
    }, t.prototype.Vc = function(t) {
        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.Pc({
            path: n,
            Ec: !1
        });
        return r.gc(t), r;
    }, t.prototype.pc = function(t) {
        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.Pc({
            path: n,
            Ec: !1
        });
        return r.mc(), r;
    }, t.prototype.yc = function(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.Pc({
            path: void 0,
            Ec: !0
        });
    }, t.prototype.fc = function(t) {
        var e = !this.path || this.path.B() ? "" : " (found in field " + this.path.toString() + ")";
        return new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + this.settings.methodName + "() called with invalid data. " + t + e);
    }, /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ t.prototype.contains = function(t) {
        return void 0 !== this.Vt.find(function(e) {
            return t.q(e);
        }) || void 0 !== this.fieldTransforms.find(function(e) {
            return t.q(e.field);
        });
    }, t.prototype.mc = function() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(var t = 0; t < this.path.length; t++)this.gc(this.path.get(t));
    }, t.prototype.gc = function(t) {
        if (0 === t.length) throw this.fc("Document fields must not be empty");
        if ($75536fd4bb2e2ab6$var$Cr(this.dc) && $75536fd4bb2e2ab6$var$Vr.test(t)) throw this.fc('Document fields cannot begin and end with "__"');
    }, t;
}(), $75536fd4bb2e2ab6$var$Mr = /** @class */ function() {
    function t(t, e, n) {
        this.ii = t, this.ignoreUndefinedProperties = e, this.serializer = n || $75536fd4bb2e2ab6$var$ce.nt().bc(t);
    }
    return t.prototype.vc = function(t, e) {
        var n = this.Sc(0 /* Set */ , t);
        $75536fd4bb2e2ab6$var$zr("Data must be an object, but it was:", n, e);
        var r = $75536fd4bb2e2ab6$var$Fr(e, n);
        return new $75536fd4bb2e2ab6$var$Pr(new $75536fd4bb2e2ab6$var$ht(r), /* fieldMask= */ null, n.fieldTransforms);
    }, /** Parse document data from a set() call with '{merge:true}'. */ t.prototype.Dc = function(t, e, n) {
        var r = this.Sc(2 /* MergeSet */ , t);
        $75536fd4bb2e2ab6$var$zr("Data must be an object, but it was:", r, e);
        var i, o, s = $75536fd4bb2e2ab6$var$Fr(e, r);
        if (n) {
            for(var u = [], a = 0, f = n; a < f.length; a++){
                var l = f[a], p = void 0;
                if (l instanceof $75536fd4bb2e2ab6$var$Nr) p = l.cc;
                else {
                    if ("string" != typeof l) throw $75536fd4bb2e2ab6$var$ge();
                    p = $75536fd4bb2e2ab6$var$Wr(t, l);
                }
                if (!r.contains(p)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Field '" + p + "' is specified in your field mask but missing from your input data.");
                $75536fd4bb2e2ab6$var$Qr(u, p) || u.push(p);
            }
            i = new $75536fd4bb2e2ab6$var$Z(u), o = r.fieldTransforms.filter(function(t) {
                return i.dt(t.field);
            });
        } else i = new $75536fd4bb2e2ab6$var$Z(r.Vt), o = r.fieldTransforms;
        return new $75536fd4bb2e2ab6$var$Pr(new $75536fd4bb2e2ab6$var$ht(s), i, o);
    }, /** Parse update data from an update() call. */ t.prototype.Cc = function(t, e) {
        var n = this.Sc(1 /* Update */ , t);
        $75536fd4bb2e2ab6$var$zr("Data must be an object, but it was:", n, e);
        var r = [], i = new $75536fd4bb2e2ab6$var$ct;
        $75536fd4bb2e2ab6$var$I(e, function(e, o) {
            var s = $75536fd4bb2e2ab6$var$Wr(t, e), u = n.pc(s);
            if (o instanceof $75536fd4bb2e2ab6$var$Dr) // Add it to the field mask, but don't add anything to updateData.
            r.push(s);
            else {
                var a = $75536fd4bb2e2ab6$var$jr(o, u);
                null != a && (r.push(s), i.set(s, a));
            }
        });
        var o = new $75536fd4bb2e2ab6$var$Z(r);
        return new $75536fd4bb2e2ab6$var$Ur(i.yt(), o, n.fieldTransforms);
    }, /** Parse update data from a list of field/value arguments. */ t.prototype.Fc = function(t, e, n, r) {
        var i = this.Sc(1 /* Update */ , t), o = [
            $75536fd4bb2e2ab6$var$Gr(t, e)
        ], s = [
            n
        ];
        if (r.length % 2 != 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() needs to be called with an even number of arguments that alternate between field names and values.");
        for(var u = 0; u < r.length; u += 2)o.push($75536fd4bb2e2ab6$var$Gr(t, r[u])), s.push(r[u + 1]);
        // We iterate in reverse order to pick the last value for a field if the
        // user specified the field multiple times.
        for(var a = [], f = new $75536fd4bb2e2ab6$var$ct, l = o.length - 1; l >= 0; --l)if (!$75536fd4bb2e2ab6$var$Qr(a, o[l])) {
            var p = o[l], d = s[l], y = i.pc(p);
            if (d instanceof $75536fd4bb2e2ab6$var$Dr) // Add it to the field mask, but don't add anything to updateData.
            a.push(p);
            else {
                var v = $75536fd4bb2e2ab6$var$jr(d, y);
                null != v && (a.push(p), f.set(p, v));
            }
        }
        var g = new $75536fd4bb2e2ab6$var$Z(a);
        return new $75536fd4bb2e2ab6$var$Ur(f.yt(), g, i.fieldTransforms);
    }, /** Creates a new top-level parse context. */ t.prototype.Sc = function(t, e) {
        return new $75536fd4bb2e2ab6$var$qr({
            dc: t,
            methodName: e,
            path: $75536fd4bb2e2ab6$var$b.G,
            Ec: !1
        }, this.ii, this.serializer, this.ignoreUndefinedProperties);
    }, /**
     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
     * bound).
     *
     * @param allowArrays Whether the query value is an array that may directly
     * contain additional arrays (e.g. the operand of an `in` query).
     */ t.prototype.Nc = function(t, e, n) {
        return void 0 === n && (n = !1), $75536fd4bb2e2ab6$var$jr(e, this.Sc(n ? 4 /* ArrayArgument */  : 3 /* Argument */ , t));
    }, t;
}();
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ /**
 * Parses user data to Protobuf Values.
 *
 * @param input Data to be parsed.
 * @param context A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @return The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $75536fd4bb2e2ab6$var$jr(t, e) {
    if ($75536fd4bb2e2ab6$var$Br(t)) return $75536fd4bb2e2ab6$var$zr("Unsupported field value:", e, t), $75536fd4bb2e2ab6$var$Fr(t, e);
    if (t instanceof $75536fd4bb2e2ab6$var$kr) // FieldValues usually parse into transforms (except FieldValue.delete())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */ return function(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$75536fd4bb2e2ab6$var$Cr(e.dc)) throw e.fc(t.lc + "() can only be used with update() and set()");
        if (null === e.path) throw e.fc(t.lc + "() is not currently supported inside arrays");
        var n = t.Di(e);
        n && e.fieldTransforms.push(n);
    }(t, e), null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.Vt.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.Ec && 4 /* ArrayArgument */  !== e.dc) throw e.fc("Nested arrays are not supported");
        return function(t, e) {
            for(var n = [], r = 0, i = 0, o = t; i < o.length; i++){
                var s = $75536fd4bb2e2ab6$var$jr(o[i], e.yc(r));
                null == s && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (s = {
                    nullValue: "NULL_VALUE"
                }), n.push(s), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(t, e);
    }
    return function(t, e) {
        if (null === t) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return e.serializer.ai(t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            var n = $75536fd4bb2e2ab6$var$v.fromDate(t);
            return {
                timestampValue: e.serializer.C(n)
            };
        }
        if (t instanceof $75536fd4bb2e2ab6$var$v) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            var r = new $75536fd4bb2e2ab6$var$v(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: e.serializer.C(r)
            };
        }
        if (t instanceof $75536fd4bb2e2ab6$var$Or) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $75536fd4bb2e2ab6$var$Ir) return {
            bytesValue: e.serializer.ui(t)
        };
        if (t instanceof $75536fd4bb2e2ab6$var$Mi) {
            var i = e.ii, o = t.firestore.$c;
            if (!o.isEqual(i)) throw e.fc("Document reference is for database " + o.projectId + "/" + o.database + " but should be for database " + i.projectId + "/" + i.database);
            return {
                referenceValue: e.serializer._i(t.kc.path, t.firestore.$c)
            };
        }
        if (void 0 === t && e.ignoreUndefinedProperties) return null;
        throw e.fc("Unsupported field value: " + $75536fd4bb2e2ab6$var$yr(t));
    }(t, e);
}
function $75536fd4bb2e2ab6$var$Fr(t, e) {
    var n = {};
    return $75536fd4bb2e2ab6$var$N(t) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.Vt.push(e.path) : $75536fd4bb2e2ab6$var$I(t, function(t, r) {
        var i = $75536fd4bb2e2ab6$var$jr(r, e.Vc(t));
        null != i && (n[t] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $75536fd4bb2e2ab6$var$Br(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $75536fd4bb2e2ab6$var$v || t instanceof $75536fd4bb2e2ab6$var$Or || t instanceof $75536fd4bb2e2ab6$var$Ir || t instanceof $75536fd4bb2e2ab6$var$Mi || t instanceof $75536fd4bb2e2ab6$var$kr);
}
function $75536fd4bb2e2ab6$var$zr(t, e, n) {
    if (!$75536fd4bb2e2ab6$var$Br(n) || !$75536fd4bb2e2ab6$var$dr(n)) {
        var r = $75536fd4bb2e2ab6$var$yr(n);
        throw "an object" === r ? e.fc(t + " a custom object") : e.fc(t + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $75536fd4bb2e2ab6$var$Gr(t, e) {
    if (e instanceof $75536fd4bb2e2ab6$var$Nr) return e.cc;
    if ("string" == typeof e) return $75536fd4bb2e2ab6$var$Wr(t, e);
    throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() called with invalid data. Field path arguments must be of type string or FieldPath.");
}
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 */ function $75536fd4bb2e2ab6$var$Wr(t, n) {
    try {
        return function(t) {
            if (t.search($75536fd4bb2e2ab6$var$Ar) >= 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not contain '~', '*', '/', '[', or ']'");
            try {
                return new ($75536fd4bb2e2ab6$var$Nr.bind.apply($75536fd4bb2e2ab6$var$Nr, $8QG6t.__spreadArrays([
                    void 0
                ], t.split("."))));
            } catch (e) {
                throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
            }
        }(n).cc;
    } catch (n) {
        var r = (i = n) instanceof Error ? i.message : i.toString();
        throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() called with invalid data. " + r);
    }
    /**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */ var i;
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ }
function $75536fd4bb2e2ab6$var$Qr(t, e) {
    return t.some(function(t) {
        return t.isEqual(e);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ var $75536fd4bb2e2ab6$var$Kr = /** @class */ function() {
    function t(t, e, n, r, i, o) {
        this.Tr = t, this.Lc = n, this.Mc = r, this.Oc = i, this.listener = o, this.state = 0 /* Initial */ , /**
             * A close count that's incremented every time the stream is closed; used by
             * getCloseGuardedDispatcher() to invalidate callbacks that happen after
             * close.
             */ this.xc = 0, this.Bc = null, this.stream = null, this.$a = new $75536fd4bb2e2ab6$var$Ce(t, e);
    }
    return t.prototype.qc = function() {
        return 1 /* Starting */  === this.state || 2 /* Open */  === this.state || 4 /* Backoff */  === this.state;
    }, /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ t.prototype.Uc = function() {
        return 2 /* Open */  === this.state;
    }, /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ t.prototype.start = function() {
        3 /* Error */  !== this.state ? this.auth() : this.Qc();
    }, /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ t.prototype.stop = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.qc() ? [
                            4 /*yield*/ ,
                            this.close(0 /* Initial */ )
                        ] : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ t.prototype.Wc = function() {
        this.state = 0 /* Initial */ , this.$a.reset();
    }, /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ t.prototype.jc = function() {
        var t = this;
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Uc() && null === this.Bc && (this.Bc = this.Tr.yr(this.Lc, 6e4, function() {
            return t.Kc();
        }));
    }, /** Sends a message to the underlying stream. */ t.prototype.Gc = function(t) {
        this.zc(), this.stream.send(t);
    }, /** Called by the idle timer when the stream should close due to inactivity. */ t.prototype.Kc = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                return this.Uc() ? [
                    2 /*return*/ ,
                    this.close(0 /* Initial */ )
                ] : [
                    2 /*return*/ 
                ];
            });
        });
    }, /** Marks the stream as active again. */ t.prototype.zc = function() {
        this.Bc && (this.Bc.cancel(), this.Bc = null);
    }, /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */ t.prototype.close = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        // Notify the listener that the stream closed.
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        return this.zc(), this.$a.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
                        // underlying stream), guaranteeing they won't execute.
                        this.xc++, 3 /* Error */  !== t ? // If this is an intentional close ensure we don't delay our next connection attempt.
                        this.$a.reset() : n && n.code === $75536fd4bb2e2ab6$var$h.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                        ($75536fd4bb2e2ab6$var$ye(n.toString()), $75536fd4bb2e2ab6$var$ye("Using maximum backoff delay to prevent overloading the backend."), this.$a.Vr()) : n && n.code === $75536fd4bb2e2ab6$var$h.UNAUTHENTICATED && // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
                        // just expired.
                        this.Oc._(), // Clean up the underlying stream because we are no longer interested in events.
                        null !== this.stream && (this.Hc(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
                        // inhibit backoff or otherwise manipulate the state in its non-started state.
                        this.state = t, [
                            4 /*yield*/ ,
                            this.listener.Yc(n)
                        ];
                    case 1:
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        // Notify the listener that the stream closed.
                        return e.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ t.prototype.Hc = function() {}, t.prototype.auth = function() {
        var t = this;
        this.state = 1 /* Starting */ ;
        var e = this.Jc(this.xc), n = this.xc;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        this.Oc.getToken().then(function(e) {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            t.xc === n && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            t.Xc(e);
        }, function(n) {
            e(function() {
                var e = new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNKNOWN, "Fetching auth token failed: " + n.message);
                return t.Zc(e);
            });
        });
    }, t.prototype.Xc = function(t) {
        var e = this, n = this.Jc(this.xc);
        this.stream = this.t_(t), this.stream.e_(function() {
            n(function() {
                return e.state = 2 /* Open */ , e.listener.e_();
            });
        }), this.stream.Yc(function(t) {
            n(function() {
                return e.Zc(t);
            });
        }), this.stream.onMessage(function(t) {
            n(function() {
                return e.onMessage(t);
            });
        });
    }, t.prototype.Qc = function() {
        var t = this;
        this.state = 4 /* Backoff */ , this.$a.gr(function() {
            return $8QG6t.__awaiter(t, void 0, void 0, function() {
                return $8QG6t.__generator(this, function(t) {
                    return this.state = 0 /* Initial */ , this.start(), [
                        2 /*return*/ 
                    ];
                });
            });
        });
    }, // Visible for tests
    t.prototype.Zc = function(t) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $75536fd4bb2e2ab6$var$de("PersistentStream", "close with error: " + t), this.stream = null, this.close(3 /* Error */ , t);
    }, /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ t.prototype.Jc = function(t) {
        var e = this;
        return function(n) {
            e.Tr.uo(function() {
                return e.xc === t ? n() : ($75536fd4bb2e2ab6$var$de("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
            });
        };
    }, t;
}(), $75536fd4bb2e2ab6$var$Yr = /** @class */ function(t) {
    function n(e, n, r, i, o) {
        var s = this;
        return (s = t.call(this, e, "listen_stream_connection_backoff" /* ListenStreamConnectionBackoff */ , "listen_stream_idle" /* ListenStreamIdle */ , n, r, o) || this).serializer = i, s;
    }
    return $8QG6t.__extends(n, t), n.prototype.t_ = function(t) {
        return this.Mc.s_("Listen", t);
    }, n.prototype.onMessage = function(t) {
        // A successful response means the stream is healthy
        this.$a.reset();
        var e = this.serializer.pi(t), n = this.serializer.bi(t);
        return this.listener.i_(e, n);
    }, /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ n.prototype.n_ = function(t) {
        var e = {};
        e.database = this.serializer.wi, e.addTarget = this.serializer.ee(t);
        var n = this.serializer.zi(t);
        n && (e.labels = n), this.Gc(e);
    }, /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ n.prototype.r_ = function(t) {
        var e = {};
        e.database = this.serializer.wi, e.removeTarget = t, this.Gc(e);
    }, n;
}($75536fd4bb2e2ab6$var$Kr), $75536fd4bb2e2ab6$var$$r = /** @class */ function(t) {
    function n(e, n, r, i, o) {
        var s = this;
        return (s = t.call(this, e, "write_stream_connection_backoff" /* WriteStreamConnectionBackoff */ , "write_stream_idle" /* WriteStreamIdle */ , n, r, o) || this).serializer = i, s.h_ = !1, /**
             * The last received stream token from the server, used to acknowledge which
             * responses the client has processed. Stream tokens are opaque checkpoint
             * markers whose only real value is their inclusion in the next request.
             *
             * PersistentWriteStream manages propagating this value from responses to the
             * next request.
             */ s.lastStreamToken = $75536fd4bb2e2ab6$var$A.ht, s;
    }
    return $8QG6t.__extends(n, t), Object.defineProperty(n.prototype, "o_", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */ get: function() {
            return this.h_;
        },
        enumerable: !0,
        configurable: !0
    }), // Override of PersistentStream.start
    n.prototype.start = function() {
        this.h_ = !1, t.prototype.start.call(this);
    }, n.prototype.Hc = function() {
        this.h_ && this.a_([]);
    }, n.prototype.t_ = function(t) {
        return this.Mc.s_("Write", t);
    }, n.prototype.onMessage = function(t) {
        if (// Always capture the last stream token.
        $75536fd4bb2e2ab6$var$me(!!t.streamToken), this.lastStreamToken = this.serializer.ci(t.streamToken), this.h_) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.$a.reset();
            var e = this.serializer.Mi(t.writeResults, t.commitTime), n = this.serializer.fromVersion(t.commitTime);
            return this.listener.u_(n, e);
        }
        // The first response is always the handshake response
        return $75536fd4bb2e2ab6$var$me(!t.writeResults || 0 === t.writeResults.length), this.h_ = !0, this.listener.c_();
    }, /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ n.prototype.__ = function() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var t = {};
        t.database = this.serializer.wi, this.Gc(t);
    }, /** Sends a group of mutations to the Firestore backend to apply. */ n.prototype.a_ = function(t) {
        var e = this, n = {
            streamToken: this.serializer.ui(this.lastStreamToken),
            writes: t.map(function(t) {
                return e.serializer.vi(t);
            })
        };
        this.Gc(n);
    }, n;
}($75536fd4bb2e2ab6$var$Kr), $75536fd4bb2e2ab6$var$Jr = /** @class */ function(t) {
    function n(e, n, r) {
        var i = this;
        return (i = t.call(this) || this).Mc = e, i.credentials = n, i.serializer = r, i;
    }
    /** Gets an auth token and invokes the provided RPC. */ return $8QG6t.__extends(n, t), n.prototype.d_ = function(t, e) {
        var n = this;
        return this.credentials.getToken().then(function(r) {
            return n.Mc.d_(t, e, r);
        }).catch(function(t) {
            throw t.code === $75536fd4bb2e2ab6$var$h.UNAUTHENTICATED && n.credentials._(), t;
        });
    }, /** Gets an auth token and invokes the provided RPC with streamed results. */ n.prototype.f_ = function(t, e) {
        var n = this;
        return this.credentials.getToken().then(function(r) {
            return n.Mc.f_(t, e, r);
        }).catch(function(t) {
            throw t.code === $75536fd4bb2e2ab6$var$h.UNAUTHENTICATED && n.credentials._(), t;
        });
    }, n;
}(function() {
    // Make sure that the structural type of `Datastore` is unique.
    // See https://github.com/microsoft/TypeScript/issues/5451
    this.l_ = void 0;
}), $75536fd4bb2e2ab6$var$Hr = /** @class */ function() {
    function t(t) {
        this.T_ = t, // The version of each document that was read during this transaction.
        this.E_ = $75536fd4bb2e2ab6$var$zt(), this.mutations = [], this.I_ = !1, /**
             * A deferred usage error that occurred previously in this transaction that
             * will cause the transaction to fail once it actually commits.
             */ this.w_ = null, /**
             * Set of documents that have been written in the transaction.
             *
             * When there's more than one write to the same key in a transaction, any
             * writes after the first are handled differently.
             */ this.R_ = new Set;
    }
    return t.prototype.A_ = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r = this;
            return $8QG6t.__generator(this, function(i) {
                switch(i.label){
                    case 0:
                        if (this.m_(), this.mutations.length > 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
                        return [
                            4 /*yield*/ ,
                            function(t, n) {
                                return $8QG6t.__awaiter(this, void 0, void 0, function() {
                                    var r, i, o, s, u;
                                    return $8QG6t.__generator(this, function(e) {
                                        switch(e.label){
                                            case 0:
                                                return r = $75536fd4bb2e2ab6$var$we(t), i = {
                                                    database: r.serializer.wi,
                                                    documents: n.map(function(t) {
                                                        return r.serializer.fi(t);
                                                    })
                                                }, [
                                                    4 /*yield*/ ,
                                                    r.f_("BatchGetDocuments", i)
                                                ];
                                            case 1:
                                                return o = e.sent(), s = new Map, o.forEach(function(t) {
                                                    var e = r.serializer.gi(t);
                                                    s.set(e.key.toString(), e);
                                                }), u = [], [
                                                    2 /*return*/ ,
                                                    (n.forEach(function(t) {
                                                        var e = s.get(t.toString());
                                                        $75536fd4bb2e2ab6$var$me(!!e), u.push(e);
                                                    }), u)
                                                ];
                                        }
                                    });
                                });
                            }(this.T_, t)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            ((n = i.sent()).forEach(function(t) {
                                t instanceof $75536fd4bb2e2ab6$var$vt || t instanceof $75536fd4bb2e2ab6$var$yt ? r.P_(t) : $75536fd4bb2e2ab6$var$ge();
                            }), n)
                        ];
                }
            });
        });
    }, t.prototype.set = function(t, e) {
        this.write(e.Ac(t, this.Rt(t))), this.R_.add(t);
    }, t.prototype.update = function(t, e) {
        try {
            this.write(e.Ac(t, this.V_(t)));
        } catch (t) {
            this.w_ = t;
        }
        this.R_.add(t);
    }, t.prototype.delete = function(t) {
        this.write([
            new $75536fd4bb2e2ab6$var$ut(t, this.Rt(t))
        ]), this.R_.add(t);
    }, t.prototype.commit = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t, n = this;
            return $8QG6t.__generator(this, function(r) {
                switch(r.label){
                    case 0:
                        if (this.m_(), this.w_) throw this.w_;
                        return t = this.E_, // For each mutation, note that the doc was written.
                        this.mutations.forEach(function(e) {
                            t = t.remove(e.key);
                        }), // For each document that was read but not written to, we want to perform
                        // a `verify` operation.
                        t.forEach(function(t, e) {
                            n.mutations.push(new $75536fd4bb2e2ab6$var$at(t, n.Rt(t)));
                        }), [
                            4 /*yield*/ ,
                            function(t, n) {
                                return $8QG6t.__awaiter(this, void 0, void 0, function() {
                                    var r, i, o;
                                    return $8QG6t.__generator(this, function(e) {
                                        switch(e.label){
                                            case 0:
                                                return r = $75536fd4bb2e2ab6$var$we(t), i = {
                                                    database: r.serializer.wi,
                                                    writes: n.map(function(t) {
                                                        return r.serializer.vi(t);
                                                    })
                                                }, [
                                                    4 /*yield*/ ,
                                                    r.d_("Commit", i)
                                                ];
                                            case 1:
                                                return o = e.sent(), [
                                                    2 /*return*/ ,
                                                    r.serializer.Mi(o.writeResults, o.commitTime)
                                                ];
                                        }
                                    });
                                });
                            }(this.T_, this.mutations)
                        ];
                    case 1:
                        // For each mutation, note that the doc was written.
                        return r.sent(), this.I_ = !0, [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.P_ = function(t) {
        var e;
        if (t instanceof $75536fd4bb2e2ab6$var$yt) e = t.version;
        else {
            if (!(t instanceof $75536fd4bb2e2ab6$var$vt)) throw $75536fd4bb2e2ab6$var$ge();
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            e = $75536fd4bb2e2ab6$var$g.min();
        }
        var n = this.E_.get(t.key);
        if (null !== n) {
            if (!e.isEqual(n)) // This transaction will fail no matter what.
            throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.ABORTED, "Document version changed between two reads.");
        } else this.E_ = this.E_.Ae(t.key, e);
    }, /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ t.prototype.Rt = function(t) {
        var e = this.E_.get(t);
        return !this.R_.has(t) && e ? $75536fd4bb2e2ab6$var$nt.updateTime(e) : $75536fd4bb2e2ab6$var$nt.ft();
    }, /**
     * Returns the precondition for a document if the operation is an update.
     */ t.prototype.V_ = function(t) {
        var e = this.E_.get(t);
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.R_.has(t) && e) {
            if (e.isEqual($75536fd4bb2e2ab6$var$g.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $75536fd4bb2e2ab6$var$nt.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $75536fd4bb2e2ab6$var$nt.exists(!0);
    }, t.prototype.write = function(t) {
        this.m_(), this.mutations = this.mutations.concat(t);
    }, t.prototype.m_ = function() {}, t;
}(), $75536fd4bb2e2ab6$var$Xr = /** @class */ function() {
    function t(t, e) {
        this.Aa = t, this.g_ = e, /** The current OnlineState. */ this.state = "Unknown" /* Unknown */ , /**
             * A count of consecutive failures to open the stream. If it reaches the
             * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
             * Offline.
             */ this.p_ = 0, /**
             * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
             * transition from OnlineState.Unknown to OnlineState.Offline without waiting
             * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
             */ this.y_ = null, /**
             * Whether the client should log a warning message if it fails to connect to
             * the backend (initially true, cleared after a successful stream, or if we've
             * logged the message already).
             */ this.b_ = !0;
    }
    return t.prototype.v_ = function() {
        var t = this;
        0 === this.p_ && (this.S_("Unknown" /* Unknown */ ), this.y_ = this.Aa.yr("online_state_timeout" /* OnlineStateTimeout */ , 1e4, function() {
            return t.y_ = null, t.D_("Backend didn't respond within 10 seconds."), t.S_("Offline" /* Offline */ ), Promise.resolve();
        }));
    }, /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ t.prototype.C_ = function(t) {
        "Online" /* Online */  === this.state ? this.S_("Unknown" /* Unknown */ ) : (this.p_++, this.p_ >= 1 && (this.F_(), this.D_("Connection failed 1 times. Most recent error: " + t.toString()), this.S_("Offline" /* Offline */ )));
    }, /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ t.prototype.set = function(t) {
        this.F_(), this.p_ = 0, "Online" /* Online */  === t && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.b_ = !1), this.S_(t);
    }, t.prototype.S_ = function(t) {
        t !== this.state && (this.state = t, this.g_(t));
    }, t.prototype.D_ = function(t) {
        var e = "Could not reach Cloud Firestore backend. " + t + "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.";
        this.b_ ? ($75536fd4bb2e2ab6$var$ye(e), this.b_ = !1) : $75536fd4bb2e2ab6$var$de("OnlineStateTracker", e);
    }, t.prototype.F_ = function() {
        null !== this.y_ && (this.y_.cancel(), this.y_ = null);
    }, t;
}(), $75536fd4bb2e2ab6$var$Zr = /** @class */ function() {
    function t(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ t, /** The client-side proxy for interacting with the backend. */ n, r, i, o) {
        var s = this;
        this.N_ = t, this.T_ = n, this.Aa = r, /**
             * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
             * LocalStore via fillWritePipeline() and have or will send to the write
             * stream.
             *
             * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
             * restart the write stream. When the stream is established the writes in the
             * pipeline will be sent in order.
             *
             * Writes remain in writePipeline until they are acknowledged by the backend
             * and thus will automatically be re-sent if the stream is interrupted /
             * restarted before they're acknowledged.
             *
             * Write responses from the backend are linked to their originating request
             * purely based on order, and so we can just shift() writes from the front of
             * the writePipeline as we receive responses.
             */ this.k_ = [], /**
             * A mapping of watched targets that the client cares about tracking and the
             * user has explicitly called a 'listen' for this target.
             *
             * These targets may or may not have been sent to or acknowledged by the
             * server. On re-establishing the listen stream, these targets should be sent
             * to the server. The targets removed with unlistens are removed eagerly
             * without waiting for confirmation from the listen stream.
             */ this.L_ = new Map, this.M_ = null, /**
             * Set to true by enableNetwork() and false by disableNetwork() and indicates
             * the user-preferred network state.
             */ this.networkEnabled = !1, this.isPrimary = !1, /**
             * When set to `true`, the network was taken offline due to an IndexedDB
             * failure. The state is flipped to `false` when access becomes available
             * again.
             */ this.O_ = !1, this.x_ = o, this.x_.B_(function(t) {
            r.uo(function() {
                return $8QG6t.__awaiter(s, void 0, void 0, function() {
                    return $8QG6t.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                return this.q_() ? ($75536fd4bb2e2ab6$var$de("RemoteStore", "Restarting streams for network reachability change."), [
                                    4 /*yield*/ ,
                                    this.U_()
                                ]) : [
                                    3 /*break*/ ,
                                    2
                                ];
                            case 1:
                                t.sent(), t.label = 2;
                            case 2:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        }), this.Q_ = new $75536fd4bb2e2ab6$var$Xr(r, i), // Create streams (but note they're not started yet).
        this.W_ = function(t, e, n) {
            var r = $75536fd4bb2e2ab6$var$we(t);
            return new $75536fd4bb2e2ab6$var$Yr(e, r.Mc, r.credentials, r.serializer, n);
        }(this.T_, r, {
            e_: this.j_.bind(this),
            Yc: this.K_.bind(this),
            i_: this.G_.bind(this)
        }), this.z_ = function(t, e, n) {
            var r = $75536fd4bb2e2ab6$var$we(t);
            return new $75536fd4bb2e2ab6$var$$r(e, r.Mc, r.credentials, r.serializer, n);
        }(this.T_, r, {
            e_: this.H_.bind(this),
            Yc: this.Y_.bind(this),
            c_: this.J_.bind(this),
            u_: this.u_.bind(this)
        });
    }
    /**
     * Starts up the remote store, creating streams, restoring state from
     * LocalStore, etc.
     */ return t.prototype.start = function() {
        return this.enableNetwork();
    }, /** Re-enables the network. Idempotent. */ t.prototype.enableNetwork = function() {
        return this.networkEnabled = !0, this.X_();
    }, t.prototype.X_ = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.q_() ? (t = this.z_, [
                            4 /*yield*/ ,
                            this.N_.Yo()
                        ]) : [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        // This will start the write stream if necessary.
                        return t.lastStreamToken = e.sent(), this.Z_() ? this.tl() : this.Q_.set("Unknown" /* Unknown */ ), [
                            4 /*yield*/ ,
                            this.el()
                        ];
                    case 2:
                        // This will start the write stream if necessary.
                        e.sent(), e.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Temporarily disables the network. The network can be re-enabled using
     * enableNetwork().
     */ t.prototype.disableNetwork = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.networkEnabled = !1, [
                            4 /*yield*/ ,
                            this.sl()
                        ];
                    case 1:
                        return t.sent(), // Set the OnlineState to Offline so get()s return from cache, etc.
                        this.Q_.set("Offline" /* Offline */ ), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.sl = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.z_.stop()
                        ];
                    case 1:
                        return t.sent(), [
                            4 /*yield*/ ,
                            this.W_.stop()
                        ];
                    case 2:
                        return t.sent(), this.k_.length > 0 && ($75536fd4bb2e2ab6$var$de("RemoteStore", "Stopping write stream with " + this.k_.length + " pending writes"), this.k_ = []), this.il(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.mo = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return $75536fd4bb2e2ab6$var$de("RemoteStore", "RemoteStore shutting down."), this.networkEnabled = !1, [
                            4 /*yield*/ ,
                            this.sl()
                        ];
                    case 1:
                        return t.sent(), this.x_.mo(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                        // triggering spurious listener events with cached data, etc.
                        this.Q_.set("Unknown" /* Unknown */ ), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Starts new listen for the given target. Uses resume token if provided. It
     * is a no-op if the target of given `TargetData` is already being listened to.
     */ t.prototype.listen = function(t) {
        this.L_.has(t.targetId) || // Mark this as something the client is currently listening for.
        (this.L_.set(t.targetId, t), this.Z_() ? // The listen will be sent in onWatchStreamOpen
        this.tl() : this.W_.Uc() && this.nl(t));
    }, /**
     * Removes the listen from server. It is a no-op if the given target id is
     * not being listened to.
     */ t.prototype.rl = function(t) {
        this.L_.delete(t), this.W_.Uc() && this.hl(t), 0 === this.L_.size && (this.W_.Uc() ? this.W_.jc() : this.q_() && // Revert to OnlineState.Unknown if the watch stream is not open and we
        // have no listeners, since without any listens to send we cannot
        // confirm if the stream is healthy and upgrade to OnlineState.Online.
        this.Q_.set("Unknown" /* Unknown */ ));
    }, /** {@link TargetMetadataProvider.getTargetDataForTarget} */ t.prototype.si = function(t) {
        return this.L_.get(t) || null;
    }, /** {@link TargetMetadataProvider.getRemoteKeysForTarget} */ t.prototype.ei = function(t) {
        return this.ol.ei(t);
    }, /**
     * We need to increment the the expected number of pending responses we're due
     * from watch so we wait for the ack to process any messages from this target.
     */ t.prototype.nl = function(t) {
        this.M_.Ns(t.targetId), this.W_.n_(t);
    }, /**
     * We need to increment the expected number of pending responses we're due
     * from watch so we wait for the removal on the server before we process any
     * messages from this target.
     */ t.prototype.hl = function(t) {
        this.M_.Ns(t), this.W_.r_(t);
    }, t.prototype.tl = function() {
        this.M_ = new $75536fd4bb2e2ab6$var$re(this), this.W_.start(), this.Q_.v_();
    }, /**
     * Returns whether the watch stream should be started because it's necessary
     * and has not yet been started.
     */ t.prototype.Z_ = function() {
        return this.q_() && !this.W_.qc() && this.L_.size > 0;
    }, t.prototype.q_ = function() {
        return !this.O_ && this.isPrimary && this.networkEnabled;
    }, t.prototype.il = function() {
        this.M_ = null;
    }, t.prototype.j_ = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t = this;
            return $8QG6t.__generator(this, function(e) {
                return this.L_.forEach(function(e, n) {
                    t.nl(e);
                }), [
                    2 /*return*/ 
                ];
            });
        });
    }, t.prototype.K_ = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(e) {
                return this.il(), // If we still need the watch stream, retry the connection.
                this.Z_() ? (this.Q_.C_(t), this.tl()) : // No need to restart watch stream because there are no active targets.
                // The online state is set to unknown because there is no active attempt
                // at establishing a connection
                this.Q_.set("Unknown" /* Unknown */ ), [
                    2 /*return*/ 
                ];
            });
        });
    }, t.prototype.G_ = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r, i, o;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        if (this.Q_.set("Online" /* Online */ ), !(t instanceof $75536fd4bb2e2ab6$var$ee && 2 /* Removed */  === t.state && t.cause)) // Mark the client as online since we got a message from the server
                        return [
                            3 /*break*/ ,
                            6
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]), [
                            4 /*yield*/ ,
                            this.al(t)
                        ];
                    case 2:
                        return e.sent(), [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return r = e.sent(), $75536fd4bb2e2ab6$var$de("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), r), [
                            4 /*yield*/ ,
                            this.ul(r)
                        ];
                    case 4:
                        return e.sent(), [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 6:
                        if (t instanceof $75536fd4bb2e2ab6$var$Zt ? this.M_.qs(t) : t instanceof $75536fd4bb2e2ab6$var$te ? this.M_.Hs(t) : this.M_.Ws(t), n.isEqual($75536fd4bb2e2ab6$var$g.min())) return [
                            3 /*break*/ ,
                            13
                        ];
                        e.label = 7;
                    case 7:
                        return e.trys.push([
                            7,
                            11,
                            ,
                            13
                        ]), [
                            4 /*yield*/ ,
                            this.N_._h()
                        ];
                    case 8:
                        return i = e.sent(), n.S(i) >= 0 ? [
                            4 /*yield*/ ,
                            this.cl(n)
                        ] : [
                            3 /*break*/ ,
                            10
                        ];
                    // We have received a target change with a global snapshot if the snapshot
                    // version is not equal to SnapshotVersion.min().
                    case 9:
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.min().
                        e.sent(), e.label = 10;
                    case 10:
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 11:
                        return $75536fd4bb2e2ab6$var$de("RemoteStore", "Failed to raise snapshot:", o = e.sent()), [
                            4 /*yield*/ ,
                            this.ul(o)
                        ];
                    case 12:
                        return e.sent(), [
                            3 /*break*/ ,
                            13
                        ];
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Recovery logic for IndexedDB errors that takes the network offline until
     * IndexedDb probing succeeds. Retries are scheduled with backoff using
     * `enqueueRetryable()`.
     */ t.prototype.ul = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n = this;
            return $8QG6t.__generator(this, function(r) {
                switch(r.label){
                    case 0:
                        if (!$75536fd4bb2e2ab6$var$qn(t)) throw t;
                        // Disable network and raise offline snapshots
                        return this.O_ = !0, [
                            4 /*yield*/ ,
                            this.sl()
                        ];
                    case 1:
                        // Disable network and raise offline snapshots
                        return r.sent(), this.Q_.set("Offline" /* Offline */ ), // Probe IndexedDB periodically and re-enable network
                        this.Aa.Ua(function() {
                            return $8QG6t.__awaiter(n, void 0, void 0, function() {
                                return $8QG6t.__generator(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            // Issue a simple read operation to determine if IndexedDB recovered.
                                            // Ideally, we would expose a health check directly on SimpleDb, but
                                            // RemoteStore only has access to persistence through LocalStore.
                                            return $75536fd4bb2e2ab6$var$de("RemoteStore", "Retrying IndexedDB access"), [
                                                4 /*yield*/ ,
                                                this.N_._h()
                                            ];
                                        case 1:
                                            // Issue a simple read operation to determine if IndexedDB recovered.
                                            // Ideally, we would expose a health check directly on SimpleDb, but
                                            // RemoteStore only has access to persistence through LocalStore.
                                            return t.sent(), this.O_ = !1, [
                                                4 /*yield*/ ,
                                                this.X_()
                                            ];
                                        case 2:
                                            return t.sent(), [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Takes a batch of changes from the Datastore, repackages them as a
     * RemoteEvent, and passes that on to the listener, which is typically the
     * SyncEngine.
     */ t.prototype.cl = function(t) {
        var e = this, n = this.M_.Xs(t);
        // Update in-memory resume tokens. LocalStore will update the
        // persistent view of these when applying the completed RemoteEvent.
        // Finally raise remote event
        return n.as.forEach(function(n, r) {
            if (n.resumeToken.rt() > 0) {
                var i = e.L_.get(r);
                // A watched target might have been removed already.
                i && e.L_.set(r, i.we(n.resumeToken, t));
            }
        }), // Re-establish listens for the targets that have been invalidated by
        // existence filter mismatches.
        n.us.forEach(function(t) {
            var n = e.L_.get(t);
            if (n) {
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.L_.set(t, n.we($75536fd4bb2e2ab6$var$A.ht, n.Ee)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                e.hl(t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                var r = new $75536fd4bb2e2ab6$var$Dt(n.target, t, 1 /* ExistenceFilterMismatch */ , n.sequenceNumber);
                e.nl(r);
            }
        }), this.ol.Mu(n);
    }, /** Handles an error on a target */ t.prototype.al = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        n = t.cause, r = 0, i = t.targetIds, e.label = 1;
                    case 1:
                        return r < i.length ? (o = i[r], this.L_.has(o) ? [
                            4 /*yield*/ ,
                            this.ol._l(o, n)
                        ] : [
                            3 /*break*/ ,
                            3
                        ]) : [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        e.sent(), this.L_.delete(o), this.M_.removeTarget(o), e.label = 3;
                    case 3:
                        e.label = 4;
                    case 4:
                        return r++, [
                            3 /*break*/ ,
                            1
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Attempts to fill our write pipeline with writes from the LocalStore.
     *
     * Called internally to bootstrap or refill the write pipeline and by
     * SyncEngine whenever there are new mutations to process.
     *
     * Starts the write stream if necessary.
     */ t.prototype.el = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t, n;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.ll() ? (t = this.k_.length > 0 ? this.k_[this.k_.length - 1].batchId : -1, [
                            4 /*yield*/ ,
                            this.N_.qu(t)
                        ]) : [
                            3 /*break*/ ,
                            5
                        ];
                    case 1:
                        return null !== (n = e.sent()) ? [
                            3 /*break*/ ,
                            2
                        ] : (0 === this.k_.length && this.z_.jc(), [
                            3 /*break*/ ,
                            4
                        ]);
                    case 2:
                        return this.dl(n), [
                            4 /*yield*/ ,
                            this.el()
                        ];
                    case 3:
                        e.sent(), e.label = 4;
                    case 4:
                        e.label = 5;
                    case 5:
                        return this.fl() && this.Tl(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Returns true if we can add to the write pipeline (i.e. the network is
     * enabled and the write pipeline is not full).
     */ t.prototype.ll = function() {
        return this.q_() && this.k_.length < 10;
    }, // For testing
    t.prototype.El = function() {
        return this.k_.length;
    }, /**
     * Queues additional writes to be sent to the write stream, sending them
     * immediately if the write stream is established.
     */ t.prototype.dl = function(t) {
        this.k_.push(t), this.z_.Uc() && this.z_.o_ && this.z_.a_(t.mutations);
    }, t.prototype.fl = function() {
        return this.q_() && !this.z_.qc() && this.k_.length > 0;
    }, t.prototype.Tl = function() {
        this.z_.start();
    }, t.prototype.H_ = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                return this.z_.__(), [
                    2 /*return*/ 
                ];
            });
        });
    }, t.prototype.J_ = function() {
        var t = this;
        // Record the stream token.
        return this.N_.Jo(this.z_.lastStreamToken).then(function() {
            // Send the write pipeline now that the stream is established.
            for(var e = 0, n = t.k_; e < n.length; e++){
                var r = n[e];
                t.z_.a_(r.mutations);
            }
        }).catch($75536fd4bb2e2ab6$var$er);
    }, t.prototype.u_ = function(t, e) {
        var n = this, r = this.k_.shift(), i = $75536fd4bb2e2ab6$var$De.from(r, t, e, this.z_.lastStreamToken);
        return this.ol.Il(i).then(function() {
            return n.el();
        });
    }, t.prototype.Y_ = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return t && this.k_.length > 0 ? this.z_.o_ ? [
                            4 /*yield*/ ,
                            this.wl(t)
                        ] : [
                            3 /*break*/ ,
                            2
                        ] : [
                            3 /*break*/ ,
                            5
                        ];
                    case 1:
                        // This error affects the actual write.
                        return e.sent(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        // If there was an error before the handshake has finished, it's
                        // possible that the server is unable to process the stream token
                        // we're sending. (Perhaps it's too old?)
                        return [
                            4 /*yield*/ ,
                            this.Rl(t)
                        ];
                    case 3:
                        // If there was an error before the handshake has finished, it's
                        // possible that the server is unable to process the stream token
                        // we're sending. (Perhaps it's too old?)
                        e.sent(), e.label = 4;
                    case 4:
                        // The write stream might have been started by refilling the write
                        // pipeline for failed writes
                        this.fl() && this.Tl(), e.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.Rl = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(e) {
                // Reset the token if it's a permanent error, signaling the write stream is
                // no longer valid. Note that the handshake does not count as a write: see
                // comments on isPermanentWriteError for details.
                return $75536fd4bb2e2ab6$var$St(t.code) ? [
                    2 /*return*/ ,
                    ($75536fd4bb2e2ab6$var$de("RemoteStore", "RemoteStore error before completed handshake; resetting stream token: ", this.z_.lastStreamToken), this.z_.lastStreamToken = $75536fd4bb2e2ab6$var$A.ht, this.N_.Jo($75536fd4bb2e2ab6$var$A.ht).catch($75536fd4bb2e2ab6$var$er))
                ] : [
                    2 /*return*/ 
                ];
            });
        });
    }, t.prototype.wl = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i = this;
            return $8QG6t.__generator(this, function(e) {
                // Only handle permanent errors here. If it's transient, just let the retry
                // logic kick in.
                return $75536fd4bb2e2ab6$var$St(r = t.code) && r !== $75536fd4bb2e2ab6$var$h.ABORTED ? (n = this.k_.shift(), [
                    2 /*return*/ ,
                    (this.z_.Wc(), this.ol.Al(n.batchId, t).then(function() {
                        return i.el();
                    }))
                ]) : [
                    2 /*return*/ 
                ];
            });
        });
    }, t.prototype.ml = function() {
        return new $75536fd4bb2e2ab6$var$Hr(this.T_);
    }, t.prototype.U_ = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.networkEnabled = !1, [
                            4 /*yield*/ ,
                            this.sl()
                        ];
                    case 1:
                        return t.sent(), this.Q_.set("Unknown" /* Unknown */ ), [
                            4 /*yield*/ ,
                            this.enableNetwork()
                        ];
                    case 2:
                        return t.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.Pl = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.q_() ? // Tear down and re-create our network streams. This will ensure we get a fresh auth token
                        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
                        // (since mutations are per-user).
                        ($75536fd4bb2e2ab6$var$de("RemoteStore", "RemoteStore restarting streams for new credential"), [
                            4 /*yield*/ ,
                            this.U_()
                        ]) : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Toggles the network state when the client gains or loses its primary lease.
     */ t.prototype.Vl = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.isPrimary = t, t && this.networkEnabled ? [
                            4 /*yield*/ ,
                            this.enableNetwork()
                        ] : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        return e.sent(), [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        return (n = t) ? [
                            3 /*break*/ ,
                            4
                        ] : [
                            4 /*yield*/ ,
                            this.sl()
                        ];
                    case 3:
                        e.sent(), n = this.Q_.set("Unknown" /* Unknown */ ), e.label = 4;
                    case 4:
                        n, e.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t;
}();
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
/** Assembles the key for a client state in WebStorage */ function $75536fd4bb2e2ab6$var$ti(t, e) {
    return "firestore_clients_" + t + "_" + e;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $75536fd4bb2e2ab6$var$ei(t, e, n) {
    var r = "firestore_mutations_" + t + "_" + n;
    return e.t() && (r += "_" + e.uid), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $75536fd4bb2e2ab6$var$ni(t, e) {
    return "firestore_targets_" + t + "_" + e;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
var $75536fd4bb2e2ab6$var$ri = /** @class */ function() {
    function t(t, e, n, r) {
        this.user = t, this.batchId = e, this.state = n, this.error = r;
    }
    return t.gl = function(e, n, r) {
        var i = JSON.parse(r), o = "object" == typeof i && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(i.state) && (void 0 === i.error || "object" == typeof i.error), s = void 0;
        return o && i.error && (o = "string" == typeof i.error.message && "string" == typeof i.error.code) && (s = new $75536fd4bb2e2ab6$var$c(i.error.code, i.error.message)), o ? new t(e, n, i.state, s) : ($75536fd4bb2e2ab6$var$ye("SharedClientState", "Failed to parse mutation state for ID '" + n + "': " + r), null);
    }, t.prototype.pl = function() {
        var t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }, t;
}(), $75536fd4bb2e2ab6$var$ii = /** @class */ function() {
    function t(t, e, n) {
        this.targetId = t, this.state = e, this.error = n;
    }
    return t.gl = function(e, n) {
        var r = JSON.parse(n), i = "object" == typeof r && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error), o = void 0;
        return i && r.error && (i = "string" == typeof r.error.message && "string" == typeof r.error.code) && (o = new $75536fd4bb2e2ab6$var$c(r.error.code, r.error.message)), i ? new t(e, r.state, o) : ($75536fd4bb2e2ab6$var$ye("SharedClientState", "Failed to parse target state for ID '" + e + "': " + n), null);
    }, t.prototype.pl = function() {
        var t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }, t;
}(), $75536fd4bb2e2ab6$var$oi = /** @class */ function() {
    function t(t, e) {
        this.clientId = t, this.activeTargetIds = e;
    }
    return t.gl = function(e, n) {
        for(var r = JSON.parse(n), i = "object" == typeof r && r.activeTargetIds instanceof Array, o = $75536fd4bb2e2ab6$var$Kt(), s = 0; i && s < r.activeTargetIds.length; ++s)i = $75536fd4bb2e2ab6$var$x(r.activeTargetIds[s]), o = o.add(r.activeTargetIds[s]);
        return i ? new t(e, o) : ($75536fd4bb2e2ab6$var$ye("SharedClientState", "Failed to parse client data for instance '" + e + "': " + n), null);
    }, t;
}(), $75536fd4bb2e2ab6$var$si = /** @class */ function() {
    function t(t, e) {
        this.clientId = t, this.onlineState = e;
    }
    return t.gl = function(e) {
        var n = JSON.parse(e);
        return "object" == typeof n && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(n.onlineState) && "string" == typeof n.clientId ? new t(n.clientId, n.onlineState) : ($75536fd4bb2e2ab6$var$ye("SharedClientState", "Failed to parse online state: " + e), null);
    }, t;
}(), $75536fd4bb2e2ab6$var$ui = /** @class */ function() {
    function t() {
        this.activeTargetIds = $75536fd4bb2e2ab6$var$Kt();
    }
    return t.prototype.yl = function(t) {
        this.activeTargetIds = this.activeTargetIds.add(t);
    }, t.prototype.bl = function(t) {
        this.activeTargetIds = this.activeTargetIds.delete(t);
    }, /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ t.prototype.pl = function() {
        var t = {
            activeTargetIds: this.activeTargetIds.W(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(t);
    }, t;
}(), $75536fd4bb2e2ab6$var$ai = /** @class */ function() {
    function t(e, n, r, i, o) {
        if (this.Tr = e, this.platform = n, this.persistenceKey = r, this.vl = i, this.ol = null, this.g_ = null, this.ur = null, this.Sl = this.Dl.bind(this), this.Cl = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$be), this.ro = !1, /**
             * Captures WebStorage events that occur before `start()` is called. These
             * events are replayed once `WebStorageSharedClientState` is started.
             */ this.Fl = [], !t.Gh(this.platform)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNIMPLEMENTED, "LocalStorage is not available on this platform.");
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var s = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.platform.window.localStorage, this.currentUser = o, this.Nl = $75536fd4bb2e2ab6$var$ti(this.persistenceKey, this.vl), this.$l = /** Assembles the key for the current sequence number. */ function(t) {
            return "firestore_sequence_number_" + t;
        }(this.persistenceKey), this.Cl = this.Cl.Ae(this.vl, new $75536fd4bb2e2ab6$var$ui), this.kl = new RegExp("^firestore_clients_" + s + "_([^_]*)$"), this.Ll = new RegExp("^firestore_mutations_" + s + "_(\\d+)(?:_(.*))?$"), this.Ml = new RegExp("^firestore_targets_" + s + "_(\\d+)$"), this.Ol = /** Assembles the key for the online state of the primary tab. */ function(t) {
            return "firestore_online_state_" + t;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.platform.window.addEventListener("storage", this.Sl);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ return t.Gh = function(t) {
        return !(!t.window || null == t.window.localStorage);
    }, t.prototype.start = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t, n, r, i, o, s, u, a, h, c, f, l = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.ol.bo()
                        ];
                    case 1:
                        for(t = e.sent(), n = 0, r = t; n < r.length; n++)(i = r[n]) !== this.vl && (o = this.getItem($75536fd4bb2e2ab6$var$ti(this.persistenceKey, i))) && (s = $75536fd4bb2e2ab6$var$oi.gl(i, o)) && (this.Cl = this.Cl.Ae(s.clientId, s));
                        for(this.xl(), (u = this.storage.getItem(this.Ol)) && (a = this.Bl(u)) && this.ql(a), h = 0, c = this.Fl; h < c.length; h++)f = c[h], this.Dl(f);
                        return this.Fl = [], // Register a window unload hook to remove the client metadata entry from
                        // WebStorage even if `shutdown()` was not called.
                        this.platform.window.addEventListener("unload", function() {
                            return l.mo();
                        }), this.ro = !0, [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.lr = function(t) {
        this.setItem(this.$l, JSON.stringify(t));
    }, t.prototype.Ul = function() {
        return this.Ql(this.Cl);
    }, t.prototype.Wl = function(t) {
        var e = !1;
        return this.Cl.forEach(function(n, r) {
            r.activeTargetIds.has(t) && (e = !0);
        }), e;
    }, t.prototype.jl = function(t) {
        this.Kl(t, "pending");
    }, t.prototype.Gl = function(t, e, n) {
        this.Kl(t, e, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.zl(t);
    }, t.prototype.Hl = function(t) {
        var e = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.Wl(t)) {
            var n = this.storage.getItem($75536fd4bb2e2ab6$var$ni(this.persistenceKey, t));
            if (n) {
                var r = $75536fd4bb2e2ab6$var$ii.gl(t, n);
                r && (e = r.state);
            }
        }
        return this.Yl.yl(t), this.xl(), e;
    }, t.prototype.Jl = function(t) {
        this.Yl.bl(t), this.xl();
    }, t.prototype.Xl = function(t) {
        return this.Yl.activeTargetIds.has(t);
    }, t.prototype.Zl = function(t) {
        this.removeItem($75536fd4bb2e2ab6$var$ni(this.persistenceKey, t));
    }, t.prototype.td = function(t, e, n) {
        this.ed(t, e, n);
    }, t.prototype.Du = function(t, e, n) {
        var r = this;
        e.forEach(function(t) {
            r.zl(t);
        }), this.currentUser = t, n.forEach(function(t) {
            r.jl(t);
        });
    }, t.prototype.sd = function(t) {
        this.nd(t);
    }, t.prototype.mo = function() {
        this.ro && (this.platform.window.removeEventListener("storage", this.Sl), this.removeItem(this.Nl), this.ro = !1);
    }, t.prototype.getItem = function(t) {
        var e = this.storage.getItem(t);
        return $75536fd4bb2e2ab6$var$de("SharedClientState", "READ", t, e), e;
    }, t.prototype.setItem = function(t, e) {
        $75536fd4bb2e2ab6$var$de("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }, t.prototype.removeItem = function(t) {
        $75536fd4bb2e2ab6$var$de("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }, t.prototype.Dl = function(t) {
        var n = this;
        if (t.storageArea === this.storage) {
            if ($75536fd4bb2e2ab6$var$de("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.Nl) return void $75536fd4bb2e2ab6$var$ye("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Tr.Ua(function() {
                return $8QG6t.__awaiter(n, void 0, void 0, function() {
                    var n, r, i, o, s, u;
                    return $8QG6t.__generator(this, function(e) {
                        if (this.ro) {
                            if (null !== t.key) {
                                if (this.kl.test(t.key)) {
                                    if (null == t.newValue) return n = this.rd(t.key), [
                                        2 /*return*/ ,
                                        this.hd(n, null)
                                    ];
                                    if (r = this.od(t.key, t.newValue)) return [
                                        2 /*return*/ ,
                                        this.hd(r.clientId, r)
                                    ];
                                } else if (this.Ll.test(t.key)) {
                                    if (null !== t.newValue && (i = this.ad(t.key, t.newValue))) return [
                                        2 /*return*/ ,
                                        this.ud(i)
                                    ];
                                } else if (this.Ml.test(t.key)) {
                                    if (null !== t.newValue && (o = this._d(t.key, t.newValue))) return [
                                        2 /*return*/ ,
                                        this.ld(o)
                                    ];
                                } else if (t.key === this.Ol) {
                                    if (null !== t.newValue && (s = this.Bl(t.newValue))) return [
                                        2 /*return*/ ,
                                        this.ql(s)
                                    ];
                                } else t.key === this.$l && (u = function(t) {
                                    var e = $75536fd4bb2e2ab6$var$Pe.dr;
                                    if (null != t) try {
                                        var n = JSON.parse(t);
                                        $75536fd4bb2e2ab6$var$me("number" == typeof n), e = n;
                                    } catch (t) {
                                        $75536fd4bb2e2ab6$var$ye("SharedClientState", "Failed to read sequence number from WebStorage", t);
                                    }
                                    return e;
                                }(t.newValue)) !== $75536fd4bb2e2ab6$var$Pe.dr && this.ur(u);
                            }
                        } else this.Fl.push(t);
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        }
    }, Object.defineProperty(t.prototype, "Yl", {
        get: function() {
            return this.Cl.get(this.vl);
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.xl = function() {
        this.setItem(this.Nl, this.Yl.pl());
    }, t.prototype.Kl = function(t, e, n) {
        var r = new $75536fd4bb2e2ab6$var$ri(this.currentUser, t, e, n), i = $75536fd4bb2e2ab6$var$ei(this.persistenceKey, this.currentUser, t);
        this.setItem(i, r.pl());
    }, t.prototype.zl = function(t) {
        var e = $75536fd4bb2e2ab6$var$ei(this.persistenceKey, this.currentUser, t);
        this.removeItem(e);
    }, t.prototype.nd = function(t) {
        var e = {
            clientId: this.vl,
            onlineState: t
        };
        this.storage.setItem(this.Ol, JSON.stringify(e));
    }, t.prototype.ed = function(t, e, n) {
        var r = $75536fd4bb2e2ab6$var$ni(this.persistenceKey, t), i = new $75536fd4bb2e2ab6$var$ii(t, e, n);
        this.setItem(r, i.pl());
    }, /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ t.prototype.rd = function(t) {
        var e = this.kl.exec(t);
        return e ? e[1] : null;
    }, /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ t.prototype.od = function(t, e) {
        var n = this.rd(t);
        return $75536fd4bb2e2ab6$var$oi.gl(n, e);
    }, /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ t.prototype.ad = function(t, e) {
        var n = this.Ll.exec(t), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $75536fd4bb2e2ab6$var$ri.gl(new $75536fd4bb2e2ab6$var$a(i), r, e);
    }, /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ t.prototype._d = function(t, e) {
        var n = this.Ml.exec(t), r = Number(n[1]);
        return $75536fd4bb2e2ab6$var$ii.gl(r, e);
    }, /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ t.prototype.Bl = function(t) {
        return $75536fd4bb2e2ab6$var$si.gl(t);
    }, t.prototype.ud = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            return $8QG6t.__generator(this, function(e) {
                return t.user.uid === this.currentUser.uid ? [
                    2 /*return*/ ,
                    this.ol.dd(t.batchId, t.state, t.error)
                ] : ($75536fd4bb2e2ab6$var$de("SharedClientState", "Ignoring mutation for non-active user " + t.user.uid), [
                    2 /*return*/ 
                ]);
            });
        });
    }, t.prototype.ld = function(t) {
        return this.ol.fd(t.targetId, t.state, t.error);
    }, t.prototype.hd = function(t, e) {
        var n = this, r = e ? this.Cl.Ae(t, e) : this.Cl.remove(t), i = this.Ql(this.Cl), o = this.Ql(r), s = [], u = [];
        return o.forEach(function(t) {
            i.has(t) || s.push(t);
        }), i.forEach(function(t) {
            o.has(t) || u.push(t);
        }), this.ol.Td(s, u).then(function() {
            n.Cl = r;
        });
    }, t.prototype.ql = function(t) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Cl.get(t.clientId) && this.g_(t.onlineState);
    }, t.prototype.Ql = function(t) {
        var e = $75536fd4bb2e2ab6$var$Kt();
        return t.forEach(function(t, n) {
            e = e.He(n.activeTargetIds);
        }), e;
    }, t;
}(), $75536fd4bb2e2ab6$var$hi = /** @class */ function() {
    function t() {
        this.Ed = new $75536fd4bb2e2ab6$var$ui, this.Id = {}, this.ol = null, this.g_ = null, this.ur = null;
    }
    return t.prototype.jl = function(t) {
    // No op.
    }, t.prototype.Gl = function(t, e, n) {
    // No op.
    }, t.prototype.Hl = function(t) {
        return this.Ed.yl(t), this.Id[t] || "not-current";
    }, t.prototype.td = function(t, e, n) {
        this.Id[t] = e;
    }, t.prototype.Jl = function(t) {
        this.Ed.bl(t);
    }, t.prototype.Xl = function(t) {
        return this.Ed.activeTargetIds.has(t);
    }, t.prototype.Zl = function(t) {
        delete this.Id[t];
    }, t.prototype.Ul = function() {
        return this.Ed.activeTargetIds;
    }, t.prototype.Wl = function(t) {
        return this.Ed.activeTargetIds.has(t);
    }, t.prototype.start = function() {
        return this.Ed = new $75536fd4bb2e2ab6$var$ui, Promise.resolve();
    }, t.prototype.Du = function(t, e, n) {
    // No op.
    }, t.prototype.sd = function(t) {
    // No op.
    }, t.prototype.mo = function() {}, t.prototype.lr = function(t) {}, t;
}(), $75536fd4bb2e2ab6$var$ci = function(t) {
    this.key = t;
}, $75536fd4bb2e2ab6$var$fi = function(t) {
    this.key = t;
}, $75536fd4bb2e2ab6$var$li = /** @class */ function() {
    function t(t, /** Documents included in the remote target */ e) {
        this.query = t, this.wd = e, this.Rd = null, /**
             * A flag whether the view is current with the backend. A view is considered
             * current after it has seen the current flag from the backend and did not
             * lose consistency within the watch stream (e.g. because of an existence
             * filter mismatch).
             */ this.fs = !1, /** Documents in the view but not in the remote target */ this.Ad = $75536fd4bb2e2ab6$var$Wt(), /** Document Keys that have local changes */ this.ns = $75536fd4bb2e2ab6$var$Wt(), this.md = new $75536fd4bb2e2ab6$var$Yt(t.se.bind(t));
    }
    return Object.defineProperty(t.prototype, "Pd", {
        /**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */ get: function() {
            return this.wd;
        },
        enumerable: !0,
        configurable: !0
    }), /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */ t.prototype.Vd = function(t, e) {
        var n = this, r = e ? e.gd : new $75536fd4bb2e2ab6$var$$t, i = e ? e.md : this.md, o = e ? e.ns : this.ns, s = i, u = !1, a = this.query.oe() && i.size === this.query.limit ? i.last() : null, h = this.query.ae() && i.size === this.query.limit ? i.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (t.pe(function(t, e) {
            var c = i.get(t), f = e instanceof $75536fd4bb2e2ab6$var$yt ? e : null;
            f && (f = n.query.matches(f) ? f : null);
            var l = !!c && n.ns.has(c.key), p = !!f && (f.At || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            n.ns.has(f.key) && f.hasCommittedMutations), d = !1;
            // Calculate change
            c && f ? c.data().isEqual(f.data()) ? l !== p && (r.track({
                type: 3 /* Metadata */ ,
                doc: f
            }), d = !0) : n.pd(c, f) || (r.track({
                type: 2 /* Modified */ ,
                doc: f
            }), d = !0, (a && n.query.se(f, a) > 0 || h && n.query.se(f, h) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (u = !0)) : !c && f ? (r.track({
                type: 0 /* Added */ ,
                doc: f
            }), d = !0) : c && !f && (r.track({
                type: 1 /* Removed */ ,
                doc: c
            }), d = !0, (a || h) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (u = !0)), d && (f ? (s = s.add(f), o = p ? o.add(t) : o.delete(t)) : (s = s.delete(t), o = o.delete(t)));
        }), this.query.oe() || this.query.ae()) for(; s.size > this.query.limit;){
            var c = this.query.oe() ? s.last() : s.first();
            s = s.delete(c.key), o = o.delete(c.key), r.track({
                type: 1 /* Removed */ ,
                doc: c
            });
        }
        return {
            md: s,
            gd: r,
            yd: u,
            ns: o
        };
    }, t.prototype.pd = function(t, e) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return t.At && e.hasCommittedMutations && !e.At;
    }, /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param updateLimboDocuments Whether to update limbo documents based on this
     *        change.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    t.prototype.xn = function(t, e, n) {
        var r = this, i = this.md;
        this.md = t.md, this.ns = t.ns;
        // Sort changes based on type and query comparator
        var o = t.gd.es();
        o.sort(function(t, e) {
            return function(t, e) {
                var n = function(t) {
                    switch(t){
                        case 0 /* Added */ :
                            return 1;
                        case 2 /* Modified */ :
                        case 3 /* Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* Removed */ :
                            return 0;
                        default:
                            return $75536fd4bb2e2ab6$var$ge();
                    }
                };
                return n(t) - n(e);
            }(t.type, e.type) || r.query.se(t.doc, e.doc);
        }), this.bd(n);
        var s = e ? this.vd() : [], u = 0 === this.Ad.size && this.fs ? 1 /* Synced */  : 0 /* Local */ , a = u !== this.Rd;
        return this.Rd = u, 0 !== o.length || a ? {
            snapshot: new $75536fd4bb2e2ab6$var$Jt(this.query, t.md, i, o, t.ns, 0 /* Local */  === u, a, /* excludesMetadataChanges= */ !1),
            Sd: s
        } : {
            Sd: s
        };
    // no changes
    }, /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ t.prototype.Dd = function(t) {
        return this.fs && "Offline" /* Offline */  === t ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.fs = !1, this.xn({
            md: this.md,
            gd: new $75536fd4bb2e2ab6$var$$t,
            ns: this.ns,
            yd: !1
        }, /* updateLimboDocuments= */ !1)) : {
            Sd: []
        };
    }, /**
     * Returns whether the doc for the given key should be in limbo.
     */ t.prototype.Cd = function(t) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.wd.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.md.has(t) && !this.md.get(t).At;
    }, /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ t.prototype.bd = function(t) {
        var e = this;
        t && (t.Ts.forEach(function(t) {
            return e.wd = e.wd.add(t);
        }), t.Es.forEach(function(t) {}), t.Is.forEach(function(t) {
            return e.wd = e.wd.delete(t);
        }), this.fs = t.fs);
    }, t.prototype.vd = function() {
        var t = this;
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.fs) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var e = this.Ad;
        this.Ad = $75536fd4bb2e2ab6$var$Wt(), this.md.forEach(function(e) {
            t.Cd(e.key) && (t.Ad = t.Ad.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        var n = [];
        return e.forEach(function(e) {
            t.Ad.has(e) || n.push(new $75536fd4bb2e2ab6$var$fi(e));
        }), this.Ad.forEach(function(t) {
            e.has(t) || n.push(new $75536fd4bb2e2ab6$var$ci(t));
        }), n;
    }, /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @return The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.Fd = function(t) {
        this.wd = t.Ku, this.Ad = $75536fd4bb2e2ab6$var$Wt();
        var e = this.Vd(t.documents);
        return this.xn(e, /*updateLimboDocuments=*/ !0);
    }, /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    t.prototype.Nd = function() {
        return $75536fd4bb2e2ab6$var$Jt.os(this.query, this.md, this.ns, 0 /* Local */  === this.Rd);
    }, t;
}(), $75536fd4bb2e2ab6$var$pi = /** @class */ function() {
    function t(t, e, n, r) {
        this.Aa = t, this.$d = e, this.updateFunction = n, this.Va = r, this.kd = 5, this.$a = new $75536fd4bb2e2ab6$var$Ce(this.Aa, "transaction_retry" /* TransactionRetry */ );
    }
    return t.prototype.Ld = function() {
        this.Md();
    }, t.prototype.Md = function() {
        var t = this;
        this.$a.gr(function() {
            return $8QG6t.__awaiter(t, void 0, void 0, function() {
                var t, n, r = this;
                return $8QG6t.__generator(this, function(e) {
                    return t = this.$d.ml(), (n = this.Od(t)) && n.then(function(e) {
                        r.Aa.uo(function() {
                            return t.commit().then(function() {
                                r.Va.resolve(e);
                            }).catch(function(t) {
                                r.xd(t);
                            });
                        });
                    }).catch(function(t) {
                        r.xd(t);
                    }), [
                        2 /*return*/ 
                    ];
                });
            });
        });
    }, t.prototype.Od = function(t) {
        try {
            var e = this.updateFunction(t);
            return !$75536fd4bb2e2ab6$var$k(e) && e.catch && e.then ? e : (this.Va.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.Va.reject(t), null;
        }
    }, t.prototype.xd = function(t) {
        var e = this;
        this.kd > 0 && this.Bd(t) ? (this.kd -= 1, this.Aa.uo(function() {
            return e.Md(), Promise.resolve();
        })) : this.Va.reject(t);
    }, t.prototype.Bd = function(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            var e = t.code;
            return "aborted" === e || "failed-precondition" === e || !$75536fd4bb2e2ab6$var$St(e);
        }
        return !1;
    }, t;
}(), $75536fd4bb2e2ab6$var$di = function(/**
     * The query itself.
     */ t, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ e, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n) {
    this.query = t, this.targetId = e, this.view = n;
}, $75536fd4bb2e2ab6$var$yi = function(t) {
    this.key = t, /**
             * Set to true once we've received a document. This is used in
             * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
             * decide whether it needs to manufacture a delete event for the target once
             * the target is CURRENT.
             */ this.qd = !1;
}, $75536fd4bb2e2ab6$var$vi = /** @class */ function() {
    function t(t, e, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    n, r, i) {
        this.N_ = t, this.$d = e, this.Ud = n, this.currentUser = r, this.Qd = i, this.Wd = null, this.jd = new $75536fd4bb2e2ab6$var$Ae(function(t) {
            return t.canonicalId();
        }), this.Kd = new Map, /**
             * The keys of documents that are in limbo for which we haven't yet started a
             * limbo resolution query.
             */ this.Gd = [], /**
             * Keeps track of the target ID for each document that is in limbo with an
             * active target.
             */ this.zd = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N), /**
             * Keeps track of the information about an active limbo resolution for each
             * active target ID that was started for the purpose of limbo resolution.
             */ this.Hd = new Map, this.Yd = new $75536fd4bb2e2ab6$var$nr, /** Stores user completion handlers, indexed by User and BatchId. */ this.Jd = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Xd = new Map, this.Zd = $75536fd4bb2e2ab6$var$He.rh(), this.onlineState = "Unknown" /* Unknown */ ;
    }
    return Object.defineProperty(t.prototype, "tf", {
        get: function() {
            return !0;
        },
        enumerable: !0,
        configurable: !0
    }), /** Subscribes to SyncEngine notifications. Has to be called exactly once. */ t.prototype.subscribe = function(t) {
        this.Wd = t;
    }, /**
     * Initiates the new listen, resolves promise when listen enqueued to the
     * server. All the subsequent view snapshots or errors are sent to the
     * subscribed handlers. Returns the initial snapshot.
     */ t.prototype.listen = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o, s;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.ef("listen()"), (i = this.jd.get(t)) ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                        // already exists when EventManager calls us for the first time. This
                        // happens when the primary tab is already listening to this query on
                        // behalf of another tab and the user of the primary also starts listening
                        // to the query. EventManager will not have an assigned target ID in this
                        // case and calls `listen` to obtain this ID.
                        (n = i.targetId, this.Ud.Hl(n), r = i.view.Nd(), [
                            3 /*break*/ ,
                            4
                        ]) : [
                            3 /*break*/ ,
                            1
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.N_.Qu(t.ee())
                        ];
                    case 2:
                        return o = e.sent(), s = this.Ud.Hl(o.targetId), n = o.targetId, [
                            4 /*yield*/ ,
                            this.sf(t, n, "current" === s)
                        ];
                    case 3:
                        r = e.sent(), this.tf && this.$d.listen(o), e.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            r
                        ];
                }
            });
        });
    }, /**
     * Registers a view for a previously unknown query and computes its initial
     * snapshot.
     */ t.prototype.sf = function(t, n, r) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var i, o, s, u, a, h;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.N_.ju(t, /* usePreviousResults= */ !0)
                        ];
                    case 1:
                        return i = e.sent(), o = new $75536fd4bb2e2ab6$var$li(t, i.Ku), s = o.Vd(i.documents), u = $75536fd4bb2e2ab6$var$Xt.ds(n, r && "Offline" /* Offline */  !== this.onlineState), a = o.xn(s, /* updateLimboDocuments= */ this.tf, u), this.if(n, a.Sd), h = new $75536fd4bb2e2ab6$var$di(t, n, o), [
                            2 /*return*/ ,
                            (this.jd.set(t, h), this.Kd.has(n) ? this.Kd.get(n).push(t) : this.Kd.set(n, [
                                t
                            ]), a.snapshot)
                        ];
                }
            });
        });
    }, /** Stops listening to the query. */ t.prototype.rl = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        // Only clean up the query view and target if this is the only query mapped
                        // to the target.
                        return this.ef("unlisten()"), n = this.jd.get(t), (r = this.Kd.get(n.targetId)).length > 1 ? [
                            2 /*return*/ ,
                            (this.Kd.set(n.targetId, r.filter(function(e) {
                                return !e.isEqual(t);
                            })), void this.jd.delete(t))
                        ] : this.tf ? // We need to remove the local query target first to allow us to verify
                        // whether any other client is still interested in this target.
                        (this.Ud.Jl(n.targetId), this.Ud.Wl(n.targetId) ? [
                            3 /*break*/ ,
                            2
                        ] : [
                            4 /*yield*/ ,
                            this.N_.Wu(n.targetId, /*keepPersistedTargetData=*/ !1).then(function() {
                                i.Ud.Zl(n.targetId), i.$d.rl(n.targetId), i.nf(n.targetId);
                            }).catch($75536fd4bb2e2ab6$var$er)
                        ]) : [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return this.nf(n.targetId), [
                            4 /*yield*/ ,
                            this.N_.Wu(n.targetId, /*keepPersistedTargetData=*/ !0)
                        ];
                    case 4:
                        e.sent(), e.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Initiates the write of local mutation batch which involves adding the
     * writes to the mutation queue, notifying the remote store about new
     * mutations and raising events for any changes this write caused.
     *
     * The promise returned by this call is resolved when the above steps
     * have completed, *not* when the write was acked by the backend. The
     * userCallback is resolved once the write was acked/rejected by the
     * backend (or failed locally for any other reason).
     */ t.prototype.write = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r, i, o;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        this.ef("write()"), e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), [
                            4 /*yield*/ ,
                            this.N_.$u(t)
                        ];
                    case 2:
                        return r = e.sent(), this.Ud.jl(r.batchId), this.rf(r.batchId, n), [
                            4 /*yield*/ ,
                            this.hf(r.Dn)
                        ];
                    case 3:
                        return e.sent(), [
                            4 /*yield*/ ,
                            this.$d.el()
                        ];
                    case 4:
                        return e.sent(), [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        return i = e.sent(), o = $75536fd4bb2e2ab6$var$Qn(i, "Failed to persist write"), n.reject(o), [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If a retryable error occurs (ex: some other
     * client has changed any of the data referenced), then the updateFunction
     * will be called again after a backoff. If the updateFunction still fails
     * after all retries, then the transaction will be rejected.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     *
     * The Deferred input is resolved when the transaction is fully committed.
     */ t.prototype.runTransaction = function(t, e, n) {
        new $75536fd4bb2e2ab6$var$pi(t, this.$d, e, n).Ld();
    }, t.prototype.Mu = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        this.ef("applyRemoteEvent()"), e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]), [
                            4 /*yield*/ ,
                            this.N_.Mu(t)
                        ];
                    case 2:
                        return n = e.sent(), // Update `receivedDocument` as appropriate for any limbo targets.
                        t.as.forEach(function(t, e) {
                            var n = r.Hd.get(e);
                            n && // Since this is a limbo resolution lookup, it's for a single document
                            // and it could be added, modified, or removed, but not a combination.
                            ($75536fd4bb2e2ab6$var$me(t.Ts.size + t.Es.size + t.Is.size <= 1), t.Ts.size > 0 ? n.qd = !0 : t.Es.size > 0 ? $75536fd4bb2e2ab6$var$me(n.qd) : t.Is.size > 0 && ($75536fd4bb2e2ab6$var$me(n.qd), n.qd = !1));
                        }), [
                            4 /*yield*/ ,
                            this.hf(n, t)
                        ];
                    case 3:
                        // Update `receivedDocument` as appropriate for any limbo targets.
                        return e.sent(), [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            $75536fd4bb2e2ab6$var$er(e.sent())
                        ];
                    case 5:
                        return e.sent(), [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Applies an OnlineState change to the sync engine and notifies any views of
     * the change.
     */ t.prototype.Dd = function(t, e) {
        this.ef("applyOnlineStateChange()");
        var n = [];
        this.jd.forEach(function(e, r) {
            var i = r.view.Dd(t);
            i.snapshot && n.push(i.snapshot);
        }), this.Wd.af(t), this.Wd.i_(n), this.onlineState = t;
    }, t.prototype._l = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r, i, o, s, u, a = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.ef("rejectListens()"), // PORTING NOTE: Multi-tab only.
                        this.Ud.td(t, "rejected", n), r = this.Hd.get(t), (i = r && r.key) ? (o = (o = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N)).Ae(i, new $75536fd4bb2e2ab6$var$vt(i, $75536fd4bb2e2ab6$var$g.min())), s = $75536fd4bb2e2ab6$var$Wt().add(i), u = new $75536fd4bb2e2ab6$var$Ht($75536fd4bb2e2ab6$var$g.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be), o, s), [
                            4 /*yield*/ ,
                            this.Mu(u)
                        ]) : [
                            3 /*break*/ ,
                            2
                        ];
                    case 1:
                        return e.sent(), // Since this query failed, we won't want to manually unlisten to it.
                        // We only remove it from bookkeeping after we successfully applied the
                        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
                        // this query when the RemoteStore restarts the Watch stream, which should
                        // re-trigger the target failure.
                        this.zd = this.zd.remove(i), this.Hd.delete(t), this.uf(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.N_.Wu(t, /* keepPersistedTargetData */ !1).then(function() {
                                return a.nf(t, n);
                            }).catch($75536fd4bb2e2ab6$var$er)
                        ];
                    case 3:
                        e.sent(), e.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.Il = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        this.ef("applySuccessfulWrite()"), n = t.batch.batchId, // The local store may or may not be able to apply the write result and
                        // raise events immediately (depending on whether the watcher is caught
                        // up), so we raise user callbacks first so that they consistently happen
                        // before listen events.
                        this.cf(n, /*error=*/ null), this._f(n), e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]), [
                            4 /*yield*/ ,
                            this.N_.zo(t)
                        ];
                    case 2:
                        return r = e.sent(), this.Ud.Gl(n, "acknowledged"), [
                            4 /*yield*/ ,
                            this.hf(r)
                        ];
                    case 3:
                        return e.sent(), [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            $75536fd4bb2e2ab6$var$er(e.sent())
                        ];
                    case 5:
                        return e.sent(), [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.Al = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        this.ef("rejectFailedWrite()"), // The local store may or may not be able to apply the write result and
                        // raise events immediately (depending on whether the watcher is caught up),
                        // so we raise user callbacks first so that they consistently happen before
                        // listen events.
                        this.cf(t, n), this._f(t), e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]), [
                            4 /*yield*/ ,
                            this.N_.Lu(t)
                        ];
                    case 2:
                        return r = e.sent(), this.Ud.Gl(t, "rejected", n), [
                            4 /*yield*/ ,
                            this.hf(r)
                        ];
                    case 3:
                        return e.sent(), [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            $75536fd4bb2e2ab6$var$er(e.sent())
                        ];
                    case 5:
                        return e.sent(), [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Registers a user callback that resolves when all pending mutations at the moment of calling
     * are acknowledged .
     */ t.prototype.lf = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        this.$d.q_() || $75536fd4bb2e2ab6$var$de("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled."), e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4 /*yield*/ ,
                            this.N_.sa()
                        ];
                    case 2:
                        return -1 === (n = e.sent()) ? [
                            2 /*return*/ ,
                            void t.resolve()
                        ] : ((r = this.Xd.get(n) || []).push(t), this.Xd.set(n, r), [
                            3 /*break*/ ,
                            4
                        ]);
                    case 3:
                        return i = e.sent(), o = $75536fd4bb2e2ab6$var$Qn(i, "Initialization of waitForPendingWrites() operation failed"), t.reject(o), [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
     * if there are any.
     */ t.prototype._f = function(t) {
        (this.Xd.get(t) || []).forEach(function(t) {
            t.resolve();
        }), this.Xd.delete(t);
    }, /** Reject all outstanding callbacks waiting for pending writes to complete. */ t.prototype.df = function(t) {
        this.Xd.forEach(function(e) {
            e.forEach(function(e) {
                e.reject(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.CANCELLED, t));
            });
        }), this.Xd.clear();
    }, t.prototype.rf = function(t, e) {
        var n = this.Jd[this.currentUser.s()];
        n || (n = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$be)), n = n.Ae(t, e), this.Jd[this.currentUser.s()] = n;
    }, /**
     * Resolves or rejects the user callback for the given batch and then discards
     * it.
     */ t.prototype.cf = function(t, e) {
        var n = this.Jd[this.currentUser.s()];
        // NOTE: Mutations restored from persistence won't have callbacks, so it's
        // okay for there to be no callback for this ID.
        if (n) {
            var r = n.get(t);
            r && (e ? r.reject(e) : r.resolve(), n = n.remove(t)), this.Jd[this.currentUser.s()] = n;
        }
    }, t.prototype.nf = function(t, e) {
        var n = this;
        void 0 === e && (e = null), this.Ud.Jl(t);
        for(var r = 0, i = this.Kd.get(t); r < i.length; r++){
            var o = i[r];
            this.jd.delete(o), e && this.Wd.ff(o, e);
        }
        this.Kd.delete(t), this.tf && this.Yd.nc(t).forEach(function(t) {
            n.Yd.Ch(t) || // We removed the last reference for this key
            n.Tf(t);
        });
    }, t.prototype.Tf = function(t) {
        // It's possible that the target already got removed because the query failed. In that case,
        // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
        var e = this.zd.get(t);
        null !== e && (this.$d.rl(e), this.zd = this.zd.remove(t), this.Hd.delete(e), this.uf());
    }, t.prototype.if = function(t, e) {
        for(var n = 0, r = e; n < r.length; n++){
            var i = r[n];
            i instanceof $75536fd4bb2e2ab6$var$ci ? (this.Yd.yh(i.key, t), this.Ef(i)) : i instanceof $75536fd4bb2e2ab6$var$fi ? ($75536fd4bb2e2ab6$var$de("SyncEngine", "Document no longer in limbo: " + i.key), this.Yd.vh(i.key, t), this.Yd.Ch(i.key) || // We removed the last reference for this key
            this.Tf(i.key)) : $75536fd4bb2e2ab6$var$ge();
        }
    }, t.prototype.Ef = function(t) {
        var e = t.key;
        this.zd.get(e) || ($75536fd4bb2e2ab6$var$de("SyncEngine", "New document in limbo: " + e), this.Gd.push(e), this.uf());
    }, /**
     * Starts listens for documents in limbo that are enqueued for resolution,
     * subject to a maximum number of concurrent resolutions.
     *
     * Without bounding the number of concurrent resolutions, the server can fail
     * with "resource exhausted" errors which can lead to pathological client
     * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
     */ t.prototype.uf = function() {
        for(; this.Gd.length > 0 && this.zd.size < this.Qd;){
            var t = this.Gd.shift(), e = this.Zd.next();
            this.Hd.set(e, new $75536fd4bb2e2ab6$var$yi(t)), this.zd = this.zd.Ae(t, e), this.$d.listen(new $75536fd4bb2e2ab6$var$Dt($75536fd4bb2e2ab6$var$wt.Wt(t.path).ee(), e, 2 /* LimboResolution */ , $75536fd4bb2e2ab6$var$Pe.dr));
        }
    }, // Visible for testing
    t.prototype.If = function() {
        return this.zd;
    }, // Visible for testing
    t.prototype.wf = function() {
        return this.Gd;
    }, t.prototype.hf = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r, i, o, s = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return r = [], i = [], o = [], this.jd.forEach(function(e, u) {
                            o.push(Promise.resolve().then(function() {
                                var e = u.view.Vd(t);
                                return e.yd ? s.N_.ju(u.query, /* usePreviousResults= */ !1).then(function(t) {
                                    var n = t.documents;
                                    return u.view.Vd(n, e);
                                }) : e;
                            // The query has a limit and some docs were removed, so we need
                            // to re-run the query against the local store to make sure we
                            // didn't lose any good docs that had been past the limit.
                            }).then(function(t) {
                                var e = n && n.as.get(u.targetId), o = u.view.xn(t, /* updateLimboDocuments= */ s.tf, e);
                                if (s.if(u.targetId, o.Sd), o.snapshot) {
                                    s.tf && s.Ud.td(u.targetId, o.snapshot.fromCache ? "not-current" : "current"), r.push(o.snapshot);
                                    var a = $75536fd4bb2e2ab6$var$Ve.ar(u.targetId, o.snapshot);
                                    i.push(a);
                                }
                            }));
                        }), [
                            4 /*yield*/ ,
                            Promise.all(o)
                        ];
                    case 1:
                        return e.sent(), this.Wd.i_(r), [
                            4 /*yield*/ ,
                            this.N_.Bu(i)
                        ];
                    case 2:
                        return e.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.ef = function(t) {}, t.prototype.Pl = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.currentUser.isEqual(t) ? [
                            3 /*break*/ ,
                            3
                        ] : [
                            4 /*yield*/ ,
                            this.N_.Du(t)
                        ];
                    case 1:
                        return n = e.sent(), this.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
                        this.df("'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
                        this.Ud.Du(t, n.Fu, n.Nu), [
                            4 /*yield*/ ,
                            this.hf(n.Cu)
                        ];
                    case 2:
                        e.sent(), e.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this.$d.Pl()
                        ];
                    case 4:
                        return e.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.enableNetwork = function() {
        return this.$d.enableNetwork();
    }, t.prototype.disableNetwork = function() {
        return this.$d.disableNetwork();
    }, t.prototype.ei = function(t) {
        var e = this.Hd.get(t);
        if (e && e.qd) return $75536fd4bb2e2ab6$var$Wt().add(e.key);
        var n = $75536fd4bb2e2ab6$var$Wt(), r = this.Kd.get(t);
        if (!r) return n;
        for(var i = 0, o = r; i < o.length; i++){
            var s = o[i], u = this.jd.get(s);
            n = n.He(u.view.Pd);
        }
        return n;
    }, t;
}(), $75536fd4bb2e2ab6$var$gi = /** @class */ function(t) {
    function n(e, n, r, i, o) {
        var s = this;
        return (s = t.call(this, e, n, r, i, o) || this).N_ = e, // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        s.Rf = void 0, s;
    }
    return $8QG6t.__extends(n, t), Object.defineProperty(n.prototype, "tf", {
        get: function() {
            return !0 === this.Rf;
        },
        enumerable: !0,
        configurable: !0
    }), n.prototype.enableNetwork = function() {
        return this.N_.ao(!0), t.prototype.enableNetwork.call(this);
    }, n.prototype.disableNetwork = function() {
        return this.N_.ao(!1), t.prototype.disableNetwork.call(this);
    }, /**
     * Reconcile the list of synced documents in an existing view with those
     * from persistence.
     */ n.prototype.Af = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.N_.ju(t.query, /* usePreviousResults= */ !0)
                        ];
                    case 1:
                        return n = e.sent(), r = t.view.Fd(n), [
                            2 /*return*/ ,
                            (this.Rf && this.if(t.targetId, r.Sd), r)
                        ];
                }
            });
        });
    }, n.prototype.Dd = function(e, n) {
        // If we are the primary client, the online state of all clients only
        // depends on the online state of the local RemoteStore.
        this.tf && 0 /* RemoteStore */  === n && (t.prototype.Dd.call(this, e, n), this.Ud.sd(e)), // If we are the secondary client, we explicitly ignore the remote store's
        // online state (the local client may go offline, even though the primary
        // tab remains online) and only apply the primary tab's online state from
        // SharedClientState.
        this.tf || 1 /* SharedClientState */  !== n || t.prototype.Dd.call(this, e, n);
    }, n.prototype.dd = function(t, n, r) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var i;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.ef("applyBatchState()"), [
                            4 /*yield*/ ,
                            this.N_.zu(t)
                        ];
                    case 1:
                        return null === (i = e.sent()) ? [
                            3 /*break*/ ,
                            6
                        ] : "pending" !== n ? [
                            3 /*break*/ ,
                            3
                        ] : [
                            4 /*yield*/ ,
                            this.$d.el()
                        ];
                    case 2:
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        return e.sent(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
                        // other clients.
                        (this.cf(t, r || null), this.N_.Hu(t)) : $75536fd4bb2e2ab6$var$ge(), e.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            this.hf(i)
                        ];
                    case 5:
                        return e.sent(), [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        // A throttled tab may not have seen the mutation before it was completed
                        // and removed from the mutation queue, in which case we won't have cached
                        // the affected documents. In this case we can safely ignore the update
                        // since that means we didn't apply the mutation locally at all (if we
                        // had, we would have cached the affected documents), and so we will just
                        // see any resulting document changes via normal remote document updates
                        // as applicable.
                        $75536fd4bb2e2ab6$var$de("SyncEngine", "Cannot apply mutation batch with id: " + t), e.label = 7;
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n.prototype.Vl = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o, s, u, a, h = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return !0 !== t || !0 === this.Rf ? [
                            3 /*break*/ ,
                            3
                        ] : (n = this.Ud.Ul(), [
                            4 /*yield*/ ,
                            this.mf(n.W(), /*transitionToPrimary=*/ !0)
                        ]);
                    case 1:
                        return r = e.sent(), this.Rf = !0, [
                            4 /*yield*/ ,
                            this.$d.Vl(!0)
                        ];
                    case 2:
                        for(e.sent(), i = 0, o = r; i < o.length; i++)s = o[i], this.$d.listen(s);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        return !1 !== t || !1 === this.Rf ? [
                            3 /*break*/ ,
                            7
                        ] : (u = [], a = Promise.resolve(), this.Kd.forEach(function(t, e) {
                            h.Ud.Xl(e) ? u.push(e) : a = a.then(function() {
                                return h.nf(e), h.N_.Wu(e, /*keepPersistedTargetData=*/ !0);
                            }), h.$d.rl(e);
                        }), [
                            4 /*yield*/ ,
                            a
                        ]);
                    case 4:
                        return e.sent(), [
                            4 /*yield*/ ,
                            this.mf(u, /*transitionToPrimary=*/ !1)
                        ];
                    case 5:
                        return e.sent(), this.Pf(), this.Rf = !1, [
                            4 /*yield*/ ,
                            this.$d.Vl(!1)
                        ];
                    case 6:
                        e.sent(), e.label = 7;
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n.prototype.Pf = function() {
        var t = this;
        this.Hd.forEach(function(e, n) {
            t.$d.rl(n);
        }), this.Yd.rc(), this.Hd = new Map, this.zd = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N);
    }, /**
     * Reconcile the query views of the provided query targets with the state from
     * persistence. Raises snapshots for any changes that affect the local
     * client and returns the updated state of all target's query data.
     *
     * @param targets the list of targets with views that need to be recomputed
     * @param transitionToPrimary `true` iff the tab transitions from a secondary
     * tab to a primary tab
     */ n.prototype.mf = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o, s, u, a, h, c, f, l, p, d;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        n = [], r = [], i = 0, o = t, e.label = 1;
                    case 1:
                        return i < o.length ? (s = o[i], u = void 0, (a = this.Kd.get(s)) && 0 !== a.length ? [
                            4 /*yield*/ ,
                            this.N_.Wu(s, /*keepPersistedTargetData=*/ !0)
                        ] : [
                            3 /*break*/ ,
                            8
                        ]) : [
                            3 /*break*/ ,
                            14
                        ];
                    case 2:
                        // For queries that have a local View, we need to update their state
                        // in LocalStore (as the resume token and the snapshot version
                        // might have changed) and reconcile their views with the persisted
                        // state (the list of syncedDocuments may have gotten out of sync).
                        return e.sent(), [
                            4 /*yield*/ ,
                            this.N_.Qu(a[0].ee())
                        ];
                    case 3:
                        // For queries that have a local View, we need to update their state
                        // in LocalStore (as the resume token and the snapshot version
                        // might have changed) and reconcile their views with the persisted
                        // state (the list of syncedDocuments may have gotten out of sync).
                        u = e.sent(), h = 0, c = a, e.label = 4;
                    case 4:
                        return h < c.length ? (f = c[h], l = this.jd.get(f), [
                            4 /*yield*/ ,
                            this.Af(l)
                        ]) : [
                            3 /*break*/ ,
                            7
                        ];
                    case 5:
                        (p = e.sent()).snapshot && r.push(p.snapshot), e.label = 6;
                    case 6:
                        return h++, [
                            3 /*break*/ ,
                            4
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 8:
                        return [
                            4 /*yield*/ ,
                            this.N_.Yu(s)
                        ];
                    case 9:
                        return d = e.sent(), [
                            4 /*yield*/ ,
                            this.N_.Qu(d)
                        ];
                    case 10:
                        return u = e.sent(), [
                            4 /*yield*/ ,
                            this.sf(this.Vf(d), s, /*current=*/ !1)
                        ];
                    case 11:
                        e.sent(), e.label = 12;
                    case 12:
                        n.push(u), e.label = 13;
                    case 13:
                        return i++, [
                            3 /*break*/ ,
                            1
                        ];
                    case 14:
                        return [
                            2 /*return*/ ,
                            (this.Wd.i_(r), n)
                        ];
                }
            });
        });
    }, /**
     * Creates a `Query` object from the specified `Target`. There is no way to
     * obtain the original `Query`, so we synthesize a `Query` from the `Target`
     * object.
     *
     * The synthesized result might be different from the original `Query`, but
     * since the synthesized `Query` should return the same results as the
     * original one (only the presentation of results might differ), the potential
     * difference will not cause issues.
     */ n.prototype.Vf = function(t) {
        return new $75536fd4bb2e2ab6$var$wt(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* First */ , t.startAt, t.endAt);
    }, n.prototype.bo = function() {
        return this.N_.bo();
    }, n.prototype.fd = function(t, n, r) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var i, o;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.Rf ? // If we receive a target state notification via WebStorage, we are
                        // either already secondary or another tab has taken the primary lease.
                        ($75536fd4bb2e2ab6$var$de("SyncEngine", "Ignoring unexpected query state notification."), [
                            3 /*break*/ ,
                            8
                        ]) : [
                            3 /*break*/ ,
                            1
                        ];
                    case 1:
                        if (!this.Kd.has(t)) return [
                            3 /*break*/ ,
                            8
                        ];
                        switch(n){
                            case "current":
                            case "not-current":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "rejected":
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.N_.Kr()
                        ];
                    case 3:
                        return i = e.sent(), o = $75536fd4bb2e2ab6$var$Ht.ls(t, "current" === n), [
                            4 /*yield*/ ,
                            this.hf(i, o)
                        ];
                    case 4:
                        return e.sent(), [
                            3 /*break*/ ,
                            8
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.N_.Wu(t, /* keepPersistedTargetData */ !0)
                        ];
                    case 6:
                        return e.sent(), this.nf(t, r), [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $75536fd4bb2e2ab6$var$ge(), e.label = 8;
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n.prototype.Td = function(t, n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r, i, o, s, u, a, h, c, f, l, p = this;
            return $8QG6t.__generator(this, function(d) {
                switch(d.label){
                    case 0:
                        if (!this.Rf) return [
                            3 /*break*/ ,
                            10
                        ];
                        r = 0, i = t, d.label = 1;
                    case 1:
                        return r < i.length ? (o = i[r], this.Kd.has(o) ? // A target might have been added in a previous attempt
                        ($75536fd4bb2e2ab6$var$de("SyncEngine", "Adding an already active target " + o), [
                            3 /*break*/ ,
                            5
                        ]) : [
                            4 /*yield*/ ,
                            this.N_.Yu(o)
                        ]) : [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        return s = d.sent(), [
                            4 /*yield*/ ,
                            this.N_.Qu(s)
                        ];
                    case 3:
                        return u = d.sent(), [
                            4 /*yield*/ ,
                            this.sf(this.Vf(s), u.targetId, /*current=*/ !1)
                        ];
                    case 4:
                        d.sent(), this.$d.listen(u), d.label = 5;
                    case 5:
                        return r++, [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        a = function(t) {
                            return $8QG6t.__generator(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        return h.Kd.has(t) ? [
                                            4 /*yield*/ ,
                                            h.N_.Wu(t, /* keepPersistedTargetData */ !1).then(function() {
                                                p.$d.rl(t), p.nf(t);
                                            }).catch($75536fd4bb2e2ab6$var$er)
                                        ] : [
                                            3 /*break*/ ,
                                            2
                                        ];
                                    // Release queries that are still active.
                                    case 1:
                                        // Release queries that are still active.
                                        e.sent(), e.label = 2;
                                    case 2:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        }, h = this, c = 0, f = n, d.label = 7;
                    case 7:
                        return c < f.length ? (l = f[c], [
                            5 /*yield**/ ,
                            a(l)
                        ]) : [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        d.sent(), d.label = 9;
                    case 9:
                        return c++, [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n;
}($75536fd4bb2e2ab6$var$vi), $75536fd4bb2e2ab6$var$mi = function() {
    this.gf = void 0, this.pf = [];
}, $75536fd4bb2e2ab6$var$wi = /** @class */ function() {
    function t(t) {
        this.ol = t, this.yf = new $75536fd4bb2e2ab6$var$Ae(function(t) {
            return t.canonicalId();
        }), this.onlineState = "Unknown" /* Unknown */ , this.bf = new Set, this.ol.subscribe(this);
    }
    return t.prototype.listen = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o, s, u;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        if (n = t.query, r = !1, (i = this.yf.get(n)) || (r = !0, i = new $75536fd4bb2e2ab6$var$mi), !r) return [
                            3 /*break*/ ,
                            4
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), o = i, [
                            4 /*yield*/ ,
                            this.ol.listen(n)
                        ];
                    case 2:
                        return o.gf = e.sent(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        return s = e.sent(), u = $75536fd4bb2e2ab6$var$Qn(s, "Initialization of query '" + t.query + "' failed"), [
                            2 /*return*/ ,
                            void t.onError(u)
                        ];
                    case 4:
                        return this.yf.set(n, i), i.pf.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
                        t.Dd(this.onlineState), i.gf && t.vf(i.gf) && this.Sf(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.rl = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r, i, o;
            return $8QG6t.__generator(this, function(e) {
                return n = t.query, r = !1, (i = this.yf.get(n)) && (o = i.pf.indexOf(t)) >= 0 && (i.pf.splice(o, 1), r = 0 === i.pf.length), r ? [
                    2 /*return*/ ,
                    (this.yf.delete(n), this.ol.rl(n))
                ] : [
                    2 /*return*/ 
                ];
            });
        });
    }, t.prototype.i_ = function(t) {
        for(var e = !1, n = 0, r = t; n < r.length; n++){
            var i = r[n], o = i.query, s = this.yf.get(o);
            if (s) {
                for(var u = 0, a = s.pf; u < a.length; u++)a[u].vf(i) && (e = !0);
                s.gf = i;
            }
        }
        e && this.Sf();
    }, t.prototype.ff = function(t, e) {
        var n = this.yf.get(t);
        if (n) for(var r = 0, i = n.pf; r < i.length; r++)i[r].onError(e);
        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
        // after an error.
        this.yf.delete(t);
    }, t.prototype.af = function(t) {
        this.onlineState = t;
        var e = !1;
        this.yf.forEach(function(n, r) {
            for(var i = 0, o = r.pf; i < o.length; i++)// Run global snapshot listeners if a consistent snapshot has been emitted.
            o[i].Dd(t) && (e = !0);
        }), e && this.Sf();
    }, t.prototype.Df = function(t) {
        this.bf.add(t), // Immediately fire an initial event, indicating all existing listeners
        // are in-sync.
        t.next();
    }, t.prototype.Cf = function(t) {
        this.bf.delete(t);
    }, // Call all global snapshot listeners that have been set.
    t.prototype.Sf = function() {
        this.bf.forEach(function(t) {
            t.next();
        });
    }, t;
}(), $75536fd4bb2e2ab6$var$Ei = /** @class */ function() {
    function t(t, e, n) {
        this.query = t, this.Ff = e, /**
             * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
             * observer. This flag is set to true once we've actually raised an event.
             */ this.Nf = !1, this.$f = null, this.onlineState = "Unknown" /* Unknown */ , this.options = n || {};
    }
    return t.prototype.vf = function(t) {
        if (!this.options.includeMetadataChanges) {
            for(// Remove the metadata only changes.
            var e = [], n = 0, r = t.docChanges; n < r.length; n++){
                var i = r[n];
                3 /* Metadata */  !== i.type && e.push(i);
            }
            t = new $75536fd4bb2e2ab6$var$Jt(t.query, t.docs, t.ss, e, t.ns, t.fromCache, t.rs, /* excludesMetadataChanges= */ !0);
        }
        var o = !1;
        return this.Nf ? this.kf(t) && (this.Ff.next(t), o = !0) : this.Lf(t, this.onlineState) && (this.Mf(t), o = !0), this.$f = t, o;
    }, t.prototype.onError = function(t) {
        this.Ff.error(t);
    }, /** Returns whether a snapshot was raised. */ t.prototype.Dd = function(t) {
        this.onlineState = t;
        var e = !1;
        return this.$f && !this.Nf && this.Lf(this.$f, t) && (this.Mf(this.$f), e = !0), e;
    }, t.prototype.Lf = function(t, e) {
        // Always raise the first event when we're synced
        if (!t.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        var n = "Offline" /* Offline */  !== e;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return !(this.options.Of && n || t.docs.B() && "Offline" /* Offline */  !== e);
    // Raise data from cache if we have any documents or we are offline
    }, t.prototype.kf = function(t) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (t.docChanges.length > 0) return !0;
        var e = this.$f && this.$f.hasPendingWrites !== t.hasPendingWrites;
        return !(!t.rs && !e) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }, t.prototype.Mf = function(t) {
        t = $75536fd4bb2e2ab6$var$Jt.os(t.query, t.docs, t.ns, t.fromCache), this.Nf = !0, this.Ff.next(t);
    }, t;
}(), $75536fd4bb2e2ab6$var$bi = /** @class */ function() {
    function t() {}
    return t.prototype.Su = function(t) {
        this.xf = t;
    }, t.prototype.Zn = function(t, e, n, i) {
        var o = this;
        // Queries that match all documents don't benefit from using
        // IndexFreeQueries. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return e.te() || n.isEqual($75536fd4bb2e2ab6$var$g.min()) ? this.Bf(t, e) : this.xf.Yn(t, i).next(function(s) {
            var u = o.qf(e, s);
            return (e.oe() || e.ae()) && o.yd(e.Bt, u, i, n) ? o.Bf(t, e) : ($75536fd4bb2e2ab6$var$le() <= $ctGiR.LogLevel.DEBUG && $75536fd4bb2e2ab6$var$de("IndexFreeQueryEngine", "Re-using previous result from %s to execute query: %s", n.toString(), e.toString()), o.xf.Zn(t, e, n).next(function(t) {
                // We merge `previousResults` into `updateResults`, since
                // `updateResults` is already a DocumentMap. If a document is
                // contained in both lists, then its contents are the same.
                return u.forEach(function(e) {
                    t = t.Ae(e.key, e);
                }), t;
            }));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }, /** Applies the query filter and sorting to the provided documents.  */ t.prototype.qf = function(t, e) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        var n = new $75536fd4bb2e2ab6$var$Pt(function(e, n) {
            return t.se(e, n);
        });
        return e.forEach(function(e, r) {
            r instanceof $75536fd4bb2e2ab6$var$yt && t.matches(r) && (n = n.add(r));
        }), n;
    }, /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param sortedPreviousResults The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion The version of the snapshot when the query
     * was last synchronized.
     */ t.prototype.yd = function(t, e, n, r) {
        // The query needs to be refilled if a previously matching document no
        // longer matches.
        if (n.size !== e.size) return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        var i = "F" /* First */  === t ? e.last() : e.first();
        return !!i && (i.hasPendingWrites || i.version.S(r) > 0);
    }, t.prototype.Bf = function(t, e) {
        return $75536fd4bb2e2ab6$var$le() <= $ctGiR.LogLevel.DEBUG && $75536fd4bb2e2ab6$var$de("IndexFreeQueryEngine", "Using full collection scan to execute query:", e.toString()), this.xf.Zn(t, e, $75536fd4bb2e2ab6$var$g.min());
    }, t;
}(), $75536fd4bb2e2ab6$var$_i = /** @class */ function() {
    function t(t, e) {
        this.jn = t, this.hh = e, /**
             * The set of all mutations that have been sent but not yet been applied to
             * the backend.
             */ this.Wn = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Uf = 1, /** The last received stream token from the server, used to acknowledge which
             * responses the client has processed. Stream tokens are opaque checkpoint
             * markers whose only real value is their inclusion in the next request.
             */ this.lastStreamToken = $75536fd4bb2e2ab6$var$A.ht, /** An ordered mapping between documents and the mutations batch IDs. */ this.Qf = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$rr.Xu);
    }
    return t.prototype.Go = function(t) {
        return $75536fd4bb2e2ab6$var$xe.resolve(0 === this.Wn.length);
    }, t.prototype.zo = function(t, e, n) {
        var r = e.batchId, i = this.Wf(r, "acknowledged");
        return $75536fd4bb2e2ab6$var$me(0 === i), // Verify that the batch in the queue is the one to be acknowledged.
        this.Wn[i], this.lastStreamToken = n, $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.Yo = function(t) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.lastStreamToken);
    }, t.prototype.Jo = function(t, e) {
        return this.lastStreamToken = e, $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.Xo = function(t, e, n, r) {
        var i = this.Uf;
        this.Uf++, this.Wn.length > 0 && this.Wn[this.Wn.length - 1];
        var o = new $75536fd4bb2e2ab6$var$ke(i, e, n, r);
        this.Wn.push(o);
        // Track references by document key and index collection parents.
        for(var s = 0, u = r; s < u.length; s++){
            var a = u[s];
            this.Qf = this.Qf.add(new $75536fd4bb2e2ab6$var$rr(a.key, i)), this.jn.Dr(t, a.key.path.L());
        }
        return $75536fd4bb2e2ab6$var$xe.resolve(o);
    }, t.prototype.Zo = function(t, e) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.jf(e));
    }, t.prototype.ea = function(t, e) {
        var n = e + 1, r = this.Kf(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $75536fd4bb2e2ab6$var$xe.resolve(this.Wn.length > i ? this.Wn[i] : null);
    }, t.prototype.sa = function() {
        return $75536fd4bb2e2ab6$var$xe.resolve(0 === this.Wn.length ? -1 : this.Uf - 1);
    }, t.prototype.ia = function(t) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.Wn.slice());
    }, t.prototype.Gn = function(t, e) {
        var n = this, r = new $75536fd4bb2e2ab6$var$rr(e, 0), i = new $75536fd4bb2e2ab6$var$rr(e, Number.POSITIVE_INFINITY), o = [];
        return this.Qf.Ke([
            r,
            i
        ], function(t) {
            var e = n.jf(t.oc);
            o.push(e);
        }), $75536fd4bb2e2ab6$var$xe.resolve(o);
    }, t.prototype.Xn = function(t, e) {
        var n = this, r = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be);
        return e.forEach(function(t) {
            var e = new $75536fd4bb2e2ab6$var$rr(t, 0), i = new $75536fd4bb2e2ab6$var$rr(t, Number.POSITIVE_INFINITY);
            n.Qf.Ke([
                e,
                i
            ], function(t) {
                r = r.add(t.oc);
            });
        }), $75536fd4bb2e2ab6$var$xe.resolve(this.Gf(r));
    }, t.prototype.nr = function(t, e) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var n = e.path, r = n.length + 1, i = n;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        $75536fd4bb2e2ab6$var$_.et(i) || (i = i.child(""));
        var o = new $75536fd4bb2e2ab6$var$rr(new $75536fd4bb2e2ab6$var$_(i), 0), s = new $75536fd4bb2e2ab6$var$Pt($75536fd4bb2e2ab6$var$be);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        return this.Qf.Ge(function(t) {
            var e = t.key.path;
            return !!n.q(e) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (e.length === r && (s = s.add(t.oc)), !0);
        }, o), $75536fd4bb2e2ab6$var$xe.resolve(this.Gf(s));
    }, t.prototype.Gf = function(t) {
        var e = this, n = [];
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        return t.forEach(function(t) {
            var r = e.jf(t);
            null !== r && n.push(r);
        }), n;
    }, t.prototype.ra = function(t, e) {
        var n = this;
        $75536fd4bb2e2ab6$var$me(0 === this.Wf(e.batchId, "removed")), this.Wn.shift();
        var r = this.Qf;
        return $75536fd4bb2e2ab6$var$xe.forEach(e.mutations, function(i) {
            var o = new $75536fd4bb2e2ab6$var$rr(i.key, e.batchId);
            return r = r.delete(o), n.hh.Bo(t, i.key);
        }).next(function() {
            n.Qf = r;
        });
    }, t.prototype.ha = function(t) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }, t.prototype.Ch = function(t, e) {
        var n = new $75536fd4bb2e2ab6$var$rr(e, 0), r = this.Qf.ze(n);
        return $75536fd4bb2e2ab6$var$xe.resolve(e.isEqual(r && r.key));
    }, t.prototype.oa = function(t) {
        return this.Wn.length, $75536fd4bb2e2ab6$var$xe.resolve();
    }, /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ t.prototype.Wf = function(t, e) {
        return this.Kf(t);
    }, /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ t.prototype.Kf = function(t) {
        return 0 === this.Wn.length ? 0 : t - this.Wn[0].batchId;
    // Examine the front of the queue to figure out the difference between the
    // batchId and indexes in the array. Note that since the queue is ordered
    // by batchId, if the first batch has a larger batchId then the requested
    // batchId doesn't exist in the queue.
    }, /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ t.prototype.jf = function(t) {
        var e = this.Kf(t);
        return e < 0 || e >= this.Wn.length ? null : this.Wn[e];
    }, t;
}(), $75536fd4bb2e2ab6$var$Ti = /** @class */ function() {
    /**
     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
     * return 0 to avoid unnecessarily doing the work of calculating the size.
     */ function t(t, e) {
        this.jn = t, this.zf = e, /** Underlying cache of documents and their read times. */ this.docs = new $75536fd4bb2e2ab6$var$Lt($75536fd4bb2e2ab6$var$_.N), /** Size of all cached documents. */ this.size = 0;
    }
    return t.prototype.Nn = function(t, e, n) {
        var r = e.key, i = this.docs.get(r), o = i ? i.size : 0, s = this.zf(e);
        return this.docs = this.docs.Ae(r, {
            Mr: e,
            size: s,
            readTime: n
        }), this.size += s - o, this.jn.Dr(t, r.path.L());
    }, /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ t.prototype.kn = function(t) {
        var e = this.docs.get(t);
        e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }, t.prototype.Ln = function(t, e) {
        var n = this.docs.get(e);
        return $75536fd4bb2e2ab6$var$xe.resolve(n ? n.Mr : null);
    }, t.prototype.getEntries = function(t, e) {
        var n = this, r = $75536fd4bb2e2ab6$var$Mt();
        return e.forEach(function(t) {
            var e = n.docs.get(t);
            r = r.Ae(t, e ? e.Mr : null);
        }), $75536fd4bb2e2ab6$var$xe.resolve(r);
    }, t.prototype.Zn = function(t, e, n) {
        for(var r = $75536fd4bb2e2ab6$var$Ft(), i = new $75536fd4bb2e2ab6$var$_(e.path.child("")), o = this.docs.ve(i); o.$e();){
            var s = o.Ne(), u = s.key, a = s.value, h = a.Mr, c = a.readTime;
            if (!e.path.q(u.path)) break;
            c.S(n) <= 0 || h instanceof $75536fd4bb2e2ab6$var$yt && e.matches(h) && (r = r.Ae(h.key, h));
        }
        return $75536fd4bb2e2ab6$var$xe.resolve(r);
    }, t.prototype.Hf = function(t, e) {
        return $75536fd4bb2e2ab6$var$xe.forEach(this.docs, function(t) {
            return e(t);
        });
    }, t.prototype.Yr = function(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new t.Jr(this);
    }, t.prototype.Zr = function(t) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.size);
    }, t;
}();
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
/**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ $75536fd4bb2e2ab6$var$Ti.Jr = /** @class */ function(t) {
    function n(e) {
        var n = this;
        return (n = t.call(this) || this).th = e, n;
    }
    return $8QG6t.__extends(n, t), n.prototype.xn = function(t) {
        var e = this, n = [];
        return this.Dn.forEach(function(r, i) {
            i ? n.push(e.th.Nn(t, i, e.readTime)) : e.th.kn(r);
        }), $75536fd4bb2e2ab6$var$xe.vn(n);
    }, n.prototype.Mn = function(t, e) {
        return this.th.Ln(t, e);
    }, n.prototype.On = function(t, e) {
        return this.th.getEntries(t, e);
    }, n;
}($75536fd4bb2e2ab6$var$Se);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $75536fd4bb2e2ab6$var$Ii = /** @class */ function() {
    function t(t) {
        this.persistence = t, /**
             * Maps a target to the data about that target
             */ this.Yf = new $75536fd4bb2e2ab6$var$Ae(function(t) {
            return t.canonicalId();
        }), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $75536fd4bb2e2ab6$var$g.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Jf = 0, /**
             * A ordered bidirectional mapping between documents and the remote target
             * IDs.
             */ this.Xf = new $75536fd4bb2e2ab6$var$nr, this.targetCount = 0, this.Zf = $75536fd4bb2e2ab6$var$He.nh();
    }
    return t.prototype.js = function(t, e) {
        return this.Yf.forEach(function(t, n) {
            return e(n);
        }), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype._h = function(t) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.lastRemoteSnapshotVersion);
    }, t.prototype.lh = function(t) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.Jf);
    }, t.prototype.oh = function(t) {
        return this.highestTargetId = this.Zf.next(), $75536fd4bb2e2ab6$var$xe.resolve(this.highestTargetId);
    }, t.prototype.dh = function(t, e, n) {
        return n && (this.lastRemoteSnapshotVersion = n), e > this.Jf && (this.Jf = e), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.Th = function(t) {
        this.Yf.set(t.target, t);
        var e = t.targetId;
        e > this.highestTargetId && (this.Zf = new $75536fd4bb2e2ab6$var$He(e), this.highestTargetId = e), t.sequenceNumber > this.Jf && (this.Jf = t.sequenceNumber);
    }, t.prototype.fh = function(t, e) {
        return this.Th(e), this.targetCount += 1, $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.Ih = function(t, e) {
        return this.Th(e), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.wh = function(t, e) {
        return this.Yf.delete(e.target), this.Xf.nc(e.targetId), this.targetCount -= 1, $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.Ah = function(t, e, n) {
        var r = this, i = 0, o = [];
        return this.Yf.forEach(function(s, u) {
            u.sequenceNumber <= e && null === n.get(u.targetId) && (r.Yf.delete(s), o.push(r.Rh(t, u.targetId)), i++);
        }), $75536fd4bb2e2ab6$var$xe.vn(o).next(function() {
            return i;
        });
    }, t.prototype.Vh = function(t) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.targetCount);
    }, t.prototype.gh = function(t, e) {
        var n = this.Yf.get(e) || null;
        return $75536fd4bb2e2ab6$var$xe.resolve(n);
    }, t.prototype.ph = function(t, e, n) {
        return this.Xf.ec(e, n), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.bh = function(t, e, n) {
        this.Xf.ic(e, n);
        var r = this.persistence.hh, i = [];
        return r && e.forEach(function(e) {
            i.push(r.Bo(t, e));
        }), $75536fd4bb2e2ab6$var$xe.vn(i);
    }, t.prototype.Rh = function(t, e) {
        return this.Xf.nc(e), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.Sh = function(t, e) {
        var n = this.Xf.hc(e);
        return $75536fd4bb2e2ab6$var$xe.resolve(n);
    }, t.prototype.Ch = function(t, e) {
        return $75536fd4bb2e2ab6$var$xe.resolve(this.Xf.Ch(e));
    }, t;
}(), $75536fd4bb2e2ab6$var$Ni = /** @class */ function() {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ function t(t) {
        var e = this;
        this.tT = {}, this.Bh = new $75536fd4bb2e2ab6$var$Pe(0), this.qh = !1, this.qh = !0, this.hh = t(this), this.Yh = new $75536fd4bb2e2ab6$var$Ii(this), this.jn = new $75536fd4bb2e2ab6$var$Be, this.Qn = new $75536fd4bb2e2ab6$var$Ti(this.jn, function(t) {
            return e.hh.eT(t);
        });
    }
    return t.prototype.start = function() {
        return Promise.resolve();
    }, t.prototype.mo = function() {
        // No durable state to ensure is closed on shutdown.
        return this.qh = !1, Promise.resolve();
    }, Object.defineProperty(t.prototype, "ro", {
        get: function() {
            return this.qh;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.ho = function() {
    // No op.
    }, t.prototype.Fo = function() {
        return this.jn;
    }, t.prototype.vo = function(t) {
        var e = this.tT[t.s()];
        return e || (e = new $75536fd4bb2e2ab6$var$_i(this.jn, this.hh), this.tT[t.s()] = e), e;
    }, t.prototype.Do = function() {
        return this.Yh;
    }, t.prototype.Co = function() {
        return this.Qn;
    }, t.prototype.runTransaction = function(t, e, n) {
        var r = this;
        $75536fd4bb2e2ab6$var$de("MemoryPersistence", "Starting transaction:", t);
        var i = new $75536fd4bb2e2ab6$var$Ai(this.Bh.next());
        return this.hh.sT(), n(i).next(function(t) {
            return r.hh.iT(i).next(function() {
                return t;
            });
        }).yn().then(function(t) {
            return i.Un(), t;
        });
    }, t.prototype.nT = function(t, e) {
        return $75536fd4bb2e2ab6$var$xe.Sn(Object.values(this.tT).map(function(n) {
            return function() {
                return n.Ch(t, e);
            };
        }));
    }, t;
}(), $75536fd4bb2e2ab6$var$Ai = /** @class */ function(t) {
    function n(e) {
        var n = this;
        return (n = t.call(this) || this).Oh = e, n;
    }
    return $8QG6t.__extends(n, t), n;
}($75536fd4bb2e2ab6$var$Le), $75536fd4bb2e2ab6$var$ki = /** @class */ function() {
    function t(t) {
        this.persistence = t, /** Tracks all documents that are active in Query views. */ this.rT = new $75536fd4bb2e2ab6$var$nr, /** The list of documents that are potentially GCed after each transaction. */ this.hT = null;
    }
    return t.oT = function(e) {
        return new t(e);
    }, Object.defineProperty(t.prototype, "aT", {
        get: function() {
            if (this.hT) return this.hT;
            throw $75536fd4bb2e2ab6$var$ge();
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.yh = function(t, e, n) {
        return this.rT.yh(n, e), this.aT.delete(n), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.vh = function(t, e, n) {
        return this.rT.vh(n, e), this.aT.add(n), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.Bo = function(t, e) {
        return this.aT.add(e), $75536fd4bb2e2ab6$var$xe.resolve();
    }, t.prototype.removeTarget = function(t, e) {
        var n = this;
        this.rT.nc(e.targetId).forEach(function(t) {
            return n.aT.add(t);
        });
        var r = this.persistence.Do();
        return r.Sh(t, e.targetId).next(function(t) {
            t.forEach(function(t) {
                return n.aT.add(t);
            });
        }).next(function() {
            return r.wh(t, e);
        });
    }, t.prototype.sT = function() {
        this.hT = new Set;
    }, t.prototype.iT = function(t) {
        var e = this, n = this.persistence.Co().Yr();
        // Remove newly orphaned documents.
        return $75536fd4bb2e2ab6$var$xe.forEach(this.aT, function(r) {
            return e.uT(t, r).next(function(t) {
                t || n.kn(r);
            });
        }).next(function() {
            return e.hT = null, n.apply(t);
        });
    }, t.prototype.Wo = function(t, e) {
        var n = this;
        return this.uT(t, e).next(function(t) {
            t ? n.aT.delete(e) : n.aT.add(e);
        });
    }, t.prototype.eT = function(t) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }, t.prototype.uT = function(t, e) {
        var n = this;
        return $75536fd4bb2e2ab6$var$xe.Sn([
            function() {
                return $75536fd4bb2e2ab6$var$xe.resolve(n.rT.Ch(e));
            },
            function() {
                return n.persistence.Do().Ch(t, e);
            },
            function() {
                return n.persistence.nT(t, e);
            }
        ]);
    }, t;
}(), $75536fd4bb2e2ab6$var$Di = /** @class */ function() {
    function t() {}
    return t.prototype.initialize = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n = this;
            return $8QG6t.__generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.Ud = this.cT(t), this.persistence = this._T(t), [
                            4 /*yield*/ ,
                            this.persistence.start()
                        ];
                    case 1:
                        return e.sent(), this.lT = this.dT(t), this.N_ = this.fT(t), this.$d = this.TT(t), this.ol = this.ET(t), this.IT = this.wT(t), this.Ud.g_ = function(t) {
                            return n.ol.Dd(t, 1 /* SharedClientState */ );
                        }, this.$d.ol = this.ol, [
                            4 /*yield*/ ,
                            this.N_.start()
                        ];
                    case 2:
                        return e.sent(), [
                            4 /*yield*/ ,
                            this.Ud.start()
                        ];
                    case 3:
                        return e.sent(), [
                            4 /*yield*/ ,
                            this.$d.start()
                        ];
                    case 4:
                        return e.sent(), [
                            4 /*yield*/ ,
                            this.$d.Vl(this.ol.tf)
                        ];
                    case 5:
                        return e.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, t.prototype.wT = function(t) {
        return new $75536fd4bb2e2ab6$var$wi(this.ol);
    }, t.prototype.dT = function(t) {
        return null;
    }, t.prototype.fT = function(t) {
        return new $75536fd4bb2e2ab6$var$Zn(this.persistence, new $75536fd4bb2e2ab6$var$bi, t.RT);
    }, t.prototype._T = function(t) {
        return new $75536fd4bb2e2ab6$var$Ni($75536fd4bb2e2ab6$var$ki.oT);
    }, t.prototype.TT = function(t) {
        var e = this;
        return new $75536fd4bb2e2ab6$var$Zr(this.N_, t.T_, t.Aa, function(t) {
            return e.ol.Dd(t, 0 /* RemoteStore */ );
        }, t.platform.AT());
    }, t.prototype.cT = function(t) {
        return new $75536fd4bb2e2ab6$var$hi;
    }, t.prototype.ET = function(t) {
        return new $75536fd4bb2e2ab6$var$vi(this.N_, this.$d, this.Ud, t.RT, t.Qd);
    }, t.prototype.clearPersistence = function(t) {
        throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "You are using the memory-only build of Firestore. Persistence support is only available via the @firebase/firestore bundle or the firebase-firestore.js build.");
    }, t;
}(), $75536fd4bb2e2ab6$var$xi = /** @class */ function(t) {
    function n() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.initialize = function(n) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var r = this;
            return $8QG6t.__generator(this, function(i) {
                switch(i.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            t.prototype.initialize.call(this, n)
                        ];
                    case 1:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return i.sent(), [
                            4 /*yield*/ ,
                            this.persistence.no(function(t) {
                                return $8QG6t.__awaiter(r, void 0, void 0, function() {
                                    return $8QG6t.__generator(this, function(e) {
                                        switch(e.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    this.ol.Vl(t)
                                                ];
                                            case 1:
                                                return e.sent(), this.lT && (t && !this.lT.ro ? this.lT.start(this.N_) : t || this.lT.stop()), [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 2:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return i.sent(), [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, n.prototype.fT = function(t) {
        return new $75536fd4bb2e2ab6$var$tr(this.persistence, new $75536fd4bb2e2ab6$var$bi, t.RT);
    }, n.prototype.ET = function(t) {
        var e = new $75536fd4bb2e2ab6$var$gi(this.N_, this.$d, this.Ud, t.RT, t.Qd);
        return this.Ud instanceof $75536fd4bb2e2ab6$var$ai && (this.Ud.ol = e), e;
    }, n.prototype.dT = function(t) {
        var e = this.persistence.hh.ko;
        return new $75536fd4bb2e2ab6$var$Hn(e, t.Aa);
    }, n.prototype._T = function(t) {
        var e = $75536fd4bb2e2ab6$var$sn.$o(t.mT), n = t.platform.bc(t.mT.ii);
        return new $75536fd4bb2e2ab6$var$sn(t.PT.synchronizeTabs, e, t.clientId, t.platform, $75536fd4bb2e2ab6$var$Jn.hu(t.PT.cacheSizeBytes), t.Aa, n, this.Ud);
    }, n.prototype.cT = function(t) {
        if (t.PT.VT && t.PT.synchronizeTabs) {
            if (!$75536fd4bb2e2ab6$var$ai.Gh(t.platform)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
            var e = $75536fd4bb2e2ab6$var$sn.$o(t.mT);
            return new $75536fd4bb2e2ab6$var$ai(t.Aa, t.platform, e, t.clientId, t.RT);
        }
        return new $75536fd4bb2e2ab6$var$hi;
    }, n.prototype.clearPersistence = function(t) {
        var e = $75536fd4bb2e2ab6$var$sn.$o(t);
        return $75536fd4bb2e2ab6$var$sn.clearPersistence(e);
    }, n;
}($75536fd4bb2e2ab6$var$Di), $75536fd4bb2e2ab6$var$Si = /** @class */ function() {
    function t(t, e, n, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ r) {
        this.platform = t, this.mT = e, this.credentials = n, this.Aa = r, this.clientId = $75536fd4bb2e2ab6$var$Ee.cn();
    }
    return t.prototype.start = function(t, e) {
        var n = this;
        this.gT();
        // We defer our initialization until we get the current user from
        // setChangeListener(). We block the async queue until we got the initial
        // user and the initialization is completed. This will prevent any scheduled
        // work from happening before initialization is completed.
        // If initializationDone resolved then the FirestoreClient is in a usable
        // state.
        var r = new $75536fd4bb2e2ab6$var$Ue, i = new $75536fd4bb2e2ab6$var$Ue, o = !1;
        // If usePersistence is true, certain classes of errors while starting are
        // recoverable but only by falling back to persistence disabled.
        // If there's an error in the first case but not in recovery we cannot
        // reject the promise blocking the async queue because this will cause the
        // async queue to panic.
        // Return only the result of enabling persistence. Note that this does not
        // need to await the completion of initializationDone because the result of
        // this method should not reflect any other kind of failure to start.
        return this.credentials.l(function(s) {
            if (!o) return o = !0, $75536fd4bb2e2ab6$var$de("FirestoreClient", "Initializing. user=", s.uid), n.pT(t, e, s, i).then(r.resolve, r.reject);
            n.Aa.Ua(function() {
                return n.Pl(s);
            });
        }), // Block the async queue until initialization is done
        this.Aa.uo(function() {
            return r.promise;
        }), i.promise;
    }, /** Enables the network connection and requeues all pending operations. */ t.prototype.enableNetwork = function() {
        var t = this;
        return this.gT(), this.Aa.enqueue(function() {
            return t.ol.enableNetwork();
        });
    }, /**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param componentProvider The provider that provides all core componennts
     *     for IndexedDB or memory-backed persistence
     * @param persistenceSettings Settings object to configure offline persistence
     * @param user The initial user
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */ t.prototype.pT = function(t, n, r, i) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var o, s, u, a, h = this;
            return $8QG6t.__generator(this, function(c) {
                switch(c.label){
                    case 0:
                        return c.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]), [
                            4 /*yield*/ ,
                            this.platform.yT(this.mT)
                        ];
                    case 1:
                        return o = c.sent(), s = this.platform.bc(this.mT.ii), u = function(t, e, n) {
                            return new $75536fd4bb2e2ab6$var$Jr(t, e, n);
                        }(o, this.credentials, s), [
                            4 /*yield*/ ,
                            t.initialize({
                                Aa: this.Aa,
                                mT: this.mT,
                                platform: this.platform,
                                T_: u,
                                clientId: this.clientId,
                                RT: r,
                                Qd: 100,
                                PT: n
                            })
                        ];
                    case 2:
                        return c.sent(), this.persistence = t.persistence, this.Ud = t.Ud, this.N_ = t.N_, this.$d = t.$d, this.ol = t.ol, this.lT = t.lT, this.bT = t.IT, // When a user calls clearPersistence() in one client, all other clients
                        // need to be terminated to allow the delete to succeed.
                        this.persistence.ho(function() {
                            return $8QG6t.__awaiter(h, void 0, void 0, function() {
                                return $8QG6t.__generator(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.terminate()
                                            ];
                                        case 1:
                                            return t.sent(), [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }), i.resolve(), [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        // An unknown failure on the first stage shuts everything down.
                        if (a = c.sent(), // Regardless of whether or not the retry succeeds, from an user
                        // perspective, offline persistence has failed.
                        i.reject(a), !this.vT(a)) throw a;
                        return [
                            2 /*return*/ ,
                            (console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + a), this.pT(new $75536fd4bb2e2ab6$var$Di, {
                                VT: !1
                            }, r, i))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, /**
     * Decides whether the provided error allows us to gracefully disable
     * persistence (as opposed to crashing the client).
     */ t.prototype.vT = function(t) {
        return "FirebaseError" === t.name ? t.code === $75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION || t.code === $75536fd4bb2e2ab6$var$h.UNIMPLEMENTED : !("undefined" != typeof DOMException && t instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
        // or an aborted error depending on whether the error happened during
        // schema migration.
        22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
        // INVALID_STATE for any usage.
        11 === t.code;
    }, /**
     * Checks that the client has not been terminated. Ensures that other methods on
     * this class cannot be called after the client is terminated.
     */ t.prototype.gT = function() {
        if (this.Aa.La) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "The client has already been terminated.");
    }, t.prototype.Pl = function(t) {
        return this.Aa.Wa(), $75536fd4bb2e2ab6$var$de("FirestoreClient", "Credential Changed. Current user: " + t.uid), this.ol.Pl(t);
    }, /** Disables the network connection. Pending operations will not complete. */ t.prototype.disableNetwork = function() {
        var t = this;
        return this.gT(), this.Aa.enqueue(function() {
            return t.ol.disableNetwork();
        });
    }, t.prototype.terminate = function() {
        var t = this;
        return this.Aa.qa(function() {
            return $8QG6t.__awaiter(t, void 0, void 0, function() {
                return $8QG6t.__generator(this, function(t) {
                    switch(t.label){
                        case 0:
                            // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                            return this.lT && this.lT.stop(), [
                                4 /*yield*/ ,
                                this.$d.mo()
                            ];
                        case 1:
                            return t.sent(), [
                                4 /*yield*/ ,
                                this.Ud.mo()
                            ];
                        case 2:
                            return t.sent(), [
                                4 /*yield*/ ,
                                this.persistence.mo()
                            ];
                        case 3:
                            // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                            return t.sent(), // `removeChangeListener` must be called after shutting down the
                            // RemoteStore as it will prevent the RemoteStore from retrieving
                            // auth tokens.
                            this.credentials.T(), [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    }, /**
     * Returns a Promise that resolves when all writes that were pending at the time this
     * method was called received server acknowledgement. An acknowledgement can be either acceptance
     * or rejection.
     */ t.prototype.waitForPendingWrites = function() {
        var t = this;
        this.gT();
        var e = new $75536fd4bb2e2ab6$var$Ue;
        return this.Aa.uo(function() {
            return t.ol.lf(e);
        }), e.promise;
    }, t.prototype.listen = function(t, e, n) {
        var r = this;
        this.gT();
        var i = new $75536fd4bb2e2ab6$var$Ei(t, e, n);
        return this.Aa.uo(function() {
            return r.bT.listen(i);
        }), i;
    }, t.prototype.rl = function(t) {
        var e = this;
        // Checks for termination but does not raise error, allowing unlisten after
        // termination to be a no-op.
        this.ST || this.Aa.uo(function() {
            return e.bT.rl(t);
        });
    }, t.prototype.DT = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r = this;
            return $8QG6t.__generator(this, function(i) {
                switch(i.label){
                    case 0:
                        return this.gT(), n = new $75536fd4bb2e2ab6$var$Ue, [
                            4 /*yield*/ ,
                            this.Aa.enqueue(function() {
                                return $8QG6t.__awaiter(r, void 0, void 0, function() {
                                    var r, i, o;
                                    return $8QG6t.__generator(this, function(e) {
                                        switch(e.label){
                                            case 0:
                                                return e.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]), [
                                                    4 /*yield*/ ,
                                                    this.N_.Uu(t)
                                                ];
                                            case 1:
                                                return (r = e.sent()) instanceof $75536fd4bb2e2ab6$var$yt ? n.resolve(r) : r instanceof $75536fd4bb2e2ab6$var$vt ? n.resolve(null) : n.reject(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)")), [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                return i = e.sent(), o = $75536fd4bb2e2ab6$var$Qn(i, "Failed to get document '" + t + " from cache"), n.reject(o), [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 3:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (i.sent(), n.promise)
                        ];
                }
            });
        });
    }, t.prototype.CT = function(t) {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var n, r = this;
            return $8QG6t.__generator(this, function(i) {
                switch(i.label){
                    case 0:
                        return this.gT(), n = new $75536fd4bb2e2ab6$var$Ue, [
                            4 /*yield*/ ,
                            this.Aa.enqueue(function() {
                                return $8QG6t.__awaiter(r, void 0, void 0, function() {
                                    var r, i, o, s, u, a;
                                    return $8QG6t.__generator(this, function(e) {
                                        switch(e.label){
                                            case 0:
                                                return e.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]), [
                                                    4 /*yield*/ ,
                                                    this.N_.ju(t, /* usePreviousResults= */ !0)
                                                ];
                                            case 1:
                                                return r = e.sent(), i = new $75536fd4bb2e2ab6$var$li(t, r.Ku), o = i.Vd(r.documents), s = i.xn(o, /* updateLimboDocuments= */ !1), n.resolve(s.snapshot), [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                return u = e.sent(), a = $75536fd4bb2e2ab6$var$Qn(u, "Failed to execute query '" + t + " against cache"), n.reject(a), [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 3:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (i.sent(), n.promise)
                        ];
                }
            });
        });
    }, t.prototype.write = function(t) {
        var e = this;
        this.gT();
        var n = new $75536fd4bb2e2ab6$var$Ue;
        return this.Aa.uo(function() {
            return e.ol.write(t, n);
        }), n.promise;
    }, t.prototype.ii = function() {
        return this.mT.ii;
    }, t.prototype.Df = function(t) {
        var e = this;
        this.gT(), this.Aa.uo(function() {
            return e.bT.Df(t), Promise.resolve();
        });
    }, t.prototype.Cf = function(t) {
        var e = this;
        // Checks for shutdown but does not raise error, allowing remove after
        // shutdown to be a no-op.
        this.ST || this.Aa.uo(function() {
            return e.bT.Cf(t), Promise.resolve();
        });
    }, Object.defineProperty(t.prototype, "ST", {
        get: function() {
            // Technically, the asyncQueue is still running, but only accepting operations
            // related to termination or supposed to be run after termination. It is effectively
            // terminated to the eyes of users.
            return this.Aa.La;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.transaction = function(t) {
        var e = this;
        this.gT();
        var n = new $75536fd4bb2e2ab6$var$Ue;
        return this.Aa.uo(function() {
            return e.ol.runTransaction(e.Aa, t, n), Promise.resolve();
        }), n.promise;
    }, t;
}(), $75536fd4bb2e2ab6$var$Ri = /** @class */ function() {
    function t(t) {
        this.observer = t, /**
             * When set to true, will not raise future events. Necessary to deal with
             * async detachment of listener.
             */ this.muted = !1;
    }
    return t.prototype.next = function(t) {
        this.FT(this.observer.next, t);
    }, t.prototype.error = function(t) {
        this.FT(this.observer.error, t);
    }, t.prototype.NT = function() {
        this.muted = !0;
    }, t.prototype.FT = function(t, e) {
        var n = this;
        this.muted || setTimeout(function() {
            n.muted || t(e);
        }, 0);
    }, t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $75536fd4bb2e2ab6$var$Li(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function(t, e) {
        if ("object" != typeof t || null === t) return !1;
        for(var n = t, r = 0, i = [
            "next",
            "error",
            "complete"
        ]; r < i.length; r++){
            var o = i[r];
            if (o in n && "function" == typeof n[o]) return !0;
        }
        return !1;
    }(t);
}
var $75536fd4bb2e2ab6$var$Oi = /** @class */ function() {
    function t(t, e, n, r) {
        this.firestore = t, this.timestampsInSnapshots = e, this.$T = n, this.converter = r;
    }
    return t.prototype.kT = function(t) {
        switch($75536fd4bb2e2ab6$var$O(t)){
            case 0 /* NullValue */ :
                return null;
            case 1 /* BooleanValue */ :
                return t.booleanValue;
            case 2 /* NumberValue */ :
                return $75536fd4bb2e2ab6$var$j(t.integerValue || t.doubleValue);
            case 3 /* TimestampValue */ :
                return this.LT(t.timestampValue);
            case 4 /* ServerTimestampValue */ :
                return this.MT(t);
            case 5 /* StringValue */ :
                return t.stringValue;
            case 6 /* BlobValue */ :
                return new $75536fd4bb2e2ab6$var$Ir($75536fd4bb2e2ab6$var$F(t.bytesValue));
            case 7 /* RefValue */ :
                return this.OT(t.referenceValue);
            case 8 /* GeoPointValue */ :
                return this.xT(t.geoPointValue);
            case 9 /* ArrayValue */ :
                return this.BT(t.arrayValue);
            case 10 /* ObjectValue */ :
                return this.qT(t.mapValue);
            default:
                throw $75536fd4bb2e2ab6$var$ge();
        }
    }, t.prototype.qT = function(t) {
        var e = this, n = {};
        return $75536fd4bb2e2ab6$var$I(t.fields || {}, function(t, r) {
            n[t] = e.kT(r);
        }), n;
    }, t.prototype.xT = function(t) {
        return new $75536fd4bb2e2ab6$var$Or($75536fd4bb2e2ab6$var$j(t.latitude), $75536fd4bb2e2ab6$var$j(t.longitude));
    }, t.prototype.BT = function(t) {
        var e = this;
        return (t.values || []).map(function(t) {
            return e.kT(t);
        });
    }, t.prototype.MT = function(t) {
        switch(this.$T){
            case "previous":
                var e = function t(e) {
                    var n = e.mapValue.fields.__previous_value__;
                    return $75536fd4bb2e2ab6$var$S(n) ? t(n) : n;
                }(t);
                return null == e ? null : this.kT(e);
            case "estimate":
                return this.LT($75536fd4bb2e2ab6$var$R(t));
            default:
                return null;
        }
    }, t.prototype.LT = function(t) {
        var e = $75536fd4bb2e2ab6$var$M(t), n = new $75536fd4bb2e2ab6$var$v(e.seconds, e.nanos);
        return this.timestampsInSnapshots ? n : n.toDate();
    }, t.prototype.OT = function(t) {
        var e = $75536fd4bb2e2ab6$var$w.K(t);
        $75536fd4bb2e2ab6$var$me($75536fd4bb2e2ab6$var$he(e));
        var n = new $75536fd4bb2e2ab6$var$Ne(e.get(1), e.get(3)), r = new $75536fd4bb2e2ab6$var$_(e.k(5));
        return n.isEqual(this.firestore.$c) || // TODO(b/64130202): Somehow support foreign references.
        $75536fd4bb2e2ab6$var$ye("Document " + r + " contains a document reference within a different database (" + n.projectId + "/" + n.database + ") which is not supported. It will be treated as a reference in the current database (" + this.firestore.$c.projectId + "/" + this.firestore.$c.database + ") instead."), new $75536fd4bb2e2ab6$var$Mi(r, this.firestore, this.converter);
    }, t;
}(), $75536fd4bb2e2ab6$var$Vi = $75536fd4bb2e2ab6$var$Jn.uu, $75536fd4bb2e2ab6$var$Pi = /** @class */ function() {
    function t(t) {
        var e, n, r, i;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = !0;
        } else $75536fd4bb2e2ab6$var$cr("settings", "non-empty string", "host", t.host), this.host = t.host, $75536fd4bb2e2ab6$var$fr("settings", "boolean", "ssl", t.ssl), this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if ($75536fd4bb2e2ab6$var$gr("settings", t, [
            "host",
            "ssl",
            "credentials",
            "timestampsInSnapshots",
            "cacheSizeBytes",
            "experimentalForceLongPolling",
            "ignoreUndefinedProperties"
        ]), $75536fd4bb2e2ab6$var$fr("settings", "object", "credentials", t.credentials), this.credentials = t.credentials, $75536fd4bb2e2ab6$var$fr("settings", "boolean", "timestampsInSnapshots", t.timestampsInSnapshots), $75536fd4bb2e2ab6$var$fr("settings", "boolean", "ignoreUndefinedProperties", t.ignoreUndefinedProperties), // Nobody should set timestampsInSnapshots anymore, but the error depends on
        // whether they set it to true or false...
        !0 === t.timestampsInSnapshots ? $75536fd4bb2e2ab6$var$ye("The setting 'timestampsInSnapshots: true' is no longer required and should be removed.") : !1 === t.timestampsInSnapshots && $75536fd4bb2e2ab6$var$ye("Support for 'timestampsInSnapshots: false' will be removed soon. You must update your code to handle Timestamp objects."), this.timestampsInSnapshots = null === (n = t.timestampsInSnapshots) || void 0 === n || n, this.ignoreUndefinedProperties = null !== (r = t.ignoreUndefinedProperties) && void 0 !== r && r, $75536fd4bb2e2ab6$var$fr("settings", "number", "cacheSizeBytes", t.cacheSizeBytes), void 0 === t.cacheSizeBytes) this.cacheSizeBytes = $75536fd4bb2e2ab6$var$Jn._u;
        else {
            if (t.cacheSizeBytes !== $75536fd4bb2e2ab6$var$Vi && t.cacheSizeBytes < $75536fd4bb2e2ab6$var$Jn.cu) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + $75536fd4bb2e2ab6$var$Jn.cu);
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        $75536fd4bb2e2ab6$var$fr("settings", "boolean", "experimentalForceLongPolling", t.experimentalForceLongPolling), this.forceLongPolling = null !== (i = t.experimentalForceLongPolling) && void 0 !== i && i;
    }
    return t.prototype.isEqual = function(t) {
        return this.host === t.host && this.ssl === t.ssl && this.timestampsInSnapshots === t.timestampsInSnapshots && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.forceLongPolling === t.forceLongPolling && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties;
    }, t;
}(), $75536fd4bb2e2ab6$var$Ui = /** @class */ function() {
    // Note: We are using `MemoryComponentProvider` as a default
    // ComponentProvider to ensure backwards compatibility with the format
    // expected by the console build.
    function t(n, r, i) {
        var o = this;
        if (void 0 === i && (i = new $75536fd4bb2e2ab6$var$Di), this.UT = null, // Public for use in tests.
        // TODO(mikelehen): Use modularized initialization instead.
        this.QT = new $75536fd4bb2e2ab6$var$Wn, this.INTERNAL = {
            delete: function() {
                return $8QG6t.__awaiter(o, void 0, void 0, function() {
                    return $8QG6t.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                // The client must be initalized to ensure that all subsequent API usage
                                // throws an exception.
                                return this.WT(), [
                                    4 /*yield*/ ,
                                    this.jT.terminate()
                                ];
                            case 1:
                                // The client must be initalized to ensure that all subsequent API usage
                                // throws an exception.
                                return t.sent(), [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }
        }, "object" == typeof n.options) {
            // This is very likely a Firebase app object
            // TODO(b/34177605): Can we somehow use instanceof?
            var s = n;
            this.UT = s, this.$c = t.KT(s), this.GT = s.name, this.zT = new $75536fd4bb2e2ab6$var$p(r);
        } else {
            var u = n;
            if (!u.projectId) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Must provide projectId");
            this.$c = new $75536fd4bb2e2ab6$var$Ne(u.projectId, u.database), // Use a default persistenceKey that lines up with FirebaseApp.
            this.GT = "[DEFAULT]", this.zT = new $75536fd4bb2e2ab6$var$l;
        }
        this.HT = i, this.YT = new $75536fd4bb2e2ab6$var$Pi({});
    }
    return Object.defineProperty(t.prototype, "JT", {
        get: function() {
            return this.XT || // Lazy initialize UserDataReader once the settings are frozen
            (this.XT = new $75536fd4bb2e2ab6$var$Mr(this.$c, this.YT.ignoreUndefinedProperties)), this.XT;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.settings = function(t) {
        $75536fd4bb2e2ab6$var$or("Firestore.settings", arguments, 1), $75536fd4bb2e2ab6$var$ar("Firestore.settings", "object", 1, t);
        var e = new $75536fd4bb2e2ab6$var$Pi(t);
        if (this.jT && !this.YT.isEqual(e)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only call settings() before calling any other methods on a Firestore object.");
        this.YT = e, void 0 !== e.credentials && (this.zT = function(t) {
            if (!t) return new $75536fd4bb2e2ab6$var$l;
            switch(t.type){
                case "gapi":
                    var e = t.ZT;
                    // Make sure this really is a Gapi client.
                    return $75536fd4bb2e2ab6$var$me(!("object" != typeof e || null === e || !e.auth || !e.auth.getAuthHeaderValueForFirstParty)), new $75536fd4bb2e2ab6$var$y(e, t.V || "0");
                case "provider":
                    return t.ZT;
                default:
                    throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "makeCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }, t.prototype.enableNetwork = function() {
        return this.WT(), this.jT.enableNetwork();
    }, t.prototype.disableNetwork = function() {
        return this.WT(), this.jT.disableNetwork();
    }, t.prototype.enablePersistence = function(t) {
        var e, n;
        if (this.jT) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only call enablePersistence() before calling any other methods on a Firestore object.");
        var r = !1;
        return t && (void 0 !== t.experimentalTabSynchronization && $75536fd4bb2e2ab6$var$ye("The 'experimentalTabSynchronization' setting will be removed. Use 'synchronizeTabs' instead."), r = null !== (n = null !== (e = t.synchronizeTabs) && void 0 !== e ? e : t.experimentalTabSynchronization) && void 0 !== n && n), this.tE(this.HT, {
            VT: !0,
            cacheSizeBytes: this.YT.cacheSizeBytes,
            synchronizeTabs: r
        });
    }, t.prototype.clearPersistence = function() {
        return $8QG6t.__awaiter(this, void 0, void 0, function() {
            var t, n = this;
            return $8QG6t.__generator(this, function(r) {
                if (void 0 !== this.jT && !this.jT.ST) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "Persistence cannot be cleared after this Firestore instance is initialized.");
                return t = new $75536fd4bb2e2ab6$var$Ue, [
                    2 /*return*/ ,
                    (this.QT.Ma(function() {
                        return $8QG6t.__awaiter(n, void 0, void 0, function() {
                            var n, r;
                            return $8QG6t.__generator(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        return e.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]), n = this.eE(), [
                                            4 /*yield*/ ,
                                            this.HT.clearPersistence(n)
                                        ];
                                    case 1:
                                        return e.sent(), t.resolve(), [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 2:
                                        return r = e.sent(), t.reject(r), [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    }), t.promise)
                ];
            });
        });
    }, t.prototype.terminate = function() {
        return this.app._removeServiceInstance("firestore"), this.INTERNAL.delete();
    }, Object.defineProperty(t.prototype, "sE", {
        get: function() {
            return this.WT(), this.jT.ST;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.waitForPendingWrites = function() {
        return this.WT(), this.jT.waitForPendingWrites();
    }, t.prototype.onSnapshotsInSync = function(t) {
        if (this.WT(), $75536fd4bb2e2ab6$var$Li(t)) return this.iE(t);
        $75536fd4bb2e2ab6$var$ar("Firestore.onSnapshotsInSync", "function", 1, t);
        var e = {
            next: t
        };
        return this.iE(e);
    }, t.prototype.iE = function(t) {
        var e = this, n = new $75536fd4bb2e2ab6$var$Ri({
            next: function() {
                t.next && t.next();
            },
            error: function(t) {
                throw $75536fd4bb2e2ab6$var$ge();
            }
        });
        return this.jT.Df(n), function() {
            n.NT(), e.jT.Cf(n);
        };
    }, t.prototype.WT = function() {
        return this.jT || // Kick off starting the client but don't actually wait for it.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.tE(new $75536fd4bb2e2ab6$var$Di, {
            VT: !1
        }), this.jT;
    }, t.prototype.eE = function() {
        return new $75536fd4bb2e2ab6$var$Ie(this.$c, this.GT, this.YT.host, this.YT.ssl, this.YT.forceLongPolling);
    }, t.prototype.tE = function(t, e) {
        var n = this.eE();
        return this.jT = new $75536fd4bb2e2ab6$var$Si($75536fd4bb2e2ab6$var$ce.nt(), n, this.zT, this.QT), this.jT.start(t, e);
    }, t.KT = function(t) {
        if (e = t.options, !Object.prototype.hasOwnProperty.call(e, "projectId")) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        var e, n = t.options.projectId;
        /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to prevent instantiation through the constructor.
 *
 * This method creates a new constructor that throws when it's invoked.
 * The prototype of that constructor is then set to the prototype of the hidden
 * "class" to expose all the prototype methods and allow for instanceof
 * checks.
 *
 * To also make all the static methods available, all properties of the
 * original constructor are copied to the new constructor.
 */ if (!n || "string" != typeof n) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "projectId must be a string in FirebaseApp.options");
        return new $75536fd4bb2e2ab6$var$Ne(n);
    }, Object.defineProperty(t.prototype, "app", {
        get: function() {
            if (!this.UT) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
            return this.UT;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.collection = function(t) {
        return $75536fd4bb2e2ab6$var$or("Firestore.collection", arguments, 1), $75536fd4bb2e2ab6$var$ar("Firestore.collection", "non-empty string", 1, t), this.WT(), new $75536fd4bb2e2ab6$var$Wi($75536fd4bb2e2ab6$var$w.K(t), this);
    }, t.prototype.doc = function(t) {
        return $75536fd4bb2e2ab6$var$or("Firestore.doc", arguments, 1), $75536fd4bb2e2ab6$var$ar("Firestore.doc", "non-empty string", 1, t), this.WT(), $75536fd4bb2e2ab6$var$Mi.nE($75536fd4bb2e2ab6$var$w.K(t), this);
    }, t.prototype.collectionGroup = function(t) {
        if ($75536fd4bb2e2ab6$var$or("Firestore.collectionGroup", arguments, 1), $75536fd4bb2e2ab6$var$ar("Firestore.collectionGroup", "non-empty string", 1, t), t.indexOf("/") >= 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid collection ID '" + t + "' passed to function Firestore.collectionGroup(). Collection IDs must not contain '/'.");
        return this.WT(), new $75536fd4bb2e2ab6$var$zi(new $75536fd4bb2e2ab6$var$wt($75536fd4bb2e2ab6$var$w.G, t), this);
    }, t.prototype.runTransaction = function(t) {
        var e = this;
        return $75536fd4bb2e2ab6$var$or("Firestore.runTransaction", arguments, 1), $75536fd4bb2e2ab6$var$ar("Firestore.runTransaction", "function", 1, t), this.WT().transaction(function(n) {
            return t(new $75536fd4bb2e2ab6$var$Ci(e, n));
        });
    }, t.prototype.batch = function() {
        return this.WT(), new $75536fd4bb2e2ab6$var$qi(this);
    }, Object.defineProperty(t, "logLevel", {
        get: function() {
            switch($75536fd4bb2e2ab6$var$le()){
                case $ctGiR.LogLevel.DEBUG:
                    return "debug";
                case $ctGiR.LogLevel.SILENT:
                    return "silent";
                default:
                    // The default log level is error
                    return "error";
            }
        },
        enumerable: !0,
        configurable: !0
    }), t.setLogLevel = function(t) {
        switch($75536fd4bb2e2ab6$var$or("Firestore.setLogLevel", arguments, 1), $75536fd4bb2e2ab6$var$ar("Firestore.setLogLevel", "non-empty string", 1, t), t){
            case "debug":
                $75536fd4bb2e2ab6$var$pe($ctGiR.LogLevel.DEBUG);
                break;
            case "error":
                $75536fd4bb2e2ab6$var$pe($ctGiR.LogLevel.ERROR);
                break;
            case "silent":
                $75536fd4bb2e2ab6$var$pe($ctGiR.LogLevel.SILENT);
                break;
            default:
                throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid log level: " + t);
        }
    }, // Note: this is not a property because the minifier can't work correctly with
    // the way TypeScript compiler outputs properties.
    t.prototype.rE = function() {
        return this.YT.timestampsInSnapshots;
    }, t;
}(), $75536fd4bb2e2ab6$var$Ci = /** @class */ function() {
    function t(t, e) {
        this.hE = t, this.oE = e;
    }
    return t.prototype.get = function(t) {
        var e = this;
        $75536fd4bb2e2ab6$var$or("Transaction.get", arguments, 1);
        var n = $75536fd4bb2e2ab6$var$$i("Transaction.get", t, this.hE);
        return this.oE.A_([
            n.kc
        ]).then(function(t) {
            if (!t || 1 !== t.length) return $75536fd4bb2e2ab6$var$ge();
            var r = t[0];
            if (r instanceof $75536fd4bb2e2ab6$var$vt) return new $75536fd4bb2e2ab6$var$Fi(e.hE, n.kc, null, /* fromCache= */ !1, /* hasPendingWrites= */ !1, n.aE);
            if (r instanceof $75536fd4bb2e2ab6$var$yt) return new $75536fd4bb2e2ab6$var$Fi(e.hE, n.kc, r, /* fromCache= */ !1, /* hasPendingWrites= */ !1, n.aE);
            throw $75536fd4bb2e2ab6$var$ge();
        });
    }, t.prototype.set = function(t, e, n) {
        $75536fd4bb2e2ab6$var$ur("Transaction.set", arguments, 2, 3);
        var r = $75536fd4bb2e2ab6$var$$i("Transaction.set", t, this.hE);
        n = $75536fd4bb2e2ab6$var$Qi("Transaction.set", n);
        var i = $75536fd4bb2e2ab6$var$Hi(r.aE, e, "Transaction.set"), o = i[0], s = i[1], u = n.merge || n.mergeFields ? this.hE.JT.Dc(s, o, n.mergeFields) : this.hE.JT.vc(s, o);
        return this.oE.set(r.kc, u), this;
    }, t.prototype.update = function(t, e, n) {
        for(var r, i, o = [], s = 3; s < arguments.length; s++)o[s - 3] = arguments[s];
        return "string" == typeof e || e instanceof $75536fd4bb2e2ab6$var$Nr ? ($75536fd4bb2e2ab6$var$sr("Transaction.update", arguments, 3), r = $75536fd4bb2e2ab6$var$$i("Transaction.update", t, this.hE), i = this.hE.JT.Fc("Transaction.update", e, n, o)) : ($75536fd4bb2e2ab6$var$or("Transaction.update", arguments, 2), r = $75536fd4bb2e2ab6$var$$i("Transaction.update", t, this.hE), i = this.hE.JT.Cc("Transaction.update", e)), this.oE.update(r.kc, i), this;
    }, t.prototype.delete = function(t) {
        $75536fd4bb2e2ab6$var$or("Transaction.delete", arguments, 1);
        var e = $75536fd4bb2e2ab6$var$$i("Transaction.delete", t, this.hE);
        return this.oE.delete(e.kc), this;
    }, t;
}(), $75536fd4bb2e2ab6$var$qi = /** @class */ function() {
    function t(t) {
        this.hE = t, this.uE = [], this.cE = !1;
    }
    return t.prototype.set = function(t, e, n) {
        $75536fd4bb2e2ab6$var$ur("WriteBatch.set", arguments, 2, 3), this._E();
        var r = $75536fd4bb2e2ab6$var$$i("WriteBatch.set", t, this.hE);
        n = $75536fd4bb2e2ab6$var$Qi("WriteBatch.set", n);
        var i = $75536fd4bb2e2ab6$var$Hi(r.aE, e, "WriteBatch.set"), o = i[0], s = i[1], u = n.merge || n.mergeFields ? this.hE.JT.Dc(s, o, n.mergeFields) : this.hE.JT.vc(s, o);
        return this.uE = this.uE.concat(u.Ac(r.kc, $75536fd4bb2e2ab6$var$nt.ft())), this;
    }, t.prototype.update = function(t, e, n) {
        for(var r, i, o = [], s = 3; s < arguments.length; s++)o[s - 3] = arguments[s];
        return this._E(), "string" == typeof e || e instanceof $75536fd4bb2e2ab6$var$Nr ? ($75536fd4bb2e2ab6$var$sr("WriteBatch.update", arguments, 3), r = $75536fd4bb2e2ab6$var$$i("WriteBatch.update", t, this.hE), i = this.hE.JT.Fc("WriteBatch.update", e, n, o)) : ($75536fd4bb2e2ab6$var$or("WriteBatch.update", arguments, 2), r = $75536fd4bb2e2ab6$var$$i("WriteBatch.update", t, this.hE), i = this.hE.JT.Cc("WriteBatch.update", e)), this.uE = this.uE.concat(i.Ac(r.kc, $75536fd4bb2e2ab6$var$nt.exists(!0))), this;
    }, t.prototype.delete = function(t) {
        $75536fd4bb2e2ab6$var$or("WriteBatch.delete", arguments, 1), this._E();
        var e = $75536fd4bb2e2ab6$var$$i("WriteBatch.delete", t, this.hE);
        return this.uE = this.uE.concat(new $75536fd4bb2e2ab6$var$ut(e.kc, $75536fd4bb2e2ab6$var$nt.ft())), this;
    }, t.prototype.commit = function() {
        return this._E(), this.cE = !0, this.uE.length > 0 ? this.hE.WT().write(this.uE) : Promise.resolve();
    }, t.prototype._E = function() {
        if (this.cE) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }, t;
}(), $75536fd4bb2e2ab6$var$Mi = /** @class */ function() {
    function t(t, e, n) {
        this.kc = t, this.firestore = e, this.aE = n, this.jT = this.firestore.WT();
    }
    return t.nE = function(e, n, r) {
        if (e.length % 2 != 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + e.j() + " has " + e.length);
        return new t(new $75536fd4bb2e2ab6$var$_(e), n, r);
    }, Object.defineProperty(t.prototype, "id", {
        get: function() {
            return this.kc.path.O();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "parent", {
        get: function() {
            return new $75536fd4bb2e2ab6$var$Wi(this.kc.path.L(), this.firestore, this.aE);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "path", {
        get: function() {
            return this.kc.path.j();
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.collection = function(t) {
        if ($75536fd4bb2e2ab6$var$or("DocumentReference.collection", arguments, 1), $75536fd4bb2e2ab6$var$ar("DocumentReference.collection", "non-empty string", 1, t), !t) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Must provide a non-empty collection name to collection()");
        var e = $75536fd4bb2e2ab6$var$w.K(t);
        return new $75536fd4bb2e2ab6$var$Wi(this.kc.path.child(e), this.firestore);
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) throw $75536fd4bb2e2ab6$var$mr("isEqual", "DocumentReference", 1, e);
        return this.firestore === e.firestore && this.kc.isEqual(e.kc) && this.aE === e.aE;
    }, t.prototype.set = function(t, e) {
        $75536fd4bb2e2ab6$var$ur("DocumentReference.set", arguments, 1, 2), e = $75536fd4bb2e2ab6$var$Qi("DocumentReference.set", e);
        var n = $75536fd4bb2e2ab6$var$Hi(this.aE, t, "DocumentReference.set"), r = n[0], i = n[1], o = e.merge || e.mergeFields ? this.firestore.JT.Dc(i, r, e.mergeFields) : this.firestore.JT.vc(i, r);
        return this.jT.write(o.Ac(this.kc, $75536fd4bb2e2ab6$var$nt.ft()));
    }, t.prototype.update = function(t, e) {
        for(var n, r = [], i = 2; i < arguments.length; i++)r[i - 2] = arguments[i];
        return "string" == typeof t || t instanceof $75536fd4bb2e2ab6$var$Nr ? ($75536fd4bb2e2ab6$var$sr("DocumentReference.update", arguments, 2), n = this.firestore.JT.Fc("DocumentReference.update", t, e, r)) : ($75536fd4bb2e2ab6$var$or("DocumentReference.update", arguments, 1), n = this.firestore.JT.Cc("DocumentReference.update", t)), this.jT.write(n.Ac(this.kc, $75536fd4bb2e2ab6$var$nt.exists(!0)));
    }, t.prototype.delete = function() {
        return $75536fd4bb2e2ab6$var$or("DocumentReference.delete", arguments, 0), this.jT.write([
            new $75536fd4bb2e2ab6$var$ut(this.kc, $75536fd4bb2e2ab6$var$nt.ft())
        ]);
    }, t.prototype.onSnapshot = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        $75536fd4bb2e2ab6$var$ur("DocumentReference.onSnapshot", arguments, 1, 4);
        var n, r = {
            includeMetadataChanges: !1
        }, i = 0;
        "object" != typeof t[i] || $75536fd4bb2e2ab6$var$Li(t[i]) || ($75536fd4bb2e2ab6$var$gr("DocumentReference.onSnapshot", r = t[i], [
            "includeMetadataChanges"
        ]), $75536fd4bb2e2ab6$var$fr("DocumentReference.onSnapshot", "boolean", "includeMetadataChanges", r.includeMetadataChanges), i++);
        var o = {
            includeMetadataChanges: r.includeMetadataChanges
        };
        return $75536fd4bb2e2ab6$var$Li(t[i]) ? n = t[i] : ($75536fd4bb2e2ab6$var$ar("DocumentReference.onSnapshot", "function", i, t[i]), $75536fd4bb2e2ab6$var$hr("DocumentReference.onSnapshot", "function", i + 1, t[i + 1]), $75536fd4bb2e2ab6$var$hr("DocumentReference.onSnapshot", "function", i + 2, t[i + 2]), n = {
            next: t[i],
            error: t[i + 1],
            complete: t[i + 2]
        }), this.lE(o, n);
    }, t.prototype.lE = function(t, e) {
        var n = this, r = function(t) {
            console.error("Uncaught Error in onSnapshot:", t);
        };
        e.error && (r = e.error.bind(e));
        var i = new $75536fd4bb2e2ab6$var$Ri({
            next: function(t) {
                if (e.next) {
                    var r = t.docs.get(n.kc);
                    e.next(new $75536fd4bb2e2ab6$var$Fi(n.firestore, n.kc, r, t.fromCache, t.hasPendingWrites, n.aE));
                }
            },
            error: r
        }), o = this.jT.listen($75536fd4bb2e2ab6$var$wt.Wt(this.kc.path), i, t);
        return function() {
            i.NT(), n.jT.rl(o);
        };
    }, t.prototype.get = function(t) {
        var e = this;
        return $75536fd4bb2e2ab6$var$ur("DocumentReference.get", arguments, 0, 1), $75536fd4bb2e2ab6$var$Yi("DocumentReference.get", t), new Promise(function(n, r) {
            t && "cache" === t.source ? e.firestore.WT().DT(e.kc).then(function(t) {
                n(new $75536fd4bb2e2ab6$var$Fi(e.firestore, e.kc, t, /*fromCache=*/ !0, t instanceof $75536fd4bb2e2ab6$var$yt && t.At, e.aE));
            }, r) : e.dE(n, r, t);
        });
    }, t.prototype.dE = function(t, e, n) {
        var r = this.lE({
            includeMetadataChanges: !0,
            Of: !0
        }, {
            next: function(i) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                r(), !i.exists && i.metadata.fromCache ? // TODO(dimond): If we're online and the document doesn't
                // exist then we resolve with a doc.exists set to false. If
                // we're offline however, we reject the Promise in this
                // case. Two options: 1) Cache the negative response from
                // the server so we can deliver that even when you're
                // offline 2) Actually reject the Promise in the online case
                // if the document doesn't exist.
                e(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNAVAILABLE, "Failed to get document because the client is offline.")) : i.exists && i.metadata.fromCache && n && "server" === n.source ? e(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : t(i);
            },
            error: e
        });
    }, t.prototype.withConverter = function(e) {
        return new t(this.kc, this.firestore, e);
    }, t;
}(), $75536fd4bb2e2ab6$var$ji = /** @class */ function() {
    function t(t, e) {
        this.hasPendingWrites = t, this.fromCache = e;
    }
    return t.prototype.isEqual = function(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }, t;
}(), $75536fd4bb2e2ab6$var$Fi = /** @class */ function() {
    function t(t, e, n, r, i, o) {
        this.hE = t, this.kc = e, this.fE = n, this.TE = r, this.EE = i, this.aE = o;
    }
    return t.prototype.data = function(t) {
        if ($75536fd4bb2e2ab6$var$ur("DocumentSnapshot.data", arguments, 0, 1), t = $75536fd4bb2e2ab6$var$Ki("DocumentSnapshot.data", t), this.fE) {
            // We only want to use the converter and create a new DocumentSnapshot
            // if a converter has been provided.
            if (this.aE) {
                var e = new $75536fd4bb2e2ab6$var$Bi(this.hE, this.kc, this.fE, this.TE, this.EE);
                return this.aE.fromFirestore(e, t);
            }
            return new $75536fd4bb2e2ab6$var$Oi(this.hE, this.hE.rE(), t.serverTimestamps, /* converter= */ void 0).kT(this.fE.Lt());
        }
    }, t.prototype.get = function(t, e) {
        if ($75536fd4bb2e2ab6$var$ur("DocumentSnapshot.get", arguments, 1, 2), e = $75536fd4bb2e2ab6$var$Ki("DocumentSnapshot.get", e), this.fE) {
            var n = this.fE.data().field($75536fd4bb2e2ab6$var$Gr("DocumentSnapshot.get", t));
            if (null !== n) return new $75536fd4bb2e2ab6$var$Oi(this.hE, this.hE.rE(), e.serverTimestamps, this.aE).kT(n);
        }
    }, Object.defineProperty(t.prototype, "id", {
        get: function() {
            return this.kc.path.O();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "ref", {
        get: function() {
            return new $75536fd4bb2e2ab6$var$Mi(this.kc, this.hE, this.aE);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "exists", {
        get: function() {
            return null !== this.fE;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "metadata", {
        get: function() {
            return new $75536fd4bb2e2ab6$var$ji(this.EE, this.TE);
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) throw $75536fd4bb2e2ab6$var$mr("isEqual", "DocumentSnapshot", 1, e);
        return this.hE === e.hE && this.TE === e.TE && this.kc.isEqual(e.kc) && (null === this.fE ? null === e.fE : this.fE.isEqual(e.fE)) && this.aE === e.aE;
    }, t;
}(), $75536fd4bb2e2ab6$var$Bi = /** @class */ function(t) {
    function n() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $8QG6t.__extends(n, t), n.prototype.data = function(e) {
        return t.prototype.data.call(this, e);
    }, n;
}($75536fd4bb2e2ab6$var$Fi), $75536fd4bb2e2ab6$var$zi = /** @class */ function() {
    function t(t, e, n) {
        this.IE = t, this.firestore = e, this.aE = n;
    }
    return t.prototype.where = function(e, n, r) {
        $75536fd4bb2e2ab6$var$or("Query.where", arguments, 3), $75536fd4bb2e2ab6$var$vr("Query.where", 3, r);
        // Enumerated from the WhereFilterOp type in index.d.ts.
        var i, o = function(t, e, n, r) {
            if (!e.some(function(t) {
                return t === r;
            })) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid value " + $75536fd4bb2e2ab6$var$yr(r) + " provided to function Query.where() for its " + $75536fd4bb2e2ab6$var$Er(2) + " argument. Acceptable values: " + e.join(", "));
            return r;
        }(0, [
            "<" /* LESS_THAN */ ,
            "<=" /* LESS_THAN_OR_EQUAL */ ,
            "==" /* EQUAL */ ,
            ">=" /* GREATER_THAN_OR_EQUAL */ ,
            ">" /* GREATER_THAN */ ,
            "array-contains" /* ARRAY_CONTAINS */ ,
            "in" /* IN */ ,
            "array-contains-any" /* ARRAY_CONTAINS_ANY */ 
        ], 0, n), s = $75536fd4bb2e2ab6$var$Gr("Query.where", e);
        if (s.Y()) {
            if ("array-contains" /* ARRAY_CONTAINS */  === o || "array-contains-any" /* ARRAY_CONTAINS_ANY */  === o) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + o + "' queries on FieldPath.documentId().");
            if ("in" /* IN */  === o) {
                this.wE(r, o);
                for(var u = [], a = 0, f = r; a < f.length; a++){
                    var l = f[a];
                    u.push(this.RE(l));
                }
                i = {
                    arrayValue: {
                        values: u
                    }
                };
            } else i = this.RE(r);
        } else "in" /* IN */  !== o && "array-contains-any" /* ARRAY_CONTAINS_ANY */  !== o || this.wE(r, o), i = this.firestore.JT.Nc("Query.where", r, // We only allow nested arrays for IN queries.
        /** allowArrays = */ "in" /* IN */  === o);
        var p = $75536fd4bb2e2ab6$var$Et.create(s, o, i);
        return this.AE(p), new t(this.IE.Gt(p), this.firestore, this.aE);
    }, t.prototype.orderBy = function(e, n) {
        var r;
        if ($75536fd4bb2e2ab6$var$ur("Query.orderBy", arguments, 1, 2), $75536fd4bb2e2ab6$var$hr("Query.orderBy", "non-empty string", 2, n), void 0 === n || "asc" === n) r = "asc" /* ASCENDING */ ;
        else {
            if ("desc" !== n) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + n + "', expected 'asc' or 'desc'.");
            r = "desc" /* DESCENDING */ ;
        }
        if (null !== this.IE.startAt) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. You must not call Query.startAt() or Query.startAfter() before calling Query.orderBy().");
        if (null !== this.IE.endAt) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. You must not call Query.endAt() or Query.endBefore() before calling Query.orderBy().");
        var i = $75536fd4bb2e2ab6$var$Gr("Query.orderBy", e), o = new $75536fd4bb2e2ab6$var$kt(i, r);
        return this.mE(o), new t(this.IE.zt(o), this.firestore, this.aE);
    }, t.prototype.limit = function(e) {
        return $75536fd4bb2e2ab6$var$or("Query.limit", arguments, 1), $75536fd4bb2e2ab6$var$ar("Query.limit", "number", 1, e), $75536fd4bb2e2ab6$var$wr("Query.limit", 1, e), new t(this.IE.Ht(e), this.firestore, this.aE);
    }, t.prototype.limitToLast = function(e) {
        return $75536fd4bb2e2ab6$var$or("Query.limitToLast", arguments, 1), $75536fd4bb2e2ab6$var$ar("Query.limitToLast", "number", 1, e), $75536fd4bb2e2ab6$var$wr("Query.limitToLast", 1, e), new t(this.IE.Yt(e), this.firestore, this.aE);
    }, t.prototype.startAt = function(e) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $75536fd4bb2e2ab6$var$sr("Query.startAt", arguments, 1);
        var i = this.PE("Query.startAt", e, n, /*before=*/ !0);
        return new t(this.IE.Jt(i), this.firestore, this.aE);
    }, t.prototype.startAfter = function(e) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $75536fd4bb2e2ab6$var$sr("Query.startAfter", arguments, 1);
        var i = this.PE("Query.startAfter", e, n, /*before=*/ !1);
        return new t(this.IE.Jt(i), this.firestore, this.aE);
    }, t.prototype.endBefore = function(e) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $75536fd4bb2e2ab6$var$sr("Query.endBefore", arguments, 1);
        var i = this.PE("Query.endBefore", e, n, /*before=*/ !0);
        return new t(this.IE.Xt(i), this.firestore, this.aE);
    }, t.prototype.endAt = function(e) {
        for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        $75536fd4bb2e2ab6$var$sr("Query.endAt", arguments, 1);
        var i = this.PE("Query.endAt", e, n, /*before=*/ !1);
        return new t(this.IE.Xt(i), this.firestore, this.aE);
    }, t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) throw $75536fd4bb2e2ab6$var$mr("isEqual", "Query", 1, e);
        return this.firestore === e.firestore && this.IE.isEqual(e.IE);
    }, t.prototype.withConverter = function(e) {
        return new t(this.IE, this.firestore, e);
    }, /** Helper function to create a bound from a document or fields */ t.prototype.PE = function(t, e, n, r) {
        if ($75536fd4bb2e2ab6$var$vr(t, 1, e), e instanceof $75536fd4bb2e2ab6$var$Fi) {
            if (n.length > 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Too many arguments provided to " + t + "().");
            var i = e;
            if (!i.exists) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " + t + "().");
            return this.VE(i.fE, r);
        }
        var o = [
            e
        ].concat(n);
        return this.gE(t, o, r);
    }, /**
     * Create a Bound from a query and a document.
     *
     * Note that the Bound will always include the key of the document
     * and so only the provided document will compare equal to the returned
     * position.
     *
     * Will throw if the document does not contain all fields of the order by
     * of the query or if any of the fields in the order by are an uncommitted
     * server timestamp.
     */ t.prototype.VE = function(t, e) {
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for(var n = [], r = 0, i = this.IE.orderBy; r < i.length; r++){
            var o = i[r];
            if (o.field.Y()) n.push($75536fd4bb2e2ab6$var$B(this.firestore.$c, t.key));
            else {
                var s = t.field(o.field);
                if ($75536fd4bb2e2ab6$var$S(s)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + o.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
                if (null === s) {
                    var u = o.field.j();
                    throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '" + u + "' (used as the orderBy) does not exist.");
                }
                n.push(s);
            }
        }
        return new $75536fd4bb2e2ab6$var$At(n, e);
    }, /**
     * Converts a list of field values to a Bound for the given query.
     */ t.prototype.gE = function(t, e, n) {
        // Use explicit order by's because it has to match the query the user made
        var r = this.IE.xt;
        if (e.length > r.length) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Too many arguments provided to " + t + "(). The number of arguments must be less than or equal to the number of Query.orderBy() clauses");
        for(var i = [], o = 0; o < e.length; o++){
            var s = e[o];
            if (r[o].field.Y()) {
                if ("string" != typeof s) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " + t + "(), but got a " + typeof s);
                if (!this.IE._e() && -1 !== s.indexOf("/")) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), the value passed to " + t + "() must be a plain document ID, but '" + s + "' contains a slash.");
                var u = this.IE.path.child($75536fd4bb2e2ab6$var$w.K(s));
                if (!$75536fd4bb2e2ab6$var$_.et(u)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by FieldPath.documentId(), the value passed to " + t + "() must result in a valid document path, but '" + u + "' is not because it contains an odd number of segments.");
                var a = new $75536fd4bb2e2ab6$var$_(u);
                i.push($75536fd4bb2e2ab6$var$B(this.firestore.$c, a));
            } else {
                var f = this.firestore.JT.Nc(t, s);
                i.push(f);
            }
        }
        return new $75536fd4bb2e2ab6$var$At(i, n);
    }, t.prototype.onSnapshot = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        $75536fd4bb2e2ab6$var$ur("Query.onSnapshot", arguments, 1, 4);
        var n, r = {}, i = 0;
        return "object" != typeof t[i] || $75536fd4bb2e2ab6$var$Li(t[i]) || ($75536fd4bb2e2ab6$var$gr("Query.onSnapshot", r = t[i], [
            "includeMetadataChanges"
        ]), $75536fd4bb2e2ab6$var$fr("Query.onSnapshot", "boolean", "includeMetadataChanges", r.includeMetadataChanges), i++), $75536fd4bb2e2ab6$var$Li(t[i]) ? n = t[i] : ($75536fd4bb2e2ab6$var$ar("Query.onSnapshot", "function", i, t[i]), $75536fd4bb2e2ab6$var$hr("Query.onSnapshot", "function", i + 1, t[i + 1]), $75536fd4bb2e2ab6$var$hr("Query.onSnapshot", "function", i + 2, t[i + 2]), n = {
            next: t[i],
            error: t[i + 1],
            complete: t[i + 2]
        }), this.pE(this.IE), this.lE(r, n);
    }, t.prototype.lE = function(t, e) {
        var n = this, r = function(t) {
            console.error("Uncaught Error in onSnapshot:", t);
        };
        e.error && (r = e.error.bind(e));
        var i = new $75536fd4bb2e2ab6$var$Ri({
            next: function(t) {
                e.next && e.next(new $75536fd4bb2e2ab6$var$Gi(n.firestore, n.IE, t, n.aE));
            },
            error: r
        }), o = this.firestore.WT(), s = o.listen(this.IE, i, t);
        return function() {
            i.NT(), o.rl(s);
        };
    }, t.prototype.pE = function(t) {
        if (t.ae() && 0 === t.xt.length) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
    }, t.prototype.get = function(t) {
        var e = this;
        return $75536fd4bb2e2ab6$var$ur("Query.get", arguments, 0, 1), $75536fd4bb2e2ab6$var$Yi("Query.get", t), this.pE(this.IE), new Promise(function(n, r) {
            t && "cache" === t.source ? e.firestore.WT().CT(e.IE).then(function(t) {
                n(new $75536fd4bb2e2ab6$var$Gi(e.firestore, e.IE, t, e.aE));
            }, r) : e.dE(n, r, t);
        });
    }, t.prototype.dE = function(t, e, n) {
        var r = this.lE({
            includeMetadataChanges: !0,
            Of: !0
        }, {
            next: function(i) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                r(), i.metadata.fromCache && n && "server" === n.source ? e(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : t(i);
            },
            error: e
        });
    }, /**
     * Parses the given documentIdValue into a ReferenceValue, throwing
     * appropriate errors if the value is anything other than a DocumentReference
     * or String, or if the string is malformed.
     */ t.prototype.RE = function(t) {
        if ("string" == typeof t) {
            if ("" === t) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid document ID, but it was an empty string.");
            if (!this.IE._e() && -1 !== t.indexOf("/")) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. When querying a collection by FieldPath.documentId(), you must provide a plain document ID, but '" + t + "' contains a '/' character.");
            var e = this.IE.path.child($75536fd4bb2e2ab6$var$w.K(t));
            if (!$75536fd4bb2e2ab6$var$_.et(e)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. When querying a collection group by FieldPath.documentId(), the value provided must result in a valid document path, but '" + e + "' is not because it has an odd number of segments (" + e.length + ").");
            return $75536fd4bb2e2ab6$var$B(this.firestore.$c, new $75536fd4bb2e2ab6$var$_(e));
        }
        if (t instanceof $75536fd4bb2e2ab6$var$Mi) {
            var n = t;
            return $75536fd4bb2e2ab6$var$B(this.firestore.$c, n.kc);
        }
        throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid string or a DocumentReference, but it was: " + $75536fd4bb2e2ab6$var$yr(t) + ".");
    }, /**
     * Validates that the value passed into a disjunctrive filter satisfies all
     * array requirements.
     */ t.prototype.wE = function(t, e) {
        if (!Array.isArray(t) || 0 === t.length) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '" + e.toString() + "' filters.");
        if (t.length > 10) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters support a maximum of 10 elements in the value array.");
        if (t.indexOf(null) >= 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters cannot contain 'null' in the value array.");
        if (t.filter(function(t) {
            return Number.isNaN(t);
        }).length > 0) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters cannot contain 'NaN' in the value array.");
    }, t.prototype.AE = function(t) {
        if (t instanceof $75536fd4bb2e2ab6$var$Et) {
            var e = [
                "array-contains" /* ARRAY_CONTAINS */ ,
                "array-contains-any" /* ARRAY_CONTAINS_ANY */ 
            ], n = [
                "in" /* IN */ ,
                "array-contains-any" /* ARRAY_CONTAINS_ANY */ 
            ], r = e.indexOf(t.op) >= 0, i = n.indexOf(t.op) >= 0;
            if (t.ue()) {
                var o = this.IE.jt();
                if (null !== o && !o.isEqual(t.field)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, >, or >=) must be on the same field. But you have inequality filters on '" + o.toString() + "' and '" + t.field.toString() + "'");
                var s = this.IE.Kt();
                null !== s && this.yE(t.field, s);
            } else if (i || r) {
                // You can have at most 1 disjunctive filter and 1 array filter. Check if
                // the new filter conflicts with an existing one.
                var u = null;
                if (i && (u = this.IE.ce(n)), null === u && r && (u = this.IE.ce(e)), null != u) // We special case when it's a duplicate op to give a slightly clearer error message.
                throw u === t.op ? new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '" + t.op.toString() + "' filter.") : new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. You cannot use '" + t.op.toString() + "' filters with '" + u.toString() + "' filters.");
            }
        }
    }, t.prototype.mE = function(t) {
        if (null === this.IE.Kt()) {
            // This is the first order by. It must match any inequality.
            var e = this.IE.jt();
            null !== e && this.yE(e, t.field);
        }
    }, t.prototype.yE = function(t, e) {
        if (!e.isEqual(t)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, >, or >=) on field '" + t.toString() + "' and so you must also use '" + t.toString() + "' as your first Query.orderBy(), but your first Query.orderBy() is on field '" + e.toString() + "' instead.");
    }, t;
}(), $75536fd4bb2e2ab6$var$Gi = /** @class */ function() {
    function t(t, e, n, r) {
        this.hE = t, this.bE = e, this.vE = n, this.aE = r, this.SE = null, this.DE = null, this.metadata = new $75536fd4bb2e2ab6$var$ji(n.hasPendingWrites, n.fromCache);
    }
    return Object.defineProperty(t.prototype, "docs", {
        get: function() {
            var t = [];
            return this.forEach(function(e) {
                return t.push(e);
            }), t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "empty", {
        get: function() {
            return this.vE.docs.B();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
        get: function() {
            return this.vE.docs.size;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.forEach = function(t, e) {
        var n = this;
        $75536fd4bb2e2ab6$var$ur("QuerySnapshot.forEach", arguments, 1, 2), $75536fd4bb2e2ab6$var$ar("QuerySnapshot.forEach", "function", 1, t), this.vE.docs.forEach(function(r) {
            t.call(e, n.CE(r));
        });
    }, Object.defineProperty(t.prototype, "query", {
        get: function() {
            return new $75536fd4bb2e2ab6$var$zi(this.bE, this.hE, this.aE);
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.docChanges = function(t) {
        t && ($75536fd4bb2e2ab6$var$gr("QuerySnapshot.docChanges", t, [
            "includeMetadataChanges"
        ]), $75536fd4bb2e2ab6$var$fr("QuerySnapshot.docChanges", "boolean", "includeMetadataChanges", t.includeMetadataChanges));
        var e = !(!t || !t.includeMetadataChanges);
        if (e && this.vE.hs) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this.SE && this.DE === e || (this.SE = /**
     * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
     *
     * Exported for testing.
     */ function(t, e, n, r) {
            if (n.ss.B()) {
                // Special case the first snapshot because index calculation is easy and
                // fast
                var i = 0;
                return n.docChanges.map(function(e) {
                    var o = new $75536fd4bb2e2ab6$var$Bi(t, e.doc.key, e.doc, n.fromCache, n.ns.has(e.doc.key), r);
                    return e.doc, {
                        type: "added",
                        doc: o,
                        oldIndex: -1,
                        newIndex: i++
                    };
                });
            }
            // A DocumentSet that is updated incrementally as changes are applied to use
            // to lookup the index of a document.
            var o = n.ss;
            return n.docChanges.filter(function(t) {
                return e || 3 /* Metadata */  !== t.type;
            }).map(function(e) {
                var i = new $75536fd4bb2e2ab6$var$Bi(t, e.doc.key, e.doc, n.fromCache, n.ns.has(e.doc.key), r), s = -1, u = -1;
                return 0 /* Added */  !== e.type && (s = o.indexOf(e.doc.key), o = o.delete(e.doc.key)), 1 /* Removed */  !== e.type && (u = (o = o.add(e.doc)).indexOf(e.doc.key)), {
                    type: $75536fd4bb2e2ab6$var$Ji(e.type),
                    doc: i,
                    oldIndex: s,
                    newIndex: u
                };
            });
        }(this.hE, e, this.vE, this.aE), this.DE = e), this.SE;
    }, /** Check the equality. The call can be very expensive. */ t.prototype.isEqual = function(e) {
        if (!(e instanceof t)) throw $75536fd4bb2e2ab6$var$mr("isEqual", "QuerySnapshot", 1, e);
        return this.hE === e.hE && this.bE.isEqual(e.bE) && this.vE.isEqual(e.vE) && this.aE === e.aE;
    }, t.prototype.CE = function(t) {
        return new $75536fd4bb2e2ab6$var$Bi(this.hE, t.key, t, this.metadata.fromCache, this.vE.ns.has(t.key), this.aE);
    }, t;
}(), $75536fd4bb2e2ab6$var$Wi = /** @class */ function(t) {
    function n(e, n, r) {
        var i = this;
        if ((i = t.call(this, $75536fd4bb2e2ab6$var$wt.Wt(e), n, r) || this).FE = e, e.length % 2 != 1) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but " + e.j() + " has " + e.length);
        return i;
    }
    return $8QG6t.__extends(n, t), Object.defineProperty(n.prototype, "id", {
        get: function() {
            return this.IE.path.O();
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n.prototype, "parent", {
        get: function() {
            var t = this.IE.path.L();
            return t.B() ? null : new $75536fd4bb2e2ab6$var$Mi(new $75536fd4bb2e2ab6$var$_(t), this.firestore);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(n.prototype, "path", {
        get: function() {
            return this.IE.path.j();
        },
        enumerable: !0,
        configurable: !0
    }), n.prototype.doc = function(t) {
        if ($75536fd4bb2e2ab6$var$ur("CollectionReference.doc", arguments, 0, 1), // We allow omission of 'pathString' but explicitly prohibit passing in both
        // 'undefined' and 'null'.
        0 === arguments.length && (t = $75536fd4bb2e2ab6$var$Ee.cn()), $75536fd4bb2e2ab6$var$ar("CollectionReference.doc", "non-empty string", 1, t), "" === t) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Document path must be a non-empty string");
        var e = $75536fd4bb2e2ab6$var$w.K(t);
        return $75536fd4bb2e2ab6$var$Mi.nE(this.IE.path.child(e), this.firestore, this.aE);
    }, n.prototype.add = function(t) {
        $75536fd4bb2e2ab6$var$or("CollectionReference.add", arguments, 1), $75536fd4bb2e2ab6$var$ar("CollectionReference.add", "object", 1, this.aE ? this.aE.toFirestore(t) : t);
        var e = this.doc();
        return e.set(t).then(function() {
            return e;
        });
    }, n.prototype.withConverter = function(t) {
        return new n(this.FE, this.firestore, t);
    }, n;
}($75536fd4bb2e2ab6$var$zi);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
function $75536fd4bb2e2ab6$var$Qi(t, e) {
    if (void 0 === e) return {
        merge: !1
    };
    if ($75536fd4bb2e2ab6$var$gr(t, e, [
        "merge",
        "mergeFields"
    ]), $75536fd4bb2e2ab6$var$fr(t, "boolean", "merge", e.merge), function(t, e, n, r, i) {
        void 0 !== r && function(t, e, n, r, i) {
            if (!(r instanceof Array)) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires its " + e + " option to be an array, but it was: " + $75536fd4bb2e2ab6$var$yr(r));
            for(var o = 0; o < r.length; ++o)if (!i(r[o])) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Function " + t + "() requires all " + e + " elements to be " + n + ", but the value at index " + o + " was: " + $75536fd4bb2e2ab6$var$yr(r[o]));
        }(t, e, n, r, i);
    }(t, "mergeFields", "a string or a FieldPath", e.mergeFields, function(t) {
        return "string" == typeof t || t instanceof $75536fd4bb2e2ab6$var$Nr;
    }), void 0 !== e.mergeFields && void 0 !== e.merge) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Invalid options passed to function " + t + '(): You cannot specify both "merge" and "mergeFields".');
    return e;
}
function $75536fd4bb2e2ab6$var$Ki(t, e) {
    return void 0 === e ? {} : ($75536fd4bb2e2ab6$var$gr(t, e, [
        "serverTimestamps"
    ]), $75536fd4bb2e2ab6$var$lr(t, 0, "serverTimestamps", e.serverTimestamps, [
        "estimate",
        "previous",
        "none"
    ]), e);
}
function $75536fd4bb2e2ab6$var$Yi(t, e) {
    $75536fd4bb2e2ab6$var$hr(t, "object", 1, e), e && ($75536fd4bb2e2ab6$var$gr(t, e, [
        "source"
    ]), $75536fd4bb2e2ab6$var$lr(t, 0, "source", e.source, [
        "default",
        "server",
        "cache"
    ]));
}
function $75536fd4bb2e2ab6$var$$i(t, e, n) {
    if (e instanceof $75536fd4bb2e2ab6$var$Mi) {
        if (e.firestore !== n) throw new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
        return e;
    }
    throw $75536fd4bb2e2ab6$var$mr(t, "DocumentReference", 1, e);
}
function $75536fd4bb2e2ab6$var$Ji(t) {
    switch(t){
        case 0 /* Added */ :
            return "added";
        case 2 /* Modified */ :
        case 3 /* Metadata */ :
            return "modified";
        case 1 /* Removed */ :
            return "removed";
        default:
            return $75536fd4bb2e2ab6$var$ge();
    }
}
/**
 * Converts custom model object of type T into DocumentData by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to DocumentData
 * because we want to provide the user with a more specific error message if
 * their set() or fails due to invalid data originating from a toFirestore()
 * call.
 */ function $75536fd4bb2e2ab6$var$Hi(t, e, n) {
    var r;
    return t ? (r = t.toFirestore(e), n = "toFirestore() in " + n) : r = e, [
        r,
        n
    ];
}
function $75536fd4bb2e2ab6$var$Xi(t, e) {
    function n() {
        var t = "This constructor is private.";
        throw e && (t += " ", t += e), new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.INVALID_ARGUMENT, t);
    }
    // Make sure instanceof checks work and all methods are exposed on the public
    // constructor
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return n.prototype = t.prototype, // Copy any static methods/members
    Object.assign(n, t), n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Public instance that disallows construction at runtime. Note that this still
// allows instanceof checks.
var $75536fd4bb2e2ab6$var$Zi = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Ui, "Use firebase.firestore() instead."), $75536fd4bb2e2ab6$var$to = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Ci, "Use firebase.firestore().runTransaction() instead."), $75536fd4bb2e2ab6$var$eo = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$qi, "Use firebase.firestore().batch() instead."), $75536fd4bb2e2ab6$var$no = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Mi, "Use firebase.firestore().doc() instead."), $75536fd4bb2e2ab6$var$ro = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Fi), $75536fd4bb2e2ab6$var$io = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Bi), $75536fd4bb2e2ab6$var$oo = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$zi), $75536fd4bb2e2ab6$var$so = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Gi), $75536fd4bb2e2ab6$var$uo = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Wi, "Use firebase.firestore().collection() instead."), $75536fd4bb2e2ab6$var$ao = $75536fd4bb2e2ab6$var$Xi(/** @class */ function() {
    function t() {}
    return t.delete = function() {
        return $75536fd4bb2e2ab6$var$ir("FieldValue.delete", arguments), new $75536fd4bb2e2ab6$var$Dr;
    }, t.serverTimestamp = function() {
        return $75536fd4bb2e2ab6$var$ir("FieldValue.serverTimestamp", arguments), new $75536fd4bb2e2ab6$var$xr;
    }, t.arrayUnion = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return $75536fd4bb2e2ab6$var$sr("FieldValue.arrayUnion", arguments, 1), new $75536fd4bb2e2ab6$var$Sr(t);
    }, t.arrayRemove = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return $75536fd4bb2e2ab6$var$sr("FieldValue.arrayRemove", arguments, 1), new $75536fd4bb2e2ab6$var$Rr(t);
    }, t.increment = function(t) {
        return $75536fd4bb2e2ab6$var$ar("FieldValue.increment", "number", 1, t), $75536fd4bb2e2ab6$var$or("FieldValue.increment", arguments, 1), new $75536fd4bb2e2ab6$var$Lr(t);
    }, t.prototype.isEqual = function(t) {
        return this === t;
    }, t;
}(), "Use FieldValue.<field>() instead."), $75536fd4bb2e2ab6$var$ho = $75536fd4bb2e2ab6$var$Xi($75536fd4bb2e2ab6$var$Ir, "Use Blob.fromUint8Array() or Blob.fromBase64String() instead."), $75536fd4bb2e2ab6$var$co = {
    Firestore: $75536fd4bb2e2ab6$var$Zi,
    GeoPoint: $75536fd4bb2e2ab6$var$Or,
    Timestamp: $75536fd4bb2e2ab6$var$v,
    Blob: $75536fd4bb2e2ab6$var$ho,
    Transaction: $75536fd4bb2e2ab6$var$to,
    WriteBatch: $75536fd4bb2e2ab6$var$eo,
    DocumentReference: $75536fd4bb2e2ab6$var$no,
    DocumentSnapshot: $75536fd4bb2e2ab6$var$ro,
    Query: $75536fd4bb2e2ab6$var$oo,
    QueryDocumentSnapshot: $75536fd4bb2e2ab6$var$io,
    QuerySnapshot: $75536fd4bb2e2ab6$var$so,
    CollectionReference: $75536fd4bb2e2ab6$var$uo,
    FieldPath: $75536fd4bb2e2ab6$var$Nr,
    FieldValue: $75536fd4bb2e2ab6$var$ao,
    setLogLevel: $75536fd4bb2e2ab6$var$Ui.setLogLevel,
    CACHE_SIZE_UNLIMITED: $75536fd4bb2e2ab6$var$Vi
}, $75536fd4bb2e2ab6$var$fo = /** @class */ function() {
    function t() {}
    return t.prototype.B_ = function(t) {
    // No-op.
    }, t.prototype.mo = function() {
    // No-op.
    }, t;
}(), $75536fd4bb2e2ab6$var$lo = /** @class */ function() {
    function t() {
        var t = this;
        this.NE = function() {
            return t.$E();
        }, this.kE = function() {
            return t.LE();
        }, this.ME = [], this.OE();
    }
    return t.prototype.B_ = function(t) {
        this.ME.push(t);
    }, t.prototype.mo = function() {
        window.removeEventListener("online", this.NE), window.removeEventListener("offline", this.kE);
    }, t.prototype.OE = function() {
        window.addEventListener("online", this.NE), window.addEventListener("offline", this.kE);
    }, t.prototype.$E = function() {
        $75536fd4bb2e2ab6$var$de("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for(var t = 0, e = this.ME; t < e.length; t++)(0, e[t])(0 /* AVAILABLE */ );
    }, t.prototype.LE = function() {
        $75536fd4bb2e2ab6$var$de("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for(var t = 0, e = this.ME; t < e.length; t++)(0, e[t])(1 /* UNAVAILABLE */ );
    }, // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ t.Gh = function() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }, t;
}(), $75536fd4bb2e2ab6$var$po = /** @class */ function() {
    function t(t) {
        this.xE = t.xE, this.BE = t.BE;
    }
    return t.prototype.e_ = function(t) {
        this.qE = t;
    }, t.prototype.Yc = function(t) {
        this.UE = t;
    }, t.prototype.onMessage = function(t) {
        this.QE = t;
    }, t.prototype.close = function() {
        this.BE();
    }, t.prototype.send = function(t) {
        this.xE(t);
    }, t.prototype.WE = function() {
        this.qE();
    }, t.prototype.jE = function(t) {
        this.UE(t);
    }, t.prototype.KE = function(t) {
        this.QE(t);
    }, t;
}(), $75536fd4bb2e2ab6$var$yo = {
    BatchGetDocuments: "batchGet",
    Commit: "commit"
}, $75536fd4bb2e2ab6$var$vo = "gl-js/ fire/" + $75536fd4bb2e2ab6$var$u, $75536fd4bb2e2ab6$var$go = /** @class */ function() {
    function t(t) {
        this.ii = t.ii;
        var e = t.ssl ? "https" : "http";
        this.GE = e + "://" + t.host, this.forceLongPolling = t.forceLongPolling;
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ return t.prototype.zE = function(t, e) {
        if (e) for(var n in e.o)e.o.hasOwnProperty(n) && (t[n] = e.o[n]);
        t["X-Goog-Api-Client"] = $75536fd4bb2e2ab6$var$vo;
    }, t.prototype.d_ = function(t, e, n) {
        var r = this, i = this.HE(t);
        return new Promise(function(o, u) {
            var a = new $gyel3.XhrIo;
            a.listenOnce($gyel3.EventType.COMPLETE, function() {
                try {
                    switch(a.getLastErrorCode()){
                        case $gyel3.ErrorCode.NO_ERROR:
                            var e = a.getResponseJson();
                            $75536fd4bb2e2ab6$var$de("Connection", "XHR received:", JSON.stringify(e)), o(e);
                            break;
                        case $gyel3.ErrorCode.TIMEOUT:
                            $75536fd4bb2e2ab6$var$de("Connection", 'RPC "' + t + '" timed out'), u(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case $gyel3.ErrorCode.HTTP_ERROR:
                            var n = a.getStatus();
                            if ($75536fd4bb2e2ab6$var$de("Connection", 'RPC "' + t + '" failed with status:', n, "response text:", a.getResponseText()), n > 0) {
                                var r = a.getResponseJson().error;
                                if (r && r.status && r.message) {
                                    var i = function(t) {
                                        var e = t.toLowerCase().replace("_", "-");
                                        return Object.values($75536fd4bb2e2ab6$var$h).indexOf(e) >= 0 ? e : $75536fd4bb2e2ab6$var$h.UNKNOWN;
                                    }(r.status);
                                    u(new $75536fd4bb2e2ab6$var$c(i, r.message));
                                } else u(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNKNOWN, "Server responded with status " + a.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            $75536fd4bb2e2ab6$var$de("Connection", 'RPC "' + t + '" failed'), u(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $75536fd4bb2e2ab6$var$ge();
                    }
                } finally{
                    $75536fd4bb2e2ab6$var$de("Connection", 'RPC "' + t + '" completed.');
                }
            });
            // The database field is already encoded in URL. Specifying it again in
            // the body is not necessary in production, and will cause duplicate field
            // errors in the Firestore Emulator. Let's remove it.
            var f = Object.assign({}, e);
            delete f.database;
            var l = JSON.stringify(f);
            $75536fd4bb2e2ab6$var$de("Connection", "XHR sending: ", i + " " + l);
            // Content-Type: text/plain will avoid preflight requests which might
            // mess with CORS and redirects by proxies. If we add custom headers
            // we will need to change this code to potentially use the
            // $httpOverwrite parameter supported by ESF to avoid
            // triggering preflight requests.
            var p = {
                "Content-Type": "text/plain"
            };
            r.zE(p, n), a.send(i, "POST", l, p, 15);
        });
    }, t.prototype.f_ = function(t, e, n) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.d_(t, e, n);
    }, t.prototype.s_ = function(t, e) {
        var n = [
            this.GE,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            t,
            "/channel"
        ], r = $gyel3.createWebChannelTransport(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: "projects/" + this.ii.projectId + "/databases/" + this.ii.database
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling
        };
        this.zE(o.initMessageHeaders, e), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
        // doesn't have an Origin header. So we have to exclude a few browser environments that are
        // known to (sometimes) not include an Origin. See
        // https://github.com/firebase/firebase-js-sdk/issues/1491.
        $epfVL.isMobileCordova() || $epfVL.isReactNative() || $epfVL.isElectron() || $epfVL.isIE() || $epfVL.isUWP() || $epfVL.isBrowserExtension() || (o.httpHeadersOverwriteParam = "$httpHeaders");
        var u = n.join("");
        $75536fd4bb2e2ab6$var$de("Connection", "Creating WebChannel: " + u + " " + o);
        var a = r.createWebChannel(u, o), f = !1, l = !1, p = new $75536fd4bb2e2ab6$var$po({
            xE: function(t) {
                l ? $75536fd4bb2e2ab6$var$de("Connection", "Not sending because WebChannel is closed:", t) : (f || ($75536fd4bb2e2ab6$var$de("Connection", "Opening WebChannel transport."), a.open(), f = !0), $75536fd4bb2e2ab6$var$de("Connection", "WebChannel sending:", t), a.send(t));
            },
            BE: function() {
                return a.close();
            }
        }), d = function(t, e) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            a.listen(t, function(t) {
                try {
                    e(t);
                } catch (t) {
                    setTimeout(function() {
                        throw t;
                    }, 0);
                }
            });
        };
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return d($gyel3.WebChannel.EventType.OPEN, function() {
            l || $75536fd4bb2e2ab6$var$de("Connection", "WebChannel transport opened.");
        }), d($gyel3.WebChannel.EventType.CLOSE, function() {
            l || (l = !0, $75536fd4bb2e2ab6$var$de("Connection", "WebChannel transport closed"), p.jE());
        }), d($gyel3.WebChannel.EventType.ERROR, function(t) {
            l || (l = !0, $75536fd4bb2e2ab6$var$de("Connection", "WebChannel transport errored:", t), p.jE(new $75536fd4bb2e2ab6$var$c($75536fd4bb2e2ab6$var$h.UNAVAILABLE, "The operation could not be completed")));
        }), d($gyel3.WebChannel.EventType.MESSAGE, function(t) {
            var e;
            if (!l) {
                var n = t.data[0];
                $75536fd4bb2e2ab6$var$me(!!n);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                var r = n, i = r.error || (null === (e = r[0]) || void 0 === e ? void 0 : e.error);
                if (i) {
                    $75536fd4bb2e2ab6$var$de("Connection", "WebChannel received error:", i);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var o = i.status, s = function(t) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var e = $75536fd4bb2e2ab6$var$lt[t];
                        if (void 0 !== e) return $75536fd4bb2e2ab6$var$Rt(e);
                    }(o), u = i.message;
                    void 0 === s && (s = $75536fd4bb2e2ab6$var$h.INTERNAL, u = "Unknown error status: " + o + " with message " + i.message), // Mark closed so no further events are propagated
                    l = !0, p.jE(new $75536fd4bb2e2ab6$var$c(s, u)), a.close();
                } else $75536fd4bb2e2ab6$var$de("Connection", "WebChannel received:", n), p.KE(n);
            }
        }), setTimeout(function() {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            p.WE();
        }, 0), p;
    }, // visible for testing
    t.prototype.HE = function(t) {
        var e = $75536fd4bb2e2ab6$var$yo[t];
        return this.GE + "/v1/projects/" + this.ii.projectId + "/databases/" + this.ii.database + "/documents:" + e;
    }, t;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Implements the Platform API for browsers and some browser-like environments
// (including ReactNative).
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Registers the main Firestore build with the components framework.
 * Persistence can be enabled via `firebase.firestore().enablePersistence()`.
 */ function $75536fd4bb2e2ab6$var$mo(t) {
    /**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 *
 * @param firebase The FirebaseNamespace to register Firestore with
 * @param firestoreFactory A factory function that returns a new Firestore
 *    instance.
 */ !function(t, e) {
        t.INTERNAL.registerComponent(new $9Cwol.Component("firestore", function(t) {
            return function(t, e) {
                return new $75536fd4bb2e2ab6$var$Ui(t, e, new $75536fd4bb2e2ab6$var$xi);
            }(t.getProvider("app").getImmediate(), t.getProvider("auth-internal"));
        }, "PUBLIC" /* PUBLIC */ ).setServiceProps(Object.assign({}, $75536fd4bb2e2ab6$var$co)));
    }(t), t.registerVersion("@firebase/firestore", "1.14.6");
}
$75536fd4bb2e2ab6$var$ce.an(new /** @class */ (function() {
    function t() {
        this.ac = "undefined" != typeof atob;
    }
    return Object.defineProperty(t.prototype, "document", {
        get: function() {
            // `document` is not always available, e.g. in ReactNative and WebWorkers.
            // eslint-disable-next-line no-restricted-globals
            return "undefined" != typeof document ? document : null;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
        get: function() {
            // `window` is not always available, e.g. in ReactNative and WebWorkers.
            // eslint-disable-next-line no-restricted-globals
            return "undefined" != typeof window ? window : null;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.yT = function(t) {
        return Promise.resolve(new $75536fd4bb2e2ab6$var$go(t));
    }, t.prototype.AT = function() {
        return $75536fd4bb2e2ab6$var$lo.Gh() ? new $75536fd4bb2e2ab6$var$lo : new $75536fd4bb2e2ab6$var$fo;
    }, t.prototype.bc = function(t) {
        return new $75536fd4bb2e2ab6$var$ae(t, {
            hi: !0
        });
    }, t.prototype.un = function(t) {
        return JSON.stringify(t);
    }, t.prototype.atob = function(t) {
        return atob(t);
    }, t.prototype.btoa = function(t) {
        return btoa(t);
    }, t.prototype._n = function(t) {
        // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
        var e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
        if (e) e.getRandomValues(n);
        else // Falls back to Math.random
        for(var r = 0; r < t; r++)n[r] = Math.floor(256 * Math.random());
        return n;
    }, t;
}())), $75536fd4bb2e2ab6$var$mo($75536fd4bb2e2ab6$var$n), module.exports.__PRIVATE_registerFirestore = $75536fd4bb2e2ab6$var$mo;

});
parcelRegister("8QG6t", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $6713d6ea845fe63c$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $6713d6ea845fe63c$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $6713d6ea845fe63c$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArrays", () => $6713d6ea845fe63c$export$6388937ca91ccae8);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $6713d6ea845fe63c$var$extendStatics = function(d, b) {
    $6713d6ea845fe63c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6713d6ea845fe63c$var$extendStatics(d, b);
};
function $6713d6ea845fe63c$export$a8ba968b8961cb8a(d, b) {
    $6713d6ea845fe63c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6713d6ea845fe63c$export$18ce0697a983be9b = function() {
    $6713d6ea845fe63c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6713d6ea845fe63c$export$18ce0697a983be9b.apply(this, arguments);
};
function $6713d6ea845fe63c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6713d6ea845fe63c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6713d6ea845fe63c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6713d6ea845fe63c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6713d6ea845fe63c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6713d6ea845fe63c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6713d6ea845fe63c$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $6713d6ea845fe63c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6713d6ea845fe63c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6713d6ea845fe63c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6713d6ea845fe63c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6713d6ea845fe63c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6713d6ea845fe63c$export$10c90e4f7922046c(v) {
    return this instanceof $6713d6ea845fe63c$export$10c90e4f7922046c ? (this.v = v, this) : new $6713d6ea845fe63c$export$10c90e4f7922046c(v);
}
function $6713d6ea845fe63c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6713d6ea845fe63c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6713d6ea845fe63c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6713d6ea845fe63c$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6713d6ea845fe63c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6713d6ea845fe63c$export$19a8beecd37a4c45 === "function" ? $6713d6ea845fe63c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6713d6ea845fe63c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $6713d6ea845fe63c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $6713d6ea845fe63c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6713d6ea845fe63c$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $6713d6ea845fe63c$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("gyel3", function(module, exports) {

$parcel$export(module.exports, "createWebChannelTransport", () => $c0caf1a922d2a97f$export$66869136fc133c3a);
$parcel$export(module.exports, "ErrorCode", () => $c0caf1a922d2a97f$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "EventType", () => $c0caf1a922d2a97f$export$3d7865934588d77e);
$parcel$export(module.exports, "WebChannel", () => $c0caf1a922d2a97f$export$aa726fb96ad3e039);
$parcel$export(module.exports, "XhrIo", () => $c0caf1a922d2a97f$export$26404658cda3ee02);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function $c0caf1a922d2a97f$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $c0caf1a922d2a97f$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $c0caf1a922d2a97f$var$g, $c0caf1a922d2a97f$var$goog = $c0caf1a922d2a97f$var$goog || {}, $c0caf1a922d2a97f$var$k = $c0caf1a922d2a97f$var$commonjsGlobal || self;
function $c0caf1a922d2a97f$var$aa() {}
function $c0caf1a922d2a97f$var$ba(a) {
    var b = typeof a;
    if ("object" == b) {
        if (a) {
            if (a instanceof Array) return "array";
            if (a instanceof Object) return b;
            var c = Object.prototype.toString.call(a);
            if ("[object Window]" == c) return "object";
            if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
            if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
        } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b;
}
function $c0caf1a922d2a97f$var$da(a) {
    var b = $c0caf1a922d2a97f$var$ba(a);
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $c0caf1a922d2a97f$var$m(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $c0caf1a922d2a97f$var$ea(a) {
    return Object.prototype.hasOwnProperty.call(a, $c0caf1a922d2a97f$var$fa) && a[$c0caf1a922d2a97f$var$fa] || (a[$c0caf1a922d2a97f$var$fa] = ++$c0caf1a922d2a97f$var$ha);
}
var $c0caf1a922d2a97f$var$fa = "closure_uid_" + (1E9 * Math.random() >>> 0), $c0caf1a922d2a97f$var$ha = 0;
function $c0caf1a922d2a97f$var$ia(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $c0caf1a922d2a97f$var$ja(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $c0caf1a922d2a97f$var$n(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $c0caf1a922d2a97f$var$n = $c0caf1a922d2a97f$var$ia : $c0caf1a922d2a97f$var$n = $c0caf1a922d2a97f$var$ja;
    return $c0caf1a922d2a97f$var$n.apply(null, arguments);
}
function $c0caf1a922d2a97f$var$ka(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
var $c0caf1a922d2a97f$var$q = Date.now || function() {
    return +new Date;
};
function $c0caf1a922d2a97f$var$r(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.M = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
}
function $c0caf1a922d2a97f$var$t() {
    this.j = this.j;
    this.i = this.i;
}
var $c0caf1a922d2a97f$var$la = 0;
$c0caf1a922d2a97f$var$t.prototype.j = !1;
$c0caf1a922d2a97f$var$t.prototype.da = function() {
    if (!this.j && (this.j = !0, this.C(), 0 != $c0caf1a922d2a97f$var$la)) var a = $c0caf1a922d2a97f$var$ea(this);
};
$c0caf1a922d2a97f$var$t.prototype.C = function() {
    if (this.i) for(; this.i.length;)this.i.shift()();
};
var $c0caf1a922d2a97f$var$na = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
}, $c0caf1a922d2a97f$var$oa = Array.prototype.forEach ? function(a, b, c) {
    Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
    for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
};
function $c0caf1a922d2a97f$var$pa(a) {
    a: {
        var b = $c0caf1a922d2a97f$var$qa;
        for(var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)if (e in d && b.call(void 0, d[e], e, a)) {
            b = e;
            break a;
        }
        b = -1;
    }
    return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
}
function $c0caf1a922d2a97f$var$ra(a) {
    return Array.prototype.concat.apply([], arguments);
}
function $c0caf1a922d2a97f$var$sa(a) {
    var b = a.length;
    if (0 < b) {
        for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $c0caf1a922d2a97f$var$wa(a) {
    return /^[\s\xa0]*$/.test(a);
}
var $c0caf1a922d2a97f$var$xa = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function $c0caf1a922d2a97f$var$u(a, b) {
    return -1 != a.indexOf(b);
}
function $c0caf1a922d2a97f$var$ya(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var $c0caf1a922d2a97f$var$v;
a: {
    var $c0caf1a922d2a97f$var$za = $c0caf1a922d2a97f$var$k.navigator;
    if ($c0caf1a922d2a97f$var$za) {
        var $c0caf1a922d2a97f$var$Aa = $c0caf1a922d2a97f$var$za.userAgent;
        if ($c0caf1a922d2a97f$var$Aa) {
            $c0caf1a922d2a97f$var$v = $c0caf1a922d2a97f$var$Aa;
            break a;
        }
    }
    $c0caf1a922d2a97f$var$v = "";
}
function $c0caf1a922d2a97f$var$Ba(a, b, c) {
    for(var d in a)b.call(c, a[d], d, a);
}
function $c0caf1a922d2a97f$var$Ca(a) {
    var b = {};
    for(var c in a)b[c] = a[c];
    return b;
}
var $c0caf1a922d2a97f$var$Da = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $c0caf1a922d2a97f$var$Ea(a, b) {
    var c, d;
    for(var e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(var f = 0; f < $c0caf1a922d2a97f$var$Da.length; f++)c = $c0caf1a922d2a97f$var$Da[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $c0caf1a922d2a97f$var$Fa(a) {
    $c0caf1a922d2a97f$var$Fa[" "](a);
    return a;
}
$c0caf1a922d2a97f$var$Fa[" "] = $c0caf1a922d2a97f$var$aa;
function $c0caf1a922d2a97f$var$Ga(a, b) {
    var c = $c0caf1a922d2a97f$var$Ha;
    return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}
var $c0caf1a922d2a97f$var$Ia = $c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Opera"), $c0caf1a922d2a97f$var$w = $c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Trident") || $c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "MSIE"), $c0caf1a922d2a97f$var$Ja = $c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Edge"), $c0caf1a922d2a97f$var$Ka = $c0caf1a922d2a97f$var$Ja || $c0caf1a922d2a97f$var$w, $c0caf1a922d2a97f$var$La = $c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Gecko") && !($c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v.toLowerCase(), "webkit") && !$c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Edge")) && !($c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Trident") || $c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "MSIE")) && !$c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Edge"), $c0caf1a922d2a97f$var$Ma = $c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v.toLowerCase(), "webkit") && !$c0caf1a922d2a97f$var$u($c0caf1a922d2a97f$var$v, "Edge");
function $c0caf1a922d2a97f$var$Na() {
    var a = $c0caf1a922d2a97f$var$k.document;
    return a ? a.documentMode : void 0;
}
var $c0caf1a922d2a97f$var$Oa;
a: {
    var $c0caf1a922d2a97f$var$Pa = "", $c0caf1a922d2a97f$var$Qa = function() {
        var a = $c0caf1a922d2a97f$var$v;
        if ($c0caf1a922d2a97f$var$La) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($c0caf1a922d2a97f$var$Ja) return /Edge\/([\d\.]+)/.exec(a);
        if ($c0caf1a922d2a97f$var$w) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($c0caf1a922d2a97f$var$Ma) return /WebKit\/(\S+)/.exec(a);
        if ($c0caf1a922d2a97f$var$Ia) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $c0caf1a922d2a97f$var$Qa && ($c0caf1a922d2a97f$var$Pa = $c0caf1a922d2a97f$var$Qa ? $c0caf1a922d2a97f$var$Qa[1] : "");
    if ($c0caf1a922d2a97f$var$w) {
        var $c0caf1a922d2a97f$var$Ra = $c0caf1a922d2a97f$var$Na();
        if (null != $c0caf1a922d2a97f$var$Ra && $c0caf1a922d2a97f$var$Ra > parseFloat($c0caf1a922d2a97f$var$Pa)) {
            $c0caf1a922d2a97f$var$Oa = String($c0caf1a922d2a97f$var$Ra);
            break a;
        }
    }
    $c0caf1a922d2a97f$var$Oa = $c0caf1a922d2a97f$var$Pa;
}
var $c0caf1a922d2a97f$var$Ha = {};
function $c0caf1a922d2a97f$var$Sa(a) {
    return $c0caf1a922d2a97f$var$Ga(a, function() {
        var b = 0;
        var e = $c0caf1a922d2a97f$var$xa(String($c0caf1a922d2a97f$var$Oa)).split("."), f = $c0caf1a922d2a97f$var$xa(String(a)).split("."), h = Math.max(e.length, f.length);
        for(var l = 0; 0 == b && l < h; l++){
            var c = e[l] || "", d = f[l] || "";
            do {
                c = /(\d*)(\D*)(.*)/.exec(c) || [
                    "",
                    "",
                    "",
                    ""
                ];
                d = /(\d*)(\D*)(.*)/.exec(d) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == c[0].length && 0 == d[0].length) break;
                b = $c0caf1a922d2a97f$var$ya(0 == c[1].length ? 0 : parseInt(c[1], 10), 0 == d[1].length ? 0 : parseInt(d[1], 10)) || $c0caf1a922d2a97f$var$ya(0 == c[2].length, 0 == d[2].length) || $c0caf1a922d2a97f$var$ya(c[2], d[2]);
                c = c[3];
                d = d[3];
            }while (0 == b);
        }
        return 0 <= b;
    });
}
var $c0caf1a922d2a97f$var$Ta;
if ($c0caf1a922d2a97f$var$k.document && $c0caf1a922d2a97f$var$w) {
    var $c0caf1a922d2a97f$var$Ua = $c0caf1a922d2a97f$var$Na();
    $c0caf1a922d2a97f$var$Ta = $c0caf1a922d2a97f$var$Ua ? $c0caf1a922d2a97f$var$Ua : parseInt($c0caf1a922d2a97f$var$Oa, 10) || void 0;
} else $c0caf1a922d2a97f$var$Ta = void 0;
var $c0caf1a922d2a97f$var$Va = $c0caf1a922d2a97f$var$Ta;
var $c0caf1a922d2a97f$var$Wa = !$c0caf1a922d2a97f$var$w || 9 <= Number($c0caf1a922d2a97f$var$Va), $c0caf1a922d2a97f$var$Xa = $c0caf1a922d2a97f$var$w && !$c0caf1a922d2a97f$var$Sa("9"), $c0caf1a922d2a97f$var$Ya = function() {
    if (!$c0caf1a922d2a97f$var$k.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $c0caf1a922d2a97f$var$k.addEventListener("test", $c0caf1a922d2a97f$var$aa, b), $c0caf1a922d2a97f$var$k.removeEventListener("test", $c0caf1a922d2a97f$var$aa, b);
    } catch (c) {}
    return a;
}();
function $c0caf1a922d2a97f$var$x(a, b) {
    this.type = a;
    this.a = this.target = b;
    this.defaultPrevented = !1;
}
$c0caf1a922d2a97f$var$x.prototype.b = function() {
    this.defaultPrevented = !0;
};
function $c0caf1a922d2a97f$var$y(a, b) {
    $c0caf1a922d2a97f$var$x.call(this, a ? a.type : "");
    this.relatedTarget = this.a = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.pointerId = 0;
    this.pointerType = "";
    this.c = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.a = b;
        if (b = a.relatedTarget) {
            if ($c0caf1a922d2a97f$var$La) {
                a: {
                    try {
                        $c0caf1a922d2a97f$var$Fa(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $c0caf1a922d2a97f$var$Za[a.pointerType] || "";
        this.c = a;
        a.defaultPrevented && this.b();
    }
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$y, $c0caf1a922d2a97f$var$x);
var $c0caf1a922d2a97f$var$Za = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$c0caf1a922d2a97f$var$y.prototype.b = function() {
    $c0caf1a922d2a97f$var$y.M.b.call(this);
    var a = this.c;
    if (a.preventDefault) a.preventDefault();
    else if (a.returnValue = !1, $c0caf1a922d2a97f$var$Xa) try {
        if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
    } catch (b) {}
};
var $c0caf1a922d2a97f$var$A = "closure_listenable_" + (1E6 * Math.random() | 0), $c0caf1a922d2a97f$var$$a = 0;
function $c0caf1a922d2a97f$var$ab(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.aa = e;
    this.key = ++$c0caf1a922d2a97f$var$$a;
    this.V = this.X = !1;
}
function $c0caf1a922d2a97f$var$bb(a) {
    a.V = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.aa = null;
}
function $c0caf1a922d2a97f$var$cb(a) {
    this.src = a;
    this.a = {};
    this.b = 0;
}
$c0caf1a922d2a97f$var$cb.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.a[f];
    a || (a = this.a[f] = [], this.b++);
    var h = $c0caf1a922d2a97f$var$db(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.X = !1)) : (b = new $c0caf1a922d2a97f$var$ab(b, this.src, f, !!d, e), b.X = c, a.push(b));
    return b;
};
function $c0caf1a922d2a97f$var$eb(a, b) {
    var c = b.type;
    if (c in a.a) {
        var d = a.a[c], e = $c0caf1a922d2a97f$var$na(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($c0caf1a922d2a97f$var$bb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
}
function $c0caf1a922d2a97f$var$db(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.V && f.listener == b && f.capture == !!c && f.aa == d) return e;
    }
    return -1;
}
var $c0caf1a922d2a97f$var$fb = "closure_lm_" + (1E6 * Math.random() | 0), $c0caf1a922d2a97f$var$gb = {};
function $c0caf1a922d2a97f$var$ib(a, b, c, d, e) {
    if (d && d.once) return $c0caf1a922d2a97f$var$jb(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$c0caf1a922d2a97f$var$ib(a, b[f], c, d, e);
        return null;
    }
    c = $c0caf1a922d2a97f$var$kb(c);
    return a && a[$c0caf1a922d2a97f$var$A] ? a.ra(b, c, $c0caf1a922d2a97f$var$m(d) ? !!d.capture : !!d, e) : $c0caf1a922d2a97f$var$lb(a, b, c, !1, d, e);
}
function $c0caf1a922d2a97f$var$lb(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $c0caf1a922d2a97f$var$m(e) ? !!e.capture : !!e;
    if (h && !$c0caf1a922d2a97f$var$Wa) return null;
    var l = $c0caf1a922d2a97f$var$mb(a);
    l || (a[$c0caf1a922d2a97f$var$fb] = l = new $c0caf1a922d2a97f$var$cb(a));
    c = l.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $c0caf1a922d2a97f$var$nb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $c0caf1a922d2a97f$var$Ya || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($c0caf1a922d2a97f$var$ob(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $c0caf1a922d2a97f$var$nb() {
    var a = $c0caf1a922d2a97f$var$pb, b = $c0caf1a922d2a97f$var$Wa ? function(c) {
        return a.call(b.src, b.listener, c);
    } : function(c) {
        c = a.call(b.src, b.listener, c);
        if (!c) return c;
    };
    return b;
}
function $c0caf1a922d2a97f$var$jb(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$c0caf1a922d2a97f$var$jb(a, b[f], c, d, e);
        return null;
    }
    c = $c0caf1a922d2a97f$var$kb(c);
    return a && a[$c0caf1a922d2a97f$var$A] ? a.sa(b, c, $c0caf1a922d2a97f$var$m(d) ? !!d.capture : !!d, e) : $c0caf1a922d2a97f$var$lb(a, b, c, !0, d, e);
}
function $c0caf1a922d2a97f$var$qb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$c0caf1a922d2a97f$var$qb(a, b[f], c, d, e);
    else (d = $c0caf1a922d2a97f$var$m(d) ? !!d.capture : !!d, c = $c0caf1a922d2a97f$var$kb(c), a && a[$c0caf1a922d2a97f$var$A]) ? (a = a.c, b = String(b).toString(), b in a.a && (f = a.a[b], c = $c0caf1a922d2a97f$var$db(f, c, d, e), -1 < c && ($c0caf1a922d2a97f$var$bb(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = $c0caf1a922d2a97f$var$mb(a)) && (b = a.a[b.toString()], a = -1, b && (a = $c0caf1a922d2a97f$var$db(b, c, d, e)), (c = -1 < a ? b[a] : null) && $c0caf1a922d2a97f$var$rb(c));
}
function $c0caf1a922d2a97f$var$rb(a) {
    if ("number" !== typeof a && a && !a.V) {
        var b = a.src;
        if (b && b[$c0caf1a922d2a97f$var$A]) $c0caf1a922d2a97f$var$eb(b.c, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($c0caf1a922d2a97f$var$ob(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $c0caf1a922d2a97f$var$mb(b)) ? ($c0caf1a922d2a97f$var$eb(c, a), 0 == c.b && (c.src = null, b[$c0caf1a922d2a97f$var$fb] = null)) : $c0caf1a922d2a97f$var$bb(a);
        }
    }
}
function $c0caf1a922d2a97f$var$ob(a) {
    return a in $c0caf1a922d2a97f$var$gb ? $c0caf1a922d2a97f$var$gb[a] : $c0caf1a922d2a97f$var$gb[a] = "on" + a;
}
function $c0caf1a922d2a97f$var$sb(a, b) {
    var c = a.listener, d = a.aa || a.src;
    a.X && $c0caf1a922d2a97f$var$rb(a);
    return c.call(d, b);
}
function $c0caf1a922d2a97f$var$pb(a, b) {
    if (a.V) return !0;
    if (!$c0caf1a922d2a97f$var$Wa) {
        if (!b) a: {
            b = [
                "window",
                "event"
            ];
            for(var c = $c0caf1a922d2a97f$var$k, d = 0; d < b.length; d++)if (c = c[b[d]], null == c) {
                b = null;
                break a;
            }
            b = c;
        }
        b = new $c0caf1a922d2a97f$var$y(b, this);
        return $c0caf1a922d2a97f$var$sb(a, b);
    }
    return $c0caf1a922d2a97f$var$sb(a, new $c0caf1a922d2a97f$var$y(b, this));
}
function $c0caf1a922d2a97f$var$mb(a) {
    a = a[$c0caf1a922d2a97f$var$fb];
    return a instanceof $c0caf1a922d2a97f$var$cb ? a : null;
}
var $c0caf1a922d2a97f$var$tb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $c0caf1a922d2a97f$var$kb(a) {
    if ("function" == $c0caf1a922d2a97f$var$ba(a)) return a;
    a[$c0caf1a922d2a97f$var$tb] || (a[$c0caf1a922d2a97f$var$tb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$c0caf1a922d2a97f$var$tb];
}
function $c0caf1a922d2a97f$var$B() {
    $c0caf1a922d2a97f$var$t.call(this);
    this.c = new $c0caf1a922d2a97f$var$cb(this);
    this.J = this;
    this.A = null;
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$B, $c0caf1a922d2a97f$var$t);
$c0caf1a922d2a97f$var$B.prototype[$c0caf1a922d2a97f$var$A] = !0;
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$B.prototype;
$c0caf1a922d2a97f$var$g.addEventListener = function(a, b, c, d) {
    $c0caf1a922d2a97f$var$ib(this, a, b, c, d);
};
$c0caf1a922d2a97f$var$g.removeEventListener = function(a, b, c, d) {
    $c0caf1a922d2a97f$var$qb(this, a, b, c, d);
};
$c0caf1a922d2a97f$var$g.dispatchEvent = function(a) {
    var b, c = this.A;
    if (c) for(b = []; c; c = c.A)b.push(c);
    c = this.J;
    var d = a.type || a;
    if ("string" === typeof a) a = new $c0caf1a922d2a97f$var$x(a, c);
    else if (a instanceof $c0caf1a922d2a97f$var$x) a.target = a.target || c;
    else {
        var e = a;
        a = new $c0caf1a922d2a97f$var$x(d, c);
        $c0caf1a922d2a97f$var$Ea(a, e);
    }
    e = !0;
    if (b) for(var f = b.length - 1; 0 <= f; f--){
        var h = a.a = b[f];
        e = $c0caf1a922d2a97f$var$ub(h, d, !0, a) && e;
    }
    h = a.a = c;
    e = $c0caf1a922d2a97f$var$ub(h, d, !0, a) && e;
    e = $c0caf1a922d2a97f$var$ub(h, d, !1, a) && e;
    if (b) for(f = 0; f < b.length; f++)h = a.a = b[f], e = $c0caf1a922d2a97f$var$ub(h, d, !1, a) && e;
    return e;
};
$c0caf1a922d2a97f$var$g.C = function() {
    $c0caf1a922d2a97f$var$B.M.C.call(this);
    if (this.c) {
        var a = this.c, c;
        for(c in a.a){
            for(var d = a.a[c], e = 0; e < d.length; e++)$c0caf1a922d2a97f$var$bb(d[e]);
            delete a.a[c];
            a.b--;
        }
    }
    this.A = null;
};
$c0caf1a922d2a97f$var$g.ra = function(a, b, c, d) {
    return this.c.add(String(a), b, !1, c, d);
};
$c0caf1a922d2a97f$var$g.sa = function(a, b, c, d) {
    return this.c.add(String(a), b, !0, c, d);
};
function $c0caf1a922d2a97f$var$ub(a, b, c, d) {
    b = a.c.a[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.V && h.capture == c) {
            var l = h.listener, p = h.aa || h.src;
            h.X && $c0caf1a922d2a97f$var$eb(a.c, h);
            e = !1 !== l.call(p, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $c0caf1a922d2a97f$var$vb = $c0caf1a922d2a97f$var$k.JSON.stringify;
function $c0caf1a922d2a97f$var$wb() {
    this.b = this.a = null;
}
var $c0caf1a922d2a97f$var$yb = new /** @class */ (function() {
    function class_1(a, b, c) {
        this.f = c;
        this.c = a;
        this.g = b;
        this.b = 0;
        this.a = null;
    }
    class_1.prototype.get = function() {
        var a;
        0 < this.b ? (this.b--, a = this.a, this.a = a.next, a.next = null) : a = this.c();
        return a;
    };
    return class_1;
}())(function() {
    return new $c0caf1a922d2a97f$var$xb;
}, function(a) {
    a.reset();
}, 100);
$c0caf1a922d2a97f$var$wb.prototype.add = function(a, b) {
    var c = $c0caf1a922d2a97f$var$yb.get();
    c.set(a, b);
    this.b ? this.b.next = c : this.a = c;
    this.b = c;
};
function $c0caf1a922d2a97f$var$zb() {
    var a = $c0caf1a922d2a97f$var$Ab, b = null;
    a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);
    return b;
}
function $c0caf1a922d2a97f$var$xb() {
    this.next = this.b = this.a = null;
}
$c0caf1a922d2a97f$var$xb.prototype.set = function(a, b) {
    this.a = a;
    this.b = b;
    this.next = null;
};
$c0caf1a922d2a97f$var$xb.prototype.reset = function() {
    this.next = this.b = this.a = null;
};
function $c0caf1a922d2a97f$var$Bb(a) {
    $c0caf1a922d2a97f$var$k.setTimeout(function() {
        throw a;
    }, 0);
}
function $c0caf1a922d2a97f$var$Cb(a, b) {
    $c0caf1a922d2a97f$var$Db || $c0caf1a922d2a97f$var$Eb();
    $c0caf1a922d2a97f$var$Fb || ($c0caf1a922d2a97f$var$Db(), $c0caf1a922d2a97f$var$Fb = !0);
    $c0caf1a922d2a97f$var$Ab.add(a, b);
}
var $c0caf1a922d2a97f$var$Db;
function $c0caf1a922d2a97f$var$Eb() {
    var a = $c0caf1a922d2a97f$var$k.Promise.resolve(void 0);
    $c0caf1a922d2a97f$var$Db = function() {
        a.then($c0caf1a922d2a97f$var$Gb);
    };
}
var $c0caf1a922d2a97f$var$Fb = !1, $c0caf1a922d2a97f$var$Ab = new $c0caf1a922d2a97f$var$wb;
function $c0caf1a922d2a97f$var$Gb() {
    for(var a; a = $c0caf1a922d2a97f$var$zb();){
        try {
            a.a.call(a.b);
        } catch (c) {
            $c0caf1a922d2a97f$var$Bb(c);
        }
        var b = $c0caf1a922d2a97f$var$yb;
        b.g(a);
        b.b < b.f && (b.b++, a.next = b.a, b.a = a);
    }
    $c0caf1a922d2a97f$var$Fb = !1;
}
function $c0caf1a922d2a97f$var$Hb(a, b) {
    $c0caf1a922d2a97f$var$B.call(this);
    this.b = a || 1;
    this.a = b || $c0caf1a922d2a97f$var$k;
    this.f = $c0caf1a922d2a97f$var$n(this.Ua, this);
    this.g = $c0caf1a922d2a97f$var$q();
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Hb, $c0caf1a922d2a97f$var$B);
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$Hb.prototype;
$c0caf1a922d2a97f$var$g.Z = !1;
$c0caf1a922d2a97f$var$g.L = null;
$c0caf1a922d2a97f$var$g.Ua = function() {
    if (this.Z) {
        var a = $c0caf1a922d2a97f$var$q() - this.g;
        0 < a && a < .8 * this.b ? this.L = this.a.setTimeout(this.f, this.b - a) : (this.L && (this.a.clearTimeout(this.L), this.L = null), this.dispatchEvent("tick"), this.Z && ($c0caf1a922d2a97f$var$Ib(this), this.start()));
    }
};
$c0caf1a922d2a97f$var$g.start = function() {
    this.Z = !0;
    this.L || (this.L = this.a.setTimeout(this.f, this.b), this.g = $c0caf1a922d2a97f$var$q());
};
function $c0caf1a922d2a97f$var$Ib(a) {
    a.Z = !1;
    a.L && (a.a.clearTimeout(a.L), a.L = null);
}
$c0caf1a922d2a97f$var$g.C = function() {
    $c0caf1a922d2a97f$var$Hb.M.C.call(this);
    $c0caf1a922d2a97f$var$Ib(this);
    delete this.a;
};
function $c0caf1a922d2a97f$var$Jb(a, b, c) {
    if ("function" == $c0caf1a922d2a97f$var$ba(a)) c && (a = $c0caf1a922d2a97f$var$n(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $c0caf1a922d2a97f$var$n(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $c0caf1a922d2a97f$var$k.setTimeout(a, b || 0);
}
function $c0caf1a922d2a97f$var$Kb(a, b, c) {
    $c0caf1a922d2a97f$var$t.call(this);
    this.f = null != c ? $c0caf1a922d2a97f$var$n(a, c) : a;
    this.c = b;
    this.b = $c0caf1a922d2a97f$var$n(this.Pa, this);
    this.a = [];
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Kb, $c0caf1a922d2a97f$var$t);
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$Kb.prototype;
$c0caf1a922d2a97f$var$g.ba = !1;
$c0caf1a922d2a97f$var$g.T = null;
$c0caf1a922d2a97f$var$g.Ia = function(a) {
    this.a = arguments;
    this.T ? this.ba = !0 : $c0caf1a922d2a97f$var$Lb(this);
};
$c0caf1a922d2a97f$var$g.C = function() {
    $c0caf1a922d2a97f$var$Kb.M.C.call(this);
    this.T && ($c0caf1a922d2a97f$var$k.clearTimeout(this.T), this.T = null, this.ba = !1, this.a = []);
};
$c0caf1a922d2a97f$var$g.Pa = function() {
    this.T = null;
    this.ba && (this.ba = !1, $c0caf1a922d2a97f$var$Lb(this));
};
function $c0caf1a922d2a97f$var$Lb(a) {
    a.T = $c0caf1a922d2a97f$var$Jb(a.b, a.c);
    a.f.apply(null, a.a);
}
function $c0caf1a922d2a97f$var$C(a) {
    $c0caf1a922d2a97f$var$t.call(this);
    this.b = a;
    this.a = {};
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$C, $c0caf1a922d2a97f$var$t);
var $c0caf1a922d2a97f$var$Mb = [];
function $c0caf1a922d2a97f$var$Nb(a, b, c, d) {
    Array.isArray(c) || (c && ($c0caf1a922d2a97f$var$Mb[0] = c.toString()), c = $c0caf1a922d2a97f$var$Mb);
    for(var e = 0; e < c.length; e++){
        var f = $c0caf1a922d2a97f$var$ib(b, c[e], d || a.handleEvent, !1, a.b || a);
        if (!f) break;
        a.a[f.key] = f;
    }
}
function $c0caf1a922d2a97f$var$Ob(a) {
    $c0caf1a922d2a97f$var$Ba(a.a, function(b, c) {
        this.a.hasOwnProperty(c) && $c0caf1a922d2a97f$var$rb(b);
    }, a);
    a.a = {};
}
$c0caf1a922d2a97f$var$C.prototype.C = function() {
    $c0caf1a922d2a97f$var$C.M.C.call(this);
    $c0caf1a922d2a97f$var$Ob(this);
};
$c0caf1a922d2a97f$var$C.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $c0caf1a922d2a97f$var$Pb() {}
var $c0caf1a922d2a97f$var$Qb = null;
function $c0caf1a922d2a97f$var$Rb() {
    return $c0caf1a922d2a97f$var$Qb = $c0caf1a922d2a97f$var$Qb || new $c0caf1a922d2a97f$var$B;
}
function $c0caf1a922d2a97f$var$Sb(a) {
    $c0caf1a922d2a97f$var$x.call(this, "serverreachability", a);
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Sb, $c0caf1a922d2a97f$var$x);
function $c0caf1a922d2a97f$var$E(a) {
    var b = $c0caf1a922d2a97f$var$Rb();
    b.dispatchEvent(new $c0caf1a922d2a97f$var$Sb(b, a));
}
function $c0caf1a922d2a97f$var$Tb(a) {
    $c0caf1a922d2a97f$var$x.call(this, "statevent", a);
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Tb, $c0caf1a922d2a97f$var$x);
function $c0caf1a922d2a97f$var$F(a) {
    var b = $c0caf1a922d2a97f$var$Rb();
    b.dispatchEvent(new $c0caf1a922d2a97f$var$Tb(b, a));
}
function $c0caf1a922d2a97f$var$Ub(a) {
    $c0caf1a922d2a97f$var$x.call(this, "timingevent", a);
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Ub, $c0caf1a922d2a97f$var$x);
function $c0caf1a922d2a97f$var$Vb(a, b) {
    if ("function" != $c0caf1a922d2a97f$var$ba(a)) throw Error("Fn must not be null and must be a function");
    return $c0caf1a922d2a97f$var$k.setTimeout(function() {
        a();
    }, b);
}
var $c0caf1a922d2a97f$var$Wb = {
    NO_ERROR: 0,
    Va: 1,
    bb: 2,
    ab: 3,
    Ya: 4,
    $a: 5,
    cb: 6,
    za: 7,
    TIMEOUT: 8,
    gb: 9
};
var $c0caf1a922d2a97f$var$Xb = {
    Xa: "complete",
    kb: "success",
    Aa: "error",
    za: "abort",
    ib: "ready",
    jb: "readystatechange",
    TIMEOUT: "timeout",
    eb: "incrementaldata",
    hb: "progress",
    Za: "downloadprogress",
    lb: "uploadprogress"
};
function $c0caf1a922d2a97f$var$Yb() {}
$c0caf1a922d2a97f$var$Yb.prototype.a = null;
function $c0caf1a922d2a97f$var$Zb(a) {
    var b;
    (b = a.a) || (b = a.a = {});
    return b;
}
function $c0caf1a922d2a97f$var$$b() {}
var $c0caf1a922d2a97f$var$G = {
    OPEN: "a",
    Wa: "b",
    Aa: "c",
    fb: "d"
};
function $c0caf1a922d2a97f$var$ac() {
    $c0caf1a922d2a97f$var$x.call(this, "d");
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$ac, $c0caf1a922d2a97f$var$x);
function $c0caf1a922d2a97f$var$bc() {
    $c0caf1a922d2a97f$var$x.call(this, "c");
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$bc, $c0caf1a922d2a97f$var$x);
var $c0caf1a922d2a97f$var$cc;
function $c0caf1a922d2a97f$var$dc() {}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$dc, $c0caf1a922d2a97f$var$Yb);
$c0caf1a922d2a97f$var$cc = new $c0caf1a922d2a97f$var$dc;
function $c0caf1a922d2a97f$var$H(a, b, c) {
    this.g = a;
    this.W = b;
    this.U = c || 1;
    this.G = new $c0caf1a922d2a97f$var$C(this);
    this.N = $c0caf1a922d2a97f$var$ec;
    a = $c0caf1a922d2a97f$var$Ka ? 125 : void 0;
    this.O = new $c0caf1a922d2a97f$var$Hb(a);
    this.m = null;
    this.b = !1;
    this.j = this.A = this.f = this.B = this.s = this.P = this.h = null;
    this.i = [];
    this.a = null;
    this.w = 0;
    this.c = this.v = null;
    this.H = -1;
    this.l = !1;
    this.J = 0;
    this.D = null;
    this.o = this.R = this.F = !1;
}
var $c0caf1a922d2a97f$var$ec = 45E3, $c0caf1a922d2a97f$var$fc = {}, $c0caf1a922d2a97f$var$gc = {};
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$H.prototype;
$c0caf1a922d2a97f$var$g.setTimeout = function(a) {
    this.N = a;
};
function $c0caf1a922d2a97f$var$hc(a, b, c) {
    a.B = 1;
    a.f = $c0caf1a922d2a97f$var$ic($c0caf1a922d2a97f$var$I(b));
    a.j = c;
    a.F = !0;
    $c0caf1a922d2a97f$var$jc(a, null);
}
function $c0caf1a922d2a97f$var$jc(a, b) {
    a.s = $c0caf1a922d2a97f$var$q();
    $c0caf1a922d2a97f$var$J(a);
    a.A = $c0caf1a922d2a97f$var$I(a.f);
    var c = a.A, d = a.U;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $c0caf1a922d2a97f$var$kc(c.b, "t", d);
    a.w = 0;
    a.a = $c0caf1a922d2a97f$var$lc(a.g, a.g.w ? b : null);
    0 < a.J && (a.D = new $c0caf1a922d2a97f$var$Kb($c0caf1a922d2a97f$var$n(a.ya, a, a.a), a.J));
    $c0caf1a922d2a97f$var$Nb(a.G, a.a, "readystatechange", a.Sa);
    b = a.m ? $c0caf1a922d2a97f$var$Ca(a.m) : {};
    a.j ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.a.$(a.A, a.v, a.j, b)) : (a.v = "GET", a.a.$(a.A, a.v, null, b));
    $c0caf1a922d2a97f$var$E(1);
}
$c0caf1a922d2a97f$var$g.Sa = function(a) {
    a = a.target;
    var b = this.D;
    b && 3 == $c0caf1a922d2a97f$var$K(a) ? b.Ia() : this.ya(a);
};
$c0caf1a922d2a97f$var$g.ya = function(a) {
    try {
        if (a == this.a) a: {
            var b = $c0caf1a922d2a97f$var$K(this.a), c = this.a.qa(), d = this.a.S();
            if (!(3 > b || 3 == b && !$c0caf1a922d2a97f$var$Ka && !this.a.Y())) {
                this.l || 4 != b || 7 == c || (8 == c || 0 >= d ? $c0caf1a922d2a97f$var$E(3) : $c0caf1a922d2a97f$var$E(2));
                $c0caf1a922d2a97f$var$mc(this);
                var e = this.a.S();
                this.H = e;
                var f = this.a.Y();
                if (this.b = 200 == e) {
                    if (this.R && !this.o) {
                        b: {
                            if (this.a) {
                                var h, l = this.a;
                                if ((h = l.a ? l.a.getResponseHeader("X-HTTP-Initial-Response") : null) && !$c0caf1a922d2a97f$var$wa(h)) {
                                    var p = h;
                                    break b;
                                }
                            }
                            p = null;
                        }
                        if (p) this.o = !0, $c0caf1a922d2a97f$var$nc(this, p);
                        else {
                            this.b = !1;
                            this.c = 3;
                            $c0caf1a922d2a97f$var$F(12);
                            $c0caf1a922d2a97f$var$L(this);
                            $c0caf1a922d2a97f$var$pc(this);
                            break a;
                        }
                    }
                    this.F ? ($c0caf1a922d2a97f$var$qc(this, b, f), $c0caf1a922d2a97f$var$Ka && this.b && 3 == b && ($c0caf1a922d2a97f$var$Nb(this.G, this.O, "tick", this.Ra), this.O.start())) : $c0caf1a922d2a97f$var$nc(this, f);
                    4 == b && $c0caf1a922d2a97f$var$L(this);
                    this.b && !this.l && (4 == b ? $c0caf1a922d2a97f$var$rc(this.g, this) : (this.b = !1, $c0caf1a922d2a97f$var$J(this)));
                } else 400 == e && 0 < f.indexOf("Unknown SID") ? (this.c = 3, $c0caf1a922d2a97f$var$F(12)) : (this.c = 0, $c0caf1a922d2a97f$var$F(13)), $c0caf1a922d2a97f$var$L(this), $c0caf1a922d2a97f$var$pc(this);
            }
        }
    } catch (D) {} finally{}
};
function $c0caf1a922d2a97f$var$qc(a, b, c) {
    for(var d = !0; !a.l && a.w < c.length;){
        var e = $c0caf1a922d2a97f$var$tc(a, c);
        if (e == $c0caf1a922d2a97f$var$gc) {
            4 == b && (a.c = 4, $c0caf1a922d2a97f$var$F(14), d = !1);
            break;
        } else if (e == $c0caf1a922d2a97f$var$fc) {
            a.c = 4;
            $c0caf1a922d2a97f$var$F(15);
            d = !1;
            break;
        } else $c0caf1a922d2a97f$var$nc(a, e);
    }
    4 == b && 0 == c.length && (a.c = 1, $c0caf1a922d2a97f$var$F(16), d = !1);
    a.b = a.b && d;
    d || ($c0caf1a922d2a97f$var$L(a), $c0caf1a922d2a97f$var$pc(a));
}
$c0caf1a922d2a97f$var$g.Ra = function() {
    if (this.a) {
        var a = $c0caf1a922d2a97f$var$K(this.a), b = this.a.Y();
        this.w < b.length && ($c0caf1a922d2a97f$var$mc(this), $c0caf1a922d2a97f$var$qc(this, a, b), this.b && 4 != a && $c0caf1a922d2a97f$var$J(this));
    }
};
function $c0caf1a922d2a97f$var$tc(a, b) {
    var c = a.w, d = b.indexOf("\n", c);
    if (-1 == d) return $c0caf1a922d2a97f$var$gc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $c0caf1a922d2a97f$var$fc;
    d += 1;
    if (d + c > b.length) return $c0caf1a922d2a97f$var$gc;
    b = b.substr(d, c);
    a.w = d + c;
    return b;
}
$c0caf1a922d2a97f$var$g.cancel = function() {
    this.l = !0;
    $c0caf1a922d2a97f$var$L(this);
};
function $c0caf1a922d2a97f$var$J(a) {
    a.P = $c0caf1a922d2a97f$var$q() + a.N;
    $c0caf1a922d2a97f$var$uc(a, a.N);
}
function $c0caf1a922d2a97f$var$uc(a, b) {
    if (null != a.h) throw Error("WatchDog timer not null");
    a.h = $c0caf1a922d2a97f$var$Vb($c0caf1a922d2a97f$var$n(a.Qa, a), b);
}
function $c0caf1a922d2a97f$var$mc(a) {
    a.h && ($c0caf1a922d2a97f$var$k.clearTimeout(a.h), a.h = null);
}
$c0caf1a922d2a97f$var$g.Qa = function() {
    this.h = null;
    var a = $c0caf1a922d2a97f$var$q();
    0 <= a - this.P ? (2 != this.B && ($c0caf1a922d2a97f$var$E(3), $c0caf1a922d2a97f$var$F(17)), $c0caf1a922d2a97f$var$L(this), this.c = 2, $c0caf1a922d2a97f$var$pc(this)) : $c0caf1a922d2a97f$var$uc(this, this.P - a);
};
function $c0caf1a922d2a97f$var$pc(a) {
    0 == a.g.u || a.l || $c0caf1a922d2a97f$var$rc(a.g, a);
}
function $c0caf1a922d2a97f$var$L(a) {
    $c0caf1a922d2a97f$var$mc(a);
    var b = a.D;
    b && "function" == typeof b.da && b.da();
    a.D = null;
    $c0caf1a922d2a97f$var$Ib(a.O);
    $c0caf1a922d2a97f$var$Ob(a.G);
    a.a && (b = a.a, a.a = null, b.abort(), b.da());
}
function $c0caf1a922d2a97f$var$nc(a, b) {
    try {
        var c = a.g;
        if (0 != c.u && (c.a == a || $c0caf1a922d2a97f$var$vc(c.b, a))) {
            if (c.A = a.H, !a.o && $c0caf1a922d2a97f$var$vc(c.b, a) && 3 == c.u) {
                try {
                    var d = c.ja.a.parse(b);
                } catch (oc) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.i) {
                            if (c.a) {
                                if (c.a.s + 3E3 < a.s) $c0caf1a922d2a97f$var$wc(c), c.a.cancel(), c.a = null;
                                else break a;
                            }
                            $c0caf1a922d2a97f$var$xc(c);
                            $c0caf1a922d2a97f$var$F(18);
                        }
                    } else c.ia = e[1], 0 < c.ia - c.G && 37500 > e[2] && c.U && 0 == c.m && !c.l && (c.l = $c0caf1a922d2a97f$var$Vb($c0caf1a922d2a97f$var$n(c.Na, c), 6E3));
                    if (1 >= $c0caf1a922d2a97f$var$yc(c.b) && c.O) {
                        try {
                            c.O();
                        } catch (oc) {}
                        c.O = void 0;
                    }
                } else $c0caf1a922d2a97f$var$M(c, 11);
            } else if ((a.o || c.a == a) && $c0caf1a922d2a97f$var$wc(c), !$c0caf1a922d2a97f$var$wa(b)) for(b = d = c.ja.a.parse(b), d = 0; d < b.length; d++)if (e = b[d], c.G = e[0], e = e[1], 2 == c.u) {
                if ("c" == e[0]) {
                    c.B = e[1];
                    c.R = e[2];
                    var f = e[3];
                    null != f && (c.oa = f);
                    var h = e[5];
                    null != h && "number" === typeof h && 0 < h && (c.D = 1.5 * h);
                    var l = c, p = a.a;
                    if (p) {
                        var D = p.a ? p.a.getResponseHeader("X-Client-Wire-Protocol") : null;
                        if (D) {
                            var z = l.b;
                            !z.a && ($c0caf1a922d2a97f$var$u(D, "spdy") || $c0caf1a922d2a97f$var$u(D, "quic") || $c0caf1a922d2a97f$var$u(D, "h2")) && (z.f = z.g, z.a = new Set, z.b && ($c0caf1a922d2a97f$var$zc(z, z.b), z.b = null));
                        }
                        if (l.s) {
                            var ta = p.a ? p.a.getResponseHeader("X-HTTP-Session-Id") : null;
                            ta && (l.ha = ta, $c0caf1a922d2a97f$var$N(l.v, l.s, ta));
                        }
                    }
                    c.u = 3;
                    c.c && c.c.na();
                    l = c;
                    var ua = a;
                    l.ea = $c0caf1a922d2a97f$var$Ac(l, l.w ? l.R : null, l.P);
                    if (ua.o) {
                        $c0caf1a922d2a97f$var$Bc(l.b, ua);
                        var va = ua, sc = l.D;
                        sc && va.setTimeout(sc);
                        va.h && ($c0caf1a922d2a97f$var$mc(va), $c0caf1a922d2a97f$var$J(va));
                        l.a = ua;
                    } else $c0caf1a922d2a97f$var$Cc(l);
                    0 < c.f.length && $c0caf1a922d2a97f$var$Dc(c);
                } else "stop" != e[0] && "close" != e[0] || $c0caf1a922d2a97f$var$M(c, 7);
            } else 3 == c.u && ("stop" == e[0] || "close" == e[0] ? "stop" == e[0] ? $c0caf1a922d2a97f$var$M(c, 7) : $c0caf1a922d2a97f$var$Ec(c) : "noop" != e[0] && c.c && c.c.ma(e), c.m = 0);
        }
        $c0caf1a922d2a97f$var$E(4);
    } catch (oc) {}
}
function $c0caf1a922d2a97f$var$Fc(a) {
    if (a.I && "function" == typeof a.I) return a.I();
    if ("string" === typeof a) return a.split("");
    if ($c0caf1a922d2a97f$var$da(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return a = b;
}
function $c0caf1a922d2a97f$var$Gc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($c0caf1a922d2a97f$var$da(a) || "string" === typeof a) $c0caf1a922d2a97f$var$oa(a, b, void 0);
    else {
        if (a.K && "function" == typeof a.K) var c = a.K();
        else if (a.I && "function" == typeof a.I) c = void 0;
        else if ($c0caf1a922d2a97f$var$da(a) || "string" === typeof a) {
            c = [];
            for(var d = a.length, e = 0; e < d; e++)c.push(e);
        } else for(e in c = [], d = 0, a)c[d++] = e;
        d = $c0caf1a922d2a97f$var$Fc(a);
        e = d.length;
        for(var f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
}
function $c0caf1a922d2a97f$var$O(a, b) {
    this.b = {};
    this.a = [];
    this.c = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else if (a) {
        if (a instanceof $c0caf1a922d2a97f$var$O) for(c = a.K(), d = 0; d < c.length; d++)this.set(c[d], a.get(c[d]));
        else for(d in a)this.set(d, a[d]);
    }
}
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$O.prototype;
$c0caf1a922d2a97f$var$g.I = function() {
    $c0caf1a922d2a97f$var$Hc(this);
    for(var a = [], b = 0; b < this.a.length; b++)a.push(this.b[this.a[b]]);
    return a;
};
$c0caf1a922d2a97f$var$g.K = function() {
    $c0caf1a922d2a97f$var$Hc(this);
    return this.a.concat();
};
function $c0caf1a922d2a97f$var$Hc(a) {
    if (a.c != a.a.length) {
        for(var b = 0, c = 0; b < a.a.length;){
            var d = a.a[b];
            $c0caf1a922d2a97f$var$P(a.b, d) && (a.a[c++] = d);
            b++;
        }
        a.a.length = c;
    }
    if (a.c != a.a.length) {
        var e = {};
        for(c = b = 0; b < a.a.length;)d = a.a[b], $c0caf1a922d2a97f$var$P(e, d) || (a.a[c++] = d, e[d] = 1), b++;
        a.a.length = c;
    }
}
$c0caf1a922d2a97f$var$g.get = function(a, b) {
    return $c0caf1a922d2a97f$var$P(this.b, a) ? this.b[a] : b;
};
$c0caf1a922d2a97f$var$g.set = function(a, b) {
    $c0caf1a922d2a97f$var$P(this.b, a) || (this.c++, this.a.push(a));
    this.b[a] = b;
};
$c0caf1a922d2a97f$var$g.forEach = function(a, b) {
    for(var c = this.K(), d = 0; d < c.length; d++){
        var e = c[d], f = this.get(e);
        a.call(b, f, e, this);
    }
};
function $c0caf1a922d2a97f$var$P(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var $c0caf1a922d2a97f$var$Ic = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function $c0caf1a922d2a97f$var$Jc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $c0caf1a922d2a97f$var$Q(a, b) {
    this.c = this.j = this.f = "";
    this.h = null;
    this.i = this.g = "";
    this.a = !1;
    if (a instanceof $c0caf1a922d2a97f$var$Q) {
        this.a = void 0 !== b ? b : a.a;
        $c0caf1a922d2a97f$var$Kc(this, a.f);
        this.j = a.j;
        $c0caf1a922d2a97f$var$Lc(this, a.c);
        $c0caf1a922d2a97f$var$Mc(this, a.h);
        this.g = a.g;
        b = a.b;
        var c = new $c0caf1a922d2a97f$var$R;
        c.c = b.c;
        b.a && (c.a = new $c0caf1a922d2a97f$var$O(b.a), c.b = b.b);
        $c0caf1a922d2a97f$var$Nc(this, c);
        this.i = a.i;
    } else a && (c = String(a).match($c0caf1a922d2a97f$var$Ic)) ? (this.a = !!b, $c0caf1a922d2a97f$var$Kc(this, c[1] || "", !0), this.j = $c0caf1a922d2a97f$var$S(c[2] || ""), $c0caf1a922d2a97f$var$Lc(this, c[3] || "", !0), $c0caf1a922d2a97f$var$Mc(this, c[4]), this.g = $c0caf1a922d2a97f$var$S(c[5] || "", !0), $c0caf1a922d2a97f$var$Nc(this, c[6] || "", !0), this.i = $c0caf1a922d2a97f$var$S(c[7] || "")) : (this.a = !!b, this.b = new $c0caf1a922d2a97f$var$R(null, this.a));
}
$c0caf1a922d2a97f$var$Q.prototype.toString = function() {
    var a = [], b = this.f;
    b && a.push($c0caf1a922d2a97f$var$T(b, $c0caf1a922d2a97f$var$Oc, !0), ":");
    var c = this.c;
    if (c || "file" == b) a.push("//"), (b = this.j) && a.push($c0caf1a922d2a97f$var$T(b, $c0caf1a922d2a97f$var$Oc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.h, null != c && a.push(":", String(c));
    if (c = this.g) this.c && "/" != c.charAt(0) && a.push("/"), a.push($c0caf1a922d2a97f$var$T(c, "/" == c.charAt(0) ? $c0caf1a922d2a97f$var$Pc : $c0caf1a922d2a97f$var$Qc, !0));
    (c = this.b.toString()) && a.push("?", c);
    (c = this.i) && a.push("#", $c0caf1a922d2a97f$var$T(c, $c0caf1a922d2a97f$var$Rc));
    return a.join("");
};
function $c0caf1a922d2a97f$var$I(a) {
    return new $c0caf1a922d2a97f$var$Q(a);
}
function $c0caf1a922d2a97f$var$Kc(a, b, c) {
    a.f = c ? $c0caf1a922d2a97f$var$S(b, !0) : b;
    a.f && (a.f = a.f.replace(/:$/, ""));
}
function $c0caf1a922d2a97f$var$Lc(a, b, c) {
    a.c = c ? $c0caf1a922d2a97f$var$S(b, !0) : b;
}
function $c0caf1a922d2a97f$var$Mc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.h = b;
    } else a.h = null;
}
function $c0caf1a922d2a97f$var$Nc(a, b, c) {
    b instanceof $c0caf1a922d2a97f$var$R ? (a.b = b, $c0caf1a922d2a97f$var$Sc(a.b, a.a)) : (c || (b = $c0caf1a922d2a97f$var$T(b, $c0caf1a922d2a97f$var$Tc)), a.b = new $c0caf1a922d2a97f$var$R(b, a.a));
}
function $c0caf1a922d2a97f$var$N(a, b, c) {
    a.b.set(b, c);
}
function $c0caf1a922d2a97f$var$ic(a) {
    $c0caf1a922d2a97f$var$N(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ $c0caf1a922d2a97f$var$q()).toString(36));
    return a;
}
function $c0caf1a922d2a97f$var$Uc(a) {
    return a instanceof $c0caf1a922d2a97f$var$Q ? $c0caf1a922d2a97f$var$I(a) : new $c0caf1a922d2a97f$var$Q(a, void 0);
}
function $c0caf1a922d2a97f$var$Vc(a, b, c, d) {
    var e = new $c0caf1a922d2a97f$var$Q(null, void 0);
    a && $c0caf1a922d2a97f$var$Kc(e, a);
    b && $c0caf1a922d2a97f$var$Lc(e, b);
    c && $c0caf1a922d2a97f$var$Mc(e, c);
    d && (e.g = d);
    return e;
}
function $c0caf1a922d2a97f$var$S(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $c0caf1a922d2a97f$var$T(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $c0caf1a922d2a97f$var$Wc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $c0caf1a922d2a97f$var$Wc(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $c0caf1a922d2a97f$var$Oc = /[#\/\?@]/g, $c0caf1a922d2a97f$var$Qc = /[#\?:]/g, $c0caf1a922d2a97f$var$Pc = /[#\?]/g, $c0caf1a922d2a97f$var$Tc = /[#\?@]/g, $c0caf1a922d2a97f$var$Rc = /#/g;
function $c0caf1a922d2a97f$var$R(a, b) {
    this.b = this.a = null;
    this.c = a || null;
    this.f = !!b;
}
function $c0caf1a922d2a97f$var$U(a) {
    a.a || (a.a = new $c0caf1a922d2a97f$var$O, a.b = 0, a.c && $c0caf1a922d2a97f$var$Jc(a.c, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$R.prototype;
$c0caf1a922d2a97f$var$g.add = function(a, b) {
    $c0caf1a922d2a97f$var$U(this);
    this.c = null;
    a = $c0caf1a922d2a97f$var$V(this, a);
    var c = this.a.get(a);
    c || this.a.set(a, c = []);
    c.push(b);
    this.b += 1;
    return this;
};
function $c0caf1a922d2a97f$var$Xc(a, b) {
    $c0caf1a922d2a97f$var$U(a);
    b = $c0caf1a922d2a97f$var$V(a, b);
    $c0caf1a922d2a97f$var$P(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, $c0caf1a922d2a97f$var$P(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && $c0caf1a922d2a97f$var$Hc(a)));
}
function $c0caf1a922d2a97f$var$Yc(a, b) {
    $c0caf1a922d2a97f$var$U(a);
    b = $c0caf1a922d2a97f$var$V(a, b);
    return $c0caf1a922d2a97f$var$P(a.a.b, b);
}
$c0caf1a922d2a97f$var$g.forEach = function(a, b) {
    $c0caf1a922d2a97f$var$U(this);
    this.a.forEach(function(c, d) {
        $c0caf1a922d2a97f$var$oa(c, function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$c0caf1a922d2a97f$var$g.K = function() {
    $c0caf1a922d2a97f$var$U(this);
    for(var a = this.a.I(), b = this.a.K(), c = [], d = 0; d < b.length; d++)for(var e = a[d], f = 0; f < e.length; f++)c.push(b[d]);
    return c;
};
$c0caf1a922d2a97f$var$g.I = function(a) {
    $c0caf1a922d2a97f$var$U(this);
    var b = [];
    if ("string" === typeof a) $c0caf1a922d2a97f$var$Yc(this, a) && (b = $c0caf1a922d2a97f$var$ra(b, this.a.get($c0caf1a922d2a97f$var$V(this, a))));
    else {
        a = this.a.I();
        for(var c = 0; c < a.length; c++)b = $c0caf1a922d2a97f$var$ra(b, a[c]);
    }
    return b;
};
$c0caf1a922d2a97f$var$g.set = function(a, b) {
    $c0caf1a922d2a97f$var$U(this);
    this.c = null;
    a = $c0caf1a922d2a97f$var$V(this, a);
    $c0caf1a922d2a97f$var$Yc(this, a) && (this.b -= this.a.get(a).length);
    this.a.set(a, [
        b
    ]);
    this.b += 1;
    return this;
};
$c0caf1a922d2a97f$var$g.get = function(a, b) {
    if (!a) return b;
    a = this.I(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $c0caf1a922d2a97f$var$kc(a, b, c) {
    $c0caf1a922d2a97f$var$Xc(a, b);
    0 < c.length && (a.c = null, a.a.set($c0caf1a922d2a97f$var$V(a, b), $c0caf1a922d2a97f$var$sa(c)), a.b += c.length);
}
$c0caf1a922d2a97f$var$g.toString = function() {
    if (this.c) return this.c;
    if (!this.a) return "";
    for(var a = [], b = this.a.K(), c = 0; c < b.length; c++){
        var d = b[c], e = encodeURIComponent(String(d));
        d = this.I(d);
        for(var f = 0; f < d.length; f++){
            var h = e;
            "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
            a.push(h);
        }
    }
    return this.c = a.join("&");
};
function $c0caf1a922d2a97f$var$V(a, b) {
    b = String(b);
    a.f && (b = b.toLowerCase());
    return b;
}
function $c0caf1a922d2a97f$var$Sc(a, b) {
    b && !a.f && ($c0caf1a922d2a97f$var$U(a), a.c = null, a.a.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($c0caf1a922d2a97f$var$Xc(this, d), $c0caf1a922d2a97f$var$kc(this, e, c));
    }, a));
    a.f = b;
}
function $c0caf1a922d2a97f$var$Zc(a, b) {
    this.b = a;
    this.a = b;
}
function $c0caf1a922d2a97f$var$$c(a) {
    this.g = a || $c0caf1a922d2a97f$var$ad;
    $c0caf1a922d2a97f$var$k.PerformanceNavigationTiming ? (a = $c0caf1a922d2a97f$var$k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($c0caf1a922d2a97f$var$k.ca && $c0caf1a922d2a97f$var$k.ca.ua && $c0caf1a922d2a97f$var$k.ca.ua() && $c0caf1a922d2a97f$var$k.ca.ua().mb);
    this.f = a ? this.g : 1;
    this.a = null;
    1 < this.f && (this.a = new Set);
    this.b = null;
    this.c = [];
}
var $c0caf1a922d2a97f$var$ad = 10;
function $c0caf1a922d2a97f$var$bd(a) {
    return a.b ? !0 : a.a ? a.a.size >= a.f : !1;
}
function $c0caf1a922d2a97f$var$yc(a) {
    return a.b ? 1 : a.a ? a.a.size : 0;
}
function $c0caf1a922d2a97f$var$vc(a, b) {
    return a.b ? a.b == b : a.a ? a.a.has(b) : !1;
}
function $c0caf1a922d2a97f$var$zc(a, b) {
    a.a ? a.a.add(b) : a.b = b;
}
function $c0caf1a922d2a97f$var$Bc(a, b) {
    a.b && a.b == b ? a.b = null : a.a && a.a.has(b) && a.a.delete(b);
}
$c0caf1a922d2a97f$var$$c.prototype.cancel = function() {
    var e_1, _a;
    this.c = $c0caf1a922d2a97f$var$cd(this);
    if (this.b) this.b.cancel(), this.b = null;
    else if (this.a && 0 !== this.a.size) {
        try {
            for(var _b = $c0caf1a922d2a97f$var$__values(this.a.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var a = _c.value;
                a.cancel();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.a.clear();
    }
};
function $c0caf1a922d2a97f$var$cd(a) {
    var e_2, _a;
    if (null != a.b) return a.c.concat(a.b.i);
    if (null != a.a && 0 !== a.a.size) {
        var b = a.c;
        try {
            for(var _b = $c0caf1a922d2a97f$var$__values(a.a.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var c = _c.value;
                b = b.concat(c.i);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return b;
    }
    return $c0caf1a922d2a97f$var$sa(a.c);
}
function $c0caf1a922d2a97f$var$dd() {}
$c0caf1a922d2a97f$var$dd.prototype.stringify = function(a) {
    return $c0caf1a922d2a97f$var$k.JSON.stringify(a, void 0);
};
$c0caf1a922d2a97f$var$dd.prototype.parse = function(a) {
    return $c0caf1a922d2a97f$var$k.JSON.parse(a, void 0);
};
function $c0caf1a922d2a97f$var$ed() {
    this.a = new $c0caf1a922d2a97f$var$dd;
}
function $c0caf1a922d2a97f$var$fd(a, b, c) {
    var d = c || "";
    try {
        $c0caf1a922d2a97f$var$Gc(a, function(e, f) {
            var h = e;
            $c0caf1a922d2a97f$var$m(e) && (h = $c0caf1a922d2a97f$var$vb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $c0caf1a922d2a97f$var$gd(a, b) {
    var c = new $c0caf1a922d2a97f$var$Pb;
    if ($c0caf1a922d2a97f$var$k.Image) {
        var d = new Image;
        d.onload = $c0caf1a922d2a97f$var$ka($c0caf1a922d2a97f$var$hd, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $c0caf1a922d2a97f$var$ka($c0caf1a922d2a97f$var$hd, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $c0caf1a922d2a97f$var$ka($c0caf1a922d2a97f$var$hd, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $c0caf1a922d2a97f$var$ka($c0caf1a922d2a97f$var$hd, c, d, "TestLoadImage: timeout", !1, b);
        $c0caf1a922d2a97f$var$k.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $c0caf1a922d2a97f$var$hd(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
var $c0caf1a922d2a97f$var$id = $c0caf1a922d2a97f$var$k.JSON.parse;
function $c0caf1a922d2a97f$var$W(a) {
    $c0caf1a922d2a97f$var$B.call(this);
    this.headers = new $c0caf1a922d2a97f$var$O;
    this.G = a || null;
    this.b = !1;
    this.s = this.a = null;
    this.D = "";
    this.h = 0;
    this.f = "";
    this.g = this.w = this.l = this.v = !1;
    this.o = 0;
    this.m = null;
    this.H = $c0caf1a922d2a97f$var$jd;
    this.B = this.F = !1;
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$W, $c0caf1a922d2a97f$var$B);
var $c0caf1a922d2a97f$var$jd = "", $c0caf1a922d2a97f$var$kd = /^https?$/i, $c0caf1a922d2a97f$var$ld = [
    "POST",
    "PUT"
];
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$W.prototype;
$c0caf1a922d2a97f$var$g.$ = function(a, b, c, d) {
    if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.D = a;
    this.f = "";
    this.h = 0;
    this.v = !1;
    this.b = !0;
    this.a = new XMLHttpRequest;
    this.s = this.G ? $c0caf1a922d2a97f$var$Zb(this.G) : $c0caf1a922d2a97f$var$Zb($c0caf1a922d2a97f$var$cc);
    this.a.onreadystatechange = $c0caf1a922d2a97f$var$n(this.va, this);
    try {
        this.w = !0, this.a.open(b, String(a), !0), this.w = !1;
    } catch (f) {
        $c0caf1a922d2a97f$var$md(this, f);
        return;
    }
    a = c || "";
    var e = new $c0caf1a922d2a97f$var$O(this.headers);
    d && $c0caf1a922d2a97f$var$Gc(d, function(f, h) {
        e.set(h, f);
    });
    d = $c0caf1a922d2a97f$var$pa(e.K());
    c = $c0caf1a922d2a97f$var$k.FormData && a instanceof $c0caf1a922d2a97f$var$k.FormData;
    !(0 <= $c0caf1a922d2a97f$var$na($c0caf1a922d2a97f$var$ld, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    e.forEach(function(f, h) {
        this.a.setRequestHeader(h, f);
    }, this);
    this.H && (this.a.responseType = this.H);
    "withCredentials" in this.a && this.a.withCredentials !== this.F && (this.a.withCredentials = this.F);
    try {
        $c0caf1a922d2a97f$var$nd(this), 0 < this.o && ((this.B = $c0caf1a922d2a97f$var$od(this.a)) ? (this.a.timeout = this.o, this.a.ontimeout = $c0caf1a922d2a97f$var$n(this.ta, this)) : this.m = $c0caf1a922d2a97f$var$Jb(this.ta, this.o, this)), this.l = !0, this.a.send(a), this.l = !1;
    } catch (f) {
        $c0caf1a922d2a97f$var$md(this, f);
    }
};
function $c0caf1a922d2a97f$var$od(a) {
    return $c0caf1a922d2a97f$var$w && $c0caf1a922d2a97f$var$Sa(9) && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
function $c0caf1a922d2a97f$var$qa(a) {
    return "content-type" == a.toLowerCase();
}
$c0caf1a922d2a97f$var$g.ta = function() {
    "undefined" != typeof $c0caf1a922d2a97f$var$goog && this.a && (this.f = "Timed out after " + this.o + "ms, aborting", this.h = 8, this.dispatchEvent("timeout"), this.abort(8));
};
function $c0caf1a922d2a97f$var$md(a, b) {
    a.b = !1;
    a.a && (a.g = !0, a.a.abort(), a.g = !1);
    a.f = b;
    a.h = 5;
    $c0caf1a922d2a97f$var$pd(a);
    $c0caf1a922d2a97f$var$qd(a);
}
function $c0caf1a922d2a97f$var$pd(a) {
    a.v || (a.v = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
}
$c0caf1a922d2a97f$var$g.abort = function(a) {
    this.a && this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1, this.h = a || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), $c0caf1a922d2a97f$var$qd(this));
};
$c0caf1a922d2a97f$var$g.C = function() {
    this.a && (this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1), $c0caf1a922d2a97f$var$qd(this, !0));
    $c0caf1a922d2a97f$var$W.M.C.call(this);
};
$c0caf1a922d2a97f$var$g.va = function() {
    this.j || (this.w || this.l || this.g ? $c0caf1a922d2a97f$var$rd(this) : this.Oa());
};
$c0caf1a922d2a97f$var$g.Oa = function() {
    $c0caf1a922d2a97f$var$rd(this);
};
function $c0caf1a922d2a97f$var$rd(a) {
    if (a.b && "undefined" != typeof $c0caf1a922d2a97f$var$goog && (!a.s[1] || 4 != $c0caf1a922d2a97f$var$K(a) || 2 != a.S())) {
        if (a.l && 4 == $c0caf1a922d2a97f$var$K(a)) $c0caf1a922d2a97f$var$Jb(a.va, 0, a);
        else if (a.dispatchEvent("readystatechange"), 4 == $c0caf1a922d2a97f$var$K(a)) {
            a.b = !1;
            try {
                var b = a.S();
                a: switch(b){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var c = !0;
                        break a;
                    default:
                        c = !1;
                }
                var d;
                if (!(d = c)) {
                    var e;
                    if (e = 0 === b) {
                        var f = String(a.D).match($c0caf1a922d2a97f$var$Ic)[1] || null;
                        if (!f && $c0caf1a922d2a97f$var$k.self && $c0caf1a922d2a97f$var$k.self.location) {
                            var h = $c0caf1a922d2a97f$var$k.self.location.protocol;
                            f = h.substr(0, h.length - 1);
                        }
                        e = !$c0caf1a922d2a97f$var$kd.test(f ? f.toLowerCase() : "");
                    }
                    d = e;
                }
                if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");
                else {
                    a.h = 6;
                    try {
                        var l = 2 < $c0caf1a922d2a97f$var$K(a) ? a.a.statusText : "";
                    } catch (p) {
                        l = "";
                    }
                    a.f = l + " [" + a.S() + "]";
                    $c0caf1a922d2a97f$var$pd(a);
                }
            } finally{
                $c0caf1a922d2a97f$var$qd(a);
            }
        }
    }
}
function $c0caf1a922d2a97f$var$qd(a, b) {
    if (a.a) {
        $c0caf1a922d2a97f$var$nd(a);
        var c = a.a, d = a.s[0] ? $c0caf1a922d2a97f$var$aa : null;
        a.a = null;
        a.s = null;
        b || a.dispatchEvent("ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $c0caf1a922d2a97f$var$nd(a) {
    a.a && a.B && (a.a.ontimeout = null);
    a.m && ($c0caf1a922d2a97f$var$k.clearTimeout(a.m), a.m = null);
}
function $c0caf1a922d2a97f$var$K(a) {
    return a.a ? a.a.readyState : 0;
}
$c0caf1a922d2a97f$var$g.S = function() {
    try {
        return 2 < $c0caf1a922d2a97f$var$K(this) ? this.a.status : -1;
    } catch (a) {
        return -1;
    }
};
$c0caf1a922d2a97f$var$g.Y = function() {
    try {
        return this.a ? this.a.responseText : "";
    } catch (a) {
        return "";
    }
};
$c0caf1a922d2a97f$var$g.Ja = function(a) {
    if (this.a) {
        var b = this.a.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $c0caf1a922d2a97f$var$id(b);
    }
};
$c0caf1a922d2a97f$var$g.qa = function() {
    return this.h;
};
$c0caf1a922d2a97f$var$g.Ma = function() {
    return "string" === typeof this.f ? this.f : String(this.f);
};
function $c0caf1a922d2a97f$var$sd(a) {
    var b = "";
    $c0caf1a922d2a97f$var$Ba(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $c0caf1a922d2a97f$var$td(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $c0caf1a922d2a97f$var$sd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $c0caf1a922d2a97f$var$N(a, b, c));
}
function $c0caf1a922d2a97f$var$X(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $c0caf1a922d2a97f$var$ud(a) {
    this.f = [];
    this.R = this.ea = this.v = this.P = this.a = this.ha = this.s = this.N = this.h = this.F = this.j = null;
    this.Fa = this.H = 0;
    this.Ca = $c0caf1a922d2a97f$var$X("failFast", !1, a);
    this.U = this.l = this.i = this.g = this.c = null;
    this.W = !0;
    this.A = this.ia = this.G = -1;
    this.J = this.m = this.o = 0;
    this.Ba = $c0caf1a922d2a97f$var$X("baseRetryDelayMs", 5E3, a);
    this.Ga = $c0caf1a922d2a97f$var$X("retryDelaySeedMs", 1E4, a);
    this.Da = $c0caf1a922d2a97f$var$X("forwardChannelMaxRetries", 2, a);
    this.ga = $c0caf1a922d2a97f$var$X("forwardChannelRequestTimeoutMs", 2E4, a);
    this.Ea = a && a.nb || void 0;
    this.D = void 0;
    this.w = a && a.supportsCrossDomainXhr || !1;
    this.B = "";
    this.b = new $c0caf1a922d2a97f$var$$c(a && a.concurrentRequestLimit);
    this.ja = new $c0caf1a922d2a97f$var$ed;
    this.fa = a && a.fastHandshake || !1;
    a && a.forceLongPolling && (this.W = !1);
    this.O = void 0;
}
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$ud.prototype;
$c0caf1a922d2a97f$var$g.oa = 8;
$c0caf1a922d2a97f$var$g.u = 1;
function $c0caf1a922d2a97f$var$Ec(a) {
    $c0caf1a922d2a97f$var$vd(a);
    if (3 == a.u) {
        var b = a.H++, c = $c0caf1a922d2a97f$var$I(a.v);
        $c0caf1a922d2a97f$var$N(c, "SID", a.B);
        $c0caf1a922d2a97f$var$N(c, "RID", b);
        $c0caf1a922d2a97f$var$N(c, "TYPE", "terminate");
        $c0caf1a922d2a97f$var$wd(a, c);
        b = new $c0caf1a922d2a97f$var$H(a, b, void 0);
        b.B = 2;
        b.f = $c0caf1a922d2a97f$var$ic($c0caf1a922d2a97f$var$I(c));
        c = !1;
        $c0caf1a922d2a97f$var$k.navigator && $c0caf1a922d2a97f$var$k.navigator.sendBeacon && (c = $c0caf1a922d2a97f$var$k.navigator.sendBeacon(b.f.toString(), ""));
        !c && $c0caf1a922d2a97f$var$k.Image && ((new Image).src = b.f, c = !0);
        c || (b.a = $c0caf1a922d2a97f$var$lc(b.g, null), b.a.$(b.f));
        b.s = $c0caf1a922d2a97f$var$q();
        $c0caf1a922d2a97f$var$J(b);
    }
    $c0caf1a922d2a97f$var$xd(a);
}
function $c0caf1a922d2a97f$var$vd(a) {
    a.a && (a.a.cancel(), a.a = null);
    a.i && ($c0caf1a922d2a97f$var$k.clearTimeout(a.i), a.i = null);
    $c0caf1a922d2a97f$var$wc(a);
    a.b.cancel();
    a.g && ("number" === typeof a.g && $c0caf1a922d2a97f$var$k.clearTimeout(a.g), a.g = null);
}
function $c0caf1a922d2a97f$var$yd(a, b) {
    a.f.push(new $c0caf1a922d2a97f$var$Zc(a.Fa++, b));
    3 == a.u && $c0caf1a922d2a97f$var$Dc(a);
}
function $c0caf1a922d2a97f$var$Dc(a) {
    $c0caf1a922d2a97f$var$bd(a.b) || a.g || (a.g = !0, $c0caf1a922d2a97f$var$Cb(a.xa, a), a.o = 0);
}
function $c0caf1a922d2a97f$var$zd(a, b) {
    if ($c0caf1a922d2a97f$var$yc(a.b) >= a.b.f - (a.g ? 1 : 0)) return !1;
    if (a.g) return a.f = b.i.concat(a.f), !0;
    if (1 == a.u || 2 == a.u || a.o >= (a.Ca ? 0 : a.Da)) return !1;
    a.g = $c0caf1a922d2a97f$var$Vb($c0caf1a922d2a97f$var$n(a.xa, a, b), $c0caf1a922d2a97f$var$Ad(a, a.o));
    a.o++;
    return !0;
}
$c0caf1a922d2a97f$var$g.xa = function(a) {
    if (this.g) {
        if (this.g = null, 1 == this.u) {
            if (!a) {
                this.H = Math.floor(1E5 * Math.random());
                a = this.H++;
                var b = new $c0caf1a922d2a97f$var$H(this, a, void 0), c = this.j;
                this.F && (c ? (c = $c0caf1a922d2a97f$var$Ca(c), $c0caf1a922d2a97f$var$Ea(c, this.F)) : c = this.F);
                null === this.h && (b.m = c);
                var d;
                if (this.fa) a: {
                    for(var e = d = 0; e < this.f.length; e++){
                        b: {
                            var f = this.f[e];
                            if ("__data__" in f.a && (f = f.a.__data__, "string" === typeof f)) {
                                f = f.length;
                                break b;
                            }
                            f = void 0;
                        }
                        if (void 0 === f) break;
                        d += f;
                        if (4096 < d) {
                            d = e;
                            break a;
                        }
                        if (4096 === d || e === this.f.length - 1) {
                            d = e + 1;
                            break a;
                        }
                    }
                    d = 1E3;
                }
                else d = 1E3;
                d = $c0caf1a922d2a97f$var$Bd(this, b, d);
                e = $c0caf1a922d2a97f$var$I(this.v);
                $c0caf1a922d2a97f$var$N(e, "RID", a);
                $c0caf1a922d2a97f$var$N(e, "CVER", 22);
                this.s && $c0caf1a922d2a97f$var$N(e, "X-HTTP-Session-Id", this.s);
                $c0caf1a922d2a97f$var$wd(this, e);
                this.h && c && $c0caf1a922d2a97f$var$td(e, this.h, c);
                $c0caf1a922d2a97f$var$zc(this.b, b);
                this.fa ? ($c0caf1a922d2a97f$var$N(e, "$req", d), $c0caf1a922d2a97f$var$N(e, "SID", "null"), b.R = !0, $c0caf1a922d2a97f$var$hc(b, e, null)) : $c0caf1a922d2a97f$var$hc(b, e, d);
                this.u = 2;
            }
        } else 3 == this.u && (a ? $c0caf1a922d2a97f$var$Cd(this, a) : 0 == this.f.length || $c0caf1a922d2a97f$var$bd(this.b) || $c0caf1a922d2a97f$var$Cd(this));
    }
};
function $c0caf1a922d2a97f$var$Cd(a, b) {
    var c;
    b ? c = b.W : c = a.H++;
    var d = $c0caf1a922d2a97f$var$I(a.v);
    $c0caf1a922d2a97f$var$N(d, "SID", a.B);
    $c0caf1a922d2a97f$var$N(d, "RID", c);
    $c0caf1a922d2a97f$var$N(d, "AID", a.G);
    $c0caf1a922d2a97f$var$wd(a, d);
    a.h && a.j && $c0caf1a922d2a97f$var$td(d, a.h, a.j);
    c = new $c0caf1a922d2a97f$var$H(a, c, a.o + 1);
    null === a.h && (c.m = a.j);
    b && (a.f = b.i.concat(a.f));
    b = $c0caf1a922d2a97f$var$Bd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.ga) + Math.round(.5 * a.ga * Math.random()));
    $c0caf1a922d2a97f$var$zc(a.b, c);
    $c0caf1a922d2a97f$var$hc(c, d, b);
}
function $c0caf1a922d2a97f$var$wd(a, b) {
    a.c && $c0caf1a922d2a97f$var$Gc({}, function(c, d) {
        $c0caf1a922d2a97f$var$N(b, d, c);
    });
}
function $c0caf1a922d2a97f$var$Bd(a, b, c) {
    c = Math.min(a.f.length, c);
    var d = a.c ? $c0caf1a922d2a97f$var$n(a.c.Ha, a.c, a) : null;
    a: for(var e = a.f, f = -1;;){
        var h = [
            "count=" + c
        ];
        -1 == f ? 0 < c ? (f = e[0].b, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
        for(var l = !0, p = 0; p < c; p++){
            var D = e[p].b, z = e[p].a;
            D -= f;
            if (0 > D) f = Math.max(0, e[p].b - 100), l = !1;
            else try {
                $c0caf1a922d2a97f$var$fd(z, h, "req" + D + "_");
            } catch (ta) {
                d && d(z);
            }
        }
        if (l) {
            d = h.join("&");
            break a;
        }
    }
    a = a.f.splice(0, c);
    b.i = a;
    return d;
}
function $c0caf1a922d2a97f$var$Cc(a) {
    a.a || a.i || (a.J = 1, $c0caf1a922d2a97f$var$Cb(a.wa, a), a.m = 0);
}
function $c0caf1a922d2a97f$var$xc(a) {
    if (a.a || a.i || 3 <= a.m) return !1;
    a.J++;
    a.i = $c0caf1a922d2a97f$var$Vb($c0caf1a922d2a97f$var$n(a.wa, a), $c0caf1a922d2a97f$var$Ad(a, a.m));
    a.m++;
    return !0;
}
$c0caf1a922d2a97f$var$g.wa = function() {
    this.i = null;
    this.a = new $c0caf1a922d2a97f$var$H(this, "rpc", this.J);
    null === this.h && (this.a.m = this.j);
    this.a.J = 0;
    var a = $c0caf1a922d2a97f$var$I(this.ea);
    $c0caf1a922d2a97f$var$N(a, "RID", "rpc");
    $c0caf1a922d2a97f$var$N(a, "SID", this.B);
    $c0caf1a922d2a97f$var$N(a, "CI", this.U ? "0" : "1");
    $c0caf1a922d2a97f$var$N(a, "AID", this.G);
    $c0caf1a922d2a97f$var$wd(this, a);
    $c0caf1a922d2a97f$var$N(a, "TYPE", "xmlhttp");
    this.h && this.j && $c0caf1a922d2a97f$var$td(a, this.h, this.j);
    this.D && this.a.setTimeout(this.D);
    var b = this.a, c = this.R;
    b.B = 1;
    b.f = $c0caf1a922d2a97f$var$ic($c0caf1a922d2a97f$var$I(a));
    b.j = null;
    b.F = !0;
    $c0caf1a922d2a97f$var$jc(b, c);
};
$c0caf1a922d2a97f$var$g.Na = function() {
    null != this.l && (this.l = null, this.a.cancel(), this.a = null, $c0caf1a922d2a97f$var$xc(this), $c0caf1a922d2a97f$var$F(19));
};
function $c0caf1a922d2a97f$var$wc(a) {
    null != a.l && ($c0caf1a922d2a97f$var$k.clearTimeout(a.l), a.l = null);
}
function $c0caf1a922d2a97f$var$rc(a, b) {
    var c = null;
    if (a.a == b) {
        $c0caf1a922d2a97f$var$wc(a);
        a.a = null;
        var d = 2;
    } else if ($c0caf1a922d2a97f$var$vc(a.b, b)) c = b.i, $c0caf1a922d2a97f$var$Bc(a.b, b), d = 1;
    else return;
    a.A = b.H;
    if (0 != a.u) {
        if (b.b) {
            if (1 == d) {
                c = b.j ? b.j.length : 0;
                b = $c0caf1a922d2a97f$var$q() - b.s;
                var e = a.o;
                d = $c0caf1a922d2a97f$var$Rb();
                d.dispatchEvent(new $c0caf1a922d2a97f$var$Ub(d, c, b, e));
                $c0caf1a922d2a97f$var$Dc(a);
            } else $c0caf1a922d2a97f$var$Cc(a);
        } else if (e = b.c, 3 == e || 0 == e && 0 < a.A || !(1 == d && $c0caf1a922d2a97f$var$zd(a, b) || 2 == d && $c0caf1a922d2a97f$var$xc(a))) switch(c && 0 < c.length && (b = a.b, b.c = b.c.concat(c)), e){
            case 1:
                $c0caf1a922d2a97f$var$M(a, 5);
                break;
            case 4:
                $c0caf1a922d2a97f$var$M(a, 10);
                break;
            case 3:
                $c0caf1a922d2a97f$var$M(a, 6);
                break;
            default:
                $c0caf1a922d2a97f$var$M(a, 2);
        }
    }
}
function $c0caf1a922d2a97f$var$Ad(a, b) {
    var c = a.Ba + Math.floor(Math.random() * a.Ga);
    a.c || (c *= 2);
    return c * b;
}
function $c0caf1a922d2a97f$var$M(a, b) {
    if (2 == b) {
        var c = null;
        a.c && (c = null);
        var d = $c0caf1a922d2a97f$var$n(a.Ta, a);
        c || (c = new $c0caf1a922d2a97f$var$Q("//www.google.com/images/cleardot.gif"), $c0caf1a922d2a97f$var$k.location && "http" == $c0caf1a922d2a97f$var$k.location.protocol || $c0caf1a922d2a97f$var$Kc(c, "https"), $c0caf1a922d2a97f$var$ic(c));
        $c0caf1a922d2a97f$var$gd(c.toString(), d);
    } else $c0caf1a922d2a97f$var$F(2);
    a.u = 0;
    a.c && a.c.la(b);
    $c0caf1a922d2a97f$var$xd(a);
    $c0caf1a922d2a97f$var$vd(a);
}
$c0caf1a922d2a97f$var$g.Ta = function(a) {
    a ? $c0caf1a922d2a97f$var$F(2) : $c0caf1a922d2a97f$var$F(1);
};
function $c0caf1a922d2a97f$var$xd(a) {
    a.u = 0;
    a.A = -1;
    if (a.c) {
        if (0 != $c0caf1a922d2a97f$var$cd(a.b).length || 0 != a.f.length) a.b.c.length = 0, $c0caf1a922d2a97f$var$sa(a.f), a.f.length = 0;
        a.c.ka();
    }
}
function $c0caf1a922d2a97f$var$Ac(a, b, c) {
    var d = $c0caf1a922d2a97f$var$Uc(c);
    if ("" != d.c) b && $c0caf1a922d2a97f$var$Lc(d, b + "." + d.c), $c0caf1a922d2a97f$var$Mc(d, d.h);
    else {
        var e = $c0caf1a922d2a97f$var$k.location;
        d = $c0caf1a922d2a97f$var$Vc(e.protocol, b ? b + "." + e.hostname : e.hostname, +e.port, c);
    }
    a.N && $c0caf1a922d2a97f$var$Ba(a.N, function(f, h) {
        $c0caf1a922d2a97f$var$N(d, h, f);
    });
    b = a.s;
    c = a.ha;
    b && c && $c0caf1a922d2a97f$var$N(d, b, c);
    $c0caf1a922d2a97f$var$N(d, "VER", a.oa);
    $c0caf1a922d2a97f$var$wd(a, d);
    return d;
}
function $c0caf1a922d2a97f$var$lc(a, b) {
    if (b && !a.w) throw Error("Can't create secondary domain capable XhrIo object.");
    b = new $c0caf1a922d2a97f$var$W(a.Ea);
    b.F = a.w;
    return b;
}
function $c0caf1a922d2a97f$var$Dd() {}
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$Dd.prototype;
$c0caf1a922d2a97f$var$g.na = function() {};
$c0caf1a922d2a97f$var$g.ma = function() {};
$c0caf1a922d2a97f$var$g.la = function() {};
$c0caf1a922d2a97f$var$g.ka = function() {};
$c0caf1a922d2a97f$var$g.Ha = function() {};
function $c0caf1a922d2a97f$var$Ed() {
    if ($c0caf1a922d2a97f$var$w && !(10 <= Number($c0caf1a922d2a97f$var$Va))) throw Error("Environmental error: no available transport.");
}
$c0caf1a922d2a97f$var$Ed.prototype.a = function(a, b) {
    return new $c0caf1a922d2a97f$var$Y(a, b);
};
function $c0caf1a922d2a97f$var$Y(a, b) {
    $c0caf1a922d2a97f$var$B.call(this);
    this.a = new $c0caf1a922d2a97f$var$ud(b);
    this.l = a;
    this.b = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.a.j = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.pa && (a ? a["X-WebChannel-Client-Profile"] = b.pa : a = {
        "X-WebChannel-Client-Profile": b.pa
    });
    this.a.F = a;
    (a = b && b.httpHeadersOverwriteParam) && !$c0caf1a922d2a97f$var$wa(a) && (this.a.h = a);
    this.h = b && b.supportsCrossDomainXhr || !1;
    this.g = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$c0caf1a922d2a97f$var$wa(b) && (this.a.s = b, a = this.b, null !== a && b in a && (a = this.b, b in a && delete a[b]));
    this.f = new $c0caf1a922d2a97f$var$Z(this);
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Y, $c0caf1a922d2a97f$var$B);
$c0caf1a922d2a97f$var$g = $c0caf1a922d2a97f$var$Y.prototype;
$c0caf1a922d2a97f$var$g.addEventListener = function(a, b, c, d) {
    $c0caf1a922d2a97f$var$Y.M.addEventListener.call(this, a, b, c, d);
};
$c0caf1a922d2a97f$var$g.removeEventListener = function(a, b, c, d) {
    $c0caf1a922d2a97f$var$Y.M.removeEventListener.call(this, a, b, c, d);
};
$c0caf1a922d2a97f$var$g.Ka = function() {
    this.a.c = this.f;
    this.h && (this.a.w = !0);
    var a = this.a, b = this.l, c = this.b || void 0;
    $c0caf1a922d2a97f$var$F(0);
    a.P = b;
    a.N = c || {};
    a.U = a.W;
    a.v = $c0caf1a922d2a97f$var$Ac(a, null, a.P);
    $c0caf1a922d2a97f$var$Dc(a);
};
$c0caf1a922d2a97f$var$g.close = function() {
    $c0caf1a922d2a97f$var$Ec(this.a);
};
$c0caf1a922d2a97f$var$g.La = function(a) {
    if ("string" === typeof a) {
        var b = {};
        b.__data__ = a;
        $c0caf1a922d2a97f$var$yd(this.a, b);
    } else this.g ? (b = {}, b.__data__ = $c0caf1a922d2a97f$var$vb(a), $c0caf1a922d2a97f$var$yd(this.a, b)) : $c0caf1a922d2a97f$var$yd(this.a, a);
};
$c0caf1a922d2a97f$var$g.C = function() {
    this.a.c = null;
    delete this.f;
    $c0caf1a922d2a97f$var$Ec(this.a);
    delete this.a;
    $c0caf1a922d2a97f$var$Y.M.C.call(this);
};
function $c0caf1a922d2a97f$var$Fd(a) {
    $c0caf1a922d2a97f$var$ac.call(this);
    var b = a.__sm__;
    if (b) {
        a: {
            for(var c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        (this.c = a) ? (a = this.c, this.data = null !== b && a in b ? b[a] : void 0) : this.data = b;
    } else this.data = a;
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Fd, $c0caf1a922d2a97f$var$ac);
function $c0caf1a922d2a97f$var$Gd() {
    $c0caf1a922d2a97f$var$bc.call(this);
    this.status = 1;
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Gd, $c0caf1a922d2a97f$var$bc);
function $c0caf1a922d2a97f$var$Z(a) {
    this.a = a;
}
$c0caf1a922d2a97f$var$r($c0caf1a922d2a97f$var$Z, $c0caf1a922d2a97f$var$Dd);
$c0caf1a922d2a97f$var$Z.prototype.na = function() {
    this.a.dispatchEvent("a");
};
$c0caf1a922d2a97f$var$Z.prototype.ma = function(a) {
    this.a.dispatchEvent(new $c0caf1a922d2a97f$var$Fd(a));
};
$c0caf1a922d2a97f$var$Z.prototype.la = function(a) {
    this.a.dispatchEvent(new $c0caf1a922d2a97f$var$Gd(a));
};
$c0caf1a922d2a97f$var$Z.prototype.ka = function() {
    this.a.dispatchEvent("b");
}; /*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
$c0caf1a922d2a97f$var$Ed.prototype.createWebChannel = $c0caf1a922d2a97f$var$Ed.prototype.a;
$c0caf1a922d2a97f$var$Y.prototype.send = $c0caf1a922d2a97f$var$Y.prototype.La;
$c0caf1a922d2a97f$var$Y.prototype.open = $c0caf1a922d2a97f$var$Y.prototype.Ka;
$c0caf1a922d2a97f$var$Y.prototype.close = $c0caf1a922d2a97f$var$Y.prototype.close;
$c0caf1a922d2a97f$var$Wb.NO_ERROR = 0;
$c0caf1a922d2a97f$var$Wb.TIMEOUT = 8;
$c0caf1a922d2a97f$var$Wb.HTTP_ERROR = 6;
$c0caf1a922d2a97f$var$Xb.COMPLETE = "complete";
$c0caf1a922d2a97f$var$$b.EventType = $c0caf1a922d2a97f$var$G;
$c0caf1a922d2a97f$var$G.OPEN = "a";
$c0caf1a922d2a97f$var$G.CLOSE = "b";
$c0caf1a922d2a97f$var$G.ERROR = "c";
$c0caf1a922d2a97f$var$G.MESSAGE = "d";
$c0caf1a922d2a97f$var$B.prototype.listen = $c0caf1a922d2a97f$var$B.prototype.ra;
$c0caf1a922d2a97f$var$W.prototype.listenOnce = $c0caf1a922d2a97f$var$W.prototype.sa;
$c0caf1a922d2a97f$var$W.prototype.getLastError = $c0caf1a922d2a97f$var$W.prototype.Ma;
$c0caf1a922d2a97f$var$W.prototype.getLastErrorCode = $c0caf1a922d2a97f$var$W.prototype.qa;
$c0caf1a922d2a97f$var$W.prototype.getStatus = $c0caf1a922d2a97f$var$W.prototype.S;
$c0caf1a922d2a97f$var$W.prototype.getResponseJson = $c0caf1a922d2a97f$var$W.prototype.Ja;
$c0caf1a922d2a97f$var$W.prototype.getResponseText = $c0caf1a922d2a97f$var$W.prototype.Y;
$c0caf1a922d2a97f$var$W.prototype.send = $c0caf1a922d2a97f$var$W.prototype.$;
var $c0caf1a922d2a97f$var$esm = {
    createWebChannelTransport: function() {
        return new $c0caf1a922d2a97f$var$Ed;
    },
    ErrorCode: $c0caf1a922d2a97f$var$Wb,
    EventType: $c0caf1a922d2a97f$var$Xb,
    WebChannel: $c0caf1a922d2a97f$var$$b,
    XhrIo: $c0caf1a922d2a97f$var$W
};
var $c0caf1a922d2a97f$export$66869136fc133c3a = $c0caf1a922d2a97f$var$esm.createWebChannelTransport;
var $c0caf1a922d2a97f$export$d4e71bc0b80dc0fb = $c0caf1a922d2a97f$var$esm.ErrorCode;
var $c0caf1a922d2a97f$export$3d7865934588d77e = $c0caf1a922d2a97f$var$esm.EventType;
var $c0caf1a922d2a97f$export$aa726fb96ad3e039 = $c0caf1a922d2a97f$var$esm.WebChannel;
var $c0caf1a922d2a97f$export$26404658cda3ee02 = $c0caf1a922d2a97f$var$esm.XhrIo;
var $c0caf1a922d2a97f$export$2e2bcd8739ae039 = $c0caf1a922d2a97f$var$esm;

});



parcelRegister("hX7P2", function(module, exports) {
parcelRequire("8VBFV");

});
parcelRegister("8VBFV", function(module, exports) {

var $3rPrU = parcelRequire("3rPrU");
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $6800df1b0932d2db$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $6800df1b0932d2db$var$firebase = $6800df1b0932d2db$var$_interopDefault((parcelRequire("jJO2d")));

var $66Jdw = parcelRequire("66Jdw");

var $epfVL = parcelRequire("epfVL");

var $ctGiR = parcelRequire("ctGiR");

var $9Cwol = parcelRequire("9Cwol");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$DOMStorageWrapper = /** @class */ function() {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */ function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */ DOMStorageWrapper.prototype.set = function(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), $epfVL.stringify(value));
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */ DOMStorageWrapper.prototype.get = function(key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return $epfVL.jsonEval(storedVal);
    };
    /**
     * @param {string} key
     */ DOMStorageWrapper.prototype.remove = function(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */ DOMStorageWrapper.prototype.prefixedName_ = function(name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function() {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */ var $6800df1b0932d2db$var$MemoryStorage = /** @class */ function() {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    };
    MemoryStorage.prototype.get = function(key) {
        if ($epfVL.contains(this.cache_, key)) return this.cache_[key];
        return null;
    };
    MemoryStorage.prototype.remove = function(key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */ var $6800df1b0932d2db$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $6800df1b0932d2db$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $6800df1b0932d2db$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ var $6800df1b0932d2db$var$PersistentStorage = $6800df1b0932d2db$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ var $6800df1b0932d2db$var$SessionStorage = $6800df1b0932d2db$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$logClient = new $ctGiR.Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */ var $6800df1b0932d2db$var$LUIDGenerator = function() {
    var id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */ var $6800df1b0932d2db$var$sha1 = function(str) {
    var utf8Bytes = $epfVL.stringToByteArray(str);
    var sha1 = new $epfVL.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return $epfVL.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} varArgs
 * @return {string}
 * @private
 */ var $6800df1b0932d2db$var$buildLogMessage_ = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = '';
    for(var i = 0; i < varArgs.length; i++){
        var arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $6800df1b0932d2db$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += $epfVL.stringify(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */ var $6800df1b0932d2db$var$logger = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */ var $6800df1b0932d2db$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */ var $6800df1b0932d2db$var$enableLogging = function(logger_, persistent) {
    $epfVL.assert(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $6800df1b0932d2db$var$logClient.logLevel = $ctGiR.LogLevel.VERBOSE;
        $6800df1b0932d2db$var$logger = $6800df1b0932d2db$var$logClient.log.bind($6800df1b0932d2db$var$logClient);
        if (persistent) $6800df1b0932d2db$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $6800df1b0932d2db$var$logger = logger_;
    else {
        $6800df1b0932d2db$var$logger = null;
        $6800df1b0932d2db$var$SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} varArgs
 */ var $6800df1b0932d2db$var$log = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    if ($6800df1b0932d2db$var$firstLog_ === true) {
        $6800df1b0932d2db$var$firstLog_ = false;
        if ($6800df1b0932d2db$var$logger === null && $6800df1b0932d2db$var$SessionStorage.get('logging_enabled') === true) $6800df1b0932d2db$var$enableLogging(true);
    }
    if ($6800df1b0932d2db$var$logger) {
        var message = $6800df1b0932d2db$var$buildLogMessage_.apply(null, varArgs);
        $6800df1b0932d2db$var$logger(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */ var $6800df1b0932d2db$var$logWrapper = function(prefix) {
    return function() {
        var varArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
        $6800df1b0932d2db$var$log.apply(void 0, $66Jdw.__spread([
            prefix
        ], varArgs));
    };
};
/**
 * @param {...string} varArgs
 */ var $6800df1b0932d2db$var$error = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = 'FIREBASE INTERNAL ERROR: ' + $6800df1b0932d2db$var$buildLogMessage_.apply(void 0, $66Jdw.__spread(varArgs));
    $6800df1b0932d2db$var$logClient.error(message);
};
/**
 * @param {...string} varArgs
 */ var $6800df1b0932d2db$var$fatal = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = "FIREBASE FATAL ERROR: " + $6800df1b0932d2db$var$buildLogMessage_.apply(void 0, $66Jdw.__spread(varArgs));
    $6800df1b0932d2db$var$logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} varArgs
 */ var $6800df1b0932d2db$var$warn = function() {
    var varArgs = [];
    for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
    var message = 'FIREBASE WARNING: ' + $6800df1b0932d2db$var$buildLogMessage_.apply(void 0, $66Jdw.__spread(varArgs));
    $6800df1b0932d2db$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ var $6800df1b0932d2db$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $6800df1b0932d2db$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */ var $6800df1b0932d2db$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
/**
 * @param {function()} fn
 */ var $6800df1b0932d2db$var$executeWhenDOMReady = function(fn) {
    if ($epfVL.isNodeSdk() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function() {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', function() {
                if (document.readyState === 'complete') wrappedFn_1();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn_1);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */ var $6800df1b0932d2db$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */ var $6800df1b0932d2db$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */ var $6800df1b0932d2db$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $6800df1b0932d2db$var$MIN_NAME || b === $6800df1b0932d2db$var$MAX_NAME) return -1;
    else if (b === $6800df1b0932d2db$var$MIN_NAME || a === $6800df1b0932d2db$var$MAX_NAME) return 1;
    else {
        var aAsInt = $6800df1b0932d2db$var$tryParseInt(a), bAsInt = $6800df1b0932d2db$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */ var $6800df1b0932d2db$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */ var $6800df1b0932d2db$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + $epfVL.stringify(obj));
};
/**
 * @param {*} obj
 * @return {string}
 */ var $6800df1b0932d2db$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return $epfVL.stringify(obj);
    var keys = [];
    // eslint-disable-next-line guard-for-in
    for(var k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for(var i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += $epfVL.stringify(keys[i]);
        key += ':';
        key += $6800df1b0932d2db$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */ var $6800df1b0932d2db$var$splitStringBySize = function(str, segsize) {
    var len = str.length;
    if (len <= segsize) return [
        str
    ];
    var dataSegs = [];
    for(var c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj The object or array to iterate over
 * @param fn The function to apply
 */ function $6800df1b0932d2db$var$each(obj, fn) {
    for(var key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */ var $6800df1b0932d2db$var$doubleToIEEE754String = function(v) {
    $epfVL.assert(!$6800df1b0932d2db$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << ebits - 1) - 1;
    var s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    var bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    var str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for(i = 0; i < 64; i += 8){
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */ var $6800df1b0932d2db$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */ var $6800df1b0932d2db$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */ var $6800df1b0932d2db$var$errorForServerCode = function(code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */ var $6800df1b0932d2db$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */ var $6800df1b0932d2db$var$tryParseInt = function(str) {
    if ($6800df1b0932d2db$var$INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */ var $6800df1b0932d2db$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function() {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            $6800df1b0932d2db$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */ var $6800df1b0932d2db$var$beingCrawled = function() {
    var userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */ var $6800df1b0932d2db$var$setTimeoutNonBlocking = function(fn, time) {
    var timeout = setTimeout(fn, time);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ var $6800df1b0932d2db$var$Path = /** @class */ function() {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */ function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for(var i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */ get: function() {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function() {
        if (this.pieceNum_ >= this.pieces_.length) return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */ Path.prototype.getLength = function() {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */ Path.prototype.popFront = function() {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) pieceNum++;
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */ Path.prototype.getBack = function() {
        if (this.pieceNum_ < this.pieces_.length) return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function() {
        var pathString = '';
        for(var i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function() {
        var pathString = '';
        for(var i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */ Path.prototype.slice = function(begin) {
        if (begin === void 0) begin = 0;
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */ Path.prototype.parent = function() {
        if (this.pieceNum_ >= this.pieces_.length) return null;
        var pieces = [];
        for(var i = this.pieceNum_; i < this.pieces_.length - 1; i++)pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */ Path.prototype.child = function(childPathObj) {
        var pieces = [];
        for(var i = this.pieceNum_; i < this.pieces_.length; i++)pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) for(var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
        else {
            var childPieces = childPathObj.split('/');
            for(var i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */ Path.prototype.isEmpty = function() {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */ Path.relativePath = function(outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) return innerPath;
        else if (outer === inner) return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */ Path.comparePaths = function(left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for(var i = 0; i < leftKeys.length && i < rightKeys.length; i++){
            var cmp = $6800df1b0932d2db$var$nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0) return cmp;
        }
        if (leftKeys.length === rightKeys.length) return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */ Path.prototype.equals = function(other) {
        if (this.getLength() !== other.getLength()) return false;
        for(var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++){
            if (this.pieces_[i] !== other.pieces_[j]) return false;
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */ Path.prototype.contains = function(other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) return false;
        while(i < this.pieces_.length){
            if (this.pieces_[i] !== other.pieces_[j]) return false;
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}(); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ var $6800df1b0932d2db$var$ValidationPath = /** @class */ function() {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */ function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */ this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(var i = 0; i < this.parts_.length; i++)this.byteLength_ += $epfVL.stringLength(this.parts_[i]);
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */ get: function() {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */ get: function() {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */ ValidationPath.prototype.push = function(child) {
        // Count the needed '/'
        if (this.parts_.length > 0) this.byteLength_ += 1;
        this.parts_.push(child);
        this.byteLength_ += $epfVL.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function() {
        var last = this.parts_.pop();
        this.byteLength_ -= $epfVL.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) this.byteLength_ -= 1;
    };
    ValidationPath.prototype.checkValid_ = function() {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) throw new Error(this.errorPrefix_ + 'has a key path longer than ' + ValidationPath.MAX_PATH_LENGTH_BYTES + ' bytes (' + this.byteLength_ + ').');
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) throw new Error(this.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + ValidationPath.MAX_PATH_DEPTH + ') or object contains a cycle ' + this.toErrorString());
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */ ValidationPath.prototype.toErrorString = function() {
        if (this.parts_.length === 0) return '';
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$PROTOCOL_VERSION = '5';
var $6800df1b0932d2db$var$VERSION_PARAM = 'v';
var $6800df1b0932d2db$var$TRANSPORT_SESSION_PARAM = 's';
var $6800df1b0932d2db$var$REFERER_PARAM = 'r';
var $6800df1b0932d2db$var$FORGE_REF = 'f';
var $6800df1b0932d2db$var$FORGE_DOMAIN = 'firebaseio.com';
var $6800df1b0932d2db$var$LAST_SESSION_PARAM = 'ls';
var $6800df1b0932d2db$var$WEBSOCKET = 'websocket';
var $6800df1b0932d2db$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */ var $6800df1b0932d2db$var$RepoInfo = /** @class */ function() {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */ function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey, includeNamespaceInQueryParams) {
        if (persistenceKey === void 0) persistenceKey = '';
        if (includeNamespaceInQueryParams === void 0) includeNamespaceInQueryParams = false;
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = $6800df1b0932d2db$var$PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function() {
        return this.host !== this.internalHost || this.isCustomHost() || this.includeNamespaceInQueryParams;
    };
    RepoInfo.prototype.isCacheableHost = function() {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function() {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function() {
        return this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com';
    };
    RepoInfo.prototype.updateHost = function(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $6800df1b0932d2db$var$PersistentStorage.set('host:' + this.host, this.internalHost);
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */ RepoInfo.prototype.connectionURL = function(type, params) {
        $epfVL.assert(typeof type === 'string', 'typeof type must == string');
        $epfVL.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === $6800df1b0932d2db$var$WEBSOCKET) connURL = (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        else if (type === $6800df1b0932d2db$var$LONG_POLLING) connURL = (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        else throw new Error('Unknown connection type: ' + type);
        if (this.needsQueryParam()) params['ns'] = this.namespace;
        var pairs = [];
        $6800df1b0932d2db$var$each(params, function(key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */ RepoInfo.prototype.toString = function() {
        var str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    };
    /** @return {string} */ RepoInfo.prototype.toURLString = function() {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!string} pathString
 * @return {string}
 */ function $6800df1b0932d2db$var$decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for(var i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        var piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */ function $6800df1b0932d2db$var$decodeQuery(queryString) {
    var e_1, _a;
    var results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    try {
        for(var _b = $66Jdw.__values(queryString.split('&')), _c = _b.next(); !_c.done; _c = _b.next()){
            var segment = _c.value;
            if (segment.length === 0) continue;
            var kv = segment.split('=');
            if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
            else $6800df1b0932d2db$var$warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */ var $6800df1b0932d2db$var$parseRepoInfo = function(dataURL) {
    var parsedUrl = $6800df1b0932d2db$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $6800df1b0932d2db$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $6800df1b0932d2db$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $6800df1b0932d2db$var$warnIfPageIsSecure();
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $6800df1b0932d2db$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $6800df1b0932d2db$var$Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string, namespace: string}}
 */ var $6800df1b0932d2db$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $6800df1b0932d2db$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        var queryParams = $6800df1b0932d2db$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        var hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            var dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */ var $6800df1b0932d2db$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */ var $6800df1b0932d2db$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */ var $6800df1b0932d2db$var$MAX_LEAF_SIZE_ = 10485760;
/**
 * @param {*} key
 * @return {boolean}
 */ var $6800df1b0932d2db$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$6800df1b0932d2db$var$INVALID_KEY_REGEX_.test(key);
};
/**
 * @param {string} pathString
 * @return {boolean}
 */ var $6800df1b0932d2db$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$6800df1b0932d2db$var$INVALID_PATH_REGEX_.test(pathString);
};
/**
 * @param {string} pathString
 * @return {boolean}
 */ var $6800df1b0932d2db$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $6800df1b0932d2db$var$isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */ var $6800df1b0932d2db$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$6800df1b0932d2db$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $epfVL.contains(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */ var $6800df1b0932d2db$var$validateFirebaseDataArg = function(fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) return;
    $6800df1b0932d2db$var$validateFirebaseData($epfVL.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */ var $6800df1b0932d2db$var$validateFirebaseData = function(errorPrefix, data, path_) {
    var path = path_ instanceof $6800df1b0932d2db$var$Path ? new $6800df1b0932d2db$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + path.toErrorString() + ' with contents = ' + data.toString());
    if ($6800df1b0932d2db$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $6800df1b0932d2db$var$MAX_LEAF_SIZE_ / 3 && $epfVL.stringLength(data) > $6800df1b0932d2db$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $6800df1b0932d2db$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + path.toErrorString() + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false;
        var hasActualChild_1 = false;
        $6800df1b0932d2db$var$each(data, function(key, value) {
            if (key === '.value') hasDotValue_1 = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!$6800df1b0932d2db$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + path.toErrorString() + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            path.push(key);
            $6800df1b0932d2db$var$validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) throw new Error(errorPrefix + ' contains ".value" child ' + path.toErrorString() + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */ var $6800df1b0932d2db$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    var i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for(var j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$6800df1b0932d2db$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($6800df1b0932d2db$var$Path.comparePaths);
    var prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */ var $6800df1b0932d2db$var$validateFirebaseMergeDataArg = function(fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined) return;
    var errorPrefix = $epfVL.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    var mergePaths = [];
    $6800df1b0932d2db$var$each(data, function(key, value) {
        var curPath = new $6800df1b0932d2db$var$Path(key);
        $6800df1b0932d2db$var$validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!$6800df1b0932d2db$var$isValidPriority(value)) throw new Error(errorPrefix + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $6800df1b0932d2db$var$validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var $6800df1b0932d2db$var$validatePriority = function(fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined) return;
    if ($6800df1b0932d2db$var$isInvalidJSONNumber(priority)) throw new Error($epfVL.errorPrefix(fnName, argumentNumber, optional) + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$6800df1b0932d2db$var$isValidPriority(priority)) throw new Error($epfVL.errorPrefix(fnName, argumentNumber, optional) + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
var $6800df1b0932d2db$var$validateEventType = function(fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch(eventType){
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error($epfVL.errorPrefix(fnName, argumentNumber, optional) + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
var $6800df1b0932d2db$var$validateKey = function(fnName, argumentNumber, key, optional) {
    if (optional && key === undefined) return;
    if (!$6800df1b0932d2db$var$isValidKey(key)) throw new Error($epfVL.errorPrefix(fnName, argumentNumber, optional) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var $6800df1b0932d2db$var$validatePathString = function(fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$6800df1b0932d2db$var$isValidPathString(pathString)) throw new Error($epfVL.errorPrefix(fnName, argumentNumber, optional) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
var $6800df1b0932d2db$var$validateRootPathString = function(fnName, argumentNumber, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $6800df1b0932d2db$var$validatePathString(fnName, argumentNumber, pathString, optional);
};
var $6800df1b0932d2db$var$validateWritablePath = function(fnName, path) {
    if (path.getFront() === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
var $6800df1b0932d2db$var$validateUrl = function(fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$6800df1b0932d2db$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$6800df1b0932d2db$var$isValidRootPathString(pathString)) throw new Error($epfVL.errorPrefix(fnName, argumentNumber, false) + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
var $6800df1b0932d2db$var$validateBoolean = function(fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== 'boolean') throw new Error($epfVL.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 */ var $6800df1b0932d2db$var$OnDisconnect = /** @class */ function() {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */ function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.cancel = function(onComplete) {
        $epfVL.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        $epfVL.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.remove = function(onComplete) {
        $epfVL.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('OnDisconnect.remove', this.path_);
        $epfVL.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.set = function(value, onComplete) {
        $epfVL.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('OnDisconnect.set', this.path_);
        $6800df1b0932d2db$var$validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        $epfVL.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.setWithPriority = function(value, priority, onComplete) {
        $epfVL.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        $6800df1b0932d2db$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        $6800df1b0932d2db$var$validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        $epfVL.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */ OnDisconnect.prototype.update = function(objectToMerge, onComplete) {
        $epfVL.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for(var i = 0; i < objectToMerge.length; ++i)newObjectToMerge['' + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $6800df1b0932d2db$var$warn("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        $6800df1b0932d2db$var$validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        $epfVL.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$TransactionResult = /** @class */ function() {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */ function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function() {
        $epfVL.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    };
    return TransactionResult;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ var $6800df1b0932d2db$var$nextPushId = function() {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function(now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        $epfVL.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += PUSH_CHARS.charAt(lastRandChars[i]);
        $epfVL.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */ var $6800df1b0932d2db$var$NamedNode = /** @class */ function() {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */ NamedNode.Wrap = function(name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @constructor
 */ var $6800df1b0932d2db$var$Index = /** @class */ function() {
    function Index() {}
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */ Index.prototype.getCompare = function() {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ Index.prototype.indexedValueChanged = function(oldNode, newNode) {
        var oldWrapped = new $6800df1b0932d2db$var$NamedNode($6800df1b0932d2db$var$MIN_NAME, oldNode);
        var newWrapped = new $6800df1b0932d2db$var$NamedNode($6800df1b0932d2db$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ Index.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $6800df1b0932d2db$var$NamedNode.MIN;
    };
    return Index;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$__EMPTY_NODE;
var $6800df1b0932d2db$var$KeyIndex = /** @class */ function(_super) {
    $66Jdw.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function() {
            return $6800df1b0932d2db$var$__EMPTY_NODE;
        },
        set: function(val) {
            $6800df1b0932d2db$var$__EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */ KeyIndex.prototype.compare = function(a, b) {
        return $6800df1b0932d2db$var$nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.isDefinedOn = function(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw $epfVL.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $6800df1b0932d2db$var$NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */ KeyIndex.prototype.maxPost = function() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $6800df1b0932d2db$var$NamedNode($6800df1b0932d2db$var$MAX_NAME, $6800df1b0932d2db$var$__EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */ KeyIndex.prototype.makePost = function(indexValue, name) {
        $epfVL.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $6800df1b0932d2db$var$NamedNode(indexValue, $6800df1b0932d2db$var$__EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */ KeyIndex.prototype.toString = function() {
        return '.key';
    };
    return KeyIndex;
}($6800df1b0932d2db$var$Index);
var $6800df1b0932d2db$var$KEY_INDEX = new $6800df1b0932d2db$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$MAX_NODE;
function $6800df1b0932d2db$var$setMaxNode(val) {
    $6800df1b0932d2db$var$MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */ var $6800df1b0932d2db$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $6800df1b0932d2db$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */ var $6800df1b0932d2db$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        $epfVL.assert(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && $epfVL.contains(val, '.sv'), 'Priority must be a string or number.');
    } else $epfVL.assert(priorityNode === $6800df1b0932d2db$var$MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    $epfVL.assert(priorityNode === $6800df1b0932d2db$var$MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ var $6800df1b0932d2db$var$LeafNode = /** @class */ function() {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */ function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        $epfVL.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $6800df1b0932d2db$var$validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function() {
            return $6800df1b0932d2db$var$__childrenNodeConstructor;
        },
        set: function(val) {
            $6800df1b0932d2db$var$__childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */ LeafNode.prototype.isLeafNode = function() {
        return true;
    };
    /** @inheritDoc */ LeafNode.prototype.getPriority = function() {
        return this.priorityNode_;
    };
    /** @inheritDoc */ LeafNode.prototype.updatePriority = function(newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */ LeafNode.prototype.getImmediateChild = function(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    };
    /** @inheritDoc */ LeafNode.prototype.getChild = function(path) {
        if (path.isEmpty()) return this;
        else if (path.getFront() === '.priority') return this.priorityNode_;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.hasChild = function() {
        return false;
    };
    /** @inheritDoc */ LeafNode.prototype.getPredecessorChildName = function(childName, childNode) {
        return null;
    };
    /** @inheritDoc */ LeafNode.prototype.updateImmediateChild = function(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    };
    /** @inheritDoc */ LeafNode.prototype.updateChild = function(path, newChildNode) {
        var front = path.getFront();
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            $epfVL.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */ LeafNode.prototype.isEmpty = function() {
        return false;
    };
    /** @inheritDoc */ LeafNode.prototype.numChildren = function() {
        return 0;
    };
    /** @inheritDoc */ LeafNode.prototype.forEachChild = function(index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.val = function(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    };
    /** @inheritDoc */ LeafNode.prototype.hash = function() {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $6800df1b0932d2db$var$priorityHashText(this.priorityNode_.val()) + ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $6800df1b0932d2db$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $6800df1b0932d2db$var$sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */ LeafNode.prototype.getValue = function() {
        return this.value_;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.compareTo = function(other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof LeafNode.__childrenNodeConstructor) return -1;
        else {
            $epfVL.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */ LeafNode.prototype.compareToLeafNode_ = function(otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        $epfVL.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        $epfVL.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.withIndex = function() {
        return this;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.isIndexed = function() {
        return true;
    };
    /**
     * @inheritDoc
     */ LeafNode.prototype.equals = function(other) {
        /**
         * @inheritDoc
         */ if (other === this) return true;
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */ LeafNode.VALUE_TYPE_ORDER = [
        'object',
        'boolean',
        'number',
        'string'
    ];
    return LeafNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$nodeFromJSON;
var $6800df1b0932d2db$var$MAX_NODE$1;
function $6800df1b0932d2db$var$setNodeFromJSON(val) {
    $6800df1b0932d2db$var$nodeFromJSON = val;
}
function $6800df1b0932d2db$var$setMaxNode$1(val) {
    $6800df1b0932d2db$var$MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */ var $6800df1b0932d2db$var$PriorityIndex = /** @class */ function(_super) {
    $66Jdw.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.compare = function(a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $6800df1b0932d2db$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.isDefinedOn = function(node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $6800df1b0932d2db$var$NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */ PriorityIndex.prototype.maxPost = function() {
        return new $6800df1b0932d2db$var$NamedNode($6800df1b0932d2db$var$MAX_NAME, new $6800df1b0932d2db$var$LeafNode('[PRIORITY-POST]', $6800df1b0932d2db$var$MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */ PriorityIndex.prototype.makePost = function(indexValue, name) {
        var priorityNode = $6800df1b0932d2db$var$nodeFromJSON(indexValue);
        return new $6800df1b0932d2db$var$NamedNode(name, new $6800df1b0932d2db$var$LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */ PriorityIndex.prototype.toString = function() {
        return '.priority';
    };
    return PriorityIndex;
}($6800df1b0932d2db$var$Index);
var $6800df1b0932d2db$var$PRIORITY_INDEX = new $6800df1b0932d2db$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ var $6800df1b0932d2db$var$SortedMapIterator = /** @class */ function() {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */ function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) resultGenerator_ = null;
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */ this.nodeStack_ = [];
        var cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    SortedMapIterator.prototype.getNext = function() {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function() {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function() {
        if (this.nodeStack_.length === 0) return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    };
    return SortedMapIterator;
}();
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ var $6800df1b0932d2db$var$LLRBNode = /** @class */ function() {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */ function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : $6800df1b0932d2db$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $6800df1b0932d2db$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */ LLRBNode.prototype.copy = function(key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */ LLRBNode.prototype.count = function() {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */ LLRBNode.prototype.isEmpty = function() {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ LLRBNode.prototype.inorderTraversal = function(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */ LLRBNode.prototype.reverseTraversal = function(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */ LLRBNode.prototype.min_ = function() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    };
    /**
     * @return {!K} The maximum key in the tree.
     */ LLRBNode.prototype.minKey = function() {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */ LLRBNode.prototype.maxKey = function() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */ LLRBNode.prototype.insert = function(key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */ LLRBNode.prototype.removeMin_ = function() {
        if (this.left.isEmpty()) return $6800df1b0932d2db$var$SortedMap.EMPTY_NODE;
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */ LLRBNode.prototype.remove = function(key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $6800df1b0932d2db$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */ LLRBNode.prototype.isRed_ = function() {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */ LLRBNode.prototype.fixUp_ = function() {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */ LLRBNode.prototype.moveRedLeft_ = function() {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */ LLRBNode.prototype.moveRedRight_ = function() {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */ LLRBNode.prototype.rotateLeft_ = function() {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */ LLRBNode.prototype.rotateRight_ = function() {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */ LLRBNode.prototype.colorFlip_ = function() {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */ LLRBNode.prototype.checkMaxDepth_ = function() {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */ LLRBNode.prototype.check_ = function() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        var blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}();
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ var $6800df1b0932d2db$var$LLRBEmptyNode = /** @class */ function() {
    function LLRBEmptyNode() {}
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */ LLRBEmptyNode.prototype.copy = function(key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */ LLRBEmptyNode.prototype.insert = function(key, value, comparator) {
        return new $6800df1b0932d2db$var$LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */ LLRBEmptyNode.prototype.remove = function(key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */ LLRBEmptyNode.prototype.count = function() {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */ LLRBEmptyNode.prototype.isEmpty = function() {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */ LLRBEmptyNode.prototype.inorderTraversal = function(action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */ LLRBEmptyNode.prototype.reverseTraversal = function(action) {
        return false;
    };
    /**
     * @return {null}
     */ LLRBEmptyNode.prototype.minKey = function() {
        return null;
    };
    /**
     * @return {null}
     */ LLRBEmptyNode.prototype.maxKey = function() {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */ LLRBEmptyNode.prototype.check_ = function() {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */ LLRBEmptyNode.prototype.isRed_ = function() {
        return false;
    };
    return LLRBEmptyNode;
}();
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ var $6800df1b0932d2db$var$SortedMap = /** @class */ function() {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */ function SortedMap(comparator_, root_) {
        if (root_ === void 0) root_ = SortedMap.EMPTY_NODE;
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */ SortedMap.prototype.insert = function(key, value) {
        return new SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $6800df1b0932d2db$var$LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */ SortedMap.prototype.remove = function(key) {
        return new SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $6800df1b0932d2db$var$LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */ SortedMap.prototype.get = function(key) {
        var cmp;
        var node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */ SortedMap.prototype.getPredecessorKey = function(key) {
        var cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */ SortedMap.prototype.isEmpty = function() {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */ SortedMap.prototype.count = function() {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */ SortedMap.prototype.minKey = function() {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */ SortedMap.prototype.maxKey = function() {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ SortedMap.prototype.inorderTraversal = function(action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */ SortedMap.prototype.reverseTraversal = function(action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */ SortedMap.prototype.getIterator = function(resultGenerator) {
        return new $6800df1b0932d2db$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function(key, resultGenerator) {
        return new $6800df1b0932d2db$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function(key, resultGenerator) {
        return new $6800df1b0932d2db$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function(resultGenerator) {
        return new $6800df1b0932d2db$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */ SortedMap.EMPTY_NODE = new $6800df1b0932d2db$var$LLRBEmptyNode();
    return SortedMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$LOG_2 = Math.log(2);
/**
 * @constructor
 */ var $6800df1b0932d2db$var$Base12Num = /** @class */ function() {
    /**
     * @param {number} length
     */ function Base12Num(length) {
        var logBase2 = function(num) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return parseInt(Math.log(num) / $6800df1b0932d2db$var$LOG_2, 10);
        };
        var bitMask = function(bits) {
            return parseInt(Array(bits + 1).join('1'), 2);
        };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    /**
     * @return {boolean}
     */ Base12Num.prototype.nextBitIsOne = function() {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    };
    return Base12Num;
}();
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */ var $6800df1b0932d2db$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function(low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $6800df1b0932d2db$var$LLRBNode(key, namedNode.node, $6800df1b0932d2db$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var middle = parseInt(length / 2, 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $6800df1b0932d2db$var$LLRBNode(key, namedNode.node, $6800df1b0932d2db$var$LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function(base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function(chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $6800df1b0932d2db$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(var i = 0; i < base12.count; ++i){
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $6800df1b0932d2db$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $6800df1b0932d2db$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $6800df1b0932d2db$var$LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new $6800df1b0932d2db$var$Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $6800df1b0932d2db$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$_defaultIndexMap;
var $6800df1b0932d2db$var$fallbackObject = {};
var $6800df1b0932d2db$var$IndexMap = /** @class */ function() {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         */ get: function() {
            $epfVL.assert($6800df1b0932d2db$var$fallbackObject && $6800df1b0932d2db$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            $6800df1b0932d2db$var$_defaultIndexMap = $6800df1b0932d2db$var$_defaultIndexMap || new IndexMap({
                '.priority': $6800df1b0932d2db$var$fallbackObject
            }, {
                '.priority': $6800df1b0932d2db$var$PRIORITY_INDEX
            });
            return $6800df1b0932d2db$var$_defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    IndexMap.prototype.get = function(indexKey) {
        var sortedMap = $epfVL.safeGet(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $6800df1b0932d2db$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    };
    IndexMap.prototype.hasIndex = function(indexDefinition) {
        return $epfVL.contains(this.indexSet_, indexDefinition.toString());
    };
    IndexMap.prototype.addIndex = function(indexDefinition, existingChildren) {
        $epfVL.assert(indexDefinition !== $6800df1b0932d2db$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator($6800df1b0932d2db$var$NamedNode.Wrap);
        var next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) newIndex = $6800df1b0932d2db$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $6800df1b0932d2db$var$fallbackObject;
        var indexName = indexDefinition.toString();
        var newIndexSet = $66Jdw.__assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = $66Jdw.__assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ IndexMap.prototype.addToIndexes = function(namedNode, existingChildren) {
        var _this = this;
        var newIndexes = $epfVL.map(this.indexes_, function(indexedChildren, indexName) {
            var index = $epfVL.safeGet(_this.indexSet_, indexName);
            $epfVL.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $6800df1b0932d2db$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator($6800df1b0932d2db$var$NamedNode.Wrap);
                    var next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $6800df1b0932d2db$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $6800df1b0932d2db$var$fallbackObject;
            } else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $6800df1b0932d2db$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     */ IndexMap.prototype.removeFromIndexes = function(namedNode, existingChildren) {
        var newIndexes = $epfVL.map(this.indexes_, function(indexedChildren) {
            if (indexedChildren === $6800df1b0932d2db$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $6800df1b0932d2db$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $6800df1b0932d2db$var$NAME_ONLY_COMPARATOR(left, right) {
    return $6800df1b0932d2db$var$nameCompare(left.name, right.name);
}
function $6800df1b0932d2db$var$NAME_COMPARATOR(left, right) {
    return $6800df1b0932d2db$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
var $6800df1b0932d2db$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */ var $6800df1b0932d2db$var$ChildrenNode = /** @class */ function() {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */ function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $6800df1b0932d2db$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) $epfVL.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function() {
            return $6800df1b0932d2db$var$EMPTY_NODE || ($6800df1b0932d2db$var$EMPTY_NODE = new ChildrenNode(new $6800df1b0932d2db$var$SortedMap($6800df1b0932d2db$var$NAME_COMPARATOR), null, $6800df1b0932d2db$var$IndexMap.Default));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */ ChildrenNode.prototype.isLeafNode = function() {
        return false;
    };
    /** @inheritDoc */ ChildrenNode.prototype.getPriority = function() {
        return this.priorityNode_ || $6800df1b0932d2db$var$EMPTY_NODE;
    };
    /** @inheritDoc */ ChildrenNode.prototype.updatePriority = function(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    };
    /** @inheritDoc */ ChildrenNode.prototype.getImmediateChild = function(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            var child = this.children_.get(childName);
            return child === null ? $6800df1b0932d2db$var$EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.getChild = function(path) {
        var front = path.getFront();
        if (front === null) return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */ ChildrenNode.prototype.hasChild = function(childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */ ChildrenNode.prototype.updateImmediateChild = function(childName, newChildNode) {
        $epfVL.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            var namedNode = new $6800df1b0932d2db$var$NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            var newPriority = newChildren.isEmpty() ? $6800df1b0932d2db$var$EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.updateChild = function(path, newChildNode) {
        var front = path.getFront();
        if (front === null) return newChildNode;
        else {
            $epfVL.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.isEmpty = function() {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */ ChildrenNode.prototype.numChildren = function() {
        return this.children_.count();
    };
    /** @inheritDoc */ ChildrenNode.prototype.val = function(exportFormat) {
        if (this.isEmpty()) return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            // eslint-disable-next-line guard-for-in
            for(var key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    };
    /** @inheritDoc */ ChildrenNode.prototype.hash = function() {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty()) toHash_1 += 'priority:' + $6800df1b0932d2db$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '') toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : $6800df1b0932d2db$var$sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */ ChildrenNode.prototype.getPredecessorChildName = function(childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new $6800df1b0932d2db$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */ ChildrenNode.prototype.getFirstChildName = function(indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */ ChildrenNode.prototype.getFirstChild = function(indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $6800df1b0932d2db$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */ ChildrenNode.prototype.getLastChildName = function(indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */ ChildrenNode.prototype.getLastChild = function(indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $6800df1b0932d2db$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.forEachChild = function(index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal(function(wrappedNode) {
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */ ChildrenNode.prototype.getIterator = function(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */ ChildrenNode.prototype.getIteratorFrom = function(startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, function(key) {
            return key;
        });
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, $6800df1b0932d2db$var$NamedNode.Wrap);
            var next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */ ChildrenNode.prototype.getReverseIterator = function(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */ ChildrenNode.prototype.getReverseIteratorFrom = function(endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, function(key) {
            return key;
        });
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, $6800df1b0932d2db$var$NamedNode.Wrap);
            var next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.compareTo = function(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $6800df1b0932d2db$var$MAX_NODE$2) return -1;
        else // Must be another node with children.
        return 0;
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.withIndex = function(indexDefinition) {
        if (indexDefinition === $6800df1b0932d2db$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.isIndexed = function(index) {
        return index === $6800df1b0932d2db$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */ ChildrenNode.prototype.equals = function(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator($6800df1b0932d2db$var$PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator($6800df1b0932d2db$var$PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */ ChildrenNode.prototype.resolveIndex_ = function(indexDefinition) {
        if (indexDefinition === $6800df1b0932d2db$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    };
    /**
     * @private
     * @type {RegExp}
     */ ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}();
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */ var $6800df1b0932d2db$var$MaxNode = /** @class */ function(_super) {
    $66Jdw.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new $6800df1b0932d2db$var$SortedMap($6800df1b0932d2db$var$NAME_COMPARATOR), $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE, $6800df1b0932d2db$var$IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function(other) {
        if (other === this) return 0;
        else return 1;
    };
    MaxNode.prototype.equals = function(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function() {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function(childName) {
        return $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function() {
        return false;
    };
    return MaxNode;
}($6800df1b0932d2db$var$ChildrenNode);
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */ var $6800df1b0932d2db$var$MAX_NODE$2 = new $6800df1b0932d2db$var$MaxNode();
Object.defineProperties($6800df1b0932d2db$var$NamedNode, {
    MIN: {
        value: new $6800df1b0932d2db$var$NamedNode($6800df1b0932d2db$var$MIN_NAME, $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $6800df1b0932d2db$var$NamedNode($6800df1b0932d2db$var$MAX_NAME, $6800df1b0932d2db$var$MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */ $6800df1b0932d2db$var$KeyIndex.__EMPTY_NODE = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
$6800df1b0932d2db$var$LeafNode.__childrenNodeConstructor = $6800df1b0932d2db$var$ChildrenNode;
$6800df1b0932d2db$var$setMaxNode($6800df1b0932d2db$var$MAX_NODE$2);
$6800df1b0932d2db$var$setMaxNode$1($6800df1b0932d2db$var$MAX_NODE$2);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */ function $6800df1b0932d2db$var$nodeFromJSON$1(json, priority) {
    if (priority === void 0) priority = null;
    if (json === null) return $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    $epfVL.assert(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new $6800df1b0932d2db$var$LeafNode(jsonLeaf, $6800df1b0932d2db$var$nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && $6800df1b0932d2db$var$USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj = json;
        $6800df1b0932d2db$var$each(hinzeJsonObj, function(key, child) {
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = $6800df1b0932d2db$var$nodeFromJSON$1(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 = childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new $6800df1b0932d2db$var$NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length === 0) return $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
        var childSet = $6800df1b0932d2db$var$buildChildSet(children_1, $6800df1b0932d2db$var$NAME_ONLY_COMPARATOR, function(namedNode) {
            return namedNode.name;
        }, $6800df1b0932d2db$var$NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = $6800df1b0932d2db$var$buildChildSet(children_1, $6800df1b0932d2db$var$PRIORITY_INDEX.getCompare());
            return new $6800df1b0932d2db$var$ChildrenNode(childSet, $6800df1b0932d2db$var$nodeFromJSON$1(priority), new $6800df1b0932d2db$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $6800df1b0932d2db$var$PRIORITY_INDEX
            }));
        } else return new $6800df1b0932d2db$var$ChildrenNode(childSet, $6800df1b0932d2db$var$nodeFromJSON$1(priority), $6800df1b0932d2db$var$IndexMap.Default);
    } else {
        var node_1 = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
        $6800df1b0932d2db$var$each(json, function(key, childData) {
            if ($epfVL.contains(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = $6800df1b0932d2db$var$nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority($6800df1b0932d2db$var$nodeFromJSON$1(priority));
    }
}
$6800df1b0932d2db$var$setNodeFromJSON($6800df1b0932d2db$var$nodeFromJSON$1);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 * @extends {Index}
 * @private
 */ var $6800df1b0932d2db$var$ValueIndex = /** @class */ function(_super) {
    $66Jdw.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ ValueIndex.prototype.compare = function(a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $6800df1b0932d2db$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.isDefinedOn = function(node) {
        return true;
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.indexedValueChanged = function(oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.minPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $6800df1b0932d2db$var$NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */ ValueIndex.prototype.maxPost = function() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $6800df1b0932d2db$var$NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */ ValueIndex.prototype.makePost = function(indexValue, name) {
        var valueNode = $6800df1b0932d2db$var$nodeFromJSON$1(indexValue);
        return new $6800df1b0932d2db$var$NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */ ValueIndex.prototype.toString = function() {
        return '.value';
    };
    return ValueIndex;
}($6800df1b0932d2db$var$Index);
var $6800df1b0932d2db$var$VALUE_INDEX = new $6800df1b0932d2db$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */ var $6800df1b0932d2db$var$PathIndex = /** @class */ function(_super) {
    $66Jdw.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        $epfVL.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */ PathIndex.prototype.extractChild = function(snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.isDefinedOn = function(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.compare = function(a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $6800df1b0932d2db$var$nameCompare(a.name, b.name);
        else return indexCmp;
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.makePost = function(indexValue, name) {
        var valueNode = $6800df1b0932d2db$var$nodeFromJSON$1(indexValue);
        var node = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $6800df1b0932d2db$var$NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.maxPost = function() {
        var node = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $6800df1b0932d2db$var$MAX_NODE$2);
        return new $6800df1b0932d2db$var$NamedNode($6800df1b0932d2db$var$MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */ PathIndex.prototype.toString = function() {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}($6800df1b0932d2db$var$Index);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */ var $6800df1b0932d2db$var$DataSnapshot = /** @class */ function() {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */ function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */ DataSnapshot.prototype.val = function() {
        $epfVL.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */ DataSnapshot.prototype.exportVal = function() {
        $epfVL.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function() {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        $epfVL.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */ DataSnapshot.prototype.exists = function() {
        $epfVL.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */ DataSnapshot.prototype.child = function(childPathString) {
        $epfVL.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        $6800df1b0932d2db$var$validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new $6800df1b0932d2db$var$Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, $6800df1b0932d2db$var$PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */ DataSnapshot.prototype.hasChild = function(childPathString) {
        $epfVL.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        $6800df1b0932d2db$var$validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new $6800df1b0932d2db$var$Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */ DataSnapshot.prototype.getPriority = function() {
        $epfVL.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */ DataSnapshot.prototype.forEach = function(action) {
        var _this = this;
        $epfVL.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        $epfVL.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode()) return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function(key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), $6800df1b0932d2db$var$PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */ DataSnapshot.prototype.hasChildren = function() {
        $epfVL.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode()) return false;
        else return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function() {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */ DataSnapshot.prototype.numChildren = function() {
        $epfVL.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */ DataSnapshot.prototype.getRef = function() {
        $epfVL.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function() {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */ var $6800df1b0932d2db$var$DataEvent = /** @class */ function() {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */ function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */ DataEvent.prototype.getPath = function() {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') return ref.path;
        else return ref.getParent().path;
    };
    /**
     * @inheritDoc
     */ DataEvent.prototype.getEventType = function() {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */ DataEvent.prototype.getEventRunner = function() {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */ DataEvent.prototype.toString = function() {
        return this.getPath().toString() + ':' + this.eventType + ':' + $epfVL.stringify(this.snapshot.exportVal());
    };
    return DataEvent;
}();
var $6800df1b0932d2db$var$CancelEvent = /** @class */ function() {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */ function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */ CancelEvent.prototype.getPath = function() {
        return this.path;
    };
    /**
     * @inheritDoc
     */ CancelEvent.prototype.getEventType = function() {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */ CancelEvent.prototype.getEventRunner = function() {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */ CancelEvent.prototype.toString = function() {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents registration for 'value' events.
 */ var $6800df1b0932d2db$var$ValueEventRegistration = /** @class */ function() {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */ function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.respondsTo = function(eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.createEvent = function(change, query) {
        var index = query.getQueryParams().getIndex();
        return new $6800df1b0932d2db$var$DataEvent('value', this, new $6800df1b0932d2db$var$DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.getEventRunner = function(eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            $epfVL.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function() {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        } else {
            var cb_1 = this.callback_;
            return function() {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.createCancelEvent = function(error, path) {
        if (this.cancelCallback_) return new $6800df1b0932d2db$var$CancelEvent(this, error, path);
        else return null;
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.matches = function(other) {
        if (!(other instanceof ValueEventRegistration)) return false;
        else if (!other.callback_ || !this.callback_) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callback_ === this.callback_ && other.context_ === this.context_;
    };
    /**
     * @inheritDoc
     */ ValueEventRegistration.prototype.hasAnyCallback = function() {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}();
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */ var $6800df1b0932d2db$var$ChildEventRegistration = /** @class */ function() {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */ function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.respondsTo = function(eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return $epfVL.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.createCancelEvent = function(error, path) {
        if (this.cancelCallback_) return new $6800df1b0932d2db$var$CancelEvent(this, error, path);
        else return null;
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.createEvent = function(change, query) {
        $epfVL.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ change.childName);
        var index = query.getQueryParams().getIndex();
        return new $6800df1b0932d2db$var$DataEvent(change.type, this, new $6800df1b0932d2db$var$DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.getEventRunner = function(eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            $epfVL.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function() {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        } else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function() {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.matches = function(other) {
        var _this = this;
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) return true;
            else if (this.context_ === other.context_) {
                var otherKeys = Object.keys(other.callbacks_);
                var thisKeys = Object.keys(this.callbacks_);
                var otherCount = otherKeys.length;
                var thisCount = thisKeys.length;
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    // If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey = otherKeys[0];
                        var thisKey = thisKeys[0];
                        return thisKey === otherKey && (!other.callbacks_[otherKey] || !this.callbacks_[thisKey] || other.callbacks_[otherKey] === this.callbacks_[thisKey]);
                    } else // Exact match on each key.
                    return thisKeys.every(function(eventType) {
                        return other.callbacks_[eventType] === _this.callbacks_[eventType];
                    });
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */ ChildEventRegistration.prototype.hasAnyCallback = function() {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$__referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */ var $6800df1b0932d2db$var$Query = /** @class */ function() {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function() {
            $epfVL.assert($6800df1b0932d2db$var$__referenceConstructor, 'Reference.ts has not been loaded');
            return $6800df1b0932d2db$var$__referenceConstructor;
        },
        set: function(val) {
            $6800df1b0932d2db$var$__referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */ Query.validateQueryEndpoints_ = function(params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) startNode = params.getIndexStartValue();
        if (params.hasEnd()) endNode = params.getIndexEndValue();
        if (params.getIndex() === $6800df1b0932d2db$var$KEY_INDEX) {
            var tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
            var wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.";
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName !== $6800df1b0932d2db$var$MIN_NAME) throw new Error(tooManyArgsError);
                else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName !== $6800df1b0932d2db$var$MAX_NAME) throw new Error(tooManyArgsError);
                else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
            }
        } else if (params.getIndex() === $6800df1b0932d2db$var$PRIORITY_INDEX) {
            if (startNode != null && !$6800df1b0932d2db$var$isValidPriority(startNode) || endNode != null && !$6800df1b0932d2db$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");
        } else {
            $epfVL.assert(params.getIndex() instanceof $6800df1b0932d2db$var$PathIndex || params.getIndex() === $6800df1b0932d2db$var$VALUE_INDEX, 'unknown index type.');
            if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */ Query.validateLimit_ = function(params) {
        if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */ Query.prototype.validateNoPreviousOrderByCall_ = function(fnName) {
        if (this.orderByCalled_ === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
    };
    /**
     * @return {!QueryParams}
     */ Query.prototype.getQueryParams = function() {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */ Query.prototype.getRef = function() {
        $epfVL.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */ Query.prototype.on = function(eventType, callback, cancelCallbackOrContext, context) {
        $epfVL.validateArgCount('Query.on', 2, 4, arguments.length);
        $6800df1b0932d2db$var$validateEventType('Query.on', 1, eventType, false);
        $epfVL.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') this.onValueEvent(callback, ret.cancel, ret.context);
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */ Query.prototype.onValueEvent = function(callback, cancelCallback, context) {
        var container = new $6800df1b0932d2db$var$ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */ Query.prototype.onChildEvent = function(callbacks, cancelCallback, context) {
        var container = new $6800df1b0932d2db$var$ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */ Query.prototype.off = function(eventType, callback, context) {
        $epfVL.validateArgCount('Query.off', 0, 3, arguments.length);
        $6800df1b0932d2db$var$validateEventType('Query.off', 1, eventType, true);
        $epfVL.validateCallback('Query.off', 2, callback, true);
        $epfVL.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new $6800df1b0932d2db$var$ValueEventRegistration(valueCallback, null, context || null);
        } else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new $6800df1b0932d2db$var$ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param failureCallbackOrContext
     * @param context
     * @return {!firebase.Promise}
     */ Query.prototype.once = function(eventType, userCallback, failureCallbackOrContext, context) {
        var _this = this;
        $epfVL.validateArgCount('Query.once', 1, 4, arguments.length);
        $6800df1b0932d2db$var$validateEventType('Query.once', 1, eventType, false);
        $epfVL.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new $epfVL.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function() {});
        var onceCallback = function(snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) userCallback.bind(ret.context)(snapshot);
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, /*cancel=*/ function(err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel) ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */ Query.prototype.limitToFirst = function(limit) {
        $epfVL.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        if (this.queryParams_.hasLimit()) throw new Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */ Query.prototype.limitToLast = function(limit) {
        $epfVL.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('Query.limitToLast: First argument must be a positive integer.');
        if (this.queryParams_.hasLimit()) throw new Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */ Query.prototype.orderByChild = function(path) {
        $epfVL.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        else if (path === '$priority') throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        else if (path === '$value') throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        $6800df1b0932d2db$var$validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new $6800df1b0932d2db$var$Path(path);
        if (parsedPath.isEmpty()) throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        var index = new $6800df1b0932d2db$var$PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */ Query.prototype.orderByKey = function() {
        $epfVL.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy($6800df1b0932d2db$var$KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */ Query.prototype.orderByPriority = function() {
        $epfVL.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy($6800df1b0932d2db$var$PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */ Query.prototype.orderByValue = function() {
        $epfVL.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy($6800df1b0932d2db$var$VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */ Query.prototype.startAt = function(value, name) {
        if (value === void 0) value = null;
        $epfVL.validateArgCount('Query.startAt', 0, 2, arguments.length);
        $6800df1b0932d2db$var$validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        $6800df1b0932d2db$var$validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) throw new Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */ Query.prototype.endAt = function(value, name) {
        if (value === void 0) value = null;
        $epfVL.validateArgCount('Query.endAt', 0, 2, arguments.length);
        $6800df1b0932d2db$var$validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        $6800df1b0932d2db$var$validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) throw new Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */ Query.prototype.equalTo = function(value, name) {
        $epfVL.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        $6800df1b0932d2db$var$validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        $6800df1b0932d2db$var$validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) throw new Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");
        if (this.queryParams_.hasEnd()) throw new Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */ Query.prototype.toString = function() {
        $epfVL.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function() {
        // An optional spacer argument is unnecessary for a string.
        $epfVL.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */ Query.prototype.queryObject = function() {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */ Query.prototype.queryIdentifier = function() {
        var obj = this.queryObject();
        var id = $6800df1b0932d2db$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */ Query.prototype.isEqual = function(other) {
        $epfVL.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */ Query.getCancelAndContextArgs_ = function(fnName, cancelOrContext, context) {
        var ret = {
            cancel: null,
            context: null
        };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            $epfVL.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            $epfVL.validateContextObject(fnName, 4, ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) // it's a context!
            ret.context = cancelOrContext;
            else if (typeof cancelOrContext === 'function') ret.cancel = cancelOrContext;
            else throw new Error($epfVL.errorPrefix(fnName, 3, true) + ' must either be a cancel callback or a context object.');
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function() {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$ExistingValueProvider = /** @class */ function() {
    function ExistingValueProvider(node_) {
        this.node_ = node_;
    }
    ExistingValueProvider.prototype.getImmediateChild = function(childName) {
        var child = this.node_.getImmediateChild(childName);
        return new ExistingValueProvider(child);
    };
    ExistingValueProvider.prototype.node = function() {
        return this.node_;
    };
    return ExistingValueProvider;
}();
var $6800df1b0932d2db$var$DeferredValueProvider = /** @class */ function() {
    function DeferredValueProvider(syncTree, path) {
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    DeferredValueProvider.prototype.getImmediateChild = function(childName) {
        var childPath = this.path_.child(childName);
        return new DeferredValueProvider(this.syncTree_, childPath);
    };
    DeferredValueProvider.prototype.node = function() {
        return this.syncTree_.calcCompleteEventCache(this.path_);
    };
    return DeferredValueProvider;
}();
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */ var $6800df1b0932d2db$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */ var $6800df1b0932d2db$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    $epfVL.assert('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $6800df1b0932d2db$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $6800df1b0932d2db$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else $epfVL.assert(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
var $6800df1b0932d2db$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            $epfVL.assert(false, 'Unexpected server value: ' + op);
    }
};
var $6800df1b0932d2db$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) $epfVL.assert(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    var delta = op['increment'];
    if (typeof delta !== 'number') $epfVL.assert(false, 'Unexpected increment value: ' + delta);
    var existingNode = existing.node();
    $epfVL.assert(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    var leaf = existingNode;
    var existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!Path} path path to which write is relative
 * @param {!Node} node new data written at path
 * @param {!SyncTree} syncTree current data
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */ var $6800df1b0932d2db$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $6800df1b0932d2db$var$resolveDeferredValue(node, new $6800df1b0932d2db$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */ var $6800df1b0932d2db$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $6800df1b0932d2db$var$resolveDeferredValue(node, new $6800df1b0932d2db$var$ExistingValueProvider(existing), serverValues);
};
function $6800df1b0932d2db$var$resolveDeferredValue(node, existingVal, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = $6800df1b0932d2db$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = $6800df1b0932d2db$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $6800df1b0932d2db$var$LeafNode(value, $6800df1b0932d2db$var$nodeFromJSON$1(priority));
        else return node;
    } else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $6800df1b0932d2db$var$LeafNode(priority));
        childrenNode.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(childName, childNode) {
            var newChildNode = $6800df1b0932d2db$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to store a sparse set of snapshots.
 */ var $6800df1b0932d2db$var$SparseSnapshotTree = /** @class */ function() {
    function SparseSnapshotTree() {
        this.value = null;
        this.children = new Map();
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param path Path to look up snapshot for.
     * @return The retrieved node, or null.
     */ SparseSnapshotTree.prototype.find = function(path) {
        if (this.value != null) return this.value.getChild(path);
        else if (!path.isEmpty() && this.children.size > 0) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children.has(childKey)) {
                var childTree = this.children.get(childKey);
                return childTree.find(path);
            } else return null;
        } else return null;
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param path Path to look up snapshot for.
     * @param data The new data, or null.
     */ SparseSnapshotTree.prototype.remember = function(path, data) {
        if (path.isEmpty()) {
            this.value = data;
            this.children.clear();
        } else if (this.value !== null) this.value = this.value.updateChild(path, data);
        else {
            var childKey = path.getFront();
            if (!this.children.has(childKey)) this.children.set(childKey, new SparseSnapshotTree());
            var child = this.children.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param path Path to look up snapshot for.
     * @return True if this node should now be removed.
     */ SparseSnapshotTree.prototype.forget = function(path) {
        if (path.isEmpty()) {
            this.value = null;
            this.children.clear();
            return true;
        } else {
            if (this.value !== null) {
                if (this.value.isLeafNode()) // We're trying to forget a node that doesn't exist
                return false;
                else {
                    var value = this.value;
                    this.value = null;
                    var self_1 = this;
                    value.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(key, tree) {
                        self_1.remember(new $6800df1b0932d2db$var$Path(key), tree);
                    });
                    return this.forget(path);
                }
            } else if (this.children.size > 0) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children.has(childKey)) {
                    var safeToRemove = this.children.get(childKey).forget(path);
                    if (safeToRemove) this.children.delete(childKey);
                }
                return this.children.size === 0;
            } else return true;
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param prefixPath Path to look up node for.
     * @param func The function to invoke for each tree.
     */ SparseSnapshotTree.prototype.forEachTree = function(prefixPath, func) {
        if (this.value !== null) func(prefixPath, this.value);
        else this.forEachChild(function(key, tree) {
            var path = new $6800df1b0932d2db$var$Path(prefixPath.toString() + '/' + key);
            tree.forEachTree(path, func);
        });
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param func The function to invoke for each child.
     */ SparseSnapshotTree.prototype.forEachChild = function(func) {
        this.children.forEach(function(tree, key) {
            func(key, tree);
        });
    };
    return SparseSnapshotTree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $6800df1b0932d2db$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($6800df1b0932d2db$var$OperationType || ($6800df1b0932d2db$var$OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */ var $6800df1b0932d2db$var$OperationSource = /** @class */ function() {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        $epfVL.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */ OperationSource.User = new OperationSource(/*fromUser=*/ true, false, null, /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */ OperationSource.Server = new OperationSource(false, /*fromServer=*/ true, null, /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */ OperationSource.forServerTaggedQuery = function(queryId) {
        return new OperationSource(false, /*fromServer=*/ true, queryId, /*tagged=*/ true);
    };
    return OperationSource;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$AckUserWrite = /** @class */ function() {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */ function AckUserWrite(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $6800df1b0932d2db$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $6800df1b0932d2db$var$OperationSource.User;
    }
    /**
     * @inheritDoc
     */ AckUserWrite.prototype.operationForChild = function(childName) {
        if (!this.path.isEmpty()) {
            $epfVL.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            $epfVL.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            var childTree = this.affectedTree.subtree(new $6800df1b0932d2db$var$Path(childName));
            return new AckUserWrite($6800df1b0932d2db$var$Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */ var $6800df1b0932d2db$var$EmptyChildren = function() {
    if (!$6800df1b0932d2db$var$emptyChildrenSingleton) $6800df1b0932d2db$var$emptyChildrenSingleton = new $6800df1b0932d2db$var$SortedMap($6800df1b0932d2db$var$stringCompare);
    return $6800df1b0932d2db$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ var $6800df1b0932d2db$var$ImmutableTree = /** @class */ function() {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */ function ImmutableTree(value, children) {
        if (children === void 0) children = $6800df1b0932d2db$var$EmptyChildren();
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */ ImmutableTree.fromObject = function(obj) {
        var tree = ImmutableTree.Empty;
        $6800df1b0932d2db$var$each(obj, function(childPath, childSnap) {
            tree = tree.set(new $6800df1b0932d2db$var$Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */ ImmutableTree.prototype.isEmpty = function() {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */ ImmutableTree.prototype.findRootMostMatchingPathAndValue = function(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $6800df1b0932d2db$var$Path.Empty,
            value: this.value
        };
        else {
            if (relativePath.isEmpty()) return null;
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new $6800df1b0932d2db$var$Path(front).child(childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */ ImmutableTree.prototype.findRootMostValueAndPath = function(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function() {
            return true;
        });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */ ImmutableTree.prototype.subtree = function(relativePath) {
        if (relativePath.isEmpty()) return this;
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree(relativePath.popFront());
            else return ImmutableTree.Empty;
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */ ImmutableTree.prototype.set = function(relativePath, toSet) {
        if (relativePath.isEmpty()) return new ImmutableTree(toSet, this.children);
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */ ImmutableTree.prototype.remove = function(relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) return ImmutableTree.Empty;
            else return new ImmutableTree(null, this.children);
        } else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return ImmutableTree.Empty;
                else return new ImmutableTree(this.value, newChildren);
            } else return this;
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */ ImmutableTree.prototype.get = function(relativePath) {
        if (relativePath.isEmpty()) return this.value;
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) return child.get(relativePath.popFront());
            else return null;
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */ ImmutableTree.prototype.setTree = function(relativePath, newTree) {
        if (relativePath.isEmpty()) return newTree;
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */ ImmutableTree.prototype.fold = function(fn) {
        return this.fold_($6800df1b0932d2db$var$Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */ ImmutableTree.prototype.fold_ = function(pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function(childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */ ImmutableTree.prototype.findOnPath = function(path, f) {
        return this.findOnPath_(path, $6800df1b0932d2db$var$Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function(pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if (pathToFollow.isEmpty()) return null;
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                else return null;
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */ ImmutableTree.prototype.foreachOnPath = function(path, f) {
        return this.foreachOnPath_(path, $6800df1b0932d2db$var$Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function(pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            else return ImmutableTree.Empty;
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */ ImmutableTree.prototype.foreach = function(f) {
        this.foreach_($6800df1b0932d2db$var$Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function(currentRelativePath, f) {
        this.children.inorderTraversal(function(childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    };
    /**
     *
     * @param {function(string, !T)} f
     */ ImmutableTree.prototype.foreachChild = function(f) {
        this.children.inorderTraversal(function(childName, childTree) {
            if (childTree.value) f(childName, childTree.value);
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */ var $6800df1b0932d2db$var$ListenComplete = /** @class */ function() {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $6800df1b0932d2db$var$OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function(childName) {
        if (this.path.isEmpty()) return new ListenComplete(this.source, $6800df1b0932d2db$var$Path.Empty);
        else return new ListenComplete(this.source, this.path.popFront());
    };
    return ListenComplete;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */ var $6800df1b0932d2db$var$Overwrite = /** @class */ function() {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $6800df1b0932d2db$var$OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function(childName) {
        if (this.path.isEmpty()) return new Overwrite(this.source, $6800df1b0932d2db$var$Path.Empty, this.snap.getImmediateChild(childName));
        else return new Overwrite(this.source, this.path.popFront(), this.snap);
    };
    return Overwrite;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */ var $6800df1b0932d2db$var$Merge = /** @class */ function() {
    function Merge(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $6800df1b0932d2db$var$OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */ Merge.prototype.operationForChild = function(childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new $6800df1b0932d2db$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $6800df1b0932d2db$var$Overwrite(this.source, $6800df1b0932d2db$var$Path.Empty, childTree.value);
            else // This is a merge at a deeper level
            return new Merge(this.source, $6800df1b0932d2db$var$Path.Empty, childTree);
        } else {
            $epfVL.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */ Merge.prototype.toString = function() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    };
    return Merge;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ var $6800df1b0932d2db$var$CacheNode = /** @class */ function() {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */ function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */ CacheNode.prototype.isFullyInitialized = function() {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */ CacheNode.prototype.isFiltered = function() {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */ CacheNode.prototype.isCompleteForPath = function(path) {
        if (path.isEmpty()) return this.isFullyInitialized() && !this.filtered_;
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */ CacheNode.prototype.isCompleteForChild = function(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    };
    /**
     * @return {!Node}
     */ CacheNode.prototype.getNode = function() {
        return this.node_;
    };
    return CacheNode;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */ var $6800df1b0932d2db$var$ViewCache = /** @class */ function() {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */ function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */ ViewCache.prototype.updateEventSnap = function(eventSnap, complete, filtered) {
        return new ViewCache(new $6800df1b0932d2db$var$CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */ ViewCache.prototype.updateServerSnap = function(serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new $6800df1b0932d2db$var$CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */ ViewCache.prototype.getEventCache = function() {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */ ViewCache.prototype.getCompleteEventSnap = function() {
        return this.eventCache_.isFullyInitialized() ? this.eventCache_.getNode() : null;
    };
    /**
     * @return {!CacheNode}
     */ ViewCache.prototype.getServerCache = function() {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */ ViewCache.prototype.getCompleteServerSnap = function() {
        return this.serverCache_.isFullyInitialized() ? this.serverCache_.getNode() : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */ ViewCache.Empty = new ViewCache(new $6800df1b0932d2db$var$CacheNode($6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE, /*fullyInitialized=*/ false, /*filtered=*/ false), new $6800df1b0932d2db$var$CacheNode($6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE, /*fullyInitialized=*/ false, /*filtered=*/ false));
    return ViewCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */ var $6800df1b0932d2db$var$Change = /** @class */ function() {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.valueChange = function(snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.childAddedChange = function(childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.childRemovedChange = function(childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */ Change.childChangedChange = function(childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */ Change.childMovedChange = function(childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */ Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */ Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */ Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */ Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */ Change.VALUE = 'value';
    return Change;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */ var $6800df1b0932d2db$var$IndexedFilter = /** @class */ function() {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        $epfVL.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childRemovedChange(key, oldChild));
                else $epfVL.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childAddedChange(key, newChild));
            else optChangeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childChangedChange(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(key, childNode) {
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childRemovedChange(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(key, childNode) {
                if (oldSnap.hasChild(key)) {
                    var oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childChangedChange(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childAddedChange(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.filtersNodes = function() {
        return false;
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.getIndexedFilter = function() {
        return this;
    };
    /**
     * @inheritDoc
     */ IndexedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    return IndexedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$ChildChangeAccumulator = /** @class */ function() {
    function ChildChangeAccumulator() {
        this.changeMap = new Map();
    }
    ChildChangeAccumulator.prototype.trackChildChange = function(change) {
        var type = change.type;
        var childKey = change.childName;
        $epfVL.assert(type === $6800df1b0932d2db$var$Change.CHILD_ADDED || type === $6800df1b0932d2db$var$Change.CHILD_CHANGED || type === $6800df1b0932d2db$var$Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        $epfVL.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type === $6800df1b0932d2db$var$Change.CHILD_ADDED && oldType === $6800df1b0932d2db$var$Change.CHILD_REMOVED) this.changeMap.set(childKey, $6800df1b0932d2db$var$Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === $6800df1b0932d2db$var$Change.CHILD_REMOVED && oldType === $6800df1b0932d2db$var$Change.CHILD_ADDED) this.changeMap.delete(childKey);
            else if (type === $6800df1b0932d2db$var$Change.CHILD_REMOVED && oldType === $6800df1b0932d2db$var$Change.CHILD_CHANGED) this.changeMap.set(childKey, $6800df1b0932d2db$var$Change.childRemovedChange(childKey, oldChange.oldSnap));
            else if (type === $6800df1b0932d2db$var$Change.CHILD_CHANGED && oldType === $6800df1b0932d2db$var$Change.CHILD_ADDED) this.changeMap.set(childKey, $6800df1b0932d2db$var$Change.childAddedChange(childKey, change.snapshotNode));
            else if (type === $6800df1b0932d2db$var$Change.CHILD_CHANGED && oldType === $6800df1b0932d2db$var$Change.CHILD_CHANGED) this.changeMap.set(childKey, $6800df1b0932d2db$var$Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw $epfVL.assertionError('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    };
    ChildChangeAccumulator.prototype.getChanges = function() {
        return Array.from(this.changeMap.values());
    };
    return ChildChangeAccumulator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */ // eslint-disable-next-line @typescript-eslint/class-name-casing
var $6800df1b0932d2db$var$NoCompleteChildSource_ = /** @class */ function() {
    function NoCompleteChildSource_() {}
    /**
     * @inheritDoc
     */ NoCompleteChildSource_.prototype.getCompleteChild = function(childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */ NoCompleteChildSource_.prototype.getChildAfterChild = function(index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}();
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */ var $6800df1b0932d2db$var$NO_COMPLETE_CHILD_SOURCE = new $6800df1b0932d2db$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */ var $6800df1b0932d2db$var$WriteTreeCompleteChildSource = /** @class */ function() {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */ function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) optCompleteServerCache_ = null;
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */ WriteTreeCompleteChildSource.prototype.getCompleteChild = function(childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            var serverNode = this.optCompleteServerCache_ != null ? new $6800df1b0932d2db$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */ WriteTreeCompleteChildSource.prototype.getChildAfterChild = function(index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    };
    return WriteTreeCompleteChildSource;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @constructor
 * @struct
 */ var $6800df1b0932d2db$var$ProcessorResult = /** @class */ function() {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */ function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}();
/**
 * @constructor
 */ var $6800df1b0932d2db$var$ViewProcessor = /** @class */ function() {
    /**
     * @param {!NodeFilter} filter_
     */ function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */ ViewProcessor.prototype.assertIndexed = function(viewCache) {
        $epfVL.assert(viewCache.getEventCache().getNode().isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        $epfVL.assert(viewCache.getServerCache().getNode().isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */ ViewProcessor.prototype.applyOperation = function(oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new $6800df1b0932d2db$var$ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === $6800df1b0932d2db$var$OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            else {
                $epfVL.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode = overwrite.source.tagged || oldViewCache.getServerCache().isFiltered() && !overwrite.path.isEmpty();
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        } else if (operation.type === $6800df1b0932d2db$var$OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            else {
                $epfVL.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode = merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        } else if (operation.type === $6800df1b0932d2db$var$OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            else newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
        } else if (operation.type === $6800df1b0932d2db$var$OperationType.LISTEN_COMPLETE) newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        else throw $epfVL.assertionError('Unknown operation type: ' + operation.type);
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new $6800df1b0932d2db$var$ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */ ViewProcessor.maybeAddValueEvent_ = function(oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 || !oldViewCache.getEventCache().isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(/** @type {!Node} */ oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($6800df1b0932d2db$var$Change.valueChange(/** @type {!Node} */ newViewCache.getCompleteEventSnap()));
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function(viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) // we have a shadowing write, ignore changes
        return viewCache;
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                $epfVL.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof $6800df1b0932d2db$var$ChildrenNode ? serverCache : $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                } else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            } else {
                var childKey = changePath.getFront();
                if (childKey === '.priority') {
                    $epfVL.assert(changePath.getLength() === 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    else // priority didn't change, keep old node
                    newEventCache = oldEventSnap.getNode();
                } else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                        else // Nothing changed, just keep the old child
                        newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                    } else newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    if (newEventChild != null) newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    else // no complete child available or no change
                    newEventCache = oldEventSnap.getNode();
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyServerOverwrite_ = function(oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode ? this.filter_ : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        } else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) && changePath.getLength() > 1) // We don't update incomplete nodes with updates intended for other listeners
            return oldViewCache;
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $6800df1b0932d2db$var$NO_COMPLETE_CHILD_SOURCE, null);
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new $6800df1b0932d2db$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyUserOverwrite_ = function(oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new $6800df1b0932d2db$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        } else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            } else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) // Child overwrite, we can replace the child
                newChild = changedSnap;
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' && childNode.getChild(childChangePath.parent()).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                        // server will send down the priority in the update, so ignore for now
                        newChild = childNode;
                        else newChild = childNode.updateChild(childChangePath, changedSnap);
                    } else // There is no complete child node available
                    newChild = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                } else newViewCache = oldViewCache;
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */ ViewProcessor.cacheHasChild_ = function(viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyUserMerge_ = function(viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function(relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
        });
        changedChildren.foreach(function(relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */ ViewProcessor.prototype.applyMerge_ = function(node, merge) {
        merge.foreach(function(relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.applyServerMerge_ = function(viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache.getServerCache().getNode().isEmpty() && !viewCache.getServerCache().isFullyInitialized()) return viewCache;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) viewMergeTree = changedChildren;
        else viewMergeTree = $6800df1b0932d2db$var$ImmutableTree.Empty.setTree(path, changedChildren);
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function(childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new $6800df1b0932d2db$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function(childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) && childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new $6800df1b0932d2db$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.ackUserWrite_ = function(viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) return viewCache;
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if (ackPath.isEmpty() && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = $6800df1b0932d2db$var$ImmutableTree.Empty;
                serverCache.getNode().forEachChild($6800df1b0932d2db$var$KEY_INDEX, function(name, node) {
                    changedChildren_1 = changedChildren_1.set(new $6800df1b0932d2db$var$Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            } else return viewCache;
        } else {
            // This is a merge.
            var changedChildren_2 = $6800df1b0932d2db$var$ImmutableTree.Empty;
            affectedTree.foreach(function(mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.listenComplete_ = function(viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, $6800df1b0932d2db$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */ ViewProcessor.prototype.revertUserWrite_ = function(viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) return viewCache;
        else {
            var source = new $6800df1b0932d2db$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    $epfVL.assert(serverChildren instanceof $6800df1b0932d2db$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            } else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null && viewCache.getServerCache().isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
                if (newChild != null) newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                else if (viewCache.getEventCache().getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
                newEventCache = this.filter_.updateChild(oldEventCache, childKey, $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                else newEventCache = oldEventCache;
                if (newEventCache.isEmpty() && viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                }
            }
            complete = viewCache.getServerCache().isFullyInitialized() || writesCache.shadowingWrite($6800df1b0932d2db$var$Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$EventGenerator = /** @class */ function() {
    /**
     *
     * @param {!Query} query_
     */ function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */ this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */ EventGenerator.prototype.generateEventsForChanges = function(changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function(change) {
            if (change.type === $6800df1b0932d2db$var$Change.CHILD_CHANGED && _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($6800df1b0932d2db$var$Change.childMovedChange(change.childName, change.snapshotNode));
        });
        this.generateEventsForType_(events, $6800df1b0932d2db$var$Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $6800df1b0932d2db$var$Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $6800df1b0932d2db$var$Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $6800df1b0932d2db$var$Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, $6800df1b0932d2db$var$Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */ EventGenerator.prototype.generateEventsForType_ = function(events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function(change) {
            return change.type === eventType;
        });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function(change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function(registration) {
                if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, _this.query_));
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */ EventGenerator.prototype.materializeSingleChange_ = function(change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') return change;
        else {
            change.prevName = eventCache.getPredecessorChildName(/** @type {!string} */ change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */ EventGenerator.prototype.compareChanges_ = function(a, b) {
        if (a.childName == null || b.childName == null) throw $epfVL.assertionError('Should only compare child_ events.');
        var aWrapped = new $6800df1b0932d2db$var$NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new $6800df1b0932d2db$var$NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */ var $6800df1b0932d2db$var$View = /** @class */ function() {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */ function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new $6800df1b0932d2db$var$IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */ this.processor_ = new $6800df1b0932d2db$var$ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode($6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode($6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new $6800df1b0932d2db$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new $6800df1b0932d2db$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */ this.viewCache_ = new $6800df1b0932d2db$var$ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */ this.eventGenerator_ = new $6800df1b0932d2db$var$EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */ View.prototype.getQuery = function() {
        return this.query_;
    };
    /**
     * @return {?Node}
     */ View.prototype.getServerCache = function() {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */ View.prototype.getCompleteServerCache = function(path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() || !path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty()) return cache.getChild(path);
        }
        return null;
    };
    /**
     * @return {boolean}
     */ View.prototype.isEmpty = function() {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */ View.prototype.addEventRegistration = function(eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */ View.prototype.removeEventRegistration = function(eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            $epfVL.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function(registration) {
                cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) cancelEvents.push(maybeEvent);
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for(var i = 0; i < this.eventRegistrations_.length; ++i){
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) remaining.push(existing);
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        } else this.eventRegistrations_ = [];
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */ View.prototype.applyOperation = function(operation, writesCache, completeServerCache) {
        if (operation.type === $6800df1b0932d2db$var$OperationType.MERGE && operation.source.queryId !== null) {
            $epfVL.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            $epfVL.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        $epfVL.assert(result.viewCache.getServerCache().isFullyInitialized() || !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */ View.prototype.getInitialEvents = function(registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(key, childNode) {
                initialChanges.push($6800df1b0932d2db$var$Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) initialChanges.push($6800df1b0932d2db$var$Change.valueChange(eventSnap.getNode()));
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */ View.prototype.generateEventsForChanges_ = function(changes, eventCache, eventRegistration) {
        var registrations = eventRegistration ? [
            eventRegistration
        ] : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$__referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ var $6800df1b0932d2db$var$SyncPoint = /** @class */ function() {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function() {
            $epfVL.assert($6800df1b0932d2db$var$__referenceConstructor$1, 'Reference.ts has not been loaded');
            return $6800df1b0932d2db$var$__referenceConstructor$1;
        },
        set: function(val) {
            $epfVL.assert(!$6800df1b0932d2db$var$__referenceConstructor$1, '__referenceConstructor has already been defined');
            $6800df1b0932d2db$var$__referenceConstructor$1 = val;
        },
        enumerable: true,
        configurable: true
    });
    SyncPoint.prototype.isEmpty = function() {
        return this.views.size === 0;
    };
    SyncPoint.prototype.applyOperation = function(operation, writesCache, optCompleteServerCache) {
        var e_1, _a;
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = this.views.get(queryId);
            $epfVL.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        } else {
            var events = [];
            try {
                for(var _b = $66Jdw.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var view = _c.value;
                    events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return events;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */ SyncPoint.prototype.addEventRegistration = function(query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = this.views.get(queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) eventCacheComplete = true;
            else if (serverCache instanceof $6800df1b0932d2db$var$ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            } else {
                eventCache = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new $6800df1b0932d2db$var$ViewCache(new $6800df1b0932d2db$var$CacheNode(/** @type {!Node} */ eventCache, eventCacheComplete, false), new $6800df1b0932d2db$var$CacheNode(/** @type {!Node} */ serverCache, serverCacheComplete, false));
            view = new $6800df1b0932d2db$var$View(query, viewCache);
            this.views.set(queryId, view);
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */ SyncPoint.prototype.removeEventRegistration = function(query, eventRegistration, cancelError) {
        var e_2, _a;
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') try {
            // When you do ref.off(...), we search all views for the registration to remove.
            for(var _b = $66Jdw.__values(this.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $66Jdw.__read(_c.value, 2), viewQueryId = _d[0], view = _d[1];
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    this.views.delete(viewQueryId);
                    // We'll deal with complete views later.
                    if (!view.getQuery().getQueryParams().loadsAllData()) removed.push(view.getQuery());
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        else {
            // remove the callback from the specific view.
            var view = this.views.get(queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    this.views.delete(queryId);
                    // We'll deal with complete views later.
                    if (!view.getQuery().getQueryParams().loadsAllData()) removed.push(view.getQuery());
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) // We removed our last complete view.
        removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        return {
            removed: removed,
            events: cancelEvents
        };
    };
    SyncPoint.prototype.getQueryViews = function() {
        var e_3, _a;
        var result = [];
        try {
            for(var _b = $66Jdw.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var view = _c.value;
                if (!view.getQuery().getQueryParams().loadsAllData()) result.push(view);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
    /**
     * @param path The path to the desired complete snapshot
     * @return A complete cache, if it exists
     */ SyncPoint.prototype.getCompleteServerCache = function(path) {
        var e_4, _a;
        var serverCache = null;
        try {
            for(var _b = $66Jdw.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var view = _c.value;
                serverCache = serverCache || view.getCompleteServerCache(path);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return serverCache;
    };
    SyncPoint.prototype.viewForQuery = function(query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) return this.getCompleteView();
        else {
            var queryId = query.queryIdentifier();
            return this.views.get(queryId);
        }
    };
    SyncPoint.prototype.viewExistsForQuery = function(query) {
        return this.viewForQuery(query) != null;
    };
    SyncPoint.prototype.hasCompleteView = function() {
        return this.getCompleteView() != null;
    };
    SyncPoint.prototype.getCompleteView = function() {
        var e_5, _a;
        try {
            for(var _b = $66Jdw.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var view = _c.value;
                if (view.getQuery().getQueryParams().loadsAllData()) return view;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        return null;
    };
    return SyncPoint;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ var $6800df1b0932d2db$var$CompoundWrite = /** @class */ function() {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    CompoundWrite.prototype.addWrite = function(path, node) {
        if (path.isEmpty()) return new CompoundWrite(new $6800df1b0932d2db$var$ImmutableTree(node));
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = $6800df1b0932d2db$var$Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            } else {
                var subtree = new $6800df1b0932d2db$var$ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    CompoundWrite.prototype.addWrites = function(path, updates) {
        var newWrite = this;
        $6800df1b0932d2db$var$each(updates, function(childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */ CompoundWrite.prototype.removeWrite = function(path) {
        if (path.isEmpty()) return CompoundWrite.Empty;
        else {
            var newWriteTree = this.writeTree_.setTree(path, $6800df1b0932d2db$var$ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param path The path to check for
     * @return Whether there is a complete write at that path
     */ CompoundWrite.prototype.hasCompleteWrite = function(path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param path The path to get a complete write
     * @return The node if complete at that path, or null otherwise.
     */ CompoundWrite.prototype.getCompleteNode = function(path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) return this.writeTree_.get(rootmost.path).getChild($6800df1b0932d2db$var$Path.relativePath(rootmost.path, path));
        else return null;
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return A list of all complete children.
     */ CompoundWrite.prototype.getCompleteChildren = function() {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) // If it's a leaf node, it has no children; so nothing to do.
        {
            if (!node.isLeafNode()) node.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(childName, childNode) {
                children.push(new $6800df1b0932d2db$var$NamedNode(childName, childNode));
            });
        } else this.writeTree_.children.inorderTraversal(function(childName, childTree) {
            if (childTree.value != null) children.push(new $6800df1b0932d2db$var$NamedNode(childName, childTree.value));
        });
        return children;
    };
    CompoundWrite.prototype.childCompoundWrite = function(path) {
        if (path.isEmpty()) return this;
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) return new CompoundWrite(new $6800df1b0932d2db$var$ImmutableTree(shadowingNode));
            else return new CompoundWrite(this.writeTree_.subtree(path));
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return Whether this CompoundWrite is empty
     */ CompoundWrite.prototype.isEmpty = function() {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param node The node to apply this CompoundWrite to
     * @return The node with all writes applied
     */ CompoundWrite.prototype.apply = function(node) {
        return $6800df1b0932d2db$var$applySubtreeWrite($6800df1b0932d2db$var$Path.Empty, this.writeTree_, node);
    };
    CompoundWrite.Empty = new CompoundWrite(new $6800df1b0932d2db$var$ImmutableTree(null));
    return CompoundWrite;
}();
function $6800df1b0932d2db$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        var priorityWrite_1 = null;
        writeTree.children.inorderTraversal(function(childKey, childTree) {
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                $epfVL.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite_1 = childTree.value;
            } else node = $6800df1b0932d2db$var$applySubtreeWrite(relativePath.child(childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */ var $6800df1b0932d2db$var$WriteTree = /** @class */ function() {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */ this.visibleWrites_ = $6800df1b0932d2db$var$CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */ this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */ WriteTree.prototype.childWrites = function(path) {
        return new $6800df1b0932d2db$var$WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */ WriteTree.prototype.addOverwrite = function(path, snap, writeId, visible) {
        $epfVL.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) visible = true;
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */ WriteTree.prototype.addMerge = function(path, changedChildren, writeId) {
        $epfVL.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */ WriteTree.prototype.getWrite = function(writeId) {
        for(var i = 0; i < this.allWrites_.length; i++){
            var record = this.allWrites_[i];
            if (record.writeId === writeId) return record;
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */ WriteTree.prototype.removeWrite = function(writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function(s) {
            return s.writeId === writeId;
        });
        $epfVL.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while(removedWriteWasVisible && i >= 0){
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx && this.recordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
                removedWriteWasVisible = false;
                else if (writeToRemove.path.contains(currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
                removedWriteOverlapsWithOtherWrites = true;
            }
            i--;
        }
        if (!removedWriteWasVisible) return false;
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        } else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            else {
                var children = writeToRemove.children;
                $6800df1b0932d2db$var$each(children, function(childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */ WriteTree.prototype.getCompleteWriteData = function(path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */ WriteTree.prototype.calcCompleteEventCache = function(treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) return shadowingNode;
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) return completeServerCache;
                else if (completeServerCache == null && !subMerge.hasCompleteWrite($6800df1b0932d2db$var$Path.Empty)) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                return null;
                else {
                    var layeredCache = completeServerCache || $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        } else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) return completeServerCache;
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites && completeServerCache == null && !merge.hasCompleteWrite($6800df1b0932d2db$var$Path.Empty)) return null;
                else {
                    var filter = function(write) {
                        return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && (write.path.contains(treePath) || treePath.contains(write.path));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */ WriteTree.prototype.calcCompleteEventChildren = function(treePath, completeServerChildren) {
        var completeChildren = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
            topLevelSet.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(childName, childSnap) {
                completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
            });
            return completeChildren;
        } else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(childName, childNode) {
                var node = merge_1.childCompoundWrite(new $6800df1b0932d2db$var$Path(childName)).apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function(namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        } else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function(namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */ WriteTree.prototype.calcEventCacheAfterServerOverwrite = function(treePath, childPath, existingEventSnap, existingServerSnap) {
        $epfVL.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) // At this point we can probably guarantee that we're in case 2, meaning no events
        // May need to check visibility while doing the findRootMostValueAndPath call
        return null;
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) // We're not shadowing at all. Case 1
            return existingServerSnap.getChild(childPath);
            else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
            // However this is tricky to find out, since user updates don't necessary change the server
            // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
            // adds nodes, but doesn't change any existing writes. It is therefore not enough to
            // only check if the updates change the serverNode.
            // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
            return childMerge.apply(existingServerSnap.getChild(childPath));
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */ WriteTree.prototype.calcCompleteChild = function(treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) return shadowingNode;
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            } else return null;
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     */ WriteTree.prototype.shadowingWrite = function(path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     */ WriteTree.prototype.calcIndexedSlice = function(treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode($6800df1b0932d2db$var$Path.Empty);
        if (shadowingNode != null) toIterate = shadowingNode;
        else if (completeServerData != null) toIterate = merge.apply(completeServerData);
        else // no children to iterate on
        return [];
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while(next && nodes.length < count){
                if (cmp(next, startPost) !== 0) nodes.push(next);
                next = iter.getNext();
            }
            return nodes;
        } else return [];
    };
    WriteTree.prototype.recordContainsPath_ = function(writeRecord, path) {
        if (writeRecord.snap) return writeRecord.path.contains(path);
        else {
            for(var childName in writeRecord.children){
                if (writeRecord.children.hasOwnProperty(childName) && writeRecord.path.child(childName).contains(path)) return true;
            }
            return false;
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     */ WriteTree.prototype.resetTree_ = function() {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, $6800df1b0932d2db$var$Path.Empty);
        if (this.allWrites_.length > 0) this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        else this.lastWriteId_ = -1;
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     */ WriteTree.DefaultFilter_ = function(write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     */ WriteTree.layerTree_ = function(writes, filter, treeRoot) {
        var compoundWrite = $6800df1b0932d2db$var$CompoundWrite.Empty;
        for(var i = 0; i < writes.length; ++i){
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = $6800df1b0932d2db$var$Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    } else if (writePath.contains(treeRoot)) {
                        relativePath = $6800df1b0932d2db$var$Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite($6800df1b0932d2db$var$Path.Empty, write.snap.getChild(relativePath));
                    }
                } else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = $6800df1b0932d2db$var$Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    } else if (writePath.contains(treeRoot)) {
                        relativePath = $6800df1b0932d2db$var$Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) compoundWrite = compoundWrite.addWrites($6800df1b0932d2db$var$Path.Empty, write.children);
                        else {
                            var child = $epfVL.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite($6800df1b0932d2db$var$Path.Empty, deepNode);
                            }
                        }
                    }
                } else throw $epfVL.assertionError('WriteRecord should have .snap or .children');
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}();
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$WriteTreeRef = /** @class */ function() {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */ function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */ WriteTreeRef.prototype.calcCompleteEventCache = function(completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */ WriteTreeRef.prototype.calcCompleteEventChildren = function(completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */ WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function(path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */ WriteTreeRef.prototype.shadowingWrite = function(path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */ WriteTreeRef.prototype.calcIndexedSlice = function(completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */ WriteTreeRef.prototype.calcCompleteChild = function(childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */ WriteTreeRef.prototype.child = function(childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$SyncTree = /** @class */ function() {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */ function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = $6800df1b0932d2db$var$ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = new $6800df1b0932d2db$var$WriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyUserOverwrite = function(path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) return [];
        else return this.applyOperationToSyncPoints_(new $6800df1b0932d2db$var$Overwrite($6800df1b0932d2db$var$OperationSource.User, path, newData));
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyUserMerge = function(path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = $6800df1b0932d2db$var$ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new $6800df1b0932d2db$var$Merge($6800df1b0932d2db$var$OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param revert True if the given write failed and needs to be reverted
     * @return Events to raise.
     */ SyncTree.prototype.ackUserWrite = function(writeId, revert) {
        if (revert === void 0) revert = false;
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) return [];
        else {
            var affectedTree_1 = $6800df1b0932d2db$var$ImmutableTree.Empty;
            if (write.snap != null) // overwrite
            affectedTree_1 = affectedTree_1.set($6800df1b0932d2db$var$Path.Empty, true);
            else $6800df1b0932d2db$var$each(write.children, function(pathString, node) {
                affectedTree_1 = affectedTree_1.set(new $6800df1b0932d2db$var$Path(pathString), node);
            });
            return this.applyOperationToSyncPoints_(new $6800df1b0932d2db$var$AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyServerOverwrite = function(path, newData) {
        return this.applyOperationToSyncPoints_(new $6800df1b0932d2db$var$Overwrite($6800df1b0932d2db$var$OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyServerMerge = function(path, changedChildren) {
        var changeTree = $6800df1b0932d2db$var$ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new $6800df1b0932d2db$var$Merge($6800df1b0932d2db$var$OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyListenComplete = function(path) {
        return this.applyOperationToSyncPoints_(new $6800df1b0932d2db$var$ListenComplete($6800df1b0932d2db$var$OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyTaggedQueryOverwrite = function(path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = $6800df1b0932d2db$var$Path.relativePath(queryPath, path);
            var op = new $6800df1b0932d2db$var$Overwrite($6800df1b0932d2db$var$OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        } else // Query must have been removed already
        return [];
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyTaggedQueryMerge = function(path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = $6800df1b0932d2db$var$Path.relativePath(queryPath, path);
            var changeTree = $6800df1b0932d2db$var$ImmutableTree.fromObject(changedChildren);
            var op = new $6800df1b0932d2db$var$Merge($6800df1b0932d2db$var$OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        } else // We've already removed the query. No big deal, ignore the update
        return [];
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @return Events to raise.
     */ SyncTree.prototype.applyTaggedListenComplete = function(path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = $6800df1b0932d2db$var$Path.relativePath(queryPath, path);
            var op = new $6800df1b0932d2db$var$ListenComplete($6800df1b0932d2db$var$OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        } else // We've already removed the query. No big deal, ignore the update
        return [];
    };
    /**
     * Add an event callback for the specified query.
     *
     * @return Events to raise.
     */ SyncTree.prototype.addEventRegistration = function(query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function(pathToSyncPoint, sp) {
            var relativePath = $6800df1b0932d2db$var$Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView = foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new $6800df1b0932d2db$var$SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        } else {
            foundAncestorDefaultView = foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache($6800df1b0932d2db$var$Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) serverCacheComplete = true;
        else {
            serverCacheComplete = false;
            serverCache = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function(childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache($6800df1b0932d2db$var$Path.Empty);
                if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            $epfVL.assert(!this.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap.set(queryKey, tag);
            this.tagToQueryMap.set(tag, queryKey);
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */  = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param eventRegistration If null, all callbacks are removed.
     * @param cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return Cancel events, if cancelError was provided.
     */ SyncTree.prototype.removeEventRegistration = function(query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint && (query.queryIdentifier() === 'default' || maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */ var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) this.syncPointTree_ = this.syncPointTree_.remove(path);
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !== removed.findIndex(function(query) {
                return query.getQueryParams().loadsAllData();
            });
            var covered = this.syncPointTree_.findOnPath(path, function(relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(var i = 0; i < newViews.length; ++i){
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                } else removed.forEach(function(queryToRemove) {
                    var tagToRemove = _this.queryToTagMap.get(SyncTree.makeQueryKey_(queryToRemove));
                    _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                });
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
     * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
     * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
     *     <incremented total> as the write is applied locally and then acknowledged at the server.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     *
     * @param path The path to the data we want
     * @param writeIdsToExclude A specific set to be excluded
     */ SyncTree.prototype.calcCompleteEventCache = function(path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function(pathSoFar, syncPoint) {
            var relativePath = $6800df1b0932d2db$var$Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) return serverCache;
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     */ SyncTree.prototype.collectDistinctViewsForSubTree_ = function(subtree) {
        return subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [
                    completeView
                ];
            } else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) views_1 = maybeChildSyncPoint.getQueryViews();
                $6800df1b0932d2db$var$each(childMap, function(_key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    SyncTree.prototype.removeTags_ = function(queries) {
        for(var j = 0; j < queries.length; ++j){
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
                this.queryToTagMap.delete(removedQueryKey);
                this.tagToQueryMap.delete(removedQueryTag);
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     *
     * @return The normalized query
     */ SyncTree.queryForListening_ = function(query) {
        if (query.getQueryParams().loadsAllData() && !query.getQueryParams().isDefault()) // We treat queries that load all data as default queries
        // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
        // from Query
        return query.getRef();
        else return query;
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @return This method can return events to support synchronous data sources
     */ SyncTree.prototype.setupListener_ = function(query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) $epfVL.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() && maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) return [
                    maybeChildSyncPoint.getCompleteView().getQuery()
                ];
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function(view) {
                        return view.getQuery();
                    }));
                    $6800df1b0932d2db$var$each(childMap, function(_key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for(var i = 0; i < queriesToStop.length; ++i){
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    SyncTree.prototype.createListenerForView_ = function(view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function() {
                var cache = view.getServerCache() || $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function(status) {
                if (status === 'ok') {
                    if (tag) return _this.applyTaggedListenComplete(query.path, tag);
                    else return _this.applyListenComplete(query.path);
                } else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = $6800df1b0932d2db$var$errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, /*eventRegistration*/ null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     */ SyncTree.makeQueryKey_ = function(query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     */ SyncTree.parseQueryKey_ = function(queryKey) {
        var splitIndex = queryKey.indexOf('$');
        $epfVL.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new $6800df1b0932d2db$var$Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     */ SyncTree.prototype.queryKeyForTag_ = function(tag) {
        return this.tagToQueryMap.get(tag);
    };
    /**
     * Return the tag associated with the given query.
     */ SyncTree.prototype.tagForQuery_ = function(query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return this.queryToTagMap.get(queryKey);
    };
    /**
     * Static accessor for query tags.
     */ SyncTree.getNextQueryTag_ = function() {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     */ SyncTree.prototype.applyTaggedOperation_ = function(queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        $epfVL.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
     *
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
     *
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     */ SyncTree.prototype.applyOperationToSyncPoints_ = function(operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, /*serverCache=*/ null, this.pendingWriteTree_.childWrites($6800df1b0932d2db$var$Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */ SyncTree.prototype.applyOperationHelper_ = function(operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        else {
            var syncPoint = syncPointTree.get($6800df1b0932d2db$var$Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) serverCache = syncPoint.getCompleteServerCache($6800df1b0932d2db$var$Path.Empty);
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */ SyncTree.prototype.applyOperationDescendantsHelper_ = function(operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get($6800df1b0932d2db$var$Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = syncPoint.getCompleteServerCache($6800df1b0932d2db$var$Path.Empty);
        var events = [];
        syncPointTree.children.inorderTraversal(function(childName, childTree) {
            var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
        });
        if (syncPoint) events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        return events;
    };
    /**
     * Static tracker for next query tag.
     */ SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$SnapshotHolder = /** @class */ function() {
    function SnapshotHolder() {
        this.rootNode_ = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function(path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ var $6800df1b0932d2db$var$AuthTokenProvider = /** @class */ function() {
    function AuthTokenProvider(app_, authProvider_) {
        var _this = this;
        this.app_ = app_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.get().then(function(auth) {
            return _this.auth_ = auth;
        });
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */ AuthTokenProvider.prototype.getToken = function(forceRefresh) {
        if (!this.auth_) return Promise.resolve(null);
        return this.auth_.getToken(forceRefresh).catch(function(error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $6800df1b0932d2db$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else {
            setTimeout(function() {
                return listener(null);
            }, 0);
            this.authProvider_.get().then(function(auth) {
                return auth.addAuthTokenListener(listener);
            });
        }
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function(listener) {
        this.authProvider_.get().then(function(auth) {
            return auth.removeAuthTokenListener(listener);
        });
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function() {
        var errorMessage = 'Provided authentication credentials for the app named "' + this.app_.name + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.app_.options) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.app_.options) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $6800df1b0932d2db$var$warn(errorMessage);
    };
    return AuthTokenProvider;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$StatsCollection = /** @class */ function() {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function(name, amount) {
        if (amount === void 0) amount = 1;
        if (!$epfVL.contains(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function() {
        return $epfVL.deepCopy(this.counters_);
    };
    return StatsCollection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$StatsManager = /** @class */ function() {
    function StatsManager() {}
    StatsManager.getCollection = function(repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) this.collections_[hashString] = new $6800df1b0932d2db$var$StatsCollection();
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function(repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) this.reporters_[hashString] = creatorFunction();
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */ var $6800df1b0932d2db$var$StatsListener = /** @class */ function() {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function() {
        var newStats = this.collection_.get();
        var delta = $66Jdw.__assign({}, newStats);
        if (this.last_) $6800df1b0932d2db$var$each(this.last_, function(stat, value) {
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var $6800df1b0932d2db$var$FIRST_STATS_MIN_TIME = 10000;
var $6800df1b0932d2db$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
var $6800df1b0932d2db$var$REPORT_STATS_INTERVAL = 300000;
/**
 * @constructor
 */ var $6800df1b0932d2db$var$StatsReporter = /** @class */ function() {
    /**
     * @param collection
     * @param server_
     */ function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $6800df1b0932d2db$var$StatsListener(collection);
        var timeout = $6800df1b0932d2db$var$FIRST_STATS_MIN_TIME + ($6800df1b0932d2db$var$FIRST_STATS_MAX_TIME - $6800df1b0932d2db$var$FIRST_STATS_MIN_TIME) * Math.random();
        $6800df1b0932d2db$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function(stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function() {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        $6800df1b0932d2db$var$each(stats, function(stat, value) {
            if (value > 0 && $epfVL.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $6800df1b0932d2db$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $6800df1b0932d2db$var$REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$EventQueue = /** @class */ function() {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */ this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */ this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */ EventQueue.prototype.queueEvents = function(eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for(var i = 0; i < eventDataList.length; i++){
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) currList = new $6800df1b0932d2db$var$EventList(eventPath);
            currList.add(eventData);
        }
        if (currList) this.eventLists_.push(currList);
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */ EventQueue.prototype.raiseEventsAtPath = function(path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function(eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */ EventQueue.prototype.raiseEventsForChangedPath = function(changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function(eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */ EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function(predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for(var i = 0; i < this.eventLists_.length; i++){
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                } else sentAll = false;
            }
        }
        if (sentAll) this.eventLists_ = [];
        this.recursionDepth_--;
    };
    return EventQueue;
}();
/**
 * @param {!Path} path
 * @constructor
 */ var $6800df1b0932d2db$var$EventList = /** @class */ function() {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */ this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */ EventList.prototype.add = function(eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */ EventList.prototype.raise = function() {
        for(var i = 0; i < this.events_.length; i++){
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if ($6800df1b0932d2db$var$logger) $6800df1b0932d2db$var$log('event: ' + eventData.toString());
                $6800df1b0932d2db$var$exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */ EventList.prototype.getPath = function() {
        return this.path_;
    };
    return EventList;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ var $6800df1b0932d2db$var$EventEmitter = /** @class */ function() {
    /**
     * @param {!Array.<string>} allowedEvents_
     */ function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        $epfVL.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} varArgs
     */ EventEmitter.prototype.trigger = function(eventType) {
        var varArgs = [];
        for(var _i = 1; _i < arguments.length; _i++)varArgs[_i - 1] = arguments[_i];
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = $66Jdw.__spread(this.listeners_[eventType]);
            for(var i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    };
    EventEmitter.prototype.on = function(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    };
    EventEmitter.prototype.off = function(eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for(var i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    };
    EventEmitter.prototype.validateEventType_ = function(eventType) {
        $epfVL.assert(this.allowedEvents_.find(function(et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @extends {EventEmitter}
 */ var $6800df1b0932d2db$var$VisibilityMonitor = /** @class */ function(_super) {
    $66Jdw.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, [
            'visible'
        ]) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, function() {
            var visible = !document[hidden];
            if (visible !== _this.visible_) {
                _this.visible_ = visible;
                _this.trigger('visible', visible);
            }
        }, false);
        return _this;
    }
    VisibilityMonitor.getInstance = function() {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */ VisibilityMonitor.prototype.getInitialEvent = function(eventType) {
        $epfVL.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    };
    return VisibilityMonitor;
}($6800df1b0932d2db$var$EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */ var $6800df1b0932d2db$var$OnlineMonitor = /** @class */ function(_super) {
    $66Jdw.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, [
            'online'
        ]) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !$epfVL.isMobileCordova()) {
            window.addEventListener('online', function() {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function() {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function() {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */ OnlineMonitor.prototype.getInitialEvent = function(eventType) {
        $epfVL.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    };
    /**
     * @return {boolean}
     */ OnlineMonitor.prototype.currentlyOnline = function() {
        return this.online_;
    };
    return OnlineMonitor;
}($6800df1b0932d2db$var$EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */ var $6800df1b0932d2db$var$PacketReceiver = /** @class */ function() {
    /**
     * @param onMessage_
     */ function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */ PacketReceiver.prototype.handleResponse = function(requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function() {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function(i) {
                if (toProcess[i]) $6800df1b0932d2db$var$exceptionGuard(function() {
                    _this.onMessage_(toProcess[i]);
                });
            };
            for(var i = 0; i < toProcess.length; ++i)_loop_2(i);
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while(this.pendingResponses[this.currentResponseNum]){
            var state_1 = _loop_1();
            if (state_1 === "break") break;
        }
    };
    return PacketReceiver;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var $6800df1b0932d2db$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var $6800df1b0932d2db$var$MAX_URL_DATA_SIZE = 1870;
var $6800df1b0932d2db$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var $6800df1b0932d2db$var$MAX_PAYLOAD_SIZE = $6800df1b0932d2db$var$MAX_URL_DATA_SIZE - $6800df1b0932d2db$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */ var $6800df1b0932d2db$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */ var $6800df1b0932d2db$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */ var $6800df1b0932d2db$var$BrowserPollConnection = /** @class */ function() {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */ function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $6800df1b0932d2db$var$logWrapper(connId);
        this.stats_ = $6800df1b0932d2db$var$StatsManager.getCollection(repoInfo);
        this.urlFn = function(params) {
            return repoInfo.connectionURL($6800df1b0932d2db$var$LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */ BrowserPollConnection.prototype.open = function(onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $6800df1b0932d2db$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function() {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($6800df1b0932d2db$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $6800df1b0932d2db$var$executeWhenDOMReady(function() {
            if (_this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new $6800df1b0932d2db$var$FirebaseIFrameScriptHolder(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a = $66Jdw.__read(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2], arg3 = _a[3], arg4 = _a[4];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder) return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command === $6800df1b0932d2db$var$FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                } else if (command === $6800df1b0932d2db$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function() {
                            _this.onClosed_();
                        });
                    } else _this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var _a = $66Jdw.__read(args, 2), pN = _a[0], data = _a[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function() {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$6800df1b0932d2db$var$VERSION_PARAM] = $6800df1b0932d2db$var$PROTOCOL_VERSION;
            if (_this.transportSessionId) urlParams[$6800df1b0932d2db$var$TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            if (_this.lastSessionId) urlParams[$6800df1b0932d2db$var$LAST_SESSION_PARAM] = _this.lastSessionId;
            if (typeof location !== 'undefined' && location.href && location.href.indexOf($6800df1b0932d2db$var$FORGE_DOMAIN) !== -1) urlParams[$6800df1b0932d2db$var$REFERER_PARAM] = $6800df1b0932d2db$var$FORGE_REF;
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function() {
            /* do nothing */ });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ BrowserPollConnection.prototype.start = function() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */ BrowserPollConnection.forceAllow = function() {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */ BrowserPollConnection.forceDisallow = function() {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function() {
        if ($epfVL.isNodeSdk()) return false;
        else if (BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$6800df1b0932d2db$var$isChromeExtensionContentScript() && !$6800df1b0932d2db$var$isWindowsStoreApp();
    };
    /**
     * No-op for polling
     */ BrowserPollConnection.prototype.markConnectionHealthy = function() {};
    /**
     * Stops polling and cleans up the iframe
     * @private
     */ BrowserPollConnection.prototype.shutdown_ = function() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */ BrowserPollConnection.prototype.onClosed_ = function() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ BrowserPollConnection.prototype.close = function() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */ BrowserPollConnection.prototype.send = function(data) {
        var dataStr = $epfVL.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = $epfVL.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = $6800df1b0932d2db$var$splitStringBySize(base64data, $6800df1b0932d2db$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(var i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */ BrowserPollConnection.prototype.addDisconnectPingFrame = function(id, pw) {
        if ($epfVL.isNodeSdk()) return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */ BrowserPollConnection.prototype.incrementIncomingBytes_ = function(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = $epfVL.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}();
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/ var $6800df1b0932d2db$var$FirebaseIFrameScriptHolder = /** @class */ function() {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!$epfVL.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $6800df1b0932d2db$var$LUIDGenerator();
            window[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $6800df1b0932d2db$var$log('frame writing exception');
                if (e.stack) $6800df1b0932d2db$var$log(e.stack);
                $6800df1b0932d2db$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */ FirebaseIFrameScriptHolder.createIFrame_ = function() {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $6800df1b0932d2db$var$log('No IE domain setting required');
            } catch (e) {
                var domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */ FirebaseIFrameScriptHolder.prototype.close = function() {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function() {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */ FirebaseIFrameScriptHolder.prototype.startLongPoll = function(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ FirebaseIFrameScriptHolder.prototype.newRequest_ = function() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$6800df1b0932d2db$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $6800df1b0932d2db$var$SEG_HEADER_SIZE + curDataString.length <= $6800df1b0932d2db$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $6800df1b0932d2db$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $6800df1b0932d2db$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $6800df1b0932d2db$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ FirebaseIFrameScriptHolder.prototype.enqueueSegment = function(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */ FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function(url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        var doNewRequest = function() {
            _this.outstandingRequests.delete(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor($6800df1b0932d2db$var$KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function() {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */ FirebaseIFrameScriptHolder.prototype.addTag = function(url, loadCB) {
        var _this = this;
        if ($epfVL.isNodeSdk()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(function() {
            try {
                // if we're already closed, don't add this poll
                if (!_this.sendNewPolls) return;
                var newScript_1 = _this.myIFrame.doc.createElement('script');
                newScript_1.type = 'text/javascript';
                newScript_1.async = true;
                newScript_1.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript_1.onload = newScript_1.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var rstate = newScript_1.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript_1.onload = newScript_1.onreadystatechange = null;
                        if (newScript_1.parentNode) newScript_1.parentNode.removeChild(newScript_1);
                        loadCB();
                    }
                };
                newScript_1.onerror = function() {
                    $6800df1b0932d2db$var$log('Long-poll script failed to load: ' + url);
                    _this.sendNewPolls = false;
                    _this.close();
                };
                _this.myIFrame.doc.body.appendChild(newScript_1);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    };
    return FirebaseIFrameScriptHolder;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ var $6800df1b0932d2db$var$SDK_VERSION = '';
// SDK_VERSION should be set before any database instance is created
function $6800df1b0932d2db$var$setSDKVersion(version) {
    $6800df1b0932d2db$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
var $6800df1b0932d2db$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var $6800df1b0932d2db$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $6800df1b0932d2db$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $6800df1b0932d2db$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */ var $6800df1b0932d2db$var$WebSocketConnection = /** @class */ function() {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */ function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $6800df1b0932d2db$var$logWrapper(this.connId);
        this.stats_ = $6800df1b0932d2db$var$StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */ WebSocketConnection.connectionURL_ = function(repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[$6800df1b0932d2db$var$VERSION_PARAM] = $6800df1b0932d2db$var$PROTOCOL_VERSION;
        if (!$epfVL.isNodeSdk() && typeof location !== 'undefined' && location.href && location.href.indexOf($6800df1b0932d2db$var$FORGE_DOMAIN) !== -1) urlParams[$6800df1b0932d2db$var$REFERER_PARAM] = $6800df1b0932d2db$var$FORGE_REF;
        if (transportSessionId) urlParams[$6800df1b0932d2db$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$6800df1b0932d2db$var$LAST_SESSION_PARAM] = lastSessionId;
        return repoInfo.connectionURL($6800df1b0932d2db$var$WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */ WebSocketConnection.prototype.open = function(onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $6800df1b0932d2db$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            if ($epfVL.isNodeSdk()) {
                var device = $epfVL.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + $6800df1b0932d2db$var$PROTOCOL_VERSION + "/" + $6800df1b0932d2db$var$SDK_VERSION + "/" + $3rPrU.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = {};
                var proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
                this.mySock = new $6800df1b0932d2db$var$WebSocketImpl(this.connURL, [], options);
            } else this.mySock = new $6800df1b0932d2db$var$WebSocketImpl(this.connURL);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function() {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function() {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function(m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function(e) {
            _this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var error = e.message || e.data;
            if (error) _this.log_(error);
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ WebSocketConnection.prototype.start = function() {};
    WebSocketConnection.forceDisallow = function() {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function() {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $6800df1b0932d2db$var$WebSocketImpl !== null && !WebSocketConnection.forceDisallow_;
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */ WebSocketConnection.previouslyFailed = function() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $6800df1b0932d2db$var$PersistentStorage.isInMemoryStorage || $6800df1b0932d2db$var$PersistentStorage.get('previous_websocket_failure') === true;
    };
    WebSocketConnection.prototype.markConnectionHealthy = function() {
        $6800df1b0932d2db$var$PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = $epfVL.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */ WebSocketConnection.prototype.handleNewFrameCount_ = function(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */ WebSocketConnection.prototype.extractFrameCount_ = function(data) {
        $epfVL.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */ WebSocketConnection.prototype.handleIncomingFrame = function(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */ WebSocketConnection.prototype.send = function(data) {
        this.resetKeepAlive();
        var dataStr = $epfVL.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = $6800df1b0932d2db$var$splitStringBySize(dataStr, $6800df1b0932d2db$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(var i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    };
    WebSocketConnection.prototype.shutdown_ = function() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ WebSocketConnection.prototype.close = function() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ WebSocketConnection.prototype.resetKeepAlive = function() {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function() {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) _this.sendString_('0');
            _this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($6800df1b0932d2db$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */ WebSocketConnection.prototype.sendString_ = function(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */ WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */ WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */ var $6800df1b0932d2db$var$TransportManager = /** @class */ function() {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */ function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */ get: function() {
            return [
                $6800df1b0932d2db$var$BrowserPollConnection,
                $6800df1b0932d2db$var$WebSocketConnection
            ];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */ TransportManager.prototype.initTransports_ = function(repoInfo) {
        var e_1, _a;
        var isWebSocketsAvailable = $6800df1b0932d2db$var$WebSocketConnection && $6800df1b0932d2db$var$WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !$6800df1b0932d2db$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $6800df1b0932d2db$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $6800df1b0932d2db$var$WebSocketConnection
        ];
        else {
            var transports = this.transports_ = [];
            try {
                for(var _b = $66Jdw.__values(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()){
                    var transport = _c.value;
                    if (transport && transport['isAvailable']()) transports.push(transport);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */ TransportManager.prototype.initialTransport = function() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */ TransportManager.prototype.upgradeTransport = function() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    };
    return TransportManager;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
var $6800df1b0932d2db$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var $6800df1b0932d2db$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var $6800df1b0932d2db$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
var $6800df1b0932d2db$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
var $6800df1b0932d2db$var$MESSAGE_TYPE = 't';
var $6800df1b0932d2db$var$MESSAGE_DATA = 'd';
var $6800df1b0932d2db$var$CONTROL_SHUTDOWN = 's';
var $6800df1b0932d2db$var$CONTROL_RESET = 'r';
var $6800df1b0932d2db$var$CONTROL_ERROR = 'e';
var $6800df1b0932d2db$var$CONTROL_PONG = 'o';
var $6800df1b0932d2db$var$SWITCH_ACK = 'a';
var $6800df1b0932d2db$var$END_TRANSMISSION = 'n';
var $6800df1b0932d2db$var$PING = 'p';
var $6800df1b0932d2db$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */ var $6800df1b0932d2db$var$Connection = /** @class */ function() {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */ ;
        this.log_ = $6800df1b0932d2db$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $6800df1b0932d2db$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */ Connection.prototype.start_ = function() {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(function() {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $6800df1b0932d2db$var$setTimeoutNonBlocking(function() {
            _this.healthyTimeout_ = null;
            if (!_this.isHealthy_) {
                if (_this.conn_ && _this.conn_.bytesReceived > $6800df1b0932d2db$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    _this.log_('Connection exceeded healthy timeout but has received ' + _this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    _this.isHealthy_ = true;
                    _this.conn_.markConnectionHealthy();
                } else if (_this.conn_ && _this.conn_.bytesSent > $6800df1b0932d2db$var$BYTES_SENT_HEALTHY_OVERRIDE) _this.log_('Connection exceeded healthy timeout but has sent ' + _this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    _this.log_('Closing unhealthy connection after timeout.');
                    _this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    };
    /**
     * @return {!string}
     * @private
     */ Connection.prototype.nextTransportId_ = function() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function(conn) {
        var _this = this;
        return function(everConnected) {
            if (conn === _this.conn_) _this.onConnectionLost_(everConnected);
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            } else _this.log_('closing an old connection');
        };
    };
    Connection.prototype.connReceiver_ = function(conn) {
        var _this = this;
        return function(message) {
            if (_this.state_ !== 2 /* DISCONNECTED */ ) {
                if (conn === _this.rx_) _this.onPrimaryMessageReceived_(message);
                else if (conn === _this.secondaryConn_) _this.onSecondaryMessageReceived_(message);
                else _this.log_('message on old connection');
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */ Connection.prototype.sendRequest = function(dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function(controlData) {
        if ($6800df1b0932d2db$var$MESSAGE_TYPE in controlData) {
            var cmd = controlData[$6800df1b0932d2db$var$MESSAGE_TYPE];
            if (cmd === $6800df1b0932d2db$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $6800df1b0932d2db$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $6800df1b0932d2db$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function(parsedData) {
        var layer = $6800df1b0932d2db$var$requireKey('t', parsedData);
        var data = $6800df1b0932d2db$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $6800df1b0932d2db$var$PING,
                    d: {}
                }
            });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $6800df1b0932d2db$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $6800df1b0932d2db$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = $6800df1b0932d2db$var$requireKey('t', parsedData);
        var data = $6800df1b0932d2db$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    };
    Connection.prototype.onDataMessage_ = function(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function(controlData) {
        var cmd = $6800df1b0932d2db$var$requireKey($6800df1b0932d2db$var$MESSAGE_TYPE, controlData);
        if ($6800df1b0932d2db$var$MESSAGE_DATA in controlData) {
            var payload = controlData[$6800df1b0932d2db$var$MESSAGE_DATA];
            if (cmd === $6800df1b0932d2db$var$SERVER_HELLO) this.onHandshake_(payload);
            else if (cmd === $6800df1b0932d2db$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(var i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $6800df1b0932d2db$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $6800df1b0932d2db$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $6800df1b0932d2db$var$CONTROL_ERROR) $6800df1b0932d2db$var$error('Server Error: ' + payload);
            else if (cmd === $6800df1b0932d2db$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $6800df1b0932d2db$var$error('Unknown control packet command: ' + cmd);
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */ Connection.prototype.onHandshake_ = function(handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($6800df1b0932d2db$var$PROTOCOL_VERSION !== version) $6800df1b0932d2db$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function() {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    };
    Connection.prototype.startUpgrade_ = function(conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $6800df1b0932d2db$var$setTimeoutNonBlocking(function() {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor($6800df1b0932d2db$var$UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function(conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $6800df1b0932d2db$var$setTimeoutNonBlocking(function() {
            _this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($6800df1b0932d2db$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $6800df1b0932d2db$var$PING,
                    d: {}
                }
            });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function() {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */ Connection.prototype.onConnectionLost_ = function(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $6800df1b0932d2db$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */ Connection.prototype.onConnectionShutdown_ = function(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function(data) {
        if (this.state_ !== 1 /* CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ Connection.prototype.close = function() {
        if (this.state_ !== 2 /* DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */ Connection.prototype.closeConnections_ = function() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ var $6800df1b0932d2db$var$ServerActions = /** @class */ function() {
    function ServerActions() {}
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */ ServerActions.prototype.put = function(pathString, data, onComplete, hash) {};
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */ ServerActions.prototype.merge = function(pathString, data, onComplete, hash) {};
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */ ServerActions.prototype.refreshAuthToken = function(token) {};
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */ ServerActions.prototype.onDisconnectPut = function(pathString, data, onComplete) {};
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */ ServerActions.prototype.onDisconnectMerge = function(pathString, data, onComplete) {};
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */ ServerActions.prototype.onDisconnectCancel = function(pathString, onComplete) {};
    /**
     * @param {Object.<string, *>} stats
     */ ServerActions.prototype.reportStats = function(stats) {};
    return ServerActions;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$RECONNECT_MIN_DELAY = 1000;
var $6800df1b0932d2db$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
var $6800df1b0932d2db$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
var $6800df1b0932d2db$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
var $6800df1b0932d2db$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var $6800df1b0932d2db$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var $6800df1b0932d2db$var$INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ var $6800df1b0932d2db$var$PersistentConnection = /** @class */ function(_super) {
    $66Jdw.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param repoInfo_ Data about the namespace we are connecting to
     * @param onDataUpdate_ A callback for new data from the server
     */ function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = $6800df1b0932d2db$var$logWrapper('p:' + _this.id + ':');
        _this.interruptReasons_ = {};
        /** Map<path, Map<queryId, ListenSpec>> */ _this.listens = new Map();
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        _this.establishConnectionTimer_ = null;
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        _this.realtime_ = null;
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !$epfVL.isNodeSdk()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        _this.scheduleConnect_(0);
        $6800df1b0932d2db$var$VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $6800df1b0932d2db$var$OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        return _this;
    }
    PersistentConnection.prototype.sendRequest = function(action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_($epfVL.stringify(msg));
        $epfVL.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.listen = function(query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        $epfVL.assert(query.getQueryParams().isDefault() || !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        $epfVL.assert(!this.listens.get(pathString).has(queryId), 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    };
    PersistentConnection.prototype.sendListen_ = function(listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = {
            p: pathString
        };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function(message) {
            var payload = message[/*data*/ 'd'];
            var status = message[/*status*/ 's'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens.get(pathString) && _this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') _this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    };
    PersistentConnection.warnOnListenWarnings_ = function(payload, query) {
        if (payload && typeof payload === 'object' && $epfVL.contains(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var warnings = $epfVL.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' + query.getQueryParams().getIndex().toString() + '"';
                var indexPath = query.path.toString();
                $6800df1b0932d2db$var$warn("Using an unspecified index. Your data will be downloaded and " + ("filtered on the client. Consider adding " + indexSpec + " at ") + (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.refreshAuthToken = function(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, function() {});
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || $epfVL.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ PersistentConnection.prototype.tryAuth = function() {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = $epfVL.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = {
                cred: token_1
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, function(res) {
                var status = res[/*status*/ 's'];
                var data = res[/*data*/ 'd'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') _this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    _this.onAuthRevoked_(status, data);
                }
            });
        }
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.unlisten = function(query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        $epfVL.assert(query.getQueryParams().isDefault() || !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
    };
    PersistentConnection.prototype.sendUnlisten_ = function(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = {
            p: pathString
        };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.onDisconnectPut = function(pathString, data, onComplete) {
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.onDisconnectMerge = function(pathString, data, onComplete) {
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.onDisconnectCancel = function(pathString, onComplete) {
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function(action, pathString, data, onComplete) {
        var request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function(response) {
            if (onComplete) setTimeout(function() {
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.merge = function(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function(action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    };
    PersistentConnection.prototype.sendPut_ = function(index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function(message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) _this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    };
    /**
     * @inheritDoc
     */ PersistentConnection.prototype.reportStats = function(stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function(result) {
                var status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    var errorReason = result[/* data */ 'd'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    PersistentConnection.prototype.onDataMessage_ = function(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + $epfVL.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    };
    PersistentConnection.prototype.onDataPush_ = function(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $6800df1b0932d2db$var$error('Unrecognized action received from server: ' + $epfVL.stringify(action) + '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function(timeout) {
        var _this = this;
        $epfVL.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function() {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    };
    PersistentConnection.prototype.onVisible_ = function(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $6800df1b0932d2db$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $6800df1b0932d2db$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function() {
                if (connection_1) connection_1.close();
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function(msg) {
                $epfVL.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_.getToken(forceRefresh).then(function(result) {
                if (!canceled_1) {
                    $6800df1b0932d2db$var$log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new $6800df1b0932d2db$var$Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, /* onKill= */ function(reason) {
                        $6800df1b0932d2db$var$warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt($6800df1b0932d2db$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                } else $6800df1b0932d2db$var$log('getToken() completed but was canceled');
            }).then(null, function(error) {
                self_1.log_('Failed to get token: ' + error);
                if (!canceled_1) {
                    if ($epfVL.CONSTANTS.NODE_ADMIN) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $6800df1b0932d2db$var$warn(error);
                    closeFn_1();
                }
            });
        }
    };
    PersistentConnection.prototype.interrupt = function(reason) {
        $6800df1b0932d2db$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    };
    PersistentConnection.prototype.resume = function(reason) {
        $6800df1b0932d2db$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ($epfVL.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function(timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function() {
        for(var i = 0; i < this.outstandingPuts_.length; i++){
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    };
    PersistentConnection.prototype.onListenRevoked_ = function(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) queryId = 'default';
        else queryId = query.map(function(q) {
            return $6800df1b0932d2db$var$ObjectToUniqueKey(q);
        }).join('$');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    };
    PersistentConnection.prototype.removeListen_ = function(pathString, queryId) {
        var normalizedPathString = new $6800df1b0932d2db$var$Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens.has(normalizedPathString)) {
            var map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function(statusCode, explanation) {
        $6800df1b0932d2db$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $6800df1b0932d2db$var$INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $6800df1b0932d2db$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    };
    PersistentConnection.prototype.restoreState_ = function() {
        var e_1, _a, e_2, _b;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        try {
            // Puts depend on having received the corresponding data update from the server before they complete, so we must
            // make sure to send listens before puts.
            for(var _c = $66Jdw.__values(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()){
                var queries = _d.value;
                try {
                    for(var _e = (e_2 = void 0, $66Jdw.__values(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()){
                        var listenSpec = _f.value;
                        this.sendListen_(listenSpec);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        for(var i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     */ PersistentConnection.prototype.sendConnectStats_ = function() {
        var stats = {};
        var clientName = 'js';
        if ($epfVL.CONSTANTS.NODE_ADMIN) clientName = 'admin_node';
        else if ($epfVL.CONSTANTS.NODE_CLIENT) clientName = 'node';
        stats['sdk.' + clientName + '.' + $6800df1b0932d2db$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ($epfVL.isMobileCordova()) stats['framework.cordova'] = 1;
        else if ($epfVL.isReactNative()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    };
    PersistentConnection.prototype.shouldReconnect_ = function() {
        var online = $6800df1b0932d2db$var$OnlineMonitor.getInstance().currentlyOnline();
        return $epfVL.isEmpty(this.interruptReasons_) && online;
    };
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     */ PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}($6800df1b0932d2db$var$ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ var $6800df1b0932d2db$var$ReadonlyRestClient = /** @class */ function(_super) {
    $66Jdw.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */ function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */ _this.log_ = $6800df1b0932d2db$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */ _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function(stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */ ReadonlyRestClient.getListenId_ = function(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            $epfVL.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.listen = function(query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = query.getQueryParams().toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParameters, function(error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ($epfVL.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) status_1 = 'ok';
                else if (error === 401) status_1 = 'permission_denied';
                else status_1 = 'rest_error:' + error;
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.unlisten = function(query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */ ReadonlyRestClient.prototype.refreshAuthToken = function(token) {
    // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */ ReadonlyRestClient.prototype.restRequest_ = function(pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) queryStringParameters = {};
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_.getToken(/*forceRefresh=*/ false).then(function(authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) queryStringParameters['auth'] = authToken;
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') + _this.repoInfo_.host + pathString + '?' + 'ns=' + _this.repoInfo_.namespace + $epfVL.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = $epfVL.jsonEval(xhr.responseText);
                        } catch (e) {
                            $6800df1b0932d2db$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $6800df1b0932d2db$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}($6800df1b0932d2db$var$ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */ var $6800df1b0932d2db$var$Repo = /** @class */ function() {
    function Repo(repoInfo_, forceRestClient, app, authProvider) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $6800df1b0932d2db$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = new $6800df1b0932d2db$var$SparseSnapshotTree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        var authTokenProvider = new $6800df1b0932d2db$var$AuthTokenProvider(app, authProvider);
        this.stats_ = $6800df1b0932d2db$var$StatsManager.getCollection(repoInfo_);
        if (forceRestClient || $6800df1b0932d2db$var$beingCrawled()) {
            this.server_ = new $6800df1b0932d2db$var$ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        } else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                try {
                    $epfVL.stringify(authOverride);
                } catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new $6800df1b0932d2db$var$PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function(token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = $6800df1b0932d2db$var$StatsManager.getOrCreateReporter(repoInfo_, function() {
            return new $6800df1b0932d2db$var$StatsReporter(_this.stats_, _this.server_);
        });
        this.transactionsInit_();
        // Used for .info.
        this.infoData_ = new $6800df1b0932d2db$var$SnapshotHolder();
        this.infoSyncTree_ = new $6800df1b0932d2db$var$SyncTree({
            startListening: function(query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function() {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function() {}
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new $6800df1b0932d2db$var$SyncTree({
            startListening: function(query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function(status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function(query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return The URL corresponding to the root of this Firebase.
     */ Repo.prototype.toString = function() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    };
    /**
     * @return The namespace represented by the repo.
     */ Repo.prototype.name = function() {
        return this.repoInfo_.namespace;
    };
    /**
     * @return The time in milliseconds, taking the server offset into account if we have one.
     */ Repo.prototype.serverTime = function() {
        var offsetNode = this.infoData_.getNode(new $6800df1b0932d2db$var$Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     */ Repo.prototype.generateServerValues = function() {
        return $6800df1b0932d2db$var$generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     */ Repo.prototype.onDataUpdate_ = function(pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new $6800df1b0932d2db$var$Path(pathString);
        data = this.interceptServerDataCallback_ ? this.interceptServerDataCallback_(pathString, data) : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = $epfVL.map(data, function(raw) {
                    return $6800df1b0932d2db$var$nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            } else {
                var taggedSnap = $6800df1b0932d2db$var$nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        } else if (isMerge) {
            var changedChildren = $epfVL.map(data, function(raw) {
                return $6800df1b0932d2db$var$nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        } else {
            var snap = $6800df1b0932d2db$var$nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
        // is a proxy for some change having occurred.
        affectedPath = this.rerunTransactions_(path);
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    // TODO: This should be @private but it's used by test_access.js and internal.js
    Repo.prototype.interceptServerData_ = function(callback) {
        this.interceptServerDataCallback_ = callback;
    };
    Repo.prototype.onConnectStatus_ = function(connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) this.runOnDisconnectEvents_();
    };
    Repo.prototype.onServerInfoUpdate_ = function(updates) {
        var _this = this;
        $6800df1b0932d2db$var$each(updates, function(key, value) {
            _this.updateInfo_(key, value);
        });
    };
    Repo.prototype.updateInfo_ = function(pathString, value) {
        var path = new $6800df1b0932d2db$var$Path('/.info/' + pathString);
        var newNode = $6800df1b0932d2db$var$nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    Repo.prototype.getNextWriteId_ = function() {
        return this.nextWriteId_++;
    };
    Repo.prototype.setWithPriority = function(path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = $6800df1b0932d2db$var$nodeFromJSON$1(newVal, newPriority);
        var existing = this.serverSyncTree_.calcCompleteEventCache(path);
        var newNode = $6800df1b0932d2db$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function(status, errorReason) {
            var success = status === 'ok';
            if (!success) $6800df1b0932d2db$var$warn('set at ' + path + ' failed: ' + status);
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    Repo.prototype.update = function(path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', {
            path: path.toString(),
            value: childrenToMerge
        });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        $6800df1b0932d2db$var$each(childrenToMerge, function(changedKey, changedValue) {
            empty = false;
            changedChildren[changedKey] = $6800df1b0932d2db$var$resolveDeferredValueTree(path.child(changedKey), $6800df1b0932d2db$var$nodeFromJSON$1(changedValue), _this.serverSyncTree_, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function(status, errorReason) {
                var success = status === 'ok';
                if (!success) $6800df1b0932d2db$var$warn('update at ' + path + ' failed: ' + status);
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            $6800df1b0932d2db$var$each(childrenToMerge, function(changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        } else {
            $6800df1b0932d2db$var$log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     */ Repo.prototype.runOnDisconnectEvents_ = function() {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = new $6800df1b0932d2db$var$SparseSnapshotTree();
        this.onDisconnect_.forEachTree($6800df1b0932d2db$var$Path.Empty, function(path, node) {
            var resolved = $6800df1b0932d2db$var$resolveDeferredValueTree(path, node, _this.serverSyncTree_, serverValues);
            resolvedOnDisconnectTree.remember(path, resolved);
        });
        var events = [];
        resolvedOnDisconnectTree.forEachTree($6800df1b0932d2db$var$Path.Empty, function(path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new $6800df1b0932d2db$var$SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath($6800df1b0932d2db$var$Path.Empty, events);
    };
    Repo.prototype.onDisconnectCancel = function(path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function(status, errorReason) {
            if (status === 'ok') _this.onDisconnect_.forget(path);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSet = function(path, value, onComplete) {
        var _this = this;
        var newNode = $6800df1b0932d2db$var$nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function(status, errorReason) {
            if (status === 'ok') _this.onDisconnect_.remember(path, newNode);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSetWithPriority = function(path, value, priority, onComplete) {
        var _this = this;
        var newNode = $6800df1b0932d2db$var$nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function(status, errorReason) {
            if (status === 'ok') _this.onDisconnect_.remember(path, newNode);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectUpdate = function(path, childrenToMerge, onComplete) {
        var _this = this;
        if ($epfVL.isEmpty(childrenToMerge)) {
            $6800df1b0932d2db$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function(status, errorReason) {
            if (status === 'ok') $6800df1b0932d2db$var$each(childrenToMerge, function(childName, childNode) {
                var newChildNode = $6800df1b0932d2db$var$nodeFromJSON$1(childNode);
                _this.onDisconnect_.remember(path.child(childName), newChildNode);
            });
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.addEventCallbackForQuery = function(query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        else events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.removeEventCallbackForQuery = function(query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        else events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function() {
        if (this.persistentConnection_) this.persistentConnection_.interrupt($6800df1b0932d2db$var$INTERRUPT_REASON);
    };
    Repo.prototype.resume = function() {
        if (this.persistentConnection_) this.persistentConnection_.resume($6800df1b0932d2db$var$INTERRUPT_REASON);
    };
    Repo.prototype.stats = function(showDelta) {
        if (showDelta === void 0) showDelta = false;
        if (typeof console === 'undefined') return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_) this.statsListener_ = new $6800df1b0932d2db$var$StatsListener(this.stats_);
            stats = this.statsListener_.get();
        } else stats = this.stats_.get();
        var longestName = Object.keys(stats).reduce(function(previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        $6800df1b0932d2db$var$each(stats, function(stat, value) {
            var paddedStat = stat;
            // pad stat names to be the same length (plus 2 extra spaces).
            for(var i = stat.length; i < longestName + 2; i++)paddedStat += ' ';
            console.log(paddedStat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function(metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    Repo.prototype.log_ = function() {
        var varArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)varArgs[_i] = arguments[_i];
        var prefix = '';
        if (this.persistentConnection_) prefix = this.persistentConnection_.id + ':';
        $6800df1b0932d2db$var$log.apply(void 0, $66Jdw.__spread([
            prefix
        ], varArgs));
    };
    Repo.prototype.callOnCompleteCallback = function(callback, status, errorReason) {
        if (callback) $6800df1b0932d2db$var$exceptionGuard(function() {
            if (status === 'ok') callback(null);
            else {
                var code = (status || 'error').toUpperCase();
                var message = code;
                if (errorReason) message += ': ' + errorReason;
                var error = new Error(message);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                error.code = code;
                callback(error);
            }
        });
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function() {
            return this.__database || (this.__database = new $6800df1b0932d2db$var$Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */ var $6800df1b0932d2db$var$RangedFilter = /** @class */ function() {
    /**
     * @param {!QueryParams} params
     */ function RangedFilter(params) {
        this.indexedFilter_ = new $6800df1b0932d2db$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */ RangedFilter.prototype.getStartPost = function() {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */ RangedFilter.prototype.getEndPost = function() {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */ RangedFilter.prototype.matches = function(node) {
        return this.index_.compare(this.getStartPost(), node) <= 0 && this.index_.compare(node, this.getEndPost()) <= 0;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $6800df1b0932d2db$var$NamedNode(key, newChild))) newChild = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild($6800df1b0932d2db$var$PRIORITY_INDEX, function(key, childNode) {
            if (!self.matches(new $6800df1b0932d2db$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.filtersNodes = function() {
        return true;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.getIndexedFilter = function() {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */ RangedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */ RangedFilter.getStartPost_ = function(params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */ RangedFilter.getEndPost_ = function(params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    };
    return RangedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */ var $6800df1b0932d2db$var$LimitedFilter = /** @class */ function() {
    /**
     * @param {!QueryParams} params
     */ function LimitedFilter(params) {
        this.rangedFilter_ = new $6800df1b0932d2db$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $6800df1b0932d2db$var$NamedNode(key, newChild))) newChild = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            var iterator = void 0;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            var count = 0;
            while(iterator.hasNext() && count < this.limit_){
                var next = iterator.getNext();
                var inRange = void 0;
                if (this.reverse_) inRange = this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                else inRange = this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                if (inRange) {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                } else break;
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE);
            var startPost = void 0;
            var endPost = void 0;
            var cmp = void 0;
            var iterator = void 0;
            if (this.reverse_) {
                iterator = filtered.getReverseIterator(this.index_);
                startPost = this.rangedFilter_.getEndPost();
                endPost = this.rangedFilter_.getStartPost();
                var indexCompare_1 = this.index_.getCompare();
                cmp = function(a, b) {
                    return indexCompare_1(b, a);
                };
            } else {
                iterator = filtered.getIterator(this.index_);
                startPost = this.rangedFilter_.getStartPost();
                endPost = this.rangedFilter_.getEndPost();
                cmp = this.index_.getCompare();
            }
            var count = 0;
            var foundStartPost = false;
            while(iterator.hasNext()){
                var next = iterator.getNext();
                if (!foundStartPost && cmp(startPost, next) <= 0) // start adding
                foundStartPost = true;
                var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.updatePriority = function(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.filtersNodes = function() {
        return true;
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.getIndexedFilter = function() {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */ LimitedFilter.prototype.getIndex = function() {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */ LimitedFilter.prototype.fullLimitUpdateChild_ = function(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function(a, b) {
                return indexCmp_1(b, a);
            };
        } else cmp = this.index_.getCompare();
        var oldEventCache = snap;
        $epfVL.assert(oldEventCache.numChildren() === this.limit_, '');
        var newChildNamedNode = new $6800df1b0932d2db$var$NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childChangedChange(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childRemovedChange(childKey, oldChildSnap));
                var newEventCache = oldEventCache.updateImmediateChild(childKey, $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childAddedChange(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($6800df1b0932d2db$var$Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    };
    return LimitedFilter;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */ var $6800df1b0932d2db$var$QueryParams = /** @class */ function() {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $6800df1b0932d2db$var$PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */ QueryParams.prototype.hasStart = function() {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */ QueryParams.prototype.isViewFromLeft = function() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */ QueryParams.prototype.getIndexStartValue = function() {
        $epfVL.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */ QueryParams.prototype.getIndexStartName = function() {
        $epfVL.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $6800df1b0932d2db$var$MIN_NAME;
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.hasEnd = function() {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */ QueryParams.prototype.getIndexEndValue = function() {
        $epfVL.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */ QueryParams.prototype.getIndexEndName = function() {
        $epfVL.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $6800df1b0932d2db$var$MAX_NAME;
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.hasLimit = function() {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */ QueryParams.prototype.hasAnchoredLimit = function() {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */ QueryParams.prototype.getLimit = function() {
        $epfVL.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */ QueryParams.prototype.getIndex = function() {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */ QueryParams.prototype.copy_ = function() {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */ QueryParams.prototype.limit = function(newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */ QueryParams.prototype.limitToFirst = function(newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */ QueryParams.prototype.limitToLast = function(newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */ QueryParams.prototype.startAt = function(indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (indexValue === undefined) indexValue = null;
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        } else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */ QueryParams.prototype.endAt = function(indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (indexValue === undefined) indexValue = null;
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        } else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */ QueryParams.prototype.orderBy = function(index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */ QueryParams.prototype.getQueryObject = function() {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                else viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== $6800df1b0932d2db$var$PRIORITY_INDEX) obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        return obj;
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.loadsAllData = function() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */ QueryParams.prototype.isDefault = function() {
        return this.loadsAllData() && this.index_ === $6800df1b0932d2db$var$PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */ QueryParams.prototype.getNodeFilter = function() {
        if (this.loadsAllData()) return new $6800df1b0932d2db$var$IndexedFilter(this.getIndex());
        else if (this.hasLimit()) return new $6800df1b0932d2db$var$LimitedFilter(this);
        else return new $6800df1b0932d2db$var$RangedFilter(this);
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */ QueryParams.prototype.toRestQueryStringParameters = function() {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) return qs;
        var orderBy;
        if (this.index_ === $6800df1b0932d2db$var$PRIORITY_INDEX) orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        else if (this.index_ === $6800df1b0932d2db$var$VALUE_INDEX) orderBy = REST_CONSTANTS.VALUE_INDEX;
        else if (this.index_ === $6800df1b0932d2db$var$KEY_INDEX) orderBy = REST_CONSTANTS.KEY_INDEX;
        else {
            $epfVL.assert(this.index_ instanceof $6800df1b0932d2db$var$PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = $epfVL.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = $epfVL.stringify(this.indexStartValue_);
            if (this.startNameSet_) qs[REST_CONSTANTS.START_AT] += ',' + $epfVL.stringify(this.indexStartName_);
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = $epfVL.stringify(this.indexEndValue_);
            if (this.endNameSet_) qs[REST_CONSTANTS.END_AT] += ',' + $epfVL.stringify(this.indexEndName_);
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            else qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */ QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */ QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */ QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$Reference = /** @class */ function(_super) {
    $66Jdw.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */ function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof $6800df1b0932d2db$var$Repo)) throw new Error('new Reference() no longer supported - use app.database().');
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, $6800df1b0932d2db$var$QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */ Reference.prototype.getKey = function() {
        $epfVL.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty()) return null;
        else return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */ Reference.prototype.child = function(pathString) {
        $epfVL.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') pathString = String(pathString);
        else if (!(pathString instanceof $6800df1b0932d2db$var$Path)) {
            if (this.path.getFront() === null) $6800df1b0932d2db$var$validateRootPathString('Reference.child', 1, pathString, false);
            else $6800df1b0932d2db$var$validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */ Reference.prototype.getParent = function() {
        $epfVL.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */ Reference.prototype.getRoot = function() {
        $epfVL.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while(ref.getParent() !== null)ref = ref.getParent();
        return ref;
    };
    /** @return {!Database} */ Reference.prototype.databaseProp = function() {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.set = function(newVal, onComplete) {
        $epfVL.validateArgCount('Reference.set', 1, 2, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('Reference.set', this.path);
        $6800df1b0932d2db$var$validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        $epfVL.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo.setWithPriority(this.path, newVal, /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.update = function(objectToMerge, onComplete) {
        $epfVL.validateArgCount('Reference.update', 1, 2, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for(var i = 0; i < objectToMerge.length; ++i)newObjectToMerge['' + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $6800df1b0932d2db$var$warn("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        $6800df1b0932d2db$var$validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        $epfVL.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.setWithPriority = function(newVal, newPriority, onComplete) {
        $epfVL.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('Reference.setWithPriority', this.path);
        $6800df1b0932d2db$var$validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        $6800df1b0932d2db$var$validatePriority('Reference.setWithPriority', 2, newPriority, false);
        $epfVL.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys') throw 'Reference.setWithPriority failed: ' + this.getKey() + ' is a read-only object.';
        var deferred = new $epfVL.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.remove = function(onComplete) {
        $epfVL.validateArgCount('Reference.remove', 0, 1, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('Reference.remove', this.path);
        $epfVL.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */ Reference.prototype.transaction = function(transactionUpdate, onComplete, applyLocally) {
        $epfVL.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('Reference.transaction', this.path);
        $epfVL.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        $epfVL.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        $6800df1b0932d2db$var$validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys') throw 'Reference.transaction failed: ' + this.getKey() + ' is a read-only object.';
        if (applyLocally === undefined) applyLocally = true;
        var deferred = new $epfVL.Deferred();
        if (typeof onComplete === 'function') deferred.promise.catch(function() {});
        var promiseComplete = function(error, committed, snapshot) {
            if (error) deferred.reject(error);
            else deferred.resolve(new $6800df1b0932d2db$var$TransactionResult(committed, snapshot));
            if (typeof onComplete === 'function') onComplete(error, committed, snapshot);
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */ Reference.prototype.setPriority = function(priority, onComplete) {
        $epfVL.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('Reference.setPriority', this.path);
        $6800df1b0932d2db$var$validatePriority('Reference.setPriority', 1, priority, false);
        $epfVL.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new $epfVL.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */ Reference.prototype.push = function(value, onComplete) {
        $epfVL.validateArgCount('Reference.push', 0, 2, arguments.length);
        $6800df1b0932d2db$var$validateWritablePath('Reference.push', this.path);
        $6800df1b0932d2db$var$validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        $epfVL.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = $6800df1b0932d2db$var$nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) promise = thennablePushRef.set(value, onComplete).then(function() {
            return pushRef;
        });
        else promise = Promise.resolve(pushRef);
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') promise.catch(function() {});
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */ Reference.prototype.onDisconnect = function() {
        $6800df1b0932d2db$var$validateWritablePath('Reference.onDisconnect', this.path);
        return new $6800df1b0932d2db$var$OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function() {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function() {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function() {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function() {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}($6800df1b0932d2db$var$Query);
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $6800df1b0932d2db$var$Query.__referenceConstructor = $6800df1b0932d2db$var$Reference;
$6800df1b0932d2db$var$SyncPoint.__referenceConstructor = $6800df1b0932d2db$var$Reference;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Node in a Tree.
 */ var $6800df1b0932d2db$var$TreeNode = /** @class */ function() {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}();
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ var $6800df1b0932d2db$var$Tree = /** @class */ function() {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */ function Tree(name_, parent_, node_) {
        if (name_ === void 0) name_ = '';
        if (parent_ === void 0) parent_ = null;
        if (node_ === void 0) node_ = new $6800df1b0932d2db$var$TreeNode();
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */ Tree.prototype.subTree = function(pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof $6800df1b0932d2db$var$Path ? pathObj : new $6800df1b0932d2db$var$Path(pathObj);
        var child = this, next = path.getFront();
        while(next !== null){
            var childNode = $epfVL.safeGet(child.node_.children, next) || new $6800df1b0932d2db$var$TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
            next = path.getFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */ Tree.prototype.getValue = function() {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */ Tree.prototype.setValue = function(value) {
        $epfVL.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */ Tree.prototype.clear = function() {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */ Tree.prototype.hasChildren = function() {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */ Tree.prototype.isEmpty = function() {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */ Tree.prototype.forEachChild = function(action) {
        var _this = this;
        $6800df1b0932d2db$var$each(this.node_.children, function(child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */ Tree.prototype.forEachDescendant = function(action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst) action(this);
        this.forEachChild(function(child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst) action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */ Tree.prototype.forEachAncestor = function(action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while(node !== null){
            if (action(node)) return true;
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */ Tree.prototype.forEachImmediateDescendantWithValue = function(action) {
        this.forEachChild(function(child) {
            if (child.getValue() !== null) action(child);
            else child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */ Tree.prototype.path = function() {
        return new $6800df1b0932d2db$var$Path(this.parent_ === null ? this.name_ : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */ Tree.prototype.name = function() {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */ Tree.prototype.parent = function() {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */ Tree.prototype.updateParents_ = function() {
        if (this.parent_ !== null) this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */ Tree.prototype.updateChild_ = function(childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = $epfVL.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        } else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */ var $6800df1b0932d2db$var$TransactionStatus;
(function(TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})($6800df1b0932d2db$var$TransactionStatus || ($6800df1b0932d2db$var$TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.transactionsInit_ = function() {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */ this.transactionQueueTree_ = new $6800df1b0932d2db$var$Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */ $6800df1b0932d2db$var$Repo.prototype.startTransaction = function(path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function() {};
    var watchRef = new $6800df1b0932d2db$var$Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function() {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: $6800df1b0932d2db$var$LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new $6800df1b0932d2db$var$DataSnapshot(transaction.currentInputSnapshot, new $6800df1b0932d2db$var$Reference(this, transaction.path), $6800df1b0932d2db$var$PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    } else {
        $6800df1b0932d2db$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = $6800df1b0932d2db$var$TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' && newVal !== null && $epfVL.contains(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = $epfVL.safeGet(newVal, '.priority');
            $epfVL.assert($6800df1b0932d2db$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) || $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = $6800df1b0932d2db$var$nodeFromJSON$1(newVal, priorityForNode);
        var newNode = $6800df1b0932d2db$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.getLatestState_ = function(path, excludeSets) {
    return this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) || $6800df1b0932d2db$var$ChildrenNode.EMPTY_NODE;
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.sendReadyTransactions_ = function(node) {
    var _this = this;
    if (node === void 0) node = this.transactionQueueTree_;
    // Before recursing, make sure any completed transactions are removed.
    if (!node) this.pruneCompletedTransactionsBelowNode_(node);
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        $epfVL.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function(transaction) {
            return transaction.status === $6800df1b0932d2db$var$TransactionStatus.RUN;
        });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) this.sendTransactionQueue_(node.path(), queue);
    } else if (node.hasChildren()) node.forEachChild(function(childNode) {
        _this.sendReadyTransactions_(childNode);
    });
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.sendTransactionQueue_ = function(path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function(txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for(var i = 0; i < queue.length; i++){
        var txn = queue[i];
        $epfVL.assert(txn.status === $6800df1b0932d2db$var$TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = $6800df1b0932d2db$var$TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = $6800df1b0932d2db$var$Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function(status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for(var i = 0; i < queue.length; i++){
                queue[i].status = $6800df1b0932d2db$var$TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new $6800df1b0932d2db$var$Reference(_this, queue[i].path);
                    var snapshot = new $6800df1b0932d2db$var$DataSnapshot(node, ref, $6800df1b0932d2db$var$PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for(var i = 0; i < callbacks.length; i++)$6800df1b0932d2db$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(var i = 0; i < queue.length; i++)if (queue[i].status === $6800df1b0932d2db$var$TransactionStatus.SENT_NEEDS_ABORT) queue[i].status = $6800df1b0932d2db$var$TransactionStatus.NEEDS_ABORT;
                else queue[i].status = $6800df1b0932d2db$var$TransactionStatus.RUN;
            } else {
                $6800df1b0932d2db$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(var i = 0; i < queue.length; i++){
                    queue[i].status = $6800df1b0932d2db$var$TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.rerunTransactions_ = function(changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.rerunTransactionQueue_ = function(queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function(q) {
        return q.status === $6800df1b0932d2db$var$TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function(q) {
        return q.currentWriteId;
    });
    for(var i = 0; i < queue.length; i++){
        var transaction = queue[i];
        var relativePath = $6800df1b0932d2db$var$Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        $epfVL.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === $6800df1b0932d2db$var$TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        } else if (transaction.status === $6800df1b0932d2db$var$TransactionStatus.RUN) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (transaction.retryCount >= $6800df1b0932d2db$var$Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $6800df1b0932d2db$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = $6800df1b0932d2db$var$nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' && newData != null && $epfVL.contains(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = $6800df1b0932d2db$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = $6800df1b0932d2db$var$TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new $6800df1b0932d2db$var$Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */  = queue[i].currentInputSnapshot;
                    var snapshot = new $6800df1b0932d2db$var$DataSnapshot(lastInput, ref, $6800df1b0932d2db$var$PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                } else callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(var i = 0; i < callbacks.length; i++)$6800df1b0932d2db$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.getAncestorTransactionNode_ = function(path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    front = path.getFront();
    while(front !== null && transactionNode.getValue() === null){
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
        front = path.getFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.buildTransactionQueue_ = function(transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function(a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.aggregateTransactionQueuesForNode_ = function(node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) for(var i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    node.forEachChild(function(child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.pruneCompletedTransactionsBelowNode_ = function(node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for(var from = 0; from < queue.length; from++)if (queue[from].status !== $6800df1b0932d2db$var$TransactionStatus.COMPLETED) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function(childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.abortTransactions_ = function(path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function(node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function(node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$Repo.prototype.abortTransactionsOnNode_ = function(node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for(var i = 0; i < queue.length; i++){
            if (queue[i].status === $6800df1b0932d2db$var$TransactionStatus.SENT_NEEDS_ABORT) ;
            else if (queue[i].status === $6800df1b0932d2db$var$TransactionStatus.SENT) {
                $epfVL.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = $6800df1b0932d2db$var$TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            } else {
                $epfVL.assert(queue[i].status === $6800df1b0932d2db$var$TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        node.setValue(null);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for(var i = 0; i < callbacks.length; i++)$6800df1b0932d2db$var$exceptionGuard(callbacks[i]);
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** @const {string} */ var $6800df1b0932d2db$var$DATABASE_URL_OPTION = 'databaseURL';
/**
 * This variable is also defined in the firebase node.js admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ var $6800df1b0932d2db$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
var $6800df1b0932d2db$var$_staticInstance;
/**
 * Creates and caches Repo instances.
 */ var $6800df1b0932d2db$var$RepoManager = /** @class */ function() {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */ this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */ this.useRestClient_ = false;
    }
    RepoManager.getInstance = function() {
        if (!$6800df1b0932d2db$var$_staticInstance) $6800df1b0932d2db$var$_staticInstance = new RepoManager();
        return $6800df1b0932d2db$var$_staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function() {
        var e_1, _a, e_2, _b;
        try {
            for(var _c = $66Jdw.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()){
                var appName = _d.value;
                try {
                    for(var _e = (e_2 = void 0, $66Jdw.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var dbUrl = _f.value;
                        this.repos_[appName][dbUrl].interrupt();
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    RepoManager.prototype.resume = function() {
        var e_3, _a, e_4, _b;
        try {
            for(var _c = $66Jdw.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()){
                var appName = _d.value;
                try {
                    for(var _e = (e_4 = void 0, $66Jdw.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var dbUrl = _f.value;
                        this.repos_[appName][dbUrl].resume();
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */ RepoManager.prototype.databaseFromApp = function(app, authProvider, url) {
        var dbUrl = url || app.options[$6800df1b0932d2db$var$DATABASE_URL_OPTION];
        if (dbUrl === undefined) $6800df1b0932d2db$var$fatal("Can't determine Firebase Database URL.  Be sure to include " + $6800df1b0932d2db$var$DATABASE_URL_OPTION + ' option when calling firebase.initializeApp().');
        var parsedUrl = $6800df1b0932d2db$var$parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        var dbEmulatorHost = undefined;
        if (dbEmulatorHost) {
            dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
            parsedUrl = $6800df1b0932d2db$var$parseRepoInfo(dbUrl);
            repoInfo = parsedUrl.repoInfo;
        }
        $6800df1b0932d2db$var$validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) $6800df1b0932d2db$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
        var repo = this.createRepo(repoInfo, app, authProvider);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */ RepoManager.prototype.deleteRepo = function(repo) {
        var appRepos = $epfVL.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || $epfVL.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) $6800df1b0932d2db$var$fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */ RepoManager.prototype.createRepo = function(repoInfo, app, authProvider) {
        var appRepos = $epfVL.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = $epfVL.safeGet(appRepos, repoInfo.toURLString());
        if (repo) $6800df1b0932d2db$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        repo = new $6800df1b0932d2db$var$Repo(repoInfo, this.useRestClient_, app, authProvider);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */ RepoManager.prototype.forceRestClient = function(forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */ var $6800df1b0932d2db$var$Database = /** @class */ function() {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */ function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof $6800df1b0932d2db$var$Repo)) $6800df1b0932d2db$var$fatal("Don't call new Database() directly - please use firebase.database().");
        /** @type {Reference} */ this.root_ = new $6800df1b0932d2db$var$Reference(repo_, $6800df1b0932d2db$var$Path.Empty);
        this.INTERNAL = new $6800df1b0932d2db$var$DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function() {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    Database.prototype.ref = function(path) {
        this.checkDeleted_('ref');
        $epfVL.validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof $6800df1b0932d2db$var$Reference) return this.refFromURL(path.toString());
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */ Database.prototype.refFromURL = function(url) {
        /** @const {string} */ var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        $epfVL.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = $6800df1b0932d2db$var$parseRepoInfo(url);
        $6800df1b0932d2db$var$validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) $6800df1b0932d2db$var$fatal(apiName + ': Host name does not match the current database: ' + '(found ' + repoInfo.host + ' but expected ' + this.repo_.repoInfo_.host + ')');
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */ Database.prototype.checkDeleted_ = function(apiName) {
        if (this.repo_ === null) $6800df1b0932d2db$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function() {
        $epfVL.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function() {
        $epfVL.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        },
        increment: function(delta) {
            return {
                '.sv': {
                    'increment': delta
                }
            };
        }
    };
    return Database;
}();
var $6800df1b0932d2db$var$DatabaseInternals = /** @class */ function() {
    /** @param {!Database} database */ function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */ DatabaseInternals.prototype.delete = function() {
        return $66Jdw.__awaiter(this, void 0, void 0, function() {
            return $66Jdw.__generator(this, function(_a) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.checkDeleted_('delete');
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                $6800df1b0932d2db$var$RepoManager.getInstance().deleteRepo(this.database.repo_);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.repo_ = null;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return DatabaseInternals;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */ var $6800df1b0932d2db$var$forceLongPolling = function() {
    $6800df1b0932d2db$var$WebSocketConnection.forceDisallow();
    $6800df1b0932d2db$var$BrowserPollConnection.forceAllow();
};
var $6800df1b0932d2db$var$forceWebSockets = function() {
    $6800df1b0932d2db$var$BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */ var $6800df1b0932d2db$var$isWebSocketsAvailable = function() {
    return $6800df1b0932d2db$var$WebSocketConnection['isAvailable']();
};
var $6800df1b0932d2db$var$setSecurityDebugCallback = function(ref, callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var $6800df1b0932d2db$var$stats = function(ref, showDelta) {
    ref.repo.stats(showDelta);
};
var $6800df1b0932d2db$var$statsIncrementCounter = function(ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var $6800df1b0932d2db$var$dataUpdateCount = function(ref) {
    return ref.repo.dataUpdateCount;
};
var $6800df1b0932d2db$var$interceptServerData = function(ref, callback) {
    return ref.repo.interceptServerData_(callback);
};
var $6800df1b0932d2db$var$INTERNAL = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    forceLongPolling: $6800df1b0932d2db$var$forceLongPolling,
    forceWebSockets: $6800df1b0932d2db$var$forceWebSockets,
    isWebSocketsAvailable: $6800df1b0932d2db$var$isWebSocketsAvailable,
    setSecurityDebugCallback: $6800df1b0932d2db$var$setSecurityDebugCallback,
    stats: $6800df1b0932d2db$var$stats,
    statsIncrementCounter: $6800df1b0932d2db$var$statsIncrementCounter,
    dataUpdateCount: $6800df1b0932d2db$var$dataUpdateCount,
    interceptServerData: $6800df1b0932d2db$var$interceptServerData
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$DataConnection = $6800df1b0932d2db$var$PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
$6800df1b0932d2db$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var $6800df1b0932d2db$var$RealTimeConnection = $6800df1b0932d2db$var$Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */ var $6800df1b0932d2db$var$hijackHash = function(newHash) {
    var oldPut = $6800df1b0932d2db$var$PersistentConnection.prototype.put;
    $6800df1b0932d2db$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $6800df1b0932d2db$var$PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */ var $6800df1b0932d2db$var$ConnectionTarget = $6800df1b0932d2db$var$RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */ var $6800df1b0932d2db$var$queryIdentifier = function(query) {
    return query.queryIdentifier();
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */ var $6800df1b0932d2db$var$forceRestClient = function(forceRestClient) {
    $6800df1b0932d2db$var$RepoManager.getInstance().forceRestClient(forceRestClient);
};
var $6800df1b0932d2db$var$TEST_ACCESS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DataConnection: $6800df1b0932d2db$var$DataConnection,
    RealTimeConnection: $6800df1b0932d2db$var$RealTimeConnection,
    hijackHash: $6800df1b0932d2db$var$hijackHash,
    ConnectionTarget: $6800df1b0932d2db$var$ConnectionTarget,
    queryIdentifier: $6800df1b0932d2db$var$queryIdentifier,
    forceRestClient: $6800df1b0932d2db$var$forceRestClient
});
var $6800df1b0932d2db$var$name = "@firebase/database";
var $6800df1b0932d2db$var$version = "0.6.3";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6800df1b0932d2db$var$ServerValue = $6800df1b0932d2db$var$Database.ServerValue;
function $6800df1b0932d2db$var$registerDatabase(instance) {
    // set SDK_VERSION
    $6800df1b0932d2db$var$setSDKVersion(instance.SDK_VERSION);
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerComponent(new $9Cwol.Component('database', function(container, url) {
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider('app').getImmediate();
        var authProvider = container.getProvider('auth-internal');
        return $6800df1b0932d2db$var$RepoManager.getInstance().databaseFromApp(app, authProvider, url);
    }, "PUBLIC" /* PUBLIC */ ).setServiceProps(// firebase.database namespace properties
    {
        Reference: $6800df1b0932d2db$var$Reference,
        Query: $6800df1b0932d2db$var$Query,
        Database: $6800df1b0932d2db$var$Database,
        DataSnapshot: $6800df1b0932d2db$var$DataSnapshot,
        enableLogging: $6800df1b0932d2db$var$enableLogging,
        INTERNAL: $6800df1b0932d2db$var$INTERNAL,
        ServerValue: $6800df1b0932d2db$var$ServerValue,
        TEST_ACCESS: $6800df1b0932d2db$var$TEST_ACCESS
    }).setMultipleInstances(true));
    instance.registerVersion($6800df1b0932d2db$var$name, $6800df1b0932d2db$var$version);
    if ($epfVL.isNodeSdk()) module.exports = namespace;
}
$6800df1b0932d2db$var$registerDatabase($6800df1b0932d2db$var$firebase);
module.exports.DataSnapshot = $6800df1b0932d2db$var$DataSnapshot;
module.exports.Database = $6800df1b0932d2db$var$Database;
module.exports.OnDisconnect = $6800df1b0932d2db$var$OnDisconnect;
module.exports.Query = $6800df1b0932d2db$var$Query;
module.exports.Reference = $6800df1b0932d2db$var$Reference;
module.exports.ServerValue = $6800df1b0932d2db$var$ServerValue;
module.exports.enableLogging = $6800df1b0932d2db$var$enableLogging;
module.exports.registerDatabase = $6800df1b0932d2db$var$registerDatabase;

});
parcelRegister("66Jdw", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $472660cd2dfc9d5b$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $472660cd2dfc9d5b$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $472660cd2dfc9d5b$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $472660cd2dfc9d5b$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $472660cd2dfc9d5b$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $472660cd2dfc9d5b$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $472660cd2dfc9d5b$export$afc72e2116322959);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $472660cd2dfc9d5b$var$extendStatics = function(d, b) {
    $472660cd2dfc9d5b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $472660cd2dfc9d5b$var$extendStatics(d, b);
};
function $472660cd2dfc9d5b$export$a8ba968b8961cb8a(d, b) {
    $472660cd2dfc9d5b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $472660cd2dfc9d5b$export$18ce0697a983be9b = function() {
    $472660cd2dfc9d5b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $472660cd2dfc9d5b$export$18ce0697a983be9b.apply(this, arguments);
};
function $472660cd2dfc9d5b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $472660cd2dfc9d5b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $472660cd2dfc9d5b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $472660cd2dfc9d5b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $472660cd2dfc9d5b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $472660cd2dfc9d5b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $472660cd2dfc9d5b$export$f33643c0debef087(m, exports) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $472660cd2dfc9d5b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $472660cd2dfc9d5b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $472660cd2dfc9d5b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($472660cd2dfc9d5b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $472660cd2dfc9d5b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $472660cd2dfc9d5b$export$10c90e4f7922046c(v) {
    return this instanceof $472660cd2dfc9d5b$export$10c90e4f7922046c ? (this.v = v, this) : new $472660cd2dfc9d5b$export$10c90e4f7922046c(v);
}
function $472660cd2dfc9d5b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $472660cd2dfc9d5b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $472660cd2dfc9d5b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $472660cd2dfc9d5b$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $472660cd2dfc9d5b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $472660cd2dfc9d5b$export$19a8beecd37a4c45 === "function" ? $472660cd2dfc9d5b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $472660cd2dfc9d5b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $472660cd2dfc9d5b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $472660cd2dfc9d5b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $472660cd2dfc9d5b$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $472660cd2dfc9d5b$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});



parcelRegister("1MQ4j", function(module, exports) {
'use strict';
function $14d2a9e4cfb662cc$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $14d2a9e4cfb662cc$var$firebase = $14d2a9e4cfb662cc$var$_interopDefault((parcelRequire("jJO2d")));
var $14d2a9e4cfb662cc$var$name = "firebase";
var $14d2a9e4cfb662cc$var$version = "7.14.6";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $14d2a9e4cfb662cc$var$firebase.registerVersion($14d2a9e4cfb662cc$var$name, $14d2a9e4cfb662cc$var$version, 'app');
module.exports = $14d2a9e4cfb662cc$var$firebase;

});

parcelRegister("cQ02v", function(module, exports) {

$parcel$export(module.exports, "SocialLoginButtonComponent", () => $958a5f33d7167efb$export$b0bcd04f193c4507);

var $4TeKW = parcelRequire("4TeKW");
parcelRequire("1JoXj");
var $cgb9t = parcelRequire("cgb9t");
var $8KmtQ = parcelRequire("8KmtQ");
var $c4KDa = parcelRequire("c4KDa");
var $9vNTa = parcelRequire("9vNTa");
var $hG9xJ = parcelRequire("hG9xJ");
var $958a5f33d7167efb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $958a5f33d7167efb$var$__metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @customElement social-login-button
 */ let $958a5f33d7167efb$export$b0bcd04f193c4507 = /** @class */ (()=>{
    let SocialLoginButtonComponent = class SocialLoginButtonComponent extends (0, $4TeKW.LitElement) {
        constructor(){
            super(...arguments);
            this.color = '#333';
            this.bgColor = '';
            this.textColor = '#333';
            this.type = 'github';
            this.icons = {
                facebook: $cgb9t.facebook,
                github: $8KmtQ.github,
                twitter: $hG9xJ.twitter,
                google: $c4KDa.google,
                terra: $9vNTa.terra
            };
        }
        OnInit() {
            if (this.active) this.hover();
        }
        hover() {
            this.color = '#222';
            this.bgColor = '#ffffff';
            this.textColor = '#222';
        }
        leave() {
            this.color = '#333';
            this.bgColor = '';
            this.textColor = '#333';
        }
        mouseEnter() {
            if (!this.active) this.hover();
        }
        mouseLeave() {
            if (!this.active) this.leave();
        }
    };
    $958a5f33d7167efb$var$__decorate([
        (0, $4TeKW.property)(),
        $958a5f33d7167efb$var$__metadata("design:type", Object)
    ], SocialLoginButtonComponent.prototype, "color", void 0);
    $958a5f33d7167efb$var$__decorate([
        (0, $4TeKW.property)(),
        $958a5f33d7167efb$var$__metadata("design:type", Object)
    ], SocialLoginButtonComponent.prototype, "bgColor", void 0);
    $958a5f33d7167efb$var$__decorate([
        (0, $4TeKW.property)(),
        $958a5f33d7167efb$var$__metadata("design:type", Object)
    ], SocialLoginButtonComponent.prototype, "textColor", void 0);
    $958a5f33d7167efb$var$__decorate([
        (0, $4TeKW.property)({
            type: Boolean
        }),
        $958a5f33d7167efb$var$__metadata("design:type", Boolean)
    ], SocialLoginButtonComponent.prototype, "active", void 0);
    $958a5f33d7167efb$var$__decorate([
        (0, $4TeKW.property)(),
        $958a5f33d7167efb$var$__metadata("design:type", String)
    ], SocialLoginButtonComponent.prototype, "type", void 0);
    SocialLoginButtonComponent = $958a5f33d7167efb$var$__decorate([
        (0, $4TeKW.Component)({
            selector: 'social-login-button',
            style: (0, $4TeKW.css)`
    .container {
      border-radius: 5px;
      padding: 10px;
      cursor: pointer;
    }
    .container .icon {
      width: 45px;
    }
    .container .text {
      margin-left: 15px;
      margin-top: 13px;
    }
  `,
            template () {
                return (0, $4TeKW.html)`
      <div
        @pointerenter=${this.mouseEnter}
        @pointerleave=${this.mouseLeave}
        class="container"
        style="background-color:${this.bgColor}; display:flex; "
      >
        <div class="icon">${this.icons[this.type](this.color)}</div>
        <div class="text" style="color: ${this.textColor}">
          <slot></slot>
        </div>
      </div>
    `;
            }
        })
    ], SocialLoginButtonComponent);
    return SocialLoginButtonComponent;
})();

});
parcelRegister("1JoXj", function(module, exports) {
$parcel$export(module.exports, "facebook", () => (parcelRequire("cgb9t")).facebook);
$parcel$export(module.exports, "github", () => (parcelRequire("8KmtQ")).github);
$parcel$export(module.exports, "twitter", () => (parcelRequire("hG9xJ")).twitter);
$parcel$export(module.exports, "google", () => (parcelRequire("c4KDa")).google);
$parcel$export(module.exports, "terra", () => (parcelRequire("9vNTa")).terra);
parcelRequire("cgb9t");
parcelRequire("8KmtQ");
parcelRequire("hG9xJ");
parcelRequire("c4KDa");
parcelRequire("9vNTa");

});
parcelRegister("cgb9t", function(module, exports) {

$parcel$export(module.exports, "facebook", () => $8ecfa130ecb2aae6$export$e98652cea9b09aa);

var $4TeKW = parcelRequire("4TeKW");
function $8ecfa130ecb2aae6$export$e98652cea9b09aa(fill = '#FFF') {
    return (0, $4TeKW.svg)`<svg fill='${fill}'
    role='img'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'>
    <title>Facebook icon</title>
    <path
        d='M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z'/>
    </svg>`;
}

});

parcelRegister("8KmtQ", function(module, exports) {

$parcel$export(module.exports, "github", () => $65e40eb734f82c1a$export$85c7dd0b0150981e);

var $4TeKW = parcelRequire("4TeKW");
function $65e40eb734f82c1a$export$85c7dd0b0150981e(fill = '#FFF') {
    return (0, $4TeKW.svg)`<svg fill="${fill}"
    aria-labelledby="simpleicons-github-icon"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <title id="simpleicons-github-icon">GitHub icon</title>
    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>`;
}

});

parcelRegister("hG9xJ", function(module, exports) {

$parcel$export(module.exports, "twitter", () => $cdedc2f6fc0b4b85$export$87453108c2dd3831);

var $4TeKW = parcelRequire("4TeKW");
function $cdedc2f6fc0b4b85$export$87453108c2dd3831(fill = '#FFF') {
    return (0, $4TeKW.svg)`<svg fill="${fill}"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <title>Twitter icon</title>
    <path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"/></svg>`;
}

});

parcelRegister("c4KDa", function(module, exports) {

$parcel$export(module.exports, "google", () => $8caa07a28768f6f6$export$2d1fdedcfa4b711e);

var $4TeKW = parcelRequire("4TeKW");
function $8caa07a28768f6f6$export$2d1fdedcfa4b711e(fill = '#FFF') {
    return (0, $4TeKW.svg)`<svg fill="${fill}"
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <title>Google icon</title>
    <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"/></svg>`;
}

});

parcelRegister("9vNTa", function(module, exports) {

$parcel$export(module.exports, "terra", () => $6ecdb531f360f996$export$a0faaedc55eea3a0);

var $4TeKW = parcelRequire("4TeKW");
function $6ecdb531f360f996$export$a0faaedc55eea3a0() {
    return (0, $4TeKW.svg)`<?xml version="1.0" encoding="utf-8"?>
  <!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg style="width: 59px;" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1172 886" style="enable-background:new 0 0 1172 886;" xml:space="preserve">
    <style type="text/css">
    .st0{fill:#2845AD;}
    .st1{fill:#5494F8;}
    .st2{fill:none;}
  </style>
    <title>Terra icon</title>
    <path class="st0" d="M461.1,119.9c38.9-16,81.2-21.2,122.9-22.5c62.8,0.8,127.1,8.8,184.4,35.8c45,20.8,82.5,55.1,112.1,94.3
    c-9.3-6.8-14.6-17.8-22.9-25.7c-15.2-14.5-28.8-31.9-48.9-39.8c-19.8-6.8-41.1-8.5-61.9-7.5c-52.1,3.7-102.9,17.7-152,35.2
    c-53.9,21.2-108.1,47.2-148.3,90.1c-8,8-12.7,18.6-20.5,26.7c-18.4-12.5-36.3-27.4-47.2-47.1c-0.5-1-1.6-3.1-2.1-4.2
    c33.8-15.8,66.7-35.2,92.6-62.4c13.4-14.5,25.9-34.8,19-55.1C484.2,126,470.8,124.5,461.1,119.9 M605.5,525.8
    c50.5,18.6,101.5,35.8,153.2,50.7c45.3,12.3,91.6,24.3,138.8,24c-4.9,11.9-10.7,23.4-17.3,34.4c-41.6,13.4-81.5,31.8-118.7,54.8
    c-22.8,14.9-46,31.5-59.4,55.8c-5.4,9.5-5.5,20.7-2.6,30.9c-0.6,0.7-1.8,2-2.3,2.7c-16.2,4.2-33.1,13.2-50,6.7
    c-28.3-9.1-51.6-29.1-71.1-50.8c-23.8-28.2-43.3-62.5-45.7-100c-0.7-35.3,21.3-66.1,47.1-88.1C586.3,539.3,596,532.6,605.5,525.8
    L605.5,525.8z" />
    <path class="st1" d="M429.7,122c10.3-2.5,20.9-1.1,31.4-2c9.7,4.6,23.1,6.1,27.2,17.7c6.8,20.3-5.6,40.6-19,55.1
    c-25.9,27.2-58.8,46.6-92.6,62.4c0.5,1,1.5,3.1,2.1,4.2c-3.9-2.7-8.7-1.2-12.6,0.6c-25.7,11.5-52.5,20.5-80,27
    c-10.6,2.2-21.3,4.5-32.2,3.3c0-6.3,4.4-11.3,7-16.7c26-47.1,62-88,105.4-119.9C385.6,139.9,405.8,125.4,429.7,122 M594.8,189.7
    c49-17.5,99.8-31.5,152-35.2c20.8-1,42.1,0.7,61.9,7.5c20.1,8,33.7,25.4,48.9,39.8c8.3,7.9,13.6,19,22.9,25.7
    c4.8,2.4,6.5,8.4,9.9,12.4c69.4,98.2,85.9,231.2,42.9,343.5c-4.2,15-23,15.6-35.8,17.1c-47.3,0.3-93.5-11.7-138.8-24
    C707,561.6,656,544.4,605.5,525.8c-47.7-18.8-94.1-42.1-134.1-74.5c-25-21.4-48.2-48.2-54.5-81.4c-4.2-17.3-1.6-35.5,4.9-51.8
    c1.6-3.8,4.2-7.4,4.2-11.6c7.9-8.1,12.5-18.7,20.5-26.7C486.7,236.9,540.9,210.9,594.8,189.7 M237.4,325.5l2,0.8
    c15,18.3,30.3,36.5,45.4,54.6c31.8,36.4,59,76.4,84.5,117.4c35.7,55,67.7,115.3,74.2,181.5c0.6,35.7,0.8,71.7-5,107.1
    c-10.3,2.6-20.5-4-29.7-8c-68.7-37-124.8-96.6-158.3-167.2C208.4,523.2,203.4,417.6,237.4,325.5 M880.2,634.9
    c9.1-2.4,18.2-6,27.8-5.6c2.6,6.6-2.4,12.2-5.5,17.6c-30.2,48.8-71.4,90.8-120.3,120.9c-16.4,10.3-33.9,21.7-54,20.7
    c-9.6,0.7-18.9-3.4-26-9.7c-1.2,0.1-3.8,0.3-5,0.4c0.6-0.7,1.8-2,2.3-2.7c-2.8-10.2-2.7-21.5,2.6-30.9
    c13.4-24.3,36.6-40.9,59.4-55.8C798.7,666.7,838.6,648.3,880.2,634.9z" />
    <rect x="186" y="43" class="st2" width="800" height="800" />
  </svg>
  `;
}

});



parcelRegister("97odG", function(module, exports) {

$parcel$export(module.exports, "SocialService", () => $6a378e085331f7f6$export$2ad3502e5d69a818);

var $1t8Wn = parcelRequire("1t8Wn");

var $1MQ4j = parcelRequire("1MQ4j");

var $5JMLH = parcelRequire("5JMLH");
var $8id0M = parcelRequire("8id0M");
var $g5fNy = parcelRequire("g5fNy");
var $f16OP = parcelRequire("f16OP");
var $XfaK7 = parcelRequire("XfaK7");

var $j7eyO = parcelRequire("j7eyO");
var $6Rz6W = parcelRequire("6Rz6W");
var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");
var $3dOhR = parcelRequire("3dOhR");
var $6a378e085331f7f6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a378e085331f7f6$var$__metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let $6a378e085331f7f6$export$2ad3502e5d69a818 = /** @class */ (()=>{
    let SocialService = class SocialService {
        constructor(){
            this._isLoggedIn = new (0, $f16OP.Subject)();
            this.isLoggedIn = this._isLoggedIn.asObservable();
            $1MQ4j.auth().onAuthStateChanged((user)=>{
                this._isLoggedIn.next(!!user);
            });
            /* Get user token based on URI parameteres /?token=mytoken */ const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            if (token) this.checkLoggedIn().pipe((0, $lNnaw.switchMap)((isLoggedIn)=>(0, $5JMLH.from)($1MQ4j.auth().signInWithCustomToken(token)).pipe((0, $gawXH.map)(()=>isLoggedIn), (0, $j7eyO.catchError)(()=>(0, $g5fNy.of)(isLoggedIn))))).subscribe(()=>{
                window.history.pushState({}, document.title, window.location.pathname);
            });
        }
        userloggedIn() {
            this._isLoggedIn.next(true);
        }
        getUser() {
            return new (0, $8id0M.Observable)((observer)=>{
                const sub = $1MQ4j.auth().onAuthStateChanged((user)=>{
                    observer.next(user);
                    observer.complete();
                });
                return sub;
            });
        }
        getUserRef() {
            return (0, $g5fNy.of)($1MQ4j.auth().currentUser);
        }
        signInWithGithub(fn = (p)=>p) {
            return (0, $5JMLH.from)($1MQ4j.auth().signInWithPopup(fn(new $1MQ4j.auth.GithubAuthProvider())));
        }
        signInWithFacebook(fn = (p)=>p) {
            return (0, $5JMLH.from)($1MQ4j.auth().signInWithPopup(fn(new $1MQ4j.auth.FacebookAuthProvider())));
        }
        sendSignInLinkToEmail(email, returnUrl) {
            if (!returnUrl) return (0, $XfaK7.throwError)('missing-return-url');
            return (0, $5JMLH.from)($1MQ4j.auth().sendSignInLinkToEmail(email, {
                handleCodeInApp: true,
                url: returnUrl
            }));
        }
        signInWithGoogle(fn = (p)=>p) {
            return (0, $5JMLH.from)($1MQ4j.auth().signInWithPopup(fn(new $1MQ4j.auth.GoogleAuthProvider())));
        }
        signInWithTwitter(fn = (p)=>p) {
            return (0, $5JMLH.from)($1MQ4j.auth().signInWithPopup(fn(new $1MQ4j.auth.TwitterAuthProvider())));
        }
        signInWithEmailAndPassword(email, password) {
            return (0, $5JMLH.from)($1MQ4j.auth().signInWithEmailAndPassword(email, password));
        }
        createUserWithEmailAndPassword(email, password) {
            return (0, $5JMLH.from)($1MQ4j.auth().createUserWithEmailAndPassword(email, password));
        }
        signOut() {
            return (0, $5JMLH.from)($1MQ4j.auth().signOut()).pipe((0, $3dOhR.tap)(()=>{
                this._isLoggedIn.next(false);
                localStorage.clear();
            }));
        }
        checkLoggedIn() {
            return new (0, $8id0M.Observable)((o)=>{
                const unsubscribe = $1MQ4j.auth().onAuthStateChanged((user)=>{
                    o.next(!!user);
                    o.complete();
                    this._isLoggedIn.next(!!user);
                    unsubscribe();
                });
                return ()=>unsubscribe();
            });
        }
        resetPassword(email) {
            return (0, $5JMLH.from)($1MQ4j.auth().sendPasswordResetEmail(email));
        }
        linkAccount(type) {
            return this.getUserRef().pipe((0, $6Rz6W.filter)((userRef)=>!!userRef), (0, $lNnaw.switchMap)((userRef)=>userRef.linkWithPopup(this.getProvider(type))));
        }
        getProvider(type) {
            if (type === 'facebook') return new $1MQ4j.auth.FacebookAuthProvider();
            if (type === 'github') return new $1MQ4j.auth.GithubAuthProvider();
            if (type === 'google') return new $1MQ4j.auth.GoogleAuthProvider();
            if (type === 'twitter') return new $1MQ4j.auth.TwitterAuthProvider();
        }
        updateProfile(displayName, photoURL) {
            return this.getUserRef().pipe((0, $lNnaw.switchMap)((res)=>res.updateProfile({
                    displayName: displayName,
                    photoURL: photoURL
                })));
        }
    };
    SocialService = $6a378e085331f7f6$var$__decorate([
        (0, $1t8Wn.Injectable)({
            init: true
        }),
        $6a378e085331f7f6$var$__metadata("design:paramtypes", [])
    ], SocialService);
    return SocialService;
})();

});
parcelRegister("XfaK7", function(module, exports) {

$parcel$export(module.exports, "throwError", () => $0b2147b336b362a9$export$8bf7aba4a9e09055);

var $8id0M = parcelRequire("8id0M");

var $ePlbj = parcelRequire("ePlbj");
function $0b2147b336b362a9$export$8bf7aba4a9e09055(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, $ePlbj.isFunction)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, $8id0M.Observable)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}

});




parcelRegister("aNW6J", function(module, exports) {
$parcel$export(module.exports, "IotService", () => (parcelRequire("2YViC")).IotService);
parcelRequire("2YViC");

});
parcelRegister("2YViC", function(module, exports) {

$parcel$export(module.exports, "IotService", () => $22bda1ce97413256$export$8877586bdc2dec39);

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");

var $03mGZ = parcelRequire("03mGZ");
var $22bda1ce97413256$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $22bda1ce97413256$export$8877586bdc2dec39 = /** @class */ (()=>{
    let IotService = class IotService extends (0, $03mGZ.BaseService) {
        getTemperature() {
            return this.subscribe({
                query: 'get-temperature.graphql'
            }).pipe((0, $gawXH.map)((res)=>res.data.getTemperature));
        }
        getTemperatureHistory(serial, start_date) {
            return this.query({
                query: 'get-temperature-history.graphql',
                variables: {
                    serial: serial,
                    start_date: start_date
                }
            }).pipe((0, $gawXH.map)((res)=>res.data.getTemperatureHistory));
        }
        getSensorDateRanges(serial) {
            return this.query({
                query: 'get-sensor-date-ranges.graphql',
                variables: {
                    serial: serial
                }
            }).pipe((0, $gawXH.map)((res)=>res.data.getSensorDateRanges));
        }
        getLastTemperature() {
            return this.query({
                query: 'get-last-temperature.graphql'
            }).pipe((0, $gawXH.map)((res)=>res.data.getLastTemperature));
        }
        triggerRelay(state) {
            return this.mutate({
                mutation: 'trigger-relay.graphql',
                variables: {
                    state: state
                }
            }).pipe((0, $gawXH.map)((res)=>res.data.triggerRelay));
        }
        setDeviceOptions(serial, options) {
            return this.mutate({
                mutation: 'set-device-options.graphql',
                variables: {
                    serial: serial,
                    options: options
                }
            }).pipe((0, $gawXH.map)((res)=>res.data.setDeviceOptions));
        }
        updateDevice(serial, payload) {
            return this.mutate({
                mutation: 'update-device.graphql',
                variables: {
                    serial: serial,
                    payload: payload
                }
            });
        }
        listDevices() {
            return this.query({
                query: 'list-devices.graphql'
            }).pipe((0, $gawXH.map)(({ data: data })=>data.listDevices));
        }
        setFlowArguments(flowId, args) {
            return this.mutate({
                mutation: 'set-flow-arguments.graphql',
                variables: {
                    args: args,
                    flowId: flowId
                }
            }).pipe((0, $gawXH.map)((res)=>res.data.setFlowArguments));
        }
    };
    IotService = $22bda1ce97413256$var$__decorate([
        (0, $1t8Wn.Injectable)({
            init: true
        })
    ], IotService);
    return IotService;
})();

});
parcelRegister("03mGZ", function(module, exports) {

$parcel$export(module.exports, "BaseService", () => $00a1e22eb4ad6e28$export$3b34f4e23c444fa8);

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $5JMLH = parcelRequire("5JMLH");

var $nwE1I = parcelRequire("nwE1I");
var $00a1e22eb4ad6e28$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $00a1e22eb4ad6e28$var$__metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let $00a1e22eb4ad6e28$export$3b34f4e23c444fa8 = /** @class */ (()=>{
    class BaseService {
        query(options) {
            options.query = (0, $nwE1I.importQuery)(options.query);
            return (0, $5JMLH.from)(this.graphql.query.bind(this.graphql)(options));
        }
        mutate(options) {
            options.mutation = (0, $nwE1I.importQuery)(options.mutation);
            return (0, $5JMLH.from)(this.graphql.mutate.bind(this.graphql)(options));
        }
        subscribe(options) {
            options.query = (0, $nwE1I.importQuery)(options.query);
            return (0, $5JMLH.from)(this.graphql.subscribe.bind(this.graphql)(options));
        }
        watchQuery(options, raw) {
            if (!raw) options.query = (0, $nwE1I.importQuery)(options.query);
            return (0, $5JMLH.from)(this.graphql.watchQuery.bind(this.graphql)(options));
        }
    }
    $00a1e22eb4ad6e28$var$__decorate([
        (0, $1t8Wn.Injector)((0, $2O1GU.ApolloClient)),
        $00a1e22eb4ad6e28$var$__metadata("design:type", Object)
    ], BaseService.prototype, "graphql", void 0);
    return BaseService;
})();

});
parcelRegister("nwE1I", function(module, exports) {

$parcel$export(module.exports, "importQuery", () => $046b78a202b6032e$export$cf8fa1a0acea89ac);

var $eipcv = parcelRequire("eipcv");
function $046b78a202b6032e$export$cf8fa1a0acea89ac(search) {
    let result;
    Object.keys((0, $eipcv.DOCUMENTS)).filter((doc)=>{
        if (doc.indexOf(search) !== -1) result = (0, $eipcv.DOCUMENTS)[doc];
    });
    if (!result) throw new Error(`Missing query: ${search}`);
    return result;
}

});
parcelRegister("eipcv", function(module, exports) {

$parcel$export(module.exports, "DOCUMENTS", () => $a6864b7733be6764$export$2cbd0be658ac061c);
/* tslint:disable */ /* eslint-disable prettier/prettier */ const $a6864b7733be6764$export$2cbd0be658ac061c = {
    "src/services/flows/fragments/device.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 45,
                                    "end": 47
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 45,
                                "end": 47
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 50,
                                    "end": 54
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 50,
                                "end": 54
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 57,
                                    "end": 59
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 57,
                                "end": 59
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 62,
                                    "end": 65
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 65
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 68,
                                    "end": 74
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 68,
                                "end": 74
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 77,
                                    "end": 84
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 77,
                                "end": 84
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 87,
                                    "end": 92
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 87,
                                "end": 92
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 94
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 94
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 95
        },
        "name": {
            "kind": "Name",
            "value": "device.fragment.graphql"
        }
    },
    "src/services/flows/fragments/flow.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "FlowFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotFlowType",
                        "loc": {
                            "start": 25,
                            "end": 36
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 36
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 41,
                                    "end": 43
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 41,
                                "end": 43
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "userId",
                                "loc": {
                                    "start": 46,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "code",
                                "loc": {
                                    "start": 55,
                                    "end": 59
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 55,
                                "end": 59
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "args",
                                "loc": {
                                    "start": 62,
                                    "end": 66
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 66
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "device",
                                "loc": {
                                    "start": 69,
                                    "end": 75
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 69,
                                "end": 75
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "enabled",
                                "loc": {
                                    "start": 78,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 78,
                                "end": 85
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "deviceData",
                                "loc": {
                                    "start": 88,
                                    "end": 98
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DeviceFragment",
                                            "loc": {
                                                "start": 108,
                                                "end": 122
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 105,
                                            "end": 122
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 99,
                                    "end": 126
                                }
                            },
                            "loc": {
                                "start": 88,
                                "end": 126
                            }
                        }
                    ],
                    "loc": {
                        "start": 37,
                        "end": 128
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 128
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 48,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 54,
                                    "end": 60
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 60
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 62,
                                    "end": 64
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 64
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 66,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 66,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 71,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 80,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 129
        },
        "name": {
            "kind": "Name",
            "value": "flow.fragment.graphql"
        }
    },
    "src/services/flows/mutations/create-flow.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "createFlow",
                    "loc": {
                        "start": 9,
                        "end": 19
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 21,
                                    "end": 28
                                }
                            },
                            "loc": {
                                "start": 20,
                                "end": 28
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "IotFlowPayloadType",
                                    "loc": {
                                        "start": 30,
                                        "end": 48
                                    }
                                },
                                "loc": {
                                    "start": 30,
                                    "end": 48
                                }
                            },
                            "loc": {
                                "start": 30,
                                "end": 49
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 20,
                            "end": 49
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "createFlow",
                                "loc": {
                                    "start": 54,
                                    "end": 64
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 65,
                                            "end": 72
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 75,
                                                "end": 82
                                            }
                                        },
                                        "loc": {
                                            "start": 74,
                                            "end": 82
                                        }
                                    },
                                    "loc": {
                                        "start": 65,
                                        "end": 82
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 88,
                                                "end": 90
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 88,
                                            "end": 90
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "userId",
                                            "loc": {
                                                "start": 93,
                                                "end": 99
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 93,
                                            "end": 99
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "code",
                                            "loc": {
                                                "start": 102,
                                                "end": 106
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 102,
                                            "end": 106
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "args",
                                            "loc": {
                                                "start": 109,
                                                "end": 113
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 109,
                                            "end": 113
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "device",
                                            "loc": {
                                                "start": 116,
                                                "end": 122
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 116,
                                            "end": 122
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 84,
                                    "end": 125
                                }
                            },
                            "loc": {
                                "start": 54,
                                "end": 125
                            }
                        }
                    ],
                    "loc": {
                        "start": 51,
                        "end": 127
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 127
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 128
        },
        "name": {
            "kind": "Name",
            "value": "create-flow.graphql"
        }
    },
    "src/services/flows/mutations/set-flow-arguments.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "setFlowArguments",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "args",
                                "loc": {
                                    "start": 27,
                                    "end": 31
                                }
                            },
                            "loc": {
                                "start": 26,
                                "end": 31
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "JSON",
                                    "loc": {
                                        "start": 33,
                                        "end": 37
                                    }
                                },
                                "loc": {
                                    "start": 33,
                                    "end": 37
                                }
                            },
                            "loc": {
                                "start": 33,
                                "end": 38
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 26,
                            "end": 38
                        }
                    },
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "flowId",
                                "loc": {
                                    "start": 41,
                                    "end": 47
                                }
                            },
                            "loc": {
                                "start": 40,
                                "end": 47
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 49,
                                        "end": 55
                                    }
                                },
                                "loc": {
                                    "start": 49,
                                    "end": 55
                                }
                            },
                            "loc": {
                                "start": 49,
                                "end": 56
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 40,
                            "end": 56
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "setFlowArguments",
                                "loc": {
                                    "start": 62,
                                    "end": 78
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "args",
                                        "loc": {
                                            "start": 79,
                                            "end": 83
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "args",
                                            "loc": {
                                                "start": 86,
                                                "end": 90
                                            }
                                        },
                                        "loc": {
                                            "start": 85,
                                            "end": 90
                                        }
                                    },
                                    "loc": {
                                        "start": 79,
                                        "end": 90
                                    }
                                },
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowId",
                                        "loc": {
                                            "start": 92,
                                            "end": 98
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "flowId",
                                            "loc": {
                                                "start": 101,
                                                "end": 107
                                            }
                                        },
                                        "loc": {
                                            "start": 100,
                                            "end": 107
                                        }
                                    },
                                    "loc": {
                                        "start": 92,
                                        "end": 107
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 115,
                                                "end": 117
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 115,
                                            "end": 117
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "args",
                                            "loc": {
                                                "start": 122,
                                                "end": 126
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 122,
                                            "end": 126
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 109,
                                    "end": 130
                                }
                            },
                            "loc": {
                                "start": 62,
                                "end": 130
                            }
                        }
                    ],
                    "loc": {
                        "start": 58,
                        "end": 132
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 132
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 133
        },
        "name": {
            "kind": "Name",
            "value": "set-flow-arguments.graphql"
        }
    },
    "src/services/flows/mutations/update-flow.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "updateFlow",
                    "loc": {
                        "start": 9,
                        "end": 19
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "flowId",
                                "loc": {
                                    "start": 21,
                                    "end": 27
                                }
                            },
                            "loc": {
                                "start": 20,
                                "end": 27
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 29,
                                        "end": 35
                                    }
                                },
                                "loc": {
                                    "start": 29,
                                    "end": 35
                                }
                            },
                            "loc": {
                                "start": 29,
                                "end": 36
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 20,
                            "end": 36
                        }
                    },
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 39,
                                    "end": 46
                                }
                            },
                            "loc": {
                                "start": 38,
                                "end": 46
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "IotFlowPayloadType",
                                    "loc": {
                                        "start": 48,
                                        "end": 66
                                    }
                                },
                                "loc": {
                                    "start": 48,
                                    "end": 66
                                }
                            },
                            "loc": {
                                "start": 48,
                                "end": 67
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 38,
                            "end": 67
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updateFlow",
                                "loc": {
                                    "start": 72,
                                    "end": 82
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowId",
                                        "loc": {
                                            "start": 83,
                                            "end": 89
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "flowId",
                                            "loc": {
                                                "start": 92,
                                                "end": 98
                                            }
                                        },
                                        "loc": {
                                            "start": 91,
                                            "end": 98
                                        }
                                    },
                                    "loc": {
                                        "start": 83,
                                        "end": 98
                                    }
                                },
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 100,
                                            "end": 107
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 110,
                                                "end": 117
                                            }
                                        },
                                        "loc": {
                                            "start": 109,
                                            "end": 117
                                        }
                                    },
                                    "loc": {
                                        "start": 100,
                                        "end": 117
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 123,
                                                "end": 125
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 123,
                                            "end": 125
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "userId",
                                            "loc": {
                                                "start": 128,
                                                "end": 134
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 128,
                                            "end": 134
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "code",
                                            "loc": {
                                                "start": 137,
                                                "end": 141
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 137,
                                            "end": 141
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "args",
                                            "loc": {
                                                "start": 144,
                                                "end": 148
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 144,
                                            "end": 148
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "device",
                                            "loc": {
                                                "start": 151,
                                                "end": 157
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 151,
                                            "end": 157
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "enabled",
                                            "loc": {
                                                "start": 160,
                                                "end": 167
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 160,
                                            "end": 167
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 119,
                                    "end": 170
                                }
                            },
                            "loc": {
                                "start": 72,
                                "end": 170
                            }
                        }
                    ],
                    "loc": {
                        "start": 69,
                        "end": 172
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 172
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 173
        },
        "name": {
            "kind": "Name",
            "value": "update-flow.graphql"
        }
    },
    "src/services/flows/queries/get-flow.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "getFlow",
                    "loc": {
                        "start": 6,
                        "end": 13
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "flowId",
                                "loc": {
                                    "start": 15,
                                    "end": 21
                                }
                            },
                            "loc": {
                                "start": 14,
                                "end": 21
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 23,
                                        "end": 29
                                    }
                                },
                                "loc": {
                                    "start": 23,
                                    "end": 29
                                }
                            },
                            "loc": {
                                "start": 23,
                                "end": 30
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 14,
                            "end": 30
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "getFlow",
                                "loc": {
                                    "start": 36,
                                    "end": 43
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowId",
                                        "loc": {
                                            "start": 44,
                                            "end": 50
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "flowId",
                                            "loc": {
                                                "start": 53,
                                                "end": 59
                                            }
                                        },
                                        "loc": {
                                            "start": 52,
                                            "end": 59
                                        }
                                    },
                                    "loc": {
                                        "start": 44,
                                        "end": 59
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "FlowFragment",
                                            "loc": {
                                                "start": 70,
                                                "end": 82
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 67,
                                            "end": 82
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 61,
                                    "end": 86
                                }
                            },
                            "loc": {
                                "start": 36,
                                "end": 86
                            }
                        }
                    ],
                    "loc": {
                        "start": 32,
                        "end": 88
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 88
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "FlowFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotFlowType",
                        "loc": {
                            "start": 25,
                            "end": 36
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 36
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 41,
                                    "end": 43
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 41,
                                "end": 43
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "userId",
                                "loc": {
                                    "start": 46,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "code",
                                "loc": {
                                    "start": 55,
                                    "end": 59
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 55,
                                "end": 59
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "args",
                                "loc": {
                                    "start": 62,
                                    "end": 66
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 66
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "device",
                                "loc": {
                                    "start": 69,
                                    "end": 75
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 69,
                                "end": 75
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "enabled",
                                "loc": {
                                    "start": 78,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 78,
                                "end": 85
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "deviceData",
                                "loc": {
                                    "start": 88,
                                    "end": 98
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DeviceFragment",
                                            "loc": {
                                                "start": 108,
                                                "end": 122
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 105,
                                            "end": 122
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 99,
                                    "end": 126
                                }
                            },
                            "loc": {
                                "start": 88,
                                "end": 126
                            }
                        }
                    ],
                    "loc": {
                        "start": 37,
                        "end": 128
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 128
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 48,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 54,
                                    "end": 60
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 60
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 62,
                                    "end": 64
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 64
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 66,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 66,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 71,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 80,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 89
        },
        "name": {
            "kind": "Name",
            "value": "get-flow.graphql"
        }
    },
    "src/services/flows/queries/list-devices.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "listDevices",
                    "loc": {
                        "start": 6,
                        "end": 17
                    }
                },
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "listDevices",
                                "loc": {
                                    "start": 21,
                                    "end": 32
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DeviceFragment",
                                            "loc": {
                                                "start": 40,
                                                "end": 54
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 37,
                                            "end": 54
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 33,
                                    "end": 57
                                }
                            },
                            "loc": {
                                "start": 21,
                                "end": 57
                            }
                        }
                    ],
                    "loc": {
                        "start": 18,
                        "end": 59
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 59
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 48,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 54,
                                    "end": 60
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 60
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 62,
                                    "end": 64
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 64
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 66,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 66,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 71,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 80,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 60
        },
        "name": {
            "kind": "Name",
            "value": "list-devices.graphql"
        }
    },
    "src/services/flows/queries/list-flows.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "listFlows",
                    "loc": {
                        "start": 6,
                        "end": 15
                    }
                },
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "listFlows",
                                "loc": {
                                    "start": 20,
                                    "end": 29
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "FlowFragment",
                                            "loc": {
                                                "start": 39,
                                                "end": 51
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 36,
                                            "end": 51
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 30,
                                    "end": 55
                                }
                            },
                            "loc": {
                                "start": 20,
                                "end": 55
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "listDevices",
                                "loc": {
                                    "start": 59,
                                    "end": 70
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DeviceFragment",
                                            "loc": {
                                                "start": 80,
                                                "end": 94
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 77,
                                            "end": 94
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 71,
                                    "end": 98
                                }
                            },
                            "loc": {
                                "start": 59,
                                "end": 98
                            }
                        }
                    ],
                    "loc": {
                        "start": 16,
                        "end": 100
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 100
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "FlowFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotFlowType",
                        "loc": {
                            "start": 25,
                            "end": 36
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 36
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 41,
                                    "end": 43
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 41,
                                "end": 43
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "userId",
                                "loc": {
                                    "start": 46,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 46,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "code",
                                "loc": {
                                    "start": 55,
                                    "end": 59
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 55,
                                "end": 59
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "args",
                                "loc": {
                                    "start": 62,
                                    "end": 66
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 66
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "device",
                                "loc": {
                                    "start": 69,
                                    "end": 75
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 69,
                                "end": 75
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "enabled",
                                "loc": {
                                    "start": 78,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 78,
                                "end": 85
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "deviceData",
                                "loc": {
                                    "start": 88,
                                    "end": 98
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DeviceFragment",
                                            "loc": {
                                                "start": 108,
                                                "end": 122
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 105,
                                            "end": 122
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 99,
                                    "end": 126
                                }
                            },
                            "loc": {
                                "start": 88,
                                "end": 126
                            }
                        }
                    ],
                    "loc": {
                        "start": 37,
                        "end": 128
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 128
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 48,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 54,
                                    "end": 60
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 60
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 62,
                                    "end": 64
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 64
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 66,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 66,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 71,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 80,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 101
        },
        "name": {
            "kind": "Name",
            "value": "list-flows.graphql"
        }
    },
    "src/services/flows/subscriptions/flow-log.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "subscription",
                "name": {
                    "kind": "Name",
                    "value": "iotFlowLog",
                    "loc": {
                        "start": 13,
                        "end": 23
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "flowId",
                                "loc": {
                                    "start": 25,
                                    "end": 31
                                }
                            },
                            "loc": {
                                "start": 24,
                                "end": 31
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 33,
                                        "end": 39
                                    }
                                },
                                "loc": {
                                    "start": 33,
                                    "end": 39
                                }
                            },
                            "loc": {
                                "start": 33,
                                "end": 40
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 24,
                            "end": 40
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "iotFlowLog",
                                "loc": {
                                    "start": 45,
                                    "end": 55
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flowId",
                                        "loc": {
                                            "start": 56,
                                            "end": 62
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "flowId",
                                            "loc": {
                                                "start": 65,
                                                "end": 71
                                            }
                                        },
                                        "loc": {
                                            "start": 64,
                                            "end": 71
                                        }
                                    },
                                    "loc": {
                                        "start": 56,
                                        "end": 71
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "data",
                                            "loc": {
                                                "start": 77,
                                                "end": 81
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 77,
                                            "end": 81
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 84,
                                                "end": 90
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 84,
                                            "end": 90
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 73,
                                    "end": 93
                                }
                            },
                            "loc": {
                                "start": 45,
                                "end": 93
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 95
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 95
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 96
        },
        "name": {
            "kind": "Name",
            "value": "flow-log.graphql"
        }
    },
    "src/services/iot/fragments/device.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 48,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 54,
                                    "end": 60
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 60
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 62,
                                    "end": 64
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 64
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 66,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 66,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 71,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 80,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 88
        },
        "name": {
            "kind": "Name",
            "value": "device.fragment.graphql"
        }
    },
    "src/services/iot/fragments/domain-type.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DomainTypeFragment",
                    "loc": {
                        "start": 9,
                        "end": 27
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "DomainType",
                        "loc": {
                            "start": 31,
                            "end": 41
                        }
                    },
                    "loc": {
                        "start": 31,
                        "end": 41
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 45,
                                    "end": 47
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 45,
                                "end": 47
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 49,
                                    "end": 53
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 49,
                                "end": 53
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 55,
                                    "end": 57
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 55,
                                "end": 57
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "port",
                                "loc": {
                                    "start": 59,
                                    "end": 63
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 59,
                                "end": 63
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "sessionId",
                                "loc": {
                                    "start": 65,
                                    "end": 74
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 65,
                                "end": 74
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 76,
                                    "end": 83
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 76,
                                "end": 83
                            }
                        }
                    ],
                    "loc": {
                        "start": 42,
                        "end": 85
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 85
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 86
        },
        "name": {
            "kind": "Name",
            "value": "domain-type.fragment.graphql"
        }
    },
    "src/services/iot/mutations/get-last-temperature.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "getLastTemperature",
                    "loc": {
                        "start": 6,
                        "end": 24
                    }
                },
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "getLastTemperature",
                                "loc": {
                                    "start": 29,
                                    "end": 47
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "createdAt",
                                            "loc": {
                                                "start": 54,
                                                "end": 63
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 54,
                                            "end": 63
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "temp",
                                            "loc": {
                                                "start": 68,
                                                "end": 72
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 68,
                                            "end": 72
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "rh",
                                            "loc": {
                                                "start": 77,
                                                "end": 79
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 77,
                                            "end": 79
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 48,
                                    "end": 83
                                }
                            },
                            "loc": {
                                "start": 29,
                                "end": 83
                            }
                        }
                    ],
                    "loc": {
                        "start": 25,
                        "end": 85
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 85
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 86
        },
        "name": {
            "kind": "Name",
            "value": "get-last-temperature.graphql"
        }
    },
    "src/services/iot/mutations/get-temperature.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "subscription",
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "getTemperature",
                                "loc": {
                                    "start": 16,
                                    "end": 30
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "data",
                                            "loc": {
                                                "start": 35,
                                                "end": 39
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "raw",
                                                        "loc": {
                                                            "start": 45,
                                                            "end": 48
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 45,
                                                        "end": 48
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "rh",
                                                        "loc": {
                                                            "start": 52,
                                                            "end": 54
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 52,
                                                        "end": 54
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "temp",
                                                        "loc": {
                                                            "start": 58,
                                                            "end": 62
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 58,
                                                        "end": 62
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "createdAt",
                                                        "loc": {
                                                            "start": 66,
                                                            "end": 75
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 66,
                                                        "end": 75
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 40,
                                                "end": 79
                                            }
                                        },
                                        "loc": {
                                            "start": 35,
                                            "end": 79
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 82,
                                                "end": 88
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 82,
                                            "end": 88
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 31,
                                    "end": 91
                                }
                            },
                            "loc": {
                                "start": 16,
                                "end": 91
                            }
                        }
                    ],
                    "loc": {
                        "start": 13,
                        "end": 93
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 93
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 94
        },
        "name": {
            "kind": "Name",
            "value": "get-temperature.graphql"
        }
    },
    "src/services/iot/mutations/set-device-options.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "setDeviceOptions",
                    "loc": {
                        "start": 9,
                        "end": 25
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 27,
                                    "end": 34
                                }
                            },
                            "loc": {
                                "start": 26,
                                "end": 34
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "JSON",
                                    "loc": {
                                        "start": 36,
                                        "end": 40
                                    }
                                },
                                "loc": {
                                    "start": 36,
                                    "end": 40
                                }
                            },
                            "loc": {
                                "start": 36,
                                "end": 41
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 26,
                            "end": 41
                        }
                    },
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 44,
                                    "end": 50
                                }
                            },
                            "loc": {
                                "start": 43,
                                "end": 50
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 52,
                                        "end": 58
                                    }
                                },
                                "loc": {
                                    "start": 52,
                                    "end": 58
                                }
                            },
                            "loc": {
                                "start": 52,
                                "end": 59
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 43,
                            "end": 59
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "setDeviceOptions",
                                "loc": {
                                    "start": 64,
                                    "end": 80
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "options",
                                        "loc": {
                                            "start": 81,
                                            "end": 88
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "options",
                                            "loc": {
                                                "start": 91,
                                                "end": 98
                                            }
                                        },
                                        "loc": {
                                            "start": 90,
                                            "end": 98
                                        }
                                    },
                                    "loc": {
                                        "start": 81,
                                        "end": 98
                                    }
                                },
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "serial",
                                        "loc": {
                                            "start": 100,
                                            "end": 106
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 109,
                                                "end": 115
                                            }
                                        },
                                        "loc": {
                                            "start": 108,
                                            "end": 115
                                        }
                                    },
                                    "loc": {
                                        "start": 100,
                                        "end": 115
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 121,
                                                "end": 123
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 121,
                                            "end": 123
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "type",
                                            "loc": {
                                                "start": 126,
                                                "end": 130
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 126,
                                            "end": 130
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 133,
                                                "end": 139
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 133,
                                            "end": 139
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "ip",
                                            "loc": {
                                                "start": 142,
                                                "end": 144
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 142,
                                            "end": 144
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "mac",
                                            "loc": {
                                                "start": 147,
                                                "end": 150
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 147,
                                            "end": 150
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "options",
                                            "loc": {
                                                "start": 153,
                                                "end": 160
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 153,
                                            "end": 160
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 117,
                                    "end": 163
                                }
                            },
                            "loc": {
                                "start": 64,
                                "end": 163
                            }
                        }
                    ],
                    "loc": {
                        "start": 61,
                        "end": 165
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 165
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 166
        },
        "name": {
            "kind": "Name",
            "value": "set-device-options.graphql"
        }
    },
    "src/services/iot/mutations/trigger-relay.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "triggerRelay",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "state",
                                "loc": {
                                    "start": 23,
                                    "end": 28
                                }
                            },
                            "loc": {
                                "start": 22,
                                "end": 28
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "Int",
                                    "loc": {
                                        "start": 30,
                                        "end": 33
                                    }
                                },
                                "loc": {
                                    "start": 30,
                                    "end": 33
                                }
                            },
                            "loc": {
                                "start": 30,
                                "end": 34
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 22,
                            "end": 34
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "triggerRelay",
                                "loc": {
                                    "start": 39,
                                    "end": 51
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "state",
                                        "loc": {
                                            "start": 52,
                                            "end": 57
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "state",
                                            "loc": {
                                                "start": 60,
                                                "end": 65
                                            }
                                        },
                                        "loc": {
                                            "start": 59,
                                            "end": 65
                                        }
                                    },
                                    "loc": {
                                        "start": 52,
                                        "end": 65
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 71,
                                                "end": 73
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 71,
                                            "end": 73
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 76,
                                                "end": 82
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 76,
                                            "end": 82
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 67,
                                    "end": 85
                                }
                            },
                            "loc": {
                                "start": 39,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 36,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 88
        },
        "name": {
            "kind": "Name",
            "value": "trigger-relay.graphql"
        }
    },
    "src/services/iot/mutations/update-device.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "name": {
                    "kind": "Name",
                    "value": "updateDevice",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 23,
                                    "end": 29
                                }
                            },
                            "loc": {
                                "start": 22,
                                "end": 29
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 31,
                                        "end": 37
                                    }
                                },
                                "loc": {
                                    "start": 31,
                                    "end": 37
                                }
                            },
                            "loc": {
                                "start": 31,
                                "end": 38
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 22,
                            "end": 38
                        }
                    },
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "payload",
                                "loc": {
                                    "start": 41,
                                    "end": 48
                                }
                            },
                            "loc": {
                                "start": 40,
                                "end": 48
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "UpdateDeviceInputPayload",
                                    "loc": {
                                        "start": 50,
                                        "end": 74
                                    }
                                },
                                "loc": {
                                    "start": 50,
                                    "end": 74
                                }
                            },
                            "loc": {
                                "start": 50,
                                "end": 75
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 40,
                            "end": 75
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "updateDevice",
                                "loc": {
                                    "start": 80,
                                    "end": 92
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "serial",
                                        "loc": {
                                            "start": 93,
                                            "end": 99
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 102,
                                                "end": 108
                                            }
                                        },
                                        "loc": {
                                            "start": 101,
                                            "end": 108
                                        }
                                    },
                                    "loc": {
                                        "start": 93,
                                        "end": 108
                                    }
                                },
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "payload",
                                        "loc": {
                                            "start": 110,
                                            "end": 117
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "payload",
                                            "loc": {
                                                "start": 120,
                                                "end": 127
                                            }
                                        },
                                        "loc": {
                                            "start": 119,
                                            "end": 127
                                        }
                                    },
                                    "loc": {
                                        "start": 110,
                                        "end": 127
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DeviceFragment",
                                            "loc": {
                                                "start": 136,
                                                "end": 150
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 133,
                                            "end": 150
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 129,
                                    "end": 153
                                }
                            },
                            "loc": {
                                "start": 80,
                                "end": 153
                            }
                        }
                    ],
                    "loc": {
                        "start": 77,
                        "end": 155
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 155
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 48,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 54,
                                    "end": 60
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 60
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 62,
                                    "end": 64
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 64
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 66,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 66,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 71,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 80,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 156
        },
        "name": {
            "kind": "Name",
            "value": "update-device.graphql"
        }
    },
    "src/services/iot/queries/get-sensor-date-ranges.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "getSensorDateRanges",
                    "loc": {
                        "start": 6,
                        "end": 25
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 27,
                                    "end": 33
                                }
                            },
                            "loc": {
                                "start": 26,
                                "end": 33
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 35,
                                        "end": 41
                                    }
                                },
                                "loc": {
                                    "start": 35,
                                    "end": 41
                                }
                            },
                            "loc": {
                                "start": 35,
                                "end": 42
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 26,
                            "end": 42
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "getSensorDateRanges",
                                "loc": {
                                    "start": 48,
                                    "end": 67
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "serial",
                                        "loc": {
                                            "start": 68,
                                            "end": 74
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 77,
                                                "end": 83
                                            }
                                        },
                                        "loc": {
                                            "start": 76,
                                            "end": 83
                                        }
                                    },
                                    "loc": {
                                        "start": 68,
                                        "end": 83
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 84
                            }
                        }
                    ],
                    "loc": {
                        "start": 44,
                        "end": 86
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 86
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 87
        },
        "name": {
            "kind": "Name",
            "value": "get-sensor-date-ranges.graphql"
        }
    },
    "src/services/iot/queries/get-temperature-history.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "getTemperatureHistory",
                    "loc": {
                        "start": 6,
                        "end": 27
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 29,
                                    "end": 35
                                }
                            },
                            "loc": {
                                "start": 28,
                                "end": 35
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 37,
                                        "end": 43
                                    }
                                },
                                "loc": {
                                    "start": 37,
                                    "end": 43
                                }
                            },
                            "loc": {
                                "start": 37,
                                "end": 44
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 28,
                            "end": 44
                        }
                    },
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "start_date",
                                "loc": {
                                    "start": 47,
                                    "end": 57
                                }
                            },
                            "loc": {
                                "start": 46,
                                "end": 57
                            }
                        },
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String",
                                "loc": {
                                    "start": 59,
                                    "end": 65
                                }
                            },
                            "loc": {
                                "start": 59,
                                "end": 65
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 46,
                            "end": 65
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "getTemperatureHistory",
                                "loc": {
                                    "start": 71,
                                    "end": 92
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "serial",
                                        "loc": {
                                            "start": 93,
                                            "end": 99
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 102,
                                                "end": 108
                                            }
                                        },
                                        "loc": {
                                            "start": 101,
                                            "end": 108
                                        }
                                    },
                                    "loc": {
                                        "start": 93,
                                        "end": 108
                                    }
                                },
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "start_date",
                                        "loc": {
                                            "start": 110,
                                            "end": 120
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "start_date",
                                            "loc": {
                                                "start": 123,
                                                "end": 133
                                            }
                                        },
                                        "loc": {
                                            "start": 122,
                                            "end": 133
                                        }
                                    },
                                    "loc": {
                                        "start": 110,
                                        "end": 133
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 141,
                                                "end": 143
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 141,
                                            "end": 143
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "start_date",
                                            "loc": {
                                                "start": 148,
                                                "end": 158
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 148,
                                            "end": 158
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "serial",
                                            "loc": {
                                                "start": 163,
                                                "end": 169
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 163,
                                            "end": 169
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "data",
                                            "loc": {
                                                "start": 174,
                                                "end": 178
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "createdAt",
                                                        "loc": {
                                                            "start": 187,
                                                            "end": 196
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 187,
                                                        "end": 196
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "raw",
                                                        "loc": {
                                                            "start": 203,
                                                            "end": 206
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 203,
                                                        "end": 206
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "rh",
                                                        "loc": {
                                                            "start": 213,
                                                            "end": 215
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 213,
                                                        "end": 215
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "temp",
                                                        "loc": {
                                                            "start": 222,
                                                            "end": 226
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 222,
                                                        "end": 226
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 179,
                                                "end": 232
                                            }
                                        },
                                        "loc": {
                                            "start": 174,
                                            "end": 232
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 135,
                                    "end": 236
                                }
                            },
                            "loc": {
                                "start": 71,
                                "end": 236
                            }
                        }
                    ],
                    "loc": {
                        "start": 67,
                        "end": 238
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 238
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 239
        },
        "name": {
            "kind": "Name",
            "value": "get-temperature-history.graphql"
        }
    },
    "src/services/iot/queries/list-devices.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "listDevices",
                    "loc": {
                        "start": 6,
                        "end": 17
                    }
                },
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "listDevices",
                                "loc": {
                                    "start": 21,
                                    "end": 32
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DeviceFragment",
                                            "loc": {
                                                "start": 40,
                                                "end": 54
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 37,
                                            "end": 54
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 33,
                                    "end": 57
                                }
                            },
                            "loc": {
                                "start": 21,
                                "end": 57
                            }
                        }
                    ],
                    "loc": {
                        "start": 18,
                        "end": 59
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 59
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "DeviceFragment",
                    "loc": {
                        "start": 9,
                        "end": 23
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "IotDeviceType",
                        "loc": {
                            "start": 27,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 27,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 48,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "serial",
                                "loc": {
                                    "start": 54,
                                    "end": 60
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 60
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 62,
                                    "end": 64
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 62,
                                "end": 64
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "mac",
                                "loc": {
                                    "start": 66,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 66,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "options",
                                "loc": {
                                    "start": 71,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "debug",
                                "loc": {
                                    "start": 80,
                                    "end": 85
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 60
        },
        "name": {
            "kind": "Name",
            "value": "list-devices.graphql"
        }
    },
    "src/services/user/fragments/machine.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "MachineFragment",
                    "loc": {
                        "start": 9,
                        "end": 24
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "Machine",
                        "loc": {
                            "start": 28,
                            "end": 35
                        }
                    },
                    "loc": {
                        "start": 28,
                        "end": 35
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 39,
                                    "end": 41
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 39,
                                "end": 41
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "label",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 50,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 50,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "worker_type",
                                "loc": {
                                    "start": 54,
                                    "end": 65
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 65
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "machineHash",
                                "loc": {
                                    "start": 67,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 67,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "public",
                                "loc": {
                                    "start": 80,
                                    "end": 86
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 86
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "online",
                                "loc": {
                                    "start": 88,
                                    "end": 94
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 88,
                                "end": 94
                            }
                        }
                    ],
                    "loc": {
                        "start": 36,
                        "end": 96
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 96
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 97
        },
        "name": {
            "kind": "Name",
            "value": "machine.fragment.graphql"
        }
    },
    "src/services/user/fragments/user-partial.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserPartialFragment",
                    "loc": {
                        "start": 9,
                        "end": 28
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 32,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 32,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "cliToken",
                                "loc": {
                                    "start": 48,
                                    "end": 56
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 56
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "email",
                                "loc": {
                                    "start": 58,
                                    "end": 63
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 63
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 65,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 65,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "displayName",
                                "loc": {
                                    "start": 71,
                                    "end": 82
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 82
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 84,
                                    "end": 91
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 84,
                                "end": 91
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "photoURL",
                                "loc": {
                                    "start": 93,
                                    "end": 101
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 93,
                                "end": 101
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 103,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 103,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "scopes",
                                "loc": {
                                    "start": 109,
                                    "end": 115
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 109,
                                "end": 115
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 117
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 117
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 118
        },
        "name": {
            "kind": "Name",
            "value": "user-partial.fragment.graphql"
        }
    },
    "src/services/user/fragments/user.fragment.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": {
                                "kind": "Name",
                                "value": "UserPartialFragment",
                                "loc": {
                                    "start": 40,
                                    "end": 59
                                }
                            },
                            "directives": [],
                            "loc": {
                                "start": 37,
                                "end": 59
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "machines",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "MachineFragment",
                                            "loc": {
                                                "start": 77,
                                                "end": 92
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 74,
                                            "end": 92
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 95
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 95
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "sessions",
                                "loc": {
                                    "start": 97,
                                    "end": 105
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 110,
                                                "end": 112
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 110,
                                            "end": 112
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 115,
                                                "end": 119
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 115,
                                            "end": 119
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "active",
                                            "loc": {
                                                "start": 122,
                                                "end": 128
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 122,
                                            "end": 128
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "machineLabel",
                                            "loc": {
                                                "start": 131,
                                                "end": 143
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 131,
                                            "end": 143
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "cardId",
                                            "loc": {
                                                "start": 146,
                                                "end": 152
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 146,
                                            "end": 152
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "project",
                                            "loc": {
                                                "start": 155,
                                                "end": 162
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "id",
                                                        "loc": {
                                                            "start": 168,
                                                            "end": 170
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 168,
                                                        "end": 170
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "name",
                                                        "loc": {
                                                            "start": 174,
                                                            "end": 178
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 174,
                                                        "end": 178
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 163,
                                                "end": 182
                                            }
                                        },
                                        "loc": {
                                            "start": 155,
                                            "end": 182
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 106,
                                    "end": 185
                                }
                            },
                            "loc": {
                                "start": 97,
                                "end": 185
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "domains",
                                "loc": {
                                    "start": 187,
                                    "end": 194
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 199,
                                                "end": 201
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 199,
                                            "end": 201
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 204,
                                                "end": 208
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 204,
                                            "end": 208
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "ip",
                                            "loc": {
                                                "start": 211,
                                                "end": 213
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 211,
                                            "end": 213
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "port",
                                            "loc": {
                                                "start": 216,
                                                "end": 220
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 216,
                                            "end": 220
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "sessionId",
                                            "loc": {
                                                "start": 223,
                                                "end": 232
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 223,
                                            "end": 232
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "user_id",
                                            "loc": {
                                                "start": 235,
                                                "end": 242
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 235,
                                            "end": 242
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 195,
                                    "end": 245
                                }
                            },
                            "loc": {
                                "start": 187,
                                "end": 245
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 247
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 247
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserPartialFragment",
                    "loc": {
                        "start": 9,
                        "end": 28
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 32,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 32,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "cliToken",
                                "loc": {
                                    "start": 48,
                                    "end": 56
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 56
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "email",
                                "loc": {
                                    "start": 58,
                                    "end": 63
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 63
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 65,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 65,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "displayName",
                                "loc": {
                                    "start": 71,
                                    "end": 82
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 82
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 84,
                                    "end": 91
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 84,
                                "end": 91
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "photoURL",
                                "loc": {
                                    "start": 93,
                                    "end": 101
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 93,
                                "end": 101
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 103,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 103,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "scopes",
                                "loc": {
                                    "start": 109,
                                    "end": 115
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 109,
                                "end": 115
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 117
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 117
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "MachineFragment",
                    "loc": {
                        "start": 9,
                        "end": 24
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "Machine",
                        "loc": {
                            "start": 28,
                            "end": 35
                        }
                    },
                    "loc": {
                        "start": 28,
                        "end": 35
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 39,
                                    "end": 41
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 39,
                                "end": 41
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "label",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 50,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 50,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "worker_type",
                                "loc": {
                                    "start": 54,
                                    "end": 65
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 65
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "machineHash",
                                "loc": {
                                    "start": 67,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 67,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "public",
                                "loc": {
                                    "start": 80,
                                    "end": 86
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 86
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "online",
                                "loc": {
                                    "start": 88,
                                    "end": 94
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 88,
                                "end": 94
                            }
                        }
                    ],
                    "loc": {
                        "start": 36,
                        "end": 96
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 96
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 248
        },
        "name": {
            "kind": "Name",
            "value": "user.fragment.graphql"
        }
    },
    "src/services/user/mutation/generate-custom-token.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "mutation",
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "generateCustomToken",
                                "loc": {
                                    "start": 12,
                                    "end": 31
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "token",
                                            "loc": {
                                                "start": 36,
                                                "end": 41
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 36,
                                            "end": 41
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 32,
                                    "end": 44
                                }
                            },
                            "loc": {
                                "start": 12,
                                "end": 44
                            }
                        }
                    ],
                    "loc": {
                        "start": 9,
                        "end": 46
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 46
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 47
        },
        "name": {
            "kind": "Name",
            "value": "generate-custom-token.graphql"
        }
    },
    "src/services/user/queries/get-user-by-id.query.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "getUserById",
                    "loc": {
                        "start": 6,
                        "end": 17
                    }
                },
                "variableDefinitions": [
                    {
                        "kind": "VariableDefinition",
                        "variable": {
                            "kind": "Variable",
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 19,
                                    "end": 21
                                }
                            },
                            "loc": {
                                "start": 18,
                                "end": 21
                            }
                        },
                        "type": {
                            "kind": "NonNullType",
                            "type": {
                                "kind": "NamedType",
                                "name": {
                                    "kind": "Name",
                                    "value": "String",
                                    "loc": {
                                        "start": 23,
                                        "end": 29
                                    }
                                },
                                "loc": {
                                    "start": 23,
                                    "end": 29
                                }
                            },
                            "loc": {
                                "start": 23,
                                "end": 30
                            }
                        },
                        "defaultValue": null,
                        "loc": {
                            "start": 18,
                            "end": 30
                        }
                    }
                ],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "getUserById",
                                "loc": {
                                    "start": 35,
                                    "end": 46
                                }
                            },
                            "arguments": [
                                {
                                    "kind": "Argument",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id",
                                        "loc": {
                                            "start": 47,
                                            "end": 49
                                        }
                                    },
                                    "value": {
                                        "kind": "Variable",
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 52,
                                                "end": 54
                                            }
                                        },
                                        "loc": {
                                            "start": 51,
                                            "end": 54
                                        }
                                    },
                                    "loc": {
                                        "start": 47,
                                        "end": 54
                                    }
                                }
                            ],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "UserPartialFragment",
                                            "loc": {
                                                "start": 63,
                                                "end": 82
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 60,
                                            "end": 82
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 56,
                                    "end": 85
                                }
                            },
                            "loc": {
                                "start": 35,
                                "end": 85
                            }
                        }
                    ],
                    "loc": {
                        "start": 32,
                        "end": 87
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 87
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserPartialFragment",
                    "loc": {
                        "start": 9,
                        "end": 28
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 32,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 32,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "cliToken",
                                "loc": {
                                    "start": 48,
                                    "end": 56
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 56
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "email",
                                "loc": {
                                    "start": 58,
                                    "end": 63
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 63
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 65,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 65,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "displayName",
                                "loc": {
                                    "start": 71,
                                    "end": 82
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 82
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 84,
                                    "end": 91
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 84,
                                "end": 91
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "photoURL",
                                "loc": {
                                    "start": 93,
                                    "end": 101
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 93,
                                "end": 101
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 103,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 103,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "scopes",
                                "loc": {
                                    "start": 109,
                                    "end": 115
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 109,
                                "end": 115
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 117
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 117
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 88
        },
        "name": {
            "kind": "Name",
            "value": "get-user-by-id.query.graphql"
        }
    },
    "src/services/user/queries/get-user.query.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "me",
                    "loc": {
                        "start": 6,
                        "end": 8
                    }
                },
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "me",
                                "loc": {
                                    "start": 12,
                                    "end": 14
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "UserFragment",
                                            "loc": {
                                                "start": 22,
                                                "end": 34
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 19,
                                            "end": 34
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 15,
                                    "end": 37
                                }
                            },
                            "loc": {
                                "start": 12,
                                "end": 37
                            }
                        }
                    ],
                    "loc": {
                        "start": 9,
                        "end": 39
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 39
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserFragment",
                    "loc": {
                        "start": 9,
                        "end": 21
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 25,
                            "end": 33
                        }
                    },
                    "loc": {
                        "start": 25,
                        "end": 33
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": {
                                "kind": "Name",
                                "value": "UserPartialFragment",
                                "loc": {
                                    "start": 40,
                                    "end": 59
                                }
                            },
                            "directives": [],
                            "loc": {
                                "start": 37,
                                "end": 59
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "machines",
                                "loc": {
                                    "start": 61,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "MachineFragment",
                                            "loc": {
                                                "start": 77,
                                                "end": 92
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 74,
                                            "end": 92
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 70,
                                    "end": 95
                                }
                            },
                            "loc": {
                                "start": 61,
                                "end": 95
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "sessions",
                                "loc": {
                                    "start": 97,
                                    "end": 105
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 110,
                                                "end": 112
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 110,
                                            "end": 112
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 115,
                                                "end": 119
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 115,
                                            "end": 119
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "active",
                                            "loc": {
                                                "start": 122,
                                                "end": 128
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 122,
                                            "end": 128
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "machineLabel",
                                            "loc": {
                                                "start": 131,
                                                "end": 143
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 131,
                                            "end": 143
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "cardId",
                                            "loc": {
                                                "start": 146,
                                                "end": 152
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 146,
                                            "end": 152
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "project",
                                            "loc": {
                                                "start": 155,
                                                "end": 162
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": {
                                            "kind": "SelectionSet",
                                            "selections": [
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "id",
                                                        "loc": {
                                                            "start": 168,
                                                            "end": 170
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 168,
                                                        "end": 170
                                                    }
                                                },
                                                {
                                                    "kind": "Field",
                                                    "alias": null,
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "name",
                                                        "loc": {
                                                            "start": 174,
                                                            "end": 178
                                                        }
                                                    },
                                                    "arguments": [],
                                                    "directives": [],
                                                    "selectionSet": null,
                                                    "loc": {
                                                        "start": 174,
                                                        "end": 178
                                                    }
                                                }
                                            ],
                                            "loc": {
                                                "start": 163,
                                                "end": 182
                                            }
                                        },
                                        "loc": {
                                            "start": 155,
                                            "end": 182
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 106,
                                    "end": 185
                                }
                            },
                            "loc": {
                                "start": 97,
                                "end": 185
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "domains",
                                "loc": {
                                    "start": 187,
                                    "end": 194
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "id",
                                            "loc": {
                                                "start": 199,
                                                "end": 201
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 199,
                                            "end": 201
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "name",
                                            "loc": {
                                                "start": 204,
                                                "end": 208
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 204,
                                            "end": 208
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "ip",
                                            "loc": {
                                                "start": 211,
                                                "end": 213
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 211,
                                            "end": 213
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "port",
                                            "loc": {
                                                "start": 216,
                                                "end": 220
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 216,
                                            "end": 220
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "sessionId",
                                            "loc": {
                                                "start": 223,
                                                "end": 232
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 223,
                                            "end": 232
                                        }
                                    },
                                    {
                                        "kind": "Field",
                                        "alias": null,
                                        "name": {
                                            "kind": "Name",
                                            "value": "user_id",
                                            "loc": {
                                                "start": 235,
                                                "end": 242
                                            }
                                        },
                                        "arguments": [],
                                        "directives": [],
                                        "selectionSet": null,
                                        "loc": {
                                            "start": 235,
                                            "end": 242
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 195,
                                    "end": 245
                                }
                            },
                            "loc": {
                                "start": 187,
                                "end": 245
                            }
                        }
                    ],
                    "loc": {
                        "start": 34,
                        "end": 247
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 247
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserPartialFragment",
                    "loc": {
                        "start": 9,
                        "end": 28
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 32,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 32,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "cliToken",
                                "loc": {
                                    "start": 48,
                                    "end": 56
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 56
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "email",
                                "loc": {
                                    "start": 58,
                                    "end": 63
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 63
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 65,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 65,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "displayName",
                                "loc": {
                                    "start": 71,
                                    "end": 82
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 82
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 84,
                                    "end": 91
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 84,
                                "end": 91
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "photoURL",
                                "loc": {
                                    "start": 93,
                                    "end": 101
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 93,
                                "end": 101
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 103,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 103,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "scopes",
                                "loc": {
                                    "start": 109,
                                    "end": 115
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 109,
                                "end": 115
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 117
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 117
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "MachineFragment",
                    "loc": {
                        "start": 9,
                        "end": 24
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "Machine",
                        "loc": {
                            "start": 28,
                            "end": 35
                        }
                    },
                    "loc": {
                        "start": 28,
                        "end": 35
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 39,
                                    "end": 41
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 39,
                                "end": 41
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "label",
                                "loc": {
                                    "start": 43,
                                    "end": 48
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 43,
                                "end": 48
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "ip",
                                "loc": {
                                    "start": 50,
                                    "end": 52
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 50,
                                "end": 52
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "worker_type",
                                "loc": {
                                    "start": 54,
                                    "end": 65
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 54,
                                "end": 65
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "machineHash",
                                "loc": {
                                    "start": 67,
                                    "end": 78
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 67,
                                "end": 78
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "public",
                                "loc": {
                                    "start": 80,
                                    "end": 86
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 80,
                                "end": 86
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "online",
                                "loc": {
                                    "start": 88,
                                    "end": 94
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 88,
                                "end": 94
                            }
                        }
                    ],
                    "loc": {
                        "start": 36,
                        "end": 96
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 96
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 40
        },
        "name": {
            "kind": "Name",
            "value": "get-user.query.graphql"
        }
    },
    "src/services/user/queries/list-users.graphql": {
        "kind": "Document",
        "definitions": [
            {
                "kind": "OperationDefinition",
                "operation": "query",
                "name": {
                    "kind": "Name",
                    "value": "listUsers",
                    "loc": {
                        "start": 6,
                        "end": 15
                    }
                },
                "variableDefinitions": [],
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "listUsers",
                                "loc": {
                                    "start": 19,
                                    "end": 28
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": {
                                "kind": "SelectionSet",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": {
                                            "kind": "Name",
                                            "value": "UserPartialFragment",
                                            "loc": {
                                                "start": 36,
                                                "end": 55
                                            }
                                        },
                                        "directives": [],
                                        "loc": {
                                            "start": 33,
                                            "end": 55
                                        }
                                    }
                                ],
                                "loc": {
                                    "start": 29,
                                    "end": 58
                                }
                            },
                            "loc": {
                                "start": 19,
                                "end": 58
                            }
                        }
                    ],
                    "loc": {
                        "start": 16,
                        "end": 60
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 60
                }
            },
            {
                "kind": "FragmentDefinition",
                "name": {
                    "kind": "Name",
                    "value": "UserPartialFragment",
                    "loc": {
                        "start": 9,
                        "end": 28
                    }
                },
                "typeCondition": {
                    "kind": "NamedType",
                    "name": {
                        "kind": "Name",
                        "value": "UserType",
                        "loc": {
                            "start": 32,
                            "end": 40
                        }
                    },
                    "loc": {
                        "start": 32,
                        "end": 40
                    }
                },
                "directives": [],
                "selectionSet": {
                    "kind": "SelectionSet",
                    "selections": [
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "id",
                                "loc": {
                                    "start": 44,
                                    "end": 46
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 44,
                                "end": 46
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "cliToken",
                                "loc": {
                                    "start": 48,
                                    "end": 56
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 48,
                                "end": 56
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "email",
                                "loc": {
                                    "start": 58,
                                    "end": 63
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 58,
                                "end": 63
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "name",
                                "loc": {
                                    "start": 65,
                                    "end": 69
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 65,
                                "end": 69
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "displayName",
                                "loc": {
                                    "start": 71,
                                    "end": 82
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 71,
                                "end": 82
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "user_id",
                                "loc": {
                                    "start": 84,
                                    "end": 91
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 84,
                                "end": 91
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "photoURL",
                                "loc": {
                                    "start": 93,
                                    "end": 101
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 93,
                                "end": 101
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "type",
                                "loc": {
                                    "start": 103,
                                    "end": 107
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 103,
                                "end": 107
                            }
                        },
                        {
                            "kind": "Field",
                            "alias": null,
                            "name": {
                                "kind": "Name",
                                "value": "scopes",
                                "loc": {
                                    "start": 109,
                                    "end": 115
                                }
                            },
                            "arguments": [],
                            "directives": [],
                            "selectionSet": null,
                            "loc": {
                                "start": 109,
                                "end": 115
                            }
                        }
                    ],
                    "loc": {
                        "start": 41,
                        "end": 117
                    }
                },
                "loc": {
                    "start": 0,
                    "end": 117
                }
            }
        ],
        "loc": {
            "start": 0,
            "end": 61
        },
        "name": {
            "kind": "Name",
            "value": "list-users.graphql"
        }
    }
};

});





parcelRegister("xtegK", function(module, exports) {
$parcel$export(module.exports, "IotFlowsService", () => (parcelRequire("cNJGF")).IotFlowsService);
parcelRequire("cNJGF");

});
parcelRegister("cNJGF", function(module, exports) {

$parcel$export(module.exports, "IotFlowsService", () => $951d8028b6e19b86$export$2ed8146655d670f2);

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");

var $03mGZ = parcelRequire("03mGZ");
var $951d8028b6e19b86$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $951d8028b6e19b86$export$2ed8146655d670f2 = /** @class */ (()=>{
    let IotFlowsService = class IotFlowsService extends (0, $03mGZ.BaseService) {
        listFlows() {
            return this.query({
                query: 'list-flows.graphql'
            }).pipe((0, $gawXH.map)(({ data: data })=>data));
        }
        getFlow(flowId) {
            return this.query({
                query: 'get-flow.graphql',
                variables: {
                    flowId: flowId
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.getFlow));
        }
        createFlow(payload) {
            return this.mutate({
                mutation: 'create-flow.graphql',
                variables: {
                    payload: payload
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.createFlow));
        }
        updateFlow(flowId, payload) {
            return this.mutate({
                mutation: 'update-flow.graphql',
                variables: {
                    flowId: flowId,
                    payload: payload
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.updateFlow));
        }
        flowLog(flowId) {
            return this.subscribe({
                query: 'flow-log.graphql',
                variables: {
                    flowId: flowId
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.iotFlowLog));
        }
        setFlowArguments(flowId, args) {
            return this.mutate({
                mutation: 'set-flow-arguments.graphql',
                variables: {
                    args: args,
                    flowId: flowId
                }
            }).pipe((0, $gawXH.map)((res)=>res.data.setFlowArguments));
        }
    };
    IotFlowsService = $951d8028b6e19b86$var$__decorate([
        (0, $1t8Wn.Injectable)()
    ], IotFlowsService);
    return IotFlowsService;
})();

});


parcelRegister("dCd0u", function(module, exports) {
parcelRequire("03mGZ");

});

parcelRegister("5pp6R", function(module, exports) {
parcelRequire("kezEQ");
parcelRequire("bgIXq");

});
parcelRegister("kezEQ", function(module, exports) {

var $1t8Wn = parcelRequire("1t8Wn");

var $gawXH = parcelRequire("gawXH");
var $d5Aat = parcelRequire("d5Aat");

var $bgIXq = parcelRequire("bgIXq");
var $ebb0c654ba5f08bd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ebb0c654ba5f08bd$var$__metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let $ebb0c654ba5f08bd$export$254161f9c6172d5d = /** @class */ (()=>{
    let UserScopeService = class UserScopeService {
        canViewProfileSession() {
            return this.userService.getUserOnce().pipe((0, $gawXH.map)((u)=>{
                var _a;
                return !!((_a = u.scopes) === null || _a === void 0 ? void 0 : _a.includes('CAN_VIEW_PROFILE_SESSIONS'));
            }));
        }
        canListAllUsers() {
            return this.userService.getUserOnce().pipe((0, $gawXH.map)((u)=>{
                var _a;
                return !!((_a = u.scopes) === null || _a === void 0 ? void 0 : _a.includes('CAN_LIST_ALL_USERS'));
            }));
        }
        canViewApps() {
            return this.userService.getUserOnce().pipe((0, $d5Aat.take)(1), (0, $gawXH.map)((u)=>{
                var _a;
                return !!((_a = u.scopes) === null || _a === void 0 ? void 0 : _a.includes('CAN_VIEW_APPS'));
            }));
        }
    };
    $ebb0c654ba5f08bd$var$__decorate([
        (0, $1t8Wn.Inject)((0, $bgIXq.UserService)),
        $ebb0c654ba5f08bd$var$__metadata("design:type", (0, $bgIXq.UserService))
    ], UserScopeService.prototype, "userService", void 0);
    UserScopeService = $ebb0c654ba5f08bd$var$__decorate([
        (0, $1t8Wn.Injectable)()
    ], UserScopeService);
    return UserScopeService;
})();

});
parcelRegister("bgIXq", function(module, exports) {

$parcel$export(module.exports, "UserService", () => $83440fecf56313a1$export$a81c579a392aa9d2);

var $1t8Wn = parcelRequire("1t8Wn");

var $g5fNy = parcelRequire("g5fNy");

var $gawXH = parcelRequire("gawXH");
var $lNnaw = parcelRequire("lNnaw");
var $d5Aat = parcelRequire("d5Aat");
var $3dOhR = parcelRequire("3dOhR");

var $03mGZ = parcelRequire("03mGZ");

var $97odG = parcelRequire("97odG");
var $83440fecf56313a1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $83440fecf56313a1$var$__metadata = undefined && undefined.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let $83440fecf56313a1$export$a81c579a392aa9d2 = /** @class */ (()=>{
    let UserService = class UserService extends (0, $03mGZ.BaseService) {
        constructor(){
            super(...arguments);
            this.cache = true;
        }
        canViewProfileSession() {
            return this.getUserOnce().pipe((0, $d5Aat.take)(1), (0, $gawXH.map)((u)=>{
                var _a;
                return !!((_a = u.scopes) === null || _a === void 0 ? void 0 : _a.includes('CAN_VIEW_PROFILE_SESSIONS'));
            }));
        }
        setCache(cache) {
            this.cache = cache;
        }
        getUser() {
            return this.socialService.getUser().pipe((0, $gawXH.map)((res)=>res.uid), (0, $3dOhR.tap)((id)=>this.user_id = id), (0, $lNnaw.switchMap)((uid)=>this.getUserQuery(uid)));
        }
        generateCustomToken() {
            if (this.customToken) return (0, $g5fNy.of)(this.customToken);
            return this.mutate({
                mutation: 'generate-custom-token.graphql'
            }).pipe((0, $gawXH.map)(({ data: data })=>data.generateCustomToken.token), (0, $3dOhR.tap)((token)=>this.customToken = token));
        }
        getUserById(id) {
            return this.query({
                query: 'get-user-by-id.query.graphql',
                variables: {
                    id: id
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.getUserById));
        }
        getUserOnce() {
            return this.socialService.getUser().pipe((0, $gawXH.map)((res)=>res.uid), (0, $3dOhR.tap)((id)=>this.user_id = id), (0, $lNnaw.switchMap)(()=>this.query({
                    query: 'get-user.query.graphql',
                    variables: {
                        user_id: this.user_id
                    }
                }).pipe((0, $gawXH.map)(({ data: data })=>data.me))));
        }
        getUserQuery(user_id) {
            return this.watchQuery({
                query: 'get-user.query.graphql',
                errorPolicy: 'all',
                fetchPolicy: this.cache ? null : 'network-only',
                variables: {
                    user_id: user_id
                }
            }).pipe((0, $gawXH.map)(({ data: data })=>data.me));
        }
        listUsers() {
            return this.query({
                query: 'list-users.graphql'
            }).pipe((0, $gawXH.map)(({ data: data })=>data.listUsers));
        }
    };
    $83440fecf56313a1$var$__decorate([
        (0, $1t8Wn.Inject)((0, $97odG.SocialService)),
        $83440fecf56313a1$var$__metadata("design:type", (0, $97odG.SocialService))
    ], UserService.prototype, "socialService", void 0);
    UserService = $83440fecf56313a1$var$__decorate([
        (0, $1t8Wn.Injectable)()
    ], UserService);
    return UserService;
})();

});



parcelRegister("gGEGx", function(module, exports) {
$parcel$export(module.exports, "LocalStorageService", () => (parcelRequire("2yHHh")).LocalStorageService);
parcelRequire("2yHHh");

});
parcelRegister("2yHHh", function(module, exports) {

$parcel$export(module.exports, "LocalStorageService", () => $1dd0a70e6beaeab9$export$fda5b86bc4921cb9);

var $1t8Wn = parcelRequire("1t8Wn");

var $dyOK5 = parcelRequire("dyOK5");
var $1dd0a70e6beaeab9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1dd0a70e6beaeab9$export$fda5b86bc4921cb9 = /** @class */ (()=>{
    let LocalStorageService = class LocalStorageService {
        get(name) {
            const item = localStorage.getItem(name);
            try {
                return JSON.parse(item);
            } catch (e) {
                return item;
            }
        }
        update(name, payload) {
            localStorage.setItem(name, (0, $dyOK5.isPrimitive)(payload) ? payload : JSON.stringify(payload));
        }
        clear() {
            localStorage.clear();
        }
        remove(name) {
            localStorage.removeItem(name);
        }
    };
    LocalStorageService = $1dd0a70e6beaeab9$var$__decorate([
        (0, $1t8Wn.Injectable)()
    ], LocalStorageService);
    return LocalStorageService;
})();

});
parcelRegister("dyOK5", function(module, exports) {

$parcel$export(module.exports, "isPrimitive", () => $9df5cfb8af081785$export$c3825b437cbdea5c);
const $9df5cfb8af081785$export$c3825b437cbdea5c = (value)=>value !== Object(value);

});





parcelRegister("6LnE2", function(module, exports) {
"use strict";
var $4ec97936cf3df007$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4ec97936cf3df007$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4ec97936cf3df007$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4ec97936cf3df007$var$__exportStar((parcelRequire("cHWBH")), module.exports);

});
parcelRegister("cHWBH", function(module, exports) {

var $i9F75 = parcelRequire("i9F75");
var $9406f6547c261874$require$Buffer = $i9F75.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LZWService = void 0;

var $fq2va = parcelRequire("fq2va");

var $8UW2c = parcelRequire("8UW2c");

var $k2Xkw = parcelRequire("k2Xkw");
class $9406f6547c261874$var$LZWService {
    static compress(object) {
        const packed = $fq2va().encode(object);
        const compressed = $9406f6547c261874$require$Buffer.from($8UW2c.encode(packed.toString("binary")));
        const encoded = $k2Xkw.encode(compressed);
        return encoded;
    }
    static decompress(string) {
        const decoded = $k2Xkw.decode(string);
        const decompressed = $9406f6547c261874$require$Buffer.from($8UW2c.decode(decoded), "binary");
        const unpacked = $fq2va().decode(decompressed);
        return unpacked;
    }
}
module.exports.LZWService = $9406f6547c261874$var$LZWService;

});
parcelRegister("i9F75", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $d378f57e98b8d533$export$a143d493d941bafc, (v) => $d378f57e98b8d533$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $d378f57e98b8d533$export$e4cf37d7f6fb9e0a, (v) => $d378f57e98b8d533$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $d378f57e98b8d533$export$f99ded8fe4b79145, (v) => $d378f57e98b8d533$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $d378f57e98b8d533$export$599f31c3813fae4d, (v) => $d378f57e98b8d533$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d378f57e98b8d533$export$a143d493d941bafc;
var $d378f57e98b8d533$export$e4cf37d7f6fb9e0a;
var $d378f57e98b8d533$export$f99ded8fe4b79145;
var $d378f57e98b8d533$export$599f31c3813fae4d;
'use strict';

var $jdJcJ = parcelRequire("jdJcJ");

var $8cJBk = parcelRequire("8cJBk");
var $d378f57e98b8d533$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d378f57e98b8d533$export$a143d493d941bafc = $d378f57e98b8d533$var$Buffer;
$d378f57e98b8d533$export$e4cf37d7f6fb9e0a = $d378f57e98b8d533$var$SlowBuffer;
$d378f57e98b8d533$export$f99ded8fe4b79145 = 50;
var $d378f57e98b8d533$var$K_MAX_LENGTH = 0x7fffffff;
$d378f57e98b8d533$export$599f31c3813fae4d = $d378f57e98b8d533$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d378f57e98b8d533$var$Buffer.TYPED_ARRAY_SUPPORT = $d378f57e98b8d533$var$typedArraySupport();
if (!$d378f57e98b8d533$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d378f57e98b8d533$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d378f57e98b8d533$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d378f57e98b8d533$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d378f57e98b8d533$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d378f57e98b8d533$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d378f57e98b8d533$var$createBuffer(length) {
    if (length > $d378f57e98b8d533$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d378f57e98b8d533$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d378f57e98b8d533$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d378f57e98b8d533$var$allocUnsafe(arg);
    }
    return $d378f57e98b8d533$var$from(arg, encodingOrOffset, length);
}
$d378f57e98b8d533$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d378f57e98b8d533$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d378f57e98b8d533$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d378f57e98b8d533$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d378f57e98b8d533$var$isInstance(value, ArrayBuffer) || value && $d378f57e98b8d533$var$isInstance(value.buffer, ArrayBuffer)) return $d378f57e98b8d533$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d378f57e98b8d533$var$isInstance(value, SharedArrayBuffer) || value && $d378f57e98b8d533$var$isInstance(value.buffer, SharedArrayBuffer))) return $d378f57e98b8d533$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d378f57e98b8d533$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d378f57e98b8d533$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d378f57e98b8d533$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d378f57e98b8d533$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d378f57e98b8d533$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d378f57e98b8d533$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d378f57e98b8d533$var$Buffer, Uint8Array);
function $d378f57e98b8d533$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d378f57e98b8d533$var$alloc(size, fill, encoding) {
    $d378f57e98b8d533$var$assertSize(size);
    if (size <= 0) return $d378f57e98b8d533$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d378f57e98b8d533$var$createBuffer(size).fill(fill, encoding) : $d378f57e98b8d533$var$createBuffer(size).fill(fill);
    return $d378f57e98b8d533$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d378f57e98b8d533$var$Buffer.alloc = function(size, fill, encoding) {
    return $d378f57e98b8d533$var$alloc(size, fill, encoding);
};
function $d378f57e98b8d533$var$allocUnsafe(size) {
    $d378f57e98b8d533$var$assertSize(size);
    return $d378f57e98b8d533$var$createBuffer(size < 0 ? 0 : $d378f57e98b8d533$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d378f57e98b8d533$var$Buffer.allocUnsafe = function(size) {
    return $d378f57e98b8d533$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d378f57e98b8d533$var$Buffer.allocUnsafeSlow = function(size) {
    return $d378f57e98b8d533$var$allocUnsafe(size);
};
function $d378f57e98b8d533$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d378f57e98b8d533$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d378f57e98b8d533$var$byteLength(string, encoding) | 0;
    var buf = $d378f57e98b8d533$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d378f57e98b8d533$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d378f57e98b8d533$var$checked(array.length) | 0;
    var buf = $d378f57e98b8d533$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d378f57e98b8d533$var$fromArrayView(arrayView) {
    if ($d378f57e98b8d533$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d378f57e98b8d533$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d378f57e98b8d533$var$fromArrayLike(arrayView);
}
function $d378f57e98b8d533$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d378f57e98b8d533$var$Buffer.prototype);
    return buf;
}
function $d378f57e98b8d533$var$fromObject(obj) {
    if ($d378f57e98b8d533$var$Buffer.isBuffer(obj)) {
        var len = $d378f57e98b8d533$var$checked(obj.length) | 0;
        var buf = $d378f57e98b8d533$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d378f57e98b8d533$var$numberIsNaN(obj.length)) return $d378f57e98b8d533$var$createBuffer(0);
        return $d378f57e98b8d533$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d378f57e98b8d533$var$fromArrayLike(obj.data);
}
function $d378f57e98b8d533$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d378f57e98b8d533$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d378f57e98b8d533$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d378f57e98b8d533$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d378f57e98b8d533$var$Buffer.alloc(+length);
}
$d378f57e98b8d533$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d378f57e98b8d533$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d378f57e98b8d533$var$Buffer.compare = function compare(a, b) {
    if ($d378f57e98b8d533$var$isInstance(a, Uint8Array)) a = $d378f57e98b8d533$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d378f57e98b8d533$var$isInstance(b, Uint8Array)) b = $d378f57e98b8d533$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d378f57e98b8d533$var$Buffer.isBuffer(a) || !$d378f57e98b8d533$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d378f57e98b8d533$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d378f57e98b8d533$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d378f57e98b8d533$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d378f57e98b8d533$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d378f57e98b8d533$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d378f57e98b8d533$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d378f57e98b8d533$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d378f57e98b8d533$var$byteLength(string, encoding) {
    if ($d378f57e98b8d533$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d378f57e98b8d533$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d378f57e98b8d533$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d378f57e98b8d533$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d378f57e98b8d533$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d378f57e98b8d533$var$Buffer.byteLength = $d378f57e98b8d533$var$byteLength;
function $d378f57e98b8d533$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d378f57e98b8d533$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d378f57e98b8d533$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d378f57e98b8d533$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d378f57e98b8d533$var$latin1Slice(this, start, end);
        case 'base64':
            return $d378f57e98b8d533$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d378f57e98b8d533$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d378f57e98b8d533$var$Buffer.prototype._isBuffer = true;
function $d378f57e98b8d533$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d378f57e98b8d533$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d378f57e98b8d533$var$swap(this, i, i + 1);
    return this;
};
$d378f57e98b8d533$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d378f57e98b8d533$var$swap(this, i, i + 3);
        $d378f57e98b8d533$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d378f57e98b8d533$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d378f57e98b8d533$var$swap(this, i, i + 7);
        $d378f57e98b8d533$var$swap(this, i + 1, i + 6);
        $d378f57e98b8d533$var$swap(this, i + 2, i + 5);
        $d378f57e98b8d533$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d378f57e98b8d533$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d378f57e98b8d533$var$utf8Slice(this, 0, length);
    return $d378f57e98b8d533$var$slowToString.apply(this, arguments);
};
$d378f57e98b8d533$var$Buffer.prototype.toLocaleString = $d378f57e98b8d533$var$Buffer.prototype.toString;
$d378f57e98b8d533$var$Buffer.prototype.equals = function equals(b) {
    if (!$d378f57e98b8d533$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d378f57e98b8d533$var$Buffer.compare(this, b) === 0;
};
$d378f57e98b8d533$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d378f57e98b8d533$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d378f57e98b8d533$var$customInspectSymbol) $d378f57e98b8d533$var$Buffer.prototype[$d378f57e98b8d533$var$customInspectSymbol] = $d378f57e98b8d533$var$Buffer.prototype.inspect;
$d378f57e98b8d533$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d378f57e98b8d533$var$isInstance(target, Uint8Array)) target = $d378f57e98b8d533$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d378f57e98b8d533$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d378f57e98b8d533$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d378f57e98b8d533$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d378f57e98b8d533$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d378f57e98b8d533$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d378f57e98b8d533$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d378f57e98b8d533$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d378f57e98b8d533$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d378f57e98b8d533$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d378f57e98b8d533$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d378f57e98b8d533$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d378f57e98b8d533$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d378f57e98b8d533$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d378f57e98b8d533$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d378f57e98b8d533$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d378f57e98b8d533$var$utf8Write(buf, string, offset, length) {
    return $d378f57e98b8d533$var$blitBuffer($d378f57e98b8d533$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d378f57e98b8d533$var$asciiWrite(buf, string, offset, length) {
    return $d378f57e98b8d533$var$blitBuffer($d378f57e98b8d533$var$asciiToBytes(string), buf, offset, length);
}
function $d378f57e98b8d533$var$base64Write(buf, string, offset, length) {
    return $d378f57e98b8d533$var$blitBuffer($d378f57e98b8d533$var$base64ToBytes(string), buf, offset, length);
}
function $d378f57e98b8d533$var$ucs2Write(buf, string, offset, length) {
    return $d378f57e98b8d533$var$blitBuffer($d378f57e98b8d533$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d378f57e98b8d533$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d378f57e98b8d533$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d378f57e98b8d533$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d378f57e98b8d533$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d378f57e98b8d533$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d378f57e98b8d533$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d378f57e98b8d533$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d378f57e98b8d533$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jdJcJ.fromByteArray(buf);
    else return $jdJcJ.fromByteArray(buf.slice(start, end));
}
function $d378f57e98b8d533$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d378f57e98b8d533$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d378f57e98b8d533$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d378f57e98b8d533$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d378f57e98b8d533$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d378f57e98b8d533$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d378f57e98b8d533$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d378f57e98b8d533$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d378f57e98b8d533$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d378f57e98b8d533$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d378f57e98b8d533$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d378f57e98b8d533$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d378f57e98b8d533$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d378f57e98b8d533$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d378f57e98b8d533$var$Buffer.prototype.readUintLE = $d378f57e98b8d533$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d378f57e98b8d533$var$Buffer.prototype.readUintBE = $d378f57e98b8d533$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d378f57e98b8d533$var$Buffer.prototype.readUint8 = $d378f57e98b8d533$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d378f57e98b8d533$var$Buffer.prototype.readUint16LE = $d378f57e98b8d533$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d378f57e98b8d533$var$Buffer.prototype.readUint16BE = $d378f57e98b8d533$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d378f57e98b8d533$var$Buffer.prototype.readUint32LE = $d378f57e98b8d533$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d378f57e98b8d533$var$Buffer.prototype.readUint32BE = $d378f57e98b8d533$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d378f57e98b8d533$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d378f57e98b8d533$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d378f57e98b8d533$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d378f57e98b8d533$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d378f57e98b8d533$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d378f57e98b8d533$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d378f57e98b8d533$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d378f57e98b8d533$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 4, this.length);
    return $8cJBk.read(this, offset, true, 23, 4);
};
$d378f57e98b8d533$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 4, this.length);
    return $8cJBk.read(this, offset, false, 23, 4);
};
$d378f57e98b8d533$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 8, this.length);
    return $8cJBk.read(this, offset, true, 52, 8);
};
$d378f57e98b8d533$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkOffset(offset, 8, this.length);
    return $8cJBk.read(this, offset, false, 52, 8);
};
function $d378f57e98b8d533$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d378f57e98b8d533$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d378f57e98b8d533$var$Buffer.prototype.writeUintLE = $d378f57e98b8d533$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d378f57e98b8d533$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d378f57e98b8d533$var$Buffer.prototype.writeUintBE = $d378f57e98b8d533$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d378f57e98b8d533$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d378f57e98b8d533$var$Buffer.prototype.writeUint8 = $d378f57e98b8d533$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d378f57e98b8d533$var$Buffer.prototype.writeUint16LE = $d378f57e98b8d533$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d378f57e98b8d533$var$Buffer.prototype.writeUint16BE = $d378f57e98b8d533$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d378f57e98b8d533$var$Buffer.prototype.writeUint32LE = $d378f57e98b8d533$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d378f57e98b8d533$var$Buffer.prototype.writeUint32BE = $d378f57e98b8d533$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d378f57e98b8d533$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d378f57e98b8d533$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d378f57e98b8d533$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d378f57e98b8d533$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d378f57e98b8d533$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d378f57e98b8d533$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d378f57e98b8d533$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d378f57e98b8d533$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d378f57e98b8d533$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d378f57e98b8d533$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d378f57e98b8d533$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8cJBk.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d378f57e98b8d533$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d378f57e98b8d533$var$writeFloat(this, value, offset, true, noAssert);
};
$d378f57e98b8d533$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d378f57e98b8d533$var$writeFloat(this, value, offset, false, noAssert);
};
function $d378f57e98b8d533$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d378f57e98b8d533$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8cJBk.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d378f57e98b8d533$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d378f57e98b8d533$var$writeDouble(this, value, offset, true, noAssert);
};
$d378f57e98b8d533$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d378f57e98b8d533$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d378f57e98b8d533$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d378f57e98b8d533$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d378f57e98b8d533$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d378f57e98b8d533$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d378f57e98b8d533$var$Buffer.isBuffer(val) ? val : $d378f57e98b8d533$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d378f57e98b8d533$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d378f57e98b8d533$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d378f57e98b8d533$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d378f57e98b8d533$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d378f57e98b8d533$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d378f57e98b8d533$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d378f57e98b8d533$var$base64ToBytes(str) {
    return $jdJcJ.toByteArray($d378f57e98b8d533$var$base64clean(str));
}
function $d378f57e98b8d533$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d378f57e98b8d533$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d378f57e98b8d533$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d378f57e98b8d533$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("jdJcJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $dfe24be2e40be628$export$d622b2ad8d90c771, (v) => $dfe24be2e40be628$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $dfe24be2e40be628$export$6100ba28696e12de, (v) => $dfe24be2e40be628$export$6100ba28696e12de = v);
var $dfe24be2e40be628$export$a48f0734ac7c2329;
var $dfe24be2e40be628$export$d622b2ad8d90c771;
var $dfe24be2e40be628$export$6100ba28696e12de;
'use strict';
$dfe24be2e40be628$export$a48f0734ac7c2329 = $dfe24be2e40be628$var$byteLength;
$dfe24be2e40be628$export$d622b2ad8d90c771 = $dfe24be2e40be628$var$toByteArray;
$dfe24be2e40be628$export$6100ba28696e12de = $dfe24be2e40be628$var$fromByteArray;
var $dfe24be2e40be628$var$lookup = [];
var $dfe24be2e40be628$var$revLookup = [];
var $dfe24be2e40be628$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $dfe24be2e40be628$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $dfe24be2e40be628$var$i = 0, $dfe24be2e40be628$var$len = $dfe24be2e40be628$var$code.length; $dfe24be2e40be628$var$i < $dfe24be2e40be628$var$len; ++$dfe24be2e40be628$var$i){
    $dfe24be2e40be628$var$lookup[$dfe24be2e40be628$var$i] = $dfe24be2e40be628$var$code[$dfe24be2e40be628$var$i];
    $dfe24be2e40be628$var$revLookup[$dfe24be2e40be628$var$code.charCodeAt($dfe24be2e40be628$var$i)] = $dfe24be2e40be628$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$dfe24be2e40be628$var$revLookup['-'.charCodeAt(0)] = 62;
$dfe24be2e40be628$var$revLookup['_'.charCodeAt(0)] = 63;
function $dfe24be2e40be628$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $dfe24be2e40be628$var$byteLength(b64) {
    var lens = $dfe24be2e40be628$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $dfe24be2e40be628$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $dfe24be2e40be628$var$toByteArray(b64) {
    var tmp;
    var lens = $dfe24be2e40be628$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $dfe24be2e40be628$var$Arr($dfe24be2e40be628$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i)] << 18 | $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i)] << 2 | $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i)] << 10 | $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $dfe24be2e40be628$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $dfe24be2e40be628$var$tripletToBase64(num) {
    return $dfe24be2e40be628$var$lookup[num >> 18 & 0x3F] + $dfe24be2e40be628$var$lookup[num >> 12 & 0x3F] + $dfe24be2e40be628$var$lookup[num >> 6 & 0x3F] + $dfe24be2e40be628$var$lookup[num & 0x3F];
}
function $dfe24be2e40be628$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($dfe24be2e40be628$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $dfe24be2e40be628$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($dfe24be2e40be628$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($dfe24be2e40be628$var$lookup[tmp >> 2] + $dfe24be2e40be628$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($dfe24be2e40be628$var$lookup[tmp >> 10] + $dfe24be2e40be628$var$lookup[tmp >> 4 & 0x3F] + $dfe24be2e40be628$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8cJBk", function(module, exports) {

$parcel$export(module.exports, "read", () => $5f92d1221cbda41a$export$aafa59e2e03f2942, (v) => $5f92d1221cbda41a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $5f92d1221cbda41a$export$68d8715fc104d294, (v) => $5f92d1221cbda41a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5f92d1221cbda41a$export$aafa59e2e03f2942;
var $5f92d1221cbda41a$export$68d8715fc104d294;
$5f92d1221cbda41a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5f92d1221cbda41a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("fq2va", function(module, exports) {
'use strict';

var $cTI9T = parcelRequire("cTI9T");
var $b39b39841691400f$require$Buffer = $cTI9T.Buffer;

var $efNFQ = parcelRequire("efNFQ");

var $bodC8 = parcelRequire("bodC8");

var $xeMy5 = parcelRequire("xeMy5");

var $hiMf9 = parcelRequire("hiMf9");

var $cSIdg = parcelRequire("cSIdg");

var $7GBfU = parcelRequire("7GBfU");
var $b39b39841691400f$require$IncompleteBufferError = $7GBfU.IncompleteBufferError;

var $lzGYy = parcelRequire("lzGYy");
function $b39b39841691400f$var$msgpack(options) {
    const encodingTypes = [];
    const decodingTypes = new Map();
    options = options || {
        forceFloat64: false,
        compatibilityMode: false,
        // if true, skips encoding Dates using the msgpack
        // timestamp ext format (-1)
        disableTimestampEncoding: false,
        preferMap: false,
        // options.protoAction: 'error' (default) / 'remove' / 'ignore'
        protoAction: 'error'
    };
    decodingTypes.set($lzGYy.type, $lzGYy.decode);
    if (!options.disableTimestampEncoding) encodingTypes.push($lzGYy);
    function registerEncoder(check, encode) {
        $efNFQ(check, 'must have an encode function');
        $efNFQ(encode, 'must have an encode function');
        encodingTypes.push({
            check: check,
            encode: encode
        });
        return this;
    }
    function registerDecoder(type, decode) {
        $efNFQ(type >= 0, 'must have a non-negative type');
        $efNFQ(decode, 'must have a decode function');
        decodingTypes.set(type, decode);
        return this;
    }
    function register(type, constructor, encode, decode) {
        $efNFQ(constructor, 'must have a constructor');
        $efNFQ(encode, 'must have an encode function');
        $efNFQ(type >= 0, 'must have a non-negative type');
        $efNFQ(decode, 'must have a decode function');
        function check(obj) {
            return obj instanceof constructor;
        }
        function reEncode(obj) {
            const buf = $bodC8();
            const header = $b39b39841691400f$require$Buffer.allocUnsafe(1);
            header.writeInt8(type, 0);
            buf.append(header);
            buf.append(encode(obj));
            return buf;
        }
        this.registerEncoder(check, reEncode);
        this.registerDecoder(type, decode);
        return this;
    }
    return {
        encode: $cSIdg(encodingTypes, options),
        decode: $hiMf9(decodingTypes, options),
        register: register,
        registerEncoder: registerEncoder,
        registerDecoder: registerDecoder,
        encoder: $xeMy5.encoder,
        decoder: $xeMy5.decoder,
        // needed for levelup support
        buffer: true,
        type: 'msgpack5',
        IncompleteBufferError: $b39b39841691400f$require$IncompleteBufferError
    };
}
module.exports = $b39b39841691400f$var$msgpack;

});
parcelRegister("cTI9T", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $i9F75 = parcelRequire("i9F75");
var $963ce00c39ed6b8c$var$Buffer = $i9F75.Buffer;
// alternative to using Object.keys for old browsers
function $963ce00c39ed6b8c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($963ce00c39ed6b8c$var$Buffer.from && $963ce00c39ed6b8c$var$Buffer.alloc && $963ce00c39ed6b8c$var$Buffer.allocUnsafe && $963ce00c39ed6b8c$var$Buffer.allocUnsafeSlow) module.exports = $i9F75;
else {
    // Copy properties from require('buffer')
    $963ce00c39ed6b8c$var$copyProps($i9F75, module.exports);
    module.exports.Buffer = $963ce00c39ed6b8c$var$SafeBuffer;
}
function $963ce00c39ed6b8c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $963ce00c39ed6b8c$var$Buffer(arg, encodingOrOffset, length);
}
$963ce00c39ed6b8c$var$SafeBuffer.prototype = Object.create($963ce00c39ed6b8c$var$Buffer.prototype);
// Copy static methods from Buffer
$963ce00c39ed6b8c$var$copyProps($963ce00c39ed6b8c$var$Buffer, $963ce00c39ed6b8c$var$SafeBuffer);
$963ce00c39ed6b8c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $963ce00c39ed6b8c$var$Buffer(arg, encodingOrOffset, length);
};
$963ce00c39ed6b8c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $963ce00c39ed6b8c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$963ce00c39ed6b8c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $963ce00c39ed6b8c$var$Buffer(size);
};
$963ce00c39ed6b8c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $i9F75.SlowBuffer(size);
};

});

parcelRegister("efNFQ", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3rPrU = parcelRequire("3rPrU");
'use strict';
function $a608ff96325f9ab8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a608ff96325f9ab8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a608ff96325f9ab8$var$_typeof(o);
}
function $a608ff96325f9ab8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a608ff96325f9ab8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a608ff96325f9ab8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a608ff96325f9ab8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a608ff96325f9ab8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a608ff96325f9ab8$var$_toPropertyKey(arg) {
    var key = $a608ff96325f9ab8$var$_toPrimitive(arg, "string");
    return $a608ff96325f9ab8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a608ff96325f9ab8$var$_toPrimitive(input, hint) {
    if ($a608ff96325f9ab8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a608ff96325f9ab8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a608ff96325f9ab8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $e1X1x = parcelRequire("e1X1x");
var $a608ff96325f9ab8$var$_require$codes = $e1X1x.codes, $a608ff96325f9ab8$var$ERR_AMBIGUOUS_ARGUMENT = $a608ff96325f9ab8$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $a608ff96325f9ab8$var$ERR_INVALID_ARG_TYPE = $a608ff96325f9ab8$var$_require$codes.ERR_INVALID_ARG_TYPE, $a608ff96325f9ab8$var$ERR_INVALID_ARG_VALUE = $a608ff96325f9ab8$var$_require$codes.ERR_INVALID_ARG_VALUE, $a608ff96325f9ab8$var$ERR_INVALID_RETURN_VALUE = $a608ff96325f9ab8$var$_require$codes.ERR_INVALID_RETURN_VALUE, $a608ff96325f9ab8$var$ERR_MISSING_ARGS = $a608ff96325f9ab8$var$_require$codes.ERR_MISSING_ARGS;

var $UziBF = parcelRequire("UziBF");

var $dCmQe = parcelRequire("dCmQe");
var $a608ff96325f9ab8$var$inspect = $dCmQe.inspect;

var $dCmQe = parcelRequire("dCmQe");
var $a608ff96325f9ab8$require$_require$types = $dCmQe.types;
var $a608ff96325f9ab8$var$isPromise = $a608ff96325f9ab8$require$_require$types.isPromise, $a608ff96325f9ab8$var$isRegExp = $a608ff96325f9ab8$require$_require$types.isRegExp;

var $a608ff96325f9ab8$var$objectAssign = (parcelRequire("foTII"))();

var $a608ff96325f9ab8$var$objectIs = (parcelRequire("4YK7U"))();

var $a608ff96325f9ab8$var$RegExpPrototypeTest = (parcelRequire("4pAjD"))('RegExp.prototype.test');
var $a608ff96325f9ab8$var$errorCache = new Map();
var $a608ff96325f9ab8$var$isDeepEqual;
var $a608ff96325f9ab8$var$isDeepStrictEqual;
var $a608ff96325f9ab8$var$parseExpressionAt;
var $a608ff96325f9ab8$var$findNodeAround;
var $a608ff96325f9ab8$var$decoder;

function $a608ff96325f9ab8$var$lazyLoadComparison() {
    var comparison = (parcelRequire("8d0D6"));
    $a608ff96325f9ab8$var$isDeepEqual = comparison.isDeepEqual;
    $a608ff96325f9ab8$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $a608ff96325f9ab8$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $a608ff96325f9ab8$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $a608ff96325f9ab8$var$escapeFn = function escapeFn(str) {
    return $a608ff96325f9ab8$var$meta[str.charCodeAt(0)];
};
var $a608ff96325f9ab8$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $a608ff96325f9ab8$var$assert = module.exports = $a608ff96325f9ab8$var$ok;
var $a608ff96325f9ab8$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $a608ff96325f9ab8$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $UziBF(obj);
}
function $a608ff96325f9ab8$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($a608ff96325f9ab8$var$warned === false) {
            $a608ff96325f9ab8$var$warned = true;
            var warn = $3rPrU.emitWarning ? $3rPrU.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $a608ff96325f9ab8$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $UziBF(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$a608ff96325f9ab8$var$assert.fail = $a608ff96325f9ab8$var$fail;
// The AssertionError is defined in internal/error.
$a608ff96325f9ab8$var$assert.AssertionError = $UziBF;
function $a608ff96325f9ab8$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $UziBF({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $a608ff96325f9ab8$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $a608ff96325f9ab8$var$innerOk.apply(void 0, [
        $a608ff96325f9ab8$var$ok,
        args.length
    ].concat(args));
}
$a608ff96325f9ab8$var$assert.ok = $a608ff96325f9ab8$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $a608ff96325f9ab8$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$a608ff96325f9ab8$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$a608ff96325f9ab8$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($a608ff96325f9ab8$var$isDeepEqual === undefined) $a608ff96325f9ab8$var$lazyLoadComparison();
    if (!$a608ff96325f9ab8$var$isDeepEqual(actual, expected)) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$a608ff96325f9ab8$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($a608ff96325f9ab8$var$isDeepEqual === undefined) $a608ff96325f9ab8$var$lazyLoadComparison();
    if ($a608ff96325f9ab8$var$isDeepEqual(actual, expected)) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $a608ff96325f9ab8$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($a608ff96325f9ab8$var$isDeepEqual === undefined) $a608ff96325f9ab8$var$lazyLoadComparison();
    if (!$a608ff96325f9ab8$var$isDeepStrictEqual(actual, expected)) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$a608ff96325f9ab8$var$assert.notDeepStrictEqual = $a608ff96325f9ab8$var$notDeepStrictEqual;
function $a608ff96325f9ab8$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($a608ff96325f9ab8$var$isDeepEqual === undefined) $a608ff96325f9ab8$var$lazyLoadComparison();
    if ($a608ff96325f9ab8$var$isDeepStrictEqual(actual, expected)) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $a608ff96325f9ab8$var$notDeepStrictEqual
    });
}
$a608ff96325f9ab8$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$a608ff96325f9ab8$var$objectIs(actual, expected)) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$a608ff96325f9ab8$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $a608ff96325f9ab8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($a608ff96325f9ab8$var$objectIs(actual, expected)) $a608ff96325f9ab8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $a608ff96325f9ab8$var$Comparison = /*#__PURE__*/ $a608ff96325f9ab8$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $a608ff96325f9ab8$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $a608ff96325f9ab8$var$isRegExp(obj[key]) && $a608ff96325f9ab8$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $a608ff96325f9ab8$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$a608ff96325f9ab8$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $a608ff96325f9ab8$var$Comparison(actual, keys);
            var b = new $a608ff96325f9ab8$var$Comparison(expected, keys, actual);
            var err = new $UziBF({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $a608ff96325f9ab8$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $a608ff96325f9ab8$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($a608ff96325f9ab8$var$isRegExp(expected)) return $a608ff96325f9ab8$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $a608ff96325f9ab8$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($a608ff96325f9ab8$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $UziBF({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $a608ff96325f9ab8$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($a608ff96325f9ab8$var$isDeepEqual === undefined) $a608ff96325f9ab8$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $a608ff96325f9ab8$var$isRegExp(expected[key]) && $a608ff96325f9ab8$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $a608ff96325f9ab8$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $a608ff96325f9ab8$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $a608ff96325f9ab8$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $a608ff96325f9ab8$var$NO_EXCEPTION_SENTINEL;
}
function $a608ff96325f9ab8$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $a608ff96325f9ab8$var$isPromise(obj) || obj !== null && $a608ff96325f9ab8$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $a608ff96325f9ab8$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$a608ff96325f9ab8$var$checkIsPromise(resultPromise)) throw new $a608ff96325f9ab8$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($a608ff96325f9ab8$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $a608ff96325f9ab8$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $a608ff96325f9ab8$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $a608ff96325f9ab8$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $a608ff96325f9ab8$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($a608ff96325f9ab8$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $a608ff96325f9ab8$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $a608ff96325f9ab8$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $a608ff96325f9ab8$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $a608ff96325f9ab8$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $a608ff96325f9ab8$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $a608ff96325f9ab8$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$a608ff96325f9ab8$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $a608ff96325f9ab8$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $a608ff96325f9ab8$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $a608ff96325f9ab8$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $a608ff96325f9ab8$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$a608ff96325f9ab8$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $a608ff96325f9ab8$var$expectsError.apply(void 0, [
        throws,
        $a608ff96325f9ab8$var$getActual(promiseFn)
    ].concat(args));
};
$a608ff96325f9ab8$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $a608ff96325f9ab8$var$waitForActual(promiseFn).then(function(result) {
        return $a608ff96325f9ab8$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$a608ff96325f9ab8$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $a608ff96325f9ab8$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $a608ff96325f9ab8$var$getActual(fn)
    ].concat(args));
};
$a608ff96325f9ab8$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $a608ff96325f9ab8$var$waitForActual(fn).then(function(result) {
        return $a608ff96325f9ab8$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$a608ff96325f9ab8$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($a608ff96325f9ab8$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $a608ff96325f9ab8$var$inspect(err);
        var newErr = new $UziBF({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $a608ff96325f9ab8$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$a608ff96325f9ab8$var$isRegExp(regexp)) throw new $a608ff96325f9ab8$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $a608ff96325f9ab8$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($a608ff96325f9ab8$var$_typeof(string), " (").concat($a608ff96325f9ab8$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($a608ff96325f9ab8$var$inspect(regexp), ". Input:\n\n").concat($a608ff96325f9ab8$var$inspect(string), "\n"));
        var err = new $UziBF({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$a608ff96325f9ab8$var$assert.match = function match(string, regexp, message) {
    $a608ff96325f9ab8$var$internalMatch(string, regexp, message, match, 'match');
};
$a608ff96325f9ab8$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $a608ff96325f9ab8$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $a608ff96325f9ab8$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $a608ff96325f9ab8$var$innerOk.apply(void 0, [
        $a608ff96325f9ab8$var$strict,
        args.length
    ].concat(args));
}
$a608ff96325f9ab8$var$assert.strict = $a608ff96325f9ab8$var$objectAssign($a608ff96325f9ab8$var$strict, $a608ff96325f9ab8$var$assert, {
    equal: $a608ff96325f9ab8$var$assert.strictEqual,
    deepEqual: $a608ff96325f9ab8$var$assert.deepStrictEqual,
    notEqual: $a608ff96325f9ab8$var$assert.notStrictEqual,
    notDeepEqual: $a608ff96325f9ab8$var$assert.notDeepStrictEqual
});
$a608ff96325f9ab8$var$assert.strict.strict = $a608ff96325f9ab8$var$assert.strict;

});
parcelRegister("e1X1x", function(module, exports) {

$parcel$export(module.exports, "codes", () => $a36ef196393199e9$export$e45cb6485273080e, (v) => $a36ef196393199e9$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $a36ef196393199e9$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $a36ef196393199e9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a36ef196393199e9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a36ef196393199e9$var$_typeof(o);
}
function $a36ef196393199e9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a36ef196393199e9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a36ef196393199e9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a36ef196393199e9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a36ef196393199e9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a36ef196393199e9$var$_toPropertyKey(arg) {
    var key = $a36ef196393199e9$var$_toPrimitive(arg, "string");
    return $a36ef196393199e9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a36ef196393199e9$var$_toPrimitive(input, hint) {
    if ($a36ef196393199e9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a36ef196393199e9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a36ef196393199e9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a36ef196393199e9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a36ef196393199e9$var$_setPrototypeOf(subClass, superClass);
}
function $a36ef196393199e9$var$_setPrototypeOf(o, p) {
    $a36ef196393199e9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a36ef196393199e9$var$_setPrototypeOf(o, p);
}
function $a36ef196393199e9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a36ef196393199e9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a36ef196393199e9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a36ef196393199e9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a36ef196393199e9$var$_possibleConstructorReturn(this, result);
    };
}
function $a36ef196393199e9$var$_possibleConstructorReturn(self, call) {
    if (call && ($a36ef196393199e9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a36ef196393199e9$var$_assertThisInitialized(self);
}
function $a36ef196393199e9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a36ef196393199e9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a36ef196393199e9$var$_getPrototypeOf(o) {
    $a36ef196393199e9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a36ef196393199e9$var$_getPrototypeOf(o);
}
var $a36ef196393199e9$var$codes = {};
// Lazy loaded
var $a36ef196393199e9$var$assert;
var $a36ef196393199e9$var$util;
function $a36ef196393199e9$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $a36ef196393199e9$var$_inherits(NodeError, _Base);
        var _super = $a36ef196393199e9$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $a36ef196393199e9$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $a36ef196393199e9$var$_createClass(NodeError);
    }(Base);
    $a36ef196393199e9$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $a36ef196393199e9$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $a36ef196393199e9$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $a36ef196393199e9$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $a36ef196393199e9$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$a36ef196393199e9$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$a36ef196393199e9$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($a36ef196393199e9$var$assert === undefined) $a36ef196393199e9$var$assert = (parcelRequire("efNFQ"));
    $a36ef196393199e9$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $a36ef196393199e9$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($a36ef196393199e9$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($a36ef196393199e9$var$oneOf(expected, 'type'));
    else {
        var type = $a36ef196393199e9$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($a36ef196393199e9$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($a36ef196393199e9$var$_typeof(actual));
    return msg;
}, TypeError);

$a36ef196393199e9$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($a36ef196393199e9$var$util === undefined) $a36ef196393199e9$var$util = (parcelRequire("dCmQe"));
    var inspected = $a36ef196393199e9$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$a36ef196393199e9$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($a36ef196393199e9$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$a36ef196393199e9$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($a36ef196393199e9$var$assert === undefined) $a36ef196393199e9$var$assert = (parcelRequire("efNFQ"));
    $a36ef196393199e9$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$a36ef196393199e9$export$e45cb6485273080e = $a36ef196393199e9$var$codes;

});
parcelRegister("dCmQe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3rPrU = parcelRequire("3rPrU");
var $9ea08ad2f9fe2471$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $9ea08ad2f9fe2471$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$9ea08ad2f9fe2471$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($9ea08ad2f9fe2471$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($9ea08ad2f9fe2471$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($9ea08ad2f9fe2471$var$isNull(x) || !$9ea08ad2f9fe2471$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $9ea08ad2f9fe2471$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($3rPrU.throwDeprecation) throw new Error(msg);
            else if ($3rPrU.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $9ea08ad2f9fe2471$var$debugs = {};
var $9ea08ad2f9fe2471$var$debugEnvRegex = /^$/;
var $9ea08ad2f9fe2471$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$9ea08ad2f9fe2471$var$debugs[set]) {
        if ($9ea08ad2f9fe2471$var$debugEnvRegex.test(set)) {
            var pid = $3rPrU.pid;
            $9ea08ad2f9fe2471$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $9ea08ad2f9fe2471$var$debugs[set] = function() {};
    }
    return $9ea08ad2f9fe2471$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $9ea08ad2f9fe2471$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $9ea08ad2f9fe2471$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($9ea08ad2f9fe2471$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($9ea08ad2f9fe2471$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($9ea08ad2f9fe2471$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($9ea08ad2f9fe2471$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($9ea08ad2f9fe2471$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $9ea08ad2f9fe2471$var$stylizeWithColor;
    return $9ea08ad2f9fe2471$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $9ea08ad2f9fe2471$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$9ea08ad2f9fe2471$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$9ea08ad2f9fe2471$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $9ea08ad2f9fe2471$var$stylizeWithColor(str, styleType) {
    var style = $9ea08ad2f9fe2471$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $9ea08ad2f9fe2471$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $9ea08ad2f9fe2471$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $9ea08ad2f9fe2471$var$stylizeNoColor(str, styleType) {
    return str;
}
function $9ea08ad2f9fe2471$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $9ea08ad2f9fe2471$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $9ea08ad2f9fe2471$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$9ea08ad2f9fe2471$var$isString(ret)) ret = $9ea08ad2f9fe2471$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $9ea08ad2f9fe2471$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $9ea08ad2f9fe2471$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($9ea08ad2f9fe2471$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $9ea08ad2f9fe2471$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($9ea08ad2f9fe2471$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($9ea08ad2f9fe2471$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($9ea08ad2f9fe2471$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($9ea08ad2f9fe2471$var$isError(value)) return $9ea08ad2f9fe2471$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($9ea08ad2f9fe2471$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($9ea08ad2f9fe2471$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($9ea08ad2f9fe2471$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($9ea08ad2f9fe2471$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($9ea08ad2f9fe2471$var$isError(value)) base = ' ' + $9ea08ad2f9fe2471$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($9ea08ad2f9fe2471$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $9ea08ad2f9fe2471$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $9ea08ad2f9fe2471$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $9ea08ad2f9fe2471$var$reduceToSingleString(output, base, braces);
}
function $9ea08ad2f9fe2471$var$formatPrimitive(ctx, value) {
    if ($9ea08ad2f9fe2471$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($9ea08ad2f9fe2471$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($9ea08ad2f9fe2471$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($9ea08ad2f9fe2471$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($9ea08ad2f9fe2471$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $9ea08ad2f9fe2471$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $9ea08ad2f9fe2471$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($9ea08ad2f9fe2471$var$hasOwnProperty(value, String(i))) output.push($9ea08ad2f9fe2471$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($9ea08ad2f9fe2471$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $9ea08ad2f9fe2471$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$9ea08ad2f9fe2471$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($9ea08ad2f9fe2471$var$isNull(recurseTimes)) str = $9ea08ad2f9fe2471$var$formatValue(ctx, desc.value, null);
            else str = $9ea08ad2f9fe2471$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($9ea08ad2f9fe2471$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $9ea08ad2f9fe2471$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("1o5DN"));
function $9ea08ad2f9fe2471$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $9ea08ad2f9fe2471$var$isArray;
function $9ea08ad2f9fe2471$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $9ea08ad2f9fe2471$var$isBoolean;
function $9ea08ad2f9fe2471$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $9ea08ad2f9fe2471$var$isNull;
function $9ea08ad2f9fe2471$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $9ea08ad2f9fe2471$var$isNullOrUndefined;
function $9ea08ad2f9fe2471$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $9ea08ad2f9fe2471$var$isNumber;
function $9ea08ad2f9fe2471$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $9ea08ad2f9fe2471$var$isString;
function $9ea08ad2f9fe2471$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $9ea08ad2f9fe2471$var$isSymbol;
function $9ea08ad2f9fe2471$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $9ea08ad2f9fe2471$var$isUndefined;
function $9ea08ad2f9fe2471$var$isRegExp(re) {
    return $9ea08ad2f9fe2471$var$isObject(re) && $9ea08ad2f9fe2471$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $9ea08ad2f9fe2471$var$isRegExp;
module.exports.types.isRegExp = $9ea08ad2f9fe2471$var$isRegExp;
function $9ea08ad2f9fe2471$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $9ea08ad2f9fe2471$var$isObject;
function $9ea08ad2f9fe2471$var$isDate(d) {
    return $9ea08ad2f9fe2471$var$isObject(d) && $9ea08ad2f9fe2471$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $9ea08ad2f9fe2471$var$isDate;
module.exports.types.isDate = $9ea08ad2f9fe2471$var$isDate;
function $9ea08ad2f9fe2471$var$isError(e) {
    return $9ea08ad2f9fe2471$var$isObject(e) && ($9ea08ad2f9fe2471$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $9ea08ad2f9fe2471$var$isError;
module.exports.types.isNativeError = $9ea08ad2f9fe2471$var$isError;
function $9ea08ad2f9fe2471$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $9ea08ad2f9fe2471$var$isFunction;
function $9ea08ad2f9fe2471$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $9ea08ad2f9fe2471$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("c3lyk"));
function $9ea08ad2f9fe2471$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $9ea08ad2f9fe2471$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $9ea08ad2f9fe2471$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $9ea08ad2f9fe2471$var$timestamp() {
    var d = new Date();
    var time = [
        $9ea08ad2f9fe2471$var$pad(d.getHours()),
        $9ea08ad2f9fe2471$var$pad(d.getMinutes()),
        $9ea08ad2f9fe2471$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $9ea08ad2f9fe2471$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $9ea08ad2f9fe2471$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("6sBs0"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$9ea08ad2f9fe2471$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $9ea08ad2f9fe2471$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol && original[$9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol]) {
        var fn = original[$9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $9ea08ad2f9fe2471$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $9ea08ad2f9fe2471$var$kCustomPromisifiedSymbol;
function $9ea08ad2f9fe2471$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $9ea08ad2f9fe2471$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $3rPrU.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $3rPrU.nextTick($9ea08ad2f9fe2471$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $9ea08ad2f9fe2471$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $9ea08ad2f9fe2471$var$callbackify;

});
parcelRegister("1o5DN", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $8jswN = parcelRequire("8jswN");

var $l50Fy = parcelRequire("l50Fy");

var $bHm1N = parcelRequire("bHm1N");

var $4cRbO = parcelRequire("4cRbO");
function $102c687d017df6a9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $102c687d017df6a9$var$BigIntSupported = typeof BigInt !== 'undefined';
var $102c687d017df6a9$var$SymbolSupported = typeof Symbol !== 'undefined';
var $102c687d017df6a9$var$ObjectToString = $102c687d017df6a9$var$uncurryThis(Object.prototype.toString);
var $102c687d017df6a9$var$numberValue = $102c687d017df6a9$var$uncurryThis(Number.prototype.valueOf);
var $102c687d017df6a9$var$stringValue = $102c687d017df6a9$var$uncurryThis(String.prototype.valueOf);
var $102c687d017df6a9$var$booleanValue = $102c687d017df6a9$var$uncurryThis(Boolean.prototype.valueOf);
if ($102c687d017df6a9$var$BigIntSupported) var $102c687d017df6a9$var$bigIntValue = $102c687d017df6a9$var$uncurryThis(BigInt.prototype.valueOf);
if ($102c687d017df6a9$var$SymbolSupported) var $102c687d017df6a9$var$symbolValue = $102c687d017df6a9$var$uncurryThis(Symbol.prototype.valueOf);
function $102c687d017df6a9$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $8jswN;
module.exports.isGeneratorFunction = $l50Fy;
module.exports.isTypedArray = $4cRbO;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $102c687d017df6a9$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $102c687d017df6a9$var$isPromise;
function $102c687d017df6a9$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $4cRbO(value) || $102c687d017df6a9$var$isDataView(value);
}
module.exports.isArrayBufferView = $102c687d017df6a9$var$isArrayBufferView;
function $102c687d017df6a9$var$isUint8Array(value) {
    return $bHm1N(value) === 'Uint8Array';
}
module.exports.isUint8Array = $102c687d017df6a9$var$isUint8Array;
function $102c687d017df6a9$var$isUint8ClampedArray(value) {
    return $bHm1N(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $102c687d017df6a9$var$isUint8ClampedArray;
function $102c687d017df6a9$var$isUint16Array(value) {
    return $bHm1N(value) === 'Uint16Array';
}
module.exports.isUint16Array = $102c687d017df6a9$var$isUint16Array;
function $102c687d017df6a9$var$isUint32Array(value) {
    return $bHm1N(value) === 'Uint32Array';
}
module.exports.isUint32Array = $102c687d017df6a9$var$isUint32Array;
function $102c687d017df6a9$var$isInt8Array(value) {
    return $bHm1N(value) === 'Int8Array';
}
module.exports.isInt8Array = $102c687d017df6a9$var$isInt8Array;
function $102c687d017df6a9$var$isInt16Array(value) {
    return $bHm1N(value) === 'Int16Array';
}
module.exports.isInt16Array = $102c687d017df6a9$var$isInt16Array;
function $102c687d017df6a9$var$isInt32Array(value) {
    return $bHm1N(value) === 'Int32Array';
}
module.exports.isInt32Array = $102c687d017df6a9$var$isInt32Array;
function $102c687d017df6a9$var$isFloat32Array(value) {
    return $bHm1N(value) === 'Float32Array';
}
module.exports.isFloat32Array = $102c687d017df6a9$var$isFloat32Array;
function $102c687d017df6a9$var$isFloat64Array(value) {
    return $bHm1N(value) === 'Float64Array';
}
module.exports.isFloat64Array = $102c687d017df6a9$var$isFloat64Array;
function $102c687d017df6a9$var$isBigInt64Array(value) {
    return $bHm1N(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $102c687d017df6a9$var$isBigInt64Array;
function $102c687d017df6a9$var$isBigUint64Array(value) {
    return $bHm1N(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $102c687d017df6a9$var$isBigUint64Array;
function $102c687d017df6a9$var$isMapToString(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object Map]';
}
$102c687d017df6a9$var$isMapToString.working = typeof Map !== 'undefined' && $102c687d017df6a9$var$isMapToString(new Map());
function $102c687d017df6a9$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $102c687d017df6a9$var$isMapToString.working ? $102c687d017df6a9$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $102c687d017df6a9$var$isMap;
function $102c687d017df6a9$var$isSetToString(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object Set]';
}
$102c687d017df6a9$var$isSetToString.working = typeof Set !== 'undefined' && $102c687d017df6a9$var$isSetToString(new Set());
function $102c687d017df6a9$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $102c687d017df6a9$var$isSetToString.working ? $102c687d017df6a9$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $102c687d017df6a9$var$isSet;
function $102c687d017df6a9$var$isWeakMapToString(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object WeakMap]';
}
$102c687d017df6a9$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $102c687d017df6a9$var$isWeakMapToString(new WeakMap());
function $102c687d017df6a9$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $102c687d017df6a9$var$isWeakMapToString.working ? $102c687d017df6a9$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $102c687d017df6a9$var$isWeakMap;
function $102c687d017df6a9$var$isWeakSetToString(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object WeakSet]';
}
$102c687d017df6a9$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $102c687d017df6a9$var$isWeakSetToString(new WeakSet());
function $102c687d017df6a9$var$isWeakSet(value) {
    return $102c687d017df6a9$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $102c687d017df6a9$var$isWeakSet;
function $102c687d017df6a9$var$isArrayBufferToString(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$102c687d017df6a9$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $102c687d017df6a9$var$isArrayBufferToString(new ArrayBuffer());
function $102c687d017df6a9$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $102c687d017df6a9$var$isArrayBufferToString.working ? $102c687d017df6a9$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $102c687d017df6a9$var$isArrayBuffer;
function $102c687d017df6a9$var$isDataViewToString(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object DataView]';
}
$102c687d017df6a9$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $102c687d017df6a9$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $102c687d017df6a9$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $102c687d017df6a9$var$isDataViewToString.working ? $102c687d017df6a9$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $102c687d017df6a9$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $102c687d017df6a9$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $102c687d017df6a9$var$isSharedArrayBufferToString(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $102c687d017df6a9$var$isSharedArrayBuffer(value) {
    if (typeof $102c687d017df6a9$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $102c687d017df6a9$var$isSharedArrayBufferToString.working === 'undefined') $102c687d017df6a9$var$isSharedArrayBufferToString.working = $102c687d017df6a9$var$isSharedArrayBufferToString(new $102c687d017df6a9$var$SharedArrayBufferCopy());
    return $102c687d017df6a9$var$isSharedArrayBufferToString.working ? $102c687d017df6a9$var$isSharedArrayBufferToString(value) : value instanceof $102c687d017df6a9$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $102c687d017df6a9$var$isSharedArrayBuffer;
function $102c687d017df6a9$var$isAsyncFunction(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $102c687d017df6a9$var$isAsyncFunction;
function $102c687d017df6a9$var$isMapIterator(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $102c687d017df6a9$var$isMapIterator;
function $102c687d017df6a9$var$isSetIterator(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $102c687d017df6a9$var$isSetIterator;
function $102c687d017df6a9$var$isGeneratorObject(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $102c687d017df6a9$var$isGeneratorObject;
function $102c687d017df6a9$var$isWebAssemblyCompiledModule(value) {
    return $102c687d017df6a9$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $102c687d017df6a9$var$isWebAssemblyCompiledModule;
function $102c687d017df6a9$var$isNumberObject(value) {
    return $102c687d017df6a9$var$checkBoxedPrimitive(value, $102c687d017df6a9$var$numberValue);
}
module.exports.isNumberObject = $102c687d017df6a9$var$isNumberObject;
function $102c687d017df6a9$var$isStringObject(value) {
    return $102c687d017df6a9$var$checkBoxedPrimitive(value, $102c687d017df6a9$var$stringValue);
}
module.exports.isStringObject = $102c687d017df6a9$var$isStringObject;
function $102c687d017df6a9$var$isBooleanObject(value) {
    return $102c687d017df6a9$var$checkBoxedPrimitive(value, $102c687d017df6a9$var$booleanValue);
}
module.exports.isBooleanObject = $102c687d017df6a9$var$isBooleanObject;
function $102c687d017df6a9$var$isBigIntObject(value) {
    return $102c687d017df6a9$var$BigIntSupported && $102c687d017df6a9$var$checkBoxedPrimitive(value, $102c687d017df6a9$var$bigIntValue);
}
module.exports.isBigIntObject = $102c687d017df6a9$var$isBigIntObject;
function $102c687d017df6a9$var$isSymbolObject(value) {
    return $102c687d017df6a9$var$SymbolSupported && $102c687d017df6a9$var$checkBoxedPrimitive(value, $102c687d017df6a9$var$symbolValue);
}
module.exports.isSymbolObject = $102c687d017df6a9$var$isSymbolObject;
function $102c687d017df6a9$var$isBoxedPrimitive(value) {
    return $102c687d017df6a9$var$isNumberObject(value) || $102c687d017df6a9$var$isStringObject(value) || $102c687d017df6a9$var$isBooleanObject(value) || $102c687d017df6a9$var$isBigIntObject(value) || $102c687d017df6a9$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $102c687d017df6a9$var$isBoxedPrimitive;
function $102c687d017df6a9$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($102c687d017df6a9$var$isArrayBuffer(value) || $102c687d017df6a9$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $102c687d017df6a9$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("8jswN", function(module, exports) {
'use strict';

var $60d63a1d321ac487$var$hasToStringTag = (parcelRequire("kReKw"))();

var $7Eqwi = parcelRequire("7Eqwi");
var $60d63a1d321ac487$var$$toString = $7Eqwi('Object.prototype.toString');
/** @type {import('.')} */ var $60d63a1d321ac487$var$isStandardArguments = function isArguments(value) {
    if ($60d63a1d321ac487$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $60d63a1d321ac487$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $60d63a1d321ac487$var$isLegacyArguments = function isArguments(value) {
    if ($60d63a1d321ac487$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $60d63a1d321ac487$var$$toString(value) !== '[object Array]' && 'callee' in value && $60d63a1d321ac487$var$$toString(value.callee) === '[object Function]';
};
var $60d63a1d321ac487$var$supportsStandardArguments = function() {
    return $60d63a1d321ac487$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$60d63a1d321ac487$var$isStandardArguments.isLegacyArguments = $60d63a1d321ac487$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $60d63a1d321ac487$var$supportsStandardArguments ? $60d63a1d321ac487$var$isStandardArguments : $60d63a1d321ac487$var$isLegacyArguments;

});
parcelRegister("kReKw", function(module, exports) {
'use strict';

var $aldEI = parcelRequire("aldEI");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $aldEI() && !!Symbol.toStringTag;
};

});
parcelRegister("aldEI", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("7Eqwi", function(module, exports) {
'use strict';

var $4SzuX = parcelRequire("4SzuX");

var $62qfL = parcelRequire("62qfL");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $5920d71bc09017a0$var$$indexOf = $62qfL([
    $4SzuX('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $4SzuX(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $5920d71bc09017a0$var$$indexOf(name, '.prototype.') > -1) return $62qfL(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("4SzuX", function(module, exports) {
'use strict';
var $38d7bdd176edd54b$var$undefined1;

var $h4uhI = parcelRequire("h4uhI");

var $d0n8B = parcelRequire("d0n8B");

var $jInY6 = parcelRequire("jInY6");

var $aMg2e = parcelRequire("aMg2e");

var $9NBmj = parcelRequire("9NBmj");

var $hqvAp = parcelRequire("hqvAp");

var $gIZMM = parcelRequire("gIZMM");

var $6P1KO = parcelRequire("6P1KO");

var $d8cRo = parcelRequire("d8cRo");

var $ihJ7U = parcelRequire("ihJ7U");

var $fnIRg = parcelRequire("fnIRg");

var $h5MUe = parcelRequire("h5MUe");

var $kzQl3 = parcelRequire("kzQl3");

var $dJzkC = parcelRequire("dJzkC");

var $1PiN3 = parcelRequire("1PiN3");
var $38d7bdd176edd54b$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $38d7bdd176edd54b$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $38d7bdd176edd54b$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $4FqPi = parcelRequire("4FqPi");

var $26wx2 = parcelRequire("26wx2");
var $38d7bdd176edd54b$var$throwTypeError = function() {
    throw new $gIZMM();
};
var $38d7bdd176edd54b$var$ThrowTypeError = $4FqPi ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $38d7bdd176edd54b$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $4FqPi(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $38d7bdd176edd54b$var$throwTypeError;
        }
    }
}() : $38d7bdd176edd54b$var$throwTypeError;

var $38d7bdd176edd54b$var$hasSymbols = (parcelRequire("cL0uO"))();

var $5GUAe = parcelRequire("5GUAe");

var $9GM0Z = parcelRequire("9GM0Z");

var $ghmI6 = parcelRequire("ghmI6");

var $4qoSm = parcelRequire("4qoSm");

var $8VmbW = parcelRequire("8VmbW");
var $38d7bdd176edd54b$var$needsEval = {};
var $38d7bdd176edd54b$var$TypedArray = typeof Uint8Array === 'undefined' || !$5GUAe ? undefined : $5GUAe(Uint8Array);
var $38d7bdd176edd54b$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $38d7bdd176edd54b$var$hasSymbols && $5GUAe ? $5GUAe([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $38d7bdd176edd54b$var$needsEval,
    '%AsyncGenerator%': $38d7bdd176edd54b$var$needsEval,
    '%AsyncGeneratorFunction%': $38d7bdd176edd54b$var$needsEval,
    '%AsyncIteratorPrototype%': $38d7bdd176edd54b$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $d0n8B,
    '%eval%': eval,
    '%EvalError%': $jInY6,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $38d7bdd176edd54b$var$$Function,
    '%GeneratorFunction%': $38d7bdd176edd54b$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $38d7bdd176edd54b$var$hasSymbols && $5GUAe ? $5GUAe($5GUAe([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$38d7bdd176edd54b$var$hasSymbols || !$5GUAe ? undefined : $5GUAe(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $h4uhI,
    '%Object.getOwnPropertyDescriptor%': $4FqPi,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $aMg2e,
    '%ReferenceError%': $9NBmj,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$38d7bdd176edd54b$var$hasSymbols || !$5GUAe ? undefined : $5GUAe(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $38d7bdd176edd54b$var$hasSymbols && $5GUAe ? $5GUAe(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $38d7bdd176edd54b$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $hqvAp,
    '%ThrowTypeError%': $38d7bdd176edd54b$var$ThrowTypeError,
    '%TypedArray%': $38d7bdd176edd54b$var$TypedArray,
    '%TypeError%': $gIZMM,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $6P1KO,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $8VmbW,
    '%Function.prototype.apply%': $4qoSm,
    '%Object.defineProperty%': $26wx2,
    '%Object.getPrototypeOf%': $9GM0Z,
    '%Math.abs%': $d8cRo,
    '%Math.floor%': $ihJ7U,
    '%Math.max%': $fnIRg,
    '%Math.min%': $h5MUe,
    '%Math.pow%': $kzQl3,
    '%Math.round%': $dJzkC,
    '%Math.sign%': $1PiN3,
    '%Reflect.getPrototypeOf%': $ghmI6
};
if ($5GUAe) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $38d7bdd176edd54b$var$errorProto = $5GUAe($5GUAe(e));
    $38d7bdd176edd54b$var$INTRINSICS['%Error.prototype%'] = $38d7bdd176edd54b$var$errorProto;
}
var $38d7bdd176edd54b$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $38d7bdd176edd54b$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $38d7bdd176edd54b$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $38d7bdd176edd54b$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $5GUAe) value = $5GUAe(gen.prototype);
    }
    $38d7bdd176edd54b$var$INTRINSICS[name] = value;
    return value;
};
var $38d7bdd176edd54b$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $3nZu2 = parcelRequire("3nZu2");

var $dKw2R = parcelRequire("dKw2R");
var $38d7bdd176edd54b$var$$concat = $3nZu2.call($8VmbW, Array.prototype.concat);
var $38d7bdd176edd54b$var$$spliceApply = $3nZu2.call($4qoSm, Array.prototype.splice);
var $38d7bdd176edd54b$var$$replace = $3nZu2.call($8VmbW, String.prototype.replace);
var $38d7bdd176edd54b$var$$strSlice = $3nZu2.call($8VmbW, String.prototype.slice);
var $38d7bdd176edd54b$var$$exec = $3nZu2.call($8VmbW, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $38d7bdd176edd54b$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $38d7bdd176edd54b$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $38d7bdd176edd54b$var$stringToPath = function stringToPath(string) {
    var first = $38d7bdd176edd54b$var$$strSlice(string, 0, 1);
    var last = $38d7bdd176edd54b$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $hqvAp('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $hqvAp('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $38d7bdd176edd54b$var$$replace(string, $38d7bdd176edd54b$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $38d7bdd176edd54b$var$$replace(subString, $38d7bdd176edd54b$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $38d7bdd176edd54b$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($dKw2R($38d7bdd176edd54b$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $38d7bdd176edd54b$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($dKw2R($38d7bdd176edd54b$var$INTRINSICS, intrinsicName)) {
        var value = $38d7bdd176edd54b$var$INTRINSICS[intrinsicName];
        if (value === $38d7bdd176edd54b$var$needsEval) value = $38d7bdd176edd54b$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $gIZMM('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $hqvAp('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $gIZMM('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $gIZMM('"allowMissing" argument must be a boolean');
    if ($38d7bdd176edd54b$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $hqvAp('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $38d7bdd176edd54b$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $38d7bdd176edd54b$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $38d7bdd176edd54b$var$$spliceApply(parts, $38d7bdd176edd54b$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $38d7bdd176edd54b$var$$strSlice(part, 0, 1);
        var last = $38d7bdd176edd54b$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $hqvAp('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($dKw2R($38d7bdd176edd54b$var$INTRINSICS, intrinsicRealName)) value = $38d7bdd176edd54b$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $gIZMM('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($4FqPi && i + 1 >= parts.length) {
                var desc = $4FqPi(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $dKw2R(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $38d7bdd176edd54b$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("h4uhI", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("d0n8B", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("jInY6", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("aMg2e", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("9NBmj", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("hqvAp", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("gIZMM", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("6P1KO", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("d8cRo", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("ihJ7U", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("fnIRg", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("h5MUe", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("kzQl3", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("dJzkC", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("1PiN3", function(module, exports) {
'use strict';

var $2JuHo = parcelRequire("2JuHo");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($2JuHo(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("2JuHo", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("4FqPi", function(module, exports) {
'use strict';

var $fawHL = parcelRequire("fawHL");
var $365fcce9dc259418$require$$gOPD = $fawHL;
if ($365fcce9dc259418$require$$gOPD) try {
    $365fcce9dc259418$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $365fcce9dc259418$require$$gOPD = null;
}
module.exports = $365fcce9dc259418$require$$gOPD;

});
parcelRegister("fawHL", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("26wx2", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $18856074fe829ffd$var$$defineProperty = Object.defineProperty || false;
if ($18856074fe829ffd$var$$defineProperty) try {
    $18856074fe829ffd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $18856074fe829ffd$var$$defineProperty = false;
}
module.exports = $18856074fe829ffd$var$$defineProperty;

});

parcelRegister("cL0uO", function(module, exports) {
'use strict';
var $949a425330565bf3$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $aldEI = parcelRequire("aldEI");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $949a425330565bf3$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $949a425330565bf3$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $aldEI();
};

});

parcelRegister("5GUAe", function(module, exports) {
'use strict';

var $ghmI6 = parcelRequire("ghmI6");

var $9GM0Z = parcelRequire("9GM0Z");

var $6vOFR = parcelRequire("6vOFR");
/** @type {import('.')} */ module.exports = $ghmI6 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $ghmI6(O);
} : $9GM0Z ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9GM0Z(O);
} : $6vOFR ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $6vOFR(O);
} : null;

});
parcelRegister("ghmI6", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("9GM0Z", function(module, exports) {
'use strict';

var $h4uhI = parcelRequire("h4uhI");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $h4uhI.getPrototypeOf || null;

});

parcelRegister("6vOFR", function(module, exports) {
'use strict';

var $62qfL = parcelRequire("62qfL");

var $4FqPi = parcelRequire("4FqPi");
var $4bdcf225291367af$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $4bdcf225291367af$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $4bdcf225291367af$var$desc = !!$4bdcf225291367af$var$hasProtoAccessor && $4FqPi && $4FqPi(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $4bdcf225291367af$var$$Object = Object;
var $4bdcf225291367af$var$$getPrototypeOf = $4bdcf225291367af$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $4bdcf225291367af$var$desc && typeof $4bdcf225291367af$var$desc.get === 'function' ? $62qfL([
    $4bdcf225291367af$var$desc.get
]) : typeof $4bdcf225291367af$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $4bdcf225291367af$var$$getPrototypeOf(value == null ? value : $4bdcf225291367af$var$$Object(value));
} : false;

});
parcelRegister("62qfL", function(module, exports) {
'use strict';

var $3nZu2 = parcelRequire("3nZu2");

var $gIZMM = parcelRequire("gIZMM");

var $8VmbW = parcelRequire("8VmbW");

var $bB6Xx = parcelRequire("bB6Xx");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $gIZMM('a function is required');
    return $bB6Xx($3nZu2, $8VmbW, args);
};

});
parcelRegister("3nZu2", function(module, exports) {
'use strict';

var $iHVSk = parcelRequire("iHVSk");
module.exports = Function.prototype.bind || $iHVSk;

});
parcelRegister("iHVSk", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $d9e922f830ba1a67$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $d9e922f830ba1a67$var$toStr = Object.prototype.toString;
var $d9e922f830ba1a67$var$max = Math.max;
var $d9e922f830ba1a67$var$funcType = '[object Function]';
var $d9e922f830ba1a67$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $d9e922f830ba1a67$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $d9e922f830ba1a67$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $d9e922f830ba1a67$var$toStr.apply(target) !== $d9e922f830ba1a67$var$funcType) throw new TypeError($d9e922f830ba1a67$var$ERROR_MESSAGE + target);
    var args = $d9e922f830ba1a67$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $d9e922f830ba1a67$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $d9e922f830ba1a67$var$concatty(args, arguments));
    };
    var boundLength = $d9e922f830ba1a67$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $d9e922f830ba1a67$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("8VmbW", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("bB6Xx", function(module, exports) {
'use strict';

var $3nZu2 = parcelRequire("3nZu2");

var $4qoSm = parcelRequire("4qoSm");

var $8VmbW = parcelRequire("8VmbW");

var $glc33 = parcelRequire("glc33");
/** @type {import('./actualApply')} */ module.exports = $glc33 || $3nZu2.call($8VmbW, $4qoSm);

});
parcelRegister("4qoSm", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("glc33", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("dKw2R", function(module, exports) {
'use strict';
var $a0286dc1534c9d82$var$call = Function.prototype.call;
var $a0286dc1534c9d82$var$$hasOwn = Object.prototype.hasOwnProperty;

var $3nZu2 = parcelRequire("3nZu2");
/** @type {import('.')} */ module.exports = $3nZu2.call($a0286dc1534c9d82$var$call, $a0286dc1534c9d82$var$$hasOwn);

});




parcelRegister("l50Fy", function(module, exports) {
'use strict';

var $7Eqwi = parcelRequire("7Eqwi");

var $ebYVy = parcelRequire("ebYVy");
var $f58a957fcf405fdd$var$isFnRegex = $ebYVy(/^\s*(?:function)?\*/);

var $f58a957fcf405fdd$var$hasToStringTag = (parcelRequire("kReKw"))();

var $5GUAe = parcelRequire("5GUAe");
var $f58a957fcf405fdd$var$toStr = $7Eqwi('Object.prototype.toString');
var $f58a957fcf405fdd$var$fnToStr = $7Eqwi('Function.prototype.toString');

var $6NG0b = parcelRequire("6NG0b");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($f58a957fcf405fdd$var$isFnRegex($f58a957fcf405fdd$var$fnToStr(fn))) return true;
    if (!$f58a957fcf405fdd$var$hasToStringTag) {
        var str = $f58a957fcf405fdd$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$5GUAe) return false;
    var GeneratorFunction = $6NG0b();
    return GeneratorFunction && $5GUAe(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("ebYVy", function(module, exports) {
'use strict';

var $7Eqwi = parcelRequire("7Eqwi");

var $kzzXw = parcelRequire("kzzXw");
var $a5515aacfbb87ec3$var$$exec = $7Eqwi('RegExp.prototype.exec');

var $gIZMM = parcelRequire("gIZMM");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$kzzXw(regex)) throw new $gIZMM('`regex` must be a RegExp');
    return function test(s) {
        return $a5515aacfbb87ec3$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("kzzXw", function(module, exports) {
'use strict';

var $7Eqwi = parcelRequire("7Eqwi");

var $efa2f83cd332342f$var$hasToStringTag = (parcelRequire("kReKw"))();

var $dKw2R = parcelRequire("dKw2R");

var $4FqPi = parcelRequire("4FqPi");
/** @type {import('.')} */ var $efa2f83cd332342f$var$fn;
if ($efa2f83cd332342f$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $efa2f83cd332342f$var$$exec = $7Eqwi('RegExp.prototype.exec');
    /** @type {object} */ var $efa2f83cd332342f$var$isRegexMarker = {};
    var $efa2f83cd332342f$var$throwRegexMarker = function() {
        throw $efa2f83cd332342f$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $efa2f83cd332342f$var$badStringifier = {
        toString: $efa2f83cd332342f$var$throwRegexMarker,
        valueOf: $efa2f83cd332342f$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $efa2f83cd332342f$var$badStringifier[Symbol.toPrimitive] = $efa2f83cd332342f$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $efa2f83cd332342f$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $4FqPi(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $dKw2R(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $efa2f83cd332342f$var$$exec(value, /** @type {unknown} */ $efa2f83cd332342f$var$badStringifier);
        } catch (e) {
            return e === $efa2f83cd332342f$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $efa2f83cd332342f$var$$toString = $7Eqwi('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $efa2f83cd332342f$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $efa2f83cd332342f$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $efa2f83cd332342f$var$$toString(value) === $efa2f83cd332342f$var$regexClass;
    };
}
module.exports = $efa2f83cd332342f$var$fn;

});


parcelRegister("6NG0b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $57b00a2037310932$export$2e2bcd8739ae039);

var $dmqf9 = parcelRequire("dmqf9");
var /** @type {import('./index.d.mts').default} */ $57b00a2037310932$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dmqf9)));

});
parcelRegister("dmqf9", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $9ba1afd62eafc0df$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$9ba1afd62eafc0df$var$cached;

});



parcelRegister("bHm1N", function(module, exports) {
'use strict';

var $c1BbV = parcelRequire("c1BbV");

var $7ZV4l = parcelRequire("7ZV4l");

var $4pAjD = parcelRequire("4pAjD");

var $4FqPi = parcelRequire("4FqPi");
var $8844cc273e595fed$var$$toString = $4pAjD('Object.prototype.toString');

var $8844cc273e595fed$var$hasToStringTag = (parcelRequire("kReKw"))();
var $8844cc273e595fed$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $8844cc273e595fed$var$typedArrays = $7ZV4l();
var $8844cc273e595fed$var$$slice = $4pAjD('String.prototype.slice');
var $8844cc273e595fed$var$toStrTags = {};
var $8844cc273e595fed$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($8844cc273e595fed$var$hasToStringTag && $4FqPi && $8844cc273e595fed$var$getPrototypeOf) $c1BbV($8844cc273e595fed$var$typedArrays, function(typedArray) {
    if (typeof $8844cc273e595fed$var$g[typedArray] === 'function') {
        var arr = new $8844cc273e595fed$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $8844cc273e595fed$var$getPrototypeOf(arr);
            var descriptor = $4FqPi(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $8844cc273e595fed$var$getPrototypeOf(proto);
                descriptor = $4FqPi(superProto, Symbol.toStringTag);
            }
            $8844cc273e595fed$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $8844cc273e595fed$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $c1BbV($8844cc273e595fed$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $4cRbO = parcelRequire("4cRbO");
module.exports = function whichTypedArray(value) {
    if (!$4cRbO(value)) return false;
    if (!$8844cc273e595fed$var$hasToStringTag || !(Symbol.toStringTag in value)) return $8844cc273e595fed$var$$slice($8844cc273e595fed$var$$toString(value), 8, -1);
    return $8844cc273e595fed$var$tryTypedArrays(value);
};

});
parcelRegister("c1BbV", function(module, exports) {
'use strict';

var $4ACdk = parcelRequire("4ACdk");
var $8c126d78dbd8af87$var$toStr = Object.prototype.toString;
var $8c126d78dbd8af87$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8c126d78dbd8af87$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($8c126d78dbd8af87$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $8c126d78dbd8af87$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $8c126d78dbd8af87$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($8c126d78dbd8af87$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $8c126d78dbd8af87$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$4ACdk(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($8c126d78dbd8af87$var$toStr.call(list) === '[object Array]') $8c126d78dbd8af87$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $8c126d78dbd8af87$var$forEachString(list, iterator, receiver);
    else $8c126d78dbd8af87$var$forEachObject(list, iterator, receiver);
};
module.exports = $8c126d78dbd8af87$var$forEach;

});
parcelRegister("4ACdk", function(module, exports) {
'use strict';
var $35782abcc165aa3d$var$fnToStr = Function.prototype.toString;
var $35782abcc165aa3d$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $35782abcc165aa3d$var$badArrayLike;
var $35782abcc165aa3d$var$isCallableMarker;
if (typeof $35782abcc165aa3d$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $35782abcc165aa3d$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $35782abcc165aa3d$var$isCallableMarker;
        }
    });
    $35782abcc165aa3d$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $35782abcc165aa3d$var$reflectApply(function() {
        throw 42;
    }, null, $35782abcc165aa3d$var$badArrayLike);
} catch (_) {
    if (_ !== $35782abcc165aa3d$var$isCallableMarker) $35782abcc165aa3d$var$reflectApply = null;
}
else $35782abcc165aa3d$var$reflectApply = null;
var $35782abcc165aa3d$var$constructorRegex = /^\s*class\b/;
var $35782abcc165aa3d$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $35782abcc165aa3d$var$fnToStr.call(value);
        return $35782abcc165aa3d$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $35782abcc165aa3d$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($35782abcc165aa3d$var$isES6ClassFn(value)) return false;
        $35782abcc165aa3d$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $35782abcc165aa3d$var$toStr = Object.prototype.toString;
var $35782abcc165aa3d$var$objectClass = '[object Object]';
var $35782abcc165aa3d$var$fnClass = '[object Function]';
var $35782abcc165aa3d$var$genClass = '[object GeneratorFunction]';
var $35782abcc165aa3d$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $35782abcc165aa3d$var$ddaClass2 = '[object HTML document.all class]';
var $35782abcc165aa3d$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $35782abcc165aa3d$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $35782abcc165aa3d$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $35782abcc165aa3d$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $35782abcc165aa3d$var$all = document.all;
    if ($35782abcc165aa3d$var$toStr.call($35782abcc165aa3d$var$all) === $35782abcc165aa3d$var$toStr.call(document.all)) $35782abcc165aa3d$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($35782abcc165aa3d$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $35782abcc165aa3d$var$toStr.call(value);
            return (str === $35782abcc165aa3d$var$ddaClass || str === $35782abcc165aa3d$var$ddaClass2 || str === $35782abcc165aa3d$var$ddaClass3 // opera 12.16
             || str === $35782abcc165aa3d$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $35782abcc165aa3d$var$reflectApply ? function isCallable(value) {
    if ($35782abcc165aa3d$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $35782abcc165aa3d$var$reflectApply(value, null, $35782abcc165aa3d$var$badArrayLike);
    } catch (e) {
        if (e !== $35782abcc165aa3d$var$isCallableMarker) return false;
    }
    return !$35782abcc165aa3d$var$isES6ClassFn(value) && $35782abcc165aa3d$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($35782abcc165aa3d$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($35782abcc165aa3d$var$hasToStringTag) return $35782abcc165aa3d$var$tryFunctionObject(value);
    if ($35782abcc165aa3d$var$isES6ClassFn(value)) return false;
    var strClass = $35782abcc165aa3d$var$toStr.call(value);
    if (strClass !== $35782abcc165aa3d$var$fnClass && strClass !== $35782abcc165aa3d$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $35782abcc165aa3d$var$tryFunctionObject(value);
};

});


parcelRegister("7ZV4l", function(module, exports) {
'use strict';
var $5d2a7fa083c9d168$var$possibleNames = [
    'BigInt64Array',
    'BigUint64Array',
    'Float32Array',
    'Float64Array',
    'Int16Array',
    'Int32Array',
    'Int8Array',
    'Uint16Array',
    'Uint32Array',
    'Uint8Array',
    'Uint8ClampedArray'
];
var $5d2a7fa083c9d168$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $5d2a7fa083c9d168$var$possibleNames.length; i++)if (typeof $5d2a7fa083c9d168$var$g[$5d2a7fa083c9d168$var$possibleNames[i]] === 'function') out[out.length] = $5d2a7fa083c9d168$var$possibleNames[i];
    return out;
};

});

parcelRegister("4pAjD", function(module, exports) {
'use strict';

var $4SzuX = parcelRequire("4SzuX");

var $5ckum = parcelRequire("5ckum");
var $3365aac206b02d67$var$$indexOf = $5ckum($4SzuX('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $4SzuX(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $3365aac206b02d67$var$$indexOf(name, '.prototype.') > -1) return $5ckum(intrinsic);
    return intrinsic;
};

});
parcelRegister("5ckum", function(module, exports) {
'use strict';

var $4Q114 = parcelRequire("4Q114");

var $26wx2 = parcelRequire("26wx2");

var $62qfL = parcelRequire("62qfL");

var $jsM6u = parcelRequire("jsM6u");
module.exports = function callBind(originalFunction) {
    var func = $62qfL(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $4Q114(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($26wx2) $26wx2(module.exports, 'apply', {
    value: $jsM6u
});
else module.exports.apply = $jsM6u;

});
parcelRegister("4Q114", function(module, exports) {
'use strict';

var $4SzuX = parcelRequire("4SzuX");

var $6v9V1 = parcelRequire("6v9V1");

var $385cce89a3134003$var$hasDescriptors = (parcelRequire("4sUAX"))();

var $4FqPi = parcelRequire("4FqPi");

var $gIZMM = parcelRequire("gIZMM");
var $385cce89a3134003$var$$floor = $4SzuX('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $gIZMM('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $385cce89a3134003$var$$floor(length) !== length) throw new $gIZMM('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $4FqPi) {
        var desc = $4FqPi(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($385cce89a3134003$var$hasDescriptors) $6v9V1(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $6v9V1(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("6v9V1", function(module, exports) {
'use strict';

var $26wx2 = parcelRequire("26wx2");

var $hqvAp = parcelRequire("hqvAp");

var $gIZMM = parcelRequire("gIZMM");

var $4FqPi = parcelRequire("4FqPi");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $gIZMM('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $gIZMM('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $gIZMM('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $gIZMM('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $gIZMM('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $gIZMM('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$4FqPi && $4FqPi(obj, property);
    if ($26wx2) $26wx2(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $hqvAp('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("4sUAX", function(module, exports) {
'use strict';

var $26wx2 = parcelRequire("26wx2");
var $3405ad8cce6ccbea$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$26wx2;
};
$3405ad8cce6ccbea$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$26wx2) return null;
    try {
        return $26wx2([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $3405ad8cce6ccbea$var$hasPropertyDescriptors;

});


parcelRegister("jsM6u", function(module, exports) {
'use strict';

var $3nZu2 = parcelRequire("3nZu2");

var $4qoSm = parcelRequire("4qoSm");

var $bB6Xx = parcelRequire("bB6Xx");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $bB6Xx($3nZu2, $4qoSm, arguments);
};

});



parcelRegister("4cRbO", function(module, exports) {
'use strict';

var $c1BbV = parcelRequire("c1BbV");

var $7ZV4l = parcelRequire("7ZV4l");

var $4pAjD = parcelRequire("4pAjD");
var $31018ac40d0372d1$var$$toString = $4pAjD('Object.prototype.toString');

var $31018ac40d0372d1$var$hasToStringTag = (parcelRequire("kReKw"))();

var $4FqPi = parcelRequire("4FqPi");
var $31018ac40d0372d1$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $31018ac40d0372d1$var$typedArrays = $7ZV4l();
var $31018ac40d0372d1$var$$indexOf = $4pAjD('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $31018ac40d0372d1$var$$slice = $4pAjD('String.prototype.slice');
var $31018ac40d0372d1$var$toStrTags = {};
var $31018ac40d0372d1$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($31018ac40d0372d1$var$hasToStringTag && $4FqPi && $31018ac40d0372d1$var$getPrototypeOf) $c1BbV($31018ac40d0372d1$var$typedArrays, function(typedArray) {
    var arr = new $31018ac40d0372d1$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $31018ac40d0372d1$var$getPrototypeOf(arr);
        var descriptor = $4FqPi(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $31018ac40d0372d1$var$getPrototypeOf(proto);
            descriptor = $4FqPi(superProto, Symbol.toStringTag);
        }
        $31018ac40d0372d1$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $31018ac40d0372d1$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $c1BbV($31018ac40d0372d1$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$31018ac40d0372d1$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $31018ac40d0372d1$var$$slice($31018ac40d0372d1$var$$toString(value), 8, -1);
        return $31018ac40d0372d1$var$$indexOf($31018ac40d0372d1$var$typedArrays, tag) > -1;
    }
    if (!$4FqPi) return false;
    return $31018ac40d0372d1$var$tryTypedArrays(value);
};

});



parcelRegister("c3lyk", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("6sBs0", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("UziBF", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $3rPrU = parcelRequire("3rPrU");
'use strict';
function $0aa09cbeabf2af8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0aa09cbeabf2af8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0aa09cbeabf2af8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0aa09cbeabf2af8d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0aa09cbeabf2af8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0aa09cbeabf2af8d$var$_defineProperty(obj, key, value) {
    key = $0aa09cbeabf2af8d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0aa09cbeabf2af8d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0aa09cbeabf2af8d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0aa09cbeabf2af8d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0aa09cbeabf2af8d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0aa09cbeabf2af8d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0aa09cbeabf2af8d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0aa09cbeabf2af8d$var$_toPropertyKey(arg) {
    var key = $0aa09cbeabf2af8d$var$_toPrimitive(arg, "string");
    return $0aa09cbeabf2af8d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0aa09cbeabf2af8d$var$_toPrimitive(input, hint) {
    if ($0aa09cbeabf2af8d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0aa09cbeabf2af8d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0aa09cbeabf2af8d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0aa09cbeabf2af8d$var$_setPrototypeOf(subClass, superClass);
}
function $0aa09cbeabf2af8d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0aa09cbeabf2af8d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0aa09cbeabf2af8d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0aa09cbeabf2af8d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0aa09cbeabf2af8d$var$_possibleConstructorReturn(this, result);
    };
}
function $0aa09cbeabf2af8d$var$_possibleConstructorReturn(self, call) {
    if (call && ($0aa09cbeabf2af8d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0aa09cbeabf2af8d$var$_assertThisInitialized(self);
}
function $0aa09cbeabf2af8d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0aa09cbeabf2af8d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $0aa09cbeabf2af8d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$0aa09cbeabf2af8d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $0aa09cbeabf2af8d$var$_construct(Class, arguments, $0aa09cbeabf2af8d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $0aa09cbeabf2af8d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $0aa09cbeabf2af8d$var$_wrapNativeSuper(Class);
}
function $0aa09cbeabf2af8d$var$_construct(Parent, args, Class) {
    if ($0aa09cbeabf2af8d$var$_isNativeReflectConstruct()) $0aa09cbeabf2af8d$var$_construct = Reflect.construct.bind();
    else $0aa09cbeabf2af8d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $0aa09cbeabf2af8d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $0aa09cbeabf2af8d$var$_construct.apply(null, arguments);
}
function $0aa09cbeabf2af8d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0aa09cbeabf2af8d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $0aa09cbeabf2af8d$var$_setPrototypeOf(o, p) {
    $0aa09cbeabf2af8d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0aa09cbeabf2af8d$var$_setPrototypeOf(o, p);
}
function $0aa09cbeabf2af8d$var$_getPrototypeOf(o) {
    $0aa09cbeabf2af8d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0aa09cbeabf2af8d$var$_getPrototypeOf(o);
}
function $0aa09cbeabf2af8d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0aa09cbeabf2af8d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0aa09cbeabf2af8d$var$_typeof(o);
}

var $dCmQe = parcelRequire("dCmQe");
var $0aa09cbeabf2af8d$var$inspect = $dCmQe.inspect;

var $e1X1x = parcelRequire("e1X1x");
var $0aa09cbeabf2af8d$var$ERR_INVALID_ARG_TYPE = $e1X1x.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $0aa09cbeabf2af8d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $0aa09cbeabf2af8d$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $0aa09cbeabf2af8d$var$blue = '';
var $0aa09cbeabf2af8d$var$green = '';
var $0aa09cbeabf2af8d$var$red = '';
var $0aa09cbeabf2af8d$var$white = '';
var $0aa09cbeabf2af8d$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $0aa09cbeabf2af8d$var$kMaxShortLength = 10;
function $0aa09cbeabf2af8d$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $0aa09cbeabf2af8d$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $0aa09cbeabf2af8d$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $0aa09cbeabf2af8d$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $0aa09cbeabf2af8d$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $0aa09cbeabf2af8d$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $0aa09cbeabf2af8d$var$_typeof(actual) === 'object' && $0aa09cbeabf2af8d$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $0aa09cbeabf2af8d$var$kMaxShortLength) {
            if (($0aa09cbeabf2af8d$var$_typeof(actual) !== 'object' || actual === null) && ($0aa09cbeabf2af8d$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($0aa09cbeabf2af8d$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $3rPrU.stderr && $3rPrU.stderr.isTTY ? $3rPrU.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($0aa09cbeabf2af8d$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($0aa09cbeabf2af8d$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $0aa09cbeabf2af8d$var$kReadableOperator[operator] + "\n".concat($0aa09cbeabf2af8d$var$green, "+ actual").concat($0aa09cbeabf2af8d$var$white, " ").concat($0aa09cbeabf2af8d$var$red, "- expected").concat($0aa09cbeabf2af8d$var$white);
    var skippedMsg = " ".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($0aa09cbeabf2af8d$var$red, "-").concat($0aa09cbeabf2af8d$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($0aa09cbeabf2af8d$var$green, "+").concat($0aa09cbeabf2af8d$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$0aa09cbeabf2af8d$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $0aa09cbeabf2af8d$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($0aa09cbeabf2af8d$var$green, "+").concat($0aa09cbeabf2af8d$var$white, " ").concat(actualLine);
                other += "\n".concat($0aa09cbeabf2af8d$var$red, "-").concat($0aa09cbeabf2af8d$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white).concat(other, "\n") + "".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $0aa09cbeabf2af8d$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $0aa09cbeabf2af8d$var$_inherits(AssertionError, _Error);
    var _super = $0aa09cbeabf2af8d$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $0aa09cbeabf2af8d$var$_classCallCheck(this, AssertionError);
        if ($0aa09cbeabf2af8d$var$_typeof(options) !== 'object' || options === null) throw new $0aa09cbeabf2af8d$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($3rPrU.stderr && $3rPrU.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($3rPrU.stderr && $3rPrU.stderr.getColorDepth && $3rPrU.stderr.getColorDepth() !== 1) {
                    $0aa09cbeabf2af8d$var$blue = "\x1B[34m";
                    $0aa09cbeabf2af8d$var$green = "\x1B[32m";
                    $0aa09cbeabf2af8d$var$white = "\x1B[39m";
                    $0aa09cbeabf2af8d$var$red = "\x1B[31m";
                } else {
                    $0aa09cbeabf2af8d$var$blue = '';
                    $0aa09cbeabf2af8d$var$green = '';
                    $0aa09cbeabf2af8d$var$white = '';
                    $0aa09cbeabf2af8d$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($0aa09cbeabf2af8d$var$_typeof(actual) === 'object' && actual !== null && $0aa09cbeabf2af8d$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $0aa09cbeabf2af8d$var$copyError(actual);
                expected = $0aa09cbeabf2af8d$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $0aa09cbeabf2af8d$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $0aa09cbeabf2af8d$var$kReadableOperator[operator];
                var res = $0aa09cbeabf2af8d$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $0aa09cbeabf2af8d$var$_typeof(actual) === 'object' && actual !== null) base = $0aa09cbeabf2af8d$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($0aa09cbeabf2af8d$var$blue, "...").concat($0aa09cbeabf2af8d$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $0aa09cbeabf2af8d$var$inspectValue(actual);
                var other = '';
                var knownOperators = $0aa09cbeabf2af8d$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($0aa09cbeabf2af8d$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($0aa09cbeabf2af8d$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($0aa09cbeabf2af8d$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($0aa09cbeabf2af8d$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $0aa09cbeabf2af8d$var$_possibleConstructorReturn(_this);
    }
    $0aa09cbeabf2af8d$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $0aa09cbeabf2af8d$var$inspect(this, $0aa09cbeabf2af8d$var$_objectSpread($0aa09cbeabf2af8d$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $0aa09cbeabf2af8d$var$_wrapNativeSuper(Error), $0aa09cbeabf2af8d$var$inspect.custom);
module.exports = $0aa09cbeabf2af8d$var$AssertionError;

});

parcelRegister("foTII", function(module, exports) {
'use strict';

var $bUG3o = parcelRequire("bUG3o");
var $b36451cc37d121c1$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $b36451cc37d121c1$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $bUG3o;
    if ($b36451cc37d121c1$var$lacksProperEnumerationOrder()) return $bUG3o;
    if ($b36451cc37d121c1$var$assignHasPendingExceptions()) return $bUG3o;
    return Object.assign;
};

});
parcelRegister("bUG3o", function(module, exports) {
'use strict';

var $jR4Is = parcelRequire("jR4Is");

var $8ac58ba7740841d4$var$hasSymbols = (parcelRequire("aldEI"))();

var $4pAjD = parcelRequire("4pAjD");
var $8ac58ba7740841d4$var$toObject = Object;
var $8ac58ba7740841d4$var$$push = $4pAjD('Array.prototype.push');
var $8ac58ba7740841d4$var$$propIsEnumerable = $4pAjD('Object.prototype.propertyIsEnumerable');
var $8ac58ba7740841d4$var$originalGetSymbols = $8ac58ba7740841d4$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $8ac58ba7740841d4$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $8ac58ba7740841d4$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $jR4Is(from);
        var getSymbols = $8ac58ba7740841d4$var$hasSymbols && (Object.getOwnPropertySymbols || $8ac58ba7740841d4$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($8ac58ba7740841d4$var$$propIsEnumerable(from, key)) $8ac58ba7740841d4$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($8ac58ba7740841d4$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("jR4Is", function(module, exports) {
'use strict';
var $e746a01084de15fc$var$slice = Array.prototype.slice;

var $gdNDS = parcelRequire("gdNDS");
var $e746a01084de15fc$var$origKeys = Object.keys;

var $e746a01084de15fc$var$keysShim = $e746a01084de15fc$var$origKeys ? function keys(o) {
    return $e746a01084de15fc$var$origKeys(o);
} : (parcelRequire("dHhHS"));
var $e746a01084de15fc$var$originalKeys = Object.keys;
$e746a01084de15fc$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($gdNDS(object)) return $e746a01084de15fc$var$originalKeys($e746a01084de15fc$var$slice.call(object));
            return $e746a01084de15fc$var$originalKeys(object);
        };
    } else Object.keys = $e746a01084de15fc$var$keysShim;
    return Object.keys || $e746a01084de15fc$var$keysShim;
};
module.exports = $e746a01084de15fc$var$keysShim;

});
parcelRegister("gdNDS", function(module, exports) {
'use strict';
var $bcf45e207c7cf0a2$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $bcf45e207c7cf0a2$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $bcf45e207c7cf0a2$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("dHhHS", function(module, exports) {
'use strict';
var $9f8d06acbe6241a5$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $9f8d06acbe6241a5$var$has = Object.prototype.hasOwnProperty;
    var $9f8d06acbe6241a5$var$toStr = Object.prototype.toString;
    var $9f8d06acbe6241a5$var$isArgs = (parcelRequire("gdNDS")); // eslint-disable-line global-require
    var $9f8d06acbe6241a5$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $9f8d06acbe6241a5$var$hasDontEnumBug = !$9f8d06acbe6241a5$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $9f8d06acbe6241a5$var$hasProtoEnumBug = $9f8d06acbe6241a5$var$isEnumerable.call(function() {}, 'prototype');
    var $9f8d06acbe6241a5$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $9f8d06acbe6241a5$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $9f8d06acbe6241a5$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $9f8d06acbe6241a5$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$9f8d06acbe6241a5$var$excludedKeys['$' + k] && $9f8d06acbe6241a5$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $9f8d06acbe6241a5$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $9f8d06acbe6241a5$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$9f8d06acbe6241a5$var$hasAutomationEqualityBug) return $9f8d06acbe6241a5$var$equalsConstructorPrototype(o);
        try {
            return $9f8d06acbe6241a5$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $9f8d06acbe6241a5$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $9f8d06acbe6241a5$var$toStr.call(object) === '[object Function]';
        var isArguments = $9f8d06acbe6241a5$var$isArgs(object);
        var isString = isObject && $9f8d06acbe6241a5$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $9f8d06acbe6241a5$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$9f8d06acbe6241a5$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $9f8d06acbe6241a5$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($9f8d06acbe6241a5$var$hasDontEnumBug) {
            var skipConstructor = $9f8d06acbe6241a5$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $9f8d06acbe6241a5$var$dontEnums.length; ++k)if (!(skipConstructor && $9f8d06acbe6241a5$var$dontEnums[k] === 'constructor') && $9f8d06acbe6241a5$var$has.call(object, $9f8d06acbe6241a5$var$dontEnums[k])) theKeys.push($9f8d06acbe6241a5$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $9f8d06acbe6241a5$var$keysShim;

});




parcelRegister("4YK7U", function(module, exports) {
'use strict';

var $jTfum = parcelRequire("jTfum");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $jTfum;
};

});
parcelRegister("jTfum", function(module, exports) {
'use strict';
var $e7af2b2088128a66$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($e7af2b2088128a66$var$numberIsNaN(a) && $e7af2b2088128a66$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("8d0D6", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $5fa006a87a0faa0f$var$_slicedToArray(arr, i) {
    return $5fa006a87a0faa0f$var$_arrayWithHoles(arr) || $5fa006a87a0faa0f$var$_iterableToArrayLimit(arr, i) || $5fa006a87a0faa0f$var$_unsupportedIterableToArray(arr, i) || $5fa006a87a0faa0f$var$_nonIterableRest();
}
function $5fa006a87a0faa0f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5fa006a87a0faa0f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5fa006a87a0faa0f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5fa006a87a0faa0f$var$_arrayLikeToArray(o, minLen);
}
function $5fa006a87a0faa0f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5fa006a87a0faa0f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5fa006a87a0faa0f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5fa006a87a0faa0f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5fa006a87a0faa0f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5fa006a87a0faa0f$var$_typeof(o);
}
var $5fa006a87a0faa0f$var$regexFlagsSupported = /a/g.flags !== undefined;
var $5fa006a87a0faa0f$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $5fa006a87a0faa0f$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $5fa006a87a0faa0f$var$objectIs = Object.is ? Object.is : (parcelRequire("6Bk5Y"));
var $5fa006a87a0faa0f$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $5fa006a87a0faa0f$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("6GLs6"));
function $5fa006a87a0faa0f$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $5fa006a87a0faa0f$var$hasOwnProperty = $5fa006a87a0faa0f$var$uncurryThis(Object.prototype.hasOwnProperty);
var $5fa006a87a0faa0f$var$propertyIsEnumerable = $5fa006a87a0faa0f$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $5fa006a87a0faa0f$var$objectToString = $5fa006a87a0faa0f$var$uncurryThis(Object.prototype.toString);

var $dCmQe = parcelRequire("dCmQe");
var $5fa006a87a0faa0f$require$_require$types = $dCmQe.types;
var $5fa006a87a0faa0f$var$isAnyArrayBuffer = $5fa006a87a0faa0f$require$_require$types.isAnyArrayBuffer, $5fa006a87a0faa0f$var$isArrayBufferView = $5fa006a87a0faa0f$require$_require$types.isArrayBufferView, $5fa006a87a0faa0f$var$isDate = $5fa006a87a0faa0f$require$_require$types.isDate, $5fa006a87a0faa0f$var$isMap = $5fa006a87a0faa0f$require$_require$types.isMap, $5fa006a87a0faa0f$var$isRegExp = $5fa006a87a0faa0f$require$_require$types.isRegExp, $5fa006a87a0faa0f$var$isSet = $5fa006a87a0faa0f$require$_require$types.isSet, $5fa006a87a0faa0f$var$isNativeError = $5fa006a87a0faa0f$require$_require$types.isNativeError, $5fa006a87a0faa0f$var$isBoxedPrimitive = $5fa006a87a0faa0f$require$_require$types.isBoxedPrimitive, $5fa006a87a0faa0f$var$isNumberObject = $5fa006a87a0faa0f$require$_require$types.isNumberObject, $5fa006a87a0faa0f$var$isStringObject = $5fa006a87a0faa0f$require$_require$types.isStringObject, $5fa006a87a0faa0f$var$isBooleanObject = $5fa006a87a0faa0f$require$_require$types.isBooleanObject, $5fa006a87a0faa0f$var$isBigIntObject = $5fa006a87a0faa0f$require$_require$types.isBigIntObject, $5fa006a87a0faa0f$var$isSymbolObject = $5fa006a87a0faa0f$require$_require$types.isSymbolObject, $5fa006a87a0faa0f$var$isFloat32Array = $5fa006a87a0faa0f$require$_require$types.isFloat32Array, $5fa006a87a0faa0f$var$isFloat64Array = $5fa006a87a0faa0f$require$_require$types.isFloat64Array;
function $5fa006a87a0faa0f$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $5fa006a87a0faa0f$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($5fa006a87a0faa0f$var$isNonIndex).concat($5fa006a87a0faa0f$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $5fa006a87a0faa0f$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $5fa006a87a0faa0f$var$ONLY_ENUMERABLE = undefined;
var $5fa006a87a0faa0f$var$kStrict = true;
var $5fa006a87a0faa0f$var$kLoose = false;
var $5fa006a87a0faa0f$var$kNoIterator = 0;
var $5fa006a87a0faa0f$var$kIsArray = 1;
var $5fa006a87a0faa0f$var$kIsSet = 2;
var $5fa006a87a0faa0f$var$kIsMap = 3;
// Check if they have the same source and flags
function $5fa006a87a0faa0f$var$areSimilarRegExps(a, b) {
    return $5fa006a87a0faa0f$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $5fa006a87a0faa0f$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $5fa006a87a0faa0f$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $5fa006a87a0faa0f$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $5fa006a87a0faa0f$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $5fa006a87a0faa0f$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $5fa006a87a0faa0f$var$isEqualBoxedPrimitive(val1, val2) {
    if ($5fa006a87a0faa0f$var$isNumberObject(val1)) return $5fa006a87a0faa0f$var$isNumberObject(val2) && $5fa006a87a0faa0f$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($5fa006a87a0faa0f$var$isStringObject(val1)) return $5fa006a87a0faa0f$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($5fa006a87a0faa0f$var$isBooleanObject(val1)) return $5fa006a87a0faa0f$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($5fa006a87a0faa0f$var$isBigIntObject(val1)) return $5fa006a87a0faa0f$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $5fa006a87a0faa0f$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $5fa006a87a0faa0f$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $5fa006a87a0faa0f$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($5fa006a87a0faa0f$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $5fa006a87a0faa0f$var$numberIsNaN(val1) && $5fa006a87a0faa0f$var$numberIsNaN(val2);
        if ($5fa006a87a0faa0f$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $5fa006a87a0faa0f$var$_typeof(val1) !== 'object') {
            if (val2 === null || $5fa006a87a0faa0f$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $5fa006a87a0faa0f$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $5fa006a87a0faa0f$var$objectToString(val1);
    var val2Tag = $5fa006a87a0faa0f$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $5fa006a87a0faa0f$var$getOwnNonIndexProperties(val1, $5fa006a87a0faa0f$var$ONLY_ENUMERABLE);
        var keys2 = $5fa006a87a0faa0f$var$getOwnNonIndexProperties(val2, $5fa006a87a0faa0f$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $5fa006a87a0faa0f$var$keyCheck(val1, val2, strict, memos, $5fa006a87a0faa0f$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$5fa006a87a0faa0f$var$isMap(val1) && $5fa006a87a0faa0f$var$isMap(val2) || !$5fa006a87a0faa0f$var$isSet(val1) && $5fa006a87a0faa0f$var$isSet(val2)) return false;
    }
    if ($5fa006a87a0faa0f$var$isDate(val1)) {
        if (!$5fa006a87a0faa0f$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($5fa006a87a0faa0f$var$isRegExp(val1)) {
        if (!$5fa006a87a0faa0f$var$isRegExp(val2) || !$5fa006a87a0faa0f$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($5fa006a87a0faa0f$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($5fa006a87a0faa0f$var$isArrayBufferView(val1)) {
        if (!strict && ($5fa006a87a0faa0f$var$isFloat32Array(val1) || $5fa006a87a0faa0f$var$isFloat64Array(val1))) {
            if (!$5fa006a87a0faa0f$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$5fa006a87a0faa0f$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $5fa006a87a0faa0f$var$getOwnNonIndexProperties(val1, $5fa006a87a0faa0f$var$ONLY_ENUMERABLE);
        var _keys2 = $5fa006a87a0faa0f$var$getOwnNonIndexProperties(val2, $5fa006a87a0faa0f$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $5fa006a87a0faa0f$var$keyCheck(val1, val2, strict, memos, $5fa006a87a0faa0f$var$kNoIterator, _keys);
    } else if ($5fa006a87a0faa0f$var$isSet(val1)) {
        if (!$5fa006a87a0faa0f$var$isSet(val2) || val1.size !== val2.size) return false;
        return $5fa006a87a0faa0f$var$keyCheck(val1, val2, strict, memos, $5fa006a87a0faa0f$var$kIsSet);
    } else if ($5fa006a87a0faa0f$var$isMap(val1)) {
        if (!$5fa006a87a0faa0f$var$isMap(val2) || val1.size !== val2.size) return false;
        return $5fa006a87a0faa0f$var$keyCheck(val1, val2, strict, memos, $5fa006a87a0faa0f$var$kIsMap);
    } else if ($5fa006a87a0faa0f$var$isAnyArrayBuffer(val1)) {
        if (!$5fa006a87a0faa0f$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($5fa006a87a0faa0f$var$isBoxedPrimitive(val1) && !$5fa006a87a0faa0f$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $5fa006a87a0faa0f$var$keyCheck(val1, val2, strict, memos, $5fa006a87a0faa0f$var$kNoIterator);
}
function $5fa006a87a0faa0f$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $5fa006a87a0faa0f$var$propertyIsEnumerable(val, k);
    });
}
function $5fa006a87a0faa0f$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$5fa006a87a0faa0f$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $5fa006a87a0faa0f$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($5fa006a87a0faa0f$var$propertyIsEnumerable(val1, key)) {
                    if (!$5fa006a87a0faa0f$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($5fa006a87a0faa0f$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $5fa006a87a0faa0f$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $5fa006a87a0faa0f$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $5fa006a87a0faa0f$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $5fa006a87a0faa0f$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $5fa006a87a0faa0f$var$kNoIterator || iterationType === $5fa006a87a0faa0f$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $5fa006a87a0faa0f$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $5fa006a87a0faa0f$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $5fa006a87a0faa0f$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($5fa006a87a0faa0f$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $5fa006a87a0faa0f$var$findLooseMatchingPrimitives(prim) {
    switch($5fa006a87a0faa0f$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($5fa006a87a0faa0f$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $5fa006a87a0faa0f$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $5fa006a87a0faa0f$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $5fa006a87a0faa0f$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $5fa006a87a0faa0f$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$5fa006a87a0faa0f$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $5fa006a87a0faa0f$var$innerDeepEqual(item, curB, false, memo);
}
function $5fa006a87a0faa0f$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $5fa006a87a0faa0f$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($5fa006a87a0faa0f$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$5fa006a87a0faa0f$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $5fa006a87a0faa0f$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($5fa006a87a0faa0f$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$5fa006a87a0faa0f$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$5fa006a87a0faa0f$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $5fa006a87a0faa0f$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $5fa006a87a0faa0f$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($5fa006a87a0faa0f$var$innerDeepEqual(key1, key2, strict, memo) && $5fa006a87a0faa0f$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $5fa006a87a0faa0f$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $5fa006a87a0faa0f$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $5fa006a87a0faa0f$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($5fa006a87a0faa0f$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$5fa006a87a0faa0f$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$5fa006a87a0faa0f$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $5fa006a87a0faa0f$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $5fa006a87a0faa0f$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($5fa006a87a0faa0f$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$5fa006a87a0faa0f$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$5fa006a87a0faa0f$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$5fa006a87a0faa0f$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $5fa006a87a0faa0f$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $5fa006a87a0faa0f$var$kIsSet) {
        if (!$5fa006a87a0faa0f$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $5fa006a87a0faa0f$var$kIsMap) {
        if (!$5fa006a87a0faa0f$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $5fa006a87a0faa0f$var$kIsArray) for(; i < a.length; i++){
        if ($5fa006a87a0faa0f$var$hasOwnProperty(a, i)) {
            if (!$5fa006a87a0faa0f$var$hasOwnProperty(b, i) || !$5fa006a87a0faa0f$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($5fa006a87a0faa0f$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$5fa006a87a0faa0f$var$hasOwnProperty(b, key) || !$5fa006a87a0faa0f$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$5fa006a87a0faa0f$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $5fa006a87a0faa0f$var$isDeepEqual(val1, val2) {
    return $5fa006a87a0faa0f$var$innerDeepEqual(val1, val2, $5fa006a87a0faa0f$var$kLoose);
}
function $5fa006a87a0faa0f$var$isDeepStrictEqual(val1, val2) {
    return $5fa006a87a0faa0f$var$innerDeepEqual(val1, val2, $5fa006a87a0faa0f$var$kStrict);
}
module.exports = {
    isDeepEqual: $5fa006a87a0faa0f$var$isDeepEqual,
    isDeepStrictEqual: $5fa006a87a0faa0f$var$isDeepStrictEqual
};

});
parcelRegister("6Bk5Y", function(module, exports) {
'use strict';

var $di50D = parcelRequire("di50D");

var $5ckum = parcelRequire("5ckum");

var $jTfum = parcelRequire("jTfum");

var $4YK7U = parcelRequire("4YK7U");

var $aV4Ho = parcelRequire("aV4Ho");
var $4ce5c94d12666cc3$var$polyfill = $5ckum($4YK7U(), Object);
$di50D($4ce5c94d12666cc3$var$polyfill, {
    getPolyfill: $4YK7U,
    implementation: $jTfum,
    shim: $aV4Ho
});
module.exports = $4ce5c94d12666cc3$var$polyfill;

});
parcelRegister("di50D", function(module, exports) {
'use strict';

var $jR4Is = parcelRequire("jR4Is");
var $9ad0d782ae400477$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $9ad0d782ae400477$var$toStr = Object.prototype.toString;
var $9ad0d782ae400477$var$concat = Array.prototype.concat;

var $6v9V1 = parcelRequire("6v9V1");
var $9ad0d782ae400477$var$isFunction = function(fn) {
    return typeof fn === 'function' && $9ad0d782ae400477$var$toStr.call(fn) === '[object Function]';
};

var $9ad0d782ae400477$var$supportsDescriptors = (parcelRequire("4sUAX"))();
var $9ad0d782ae400477$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$9ad0d782ae400477$var$isFunction(predicate) || !predicate()) return;
    }
    if ($9ad0d782ae400477$var$supportsDescriptors) $6v9V1(object, name, value, true);
    else $6v9V1(object, name, value);
};
var $9ad0d782ae400477$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $jR4Is(map);
    if ($9ad0d782ae400477$var$hasSymbols) props = $9ad0d782ae400477$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$9ad0d782ae400477$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$9ad0d782ae400477$var$defineProperties.supportsDescriptors = !!$9ad0d782ae400477$var$supportsDescriptors;
module.exports = $9ad0d782ae400477$var$defineProperties;

});

parcelRegister("aV4Ho", function(module, exports) {
'use strict';

var $4YK7U = parcelRequire("4YK7U");

var $di50D = parcelRequire("di50D");
module.exports = function shimObjectIs() {
    var polyfill = $4YK7U();
    $di50D(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("6GLs6", function(module, exports) {
'use strict';

var $5ckum = parcelRequire("5ckum");

var $di50D = parcelRequire("di50D");

var $a2t8u = parcelRequire("a2t8u");

var $6dkYn = parcelRequire("6dkYn");

var $f90ga = parcelRequire("f90ga");
var $4deb79607186f38c$var$polyfill = $5ckum($6dkYn(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $di50D($4deb79607186f38c$var$polyfill, {
    getPolyfill: $6dkYn,
    implementation: $a2t8u,
    shim: $f90ga
});
module.exports = $4deb79607186f38c$var$polyfill;

});
parcelRegister("a2t8u", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("6dkYn", function(module, exports) {
'use strict';

var $a2t8u = parcelRequire("a2t8u");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $a2t8u;
};

});

parcelRegister("f90ga", function(module, exports) {
'use strict';

var $di50D = parcelRequire("di50D");

var $6dkYn = parcelRequire("6dkYn");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $6dkYn();
    $di50D(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("bodC8", function(module, exports) {
'use strict';

var $ghkKd = parcelRequire("ghkKd");
var $84ac7f166cdfa11f$require$DuplexStream = $ghkKd.Duplex;

var $6sBs0 = parcelRequire("6sBs0");

var $hLSVK = parcelRequire("hLSVK");
function $84ac7f166cdfa11f$var$BufferListStream(callback) {
    if (!(this instanceof $84ac7f166cdfa11f$var$BufferListStream)) return new $84ac7f166cdfa11f$var$BufferListStream(callback);
    if (typeof callback === 'function') {
        this._callback = callback;
        const piper = (function piper(err) {
            if (this._callback) {
                this._callback(err);
                this._callback = null;
            }
        }).bind(this);
        this.on('pipe', function onPipe(src) {
            src.on('error', piper);
        });
        this.on('unpipe', function onUnpipe(src) {
            src.removeListener('error', piper);
        });
        callback = null;
    }
    $hLSVK._init.call(this, callback);
    $84ac7f166cdfa11f$require$DuplexStream.call(this);
}
$6sBs0($84ac7f166cdfa11f$var$BufferListStream, $84ac7f166cdfa11f$require$DuplexStream);
Object.assign($84ac7f166cdfa11f$var$BufferListStream.prototype, $hLSVK.prototype);
$84ac7f166cdfa11f$var$BufferListStream.prototype._new = function _new(callback) {
    return new $84ac7f166cdfa11f$var$BufferListStream(callback);
};
$84ac7f166cdfa11f$var$BufferListStream.prototype._write = function _write(buf, encoding, callback) {
    this._appendBuffer(buf);
    if (typeof callback === 'function') callback();
};
$84ac7f166cdfa11f$var$BufferListStream.prototype._read = function _read(size) {
    if (!this.length) return this.push(null);
    size = Math.min(size, this.length);
    this.push(this.slice(0, size));
    this.consume(size);
};
$84ac7f166cdfa11f$var$BufferListStream.prototype.end = function end(chunk) {
    $84ac7f166cdfa11f$require$DuplexStream.prototype.end.call(this, chunk);
    if (this._callback) {
        this._callback(null, this.slice());
        this._callback = null;
    }
};
$84ac7f166cdfa11f$var$BufferListStream.prototype._destroy = function _destroy(err, cb) {
    this._bufs.length = 0;
    this.length = 0;
    cb(err);
};
$84ac7f166cdfa11f$var$BufferListStream.prototype._isBufferList = function _isBufferList(b) {
    return b instanceof $84ac7f166cdfa11f$var$BufferListStream || b instanceof $hLSVK || $84ac7f166cdfa11f$var$BufferListStream.isBufferList(b);
};
$84ac7f166cdfa11f$var$BufferListStream.isBufferList = $hLSVK.isBufferList;
module.exports = $84ac7f166cdfa11f$var$BufferListStream;
module.exports.BufferListStream = $84ac7f166cdfa11f$var$BufferListStream;
module.exports.BufferList = $hLSVK;

});
parcelRegister("ghkKd", function(module, exports) {

exports = module.exports = (parcelRequire("6js0k"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("i7pJp"));

exports.Duplex = (parcelRequire("7lvdo"));

exports.Transform = (parcelRequire("htsbb"));

exports.PassThrough = (parcelRequire("9miES"));

exports.finished = (parcelRequire("rnsu2"));

exports.pipeline = (parcelRequire("2GS9P"));

});
parcelRegister("6js0k", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3rPrU = parcelRequire("3rPrU");
'use strict';
module.exports = $498a3d857991f113$var$Readable;
/*<replacement>*/ var $498a3d857991f113$var$Duplex;
/*</replacement>*/ $498a3d857991f113$var$Readable.ReadableState = $498a3d857991f113$var$ReadableState;

var $dl99D = parcelRequire("dl99D");
var $498a3d857991f113$require$EE = $dl99D.EventEmitter;
var $498a3d857991f113$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $9wjt2 = parcelRequire("9wjt2");

var $i9F75 = parcelRequire("i9F75");
var $498a3d857991f113$require$Buffer = $i9F75.Buffer;
const $498a3d857991f113$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $498a3d857991f113$var$_uint8ArrayToBuffer(chunk) {
    return $498a3d857991f113$require$Buffer.from(chunk);
}
function $498a3d857991f113$var$_isUint8Array(obj) {
    return $498a3d857991f113$require$Buffer.isBuffer(obj) || obj instanceof $498a3d857991f113$var$OurUint8Array;
}

var $hC7Qs = parcelRequire("hC7Qs");
let $498a3d857991f113$var$debug;
if ($hC7Qs && $hC7Qs.debuglog) $498a3d857991f113$var$debug = $hC7Qs.debuglog('stream');
else $498a3d857991f113$var$debug = function debug() {};

var $dybEq = parcelRequire("dybEq");

var $7eVbp = parcelRequire("7eVbp");

var $k2O3f = parcelRequire("k2O3f");
const $498a3d857991f113$var$getHighWaterMark = $k2O3f.getHighWaterMark;

var $lviZP = parcelRequire("lviZP");
var $498a3d857991f113$require$_require$codes = $lviZP.codes;
const $498a3d857991f113$var$ERR_INVALID_ARG_TYPE = $498a3d857991f113$require$_require$codes.ERR_INVALID_ARG_TYPE, $498a3d857991f113$var$ERR_STREAM_PUSH_AFTER_EOF = $498a3d857991f113$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $498a3d857991f113$var$ERR_METHOD_NOT_IMPLEMENTED = $498a3d857991f113$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $498a3d857991f113$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $498a3d857991f113$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
let $498a3d857991f113$var$StringDecoder;
let $498a3d857991f113$var$createReadableStreamAsyncIterator;
let $498a3d857991f113$var$from;

(parcelRequire("6sBs0"))($498a3d857991f113$var$Readable, $9wjt2);
const $498a3d857991f113$var$errorOrDestroy = $7eVbp.errorOrDestroy;
const $498a3d857991f113$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $498a3d857991f113$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $498a3d857991f113$var$ReadableState(options, stream, isDuplex) {
    $498a3d857991f113$var$Duplex = $498a3d857991f113$var$Duplex || (parcelRequire("7lvdo"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $498a3d857991f113$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $498a3d857991f113$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $dybEq();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$498a3d857991f113$var$StringDecoder) $498a3d857991f113$var$StringDecoder = (parcelRequire("cgjud")).StringDecoder;
        this.decoder = new $498a3d857991f113$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $498a3d857991f113$var$Readable(options) {
    $498a3d857991f113$var$Duplex = $498a3d857991f113$var$Duplex || (parcelRequire("7lvdo"));
    if (!(this instanceof $498a3d857991f113$var$Readable)) return new $498a3d857991f113$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    const isDuplex = this instanceof $498a3d857991f113$var$Duplex;
    this._readableState = new $498a3d857991f113$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $9wjt2.call(this);
}
Object.defineProperty($498a3d857991f113$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get () {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set (value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$498a3d857991f113$var$Readable.prototype.destroy = $7eVbp.destroy;
$498a3d857991f113$var$Readable.prototype._undestroy = $7eVbp.undestroy;
$498a3d857991f113$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$498a3d857991f113$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $498a3d857991f113$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $498a3d857991f113$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$498a3d857991f113$var$Readable.prototype.unshift = function(chunk) {
    return $498a3d857991f113$var$readableAddChunk(this, chunk, null, true, false);
};
function $498a3d857991f113$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $498a3d857991f113$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $498a3d857991f113$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $498a3d857991f113$var$chunkInvalid(state, chunk);
        if (er) $498a3d857991f113$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $498a3d857991f113$require$Buffer.prototype) chunk = $498a3d857991f113$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $498a3d857991f113$var$errorOrDestroy(stream, new $498a3d857991f113$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $498a3d857991f113$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $498a3d857991f113$var$errorOrDestroy(stream, new $498a3d857991f113$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $498a3d857991f113$var$addChunk(stream, state, chunk, false);
                    else $498a3d857991f113$var$maybeReadMore(stream, state);
                } else $498a3d857991f113$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $498a3d857991f113$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $498a3d857991f113$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $498a3d857991f113$var$emitReadable(stream);
    }
    $498a3d857991f113$var$maybeReadMore(stream, state);
}
function $498a3d857991f113$var$chunkInvalid(state, chunk) {
    var er;
    if (!$498a3d857991f113$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $498a3d857991f113$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$498a3d857991f113$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$498a3d857991f113$var$Readable.prototype.setEncoding = function(enc) {
    if (!$498a3d857991f113$var$StringDecoder) $498a3d857991f113$var$StringDecoder = (parcelRequire("cgjud")).StringDecoder;
    const decoder = new $498a3d857991f113$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    let p = this._readableState.buffer.head;
    let content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
const $498a3d857991f113$var$MAX_HWM = 0x40000000;
function $498a3d857991f113$var$computeNewHighWaterMark(n) {
    if (n >= $498a3d857991f113$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $498a3d857991f113$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $498a3d857991f113$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $498a3d857991f113$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$498a3d857991f113$var$Readable.prototype.read = function(n) {
    $498a3d857991f113$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $498a3d857991f113$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $498a3d857991f113$var$endReadable(this);
        else $498a3d857991f113$var$emitReadable(this);
        return null;
    }
    n = $498a3d857991f113$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $498a3d857991f113$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $498a3d857991f113$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $498a3d857991f113$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $498a3d857991f113$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $498a3d857991f113$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $498a3d857991f113$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $498a3d857991f113$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $498a3d857991f113$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $498a3d857991f113$var$onEofChunk(stream, state) {
    $498a3d857991f113$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $498a3d857991f113$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $498a3d857991f113$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $498a3d857991f113$var$emitReadable(stream) {
    var state = stream._readableState;
    $498a3d857991f113$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $498a3d857991f113$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $3rPrU.nextTick($498a3d857991f113$var$emitReadable_, stream);
    }
}
function $498a3d857991f113$var$emitReadable_(stream) {
    var state = stream._readableState;
    $498a3d857991f113$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $498a3d857991f113$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $498a3d857991f113$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $3rPrU.nextTick($498a3d857991f113$var$maybeReadMore_, stream, state);
    }
}
function $498a3d857991f113$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $498a3d857991f113$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$498a3d857991f113$var$Readable.prototype._read = function(n) {
    $498a3d857991f113$var$errorOrDestroy(this, new $498a3d857991f113$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$498a3d857991f113$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $498a3d857991f113$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $3rPrU.stdout && dest !== $3rPrU.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $3rPrU.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $498a3d857991f113$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $498a3d857991f113$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $498a3d857991f113$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $498a3d857991f113$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $498a3d857991f113$var$debug('ondata');
        var ret = dest.write(chunk);
        $498a3d857991f113$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $498a3d857991f113$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $498a3d857991f113$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $498a3d857991f113$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($498a3d857991f113$var$EElistenerCount(dest, 'error') === 0) $498a3d857991f113$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $498a3d857991f113$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $498a3d857991f113$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $498a3d857991f113$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $498a3d857991f113$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $498a3d857991f113$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $498a3d857991f113$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $498a3d857991f113$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $498a3d857991f113$var$flow(src);
        }
    };
}
$498a3d857991f113$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $498a3d857991f113$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$498a3d857991f113$var$Readable.prototype.on = function(ev, fn) {
    const res = $9wjt2.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $498a3d857991f113$var$debug('on readable', state.length, state.reading);
            if (state.length) $498a3d857991f113$var$emitReadable(this);
            else if (!state.reading) $3rPrU.nextTick($498a3d857991f113$var$nReadingNextTick, this);
        }
    }
    return res;
};
$498a3d857991f113$var$Readable.prototype.addListener = $498a3d857991f113$var$Readable.prototype.on;
$498a3d857991f113$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $9wjt2.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $3rPrU.nextTick($498a3d857991f113$var$updateReadableListening, this);
    return res;
};
$498a3d857991f113$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $9wjt2.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $3rPrU.nextTick($498a3d857991f113$var$updateReadableListening, this);
    return res;
};
function $498a3d857991f113$var$updateReadableListening(self1) {
    const state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $498a3d857991f113$var$nReadingNextTick(self1) {
    $498a3d857991f113$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$498a3d857991f113$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $498a3d857991f113$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $498a3d857991f113$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $498a3d857991f113$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $3rPrU.nextTick($498a3d857991f113$var$resume_, stream, state);
    }
}
function $498a3d857991f113$var$resume_(stream, state) {
    $498a3d857991f113$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $498a3d857991f113$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$498a3d857991f113$var$Readable.prototype.pause = function() {
    $498a3d857991f113$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $498a3d857991f113$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $498a3d857991f113$var$flow(stream) {
    const state = stream._readableState;
    $498a3d857991f113$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$498a3d857991f113$var$Readable.prototype.wrap = function(stream) {
    var state = this._readableState;
    var paused = false;
    stream.on('end', ()=>{
        $498a3d857991f113$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) this.push(chunk);
        }
        this.push(null);
    });
    stream.on('data', (chunk)=>{
        $498a3d857991f113$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $498a3d857991f113$var$kProxyEvents.length; n++)stream.on($498a3d857991f113$var$kProxyEvents[n], this.emit.bind(this, $498a3d857991f113$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = (n)=>{
        $498a3d857991f113$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $498a3d857991f113$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($498a3d857991f113$var$createReadableStreamAsyncIterator === undefined) $498a3d857991f113$var$createReadableStreamAsyncIterator = (parcelRequire("gesp9"));
    return $498a3d857991f113$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($498a3d857991f113$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($498a3d857991f113$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($498a3d857991f113$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$498a3d857991f113$var$Readable._fromList = $498a3d857991f113$var$fromList;
Object.defineProperty($498a3d857991f113$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get () {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $498a3d857991f113$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $498a3d857991f113$var$endReadable(stream) {
    var state = stream._readableState;
    $498a3d857991f113$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $3rPrU.nextTick($498a3d857991f113$var$endReadableNT, state, stream);
    }
}
function $498a3d857991f113$var$endReadableNT(state, stream) {
    $498a3d857991f113$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            const wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $498a3d857991f113$var$Readable.from = function(iterable, opts) {
    if ($498a3d857991f113$var$from === undefined) $498a3d857991f113$var$from = (parcelRequire("615xj"));
    return $498a3d857991f113$var$from($498a3d857991f113$var$Readable, iterable, opts);
};
function $498a3d857991f113$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("dl99D", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $9b6456698d5ab9fb$var$R = typeof Reflect === 'object' ? Reflect : null;
var $9b6456698d5ab9fb$var$ReflectApply = $9b6456698d5ab9fb$var$R && typeof $9b6456698d5ab9fb$var$R.apply === 'function' ? $9b6456698d5ab9fb$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9b6456698d5ab9fb$var$ReflectOwnKeys;
if ($9b6456698d5ab9fb$var$R && typeof $9b6456698d5ab9fb$var$R.ownKeys === 'function') $9b6456698d5ab9fb$var$ReflectOwnKeys = $9b6456698d5ab9fb$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9b6456698d5ab9fb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9b6456698d5ab9fb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9b6456698d5ab9fb$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9b6456698d5ab9fb$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9b6456698d5ab9fb$var$EventEmitter() {
    $9b6456698d5ab9fb$var$EventEmitter.init.call(this);
}
module.exports = $9b6456698d5ab9fb$var$EventEmitter;
module.exports.once = $9b6456698d5ab9fb$var$once;
// Backwards-compat with node 0.10.x
$9b6456698d5ab9fb$var$EventEmitter.EventEmitter = $9b6456698d5ab9fb$var$EventEmitter;
$9b6456698d5ab9fb$var$EventEmitter.prototype._events = undefined;
$9b6456698d5ab9fb$var$EventEmitter.prototype._eventsCount = 0;
$9b6456698d5ab9fb$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9b6456698d5ab9fb$var$defaultMaxListeners = 10;
function $9b6456698d5ab9fb$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($9b6456698d5ab9fb$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $9b6456698d5ab9fb$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $9b6456698d5ab9fb$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $9b6456698d5ab9fb$var$defaultMaxListeners = arg;
    }
});
$9b6456698d5ab9fb$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9b6456698d5ab9fb$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $9b6456698d5ab9fb$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $9b6456698d5ab9fb$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9b6456698d5ab9fb$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9b6456698d5ab9fb$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9b6456698d5ab9fb$var$_getMaxListeners(this);
};
$9b6456698d5ab9fb$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $9b6456698d5ab9fb$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9b6456698d5ab9fb$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9b6456698d5ab9fb$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9b6456698d5ab9fb$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9b6456698d5ab9fb$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9b6456698d5ab9fb$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9b6456698d5ab9fb$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9b6456698d5ab9fb$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9b6456698d5ab9fb$var$_addListener(this, type, listener, false);
};
$9b6456698d5ab9fb$var$EventEmitter.prototype.on = $9b6456698d5ab9fb$var$EventEmitter.prototype.addListener;
$9b6456698d5ab9fb$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9b6456698d5ab9fb$var$_addListener(this, type, listener, true);
};
function $9b6456698d5ab9fb$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9b6456698d5ab9fb$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9b6456698d5ab9fb$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9b6456698d5ab9fb$var$EventEmitter.prototype.once = function once(type, listener) {
    $9b6456698d5ab9fb$var$checkListener(listener);
    this.on(type, $9b6456698d5ab9fb$var$_onceWrap(this, type, listener));
    return this;
};
$9b6456698d5ab9fb$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9b6456698d5ab9fb$var$checkListener(listener);
    this.prependListener(type, $9b6456698d5ab9fb$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9b6456698d5ab9fb$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9b6456698d5ab9fb$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9b6456698d5ab9fb$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$9b6456698d5ab9fb$var$EventEmitter.prototype.off = $9b6456698d5ab9fb$var$EventEmitter.prototype.removeListener;
$9b6456698d5ab9fb$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9b6456698d5ab9fb$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9b6456698d5ab9fb$var$unwrapListeners(evlistener) : $9b6456698d5ab9fb$var$arrayClone(evlistener, evlistener.length);
}
$9b6456698d5ab9fb$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9b6456698d5ab9fb$var$_listeners(this, type, true);
};
$9b6456698d5ab9fb$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9b6456698d5ab9fb$var$_listeners(this, type, false);
};
$9b6456698d5ab9fb$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $9b6456698d5ab9fb$var$listenerCount.call(emitter, type);
};
$9b6456698d5ab9fb$var$EventEmitter.prototype.listenerCount = $9b6456698d5ab9fb$var$listenerCount;
function $9b6456698d5ab9fb$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9b6456698d5ab9fb$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9b6456698d5ab9fb$var$ReflectOwnKeys(this._events) : [];
};
function $9b6456698d5ab9fb$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9b6456698d5ab9fb$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9b6456698d5ab9fb$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9b6456698d5ab9fb$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $9b6456698d5ab9fb$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $9b6456698d5ab9fb$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9b6456698d5ab9fb$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $9b6456698d5ab9fb$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $9b6456698d5ab9fb$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("9wjt2", function(module, exports) {

module.exports = (parcelRequire("dl99D")).EventEmitter;

});

parcelRegister("hC7Qs", function(module, exports) {
"use strict";

});

parcelRegister("dybEq", function(module, exports) {
'use strict';
function $9dd77cfccae7cd38$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9dd77cfccae7cd38$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9dd77cfccae7cd38$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9dd77cfccae7cd38$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9dd77cfccae7cd38$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9dd77cfccae7cd38$var$_defineProperty(obj, key, value) {
    key = $9dd77cfccae7cd38$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9dd77cfccae7cd38$var$_toPropertyKey(arg) {
    var key = $9dd77cfccae7cd38$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $9dd77cfccae7cd38$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $i9F75 = parcelRequire("i9F75");
const $9dd77cfccae7cd38$var$Buffer = $i9F75.Buffer;

var $hC7Qs = parcelRequire("hC7Qs");
const $9dd77cfccae7cd38$var$inspect = $hC7Qs.inspect;
const $9dd77cfccae7cd38$var$custom = $9dd77cfccae7cd38$var$inspect && $9dd77cfccae7cd38$var$inspect.custom || 'inspect';
function $9dd77cfccae7cd38$var$copyBuffer(src, target, offset) {
    $9dd77cfccae7cd38$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = class BufferList {
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $9dd77cfccae7cd38$var$Buffer.alloc(0);
        const ret = $9dd77cfccae7cd38$var$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $9dd77cfccae7cd38$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        var ret;
        if (n < this.head.data.length) {
            // `slice` is the same for buffers and strings.
            ret = this.head.data.slice(0, n);
            this.head.data = this.head.data.slice(n);
        } else if (n === this.head.data.length) // First chunk is a perfect match.
        ret = this.shift();
        else // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
        return ret;
    }
    first() {
        return this.head.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        var p = this.head;
        var c = 1;
        var ret = p.data;
        n -= ret.length;
        while(p = p.next){
            const str = p.data;
            const nb = n > str.length ? str.length : n;
            if (nb === str.length) ret += str;
            else ret += str.slice(0, n);
            n -= nb;
            if (n === 0) {
                if (nb === str.length) {
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    this.head = p;
                    p.data = str.slice(nb);
                }
                break;
            }
            ++c;
        }
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $9dd77cfccae7cd38$var$Buffer.allocUnsafe(n);
        var p = this.head;
        var c = 1;
        p.data.copy(ret);
        n -= p.data.length;
        while(p = p.next){
            const buf = p.data;
            const nb = n > buf.length ? buf.length : n;
            buf.copy(ret, ret.length - n, 0, nb);
            n -= nb;
            if (n === 0) {
                if (nb === buf.length) {
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    this.head = p;
                    p.data = buf.slice(nb);
                }
                break;
            }
            ++c;
        }
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [$9dd77cfccae7cd38$var$custom](_, options) {
        return $9dd77cfccae7cd38$var$inspect(this, $9dd77cfccae7cd38$var$_objectSpread($9dd77cfccae7cd38$var$_objectSpread({}, options), {}, {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
};

});

parcelRegister("7eVbp", function(module, exports) {

var $3rPrU = parcelRequire("3rPrU");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $5456328bc575710e$var$destroy(err, cb) {
    const readableDestroyed = this._readableState && this._readableState.destroyed;
    const writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $3rPrU.nextTick($5456328bc575710e$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $3rPrU.nextTick($5456328bc575710e$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, (err)=>{
        if (!cb && err) {
            if (!this._writableState) $3rPrU.nextTick($5456328bc575710e$var$emitErrorAndCloseNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $3rPrU.nextTick($5456328bc575710e$var$emitErrorAndCloseNT, this, err);
            } else $3rPrU.nextTick($5456328bc575710e$var$emitCloseNT, this);
        } else if (cb) {
            $3rPrU.nextTick($5456328bc575710e$var$emitCloseNT, this);
            cb(err);
        } else $3rPrU.nextTick($5456328bc575710e$var$emitCloseNT, this);
    });
    return this;
}
function $5456328bc575710e$var$emitErrorAndCloseNT(self, err) {
    $5456328bc575710e$var$emitErrorNT(self, err);
    $5456328bc575710e$var$emitCloseNT(self);
}
function $5456328bc575710e$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $5456328bc575710e$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $5456328bc575710e$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $5456328bc575710e$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const rState = stream._readableState;
    const wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $5456328bc575710e$var$destroy,
    undestroy: $5456328bc575710e$var$undestroy,
    errorOrDestroy: $5456328bc575710e$var$errorOrDestroy
};

});

parcelRegister("k2O3f", function(module, exports) {
'use strict';

const $e97ad1b1a9dc6d4c$var$ERR_INVALID_OPT_VALUE = (parcelRequire("lviZP")).codes.ERR_INVALID_OPT_VALUE;
function $e97ad1b1a9dc6d4c$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $e97ad1b1a9dc6d4c$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $e97ad1b1a9dc6d4c$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            const name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $e97ad1b1a9dc6d4c$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $e97ad1b1a9dc6d4c$var$getHighWaterMark
};

});
parcelRegister("lviZP", function(module, exports) {

$parcel$export(module.exports, "codes", () => $fa7b3a800a7f511d$export$e45cb6485273080e, (v) => $fa7b3a800a7f511d$export$e45cb6485273080e = v);
var $fa7b3a800a7f511d$export$e45cb6485273080e;
'use strict';
function $fa7b3a800a7f511d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $fa7b3a800a7f511d$var$codes = {};
function $fa7b3a800a7f511d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $fa7b3a800a7f511d$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $fa7b3a800a7f511d$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $fa7b3a800a7f511d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $fa7b3a800a7f511d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $fa7b3a800a7f511d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $fa7b3a800a7f511d$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$fa7b3a800a7f511d$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$fa7b3a800a7f511d$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $fa7b3a800a7f511d$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($fa7b3a800a7f511d$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($fa7b3a800a7f511d$var$oneOf(expected, 'type'));
    else {
        var type = $fa7b3a800a7f511d$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($fa7b3a800a7f511d$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$fa7b3a800a7f511d$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$fa7b3a800a7f511d$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$fa7b3a800a7f511d$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$fa7b3a800a7f511d$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$fa7b3a800a7f511d$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$fa7b3a800a7f511d$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$fa7b3a800a7f511d$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$fa7b3a800a7f511d$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$fa7b3a800a7f511d$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$fa7b3a800a7f511d$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$fa7b3a800a7f511d$export$e45cb6485273080e = $fa7b3a800a7f511d$var$codes;

});


parcelRegister("7lvdo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $3rPrU = parcelRequire("3rPrU");
'use strict';
/*<replacement>*/ var $5592b534b6d05414$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $5592b534b6d05414$var$Duplex;

var $6js0k = parcelRequire("6js0k");

var $i7pJp = parcelRequire("i7pJp");

(parcelRequire("6sBs0"))($5592b534b6d05414$var$Duplex, $6js0k);
{
    // Allow the keys array to be GC'ed.
    const keys = $5592b534b6d05414$var$objectKeys($i7pJp.prototype);
    for(var $5592b534b6d05414$var$v = 0; $5592b534b6d05414$var$v < keys.length; $5592b534b6d05414$var$v++){
        const method = keys[$5592b534b6d05414$var$v];
        if (!$5592b534b6d05414$var$Duplex.prototype[method]) $5592b534b6d05414$var$Duplex.prototype[method] = $i7pJp.prototype[method];
    }
}function $5592b534b6d05414$var$Duplex(options) {
    if (!(this instanceof $5592b534b6d05414$var$Duplex)) return new $5592b534b6d05414$var$Duplex(options);
    $6js0k.call(this, options);
    $i7pJp.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $5592b534b6d05414$var$onend);
        }
    }
}
Object.defineProperty($5592b534b6d05414$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get () {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($5592b534b6d05414$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($5592b534b6d05414$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get () {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $5592b534b6d05414$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $3rPrU.nextTick($5592b534b6d05414$var$onEndNT, this);
}
function $5592b534b6d05414$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($5592b534b6d05414$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get () {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set (value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("i7pJp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $3rPrU = parcelRequire("3rPrU");
'use strict';
module.exports = $d30cd728d2eb9bfd$var$Writable;
/* <replacement> */ function $d30cd728d2eb9bfd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $d30cd728d2eb9bfd$var$CorkedRequest(state) {
    this.next = null;
    this.entry = null;
    this.finish = ()=>{
        $d30cd728d2eb9bfd$var$onCorkedFinish(this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $d30cd728d2eb9bfd$var$Duplex;
/*</replacement>*/ $d30cd728d2eb9bfd$var$Writable.WritableState = $d30cd728d2eb9bfd$var$WritableState;

/*<replacement>*/ const $d30cd728d2eb9bfd$var$internalUtil = {
    deprecate: (parcelRequire("2eGbF"))
};

var $9wjt2 = parcelRequire("9wjt2");

var $i9F75 = parcelRequire("i9F75");
var $d30cd728d2eb9bfd$require$Buffer = $i9F75.Buffer;
const $d30cd728d2eb9bfd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $d30cd728d2eb9bfd$var$_uint8ArrayToBuffer(chunk) {
    return $d30cd728d2eb9bfd$require$Buffer.from(chunk);
}
function $d30cd728d2eb9bfd$var$_isUint8Array(obj) {
    return $d30cd728d2eb9bfd$require$Buffer.isBuffer(obj) || obj instanceof $d30cd728d2eb9bfd$var$OurUint8Array;
}

var $7eVbp = parcelRequire("7eVbp");

var $k2O3f = parcelRequire("k2O3f");
const $d30cd728d2eb9bfd$var$getHighWaterMark = $k2O3f.getHighWaterMark;

var $lviZP = parcelRequire("lviZP");
var $d30cd728d2eb9bfd$require$_require$codes = $lviZP.codes;
const $d30cd728d2eb9bfd$var$ERR_INVALID_ARG_TYPE = $d30cd728d2eb9bfd$require$_require$codes.ERR_INVALID_ARG_TYPE, $d30cd728d2eb9bfd$var$ERR_METHOD_NOT_IMPLEMENTED = $d30cd728d2eb9bfd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d30cd728d2eb9bfd$var$ERR_MULTIPLE_CALLBACK = $d30cd728d2eb9bfd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $d30cd728d2eb9bfd$var$ERR_STREAM_CANNOT_PIPE = $d30cd728d2eb9bfd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $d30cd728d2eb9bfd$var$ERR_STREAM_DESTROYED = $d30cd728d2eb9bfd$require$_require$codes.ERR_STREAM_DESTROYED, $d30cd728d2eb9bfd$var$ERR_STREAM_NULL_VALUES = $d30cd728d2eb9bfd$require$_require$codes.ERR_STREAM_NULL_VALUES, $d30cd728d2eb9bfd$var$ERR_STREAM_WRITE_AFTER_END = $d30cd728d2eb9bfd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $d30cd728d2eb9bfd$var$ERR_UNKNOWN_ENCODING = $d30cd728d2eb9bfd$require$_require$codes.ERR_UNKNOWN_ENCODING;
const $d30cd728d2eb9bfd$var$errorOrDestroy = $7eVbp.errorOrDestroy;

(parcelRequire("6sBs0"))($d30cd728d2eb9bfd$var$Writable, $9wjt2);
function $d30cd728d2eb9bfd$var$nop() {}

function $d30cd728d2eb9bfd$var$WritableState(options, stream, isDuplex) {
    $d30cd728d2eb9bfd$var$Duplex = $d30cd728d2eb9bfd$var$Duplex || (parcelRequire("7lvdo"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $d30cd728d2eb9bfd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $d30cd728d2eb9bfd$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $d30cd728d2eb9bfd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $d30cd728d2eb9bfd$var$CorkedRequest(this);
}
$d30cd728d2eb9bfd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($d30cd728d2eb9bfd$var$WritableState.prototype, 'buffer', {
            get: $d30cd728d2eb9bfd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $d30cd728d2eb9bfd$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $d30cd728d2eb9bfd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($d30cd728d2eb9bfd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($d30cd728d2eb9bfd$var$realHasInstance.call(this, object)) return true;
            if (this !== $d30cd728d2eb9bfd$var$Writable) return false;
            return object && object._writableState instanceof $d30cd728d2eb9bfd$var$WritableState;
        }
    });
} else $d30cd728d2eb9bfd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $d30cd728d2eb9bfd$var$Writable(options) {
    $d30cd728d2eb9bfd$var$Duplex = $d30cd728d2eb9bfd$var$Duplex || (parcelRequire("7lvdo"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    const isDuplex = this instanceof $d30cd728d2eb9bfd$var$Duplex;
    if (!isDuplex && !$d30cd728d2eb9bfd$var$realHasInstance.call($d30cd728d2eb9bfd$var$Writable, this)) return new $d30cd728d2eb9bfd$var$Writable(options);
    this._writableState = new $d30cd728d2eb9bfd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $9wjt2.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$d30cd728d2eb9bfd$var$Writable.prototype.pipe = function() {
    $d30cd728d2eb9bfd$var$errorOrDestroy(this, new $d30cd728d2eb9bfd$var$ERR_STREAM_CANNOT_PIPE());
};
function $d30cd728d2eb9bfd$var$writeAfterEnd(stream, cb) {
    var er = new $d30cd728d2eb9bfd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $d30cd728d2eb9bfd$var$errorOrDestroy(stream, er);
    $3rPrU.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $d30cd728d2eb9bfd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $d30cd728d2eb9bfd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $d30cd728d2eb9bfd$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $d30cd728d2eb9bfd$var$errorOrDestroy(stream, er);
        $3rPrU.nextTick(cb, er);
        return false;
    }
    return true;
}
$d30cd728d2eb9bfd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $d30cd728d2eb9bfd$var$_isUint8Array(chunk);
    if (isBuf && !$d30cd728d2eb9bfd$require$Buffer.isBuffer(chunk)) chunk = $d30cd728d2eb9bfd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $d30cd728d2eb9bfd$var$nop;
    if (state.ending) $d30cd728d2eb9bfd$var$writeAfterEnd(this, cb);
    else if (isBuf || $d30cd728d2eb9bfd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $d30cd728d2eb9bfd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$d30cd728d2eb9bfd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$d30cd728d2eb9bfd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $d30cd728d2eb9bfd$var$clearBuffer(this, state);
    }
};
$d30cd728d2eb9bfd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $d30cd728d2eb9bfd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($d30cd728d2eb9bfd$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $d30cd728d2eb9bfd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $d30cd728d2eb9bfd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($d30cd728d2eb9bfd$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $d30cd728d2eb9bfd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $d30cd728d2eb9bfd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $d30cd728d2eb9bfd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $d30cd728d2eb9bfd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $d30cd728d2eb9bfd$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $d30cd728d2eb9bfd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $3rPrU.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $3rPrU.nextTick($d30cd728d2eb9bfd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $d30cd728d2eb9bfd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $d30cd728d2eb9bfd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $d30cd728d2eb9bfd$var$finishMaybe(stream, state);
    }
}
function $d30cd728d2eb9bfd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $d30cd728d2eb9bfd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $d30cd728d2eb9bfd$var$ERR_MULTIPLE_CALLBACK();
    $d30cd728d2eb9bfd$var$onwriteStateUpdate(state);
    if (er) $d30cd728d2eb9bfd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $d30cd728d2eb9bfd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $d30cd728d2eb9bfd$var$clearBuffer(stream, state);
        if (sync) $3rPrU.nextTick($d30cd728d2eb9bfd$var$afterWrite, stream, state, finished, cb);
        else $d30cd728d2eb9bfd$var$afterWrite(stream, state, finished, cb);
    }
}
function $d30cd728d2eb9bfd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $d30cd728d2eb9bfd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $d30cd728d2eb9bfd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $d30cd728d2eb9bfd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $d30cd728d2eb9bfd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $d30cd728d2eb9bfd$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $d30cd728d2eb9bfd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $d30cd728d2eb9bfd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$d30cd728d2eb9bfd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $d30cd728d2eb9bfd$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$d30cd728d2eb9bfd$var$Writable.prototype._writev = null;
$d30cd728d2eb9bfd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $d30cd728d2eb9bfd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($d30cd728d2eb9bfd$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get () {
        return this._writableState.length;
    }
});
function $d30cd728d2eb9bfd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $d30cd728d2eb9bfd$var$callFinal(stream, state) {
    stream._final((err)=>{
        state.pendingcb--;
        if (err) $d30cd728d2eb9bfd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $d30cd728d2eb9bfd$var$finishMaybe(stream, state);
    });
}
function $d30cd728d2eb9bfd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $3rPrU.nextTick($d30cd728d2eb9bfd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $d30cd728d2eb9bfd$var$finishMaybe(stream, state) {
    var need = $d30cd728d2eb9bfd$var$needFinish(state);
    if (need) {
        $d30cd728d2eb9bfd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                const rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $d30cd728d2eb9bfd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $d30cd728d2eb9bfd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $3rPrU.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $d30cd728d2eb9bfd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($d30cd728d2eb9bfd$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get () {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set (value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$d30cd728d2eb9bfd$var$Writable.prototype.destroy = $7eVbp.destroy;
$d30cd728d2eb9bfd$var$Writable.prototype._undestroy = $7eVbp.undestroy;
$d30cd728d2eb9bfd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("2eGbF", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $1a0d9d1129c68116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $1a0d9d1129c68116$var$deprecate(fn, msg) {
    if ($1a0d9d1129c68116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1a0d9d1129c68116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($1a0d9d1129c68116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $1a0d9d1129c68116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("cgjud", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $8ed6183f2b9db2bc$export$63a7aa211a91ed69, (v) => $8ed6183f2b9db2bc$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $8ed6183f2b9db2bc$export$63a7aa211a91ed69;
'use strict';

var $cTI9T = parcelRequire("cTI9T");
var $8ed6183f2b9db2bc$require$Buffer = $cTI9T.Buffer;
/*</replacement>*/ var $8ed6183f2b9db2bc$var$isEncoding = $8ed6183f2b9db2bc$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $8ed6183f2b9db2bc$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $8ed6183f2b9db2bc$var$normalizeEncoding(enc) {
    var nenc = $8ed6183f2b9db2bc$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($8ed6183f2b9db2bc$require$Buffer.isEncoding === $8ed6183f2b9db2bc$var$isEncoding || !$8ed6183f2b9db2bc$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$8ed6183f2b9db2bc$export$63a7aa211a91ed69 = $8ed6183f2b9db2bc$var$StringDecoder;
function $8ed6183f2b9db2bc$var$StringDecoder(encoding) {
    this.encoding = $8ed6183f2b9db2bc$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $8ed6183f2b9db2bc$var$utf16Text;
            this.end = $8ed6183f2b9db2bc$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $8ed6183f2b9db2bc$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $8ed6183f2b9db2bc$var$base64Text;
            this.end = $8ed6183f2b9db2bc$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $8ed6183f2b9db2bc$var$simpleWrite;
            this.end = $8ed6183f2b9db2bc$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $8ed6183f2b9db2bc$require$Buffer.allocUnsafe(nb);
}
$8ed6183f2b9db2bc$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$8ed6183f2b9db2bc$var$StringDecoder.prototype.end = $8ed6183f2b9db2bc$var$utf8End;
// Returns only complete characters in a Buffer
$8ed6183f2b9db2bc$var$StringDecoder.prototype.text = $8ed6183f2b9db2bc$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$8ed6183f2b9db2bc$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $8ed6183f2b9db2bc$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $8ed6183f2b9db2bc$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $8ed6183f2b9db2bc$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8ed6183f2b9db2bc$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8ed6183f2b9db2bc$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $8ed6183f2b9db2bc$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $8ed6183f2b9db2bc$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $8ed6183f2b9db2bc$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $8ed6183f2b9db2bc$var$utf8Text(buf, i) {
    var total = $8ed6183f2b9db2bc$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $8ed6183f2b9db2bc$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $8ed6183f2b9db2bc$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $8ed6183f2b9db2bc$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $8ed6183f2b9db2bc$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $8ed6183f2b9db2bc$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $8ed6183f2b9db2bc$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $8ed6183f2b9db2bc$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("gesp9", function(module, exports) {

var $3rPrU = parcelRequire("3rPrU");
'use strict';

var $rnsu2 = parcelRequire("rnsu2");
const $bd13fcbd342ef881$var$kLastResolve = Symbol('lastResolve');
const $bd13fcbd342ef881$var$kLastReject = Symbol('lastReject');
const $bd13fcbd342ef881$var$kError = Symbol('error');
const $bd13fcbd342ef881$var$kEnded = Symbol('ended');
const $bd13fcbd342ef881$var$kLastPromise = Symbol('lastPromise');
const $bd13fcbd342ef881$var$kHandlePromise = Symbol('handlePromise');
const $bd13fcbd342ef881$var$kStream = Symbol('stream');
function $bd13fcbd342ef881$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $bd13fcbd342ef881$var$readAndResolve(iter) {
    const resolve = iter[$bd13fcbd342ef881$var$kLastResolve];
    if (resolve !== null) {
        const data = iter[$bd13fcbd342ef881$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$bd13fcbd342ef881$var$kLastPromise] = null;
            iter[$bd13fcbd342ef881$var$kLastResolve] = null;
            iter[$bd13fcbd342ef881$var$kLastReject] = null;
            resolve($bd13fcbd342ef881$var$createIterResult(data, false));
        }
    }
}
function $bd13fcbd342ef881$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $3rPrU.nextTick($bd13fcbd342ef881$var$readAndResolve, iter);
}
function $bd13fcbd342ef881$var$wrapForNext(lastPromise, iter) {
    return (resolve, reject)=>{
        lastPromise.then(()=>{
            if (iter[$bd13fcbd342ef881$var$kEnded]) {
                resolve($bd13fcbd342ef881$var$createIterResult(undefined, true));
                return;
            }
            iter[$bd13fcbd342ef881$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
const $bd13fcbd342ef881$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
const $bd13fcbd342ef881$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf({
    get stream () {
        return this[$bd13fcbd342ef881$var$kStream];
    },
    next () {
        // if we have detected an error in the meanwhile
        // reject straight away
        const error = this[$bd13fcbd342ef881$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$bd13fcbd342ef881$var$kEnded]) return Promise.resolve($bd13fcbd342ef881$var$createIterResult(undefined, true));
        if (this[$bd13fcbd342ef881$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise((resolve, reject)=>{
            $3rPrU.nextTick(()=>{
                if (this[$bd13fcbd342ef881$var$kError]) reject(this[$bd13fcbd342ef881$var$kError]);
                else resolve($bd13fcbd342ef881$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        const lastPromise = this[$bd13fcbd342ef881$var$kLastPromise];
        let promise;
        if (lastPromise) promise = new Promise($bd13fcbd342ef881$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            const data = this[$bd13fcbd342ef881$var$kStream].read();
            if (data !== null) return Promise.resolve($bd13fcbd342ef881$var$createIterResult(data, false));
            promise = new Promise(this[$bd13fcbd342ef881$var$kHandlePromise]);
        }
        this[$bd13fcbd342ef881$var$kLastPromise] = promise;
        return promise;
    },
    [Symbol.asyncIterator] () {
        return this;
    },
    return () {
        // destroy(err, cb) is a private API
        // we can guarantee we have that here, because we control the
        // Readable class this is attached to
        return new Promise((resolve, reject)=>{
            this[$bd13fcbd342ef881$var$kStream].destroy(null, (err)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve($bd13fcbd342ef881$var$createIterResult(undefined, true));
            });
        });
    }
}, $bd13fcbd342ef881$var$AsyncIteratorPrototype);
const $bd13fcbd342ef881$var$createReadableStreamAsyncIterator = (stream)=>{
    const iterator = Object.create($bd13fcbd342ef881$var$ReadableStreamAsyncIteratorPrototype, {
        [$bd13fcbd342ef881$var$kStream]: {
            value: stream,
            writable: true
        },
        [$bd13fcbd342ef881$var$kLastResolve]: {
            value: null,
            writable: true
        },
        [$bd13fcbd342ef881$var$kLastReject]: {
            value: null,
            writable: true
        },
        [$bd13fcbd342ef881$var$kError]: {
            value: null,
            writable: true
        },
        [$bd13fcbd342ef881$var$kEnded]: {
            value: stream._readableState.endEmitted,
            writable: true
        },
        // the function passed to new Promise
        // is cached so we avoid allocating a new
        // closure at every run
        [$bd13fcbd342ef881$var$kHandlePromise]: {
            value: (resolve, reject)=>{
                const data = iterator[$bd13fcbd342ef881$var$kStream].read();
                if (data) {
                    iterator[$bd13fcbd342ef881$var$kLastPromise] = null;
                    iterator[$bd13fcbd342ef881$var$kLastResolve] = null;
                    iterator[$bd13fcbd342ef881$var$kLastReject] = null;
                    resolve($bd13fcbd342ef881$var$createIterResult(data, false));
                } else {
                    iterator[$bd13fcbd342ef881$var$kLastResolve] = resolve;
                    iterator[$bd13fcbd342ef881$var$kLastReject] = reject;
                }
            },
            writable: true
        }
    });
    iterator[$bd13fcbd342ef881$var$kLastPromise] = null;
    $rnsu2(stream, (err)=>{
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            const reject = iterator[$bd13fcbd342ef881$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$bd13fcbd342ef881$var$kLastPromise] = null;
                iterator[$bd13fcbd342ef881$var$kLastResolve] = null;
                iterator[$bd13fcbd342ef881$var$kLastReject] = null;
                reject(err);
            }
            iterator[$bd13fcbd342ef881$var$kError] = err;
            return;
        }
        const resolve = iterator[$bd13fcbd342ef881$var$kLastResolve];
        if (resolve !== null) {
            iterator[$bd13fcbd342ef881$var$kLastPromise] = null;
            iterator[$bd13fcbd342ef881$var$kLastResolve] = null;
            iterator[$bd13fcbd342ef881$var$kLastReject] = null;
            resolve($bd13fcbd342ef881$var$createIterResult(undefined, true));
        }
        iterator[$bd13fcbd342ef881$var$kEnded] = true;
    });
    stream.on('readable', $bd13fcbd342ef881$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $bd13fcbd342ef881$var$createReadableStreamAsyncIterator;

});
parcelRegister("rnsu2", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

const $0524b81551867944$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("lviZP")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $0524b81551867944$var$once(callback) {
    let called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $0524b81551867944$var$noop() {}
function $0524b81551867944$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $0524b81551867944$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $0524b81551867944$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $0524b81551867944$var$once(callback || $0524b81551867944$var$noop);
    let readable = opts.readable || opts.readable !== false && stream.readable;
    let writable = opts.writable || opts.writable !== false && stream.writable;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    const onfinish = ()=>{
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    const onend = ()=>{
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    const onclose = ()=>{
        let err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $0524b81551867944$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $0524b81551867944$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($0524b81551867944$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $0524b81551867944$var$eos;

});


parcelRegister("615xj", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("htsbb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $cb8b00ec492f51fd$var$Transform;

var $lviZP = parcelRequire("lviZP");
var $cb8b00ec492f51fd$require$_require$codes = $lviZP.codes;
const $cb8b00ec492f51fd$var$ERR_METHOD_NOT_IMPLEMENTED = $cb8b00ec492f51fd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $cb8b00ec492f51fd$var$ERR_MULTIPLE_CALLBACK = $cb8b00ec492f51fd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $cb8b00ec492f51fd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $cb8b00ec492f51fd$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $cb8b00ec492f51fd$var$ERR_TRANSFORM_WITH_LENGTH_0 = $cb8b00ec492f51fd$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $7lvdo = parcelRequire("7lvdo");

(parcelRequire("6sBs0"))($cb8b00ec492f51fd$var$Transform, $7lvdo);
function $cb8b00ec492f51fd$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $cb8b00ec492f51fd$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $cb8b00ec492f51fd$var$Transform(options) {
    if (!(this instanceof $cb8b00ec492f51fd$var$Transform)) return new $cb8b00ec492f51fd$var$Transform(options);
    $7lvdo.call(this, options);
    this._transformState = {
        afterTransform: $cb8b00ec492f51fd$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $cb8b00ec492f51fd$var$prefinish);
}
function $cb8b00ec492f51fd$var$prefinish() {
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush((er, data)=>{
        $cb8b00ec492f51fd$var$done(this, er, data);
    });
    else $cb8b00ec492f51fd$var$done(this, null, null);
}
$cb8b00ec492f51fd$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $7lvdo.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$cb8b00ec492f51fd$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $cb8b00ec492f51fd$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$cb8b00ec492f51fd$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$cb8b00ec492f51fd$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$cb8b00ec492f51fd$var$Transform.prototype._destroy = function(err, cb) {
    $7lvdo.prototype._destroy.call(this, err, (err2)=>{
        cb(err2);
    });
};
function $cb8b00ec492f51fd$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $cb8b00ec492f51fd$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $cb8b00ec492f51fd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("9miES", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $6d04a44a2473544b$var$PassThrough;

var $htsbb = parcelRequire("htsbb");

(parcelRequire("6sBs0"))($6d04a44a2473544b$var$PassThrough, $htsbb);
function $6d04a44a2473544b$var$PassThrough(options) {
    if (!(this instanceof $6d04a44a2473544b$var$PassThrough)) return new $6d04a44a2473544b$var$PassThrough(options);
    $htsbb.call(this, options);
}
$6d04a44a2473544b$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("2GS9P", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
let $1f598398564385df$var$eos;
function $1f598398564385df$var$once(callback) {
    let called = false;
    return function() {
        if (called) return;
        called = true;
        callback(...arguments);
    };
}

var $lviZP = parcelRequire("lviZP");
var $1f598398564385df$require$_require$codes = $lviZP.codes;
const $1f598398564385df$var$ERR_MISSING_ARGS = $1f598398564385df$require$_require$codes.ERR_MISSING_ARGS, $1f598398564385df$var$ERR_STREAM_DESTROYED = $1f598398564385df$require$_require$codes.ERR_STREAM_DESTROYED;
function $1f598398564385df$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $1f598398564385df$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $1f598398564385df$var$destroyer(stream, reading, writing, callback) {
    callback = $1f598398564385df$var$once(callback);
    let closed = false;
    stream.on('close', ()=>{
        closed = true;
    });
    if ($1f598398564385df$var$eos === undefined) $1f598398564385df$var$eos = (parcelRequire("rnsu2"));
    $1f598398564385df$var$eos(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        if (err) return callback(err);
        closed = true;
        callback();
    });
    let destroyed = false;
    return (err)=>{
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($1f598398564385df$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $1f598398564385df$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $1f598398564385df$var$call(fn) {
    fn();
}
function $1f598398564385df$var$pipe(from, to) {
    return from.pipe(to);
}
function $1f598398564385df$var$popCallback(streams) {
    if (!streams.length) return $1f598398564385df$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $1f598398564385df$var$noop;
    return streams.pop();
}
function $1f598398564385df$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    const callback = $1f598398564385df$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $1f598398564385df$var$ERR_MISSING_ARGS('streams');
    let error;
    const destroys = streams.map(function(stream, i) {
        const reading = i < streams.length - 1;
        const writing = i > 0;
        return $1f598398564385df$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($1f598398564385df$var$call);
            if (reading) return;
            destroys.forEach($1f598398564385df$var$call);
            callback(error);
        });
    });
    return streams.reduce($1f598398564385df$var$pipe);
}
module.exports = $1f598398564385df$var$pipeline;

});


parcelRegister("hLSVK", function(module, exports) {
'use strict';

var $i9F75 = parcelRequire("i9F75");
var $cf016f7d6aec26bd$require$Buffer = $i9F75.Buffer;
const $cf016f7d6aec26bd$var$symbol = Symbol.for('BufferList');
function $cf016f7d6aec26bd$var$BufferList(buf) {
    if (!(this instanceof $cf016f7d6aec26bd$var$BufferList)) return new $cf016f7d6aec26bd$var$BufferList(buf);
    $cf016f7d6aec26bd$var$BufferList._init.call(this, buf);
}
$cf016f7d6aec26bd$var$BufferList._init = function _init(buf) {
    Object.defineProperty(this, $cf016f7d6aec26bd$var$symbol, {
        value: true
    });
    this._bufs = [];
    this.length = 0;
    if (buf) this.append(buf);
};
$cf016f7d6aec26bd$var$BufferList.prototype._new = function _new(buf) {
    return new $cf016f7d6aec26bd$var$BufferList(buf);
};
$cf016f7d6aec26bd$var$BufferList.prototype._offset = function _offset(offset) {
    if (offset === 0) return [
        0,
        0
    ];
    let tot = 0;
    for(let i = 0; i < this._bufs.length; i++){
        const _t = tot + this._bufs[i].length;
        if (offset < _t || i === this._bufs.length - 1) return [
            i,
            offset - tot
        ];
        tot = _t;
    }
};
$cf016f7d6aec26bd$var$BufferList.prototype._reverseOffset = function(blOffset) {
    const bufferId = blOffset[0];
    let offset = blOffset[1];
    for(let i = 0; i < bufferId; i++)offset += this._bufs[i].length;
    return offset;
};
$cf016f7d6aec26bd$var$BufferList.prototype.get = function get(index) {
    if (index > this.length || index < 0) return undefined;
    const offset = this._offset(index);
    return this._bufs[offset[0]][offset[1]];
};
$cf016f7d6aec26bd$var$BufferList.prototype.slice = function slice(start, end) {
    if (typeof start === 'number' && start < 0) start += this.length;
    if (typeof end === 'number' && end < 0) end += this.length;
    return this.copy(null, 0, start, end);
};
$cf016f7d6aec26bd$var$BufferList.prototype.copy = function copy(dst, dstStart, srcStart, srcEnd) {
    if (typeof srcStart !== 'number' || srcStart < 0) srcStart = 0;
    if (typeof srcEnd !== 'number' || srcEnd > this.length) srcEnd = this.length;
    if (srcStart >= this.length) return dst || $cf016f7d6aec26bd$require$Buffer.alloc(0);
    if (srcEnd <= 0) return dst || $cf016f7d6aec26bd$require$Buffer.alloc(0);
    const copy = !!dst;
    const off = this._offset(srcStart);
    const len = srcEnd - srcStart;
    let bytes = len;
    let bufoff = copy && dstStart || 0;
    let start = off[1];
    // copy/slice everything
    if (srcStart === 0 && srcEnd === this.length) {
        if (!copy) // slice, but full concat if multiple buffers
        return this._bufs.length === 1 ? this._bufs[0] : $cf016f7d6aec26bd$require$Buffer.concat(this._bufs, this.length);
        // copy, need to copy individual buffers
        for(let i = 0; i < this._bufs.length; i++){
            this._bufs[i].copy(dst, bufoff);
            bufoff += this._bufs[i].length;
        }
        return dst;
    }
    // easy, cheap case where it's a subset of one of the buffers
    if (bytes <= this._bufs[off[0]].length - start) return copy ? this._bufs[off[0]].copy(dst, dstStart, start, start + bytes) : this._bufs[off[0]].slice(start, start + bytes);
    if (!copy) // a slice, we need something to copy in to
    dst = $cf016f7d6aec26bd$require$Buffer.allocUnsafe(len);
    for(let i = off[0]; i < this._bufs.length; i++){
        const l = this._bufs[i].length - start;
        if (bytes > l) {
            this._bufs[i].copy(dst, bufoff, start);
            bufoff += l;
        } else {
            this._bufs[i].copy(dst, bufoff, start, start + bytes);
            bufoff += l;
            break;
        }
        bytes -= l;
        if (start) start = 0;
    }
    // safeguard so that we don't return uninitialized memory
    if (dst.length > bufoff) return dst.slice(0, bufoff);
    return dst;
};
$cf016f7d6aec26bd$var$BufferList.prototype.shallowSlice = function shallowSlice(start, end) {
    start = start || 0;
    end = typeof end !== 'number' ? this.length : end;
    if (start < 0) start += this.length;
    if (end < 0) end += this.length;
    if (start === end) return this._new();
    const startOffset = this._offset(start);
    const endOffset = this._offset(end);
    const buffers = this._bufs.slice(startOffset[0], endOffset[0] + 1);
    if (endOffset[1] === 0) buffers.pop();
    else buffers[buffers.length - 1] = buffers[buffers.length - 1].slice(0, endOffset[1]);
    if (startOffset[1] !== 0) buffers[0] = buffers[0].slice(startOffset[1]);
    return this._new(buffers);
};
$cf016f7d6aec26bd$var$BufferList.prototype.toString = function toString(encoding, start, end) {
    return this.slice(start, end).toString(encoding);
};
$cf016f7d6aec26bd$var$BufferList.prototype.consume = function consume(bytes) {
    // first, normalize the argument, in accordance with how Buffer does it
    bytes = Math.trunc(bytes);
    // do nothing if not a positive number
    if (Number.isNaN(bytes) || bytes <= 0) return this;
    while(this._bufs.length)if (bytes >= this._bufs[0].length) {
        bytes -= this._bufs[0].length;
        this.length -= this._bufs[0].length;
        this._bufs.shift();
    } else {
        this._bufs[0] = this._bufs[0].slice(bytes);
        this.length -= bytes;
        break;
    }
    return this;
};
$cf016f7d6aec26bd$var$BufferList.prototype.duplicate = function duplicate() {
    const copy = this._new();
    for(let i = 0; i < this._bufs.length; i++)copy.append(this._bufs[i]);
    return copy;
};
$cf016f7d6aec26bd$var$BufferList.prototype.append = function append(buf) {
    if (buf == null) return this;
    if (buf.buffer) // append a view of the underlying ArrayBuffer
    this._appendBuffer($cf016f7d6aec26bd$require$Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength));
    else if (Array.isArray(buf)) for(let i = 0; i < buf.length; i++)this.append(buf[i]);
    else if (this._isBufferList(buf)) // unwrap argument into individual BufferLists
    for(let i = 0; i < buf._bufs.length; i++)this.append(buf._bufs[i]);
    else {
        // coerce number arguments to strings, since Buffer(number) does
        // uninitialized memory allocation
        if (typeof buf === 'number') buf = buf.toString();
        this._appendBuffer($cf016f7d6aec26bd$require$Buffer.from(buf));
    }
    return this;
};
$cf016f7d6aec26bd$var$BufferList.prototype._appendBuffer = function appendBuffer(buf) {
    this._bufs.push(buf);
    this.length += buf.length;
};
$cf016f7d6aec26bd$var$BufferList.prototype.indexOf = function(search, offset, encoding) {
    if (encoding === undefined && typeof offset === 'string') {
        encoding = offset;
        offset = undefined;
    }
    if (typeof search === 'function' || Array.isArray(search)) throw new TypeError('The "value" argument must be one of type string, Buffer, BufferList, or Uint8Array.');
    else if (typeof search === 'number') search = $cf016f7d6aec26bd$require$Buffer.from([
        search
    ]);
    else if (typeof search === 'string') search = $cf016f7d6aec26bd$require$Buffer.from(search, encoding);
    else if (this._isBufferList(search)) search = search.slice();
    else if (Array.isArray(search.buffer)) search = $cf016f7d6aec26bd$require$Buffer.from(search.buffer, search.byteOffset, search.byteLength);
    else if (!$cf016f7d6aec26bd$require$Buffer.isBuffer(search)) search = $cf016f7d6aec26bd$require$Buffer.from(search);
    offset = Number(offset || 0);
    if (isNaN(offset)) offset = 0;
    if (offset < 0) offset = this.length + offset;
    if (offset < 0) offset = 0;
    if (search.length === 0) return offset > this.length ? this.length : offset;
    const blOffset = this._offset(offset);
    let blIndex = blOffset[0] // index of which internal buffer we're working on
    ;
    let buffOffset = blOffset[1] // offset of the internal buffer we're working on
    ;
    // scan over each buffer
    for(; blIndex < this._bufs.length; blIndex++){
        const buff = this._bufs[blIndex];
        while(buffOffset < buff.length){
            const availableWindow = buff.length - buffOffset;
            if (availableWindow >= search.length) {
                const nativeSearchResult = buff.indexOf(search, buffOffset);
                if (nativeSearchResult !== -1) return this._reverseOffset([
                    blIndex,
                    nativeSearchResult
                ]);
                buffOffset = buff.length - search.length + 1 // end of native search window
                ;
            } else {
                const revOffset = this._reverseOffset([
                    blIndex,
                    buffOffset
                ]);
                if (this._match(revOffset, search)) return revOffset;
                buffOffset++;
            }
        }
        buffOffset = 0;
    }
    return -1;
};
$cf016f7d6aec26bd$var$BufferList.prototype._match = function(offset, search) {
    if (this.length - offset < search.length) return false;
    for(let searchOffset = 0; searchOffset < search.length; searchOffset++){
        if (this.get(offset + searchOffset) !== search[searchOffset]) return false;
    }
    return true;
};
(function() {
    const methods = {
        readDoubleBE: 8,
        readDoubleLE: 8,
        readFloatBE: 4,
        readFloatLE: 4,
        readInt32BE: 4,
        readInt32LE: 4,
        readUInt32BE: 4,
        readUInt32LE: 4,
        readInt16BE: 2,
        readInt16LE: 2,
        readUInt16BE: 2,
        readUInt16LE: 2,
        readInt8: 1,
        readUInt8: 1,
        readIntBE: null,
        readIntLE: null,
        readUIntBE: null,
        readUIntLE: null
    };
    for(const m in methods)(function(m) {
        if (methods[m] === null) $cf016f7d6aec26bd$var$BufferList.prototype[m] = function(offset, byteLength) {
            return this.slice(offset, offset + byteLength)[m](0, byteLength);
        };
        else $cf016f7d6aec26bd$var$BufferList.prototype[m] = function(offset = 0) {
            return this.slice(offset, offset + methods[m])[m](0);
        };
    })(m);
})();
// Used internally by the class and also as an indicator of this object being
// a `BufferList`. It's not possible to use `instanceof BufferList` in a browser
// environment because there could be multiple different copies of the
// BufferList class and some `BufferList`s might be `BufferList`s.
$cf016f7d6aec26bd$var$BufferList.prototype._isBufferList = function _isBufferList(b) {
    return b instanceof $cf016f7d6aec26bd$var$BufferList || $cf016f7d6aec26bd$var$BufferList.isBufferList(b);
};
$cf016f7d6aec26bd$var$BufferList.isBufferList = function isBufferList(b) {
    return b != null && b[$cf016f7d6aec26bd$var$symbol];
};
module.exports = $cf016f7d6aec26bd$var$BufferList;

});


parcelRegister("xeMy5", function(module, exports) {

$parcel$export(module.exports, "decoder", () => $063e8c96855c222a$export$124c96e6ce37090b, (v) => $063e8c96855c222a$export$124c96e6ce37090b = v);
$parcel$export(module.exports, "encoder", () => $063e8c96855c222a$export$5486af06137bf21a, (v) => $063e8c96855c222a$export$5486af06137bf21a = v);
var $063e8c96855c222a$export$124c96e6ce37090b;
var $063e8c96855c222a$export$5486af06137bf21a;
'use strict';

var $ghkKd = parcelRequire("ghkKd");
var $063e8c96855c222a$require$Transform = $ghkKd.Transform;

var $6sBs0 = parcelRequire("6sBs0");

var $bodC8 = parcelRequire("bodC8");
function $063e8c96855c222a$var$Base(opts) {
    opts = opts || {};
    opts.objectMode = true;
    opts.highWaterMark = 16;
    $063e8c96855c222a$require$Transform.call(this, opts);
    this._msgpack = opts.msgpack;
}
$6sBs0($063e8c96855c222a$var$Base, $063e8c96855c222a$require$Transform);
function $063e8c96855c222a$var$Encoder(opts) {
    if (!(this instanceof $063e8c96855c222a$var$Encoder)) {
        opts = opts || {};
        opts.msgpack = this;
        return new $063e8c96855c222a$var$Encoder(opts);
    }
    $063e8c96855c222a$var$Base.call(this, opts);
    this._wrap = 'wrap' in opts && opts.wrap;
}
$6sBs0($063e8c96855c222a$var$Encoder, $063e8c96855c222a$var$Base);
$063e8c96855c222a$var$Encoder.prototype._transform = function(obj, enc, done) {
    let buf = null;
    try {
        buf = this._msgpack.encode(this._wrap ? obj.value : obj).slice(0);
    } catch (err) {
        this.emit('error', err);
        return done();
    }
    this.push(buf);
    done();
};
function $063e8c96855c222a$var$Decoder(opts) {
    if (!(this instanceof $063e8c96855c222a$var$Decoder)) {
        opts = opts || {};
        opts.msgpack = this;
        return new $063e8c96855c222a$var$Decoder(opts);
    }
    $063e8c96855c222a$var$Base.call(this, opts);
    this._chunks = $bodC8();
    this._wrap = 'wrap' in opts && opts.wrap;
}
$6sBs0($063e8c96855c222a$var$Decoder, $063e8c96855c222a$var$Base);
$063e8c96855c222a$var$Decoder.prototype._transform = function(buf, enc, done) {
    if (buf) this._chunks.append(buf);
    try {
        let result = this._msgpack.decode(this._chunks);
        if (this._wrap) result = {
            value: result
        };
        this.push(result);
    } catch (err) {
        if (err instanceof this._msgpack.IncompleteBufferError) done();
        else this.emit('error', err);
        return;
    }
    if (this._chunks.length > 0) this._transform(null, enc, done);
    else done();
};
$063e8c96855c222a$export$124c96e6ce37090b = $063e8c96855c222a$var$Decoder;
$063e8c96855c222a$export$5486af06137bf21a = $063e8c96855c222a$var$Encoder;

});

parcelRegister("hiMf9", function(module, exports) {
'use strict';

var $bodC8 = parcelRequire("bodC8");

var $7GBfU = parcelRequire("7GBfU");
var $c9898a3d0939306f$require$IncompleteBufferError = $7GBfU.IncompleteBufferError;
const $c9898a3d0939306f$var$SIZES = {
    0xc4: 2,
    0xc5: 3,
    0xc6: 5,
    0xc7: 3,
    0xc8: 4,
    0xc9: 6,
    0xca: 5,
    0xcb: 9,
    0xcc: 2,
    0xcd: 3,
    0xce: 5,
    0xcf: 9,
    0xd0: 2,
    0xd1: 3,
    0xd2: 5,
    0xd3: 9,
    0xd4: 3,
    0xd5: 4,
    0xd6: 6,
    0xd7: 10,
    0xd8: 18,
    0xd9: 2,
    0xda: 3,
    0xdb: 5,
    0xde: 3,
    0xdc: 3,
    0xdd: 5
};
function $c9898a3d0939306f$var$isValidDataSize(dataLength, bufLength, headerLength) {
    return bufLength >= headerLength + dataLength;
}
module.exports = function buildDecode(decodingTypes, options) {
    const context = {
        decodingTypes: decodingTypes,
        options: options,
        decode: decode
    };
    return decode;
    function decode(buf) {
        // TODO: Make it into ensureBl handler ?
        if (!(buf instanceof $bodC8)) buf = $bodC8().append(buf);
        const result = $c9898a3d0939306f$var$tryDecode(buf, 0, context);
        // Handle worst case ASAP and keep code flat
        if (!result) throw new $c9898a3d0939306f$require$IncompleteBufferError();
        buf.consume(result[1]);
        return result[0];
    }
};
function $c9898a3d0939306f$var$decodeArray(buf, initialOffset, length, headerLength, context) {
    let offset = initialOffset;
    const result = [];
    let i = 0;
    while(i++ < length){
        const decodeResult = $c9898a3d0939306f$var$tryDecode(buf, offset, context);
        if (!decodeResult) return null;
        result.push(decodeResult[0]);
        offset += decodeResult[1];
    }
    return [
        result,
        headerLength + offset - initialOffset
    ];
}
function $c9898a3d0939306f$var$decodeMap(buf, offset, length, headerLength, context) {
    const _temp = $c9898a3d0939306f$var$decodeArray(buf, offset, 2 * length, headerLength, context);
    if (!_temp) return null;
    const [result, consumedBytes] = _temp;
    let isPlainObject = !context.options.preferMap;
    if (isPlainObject) {
        for(let i = 0; i < 2 * length; i += 2)if (typeof result[i] !== 'string') {
            isPlainObject = false;
            break;
        }
    }
    if (isPlainObject) {
        const object = {};
        for(let i = 0; i < 2 * length; i += 2){
            const key = result[i];
            const val = result[i + 1];
            if (key === '__proto__') {
                if (context.options.protoAction === 'error') throw new SyntaxError('Object contains forbidden prototype property');
                if (context.options.protoAction === 'remove') continue;
            }
            object[key] = val;
        }
        return [
            object,
            consumedBytes
        ];
    } else {
        const mapping = new Map();
        for(let i = 0; i < 2 * length; i += 2){
            const key = result[i];
            const val = result[i + 1];
            mapping.set(key, val);
        }
        return [
            mapping,
            consumedBytes
        ];
    }
}
function $c9898a3d0939306f$var$tryDecode(buf, initialOffset, context) {
    if (buf.length <= initialOffset) return null;
    const bufLength = buf.length - initialOffset;
    let offset = initialOffset;
    const first = buf.readUInt8(offset);
    offset += 1;
    const size = $c9898a3d0939306f$var$SIZES[first] || -1;
    if (bufLength < size) return null;
    if (first < 0x80) return [
        first,
        1
    ] // 7-bits positive ints
    ;
    if ((first & 0xf0) === 0x80) {
        const length = first & 0x0f;
        const headerSize = offset - initialOffset;
        // we have a map with less than 15 elements
        return $c9898a3d0939306f$var$decodeMap(buf, offset, length, headerSize, context);
    }
    if ((first & 0xf0) === 0x90) {
        const length = first & 0x0f;
        const headerSize = offset - initialOffset;
        // we have an array with less than 15 elements
        return $c9898a3d0939306f$var$decodeArray(buf, offset, length, headerSize, context);
    }
    if ((first & 0xe0) === 0xa0) {
        // fixstr up to 31 bytes
        const length = first & 0x1f;
        if (!$c9898a3d0939306f$var$isValidDataSize(length, bufLength, 1)) return null;
        const result = buf.toString('utf8', offset, offset + length);
        return [
            result,
            length + 1
        ];
    }
    if (first >= 0xc0 && first <= 0xc3) return $c9898a3d0939306f$var$decodeConstants(first);
    if (first >= 0xc4 && first <= 0xc6) {
        const length = buf.readUIntBE(offset, size - 1);
        offset += size - 1;
        if (!$c9898a3d0939306f$var$isValidDataSize(length, bufLength, size)) return null;
        const result = buf.slice(offset, offset + length);
        return [
            result,
            size + length
        ];
    }
    if (first >= 0xc7 && first <= 0xc9) {
        const length = buf.readUIntBE(offset, size - 2);
        offset += size - 2;
        const type = buf.readInt8(offset);
        offset += 1;
        if (!$c9898a3d0939306f$var$isValidDataSize(length, bufLength, size)) return null;
        return $c9898a3d0939306f$var$decodeExt(buf, offset, type, length, size, context);
    }
    if (first >= 0xca && first <= 0xcb) return $c9898a3d0939306f$var$decodeFloat(buf, offset, size - 1);
    if (first >= 0xcc && first <= 0xcf) return $c9898a3d0939306f$var$decodeUnsignedInt(buf, offset, size - 1);
    if (first >= 0xd0 && first <= 0xd3) return $c9898a3d0939306f$var$decodeSigned(buf, offset, size - 1);
    if (first >= 0xd4 && first <= 0xd8) {
        const type = buf.readInt8(offset) // Signed
        ;
        offset += 1;
        return $c9898a3d0939306f$var$decodeExt(buf, offset, type, size - 2, 2, context);
    }
    if (first >= 0xd9 && first <= 0xdb) {
        const length = buf.readUIntBE(offset, size - 1);
        offset += size - 1;
        if (!$c9898a3d0939306f$var$isValidDataSize(length, bufLength, size)) return null;
        const result = buf.toString('utf8', offset, offset + length);
        return [
            result,
            size + length
        ];
    }
    if (first >= 0xdc && first <= 0xdd) {
        const length = buf.readUIntBE(offset, size - 1);
        offset += size - 1;
        return $c9898a3d0939306f$var$decodeArray(buf, offset, length, size, context);
    }
    if (first >= 0xde && first <= 0xdf) {
        let length;
        switch(first){
            case 0xde:
                // maps up to 2^16 elements - 2 bytes
                length = buf.readUInt16BE(offset);
                offset += 2;
                // console.log(offset - initialOffset)
                return $c9898a3d0939306f$var$decodeMap(buf, offset, length, 3, context);
            case 0xdf:
                length = buf.readUInt32BE(offset);
                offset += 4;
                return $c9898a3d0939306f$var$decodeMap(buf, offset, length, 5, context);
        }
    }
    if (first >= 0xe0) return [
        first - 0x100,
        1
    ] // 5 bits negative ints
    ;
    throw new Error('not implemented yet');
}
function $c9898a3d0939306f$var$decodeSigned(buf, offset, size) {
    let result;
    if (size === 1) result = buf.readInt8(offset);
    if (size === 2) result = buf.readInt16BE(offset);
    if (size === 4) result = buf.readInt32BE(offset);
    if (size === 8) result = $c9898a3d0939306f$var$readInt64BE(buf.slice(offset, offset + 8), 0);
    return [
        result,
        size + 1
    ];
}
function $c9898a3d0939306f$var$decodeExt(buf, offset, type, size, headerSize, context) {
    const toDecode = buf.slice(offset, offset + size);
    const decode = context.decodingTypes.get(type);
    if (!decode) throw new Error('unable to find ext type ' + type);
    const value = decode(toDecode);
    return [
        value,
        headerSize + size
    ];
}
function $c9898a3d0939306f$var$decodeUnsignedInt(buf, offset, size) {
    const maxOffset = offset + size;
    let result = 0;
    while(offset < maxOffset)result += buf.readUInt8(offset++) * Math.pow(256, maxOffset - offset);
    return [
        result,
        size + 1
    ];
}
function $c9898a3d0939306f$var$decodeConstants(first) {
    if (first === 0xc0) return [
        null,
        1
    ];
    if (first === 0xc2) return [
        false,
        1
    ];
    if (first === 0xc3) return [
        true,
        1
    ];
}
function $c9898a3d0939306f$var$decodeFloat(buf, offset, size) {
    let result;
    if (size === 4) result = buf.readFloatBE(offset);
    if (size === 8) result = buf.readDoubleBE(offset);
    return [
        result,
        size + 1
    ];
}
function $c9898a3d0939306f$var$readInt64BE(buf, offset) {
    var negate = (buf[offset] & 0x80) == 0x80; // eslint-disable-line
    if (negate) {
        let carry = 1;
        for(let i = offset + 7; i >= offset; i--){
            const v = (buf[i] ^ 0xff) + carry;
            buf[i] = v & 0xff;
            carry = v >> 8;
        }
    }
    const hi = buf.readUInt32BE(offset + 0);
    const lo = buf.readUInt32BE(offset + 4);
    return (hi * 4294967296 + lo) * (negate ? -1 : 1);
}

});
parcelRegister("7GBfU", function(module, exports) {

$parcel$export(module.exports, "IncompleteBufferError", () => $59895acfa00c142a$export$fbff06f0fd250ceb, (v) => $59895acfa00c142a$export$fbff06f0fd250ceb = v);
$parcel$export(module.exports, "isFloat", () => $59895acfa00c142a$export$4ba1d6600e2a2892, (v) => $59895acfa00c142a$export$4ba1d6600e2a2892 = v);
var $59895acfa00c142a$export$fbff06f0fd250ceb;
var $59895acfa00c142a$export$4ba1d6600e2a2892;
'use strict';

var $dCmQe = parcelRequire("dCmQe");
$59895acfa00c142a$export$fbff06f0fd250ceb = $59895acfa00c142a$var$IncompleteBufferError;
function $59895acfa00c142a$var$IncompleteBufferError(message) {
    Error.call(this) // super constructor
    ;
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor) // super helper method to include stack trace in error object
    ;
    this.name = this.constructor.name;
    this.message = message || 'unable to decode';
}
$dCmQe.inherits($59895acfa00c142a$var$IncompleteBufferError, Error);
$59895acfa00c142a$export$4ba1d6600e2a2892 = function isFloat(n) {
    return n % 1 !== 0;
};

});


parcelRegister("cSIdg", function(module, exports) {
'use strict';

var $cTI9T = parcelRequire("cTI9T");
var $960cd2f3d63bb98f$require$Buffer = $cTI9T.Buffer;

var $bodC8 = parcelRequire("bodC8");

var $7GBfU = parcelRequire("7GBfU");
var $960cd2f3d63bb98f$require$isFloat = $7GBfU.isFloat;
module.exports = function buildEncode(encodingTypes, options) {
    function encode(obj) {
        if (obj === undefined) throw new Error('undefined is not encodable in msgpack!');
        if (obj === null) return $960cd2f3d63bb98f$require$Buffer.from([
            0xc0
        ]);
        if (obj === true) return $960cd2f3d63bb98f$require$Buffer.from([
            0xc3
        ]);
        if (obj === false) return $960cd2f3d63bb98f$require$Buffer.from([
            0xc2
        ]);
        if (obj instanceof Map) return $960cd2f3d63bb98f$var$encodeMap(obj, options, encode);
        if (typeof obj === 'string') return $960cd2f3d63bb98f$var$encodeString(obj, options);
        if (obj && (obj.readUInt32LE || obj instanceof Uint8Array)) {
            if (obj instanceof Uint8Array) obj = $960cd2f3d63bb98f$require$Buffer.from(obj);
            // weird hack to support Buffer
            // and Buffer-like objects
            return $bodC8([
                $960cd2f3d63bb98f$var$getBufferHeader(obj.length),
                obj
            ]);
        }
        if (Array.isArray(obj)) return $960cd2f3d63bb98f$var$encodeArray(obj, encode);
        if (typeof obj === 'object') return $960cd2f3d63bb98f$var$encodeExt(obj, encodingTypes) || $960cd2f3d63bb98f$var$encodeObject(obj, options, encode);
        if (typeof obj === 'number') return $960cd2f3d63bb98f$var$encodeNumber(obj, options);
        throw new Error('not implemented yet');
    }
    return function(obj) {
        return encode(obj).slice();
    };
};
//
//
// === MENTAL SEPARATOR ===
//
//
function $960cd2f3d63bb98f$var$encodeArray(array, encode) {
    const acc = [
        $960cd2f3d63bb98f$var$getHeader(array.length, 0x90, 0xdc)
    ];
    // This has to be forEach; Array.prototype.map preserves missing values and
    // Array.prototype.values yields them as undefined
    array.forEach((item)=>{
        acc.push(encode(item));
    });
    if (acc.length !== array.length + 1) throw new Error('Sparse arrays are not encodable in msgpack');
    return $bodC8(acc);
}
function $960cd2f3d63bb98f$var$encodeMap(map, options, encode) {
    const acc = [
        $960cd2f3d63bb98f$var$getHeader(map.size, 0x80, 0xde)
    ];
    const keys = [
        ...map.keys()
    ];
    if (!options.preferMap) {
        if (keys.every((item)=>typeof item === 'string')) console.warn('Map with string only keys will be deserialized as an object!');
    }
    keys.forEach((key)=>{
        acc.push(encode(key), encode(map.get(key)));
    });
    return $bodC8(acc);
}
function $960cd2f3d63bb98f$var$encodeObject(obj, options, encode) {
    const keys = [];
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'function') keys.push(key);
    const acc = [
        $960cd2f3d63bb98f$var$getHeader(keys.length, 0x80, 0xde)
    ];
    if (options.sortKeys) keys.sort();
    keys.forEach((key)=>{
        acc.push(encode(key), encode(obj[key]));
    });
    return $bodC8(acc);
}
function $960cd2f3d63bb98f$var$write64BitUint(buf, offset, num) {
    const lo = num % 4294967296;
    const hi = Math.floor(num / 4294967296);
    buf.writeUInt32BE(hi, offset + 0);
    buf.writeUInt32BE(lo, offset + 4);
}
function $960cd2f3d63bb98f$var$write64BitInt(buf, offset, num) {
    const negate = num < 0;
    num = Math.abs(num);
    $960cd2f3d63bb98f$var$write64BitUint(buf, offset, num);
    if (negate) $960cd2f3d63bb98f$var$negate64BitInt(buf, offset);
}
function $960cd2f3d63bb98f$var$negate64BitInt(buf, offset) {
    let i = offset + 8;
    // Optimization based on the fact that:
    // buf[i] == 0x00  => (buf[i] ^ 0xff) + 1 = 0x100 = 0x00 + 1 curry
    while(i-- > offset){
        if (buf[i] === 0x00) continue;
        buf[i] = (buf[i] ^ 0xff) + 1;
        break;
    }
    while(i-- > offset)buf[i] = buf[i] ^ 0xff;
}
const $960cd2f3d63bb98f$var$fround = Math.fround;
function $960cd2f3d63bb98f$var$encodeFloat(obj, forceFloat64) {
    let buf;
    if (forceFloat64 || !$960cd2f3d63bb98f$var$fround || !Object.is($960cd2f3d63bb98f$var$fround(obj), obj)) {
        buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(9);
        buf[0] = 0xcb;
        buf.writeDoubleBE(obj, 1);
    } else {
        buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(5);
        buf[0] = 0xca;
        buf.writeFloatBE(obj, 1);
    }
    return buf;
}
function $960cd2f3d63bb98f$var$encodeExt(obj, encodingTypes) {
    const codec = encodingTypes.find((codec)=>codec.check(obj));
    if (!codec) return null;
    const encoded = codec.encode(obj);
    if (!encoded) return null;
    return $bodC8([
        $960cd2f3d63bb98f$var$getExtHeader(encoded.length - 1),
        encoded
    ]);
}
function $960cd2f3d63bb98f$var$getExtHeader(length) {
    if (length === 1) return $960cd2f3d63bb98f$require$Buffer.from([
        0xd4
    ]);
    if (length === 2) return $960cd2f3d63bb98f$require$Buffer.from([
        0xd5
    ]);
    if (length === 4) return $960cd2f3d63bb98f$require$Buffer.from([
        0xd6
    ]);
    if (length === 8) return $960cd2f3d63bb98f$require$Buffer.from([
        0xd7
    ]);
    if (length === 16) return $960cd2f3d63bb98f$require$Buffer.from([
        0xd8
    ]);
    if (length < 256) return $960cd2f3d63bb98f$require$Buffer.from([
        0xc7,
        length
    ]);
    if (length < 0x10000) return $960cd2f3d63bb98f$require$Buffer.from([
        0xc8,
        length >> 8,
        length & 0x00ff
    ]);
    return $960cd2f3d63bb98f$require$Buffer.from([
        0xc9,
        length >> 24,
        length >> 16 & 0x000000ff,
        length >> 8 & 0x000000ff,
        length & 0x000000ff
    ]);
}
function $960cd2f3d63bb98f$var$getHeader(length, tag1, tag2) {
    if (length < 16) return $960cd2f3d63bb98f$require$Buffer.from([
        tag1 | length
    ]);
    const size = length < 0x10000 ? 2 : 4;
    const buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(1 + size);
    buf[0] = length < 0x10000 ? tag2 : tag2 + 1;
    buf.writeUIntBE(length, 1, size);
    return buf;
}
function $960cd2f3d63bb98f$var$encodeString(obj, options) {
    const len = $960cd2f3d63bb98f$require$Buffer.byteLength(obj);
    let buf;
    if (len < 32) {
        buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(1 + len);
        buf[0] = 0xa0 | len;
        if (len > 0) buf.write(obj, 1);
    } else if (len <= 0xff && !options.compatibilityMode) {
        // str8, but only when not in compatibility mode
        buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(2 + len);
        buf[0] = 0xd9;
        buf[1] = len;
        buf.write(obj, 2);
    } else if (len <= 0xffff) {
        buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(3 + len);
        buf[0] = 0xda;
        buf.writeUInt16BE(len, 1);
        buf.write(obj, 3);
    } else {
        buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(5 + len);
        buf[0] = 0xdb;
        buf.writeUInt32BE(len, 1);
        buf.write(obj, 5);
    }
    return buf;
}
function $960cd2f3d63bb98f$var$getBufferHeader(length) {
    let header;
    if (length <= 0xff) {
        header = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(2);
        header[0] = 0xc4;
        header[1] = length;
    } else if (length <= 0xffff) {
        header = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(3);
        header[0] = 0xc5;
        header.writeUInt16BE(length, 1);
    } else {
        header = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(5);
        header[0] = 0xc6;
        header.writeUInt32BE(length, 1);
    }
    return header;
}
function $960cd2f3d63bb98f$var$encodeNumber(obj, options) {
    let buf;
    if ($960cd2f3d63bb98f$require$isFloat(obj)) return $960cd2f3d63bb98f$var$encodeFloat(obj, options.forceFloat64);
    if (Math.abs(obj) > 9007199254740991) return $960cd2f3d63bb98f$var$encodeFloat(obj, true);
    if (obj >= 0) {
        if (obj < 128) return $960cd2f3d63bb98f$require$Buffer.from([
            obj
        ]);
        else if (obj < 256) return $960cd2f3d63bb98f$require$Buffer.from([
            0xcc,
            obj
        ]);
        else if (obj < 65536) return $960cd2f3d63bb98f$require$Buffer.from([
            0xcd,
            0xff & obj >> 8,
            0xff & obj
        ]);
        else if (obj <= 0xffffffff) return $960cd2f3d63bb98f$require$Buffer.from([
            0xce,
            0xff & obj >> 24,
            0xff & obj >> 16,
            0xff & obj >> 8,
            0xff & obj
        ]);
        else if (obj <= 9007199254740991) {
            buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(9);
            buf[0] = 0xcf;
            $960cd2f3d63bb98f$var$write64BitUint(buf, 1, obj);
        }
    } else {
        if (obj >= -32) {
            buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(1);
            buf[0] = 0x100 + obj;
        } else if (obj >= -128) {
            buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(2);
            buf[0] = 0xd0;
            buf.writeInt8(obj, 1);
        } else if (obj >= -32768) {
            buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(3);
            buf[0] = 0xd1;
            buf.writeInt16BE(obj, 1);
        } else if (obj > -214748365) {
            buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(5);
            buf[0] = 0xd2;
            buf.writeInt32BE(obj, 1);
        } else if (obj >= -9007199254740991) {
            buf = $960cd2f3d63bb98f$require$Buffer.allocUnsafe(9);
            buf[0] = 0xd3;
            $960cd2f3d63bb98f$var$write64BitInt(buf, 1, obj);
        }
    }
    return buf;
} // function order(num, n = 1, step = 2) {
 //    while (num = num >> step) n++;
 //    return n
 // }

});

parcelRegister("lzGYy", function(module, exports) {

var $i9F75 = parcelRequire("i9F75");
var $fb4e33ef8dd5f6c7$require$Buffer = $i9F75.Buffer;
const $fb4e33ef8dd5f6c7$var$type = -1;
function $fb4e33ef8dd5f6c7$var$encode(dt) {
    if (dt === null) return;
    const millis = dt * 1;
    const seconds = Math.floor(millis / 1000);
    const nanos = (millis - seconds * 1000) * 1e6;
    if (seconds < 0 || seconds > 0x400000000) {
        // Timestamp96
        const encoded = $fb4e33ef8dd5f6c7$require$Buffer.allocUnsafe(13);
        encoded[0] = -1;
        encoded.writeUInt32BE(nanos, 1);
        let hex = '';
        if (seconds >= 0) {
            const padhex = '0000000000000000';
            hex = seconds.toString(16);
            // add some padding
            hex = padhex.slice(0, hex.length * -1) + hex;
        } else {
            // encode seconds in 2's Complement 64Bit
            // reverse sign
            // keep all bits 0 and first 1 from right
            // reverse all other bits
            let bin = (seconds * -1).toString(2);
            let i = bin.length - 1;
            while(bin[i] === '0')i--;
            bin = bin.slice(0, i).split('').map(function(bit) {
                return bit === '1' ? 0 : 1;
            }).join('') + bin.slice(i, bin.length);
            // add some padding
            const pad64 = '1111111111111111111111111111111111111111111111111111111111111111';
            bin = pad64.slice(0, bin.length * -1) + bin;
            // convert to hex
            bin.match(/.{1,8}/g).forEach(function(byte) {
                byte = parseInt(byte, 2).toString(16);
                if (byte.length === 1) byte = '0' + byte;
                hex += byte;
            });
        }
        encoded.write(hex, 5, 'hex');
        return encoded;
    } else if (nanos || seconds > 0xffffffff) {
        // Timestamp64
        const encoded = $fb4e33ef8dd5f6c7$require$Buffer.allocUnsafe(9);
        encoded[0] = -1;
        const upperNanos = nanos * 4;
        const upperSeconds = seconds / Math.pow(2, 32);
        const upper = upperNanos + upperSeconds & 0xffffffff;
        const lower = seconds & 0xffffffff;
        encoded.writeInt32BE(upper, 1);
        encoded.writeInt32BE(lower, 5);
        return encoded;
    } else {
        // Timestamp32
        const encoded = $fb4e33ef8dd5f6c7$require$Buffer.allocUnsafe(5);
        encoded[0] = -1;
        encoded.writeUInt32BE(Math.floor(millis / 1000), 1);
        return encoded;
    }
}
function $fb4e33ef8dd5f6c7$var$check(obj) {
    return typeof obj.getDate === 'function';
}
function $fb4e33ef8dd5f6c7$var$decode(buf) {
    let seconds;
    let nanoseconds = 0;
    let upper;
    let lower;
    let hex;
    switch(buf.length){
        case 4:
            // timestamp 32 stores the number of seconds that have elapsed since 1970-01-01 00:00:00 UTC in an 32-bit unsigned integer
            seconds = buf.readUInt32BE(0);
            break;
        case 8:
            // Timestamp 64 stores the number of seconds and nanoseconds that have elapsed
            // since 1970-01-01 00:00:00 UTC in 32-bit unsigned integers, split 30/34 bits
            upper = buf.readUInt32BE(0);
            lower = buf.readUInt32BE(4);
            nanoseconds = upper / 4;
            seconds = (upper & 0x03) * Math.pow(2, 32) + lower // If we use bitwise operators, we get truncated to 32bits
            ;
            break;
        case 12:
            // timestamp 96 stores the number of seconds and nanoseconds that have elapsed
            // since 1970-01-01 00:00:00 UTC in 64-bit signed integer and 32-bit unsigned integer
            // get seconds in hex
            hex = buf.toString('hex', 4, 12);
            // check if seconds is a negative number
            if (parseInt(buf.toString('hex', 4, 6), 16) & 0x80) {
                // convert to binary
                let bin = '';
                const pad8 = '00000000';
                hex.match(/.{1,2}/g).forEach(function(byte) {
                    byte = parseInt(byte, 16).toString(2);
                    byte = pad8.slice(0, byte.length * -1) + byte;
                    bin += byte;
                });
                // decode seconds from 2's Complement 64Bit
                // reverse all bits
                // reverse sign
                // remove one
                seconds = -1 * parseInt(bin.split('').map(function(bit) {
                    return bit === '1' ? 0 : 1;
                }).join(''), 2) - 1;
            } else seconds = parseInt(hex, 16);
            nanoseconds = buf.readUInt32BE(0);
    }
    const millis = seconds * 1000 + Math.round(nanoseconds / 1E6);
    return new Date(millis);
}
module.exports = {
    check: $fb4e33ef8dd5f6c7$var$check,
    type: $fb4e33ef8dd5f6c7$var$type,
    encode: $fb4e33ef8dd5f6c7$var$encode,
    decode: $fb4e33ef8dd5f6c7$var$decode
};

});


parcelRegister("8UW2c", function(module, exports) {
"use strict";
var $67e09225fa9207c4$var$LZW = function() {};
$67e09225fa9207c4$var$LZW.prototype.encode = function(s) {
    var dict = {};
    var data = (s + "").split("");
    var out = [];
    var currChar;
    var phrase = data[0];
    var code = 256;
    for(var i = 1; i < data.length; i++){
        currChar = data[i];
        if (dict[phrase + currChar] != null) phrase += currChar;
        else {
            out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
            dict[phrase + currChar] = code;
            code++;
            phrase = currChar;
        }
    }
    out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0));
    for(var i = 0; i < out.length; i++)out[i] = String.fromCharCode(out[i]);
    return out.join("");
};
$67e09225fa9207c4$var$LZW.prototype.decode = function(s) {
    var dict = {};
    var data = (s + "").split("");
    var currChar = data[0];
    var oldPhrase = currChar;
    var out = [
        currChar
    ];
    var code = 256;
    var phrase;
    for(var i = 1; i < data.length; i++){
        var currCode = data[i].charCodeAt(0);
        if (currCode < 256) phrase = data[i];
        else phrase = dict[currCode] ? dict[currCode] : oldPhrase + currChar;
        out.push(phrase);
        currChar = phrase.charAt(0);
        dict[code] = oldPhrase + currChar;
        code++;
        oldPhrase = phrase;
    }
    return out.join("");
};
module.exports = new $67e09225fa9207c4$var$LZW();

});

parcelRegister("k2Xkw", function(module, exports) {

module.exports = (parcelRequire("4PLrF"));

});
parcelRegister("4PLrF", function(module, exports) {

$parcel$export(module.exports, "version", () => $3850ba7afc656304$export$83d89fbfd8236492, (v) => $3850ba7afc656304$export$83d89fbfd8236492 = v);
$parcel$export(module.exports, "encode", () => $3850ba7afc656304$export$c564cdbbe6da493, (v) => $3850ba7afc656304$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $3850ba7afc656304$export$2f872c0f2117be69, (v) => $3850ba7afc656304$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "validate", () => $3850ba7afc656304$export$a22775fa5e2eebd9, (v) => $3850ba7afc656304$export$a22775fa5e2eebd9 = v);
/*!
 * urlsafe-base64
 */ /**
 * Module Dependencies
 */ // None yet!
/**
 * Library version.
 */ var $3850ba7afc656304$export$83d89fbfd8236492;
/**
 * .encode
 *
 * return an encoded Buffer as URL Safe Base64
 *
 * Note: This function encodes to the RFC 4648 Spec where '+' is encoded
 *       as '-' and '/' is encoded as '_'. The padding character '=' is
 *       removed.
 *
 * @param {Buffer} buffer
 * @return {String}
 * @api public
 */ var $3850ba7afc656304$export$c564cdbbe6da493;
/**
 * .decode
 *
 * return an decoded URL Safe Base64 as Buffer
 *
 * @param {String}
 * @return {Buffer}
 * @api public
 */ var $3850ba7afc656304$export$2f872c0f2117be69;
/**
 * .validate
 *
 * Validates a string if it is URL Safe Base64 encoded.
 *
 * @param {String}
 * @return {Boolean}
 * @api public
 */ var $3850ba7afc656304$export$a22775fa5e2eebd9;

var $i9F75 = parcelRequire("i9F75");
var $3850ba7afc656304$require$Buffer = $i9F75.Buffer;
$3850ba7afc656304$export$83d89fbfd8236492 = '1.0.0';
$3850ba7afc656304$export$c564cdbbe6da493 = function encode(buffer) {
    return buffer.toString('base64').replace(/\+/g, '-') // Convert '+' to '-'
    .replace(/\//g, '_') // Convert '/' to '_'
    .replace(/=+$/, ''); // Remove ending '='
};
$3850ba7afc656304$export$2f872c0f2117be69 = function decode(base64) {
    // Add removed at end '='
    base64 += Array(5 - base64.length % 4).join('=');
    base64 = base64.replace(/\-/g, '+') // Convert '-' to '+'
    .replace(/\_/g, '/'); // Convert '_' to '/'
    return new $3850ba7afc656304$require$Buffer(base64, 'base64');
};
$3850ba7afc656304$export$a22775fa5e2eebd9 = function validate(base64) {
    return /^[A-Za-z0-9\-_]+$/.test(base64);
};

});




parcelRegister("57Cad", function(module, exports) {
"use strict";
var $3bab35bef7dd3086$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3bab35bef7dd3086$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3bab35bef7dd3086$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3bab35bef7dd3086$var$__exportStar((parcelRequire("hS6oR")), module.exports);

$3bab35bef7dd3086$var$__exportStar((parcelRequire("52DKO")), module.exports);

$3bab35bef7dd3086$var$__exportStar((parcelRequire("dP0ks")), module.exports);

});
parcelRegister("hS6oR", function(module, exports) {
"use strict";
var $d02c71baa41824c7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d02c71baa41824c7$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $d02c71baa41824c7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

const $d02c71baa41824c7$var$graphql_tag_1 = $d02c71baa41824c7$var$__importDefault((parcelRequire("49Mok")));

var $jGY5u = parcelRequire("jGY5u");

var $1t8Wn = parcelRequire("1t8Wn");

var $j7eyO = parcelRequire("j7eyO");
var $gawXH = parcelRequire("gawXH");
var $3dOhR = parcelRequire("3dOhR");

var $bq6Hs = parcelRequire("bq6Hs");
var $8MKp4 = parcelRequire("8MKp4");
var $g5fNy = parcelRequire("g5fNy");
var $h7YIO = parcelRequire("h7YIO");

var $fl2ji = parcelRequire("fl2ji");
parcelRequire("5iaYt");
parcelRequire("cFQfj");
parcelRequire("6V1BV");
parcelRequire("6zcWp");
parcelRequire("498qP");
parcelRequire("78cSx");
parcelRequire("d1the");
/**
 * @customElement rx-graph
 */ let $d02c71baa41824c7$var$GraphComponent = class GraphComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.options = {
            fetch: '',
            state: new $bq6Hs.BehaviorSubject({}),
            render: (res)=>(0, $4TeKW.html)` ${res} `,
            loading: ()=>(0, $4TeKW.html)``,
            error: ()=>(0, $4TeKW.html)``,
            style: (0, $4TeKW.css)``,
            settings: {},
            defaultConfig: true
        };
        this.loading = true;
        this.error = '';
    }
    OnInit() {
        this.result = new $h7YIO.ReplaySubject();
    }
    OnUpdateFirst() {
        let task;
        if (this.options.state) {
            if ((0, $8MKp4.isObservable)(this.options.state)) task = this.options.state;
            else this.result.next(this.options.state);
        } else try {
            task = this.query();
        } catch (e) {
            this.result.error(e);
            this.result.complete();
        }
        if (this.options.subscribe) this.pubsubSubscription = this.graphql.subscribe({
            query: (0, $d02c71baa41824c7$var$graphql_tag_1.default)`
            ${this.options.subscribe}
          `
        }).subscribe((data)=>this.result.next(data), (e)=>this.result.error(e));
        if (!task) return;
        this.subscription = task.subscribe((detail)=>{
            this.result.next(detail);
            this.dispatchEvent(new CustomEvent('onData', {
                detail: detail
            }));
        }, (error)=>{
            if (error.networkError) error.message = `${JSON.stringify(error.networkError.result.errors)} ${error.message}`;
            this.result.error(error);
            this.dispatchEvent(new CustomEvent('onError', {
                detail: error
            }));
        });
    // const monad = this.getRootNode().host.getRootNode();
    // monad.append(this.shadowRoot)
    // const monad = this.getRootNode().host;
    // if (monad.parentElement) {
    //     monad.parentElement.prepend(this.shadowRoot)
    // }
    }
    OnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
        if (this.pubsubSubscription) this.pubsubSubscription.unsubscribe();
        this.result.complete();
    }
    query() {
        let fetch = this.options.fetch;
        this.options.settings = this.options.settings || {};
        this.options.fetch = this.options.fetch || '';
        if (this.options.fetch.loc && this.options.fetch.loc.source) fetch = this.options.fetch.loc.source.body;
        if (typeof fetch === 'string' && fetch.includes('mutation')) {
            this.options.settings.mutation = (0, $d02c71baa41824c7$var$graphql_tag_1.default)`
        ${fetch}
      `;
            return this.graphql.mutate(this.options.settings);
        }
        this.options.settings.query = typeof fetch !== 'string' ? fetch : (0, $d02c71baa41824c7$var$graphql_tag_1.default)`
            ${fetch}
          `;
        if (typeof fetch === 'string' && fetch.includes('subscription')) return this.graphql.subscribe(this.options.settings);
        return this.graphql.query(this.options.settings);
    }
    isPrimitive(test) {
        return test !== Object(test);
    }
};
$d02c71baa41824c7$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $d02c71baa41824c7$var$__metadata("design:type", Object)
], $d02c71baa41824c7$var$GraphComponent.prototype, "options", void 0);
$d02c71baa41824c7$var$__decorate([
    (0, $1t8Wn.Inject)($jGY5u.BaseService),
    $d02c71baa41824c7$var$__metadata("design:type", $jGY5u.BaseService)
], $d02c71baa41824c7$var$GraphComponent.prototype, "graphql", void 0);
$d02c71baa41824c7$var$__decorate([
    (0, $4TeKW.property)({
        type: Boolean
    }),
    $d02c71baa41824c7$var$__metadata("design:type", Object)
], $d02c71baa41824c7$var$GraphComponent.prototype, "loading", void 0);
$d02c71baa41824c7$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $d02c71baa41824c7$var$__metadata("design:type", Object)
], $d02c71baa41824c7$var$GraphComponent.prototype, "error", void 0);
$d02c71baa41824c7$var$GraphComponent = $d02c71baa41824c7$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-graph',
        template () {
            var _a;
            return (0, $4TeKW.html)`
      <style>
        ${(_a = this.options) === null || _a === void 0 ? void 0 : _a.style}
      </style>
      ${(0, $4TeKW.async)(this.result.pipe((0, $gawXH.map)((state)=>{
                return this.options.render ? this.options.render(state, (data)=>this.result.next(data), this.shadowRoot) : state;
            }), (0, $3dOhR.tap)(()=>this.loading = false), (0, $j7eyO.catchError)((e)=>{
                this.error = e;
                this.loading = false;
                return (0, $g5fNy.of)('');
            })))}
      ${this.loading ? (0, $4TeKW.html)`
            ${typeof this.options.loading === 'function' ? this.options.loading() : $1t8Wn.Container.get($fl2ji.DEFAULTS).loading()}
          ` : ''}
      ${this.error ? (0, $4TeKW.html)`
            ${typeof this.options.error === 'function' ? this.options.error(this.error) : $1t8Wn.Container.get($fl2ji.DEFAULTS).error(this.error)}
          ` : ''}
      <slot></slot>
    `;
        }
    })
], $d02c71baa41824c7$var$GraphComponent);
module.exports.GraphComponent = $d02c71baa41824c7$var$GraphComponent;

});
parcelRegister("49Mok", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "gql", () => $306d8a3188ff16b8$export$72e4926bf8358653);
$parcel$export(module.exports, "resetCaches", () => $306d8a3188ff16b8$export$657554ef4dc7ac2d);
$parcel$export(module.exports, "disableFragmentWarnings", () => $306d8a3188ff16b8$export$e4294e638636c6ab);
$parcel$export(module.exports, "enableExperimentalFragmentVariables", () => $306d8a3188ff16b8$export$78cf889af350c840);
$parcel$export(module.exports, "disableExperimentalFragmentVariables", () => $306d8a3188ff16b8$export$5290df9bbbd3cfa);
$parcel$export(module.exports, "default", () => $306d8a3188ff16b8$export$2e2bcd8739ae039);

var $deWeK = parcelRequire("deWeK");

var $42BaK = parcelRequire("42BaK");
var $306d8a3188ff16b8$var$docCache = new Map();
var $306d8a3188ff16b8$var$fragmentSourceMap = new Map();
var $306d8a3188ff16b8$var$printFragmentWarnings = true;
var $306d8a3188ff16b8$var$experimentalFragmentVariables = false;
function $306d8a3188ff16b8$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $306d8a3188ff16b8$var$cacheKeyFromLoc(loc) {
    return $306d8a3188ff16b8$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $306d8a3188ff16b8$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $306d8a3188ff16b8$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $306d8a3188ff16b8$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($306d8a3188ff16b8$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $306d8a3188ff16b8$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $deWeK.__assign)((0, $deWeK.__assign)({}, ast), {
        definitions: definitions
    });
}
function $306d8a3188ff16b8$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $306d8a3188ff16b8$var$parseDocument(source) {
    var cacheKey = $306d8a3188ff16b8$var$normalize(source);
    if (!$306d8a3188ff16b8$var$docCache.has(cacheKey)) {
        var parsed = (0, $42BaK.parse)(source, {
            experimentalFragmentVariables: $306d8a3188ff16b8$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $306d8a3188ff16b8$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $306d8a3188ff16b8$var$docCache.set(cacheKey, $306d8a3188ff16b8$var$stripLoc($306d8a3188ff16b8$var$processFragments(parsed)));
    }
    return $306d8a3188ff16b8$var$docCache.get(cacheKey);
}
function $306d8a3188ff16b8$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $306d8a3188ff16b8$var$parseDocument(result);
}
function $306d8a3188ff16b8$export$657554ef4dc7ac2d() {
    $306d8a3188ff16b8$var$docCache.clear();
    $306d8a3188ff16b8$var$fragmentSourceMap.clear();
}
function $306d8a3188ff16b8$export$e4294e638636c6ab() {
    $306d8a3188ff16b8$var$printFragmentWarnings = false;
}
function $306d8a3188ff16b8$export$78cf889af350c840() {
    $306d8a3188ff16b8$var$experimentalFragmentVariables = true;
}
function $306d8a3188ff16b8$export$5290df9bbbd3cfa() {
    $306d8a3188ff16b8$var$experimentalFragmentVariables = false;
}
var $306d8a3188ff16b8$var$extras = {
    gql: $306d8a3188ff16b8$export$72e4926bf8358653,
    resetCaches: $306d8a3188ff16b8$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $306d8a3188ff16b8$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $306d8a3188ff16b8$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $306d8a3188ff16b8$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $306d8a3188ff16b8$var$extras.gql, gql_1.resetCaches = $306d8a3188ff16b8$var$extras.resetCaches, gql_1.disableFragmentWarnings = $306d8a3188ff16b8$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $306d8a3188ff16b8$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $306d8a3188ff16b8$var$extras.disableExperimentalFragmentVariables;
})($306d8a3188ff16b8$export$72e4926bf8358653 || ($306d8a3188ff16b8$export$72e4926bf8358653 = {}));
$306d8a3188ff16b8$export$72e4926bf8358653["default"] = $306d8a3188ff16b8$export$72e4926bf8358653;
var $306d8a3188ff16b8$export$2e2bcd8739ae039 = $306d8a3188ff16b8$export$72e4926bf8358653;

});
parcelRegister("42BaK", function(module, exports) {

$parcel$export(module.exports, "parse", () => $72a9e3c4d3426ab2$export$98e6a39c04603d36);

var $eXwVb = parcelRequire("eXwVb");

var $28JEf = parcelRequire("28JEf");

var $3i8X0 = parcelRequire("3i8X0");

var $1bTmB = parcelRequire("1bTmB");

var $9bJMq = parcelRequire("9bJMq");

var $1KHiu = parcelRequire("1KHiu");

var $az2B5 = parcelRequire("az2B5");

var $jDqoD = parcelRequire("jDqoD");

var $l0bzO = parcelRequire("l0bzO");
function $72a9e3c4d3426ab2$export$98e6a39c04603d36(source, options) {
    var parser = new $72a9e3c4d3426ab2$var$Parser(source, options);
    return parser.parseDocument();
}
function $72a9e3c4d3426ab2$export$5303528d1070ff6f(source, options) {
    var parser = new $72a9e3c4d3426ab2$var$Parser(source, options);
    parser.expectToken((0, $l0bzO.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $l0bzO.TokenKind).EOF);
    return value;
}
function $72a9e3c4d3426ab2$export$28b8f402ccc88182(source, options) {
    var parser = new $72a9e3c4d3426ab2$var$Parser(source, options);
    parser.expectToken((0, $l0bzO.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $l0bzO.TokenKind).EOF);
    return type;
}
var $72a9e3c4d3426ab2$var$Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = typeof source === 'string' ? new (0, $1KHiu.Source)(source) : source;
        sourceObj instanceof (0, $1KHiu.Source) || (0, $28JEf.default)(0, "Must provide Source. Received: ".concat((0, $eXwVb.default)(sourceObj)));
        this._lexer = (0, $az2B5.createLexer)(sourceObj);
        this._options = options || {};
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $l0bzO.TokenKind).NAME);
        return {
            kind: (0, $9bJMq.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $9bJMq.Kind).DOCUMENT,
            definitions: this.many((0, $l0bzO.TokenKind).SOF, this.parseDefinition, (0, $l0bzO.TokenKind).EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $l0bzO.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $l0bzO.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $l0bzO.TokenKind).BRACE_L)) return {
            kind: (0, $9bJMq.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $l0bzO.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $9bJMq.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $l0bzO.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $l0bzO.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $l0bzO.TokenKind).PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $9bJMq.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $l0bzO.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $l0bzO.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $l0bzO.TokenKind).DOLLAR);
        return {
            kind: (0, $9bJMq.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $9bJMq.Kind).SELECTION_SET,
            selections: this.many((0, $l0bzO.TokenKind).BRACE_L, this.parseSelection, (0, $l0bzO.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $l0bzO.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $l0bzO.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $9bJMq.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $l0bzO.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $l0bzO.TokenKind).PAREN_L, item, (0, $l0bzO.TokenKind).PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $l0bzO.TokenKind).COLON);
        return {
            kind: (0, $9bJMq.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $9bJMq.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $l0bzO.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $l0bzO.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $l0bzO.TokenKind).NAME)) return {
            kind: (0, $9bJMq.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $9bJMq.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.experimentalFragmentVariables) return {
            kind: (0, $9bJMq.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $9bJMq.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $l0bzO.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $l0bzO.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $l0bzO.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $9bJMq.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $l0bzO.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $9bJMq.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $l0bzO.TokenKind).STRING:
            case (0, $l0bzO.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $l0bzO.TokenKind).NAME:
                if (token.value === 'true' || token.value === 'false') {
                    this._lexer.advance();
                    return {
                        kind: (0, $9bJMq.Kind).BOOLEAN,
                        value: token.value === 'true',
                        loc: this.loc(token)
                    };
                } else if (token.value === 'null') {
                    this._lexer.advance();
                    return {
                        kind: (0, $9bJMq.Kind).NULL,
                        loc: this.loc(token)
                    };
                }
                this._lexer.advance();
                return {
                    kind: (0, $9bJMq.Kind).ENUM,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $l0bzO.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $9bJMq.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $l0bzO.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $9bJMq.Kind).LIST,
            values: this.any((0, $l0bzO.TokenKind).BRACKET_L, item, (0, $l0bzO.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $9bJMq.Kind).OBJECT,
            fields: this.any((0, $l0bzO.TokenKind).BRACE_L, item, (0, $l0bzO.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $l0bzO.TokenKind).COLON);
        return {
            kind: (0, $9bJMq.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $l0bzO.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $l0bzO.TokenKind).AT);
        return {
            kind: (0, $9bJMq.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $l0bzO.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $l0bzO.TokenKind).BRACKET_R);
            type = {
                kind: (0, $9bJMq.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $l0bzO.TokenKind).BANG)) return {
            kind: (0, $9bJMq.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $9bJMq.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $l0bzO.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $l0bzO.TokenKind).STRING) || this.peek((0, $l0bzO.TokenKind).BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $l0bzO.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $l0bzO.TokenKind).BRACE_R);
        return {
            kind: (0, $9bJMq.Kind).SCHEMA_DEFINITION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $l0bzO.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $9bJMq.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9bJMq.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $9bJMq.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var types = [];
        if (this.expectOptionalKeyword('implements')) {
            // Optional leading ampersand
            this.expectOptionalToken((0, $l0bzO.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $l0bzO.TokenKind).AMP) || // Legacy support for the SDL?
            this._options.allowLegacySDLImplementsInterfaces && this.peek((0, $l0bzO.TokenKind).NAME));
        }
        return types;
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        // Legacy support for the SDL?
        if (this._options.allowLegacySDLEmptyFields && this.peek((0, $l0bzO.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $l0bzO.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $l0bzO.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $l0bzO.TokenKind).BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $l0bzO.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9bJMq.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $l0bzO.TokenKind).PAREN_L, this.parseInputValueDef, (0, $l0bzO.TokenKind).PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $l0bzO.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $l0bzO.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9bJMq.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $9bJMq.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $9bJMq.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        var types = [];
        if (this.expectOptionalToken((0, $l0bzO.TokenKind).EQUALS)) {
            // Optional leading pipe
            this.expectOptionalToken((0, $l0bzO.TokenKind).PIPE);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $l0bzO.TokenKind).PIPE));
        }
        return types;
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $9bJMq.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $l0bzO.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $l0bzO.TokenKind).BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $9bJMq.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $9bJMq.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $l0bzO.TokenKind).BRACE_L, this.parseInputValueDef, (0, $l0bzO.TokenKind).BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $l0bzO.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $l0bzO.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $l0bzO.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $9bJMq.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $9bJMq.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $9bJMq.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $9bJMq.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $9bJMq.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $9bJMq.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $9bJMq.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $l0bzO.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $9bJMq.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        // Optional leading pipe
        this.expectOptionalToken((0, $l0bzO.TokenKind).PIPE);
        var locations = [];
        do locations.push(this.parseDirectiveLocation());
        while (this.expectOptionalToken((0, $l0bzO.TokenKind).PIPE));
        return locations;
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $jDqoD.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        if (!this._options.noLocation) return new $72a9e3c4d3426ab2$var$Loc(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $1bTmB.syntaxError)(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat($72a9e3c4d3426ab2$var$getTokenDesc(token)));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $l0bzO.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $1bTmB.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($72a9e3c4d3426ab2$var$getTokenDesc(token)));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $l0bzO.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken || this._lexer.token;
        return (0, $1bTmB.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($72a9e3c4d3426ab2$var$getTokenDesc(token)));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    return Parser;
}();
function $72a9e3c4d3426ab2$var$Loc(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, $3i8X0.default)($72a9e3c4d3426ab2$var$Loc, function() {
    return {
        start: this.start,
        end: this.end
    };
});
/**
 * A helper function to describe a token as a string for debugging
 */ function $72a9e3c4d3426ab2$var$getTokenDesc(token) {
    var value = token.value;
    return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

});
parcelRegister("3i8X0", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d04d9058c58318$export$2e2bcd8739ae039);

var $hmmvT = parcelRequire("hmmvT");
function $61d04d9058c58318$export$2e2bcd8739ae039(classObject) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
    classObject.prototype.toJSON = fn;
    classObject.prototype.inspect = fn;
    if (0, $hmmvT.default) classObject.prototype[0, $hmmvT.default] = fn;
}

});

parcelRegister("1bTmB", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $aefa7ec39b6f22e0$export$bbee0c6176c019d4);

var $hgajI = parcelRequire("hgajI");
function $aefa7ec39b6f22e0$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $hgajI.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("hgajI", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $ead516ca2cd94c95$export$92d6ed0888e7cb7f);

var $aCbOe = parcelRequire("aCbOe");

var $iz7Ac = parcelRequire("iz7Ac");

var $jVFgN = parcelRequire("jVFgN");
function $ead516ca2cd94c95$export$92d6ed0888e7cb7f(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $iz7Ac.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $iz7Ac.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions;
    if (_extensions == null && originalError != null) {
        var originalExtensions = originalError.extensions;
        if ((0, $aCbOe.default)(originalExtensions)) _extensions = originalExtensions;
    }
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $ead516ca2cd94c95$export$92d6ed0888e7cb7f);
    else Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$ead516ca2cd94c95$export$92d6ed0888e7cb7f.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $ead516ca2cd94c95$export$92d6ed0888e7cb7f
    },
    name: {
        value: 'GraphQLError'
    },
    toString: {
        value: function toString() {
            return $ead516ca2cd94c95$export$55ee1551a3f962e6(this);
        }
    }
});
function $ead516ca2cd94c95$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++){
        var node = _error$nodes2[_i2];
        if (node.loc) output += '\n\n' + (0, $jVFgN.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++){
        var location = _error$locations2[_i4];
        output += '\n\n' + (0, $jVFgN.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("aCbOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $53633bf55801e016$export$2e2bcd8739ae039);
function $53633bf55801e016$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $53633bf55801e016$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $53633bf55801e016$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $53633bf55801e016$var$_typeof(obj);
}
function $53633bf55801e016$export$2e2bcd8739ae039(value) {
    return $53633bf55801e016$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("iz7Ac", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $cf5d87fe0c32fd5c$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $cf5d87fe0c32fd5c$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("jVFgN", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $f377abd267e4d51b$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $f377abd267e4d51b$export$867940333fd9f869);

var $iz7Ac = parcelRequire("iz7Ac");
function $f377abd267e4d51b$export$96a9681e539deed(location) {
    return $f377abd267e4d51b$export$867940333fd9f869(location.source, (0, $iz7Ac.getLocation)(location.source, location.start));
}
function $f377abd267e4d51b$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $f377abd267e4d51b$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var sublineIndex = Math.floor(columnNum / 80);
        var sublineColumnNum = columnNum % 80;
        var sublines = [];
        for(var i = 0; i < locationLine.length; i += 80)sublines.push(locationLine.slice(i, i + 80));
        return locationStr + $f377abd267e4d51b$var$printPrefixedLines([
            [
                "".concat(lineNum),
                sublines[0]
            ]
        ].concat(sublines.slice(1, sublineIndex + 1).map(function(subline) {
            return [
                '',
                subline
            ];
        }), [
            [
                ' ',
                $f377abd267e4d51b$var$whitespace(sublineColumnNum - 1) + '^'
            ],
            [
                '',
                sublines[sublineIndex + 1]
            ]
        ]));
    }
    return locationStr + $f377abd267e4d51b$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $f377abd267e4d51b$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $f377abd267e4d51b$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $f377abd267e4d51b$var$lpad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $f377abd267e4d51b$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $f377abd267e4d51b$var$lpad(len, str) {
    return $f377abd267e4d51b$var$whitespace(len - str.length) + str;
}

});



parcelRegister("az2B5", function(module, exports) {

$parcel$export(module.exports, "createLexer", () => $544acd9116bd8f57$export$542413421c3f8a82);

var $3i8X0 = parcelRequire("3i8X0");

var $1bTmB = parcelRequire("1bTmB");

var $fs9Mn = parcelRequire("fs9Mn");

var $l0bzO = parcelRequire("l0bzO");
function $544acd9116bd8f57$export$542413421c3f8a82(source, options) {
    var startOfFileToken = new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).SOF, 0, 0, 0, 0, null);
    var lexer = {
        source: source,
        options: options,
        lastToken: startOfFileToken,
        token: startOfFileToken,
        line: 1,
        lineStart: 0,
        advance: $544acd9116bd8f57$var$advanceLexer,
        lookahead: $544acd9116bd8f57$var$lookahead
    };
    return lexer;
}
function $544acd9116bd8f57$var$advanceLexer() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
}
function $544acd9116bd8f57$var$lookahead() {
    var token = this.token;
    if (token.kind !== (0, $l0bzO.TokenKind).EOF) do // Note: next is only mutable during parsing, so we cast to allow this.
    token = token.next || (token.next = $544acd9116bd8f57$var$readToken(this, token));
    while (token.kind === (0, $l0bzO.TokenKind).COMMENT);
    return token;
}
function $544acd9116bd8f57$export$aebcc098ae68f143(token) {
    var kind = token.kind;
    return kind === (0, $l0bzO.TokenKind).BANG || kind === (0, $l0bzO.TokenKind).DOLLAR || kind === (0, $l0bzO.TokenKind).AMP || kind === (0, $l0bzO.TokenKind).PAREN_L || kind === (0, $l0bzO.TokenKind).PAREN_R || kind === (0, $l0bzO.TokenKind).SPREAD || kind === (0, $l0bzO.TokenKind).COLON || kind === (0, $l0bzO.TokenKind).EQUALS || kind === (0, $l0bzO.TokenKind).AT || kind === (0, $l0bzO.TokenKind).BRACKET_L || kind === (0, $l0bzO.TokenKind).BRACKET_R || kind === (0, $l0bzO.TokenKind).BRACE_L || kind === (0, $l0bzO.TokenKind).PIPE || kind === (0, $l0bzO.TokenKind).BRACE_R;
}
/**
 * Helper function for constructing the Token object.
 */ function $544acd9116bd8f57$var$Tok(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, $3i8X0.default)($544acd9116bd8f57$var$Tok, function() {
    return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
    };
});
function $544acd9116bd8f57$var$printCharCode(code) {
    return isNaN(code) ? (0, $l0bzO.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $544acd9116bd8f57$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = $544acd9116bd8f57$var$positionAfterWhitespace(body, prev.end, lexer);
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    if (pos >= bodyLength) return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
    var code = body.charCodeAt(pos); // SourceCharacter
    switch(code){
        // !
        case 33:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).BANG, pos, pos + 1, line, col, prev);
        // #
        case 35:
            return $544acd9116bd8f57$var$readComment(source, pos, line, col, prev);
        // $
        case 36:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).DOLLAR, pos, pos + 1, line, col, prev);
        // &
        case 38:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).AMP, pos, pos + 1, line, col, prev);
        // (
        case 40:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).PAREN_L, pos, pos + 1, line, col, prev);
        // )
        case 41:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).PAREN_R, pos, pos + 1, line, col, prev);
        // .
        case 46:
            if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).SPREAD, pos, pos + 3, line, col, prev);
            break;
        // :
        case 58:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).COLON, pos, pos + 1, line, col, prev);
        // =
        case 61:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).EQUALS, pos, pos + 1, line, col, prev);
        // @
        case 64:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).AT, pos, pos + 1, line, col, prev);
        // [
        case 91:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).BRACKET_L, pos, pos + 1, line, col, prev);
        // ]
        case 93:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).BRACKET_R, pos, pos + 1, line, col, prev);
        // {
        case 123:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).BRACE_L, pos, pos + 1, line, col, prev);
        // |
        case 124:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).PIPE, pos, pos + 1, line, col, prev);
        // }
        case 125:
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).BRACE_R, pos, pos + 1, line, col, prev);
        // A-Z _ a-z
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
            return $544acd9116bd8f57$var$readName(source, pos, line, col, prev);
        // - 0-9
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return $544acd9116bd8f57$var$readNumber(source, pos, code, line, col, prev);
        // "
        case 34:
            if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $544acd9116bd8f57$var$readBlockString(source, pos, line, col, prev, lexer);
            return $544acd9116bd8f57$var$readString(source, pos, line, col, prev);
    }
    throw (0, $1bTmB.syntaxError)(source, pos, $544acd9116bd8f57$var$unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $544acd9116bd8f57$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($544acd9116bd8f57$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($544acd9116bd8f57$var$printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */ function $544acd9116bd8f57$var$positionAfterWhitespace(body, startPosition, lexer) {
    var bodyLength = body.length;
    var position = startPosition;
    while(position < bodyLength){
        var code = body.charCodeAt(position); // tab | space | comma | BOM
        if (code === 9 || code === 32 || code === 44 || code === 0xfeff) ++position;
        else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else break;
    }
    return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $544acd9116bd8f57$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $544acd9116bd8f57$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $1bTmB.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($544acd9116bd8f57$var$printCharCode(code), "."));
    } else {
        position = $544acd9116bd8f57$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $544acd9116bd8f57$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $544acd9116bd8f57$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or e
    if (code === 46 || code === 69 || code === 101) throw (0, $1bTmB.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($544acd9116bd8f57$var$printCharCode(code), "."));
    return new $544acd9116bd8f57$var$Tok(isFloat ? (0, $l0bzO.TokenKind).FLOAT : (0, $l0bzO.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $544acd9116bd8f57$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $1bTmB.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($544acd9116bd8f57$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $544acd9116bd8f57$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $1bTmB.syntaxError)(source, position, "Invalid character within String: ".concat($544acd9116bd8f57$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $544acd9116bd8f57$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $1bTmB.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $1bTmB.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $1bTmB.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $544acd9116bd8f57$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $fs9Mn.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $1bTmB.syntaxError)(source, position, "Invalid character within String: ".concat($544acd9116bd8f57$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $1bTmB.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $544acd9116bd8f57$var$uniCharCode(a, b, c, d) {
    return $544acd9116bd8f57$var$char2hex(a) << 12 | $544acd9116bd8f57$var$char2hex(b) << 8 | $544acd9116bd8f57$var$char2hex(c) << 4 | $544acd9116bd8f57$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $544acd9116bd8f57$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $544acd9116bd8f57$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new $544acd9116bd8f57$var$Tok((0, $l0bzO.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
}

});
parcelRegister("l0bzO", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $082d89beaaf55a4c$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $082d89beaaf55a4c$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});


parcelRegister("jDqoD", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $f8f27064cc6dd239$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $f8f27064cc6dd239$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});



parcelRegister("jGY5u", function(module, exports) {
"use strict";
var $e5608cb0e2d758ba$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e5608cb0e2d758ba$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseService = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $5JMLH = parcelRequire("5JMLH");
let $e5608cb0e2d758ba$var$BaseService = class BaseService {
    query(options) {
        return (0, $5JMLH.from)(this.graphql.query.bind(this.graphql)(options));
    }
    mutate(options) {
        return (0, $5JMLH.from)(this.graphql.mutate.bind(this.graphql)(options));
    }
    watchQuery(options) {
        return this.graphql.watchQuery(options);
    }
    subscribe(options) {
        return (0, $5JMLH.from)(this.graphql.subscribe.bind(this.graphql)(options));
    }
};
$e5608cb0e2d758ba$var$__decorate([
    (0, $1t8Wn.Injector)($2O1GU.ApolloClient),
    $e5608cb0e2d758ba$var$__metadata("design:type", Object)
], $e5608cb0e2d758ba$var$BaseService.prototype, "graphql", void 0);
$e5608cb0e2d758ba$var$BaseService = $e5608cb0e2d758ba$var$__decorate([
    (0, $1t8Wn.Injectable)()
], $e5608cb0e2d758ba$var$BaseService);
module.exports.BaseService = $e5608cb0e2d758ba$var$BaseService;

});

parcelRegister("8MKp4", function(module, exports) {

$parcel$export(module.exports, "isObservable", () => $6656cd3073292ea3$export$5cd057a6046189f9);

var $8id0M = parcelRequire("8id0M");

var $ePlbj = parcelRequire("ePlbj");
function $6656cd3073292ea3$export$5cd057a6046189f9(obj) {
    return !!obj && (obj instanceof (0, $8id0M.Observable) || (0, $ePlbj.isFunction)(obj.lift) && (0, $ePlbj.isFunction)(obj.subscribe));
}

});

parcelRegister("fl2ji", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULTS = void 0;

var $1t8Wn = parcelRequire("1t8Wn");
module.exports.DEFAULTS = new $1t8Wn.InjectionToken();

});

parcelRegister("5iaYt", function(module, exports) {
"use strict";
var $3da7257e6c8cba94$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3da7257e6c8cba94$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-fetch
 */ let $3da7257e6c8cba94$var$FetchComponent = class FetchComponent extends $4TeKW.LitElement {
};
$3da7257e6c8cba94$var$__decorate([
    (0, $4TeKW.property)(),
    $3da7257e6c8cba94$var$__metadata("design:type", String)
], $3da7257e6c8cba94$var$FetchComponent.prototype, "query", void 0);
$3da7257e6c8cba94$var$__decorate([
    (0, $4TeKW.property)(),
    $3da7257e6c8cba94$var$__metadata("design:type", String)
], $3da7257e6c8cba94$var$FetchComponent.prototype, "mutate", void 0);
$3da7257e6c8cba94$var$__decorate([
    (0, $4TeKW.property)(),
    $3da7257e6c8cba94$var$__metadata("design:type", String)
], $3da7257e6c8cba94$var$FetchComponent.prototype, "subscribe", void 0);
$3da7257e6c8cba94$var$FetchComponent = $3da7257e6c8cba94$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-fetch'
    })
], $3da7257e6c8cba94$var$FetchComponent);
module.exports.FetchComponent = $3da7257e6c8cba94$var$FetchComponent;

});

parcelRegister("cFQfj", function(module, exports) {
"use strict";
var $93a1d75a06ba35c6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $93a1d75a06ba35c6$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RenderComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-render
 */ let $93a1d75a06ba35c6$var$RenderComponent = class RenderComponent extends $4TeKW.LitElement {
};
$93a1d75a06ba35c6$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $93a1d75a06ba35c6$var$__metadata("design:type", Function)
], $93a1d75a06ba35c6$var$RenderComponent.prototype, "state", void 0);
$93a1d75a06ba35c6$var$RenderComponent = $93a1d75a06ba35c6$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-render',
        template: ()=>(0, $4TeKW.html)` <slot></slot> `
    })
], $93a1d75a06ba35c6$var$RenderComponent);
module.exports.RenderComponent = $93a1d75a06ba35c6$var$RenderComponent;

});

parcelRegister("6V1BV", function(module, exports) {
"use strict";
var $509950d28a6574e9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $509950d28a6574e9$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var $509950d28a6574e9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MonadComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");

var $gOO6w = parcelRequire("gOO6w");

var $8MKp4 = parcelRequire("8MKp4");

var $gawXH = parcelRequire("gawXH");
/**
 * @customElement rx-monad
 */ let $509950d28a6574e9$var$MonadComponent = class MonadComponent extends $4TeKW.LitElement {
    OnUpdateFirst() {
        return $509950d28a6574e9$var$__awaiter(this, void 0, void 0, function*() {
            const nodes = this.shadowRoot.querySelector('slot').assignedNodes();
            const renderComponent = this.findNode(nodes, 'rx-render');
            const fetchComponent = this.findNode(nodes, 'rx-fetch');
            const stateComponent = this.findNode(nodes, 'rx-state');
            const styleComponent = this.findNode(nodes, 'rx-style');
            const settingsComponent = this.findNode(nodes, 'rx-settings');
            const lensComponent = this.findNode(nodes, 'rx-lens');
            let fetch;
            let state = yield stateComponent.value;
            if (lensComponent.match) state = this.get(state, lensComponent.match);
            else if (lensComponent.get) {
                lensComponent.get = lensComponent.get.map((a)=>a === 'all' ? $gOO6w.all : a);
                if ((0, $8MKp4.isObservable)(state)) state = state.pipe((0, $gawXH.map)((s)=>{
                    const expectedState = $gOO6w.get(...lensComponent.get)(s);
                    if (!expectedState) return s;
                    return expectedState;
                }));
                else state = $gOO6w.get(...lensComponent.get)(state);
                if (lensComponent.ray) state = lensComponent.ray(state);
            } else if (lensComponent.ray) {
                if ((0, $8MKp4.isObservable)(state)) state = state.pipe((0, $gawXH.map)((s)=>lensComponent.ray(s)));
                else state = lensComponent.ray(state);
            }
            if (fetchComponent.query) fetch = this.trim(fetchComponent.query, 'query');
            if (fetchComponent.subscribe) fetch = this.trim(fetchComponent.subscribe, 'subscription');
            if (fetchComponent.mutate) fetch = this.trim(fetchComponent.mutate, 'mutation');
            this.options = {
                settings: settingsComponent.value,
                state: state,
                fetch: fetch,
                style: styleComponent.value,
                render: renderComponent.state
            };
        });
    }
    trim(query = '', type) {
        if (query.includes(type)) return query;
        const trimmedQuery = query.trim().replace(/\s/g, '');
        return `${type} ${trimmedQuery}`;
    }
    modState(args, state) {
        return new Promise((resolve, reject)=>{
            try {
                (0, $gOO6w.mod)(args[0], args[1], args[2], args[3], args[4])(resolve)(state);
            } catch (e) {
                reject(e);
            }
        });
    }
    findNode(nodes, localName) {
        const node = nodes.find((n)=>n && n.nextSibling && n.nextSibling.localName === localName);
        if (node) return node.nextSibling;
        return {
            value: null
        };
    }
    get(obj = {}, path = '', defaultValue) {
        return path.replace(/\[(.+?)\]/g, '.$1').split('.').reduce((o, key)=>o[key], obj) || defaultValue;
    }
};
$509950d28a6574e9$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $509950d28a6574e9$var$__metadata("design:type", Object)
], $509950d28a6574e9$var$MonadComponent.prototype, "options", void 0);
$509950d28a6574e9$var$MonadComponent = $509950d28a6574e9$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-monad',
        template () {
            return (0, $4TeKW.html)`
      <slot></slot>
      ${this.options ? (0, $4TeKW.html)`
            <rx-graph .options=${this.options}></rx-graph>
          ` : ''}
    `;
        }
    })
], $509950d28a6574e9$var$MonadComponent);
module.exports.MonadComponent = $509950d28a6574e9$var$MonadComponent;

});
parcelRegister("gOO6w", function(module, exports) {

$parcel$export(module.exports, "get", () => $c3e82e7ee6b9bc0f$export$3988ae62b71be9a3);
$parcel$export(module.exports, "mod", () => $c3e82e7ee6b9bc0f$export$842a2cf37af977e1);
$parcel$export(module.exports, "matching", () => $c3e82e7ee6b9bc0f$export$ba4f22f061f42309);
$parcel$export(module.exports, "all", () => $c3e82e7ee6b9bc0f$export$84bf76cd7afc7469);
function $c3e82e7ee6b9bc0f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c3e82e7ee6b9bc0f$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c3e82e7ee6b9bc0f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c3e82e7ee6b9bc0f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c3e82e7ee6b9bc0f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c3e82e7ee6b9bc0f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c3e82e7ee6b9bc0f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c3e82e7ee6b9bc0f$var$_typeof(obj);
}
function $c3e82e7ee6b9bc0f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c3e82e7ee6b9bc0f$var$_slicedToArray(arr, i) {
    return $c3e82e7ee6b9bc0f$var$_arrayWithHoles(arr) || $c3e82e7ee6b9bc0f$var$_iterableToArrayLimit(arr, i) || $c3e82e7ee6b9bc0f$var$_unsupportedIterableToArray(arr, i) || $c3e82e7ee6b9bc0f$var$_nonIterableRest();
}
function $c3e82e7ee6b9bc0f$var$_toArray(arr) {
    return $c3e82e7ee6b9bc0f$var$_arrayWithHoles(arr) || $c3e82e7ee6b9bc0f$var$_iterableToArray(arr) || $c3e82e7ee6b9bc0f$var$_unsupportedIterableToArray(arr) || $c3e82e7ee6b9bc0f$var$_nonIterableRest();
}
function $c3e82e7ee6b9bc0f$var$_toConsumableArray(arr) {
    return $c3e82e7ee6b9bc0f$var$_arrayWithoutHoles(arr) || $c3e82e7ee6b9bc0f$var$_iterableToArray(arr) || $c3e82e7ee6b9bc0f$var$_unsupportedIterableToArray(arr) || $c3e82e7ee6b9bc0f$var$_nonIterableSpread();
}
function $c3e82e7ee6b9bc0f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c3e82e7ee6b9bc0f$var$_arrayLikeToArray(arr);
}
function $c3e82e7ee6b9bc0f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c3e82e7ee6b9bc0f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c3e82e7ee6b9bc0f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c3e82e7ee6b9bc0f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c3e82e7ee6b9bc0f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c3e82e7ee6b9bc0f$var$_arrayLikeToArray(o, minLen);
}
function $c3e82e7ee6b9bc0f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c3e82e7ee6b9bc0f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c3e82e7ee6b9bc0f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c3e82e7ee6b9bc0f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c3e82e7ee6b9bc0f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $c3e82e7ee6b9bc0f$var$attr = function(name) {
    return {
        get: function get(obj) {
            return !obj[name] && typeof obj.get === 'function' ? obj.get(name) : obj[name];
        },
        mod: function mod(f) {
            return function(obj) {
                var _len, params, _key, _arguments = arguments;
                return function() {
                    for(_len = _arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = _arguments[_key];
                    if (typeof obj.set === 'function') return obj.set(name, f(obj[name] || obj.get(name)));
                    else if (Array.isArray(obj)) return obj.slice(0, name).concat(f.apply(void 0, [
                        obj[name]
                    ].concat(params))).concat(obj.slice(name + 1));
                    else return $c3e82e7ee6b9bc0f$var$_objectSpread2($c3e82e7ee6b9bc0f$var$_objectSpread2({}, obj), {}, $c3e82e7ee6b9bc0f$var$_defineProperty({}, name, f.apply(void 0, [
                        obj[name]
                    ].concat(params))));
                }();
            };
        },
        traversal: false
    };
};
var $c3e82e7ee6b9bc0f$var$keys = function keys(obj) {
    return obj ? typeof obj.keys === 'function' ? obj.keys() : Object.keys(obj) : [];
};
var $c3e82e7ee6b9bc0f$var$setter = function setter(constructor) {
    switch(constructor){
        case Map:
            return function(obj, key, value) {
                obj.set(key, value);
                return obj;
            };
        case Set:
            return function(obj, _, value) {
                return obj.add(value);
            };
        case Object:
            return function(obj, key, value) {
                obj[key] = value;
                return obj;
            };
    }
};
var $c3e82e7ee6b9bc0f$var$getter = function getter(constructor) {
    switch(constructor){
        case Map:
            return function(obj, key) {
                return obj.get(key);
            };
        case Set:
            return function(_, key) {
                return key;
            };
        case Object:
            return function(obj, key) {
                return obj[key];
            };
    }
};
var $c3e82e7ee6b9bc0f$var$toFP = function toFP(_ref) {
    var _native = _ref["native"], overrides = _ref.overrides;
    return function(f) {
        for(var _len = arguments.length, fixedArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)fixedArgs[_key - 1] = arguments[_key];
        return function(coll) {
            var fxn = $c3e82e7ee6b9bc0f$export$cd7b322347cd567b(f);
            if (typeof coll === 'undefined' || coll === null) return coll;
            if (typeof coll[_native] === 'function') return coll[_native].apply(coll, [
                fxn
            ].concat(fixedArgs));
            else {
                var Constructor = Object.getPrototypeOf(coll).constructor;
                var override = overrides[Constructor];
                if (override) return override(Constructor, $c3e82e7ee6b9bc0f$var$getter(Constructor), $c3e82e7ee6b9bc0f$var$setter(Constructor)).apply(void 0, [
                    coll,
                    fxn
                ].concat(fixedArgs));
            }
        };
    };
};
var $c3e82e7ee6b9bc0f$export$3dea766d36a8935f = function() {
    var _overrides;
    var iteratorFilter = function iteratorFilter(Constructor, get, set) {
        return function(obj, pred) {
            var acc = new Constructor();
            var _iterator = $c3e82e7ee6b9bc0f$var$_createForOfIteratorHelper($c3e82e7ee6b9bc0f$var$keys(obj)), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var key = _step.value;
                    var value = get(obj, key);
                    if (pred(value, key)) set(acc, key, value);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            return acc;
        };
    };
    return $c3e82e7ee6b9bc0f$var$toFP({
        "native": 'filter',
        overrides: (_overrides = {}, $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides, Object, iteratorFilter), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides, Map, iteratorFilter), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides, Set, iteratorFilter), _overrides)
    });
}();
var $c3e82e7ee6b9bc0f$export$871de8747c9eaa88 = function() {
    var _overrides2;
    var iteratorMap = function iteratorMap(Constructor, get, set) {
        return function(obj, f) {
            var acc = new Constructor();
            var _iterator2 = $c3e82e7ee6b9bc0f$var$_createForOfIteratorHelper($c3e82e7ee6b9bc0f$var$keys(obj)), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var key = _step2.value;
                    set(acc, key, f(get(obj, key), key));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            return acc;
        };
    };
    return $c3e82e7ee6b9bc0f$var$toFP({
        "native": 'map',
        overrides: (_overrides2 = {}, $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides2, Object, iteratorMap), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides2, Map, iteratorMap), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides2, Set, iteratorMap), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides2, Promise, function() {
            return function(promise, f) {
                return promise.then(f);
            };
        }), _overrides2)
    });
}();
var $c3e82e7ee6b9bc0f$export$71aa6c912b956294 = function() {
    var _overrides3;
    var iteratorFind = function iteratorFind(_, get, __) {
        return function(obj, f) {
            var result;
            if (!obj) return result;
            var _iterator3 = $c3e82e7ee6b9bc0f$var$_createForOfIteratorHelper($c3e82e7ee6b9bc0f$var$keys(obj)), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var key = _step3.value;
                    var value = get(obj, key);
                    if (f(value, key)) return value;
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        };
    };
    return $c3e82e7ee6b9bc0f$var$toFP({
        "native": 'find',
        overrides: (_overrides3 = {}, $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides3, Object, iteratorFind), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides3, Map, iteratorFind), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides3, Set, iteratorFind), _overrides3)
    });
}();
var $c3e82e7ee6b9bc0f$export$ad14ef4001db2bcd = function() {
    var _overrides4;
    var iteratorSome = function iteratorSome(_, get, __) {
        return function(obj, pred) {
            var _iterator4 = $c3e82e7ee6b9bc0f$var$_createForOfIteratorHelper($c3e82e7ee6b9bc0f$var$keys(obj)), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var key = _step4.value;
                    if (pred(get(obj, key), key)) return true;
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            return false;
        };
    };
    return $c3e82e7ee6b9bc0f$var$toFP({
        "native": 'some',
        overrides: (_overrides4 = {}, $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides4, Object, iteratorSome), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides4, Map, iteratorSome), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides4, Set, iteratorSome), _overrides4)
    });
}();
var $c3e82e7ee6b9bc0f$export$533b26079ad0b4b = function() {
    var _overrides5;
    var iteratorReduce = function iteratorReduce(Constructor, get, _) {
        return function(obj, f, base) {
            var acc = new Constructor();
            var _iterator5 = $c3e82e7ee6b9bc0f$var$_createForOfIteratorHelper($c3e82e7ee6b9bc0f$var$keys(obj)), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var key = _step5.value;
                    f(acc, get(obj, key), key);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
            return base;
        };
    };
    return $c3e82e7ee6b9bc0f$var$toFP({
        "native": 'reduce',
        overrides: (_overrides5 = {}, $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides5, Object, iteratorReduce), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides5, Map, iteratorReduce), $c3e82e7ee6b9bc0f$var$_defineProperty(_overrides5, Set, iteratorReduce), _overrides5)
    });
}();
var $c3e82e7ee6b9bc0f$export$7ecc1a3b11b57dab = function every(arr) {
    var _iterator6 = $c3e82e7ee6b9bc0f$var$_createForOfIteratorHelper(arr), _step6;
    try {
        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
            var elem = _step6.value;
            if (!elem) return false;
        }
    } catch (err) {
        _iterator6.e(err);
    } finally{
        _iterator6.f();
    }
    return true;
};
var $c3e82e7ee6b9bc0f$export$8327ebbef2a0ba76 = function cons(x) {
    return function(xs) {
        return [].concat($c3e82e7ee6b9bc0f$var$_toConsumableArray(xs), [
            x
        ]);
    };
};
var $c3e82e7ee6b9bc0f$export$37cdb546b806ae87 = function unshift(x) {
    return function(xs) {
        return [
            x
        ].concat($c3e82e7ee6b9bc0f$var$_toConsumableArray(xs));
    };
};
var $c3e82e7ee6b9bc0f$export$43128fadae87b74a = function first(xs) {
    return xs[0];
};
var $c3e82e7ee6b9bc0f$export$c58417706a208278 = function rest(_ref2) {
    var _ref3 = $c3e82e7ee6b9bc0f$var$_toArray(_ref2);
    _ref3[0];
    var xs = _ref3.slice(1);
    return xs;
};
var $c3e82e7ee6b9bc0f$export$4cbf152802aa238 = $c3e82e7ee6b9bc0f$export$8327ebbef2a0ba76;
var $c3e82e7ee6b9bc0f$export$ee1b3e54f0441b22 = function concat(xs) {
    return function(ys) {
        return [].concat($c3e82e7ee6b9bc0f$var$_toConsumableArray(ys), $c3e82e7ee6b9bc0f$var$_toConsumableArray(xs));
    };
};
var $c3e82e7ee6b9bc0f$export$10d8903dec122b9d = $c3e82e7ee6b9bc0f$export$ee1b3e54f0441b22;
var $c3e82e7ee6b9bc0f$export$68159836694e22c1 = function prepend(ys) {
    return function(xs) {
        return [].concat($c3e82e7ee6b9bc0f$var$_toConsumableArray(ys), $c3e82e7ee6b9bc0f$var$_toConsumableArray(xs));
    };
};
var $c3e82e7ee6b9bc0f$export$21cde5187c2605a3 = function compile(lens) {
    return [
        'string',
        'number'
    ].includes($c3e82e7ee6b9bc0f$var$_typeof(lens)) ? $c3e82e7ee6b9bc0f$var$attr(lens) : $c3e82e7ee6b9bc0f$var$_objectSpread2({
        traversal: false,
        optional: false
    }, lens);
};
var $c3e82e7ee6b9bc0f$export$f672e0b6f7222cd7 = function() {
    for(var _len = arguments.length, lenses = new Array(_len), _key = 0; _key < _len; _key++)lenses[_key] = arguments[_key];
    return lenses.length === 1 ? $c3e82e7ee6b9bc0f$export$21cde5187c2605a3(lenses[0]) : {
        get: function get(obj) {
            return lenses.map($c3e82e7ee6b9bc0f$export$21cde5187c2605a3).reduce(function(_ref, lens) {
                var traverser = _ref.traverser, state = _ref.state, shortCircuited = _ref.shortCircuited;
                var nextState = shortCircuited ? null : traverser(lens.get)(state);
                return {
                    state: nextState,
                    traverser: lens.traversal ? function(f) {
                        return $c3e82e7ee6b9bc0f$export$871de8747c9eaa88(traverser(f));
                    } : traverser,
                    shortCircuited: shortCircuited || lens.optional && (nextState === null || nextState === undefined)
                };
            }, {
                state: obj,
                traverser: function traverser(x) {
                    return x;
                },
                shortCircuited: false
            }).state;
        },
        mod: function mod(f) {
            return function(obj) {
                var aux;
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                return aux = function aux(object, lenses) {
                    var _lenses, first, rest;
                    return _lenses = $c3e82e7ee6b9bc0f$var$_toArray(lenses), first = _lenses[0], rest = _lenses.slice(1), rest.length === 0 ? first.mod(f).apply(void 0, [
                        object
                    ].concat(params)) : first.mod(function(obj) {
                        return aux(obj, rest);
                    }).apply(void 0, [
                        object
                    ].concat(params));
                }, aux(obj, lenses.map($c3e82e7ee6b9bc0f$export$21cde5187c2605a3));
            };
        }
    };
};
var $c3e82e7ee6b9bc0f$export$3988ae62b71be9a3 = function get() {
    return $c3e82e7ee6b9bc0f$export$f672e0b6f7222cd7.apply(void 0, arguments).get;
};
var $c3e82e7ee6b9bc0f$export$a4f4bb6b1453fff5 = function has(pattern) {
    return function(obj) {
        return pattern && $c3e82e7ee6b9bc0f$var$_typeof(pattern) === 'object' ? !!obj && $c3e82e7ee6b9bc0f$export$7ecc1a3b11b57dab(Object.keys(pattern).map(function(key) {
            return has($c3e82e7ee6b9bc0f$export$3988ae62b71be9a3(key)(pattern))($c3e82e7ee6b9bc0f$var$bindingGet(key)(obj));
        })) : typeof pattern === 'function' ? pattern(obj) : pattern === obj;
    };
};
var $c3e82e7ee6b9bc0f$export$f517ea36c68d4644 = function greaterThan(a) {
    return function(b) {
        return b > a;
    };
};
var $c3e82e7ee6b9bc0f$export$9b050841a3a1b328 = function lessThan(a) {
    return function(b) {
        return b < a;
    };
};
var $c3e82e7ee6b9bc0f$export$36aa029c34b83c19 = function greaterThanEq(a) {
    return function(b) {
        return b >= a;
    };
};
var $c3e82e7ee6b9bc0f$export$859c4b8b8840d9a3 = function lessThanEq(a) {
    return function(b) {
        return b <= a;
    };
};
var $c3e82e7ee6b9bc0f$export$e03c1c3201ee8bb7 = function toggle(bool) {
    return !bool;
};
var $c3e82e7ee6b9bc0f$export$42b74c557bc9df8 = function returns(val) {
    return function(f) {
        return f() === val;
    };
};
var $c3e82e7ee6b9bc0f$var$bindingGet = function bindingGet(key) {
    return function(pattern) {
        var v;
        return v = $c3e82e7ee6b9bc0f$export$3988ae62b71be9a3(key)(pattern), typeof v === 'function' ? v.bind(pattern) : v;
    };
};
var $c3e82e7ee6b9bc0f$export$a6cdc56e425d0d0a = function isObject(x) {
    return $c3e82e7ee6b9bc0f$var$_typeof(x) === 'object' && !Array.isArray(x) && x !== null;
};
var $c3e82e7ee6b9bc0f$export$2fb7a00a48619649 = function isValue(x) {
    return x !== null && x !== undefined;
};
var $c3e82e7ee6b9bc0f$export$cd7b322347cd567b = function into(f) {
    return typeof f === 'function' ? f : $c3e82e7ee6b9bc0f$var$_typeof(f) === 'object' ? $c3e82e7ee6b9bc0f$export$a4f4bb6b1453fff5(f) : $c3e82e7ee6b9bc0f$export$3988ae62b71be9a3(f);
};
var $c3e82e7ee6b9bc0f$export$f0954fd7d5368655 = function identity(a) {
    return a;
};
var $c3e82e7ee6b9bc0f$export$8a83211c878a3f1f = function flip(f) {
    return function(a) {
        return function(b) {
            return f(b)(a);
        };
    };
};
var $c3e82e7ee6b9bc0f$export$ba9e5d519bc326ca = function always(a) {
    return function(b) {
        return a;
    };
};
var $c3e82e7ee6b9bc0f$export$6003a5f097c73977 = function not(f) {
    return function() {
        return !$c3e82e7ee6b9bc0f$export$cd7b322347cd567b(f).apply(void 0, arguments);
    };
};
var $c3e82e7ee6b9bc0f$export$21c0ac7fe1cef1b8 = function and() {
    for(var _len = arguments.length, fs = new Array(_len), _key = 0; _key < _len; _key++)fs[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return fs.reduce(function(acc, f) {
            return acc && f.apply(void 0, args);
        }, true);
    };
};
var $c3e82e7ee6b9bc0f$export$252bb8b3bbdf6749 = function or() {
    for(var _len3 = arguments.length, fs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)fs[_key3] = arguments[_key3];
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return fs.reduce(function(acc, f) {
            return acc || f.apply(void 0, args);
        }, false);
    };
};
var $c3e82e7ee6b9bc0f$export$c3095a23b368d1f2 = function curry(n) {
    return function(f) {
        return $c3e82e7ee6b9bc0f$var$_curry(n, f);
    };
};
function $c3e82e7ee6b9bc0f$var$_curry(n, f) {
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return function(arg) {
        return n ? $c3e82e7ee6b9bc0f$var$_curry(n, f, $c3e82e7ee6b9bc0f$export$8327ebbef2a0ba76(arg)(args)) : f.apply(void 0, $c3e82e7ee6b9bc0f$var$_toConsumableArray(args));
    };
}
var $c3e82e7ee6b9bc0f$export$e16d8520af44a096 = function add(a) {
    return function(b) {
        return a + b;
    };
};
var $c3e82e7ee6b9bc0f$export$f93b5905241a7cca = function sub(a) {
    return function(b) {
        return b - a;
    };
};
var $c3e82e7ee6b9bc0f$export$64d41e6bd9c791f3 = function inc(num) {
    return num + 1;
};
var $c3e82e7ee6b9bc0f$export$732526d242a38a7f = function dec(num) {
    return num - 1;
};
var $c3e82e7ee6b9bc0f$export$ee2e0f811dca1807 = function includes(snippet) {
    return function(text) {
        return text.includes(snippet);
    };
};
var $c3e82e7ee6b9bc0f$export$e41e96bb88700ba3 = function includesi(snippet) {
    return function(text) {
        return text.toLowerCase().includes(snippet.toLowerCase());
    };
};
var $c3e82e7ee6b9bc0f$export$52dcd5ad4274e359 = function foldOf(f) {
    return function(field) {
        var getter = $c3e82e7ee6b9bc0f$export$cd7b322347cd567b(field);
        return function(acc, curr) {
            return f(acc, curr, getter);
        };
    };
};
var $c3e82e7ee6b9bc0f$export$75e12408367c5187 = $c3e82e7ee6b9bc0f$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) > getter(acc) ? curr : acc;
});
var $c3e82e7ee6b9bc0f$export$8ee782a1d8add48c = $c3e82e7ee6b9bc0f$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) < getter(acc) ? curr : acc;
});
var $c3e82e7ee6b9bc0f$export$42468c76f380d4d8 = $c3e82e7ee6b9bc0f$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(acc) ? acc : getter(curr) ? curr : null;
});
var $c3e82e7ee6b9bc0f$export$226773add4f378f5 = $c3e82e7ee6b9bc0f$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) + (typeof acc === 'number' ? acc : getter(acc));
});
var $c3e82e7ee6b9bc0f$export$7be5941944569cfd = $c3e82e7ee6b9bc0f$export$52dcd5ad4274e359(function(acc, curr, getter) {
    return getter(curr) * (typeof acc === 'number' ? acc : getter(acc));
});
var $c3e82e7ee6b9bc0f$export$842a2cf37af977e1 = function mod() {
    return $c3e82e7ee6b9bc0f$export$f672e0b6f7222cd7.apply(void 0, arguments).mod;
};
var $c3e82e7ee6b9bc0f$export$adaa4cf7ef1b65be = function set() {
    for(var _len = arguments.length, lenses = new Array(_len), _key = 0; _key < _len; _key++)lenses[_key] = arguments[_key];
    return function(newValue) {
        return $c3e82e7ee6b9bc0f$export$f672e0b6f7222cd7.apply(void 0, lenses).mod($c3e82e7ee6b9bc0f$export$ba9e5d519bc326ca(newValue));
    };
};
var $c3e82e7ee6b9bc0f$export$ba4f22f061f42309 = function matching(pred) {
    var predFxn = $c3e82e7ee6b9bc0f$export$cd7b322347cd567b(pred);
    return {
        get: $c3e82e7ee6b9bc0f$export$3dea766d36a8935f(predFxn),
        mod: function mod(f) {
            return $c3e82e7ee6b9bc0f$export$871de8747c9eaa88(function(n) {
                return predFxn(n) ? f(n) : n;
            });
        },
        traversal: true
    };
};
var $c3e82e7ee6b9bc0f$var$all = function all() {
    return {
        get: $c3e82e7ee6b9bc0f$export$f0954fd7d5368655,
        mod: $c3e82e7ee6b9bc0f$export$871de8747c9eaa88,
        traversal: true
    };
};
var $c3e82e7ee6b9bc0f$export$84bf76cd7afc7469 = Object.assign($c3e82e7ee6b9bc0f$var$all, $c3e82e7ee6b9bc0f$var$all());
var $c3e82e7ee6b9bc0f$export$6f0673371501d6b6 = function(pred) {
    return $c3e82e7ee6b9bc0f$export$ba4f22f061f42309($c3e82e7ee6b9bc0f$export$6003a5f097c73977(pred));
};
var $c3e82e7ee6b9bc0f$export$443b903547e5c42d = function updateAll() {
    for(var _len = arguments.length, updaters = new Array(_len), _key = 0; _key < _len; _key++)updaters[_key] = arguments[_key];
    return function(state) {
        return updaters.reduce(function(currState, transformer) {
            return transformer(currState);
        }, state);
    };
};
var $c3e82e7ee6b9bc0f$var$withOf = function withOf(f) {
    f.of = f;
    return f;
};
var $c3e82e7ee6b9bc0f$export$2a12373211ef4ed4 = function foldBy(reducer) {
    return function(field) {
        return $c3e82e7ee6b9bc0f$export$21cde5187c2605a3({
            get: $c3e82e7ee6b9bc0f$export$533b26079ad0b4b(reducer(field)),
            mod: function mod(f) {
                return function(obj) {
                    var matching = $c3e82e7ee6b9bc0f$export$533b26079ad0b4b(reducer(field))(obj);
                    return $c3e82e7ee6b9bc0f$export$871de8747c9eaa88(function(item) {
                        return item === matching ? f(item) : item;
                    })(obj);
                };
            }
        });
    };
};
var $c3e82e7ee6b9bc0f$export$63d5f59f45ab3135 = $c3e82e7ee6b9bc0f$var$withOf($c3e82e7ee6b9bc0f$export$2a12373211ef4ed4($c3e82e7ee6b9bc0f$export$42468c76f380d4d8));
var $c3e82e7ee6b9bc0f$export$ad1963a493908da4 = $c3e82e7ee6b9bc0f$var$withOf($c3e82e7ee6b9bc0f$export$2a12373211ef4ed4($c3e82e7ee6b9bc0f$export$75e12408367c5187));
var $c3e82e7ee6b9bc0f$export$8c826aa0fa59ac68 = $c3e82e7ee6b9bc0f$var$withOf($c3e82e7ee6b9bc0f$export$2a12373211ef4ed4($c3e82e7ee6b9bc0f$export$8ee782a1d8add48c));
var $c3e82e7ee6b9bc0f$export$f8b8b9ce72e9ccbf = function(name) {
    var base = $c3e82e7ee6b9bc0f$var$attr(name);
    return $c3e82e7ee6b9bc0f$export$21cde5187c2605a3({
        get: function get(obj) {
            return obj && base.get(obj);
        },
        mod: function mod(f) {
            return function(obj) {
                return obj && base.get(obj) ? base.mod(f)(obj) : obj;
            };
        },
        optional: true
    });
};
var $c3e82e7ee6b9bc0f$export$a1eaec3f779505d4 = function valueOr(def) {
    return $c3e82e7ee6b9bc0f$export$21cde5187c2605a3({
        get: function get(val) {
            return $c3e82e7ee6b9bc0f$export$2fb7a00a48619649(val) ? val : def;
        },
        mod: function mod(fn) {
            return function(val) {
                return $c3e82e7ee6b9bc0f$export$2fb7a00a48619649(val) ? fn(val) : fn(def);
            };
        }
    });
};
var $c3e82e7ee6b9bc0f$export$9563e054e6f787fb = function fill(filling) {
    return function(obj) {
        var out = $c3e82e7ee6b9bc0f$var$_objectSpread2({}, obj);
        Object.entries(filling).forEach(function(_ref) {
            var _ref2 = $c3e82e7ee6b9bc0f$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
            out[key] = $c3e82e7ee6b9bc0f$export$2fb7a00a48619649(out[key]) ? out[key] : value;
            if (out.hasOwnProperty(key)) {
                if ($c3e82e7ee6b9bc0f$export$a6cdc56e425d0d0a(out[key]) && $c3e82e7ee6b9bc0f$export$a6cdc56e425d0d0a(value)) out[key] = fill(value)(obj[key]);
            }
        });
        return out;
    };
};

});


parcelRegister("6zcWp", function(module, exports) {
"use strict";
var $4c800ccc0d232807$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4c800ccc0d232807$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LensComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-lens
 */ let $4c800ccc0d232807$var$LensComponent = class LensComponent extends $4TeKW.LitElement {
    constructor(){
        super(...arguments);
        this.ray = (res)=>res;
    }
};
$4c800ccc0d232807$var$__decorate([
    (0, $4TeKW.property)({
        type: String
    }),
    $4c800ccc0d232807$var$__metadata("design:type", String)
], $4c800ccc0d232807$var$LensComponent.prototype, "match", void 0);
$4c800ccc0d232807$var$__decorate([
    (0, $4TeKW.property)({
        type: Array
    }),
    $4c800ccc0d232807$var$__metadata("design:type", Array)
], $4c800ccc0d232807$var$LensComponent.prototype, "get", void 0);
$4c800ccc0d232807$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $4c800ccc0d232807$var$__metadata("design:type", Function)
], $4c800ccc0d232807$var$LensComponent.prototype, "ray", void 0);
$4c800ccc0d232807$var$LensComponent = $4c800ccc0d232807$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-lens'
    })
], $4c800ccc0d232807$var$LensComponent);
module.exports.LensComponent = $4c800ccc0d232807$var$LensComponent;

});

parcelRegister("498qP", function(module, exports) {
"use strict";
var $304e8b0d57a20578$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $304e8b0d57a20578$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SettingsComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-settings
 */ let $304e8b0d57a20578$var$SettingsComponent = class SettingsComponent extends $4TeKW.LitElement {
};
$304e8b0d57a20578$var$__decorate([
    (0, $4TeKW.property)({
        type: Object
    }),
    $304e8b0d57a20578$var$__metadata("design:type", Object)
], $304e8b0d57a20578$var$SettingsComponent.prototype, "value", void 0);
$304e8b0d57a20578$var$SettingsComponent = $304e8b0d57a20578$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-settings'
    })
], $304e8b0d57a20578$var$SettingsComponent);
module.exports.SettingsComponent = $304e8b0d57a20578$var$SettingsComponent;

});

parcelRegister("78cSx", function(module, exports) {
"use strict";
var $5313453687c9797d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5313453687c9797d$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StateComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-state
 */ let $5313453687c9797d$var$StateComponent = class StateComponent extends $4TeKW.LitElement {
};
$5313453687c9797d$var$__decorate([
    (0, $4TeKW.property)(),
    $5313453687c9797d$var$__metadata("design:type", Object)
], $5313453687c9797d$var$StateComponent.prototype, "value", void 0);
$5313453687c9797d$var$StateComponent = $5313453687c9797d$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-state'
    })
], $5313453687c9797d$var$StateComponent);
module.exports.StateComponent = $5313453687c9797d$var$StateComponent;

});

parcelRegister("d1the", function(module, exports) {
"use strict";
var $97b214278ebce6b7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $97b214278ebce6b7$var$__metadata = module.exports && module.exports.__metadata || function(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StyleComponent = void 0;

var $4TeKW = parcelRequire("4TeKW");
/**
 * @customElement rx-style
 */ let $97b214278ebce6b7$var$StyleComponent = class StyleComponent extends $4TeKW.LitElement {
};
$97b214278ebce6b7$var$__decorate([
    (0, $4TeKW.property)(),
    $97b214278ebce6b7$var$__metadata("design:type", Object)
], $97b214278ebce6b7$var$StyleComponent.prototype, "value", void 0);
$97b214278ebce6b7$var$StyleComponent = $97b214278ebce6b7$var$__decorate([
    (0, $4TeKW.Component)({
        selector: 'rx-style'
    })
], $97b214278ebce6b7$var$StyleComponent);
module.exports.StyleComponent = $97b214278ebce6b7$var$StyleComponent;

});


parcelRegister("52DKO", function(module, exports) {
"use strict";
var $3abbf9ffa77eea07$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3abbf9ffa77eea07$var$GraphModule_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphModule = void 0;

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $hS6oR = parcelRequire("hS6oR");

var $fl2ji = parcelRequire("fl2ji");
let $3abbf9ffa77eea07$var$GraphModule = $3abbf9ffa77eea07$var$GraphModule_1 = class GraphModule {
    static forRoot(config, defaults = {}) {
        return {
            module: $3abbf9ffa77eea07$var$GraphModule_1,
            components: [
                $hS6oR.GraphComponent
            ],
            providers: [
                {
                    provide: $fl2ji.DEFAULTS,
                    useValue: defaults
                }
            ],
            frameworkImports: [
                $2O1GU.GraphqlModule.forRoot(config)
            ]
        };
    }
};
$3abbf9ffa77eea07$var$GraphModule = $3abbf9ffa77eea07$var$GraphModule_1 = $3abbf9ffa77eea07$var$__decorate([
    (0, $1t8Wn.Module)()
], $3abbf9ffa77eea07$var$GraphModule);
module.exports.GraphModule = $3abbf9ffa77eea07$var$GraphModule;

});

parcelRegister("dP0ks", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("7GVDC", function(module, exports) {
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode('');
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== 'undefined') {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ('document' in global1 && 'onreadystatechange' in global1.document.createElement('script')) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement('script');
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    'REJECTED'
                ];
                var FULFILLED = [
                    'FULFILLED'
                ];
                var PENDING = [
                    'PENDING'
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== 'function') throw new TypeError('resolver must be a function');
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === 'function') {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === 'function') {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === 'error') return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === 'error') onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = 'success';
                    } catch (e) {
                        out.status = 'error';
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    if (typeof global1.Promise !== 'function') global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== 'undefined') return indexedDB;
                        if (typeof webkitIndexedDB !== 'undefined') return webkitIndexedDB;
                        if (typeof mozIndexedDB !== 'undefined') return mozIndexedDB;
                        if (typeof OIndexedDB !== 'undefined') return OIndexedDB;
                        if (typeof msIndexedDB !== 'undefined') return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== 'undefined';
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== 'TypeError') throw e;
                        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === 'undefined') // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === 'function') promise.then(callback);
                    if (typeof errorCallback === 'function') promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== 'string') {
                        console.warn(key + ' used as a key, but it is not a string.');
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = 'readonly';
                var READ_WRITE = 'readwrite';
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ''
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === 'boolean') return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === 'ConstraintError') console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || '');
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === '[object Blob]') return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: 'asyncStorage',
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === 'function';
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var BLOB_TYPE_PREFIX = '~~local_forage_type~';
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = '__lfsc__:';
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = 'arbf';
                var TYPE_BLOB = 'blob';
                var TYPE_INT8ARRAY = 'si08';
                var TYPE_UINT8ARRAY = 'ui08';
                var TYPE_UINT8CLAMPEDARRAY = 'uic8';
                var TYPE_INT16ARRAY = 'si16';
                var TYPE_INT32ARRAY = 'si32';
                var TYPE_UINT16ARRAY = 'ur16';
                var TYPE_UINT32ARRAY = 'ui32';
                var TYPE_FLOAT32ARRAY = 'fl32';
                var TYPE_FLOAT64ARRAY = 'fl64';
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === '=') {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === '=') bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = '';
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + '=';
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + '==';
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = '';
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === '[object Int8Array]') marker += TYPE_INT8ARRAY;
                            else if (valueType === '[object Uint8Array]') marker += TYPE_UINT8ARRAY;
                            else if (valueType === '[object Uint8ClampedArray]') marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === '[object Int16Array]') marker += TYPE_INT16ARRAY;
                            else if (valueType === '[object Uint16Array]') marker += TYPE_UINT16ARRAY;
                            else if (valueType === '[object Int32Array]') marker += TYPE_INT32ARRAY;
                            else if (valueType === '[object Uint32Array]') marker += TYPE_UINT32ARRAY;
                            else if (valueType === '[object Float32Array]') marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === '[object Float64Array]') marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error('Failed to get type for BinaryArray'));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === '[object Blob]') {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error('Unkown type: ' + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, '', '', 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: 'webSQLStorage',
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + '/';
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + '/';
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = '_localforage_support_test';
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + '/');
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: 'localStorageWrapper',
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === '[object Array]';
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    'dropInstance'
                ];
                var LibraryMethods = [
                    'clear',
                    'getItem',
                    'iterate',
                    'key',
                    'keys',
                    'length',
                    'removeItem',
                    'setItem'
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: '',
                    driver: DefaultDriverOrder.slice(),
                    name: 'localforage',
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: 'keyvaluepairs',
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === 'storeName') options[i] = options[i].replace(/\W/g, '_');
                                if (i === 'version' && typeof options[i] !== 'number') return new Error('Database version must be a number.');
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ('driver' in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === 'string') return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat('_initStorage');
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info('Redefining LocalForage driver: ' + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ('_support' in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === 'function') driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error('No available storage method found.');
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error('No available storage method found.');
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("2N8YZ", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("dJ7PV"))(import.meta.resolve("319uT")),
    import("cjlIH")
]).then(()=>parcelRequire('aZknp'));

});
parcelRegister("dJ7PV", function(module, exports) {
"use strict";

var $9REzA = parcelRequire("9REzA");
module.exports = $9REzA(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("9REzA", function(module, exports) {
"use strict";
var $72e8893e666e97bf$var$cachedBundles = {};
var $72e8893e666e97bf$var$cachedPreloads = {};
var $72e8893e666e97bf$var$cachedPrefetches = {};
function $72e8893e666e97bf$var$getCache(type) {
    switch(type){
        case 'preload':
            return $72e8893e666e97bf$var$cachedPreloads;
        case 'prefetch':
            return $72e8893e666e97bf$var$cachedPrefetches;
        default:
            return $72e8893e666e97bf$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $72e8893e666e97bf$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $bQvnf = parcelRequire("bQvnf");

var $7lFX5 = parcelRequire("7lFX5");

var $1t8Wn = parcelRequire("1t8Wn");

var $9fktW = parcelRequire("9fktW");
/** Prefix for logging strings */ const $5e86e2077273f401$var$PREFIX = 'Sentry Logger ';
const $5e86e2077273f401$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $5e86e2077273f401$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $9fktW.GLOBAL_OBJ))) return callback();
    const originalConsole = (0, $9fktW.GLOBAL_OBJ).console;
    const wrappedLevels = {};
    // Restore all wrapped console methods
    $5e86e2077273f401$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $5e86e2077273f401$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $5e86e2077273f401$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $5e86e2077273f401$export$cda52e2a8927a2ca(()=>{
                (0, $9fktW.GLOBAL_OBJ).console[name](`${$5e86e2077273f401$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $5e86e2077273f401$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $5e86e2077273f401$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $5e86e2077273f401$export$af88d00dbe7f521 = (0, $9fktW.getGlobalSingleton)('logger', $5e86e2077273f401$var$makeLogger);
else $5e86e2077273f401$export$af88d00dbe7f521 = $5e86e2077273f401$var$makeLogger();


var $crd5F = parcelRequire("crd5F");
var $9fktW = parcelRequire("9fktW");
var $fWOqV = parcelRequire("fWOqV");// eslint-disable-next-line @typescript-eslint/unbound-method
const $36d5b4e82d3fe8cc$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$e6127cc7fe7395c3(wat) {
    switch($36d5b4e82d3fe8cc$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $36d5b4e82d3fe8cc$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$var$isBuiltin(wat, className) {
    return $36d5b4e82d3fe8cc$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$9f9636d330b71954(wat) {
    return $36d5b4e82d3fe8cc$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$ef9e2056653f0c8e(wat) {
    return $36d5b4e82d3fe8cc$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$12e869b2a583f783(wat) {
    return $36d5b4e82d3fe8cc$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$844ec244b1367d54(wat) {
    return $36d5b4e82d3fe8cc$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$53b83ca8eaab0383(wat) {
    return $36d5b4e82d3fe8cc$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $36d5b4e82d3fe8cc$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $36d5b4e82d3fe8cc$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$49841c62b9eff15(wat) {
    return $36d5b4e82d3fe8cc$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $36d5b4e82d3fe8cc$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$bc2894c7158efbac(wat) {
    return $36d5b4e82d3fe8cc$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $36d5b4e82d3fe8cc$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}



var $9fktW = parcelRequire("9fktW");
// eslint-disable-next-line deprecation/deprecation
const $1c622875a291eb2b$var$WINDOW = (0, $9fktW.getGlobalObject)();
const $1c622875a291eb2b$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1c622875a291eb2b$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1c622875a291eb2b$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1c622875a291eb2b$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1c622875a291eb2b$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $36d5b4e82d3fe8cc$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $1c622875a291eb2b$export$1cfafeee2987818b() {
    try {
        return $1c622875a291eb2b$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c622875a291eb2b$export$c660c1f3ab49225c(selector) {
    if ($1c622875a291eb2b$var$WINDOW.document && $1c622875a291eb2b$var$WINDOW.document.querySelector) return $1c622875a291eb2b$var$WINDOW.document.querySelector(selector);
    return null;
}




/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e92bed95d72e6528$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e92bed95d72e6528$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e92bed95d72e6528$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e92bed95d72e6528$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $36d5b4e82d3fe8cc$export$844ec244b1367d54)(value)) return false;
    if ((0, $36d5b4e82d3fe8cc$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $36d5b4e82d3fe8cc$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e92bed95d72e6528$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e92bed95d72e6528$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ function $e92bed95d72e6528$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $d2095ac82d3e5999$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $d2095ac82d3e5999$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $d2095ac82d3e5999$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $d2095ac82d3e5999$export$5c1499e2e5d010ae(wrapped, original) {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $d2095ac82d3e5999$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $d2095ac82d3e5999$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $d2095ac82d3e5999$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $d2095ac82d3e5999$export$62ff257738bf57f5(value) {
    if ((0, $36d5b4e82d3fe8cc$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$d2095ac82d3e5999$var$getOwnProperties(value)
    };
    else if ((0, $36d5b4e82d3fe8cc$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $d2095ac82d3e5999$var$serializeEventTarget(value.target),
            currentTarget: $d2095ac82d3e5999$var$serializeEventTarget(value.currentTarget),
            ...$d2095ac82d3e5999$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $36d5b4e82d3fe8cc$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $d2095ac82d3e5999$var$serializeEventTarget(target) {
    try {
        return (0, $36d5b4e82d3fe8cc$export$45a5e7f76e0caa8d)(target) ? (0, $1c622875a291eb2b$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $d2095ac82d3e5999$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $d2095ac82d3e5999$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($d2095ac82d3e5999$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $e92bed95d72e6528$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $e92bed95d72e6528$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $d2095ac82d3e5999$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $d2095ac82d3e5999$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $d2095ac82d3e5999$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $36d5b4e82d3fe8cc$export$53b83ca8eaab0383)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $d2095ac82d3e5999$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($d2095ac82d3e5999$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $d2095ac82d3e5999$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $36d5b4e82d3fe8cc$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




var $9fktW = parcelRequire("9fktW");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $ebd44ecf67fae0f0$export$19f53698e68b2496() {
    const gbl = (0, $9fktW.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    const getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $ebd44ecf67fae0f0$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $ebd44ecf67fae0f0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $ebd44ecf67fae0f0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $ebd44ecf67fae0f0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $ebd44ecf67fae0f0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $ebd44ecf67fae0f0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $ebd44ecf67fae0f0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $ebd44ecf67fae0f0$export$d364f2020ab30578(input) {
    const match = input.match($ebd44ecf67fae0f0$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $ebd44ecf67fae0f0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $e92bed95d72e6528$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $e92bed95d72e6528$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $e92bed95d72e6528$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $ebd44ecf67fae0f0$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $d2095ac82d3e5999$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $ebd44ecf67fae0f0$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $cc762552b072a285$export$849dbeeeda01ae98 = 'production';



var $crd5F = parcelRequire("crd5F");
var $9fktW = parcelRequire("9fktW");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $d18f33e59a561b5c$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($d18f33e59a561b5c$var$States || ($d18f33e59a561b5c$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $d18f33e59a561b5c$export$1fda8aa4d135f8aa(value) {
    return new $d18f33e59a561b5c$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $d18f33e59a561b5c$export$78e43115b553f358(reason) {
    return new $d18f33e59a561b5c$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $d18f33e59a561b5c$export$6f292d4960313241 {
    __init() {
        this._state = $d18f33e59a561b5c$var$States.PENDING;
    }
    __init2() {
        this._handlers = [];
    }
    constructor(executor){
        $d18f33e59a561b5c$export$6f292d4960313241.prototype.__init.call(this);
        $d18f33e59a561b5c$export$6f292d4960313241.prototype.__init2.call(this);
        $d18f33e59a561b5c$export$6f292d4960313241.prototype.__init3.call(this);
        $d18f33e59a561b5c$export$6f292d4960313241.prototype.__init4.call(this);
        $d18f33e59a561b5c$export$6f292d4960313241.prototype.__init5.call(this);
        $d18f33e59a561b5c$export$6f292d4960313241.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $d18f33e59a561b5c$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $d18f33e59a561b5c$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init3() {
        this._resolve = (value)=>{
            this._setResult($d18f33e59a561b5c$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init4() {
        this._reject = (reason)=>{
            this._setResult($d18f33e59a561b5c$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init5() {
        this._setResult = (state, value)=>{
            if (this._state !== $d18f33e59a561b5c$var$States.PENDING) return;
            if ((0, $36d5b4e82d3fe8cc$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init6() {
        this._executeHandlers = ()=>{
            if (this._state === $d18f33e59a561b5c$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $d18f33e59a561b5c$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $d18f33e59a561b5c$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



var $crd5F = parcelRequire("crd5F");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $6dcc3646f7b2578b$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $crd5F.timestampInSeconds)();
    const session = {
        sid: (0, $ebd44ecf67fae0f0$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$6dcc3646f7b2578b$var$sessionToJSON(session)
    };
    if (context) $6dcc3646f7b2578b$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $6dcc3646f7b2578b$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $crd5F.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $ebd44ecf67fae0f0$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $6dcc3646f7b2578b$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $6dcc3646f7b2578b$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $6dcc3646f7b2578b$var$sessionToJSON(session) {
    return (0, $d2095ac82d3e5999$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2e26acc76f08a355$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $2e26acc76f08a355$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $2e26acc76f08a355$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $6dcc3646f7b2578b$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $2e26acc76f08a355$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $2e26acc76f08a355$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $36d5b4e82d3fe8cc$export$53b83ca8eaab0383)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $2e26acc76f08a355$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $crd5F.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = {
                transaction: transactionName,
                ...event.tags
            };
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata
        };
        return this._notifyEventProcessors([
            ...$2e26acc76f08a355$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $d18f33e59a561b5c$export$6f292d4960313241)((resolve, reject)=>{
            const processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                const result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && processor.id && result === null && (0, $5e86e2077273f401$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $36d5b4e82d3fe8cc$export$f5b060c2914b97c8)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $ebd44ecf67fae0f0$export$3131421a7d01b4fb)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $2e26acc76f08a355$var$getGlobalEventProcessors() {
    return (0, $9fktW.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $2e26acc76f08a355$export$8e4e25f54d456511(callback) {
    $2e26acc76f08a355$var$getGlobalEventProcessors().push(callback);
}



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $45bbacb34c7eee9d$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $45bbacb34c7eee9d$var$DEFAULT_BREADCRUMBS = 100;
/**
 * A layer in the process stack.
 * @hidden
 */ /**
 * @inheritDoc
 */ class $45bbacb34c7eee9d$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ __init() {
        this._stack = [
            {}
        ];
    }
    /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $2e26acc76f08a355$export$775b6bb06e53a214)(), _version = $45bbacb34c7eee9d$export$24a86ef7798177e4){
        this._version = _version;
        $45bbacb34c7eee9d$export$8c41bb232f1008b1.prototype.__init.call(this);
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $2e26acc76f08a355$export$775b6bb06e53a214).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $ebd44ecf67fae0f0$export$19f53698e68b2496)();
        const syntheticException = new Error('Sentry syntheticException');
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $ebd44ecf67fae0f0$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $ebd44ecf67fae0f0$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!scope || !client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $45bbacb34c7eee9d$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $crd5F.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $5e86e2077273f401$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        const scope = this.getScope();
        if (scope) scope.setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        const scope = this.getScope();
        if (scope) scope.setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        const scope = this.getScope();
        if (scope) scope.setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        const scope = this.getScope();
        if (scope) scope.setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        const scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        const scope = this.getScope();
        if (scope) scope.setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (scope && client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $45bbacb34c7eee9d$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $45bbacb34c7eee9d$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer && layer.scope;
        const session = scope && scope.getSession();
        if (session) (0, $6dcc3646f7b2578b$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $cc762552b072a285$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $9fktW.GLOBAL_OBJ).navigator || {};
        const session = (0, $6dcc3646f7b2578b$export$14a186326edbb264)({
            release: release,
            environment: environment,
            ...scope && {
                user: scope.getUser()
            },
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        if (scope) {
            // End existing session if there's one
            const currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') (0, $6dcc3646f7b2578b$export$531818e825e774db)(currentSession, {
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        if (!scope) return;
        const session = scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $45bbacb34c7eee9d$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $45bbacb34c7eee9d$export$19eade501500c6c1() {
    (0, $9fktW.GLOBAL_OBJ).__SENTRY__ = (0, $9fktW.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $9fktW.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $45bbacb34c7eee9d$export$4188a14ad302d1bc(hub) {
    const registry = $45bbacb34c7eee9d$export$19eade501500c6c1();
    const oldHub = $45bbacb34c7eee9d$export$bfa8a924a84a76b7(registry);
    $45bbacb34c7eee9d$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $45bbacb34c7eee9d$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $45bbacb34c7eee9d$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$45bbacb34c7eee9d$var$hasHubOnCarrier(registry) || $45bbacb34c7eee9d$export$bfa8a924a84a76b7(registry).isOlderThan($45bbacb34c7eee9d$export$24a86ef7798177e4)) $45bbacb34c7eee9d$export$849f05434e95d2f2(registry, new $45bbacb34c7eee9d$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $fWOqV.isNodeEnv)()) return $45bbacb34c7eee9d$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $45bbacb34c7eee9d$export$bfa8a924a84a76b7(registry);
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $45bbacb34c7eee9d$var$getHubFromActiveDomain(registry) {
    try {
        const sentry = $45bbacb34c7eee9d$export$19eade501500c6c1().__SENTRY__;
        const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $45bbacb34c7eee9d$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$45bbacb34c7eee9d$var$hasHubOnCarrier(activeDomain) || $45bbacb34c7eee9d$export$bfa8a924a84a76b7(activeDomain).isOlderThan($45bbacb34c7eee9d$export$24a86ef7798177e4)) {
            const registryHubTopStack = $45bbacb34c7eee9d$export$bfa8a924a84a76b7(registry).getStackTop();
            $45bbacb34c7eee9d$export$849f05434e95d2f2(activeDomain, new $45bbacb34c7eee9d$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $2e26acc76f08a355$export$775b6bb06e53a214).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $45bbacb34c7eee9d$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $45bbacb34c7eee9d$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $45bbacb34c7eee9d$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $45bbacb34c7eee9d$export$bfa8a924a84a76b7(carrier) {
    return (0, $9fktW.getGlobalSingleton)('hub', ()=>new $45bbacb34c7eee9d$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $45bbacb34c7eee9d$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




const $35674e6cecc7a491$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $35674e6cecc7a491$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $35674e6cecc7a491$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $ebd44ecf67fae0f0$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $35674e6cecc7a491$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $35674e6cecc7a491$export$51abed9797baa598(integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $35674e6cecc7a491$export$e7390a03b70a6f2f(integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $35674e6cecc7a491$export$e7390a03b70a6f2f(integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    if ($35674e6cecc7a491$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        integration.setupOnce((0, $2e26acc76f08a355$export$8e4e25f54d456511), (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c));
        $35674e6cecc7a491$export$b14a8888f80a0b3e.push(integration.name);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
    }
}

/** An error emitted by Sentry SDKs and related utilities. */ class $8582b90aa2262557$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}


/** Regular expression used to parse a Dsn. */ const $c359a1b3b6dd7ea2$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $c359a1b3b6dd7ea2$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $c359a1b3b6dd7ea2$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */ function $c359a1b3b6dd7ea2$export$b892860177f70a30(str) {
    const match = $c359a1b3b6dd7ea2$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: ${str}`);
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $c359a1b3b6dd7ea2$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $c359a1b3b6dd7ea2$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $c359a1b3b6dd7ea2$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) return;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach((component)=>{
        if (!dsn[component]) throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: ${component} missing`);
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    if (!$c359a1b3b6dd7ea2$var$isValidProtocol(protocol)) throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: Invalid port ${port}`);
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */ function $c359a1b3b6dd7ea2$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $c359a1b3b6dd7ea2$export$b892860177f70a30(from) : $c359a1b3b6dd7ea2$var$dsnFromComponents(from);
    $c359a1b3b6dd7ea2$var$validateDsn(components);
    return components;
}


const $1b19efd29196ef7b$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $1b19efd29196ef7b$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $1b19efd29196ef7b$var$_getIngestEndpoint(dsn) {
    return `${$1b19efd29196ef7b$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $1b19efd29196ef7b$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $d2095ac82d3e5999$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $1b19efd29196ef7b$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $1b19efd29196ef7b$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$1b19efd29196ef7b$var$_getIngestEndpoint(dsn)}?${$1b19efd29196ef7b$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $1b19efd29196ef7b$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $c359a1b3b6dd7ea2$export$128827c3562ec0cb)(dsnLike);
    const endpoint = `${$1b19efd29196ef7b$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $c359a1b3b6dd7ea2$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}



/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $f1e63da6d3e6770b$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) (0, $5e86e2077273f401$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    const hub = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    const client = new clientClass(options);
    hub.bindClient(client);
}

var $6779fccd8d1e1d09$exports = {};

$parcel$export($6779fccd8d1e1d09$exports, "FunctionToString", () => $a65ea21de3b26ead$export$da4704525c20ae79);
$parcel$export($6779fccd8d1e1d09$exports, "InboundFilters", () => $2907fd1c708c527a$export$2ffbb5359dcc6be4);

let $a65ea21de3b26ead$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $a65ea21de3b26ead$export$da4704525c20ae79 {
    constructor(){
        $a65ea21de3b26ead$export$da4704525c20ae79.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'FunctionToString';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $a65ea21de3b26ead$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $a65ea21de3b26ead$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function(...args) {
            const context = (0, $d2095ac82d3e5999$export$e6cc1e135e2092e5)(this) || this;
            return $a65ea21de3b26ead$var$originalFunctionToString.apply(context, args);
        };
    }
}
$a65ea21de3b26ead$export$da4704525c20ae79.__initStatic();



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $2907fd1c708c527a$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $2907fd1c708c527a$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'InboundFilters';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $2907fd1c708c527a$export$2ffbb5359dcc6be4.id;
    }
    constructor(_options = {}){
        this._options = _options;
        $2907fd1c708c527a$export$2ffbb5359dcc6be4.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcess = (event)=>{
            const hub = getCurrentHub();
            if (hub) {
                const self = hub.getIntegration($2907fd1c708c527a$export$2ffbb5359dcc6be4);
                if (self) {
                    const client = hub.getClient();
                    const clientOptions = client ? client.getOptions() : {};
                    const options = $2907fd1c708c527a$export$6620a151868b99aa(self._options, clientOptions);
                    return $2907fd1c708c527a$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        };
        eventProcess.id = this.name;
        addGlobalEventProcessor(eventProcess);
    }
}
$2907fd1c708c527a$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $2907fd1c708c527a$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...$2907fd1c708c527a$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $2907fd1c708c527a$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $2907fd1c708c527a$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $ebd44ecf67fae0f0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($2907fd1c708c527a$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $ebd44ecf67fae0f0$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($2907fd1c708c527a$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $ebd44ecf67fae0f0$export$4157119e2b157127)(event)}.\nUrl: ${$2907fd1c708c527a$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$2907fd1c708c527a$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $ebd44ecf67fae0f0$export$4157119e2b157127)(event)}.\nUrl: ${$2907fd1c708c527a$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $2907fd1c708c527a$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $2907fd1c708c527a$var$_getPossibleEventMessages(event).some((message)=>(0, $e92bed95d72e6528$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $2907fd1c708c527a$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $2907fd1c708c527a$var$_getEventFilterUrl(event);
    return !url ? false : (0, $e92bed95d72e6528$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $2907fd1c708c527a$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $2907fd1c708c527a$var$_getEventFilterUrl(event);
    return !url ? true : (0, $e92bed95d72e6528$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $2907fd1c708c527a$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        const { type: type = '', value: value = '' } = event.exception.values && event.exception.values[0] || {};
        return [
            `${value}`,
            `${type}: ${value}`
        ];
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error(`Cannot extract message for event ${(0, $ebd44ecf67fae0f0$export$4157119e2b157127)(event)}`);
        return [];
    }
    return [];
}
function $2907fd1c708c527a$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $2907fd1c708c527a$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $2907fd1c708c527a$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $2907fd1c708c527a$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $ebd44ecf67fae0f0$export$4157119e2b157127)(event)}`);
        return null;
    }
}







const $4a505a9ef49b467d$var$STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4a505a9ef49b467d$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        for (const line of stack.split('\n').slice(skipFirst)){
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = line.replace(/\(error: (.*)\)/, '$1');
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
        }
        return $4a505a9ef49b467d$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4a505a9ef49b467d$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4a505a9ef49b467d$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * @hidden
 */ function $4a505a9ef49b467d$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    let localStack = stack;
    const firstFrameFunction = localStack[0].function || '';
    const lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $4a505a9ef49b467d$var$STACKTRACE_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        })).reverse();
}
const $4a505a9ef49b467d$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4a505a9ef49b467d$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4a505a9ef49b467d$var$defaultFunctionName;
        return fn.name || $4a505a9ef49b467d$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4a505a9ef49b467d$var$defaultFunctionName;
    }
}
// eslint-disable-next-line complexity
function $4a505a9ef49b467d$var$node(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        const lineMatch = line.match(FULL_MATCH);
        if (!lineMatch) return undefined;
        let object;
        let method;
        let functionName;
        let typeName;
        let methodName;
        if (lineMatch[1]) {
            functionName = lineMatch[1];
            let methodStart = functionName.lastIndexOf('.');
            if (functionName[methodStart - 1] === '.') methodStart--;
            if (methodStart > 0) {
                object = functionName.slice(0, methodStart);
                method = functionName.slice(methodStart + 1);
                const objectEnd = object.indexOf('.Module');
                if (objectEnd > 0) {
                    functionName = functionName.slice(objectEnd + 1);
                    object = object.slice(0, objectEnd);
                }
            }
            typeName = undefined;
        }
        if (method) {
            typeName = object;
            methodName = method;
        }
        if (method === '<anonymous>') {
            methodName = undefined;
            functionName = undefined;
        }
        if (functionName === undefined) {
            methodName = methodName || '<anonymous>';
            functionName = typeName ? `${typeName}.${methodName}` : methodName;
        }
        const filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
        const isNative = lineMatch[5] === 'native';
        const isInternal = isNative || filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1;
        // in_app is all that's not an internal Node function or a module within node_modules
        // note that isNative appears to return true even for node core libraries
        // see https://github.com/getsentry/raven-node/issues/176
        const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');
        return {
            filename: filename,
            module: getModule ? getModule(filename) : undefined,
            function: functionName,
            lineno: parseInt(lineMatch[3], 10) || undefined,
            colno: parseInt(lineMatch[4], 10) || undefined,
            in_app: in_app
        };
    };
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $4a505a9ef49b467d$export$673345a0da635a78(getModule) {
    return [
        90,
        $4a505a9ef49b467d$var$node(getModule)
    ];
}




var $9fktW = parcelRequire("9fktW");
// eslint-disable-next-line deprecation/deprecation
const $e16a962b14cdc560$var$WINDOW = (0, $9fktW.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $e16a962b14cdc560$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $e16a962b14cdc560$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $e16a962b14cdc560$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $e16a962b14cdc560$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $e16a962b14cdc560$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e16a962b14cdc560$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $e16a962b14cdc560$export$c82d238e23c40b21() {
    if (!$e16a962b14cdc560$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($e16a962b14cdc560$export$18cf36ed71d733e7($e16a962b14cdc560$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $e16a962b14cdc560$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $e16a962b14cdc560$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $e16a962b14cdc560$export$531055a6c684a70a() {
    return 'ReportingObserver' in $e16a962b14cdc560$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $e16a962b14cdc560$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$e16a962b14cdc560$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $e16a962b14cdc560$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $e16a962b14cdc560$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $e16a962b14cdc560$var$WINDOW && !!$e16a962b14cdc560$var$WINDOW.history.pushState && !!$e16a962b14cdc560$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $9fktW = parcelRequire("9fktW");
// eslint-disable-next-line deprecation/deprecation
const $2dc29850f174c3c4$var$WINDOW = (0, $9fktW.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $2dc29850f174c3c4$var$handlers = {};
const $2dc29850f174c3c4$var$instrumented = {};
/** Instruments given API */ function $2dc29850f174c3c4$var$instrument(type) {
    if ($2dc29850f174c3c4$var$instrumented[type]) return;
    $2dc29850f174c3c4$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $2dc29850f174c3c4$var$instrumentConsole();
            break;
        case 'dom':
            $2dc29850f174c3c4$var$instrumentDOM();
            break;
        case 'xhr':
            $2dc29850f174c3c4$var$instrumentXHR();
            break;
        case 'fetch':
            $2dc29850f174c3c4$var$instrumentFetch();
            break;
        case 'history':
            $2dc29850f174c3c4$var$instrumentHistory();
            break;
        case 'error':
            $2dc29850f174c3c4$var$instrumentError();
            break;
        case 'unhandledrejection':
            $2dc29850f174c3c4$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2dc29850f174c3c4$export$285b9172a3741fb7(type, callback) {
    $2dc29850f174c3c4$var$handlers[type] = $2dc29850f174c3c4$var$handlers[type] || [];
    $2dc29850f174c3c4$var$handlers[type].push(callback);
    $2dc29850f174c3c4$var$instrument(type);
}
/** JSDoc */ function $2dc29850f174c3c4$var$triggerHandlers(type, data) {
    if (!type || !$2dc29850f174c3c4$var$handlers[type]) return;
    for (const handler of $2dc29850f174c3c4$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4a505a9ef49b467d$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $2dc29850f174c3c4$var$instrumentConsole() {
    if (!('console' in $2dc29850f174c3c4$var$WINDOW)) return;
    (0, $5e86e2077273f401$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in $2dc29850f174c3c4$var$WINDOW.console)) return;
        (0, $d2095ac82d3e5999$export$9563e054e6f787fb)($2dc29850f174c3c4$var$WINDOW.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $2dc29850f174c3c4$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($2dc29850f174c3c4$var$WINDOW.console, args);
            };
        });
    });
}
/** JSDoc */ function $2dc29850f174c3c4$var$instrumentFetch() {
    if (!(0, $e16a962b14cdc560$export$c82d238e23c40b21)()) return;
    (0, $d2095ac82d3e5999$export$9563e054e6f787fb)($2dc29850f174c3c4$var$WINDOW, 'fetch', function(originalFetch) {
        return function(...args) {
            const handlerData = {
                args: args,
                fetchData: {
                    method: $2dc29850f174c3c4$var$getFetchMethod(args),
                    url: $2dc29850f174c3c4$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $2dc29850f174c3c4$var$triggerHandlers('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($2dc29850f174c3c4$var$WINDOW, args).then((response)=>{
                $2dc29850f174c3c4$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $2dc29850f174c3c4$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $2dc29850f174c3c4$var$getFetchMethod(fetchArgs = []) {
    if ('Request' in $2dc29850f174c3c4$var$WINDOW && (0, $36d5b4e82d3fe8cc$export$49034edbe6b62415)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $2dc29850f174c3c4$var$getFetchUrl(fetchArgs = []) {
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $2dc29850f174c3c4$var$WINDOW && (0, $36d5b4e82d3fe8cc$export$49034edbe6b62415)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $2dc29850f174c3c4$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $2dc29850f174c3c4$var$WINDOW)) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const xhr = this;
            const url = args[1];
            const xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $36d5b4e82d3fe8cc$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $36d5b4e82d3fe8cc$export$844ec244b1367d54)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            const onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $2dc29850f174c3c4$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(xhr, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $2dc29850f174c3c4$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $2dc29850f174c3c4$var$lastHref;
/** JSDoc */ function $2dc29850f174c3c4$var$instrumentHistory() {
    if (!(0, $e16a962b14cdc560$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $2dc29850f174c3c4$var$WINDOW.onpopstate;
    $2dc29850f174c3c4$var$WINDOW.onpopstate = function(...args) {
        const to = $2dc29850f174c3c4$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $2dc29850f174c3c4$var$lastHref;
        $2dc29850f174c3c4$var$lastHref = to;
        $2dc29850f174c3c4$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $2dc29850f174c3c4$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $2dc29850f174c3c4$var$lastHref = to;
                $2dc29850f174c3c4$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $d2095ac82d3e5999$export$9563e054e6f787fb)($2dc29850f174c3c4$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $d2095ac82d3e5999$export$9563e054e6f787fb)($2dc29850f174c3c4$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}
const $2dc29850f174c3c4$var$debounceDuration = 1000;
let $2dc29850f174c3c4$var$debounceTimerID;
let $2dc29850f174c3c4$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $2dc29850f174c3c4$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $2dc29850f174c3c4$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $2dc29850f174c3c4$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $2dc29850f174c3c4$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($2dc29850f174c3c4$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($2dc29850f174c3c4$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $2dc29850f174c3c4$var$lastCapturedEvent = event;
        } else if ($2dc29850f174c3c4$var$shouldShortcircuitPreviousDebounce($2dc29850f174c3c4$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $2dc29850f174c3c4$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($2dc29850f174c3c4$var$debounceTimerID);
        $2dc29850f174c3c4$var$debounceTimerID = $2dc29850f174c3c4$var$WINDOW.setTimeout(()=>{
            $2dc29850f174c3c4$var$debounceTimerID = undefined;
        }, $2dc29850f174c3c4$var$debounceDuration);
    };
}
/** JSDoc */ function $2dc29850f174c3c4$var$instrumentDOM() {
    if (!('document' in $2dc29850f174c3c4$var$WINDOW)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $2dc29850f174c3c4$var$triggerHandlers.bind(null, 'dom');
    const globalDOMEventHandler = $2dc29850f174c3c4$var$makeDOMEventHandler(triggerDOMHandler, true);
    $2dc29850f174c3c4$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $2dc29850f174c3c4$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $2dc29850f174c3c4$var$WINDOW[target] && $2dc29850f174c3c4$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $2dc29850f174c3c4$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $2dc29850f174c3c4$var$_oldOnErrorHandler = null;
/** JSDoc */ function $2dc29850f174c3c4$var$instrumentError() {
    $2dc29850f174c3c4$var$_oldOnErrorHandler = $2dc29850f174c3c4$var$WINDOW.onerror;
    $2dc29850f174c3c4$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $2dc29850f174c3c4$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($2dc29850f174c3c4$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $2dc29850f174c3c4$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
let $2dc29850f174c3c4$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $2dc29850f174c3c4$var$instrumentUnhandledRejection() {
    $2dc29850f174c3c4$var$_oldOnUnhandledRejectionHandler = $2dc29850f174c3c4$var$WINDOW.onunhandledrejection;
    $2dc29850f174c3c4$var$WINDOW.onunhandledrejection = function(e) {
        $2dc29850f174c3c4$var$triggerHandlers('unhandledrejection', e);
        if ($2dc29850f174c3c4$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $2dc29850f174c3c4$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $a42315a06c1c8b1d$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d17b1767b4fe59eb$export$a3295358bff77e(input, depth = Infinity, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $d17b1767b4fe59eb$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $d17b1767b4fe59eb$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $d17b1767b4fe59eb$export$a3295358bff77e(object, depth);
    if ($d17b1767b4fe59eb$var$jsonSize(normalized) > maxSize) return $d17b1767b4fe59eb$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $d17b1767b4fe59eb$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $a42315a06c1c8b1d$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $36d5b4e82d3fe8cc$export$c9f5652083b8129d)(value)) return value;
    const stringified = $d17b1767b4fe59eb$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $d17b1767b4fe59eb$export$588732934346abbf('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $d2095ac82d3e5999$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $d17b1767b4fe59eb$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $d17b1767b4fe59eb$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $36d5b4e82d3fe8cc$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return `[Function: ${(0, $4a505a9ef49b467d$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return `[object ${$d17b1767b4fe59eb$var$getConstructorName(value)}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $d17b1767b4fe59eb$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $d17b1767b4fe59eb$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d17b1767b4fe59eb$var$jsonSize(value) {
    return $d17b1767b4fe59eb$var$utf8Length(JSON.stringify(value));
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f4975d8ce2ed0898$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f4975d8ce2ed0898$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f4975d8ce2ed0898$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f4975d8ce2ed0898$export$604a45d95a155e2b(envelope, types) {
    return $f4975d8ce2ed0898$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $f4975d8ce2ed0898$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $f4975d8ce2ed0898$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $f4975d8ce2ed0898$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $f4975d8ce2ed0898$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $d17b1767b4fe59eb$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $f4975d8ce2ed0898$var$concatBuffers(parts);
}
function $f4975d8ce2ed0898$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f4975d8ce2ed0898$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $f4975d8ce2ed0898$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $f4975d8ce2ed0898$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $d2095ac82d3e5999$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $f4975d8ce2ed0898$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f4975d8ce2ed0898$export$b11169581eeaf237(type) {
    return $f4975d8ce2ed0898$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $f4975d8ce2ed0898$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f4975d8ce2ed0898$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $c359a1b3b6dd7ea2$export$44d472fbb931a776)(dsn)
        },
        ...event.type === 'transaction' && dynamicSamplingContext && {
            trace: (0, $d2095ac82d3e5999$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $25ab474c89e5aad0$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $25ab474c89e5aad0$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f4975d8ce2ed0898$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $c359a1b3b6dd7ea2$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session
    ];
    return (0, $f4975d8ce2ed0898$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $25ab474c89e5aad0$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f4975d8ce2ed0898$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $25ab474c89e5aad0$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $f4975d8ce2ed0898$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f4975d8ce2ed0898$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}





var $crd5F = parcelRequire("crd5F");
var $9fktW = parcelRequire("9fktW");


/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $c49ca008f0ff426f$export$2d67fb380bd11267(options, event, hint, scope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $ebd44ecf67fae0f0$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $crd5F.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $c49ca008f0ff426f$var$applyClientOptions(prepared, options);
    $c49ca008f0ff426f$var$applyIntegrationsMetadata(prepared, integrations);
    $c49ca008f0ff426f$export$4c0b0d8ee0d018b5(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) finalScope = (0, $2e26acc76f08a355$export$775b6bb06e53a214).clone(finalScope).update(hint.captureContext);
    // We prepare the result here with a resolved Event.
    let result = (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)(prepared);
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            const attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
    }
    return result.then((evt)=>{
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $c49ca008f0ff426f$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $c49ca008f0ff426f$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $cc762552b072a285$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $e92bed95d72e6528$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $e92bed95d72e6528$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $e92bed95d72e6528$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Applies debug metadata images to the event in order to apply source maps by looking up their debug ID.
 */ function $c49ca008f0ff426f$export$4c0b0d8ee0d018b5(event, stackParser) {
    const debugIdMap = (0, $9fktW.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    // Build a map of abs_path -> debug_id
    const absPathDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        const parsedStack = stackParser(debugIdStackTrace);
        for (const stackFrame of parsedStack)if (stackFrame.abs_path) {
            acc[stackFrame.abs_path] = debugIdMap[debugIdStackTrace];
            break;
        }
        return acc;
    }, {});
    // Get a Set of abs_paths in the stack trace
    const errorAbsPaths = new Set();
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.abs_path) errorAbsPaths.add(frame.abs_path);
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    errorAbsPaths.forEach((absPath)=>{
        if (absPathDebugIdMap[absPath]) images.push({
            type: 'sourcemap',
            code_file: absPath,
            debug_id: absPathDebugIdMap[absPath]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $c49ca008f0ff426f$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $c49ca008f0ff426f$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $d17b1767b4fe59eb$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $d17b1767b4fe59eb$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $d17b1767b4fe59eb$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $d17b1767b4fe59eb$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $d17b1767b4fe59eb$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $d17b1767b4fe59eb$export$a3295358bff77e)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}


const $f88e8f0aa7092fb8$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $f88e8f0aa7092fb8$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ __init() {
        this._integrations = {};
    }
    /** Indicates whether this client's integrations have been set up. */ __init2() {
        this._integrationsInitialized = false;
    }
    /** Number of calls being processed */ __init3() {
        this._numProcessing = 0;
    }
    /** Holds flushable  */ __init4() {
        this._outcomes = {};
    }
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        $f88e8f0aa7092fb8$export$4f22f74eddb7716a.prototype.__init.call(this);
        $f88e8f0aa7092fb8$export$4f22f74eddb7716a.prototype.__init2.call(this);
        $f88e8f0aa7092fb8$export$4f22f74eddb7716a.prototype.__init3.call(this);
        $f88e8f0aa7092fb8$export$4f22f74eddb7716a.prototype.__init4.call(this);
        this._options = options;
        if (options.dsn) {
            this._dsn = (0, $c359a1b3b6dd7ea2$export$128827c3562ec0cb)(options.dsn);
            const url = (0, $1b19efd29196ef7b$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('No DSN provided, client will not do anything.');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $ebd44ecf67fae0f0$export$6de4ffac6a2f1098)(exception)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log($f88e8f0aa7092fb8$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = (0, $36d5b4e82d3fe8cc$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $ebd44ecf67fae0f0$export$6de4ffac6a2f1098)(hint.originalException)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log($f88e8f0aa7092fb8$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $6dcc3646f7b2578b$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /**
   * Sets up the integrations
   */ setupIntegrations() {
        if (this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $35674e6cecc7a491$export$51abed9797baa598)(this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $35674e6cecc7a491$export$e7390a03b70a6f2f)(integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        if (this._dsn) {
            let env = (0, $25ab474c89e5aad0$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
            for (const attachment of hint.attachments || [])env = (0, $f4975d8ce2ed0898$export$d650323442802f6f)(env, (0, $f4975d8ce2ed0898$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        if (this._dsn) {
            const env = (0, $25ab474c89e5aad0$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $6dcc3646f7b2578b$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $d18f33e59a561b5c$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        return (0, $c49ca008f0ff426f$export$2d67fb380bd11267)(options, event, hint, scope);
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $5e86e2077273f401$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        if (!this._isEnabled()) return (0, $d18f33e59a561b5c$export$78e43115b553f358)(new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)('SDK not enabled, will not capture event.', 'log'));
        const isTransaction = $f88e8f0aa7092fb8$var$isTransactionEvent(event);
        const isError = $f88e8f0aa7092fb8$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $d18f33e59a561b5c$export$78e43115b553f358)(new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $f88e8f0aa7092fb8$var$processBeforeSend(options, prepared, hint);
            return $f88e8f0aa7092fb8$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $8582b90aa2262557$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        if (this._transport && this._dsn) this._transport.send(envelope).then(null, (reason)=>{
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error('Error while sending event:', reason);
        });
        else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $f88e8f0aa7092fb8$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $36d5b4e82d3fe8cc$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $36d5b4e82d3fe8cc$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $36d5b4e82d3fe8cc$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $f88e8f0aa7092fb8$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($f88e8f0aa7092fb8$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($f88e8f0aa7092fb8$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $f88e8f0aa7092fb8$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $f88e8f0aa7092fb8$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}

const $8918076f6f8055ca$export$31499a9cd224b78c = '7.41.0';




var $crd5F = parcelRequire("crd5F");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $6b5e6004598bcba6$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $crd5F.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f4975d8ce2ed0898$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $kHHr4 = parcelRequire("kHHr4");


/**
 * This function creates an exception from a JavaScript Error
 */ function $e5fecadc2e43bcdc$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $e5fecadc2e43bcdc$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $e5fecadc2e43bcdc$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $e5fecadc2e43bcdc$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const hub = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $36d5b4e82d3fe8cc$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: `Non-Error ${isUnhandledRejection ? 'promise rejection' : 'exception'} captured with keys: ${(0, $d2095ac82d3e5999$export$b0244d5063c0b61b)(exception)}`
                }
            ]
        },
        extra: {
            __serialized__: (0, $d17b1767b4fe59eb$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $e5fecadc2e43bcdc$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $e5fecadc2e43bcdc$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $e5fecadc2e43bcdc$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $e5fecadc2e43bcdc$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $e5fecadc2e43bcdc$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $e5fecadc2e43bcdc$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $e5fecadc2e43bcdc$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($e5fecadc2e43bcdc$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $e5fecadc2e43bcdc$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $e5fecadc2e43bcdc$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $e5fecadc2e43bcdc$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $ebd44ecf67fae0f0$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $e5fecadc2e43bcdc$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $e5fecadc2e43bcdc$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $e5fecadc2e43bcdc$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $36d5b4e82d3fe8cc$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $e5fecadc2e43bcdc$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $36d5b4e82d3fe8cc$export$ef9e2056653f0c8e)(exception) || (0, $36d5b4e82d3fe8cc$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $e5fecadc2e43bcdc$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $36d5b4e82d3fe8cc$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $e5fecadc2e43bcdc$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $ebd44ecf67fae0f0$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $36d5b4e82d3fe8cc$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $e5fecadc2e43bcdc$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $36d5b4e82d3fe8cc$export$53b83ca8eaab0383)(exception) || (0, $36d5b4e82d3fe8cc$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $e5fecadc2e43bcdc$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $ebd44ecf67fae0f0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $e5fecadc2e43bcdc$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $ebd44ecf67fae0f0$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $ebd44ecf67fae0f0$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $e5fecadc2e43bcdc$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    const event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        const frames = $e5fecadc2e43bcdc$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}



// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $f948ba28b6b59b27$export$f5282963edea4a68(exception, captureContext) {
    return (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $f948ba28b6b59b27$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $f948ba28b6b59b27$export$1462b974fdcf6ba2(event, hint) {
    return (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $f948ba28b6b59b27$export$99d44f04437e9cb8(callback) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $f948ba28b6b59b27$export$efda9a273d7a036d(breadcrumb) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f948ba28b6b59b27$export$2f04de43fe27971a(name, context) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f948ba28b6b59b27$export$bb4922da0dd51b92(extras) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f948ba28b6b59b27$export$8e8e7789d42ed61d(key, extra) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f948ba28b6b59b27$export$74a8fb34822092e6(tags) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f948ba28b6b59b27$export$a37d07ee78eb4569(key, value) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f948ba28b6b59b27$export$8b6bb3dd62a01be2(user) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $f948ba28b6b59b27$export$ec58d9285c204497(callback) {
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $f948ba28b6b59b27$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}



var $9fktW = parcelRequire("9fktW");
const $cf6623f1d5b4f204$export$56d8a8a25bd48b81 = (0, $9fktW.GLOBAL_OBJ);
let $cf6623f1d5b4f204$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $cf6623f1d5b4f204$export$b79738ab10c590b2() {
    return $cf6623f1d5b4f204$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $cf6623f1d5b4f204$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $cf6623f1d5b4f204$var$ignoreOnError++;
    setTimeout(()=>{
        $cf6623f1d5b4f204$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $cf6623f1d5b4f204$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $d2095ac82d3e5999$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$cf6623f1d5b4f204$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $cf6623f1d5b4f204$export$1265a142ff5ba165();
            (0, $f948ba28b6b59b27$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $ebd44ecf67fae0f0$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $ebd44ecf67fae0f0$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f948ba28b6b59b27$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $d2095ac82d3e5999$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $d2095ac82d3e5999$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $86d16f599cdc76ef$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $86d16f599cdc76ef$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $86d16f599cdc76ef$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $00366d06c913a420$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $00366d06c913a420$export$e01cef29b4327697(level) {
    return $00366d06c913a420$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $00366d06c913a420$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $00366d06c913a420$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $458d3c500e5cc1b9$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $458d3c500e5cc1b9$export$6d0f6df16bece7bf = 'Breadcrumbs';
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $458d3c500e5cc1b9$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = $458d3c500e5cc1b9$export$6d0f6df16bece7bf;
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $458d3c500e5cc1b9$export$2dc68d50d56fbbd.id;
    }
    /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        $458d3c500e5cc1b9$export$2dc68d50d56fbbd.prototype.__init.call(this);
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('console', $458d3c500e5cc1b9$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('dom', $458d3c500e5cc1b9$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('xhr', $458d3c500e5cc1b9$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('fetch', $458d3c500e5cc1b9$var$_fetchBreadcrumb);
        if (this.options.history) (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('history', $458d3c500e5cc1b9$var$_historyBreadcrumb);
    }
    /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */ addSentryBreadcrumb(event) {
        if (this.options.sentry) (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $ebd44ecf67fae0f0$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    }
}
$458d3c500e5cc1b9$export$2dc68d50d56fbbd.__initStatic();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $458d3c500e5cc1b9$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $458d3c500e5cc1b9$var$MAX_ALLOWED_STRING_LENGTH) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$458d3c500e5cc1b9$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$458d3c500e5cc1b9$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $458d3c500e5cc1b9$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $1c622875a291eb2b$export$5647df6b7814ac86)(handlerData.event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $1c622875a291eb2b$export$5647df6b7814ac86)(handlerData.event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $458d3c500e5cc1b9$var$_consoleBreadcrumb(handlerData) {
    // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
    // console warnings. This happens when a Vue template is rendered with
    // an undeclared variable, which we try to stringify, ultimately causing
    // Vue to issue another warning which repeats indefinitely.
    // see: https://github.com/getsentry/sentry-javascript/pull/6010
    // see: https://github.com/getsentry/sentry-javascript/issues/5916
    for(let i = 0; i < handlerData.args.length; i++)if (handlerData.args[i] === 'ref=Ref<') {
        handlerData.args[i + 1] = 'viewRef';
        break;
    }
    const breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $00366d06c913a420$export$d771ef054122c30a)(handlerData.level),
        message: (0, $e92bed95d72e6528$export$465e9d514283d4fd)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $e92bed95d72e6528$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $458d3c500e5cc1b9$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        const { method: method, url: url, status_code: status_code, body: body } = handlerData.xhr.__sentry_xhr__ || {};
        (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $458d3c500e5cc1b9$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: 'fetch',
        data: {
            ...handlerData.fetchData,
            status_code: handlerData.response.status
        },
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $458d3c500e5cc1b9$var$_historyBreadcrumb(handlerData) {
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0, $86d16f599cdc76ef$export$7a5253c0f62e0150)((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).location.href);
    let parsedFrom = (0, $86d16f599cdc76ef$export$7a5253c0f62e0150)(from);
    const parsedTo = (0, $86d16f599cdc76ef$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $572d93b5c8b71257$export$1df9218a526d318d extends (0, $f88e8f0aa7092fb8$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $kHHr4.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $8918076f6f8055ca$export$31499a9cd224b78c)
                }
            ],
            version: (0, $8918076f6f8055ca$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document) (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $e5fecadc2e43bcdc$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $e5fecadc2e43bcdc$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint) {
        // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
        // activated its `sentry` option.
        // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
        // bundles, if it is not used by the SDK.
        // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
        // way for now.
        const breadcrumbIntegration = this.getIntegrationById((0, $458d3c500e5cc1b9$export$6d0f6df16bece7bf));
        // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
        // "Breadcrumbs" that does not have this function.
        if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) breadcrumbIntegration.addSentryBreadcrumb(event);
        super.sendEvent(event, hint);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        if (!this._dsn) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const url = (0, $1b19efd29196ef7b$export$9964600bfe84e6a3)(this._dsn, this._options);
        const envelope = (0, $6b5e6004598bcba6$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $c359a1b3b6dd7ea2$export$44d472fbb931a776)(this._dsn));
        try {
            const isRealNavigator = Object.prototype.toString.call((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81) && (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).navigator) === '[object Navigator]';
            const hasSendBeacon = isRealNavigator && typeof (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).navigator.sendBeacon === 'function';
            // Make sure beacon is not used if user configures custom transport options
            if (hasSendBeacon && !this._options.transportOptions) {
                // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
                const sendBeacon = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).navigator.sendBeacon.bind((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).navigator);
                sendBeacon(url, (0, $f4975d8ce2ed0898$export$32f9b428425aac85)(envelope));
            } else // If beacon is not supported or if they are using the tunnel option
            // use our regular transport to send client reports to Sentry.
            this._sendEnvelope(envelope);
        } catch (e) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error(e);
        }
    }
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ class $6c1ff8b69585281a$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GlobalHandlers';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $6c1ff8b69585281a$export$204155decbc90e5a.id;
    }
    /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ __init2() {
        this._installFunc = {
            onerror: $6c1ff8b69585281a$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $6c1ff8b69585281a$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /** JSDoc */ constructor(options){
        $6c1ff8b69585281a$export$204155decbc90e5a.prototype.__init.call(this);
        $6c1ff8b69585281a$export$204155decbc90e5a.prototype.__init2.call(this);
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        const options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(const key in options){
            const installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $6c1ff8b69585281a$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$6c1ff8b69585281a$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $6c1ff8b69585281a$var$_installGlobalOnErrorHandler() {
    (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data)=>{
        const [hub, stackParser, attachStacktrace] = $6c1ff8b69585281a$var$getHubAndOptions();
        if (!hub.getIntegration($6c1ff8b69585281a$export$204155decbc90e5a)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        if ((0, $cf6623f1d5b4f204$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        const event = error === undefined && (0, $36d5b4e82d3fe8cc$export$844ec244b1367d54)(msg) ? $6c1ff8b69585281a$var$_eventFromIncompleteOnError(msg, url, line, column) : $6c1ff8b69585281a$var$_enhanceEventWithInitialFrame((0, $e5fecadc2e43bcdc$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        $6c1ff8b69585281a$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $6c1ff8b69585281a$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        const [hub, stackParser, attachStacktrace] = $6c1ff8b69585281a$var$getHubAndOptions();
        if (!hub.getIntegration($6c1ff8b69585281a$export$204155decbc90e5a)) return;
        let error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $cf6623f1d5b4f204$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        const event = (0, $36d5b4e82d3fe8cc$export$c3825b437cbdea5c)(error) ? $6c1ff8b69585281a$var$_eventFromRejectionWithPrimitive(error) : (0, $e5fecadc2e43bcdc$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        $6c1ff8b69585281a$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $6c1ff8b69585281a$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6c1ff8b69585281a$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $36d5b4e82d3fe8cc$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $6c1ff8b69585281a$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6c1ff8b69585281a$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $36d5b4e82d3fe8cc$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $1c622875a291eb2b$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $6c1ff8b69585281a$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $6c1ff8b69585281a$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $ebd44ecf67fae0f0$export$c69a9a0313b03bb1)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $6c1ff8b69585281a$var$getHubAndOptions() {
    const hub = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}




const $b2dde7cad90661cd$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $b2dde7cad90661cd$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'TryCatch';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $b2dde7cad90661cd$export$f1a018517668e6d3.id;
    }
    /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        $b2dde7cad90661cd$export$f1a018517668e6d3.prototype.__init.call(this);
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        if (this._options.setTimeout) (0, $d2095ac82d3e5999$export$9563e054e6f787fb)((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81), 'setTimeout', $b2dde7cad90661cd$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $d2095ac82d3e5999$export$9563e054e6f787fb)((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81), 'setInterval', $b2dde7cad90661cd$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $d2095ac82d3e5999$export$9563e054e6f787fb)((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81), 'requestAnimationFrame', $b2dde7cad90661cd$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81)) (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $b2dde7cad90661cd$var$_wrapXHR);
        const eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $b2dde7cad90661cd$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($b2dde7cad90661cd$var$_wrapEventTarget);
        }
    }
}
$b2dde7cad90661cd$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $b2dde7cad90661cd$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $cf6623f1d5b4f204$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4a505a9ef49b467d$export$aad197c7121a6651)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b2dde7cad90661cd$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $cf6623f1d5b4f204$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4a505a9ef49b467d$export$aad197c7121a6651)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $b2dde7cad90661cd$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4a505a9ef49b467d$export$aad197c7121a6651)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $d2095ac82d3e5999$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4a505a9ef49b467d$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $cf6623f1d5b4f204$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $b2dde7cad90661cd$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $cf6623f1d5b4f204$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4a505a9ef49b467d$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $cf6623f1d5b4f204$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4a505a9ef49b467d$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $d2095ac82d3e5999$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}






const $f0c3c2510db83406$var$DEFAULT_KEY = 'cause';
const $f0c3c2510db83406$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $f0c3c2510db83406$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'LinkedErrors';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $f0c3c2510db83406$export$8d1e60aaf616fb4f.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $f0c3c2510db83406$export$8d1e60aaf616fb4f.prototype.__init.call(this);
        this._key = options.key || $f0c3c2510db83406$var$DEFAULT_KEY;
        this._limit = options.limit || $f0c3c2510db83406$var$DEFAULT_LIMIT;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        const client = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().getClient();
        if (!client) return;
        (0, $2e26acc76f08a355$export$8e4e25f54d456511)((event, hint)=>{
            const self = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().getIntegration($f0c3c2510db83406$export$8d1e60aaf616fb4f);
            return self ? $f0c3c2510db83406$export$7bd713d0612d8839(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
        });
    }
}
$f0c3c2510db83406$export$8d1e60aaf616fb4f.__initStatic();
/**
 * @inheritDoc
 */ function $f0c3c2510db83406$export$7bd713d0612d8839(parser, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $36d5b4e82d3fe8cc$export$49034edbe6b62415)(hint.originalException, Error)) return event;
    const linkedErrors = $f0c3c2510db83406$export$e4e3ecf6f8f76c75(parser, limit, hint.originalException, key);
    event.exception.values = [
        ...linkedErrors,
        ...event.exception.values
    ];
    return event;
}
/**
 * JSDOC
 */ function $f0c3c2510db83406$export$e4e3ecf6f8f76c75(parser, limit, error, key, stack = []) {
    if (!(0, $36d5b4e82d3fe8cc$export$49034edbe6b62415)(error[key], Error) || stack.length + 1 >= limit) return stack;
    const exception = (0, $e5fecadc2e43bcdc$export$a6c2d27607295951)(parser, error[key]);
    return $f0c3c2510db83406$export$e4e3ecf6f8f76c75(parser, limit, error[key], key, [
        exception,
        ...stack
    ]);
}




/** HttpContext integration collects information about HTTP request headers */ class $dad571044eeff58f$export$5d2ee9a544b09a94 {
    constructor(){
        $dad571044eeff58f$export$5d2ee9a544b09a94.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'HttpContext';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $dad571044eeff58f$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        (0, $2e26acc76f08a355$export$8e4e25f54d456511)((event)=>{
            if ((0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().getIntegration($dad571044eeff58f$export$5d2ee9a544b09a94)) {
                // if none of the information we want exists, don't bother
                if (!(0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).navigator && !(0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).location && !(0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document) return event;
                // grab as much info as exists and add it to the event
                const url = event.request && event.request.url || (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).location && (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).location.href;
                const { referrer: referrer } = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document || {};
                const { userAgent: userAgent } = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).navigator || {};
                const headers = {
                    ...event.request && event.request.headers,
                    ...referrer && {
                        Referer: referrer
                    },
                    ...userAgent && {
                        'User-Agent': userAgent
                    }
                };
                const request = {
                    ...event.request,
                    ...url && {
                        url: url
                    },
                    headers: headers
                };
                return {
                    ...event,
                    request: request
                };
            }
            return event;
        });
    }
}
$dad571044eeff58f$export$5d2ee9a544b09a94.__initStatic();



/** Deduplication filter */ class $09a4994f76407ad1$export$688d98c249d31ad3 {
    constructor(){
        $09a4994f76407ad1$export$688d98c249d31ad3.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Dedupe';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $09a4994f76407ad1$export$688d98c249d31ad3.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcessor = (currentEvent)=>{
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            const self = getCurrentHub().getIntegration($09a4994f76407ad1$export$688d98c249d31ad3);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($09a4994f76407ad1$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        };
        eventProcessor.id = this.name;
        addGlobalEventProcessor(eventProcessor);
    }
}
$09a4994f76407ad1$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $09a4994f76407ad1$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($09a4994f76407ad1$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($09a4994f76407ad1$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $09a4994f76407ad1$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$09a4994f76407ad1$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$09a4994f76407ad1$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $09a4994f76407ad1$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $09a4994f76407ad1$var$_getExceptionFromEvent(previousEvent);
    const currentException = $09a4994f76407ad1$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$09a4994f76407ad1$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$09a4994f76407ad1$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $09a4994f76407ad1$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $09a4994f76407ad1$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $09a4994f76407ad1$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $09a4994f76407ad1$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $09a4994f76407ad1$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $09a4994f76407ad1$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



// global reference to slice
const $38cca913ba09cf2a$var$UNKNOWN_FUNCTION = '?';
const $38cca913ba09cf2a$var$OPERA10_PRIORITY = 10;
const $38cca913ba09cf2a$var$OPERA11_PRIORITY = 20;
const $38cca913ba09cf2a$var$CHROME_PRIORITY = 30;
const $38cca913ba09cf2a$var$WINJS_PRIORITY = 40;
const $38cca913ba09cf2a$var$GECKO_PRIORITY = 50;
function $38cca913ba09cf2a$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        abs_path: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $38cca913ba09cf2a$var$chromeRegex = /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?(?:async )?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $38cca913ba09cf2a$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $38cca913ba09cf2a$var$chrome = (line)=>{
    const parts = $38cca913ba09cf2a$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $38cca913ba09cf2a$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $38cca913ba09cf2a$var$extractSafariExtensionDetails(parts[1] || $38cca913ba09cf2a$var$UNKNOWN_FUNCTION, parts[2]);
        return $38cca913ba09cf2a$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $38cca913ba09cf2a$export$263a749fff749872 = [
    $38cca913ba09cf2a$var$CHROME_PRIORITY,
    $38cca913ba09cf2a$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $38cca913ba09cf2a$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $38cca913ba09cf2a$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $38cca913ba09cf2a$var$gecko = (line)=>{
    const parts = $38cca913ba09cf2a$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $38cca913ba09cf2a$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $38cca913ba09cf2a$var$UNKNOWN_FUNCTION;
        [func, filename] = $38cca913ba09cf2a$var$extractSafariExtensionDetails(func, filename);
        return $38cca913ba09cf2a$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $38cca913ba09cf2a$export$cdba47a5dd2804d = [
    $38cca913ba09cf2a$var$GECKO_PRIORITY,
    $38cca913ba09cf2a$var$gecko
];
const $38cca913ba09cf2a$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $38cca913ba09cf2a$var$winjs = (line)=>{
    const parts = $38cca913ba09cf2a$var$winjsRegex.exec(line);
    return parts ? $38cca913ba09cf2a$var$createFrame(parts[2], parts[1] || $38cca913ba09cf2a$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $38cca913ba09cf2a$export$179460296da408e8 = [
    $38cca913ba09cf2a$var$WINJS_PRIORITY,
    $38cca913ba09cf2a$var$winjs
];
const $38cca913ba09cf2a$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $38cca913ba09cf2a$var$opera10 = (line)=>{
    const parts = $38cca913ba09cf2a$var$opera10Regex.exec(line);
    return parts ? $38cca913ba09cf2a$var$createFrame(parts[2], parts[3] || $38cca913ba09cf2a$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $38cca913ba09cf2a$export$f892b52c880ffc7a = [
    $38cca913ba09cf2a$var$OPERA10_PRIORITY,
    $38cca913ba09cf2a$var$opera10
];
const $38cca913ba09cf2a$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $38cca913ba09cf2a$var$opera11 = (line)=>{
    const parts = $38cca913ba09cf2a$var$opera11Regex.exec(line);
    return parts ? $38cca913ba09cf2a$var$createFrame(parts[5], parts[3] || parts[4] || $38cca913ba09cf2a$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $38cca913ba09cf2a$export$af11af13f09fb0dc = [
    $38cca913ba09cf2a$var$OPERA11_PRIORITY,
    $38cca913ba09cf2a$var$opera11
];
const $38cca913ba09cf2a$export$7197c0fe6554c079 = [
    $38cca913ba09cf2a$export$263a749fff749872,
    $38cca913ba09cf2a$export$cdba47a5dd2804d,
    $38cca913ba09cf2a$export$179460296da408e8
];
const $38cca913ba09cf2a$export$2b2b997d81bf3907 = (0, $4a505a9ef49b467d$export$a5739666fb2d03d4)(...$38cca913ba09cf2a$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $38cca913ba09cf2a$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $38cca913ba09cf2a$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $00554492e88f3244$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $00554492e88f3244$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $00554492e88f3244$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $00554492e88f3244$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $00554492e88f3244$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $00554492e88f3244$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $00554492e88f3244$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories] = limit.split(':', 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';'))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $00554492e88f3244$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $888142e07403e395$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $d18f33e59a561b5c$export$78e43115b553f358)(new (0, $8582b90aa2262557$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $d18f33e59a561b5c$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


const $fa31ee756648ec85$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $fa31ee756648ec85$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $888142e07403e395$export$85a4f67f852183e6)(options.bufferSize || $fa31ee756648ec85$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $f4975d8ce2ed0898$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $f4975d8ce2ed0898$export$b11169581eeaf237)(type);
            if ((0, $00554492e88f3244$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $fa31ee756648ec85$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $f4975d8ce2ed0898$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $f4975d8ce2ed0898$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $fa31ee756648ec85$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $f4975d8ce2ed0898$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f4975d8ce2ed0898$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $00554492e88f3244$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $8582b90aa2262557$export$5949942ba2a7c0e2)) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $fa31ee756648ec85$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}





let $0b31e3e8216f88fc$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $0b31e3e8216f88fc$export$8be2119ce08e3379() {
    if ($0b31e3e8216f88fc$var$cachedFetchImpl) return $0b31e3e8216f88fc$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $e16a962b14cdc560$export$18cf36ed71d733e7)((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).fetch)) return $0b31e3e8216f88fc$var$cachedFetchImpl = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).fetch.bind((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81));
    const document = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $0b31e3e8216f88fc$var$cachedFetchImpl = fetchImpl.bind((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $0b31e3e8216f88fc$export$d499686d2dd738c6() {
    $0b31e3e8216f88fc$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $6648f598040e200b$export$b2311068c46d7cc8(options, nativeFetch = (0, $0b31e3e8216f88fc$export$8be2119ce08e3379)()) {
    function makeRequest(request) {
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch), a request with `keepalive: true`
            //   and a content length of > 64 kibibytes returns a network error. We will therefore only activate the flag when
            //   we're below that limit.
            keepalive: request.body.length <= 65536,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>({
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                }));
        } catch (e) {
            (0, $0b31e3e8216f88fc$export$d499686d2dd738c6)();
            return (0, $d18f33e59a561b5c$export$78e43115b553f358)(e);
        }
    }
    return (0, $fa31ee756648ec85$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $9cb459fd0efa683a$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $9cb459fd0efa683a$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $d18f33e59a561b5c$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $9cb459fd0efa683a$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $fa31ee756648ec85$export$d09f50d9ab7f7b69)(options, makeRequest);
}


const $61878516848e5cd2$export$5ef831fccfce35e5 = [
    new (0, $6779fccd8d1e1d09$exports).InboundFilters(),
    new (0, $6779fccd8d1e1d09$exports).FunctionToString(),
    new (0, $b2dde7cad90661cd$export$f1a018517668e6d3)(),
    new (0, $458d3c500e5cc1b9$export$2dc68d50d56fbbd)(),
    new (0, $6c1ff8b69585281a$export$204155decbc90e5a)(),
    new (0, $f0c3c2510db83406$export$8d1e60aaf616fb4f)(),
    new (0, $09a4994f76407ad1$export$688d98c249d31ad3)(),
    new (0, $dad571044eeff58f$export$5d2ee9a544b09a94)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $61878516848e5cd2$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $61878516848e5cd2$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $4a505a9ef49b467d$export$1d5cf88b347146d4)(options.stackParser || (0, $38cca913ba09cf2a$export$2b2b997d81bf3907)),
        integrations: (0, $35674e6cecc7a491$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $e16a962b14cdc560$export$edf3cb81fd7d2a3e)() ? (0, $6648f598040e200b$export$b2311068c46d7cc8) : (0, $9cb459fd0efa683a$export$5e1441cee30d5a39))
    };
    (0, $f1e63da6d3e6770b$export$5333c3f1c58d9bc1)((0, $572d93b5c8b71257$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $61878516848e5cd2$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $61878516848e5cd2$export$3a8fd680da42627b(options = {}, hub = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)()) {
    // doesn't work without a document (React Native)
    if (!(0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    const script = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.src = (0, $1b19efd29196ef7b$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const injectionPoint = (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document.head || (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $61878516848e5cd2$export$5d4e9fd7fac8e617() {
    return (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $61878516848e5cd2$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $61878516848e5cd2$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $61878516848e5cd2$export$4909b86c8034bf73(timeout) {
    const client = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.flush(timeout);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $61878516848e5cd2$export$8360e631d277ea4d(timeout) {
    const client = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.close(timeout);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $d18f33e59a561b5c$export$1fda8aa4d135f8aa)(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $61878516848e5cd2$export$4997ffc0176396a6(fn) {
    return (0, $cf6623f1d5b4f204$export$4997ffc0176396a6)(fn)();
}
function $61878516848e5cd2$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $61878516848e5cd2$var$startSessionTracking() {
    if (typeof (0, $cf6623f1d5b4f204$export$56d8a8a25bd48b81).document === 'undefined') {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $5e86e2077273f401$export$af88d00dbe7f521).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    const hub = (0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $61878516848e5cd2$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $2dc29850f174c3c4$export$285b9172a3741fb7)('history', ({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $61878516848e5cd2$var$startSessionOnHub((0, $45bbacb34c7eee9d$export$a07cdf6544bbd7c)());
    });
}


parcelRequire("cDzby");
var $kWJha = parcelRequire("kWJha");
var $97odG = parcelRequire("97odG");

var $5JMLH = parcelRequire("5JMLH");

var $lNnaw = parcelRequire("lNnaw");
var $3dOhR = parcelRequire("3dOhR");

var $deWeK = parcelRequire("deWeK");
/* tslint:disable */ /* eslint-disable prettier/prettier */ const $05aa38b2753ea564$export$a988b149d1c415aa = {
    "__schema": {
        "types": [
            {
                "kind": "UNION",
                "name": "UnionMessagesType",
                "possibleTypes": [
                    {
                        "name": "ProjectNotifications"
                    },
                    {
                        "name": "MachineNotifications"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "ProjectNotificationsDataUnion",
                "possibleTypes": [
                    {
                        "name": "ProjectNotificationsInvite"
                    },
                    {
                        "name": "ProjectNotificationsRemove"
                    },
                    {
                        "name": "ProjectNotificationsMention"
                    }
                ]
            },
            {
                "kind": "UNION",
                "name": "MachineNotificationsDataUnion",
                "possibleTypes": [
                    {
                        "name": "MachineNotificationsStarted"
                    },
                    {
                        "name": "MachineNotificationsStopped"
                    }
                ]
            }
        ]
    }
};



var $7lFX5 = parcelRequire("7lFX5");
const $daf04de585086b9e$export$255739011e013f34 = `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`;



var $6LnE2 = parcelRequire("6LnE2");

var $1t8Wn = parcelRequire("1t8Wn");

var $2O1GU = parcelRequire("2O1GU");

var $4TeKW = parcelRequire("4TeKW");

var $57Cad = parcelRequire("57Cad");
var $9d0f5f23a98d09dd$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $9d0f5f23a98d09dd$var$Log = function() {
    function Log(options) {
        var _a = options.debug, debug = _a === void 0 ? false : _a;
        this.debug = debug;
        this.lines = [];
    }
    Log.prototype.emit = function(level, message) {
        if (level in console) {
            var prefix = Log.prefix;
            console[level].apply(console, $9d0f5f23a98d09dd$var$__spreadArrays([
                prefix
            ], message));
        }
    };
    Log.prototype.tailLogs = function() {
        var _this = this;
        this.lines.forEach(function(_a) {
            var level = _a[0], message = _a[1];
            return _this.emit(level, message);
        });
    };
    Log.prototype.getLogs = function() {
        return this.lines;
    };
    Log.prototype.write = function(level, message) {
        var buffer = Log.buffer;
        this.lines = $9d0f5f23a98d09dd$var$__spreadArrays(this.lines.slice(1 - buffer), [
            [
                level,
                message
            ]
        ]);
        if (this.debug || level !== 'log') this.emit(level, message);
    };
    Log.prototype.info = function() {
        var message = [];
        for(var _i = 0; _i < arguments.length; _i++)message[_i] = arguments[_i];
        this.write('log', message);
    };
    Log.prototype.warn = function() {
        var message = [];
        for(var _i = 0; _i < arguments.length; _i++)message[_i] = arguments[_i];
        this.write('warn', message);
    };
    Log.prototype.error = function() {
        var message = [];
        for(var _i = 0; _i < arguments.length; _i++)message[_i] = arguments[_i];
        this.write('error', message);
    };
    Log.buffer = 30;
    Log.prefix = '[apollo-cache-persist]';
    return Log;
}();
var $9d0f5f23a98d09dd$export$2e2bcd8739ae039 = $9d0f5f23a98d09dd$var$Log;


var $443f9ec21d54ddd9$var$Cache = function() {
    function Cache(options) {
        var cache = options.cache, _a = options.serialize, serialize = _a === void 0 ? true : _a;
        this.cache = cache;
        this.serialize = serialize;
    }
    Cache.prototype.extract = function() {
        var data = this.cache.extract();
        if (this.serialize) data = JSON.stringify(data);
        return data;
    };
    Cache.prototype.restore = function(data) {
        if (this.serialize && typeof data === 'string') data = JSON.parse(data);
        if (data != null) this.cache.restore(data);
    };
    return Cache;
}();
var $443f9ec21d54ddd9$export$2e2bcd8739ae039 = $443f9ec21d54ddd9$var$Cache;


var $6a421b6142ccca4a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6a421b6142ccca4a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6a421b6142ccca4a$var$Storage = function() {
    function Storage(options) {
        var storage = options.storage, _a = options.key, key = _a === void 0 ? 'apollo-cache-persist' : _a;
        this.storage = storage;
        this.key = key;
    }
    Storage.prototype.read = function() {
        return $6a421b6142ccca4a$var$__awaiter(this, void 0, void 0, function() {
            return $6a421b6142ccca4a$var$__generator(this, function(_a) {
                return [
                    2,
                    this.storage.getItem(this.key)
                ];
            });
        });
    };
    Storage.prototype.write = function(data) {
        return $6a421b6142ccca4a$var$__awaiter(this, void 0, void 0, function() {
            return $6a421b6142ccca4a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.storage.setItem(this.key, data)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2
                        ];
                }
            });
        });
    };
    Storage.prototype.purge = function() {
        return $6a421b6142ccca4a$var$__awaiter(this, void 0, void 0, function() {
            return $6a421b6142ccca4a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.storage.removeItem(this.key)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2
                        ];
                }
            });
        });
    };
    Storage.prototype.getSize = function() {
        return $6a421b6142ccca4a$var$__awaiter(this, void 0, void 0, function() {
            var data;
            return $6a421b6142ccca4a$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.storage.getItem(this.key)
                        ];
                    case 1:
                        data = _a.sent();
                        if (data == null) return [
                            2,
                            0
                        ];
                        else return [
                            2,
                            typeof data === 'string' ? data.length : null
                        ];
                        return [
                            2
                        ];
                }
            });
        });
    };
    return Storage;
}();
var $6a421b6142ccca4a$export$2e2bcd8739ae039 = $6a421b6142ccca4a$var$Storage;


var $fbffad5aad4c4a59$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fbffad5aad4c4a59$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fbffad5aad4c4a59$var$Persistor = function() {
    function Persistor(_a, options) {
        var log = _a.log, cache = _a.cache, storage = _a.storage;
        var _b = options.maxSize, maxSize = _b === void 0 ? 1048576 : _b, persistenceMapper = options.persistenceMapper;
        this.log = log;
        this.cache = cache;
        this.storage = storage;
        this.paused = false;
        if (persistenceMapper) this.persistenceMapper = persistenceMapper;
        if (maxSize) this.maxSize = maxSize;
    }
    Persistor.prototype.persist = function() {
        return $fbffad5aad4c4a59$var$__awaiter(this, void 0, void 0, function() {
            var data, error_1;
            return $fbffad5aad4c4a59$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        data = this.cache.extract();
                        if (!(!this.paused && this.persistenceMapper)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.persistenceMapper(data)
                        ];
                    case 1:
                        data = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(this.maxSize != null && typeof data === 'string' && data.length > this.maxSize && !this.paused)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            this.purge()
                        ];
                    case 3:
                        _a.sent();
                        this.paused = true;
                        return [
                            2
                        ];
                    case 4:
                        if (this.paused) return [
                            2
                        ];
                        return [
                            4,
                            this.storage.write(data)
                        ];
                    case 5:
                        _a.sent();
                        this.log.info(typeof data === 'string' ? "Persisted cache of size " + data.length + " characters" : 'Persisted cache');
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error_1 = _a.sent();
                        this.log.error('Error persisting cache', error_1);
                        throw error_1;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Persistor.prototype.restore = function() {
        return $fbffad5aad4c4a59$var$__awaiter(this, void 0, void 0, function() {
            var data, error_2;
            return $fbffad5aad4c4a59$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            this.storage.read()
                        ];
                    case 1:
                        data = _a.sent();
                        if (!(data != null)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            this.cache.restore(data)
                        ];
                    case 2:
                        _a.sent();
                        this.log.info(typeof data === 'string' ? "Restored cache of size " + data.length + " characters" : 'Restored cache');
                        return [
                            3,
                            4
                        ];
                    case 3:
                        this.log.info('No stored cache to restore');
                        _a.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error_2 = _a.sent();
                        this.log.error('Error restoring cache', error_2);
                        throw error_2;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Persistor.prototype.purge = function() {
        return $fbffad5aad4c4a59$var$__awaiter(this, void 0, void 0, function() {
            var error_3;
            return $fbffad5aad4c4a59$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.storage.purge()
                        ];
                    case 1:
                        _a.sent();
                        this.log.info('Purged cache storage');
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        this.log.error('Error purging cache storage', error_3);
                        throw error_3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return Persistor;
}();
var $fbffad5aad4c4a59$export$2e2bcd8739ae039 = $fbffad5aad4c4a59$var$Persistor;


var $52c8ba5ffa3a2c4c$export$2e2bcd8739ae039 = function(_a) {
    var cache = _a.cache;
    return function(persist) {
        var write = cache.write;
        var evict = cache.evict;
        var modify = cache.modify;
        cache.write = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var result = write.apply(cache, args);
            persist();
            return result;
        };
        cache.evict = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var result = evict.apply(cache, args);
            persist();
            return result;
        };
        cache.modify = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var result = modify.apply(cache, args);
            persist();
            return result;
        };
        return function() {
            cache.write = write;
            cache.evict = evict;
            cache.modify = modify;
        };
    };
};



var $12f7d161e59c39c0$export$2e2bcd8739ae039 = function(_a) {
    var log = _a.log, cache = _a.cache;
    return function(persist) {
        log.warn('Trigger option `background` not available on web; using `write` trigger');
        return (0, $52c8ba5ffa3a2c4c$export$2e2bcd8739ae039)({
            cache: cache
        })(persist);
    };
};


var $e2b49000f548fc88$var$Trigger = function() {
    function Trigger(_a, options) {
        var _this = this;
        var log = _a.log, persistor = _a.persistor;
        this.fire = function() {
            if (!_this.debounce) {
                _this.persist();
                return;
            }
            if (_this.timeout != null) clearTimeout(_this.timeout);
            _this.timeout = setTimeout(_this.persist, _this.debounce);
        };
        this.persist = function() {
            if (_this.paused) return;
            _this.persistor.persist();
        };
        var defaultDebounce = Trigger.defaultDebounce;
        var cache = options.cache, debounce = options.debounce, _b = options.trigger, trigger = _b === void 0 ? 'write' : _b;
        if (!trigger) return;
        this.debounce = debounce != null ? debounce : defaultDebounce;
        this.persistor = persistor;
        this.paused = false;
        switch(trigger){
            case 'write':
                this.uninstall = (0, $52c8ba5ffa3a2c4c$export$2e2bcd8739ae039)({
                    cache: cache
                })(this.fire);
                break;
            case 'background':
                if (debounce) log.warn('Debounce is not recommended with `background` trigger');
                this.debounce = debounce;
                this.uninstall = (0, $12f7d161e59c39c0$export$2e2bcd8739ae039)({
                    cache: cache,
                    log: log
                })(this.fire);
                break;
            default:
                if (typeof trigger === 'function') this.uninstall = trigger(this.fire);
                else throw Error("Unrecognized trigger option: " + trigger);
        }
    }
    Trigger.prototype.pause = function() {
        this.paused = true;
    };
    Trigger.prototype.resume = function() {
        this.paused = false;
    };
    Trigger.prototype.remove = function() {
        if (this.uninstall) {
            this.uninstall();
            this.uninstall = null;
            this.paused = true;
        }
    };
    Trigger.defaultDebounce = 1000;
    return Trigger;
}();
var $e2b49000f548fc88$export$2e2bcd8739ae039 = $e2b49000f548fc88$var$Trigger;


var $98dab62e04219fba$var$CachePersistor = function() {
    function CachePersistor(options) {
        if (!options.cache) throw new Error("In order to persist your Apollo Cache, you need to pass in a cache. Please see https://www.apollographql.com/docs/react/basics/caching.html for our default InMemoryCache.");
        if (!options.storage) throw new Error("In order to persist your Apollo Cache, you need to pass in an underlying storage provider. Please see https://github.com/apollographql/apollo-cache-persist#storage-providers");
        var log = new (0, $9d0f5f23a98d09dd$export$2e2bcd8739ae039)(options);
        var cache = new (0, $443f9ec21d54ddd9$export$2e2bcd8739ae039)(options);
        var storage = new (0, $6a421b6142ccca4a$export$2e2bcd8739ae039)(options);
        var persistor = new (0, $fbffad5aad4c4a59$export$2e2bcd8739ae039)({
            log: log,
            cache: cache,
            storage: storage
        }, options);
        var trigger = new (0, $e2b49000f548fc88$export$2e2bcd8739ae039)({
            log: log,
            persistor: persistor
        }, options);
        this.log = log;
        this.cache = cache;
        this.storage = storage;
        this.persistor = persistor;
        this.trigger = trigger;
    }
    CachePersistor.prototype.persist = function() {
        return this.persistor.persist();
    };
    CachePersistor.prototype.restore = function() {
        return this.persistor.restore();
    };
    CachePersistor.prototype.purge = function() {
        return this.persistor.purge();
    };
    CachePersistor.prototype.pause = function() {
        this.trigger.pause();
    };
    CachePersistor.prototype.resume = function() {
        this.trigger.resume();
    };
    CachePersistor.prototype.remove = function() {
        this.trigger.remove();
    };
    CachePersistor.prototype.getLogs = function(print) {
        if (print === void 0) print = false;
        if (print) this.log.tailLogs();
        else return this.log.getLogs();
    };
    CachePersistor.prototype.getSize = function() {
        return this.storage.getSize();
    };
    return CachePersistor;
}();
var $98dab62e04219fba$export$2e2bcd8739ae039 = $98dab62e04219fba$var$CachePersistor;



var $8a41a05288a7d2ab$export$2e2bcd8739ae039 = function(options) {
    var persistor = new (0, $98dab62e04219fba$export$2e2bcd8739ae039)(options);
    return persistor.restore();
};





var $ce2a3e2e6e1f297b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ce2a3e2e6e1f297b$export$16ff6ab4c11971cb = function(options) {
    var cachePersistor = new $ce2a3e2e6e1f297b$export$7d8c7e8107dbf913(options);
    cachePersistor.restoreSync();
};
var $ce2a3e2e6e1f297b$export$7d8c7e8107dbf913 = function(_super) {
    $ce2a3e2e6e1f297b$var$__extends(SynchronousCachePersistor, _super);
    function SynchronousCachePersistor(options) {
        var _this = _super.call(this, options) || this;
        _this.storage = new $ce2a3e2e6e1f297b$export$5fc3ab74908570a3(options);
        _this.persistor = new $ce2a3e2e6e1f297b$export$6dedb4849802d85({
            log: _this.log,
            cache: _this.cache,
            storage: _this.storage
        }, options);
        return _this;
    }
    SynchronousCachePersistor.prototype.restoreSync = function() {
        this.persistor.restoreSync();
    };
    return SynchronousCachePersistor;
}((0, $98dab62e04219fba$export$2e2bcd8739ae039));
var $ce2a3e2e6e1f297b$export$6dedb4849802d85 = function(_super) {
    $ce2a3e2e6e1f297b$var$__extends(SynchronousPersistor, _super);
    function SynchronousPersistor(_a, options) {
        var log = _a.log, cache = _a.cache, storage = _a.storage;
        return _super.call(this, {
            log: log,
            cache: cache,
            storage: storage
        }, options) || this;
    }
    SynchronousPersistor.prototype.restoreSync = function() {
        this.cache.restore(this.storage.readSync());
    };
    return SynchronousPersistor;
}((0, $fbffad5aad4c4a59$export$2e2bcd8739ae039));
var $ce2a3e2e6e1f297b$export$5fc3ab74908570a3 = function(_super) {
    $ce2a3e2e6e1f297b$var$__extends(SynchronousStorage, _super);
    function SynchronousStorage(options) {
        return _super.call(this, options) || this;
    }
    SynchronousStorage.prototype.readSync = function() {
        return this.storage.getItem(this.key);
    };
    return SynchronousStorage;
}((0, $6a421b6142ccca4a$export$2e2bcd8739ae039));


var $33a01943033da786$export$1145885acffdcf2 = function() {
    function AsyncStorageWrapper(storage) {
        this.storage = storage;
    }
    AsyncStorageWrapper.prototype.getItem = function(key) {
        return this.storage.getItem(key);
    };
    AsyncStorageWrapper.prototype.removeItem = function(key) {
        return this.storage.removeItem(key);
    };
    AsyncStorageWrapper.prototype.setItem = function(key, value) {
        return this.storage.setItem(key, value);
    };
    return AsyncStorageWrapper;
}();


var $da333db6b94a906c$export$dc2290925d407545 = function() {
    function IonicStorageWrapper(storage) {
        this.storage = storage;
    }
    IonicStorageWrapper.prototype.getItem = function(key) {
        return this.storage.get(key);
    };
    IonicStorageWrapper.prototype.removeItem = function(key) {
        return this.storage.remove(key);
    };
    IonicStorageWrapper.prototype.setItem = function(key, value) {
        return this.storage.set(key, value);
    };
    return IonicStorageWrapper;
}();


var $e0c68a6894be3158$export$252e097fc9c1bff9 = function() {
    function LocalForageWrapper(storage) {
        this.storage = storage;
    }
    LocalForageWrapper.prototype.getItem = function(key) {
        return this.storage.getItem(key);
    };
    LocalForageWrapper.prototype.removeItem = function(key) {
        return this.storage.removeItem(key);
    };
    LocalForageWrapper.prototype.setItem = function(key, value) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.storage.setItem(key, value).then(function() {
                return resolve();
            }).catch(function() {
                return reject();
            });
        });
    };
    return LocalForageWrapper;
}();


var $4e634347a3ffeb43$export$219db0002440cca3 = function() {
    function LocalStorageWrapper(storage) {
        this.storage = storage;
    }
    LocalStorageWrapper.prototype.getItem = function(key) {
        return this.storage.getItem(key);
    };
    LocalStorageWrapper.prototype.removeItem = function(key) {
        return this.storage.removeItem(key);
    };
    LocalStorageWrapper.prototype.setItem = function(key, value) {
        if (value !== null) return this.storage.setItem(key, value);
        else return this.removeItem(key);
    };
    return LocalStorageWrapper;
}();


var $5943cccb4f8bf724$export$a9773760f993025f = function() {
    function MMKVStorageWrapper(storage) {
        this.storage = storage;
    }
    MMKVStorageWrapper.prototype.getItem = function(key) {
        return this.storage.getItem(key) || null;
    };
    MMKVStorageWrapper.prototype.removeItem = function(key) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            Promise.resolve(_this.storage.removeItem(key)).then(function() {
                return resolve();
            }).catch(function() {
                return reject();
            });
        });
    };
    MMKVStorageWrapper.prototype.setItem = function(key, value) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.storage.setItem(key, value).then(function() {
                return resolve();
            }).catch(function() {
                return reject();
            });
        });
    };
    return MMKVStorageWrapper;
}();


var $f580cb0db4ecee52$export$55ee87ebae5f3d9 = function() {
    function MMKVWrapper(storage) {
        this.storage = storage;
    }
    MMKVWrapper.prototype.getItem = function(key) {
        return this.storage.getString(key) || null;
    };
    MMKVWrapper.prototype.removeItem = function(key) {
        return this.storage.delete(key);
    };
    MMKVWrapper.prototype.setItem = function(key, value) {
        if (value !== null) return this.storage.set(key, value);
        return this.removeItem(key);
    };
    return MMKVWrapper;
}();


var $840853f23800762c$export$138a5846702f1d8e = function() {
    function SessionStorageWrapper(storage) {
        this.storage = storage;
    }
    SessionStorageWrapper.prototype.getItem = function(key) {
        return this.storage.getItem(key);
    };
    SessionStorageWrapper.prototype.removeItem = function(key) {
        return this.storage.removeItem(key);
    };
    SessionStorageWrapper.prototype.setItem = function(key, value) {
        if (value !== null) return this.storage.setItem(key, value);
        else return this.removeItem(key);
    };
    return SessionStorageWrapper;
}();







var $1MQ4j = parcelRequire("1MQ4j");

var $7GVDC = parcelRequire("7GVDC");
(0, (/*@__PURE__*/$parcel$interopDefault($7GVDC))).config({
    driver: localStorage.getItem('offline-persistance-driver') ?? (0, (/*@__PURE__*/$parcel$interopDefault($7GVDC))).LOCALSTORAGE,
    name: 'graphql-server',
    version: 1.0,
    size: 4980736,
    storeName: 'keyvaluepairs',
    description: 'some description'
});
const $e45a22371bd99f48$var$cache = new (0, $2O1GU.InMemoryCache)({
    possibleTypes: (0, $2O1GU.convertToPossibleTypes)((0, $05aa38b2753ea564$export$a988b149d1c415aa))
});
if (Boolean(Number(localStorage.getItem('offline-persistance')))) {
    const newPersistor = new (0, $98dab62e04219fba$export$2e2bcd8739ae039)({
        cache: $e45a22371bd99f48$var$cache,
        storage: new (0, $e0c68a6894be3158$export$252e097fc9c1bff9)((0, (/*@__PURE__*/$parcel$interopDefault($7GVDC)))),
        debug: true
    });
    newPersistor.restore();
}
const $e45a22371bd99f48$var$graphConfig = {
    async onRequest () {
        const headers = new Headers();
        const user = $1MQ4j.auth().currentUser;
        if (user) headers.append('authorization', await user.getIdToken());
        headers.append('domain', 'graphql-server');
        return headers;
    },
    cache: $e45a22371bd99f48$var$cache,
    //  apolloClientOptions: {
    //   queryDeduplication: false,
    //  },
    cancelPendingRequests: true,
    refreshOnUnauthenticated: true,
    uri: (0, $7lFX5.ENVIRONMENT).GRAPH_URL,
    pubsub: (0, $7lFX5.ENVIRONMENT).GRAPH_WS_URL
};
const $e45a22371bd99f48$var$defaultTemplates = {
    error: (e)=>{
        return (0, $4TeKW.html)` <p style="color: inherit; text-align: center;">${e}</p> `;
    },
    loading: ()=>{
        return (0, $4TeKW.html)`
      <div style="text-align: center;">
        <rx-loading palette="danger"></rx-loading>
      </div>
    `;
    }
};
class $e45a22371bd99f48$export$99bb444e5b36d4dc {
}
$e45a22371bd99f48$export$99bb444e5b36d4dc = (0, $deWeK.__decorate)([
    (0, $1t8Wn.Module)({
        imports: [
            (0, $2O1GU.GraphqlModule).forRoot($e45a22371bd99f48$var$graphConfig, (0, $6LnE2.LZWService).decompress((0, $daf04de585086b9e$export$255739011e013f34))),
            (0, $57Cad.GraphModule).forRoot($e45a22371bd99f48$var$graphConfig, $e45a22371bd99f48$var$defaultTemplates)
        ]
    })
], $e45a22371bd99f48$export$99bb444e5b36d4dc);



(0, $1t8Wn.Bootstrap)((0, $kWJha.SocialModule).forRoot({
    apiKey: (0, $7lFX5.ENVIRONMENT).GOOGLE_API_KEY,
    authDomain: (0, $7lFX5.ENVIRONMENT).GOOGLE_AUTH_DOMAIN,
    databaseURL: (0, $7lFX5.ENVIRONMENT).GOOGLE_DATABASE_URL,
    projectId: (0, $7lFX5.ENVIRONMENT).GOOGLE_PROJECT_ID,
    storageBucket: (0, $7lFX5.ENVIRONMENT).GOOGLE_STORAGE_BUCKET,
    messagingSenderId: (0, $7lFX5.ENVIRONMENT).GOOGLE_MESSAGE_SENDER_ID,
    appId: (0, $7lFX5.ENVIRONMENT).GOOGLE_APP_ID,
    measurmentId: (0, $7lFX5.ENVIRONMENT).GOOGLE_MEASURMENT_ID
})).pipe((0, $lNnaw.switchMap)(()=>(0, $1t8Wn.Bootstrap)((0, $e45a22371bd99f48$export$99bb444e5b36d4dc))), (0, $lNnaw.switchMap)((ctx)=>ctx.get((0, $97odG.SocialService)).getUser().pipe((0, $3dOhR.tap)((user)=>!(0, $7lFX5.isDevelopment)() ? (0, $61878516848e5cd2$export$2cd8252107eb640b)({
            dsn: (0, $7lFX5.ENVIRONMENT).SENTRY_DSN,
            initialScope: {
                user: {
                    id: user?.uid,
                    email: user?.email
                }
            }
        }) : null), (0, $lNnaw.switchMap)(()=>ctx.get((0, $bQvnf.FeatureFlagsService)).fetchFeatureFlags()), (0, $lNnaw.switchMap)(()=>(0, $5JMLH.from)((parcelRequire("2N8YZ"))).pipe((0, $lNnaw.switchMap)(({ AppModule: AppModule })=>(0, $1t8Wn.Bootstrap)(AppModule))))))).subscribe();
if (null) null.dispose(()=>document.body.innerHTML = '');
var $36f046df944608dd$exports = {};
$36f046df944608dd$exports = import.meta.resolve("9XP4K");


async function $6caac8241ac8ddfb$var$registerServiceWorker() {
    if ('serviceWorker' in navigator) {
        if (!(0, $7lFX5.isDevelopment)()) window.addEventListener('load', ()=>{
            navigator.serviceWorker.register($36f046df944608dd$exports);
        });
        else {
            const workers = await navigator.serviceWorker.getRegistrations();
            for (const worker of workers)await worker.unregister();
        }
    }
}
function $6caac8241ac8ddfb$var$initAnalytics() {
    if (!(0, $7lFX5.isDevelopment)()) {
        /* eslint-disable @typescript-eslint/no-explicit-any */ const _window = window;
        _window.dataLayer = _window.dataLayer || [];
        function gtag(...args) {
            _window.dataLayer.push(args);
        }
        gtag('js', new Date());
        gtag('config', 'UA-52122847-6');
    }
}
$6caac8241ac8ddfb$var$initAnalytics();
$6caac8241ac8ddfb$var$registerServiceWorker();


//# sourceMappingURL=graphql-client.e6e226f5.js.map
